module.exports = {
  "GO:0000001": "mitochondrion inheritance",
  "GO:0000002": "mitochondrial genome maintenance",
  "GO:0000003": "reproduction",
  "GO:0000005": "obsolete ribosomal chaperone activity",
  "GO:0000006": "high-affinity zinc uptake transmembrane transporter activity",
  "GO:0000007": "low-affinity zinc ion transmembrane transporter activity",
  "GO:0000008": "obsolete thioredoxin",
  "GO:0000009": "alpha-1,6-mannosyltransferase activity",
  "GO:0000010": "trans-hexaprenyltranstransferase activity",
  "GO:0000011": "vacuole inheritance",
  "GO:0000012": "single strand break repair",
  "GO:0000014": "single-stranded DNA endodeoxyribonuclease activity",
  "GO:0000015": "phosphopyruvate hydratase complex",
  "GO:0000016": "lactase activity",
  "GO:0000017": "alpha-glucoside transport",
  "GO:0000018": "regulation of DNA recombination",
  "GO:0000019": "regulation of mitotic recombination",
  "GO:0000020": "obsolete negative regulation of recombination within rDNA repeats",
  "GO:0000022": "mitotic spindle elongation",
  "GO:0000023": "maltose metabolic process",
  "GO:0000024": "maltose biosynthetic process",
  "GO:0000025": "maltose catabolic process",
  "GO:0000026": "alpha-1,2-mannosyltransferase activity",
  "GO:0000027": "ribosomal large subunit assembly",
  "GO:0000028": "ribosomal small subunit assembly",
  "GO:0000030": "mannosyltransferase activity",
  "GO:0000031": "mannosylphosphate transferase activity",
  "GO:0000032": "cell wall mannoprotein biosynthetic process",
  "GO:0000033": "alpha-1,3-mannosyltransferase activity",
  "GO:0000034": "adenine deaminase activity",
  "GO:0000035": "acyl binding",
  "GO:0000036": "ACP phosphopantetheine attachment site binding involved in fatty acid biosynthetic process",
  "GO:0000038": "very long-chain fatty acid metabolic process",
  "GO:0000039": "obsolete plasma membrane long-chain fatty acid transporter",
  "GO:0000040": "low-affinity iron ion transmembrane transport",
  "GO:0000041": "transition metal ion transport",
  "GO:0000042": "protein targeting to Golgi",
  "GO:0000044": "obsolete ascorbate stabilization",
  "GO:0000045": "autophagosome assembly",
  "GO:0000047": "obsolete Rieske iron-sulfur protein",
  "GO:0000048": "peptidyltransferase activity",
  "GO:0000049": "tRNA binding",
  "GO:0000050": "urea cycle",
  "GO:0000051": "obsolete urea cycle intermediate metabolic process",
  "GO:0000052": "citrulline metabolic process",
  "GO:0000053": "argininosuccinate metabolic process",
  "GO:0000054": "ribosomal subunit export from nucleus",
  "GO:0000055": "ribosomal large subunit export from nucleus",
  "GO:0000056": "ribosomal small subunit export from nucleus",
  "GO:0000059": "protein import into nucleus, docking",
  "GO:0000060": "protein import into nucleus, translocation",
  "GO:0000061": "protein import into nucleus, substrate release",
  "GO:0000062": "fatty-acyl-CoA binding",
  "GO:0000064": "L-ornithine transmembrane transporter activity",
  "GO:0000066": "mitochondrial ornithine transport",
  "GO:0000067": "obsolete DNA replication and chromosome cycle",
  "GO:0000070": "mitotic sister chromatid segregation",
  "GO:0000072": "obsolete M phase specific microtubule process",
  "GO:0000073": "spindle pole body separation",
  "GO:0000075": "cell cycle checkpoint",
  "GO:0000076": "DNA replication checkpoint",
  "GO:0000077": "DNA damage checkpoint",
  "GO:0000078": "obsolete cytokinesis after mitosis checkpoint",
  "GO:0000079": "regulation of cyclin-dependent protein serine/threonine kinase activity",
  "GO:0000080": "mitotic G1 phase",
  "GO:0000082": "G1/S transition of mitotic cell cycle",
  "GO:0000083": "regulation of transcription involved in G1/S transition of mitotic cell cycle",
  "GO:0000084": "mitotic S phase",
  "GO:0000085": "mitotic G2 phase",
  "GO:0000086": "G2/M transition of mitotic cell cycle",
  "GO:0000087": "mitotic M phase",
  "GO:0000088": "mitotic prophase",
  "GO:0000089": "mitotic metaphase",
  "GO:0000090": "mitotic anaphase",
  "GO:0000091": "mitotic anaphase A",
  "GO:0000092": "mitotic anaphase B",
  "GO:0000093": "mitotic telophase",
  "GO:0000094": "obsolete septin assembly and septum formation",
  "GO:0000095": "S-adenosyl-L-methionine transmembrane transporter activity",
  "GO:0000096": "sulfur amino acid metabolic process",
  "GO:0000097": "sulfur amino acid biosynthetic process",
  "GO:0000098": "sulfur amino acid catabolic process",
  "GO:0000099": "sulfur amino acid transmembrane transporter activity",
  "GO:0000100": "S-methylmethionine transmembrane transporter activity",
  "GO:0000101": "sulfur amino acid transport",
  "GO:0000102": "L-methionine secondary active transmembrane transporter activity",
  "GO:0000103": "sulfate assimilation",
  "GO:0000104": "succinate dehydrogenase activity",
  "GO:0000105": "histidine biosynthetic process",
  "GO:0000107": "imidazoleglycerol-phosphate synthase activity",
  "GO:0000108": "obsolete repairosome",
  "GO:0000109": "nucleotide-excision repair complex",
  "GO:0000110": "nucleotide-excision repair factor 1 complex",
  "GO:0000111": "nucleotide-excision repair factor 2 complex",
  "GO:0000112": "nucleotide-excision repair factor 3 complex",
  "GO:0000113": "nucleotide-excision repair factor 4 complex",
  "GO:0000114": "obsolete regulation of transcription involved in G1 phase of mitotic cell cycle",
  "GO:0000115": "obsolete regulation of transcription involved in S phase of mitotic cell cycle",
  "GO:0000116": "obsolete regulation of transcription involved in G2-phase of mitotic cell cycle",
  "GO:0000117": "regulation of transcription involved in G2/M transition of mitotic cell cycle",
  "GO:0000118": "histone deacetylase complex",
  "GO:0000120": "RNA polymerase I transcription factor complex",
  "GO:0000121": "glycerol-1-phosphatase activity",
  "GO:0000122": "negative regulation of transcription from RNA polymerase II promoter",
  "GO:0000123": "histone acetyltransferase complex",
  "GO:0000124": "SAGA complex",
  "GO:0000125": "PCAF complex",
  "GO:0000126": "transcription factor TFIIIB complex",
  "GO:0000127": "transcription factor TFIIIC complex",
  "GO:0000128": "flocculation",
  "GO:0000131": "incipient cellular bud site",
  "GO:0000132": "establishment of mitotic spindle orientation",
  "GO:0000133": "polarisome",
  "GO:0000136": "alpha-1,6-mannosyltransferase complex",
  "GO:0000137": "Golgi cis cisterna",
  "GO:0000138": "Golgi trans cisterna",
  "GO:0000139": "Golgi membrane",
  "GO:0000140": "acylglycerone-phosphate reductase activity",
  "GO:0000142": "cellular bud neck contractile ring",
  "GO:0000144": "cellular bud neck septin ring",
  "GO:0000145": "exocyst",
  "GO:0000146": "microfilament motor activity",
  "GO:0000147": "actin cortical patch assembly",
  "GO:0000148": "1,3-beta-D-glucan synthase complex",
  "GO:0000149": "SNARE binding",
  "GO:0000150": "recombinase activity",
  "GO:0000151": "ubiquitin ligase complex",
  "GO:0000152": "nuclear ubiquitin ligase complex",
  "GO:0000153": "cytoplasmic ubiquitin ligase complex",
  "GO:0000154": "rRNA modification",
  "GO:0000155": "phosphorelay sensor kinase activity",
  "GO:0000156": "phosphorelay response regulator activity",
  "GO:0000159": "protein phosphatase type 2A complex",
  "GO:0000160": "phosphorelay signal transduction system",
  "GO:0000161": "MAPK cascade involved in osmosensory signaling pathway",
  "GO:0000162": "tryptophan biosynthetic process",
  "GO:0000164": "protein phosphatase type 1 complex",
  "GO:0000165": "MAPK cascade",
  "GO:0000166": "nucleotide binding",
  "GO:0000167": "activation of MAPKKK activity involved in osmosensory signaling pathway",
  "GO:0000168": "activation of MAPKK activity involved in osmosensory signaling pathway",
  "GO:0000169": "activation of MAPK activity involved in osmosensory signaling pathway",
  "GO:0000170": "sphingosine hydroxylase activity",
  "GO:0000171": "ribonuclease MRP activity",
  "GO:0000172": "ribonuclease MRP complex",
  "GO:0000173": "inactivation of MAPK activity involved in osmosensory signaling pathway",
  "GO:0000174": "obsolete inactivation of MAPK (mating sensu Saccharomyces)",
  "GO:0000175": "3'-5'-exoribonuclease activity",
  "GO:0000176": "nuclear exosome (RNase complex)",
  "GO:0000177": "cytoplasmic exosome (RNase complex)",
  "GO:0000178": "exosome (RNase complex)",
  "GO:0000179": "rRNA (adenine-N6,N6-)-dimethyltransferase activity",
  "GO:0000180": "obsolete cytosolic large ribosomal subunit",
  "GO:0000181": "obsolete cytosolic small ribosomal subunit",
  "GO:0000182": "rDNA binding",
  "GO:0000183": "chromatin silencing at rDNA",
  "GO:0000184": "nuclear-transcribed mRNA catabolic process, nonsense-mediated decay",
  "GO:0000185": "activation of MAPKKK activity",
  "GO:0000186": "activation of MAPKK activity",
  "GO:0000187": "activation of MAPK activity",
  "GO:0000188": "inactivation of MAPK activity",
  "GO:0000189": "MAPK import into nucleus",
  "GO:0000190": "obsolete MAPKKK cascade (pseudohyphal growth)",
  "GO:0000191": "obsolete activation of MAPKKK (pseudohyphal growth)",
  "GO:0000192": "obsolete activation of MAPKK (pseudohyphal growth)",
  "GO:0000193": "obsolete activation of MAPK (pseudohyphal growth)",
  "GO:0000194": "obsolete inactivation of MAPK (pseudohyphal growth)",
  "GO:0000195": "obsolete nuclear translocation of MAPK (pseudohyphal growth)",
  "GO:0000196": "MAPK cascade involved in cell wall organization or biogenesis",
  "GO:0000197": "activation of MAPKKK activity involved in cell wall organization or biogenesis",
  "GO:0000198": "activation of MAPKK activity involved in cell wall organization or biogenesis",
  "GO:0000199": "activation of MAPK activity involved in cell wall organization or biogenesis",
  "GO:0000200": "inactivation of MAPK activity involved in cell wall organization or biogenesis",
  "GO:0000201": "MAPK import into nucleus involved in cell wall organization or biogenesis",
  "GO:0000202": "obsolete MAPKKK cascade during sporulation (sensu Saccharomyces)",
  "GO:0000203": "obsolete activation of MAPKKK during sporulation (sensu Saccharomyces)",
  "GO:0000204": "obsolete activation of MAPKK during sporulation (sensu Saccharomyces)",
  "GO:0000205": "obsolete activation of MAPK during sporulation (sensu Saccharomyces)",
  "GO:0000206": "obsolete inactivation of MAPK during sporulation (sensu Saccharomyces)",
  "GO:0000207": "obsolete nuclear translocation of MAPK during sporulation (sensu Saccharomyces)",
  "GO:0000208": "MAPK import into nucleus involved in osmosensory signaling pathway",
  "GO:0000209": "protein polyubiquitination",
  "GO:0000210": "NAD+ diphosphatase activity",
  "GO:0000211": "obsolete protein degradation tagging activity",
  "GO:0000212": "meiotic spindle organization",
  "GO:0000213": "tRNA-intron endonuclease activity",
  "GO:0000214": "tRNA-intron endonuclease complex",
  "GO:0000215": "tRNA 2'-phosphotransferase activity",
  "GO:0000216": "obsolete M/G1 transition of mitotic cell cycle",
  "GO:0000217": "DNA secondary structure binding",
  "GO:0000219": "obsolete vacuolar hydrogen-transporting ATPase",
  "GO:0000220": "vacuolar proton-transporting V-type ATPase, V0 domain",
  "GO:0000221": "vacuolar proton-transporting V-type ATPase, V1 domain",
  "GO:0000222": "plasma membrane proton-transporting V-type ATPase, V0 domain",
  "GO:0000223": "plasma membrane proton-transporting V-type ATPase, V1 domain",
  "GO:0000224": "peptide-N4-(N-acetyl-beta-glucosaminyl)asparagine amidase activity",
  "GO:0000225": "N-acetylglucosaminylphosphatidylinositol deacetylase activity",
  "GO:0000226": "microtubule cytoskeleton organization",
  "GO:0000227": "oxaloacetate secondary active transmembrane transporter activity",
  "GO:0000228": "nuclear chromosome",
  "GO:0000229": "cytoplasmic chromosome",
  "GO:0000230": "obsolete nuclear mitotic chromosome",
  "GO:0000231": "obsolete cytoplasmic mitotic chromosome",
  "GO:0000232": "obsolete nuclear interphase chromosome",
  "GO:0000233": "obsolete cytoplasmic interphase chromosome",
  "GO:0000234": "phosphoethanolamine N-methyltransferase activity",
  "GO:0000235": "astral microtubule",
  "GO:0000236": "mitotic prometaphase",
  "GO:0000237": "leptotene",
  "GO:0000238": "zygotene",
  "GO:0000239": "pachytene",
  "GO:0000240": "diplotene",
  "GO:0000241": "diakinesis",
  "GO:0000242": "pericentriolar material",
  "GO:0000243": "commitment complex",
  "GO:0000244": "spliceosomal tri-snRNP complex assembly",
  "GO:0000245": "spliceosomal complex assembly",
  "GO:0000246": "delta24(24-1) sterol reductase activity",
  "GO:0000247": "C-8 sterol isomerase activity",
  "GO:0000248": "C-5 sterol desaturase activity",
  "GO:0000249": "C-22 sterol desaturase activity",
  "GO:0000250": "lanosterol synthase activity",
  "GO:0000252": "C-3 sterol dehydrogenase (C-4 sterol decarboxylase) activity",
  "GO:0000253": "3-keto sterol reductase activity",
  "GO:0000254": "C-4 methylsterol oxidase activity",
  "GO:0000255": "allantoin metabolic process",
  "GO:0000256": "allantoin catabolic process",
  "GO:0000257": "nitrilase activity",
  "GO:0000258": "obsolete isoleucine/valine:sodium symporter activity",
  "GO:0000259": "obsolete intracellular nucleoside transmembrane transporter activity",
  "GO:0000260": "obsolete hydrogen-translocating V-type ATPase activity",
  "GO:0000261": "obsolete sodium-translocating V-type ATPase activity",
  "GO:0000262": "mitochondrial chromosome",
  "GO:0000263": "obsolete heterotrimeric G-protein GTPase, alpha-subunit",
  "GO:0000264": "obsolete heterotrimeric G-protein GTPase, beta-subunit",
  "GO:0000265": "obsolete heterotrimeric G-protein GTPase, gamma-subunit",
  "GO:0000266": "mitochondrial fission",
  "GO:0000267": "obsolete cell fraction",
  "GO:0000268": "peroxisome targeting sequence binding",
  "GO:0000269": "toxin export channel activity",
  "GO:0000270": "peptidoglycan metabolic process",
  "GO:0000271": "polysaccharide biosynthetic process",
  "GO:0000272": "polysaccharide catabolic process",
  "GO:0000274": "mitochondrial proton-transporting ATP synthase, stator stalk",
  "GO:0000275": "mitochondrial proton-transporting ATP synthase complex, catalytic core F(1)",
  "GO:0000276": "mitochondrial proton-transporting ATP synthase complex, coupling factor F(o)",
  "GO:0000277": "[cytochrome c]-lysine N-methyltransferase activity",
  "GO:0000278": "mitotic cell cycle",
  "GO:0000279": "M phase",
  "GO:0000280": "nuclear division",
  "GO:0000281": "mitotic cytokinesis",
  "GO:0000282": "cellular bud site selection",
  "GO:0000284": "obsolete shmoo orientation",
  "GO:0000285": "1-phosphatidylinositol-3-phosphate 5-kinase activity",
  "GO:0000286": "alanine dehydrogenase activity",
  "GO:0000287": "magnesium ion binding",
  "GO:0000288": "nuclear-transcribed mRNA catabolic process, deadenylation-dependent decay",
  "GO:0000289": "nuclear-transcribed mRNA poly(A) tail shortening",
  "GO:0000290": "deadenylation-dependent decapping of nuclear-transcribed mRNA",
  "GO:0000291": "nuclear-transcribed mRNA catabolic process, exonucleolytic",
  "GO:0000292": "RNA fragment catabolic process",
  "GO:0000293": "ferric-chelate reductase activity",
  "GO:0000294": "nuclear-transcribed mRNA catabolic process, endonucleolytic cleavage-dependent decay",
  "GO:0000295": "adenine nucleotide transmembrane transporter activity",
  "GO:0000296": "spermine transport",
  "GO:0000297": "spermine transmembrane transporter activity",
  "GO:0000298": "endopolyphosphatase activity",
  "GO:0000299": "obsolete integral to membrane of membrane fraction",
  "GO:0000300": "obsolete peripheral to membrane of membrane fraction",
  "GO:0000301": "retrograde transport, vesicle recycling within Golgi",
  "GO:0000302": "response to reactive oxygen species",
  "GO:0000303": "response to superoxide",
  "GO:0000304": "response to singlet oxygen",
  "GO:0000305": "response to oxygen radical",
  "GO:0000306": "extrinsic component of vacuolar membrane",
  "GO:0000307": "cyclin-dependent protein kinase holoenzyme complex",
  "GO:0000308": "cytoplasmic cyclin-dependent protein kinase holoenzyme complex",
  "GO:0000309": "nicotinamide-nucleotide adenylyltransferase activity",
  "GO:0000310": "xanthine phosphoribosyltransferase activity",
  "GO:0000311": "plastid large ribosomal subunit",
  "GO:0000312": "plastid small ribosomal subunit",
  "GO:0000313": "organellar ribosome",
  "GO:0000314": "organellar small ribosomal subunit",
  "GO:0000315": "organellar large ribosomal subunit",
  "GO:0000316": "sulfite transport",
  "GO:0000319": "sulfite transmembrane transporter activity",
  "GO:0000320": "re-entry into mitotic cell cycle",
  "GO:0000321": "re-entry into mitotic cell cycle after pheromone arrest",
  "GO:0000322": "storage vacuole",
  "GO:0000323": "lytic vacuole",
  "GO:0000324": "fungal-type vacuole",
  "GO:0000325": "plant-type vacuole",
  "GO:0000326": "protein storage vacuole",
  "GO:0000327": "lytic vacuole within protein storage vacuole",
  "GO:0000328": "fungal-type vacuole lumen",
  "GO:0000329": "fungal-type vacuole membrane",
  "GO:0000330": "plant-type vacuole lumen",
  "GO:0000331": "contractile vacuole",
  "GO:0000332": "template for synthesis of G-rich strand of telomere DNA activity",
  "GO:0000333": "telomerase catalytic core complex",
  "GO:0000334": "3-hydroxyanthranilate 3,4-dioxygenase activity",
  "GO:0000335": "negative regulation of transposition, DNA-mediated",
  "GO:0000336": "positive regulation of transposition, DNA-mediated",
  "GO:0000337": "regulation of transposition, DNA-mediated",
  "GO:0000338": "protein deneddylation",
  "GO:0000339": "RNA cap binding",
  "GO:0000340": "RNA 7-methylguanosine cap binding",
  "GO:0000341": "RNA trimethylguanosine cap binding",
  "GO:0000342": "RNA cap 4 binding",
  "GO:0000343": "plastid-encoded plastid RNA polymerase complex A",
  "GO:0000344": "plastid-encoded plastid RNA polymerase complex B",
  "GO:0000345": "cytosolic DNA-directed RNA polymerase complex",
  "GO:0000346": "transcription export complex",
  "GO:0000347": "THO complex",
  "GO:0000348": "mRNA branch site recognition",
  "GO:0000349": "generation of catalytic spliceosome for first transesterification step",
  "GO:0000350": "generation of catalytic spliceosome for second transesterification step",
  "GO:0000352": "trans assembly of SL-containing precatalytic spliceosome",
  "GO:0000353": "formation of quadruple SL/U4/U5/U6 snRNP",
  "GO:0000354": "cis assembly of pre-catalytic spliceosome",
  "GO:0000362": "obsolete first U2-type spliceosomal transesterification activity",
  "GO:0000363": "obsolete first U12-type spliceosomal transesterification activity",
  "GO:0000364": "obsolete second U2-type spliceosomal transesterification activity",
  "GO:0000365": "mRNA trans splicing, via spliceosome",
  "GO:0000366": "intergenic mRNA trans splicing",
  "GO:0000367": "obsolete second U12-type spliceosomal transesterification activity",
  "GO:0000372": "Group I intron splicing",
  "GO:0000373": "Group II intron splicing",
  "GO:0000374": "Group III intron splicing",
  "GO:0000375": "RNA splicing, via transesterification reactions",
  "GO:0000376": "RNA splicing, via transesterification reactions with guanosine as nucleophile",
  "GO:0000377": "RNA splicing, via transesterification reactions with bulged adenosine as nucleophile",
  "GO:0000378": "RNA exon ligation",
  "GO:0000379": "tRNA-type intron splice site recognition and cleavage",
  "GO:0000380": "alternative mRNA splicing, via spliceosome",
  "GO:0000381": "regulation of alternative mRNA splicing, via spliceosome",
  "GO:0000384": "first spliceosomal transesterification activity",
  "GO:0000386": "second spliceosomal transesterification activity",
  "GO:0000387": "spliceosomal snRNP assembly",
  "GO:0000388": "spliceosome conformational change to release U4 (or U4atac) and U1 (or U11)",
  "GO:0000389": "mRNA 3'-splice site recognition",
  "GO:0000390": "spliceosomal complex disassembly",
  "GO:0000393": "spliceosomal conformational changes to generate catalytic conformation",
  "GO:0000394": "RNA splicing, via endonucleolytic cleavage and ligation",
  "GO:0000395": "mRNA 5'-splice site recognition",
  "GO:0000398": "mRNA splicing, via spliceosome",
  "GO:0000399": "cellular bud neck septin structure",
  "GO:0000400": "four-way junction DNA binding",
  "GO:0000401": "open form four-way junction DNA binding",
  "GO:0000402": "crossed form four-way junction DNA binding",
  "GO:0000403": "Y-form DNA binding",
  "GO:0000404": "heteroduplex DNA loop binding",
  "GO:0000405": "bubble DNA binding",
  "GO:0000406": "double-strand/single-strand DNA junction binding",
  "GO:0000407": "pre-autophagosomal structure",
  "GO:0000408": "EKC/KEOPS complex",
  "GO:0000409": "regulation of transcription by galactose",
  "GO:0000410": "negative regulation of transcription by galactose",
  "GO:0000411": "positive regulation of transcription by galactose",
  "GO:0000412": "histone peptidyl-prolyl isomerization",
  "GO:0000413": "protein peptidyl-prolyl isomerization",
  "GO:0000414": "regulation of histone H3-K36 methylation",
  "GO:0000415": "negative regulation of histone H3-K36 methylation",
  "GO:0000416": "positive regulation of histone H3-K36 methylation",
  "GO:0000417": "HIR complex",
  "GO:0000418": "DNA-directed RNA polymerase IV complex",
  "GO:0000419": "DNA-directed RNA polymerase V complex",
  "GO:0000421": "autophagosome membrane",
  "GO:0000422": "mitophagy",
  "GO:0000423": "macromitophagy",
  "GO:0000424": "micromitophagy",
  "GO:0000425": "macropexophagy",
  "GO:0000426": "micropexophagy",
  "GO:0000427": "plastid-encoded plastid RNA polymerase complex",
  "GO:0000428": "DNA-directed RNA polymerase complex",
  "GO:0000429": "carbon catabolite regulation of transcription from RNA polymerase II promoter",
  "GO:0000430": "regulation of transcription from RNA polymerase II promoter by glucose",
  "GO:0000431": "regulation of transcription from RNA polymerase II promoter by galactose",
  "GO:0000432": "positive regulation of transcription from RNA polymerase II promoter by glucose",
  "GO:0000433": "negative regulation of transcription from RNA polymerase II promoter by glucose",
  "GO:0000434": "negative regulation of transcription from RNA polymerase II promoter by galactose",
  "GO:0000435": "positive regulation of transcription from RNA polymerase II promoter by galactose",
  "GO:0000436": "carbon catabolite activation of transcription from RNA polymerase II promoter",
  "GO:0000437": "carbon catabolite repression of transcription from RNA polymerase II promoter",
  "GO:0000438": "core TFIIH complex portion of holo TFIIH complex",
  "GO:0000439": "core TFIIH complex",
  "GO:0000440": "core TFIIH complex portion of NEF3 complex",
  "GO:0000444": "MIS12/MIND type complex",
  "GO:0000445": "THO complex part of transcription export complex",
  "GO:0000446": "nucleoplasmic THO complex",
  "GO:0000447": "endonucleolytic cleavage in ITS1 to separate SSU-rRNA from 5.8S rRNA and LSU-rRNA from tricistronic rRNA transcript (SSU-rRNA, 5.8S rRNA, LSU-rRNA)",
  "GO:0000448": "cleavage in ITS2 between 5.8S rRNA and LSU-rRNA of tricistronic rRNA transcript (SSU-rRNA, 5.8S rRNA, LSU-rRNA)",
  "GO:0000449": "endonucleolytic cleavage of tricistronic rRNA transcript (SSU-rRNA, LSU-rRNA, 5S)",
  "GO:0000450": "cleavage of bicistronic rRNA transcript (SSU-rRNA, LSU-rRNA)",
  "GO:0000451": "rRNA 2'-O-methylation",
  "GO:0000452": "snoRNA guided rRNA 2'-O-methylation",
  "GO:0000453": "enzyme-directed rRNA 2'-O-methylation",
  "GO:0000454": "snoRNA guided rRNA pseudouridine synthesis",
  "GO:0000455": "enzyme-directed rRNA pseudouridine synthesis",
  "GO:0000456": "dimethylation involved in SSU-rRNA maturation",
  "GO:0000457": "endonucleolytic cleavage between SSU-rRNA and LSU-rRNA of tricistronic rRNA transcript (SSU-rRNA, LSU-rRNA, 5S)",
  "GO:0000458": "endonucleolytic cleavage between LSU-rRNA and 5S rRNA of tricistronic rRNA transcript (SSU-rRNA, LSU-rRNA, 5S)",
  "GO:0000459": "exonucleolytic trimming involved in rRNA processing",
  "GO:0000460": "maturation of 5.8S rRNA",
  "GO:0000461": "endonucleolytic cleavage to generate mature 3'-end of SSU-rRNA from (SSU-rRNA, 5.8S rRNA, LSU-rRNA)",
  "GO:0000462": "maturation of SSU-rRNA from tricistronic rRNA transcript (SSU-rRNA, 5.8S rRNA, LSU-rRNA)",
  "GO:0000463": "maturation of LSU-rRNA from tricistronic rRNA transcript (SSU-rRNA, 5.8S rRNA, LSU-rRNA)",
  "GO:0000464": "endonucleolytic cleavage in ITS1 upstream of 5.8S rRNA from tricistronic rRNA transcript (SSU-rRNA, 5.8S rRNA, LSU-rRNA)",
  "GO:0000465": "exonucleolytic trimming to generate mature 5'-end of 5.8S rRNA from tricistronic rRNA transcript (SSU-rRNA, 5.8S rRNA, LSU-rRNA)",
  "GO:0000466": "maturation of 5.8S rRNA from tricistronic rRNA transcript (SSU-rRNA, 5.8S rRNA, LSU-rRNA)",
  "GO:0000467": "exonucleolytic trimming to generate mature 3'-end of 5.8S rRNA from tricistronic rRNA transcript (SSU-rRNA, 5.8S rRNA, LSU-rRNA)",
  "GO:0000468": "generation of mature 3'-end of LSU-rRNA from tricistronic rRNA transcript (SSU-rRNA, 5.8S rRNA, LSU-rRNA)",
  "GO:0000469": "cleavage involved in rRNA processing",
  "GO:0000470": "maturation of LSU-rRNA",
  "GO:0000471": "endonucleolytic cleavage in 3'-ETS of tricistronic rRNA transcript (SSU-rRNA, 5.8S rRNA, LSU-rRNA)",
  "GO:0000472": "endonucleolytic cleavage to generate mature 5'-end of SSU-rRNA from (SSU-rRNA, 5.8S rRNA, LSU-rRNA)",
  "GO:0000473": "maturation of LSU-rRNA from tetracistronic rRNA transcript (SSU-rRNA, 5.8S rRNA, 2S rRNA, LSU-rRNA)",
  "GO:0000474": "maturation of SSU-rRNA from tetracistronic rRNA transcript (SSU-rRNA, 5.8S rRNA, 2S rRNA, LSU-rRNA)",
  "GO:0000475": "maturation of 2S rRNA",
  "GO:0000476": "maturation of 4.5S rRNA",
  "GO:0000477": "generation of mature 5'-end of LSU-rRNA from tricistronic rRNA transcript (SSU-rRNA, 5.8S rRNA, LSU-rRNA)",
  "GO:0000478": "endonucleolytic cleavage involved in rRNA processing",
  "GO:0000479": "endonucleolytic cleavage of tricistronic rRNA transcript (SSU-rRNA, 5.8S rRNA, LSU-rRNA)",
  "GO:0000480": "endonucleolytic cleavage in 5'-ETS of tricistronic rRNA transcript (SSU-rRNA, 5.8S rRNA, LSU-rRNA)",
  "GO:0000481": "maturation of 5S rRNA",
  "GO:0000482": "maturation of 5S rRNA from tetracistronic rRNA transcript (SSU-rRNA, 5.8S rRNA, LSU-rRNA)",
  "GO:0000483": "endonucleolytic cleavage of tetracistronic rRNA transcript (SSU-rRNA, 5.8S rRNA, 2S rRNA, LSU-rRNA)",
  "GO:0000484": "cleavage between SSU-rRNA and 5.8S rRNA of tetracistronic rRNA transcript (SSU-rRNA, 5.8S rRNA, 2S rRNA, LSU-rRNA)",
  "GO:0000485": "cleavage between 2S rRNA and LSU-rRNA of tetracistronic rRNA transcript (SSU-rRNA, 5.8S rRNA, 2S rRNA, LSU-rRNA)",
  "GO:0000486": "cleavage between 5.8S rRNA and 2S rRNA of tetracistronic rRNA transcript (SSU-rRNA, 5.8S rRNA, 2S rRNA, LSU-rRNA)",
  "GO:0000487": "maturation of 5.8S rRNA from tetracistronic rRNA transcript (SSU-rRNA, 5.8S rRNA, 2S rRNA, LSU-rRNA)",
  "GO:0000488": "maturation of LSU-rRNA from tetracistronic rRNA transcript (SSU-rRNA, LSU-rRNA, 4.5S-rRNA, 5S-rRNA)",
  "GO:0000489": "maturation of SSU-rRNA from tetracistronic rRNA transcript (SSU-rRNA, LSU-rRNA, 4.5S-rRNA, 5S-rRNA)",
  "GO:0000491": "small nucleolar ribonucleoprotein complex assembly",
  "GO:0000492": "box C/D snoRNP assembly",
  "GO:0000493": "box H/ACA snoRNP assembly",
  "GO:0000494": "box C/D snoRNA 3'-end processing",
  "GO:0000495": "box H/ACA snoRNA 3'-end processing",
  "GO:0000496": "base pairing",
  "GO:0000497": "base pairing with DNA",
  "GO:0000498": "base pairing with RNA",
  "GO:0000499": "base pairing with mRNA",
  "GO:0000500": "RNA polymerase I upstream activating factor complex",
  "GO:0000501": "flocculation via cell wall protein-carbohydrate interaction",
  "GO:0000502": "proteasome complex",
  "GO:0000504": "obsolete proteasome regulatory particle (sensu Bacteria)",
  "GO:0000506": "glycosylphosphatidylinositol-N-acetylglucosaminyltransferase (GPI-GnT) complex",
  "GO:0000578": "embryonic axis specification",
  "GO:0000700": "mismatch base pair DNA N-glycosylase activity",
  "GO:0000701": "purine-specific mismatch base pair DNA N-glycosylase activity",
  "GO:0000702": "oxidized base lesion DNA N-glycosylase activity",
  "GO:0000703": "oxidized pyrimidine nucleobase lesion DNA N-glycosylase activity",
  "GO:0000704": "pyrimidine dimer DNA N-glycosylase activity",
  "GO:0000705": "achiasmate meiosis I",
  "GO:0000706": "meiotic DNA double-strand break processing",
  "GO:0000707": "meiotic DNA recombinase assembly",
  "GO:0000708": "meiotic strand invasion",
  "GO:0000709": "meiotic joint molecule formation",
  "GO:0000710": "meiotic mismatch repair",
  "GO:0000711": "meiotic DNA repair synthesis",
  "GO:0000712": "resolution of meiotic recombination intermediates",
  "GO:0000713": "meiotic heteroduplex formation",
  "GO:0000714": "meiotic strand displacement",
  "GO:0000715": "nucleotide-excision repair, DNA damage recognition",
  "GO:0000716": "transcription-coupled nucleotide-excision repair, DNA damage recognition",
  "GO:0000717": "nucleotide-excision repair, DNA duplex unwinding",
  "GO:0000718": "nucleotide-excision repair, DNA damage removal",
  "GO:0000719": "photoreactive repair",
  "GO:0000720": "pyrimidine dimer repair by nucleotide-excision repair",
  "GO:0000721": "(R,R)-butanediol dehydrogenase activity",
  "GO:0000722": "telomere maintenance via recombination",
  "GO:0000723": "telomere maintenance",
  "GO:0000724": "double-strand break repair via homologous recombination",
  "GO:0000725": "recombinational repair",
  "GO:0000726": "non-recombinational repair",
  "GO:0000727": "double-strand break repair via break-induced replication",
  "GO:0000728": "gene conversion at mating-type locus, DNA double-strand break formation",
  "GO:0000729": "DNA double-strand break processing",
  "GO:0000730": "DNA recombinase assembly",
  "GO:0000731": "DNA synthesis involved in DNA repair",
  "GO:0000732": "strand displacement",
  "GO:0000733": "DNA strand renaturation",
  "GO:0000734": "gene conversion at mating-type locus, DNA repair synthesis",
  "GO:0000735": "removal of nonhomologous ends",
  "GO:0000736": "double-strand break repair via single-strand annealing, removal of nonhomologous ends",
  "GO:0000737": "DNA catabolic process, endonucleolytic",
  "GO:0000738": "DNA catabolic process, exonucleolytic",
  "GO:0000739": "obsolete DNA strand annealing activity",
  "GO:0000740": "nuclear membrane fusion",
  "GO:0000741": "karyogamy",
  "GO:0000742": "karyogamy involved in conjugation with cellular fusion",
  "GO:0000743": "nuclear migration involved in conjugation with cellular fusion",
  "GO:0000744": "karyogamy involved in conjugation with mutual genetic exchange",
  "GO:0000745": "nuclear migration involved in conjugation with mutual genetic exchange",
  "GO:0000746": "conjugation",
  "GO:0000747": "conjugation with cellular fusion",
  "GO:0000748": "conjugation with mutual genetic exchange",
  "GO:0000749": "response to pheromone involved in conjugation with cellular fusion",
  "GO:0000750": "pheromone-dependent signal transduction involved in conjugation with cellular fusion",
  "GO:0000751": "mitotic cell cycle arrest in response to pheromone",
  "GO:0000752": "agglutination involved in conjugation with cellular fusion",
  "GO:0000753": "cell morphogenesis involved in conjugation with cellular fusion",
  "GO:0000754": "adaptation of signaling pathway by response to pheromone involved in conjugation with cellular fusion",
  "GO:0000755": "cytogamy",
  "GO:0000756": "response to pheromone involved in conjugation with mutual genetic exchange",
  "GO:0000757": "signal transduction involved in conjugation with mutual genetic exchange",
  "GO:0000758": "agglutination involved in conjugation with mutual genetic exchange",
  "GO:0000759": "cell morphogenesis involved in conjugation with mutual genetic exchange",
  "GO:0000760": "adaptation to pheromone involved in conjugation with mutual genetic exchange",
  "GO:0000761": "conjugant formation",
  "GO:0000762": "pheromone-induced unidirectional conjugation",
  "GO:0000763": "obsolete cell morphogenesis involved in unidirectional conjugation",
  "GO:0000764": "obsolete cellular morphogenesis involved in pheromone-induced unidirectional conjugation",
  "GO:0000765": "response to pheromone involved in pheromone-induced unidirectional conjugation",
  "GO:0000766": "negative adaptation of signaling pathway by response to pheromone involved in pheromone-induced unidirectional conjugation",
  "GO:0000767": "cell morphogenesis involved in conjugation",
  "GO:0000768": "syncytium formation by plasma membrane fusion",
  "GO:0000769": "syncytium formation by mitosis without cytokinesis",
  "GO:0000770": "peptide pheromone export",
  "GO:0000771": "agglutination involved in conjugation",
  "GO:0000772": "mating pheromone activity",
  "GO:0000773": "phosphatidyl-N-methylethanolamine N-methyltransferase activity",
  "GO:0000774": "adenyl-nucleotide exchange factor activity",
  "GO:0000775": "chromosome, centromeric region",
  "GO:0000776": "kinetochore",
  "GO:0000777": "condensed chromosome kinetochore",
  "GO:0000778": "condensed nuclear chromosome kinetochore",
  "GO:0000779": "condensed chromosome, centromeric region",
  "GO:0000780": "condensed nuclear chromosome, centromeric region",
  "GO:0000781": "chromosome, telomeric region",
  "GO:0000782": "telomere cap complex",
  "GO:0000783": "nuclear telomere cap complex",
  "GO:0000784": "nuclear chromosome, telomeric region",
  "GO:0000785": "chromatin",
  "GO:0000786": "nucleosome",
  "GO:0000787": "cytoplasmic nucleosome",
  "GO:0000788": "nuclear nucleosome",
  "GO:0000789": "cytoplasmic chromatin",
  "GO:0000790": "nuclear chromatin",
  "GO:0000791": "euchromatin",
  "GO:0000792": "heterochromatin",
  "GO:0000793": "condensed chromosome",
  "GO:0000794": "condensed nuclear chromosome",
  "GO:0000795": "synaptonemal complex",
  "GO:0000796": "condensin complex",
  "GO:0000797": "condensin core heterodimer",
  "GO:0000798": "nuclear cohesin complex",
  "GO:0000799": "nuclear condensin complex",
  "GO:0000800": "lateral element",
  "GO:0000801": "central element",
  "GO:0000802": "transverse filament",
  "GO:0000803": "sex chromosome",
  "GO:0000804": "W chromosome",
  "GO:0000805": "X chromosome",
  "GO:0000806": "Y chromosome",
  "GO:0000807": "Z chromosome",
  "GO:0000808": "origin recognition complex",
  "GO:0000809": "cytoplasmic origin of replication recognition complex",
  "GO:0000810": "diacylglycerol diphosphate phosphatase activity",
  "GO:0000811": "GINS complex",
  "GO:0000812": "Swr1 complex",
  "GO:0000813": "ESCRT I complex",
  "GO:0000814": "ESCRT II complex",
  "GO:0000815": "ESCRT III complex",
  "GO:0000817": "COMA complex",
  "GO:0000818": "nuclear MIS12/MIND complex",
  "GO:0000819": "sister chromatid segregation",
  "GO:0000820": "regulation of glutamine family amino acid metabolic process",
  "GO:0000821": "regulation of arginine metabolic process",
  "GO:0000822": "inositol hexakisphosphate binding",
  "GO:0000823": "inositol-1,4,5-trisphosphate 6-kinase activity",
  "GO:0000824": "inositol tetrakisphosphate 3-kinase activity",
  "GO:0000825": "inositol tetrakisphosphate 6-kinase activity",
  "GO:0000826": "obsolete inositol pyrophosphate synthase activity",
  "GO:0000827": "inositol-1,3,4,5,6-pentakisphosphate kinase activity",
  "GO:0000828": "inositol hexakisphosphate kinase activity",
  "GO:0000829": "inositol heptakisphosphate kinase activity",
  "GO:0000830": "inositol hexakisphosphate 4-kinase activity",
  "GO:0000831": "inositol hexakisphosphate 6-kinase activity",
  "GO:0000832": "inositol hexakisphosphate 5-kinase activity",
  "GO:0000833": "inositol heptakisphosphate 4-kinase activity",
  "GO:0000834": "inositol heptakisphosphate 6-kinase activity",
  "GO:0000835": "ER ubiquitin ligase complex",
  "GO:0000836": "Hrd1p ubiquitin ligase complex",
  "GO:0000837": "Doa10p ubiquitin ligase complex",
  "GO:0000838": "Hrd1p ubiquitin ligase ERAD-M complex",
  "GO:0000839": "Hrd1p ubiquitin ligase ERAD-L complex",
  "GO:0000900": "translation repressor activity, nucleic acid binding",
  "GO:0000901": "translation repressor activity, non-nucleic acid binding",
  "GO:0000902": "cell morphogenesis",
  "GO:0000903": "regulation of cell shape during vegetative growth phase",
  "GO:0000904": "cell morphogenesis involved in differentiation",
  "GO:0000905": "sporocarp development involved in asexual reproduction",
  "GO:0000906": "6,7-dimethyl-8-ribityllumazine synthase activity",
  "GO:0000907": "sulfonate dioxygenase activity",
  "GO:0000908": "taurine dioxygenase activity",
  "GO:0000909": "sporocarp development involved in sexual reproduction",
  "GO:0000910": "cytokinesis",
  "GO:0000911": "cytokinesis by cell plate formation",
  "GO:0000912": "assembly of actomyosin apparatus involved in cytokinesis",
  "GO:0000913": "preprophase band assembly",
  "GO:0000914": "phragmoplast assembly",
  "GO:0000915": "actomyosin contractile ring assembly",
  "GO:0000916": "actomyosin contractile ring contraction",
  "GO:0000917": "barrier septum assembly",
  "GO:0000918": "barrier septum site selection",
  "GO:0000919": "cell plate assembly",
  "GO:0000920": "cell separation after cytokinesis",
  "GO:0000921": "septin ring assembly",
  "GO:0000922": "spindle pole",
  "GO:0000923": "equatorial microtubule organizing center",
  "GO:0000924": "gamma-tubulin ring complex, centrosomal",
  "GO:0000927": "gamma-tubulin small complex, centrosomal",
  "GO:0000928": "gamma-tubulin small complex, spindle pole body",
  "GO:0000930": "gamma-tubulin complex",
  "GO:0000931": "gamma-tubulin large complex",
  "GO:0000932": "cytoplasmic mRNA processing body",
  "GO:0000933": "adventitious septum",
  "GO:0000934": "porous cell septum",
  "GO:0000935": "barrier septum",
  "GO:0000936": "primary cell septum",
  "GO:0000937": "dolipore septum",
  "GO:0000938": "GARP complex",
  "GO:0000939": "condensed chromosome inner kinetochore",
  "GO:0000940": "condensed chromosome outer kinetochore",
  "GO:0000941": "condensed nuclear chromosome inner kinetochore",
  "GO:0000942": "condensed nuclear chromosome outer kinetochore",
  "GO:0000943": "retrotransposon nucleocapsid",
  "GO:0000944": "base pairing with rRNA",
  "GO:0000945": "base pairing with snRNA",
  "GO:0000946": "base pairing with tRNA",
  "GO:0000947": "amino acid catabolic process to alcohol via Ehrlich pathway",
  "GO:0000948": "amino acid catabolic process to carboxylic acid via Ehrlich pathway",
  "GO:0000949": "aromatic amino acid family catabolic process to alcohol via Ehrlich pathway",
  "GO:0000950": "branched-chain amino acid catabolic process to alcohol via Ehrlich pathway",
  "GO:0000951": "methionine catabolic process to 3-methylthiopropanol",
  "GO:0000952": "aromatic amino acid family catabolic process to carboxylic acid via Ehrlich pathway",
  "GO:0000953": "branched-chain amino acid catabolic process to carboxylic acid via Ehrlich pathway",
  "GO:0000954": "methionine catabolic process to 3-methylthiopropanoate",
  "GO:0000955": "amino acid catabolic process via Ehrlich pathway",
  "GO:0000956": "nuclear-transcribed mRNA catabolic process",
  "GO:0000957": "mitochondrial RNA catabolic process",
  "GO:0000958": "mitochondrial mRNA catabolic process",
  "GO:0000959": "mitochondrial RNA metabolic process",
  "GO:0000960": "regulation of mitochondrial RNA catabolic process",
  "GO:0000961": "negative regulation of mitochondrial RNA catabolic process",
  "GO:0000962": "positive regulation of mitochondrial RNA catabolic process",
  "GO:0000963": "mitochondrial RNA processing",
  "GO:0000964": "mitochondrial RNA 5'-end processing",
  "GO:0000965": "mitochondrial RNA 3'-end processing",
  "GO:0000966": "RNA 5'-end processing",
  "GO:0000967": "rRNA 5'-end processing",
  "GO:0000968": "tRNA exon ligation",
  "GO:0000969": "tRNA exon ligation utilizing ATP as source of linkage phosphate",
  "GO:0000970": "tRNA exon ligation utilizing GTP as source of linkage phosphate",
  "GO:0000971": "tRNA exon ligation utilizing 2',3' cyclic phosphate of 5'-exon as source of linkage phosphate",
  "GO:0000972": "transcription-dependent tethering of RNA polymerase II gene DNA at nuclear periphery",
  "GO:0000973": "posttranscriptional tethering of RNA polymerase II gene DNA at nuclear periphery",
  "GO:0000974": "Prp19 complex",
  "GO:0000975": "regulatory region DNA binding",
  "GO:0000976": "transcription regulatory region sequence-specific DNA binding",
  "GO:0000977": "RNA polymerase II regulatory region sequence-specific DNA binding",
  "GO:0000978": "RNA polymerase II core promoter proximal region sequence-specific DNA binding",
  "GO:0000979": "RNA polymerase II core promoter sequence-specific DNA binding",
  "GO:0000980": "RNA polymerase II distal enhancer sequence-specific DNA binding",
  "GO:0000981": "RNA polymerase II transcription factor activity, sequence-specific DNA binding",
  "GO:0000982": "transcription factor activity, RNA polymerase II core promoter proximal region sequence-specific binding",
  "GO:0000983": "transcription factor activity, RNA polymerase II core promoter sequence-specific",
  "GO:0000984": "bacterial-type RNA polymerase regulatory region sequence-specific DNA binding",
  "GO:0000985": "bacterial-type RNA polymerase core promoter sequence-specific DNA binding",
  "GO:0000986": "bacterial-type RNA polymerase core promoter proximal region sequence-specific DNA binding",
  "GO:0000987": "core promoter proximal region sequence-specific DNA binding",
  "GO:0000988": "transcription factor activity, protein binding",
  "GO:0000989": "transcription factor activity, transcription factor binding",
  "GO:0000990": "transcription factor activity, core RNA polymerase binding",
  "GO:0000991": "transcription factor activity, core RNA polymerase II binding",
  "GO:0000992": "polymerase III regulatory region sequence-specific DNA binding",
  "GO:0000993": "RNA polymerase II core binding",
  "GO:0000994": "RNA polymerase III core binding",
  "GO:0000995": "transcription factor activity, core RNA polymerase III binding",
  "GO:0000996": "core DNA-dependent RNA polymerase binding promoter specificity activity",
  "GO:0000997": "mitochondrial RNA polymerase core promoter sequence-specific DNA binding",
  "GO:0000999": "RNA polymerase III type 1 promoter transcriptional preinitiation complex assembly",
  "GO:0001000": "bacterial-type RNA polymerase core enzyme binding",
  "GO:0001001": "mitochondrial single-subunit type RNA polymerase binding",
  "GO:0001002": "RNA polymerase III type 1 promoter sequence-specific DNA binding",
  "GO:0001003": "RNA polymerase III type 2 promoter sequence-specific DNA binding",
  "GO:0001004": "transcription factor activity, RNA polymerase III promoter sequence-specific binding, TFIIIB recruiting",
  "GO:0001005": "transcription factor activity, RNA polymerase III type 1 promoter sequence-specific binding, TFIIIB recruiting",
  "GO:0001006": "RNA polymerase III type 3 promoter sequence-specific DNA binding",
  "GO:0001007": "transcription factor activity, RNA polymerase III transcription factor binding",
  "GO:0001008": "transcription factor activity, RNA polymerase III type 2 promoter sequence-specific binding, TFIIIB recruiting",
  "GO:0001009": "transcription from RNA polymerase III type 2 promoter",
  "GO:0001010": "transcription factor activity, sequence-specific DNA binding transcription factor recruiting",
  "GO:0001011": "transcription factor activity, sequence-specific DNA binding, RNA polymerase recruiting",
  "GO:0001012": "RNA polymerase II regulatory region DNA binding",
  "GO:0001013": "RNA polymerase I regulatory region DNA binding",
  "GO:0001014": "snoRNA transcription from a type 2 RNA polymerase III promoter",
  "GO:0001015": "snoRNA transcription from an RNA polymerase II promoter",
  "GO:0001016": "RNA polymerase III regulatory region DNA binding",
  "GO:0001017": "bacterial-type RNA polymerase regulatory region DNA binding",
  "GO:0001018": "mitochondrial RNA polymerase regulatory region DNA binding",
  "GO:0001019": "plastid RNA polymerase regulatory region DNA binding",
  "GO:0001020": "RNA polymerase III type 3 promoter transcriptional preinitiation complex assembly",
  "GO:0001021": "RNA polymerase III type 2 promoter transcriptional preinitiation complex assembly",
  "GO:0001022": "transcription initiation from RNA polymerase III type 1 promoter",
  "GO:0001023": "transcription initiation from RNA polymerase III type 2 promoter",
  "GO:0001024": "transcription initiation from RNA polymerase III type 3 promoter",
  "GO:0001025": "RNA polymerase III transcription factor binding",
  "GO:0001026": "TFIIIB-type transcription factor activity",
  "GO:0001027": "RNA polymerase III type 1 promoter TFIIIB-type transcription factor activity",
  "GO:0001028": "RNA polymerase III type 2 promoter TFIIIB-type transcription factor activity",
  "GO:0001029": "RNA polymerase III type 3 promoter TFIIIB-type transcription factor activity",
  "GO:0001030": "RNA polymerase III type 1 promoter DNA binding",
  "GO:0001031": "RNA polymerase III type 2 promoter DNA binding",
  "GO:0001032": "RNA polymerase III type 3 promoter DNA binding",
  "GO:0001033": "transcription factor activity, RNA polymerase III type 3 promoter TFIIIB recruiting",
  "GO:0001034": "RNA polymerase III transcription factor activity, sequence-specific DNA binding",
  "GO:0001035": "transcription from RNA polymerase III type 3 promoter",
  "GO:0001036": "transcription initiation from RNA polymerase III hybrid type promoter",
  "GO:0001037": "RNA polymerase III hybrid type promoter DNA binding",
  "GO:0001038": "RNA polymerase III hybrid type promoter TFIIIB recruiting transcription factor activity",
  "GO:0001039": "RNA polymerase III hybrid type promoter sequence-specific DNA binding",
  "GO:0001040": "RNA polymerase III hybrid type promoter TFIIIB-type transcription factor activity",
  "GO:0001041": "transcription from a RNA polymerase III hybrid type promoter",
  "GO:0001042": "RNA polymerase I core binding",
  "GO:0001043": "RNA polymerase III hybrid type promoter transcriptional preinitiation complex assembly",
  "GO:0001044": "mitochondrial RNA polymerase regulatory region sequence-specific DNA binding",
  "GO:0001045": "mitochondrial RNA polymerase core promoter proximal region sequence-specific DNA binding",
  "GO:0001046": "core promoter sequence-specific DNA binding",
  "GO:0001047": "core promoter binding",
  "GO:0001048": "RNA polymerase IV core binding",
  "GO:0001049": "RNA polymerase V core binding",
  "GO:0001050": "single-subunit type RNA polymerase binding",
  "GO:0001051": "plastid single-subunit type RNA polymerase binding",
  "GO:0001052": "plastid PEP RNA polymerase core enzyme binding",
  "GO:0001053": "plastid sigma factor activity",
  "GO:0001054": "RNA polymerase I activity",
  "GO:0001055": "RNA polymerase II activity",
  "GO:0001056": "RNA polymerase III activity",
  "GO:0001057": "RNA polymerase IV activity",
  "GO:0001058": "RNA polymerase V activity",
  "GO:0001059": "transcription from RNA polymerase IV promoter",
  "GO:0001060": "transcription from RNA polymerase V promoter",
  "GO:0001061": "bacterial-type RNA polymerase activity",
  "GO:0001062": "plastid PEP-A RNA polymerase activity",
  "GO:0001063": "plastid PEP-B RNA polymerase activity",
  "GO:0001064": "single subunit type RNA polymerase activity",
  "GO:0001065": "mitochondrial single subunit type RNA polymerase activity",
  "GO:0001066": "plastid single subunit type RNA polymerase activity",
  "GO:0001067": "regulatory region nucleic acid binding",
  "GO:0001068": "transcription regulatory region RNA binding",
  "GO:0001069": "regulatory region RNA binding",
  "GO:0001070": "RNA binding transcription factor activity",
  "GO:0001071": "nucleic acid binding transcription factor activity",
  "GO:0001072": "transcription antitermination factor activity, RNA binding",
  "GO:0001073": "transcription antitermination factor activity, DNA binding",
  "GO:0001074": "transcription factor activity, RNA polymerase II core promoter proximal region sequence-specific binding involved in preinitiation complex assembly",
  "GO:0001075": "transcription factor activity, RNA polymerase II core promoter sequence-specific binding involved in preinitiation complex assembly",
  "GO:0001076": "transcription factor activity, RNA polymerase II transcription factor binding",
  "GO:0001077": "transcriptional activator activity, RNA polymerase II core promoter proximal region sequence-specific binding",
  "GO:0001078": "transcriptional repressor activity, RNA polymerase II core promoter proximal region sequence-specific binding",
  "GO:0001079": "nitrogen catabolite regulation of transcription from RNA polymerase II promoter",
  "GO:0001080": "nitrogen catabolite activation of transcription from RNA polymerase II promoter",
  "GO:0001081": "nitrogen catabolite repression of transcription from RNA polymerase II promoter",
  "GO:0001082": "transcription factor activity, RNA polymerase I transcription factor binding",
  "GO:0001083": "transcription factor activity, RNA polymerase II basal transcription factor binding",
  "GO:0001084": "transcription factor activity, TFIID-class binding",
  "GO:0001085": "RNA polymerase II transcription factor binding",
  "GO:0001086": "transcription factor activity, TFIIA-class binding",
  "GO:0001087": "transcription factor activity, TFIIB-class binding",
  "GO:0001088": "transcription factor activity, TFIIE-class binding",
  "GO:0001089": "transcription factor activity, TFIIF-class transcription factor binding",
  "GO:0001090": "transcription factor activity, TFIIH-class binding",
  "GO:0001091": "RNA polymerase II basal transcription factor binding",
  "GO:0001092": "TFIIA-class transcription factor binding",
  "GO:0001093": "TFIIB-class transcription factor binding",
  "GO:0001094": "TFIID-class transcription factor binding",
  "GO:0001095": "TFIIE-class transcription factor binding",
  "GO:0001096": "TFIIF-class transcription factor binding",
  "GO:0001097": "TFIIH-class transcription factor binding",
  "GO:0001098": "basal transcription machinery binding",
  "GO:0001099": "basal RNA polymerase II transcription machinery binding",
  "GO:0001100": "negative regulation of exit from mitosis",
  "GO:0001101": "response to acid chemical",
  "GO:0001102": "RNA polymerase II activating transcription factor binding",
  "GO:0001103": "RNA polymerase II repressing transcription factor binding",
  "GO:0001104": "RNA polymerase II transcription cofactor activity",
  "GO:0001105": "RNA polymerase II transcription coactivator activity",
  "GO:0001106": "RNA polymerase II transcription corepressor activity",
  "GO:0001108": "bacterial-type RNA polymerase holo enzyme binding",
  "GO:0001109": "promoter clearance during DNA-templated transcription",
  "GO:0001110": "promoter clearance from RNA polymerase III promoter",
  "GO:0001111": "promoter clearance from RNA polymerase II promoter",
  "GO:0001112": "DNA-templated transcriptional open complex formation",
  "GO:0001113": "transcriptional open complex formation at RNA polymerase II promoter",
  "GO:0001114": "protein-DNA-RNA complex",
  "GO:0001115": "protein-DNA-RNA complex subunit organization",
  "GO:0001116": "protein-DNA-RNA complex assembly",
  "GO:0001117": "protein-DNA-RNA complex disassembly",
  "GO:0001118": "transcription ternary complex disassembly",
  "GO:0001119": "protein-DNA-RNA complex remodeling",
  "GO:0001120": "protein-DNA complex remodeling",
  "GO:0001121": "transcription from bacterial-type RNA polymerase promoter",
  "GO:0001122": "promoter clearance from bacterial-type RNA polymerase promoter",
  "GO:0001123": "transcription initiation from bacterial-type RNA polymerase promoter",
  "GO:0001124": "transcription elongation from bacterial-type RNA polymerase promoter",
  "GO:0001125": "transcription termination from bacterial-type RNA polymerase promoter",
  "GO:0001126": "bacterial-type RNA polymerase preinitiation complex assembly",
  "GO:0001127": "transcriptional open complex formation at bacterial-type RNA polymerase promoter",
  "GO:0001128": "RNA polymerase II transcription coactivator activity involved in preinitiation complex assembly",
  "GO:0001129": "RNA polymerase II transcription factor activity, TBP-class protein binding, involved in preinitiation complex assembly",
  "GO:0001130": "bacterial-type RNA polymerase transcription factor activity, sequence-specific DNA binding",
  "GO:0001131": "transcription factor activity, bacterial-type RNA polymerase core promoter proximal region sequence-specific binding",
  "GO:0001132": "RNA polymerase II transcription factor activity, TBP-class protein binding",
  "GO:0001133": "RNA polymerase II transcription factor activity, sequence-specific transcription regulatory region DNA binding",
  "GO:0001134": "transcription factor activity, transcription factor recruiting",
  "GO:0001135": "transcription factor activity, RNA polymerase II transcription factor recruiting",
  "GO:0001136": "transcription factor activity, TFIIE-class transcription factor recruiting",
  "GO:0001137": "transcription factor activity, TFIIF-class transcription factor recruiting",
  "GO:0001138": "transcription factor activity, TFIIH-class transcription factor recruiting",
  "GO:0001139": "transcription factor activity, core RNA polymerase II recruiting",
  "GO:0001140": "transcriptional activator activity, bacterial-type RNA polymerase core promoter proximal region sequence-specific binding",
  "GO:0001141": "transcriptional repressor activity, bacterial-type RNA polymerase core promoter proximal region sequence-specific binding",
  "GO:0001142": "mitochondrial RNA polymerase transcription factor activity, sequence-specific DNA binding",
  "GO:0001143": "mitochondrial RNA polymerase core promoter sequence-specific DNA binding transcription factor activity",
  "GO:0001144": "transcription factor activity, mitochondrial RNA polymerase core promoter proximal region sequence-specific binding",
  "GO:0001145": "mitochondrial RNA polymerase termination site sequence-specific DNA binding",
  "GO:0001146": "transcription factor activity, mitochondrial RNA polymerase terminator site sequence-specific binding",
  "GO:0001147": "transcription termination site sequence-specific DNA binding",
  "GO:0001148": "bacterial-type RNA polymerase termination site sequence-specific DNA binding",
  "GO:0001149": "transcription factor activity, bacterial-type RNA polymerase termination site sequence-specific binding",
  "GO:0001150": "bacterial-type RNA polymerase enhancer sequence-specific DNA binding",
  "GO:0001151": "transcription factor activity, bacterial-type RNA polymerase transcription enhancer sequence-specific binding",
  "GO:0001152": "transcription factor activity, RNA polymerase III type 1 promoter sequence-specific binding, TFIIIC recruiting",
  "GO:0001153": "transcription factor activity, RNA polymerase III transcription factor recruiting",
  "GO:0001154": "TFIIIB-class transcription factor binding",
  "GO:0001155": "TFIIIA-class transcription factor binding",
  "GO:0001156": "TFIIIC-class transcription factor binding",
  "GO:0001157": "transcription factor activity, RNA polymerase III type 1 promoter TFIIIB",
  "GO:0001158": "enhancer sequence-specific DNA binding",
  "GO:0001159": "core promoter proximal region DNA binding",
  "GO:0001160": "transcription termination site DNA binding",
  "GO:0001161": "intronic transcription regulatory region sequence-specific DNA binding",
  "GO:0001162": "RNA polymerase II intronic transcription regulatory region sequence-specific DNA binding",
  "GO:0001163": "RNA polymerase I regulatory region sequence-specific DNA binding",
  "GO:0001164": "RNA polymerase I CORE element sequence-specific DNA binding",
  "GO:0001165": "RNA polymerase I upstream control element sequence-specific DNA binding",
  "GO:0001166": "RNA polymerase I enhancer sequence-specific DNA binding",
  "GO:0001167": "RNA polymerase I transcription factor activity, sequence-specific DNA binding",
  "GO:0001168": "transcription factor activity, RNA polymerase I upstream control element sequence-specific binding",
  "GO:0001169": "transcription factor activity, RNA polymerase I CORE element sequence-specific binding",
  "GO:0001170": "transcription factor activity, RNA polymerase I enhancer sequence-specific binding",
  "GO:0001171": "reverse transcription",
  "GO:0001172": "transcription, RNA-templated",
  "GO:0001173": "DNA-templated transcriptional start site selection",
  "GO:0001174": "transcriptional start site selection at RNA polymerase II promoter",
  "GO:0001175": "transcriptional start site selection at RNA polymerase III promoter",
  "GO:0001176": "transcriptional start site selection at bacterial-type RNA polymerase promoter",
  "GO:0001177": "regulation of transcriptional open complex formation at RNA polymerase II promoter",
  "GO:0001178": "regulation of transcriptional start site selection at RNA polymerase II promoter",
  "GO:0001179": "RNA polymerase I transcription factor binding",
  "GO:0001180": "transcription initiation from RNA polymerase I promoter for nuclear large rRNA transcript",
  "GO:0001181": "transcription factor activity, core RNA polymerase I binding",
  "GO:0001182": "promoter clearance from RNA polymerase I promoter",
  "GO:0001183": "transcription elongation from RNA polymerase I promoter for nuclear large rRNA transcript",
  "GO:0001184": "promoter clearance from RNA polymerase I promoter for nuclear large rRNA transcript",
  "GO:0001185": "termination of RNA polymerase I transcription from promoter for nuclear large rRNA transcript",
  "GO:0001186": "transcription factor activity, RNA polymerase I transcription factor recruiting",
  "GO:0001187": "transcription factor activity, RNA polymerase I CORE element binding transcription factor recruiting",
  "GO:0001188": "RNA polymerase I transcriptional preinitiation complex assembly",
  "GO:0001189": "RNA polymerase I transcriptional preinitiation complex assembly at the promoter for the nuclear large rRNA transcript",
  "GO:0001190": "transcriptional activator activity, RNA polymerase II transcription factor binding",
  "GO:0001191": "transcriptional repressor activity, RNA polymerase II transcription factor binding",
  "GO:0001192": "maintenance of transcriptional fidelity during DNA-templated transcription elongation",
  "GO:0001193": "maintenance of transcriptional fidelity during DNA-templated transcription elongation from RNA polymerase II promoter",
  "GO:0001194": "maintenance of transcriptional fidelity during DNA-templated transcription elongation from bacterial-type RNA polymerase promoter",
  "GO:0001195": "maintenance of transcriptional fidelity during DNA-templated transcription elongation from RNA polymerase III promoter",
  "GO:0001196": "regulation of mating-type specific transcription from RNA polymerase II promoter",
  "GO:0001197": "positive regulation of mating-type specific transcription from RNA polymerase II promoter",
  "GO:0001198": "negative regulation of mating-type specific transcription from RNA polymerase II promoter",
  "GO:0001199": "transcription factor activity, metal ion regulated sequence-specific DNA binding",
  "GO:0001200": "RNA polymerase II transcription factor activity, metal ion regulated sequence-specific DNA binding",
  "GO:0001201": "RNA polymerase II transcription factor activity, metal ion regulated core promoter proximal region sequence-specific binding",
  "GO:0001202": "RNA polymerase II transcription factor activity, copper ion regulated core promoter proximal region sequence-specific binding",
  "GO:0001203": "RNA polymerase II transcription factor activity, zinc ion regulated core promoter proximal region sequence-specific DNA binding",
  "GO:0001204": "bacterial-type RNA polymerase transcription factor activity, metal ion regulated sequence-specific DNA binding",
  "GO:0001205": "transcriptional activator activity, RNA polymerase II distal enhancer sequence-specific binding",
  "GO:0001206": "transcriptional repressor activity, RNA polymerase II distal enhancer sequence-specific binding",
  "GO:0001207": "histone displacement",
  "GO:0001208": "histone H2A-H2B dimer displacement",
  "GO:0001209": "transcriptional activator activity, metal ion regulated sequence-specific DNA binding",
  "GO:0001210": "transcriptional repressor activity, metal ion regulated sequence-specific DNA binding",
  "GO:0001211": "RNA polymerase II transcriptional activator activity, copper ion regulated core promoter proximal region sequence-specific binding",
  "GO:0001212": "RNA polymerase II transcriptional activator activity, zinc ion regulated core promoter proximal region sequence-specific binding",
  "GO:0001213": "RNA polymerase II transcriptional activator activity, metal ion regulated core promoter proximal region sequence-specific binding",
  "GO:0001214": "RNA polymerase II transcriptional repressor activity, metal ion regulated core promoter proximal region sequence-specific binding",
  "GO:0001215": "bacterial-type RNA polymerase transcriptional activator activity, metal ion regulated sequence-specific DNA binding",
  "GO:0001216": "bacterial-type RNA polymerase transcriptional activator activity, sequence-specific DNA binding",
  "GO:0001217": "bacterial-type RNA polymerase transcriptional repressor activity, sequence-specific DNA binding",
  "GO:0001218": "bacterial-type RNA polymerase transcriptional repressor activity, metal ion regulated sequence-specific DNA binding",
  "GO:0001219": "bacterial-type RNA polymerase transcriptional repressor activity, copper ion regulated sequence-specific DNA binding",
  "GO:0001220": "bacterial-type RNA polymerase transcriptional repressor activity, cadmium ion regulated sequence-specific DNA binding",
  "GO:0001221": "transcription cofactor binding",
  "GO:0001222": "transcription corepressor binding",
  "GO:0001223": "transcription coactivator binding",
  "GO:0001224": "RNA polymerase II transcription cofactor binding",
  "GO:0001225": "RNA polymerase II transcription coactivator binding",
  "GO:0001226": "RNA polymerase II transcription corepressor binding",
  "GO:0001227": "transcriptional repressor activity, RNA polymerase II transcription regulatory region sequence-specific binding",
  "GO:0001228": "transcriptional activator activity, RNA polymerase II transcription regulatory region sequence-specific binding",
  "GO:0001300": "chronological cell aging",
  "GO:0001301": "progressive alteration of chromatin involved in cell aging",
  "GO:0001302": "replicative cell aging",
  "GO:0001303": "nucleolar fragmentation involved in replicative aging",
  "GO:0001304": "progressive alteration of chromatin involved in replicative cell aging",
  "GO:0001305": "progressive alteration of chromatin involved in chronological cell aging",
  "GO:0001306": "age-dependent response to oxidative stress",
  "GO:0001307": "extrachromosomal circular DNA accumulation involved in replicative cell aging",
  "GO:0001308": "negative regulation of chromatin silencing involved in replicative cell aging",
  "GO:0001309": "obsolete age-dependent telomere shortening",
  "GO:0001310": "extrachromosomal rDNA circle accumulation involved in replicative cell aging",
  "GO:0001311": "formation of extrachromosomal circular rDNA by homologous recombination involved in replicative cell aging",
  "GO:0001312": "replication of extrachromosomal rDNA circles involved in replicative cell aging",
  "GO:0001313": "formation of extrachromosomal circular DNA involved in replicative cell aging",
  "GO:0001314": "replication of extrachromosomal circular DNA involved in replicative cell aging",
  "GO:0001315": "age-dependent response to reactive oxygen species",
  "GO:0001316": "age-dependent response to reactive oxygen species involved in replicative cell aging",
  "GO:0001317": "accumulation of oxidatively modified proteins involved in replicative cell aging",
  "GO:0001318": "formation of oxidatively modified proteins involved in replicative cell aging",
  "GO:0001319": "inheritance of oxidatively modified proteins involved in replicative cell aging",
  "GO:0001320": "age-dependent response to reactive oxygen species involved in chronological cell aging",
  "GO:0001321": "age-dependent general metabolic decline involved in replicative cell aging",
  "GO:0001322": "age-dependent response to oxidative stress involved in replicative cell aging",
  "GO:0001323": "age-dependent general metabolic decline involved in chronological cell aging",
  "GO:0001324": "age-dependent response to oxidative stress involved in chronological cell aging",
  "GO:0001325": "formation of extrachromosomal circular DNA",
  "GO:0001326": "replication of extrachromosomal circular DNA",
  "GO:0001400": "mating projection base",
  "GO:0001401": "mitochondrial sorting and assembly machinery complex",
  "GO:0001402": "signal transduction involved in filamentous growth",
  "GO:0001403": "invasive growth in response to glucose limitation",
  "GO:0001404": "obsolete invasive growth",
  "GO:0001405": "presequence translocase-associated import motor",
  "GO:0001406": "glycerophosphodiester transmembrane transporter activity",
  "GO:0001407": "glycerophosphodiester transport",
  "GO:0001408": "guanine nucleotide transport",
  "GO:0001409": "guanine nucleotide transmembrane transporter activity",
  "GO:0001410": "chlamydospore formation",
  "GO:0001411": "hyphal tip",
  "GO:0001501": "skeletal system development",
  "GO:0001502": "cartilage condensation",
  "GO:0001503": "ossification",
  "GO:0001504": "neurotransmitter uptake",
  "GO:0001505": "regulation of neurotransmitter levels",
  "GO:0001506": "obsolete neurotransmitter biosynthetic process and storage",
  "GO:0001507": "acetylcholine catabolic process in synaptic cleft",
  "GO:0001508": "action potential",
  "GO:0001509": "obsolete legumain activity",
  "GO:0001510": "RNA methylation",
  "GO:0001511": "obsolete fibrillin",
  "GO:0001512": "dihydronicotinamide riboside quinone reductase activity",
  "GO:0001514": "selenocysteine incorporation",
  "GO:0001515": "opioid peptide activity",
  "GO:0001516": "prostaglandin biosynthetic process",
  "GO:0001517": "N-acetylglucosamine 6-O-sulfotransferase activity",
  "GO:0001518": "voltage-gated sodium channel complex",
  "GO:0001519": "peptide amidation",
  "GO:0001520": "outer dense fiber",
  "GO:0001522": "pseudouridine synthesis",
  "GO:0001523": "retinoid metabolic process",
  "GO:0001524": "obsolete globin",
  "GO:0001525": "angiogenesis",
  "GO:0001526": "obsolete proteoglycan sulfate transfer",
  "GO:0001527": "microfibril",
  "GO:0001528": "obsolete elastin",
  "GO:0001529": "obsolete elastin",
  "GO:0001530": "lipopolysaccharide binding",
  "GO:0001531": "interleukin-21 receptor binding",
  "GO:0001532": "interleukin-21 receptor activity",
  "GO:0001533": "cornified envelope",
  "GO:0001534": "radial spoke",
  "GO:0001535": "radial spokehead",
  "GO:0001536": "radial spoke stalk",
  "GO:0001537": "N-acetylgalactosamine 4-O-sulfotransferase activity",
  "GO:0001539": "cilium or flagellum-dependent cell motility",
  "GO:0001540": "beta-amyloid binding",
  "GO:0001541": "ovarian follicle development",
  "GO:0001542": "ovulation from ovarian follicle",
  "GO:0001543": "ovarian follicle rupture",
  "GO:0001544": "initiation of primordial ovarian follicle growth",
  "GO:0001545": "primary ovarian follicle growth",
  "GO:0001546": "preantral ovarian follicle growth",
  "GO:0001547": "antral ovarian follicle growth",
  "GO:0001548": "follicular fluid formation in ovarian follicle antrum",
  "GO:0001549": "cumulus cell differentiation",
  "GO:0001550": "ovarian cumulus expansion",
  "GO:0001551": "ovarian follicle endowment",
  "GO:0001552": "ovarian follicle atresia",
  "GO:0001553": "luteinization",
  "GO:0001554": "luteolysis",
  "GO:0001555": "oocyte growth",
  "GO:0001556": "oocyte maturation",
  "GO:0001557": "obsolete metabolic process resulting in cell growth",
  "GO:0001558": "regulation of cell growth",
  "GO:0001559": "regulation of cell growth by detection of nuclear:cytoplasmic ratio",
  "GO:0001560": "regulation of cell growth by extracellular stimulus",
  "GO:0001561": "fatty acid alpha-oxidation",
  "GO:0001562": "response to protozoan",
  "GO:0001563": "detection of protozoan",
  "GO:0001564": "obsolete resistance to pathogenic protozoa",
  "GO:0001565": "phorbol ester receptor activity",
  "GO:0001566": "non-kinase phorbol ester receptor activity",
  "GO:0001567": "cholesterol 25-hydroxylase activity",
  "GO:0001568": "blood vessel development",
  "GO:0001569": "patterning of blood vessels",
  "GO:0001570": "vasculogenesis",
  "GO:0001571": "non-tyrosine kinase fibroblast growth factor receptor activity",
  "GO:0001572": "lactosylceramide biosynthetic process",
  "GO:0001573": "ganglioside metabolic process",
  "GO:0001574": "ganglioside biosynthetic process",
  "GO:0001575": "globoside metabolic process",
  "GO:0001576": "globoside biosynthetic process",
  "GO:0001577": "obsolete galectin",
  "GO:0001578": "microtubule bundle formation",
  "GO:0001579": "medium-chain fatty acid transport",
  "GO:0001580": "detection of chemical stimulus involved in sensory perception of bitter taste",
  "GO:0001581": "detection of chemical stimulus involved in sensory perception of sour taste",
  "GO:0001582": "detection of chemical stimulus involved in sensory perception of sweet taste",
  "GO:0001583": "detection of chemical stimulus involved in sensory perception of salty taste",
  "GO:0001584": "obsolete rhodopsin-like receptor activity",
  "GO:0001586": "Gi/o-coupled serotonin receptor activity",
  "GO:0001587": "Gq/11-coupled serotonin receptor activity",
  "GO:0001588": "dopamine neurotransmitter receptor activity, coupled via Gs",
  "GO:0001591": "dopamine neurotransmitter receptor activity, coupled via Gi/Go",
  "GO:0001594": "trace-amine receptor activity",
  "GO:0001595": "angiotensin receptor activity",
  "GO:0001596": "angiotensin type I receptor activity",
  "GO:0001597": "obsolete apelin-like receptor",
  "GO:0001598": "obsolete chemokine receptor-like receptor activity",
  "GO:0001601": "peptide YY receptor activity",
  "GO:0001602": "pancreatic polypeptide receptor activity",
  "GO:0001603": "obsolete vasopressin-like receptor activity",
  "GO:0001604": "urotensin II receptor activity",
  "GO:0001605": "adrenomedullin receptor activity",
  "GO:0001606": "obsolete GPR37/endothelin B-like receptor activity",
  "GO:0001607": "neuromedin U receptor activity",
  "GO:0001608": "G-protein coupled nucleotide receptor activity",
  "GO:0001609": "G-protein coupled adenosine receptor activity",
  "GO:0001614": "purinergic nucleotide receptor activity",
  "GO:0001615": "obsolete thyrotropin releasing hormone and secretagogue-like receptors activity",
  "GO:0001616": "growth hormone secretagogue receptor activity",
  "GO:0001617": "obsolete growth hormone secretagogue-like receptor activity",
  "GO:0001618": "virus receptor activity",
  "GO:0001619": "obsolete lysosphingolipid and lysophosphatidic acid receptor activity",
  "GO:0001621": "ADP receptor activity",
  "GO:0001626": "nociceptin receptor activity",
  "GO:0001627": "obsolete leucine-rich G-protein receptor-like receptor activity",
  "GO:0001628": "obsolete gastropyloric receptor activity",
  "GO:0001629": "obsolete G-protein receptor 45-like receptor activity",
  "GO:0001630": "obsolete GP40-like receptor activity",
  "GO:0001631": "cysteinyl leukotriene receptor activity",
  "GO:0001632": "leukotriene B4 receptor activity",
  "GO:0001633": "obsolete secretin-like receptor activity",
  "GO:0001634": "pituitary adenylate cyclase-activating polypeptide receptor activity",
  "GO:0001635": "calcitonin gene-related peptide receptor activity",
  "GO:0001636": "obsolete corticotrophin-releasing factor gastric inhibitory peptide-like receptor activity",
  "GO:0001637": "G-protein coupled chemoattractant receptor activity",
  "GO:0001639": "PLC activating G-protein coupled glutamate receptor activity",
  "GO:0001640": "adenylate cyclase inhibiting G-protein coupled glutamate receptor activity",
  "GO:0001641": "group II metabotropic glutamate receptor activity",
  "GO:0001642": "group III metabotropic glutamate receptor activity",
  "GO:0001646": "cAMP receptor activity",
  "GO:0001647": "G-protein coupled cytokinin receptor activity",
  "GO:0001648": "proteinase activated receptor activity",
  "GO:0001649": "osteoblast differentiation",
  "GO:0001650": "fibrillar center",
  "GO:0001651": "dense fibrillar component",
  "GO:0001652": "granular component",
  "GO:0001653": "peptide receptor activity",
  "GO:0001654": "eye development",
  "GO:0001655": "urogenital system development",
  "GO:0001656": "metanephros development",
  "GO:0001657": "ureteric bud development",
  "GO:0001658": "branching involved in ureteric bud morphogenesis",
  "GO:0001659": "temperature homeostasis",
  "GO:0001660": "fever generation",
  "GO:0001661": "conditioned taste aversion",
  "GO:0001662": "behavioral fear response",
  "GO:0001664": "G-protein coupled receptor binding",
  "GO:0001665": "alpha-N-acetylgalactosaminide alpha-2,6-sialyltransferase activity",
  "GO:0001666": "response to hypoxia",
  "GO:0001667": "ameboidal-type cell migration",
  "GO:0001669": "acrosomal vesicle",
  "GO:0001671": "ATPase activator activity",
  "GO:0001672": "regulation of chromatin assembly or disassembly",
  "GO:0001673": "male germ cell nucleus",
  "GO:0001674": "female germ cell nucleus",
  "GO:0001675": "acrosome assembly",
  "GO:0001676": "long-chain fatty acid metabolic process",
  "GO:0001677": "formation of translation initiation ternary complex",
  "GO:0001678": "cellular glucose homeostasis",
  "GO:0001680": "tRNA 3'-terminal CCA addition",
  "GO:0001681": "sialate O-acetylesterase activity",
  "GO:0001682": "tRNA 5'-leader removal",
  "GO:0001683": "obsolete axonemal dynein heavy chain",
  "GO:0001684": "obsolete axonemal dynein intermediate chain",
  "GO:0001685": "obsolete axonemal dynein intermediate light chain",
  "GO:0001686": "obsolete axonemal dynein light chain",
  "GO:0001687": "obsolete cytoplasmic dynein heavy chain",
  "GO:0001688": "obsolete cytoplasmic dynein intermediate chain",
  "GO:0001689": "obsolete cytoplasmic dynein intermediate light chain",
  "GO:0001690": "obsolete cytoplasmic dynein light chain",
  "GO:0001691": "pseudophosphatase activity",
  "GO:0001692": "histamine metabolic process",
  "GO:0001694": "histamine biosynthetic process",
  "GO:0001695": "histamine catabolic process",
  "GO:0001696": "gastric acid secretion",
  "GO:0001697": "histamine-induced gastric acid secretion",
  "GO:0001698": "gastrin-induced gastric acid secretion",
  "GO:0001699": "acetylcholine-induced gastric acid secretion",
  "GO:0001700": "embryonic development via the syncytial blastoderm",
  "GO:0001701": "in utero embryonic development",
  "GO:0001702": "gastrulation with mouth forming second",
  "GO:0001703": "gastrulation with mouth forming first",
  "GO:0001704": "formation of primary germ layer",
  "GO:0001705": "ectoderm formation",
  "GO:0001706": "endoderm formation",
  "GO:0001707": "mesoderm formation",
  "GO:0001708": "cell fate specification",
  "GO:0001709": "cell fate determination",
  "GO:0001710": "mesodermal cell fate commitment",
  "GO:0001711": "endodermal cell fate commitment",
  "GO:0001712": "ectodermal cell fate commitment",
  "GO:0001713": "ectodermal cell fate determination",
  "GO:0001714": "endodermal cell fate specification",
  "GO:0001715": "ectodermal cell fate specification",
  "GO:0001716": "L-amino-acid oxidase activity",
  "GO:0001717": "conversion of seryl-tRNAsec to selenocys-tRNAsec",
  "GO:0001720": "conversion of lysyl-tRNA to pyrrolysyl-tRNA",
  "GO:0001721": "obsolete intermediate filament associated protein",
  "GO:0001722": "obsolete type I intermediate filament associated protein",
  "GO:0001723": "obsolete type II intermediate filament associated protein",
  "GO:0001724": "obsolete type III intermediate filament associated protein",
  "GO:0001725": "stress fiber",
  "GO:0001726": "ruffle",
  "GO:0001727": "lipid kinase activity",
  "GO:0001729": "ceramide kinase activity",
  "GO:0001730": "2'-5'-oligoadenylate synthetase activity",
  "GO:0001731": "formation of translation preinitiation complex",
  "GO:0001732": "formation of cytoplasmic translation initiation complex",
  "GO:0001733": "galactosylceramide sulfotransferase activity",
  "GO:0001734": "mRNA (N6-adenosine)-methyltransferase activity",
  "GO:0001735": "prenylcysteine oxidase activity",
  "GO:0001736": "establishment of planar polarity",
  "GO:0001737": "establishment of imaginal disc-derived wing hair orientation",
  "GO:0001738": "morphogenesis of a polarized epithelium",
  "GO:0001739": "sex chromatin",
  "GO:0001740": "Barr body",
  "GO:0001741": "XY body",
  "GO:0001742": "oenocyte differentiation",
  "GO:0001743": "optic placode formation",
  "GO:0001744": "optic lobe placode formation",
  "GO:0001745": "compound eye morphogenesis",
  "GO:0001746": "Bolwig's organ morphogenesis",
  "GO:0001748": "optic lobe placode development",
  "GO:0001750": "photoreceptor outer segment",
  "GO:0001751": "compound eye photoreceptor cell differentiation",
  "GO:0001752": "compound eye photoreceptor fate commitment",
  "GO:0001753": "obsolete adult eye photoreceptor development (sensu Drosophila)",
  "GO:0001754": "eye photoreceptor cell differentiation",
  "GO:0001755": "neural crest cell migration",
  "GO:0001756": "somitogenesis",
  "GO:0001757": "somite specification",
  "GO:0001758": "retinal dehydrogenase activity",
  "GO:0001759": "organ induction",
  "GO:0001760": "aminocarboxymuconate-semialdehyde decarboxylase activity",
  "GO:0001761": "beta-alanine transmembrane transporter activity",
  "GO:0001762": "beta-alanine transport",
  "GO:0001763": "morphogenesis of a branching structure",
  "GO:0001764": "neuron migration",
  "GO:0001765": "membrane raft assembly",
  "GO:0001766": "membrane raft polarization",
  "GO:0001767": "establishment of lymphocyte polarity",
  "GO:0001768": "establishment of T cell polarity",
  "GO:0001769": "establishment of B cell polarity",
  "GO:0001770": "establishment of natural killer cell polarity",
  "GO:0001771": "immunological synapse formation",
  "GO:0001772": "immunological synapse",
  "GO:0001773": "myeloid dendritic cell activation",
  "GO:0001774": "microglial cell activation",
  "GO:0001775": "cell activation",
  "GO:0001776": "leukocyte homeostasis",
  "GO:0001777": "T cell homeostatic proliferation",
  "GO:0001778": "plasma membrane repair",
  "GO:0001779": "natural killer cell differentiation",
  "GO:0001780": "neutrophil homeostasis",
  "GO:0001781": "neutrophil apoptotic process",
  "GO:0001782": "B cell homeostasis",
  "GO:0001783": "B cell apoptotic process",
  "GO:0001784": "phosphotyrosine binding",
  "GO:0001785": "prostaglandin J receptor activity",
  "GO:0001786": "phosphatidylserine binding",
  "GO:0001787": "natural killer cell proliferation",
  "GO:0001788": "antibody-dependent cellular cytotoxicity",
  "GO:0001789": "G-protein coupled receptor signaling pathway, coupled to S1P second messenger",
  "GO:0001790": "polymeric immunoglobulin binding",
  "GO:0001791": "IgM binding",
  "GO:0001792": "polymeric immunoglobulin receptor activity",
  "GO:0001793": "IgM receptor activity",
  "GO:0001794": "type IIa hypersensitivity",
  "GO:0001795": "type IIb hypersensitivity",
  "GO:0001796": "regulation of type IIa hypersensitivity",
  "GO:0001797": "negative regulation of type IIa hypersensitivity",
  "GO:0001798": "positive regulation of type IIa hypersensitivity",
  "GO:0001799": "regulation of type IIb hypersensitivity",
  "GO:0001800": "negative regulation of type IIb hypersensitivity",
  "GO:0001801": "positive regulation of type IIb hypersensitivity",
  "GO:0001802": "type III hypersensitivity",
  "GO:0001803": "regulation of type III hypersensitivity",
  "GO:0001804": "negative regulation of type III hypersensitivity",
  "GO:0001805": "positive regulation of type III hypersensitivity",
  "GO:0001806": "type IV hypersensitivity",
  "GO:0001807": "regulation of type IV hypersensitivity",
  "GO:0001808": "negative regulation of type IV hypersensitivity",
  "GO:0001809": "positive regulation of type IV hypersensitivity",
  "GO:0001810": "regulation of type I hypersensitivity",
  "GO:0001811": "negative regulation of type I hypersensitivity",
  "GO:0001812": "positive regulation of type I hypersensitivity",
  "GO:0001813": "regulation of antibody-dependent cellular cytotoxicity",
  "GO:0001814": "negative regulation of antibody-dependent cellular cytotoxicity",
  "GO:0001815": "positive regulation of antibody-dependent cellular cytotoxicity",
  "GO:0001816": "cytokine production",
  "GO:0001817": "regulation of cytokine production",
  "GO:0001818": "negative regulation of cytokine production",
  "GO:0001819": "positive regulation of cytokine production",
  "GO:0001820": "serotonin secretion",
  "GO:0001821": "histamine secretion",
  "GO:0001822": "kidney development",
  "GO:0001823": "mesonephros development",
  "GO:0001824": "blastocyst development",
  "GO:0001825": "blastocyst formation",
  "GO:0001826": "inner cell mass cell differentiation",
  "GO:0001827": "inner cell mass cell fate commitment",
  "GO:0001828": "inner cell mass cellular morphogenesis",
  "GO:0001829": "trophectodermal cell differentiation",
  "GO:0001830": "trophectodermal cell fate commitment",
  "GO:0001831": "trophectodermal cellular morphogenesis",
  "GO:0001832": "blastocyst growth",
  "GO:0001833": "inner cell mass cell proliferation",
  "GO:0001834": "trophectodermal cell proliferation",
  "GO:0001835": "blastocyst hatching",
  "GO:0001836": "release of cytochrome c from mitochondria",
  "GO:0001837": "epithelial to mesenchymal transition",
  "GO:0001838": "embryonic epithelial tube formation",
  "GO:0001839": "neural plate morphogenesis",
  "GO:0001840": "neural plate development",
  "GO:0001841": "neural tube formation",
  "GO:0001842": "neural fold formation",
  "GO:0001843": "neural tube closure",
  "GO:0001844": "protein insertion into mitochondrial membrane involved in apoptotic signaling pathway",
  "GO:0001845": "phagolysosome assembly",
  "GO:0001846": "opsonin binding",
  "GO:0001847": "opsonin receptor activity",
  "GO:0001848": "complement binding",
  "GO:0001849": "complement component C1q binding",
  "GO:0001850": "complement component C3a binding",
  "GO:0001851": "complement component C3b binding",
  "GO:0001852": "complement component iC3b binding",
  "GO:0001853": "complement component C3dg binding",
  "GO:0001854": "complement component C3d binding",
  "GO:0001855": "complement component C4b binding",
  "GO:0001856": "complement component C5a binding",
  "GO:0001857": "complement component C1q receptor activity",
  "GO:0001858": "complement component iC3b receptor activity",
  "GO:0001859": "complement component C3dg receptor activity",
  "GO:0001860": "complement component C3d receptor activity",
  "GO:0001861": "complement component C4b receptor activity",
  "GO:0001862": "collectin binding",
  "GO:0001863": "collectin receptor activity",
  "GO:0001864": "pentraxin binding",
  "GO:0001865": "NK T cell differentiation",
  "GO:0001866": "NK T cell proliferation",
  "GO:0001867": "complement activation, lectin pathway",
  "GO:0001868": "regulation of complement activation, lectin pathway",
  "GO:0001869": "negative regulation of complement activation, lectin pathway",
  "GO:0001870": "positive regulation of complement activation, lectin pathway",
  "GO:0001871": "pattern binding",
  "GO:0001872": "(1->3)-beta-D-glucan binding",
  "GO:0001873": "polysaccharide receptor activity",
  "GO:0001874": "(1->3)-beta-D-glucan receptor activity",
  "GO:0001875": "lipopolysaccharide receptor activity",
  "GO:0001876": "lipoarabinomannan binding",
  "GO:0001877": "lipoarabinomannan receptor activity",
  "GO:0001878": "response to yeast",
  "GO:0001879": "detection of yeast",
  "GO:0001880": "Mullerian duct regression",
  "GO:0001881": "receptor recycling",
  "GO:0001882": "nucleoside binding",
  "GO:0001883": "purine nucleoside binding",
  "GO:0001884": "pyrimidine nucleoside binding",
  "GO:0001885": "endothelial cell development",
  "GO:0001886": "endothelial cell morphogenesis",
  "GO:0001887": "selenium compound metabolic process",
  "GO:0001888": "glucuronyl-galactosyl-proteoglycan 4-alpha-N-acetylglucosaminyltransferase activity",
  "GO:0001889": "liver development",
  "GO:0001890": "placenta development",
  "GO:0001891": "phagocytic cup",
  "GO:0001892": "embryonic placenta development",
  "GO:0001893": "maternal placenta development",
  "GO:0001894": "tissue homeostasis",
  "GO:0001895": "retina homeostasis",
  "GO:0001896": "autolysis",
  "GO:0001897": "cytolysis by symbiont of host cells",
  "GO:0001898": "regulation of cytolysis by symbiont of host cells",
  "GO:0001899": "negative regulation of cytolysis by symbiont of host cells",
  "GO:0001900": "positive regulation of cytolysis by symbiont of host cells",
  "GO:0001905": "activation of membrane attack complex",
  "GO:0001906": "cell killing",
  "GO:0001907": "killing by symbiont of host cells",
  "GO:0001909": "leukocyte mediated cytotoxicity",
  "GO:0001910": "regulation of leukocyte mediated cytotoxicity",
  "GO:0001911": "negative regulation of leukocyte mediated cytotoxicity",
  "GO:0001912": "positive regulation of leukocyte mediated cytotoxicity",
  "GO:0001913": "T cell mediated cytotoxicity",
  "GO:0001914": "regulation of T cell mediated cytotoxicity",
  "GO:0001915": "negative regulation of T cell mediated cytotoxicity",
  "GO:0001916": "positive regulation of T cell mediated cytotoxicity",
  "GO:0001917": "photoreceptor inner segment",
  "GO:0001918": "farnesylated protein binding",
  "GO:0001919": "regulation of receptor recycling",
  "GO:0001920": "negative regulation of receptor recycling",
  "GO:0001921": "positive regulation of receptor recycling",
  "GO:0001922": "B-1 B cell homeostasis",
  "GO:0001923": "B-1 B cell differentiation",
  "GO:0001924": "regulation of B-1 B cell differentiation",
  "GO:0001925": "negative regulation of B-1 B cell differentiation",
  "GO:0001926": "positive regulation of B-1 B cell differentiation",
  "GO:0001927": "exocyst assembly",
  "GO:0001928": "regulation of exocyst assembly",
  "GO:0001929": "negative regulation of exocyst assembly",
  "GO:0001930": "positive regulation of exocyst assembly",
  "GO:0001931": "uropod",
  "GO:0001932": "regulation of protein phosphorylation",
  "GO:0001933": "negative regulation of protein phosphorylation",
  "GO:0001934": "positive regulation of protein phosphorylation",
  "GO:0001935": "endothelial cell proliferation",
  "GO:0001936": "regulation of endothelial cell proliferation",
  "GO:0001937": "negative regulation of endothelial cell proliferation",
  "GO:0001938": "positive regulation of endothelial cell proliferation",
  "GO:0001939": "female pronucleus",
  "GO:0001940": "male pronucleus",
  "GO:0001941": "postsynaptic membrane organization",
  "GO:0001942": "hair follicle development",
  "GO:0001944": "vasculature development",
  "GO:0001945": "lymph vessel development",
  "GO:0001946": "lymphangiogenesis",
  "GO:0001947": "heart looping",
  "GO:0001948": "glycoprotein binding",
  "GO:0001949": "sebaceous gland cell differentiation",
  "GO:0001950": "obsolete plasma membrane enriched fraction",
  "GO:0001951": "intestinal D-glucose absorption",
  "GO:0001952": "regulation of cell-matrix adhesion",
  "GO:0001953": "negative regulation of cell-matrix adhesion",
  "GO:0001954": "positive regulation of cell-matrix adhesion",
  "GO:0001955": "blood vessel maturation",
  "GO:0001956": "positive regulation of neurotransmitter secretion",
  "GO:0001957": "intramembranous ossification",
  "GO:0001958": "endochondral ossification",
  "GO:0001959": "regulation of cytokine-mediated signaling pathway",
  "GO:0001960": "negative regulation of cytokine-mediated signaling pathway",
  "GO:0001961": "positive regulation of cytokine-mediated signaling pathway",
  "GO:0001962": "alpha-1,3-galactosyltransferase activity",
  "GO:0001963": "synaptic transmission, dopaminergic",
  "GO:0001964": "startle response",
  "GO:0001965": "G-protein alpha-subunit binding",
  "GO:0001966": "thigmotaxis",
  "GO:0001967": "suckling behavior",
  "GO:0001968": "fibronectin binding",
  "GO:0001969": "regulation of activation of membrane attack complex",
  "GO:0001970": "positive regulation of activation of membrane attack complex",
  "GO:0001971": "negative regulation of activation of membrane attack complex",
  "GO:0001972": "retinoic acid binding",
  "GO:0001973": "adenosine receptor signaling pathway",
  "GO:0001974": "blood vessel remodeling",
  "GO:0001975": "response to amphetamine",
  "GO:0001976": "neurological system process involved in regulation of systemic arterial blood pressure",
  "GO:0001977": "renal system process involved in regulation of blood volume",
  "GO:0001978": "regulation of systemic arterial blood pressure by carotid sinus baroreceptor feedback",
  "GO:0001979": "regulation of systemic arterial blood pressure by chemoreceptor signaling",
  "GO:0001980": "regulation of systemic arterial blood pressure by ischemic conditions",
  "GO:0001981": "baroreceptor detection of arterial stretch",
  "GO:0001982": "baroreceptor response to decreased systemic arterial blood pressure",
  "GO:0001983": "baroreceptor response to increased systemic arterial blood pressure",
  "GO:0001984": "vasodilation of artery involved in baroreceptor response to increased systemic arterial blood pressure",
  "GO:0001985": "negative regulation of heart rate involved in baroreceptor response to increased systemic arterial blood pressure",
  "GO:0001986": "negative regulation of the force of heart contraction involved in baroreceptor response to increased systemic arterial blood pressure",
  "GO:0001987": "vasoconstriction of artery involved in baroreceptor response to lowering of systemic arterial blood pressure",
  "GO:0001988": "positive regulation of heart rate involved in baroreceptor response to decreased systemic arterial blood pressure",
  "GO:0001989": "positive regulation of the force of heart contraction involved in baroreceptor response to decreased systemic arterial blood pressure",
  "GO:0001990": "regulation of systemic arterial blood pressure by hormone",
  "GO:0001991": "regulation of systemic arterial blood pressure by circulatory renin-angiotensin",
  "GO:0001992": "regulation of systemic arterial blood pressure by vasopressin",
  "GO:0001993": "regulation of systemic arterial blood pressure by norepinephrine-epinephrine",
  "GO:0001994": "norepinephrine-epinephrine vasoconstriction involved in regulation of systemic arterial blood pressure",
  "GO:0001995": "norepinephrine-epinephrine catabolic process in blood stream",
  "GO:0001996": "positive regulation of heart rate by epinephrine-norepinephrine",
  "GO:0001997": "positive regulation of the force of heart contraction by epinephrine-norepinephrine",
  "GO:0001998": "angiotensin mediated vasoconstriction involved in regulation of systemic arterial blood pressure",
  "GO:0001999": "renal response to blood flow involved in circulatory renin-angiotensin regulation of systemic arterial blood pressure",
  "GO:0002000": "detection of renal blood flow",
  "GO:0002001": "renin secretion into blood stream",
  "GO:0002002": "regulation of angiotensin levels in blood",
  "GO:0002003": "angiotensin maturation",
  "GO:0002004": "secretion of vasopressin involved in fast regulation of systemic arterial blood pressure",
  "GO:0002005": "angiotensin catabolic process in blood",
  "GO:0002006": "vasoconstriction by vasopressin involved in systemic arterial blood pressure control",
  "GO:0002007": "detection of hypoxic conditions in blood by chemoreceptor signaling",
  "GO:0002008": "excitation of vasomotor center by chemoreceptor signaling",
  "GO:0002009": "morphogenesis of an epithelium",
  "GO:0002010": "excitation of vasomotor center by baroreceptor signaling",
  "GO:0002011": "morphogenesis of an epithelial sheet",
  "GO:0002012": "vasoconstriction of artery involved in chemoreceptor response to lowering of systemic arterial blood pressure",
  "GO:0002013": "detection of carbon dioxide by vasomotor center",
  "GO:0002014": "vasoconstriction of artery involved in ischemic response to lowering of systemic arterial blood pressure",
  "GO:0002015": "regulation of systemic arterial blood pressure by atrial baroreceptor feedback",
  "GO:0002016": "regulation of blood volume by renin-angiotensin",
  "GO:0002017": "regulation of blood volume by renal aldosterone",
  "GO:0002018": "renin-angiotensin regulation of aldosterone production",
  "GO:0002019": "regulation of renal output by angiotensin",
  "GO:0002020": "protease binding",
  "GO:0002021": "response to dietary excess",
  "GO:0002022": "detection of dietary excess",
  "GO:0002023": "reduction of food intake in response to dietary excess",
  "GO:0002024": "diet induced thermogenesis",
  "GO:0002025": "vasodilation by norepinephrine-epinephrine involved in regulation of systemic arterial blood pressure",
  "GO:0002026": "regulation of the force of heart contraction",
  "GO:0002027": "regulation of heart rate",
  "GO:0002028": "regulation of sodium ion transport",
  "GO:0002029": "desensitization of G-protein coupled receptor protein signaling pathway",
  "GO:0002030": "inhibitory G-protein coupled receptor phosphorylation",
  "GO:0002031": "G-protein coupled receptor internalization",
  "GO:0002032": "desensitization of G-protein coupled receptor protein signaling pathway by arrestin",
  "GO:0002033": "vasodilation by angiotensin involved in regulation of systemic arterial blood pressure",
  "GO:0002034": "regulation of blood vessel size by renin-angiotensin",
  "GO:0002035": "brain renin-angiotensin system",
  "GO:0002036": "regulation of L-glutamate transport",
  "GO:0002037": "negative regulation of L-glutamate transport",
  "GO:0002038": "positive regulation of L-glutamate transport",
  "GO:0002039": "p53 binding",
  "GO:0002040": "sprouting angiogenesis",
  "GO:0002041": "intussusceptive angiogenesis",
  "GO:0002042": "cell migration involved in sprouting angiogenesis",
  "GO:0002043": "blood vessel endothelial cell proliferation involved in sprouting angiogenesis",
  "GO:0002044": "blood vessel endothelial cell migration involved in intussusceptive angiogenesis",
  "GO:0002045": "regulation of cell adhesion involved in intussusceptive angiogenesis",
  "GO:0002046": "opsin binding",
  "GO:0002047": "phenazine biosynthetic process",
  "GO:0002048": "pyoverdine metabolic process",
  "GO:0002049": "pyoverdine biosynthetic process",
  "GO:0002050": "pyoverdine catabolic process",
  "GO:0002051": "osteoblast fate commitment",
  "GO:0002052": "positive regulation of neuroblast proliferation",
  "GO:0002053": "positive regulation of mesenchymal cell proliferation",
  "GO:0002054": "nucleobase binding",
  "GO:0002055": "adenine binding",
  "GO:0002056": "cytosine binding",
  "GO:0002057": "guanine binding",
  "GO:0002058": "uracil binding",
  "GO:0002059": "thymine binding",
  "GO:0002060": "purine nucleobase binding",
  "GO:0002061": "pyrimidine nucleobase binding",
  "GO:0002062": "chondrocyte differentiation",
  "GO:0002063": "chondrocyte development",
  "GO:0002064": "epithelial cell development",
  "GO:0002065": "columnar/cuboidal epithelial cell differentiation",
  "GO:0002066": "columnar/cuboidal epithelial cell development",
  "GO:0002067": "glandular epithelial cell differentiation",
  "GO:0002068": "glandular epithelial cell development",
  "GO:0002069": "columnar/cuboidal epithelial cell maturation",
  "GO:0002070": "epithelial cell maturation",
  "GO:0002071": "glandular epithelial cell maturation",
  "GO:0002072": "optic cup morphogenesis involved in camera-type eye development",
  "GO:0002074": "extraocular skeletal muscle development",
  "GO:0002075": "somitomeric trunk muscle development",
  "GO:0002076": "osteoblast development",
  "GO:0002077": "acrosome matrix dispersal",
  "GO:0002078": "membrane fusion involved in acrosome reaction",
  "GO:0002079": "inner acrosomal membrane",
  "GO:0002080": "acrosomal membrane",
  "GO:0002081": "outer acrosomal membrane",
  "GO:0002082": "regulation of oxidative phosphorylation",
  "GO:0002083": "4-hydroxybenzoate decaprenyltransferase activity",
  "GO:0002084": "protein depalmitoylation",
  "GO:0002085": "inhibition of neuroepithelial cell differentiation",
  "GO:0002086": "diaphragm contraction",
  "GO:0002087": "regulation of respiratory gaseous exchange by neurological system process",
  "GO:0002088": "lens development in camera-type eye",
  "GO:0002089": "lens morphogenesis in camera-type eye",
  "GO:0002090": "regulation of receptor internalization",
  "GO:0002091": "negative regulation of receptor internalization",
  "GO:0002092": "positive regulation of receptor internalization",
  "GO:0002093": "auditory receptor cell morphogenesis",
  "GO:0002094": "polyprenyltransferase activity",
  "GO:0002095": "caveolar macromolecular signaling complex",
  "GO:0002096": "polkadots",
  "GO:0002097": "tRNA wobble base modification",
  "GO:0002098": "tRNA wobble uridine modification",
  "GO:0002099": "tRNA wobble guanine modification",
  "GO:0002100": "tRNA wobble adenosine to inosine editing",
  "GO:0002101": "tRNA wobble cytosine modification",
  "GO:0002102": "podosome",
  "GO:0002103": "endonucleolytic cleavage of tetracistronic rRNA transcript (SSU-rRNA, LSU-rRNA, 4.5S-rRNA, 5S-rRNA)",
  "GO:0002104": "endonucleolytic cleaveage between 4.5S rRNA and 5S rRNA of tetracistronic rRNA transcript (SSU-rRNA, LSU-rRNA, 4.5S-rRNA, 5S-rRNA)",
  "GO:0002105": "endonucleolytic cleaveage between LSU-rRNA and 4.5S rRNA of tetracistronic rRNA transcript (SSU-rRNA, LSU-rRNA, 4.5S-rRNA, 5S-rRNA)",
  "GO:0002106": "endonucleolytic cleaveage between SSU-rRNA and LSU-rRNA of tetracistronic rRNA transcript (SSU-rRNA, LSU-rRNA, 4.5S-rRNA, 5S-rRNA)",
  "GO:0002107": "generation of mature 3'-end of 5S rRNA generated by RNA polymerase III",
  "GO:0002108": "maturation of LSU-rRNA from tricistronic rRNA transcript (SSU-rRNA, LSU-rRNA,5S)",
  "GO:0002109": "maturation of SSU-rRNA from tricistronic rRNA transcript (SSU-rRNA, LSU-rRNA,5S)",
  "GO:0002110": "cotranscriptional mitochondrial rRNA nucleotide insertion",
  "GO:0002111": "BRCA2-BRAF35 complex",
  "GO:0002112": "interleukin-33 receptor binding",
  "GO:0002113": "interleukin-33 binding",
  "GO:0002114": "interleukin-33 receptor activity",
  "GO:0002115": "store-operated calcium entry",
  "GO:0002116": "semaphorin receptor complex",
  "GO:0002117": "amphibian larval development",
  "GO:0002118": "aggressive behavior",
  "GO:0002119": "nematode larval development",
  "GO:0002120": "predatory behavior",
  "GO:0002121": "inter-male aggressive behavior",
  "GO:0002122": "fear-induced aggressive behavior",
  "GO:0002123": "irritable aggressive behavior",
  "GO:0002124": "territorial aggressive behavior",
  "GO:0002125": "maternal aggressive behavior",
  "GO:0002126": "instrumental aggressive behavior",
  "GO:0002127": "wobble base cytosine methylation",
  "GO:0002128": "tRNA nucleoside ribose methylation",
  "GO:0002129": "wobble position guanine ribose methylation",
  "GO:0002130": "wobble position ribose methylation",
  "GO:0002131": "wobble position cytosine ribose methylation",
  "GO:0002132": "wobble position uridine ribose methylation",
  "GO:0002133": "polycystin complex",
  "GO:0002134": "UTP binding",
  "GO:0002135": "CTP binding",
  "GO:0002136": "wobble base lysidine biosynthesis",
  "GO:0002138": "retinoic acid biosynthetic process",
  "GO:0002139": "stereocilia coupling link",
  "GO:0002140": "stereocilia tip link",
  "GO:0002141": "stereocilia ankle link",
  "GO:0002142": "stereocilia ankle link complex",
  "GO:0002143": "tRNA wobble position uridine thiolation",
  "GO:0002144": "cytosolic tRNA wobble base thiouridylase complex",
  "GO:0002145": "4-amino-5-hydroxymethyl-2-methylpyrimidine diphosphatase activity",
  "GO:0002146": "steroid hormone receptor import into nucleus",
  "GO:0002147": "glucocorticoid receptor import into nucleus",
  "GO:0002148": "hypochlorous acid metabolic process",
  "GO:0002149": "hypochlorous acid biosynthetic process",
  "GO:0002150": "hypochlorous acid catabolic process",
  "GO:0002151": "G-quadruplex RNA binding",
  "GO:0002152": "bile acid conjugation",
  "GO:0002153": "steroid receptor RNA activator RNA binding",
  "GO:0002154": "thyroid hormone mediated signaling pathway",
  "GO:0002155": "regulation of thyroid hormone mediated signaling pathway",
  "GO:0002156": "negative regulation of thyroid hormone mediated signaling pathway",
  "GO:0002157": "positive regulation of thyroid hormone mediated signaling pathway",
  "GO:0002158": "osteoclast proliferation",
  "GO:0002159": "desmosome assembly",
  "GO:0002160": "desmosome maintenance",
  "GO:0002161": "aminoacyl-tRNA editing activity",
  "GO:0002162": "dystroglycan binding",
  "GO:0002164": "larval development",
  "GO:0002165": "instar larval or pupal development",
  "GO:0002167": "VRK3/VHR/ERK complex",
  "GO:0002168": "instar larval development",
  "GO:0002169": "3-methylcrotonyl-CoA carboxylase complex, mitochondrial",
  "GO:0002170": "high-affinity IgA receptor activity",
  "GO:0002171": "low-affinity IgA receptor activity",
  "GO:0002172": "high-affinity IgM receptor activity",
  "GO:0002173": "low-affinity IgM receptor activity",
  "GO:0002174": "mammary stem cell proliferation",
  "GO:0002175": "protein localization to paranode region of axon",
  "GO:0002176": "male germ cell proliferation",
  "GO:0002177": "manchette",
  "GO:0002178": "palmitoyltransferase complex",
  "GO:0002179": "homodimeric serine palmitoyltransferase complex",
  "GO:0002180": "5-lipoxygenase complex",
  "GO:0002181": "cytoplasmic translation",
  "GO:0002182": "cytoplasmic translational elongation",
  "GO:0002183": "cytoplasmic translational initiation",
  "GO:0002184": "cytoplasmic translational termination",
  "GO:0002185": "creatine kinase complex",
  "GO:0002186": "cytosolic creatine kinase complex",
  "GO:0002187": "mitochondrial creatine kinase complex",
  "GO:0002188": "translation reinitiation",
  "GO:0002189": "ribose phosphate diphosphokinase complex",
  "GO:0002190": "cap-independent translational initiation",
  "GO:0002191": "cap-dependent translational initiation",
  "GO:0002192": "IRES-dependent translational initiation",
  "GO:0002193": "MAML1-RBP-Jkappa- ICN1 complex",
  "GO:0002194": "hepatocyte cell migration",
  "GO:0002195": "2-methylthio-N-6-(cis-hydroxy)isopentenyl adenosine-tRNA biosynthesis",
  "GO:0002196": "Ser-tRNA(Ala) hydrolase activity",
  "GO:0002197": "xanthine dehydrogenase complex",
  "GO:0002198": "obsolete S/G2 transition of mitotic cell cycle",
  "GO:0002199": "zona pellucida receptor complex",
  "GO:0002200": "somatic diversification of immune receptors",
  "GO:0002201": "somatic diversification of DSCAM-based immune receptors",
  "GO:0002202": "somatic diversification of variable lymphocyte receptors of jawless fish",
  "GO:0002203": "proteolysis by cytosolic proteases associated with antigen processing and presentation",
  "GO:0002204": "somatic recombination of immunoglobulin genes involved in immune response",
  "GO:0002205": "somatic hypermutation of immunoglobulin genes involved in immune response",
  "GO:0002206": "gene conversion of immunoglobulin genes",
  "GO:0002207": "gene conversion of immunoglobulin genes involved in immune response",
  "GO:0002208": "somatic diversification of immunoglobulins involved in immune response",
  "GO:0002209": "behavioral defense response",
  "GO:0002210": "behavioral response to wounding",
  "GO:0002211": "behavioral defense response to insect",
  "GO:0002212": "behavioral defense response to nematode",
  "GO:0002213": "defense response to insect",
  "GO:0002215": "defense response to nematode",
  "GO:0002218": "activation of innate immune response",
  "GO:0002220": "innate immune response activating cell surface receptor signaling pathway",
  "GO:0002221": "pattern recognition receptor signaling pathway",
  "GO:0002222": "stimulatory killer cell immunoglobulin-like receptor signaling pathway",
  "GO:0002223": "stimulatory C-type lectin receptor signaling pathway",
  "GO:0002224": "toll-like receptor signaling pathway",
  "GO:0002225": "positive regulation of antimicrobial peptide production",
  "GO:0002227": "innate immune response in mucosa",
  "GO:0002228": "natural killer cell mediated immunity",
  "GO:0002229": "defense response to oomycetes",
  "GO:0002230": "positive regulation of defense response to virus by host",
  "GO:0002231": "detection of oomycetes",
  "GO:0002232": "leukocyte chemotaxis involved in inflammatory response",
  "GO:0002233": "leukocyte chemotaxis involved in immune response",
  "GO:0002234": "detection of endoplasmic reticulum overloading",
  "GO:0002235": "detection of unfolded protein",
  "GO:0002236": "detection of misfolded protein",
  "GO:0002237": "response to molecule of bacterial origin",
  "GO:0002238": "response to molecule of fungal origin",
  "GO:0002239": "response to oomycetes",
  "GO:0002240": "response to molecule of oomycetes origin",
  "GO:0002241": "response to parasitic plant",
  "GO:0002242": "defense response to parasitic plant",
  "GO:0002243": "detection of parasitic plant",
  "GO:0002244": "hematopoietic progenitor cell differentiation",
  "GO:0002246": "wound healing involved in inflammatory response",
  "GO:0002247": "clearance of damaged tissue involved in inflammatory response wound healing",
  "GO:0002248": "connective tissue replacement involved in inflammatory response wound healing",
  "GO:0002249": "lymphocyte anergy",
  "GO:0002250": "adaptive immune response",
  "GO:0002251": "organ or tissue specific immune response",
  "GO:0002252": "immune effector process",
  "GO:0002253": "activation of immune response",
  "GO:0002254": "kinin cascade",
  "GO:0002255": "tissue kallikrein-kinin cascade",
  "GO:0002256": "regulation of kinin cascade",
  "GO:0002257": "negative regulation of kinin cascade",
  "GO:0002258": "positive regulation of kinin cascade",
  "GO:0002259": "endothelial cell activation within high endothelial venule involved in immune response",
  "GO:0002260": "lymphocyte homeostasis",
  "GO:0002261": "mucosal lymphocyte homeostasis",
  "GO:0002262": "myeloid cell homeostasis",
  "GO:0002263": "cell activation involved in immune response",
  "GO:0002264": "endothelial cell activation involved in immune response",
  "GO:0002265": "astrocyte activation involved in immune response",
  "GO:0002266": "follicular dendritic cell activation",
  "GO:0002267": "follicular dendritic cell activation involved in immune response",
  "GO:0002268": "follicular dendritic cell differentiation",
  "GO:0002269": "leukocyte activation involved in inflammatory response",
  "GO:0002270": "plasmacytoid dendritic cell activation",
  "GO:0002271": "plasmacytoid dendritic cell activation involved in immune response",
  "GO:0002272": "plasmacytoid dendritic cell differentiation involved in immune response",
  "GO:0002273": "plasmacytoid dendritic cell differentiation",
  "GO:0002274": "myeloid leukocyte activation",
  "GO:0002275": "myeloid cell activation involved in immune response",
  "GO:0002276": "basophil activation involved in immune response",
  "GO:0002277": "myeloid dendritic cell activation involved in immune response",
  "GO:0002278": "eosinophil activation involved in immune response",
  "GO:0002279": "mast cell activation involved in immune response",
  "GO:0002280": "monocyte activation involved in immune response",
  "GO:0002281": "macrophage activation involved in immune response",
  "GO:0002282": "microglial cell activation involved in immune response",
  "GO:0002283": "neutrophil activation involved in immune response",
  "GO:0002284": "myeloid dendritic cell differentiation involved in immune response",
  "GO:0002285": "lymphocyte activation involved in immune response",
  "GO:0002286": "T cell activation involved in immune response",
  "GO:0002287": "alpha-beta T cell activation involved in immune response",
  "GO:0002288": "NK T cell activation involved in immune response",
  "GO:0002289": "NK T cell proliferation involved in immune response",
  "GO:0002290": "gamma-delta T cell activation involved in immune response",
  "GO:0002291": "T cell activation via T cell receptor contact with antigen bound to MHC molecule on antigen presenting cell",
  "GO:0002292": "T cell differentiation involved in immune response",
  "GO:0002293": "alpha-beta T cell differentiation involved in immune response",
  "GO:0002294": "CD4-positive, alpha-beta T cell differentiation involved in immune response",
  "GO:0002295": "T-helper cell lineage commitment",
  "GO:0002296": "T-helper 1 cell lineage commitment",
  "GO:0002297": "T-helper 2 cell lineage commitment",
  "GO:0002298": "CD4-positive, CD25-positive, alpha-beta regulatory T cell differentiation involved in immune response",
  "GO:0002299": "alpha-beta intraepithelial T cell differentiation",
  "GO:0002300": "CD8-positive, alpha-beta intraepithelial T cell differentiation",
  "GO:0002301": "CD4-positive, alpha-beta intraepithelial T cell differentiation",
  "GO:0002302": "CD8-positive, alpha-beta T cell differentiation involved in immune response",
  "GO:0002303": "gamma-delta T cell differentiation involved in immune response",
  "GO:0002304": "gamma-delta intraepithelial T cell differentiation",
  "GO:0002305": "CD8-positive, gamma-delta intraepithelial T cell differentiation",
  "GO:0002306": "CD4-positive gamma-delta intraepithelial T cell differentiation",
  "GO:0002307": "CD8-positive, alpha-beta regulatory T cell differentiation",
  "GO:0002308": "CD8-positive, alpha-beta cytotoxic T cell differentiation",
  "GO:0002309": "T cell proliferation involved in immune response",
  "GO:0002310": "alpha-beta T cell proliferation involved in immune response",
  "GO:0002311": "gamma-delta T cell proliferation involved in immune response",
  "GO:0002312": "B cell activation involved in immune response",
  "GO:0002313": "mature B cell differentiation involved in immune response",
  "GO:0002314": "germinal center B cell differentiation",
  "GO:0002315": "marginal zone B cell differentiation",
  "GO:0002316": "follicular B cell differentiation",
  "GO:0002317": "plasma cell differentiation",
  "GO:0002318": "myeloid progenitor cell differentiation",
  "GO:0002319": "memory B cell differentiation",
  "GO:0002320": "lymphoid progenitor cell differentiation",
  "GO:0002321": "natural killer cell progenitor differentiation",
  "GO:0002322": "B cell proliferation involved in immune response",
  "GO:0002323": "natural killer cell activation involved in immune response",
  "GO:0002324": "natural killer cell proliferation involved in immune response",
  "GO:0002325": "natural killer cell differentiation involved in immune response",
  "GO:0002326": "B cell lineage commitment",
  "GO:0002327": "immature B cell differentiation",
  "GO:0002328": "pro-B cell differentiation",
  "GO:0002329": "pre-B cell differentiation",
  "GO:0002330": "pre-B cell receptor expression",
  "GO:0002331": "pre-B cell allelic exclusion",
  "GO:0002332": "transitional stage B cell differentiation",
  "GO:0002333": "transitional one stage B cell differentiation",
  "GO:0002334": "transitional two stage B cell differentiation",
  "GO:0002335": "mature B cell differentiation",
  "GO:0002336": "B-1 B cell lineage commitment",
  "GO:0002337": "B-1a B cell differentiation",
  "GO:0002338": "B-1b B cell differentiation",
  "GO:0002339": "B cell selection",
  "GO:0002340": "central B cell selection",
  "GO:0002341": "central B cell anergy",
  "GO:0002342": "central B cell deletion",
  "GO:0002343": "peripheral B cell selection",
  "GO:0002344": "B cell affinity maturation",
  "GO:0002345": "peripheral B cell receptor editing",
  "GO:0002346": "B cell positive selection",
  "GO:0002347": "response to tumor cell",
  "GO:0002348": "central B cell positive selection",
  "GO:0002349": "histamine production involved in inflammatory response",
  "GO:0002350": "peripheral B cell positive selection",
  "GO:0002351": "serotonin production involved in inflammatory response",
  "GO:0002352": "B cell negative selection",
  "GO:0002353": "plasma kallikrein-kinin cascade",
  "GO:0002354": "central B cell negative selection",
  "GO:0002355": "detection of tumor cell",
  "GO:0002356": "peripheral B cell negative selection",
  "GO:0002357": "defense response to tumor cell",
  "GO:0002358": "B cell homeostatic proliferation",
  "GO:0002359": "B-1 B cell proliferation",
  "GO:0002360": "T cell lineage commitment",
  "GO:0002361": "CD4-positive, CD25-positive, alpha-beta regulatory T cell differentiation",
  "GO:0002362": "CD4-positive, CD25-positive, alpha-beta regulatory T cell lineage commitment",
  "GO:0002363": "alpha-beta T cell lineage commitment",
  "GO:0002364": "NK T cell lineage commitment",
  "GO:0002365": "gamma-delta T cell lineage commitment",
  "GO:0002366": "leukocyte activation involved in immune response",
  "GO:0002367": "cytokine production involved in immune response",
  "GO:0002368": "B cell cytokine production",
  "GO:0002369": "T cell cytokine production",
  "GO:0002370": "natural killer cell cytokine production",
  "GO:0002371": "dendritic cell cytokine production",
  "GO:0002372": "myeloid dendritic cell cytokine production",
  "GO:0002373": "plasmacytoid dendritic cell cytokine production",
  "GO:0002374": "cytokine secretion involved in immune response",
  "GO:0002375": "cytokine biosynthetic process involved in immune response",
  "GO:0002376": "immune system process",
  "GO:0002377": "immunoglobulin production",
  "GO:0002378": "immunoglobulin biosynthetic process",
  "GO:0002379": "immunoglobulin biosynthetic process involved in immune response",
  "GO:0002380": "immunoglobulin secretion involved in immune response",
  "GO:0002381": "immunoglobulin production involved in immunoglobulin mediated immune response",
  "GO:0002382": "regulation of tissue kallikrein-kinin cascade",
  "GO:0002383": "immune response in brain or nervous system",
  "GO:0002384": "hepatic immune response",
  "GO:0002385": "mucosal immune response",
  "GO:0002386": "immune response in mucosal-associated lymphoid tissue",
  "GO:0002387": "immune response in gut-associated lymphoid tissue",
  "GO:0002388": "immune response in Peyer's patch",
  "GO:0002389": "tolerance induction in Peyer's patch",
  "GO:0002390": "platelet activating factor production",
  "GO:0002391": "platelet activating factor production involved in inflammatory response",
  "GO:0002392": "platelet activating factor secretion",
  "GO:0002393": "lysosomal enzyme production involved in inflammatory response",
  "GO:0002394": "tolerance induction in gut-associated lymphoid tissue",
  "GO:0002395": "immune response in nasopharyngeal-associated lymphoid tissue",
  "GO:0002396": "MHC protein complex assembly",
  "GO:0002397": "MHC class I protein complex assembly",
  "GO:0002398": "MHC class Ib protein complex assembly",
  "GO:0002399": "MHC class II protein complex assembly",
  "GO:0002400": "tolerance induction in nasopharyngeal-associated lymphoid tissue",
  "GO:0002401": "tolerance induction in mucosal-associated lymphoid tissue",
  "GO:0002402": "B cell tolerance induction in mucosal-associated lymphoid tissue",
  "GO:0002403": "T cell tolerance induction in mucosal-associated lymphoid tissue",
  "GO:0002404": "antigen sampling in mucosal-associated lymphoid tissue",
  "GO:0002405": "antigen sampling by dendritic cells in mucosal-associated lymphoid tissue",
  "GO:0002406": "antigen sampling by M cells in mucosal-associated lymphoid tissue",
  "GO:0002407": "dendritic cell chemotaxis",
  "GO:0002408": "myeloid dendritic cell chemotaxis",
  "GO:0002409": "Langerhans cell chemotaxis",
  "GO:0002410": "plasmacytoid dendritic cell chemotaxis",
  "GO:0002411": "T cell tolerance induction to tumor cell",
  "GO:0002412": "antigen transcytosis by M cells in mucosal-associated lymphoid tissue",
  "GO:0002413": "tolerance induction to tumor cell",
  "GO:0002414": "immunoglobulin transcytosis in epithelial cells",
  "GO:0002415": "immunoglobulin transcytosis in epithelial cells mediated by polymeric immunoglobulin receptor",
  "GO:0002416": "IgG immunoglobulin transcytosis in epithelial cells mediated by FcRn immunoglobulin receptor",
  "GO:0002417": "B cell antigen processing and presentation mediated by B cell receptor uptake of antigen",
  "GO:0002418": "immune response to tumor cell",
  "GO:0002419": "T cell mediated cytotoxicity directed against tumor cell target",
  "GO:0002420": "natural killer cell mediated cytotoxicity directed against tumor cell target",
  "GO:0002421": "B cell antigen processing and presentation following pinocytosis",
  "GO:0002422": "immune response in urogenital tract",
  "GO:0002423": "natural killer cell mediated immune response to tumor cell",
  "GO:0002424": "T cell mediated immune response to tumor cell",
  "GO:0002425": "tolerance induction in urogenital tract",
  "GO:0002426": "immunoglobulin production in mucosal tissue",
  "GO:0002427": "mucosal tolerance induction",
  "GO:0002428": "antigen processing and presentation of peptide antigen via MHC class Ib",
  "GO:0002429": "immune response-activating cell surface receptor signaling pathway",
  "GO:0002430": "complement receptor mediated signaling pathway",
  "GO:0002431": "Fc receptor mediated stimulatory signaling pathway",
  "GO:0002432": "granuloma formation",
  "GO:0002433": "immune response-regulating cell surface receptor signaling pathway involved in phagocytosis",
  "GO:0002434": "immune complex clearance",
  "GO:0002435": "immune complex clearance by erythrocytes",
  "GO:0002436": "immune complex clearance by monocytes and macrophages",
  "GO:0002437": "inflammatory response to antigenic stimulus",
  "GO:0002438": "acute inflammatory response to antigenic stimulus",
  "GO:0002439": "chronic inflammatory response to antigenic stimulus",
  "GO:0002440": "production of molecular mediator of immune response",
  "GO:0002441": "histamine secretion involved in inflammatory response",
  "GO:0002442": "serotonin secretion involved in inflammatory response",
  "GO:0002443": "leukocyte mediated immunity",
  "GO:0002444": "myeloid leukocyte mediated immunity",
  "GO:0002445": "type II hypersensitivity",
  "GO:0002446": "neutrophil mediated immunity",
  "GO:0002447": "eosinophil mediated immunity",
  "GO:0002448": "mast cell mediated immunity",
  "GO:0002449": "lymphocyte mediated immunity",
  "GO:0002450": "B cell antigen processing and presentation",
  "GO:0002451": "peripheral B cell tolerance induction",
  "GO:0002452": "B cell receptor editing",
  "GO:0002453": "peripheral B cell anergy",
  "GO:0002454": "peripheral B cell deletion",
  "GO:0002455": "humoral immune response mediated by circulating immunoglobulin",
  "GO:0002456": "T cell mediated immunity",
  "GO:0002457": "T cell antigen processing and presentation",
  "GO:0002458": "peripheral T cell tolerance induction",
  "GO:0002459": "adaptive immune response based on somatic recombination of immune receptors built from leucine-rich repeat domains",
  "GO:0002460": "adaptive immune response based on somatic recombination of immune receptors built from immunoglobulin superfamily domains",
  "GO:0002461": "tolerance induction dependent upon immune response",
  "GO:0002462": "tolerance induction to nonself antigen",
  "GO:0002463": "central tolerance induction to nonself antigen",
  "GO:0002464": "peripheral tolerance induction to nonself antigen",
  "GO:0002465": "peripheral tolerance induction",
  "GO:0002466": "peripheral tolerance induction to self antigen",
  "GO:0002467": "germinal center formation",
  "GO:0002468": "dendritic cell antigen processing and presentation",
  "GO:0002469": "myeloid dendritic cell antigen processing and presentation",
  "GO:0002470": "plasmacytoid dendritic cell antigen processing and presentation",
  "GO:0002471": "monocyte antigen processing and presentation",
  "GO:0002472": "macrophage antigen processing and presentation",
  "GO:0002473": "non-professional antigen presenting cell antigen processing and presentation",
  "GO:0002474": "antigen processing and presentation of peptide antigen via MHC class I",
  "GO:0002475": "antigen processing and presentation via MHC class Ib",
  "GO:0002476": "antigen processing and presentation of endogenous peptide antigen via MHC class Ib",
  "GO:0002477": "antigen processing and presentation of exogenous peptide antigen via MHC class Ib",
  "GO:0002478": "antigen processing and presentation of exogenous peptide antigen",
  "GO:0002479": "antigen processing and presentation of exogenous peptide antigen via MHC class I, TAP-dependent",
  "GO:0002480": "antigen processing and presentation of exogenous peptide antigen via MHC class I, TAP-independent",
  "GO:0002481": "antigen processing and presentation of exogenous protein antigen via MHC class Ib, TAP-dependent",
  "GO:0002482": "antigen processing and presentation of exogenous protein antigen via MHC class Ib, TAP-independent",
  "GO:0002483": "antigen processing and presentation of endogenous peptide antigen",
  "GO:0002484": "antigen processing and presentation of endogenous peptide antigen via MHC class I via ER pathway",
  "GO:0002485": "antigen processing and presentation of endogenous peptide antigen via MHC class I via ER pathway, TAP-dependent",
  "GO:0002486": "antigen processing and presentation of endogenous peptide antigen via MHC class I via ER pathway, TAP-independent",
  "GO:0002487": "antigen processing and presentation of endogenous peptide antigen via MHC class I via endolysosomal pathway",
  "GO:0002488": "antigen processing and presentation of endogenous peptide antigen via MHC class Ib via ER pathway",
  "GO:0002489": "antigen processing and presentation of endogenous peptide antigen via MHC class Ib via ER pathway, TAP-dependent",
  "GO:0002490": "antigen processing and presentation of endogenous peptide antigen via MHC class Ib via ER pathway, TAP-independent",
  "GO:0002491": "antigen processing and presentation of endogenous peptide antigen via MHC class II",
  "GO:0002492": "peptide antigen assembly with MHC class Ib protein complex",
  "GO:0002493": "lipid antigen assembly with MHC class Ib protein complex",
  "GO:0002494": "lipid antigen transport",
  "GO:0002495": "antigen processing and presentation of peptide antigen via MHC class II",
  "GO:0002496": "proteolysis associated with antigen processing and presentation",
  "GO:0002497": "proteasomal proteolysis associated with antigen processing and presentation",
  "GO:0002498": "proteolysis within endoplasmic reticulum associated with antigen processing and presentation",
  "GO:0002499": "proteolysis within endosome associated with antigen processing and presentation",
  "GO:0002500": "proteolysis within lysosome associated with antigen processing and presentation",
  "GO:0002501": "peptide antigen assembly with MHC protein complex",
  "GO:0002502": "peptide antigen assembly with MHC class I protein complex",
  "GO:0002503": "peptide antigen assembly with MHC class II protein complex",
  "GO:0002504": "antigen processing and presentation of peptide or polysaccharide antigen via MHC class II",
  "GO:0002505": "antigen processing and presentation of polysaccharide antigen via MHC class II",
  "GO:0002506": "polysaccharide assembly with MHC class II protein complex",
  "GO:0002507": "tolerance induction",
  "GO:0002508": "central tolerance induction",
  "GO:0002509": "central tolerance induction to self antigen",
  "GO:0002510": "central B cell tolerance induction",
  "GO:0002511": "central B cell receptor editing",
  "GO:0002512": "central T cell tolerance induction",
  "GO:0002513": "tolerance induction to self antigen",
  "GO:0002514": "B cell tolerance induction",
  "GO:0002515": "B cell anergy",
  "GO:0002516": "B cell deletion",
  "GO:0002517": "T cell tolerance induction",
  "GO:0002518": "lymphocyte chemotaxis across high endothelial venule",
  "GO:0002519": "natural killer cell tolerance induction",
  "GO:0002520": "immune system development",
  "GO:0002521": "leukocyte differentiation",
  "GO:0002522": "leukocyte migration involved in immune response",
  "GO:0002523": "leukocyte migration involved in inflammatory response",
  "GO:0002524": "hypersensitivity",
  "GO:0002525": "acute inflammatory response to non-antigenic stimulus",
  "GO:0002526": "acute inflammatory response",
  "GO:0002527": "vasodilation involved in acute inflammatory response",
  "GO:0002528": "regulation of vascular permeability involved in acute inflammatory response",
  "GO:0002529": "regulation of plasma kallikrein-kinin cascade",
  "GO:0002530": "regulation of systemic arterial blood pressure involved in acute-phase response",
  "GO:0002531": "regulation of heart contraction involved in acute-phase response",
  "GO:0002532": "production of molecular mediator involved in inflammatory response",
  "GO:0002533": "lysosomal enzyme secretion involved in inflammatory response",
  "GO:0002534": "cytokine production involved in inflammatory response",
  "GO:0002535": "platelet activating factor secretion involved in inflammatory response",
  "GO:0002536": "respiratory burst involved in inflammatory response",
  "GO:0002537": "nitric oxide production involved in inflammatory response",
  "GO:0002538": "arachidonic acid metabolite production involved in inflammatory response",
  "GO:0002539": "prostaglandin production involved in inflammatory response",
  "GO:0002540": "leukotriene production involved in inflammatory response",
  "GO:0002541": "activation of plasma proteins involved in acute inflammatory response",
  "GO:0002542": "Factor XII activation",
  "GO:0002543": "activation of blood coagulation via clotting cascade",
  "GO:0002544": "chronic inflammatory response",
  "GO:0002545": "chronic inflammatory response to non-antigenic stimulus",
  "GO:0002546": "negative regulation of tissue kallikrein-kinin cascade",
  "GO:0002547": "positive regulation of tissue kallikrein-kinin cascade",
  "GO:0002548": "monocyte chemotaxis",
  "GO:0002549": "negative regulation of plasma kallikrein-kinin cascade",
  "GO:0002550": "positive regulation of plasma kallikrein-kinin cascade",
  "GO:0002551": "mast cell chemotaxis",
  "GO:0002552": "serotonin secretion by mast cell",
  "GO:0002553": "histamine secretion by mast cell",
  "GO:0002554": "serotonin secretion by platelet",
  "GO:0002555": "histamine secretion by platelet",
  "GO:0002556": "serotonin secretion by basophil",
  "GO:0002557": "histamine secretion by basophil",
  "GO:0002558": "type I hypersensitivity mediated by mast cells",
  "GO:0002559": "type I hypersensitivity mediated by basophils",
  "GO:0002560": "basophil mediated immunity",
  "GO:0002561": "basophil degranulation",
  "GO:0002562": "somatic diversification of immune receptors via germline recombination within a single locus",
  "GO:0002563": "somatic diversification of immune receptors via alternate splicing",
  "GO:0002564": "alternate splicing of immunoglobulin genes",
  "GO:0002565": "somatic diversification of immune receptors via gene conversion",
  "GO:0002566": "somatic diversification of immune receptors via somatic mutation",
  "GO:0002567": "somatic diversification of FREP-based immune receptors",
  "GO:0002568": "somatic diversification of T cell receptor genes",
  "GO:0002569": "somatic diversification of immune receptors by N region addition",
  "GO:0002570": "somatic diversification of immunoglobulin genes by N region addition",
  "GO:0002571": "somatic diversification of T cell receptor genes by N region addition",
  "GO:0002572": "pro-T cell differentiation",
  "GO:0002573": "myeloid leukocyte differentiation",
  "GO:0002574": "thrombocyte differentiation",
  "GO:0002575": "basophil chemotaxis",
  "GO:0002576": "platelet degranulation",
  "GO:0002577": "regulation of antigen processing and presentation",
  "GO:0002578": "negative regulation of antigen processing and presentation",
  "GO:0002579": "positive regulation of antigen processing and presentation",
  "GO:0002580": "regulation of antigen processing and presentation of peptide or polysaccharide antigen via MHC class II",
  "GO:0002581": "negative regulation of antigen processing and presentation of peptide or polysaccharide antigen via MHC class II",
  "GO:0002582": "positive regulation of antigen processing and presentation of peptide or polysaccharide antigen via MHC class II",
  "GO:0002583": "regulation of antigen processing and presentation of peptide antigen",
  "GO:0002584": "negative regulation of antigen processing and presentation of peptide antigen",
  "GO:0002585": "positive regulation of antigen processing and presentation of peptide antigen",
  "GO:0002586": "regulation of antigen processing and presentation of peptide antigen via MHC class II",
  "GO:0002587": "negative regulation of antigen processing and presentation of peptide antigen via MHC class II",
  "GO:0002588": "positive regulation of antigen processing and presentation of peptide antigen via MHC class II",
  "GO:0002589": "regulation of antigen processing and presentation of peptide antigen via MHC class I",
  "GO:0002590": "negative regulation of antigen processing and presentation of peptide antigen via MHC class I",
  "GO:0002591": "positive regulation of antigen processing and presentation of peptide antigen via MHC class I",
  "GO:0002592": "regulation of antigen processing and presentation via MHC class Ib",
  "GO:0002593": "negative regulation of antigen processing and presentation via MHC class Ib",
  "GO:0002594": "positive regulation of antigen processing and presentation via MHC class Ib",
  "GO:0002595": "regulation of antigen processing and presentation of peptide antigen via MHC class Ib",
  "GO:0002596": "negative regulation of antigen processing and presentation of peptide antigen via MHC class Ib",
  "GO:0002597": "positive regulation of antigen processing and presentation of peptide antigen via MHC class Ib",
  "GO:0002598": "regulation of antigen processing and presentation of lipid antigen via MHC class Ib",
  "GO:0002599": "negative regulation of antigen processing and presentation of lipid antigen via MHC class Ib",
  "GO:0002600": "positive regulation of antigen processing and presentation of lipid antigen via MHC class Ib",
  "GO:0002601": "regulation of antigen processing and presentation of polysaccharide antigen via MHC class II",
  "GO:0002602": "negative regulation of antigen processing and presentation of polysaccharide antigen via MHC class II",
  "GO:0002603": "positive regulation of antigen processing and presentation of polysaccharide antigen via MHC class II",
  "GO:0002604": "regulation of dendritic cell antigen processing and presentation",
  "GO:0002605": "negative regulation of dendritic cell antigen processing and presentation",
  "GO:0002606": "positive regulation of dendritic cell antigen processing and presentation",
  "GO:0002607": "regulation of myeloid dendritic cell antigen processing and presentation",
  "GO:0002608": "negative regulation of myeloid dendritic cell antigen processing and presentation",
  "GO:0002609": "positive regulation of myeloid dendritic cell antigen processing and presentation",
  "GO:0002610": "regulation of plasmacytoid dendritic cell antigen processing and presentation",
  "GO:0002611": "negative regulation of plasmacytoid dendritic cell antigen processing and presentation",
  "GO:0002612": "positive regulation of plasmacytoid dendritic cell antigen processing and presentation",
  "GO:0002613": "regulation of monocyte antigen processing and presentation",
  "GO:0002614": "negative regulation of monocyte antigen processing and presentation",
  "GO:0002615": "positive regulation of monocyte antigen processing and presentation",
  "GO:0002616": "regulation of macrophage antigen processing and presentation",
  "GO:0002617": "negative regulation of macrophage antigen processing and presentation",
  "GO:0002618": "positive regulation of macrophage antigen processing and presentation",
  "GO:0002619": "regulation of non-professional antigen presenting cell antigen processing and presentation",
  "GO:0002620": "negative regulation of non-professional antigen presenting cell antigen processing and presentation",
  "GO:0002621": "positive regulation of non-professional antigen presenting cell antigen processing and presentation",
  "GO:0002622": "regulation of B cell antigen processing and presentation",
  "GO:0002623": "negative regulation of B cell antigen processing and presentation",
  "GO:0002624": "positive regulation of B cell antigen processing and presentation",
  "GO:0002625": "regulation of T cell antigen processing and presentation",
  "GO:0002626": "negative regulation of T cell antigen processing and presentation",
  "GO:0002627": "positive regulation of T cell antigen processing and presentation",
  "GO:0002628": "regulation of proteolysis associated with antigen processing and presentation",
  "GO:0002629": "negative regulation of proteolysis associated with antigen processing and presentation",
  "GO:0002630": "positive regulation of proteolysis associated with antigen processing and presentation",
  "GO:0002631": "regulation of granuloma formation",
  "GO:0002632": "negative regulation of granuloma formation",
  "GO:0002633": "positive regulation of granuloma formation",
  "GO:0002634": "regulation of germinal center formation",
  "GO:0002635": "negative regulation of germinal center formation",
  "GO:0002636": "positive regulation of germinal center formation",
  "GO:0002637": "regulation of immunoglobulin production",
  "GO:0002638": "negative regulation of immunoglobulin production",
  "GO:0002639": "positive regulation of immunoglobulin production",
  "GO:0002640": "regulation of immunoglobulin biosynthetic process",
  "GO:0002641": "negative regulation of immunoglobulin biosynthetic process",
  "GO:0002642": "positive regulation of immunoglobulin biosynthetic process",
  "GO:0002643": "regulation of tolerance induction",
  "GO:0002644": "negative regulation of tolerance induction",
  "GO:0002645": "positive regulation of tolerance induction",
  "GO:0002646": "regulation of central tolerance induction",
  "GO:0002647": "negative regulation of central tolerance induction",
  "GO:0002648": "positive regulation of central tolerance induction",
  "GO:0002649": "regulation of tolerance induction to self antigen",
  "GO:0002650": "negative regulation of tolerance induction to self antigen",
  "GO:0002651": "positive regulation of tolerance induction to self antigen",
  "GO:0002652": "regulation of tolerance induction dependent upon immune response",
  "GO:0002653": "negative regulation of tolerance induction dependent upon immune response",
  "GO:0002654": "positive regulation of tolerance induction dependent upon immune response",
  "GO:0002655": "regulation of tolerance induction to nonself antigen",
  "GO:0002656": "negative regulation of tolerance induction to nonself antigen",
  "GO:0002657": "positive regulation of tolerance induction to nonself antigen",
  "GO:0002658": "regulation of peripheral tolerance induction",
  "GO:0002659": "negative regulation of peripheral tolerance induction",
  "GO:0002660": "positive regulation of peripheral tolerance induction",
  "GO:0002661": "regulation of B cell tolerance induction",
  "GO:0002662": "negative regulation of B cell tolerance induction",
  "GO:0002663": "positive regulation of B cell tolerance induction",
  "GO:0002664": "regulation of T cell tolerance induction",
  "GO:0002665": "negative regulation of T cell tolerance induction",
  "GO:0002666": "positive regulation of T cell tolerance induction",
  "GO:0002667": "regulation of T cell anergy",
  "GO:0002668": "negative regulation of T cell anergy",
  "GO:0002669": "positive regulation of T cell anergy",
  "GO:0002670": "regulation of B cell anergy",
  "GO:0002671": "negative regulation of B cell anergy",
  "GO:0002672": "positive regulation of B cell anergy",
  "GO:0002673": "regulation of acute inflammatory response",
  "GO:0002674": "negative regulation of acute inflammatory response",
  "GO:0002675": "positive regulation of acute inflammatory response",
  "GO:0002676": "regulation of chronic inflammatory response",
  "GO:0002677": "negative regulation of chronic inflammatory response",
  "GO:0002678": "positive regulation of chronic inflammatory response",
  "GO:0002679": "respiratory burst involved in defense response",
  "GO:0002680": "pro-T cell lineage commitment",
  "GO:0002681": "somatic recombination of T cell receptor gene segments",
  "GO:0002682": "regulation of immune system process",
  "GO:0002683": "negative regulation of immune system process",
  "GO:0002684": "positive regulation of immune system process",
  "GO:0002685": "regulation of leukocyte migration",
  "GO:0002686": "negative regulation of leukocyte migration",
  "GO:0002687": "positive regulation of leukocyte migration",
  "GO:0002688": "regulation of leukocyte chemotaxis",
  "GO:0002689": "negative regulation of leukocyte chemotaxis",
  "GO:0002690": "positive regulation of leukocyte chemotaxis",
  "GO:0002691": "regulation of cellular extravasation",
  "GO:0002692": "negative regulation of cellular extravasation",
  "GO:0002693": "positive regulation of cellular extravasation",
  "GO:0002694": "regulation of leukocyte activation",
  "GO:0002695": "negative regulation of leukocyte activation",
  "GO:0002696": "positive regulation of leukocyte activation",
  "GO:0002697": "regulation of immune effector process",
  "GO:0002698": "negative regulation of immune effector process",
  "GO:0002699": "positive regulation of immune effector process",
  "GO:0002700": "regulation of production of molecular mediator of immune response",
  "GO:0002701": "negative regulation of production of molecular mediator of immune response",
  "GO:0002702": "positive regulation of production of molecular mediator of immune response",
  "GO:0002703": "regulation of leukocyte mediated immunity",
  "GO:0002704": "negative regulation of leukocyte mediated immunity",
  "GO:0002705": "positive regulation of leukocyte mediated immunity",
  "GO:0002706": "regulation of lymphocyte mediated immunity",
  "GO:0002707": "negative regulation of lymphocyte mediated immunity",
  "GO:0002708": "positive regulation of lymphocyte mediated immunity",
  "GO:0002709": "regulation of T cell mediated immunity",
  "GO:0002710": "negative regulation of T cell mediated immunity",
  "GO:0002711": "positive regulation of T cell mediated immunity",
  "GO:0002712": "regulation of B cell mediated immunity",
  "GO:0002713": "negative regulation of B cell mediated immunity",
  "GO:0002714": "positive regulation of B cell mediated immunity",
  "GO:0002715": "regulation of natural killer cell mediated immunity",
  "GO:0002716": "negative regulation of natural killer cell mediated immunity",
  "GO:0002717": "positive regulation of natural killer cell mediated immunity",
  "GO:0002718": "regulation of cytokine production involved in immune response",
  "GO:0002719": "negative regulation of cytokine production involved in immune response",
  "GO:0002720": "positive regulation of cytokine production involved in immune response",
  "GO:0002721": "regulation of B cell cytokine production",
  "GO:0002722": "negative regulation of B cell cytokine production",
  "GO:0002723": "positive regulation of B cell cytokine production",
  "GO:0002724": "regulation of T cell cytokine production",
  "GO:0002725": "negative regulation of T cell cytokine production",
  "GO:0002726": "positive regulation of T cell cytokine production",
  "GO:0002727": "regulation of natural killer cell cytokine production",
  "GO:0002728": "negative regulation of natural killer cell cytokine production",
  "GO:0002729": "positive regulation of natural killer cell cytokine production",
  "GO:0002730": "regulation of dendritic cell cytokine production",
  "GO:0002731": "negative regulation of dendritic cell cytokine production",
  "GO:0002732": "positive regulation of dendritic cell cytokine production",
  "GO:0002733": "regulation of myeloid dendritic cell cytokine production",
  "GO:0002734": "negative regulation of myeloid dendritic cell cytokine production",
  "GO:0002735": "positive regulation of myeloid dendritic cell cytokine production",
  "GO:0002736": "regulation of plasmacytoid dendritic cell cytokine production",
  "GO:0002737": "negative regulation of plasmacytoid dendritic cell cytokine production",
  "GO:0002738": "positive regulation of plasmacytoid dendritic cell cytokine production",
  "GO:0002739": "regulation of cytokine secretion involved in immune response",
  "GO:0002740": "negative regulation of cytokine secretion involved in immune response",
  "GO:0002741": "positive regulation of cytokine secretion involved in immune response",
  "GO:0002742": "regulation of cytokine biosynthetic process involved in immune response",
  "GO:0002743": "negative regulation of cytokine biosynthetic process involved in immune response",
  "GO:0002744": "positive regulation of cytokine biosynthetic process involved in immune response",
  "GO:0002745": "antigen processing and presentation initiated by receptor mediated uptake of antigen",
  "GO:0002746": "antigen processing and presentation following pinocytosis",
  "GO:0002747": "antigen processing and presentation following phagocytosis",
  "GO:0002748": "antigen processing and presentation initiated by pattern recognition receptor mediated uptake of antigen",
  "GO:0002749": "antigen processing and presentation initiated by toll-like receptor mediated phagocytosis of antigen",
  "GO:0002750": "antigen processing and presentation following macropinocytosis",
  "GO:0002751": "antigen processing and presentation following receptor mediated endocytosis",
  "GO:0002752": "cell surface pattern recognition receptor signaling pathway",
  "GO:0002753": "cytoplasmic pattern recognition receptor signaling pathway",
  "GO:0002754": "intracellular vesicle pattern recognition receptor signaling pathway",
  "GO:0002755": "MyD88-dependent toll-like receptor signaling pathway",
  "GO:0002756": "MyD88-independent toll-like receptor signaling pathway",
  "GO:0002757": "immune response-activating signal transduction",
  "GO:0002758": "innate immune response-activating signal transduction",
  "GO:0002759": "regulation of antimicrobial humoral response",
  "GO:0002760": "positive regulation of antimicrobial humoral response",
  "GO:0002761": "regulation of myeloid leukocyte differentiation",
  "GO:0002762": "negative regulation of myeloid leukocyte differentiation",
  "GO:0002763": "positive regulation of myeloid leukocyte differentiation",
  "GO:0002764": "immune response-regulating signaling pathway",
  "GO:0002765": "immune response-inhibiting signal transduction",
  "GO:0002766": "innate immune response-inhibiting signal transduction",
  "GO:0002767": "immune response-inhibiting cell surface receptor signaling pathway",
  "GO:0002768": "immune response-regulating cell surface receptor signaling pathway",
  "GO:0002769": "natural killer cell inhibitory signaling pathway",
  "GO:0002770": "T cell inhibitory signaling pathway",
  "GO:0002771": "inhibitory killer cell immunoglobulin-like receptor signaling pathway",
  "GO:0002772": "inhibitory C-type lectin receptor signaling pathway",
  "GO:0002773": "B cell inhibitory signaling pathway",
  "GO:0002774": "Fc receptor mediated inhibitory signaling pathway",
  "GO:0002775": "antimicrobial peptide production",
  "GO:0002776": "antimicrobial peptide secretion",
  "GO:0002777": "antimicrobial peptide biosynthetic process",
  "GO:0002778": "antibacterial peptide production",
  "GO:0002779": "antibacterial peptide secretion",
  "GO:0002780": "antibacterial peptide biosynthetic process",
  "GO:0002781": "antifungal peptide production",
  "GO:0002782": "antifungal peptide secretion",
  "GO:0002783": "antifungal peptide biosynthetic process",
  "GO:0002784": "regulation of antimicrobial peptide production",
  "GO:0002785": "negative regulation of antimicrobial peptide production",
  "GO:0002786": "regulation of antibacterial peptide production",
  "GO:0002787": "negative regulation of antibacterial peptide production",
  "GO:0002788": "regulation of antifungal peptide production",
  "GO:0002789": "negative regulation of antifungal peptide production",
  "GO:0002790": "peptide secretion",
  "GO:0002791": "regulation of peptide secretion",
  "GO:0002792": "negative regulation of peptide secretion",
  "GO:0002793": "positive regulation of peptide secretion",
  "GO:0002794": "regulation of antimicrobial peptide secretion",
  "GO:0002795": "negative regulation of antimicrobial peptide secretion",
  "GO:0002796": "positive regulation of antimicrobial peptide secretion",
  "GO:0002797": "regulation of antibacterial peptide secretion",
  "GO:0002798": "negative regulation of antibacterial peptide secretion",
  "GO:0002799": "positive regulation of antibacterial peptide secretion",
  "GO:0002800": "regulation of antifungal peptide secretion",
  "GO:0002801": "negative regulation of antifungal peptide secretion",
  "GO:0002802": "positive regulation of antifungal peptide secretion",
  "GO:0002803": "positive regulation of antibacterial peptide production",
  "GO:0002804": "positive regulation of antifungal peptide production",
  "GO:0002805": "regulation of antimicrobial peptide biosynthetic process",
  "GO:0002806": "negative regulation of antimicrobial peptide biosynthetic process",
  "GO:0002807": "positive regulation of antimicrobial peptide biosynthetic process",
  "GO:0002808": "regulation of antibacterial peptide biosynthetic process",
  "GO:0002809": "negative regulation of antibacterial peptide biosynthetic process",
  "GO:0002810": "regulation of antifungal peptide biosynthetic process",
  "GO:0002811": "negative regulation of antifungal peptide biosynthetic process",
  "GO:0002812": "biosynthetic process of antibacterial peptides active against Gram-negative bacteria",
  "GO:0002813": "regulation of biosynthetic process of antibacterial peptides active against Gram-negative bacteria",
  "GO:0002814": "negative regulation of biosynthetic process of antibacterial peptides active against Gram-negative bacteria",
  "GO:0002815": "biosynthetic process of antibacterial peptides active against Gram-positive bacteria",
  "GO:0002816": "regulation of biosynthetic process of antibacterial peptides active against Gram-positive bacteria",
  "GO:0002817": "negative regulation of biosynthetic process of antibacterial peptides active against Gram-positive bacteria",
  "GO:0002818": "intracellular defense response",
  "GO:0002819": "regulation of adaptive immune response",
  "GO:0002820": "negative regulation of adaptive immune response",
  "GO:0002821": "positive regulation of adaptive immune response",
  "GO:0002822": "regulation of adaptive immune response based on somatic recombination of immune receptors built from immunoglobulin superfamily domains",
  "GO:0002823": "negative regulation of adaptive immune response based on somatic recombination of immune receptors built from immunoglobulin superfamily domains",
  "GO:0002824": "positive regulation of adaptive immune response based on somatic recombination of immune receptors built from immunoglobulin superfamily domains",
  "GO:0002825": "regulation of T-helper 1 type immune response",
  "GO:0002826": "negative regulation of T-helper 1 type immune response",
  "GO:0002827": "positive regulation of T-helper 1 type immune response",
  "GO:0002828": "regulation of type 2 immune response",
  "GO:0002829": "negative regulation of type 2 immune response",
  "GO:0002830": "positive regulation of type 2 immune response",
  "GO:0002831": "regulation of response to biotic stimulus",
  "GO:0002832": "negative regulation of response to biotic stimulus",
  "GO:0002833": "positive regulation of response to biotic stimulus",
  "GO:0002834": "regulation of response to tumor cell",
  "GO:0002835": "negative regulation of response to tumor cell",
  "GO:0002836": "positive regulation of response to tumor cell",
  "GO:0002837": "regulation of immune response to tumor cell",
  "GO:0002838": "negative regulation of immune response to tumor cell",
  "GO:0002839": "positive regulation of immune response to tumor cell",
  "GO:0002840": "regulation of T cell mediated immune response to tumor cell",
  "GO:0002841": "negative regulation of T cell mediated immune response to tumor cell",
  "GO:0002842": "positive regulation of T cell mediated immune response to tumor cell",
  "GO:0002843": "regulation of tolerance induction to tumor cell",
  "GO:0002844": "negative regulation of tolerance induction to tumor cell",
  "GO:0002845": "positive regulation of tolerance induction to tumor cell",
  "GO:0002846": "regulation of T cell tolerance induction to tumor cell",
  "GO:0002847": "negative regulation of T cell tolerance induction to tumor cell",
  "GO:0002848": "positive regulation of T cell tolerance induction to tumor cell",
  "GO:0002849": "regulation of peripheral T cell tolerance induction",
  "GO:0002850": "negative regulation of peripheral T cell tolerance induction",
  "GO:0002851": "positive regulation of peripheral T cell tolerance induction",
  "GO:0002852": "regulation of T cell mediated cytotoxicity directed against tumor cell target",
  "GO:0002853": "negative regulation of T cell mediated cytotoxicity directed against tumor cell target",
  "GO:0002854": "positive regulation of T cell mediated cytotoxicity directed against tumor cell target",
  "GO:0002855": "regulation of natural killer cell mediated immune response to tumor cell",
  "GO:0002856": "negative regulation of natural killer cell mediated immune response to tumor cell",
  "GO:0002857": "positive regulation of natural killer cell mediated immune response to tumor cell",
  "GO:0002858": "regulation of natural killer cell mediated cytotoxicity directed against tumor cell target",
  "GO:0002859": "negative regulation of natural killer cell mediated cytotoxicity directed against tumor cell target",
  "GO:0002860": "positive regulation of natural killer cell mediated cytotoxicity directed against tumor cell target",
  "GO:0002861": "regulation of inflammatory response to antigenic stimulus",
  "GO:0002862": "negative regulation of inflammatory response to antigenic stimulus",
  "GO:0002863": "positive regulation of inflammatory response to antigenic stimulus",
  "GO:0002864": "regulation of acute inflammatory response to antigenic stimulus",
  "GO:0002865": "negative regulation of acute inflammatory response to antigenic stimulus",
  "GO:0002866": "positive regulation of acute inflammatory response to antigenic stimulus",
  "GO:0002867": "regulation of B cell deletion",
  "GO:0002868": "negative regulation of B cell deletion",
  "GO:0002869": "positive regulation of B cell deletion",
  "GO:0002870": "T cell anergy",
  "GO:0002871": "regulation of natural killer cell tolerance induction",
  "GO:0002872": "negative regulation of natural killer cell tolerance induction",
  "GO:0002873": "positive regulation of natural killer cell tolerance induction",
  "GO:0002874": "regulation of chronic inflammatory response to antigenic stimulus",
  "GO:0002875": "negative regulation of chronic inflammatory response to antigenic stimulus",
  "GO:0002876": "positive regulation of chronic inflammatory response to antigenic stimulus",
  "GO:0002877": "regulation of acute inflammatory response to non-antigenic stimulus",
  "GO:0002878": "negative regulation of acute inflammatory response to non-antigenic stimulus",
  "GO:0002879": "positive regulation of acute inflammatory response to non-antigenic stimulus",
  "GO:0002880": "regulation of chronic inflammatory response to non-antigenic stimulus",
  "GO:0002881": "negative regulation of chronic inflammatory response to non-antigenic stimulus",
  "GO:0002882": "positive regulation of chronic inflammatory response to non-antigenic stimulus",
  "GO:0002883": "regulation of hypersensitivity",
  "GO:0002884": "negative regulation of hypersensitivity",
  "GO:0002885": "positive regulation of hypersensitivity",
  "GO:0002886": "regulation of myeloid leukocyte mediated immunity",
  "GO:0002887": "negative regulation of myeloid leukocyte mediated immunity",
  "GO:0002888": "positive regulation of myeloid leukocyte mediated immunity",
  "GO:0002889": "regulation of immunoglobulin mediated immune response",
  "GO:0002890": "negative regulation of immunoglobulin mediated immune response",
  "GO:0002891": "positive regulation of immunoglobulin mediated immune response",
  "GO:0002892": "regulation of type II hypersensitivity",
  "GO:0002893": "negative regulation of type II hypersensitivity",
  "GO:0002894": "positive regulation of type II hypersensitivity",
  "GO:0002895": "regulation of central B cell tolerance induction",
  "GO:0002896": "negative regulation of central B cell tolerance induction",
  "GO:0002897": "positive regulation of central B cell tolerance induction",
  "GO:0002898": "regulation of central B cell deletion",
  "GO:0002899": "negative regulation of central B cell deletion",
  "GO:0002900": "positive regulation of central B cell deletion",
  "GO:0002901": "mature B cell apoptotic process",
  "GO:0002902": "regulation of B cell apoptotic process",
  "GO:0002903": "negative regulation of B cell apoptotic process",
  "GO:0002904": "positive regulation of B cell apoptotic process",
  "GO:0002905": "regulation of mature B cell apoptotic process",
  "GO:0002906": "negative regulation of mature B cell apoptotic process",
  "GO:0002907": "positive regulation of mature B cell apoptotic process",
  "GO:0002908": "regulation of peripheral B cell deletion",
  "GO:0002909": "negative regulation of peripheral B cell deletion",
  "GO:0002910": "positive regulation of peripheral B cell deletion",
  "GO:0002911": "regulation of lymphocyte anergy",
  "GO:0002912": "negative regulation of lymphocyte anergy",
  "GO:0002913": "positive regulation of lymphocyte anergy",
  "GO:0002914": "regulation of central B cell anergy",
  "GO:0002915": "negative regulation of central B cell anergy",
  "GO:0002916": "positive regulation of central B cell anergy",
  "GO:0002917": "regulation of peripheral B cell anergy",
  "GO:0002918": "negative regulation of peripheral B cell anergy",
  "GO:0002919": "positive regulation of peripheral B cell anergy",
  "GO:0002920": "regulation of humoral immune response",
  "GO:0002921": "negative regulation of humoral immune response",
  "GO:0002922": "positive regulation of humoral immune response",
  "GO:0002923": "regulation of humoral immune response mediated by circulating immunoglobulin",
  "GO:0002924": "negative regulation of humoral immune response mediated by circulating immunoglobulin",
  "GO:0002925": "positive regulation of humoral immune response mediated by circulating immunoglobulin",
  "GO:0002926": "tRNA wobble base 5-methoxycarbonylmethyl-2-thiouridine biosynthesis.",
  "GO:0002927": "archaeosine-tRNA biosynthetic process",
  "GO:0002929": "MECO complex",
  "GO:0002930": "trabecular meshwork development",
  "GO:0002931": "response to ischemia",
  "GO:0002932": "tendon sheath development",
  "GO:0002933": "lipid hydroxylation",
  "GO:0002934": "desmosome organization",
  "GO:0002935": "tRNA (adenine-C2-)-methyltransferase activity",
  "GO:0002936": "bradykinin biosynthetic process",
  "GO:0002937": "tRNA 4-thiouridine biosynthesis",
  "GO:0002938": "tRNA guanine ribose methylation",
  "GO:0002939": "tRNA N1-guanine methylation",
  "GO:0002940": "tRNA N2-guanine methylation",
  "GO:0002941": "synoviocyte proliferation",
  "GO:0002942": "tRNA m2,2-guanine biosynthesis",
  "GO:0002943": "tRNA dihydrouridine synthesis",
  "GO:0002944": "cyclin K-CDK12 complex",
  "GO:0002945": "cyclin K-CDK13 complex",
  "GO:0002946": "tRNA C5-cytosine methylation",
  "GO:0002947": "tumor necrosis factor receptor superfamily complex",
  "GO:0002948": "archaeosine synthase activity",
  "GO:0002949": "tRNA threonylcarbamoyladenosine modification",
  "GO:0003001": "obsolete generation of a signal involved in cell-cell signaling",
  "GO:0003002": "regionalization",
  "GO:0003003": "follicular fluid formation in ovarian follicle antrum involved in fused antrum stage",
  "GO:0003004": "follicular fluid formation in ovarian follicle antrum involved in distinct antral spaces stage",
  "GO:0003005": "follicular fluid formation in ovarian follicle antrum involved in scattered antral spaces stage",
  "GO:0003006": "developmental process involved in reproduction",
  "GO:0003007": "heart morphogenesis",
  "GO:0003008": "system process",
  "GO:0003009": "skeletal muscle contraction",
  "GO:0003010": "voluntary skeletal muscle contraction",
  "GO:0003011": "involuntary skeletal muscle contraction",
  "GO:0003012": "muscle system process",
  "GO:0003013": "circulatory system process",
  "GO:0003014": "renal system process",
  "GO:0003015": "heart process",
  "GO:0003016": "respiratory system process",
  "GO:0003017": "lymph circulation",
  "GO:0003018": "vascular process in circulatory system",
  "GO:0003019": "central nervous system control of baroreceptor feedback",
  "GO:0003020": "detection of reduced oxygen by chemoreceptor signaling",
  "GO:0003021": "detection of increased carbon dioxide by chemoreceptor signaling",
  "GO:0003022": "detection of pH by chemoreceptor signaling",
  "GO:0003023": "baroreceptor detection of increased arterial stretch",
  "GO:0003024": "baroreceptor detection of decreased arterial stretch",
  "GO:0003025": "regulation of systemic arterial blood pressure by baroreceptor feedback",
  "GO:0003026": "regulation of systemic arterial blood pressure by aortic arch baroreceptor feedback",
  "GO:0003027": "regulation of systemic arterial blood pressure by carotid body chemoreceptor signaling",
  "GO:0003028": "regulation of systemic arterial blood pressure by aortic body chemoreceptor signaling",
  "GO:0003029": "detection of hypoxic conditions in blood by carotid body chemoreceptor signaling",
  "GO:0003030": "detection of hydrogen ion",
  "GO:0003031": "detection of carbon dioxide",
  "GO:0003032": "detection of oxygen",
  "GO:0003033": "detection of hypoxic conditions in blood by aortic body chemoreceptor signaling",
  "GO:0003034": "detection of increased carbon dioxide by aortic body chemoreceptor signaling",
  "GO:0003035": "detection of increased carbon dioxide by carotid body chemoreceptor signaling",
  "GO:0003036": "detection of pH by aortic body chemoreceptor signaling",
  "GO:0003037": "detection of pH by carotid body chemoreceptor signaling",
  "GO:0003038": "detection of reduced oxygen by aortic body chemoreceptor signaling",
  "GO:0003039": "detection of reduced oxygen by carotid body chemoreceptor signaling",
  "GO:0003040": "excitation of vasomotor center by aortic body chemoreceptor signaling",
  "GO:0003041": "excitation of vasomotor center by carotid body chemoreceptor signaling",
  "GO:0003042": "vasoconstriction of artery involved in carotid body chemoreceptor response to lowering of systemic arterial blood pressure",
  "GO:0003043": "vasoconstriction of artery involved in aortic body chemoreceptor response to lowering of systemic arterial blood pressure",
  "GO:0003044": "regulation of systemic arterial blood pressure mediated by a chemical signal",
  "GO:0003045": "regulation of systemic arterial blood pressure by physical factors",
  "GO:0003046": "regulation of systemic arterial blood pressure by stress relaxation",
  "GO:0003047": "regulation of systemic arterial blood pressure by epinephrine",
  "GO:0003048": "regulation of systemic arterial blood pressure by norepinephrine",
  "GO:0003049": "regulation of systemic arterial blood pressure by capillary fluid shift",
  "GO:0003050": "regulation of systemic arterial blood pressure by atrial natriuretic peptide",
  "GO:0003051": "angiotensin-mediated drinking behavior",
  "GO:0003052": "circadian regulation of systemic arterial blood pressure",
  "GO:0003053": "circadian regulation of heart rate",
  "GO:0003054": "circadian regulation of systemic arterial blood pressure by the suprachiasmatic nucleus",
  "GO:0003055": "circadian regulation of heart rate by the suprachiasmatic nucleus",
  "GO:0003056": "regulation of vascular smooth muscle contraction",
  "GO:0003057": "regulation of the force of heart contraction by chemical signal",
  "GO:0003058": "hormonal regulation of the force of heart contraction",
  "GO:0003059": "positive regulation of the force of heart contraction by epinephrine",
  "GO:0003060": "negative regulation of the force of heart contraction by acetylcholine",
  "GO:0003061": "positive regulation of the force of heart contraction by norepinephrine",
  "GO:0003062": "regulation of heart rate by chemical signal",
  "GO:0003063": "negative regulation of heart rate by acetylcholine",
  "GO:0003064": "regulation of heart rate by hormone",
  "GO:0003065": "positive regulation of heart rate by epinephrine",
  "GO:0003066": "positive regulation of heart rate by norepinephrine",
  "GO:0003067": "circadian regulation of systemic arterial blood pressure by hormone",
  "GO:0003068": "regulation of systemic arterial blood pressure by acetylcholine",
  "GO:0003069": "vasodilation by acetylcholine involved in regulation of systemic arterial blood pressure",
  "GO:0003070": "regulation of systemic arterial blood pressure by neurotransmitter",
  "GO:0003071": "renal system process involved in regulation of systemic arterial blood pressure",
  "GO:0003072": "renal control of peripheral vascular resistance involved in regulation of systemic arterial blood pressure",
  "GO:0003073": "regulation of systemic arterial blood pressure",
  "GO:0003074": "obsolete regulation of diuresis",
  "GO:0003075": "renal vasodilation of the peripheral vascular system involved in regulation of systemic arterial blood pressure",
  "GO:0003077": "obsolete negative regulation of diuresis",
  "GO:0003078": "obsolete regulation of natriuresis",
  "GO:0003079": "obsolete positive regulation of natriuresis",
  "GO:0003080": "obsolete negative regulation of natriuresis",
  "GO:0003081": "regulation of systemic arterial blood pressure by renin-angiotensin",
  "GO:0003082": "obsolete positive regulation of renal output by angiotensin",
  "GO:0003083": "negative regulation of renal output by angiotensin",
  "GO:0003084": "positive regulation of systemic arterial blood pressure",
  "GO:0003085": "negative regulation of systemic arterial blood pressure",
  "GO:0003086": "regulation of systemic arterial blood pressure by local renal renin-angiotensin",
  "GO:0003087": "positive regulation of the force of heart contraction by neuronal epinephrine",
  "GO:0003088": "positive regulation of the force of heart contraction by circulating epinephrine",
  "GO:0003089": "positive regulation of the force of heart contraction by circulating epinephrine-norepinephrine",
  "GO:0003090": "positive regulation of the force of heart contraction by neuronal epinephrine-norepinephrine",
  "GO:0003091": "renal water homeostasis",
  "GO:0003092": "renal water retention",
  "GO:0003093": "regulation of glomerular filtration",
  "GO:0003094": "glomerular filtration",
  "GO:0003095": "pressure natriuresis",
  "GO:0003096": "renal sodium ion transport",
  "GO:0003097": "renal water transport",
  "GO:0003098": "tubuloglomerular feedback",
  "GO:0003099": "positive regulation of the force of heart contraction by chemical signal",
  "GO:0003100": "regulation of systemic arterial blood pressure by endothelin",
  "GO:0003101": "regulation of systemic arterial blood pressure by circulatory epinephrine-norepinephrine",
  "GO:0003102": "obsolete positive regulation of diuresis by angiotensin",
  "GO:0003103": "obsolete positive regulation of diuresis",
  "GO:0003104": "positive regulation of glomerular filtration",
  "GO:0003105": "negative regulation of glomerular filtration",
  "GO:0003106": "negative regulation of glomerular filtration by angiotensin",
  "GO:0003107": "obsolete positive regulation of natriuresis by angiotensin",
  "GO:0003108": "negative regulation of the force of heart contraction by chemical signal",
  "GO:0003109": "positive regulation of the force of heart contraction by circulating norepinephrine",
  "GO:0003110": "positive regulation of the force of heart contraction by neuronal norepinephrine",
  "GO:0003111": "positive regulation of heart rate by circulating epinephrine",
  "GO:0003112": "positive regulation of heart rate by neuronal epinephrine",
  "GO:0003113": "positive regulation of heart rate by neuronal norepinephrine",
  "GO:0003114": "positive regulation of heart rate by circulating norepinephrine",
  "GO:0003115": "regulation of vasoconstriction by epinephrine",
  "GO:0003116": "regulation of vasoconstriction by norepinephrine",
  "GO:0003117": "regulation of vasoconstriction by circulating norepinephrine",
  "GO:0003118": "regulation of vasoconstriction by neuronal norepinephrine",
  "GO:0003119": "regulation of vasoconstriction by neuronal epinephrine",
  "GO:0003120": "regulation of vasoconstriction by circulating epinephrine",
  "GO:0003121": "regulation of vasodilation by epinephrine",
  "GO:0003122": "regulation of vasodilation by norepinephrine",
  "GO:0003123": "regulation of vasodilation by circulating epinephrine",
  "GO:0003124": "regulation of vasodilation by neuronal epinephrine",
  "GO:0003125": "regulation of vasodilation by circulating norepinephrine",
  "GO:0003126": "regulation of vasodilation by neuronal norepinephrine",
  "GO:0003127": "detection of nodal flow",
  "GO:0003128": "heart field specification",
  "GO:0003129": "heart induction",
  "GO:0003130": "BMP signaling pathway involved in heart induction",
  "GO:0003131": "mesodermal-endodermal cell signaling",
  "GO:0003132": "mesodermal-endodermal cell signaling involved in heart induction",
  "GO:0003133": "endodermal-mesodermal cell signaling",
  "GO:0003134": "endodermal-mesodermal cell signaling involved in heart induction",
  "GO:0003135": "fibroblast growth factor receptor signaling pathway involved in heart induction",
  "GO:0003136": "negative regulation of heart induction by canonical Wnt signaling pathway",
  "GO:0003137": "Notch signaling pathway involved in heart induction",
  "GO:0003138": "primary heart field specification",
  "GO:0003139": "secondary heart field specification",
  "GO:0003140": "determination of left/right asymmetry in lateral mesoderm",
  "GO:0003141": "obsolete transforming growth factor beta receptor signaling pathway involved in determination of lateral mesoderm left/right asymmetry",
  "GO:0003142": "cardiogenic plate morphogenesis",
  "GO:0003143": "embryonic heart tube morphogenesis",
  "GO:0003144": "embryonic heart tube formation",
  "GO:0003145": "embryonic heart tube formation via epithelial folding",
  "GO:0003146": "heart jogging",
  "GO:0003147": "neural crest cell migration involved in heart formation",
  "GO:0003148": "outflow tract septum morphogenesis",
  "GO:0003149": "membranous septum morphogenesis",
  "GO:0003150": "muscular septum morphogenesis",
  "GO:0003151": "outflow tract morphogenesis",
  "GO:0003152": "morphogenesis of an epithelial fold involved in embryonic heart tube formation",
  "GO:0003153": "closure of embryonic heart tube",
  "GO:0003154": "BMP signaling pathway involved in determination of left/right symmetry",
  "GO:0003155": "BMP signaling pathway involved in determination of lateral mesoderm left/right asymmetry",
  "GO:0003156": "regulation of organ formation",
  "GO:0003157": "endocardium development",
  "GO:0003158": "endothelium development",
  "GO:0003159": "morphogenesis of an endothelium",
  "GO:0003160": "endocardium morphogenesis",
  "GO:0003161": "cardiac conduction system development",
  "GO:0003162": "atrioventricular node development",
  "GO:0003163": "sinoatrial node development",
  "GO:0003164": "His-Purkinje system development",
  "GO:0003165": "Purkinje myocyte development",
  "GO:0003166": "bundle of His development",
  "GO:0003167": "atrioventricular bundle cell differentiation",
  "GO:0003168": "Purkinje myocyte differentiation",
  "GO:0003169": "coronary vein morphogenesis",
  "GO:0003170": "heart valve development",
  "GO:0003171": "atrioventricular valve development",
  "GO:0003172": "sinoatrial valve development",
  "GO:0003173": "ventriculo bulbo valve development",
  "GO:0003174": "mitral valve development",
  "GO:0003175": "tricuspid valve development",
  "GO:0003176": "aortic valve development",
  "GO:0003177": "pulmonary valve development",
  "GO:0003178": "coronary sinus valve development",
  "GO:0003179": "heart valve morphogenesis",
  "GO:0003180": "aortic valve morphogenesis",
  "GO:0003181": "atrioventricular valve morphogenesis",
  "GO:0003182": "coronary sinus valve morphogenesis",
  "GO:0003183": "mitral valve morphogenesis",
  "GO:0003184": "pulmonary valve morphogenesis",
  "GO:0003185": "sinoatrial valve morphogenesis",
  "GO:0003186": "tricuspid valve morphogenesis",
  "GO:0003187": "ventriculo bulbo valve morphogenesis",
  "GO:0003188": "heart valve formation",
  "GO:0003189": "aortic valve formation",
  "GO:0003190": "atrioventricular valve formation",
  "GO:0003191": "coronary sinus valve formation",
  "GO:0003192": "mitral valve formation",
  "GO:0003193": "pulmonary valve formation",
  "GO:0003194": "sinoatrial valve formation",
  "GO:0003195": "tricuspid valve formation",
  "GO:0003196": "ventriculo bulbo valve formation",
  "GO:0003197": "endocardial cushion development",
  "GO:0003198": "epithelial to mesenchymal transition involved in endocardial cushion formation",
  "GO:0003199": "endocardial cushion to mesenchymal transition involved in heart valve formation",
  "GO:0003200": "endocardial cushion to mesenchymal transition involved in heart chamber septation",
  "GO:0003201": "epithelial to mesenchymal transition involved in coronary vasculature morphogenesis",
  "GO:0003202": "endocardial cushion to mesenchymal transition involved in cardiac skeleton development",
  "GO:0003203": "endocardial cushion morphogenesis",
  "GO:0003204": "cardiac skeleton development",
  "GO:0003205": "cardiac chamber development",
  "GO:0003206": "cardiac chamber morphogenesis",
  "GO:0003207": "cardiac chamber formation",
  "GO:0003208": "cardiac ventricle morphogenesis",
  "GO:0003209": "cardiac atrium morphogenesis",
  "GO:0003210": "cardiac atrium formation",
  "GO:0003211": "cardiac ventricle formation",
  "GO:0003212": "cardiac left atrium morphogenesis",
  "GO:0003213": "cardiac right atrium morphogenesis",
  "GO:0003214": "cardiac left ventricle morphogenesis",
  "GO:0003215": "cardiac right ventricle morphogenesis",
  "GO:0003216": "cardiac left atrium formation",
  "GO:0003217": "cardiac right atrium formation",
  "GO:0003218": "cardiac left ventricle formation",
  "GO:0003219": "cardiac right ventricle formation",
  "GO:0003220": "left ventricular cardiac muscle tissue morphogenesis",
  "GO:0003221": "right ventricular cardiac muscle tissue morphogenesis",
  "GO:0003222": "ventricular trabecula myocardium morphogenesis",
  "GO:0003223": "ventricular compact myocardium morphogenesis",
  "GO:0003224": "left ventricular compact myocardium morphogenesis",
  "GO:0003225": "left ventricular trabecular myocardium morphogenesis",
  "GO:0003226": "right ventricular compact myocardium morphogenesis",
  "GO:0003227": "right ventricular trabecular myocardium morphogenesis",
  "GO:0003228": "atrial cardiac muscle tissue development",
  "GO:0003229": "ventricular cardiac muscle tissue development",
  "GO:0003230": "cardiac atrium development",
  "GO:0003231": "cardiac ventricle development",
  "GO:0003232": "bulbus arteriosus development",
  "GO:0003233": "bulbus arteriosus morphogenesis",
  "GO:0003234": "bulbus arteriosus formation",
  "GO:0003235": "sinus venosus development",
  "GO:0003236": "sinus venosus morphogenesis",
  "GO:0003237": "sinus venosus formation",
  "GO:0003238": "conus arteriosus development",
  "GO:0003239": "conus arteriosus morphogenesis",
  "GO:0003240": "conus arteriosus formation",
  "GO:0003241": "growth involved in heart morphogenesis",
  "GO:0003242": "cardiac chamber ballooning",
  "GO:0003243": "circumferential growth involved in left ventricle morphogenesis",
  "GO:0003244": "radial growth involved in right ventricle morphogenesis",
  "GO:0003245": "cardiac muscle tissue growth involved in heart morphogenesis",
  "GO:0003246": "embryonic cardiac muscle cell growth involved in heart morphogenesis",
  "GO:0003247": "post-embryonic cardiac muscle cell growth involved in heart morphogenesis",
  "GO:0003248": "heart capillary growth",
  "GO:0003249": "cell proliferation involved in heart valve morphogenesis",
  "GO:0003250": "regulation of cell proliferation involved in heart valve morphogenesis",
  "GO:0003251": "positive regulation of cell proliferation involved in heart valve morphogenesis",
  "GO:0003252": "negative regulation of cell proliferation involved in heart valve morphogenesis",
  "GO:0003253": "cardiac neural crest cell migration involved in outflow tract morphogenesis",
  "GO:0003254": "regulation of membrane depolarization",
  "GO:0003255": "endocardial precursor cell differentiation",
  "GO:0003256": "regulation of transcription from RNA polymerase II promoter involved in myocardial precursor cell differentiation",
  "GO:0003257": "positive regulation of transcription from RNA polymerase II promoter involved in myocardial precursor cell differentiation",
  "GO:0003258": "regulation of transcription from RNA polymerase II promoter involved in endocardial precursor cell differentiation",
  "GO:0003259": "cardioblast anterior-lateral migration",
  "GO:0003260": "cardioblast migration",
  "GO:0003261": "cardiac muscle progenitor cell migration to the midline involved in heart field formation",
  "GO:0003262": "endocardial progenitor cell migration to the midline involved in heart field formation",
  "GO:0003263": "cardioblast proliferation",
  "GO:0003264": "regulation of cardioblast proliferation",
  "GO:0003265": "regulation of primary heart field cardioblast proliferation",
  "GO:0003266": "regulation of secondary heart field cardioblast proliferation",
  "GO:0003267": "canonical Wnt signaling pathway involved in positive regulation of secondary heart field cardioblast proliferation",
  "GO:0003268": "fibroblast growth factor receptor signaling pathway involved in regulation of secondary heart field cardioblast proliferation",
  "GO:0003269": "BMP signaling pathway involved in regulation of secondary heart field cardioblast proliferation",
  "GO:0003270": "Notch signaling pathway involved in regulation of secondary heart field cardioblast proliferation",
  "GO:0003271": "smoothened signaling pathway involved in regulation of secondary heart field cardioblast proliferation",
  "GO:0003272": "endocardial cushion formation",
  "GO:0003273": "cell migration involved in endocardial cushion formation",
  "GO:0003274": "endocardial cushion fusion",
  "GO:0003275": "apoptotic process involved in outflow tract morphogenesis",
  "GO:0003276": "apoptotic process involved in heart valve morphogenesis",
  "GO:0003277": "apoptotic process involved in endocardial cushion morphogenesis",
  "GO:0003278": "apoptotic process involved in heart morphogenesis",
  "GO:0003279": "cardiac septum development",
  "GO:0003281": "ventricular septum development",
  "GO:0003282": "ventricular septum intermedium development",
  "GO:0003283": "atrial septum development",
  "GO:0003284": "septum primum development",
  "GO:0003285": "septum secundum development",
  "GO:0003286": "atrial septum intermedium development",
  "GO:0003288": "ventricular septum intermedium morphogenesis",
  "GO:0003289": "atrial septum primum morphogenesis",
  "GO:0003290": "atrial septum secundum morphogenesis",
  "GO:0003291": "atrial septum intermedium morphogenesis",
  "GO:0003292": "cardiac septum cell differentiation",
  "GO:0003293": "heart valve cell differentiation",
  "GO:0003294": "atrial ventricular junction remodeling",
  "GO:0003295": "cell proliferation involved in atrial ventricular junction remodeling",
  "GO:0003296": "apoptotic process involved in atrial ventricular junction remodeling",
  "GO:0003297": "heart wedging",
  "GO:0003298": "physiological muscle hypertrophy",
  "GO:0003299": "muscle hypertrophy in response to stress",
  "GO:0003300": "cardiac muscle hypertrophy",
  "GO:0003301": "physiological cardiac muscle hypertrophy",
  "GO:0003302": "transforming growth factor beta receptor signaling pathway involved in heart jogging",
  "GO:0003303": "BMP signaling pathway involved in heart jogging",
  "GO:0003304": "myocardial epithelial involution involved in heart jogging",
  "GO:0003305": "cell migration involved in heart jogging",
  "GO:0003306": "Wnt signaling pathway involved in heart development",
  "GO:0003307": "regulation of Wnt signaling pathway involved in heart development",
  "GO:0003308": "negative regulation of Wnt signaling pathway involved in heart development",
  "GO:0003309": "type B pancreatic cell differentiation",
  "GO:0003310": "pancreatic A cell differentiation",
  "GO:0003311": "pancreatic D cell differentiation",
  "GO:0003312": "pancreatic PP cell differentiation",
  "GO:0003313": "heart rudiment development",
  "GO:0003314": "heart rudiment morphogenesis",
  "GO:0003315": "heart rudiment formation",
  "GO:0003316": "establishment of myocardial progenitor cell apical/basal polarity",
  "GO:0003317": "cardioblast cell midline fusion",
  "GO:0003318": "cell migration to the midline involved in heart development",
  "GO:0003319": "cardioblast migration to the midline involved in heart rudiment formation",
  "GO:0003320": "heart rudiment involution",
  "GO:0003321": "positive regulation of blood pressure by epinephrine-norepinephrine",
  "GO:0003322": "pancreatic A cell development",
  "GO:0003323": "type B pancreatic cell development",
  "GO:0003324": "pancreatic D cell development",
  "GO:0003325": "pancreatic PP cell development",
  "GO:0003326": "pancreatic A cell fate commitment",
  "GO:0003327": "type B pancreatic cell fate commitment",
  "GO:0003328": "pancreatic D cell fate commitment",
  "GO:0003329": "pancreatic PP cell fate commitment",
  "GO:0003330": "regulation of extracellular matrix constituent secretion",
  "GO:0003331": "positive regulation of extracellular matrix constituent secretion",
  "GO:0003332": "negative regulation of extracellular matrix constituent secretion",
  "GO:0003333": "amino acid transmembrane transport",
  "GO:0003334": "keratinocyte development",
  "GO:0003335": "corneocyte development",
  "GO:0003336": "corneocyte desquamation",
  "GO:0003337": "mesenchymal to epithelial transition involved in metanephros morphogenesis",
  "GO:0003338": "metanephros morphogenesis",
  "GO:0003339": "regulation of mesenchymal to epithelial transition involved in metanephros morphogenesis",
  "GO:0003340": "negative regulation of mesenchymal to epithelial transition involved in metanephros morphogenesis",
  "GO:0003341": "cilium movement",
  "GO:0003342": "proepicardium development",
  "GO:0003343": "septum transversum development",
  "GO:0003344": "pericardium morphogenesis",
  "GO:0003345": "proepicardium cell migration involved in pericardium morphogenesis",
  "GO:0003346": "epicardium-derived cell migration to the myocardium",
  "GO:0003347": "epicardial cell to mesenchymal cell transition",
  "GO:0003348": "cardiac endothelial cell differentiation",
  "GO:0003349": "epicardium-derived cardiac endothelial cell differentiation",
  "GO:0003350": "pulmonary myocardium development",
  "GO:0003351": "epithelial cilium movement",
  "GO:0003352": "regulation of cilium movement",
  "GO:0003353": "positive regulation of cilium movement",
  "GO:0003354": "negative regulation of cilium movement",
  "GO:0003355": "cilium movement involved in otolith formation",
  "GO:0003356": "regulation of cilium beat frequency",
  "GO:0003357": "noradrenergic neuron differentiation",
  "GO:0003358": "noradrenergic neuron development",
  "GO:0003359": "noradrenergic neuron fate commitment",
  "GO:0003360": "brainstem development",
  "GO:0003361": "noradrenergic neuron differentiation involved in brainstem development",
  "GO:0003362": "noradrenergic neuron fate commitment involved in brainstem development",
  "GO:0003363": "lamellipodium assembly involved in ameboidal cell migration",
  "GO:0003364": "lamellipodium assembly involved in mesendodermal cell migration",
  "GO:0003365": "establishment of cell polarity involved in ameboidal cell migration",
  "GO:0003366": "cell-matrix adhesion involved in ameboidal cell migration",
  "GO:0003367": "cell-cell adhesion involved in ameboidal cell migration",
  "GO:0003368": "cell-matrix adhesion involved in mesendodermal cell migration",
  "GO:0003369": "establishment of cell polarity involved in mesendodermal cell migration",
  "GO:0003370": "cell-cell adhesion involved in mesendodermal cell migration",
  "GO:0003371": "establishment or maintenance of cytoskeleton polarity involved in ameboidal cell migration",
  "GO:0003372": "establishment or maintenance of cytoskeleton polarity involved in mesendodermal cell migration",
  "GO:0003373": "dynamin polymerization involved in membrane fission",
  "GO:0003374": "dynamin polymerization involved in mitochondrial fission",
  "GO:0003375": "regulation of dynamin polymerization involved in membrane fission",
  "GO:0003376": "sphingosine-1-phosphate signaling pathway",
  "GO:0003377": "regulation of apoptosis by sphingosine-1-phosphate signaling pathway",
  "GO:0003378": "regulation of inflammatory response by sphingosine-1-phosphate signaling pathway",
  "GO:0003379": "establishment of cell polarity involved in gastrulation cell migration",
  "GO:0003380": "establishment or maintenance of cytoskeleton polarity involved in gastrulation",
  "GO:0003381": "epithelial cell morphogenesis involved in gastrulation",
  "GO:0003382": "epithelial cell morphogenesis",
  "GO:0003383": "apical constriction",
  "GO:0003384": "apical constriction involved in gastrulation",
  "GO:0003385": "cell-cell signaling involved in amphid sensory organ development",
  "GO:0003386": "amphid sensory organ development",
  "GO:0003387": "neuron differentiation involved in amphid sensory organ development",
  "GO:0003388": "neuron development involved in amphid sensory organ development",
  "GO:0003389": "retrograde extension",
  "GO:0003390": "dendrite development by retrograde extension",
  "GO:0003391": "amphid sensory organ dendrite retrograde extension",
  "GO:0003392": "cell adhesion involved in retrograde extension",
  "GO:0003393": "neuron migration involved in retrograde extension",
  "GO:0003394": "cell adhesion involved in dendrite retrograde extension",
  "GO:0003395": "neuron migration involved in dendrite retrograde extension",
  "GO:0003396": "cell adhesion involved in amphid sensory organ dendrite retrograde extension",
  "GO:0003397": "neuron migration involved in amphid sensory organ dendrite retrograde extension",
  "GO:0003398": "glial cell differentiation involved in amphid sensory organ development",
  "GO:0003399": "cytoneme morphogenesis",
  "GO:0003400": "regulation of COPII vesicle coating",
  "GO:0003401": "axis elongation",
  "GO:0003402": "planar cell polarity pathway involved in axis elongation",
  "GO:0003403": "optic vesicle formation",
  "GO:0003404": "optic vesicle morphogenesis",
  "GO:0003405": "optic vesicle elongation",
  "GO:0003406": "retinal pigment epithelium development",
  "GO:0003407": "neural retina development",
  "GO:0003408": "optic cup formation involved in camera-type eye development",
  "GO:0003409": "optic cup structural organization",
  "GO:0003410": "anterior rotation of the optic cup",
  "GO:0003411": "cell motility involved in camera-type eye morphogenesis",
  "GO:0003412": "establishment of epithelial cell apical/basal polarity involved in camera-type eye morphogenesis",
  "GO:0003413": "chondrocyte differentiation involved in endochondral bone morphogenesis",
  "GO:0003414": "chondrocyte morphogenesis involved in endochondral bone morphogenesis",
  "GO:0003415": "chondrocyte hypertrophy",
  "GO:0003416": "endochondral bone growth",
  "GO:0003417": "growth plate cartilage development",
  "GO:0003418": "growth plate cartilage chondrocyte differentiation",
  "GO:0003419": "growth plate cartilage chondrocyte proliferation",
  "GO:0003420": "regulation of growth plate cartilage chondrocyte proliferation",
  "GO:0003421": "growth plate cartilage axis specification",
  "GO:0003422": "growth plate cartilage morphogenesis",
  "GO:0003423": "growth plate cartilage chondrocyte division",
  "GO:0003424": "establishment of cell polarity involved in growth plate cartilage chondrocyte division",
  "GO:0003425": "establishment of mitotic spindle orientation involved in growth plate cartilage chondrocyte division",
  "GO:0003426": "cytoskeleton polarization involved in growth plate cartilage chondrocyte division",
  "GO:0003427": "regulation of cytoskeleton polarization involved in growth plate cartilage chondrocyte division",
  "GO:0003428": "chondrocyte intercalation involved in growth plate cartilage morphogenesis",
  "GO:0003429": "growth plate cartilage chondrocyte morphogenesis",
  "GO:0003430": "growth plate cartilage chondrocyte growth",
  "GO:0003431": "growth plate cartilage chondrocyte development",
  "GO:0003432": "cell growth involved in growth plate cartilage chondrocyte morphogenesis",
  "GO:0003433": "chondrocyte development involved in endochondral bone morphogenesis",
  "GO:0003434": "BMP signaling pathway involved in growth plate cartilage chondrocyte development",
  "GO:0003435": "smoothened signaling pathway involved in growth plate cartilage chondrocyte development",
  "GO:0003436": "regulation of cell adhesion involved in growth plate cartilage morphogenesis",
  "GO:0003437": "regulation of cell communication involved in growth plate cartilage morphogenesis",
  "GO:0003673": "obsolete Gene_Ontology",
  "GO:0003674": "molecular_function",
  "GO:0003675": "obsolete protein",
  "GO:0003676": "nucleic acid binding",
  "GO:0003677": "DNA binding",
  "GO:0003678": "DNA helicase activity",
  "GO:0003680": "AT DNA binding",
  "GO:0003681": "bent DNA binding",
  "GO:0003682": "chromatin binding",
  "GO:0003683": "obsolete lamin/chromatin binding",
  "GO:0003684": "damaged DNA binding",
  "GO:0003685": "obsolete DNA repair protein",
  "GO:0003686": "obsolete DNA repair enzyme",
  "GO:0003687": "obsolete DNA replication factor",
  "GO:0003688": "DNA replication origin binding",
  "GO:0003689": "DNA clamp loader activity",
  "GO:0003690": "double-stranded DNA binding",
  "GO:0003691": "double-stranded telomeric DNA binding",
  "GO:0003692": "left-handed Z-DNA binding",
  "GO:0003693": "P-element binding",
  "GO:0003694": "obsolete plasmid binding",
  "GO:0003695": "random coil DNA binding",
  "GO:0003696": "satellite DNA binding",
  "GO:0003697": "single-stranded DNA binding",
  "GO:0003700": "transcription factor activity, sequence-specific DNA binding",
  "GO:0003701": "obsolete RNA polymerase I transcription factor activity",
  "GO:0003702": "obsolete RNA polymerase II transcription factor activity",
  "GO:0003704": "obsolete specific RNA polymerase II transcription factor activity",
  "GO:0003705": "transcription factor activity, RNA polymerase II distal enhancer sequence-specific binding",
  "GO:0003706": "obsolete ligand-regulated transcription factor activity",
  "GO:0003707": "steroid hormone receptor activity",
  "GO:0003708": "retinoic acid receptor activity",
  "GO:0003709": "obsolete RNA polymerase III transcription factor activity",
  "GO:0003711": "obsolete transcription elongation regulator activity",
  "GO:0003712": "transcription cofactor activity",
  "GO:0003713": "transcription coactivator activity",
  "GO:0003714": "transcription corepressor activity",
  "GO:0003715": "obsolete transcription termination factor activity",
  "GO:0003716": "obsolete RNA polymerase I transcription termination factor activity",
  "GO:0003717": "obsolete RNA polymerase II transcription termination factor activity",
  "GO:0003718": "obsolete RNA polymerase III transcription termination factor activity",
  "GO:0003719": "obsolete transcription factor binding, cytoplasmic sequestering",
  "GO:0003720": "telomerase activity",
  "GO:0003721": "telomerase RNA reverse transcriptase activity",
  "GO:0003723": "RNA binding",
  "GO:0003724": "RNA helicase activity",
  "GO:0003725": "double-stranded RNA binding",
  "GO:0003726": "double-stranded RNA adenosine deaminase activity",
  "GO:0003727": "single-stranded RNA binding",
  "GO:0003729": "mRNA binding",
  "GO:0003730": "mRNA 3'-UTR binding",
  "GO:0003731": "obsolete mRNA cap binding",
  "GO:0003732": "obsolete snRNA cap binding",
  "GO:0003733": "obsolete ribonucleoprotein",
  "GO:0003734": "obsolete small nuclear ribonucleoprotein",
  "GO:0003735": "structural constituent of ribosome",
  "GO:0003743": "translation initiation factor activity",
  "GO:0003746": "translation elongation factor activity",
  "GO:0003747": "translation release factor activity",
  "GO:0003750": "obsolete cell cycle regulator",
  "GO:0003754": "obsolete chaperone activity",
  "GO:0003755": "peptidyl-prolyl cis-trans isomerase activity",
  "GO:0003756": "protein disulfide isomerase activity",
  "GO:0003759": "obsolete glycoprotein-specific chaperone activity",
  "GO:0003762": "obsolete histone-specific chaperone activity",
  "GO:0003763": "obsolete chaperonin ATPase activity",
  "GO:0003767": "obsolete co-chaperone activity",
  "GO:0003772": "obsolete co-chaperonin activity",
  "GO:0003773": "obsolete heat shock protein activity",
  "GO:0003774": "motor activity",
  "GO:0003775": "obsolete axonemal motor activity",
  "GO:0003776": "obsolete muscle motor activity",
  "GO:0003777": "microtubule motor activity",
  "GO:0003778": "obsolete dynactin motor",
  "GO:0003779": "actin binding",
  "GO:0003780": "obsolete actin cross-linking activity",
  "GO:0003781": "obsolete actin bundling activity",
  "GO:0003782": "obsolete F-actin capping activity",
  "GO:0003783": "obsolete barbed-end actin capping activity",
  "GO:0003784": "obsolete barbed-end actin capping/severing activity",
  "GO:0003785": "actin monomer binding",
  "GO:0003786": "actin lateral binding",
  "GO:0003787": "obsolete actin depolymerizing activity",
  "GO:0003788": "obsolete actin monomer sequestering activity",
  "GO:0003789": "obsolete actin filament severing activity",
  "GO:0003790": "obsolete actin modulating activity",
  "GO:0003791": "obsolete membrane associated actin binding",
  "GO:0003792": "obsolete regulation of actin thin filament length activity",
  "GO:0003793": "obsolete defense/immunity protein activity",
  "GO:0003794": "obsolete acute-phase response protein activity",
  "GO:0003795": "obsolete antimicrobial peptide activity",
  "GO:0003796": "lysozyme activity",
  "GO:0003797": "obsolete antibacterial peptide activity",
  "GO:0003798": "obsolete male-specific antibacterial peptide activity",
  "GO:0003799": "obsolete antifungal peptide activity",
  "GO:0003800": "obsolete antiviral response protein activity",
  "GO:0003801": "obsolete blood coagulation factor activity",
  "GO:0003802": "obsolete coagulation factor VIIa activity",
  "GO:0003803": "obsolete coagulation factor IXa activity",
  "GO:0003804": "obsolete coagulation factor Xa activity",
  "GO:0003805": "obsolete coagulation factor XIa activity",
  "GO:0003806": "obsolete coagulation factor XIIa activity",
  "GO:0003807": "obsolete plasma kallikrein activity",
  "GO:0003808": "obsolete protein C (activated) activity",
  "GO:0003809": "obsolete thrombin activity",
  "GO:0003810": "protein-glutamine gamma-glutamyltransferase activity",
  "GO:0003811": "obsolete complement activity",
  "GO:0003812": "obsolete alternative-complement-pathway C3/C5 convertase activity",
  "GO:0003813": "obsolete classical-complement-pathway C3/C5 convertase activity",
  "GO:0003815": "obsolete complement component C1r activity",
  "GO:0003816": "obsolete complement component C1s activity",
  "GO:0003817": "obsolete complement factor D activity",
  "GO:0003818": "obsolete complement factor I activity",
  "GO:0003819": "obsolete major histocompatibility complex antigen",
  "GO:0003820": "obsolete class I major histocompatibility complex antigen",
  "GO:0003821": "obsolete class II major histocompatibility complex antigen",
  "GO:0003822": "obsolete MHC-interacting protein",
  "GO:0003823": "antigen binding",
  "GO:0003824": "catalytic activity",
  "GO:0003825": "alpha,alpha-trehalose-phosphate synthase (UDP-forming) activity",
  "GO:0003826": "alpha-ketoacid dehydrogenase activity",
  "GO:0003827": "alpha-1,3-mannosylglycoprotein 2-beta-N-acetylglucosaminyltransferase activity",
  "GO:0003828": "alpha-N-acetylneuraminate alpha-2,8-sialyltransferase activity",
  "GO:0003829": "beta-1,3-galactosyl-O-glycosyl-glycoprotein beta-1,6-N-acetylglucosaminyltransferase activity",
  "GO:0003830": "beta-1,4-mannosylglycoprotein 4-beta-N-acetylglucosaminyltransferase activity",
  "GO:0003831": "beta-N-acetylglucosaminylglycopeptide beta-1,4-galactosyltransferase activity",
  "GO:0003832": "beta-alanyl-dopamine hydrolase activity",
  "GO:0003833": "beta-alanyl-dopamine synthase activity",
  "GO:0003834": "beta-carotene 15,15'-monooxygenase activity",
  "GO:0003835": "beta-galactoside alpha-2,6-sialyltransferase activity",
  "GO:0003836": "beta-galactoside (CMP) alpha-2,3-sialyltransferase activity",
  "GO:0003837": "beta-ureidopropionase activity",
  "GO:0003838": "sterol 24-C-methyltransferase activity",
  "GO:0003839": "gamma-glutamylcyclotransferase activity",
  "GO:0003840": "gamma-glutamyltransferase activity",
  "GO:0003841": "1-acylglycerol-3-phosphate O-acyltransferase activity",
  "GO:0003842": "1-pyrroline-5-carboxylate dehydrogenase activity",
  "GO:0003843": "1,3-beta-D-glucan synthase activity",
  "GO:0003844": "1,4-alpha-glucan branching enzyme activity",
  "GO:0003845": "11-beta-hydroxysteroid dehydrogenase [NAD(P)] activity",
  "GO:0003846": "2-acylglycerol O-acyltransferase activity",
  "GO:0003847": "1-alkyl-2-acetylglycerophosphocholine esterase activity",
  "GO:0003848": "2-amino-4-hydroxy-6-hydroxymethyldihydropteridine diphosphokinase activity",
  "GO:0003849": "3-deoxy-7-phosphoheptulonate synthase activity",
  "GO:0003850": "2-deoxyglucose-6-phosphatase activity",
  "GO:0003851": "2-hydroxyacylsphingosine 1-beta-galactosyltransferase activity",
  "GO:0003852": "2-isopropylmalate synthase activity",
  "GO:0003853": "2-methylacyl-CoA dehydrogenase activity",
  "GO:0003854": "3-beta-hydroxy-delta5-steroid dehydrogenase activity",
  "GO:0003855": "3-dehydroquinate dehydratase activity",
  "GO:0003856": "3-dehydroquinate synthase activity",
  "GO:0003857": "3-hydroxyacyl-CoA dehydrogenase activity",
  "GO:0003858": "3-hydroxybutyrate dehydrogenase activity",
  "GO:0003859": "3-hydroxybutyryl-CoA dehydratase activity",
  "GO:0003860": "3-hydroxyisobutyryl-CoA hydrolase activity",
  "GO:0003861": "3-isopropylmalate dehydratase activity",
  "GO:0003862": "3-isopropylmalate dehydrogenase activity",
  "GO:0003863": "3-methyl-2-oxobutanoate dehydrogenase (2-methylpropanoyl-transferring) activity",
  "GO:0003864": "3-methyl-2-oxobutanoate hydroxymethyltransferase activity",
  "GO:0003865": "3-oxo-5-alpha-steroid 4-dehydrogenase activity",
  "GO:0003866": "3-phosphoshikimate 1-carboxyvinyltransferase activity",
  "GO:0003867": "4-aminobutyrate transaminase activity",
  "GO:0003868": "4-hydroxyphenylpyruvate dioxygenase activity",
  "GO:0003870": "5-aminolevulinate synthase activity",
  "GO:0003871": "5-methyltetrahydropteroyltriglutamate-homocysteine S-methyltransferase activity",
  "GO:0003872": "6-phosphofructokinase activity",
  "GO:0003873": "6-phosphofructo-2-kinase activity",
  "GO:0003874": "6-pyruvoyltetrahydropterin synthase activity",
  "GO:0003875": "ADP-ribosylarginine hydrolase activity",
  "GO:0003876": "AMP deaminase activity",
  "GO:0003877": "ATP adenylyltransferase activity",
  "GO:0003878": "ATP citrate synthase activity",
  "GO:0003879": "ATP phosphoribosyltransferase activity",
  "GO:0003880": "protein C-terminal carboxyl O-methyltransferase activity",
  "GO:0003881": "CDP-diacylglycerol-inositol 3-phosphatidyltransferase activity",
  "GO:0003882": "CDP-diacylglycerol-serine O-phosphatidyltransferase activity",
  "GO:0003883": "CTP synthase activity",
  "GO:0003884": "D-amino-acid oxidase activity",
  "GO:0003885": "D-arabinono-1,4-lactone oxidase activity",
  "GO:0003886": "DNA (cytosine-5-)-methyltransferase activity",
  "GO:0003887": "DNA-directed DNA polymerase activity",
  "GO:0003892": "obsolete proliferating cell nuclear antigen",
  "GO:0003896": "DNA primase activity",
  "GO:0003899": "DNA-directed RNA polymerase activity",
  "GO:0003900": "obsolete DNA-directed RNA polymerase I activity",
  "GO:0003901": "obsolete DNA-directed RNA polymerase II activity",
  "GO:0003902": "obsolete DNA-directed RNA polymerase III activity",
  "GO:0003904": "deoxyribodipyrimidine photo-lyase activity",
  "GO:0003905": "alkylbase DNA N-glycosylase activity",
  "GO:0003906": "DNA-(apurinic or apyrimidinic site) lyase activity",
  "GO:0003908": "methylated-DNA-[protein]-cysteine S-methyltransferase activity",
  "GO:0003909": "DNA ligase activity",
  "GO:0003910": "DNA ligase (ATP) activity",
  "GO:0003911": "DNA ligase (NAD+) activity",
  "GO:0003912": "DNA nucleotidylexotransferase activity",
  "GO:0003913": "DNA photolyase activity",
  "GO:0003914": "DNA (6-4) photolyase activity",
  "GO:0003916": "DNA topoisomerase activity",
  "GO:0003917": "DNA topoisomerase type I activity",
  "GO:0003918": "DNA topoisomerase type II (ATP-hydrolyzing) activity",
  "GO:0003919": "FMN adenylyltransferase activity",
  "GO:0003920": "GMP reductase activity",
  "GO:0003921": "GMP synthase activity",
  "GO:0003922": "GMP synthase (glutamine-hydrolyzing) activity",
  "GO:0003923": "GPI-anchor transamidase activity",
  "GO:0003924": "GTPase activity",
  "GO:0003925": "obsolete small monomeric GTPase activity",
  "GO:0003926": "obsolete ARF small monomeric GTPase activity",
  "GO:0003927": "obsolete heterotrimeric G-protein GTPase activity",
  "GO:0003928": "obsolete RAB small monomeric GTPase activity",
  "GO:0003929": "obsolete RAN small monomeric GTPase activity",
  "GO:0003930": "obsolete RAS small monomeric GTPase activity",
  "GO:0003931": "obsolete Rho small monomeric GTPase activity",
  "GO:0003932": "obsolete SAR small monomeric GTPase activity",
  "GO:0003933": "GTP cyclohydrolase activity",
  "GO:0003934": "GTP cyclohydrolase I activity",
  "GO:0003935": "GTP cyclohydrolase II activity",
  "GO:0003936": "obsolete hydrogen-transporting two-sector ATPase activity",
  "GO:0003937": "IMP cyclohydrolase activity",
  "GO:0003938": "IMP dehydrogenase activity",
  "GO:0003939": "L-iditol 2-dehydrogenase activity",
  "GO:0003940": "L-iduronidase activity",
  "GO:0003941": "L-serine ammonia-lyase activity",
  "GO:0003942": "N-acetyl-gamma-glutamyl-phosphate reductase activity",
  "GO:0003943": "N-acetylgalactosamine-4-sulfatase activity",
  "GO:0003944": "N-acetylglucosamine-1-phosphodiester alpha-N-acetylglucosaminidase activity",
  "GO:0003945": "N-acetyllactosamine synthase activity",
  "GO:0003947": "(N-acetylneuraminyl)-galactosylglucosylceramide N-acetylgalactosaminyltransferase activity",
  "GO:0003948": "N4-(beta-N-acetylglucosaminyl)-L-asparaginase activity",
  "GO:0003949": "1-(5-phosphoribosyl)-5-[(5-phosphoribosylamino)methylideneamino]imidazole-4-carboxamide isomerase activity",
  "GO:0003950": "NAD+ ADP-ribosyltransferase activity",
  "GO:0003951": "NAD+ kinase activity",
  "GO:0003952": "NAD+ synthase (glutamine-hydrolyzing) activity",
  "GO:0003953": "NAD+ nucleosidase activity",
  "GO:0003954": "NADH dehydrogenase activity",
  "GO:0003955": "NAD(P)H dehydrogenase (quinone) activity",
  "GO:0003956": "NAD(P)+-protein-arginine ADP-ribosyltransferase activity",
  "GO:0003957": "NAD(P)+ transhydrogenase (B-specific) activity",
  "GO:0003958": "NADPH-hemoprotein reductase activity",
  "GO:0003959": "NADPH dehydrogenase activity",
  "GO:0003960": "NADPH:quinone reductase activity",
  "GO:0003961": "O-acetylhomoserine aminocarboxypropyltransferase activity",
  "GO:0003962": "cystathionine gamma-synthase activity",
  "GO:0003963": "RNA-3'-phosphate cyclase activity",
  "GO:0003964": "RNA-directed DNA polymerase activity",
  "GO:0003966": "obsolete RNA-directed DNA polymerase, transposon encoded",
  "GO:0003967": "obsolete RNA-directed DNA polymerase, group II intron encoded",
  "GO:0003968": "RNA-directed RNA polymerase activity",
  "GO:0003969": "obsolete RNA editase activity",
  "GO:0003972": "RNA ligase (ATP) activity",
  "GO:0003973": "(S)-2-hydroxy-acid oxidase activity",
  "GO:0003974": "UDP-N-acetylglucosamine 4-epimerase activity",
  "GO:0003975": "UDP-N-acetylglucosamine-dolichyl-phosphate N-acetylglucosaminephosphotransferase activity",
  "GO:0003976": "UDP-N-acetylglucosamine-lysosomal-enzyme N-acetylglucosaminephosphotransferase activity",
  "GO:0003977": "UDP-N-acetylglucosamine diphosphorylase activity",
  "GO:0003978": "UDP-glucose 4-epimerase activity",
  "GO:0003979": "UDP-glucose 6-dehydrogenase activity",
  "GO:0003980": "UDP-glucose:glycoprotein glucosyltransferase activity",
  "GO:0003983": "UTP:glucose-1-phosphate uridylyltransferase activity",
  "GO:0003984": "acetolactate synthase activity",
  "GO:0003985": "acetyl-CoA C-acetyltransferase activity",
  "GO:0003986": "acetyl-CoA hydrolase activity",
  "GO:0003987": "acetate-CoA ligase activity",
  "GO:0003988": "acetyl-CoA C-acyltransferase activity",
  "GO:0003989": "acetyl-CoA carboxylase activity",
  "GO:0003990": "acetylcholinesterase activity",
  "GO:0003991": "acetylglutamate kinase activity",
  "GO:0003992": "N2-acetyl-L-ornithine:2-oxoglutarate 5-aminotransferase activity",
  "GO:0003993": "acid phosphatase activity",
  "GO:0003994": "aconitate hydratase activity",
  "GO:0003995": "acyl-CoA dehydrogenase activity",
  "GO:0003996": "acyl-CoA ligase activity",
  "GO:0003997": "acyl-CoA oxidase activity",
  "GO:0003998": "acylphosphatase activity",
  "GO:0003999": "adenine phosphoribosyltransferase activity",
  "GO:0004000": "adenosine deaminase activity",
  "GO:0004001": "adenosine kinase activity",
  "GO:0004003": "ATP-dependent DNA helicase activity",
  "GO:0004004": "ATP-dependent RNA helicase activity",
  "GO:0004005": "obsolete plasma membrane cation-transporting ATPase",
  "GO:0004007": "obsolete heavy metal-exporting ATPase activity",
  "GO:0004008": "copper-exporting ATPase activity",
  "GO:0004009": "obsolete ATP-binding cassette (ABC) transporter activity",
  "GO:0004012": "phospholipid-translocating ATPase activity",
  "GO:0004013": "adenosylhomocysteinase activity",
  "GO:0004014": "adenosylmethionine decarboxylase activity",
  "GO:0004015": "adenosylmethionine-8-amino-7-oxononanoate transaminase activity",
  "GO:0004016": "adenylate cyclase activity",
  "GO:0004017": "adenylate kinase activity",
  "GO:0004018": "N6-(1,2-dicarboxyethyl)AMP AMP-lyase (fumarate-forming) activity",
  "GO:0004019": "adenylosuccinate synthase activity",
  "GO:0004020": "adenylylsulfate kinase activity",
  "GO:0004021": "L-alanine:2-oxoglutarate aminotransferase activity",
  "GO:0004022": "alcohol dehydrogenase (NAD) activity",
  "GO:0004023": "alcohol dehydrogenase activity, metal ion-independent",
  "GO:0004024": "alcohol dehydrogenase activity, zinc-dependent",
  "GO:0004025": "alcohol dehydrogenase activity, iron-dependent",
  "GO:0004026": "alcohol O-acetyltransferase activity",
  "GO:0004027": "alcohol sulfotransferase activity",
  "GO:0004028": "3-chloroallyl aldehyde dehydrogenase activity",
  "GO:0004029": "aldehyde dehydrogenase (NAD) activity",
  "GO:0004030": "aldehyde dehydrogenase [NAD(P)+] activity",
  "GO:0004031": "aldehyde oxidase activity",
  "GO:0004032": "alditol:NADP+ 1-oxidoreductase activity",
  "GO:0004033": "aldo-keto reductase (NADP) activity",
  "GO:0004034": "aldose 1-epimerase activity",
  "GO:0004035": "alkaline phosphatase activity",
  "GO:0004037": "allantoicase activity",
  "GO:0004038": "allantoinase activity",
  "GO:0004039": "allophanate hydrolase activity",
  "GO:0004040": "amidase activity",
  "GO:0004042": "acetyl-CoA:L-glutamate N-acetyltransferase activity",
  "GO:0004043": "L-aminoadipate-semialdehyde dehydrogenase activity",
  "GO:0004044": "amidophosphoribosyltransferase activity",
  "GO:0004045": "aminoacyl-tRNA hydrolase activity",
  "GO:0004046": "aminoacylase activity",
  "GO:0004047": "aminomethyltransferase activity",
  "GO:0004048": "anthranilate phosphoribosyltransferase activity",
  "GO:0004049": "anthranilate synthase activity",
  "GO:0004050": "obsolete apyrase activity",
  "GO:0004051": "arachidonate 5-lipoxygenase activity",
  "GO:0004052": "arachidonate 12-lipoxygenase activity",
  "GO:0004053": "arginase activity",
  "GO:0004054": "arginine kinase activity",
  "GO:0004055": "argininosuccinate synthase activity",
  "GO:0004056": "argininosuccinate lyase activity",
  "GO:0004057": "arginyltransferase activity",
  "GO:0004058": "aromatic-L-amino-acid decarboxylase activity",
  "GO:0004059": "aralkylamine N-acetyltransferase activity",
  "GO:0004060": "arylamine N-acetyltransferase activity",
  "GO:0004061": "arylformamidase activity",
  "GO:0004062": "aryl sulfotransferase activity",
  "GO:0004063": "aryldialkylphosphatase activity",
  "GO:0004064": "arylesterase activity",
  "GO:0004065": "arylsulfatase activity",
  "GO:0004066": "asparagine synthase (glutamine-hydrolyzing) activity",
  "GO:0004067": "asparaginase activity",
  "GO:0004068": "aspartate 1-decarboxylase activity",
  "GO:0004069": "L-aspartate:2-oxoglutarate aminotransferase activity",
  "GO:0004070": "aspartate carbamoyltransferase activity",
  "GO:0004071": "aspartate-ammonia ligase activity",
  "GO:0004072": "aspartate kinase activity",
  "GO:0004073": "aspartate-semialdehyde dehydrogenase activity",
  "GO:0004074": "biliverdin reductase activity",
  "GO:0004075": "biotin carboxylase activity",
  "GO:0004076": "biotin synthase activity",
  "GO:0004077": "biotin-[acetyl-CoA-carboxylase] ligase activity",
  "GO:0004078": "biotin-[methylcrotonoyl-CoA-carboxylase] ligase activity",
  "GO:0004079": "biotin-[methylmalonyl-CoA-carboxytransferase] ligase activity",
  "GO:0004080": "biotin-[propionyl-CoA-carboxylase (ATP-hydrolyzing)] ligase activity",
  "GO:0004081": "bis(5'-nucleosyl)-tetraphosphatase (asymmetrical) activity",
  "GO:0004082": "bisphosphoglycerate mutase activity",
  "GO:0004083": "bisphosphoglycerate 2-phosphatase activity",
  "GO:0004084": "branched-chain-amino-acid transaminase activity",
  "GO:0004085": "butyryl-CoA dehydrogenase activity",
  "GO:0004086": "obsolete carbamoyl-phosphate synthase activity",
  "GO:0004087": "carbamoyl-phosphate synthase (ammonia) activity",
  "GO:0004088": "carbamoyl-phosphate synthase (glutamine-hydrolyzing) activity",
  "GO:0004089": "carbonate dehydratase activity",
  "GO:0004090": "carbonyl reductase (NADPH) activity",
  "GO:0004092": "carnitine O-acetyltransferase activity",
  "GO:0004095": "carnitine O-palmitoyltransferase activity",
  "GO:0004096": "catalase activity",
  "GO:0004097": "catechol oxidase activity",
  "GO:0004098": "cerebroside-sulfatase activity",
  "GO:0004099": "chitin deacetylase activity",
  "GO:0004100": "chitin synthase activity",
  "GO:0004102": "choline O-acetyltransferase activity",
  "GO:0004103": "choline kinase activity",
  "GO:0004104": "cholinesterase activity",
  "GO:0004105": "choline-phosphate cytidylyltransferase activity",
  "GO:0004106": "chorismate mutase activity",
  "GO:0004107": "chorismate synthase activity",
  "GO:0004108": "citrate (Si)-synthase activity",
  "GO:0004109": "coproporphyrinogen oxidase activity",
  "GO:0004110": "corticosteroid side-chain-isomerase activity",
  "GO:0004111": "creatine kinase activity",
  "GO:0004112": "cyclic-nucleotide phosphodiesterase activity",
  "GO:0004113": "2',3'-cyclic-nucleotide 3'-phosphodiesterase activity",
  "GO:0004114": "3',5'-cyclic-nucleotide phosphodiesterase activity",
  "GO:0004115": "3',5'-cyclic-AMP phosphodiesterase activity",
  "GO:0004117": "calmodulin-dependent cyclic-nucleotide phosphodiesterase activity",
  "GO:0004118": "cGMP-stimulated cyclic-nucleotide phosphodiesterase activity",
  "GO:0004119": "cGMP-inhibited cyclic-nucleotide phosphodiesterase activity",
  "GO:0004120": "photoreceptor cyclic-nucleotide phosphodiesterase activity",
  "GO:0004121": "cystathionine beta-lyase activity",
  "GO:0004122": "cystathionine beta-synthase activity",
  "GO:0004123": "cystathionine gamma-lyase activity",
  "GO:0004124": "cysteine synthase activity",
  "GO:0004125": "L-seryl-tRNASec selenium transferase activity",
  "GO:0004126": "cytidine deaminase activity",
  "GO:0004127": "cytidylate kinase activity",
  "GO:0004128": "cytochrome-b5 reductase activity, acting on NAD(P)H",
  "GO:0004129": "cytochrome-c oxidase activity",
  "GO:0004130": "cytochrome-c peroxidase activity",
  "GO:0004131": "cytosine deaminase activity",
  "GO:0004132": "dCMP deaminase activity",
  "GO:0004133": "glycogen debranching enzyme activity",
  "GO:0004134": "4-alpha-glucanotransferase activity",
  "GO:0004135": "amylo-alpha-1,6-glucosidase activity",
  "GO:0004136": "deoxyadenosine kinase activity",
  "GO:0004137": "deoxycytidine kinase activity",
  "GO:0004138": "deoxyguanosine kinase activity",
  "GO:0004139": "deoxyribose-phosphate aldolase activity",
  "GO:0004140": "dephospho-CoA kinase activity",
  "GO:0004141": "dethiobiotin synthase activity",
  "GO:0004142": "diacylglycerol cholinephosphotransferase activity",
  "GO:0004143": "diacylglycerol kinase activity",
  "GO:0004144": "diacylglycerol O-acyltransferase activity",
  "GO:0004145": "diamine N-acetyltransferase activity",
  "GO:0004146": "dihydrofolate reductase activity",
  "GO:0004147": "dihydrolipoamide branched chain acyltransferase activity",
  "GO:0004148": "dihydrolipoyl dehydrogenase activity",
  "GO:0004149": "dihydrolipoyllysine-residue succinyltransferase activity",
  "GO:0004150": "dihydroneopterin aldolase activity",
  "GO:0004151": "dihydroorotase activity",
  "GO:0004152": "dihydroorotate dehydrogenase activity",
  "GO:0004153": "dihydropterin deaminase activity",
  "GO:0004154": "dihydropterin oxidase activity",
  "GO:0004155": "6,7-dihydropteridine reductase activity",
  "GO:0004156": "dihydropteroate synthase activity",
  "GO:0004157": "dihydropyrimidinase activity",
  "GO:0004158": "dihydroorotate oxidase activity",
  "GO:0004159": "dihydrouracil dehydrogenase (NAD+) activity",
  "GO:0004160": "dihydroxy-acid dehydratase activity",
  "GO:0004161": "dimethylallyltranstransferase activity",
  "GO:0004162": "dimethylnitrosamine demethylase activity",
  "GO:0004163": "diphosphomevalonate decarboxylase activity",
  "GO:0004164": "diphthine synthase activity",
  "GO:0004165": "dodecenoyl-CoA delta-isomerase activity",
  "GO:0004166": "dolichyl-phosphate alpha-N-acetylglucosaminyltransferase activity",
  "GO:0004167": "dopachrome isomerase activity",
  "GO:0004168": "dolichol kinase activity",
  "GO:0004169": "dolichyl-phosphate-mannose-protein mannosyltransferase activity",
  "GO:0004170": "dUTP diphosphatase activity",
  "GO:0004171": "obsolete deoxyhypusine synthase activity",
  "GO:0004172": "obsolete ecdysteroid UDP-glucosyl/UDP-glucuronosyl transferase activity",
  "GO:0004173": "ecdysone O-acyltransferase activity",
  "GO:0004174": "electron-transferring-flavoprotein dehydrogenase activity",
  "GO:0004175": "endopeptidase activity",
  "GO:0004176": "ATP-dependent peptidase activity",
  "GO:0004177": "aminopeptidase activity",
  "GO:0004178": "obsolete leucyl aminopeptidase activity",
  "GO:0004179": "obsolete membrane alanyl aminopeptidase activity",
  "GO:0004180": "carboxypeptidase activity",
  "GO:0004181": "metallocarboxypeptidase activity",
  "GO:0004182": "obsolete carboxypeptidase A activity",
  "GO:0004183": "obsolete carboxypeptidase E activity",
  "GO:0004184": "obsolete lysine carboxypeptidase activity",
  "GO:0004185": "serine-type carboxypeptidase activity",
  "GO:0004186": "obsolete carboxypeptidase C activity",
  "GO:0004187": "obsolete carboxypeptidase D activity",
  "GO:0004188": "obsolete serine-type Pro-X carboxypeptidase activity",
  "GO:0004189": "obsolete tubulinyl-Tyr carboxypeptidase activity",
  "GO:0004190": "aspartic-type endopeptidase activity",
  "GO:0004191": "obsolete barrierpepsin activity",
  "GO:0004192": "obsolete cathepsin D activity",
  "GO:0004193": "obsolete cathepsin E activity",
  "GO:0004194": "obsolete pepsin A activity",
  "GO:0004195": "obsolete renin activity",
  "GO:0004196": "obsolete saccharopepsin activity",
  "GO:0004197": "cysteine-type endopeptidase activity",
  "GO:0004198": "calcium-dependent cysteine-type endopeptidase activity",
  "GO:0004200": "obsolete signaling (initiator) caspase activity",
  "GO:0004201": "obsolete caspase-1 activity",
  "GO:0004202": "obsolete caspase-2 activity",
  "GO:0004203": "obsolete caspase-4 activity",
  "GO:0004204": "obsolete caspase-5 activity",
  "GO:0004205": "obsolete caspase-8 activity",
  "GO:0004206": "obsolete caspase-10 activity",
  "GO:0004207": "obsolete effector caspase activity",
  "GO:0004208": "obsolete caspase-3 activity",
  "GO:0004209": "obsolete caspase-6 activity",
  "GO:0004210": "obsolete caspase-7 activity",
  "GO:0004211": "obsolete caspase-9 activity",
  "GO:0004212": "obsolete lysosomal cysteine-type endopeptidase",
  "GO:0004213": "obsolete cathepsin B activity",
  "GO:0004214": "obsolete dipeptidyl-peptidase I activity",
  "GO:0004215": "obsolete cathepsin H activity",
  "GO:0004216": "obsolete cathepsin K activity",
  "GO:0004217": "obsolete cathepsin L activity",
  "GO:0004218": "obsolete cathepsin S activity",
  "GO:0004219": "obsolete pyroglutamyl-peptidase I activity",
  "GO:0004221": "obsolete ubiquitin thiolesterase activity",
  "GO:0004222": "metalloendopeptidase activity",
  "GO:0004226": "obsolete Gly-X carboxypeptidase activity",
  "GO:0004228": "obsolete gelatinase A activity",
  "GO:0004229": "obsolete gelatinase B activity",
  "GO:0004230": "obsolete glutamyl aminopeptidase activity",
  "GO:0004231": "obsolete insulysin activity",
  "GO:0004232": "obsolete interstitial collagenase activity",
  "GO:0004234": "obsolete macrophage elastase activity",
  "GO:0004235": "obsolete matrilysin activity",
  "GO:0004237": "obsolete membrane dipeptidase activity",
  "GO:0004238": "obsolete meprin A activity",
  "GO:0004239": "obsolete methionyl aminopeptidase activity",
  "GO:0004240": "obsolete mitochondrial processing peptidase activity",
  "GO:0004241": "obsolete alpha-mitochondrial processing peptidase",
  "GO:0004242": "obsolete beta-mitochondrial processing peptidase",
  "GO:0004243": "obsolete mitochondrial intermediate peptidase activity",
  "GO:0004244": "obsolete mitochondrial inner membrane peptidase activity",
  "GO:0004245": "obsolete neprilysin activity",
  "GO:0004246": "obsolete peptidyl-dipeptidase A activity",
  "GO:0004247": "obsolete saccharolysin activity",
  "GO:0004248": "obsolete stromelysin 1 activity",
  "GO:0004249": "obsolete stromelysin 3 activity",
  "GO:0004250": "obsolete aminopeptidase I activity",
  "GO:0004251": "obsolete X-Pro dipeptidase activity",
  "GO:0004252": "serine-type endopeptidase activity",
  "GO:0004253": "obsolete gamma-renin activity",
  "GO:0004254": "obsolete acylaminoacyl-peptidase activity",
  "GO:0004258": "obsolete vacuolar carboxypeptidase Y",
  "GO:0004261": "obsolete cathepsin G activity",
  "GO:0004262": "obsolete cerevisin activity",
  "GO:0004263": "obsolete chymotrypsin activity",
  "GO:0004274": "obsolete dipeptidyl-peptidase IV activity",
  "GO:0004275": "obsolete enteropeptidase activity",
  "GO:0004276": "obsolete furin activity",
  "GO:0004277": "obsolete granzyme A activity",
  "GO:0004278": "obsolete granzyme B activity",
  "GO:0004281": "obsolete pancreatic elastase II activity",
  "GO:0004283": "obsolete plasmin activity",
  "GO:0004284": "obsolete acrosin activity",
  "GO:0004285": "obsolete proprotein convertase 1 activity",
  "GO:0004286": "obsolete proprotein convertase 2 activity",
  "GO:0004287": "obsolete prolyl oligopeptidase activity",
  "GO:0004289": "obsolete subtilase activity",
  "GO:0004290": "obsolete kexin activity",
  "GO:0004291": "obsolete subtilisin activity",
  "GO:0004293": "obsolete tissue kallikrein activity",
  "GO:0004294": "obsolete tripeptidyl-peptidase II activity",
  "GO:0004295": "obsolete trypsin activity",
  "GO:0004298": "threonine-type endopeptidase activity",
  "GO:0004299": "obsolete proteasome endopeptidase activity",
  "GO:0004300": "enoyl-CoA hydratase activity",
  "GO:0004301": "epoxide hydrolase activity",
  "GO:0004303": "estradiol 17-beta-dehydrogenase activity",
  "GO:0004304": "estrone sulfotransferase activity",
  "GO:0004305": "ethanolamine kinase activity",
  "GO:0004306": "ethanolamine-phosphate cytidylyltransferase activity",
  "GO:0004307": "ethanolaminephosphotransferase activity",
  "GO:0004308": "exo-alpha-sialidase activity",
  "GO:0004309": "exopolyphosphatase activity",
  "GO:0004310": "farnesyl-diphosphate farnesyltransferase activity",
  "GO:0004311": "farnesyltranstransferase activity",
  "GO:0004312": "fatty acid synthase activity",
  "GO:0004313": "[acyl-carrier-protein] S-acetyltransferase activity",
  "GO:0004314": "[acyl-carrier-protein] S-malonyltransferase activity",
  "GO:0004315": "3-oxoacyl-[acyl-carrier-protein] synthase activity",
  "GO:0004316": "3-oxoacyl-[acyl-carrier-protein] reductase (NADPH) activity",
  "GO:0004317": "3-hydroxypalmitoyl-[acyl-carrier-protein] dehydratase activity",
  "GO:0004318": "enoyl-[acyl-carrier-protein] reductase (NADH) activity",
  "GO:0004319": "enoyl-[acyl-carrier-protein] reductase (NADPH, B-specific) activity",
  "GO:0004320": "oleoyl-[acyl-carrier-protein] hydrolase activity",
  "GO:0004321": "fatty-acyl-CoA synthase activity",
  "GO:0004322": "ferroxidase activity",
  "GO:0004323": "obsolete multicopper ferroxidase iron transport mediator activity",
  "GO:0004324": "ferredoxin-NADP+ reductase activity",
  "GO:0004325": "ferrochelatase activity",
  "GO:0004326": "tetrahydrofolylpolyglutamate synthase activity",
  "GO:0004327": "obsolete formaldehyde dehydrogenase (glutathione) activity",
  "GO:0004328": "formamidase activity",
  "GO:0004329": "formate-tetrahydrofolate ligase activity",
  "GO:0004331": "fructose-2,6-bisphosphate 2-phosphatase activity",
  "GO:0004332": "fructose-bisphosphate aldolase activity",
  "GO:0004333": "fumarate hydratase activity",
  "GO:0004334": "fumarylacetoacetase activity",
  "GO:0004335": "galactokinase activity",
  "GO:0004336": "galactosylceramidase activity",
  "GO:0004337": "geranyltranstransferase activity",
  "GO:0004338": "glucan exo-1,3-beta-glucosidase activity",
  "GO:0004339": "glucan 1,4-alpha-glucosidase activity",
  "GO:0004340": "glucokinase activity",
  "GO:0004341": "gluconolactonase activity",
  "GO:0004342": "glucosamine-6-phosphate deaminase activity",
  "GO:0004343": "glucosamine 6-phosphate N-acetyltransferase activity",
  "GO:0004344": "glucose dehydrogenase activity",
  "GO:0004345": "glucose-6-phosphate dehydrogenase activity",
  "GO:0004346": "glucose-6-phosphatase activity",
  "GO:0004347": "glucose-6-phosphate isomerase activity",
  "GO:0004348": "glucosylceramidase activity",
  "GO:0004349": "glutamate 5-kinase activity",
  "GO:0004350": "glutamate-5-semialdehyde dehydrogenase activity",
  "GO:0004351": "glutamate decarboxylase activity",
  "GO:0004352": "glutamate dehydrogenase (NAD+) activity",
  "GO:0004353": "glutamate dehydrogenase [NAD(P)+] activity",
  "GO:0004354": "glutamate dehydrogenase (NADP+) activity",
  "GO:0004355": "glutamate synthase (NADPH) activity",
  "GO:0004356": "glutamate-ammonia ligase activity",
  "GO:0004357": "glutamate-cysteine ligase activity",
  "GO:0004358": "glutamate N-acetyltransferase activity",
  "GO:0004359": "glutaminase activity",
  "GO:0004360": "glutamine-fructose-6-phosphate transaminase (isomerizing) activity",
  "GO:0004361": "glutaryl-CoA dehydrogenase activity",
  "GO:0004362": "glutathione-disulfide reductase activity",
  "GO:0004363": "glutathione synthase activity",
  "GO:0004364": "glutathione transferase activity",
  "GO:0004365": "glyceraldehyde-3-phosphate dehydrogenase (NAD+) (phosphorylating) activity",
  "GO:0004366": "glycerol-3-phosphate O-acyltransferase activity",
  "GO:0004367": "glycerol-3-phosphate dehydrogenase [NAD+] activity",
  "GO:0004368": "glycerol-3-phosphate dehydrogenase activity",
  "GO:0004369": "glycerol-3-phosphate oxidase activity",
  "GO:0004370": "glycerol kinase activity",
  "GO:0004371": "glycerone kinase activity",
  "GO:0004372": "glycine hydroxymethyltransferase activity",
  "GO:0004373": "glycogen (starch) synthase activity",
  "GO:0004374": "obsolete glycine cleavage system",
  "GO:0004375": "glycine dehydrogenase (decarboxylating) activity",
  "GO:0004376": "glycolipid mannosyltransferase activity",
  "GO:0004377": "GDP-Man:Man3GlcNAc2-PP-Dol alpha-1,2-mannosyltransferase activity",
  "GO:0004378": "GDP-Man:Man1GlcNAc2-PP-Dol alpha-1,3-mannosyltransferase activity",
  "GO:0004379": "glycylpeptide N-tetradecanoyltransferase activity",
  "GO:0004380": "glycoprotein-fucosylgalactoside alpha-N-acetylgalactosaminyltransferase activity",
  "GO:0004381": "fucosylgalactoside 3-alpha-galactosyltransferase activity",
  "GO:0004382": "guanosine-diphosphatase activity",
  "GO:0004383": "guanylate cyclase activity",
  "GO:0004384": "obsolete membrane-associated guanylate kinase",
  "GO:0004385": "guanylate kinase activity",
  "GO:0004386": "helicase activity",
  "GO:0004392": "heme oxygenase (decyclizing) activity",
  "GO:0004394": "heparan sulfate 2-O-sulfotransferase activity",
  "GO:0004395": "hexaprenyldihydroxybenzoate methyltransferase activity",
  "GO:0004396": "hexokinase activity",
  "GO:0004397": "histidine ammonia-lyase activity",
  "GO:0004398": "histidine decarboxylase activity",
  "GO:0004399": "histidinol dehydrogenase activity",
  "GO:0004400": "histidinol-phosphate transaminase activity",
  "GO:0004401": "histidinol-phosphatase activity",
  "GO:0004402": "histone acetyltransferase activity",
  "GO:0004407": "histone deacetylase activity",
  "GO:0004408": "holocytochrome-c synthase activity",
  "GO:0004409": "homoaconitate hydratase activity",
  "GO:0004410": "homocitrate synthase activity",
  "GO:0004411": "homogentisate 1,2-dioxygenase activity",
  "GO:0004412": "homoserine dehydrogenase activity",
  "GO:0004413": "homoserine kinase activity",
  "GO:0004414": "homoserine O-acetyltransferase activity",
  "GO:0004415": "hyalurononglucosaminidase activity",
  "GO:0004416": "hydroxyacylglutathione hydrolase activity",
  "GO:0004417": "hydroxyethylthiazole kinase activity",
  "GO:0004418": "hydroxymethylbilane synthase activity",
  "GO:0004419": "hydroxymethylglutaryl-CoA lyase activity",
  "GO:0004420": "hydroxymethylglutaryl-CoA reductase (NADPH) activity",
  "GO:0004421": "hydroxymethylglutaryl-CoA synthase activity",
  "GO:0004422": "hypoxanthine phosphoribosyltransferase activity",
  "GO:0004423": "iduronate-2-sulfatase activity",
  "GO:0004424": "imidazoleglycerol-phosphate dehydratase activity",
  "GO:0004425": "indole-3-glycerol-phosphate synthase activity",
  "GO:0004427": "inorganic diphosphatase activity",
  "GO:0004428": "obsolete inositol or phosphatidylinositol kinase activity",
  "GO:0004430": "1-phosphatidylinositol 4-kinase activity",
  "GO:0004432": "obsolete 1-phosphatidylinositol-4-phosphate kinase, class IA",
  "GO:0004433": "obsolete 1-phosphatidylinositol-4-phosphate kinase, class IB",
  "GO:0004435": "phosphatidylinositol phospholipase C activity",
  "GO:0004436": "phosphatidylinositol diacylglycerol-lyase activity",
  "GO:0004437": "obsolete inositol or phosphatidylinositol phosphatase activity",
  "GO:0004438": "phosphatidylinositol-3-phosphatase activity",
  "GO:0004439": "phosphatidylinositol-4,5-bisphosphate 5-phosphatase activity",
  "GO:0004441": "inositol-1,4-bisphosphate 1-phosphatase activity",
  "GO:0004442": "obsolete inositol-1,4,-bisphosphate 3-phosphatase",
  "GO:0004443": "obsolete inositol-1,4,-bisphosphate 4-phosphatase",
  "GO:0004444": "obsolete inositol-1,4,5-trisphosphate 1-phosphatase",
  "GO:0004445": "inositol-polyphosphate 5-phosphatase activity",
  "GO:0004446": "inositol-hexakisphosphate phosphatase activity",
  "GO:0004447": "iodide peroxidase activity",
  "GO:0004448": "isocitrate dehydrogenase activity",
  "GO:0004449": "isocitrate dehydrogenase (NAD+) activity",
  "GO:0004450": "isocitrate dehydrogenase (NADP+) activity",
  "GO:0004451": "isocitrate lyase activity",
  "GO:0004452": "isopentenyl-diphosphate delta-isomerase activity",
  "GO:0004453": "juvenile-hormone esterase activity",
  "GO:0004454": "ketohexokinase activity",
  "GO:0004455": "ketol-acid reductoisomerase activity",
  "GO:0004456": "phosphogluconate dehydratase activity",
  "GO:0004457": "lactate dehydrogenase activity",
  "GO:0004458": "D-lactate dehydrogenase (cytochrome) activity",
  "GO:0004459": "L-lactate dehydrogenase activity",
  "GO:0004460": "L-lactate dehydrogenase (cytochrome) activity",
  "GO:0004461": "lactose synthase activity",
  "GO:0004462": "lactoylglutathione lyase activity",
  "GO:0004463": "leukotriene-A4 hydrolase activity",
  "GO:0004464": "leukotriene-C4 synthase activity",
  "GO:0004465": "lipoprotein lipase activity",
  "GO:0004466": "long-chain-acyl-CoA dehydrogenase activity",
  "GO:0004467": "long-chain fatty acid-CoA ligase activity",
  "GO:0004468": "lysine N-acetyltransferase activity, acting on acetyl phosphate as donor",
  "GO:0004470": "malic enzyme activity",
  "GO:0004471": "malate dehydrogenase (decarboxylating) (NAD+) activity",
  "GO:0004473": "malate dehydrogenase (decarboxylating) (NADP+) activity",
  "GO:0004474": "malate synthase activity",
  "GO:0004475": "mannose-1-phosphate guanylyltransferase activity",
  "GO:0004476": "mannose-6-phosphate isomerase activity",
  "GO:0004477": "methenyltetrahydrofolate cyclohydrolase activity",
  "GO:0004478": "methionine adenosyltransferase activity",
  "GO:0004479": "methionyl-tRNA formyltransferase activity",
  "GO:0004481": "methylene-fatty-acyl-phospholipid synthase activity",
  "GO:0004482": "mRNA (guanine-N7-)-methyltransferase activity",
  "GO:0004483": "mRNA (nucleoside-2'-O-)-methyltransferase activity",
  "GO:0004484": "mRNA guanylyltransferase activity",
  "GO:0004485": "methylcrotonoyl-CoA carboxylase activity",
  "GO:0004486": "methylenetetrahydrofolate dehydrogenase [NAD(P)+] activity",
  "GO:0004487": "methylenetetrahydrofolate dehydrogenase (NAD+) activity",
  "GO:0004488": "methylenetetrahydrofolate dehydrogenase (NADP+) activity",
  "GO:0004489": "methylenetetrahydrofolate reductase (NAD(P)H) activity",
  "GO:0004490": "methylglutaconyl-CoA hydratase activity",
  "GO:0004491": "methylmalonate-semialdehyde dehydrogenase (acylating) activity",
  "GO:0004492": "methylmalonyl-CoA decarboxylase activity",
  "GO:0004493": "methylmalonyl-CoA epimerase activity",
  "GO:0004494": "methylmalonyl-CoA mutase activity",
  "GO:0004495": "mevaldate reductase activity",
  "GO:0004496": "mevalonate kinase activity",
  "GO:0004497": "monooxygenase activity",
  "GO:0004498": "calcidiol 1-monooxygenase activity",
  "GO:0004499": "N,N-dimethylaniline monooxygenase activity",
  "GO:0004500": "dopamine beta-monooxygenase activity",
  "GO:0004501": "ecdysone 20-monooxygenase activity",
  "GO:0004502": "kynurenine 3-monooxygenase activity",
  "GO:0004503": "monophenol monooxygenase activity",
  "GO:0004504": "peptidylglycine monooxygenase activity",
  "GO:0004505": "phenylalanine 4-monooxygenase activity",
  "GO:0004506": "squalene monooxygenase activity",
  "GO:0004507": "steroid 11-beta-monooxygenase activity",
  "GO:0004508": "steroid 17-alpha-monooxygenase activity",
  "GO:0004509": "steroid 21-monooxygenase activity",
  "GO:0004510": "tryptophan 5-monooxygenase activity",
  "GO:0004511": "tyrosine 3-monooxygenase activity",
  "GO:0004512": "inositol-3-phosphate synthase activity",
  "GO:0004513": "neolactotetraosylceramide alpha-2,3-sialyltransferase activity",
  "GO:0004514": "nicotinate-nucleotide diphosphorylase (carboxylating) activity",
  "GO:0004515": "nicotinate-nucleotide adenylyltransferase activity",
  "GO:0004516": "nicotinate phosphoribosyltransferase activity",
  "GO:0004517": "nitric-oxide synthase activity",
  "GO:0004518": "nuclease activity",
  "GO:0004519": "endonuclease activity",
  "GO:0004520": "endodeoxyribonuclease activity",
  "GO:0004521": "endoribonuclease activity",
  "GO:0004522": "ribonuclease A activity",
  "GO:0004523": "RNA-DNA hybrid ribonuclease activity",
  "GO:0004525": "ribonuclease III activity",
  "GO:0004526": "ribonuclease P activity",
  "GO:0004527": "exonuclease activity",
  "GO:0004528": "phosphodiesterase I activity",
  "GO:0004529": "exodeoxyribonuclease activity",
  "GO:0004530": "deoxyribonuclease I activity",
  "GO:0004531": "deoxyribonuclease II activity",
  "GO:0004532": "exoribonuclease activity",
  "GO:0004533": "exoribonuclease H activity",
  "GO:0004534": "5'-3' exoribonuclease activity",
  "GO:0004535": "poly(A)-specific ribonuclease activity",
  "GO:0004536": "deoxyribonuclease activity",
  "GO:0004540": "ribonuclease activity",
  "GO:0004549": "tRNA-specific ribonuclease activity",
  "GO:0004550": "nucleoside diphosphate kinase activity",
  "GO:0004551": "nucleotide diphosphatase activity",
  "GO:0004552": "octanol dehydrogenase activity",
  "GO:0004553": "hydrolase activity, hydrolyzing O-glycosyl compounds",
  "GO:0004555": "alpha,alpha-trehalase activity",
  "GO:0004556": "alpha-amylase activity",
  "GO:0004557": "alpha-galactosidase activity",
  "GO:0004558": "alpha-1,4-glucosidase activity",
  "GO:0004559": "alpha-mannosidase activity",
  "GO:0004560": "alpha-L-fucosidase activity",
  "GO:0004561": "alpha-N-acetylglucosaminidase activity",
  "GO:0004563": "beta-N-acetylhexosaminidase activity",
  "GO:0004564": "beta-fructofuranosidase activity",
  "GO:0004565": "beta-galactosidase activity",
  "GO:0004566": "beta-glucuronidase activity",
  "GO:0004567": "beta-mannosidase activity",
  "GO:0004568": "chitinase activity",
  "GO:0004569": "glycoprotein endo-alpha-1,2-mannosidase activity",
  "GO:0004571": "mannosyl-oligosaccharide 1,2-alpha-mannosidase activity",
  "GO:0004572": "mannosyl-oligosaccharide 1,3-1,6-alpha-mannosidase activity",
  "GO:0004573": "mannosyl-oligosaccharide glucosidase activity",
  "GO:0004574": "oligo-1,6-glucosidase activity",
  "GO:0004575": "sucrose alpha-glucosidase activity",
  "GO:0004576": "oligosaccharyl transferase activity",
  "GO:0004577": "N-acetylglucosaminyldiphosphodolichol N-acetylglucosaminyltransferase activity",
  "GO:0004578": "chitobiosyldiphosphodolichol beta-mannosyltransferase activity",
  "GO:0004579": "dolichyl-diphosphooligosaccharide-protein glycotransferase activity",
  "GO:0004581": "dolichyl-phosphate beta-glucosyltransferase activity",
  "GO:0004582": "dolichyl-phosphate beta-D-mannosyltransferase activity",
  "GO:0004583": "dolichyl-phosphate-glucose-glycolipid alpha-glucosyltransferase activity",
  "GO:0004584": "dolichyl-phosphate-mannose-glycolipid alpha-mannosyltransferase activity",
  "GO:0004585": "ornithine carbamoyltransferase activity",
  "GO:0004586": "ornithine decarboxylase activity",
  "GO:0004587": "ornithine-oxo-acid transaminase activity",
  "GO:0004588": "orotate phosphoribosyltransferase activity",
  "GO:0004589": "orotate reductase (NADH) activity",
  "GO:0004590": "orotidine-5'-phosphate decarboxylase activity",
  "GO:0004591": "oxoglutarate dehydrogenase (succinyl-transferring) activity",
  "GO:0004592": "pantoate-beta-alanine ligase activity",
  "GO:0004593": "pantothenase activity",
  "GO:0004594": "pantothenate kinase activity",
  "GO:0004595": "pantetheine-phosphate adenylyltransferase activity",
  "GO:0004596": "peptide alpha-N-acetyltransferase activity",
  "GO:0004597": "peptide-aspartate beta-dioxygenase activity",
  "GO:0004598": "peptidylamidoglycolate lyase activity",
  "GO:0004600": "obsolete cyclophilin",
  "GO:0004601": "peroxidase activity",
  "GO:0004602": "glutathione peroxidase activity",
  "GO:0004603": "phenylethanolamine N-methyltransferase activity",
  "GO:0004604": "phosphoadenylyl-sulfate reductase (thioredoxin) activity",
  "GO:0004605": "phosphatidate cytidylyltransferase activity",
  "GO:0004607": "phosphatidylcholine-sterol O-acyltransferase activity",
  "GO:0004608": "phosphatidylethanolamine N-methyltransferase activity",
  "GO:0004609": "phosphatidylserine decarboxylase activity",
  "GO:0004610": "phosphoacetylglucosamine mutase activity",
  "GO:0004611": "phosphoenolpyruvate carboxykinase activity",
  "GO:0004612": "phosphoenolpyruvate carboxykinase (ATP) activity",
  "GO:0004613": "phosphoenolpyruvate carboxykinase (GTP) activity",
  "GO:0004614": "phosphoglucomutase activity",
  "GO:0004615": "phosphomannomutase activity",
  "GO:0004616": "phosphogluconate dehydrogenase (decarboxylating) activity",
  "GO:0004617": "phosphoglycerate dehydrogenase activity",
  "GO:0004618": "phosphoglycerate kinase activity",
  "GO:0004619": "phosphoglycerate mutase activity",
  "GO:0004620": "phospholipase activity",
  "GO:0004621": "glycosylphosphatidylinositol phospholipase D activity",
  "GO:0004622": "lysophospholipase activity",
  "GO:0004623": "phospholipase A2 activity",
  "GO:0004624": "obsolete secreted phospholipase A2 activity",
  "GO:0004625": "obsolete calcium-dependent secreted phospholipase A2 activity",
  "GO:0004626": "obsolete cytosolic phospholipase A2 activity",
  "GO:0004627": "obsolete calcium-dependent cytosolic phospholipase A2 activity",
  "GO:0004628": "obsolete calcium-independent cytosolic phospholipase A2 activity",
  "GO:0004629": "phospholipase C activity",
  "GO:0004630": "phospholipase D activity",
  "GO:0004631": "phosphomevalonate kinase activity",
  "GO:0004632": "phosphopantothenate--cysteine ligase activity",
  "GO:0004633": "phosphopantothenoylcysteine decarboxylase activity",
  "GO:0004634": "phosphopyruvate hydratase activity",
  "GO:0004635": "phosphoribosyl-AMP cyclohydrolase activity",
  "GO:0004636": "phosphoribosyl-ATP diphosphatase activity",
  "GO:0004637": "phosphoribosylamine-glycine ligase activity",
  "GO:0004638": "phosphoribosylaminoimidazole carboxylase activity",
  "GO:0004639": "phosphoribosylaminoimidazolesuccinocarboxamide synthase activity",
  "GO:0004640": "phosphoribosylanthranilate isomerase activity",
  "GO:0004641": "phosphoribosylformylglycinamidine cyclo-ligase activity",
  "GO:0004642": "phosphoribosylformylglycinamidine synthase activity",
  "GO:0004643": "phosphoribosylaminoimidazolecarboxamide formyltransferase activity",
  "GO:0004644": "phosphoribosylglycinamide formyltransferase activity",
  "GO:0004645": "phosphorylase activity",
  "GO:0004647": "phosphoserine phosphatase activity",
  "GO:0004648": "O-phospho-L-serine:2-oxoglutarate aminotransferase activity",
  "GO:0004649": "poly(ADP-ribose) glycohydrolase activity",
  "GO:0004650": "polygalacturonase activity",
  "GO:0004651": "polynucleotide 5'-phosphatase activity",
  "GO:0004652": "polynucleotide adenylyltransferase activity",
  "GO:0004653": "polypeptide N-acetylgalactosaminyltransferase activity",
  "GO:0004654": "polyribonucleotide nucleotidyltransferase activity",
  "GO:0004655": "porphobilinogen synthase activity",
  "GO:0004656": "procollagen-proline 4-dioxygenase activity",
  "GO:0004657": "proline dehydrogenase activity",
  "GO:0004658": "propionyl-CoA carboxylase activity",
  "GO:0004659": "prenyltransferase activity",
  "GO:0004660": "protein farnesyltransferase activity",
  "GO:0004661": "protein geranylgeranyltransferase activity",
  "GO:0004662": "CAAX-protein geranylgeranyltransferase activity",
  "GO:0004663": "Rab geranylgeranyltransferase activity",
  "GO:0004664": "prephenate dehydratase activity",
  "GO:0004665": "prephenate dehydrogenase (NADP+) activity",
  "GO:0004666": "prostaglandin-endoperoxide synthase activity",
  "GO:0004667": "prostaglandin-D synthase activity",
  "GO:0004668": "protein-arginine deiminase activity",
  "GO:0004671": "protein C-terminal S-isoprenylcysteine carboxyl O-methyltransferase activity",
  "GO:0004672": "protein kinase activity",
  "GO:0004673": "protein histidine kinase activity",
  "GO:0004674": "protein serine/threonine kinase activity",
  "GO:0004675": "transmembrane receptor protein serine/threonine kinase activity",
  "GO:0004676": "3-phosphoinositide-dependent protein kinase activity",
  "GO:0004677": "DNA-dependent protein kinase activity",
  "GO:0004679": "AMP-activated protein kinase activity",
  "GO:0004680": "obsolete casein kinase activity",
  "GO:0004681": "obsolete casein kinase I activity",
  "GO:0004682": "obsolete protein kinase CK2 activity",
  "GO:0004683": "calmodulin-dependent protein kinase activity",
  "GO:0004686": "elongation factor-2 kinase activity",
  "GO:0004687": "myosin light chain kinase activity",
  "GO:0004689": "phosphorylase kinase activity",
  "GO:0004690": "cyclic nucleotide-dependent protein kinase activity",
  "GO:0004691": "cAMP-dependent protein kinase activity",
  "GO:0004692": "cGMP-dependent protein kinase activity",
  "GO:0004693": "cyclin-dependent protein serine/threonine kinase activity",
  "GO:0004694": "eukaryotic translation initiation factor 2alpha kinase activity",
  "GO:0004697": "protein kinase C activity",
  "GO:0004698": "calcium-dependent protein kinase C activity",
  "GO:0004699": "calcium-independent protein kinase C activity",
  "GO:0004702": "receptor signaling protein serine/threonine kinase activity",
  "GO:0004703": "G-protein coupled receptor kinase activity",
  "GO:0004704": "NF-kappaB-inducing kinase activity",
  "GO:0004705": "JUN kinase activity",
  "GO:0004706": "JUN kinase kinase kinase activity",
  "GO:0004707": "MAP kinase activity",
  "GO:0004708": "MAP kinase kinase activity",
  "GO:0004709": "MAP kinase kinase kinase activity",
  "GO:0004711": "ribosomal protein S6 kinase activity",
  "GO:0004712": "protein serine/threonine/tyrosine kinase activity",
  "GO:0004713": "protein tyrosine kinase activity",
  "GO:0004714": "transmembrane receptor protein tyrosine kinase activity",
  "GO:0004715": "non-membrane spanning protein tyrosine kinase activity",
  "GO:0004716": "receptor signaling protein tyrosine kinase activity",
  "GO:0004717": "obsolete focal adhesion kinase activity",
  "GO:0004719": "protein-L-isoaspartate (D-aspartate) O-methyltransferase activity",
  "GO:0004720": "protein-lysine 6-oxidase activity",
  "GO:0004721": "phosphoprotein phosphatase activity",
  "GO:0004722": "protein serine/threonine phosphatase activity",
  "GO:0004723": "calcium-dependent protein serine/threonine phosphatase activity",
  "GO:0004724": "magnesium-dependent protein serine/threonine phosphatase activity",
  "GO:0004725": "protein tyrosine phosphatase activity",
  "GO:0004726": "non-membrane spanning protein tyrosine phosphatase activity",
  "GO:0004727": "prenylated protein tyrosine phosphatase activity",
  "GO:0004728": "receptor signaling protein tyrosine phosphatase activity",
  "GO:0004729": "oxygen-dependent protoporphyrinogen oxidase activity",
  "GO:0004730": "pseudouridylate synthase activity",
  "GO:0004731": "purine-nucleoside phosphorylase activity",
  "GO:0004732": "pyridoxal oxidase activity",
  "GO:0004733": "pyridoxamine-phosphate oxidase activity",
  "GO:0004734": "pyrimidodiazepine synthase activity",
  "GO:0004735": "pyrroline-5-carboxylate reductase activity",
  "GO:0004736": "pyruvate carboxylase activity",
  "GO:0004737": "pyruvate decarboxylase activity",
  "GO:0004738": "pyruvate dehydrogenase activity",
  "GO:0004739": "pyruvate dehydrogenase (acetyl-transferring) activity",
  "GO:0004740": "pyruvate dehydrogenase (acetyl-transferring) kinase activity",
  "GO:0004741": "[pyruvate dehydrogenase (lipoamide)] phosphatase activity",
  "GO:0004742": "dihydrolipoyllysine-residue acetyltransferase activity",
  "GO:0004743": "pyruvate kinase activity",
  "GO:0004744": "retinal isomerase activity",
  "GO:0004745": "retinol dehydrogenase activity",
  "GO:0004746": "riboflavin synthase activity",
  "GO:0004747": "ribokinase activity",
  "GO:0004748": "ribonucleoside-diphosphate reductase activity, thioredoxin disulfide as acceptor",
  "GO:0004749": "ribose phosphate diphosphokinase activity",
  "GO:0004750": "ribulose-phosphate 3-epimerase activity",
  "GO:0004751": "ribose-5-phosphate isomerase activity",
  "GO:0004753": "saccharopine dehydrogenase activity",
  "GO:0004754": "saccharopine dehydrogenase (NAD+, L-lysine-forming) activity",
  "GO:0004755": "saccharopine dehydrogenase (NADP+, L-glutamate-forming) activity",
  "GO:0004756": "selenide, water dikinase activity",
  "GO:0004757": "sepiapterin reductase activity",
  "GO:0004758": "serine C-palmitoyltransferase activity",
  "GO:0004760": "serine-pyruvate transaminase activity",
  "GO:0004764": "shikimate 3-dehydrogenase (NADP+) activity",
  "GO:0004765": "shikimate kinase activity",
  "GO:0004766": "spermidine synthase activity",
  "GO:0004767": "sphingomyelin phosphodiesterase activity",
  "GO:0004768": "stearoyl-CoA 9-desaturase activity",
  "GO:0004769": "steroid delta-isomerase activity",
  "GO:0004771": "sterol esterase activity",
  "GO:0004772": "sterol O-acyltransferase activity",
  "GO:0004773": "steryl-sulfatase activity",
  "GO:0004774": "succinate-CoA ligase activity",
  "GO:0004775": "succinate-CoA ligase (ADP-forming) activity",
  "GO:0004776": "succinate-CoA ligase (GDP-forming) activity",
  "GO:0004777": "succinate-semialdehyde dehydrogenase (NAD+) activity",
  "GO:0004778": "succinyl-CoA hydrolase activity",
  "GO:0004779": "sulfate adenylyltransferase activity",
  "GO:0004780": "sulfate adenylyltransferase (ADP) activity",
  "GO:0004781": "sulfate adenylyltransferase (ATP) activity",
  "GO:0004782": "sulfinoalanine decarboxylase activity",
  "GO:0004783": "sulfite reductase (NADPH) activity",
  "GO:0004784": "superoxide dismutase activity",
  "GO:0004786": "obsolete Mn, Fe superoxide dismutase",
  "GO:0004787": "thiamine-pyrophosphatase activity",
  "GO:0004788": "thiamine diphosphokinase activity",
  "GO:0004789": "thiamine-phosphate diphosphorylase activity",
  "GO:0004790": "thioether S-methyltransferase activity",
  "GO:0004791": "thioredoxin-disulfide reductase activity",
  "GO:0004792": "thiosulfate sulfurtransferase activity",
  "GO:0004793": "threonine aldolase activity",
  "GO:0004794": "L-threonine ammonia-lyase activity",
  "GO:0004795": "threonine synthase activity",
  "GO:0004796": "thromboxane-A synthase activity",
  "GO:0004797": "thymidine kinase activity",
  "GO:0004798": "thymidylate kinase activity",
  "GO:0004799": "thymidylate synthase activity",
  "GO:0004800": "thyroxine 5'-deiodinase activity",
  "GO:0004801": "sedoheptulose-7-phosphate:D-glyceraldehyde-3-phosphate glyceronetransferase activity",
  "GO:0004802": "transketolase activity",
  "GO:0004803": "transposase activity",
  "GO:0004805": "trehalose-phosphatase activity",
  "GO:0004806": "triglyceride lipase activity",
  "GO:0004807": "triose-phosphate isomerase activity",
  "GO:0004808": "tRNA (5-methylaminomethyl-2-thiouridylate)-methyltransferase activity",
  "GO:0004809": "tRNA (guanine-N2-)-methyltransferase activity",
  "GO:0004810": "tRNA adenylyltransferase activity",
  "GO:0004812": "aminoacyl-tRNA ligase activity",
  "GO:0004813": "alanine-tRNA ligase activity",
  "GO:0004814": "arginine-tRNA ligase activity",
  "GO:0004815": "aspartate-tRNA ligase activity",
  "GO:0004816": "asparagine-tRNA ligase activity",
  "GO:0004817": "cysteine-tRNA ligase activity",
  "GO:0004818": "glutamate-tRNA ligase activity",
  "GO:0004819": "glutamine-tRNA ligase activity",
  "GO:0004820": "glycine-tRNA ligase activity",
  "GO:0004821": "histidine-tRNA ligase activity",
  "GO:0004822": "isoleucine-tRNA ligase activity",
  "GO:0004823": "leucine-tRNA ligase activity",
  "GO:0004824": "lysine-tRNA ligase activity",
  "GO:0004825": "methionine-tRNA ligase activity",
  "GO:0004826": "phenylalanine-tRNA ligase activity",
  "GO:0004827": "proline-tRNA ligase activity",
  "GO:0004828": "serine-tRNA ligase activity",
  "GO:0004829": "threonine-tRNA ligase activity",
  "GO:0004830": "tryptophan-tRNA ligase activity",
  "GO:0004831": "tyrosine-tRNA ligase activity",
  "GO:0004832": "valine-tRNA ligase activity",
  "GO:0004833": "tryptophan 2,3-dioxygenase activity",
  "GO:0004834": "tryptophan synthase activity",
  "GO:0004835": "tubulin-tyrosine ligase activity",
  "GO:0004836": "tyramine-beta hydroxylase activity",
  "GO:0004837": "tyrosine decarboxylase activity",
  "GO:0004838": "L-tyrosine:2-oxoglutarate aminotransferase activity",
  "GO:0004839": "ubiquitin activating enzyme activity",
  "GO:0004842": "ubiquitin-protein transferase activity",
  "GO:0004843": "thiol-dependent ubiquitin-specific protease activity",
  "GO:0004844": "uracil DNA N-glycosylase activity",
  "GO:0004845": "uracil phosphoribosyltransferase activity",
  "GO:0004846": "urate oxidase activity",
  "GO:0004847": "urea carboxylase activity",
  "GO:0004848": "ureidoglycolate hydrolase activity",
  "GO:0004849": "uridine kinase activity",
  "GO:0004850": "uridine phosphorylase activity",
  "GO:0004851": "uroporphyrin-III C-methyltransferase activity",
  "GO:0004852": "uroporphyrinogen-III synthase activity",
  "GO:0004853": "uroporphyrinogen decarboxylase activity",
  "GO:0004854": "xanthine dehydrogenase activity",
  "GO:0004855": "xanthine oxidase activity",
  "GO:0004856": "xylulokinase activity",
  "GO:0004857": "enzyme inhibitor activity",
  "GO:0004858": "dUTP pyrophosphatase inhibitor activity",
  "GO:0004859": "phospholipase inhibitor activity",
  "GO:0004860": "protein kinase inhibitor activity",
  "GO:0004861": "cyclin-dependent protein serine/threonine kinase inhibitor activity",
  "GO:0004862": "cAMP-dependent protein kinase inhibitor activity",
  "GO:0004864": "protein phosphatase inhibitor activity",
  "GO:0004865": "protein serine/threonine phosphatase inhibitor activity",
  "GO:0004866": "endopeptidase inhibitor activity",
  "GO:0004867": "serine-type endopeptidase inhibitor activity",
  "GO:0004868": "obsolete serpin",
  "GO:0004869": "cysteine-type endopeptidase inhibitor activity",
  "GO:0004871": "signal transducer activity",
  "GO:0004872": "receptor activity",
  "GO:0004873": "asialoglycoprotein receptor activity",
  "GO:0004874": "aryl hydrocarbon receptor activity",
  "GO:0004875": "complement receptor activity",
  "GO:0004876": "complement component C3a receptor activity",
  "GO:0004877": "complement component C3b receptor activity",
  "GO:0004878": "complement component C5a receptor activity",
  "GO:0004879": "RNA polymerase II transcription factor activity, ligand-activated sequence-specific DNA binding",
  "GO:0004880": "juvenile hormone receptor activity",
  "GO:0004882": "androgen receptor activity",
  "GO:0004883": "glucocorticoid receptor activity",
  "GO:0004884": "ecdysteroid hormone receptor activity",
  "GO:0004886": "9-cis retinoic acid receptor activity",
  "GO:0004887": "thyroid hormone receptor activity",
  "GO:0004888": "transmembrane signaling receptor activity",
  "GO:0004889": "acetylcholine-activated cation-selective channel activity",
  "GO:0004890": "GABA-A receptor activity",
  "GO:0004892": "obsolete B cell receptor activity",
  "GO:0004894": "obsolete T cell receptor activity",
  "GO:0004895": "obsolete cell adhesion receptor activity",
  "GO:0004896": "cytokine receptor activity",
  "GO:0004897": "ciliary neurotrophic factor receptor activity",
  "GO:0004898": "obsolete gp130",
  "GO:0004900": "erythropoietin receptor activity",
  "GO:0004901": "granulocyte macrophage colony-stimulating factor receptor activity",
  "GO:0004902": "granulocyte colony-stimulating factor receptor activity",
  "GO:0004903": "growth hormone receptor activity",
  "GO:0004904": "interferon receptor activity",
  "GO:0004905": "type I interferon receptor activity",
  "GO:0004906": "interferon-gamma receptor activity",
  "GO:0004908": "interleukin-1 receptor activity",
  "GO:0004909": "interleukin-1, Type I, activating receptor activity",
  "GO:0004910": "interleukin-1, Type II, blocking receptor activity",
  "GO:0004911": "interleukin-2 receptor activity",
  "GO:0004912": "interleukin-3 receptor activity",
  "GO:0004913": "interleukin-4 receptor activity",
  "GO:0004914": "interleukin-5 receptor activity",
  "GO:0004915": "interleukin-6 receptor activity",
  "GO:0004917": "interleukin-7 receptor activity",
  "GO:0004918": "interleukin-8 receptor activity",
  "GO:0004919": "interleukin-9 receptor activity",
  "GO:0004920": "interleukin-10 receptor activity",
  "GO:0004921": "interleukin-11 receptor activity",
  "GO:0004923": "leukemia inhibitory factor receptor activity",
  "GO:0004924": "oncostatin-M receptor activity",
  "GO:0004925": "prolactin receptor activity",
  "GO:0004927": "obsolete sevenless receptor activity",
  "GO:0004928": "obsolete frizzled receptor activity",
  "GO:0004929": "obsolete frizzled-2 receptor activity",
  "GO:0004930": "G-protein coupled receptor activity",
  "GO:0004931": "extracellular ATP-gated cation channel activity",
  "GO:0004932": "mating-type factor pheromone receptor activity",
  "GO:0004933": "mating-type a-factor pheromone receptor activity",
  "GO:0004934": "mating-type alpha-factor pheromone receptor activity",
  "GO:0004935": "adrenergic receptor activity",
  "GO:0004936": "alpha-adrenergic receptor activity",
  "GO:0004937": "alpha1-adrenergic receptor activity",
  "GO:0004938": "alpha2-adrenergic receptor activity",
  "GO:0004939": "beta-adrenergic receptor activity",
  "GO:0004940": "beta1-adrenergic receptor activity",
  "GO:0004941": "beta2-adrenergic receptor activity",
  "GO:0004942": "anaphylatoxin receptor activity",
  "GO:0004943": "C3a anaphylatoxin receptor activity",
  "GO:0004944": "C5a anaphylatoxin receptor activity",
  "GO:0004945": "angiotensin type II receptor activity",
  "GO:0004946": "bombesin receptor activity",
  "GO:0004947": "bradykinin receptor activity",
  "GO:0004948": "calcitonin receptor activity",
  "GO:0004949": "cannabinoid receptor activity",
  "GO:0004950": "chemokine receptor activity",
  "GO:0004951": "cholecystokinin receptor activity",
  "GO:0004952": "dopamine neurotransmitter receptor activity",
  "GO:0004953": "icosanoid receptor activity",
  "GO:0004954": "prostanoid receptor activity",
  "GO:0004955": "prostaglandin receptor activity",
  "GO:0004956": "prostaglandin D receptor activity",
  "GO:0004957": "prostaglandin E receptor activity",
  "GO:0004958": "prostaglandin F receptor activity",
  "GO:0004960": "thromboxane receptor activity",
  "GO:0004961": "thromboxane A2 receptor activity",
  "GO:0004962": "endothelin receptor activity",
  "GO:0004963": "follicle-stimulating hormone receptor activity",
  "GO:0004964": "luteinizing hormone receptor activity",
  "GO:0004965": "G-protein coupled GABA receptor activity",
  "GO:0004966": "galanin receptor activity",
  "GO:0004967": "glucagon receptor activity",
  "GO:0004968": "gonadotropin-releasing hormone receptor activity",
  "GO:0004969": "histamine receptor activity",
  "GO:0004970": "ionotropic glutamate receptor activity",
  "GO:0004971": "AMPA glutamate receptor activity",
  "GO:0004972": "NMDA glutamate receptor activity",
  "GO:0004973": "obsolete N-methyl-D-aspartate receptor-associated protein activity",
  "GO:0004974": "leukotriene receptor activity",
  "GO:0004977": "melanocortin receptor activity",
  "GO:0004978": "corticotropin receptor activity",
  "GO:0004979": "beta-endorphin receptor activity",
  "GO:0004980": "melanocyte-stimulating hormone receptor activity",
  "GO:0004982": "N-formyl peptide receptor activity",
  "GO:0004983": "neuropeptide Y receptor activity",
  "GO:0004984": "olfactory receptor activity",
  "GO:0004985": "opioid receptor activity",
  "GO:0004986": "obsolete delta-opioid receptor activity",
  "GO:0004987": "obsolete kappa-opioid receptor activity",
  "GO:0004988": "obsolete mu-opioid receptor activity",
  "GO:0004989": "octopamine receptor activity",
  "GO:0004990": "oxytocin receptor activity",
  "GO:0004991": "parathyroid hormone receptor activity",
  "GO:0004992": "platelet activating factor receptor activity",
  "GO:0004993": "G-protein coupled serotonin receptor activity",
  "GO:0004994": "somatostatin receptor activity",
  "GO:0004995": "tachykinin receptor activity",
  "GO:0004996": "thyroid-stimulating hormone receptor activity",
  "GO:0004997": "thyrotropin-releasing hormone receptor activity",
  "GO:0004998": "transferrin receptor activity",
  "GO:0004999": "vasoactive intestinal polypeptide receptor activity",
  "GO:0005000": "vasopressin receptor activity",
  "GO:0005001": "transmembrane receptor protein tyrosine phosphatase activity",
  "GO:0005003": "ephrin receptor activity",
  "GO:0005004": "GPI-linked ephrin receptor activity",
  "GO:0005005": "transmembrane-ephrin receptor activity",
  "GO:0005006": "epidermal growth factor-activated receptor activity",
  "GO:0005007": "fibroblast growth factor-activated receptor activity",
  "GO:0005008": "hepatocyte growth factor-activated receptor activity",
  "GO:0005009": "insulin-activated receptor activity",
  "GO:0005010": "insulin-like growth factor-activated receptor activity",
  "GO:0005011": "macrophage colony-stimulating factor receptor activity",
  "GO:0005012": "obsolete Neu/ErbB-2 receptor activity",
  "GO:0005013": "obsolete neurotrophin TRK receptor activity",
  "GO:0005014": "obsolete neurotrophin TRKA receptor activity",
  "GO:0005015": "obsolete neurotrophin TRKB receptor activity",
  "GO:0005016": "obsolete neurotrophin TRKC receptor activity",
  "GO:0005017": "platelet-derived growth factor-activated receptor activity",
  "GO:0005018": "platelet-derived growth factor alpha-receptor activity",
  "GO:0005019": "platelet-derived growth factor beta-receptor activity",
  "GO:0005020": "stem cell factor receptor activity",
  "GO:0005021": "vascular endothelial growth factor-activated receptor activity",
  "GO:0005024": "transforming growth factor beta-activated receptor activity",
  "GO:0005025": "transforming growth factor beta receptor activity, type I",
  "GO:0005026": "transforming growth factor beta receptor activity, type II",
  "GO:0005027": "obsolete NGF/TNF (6 C-domain) receptor activity",
  "GO:0005028": "obsolete CD40 receptor activity",
  "GO:0005029": "obsolete CD27 receptor activity",
  "GO:0005030": "neurotrophin receptor activity",
  "GO:0005031": "tumor necrosis factor-activated receptor activity",
  "GO:0005034": "osmosensor activity",
  "GO:0005035": "death receptor activity",
  "GO:0005037": "obsolete death receptor adaptor protein activity",
  "GO:0005038": "obsolete death receptor interacting protein activity",
  "GO:0005039": "obsolete death receptor-associated factor activity",
  "GO:0005040": "decoy death receptor activity",
  "GO:0005041": "low-density lipoprotein receptor activity",
  "GO:0005042": "netrin receptor activity",
  "GO:0005043": "netrin receptor activity involved in chemorepulsion",
  "GO:0005044": "scavenger receptor activity",
  "GO:0005045": "obsolete endoplasmic reticulum receptor activity",
  "GO:0005046": "KDEL sequence binding",
  "GO:0005047": "signal recognition particle binding",
  "GO:0005048": "signal sequence binding",
  "GO:0005049": "nuclear export signal receptor activity",
  "GO:0005050": "obsolete peroxisome receptor",
  "GO:0005052": "peroxisome matrix targeting signal-1 binding",
  "GO:0005053": "peroxisome matrix targeting signal-2 binding",
  "GO:0005054": "obsolete peroxisome integral membrane receptor",
  "GO:0005055": "laminin receptor activity",
  "GO:0005056": "tiggrin receptor activity",
  "GO:0005057": "receptor signaling protein activity",
  "GO:0005061": "obsolete aryl hydrocarbon receptor nuclear translocator activity",
  "GO:0005065": "obsolete heterotrimeric G-protein",
  "GO:0005066": "obsolete transmembrane receptor protein tyrosine kinase signaling protein activity",
  "GO:0005068": "transmembrane receptor protein tyrosine kinase adaptor activity",
  "GO:0005070": "SH3/SH2 adaptor activity",
  "GO:0005071": "obsolete transmembrane receptor protein serine/threonine kinase signaling protein activity",
  "GO:0005072": "transforming growth factor beta receptor, cytoplasmic mediator activity",
  "GO:0005073": "obsolete common-partner SMAD protein",
  "GO:0005074": "obsolete inhibitory SMAD protein",
  "GO:0005075": "obsolete pathway-specific SMAD protein",
  "GO:0005076": "obsolete receptor signaling protein serine/threonine kinase signaling protein activity",
  "GO:0005077": "obsolete MAP-kinase anchoring activity",
  "GO:0005078": "MAP-kinase scaffold activity",
  "GO:0005079": "obsolete protein kinase A anchoring activity",
  "GO:0005080": "protein kinase C binding",
  "GO:0005081": "obsolete receptor signaling protein serine/threonine phosphatase signaling protein activity",
  "GO:0005082": "obsolete receptor signaling protein tyrosine phosphatase signaling protein activity",
  "GO:0005085": "guanyl-nucleotide exchange factor activity",
  "GO:0005086": "ARF guanyl-nucleotide exchange factor activity",
  "GO:0005087": "Ran guanyl-nucleotide exchange factor activity",
  "GO:0005088": "Ras guanyl-nucleotide exchange factor activity",
  "GO:0005089": "Rho guanyl-nucleotide exchange factor activity",
  "GO:0005090": "Sar guanyl-nucleotide exchange factor activity",
  "GO:0005091": "guanyl-nucleotide exchange factor adaptor activity",
  "GO:0005092": "GDP-dissociation inhibitor activity",
  "GO:0005093": "Rab GDP-dissociation inhibitor activity",
  "GO:0005094": "Rho GDP-dissociation inhibitor activity",
  "GO:0005095": "GTPase inhibitor activity",
  "GO:0005096": "GTPase activator activity",
  "GO:0005102": "receptor binding",
  "GO:0005104": "fibroblast growth factor receptor binding",
  "GO:0005105": "type 1 fibroblast growth factor receptor binding",
  "GO:0005106": "obsolete ephrin",
  "GO:0005107": "obsolete GPI-linked ephrin",
  "GO:0005108": "obsolete transmembrane ephrin",
  "GO:0005109": "frizzled binding",
  "GO:0005110": "frizzled-2 binding",
  "GO:0005111": "type 2 fibroblast growth factor receptor binding",
  "GO:0005112": "Notch binding",
  "GO:0005113": "patched binding",
  "GO:0005114": "type II transforming growth factor beta receptor binding",
  "GO:0005115": "receptor tyrosine kinase-like orphan receptor binding",
  "GO:0005117": "wishful thinking binding",
  "GO:0005118": "sevenless binding",
  "GO:0005119": "smoothened binding",
  "GO:0005121": "Toll binding",
  "GO:0005122": "torso binding",
  "GO:0005123": "death receptor binding",
  "GO:0005124": "scavenger receptor binding",
  "GO:0005125": "cytokine activity",
  "GO:0005126": "cytokine receptor binding",
  "GO:0005127": "ciliary neurotrophic factor receptor binding",
  "GO:0005128": "erythropoietin receptor binding",
  "GO:0005129": "granulocyte macrophage colony-stimulating factor receptor binding",
  "GO:0005130": "granulocyte colony-stimulating factor receptor binding",
  "GO:0005131": "growth hormone receptor binding",
  "GO:0005132": "type I interferon receptor binding",
  "GO:0005133": "interferon-gamma receptor binding",
  "GO:0005134": "interleukin-2 receptor binding",
  "GO:0005135": "interleukin-3 receptor binding",
  "GO:0005136": "interleukin-4 receptor binding",
  "GO:0005137": "interleukin-5 receptor binding",
  "GO:0005138": "interleukin-6 receptor binding",
  "GO:0005139": "interleukin-7 receptor binding",
  "GO:0005140": "interleukin-9 receptor binding",
  "GO:0005141": "interleukin-10 receptor binding",
  "GO:0005142": "interleukin-11 receptor binding",
  "GO:0005143": "interleukin-12 receptor binding",
  "GO:0005144": "interleukin-13 receptor binding",
  "GO:0005145": "interleukin-14 receptor binding",
  "GO:0005146": "leukemia inhibitory factor receptor binding",
  "GO:0005147": "oncostatin-M receptor binding",
  "GO:0005148": "prolactin receptor binding",
  "GO:0005149": "interleukin-1 receptor binding",
  "GO:0005150": "interleukin-1, Type I receptor binding",
  "GO:0005151": "interleukin-1, Type II receptor binding",
  "GO:0005152": "interleukin-1 receptor antagonist activity",
  "GO:0005153": "interleukin-8 receptor binding",
  "GO:0005154": "epidermal growth factor receptor binding",
  "GO:0005155": "obsolete epidermal growth factor receptor activating ligand activity",
  "GO:0005156": "obsolete epidermal growth factor receptor inhibiting ligand activity",
  "GO:0005157": "macrophage colony-stimulating factor receptor binding",
  "GO:0005158": "insulin receptor binding",
  "GO:0005159": "insulin-like growth factor receptor binding",
  "GO:0005160": "transforming growth factor beta receptor binding",
  "GO:0005161": "platelet-derived growth factor receptor binding",
  "GO:0005163": "nerve growth factor receptor binding",
  "GO:0005164": "tumor necrosis factor receptor binding",
  "GO:0005165": "neurotrophin receptor binding",
  "GO:0005166": "neurotrophin p75 receptor binding",
  "GO:0005167": "neurotrophin TRK receptor binding",
  "GO:0005168": "neurotrophin TRKA receptor binding",
  "GO:0005169": "neurotrophin TRKB receptor binding",
  "GO:0005170": "neurotrophin TRKC receptor binding",
  "GO:0005171": "hepatocyte growth factor receptor binding",
  "GO:0005172": "vascular endothelial growth factor receptor binding",
  "GO:0005173": "stem cell factor receptor binding",
  "GO:0005174": "CD40 receptor binding",
  "GO:0005175": "CD27 receptor binding",
  "GO:0005176": "ErbB-2 class receptor binding",
  "GO:0005177": "obsolete neuroligin",
  "GO:0005178": "integrin binding",
  "GO:0005179": "hormone activity",
  "GO:0005180": "obsolete peptide hormone",
  "GO:0005181": "obsolete glycopeptide hormone",
  "GO:0005182": "obsolete lipopeptide hormone",
  "GO:0005183": "gonadotropin hormone-releasing hormone activity",
  "GO:0005184": "neuropeptide hormone activity",
  "GO:0005185": "neurohypophyseal hormone activity",
  "GO:0005186": "pheromone activity",
  "GO:0005187": "obsolete storage protein",
  "GO:0005188": "obsolete larval serum protein (sensu Insecta)",
  "GO:0005189": "obsolete milk protein",
  "GO:0005190": "obsolete seminal fluid protein",
  "GO:0005191": "obsolete acidic epididymal glycoprotein",
  "GO:0005192": "obsolete urinary protein",
  "GO:0005193": "obsolete major urinary protein",
  "GO:0005194": "obsolete cell adhesion molecule activity",
  "GO:0005198": "structural molecule activity",
  "GO:0005199": "structural constituent of cell wall",
  "GO:0005200": "structural constituent of cytoskeleton",
  "GO:0005201": "extracellular matrix structural constituent",
  "GO:0005202": "obsolete collagen",
  "GO:0005203": "obsolete proteoglycan",
  "GO:0005204": "obsolete chondroitin sulfate proteoglycan",
  "GO:0005205": "obsolete chondroitin sulfate/dermatan sulfate proteoglycan",
  "GO:0005206": "obsolete heparin sulfate proteoglycan",
  "GO:0005207": "obsolete extracellular matrix glycoprotein",
  "GO:0005208": "obsolete amyloid protein",
  "GO:0005209": "obsolete plasma protein",
  "GO:0005211": "obsolete plasma glycoprotein",
  "GO:0005212": "structural constituent of eye lens",
  "GO:0005213": "structural constituent of chorion",
  "GO:0005214": "structural constituent of chitin-based cuticle",
  "GO:0005215": "transporter activity",
  "GO:0005216": "ion channel activity",
  "GO:0005217": "intracellular ligand-gated ion channel activity",
  "GO:0005219": "ryanodine-sensitive calcium-release channel activity",
  "GO:0005220": "inositol 1,4,5-trisphosphate-sensitive calcium-release channel activity",
  "GO:0005221": "intracellular cyclic nucleotide activated cation channel activity",
  "GO:0005222": "intracellular cAMP activated cation channel activity",
  "GO:0005223": "intracellular cGMP activated cation channel activity",
  "GO:0005224": "ATP-binding and phosphorylation-dependent chloride channel activity",
  "GO:0005225": "volume-sensitive anion channel activity",
  "GO:0005227": "calcium activated cation channel activity",
  "GO:0005228": "intracellular sodium activated potassium channel activity",
  "GO:0005229": "intracellular calcium activated chloride channel activity",
  "GO:0005230": "extracellular ligand-gated ion channel activity",
  "GO:0005231": "excitatory extracellular ligand-gated ion channel activity",
  "GO:0005232": "serotonin-activated cation-selective channel activity",
  "GO:0005234": "extracellular-glutamate-gated ion channel activity",
  "GO:0005237": "inhibitory extracellular ligand-gated ion channel activity",
  "GO:0005240": "obsolete glycine receptor-associated protein",
  "GO:0005241": "obsolete inward rectifier channel",
  "GO:0005242": "inward rectifier potassium channel activity",
  "GO:0005243": "gap junction channel activity",
  "GO:0005244": "voltage-gated ion channel activity",
  "GO:0005245": "voltage-gated calcium channel activity",
  "GO:0005246": "calcium channel regulator activity",
  "GO:0005247": "voltage-gated chloride channel activity",
  "GO:0005248": "voltage-gated sodium channel activity",
  "GO:0005249": "voltage-gated potassium channel activity",
  "GO:0005250": "A-type (transient outward) potassium channel activity",
  "GO:0005251": "delayed rectifier potassium channel activity",
  "GO:0005252": "open rectifier potassium channel activity",
  "GO:0005253": "anion channel activity",
  "GO:0005254": "chloride channel activity",
  "GO:0005260": "channel-conductance-controlling ATPase activity",
  "GO:0005261": "cation channel activity",
  "GO:0005262": "calcium channel activity",
  "GO:0005267": "potassium channel activity",
  "GO:0005272": "sodium channel activity",
  "GO:0005274": "allantoin uptake transmembrane transporter activity",
  "GO:0005275": "amine transmembrane transporter activity",
  "GO:0005276": "vesicular hydrogen:amino acid antiporter activity",
  "GO:0005277": "acetylcholine transmembrane transporter activity",
  "GO:0005278": "acetylcholine:proton antiporter activity",
  "GO:0005280": "hydrogen:amino acid symporter activity",
  "GO:0005281": "obsolete general amino acid permease activity",
  "GO:0005283": "sodium:amino acid symporter activity",
  "GO:0005287": "high-affinity basic amino acid transmembrane transporter activity",
  "GO:0005289": "high-affinity arginine transmembrane transporter activity",
  "GO:0005290": "L-histidine transmembrane transporter activity",
  "GO:0005291": "high-affinity L-histidine transmembrane transporter activity",
  "GO:0005292": "high-affinity lysine transmembrane transporter activity",
  "GO:0005294": "neutral L-amino acid secondary active transmembrane transporter activity",
  "GO:0005295": "neutral amino acid:sodium symporter activity",
  "GO:0005297": "hydrogen:proline symporter activity",
  "GO:0005298": "proline:sodium symporter activity",
  "GO:0005300": "high-affinity tryptophan transmembrane transporter activity",
  "GO:0005301": "obsolete valine/tyrosine/tryptophan permease activity",
  "GO:0005302": "L-tyrosine transmembrane transporter activity",
  "GO:0005304": "L-valine transmembrane transporter activity",
  "GO:0005307": "choline:sodium symporter activity",
  "GO:0005308": "creatine transmembrane transporter activity",
  "GO:0005309": "creatine:sodium symporter activity",
  "GO:0005310": "dicarboxylic acid transmembrane transporter activity",
  "GO:0005311": "obsolete sodium:dicarboxylate/tricarboxylate symporter activity",
  "GO:0005313": "L-glutamate transmembrane transporter activity",
  "GO:0005314": "high-affinity glutamate transmembrane transporter activity",
  "GO:0005315": "inorganic phosphate transmembrane transporter activity",
  "GO:0005316": "high-affinity inorganic phosphate:sodium symporter activity",
  "GO:0005318": "obsolete phosphate:hydrogen symporter",
  "GO:0005319": "lipid transporter activity",
  "GO:0005320": "obsolete apolipoprotein",
  "GO:0005321": "obsolete high-density lipoprotein",
  "GO:0005322": "obsolete low-density lipoprotein",
  "GO:0005323": "obsolete very-low-density lipoprotein",
  "GO:0005324": "long-chain fatty acid transporter activity",
  "GO:0005325": "peroxisomal fatty-acyl-CoA transporter activity",
  "GO:0005326": "neurotransmitter transporter activity",
  "GO:0005328": "neurotransmitter:sodium symporter activity",
  "GO:0005329": "dopamine transmembrane transporter activity",
  "GO:0005330": "dopamine:sodium symporter activity",
  "GO:0005332": "gamma-aminobutyric acid:sodium symporter activity",
  "GO:0005333": "norepinephrine transmembrane transporter activity",
  "GO:0005334": "norepinephrine:sodium symporter activity",
  "GO:0005335": "serotonin:sodium symporter activity",
  "GO:0005337": "nucleoside transmembrane transporter activity",
  "GO:0005338": "nucleotide-sugar transmembrane transporter activity",
  "GO:0005340": "nucleotide-sulfate transmembrane transporter activity",
  "GO:0005342": "organic acid transmembrane transporter activity",
  "GO:0005343": "organic acid:sodium symporter activity",
  "GO:0005344": "oxygen transporter activity",
  "GO:0005345": "purine nucleobase transmembrane transporter activity",
  "GO:0005346": "purine ribonucleotide transmembrane transporter activity",
  "GO:0005347": "ATP transmembrane transporter activity",
  "GO:0005350": "pyrimidine nucleobase transmembrane transporter activity",
  "GO:0005351": "sugar:proton symporter activity",
  "GO:0005352": "alpha-glucoside:proton symporter activity",
  "GO:0005353": "fructose transmembrane transporter activity",
  "GO:0005354": "galactose transmembrane transporter activity",
  "GO:0005355": "glucose transmembrane transporter activity",
  "GO:0005356": "hydrogen:glucose symporter activity",
  "GO:0005357": "constitutive hydrogen:glucose symporter activity",
  "GO:0005358": "high-affinity hydrogen:glucose symporter activity",
  "GO:0005359": "low-affinity hydrogen:glucose symporter activity",
  "GO:0005360": "insulin-responsive hydrogen:glucose symporter activity",
  "GO:0005362": "low-affinity glucose:sodium symporter activity",
  "GO:0005363": "maltose transmembrane transporter activity",
  "GO:0005364": "maltose:proton symporter activity",
  "GO:0005365": "myo-inositol transmembrane transporter activity",
  "GO:0005366": "myo-inositol:proton symporter activity",
  "GO:0005367": "myo-inositol:sodium symporter activity",
  "GO:0005368": "taurine transmembrane transporter activity",
  "GO:0005369": "taurine:sodium symporter activity",
  "GO:0005371": "tricarboxylate secondary active transmembrane transporter activity",
  "GO:0005372": "water transmembrane transporter activity",
  "GO:0005373": "obsolete heavy metal ion porter activity",
  "GO:0005375": "copper ion transmembrane transporter activity",
  "GO:0005376": "obsolete plasma membrane copper transporter",
  "GO:0005377": "obsolete intracellular copper ion transporter",
  "GO:0005381": "iron ion transmembrane transporter activity",
  "GO:0005384": "manganese ion transmembrane transporter activity",
  "GO:0005385": "zinc ion transmembrane transporter activity",
  "GO:0005388": "calcium-transporting ATPase activity",
  "GO:0005391": "sodium:potassium-exchanging ATPase activity",
  "GO:0005395": "eye pigment precursor transporter activity",
  "GO:0005396": "obsolete transmembrane conductance regulator activity",
  "GO:0005400": "obsolete peroxisomal membrane transporter",
  "GO:0005402": "cation:sugar symporter activity",
  "GO:0005412": "glucose:sodium symporter activity",
  "GO:0005415": "nucleoside:sodium symporter activity",
  "GO:0005416": "cation:amino acid symporter activity",
  "GO:0005427": "proton-dependent oligopeptide secondary active transmembrane transporter activity",
  "GO:0005429": "chromaffin granule amine transmembrane transporter activity",
  "GO:0005430": "synaptic vesicle amine transmembrane transporter activity",
  "GO:0005432": "calcium:sodium antiporter activity",
  "GO:0005436": "sodium:phosphate symporter activity",
  "GO:0005451": "monovalent cation:proton antiporter activity",
  "GO:0005452": "inorganic anion exchanger activity",
  "GO:0005456": "CMP-N-acetylneuraminate transmembrane transporter activity",
  "GO:0005457": "GDP-fucose transmembrane transporter activity",
  "GO:0005458": "GDP-mannose transmembrane transporter activity",
  "GO:0005459": "UDP-galactose transmembrane transporter activity",
  "GO:0005460": "UDP-glucose transmembrane transporter activity",
  "GO:0005461": "UDP-glucuronic acid transmembrane transporter activity",
  "GO:0005462": "UDP-N-acetylglucosamine transmembrane transporter activity",
  "GO:0005463": "UDP-N-acetylgalactosamine transmembrane transporter activity",
  "GO:0005464": "UDP-xylose transmembrane transporter activity",
  "GO:0005468": "obsolete small-molecule carrier or transporter",
  "GO:0005469": "succinate:fumarate antiporter activity",
  "GO:0005471": "ATP:ADP antiporter activity",
  "GO:0005472": "FAD carrier activity",
  "GO:0005476": "carnitine:acyl carnitine antiporter activity",
  "GO:0005477": "pyruvate secondary active transmembrane transporter activity",
  "GO:0005479": "obsolete vacuolar assembly",
  "GO:0005480": "obsolete vesicle transport",
  "GO:0005481": "obsolete vesicle fusion",
  "GO:0005482": "obsolete vesicle targeting",
  "GO:0005483": "soluble NSF attachment protein activity",
  "GO:0005484": "SNAP receptor activity",
  "GO:0005487": "nucleocytoplasmic transporter activity",
  "GO:0005488": "binding",
  "GO:0005489": "obsolete electron transporter activity",
  "GO:0005490": "obsolete cytochrome P450",
  "GO:0005496": "steroid binding",
  "GO:0005497": "androgen binding",
  "GO:0005499": "vitamin D binding",
  "GO:0005500": "juvenile hormone binding",
  "GO:0005501": "retinoid binding",
  "GO:0005502": "11-cis retinal binding",
  "GO:0005503": "all-trans retinal binding",
  "GO:0005504": "fatty acid binding",
  "GO:0005505": "obsolete heavy metal binding",
  "GO:0005506": "iron ion binding",
  "GO:0005507": "copper ion binding",
  "GO:0005508": "obsolete copper/cadmium binding",
  "GO:0005509": "calcium ion binding",
  "GO:0005513": "detection of calcium ion",
  "GO:0005514": "obsolete calcium ion storage activity",
  "GO:0005515": "protein binding",
  "GO:0005516": "calmodulin binding",
  "GO:0005517": "obsolete calmodulin inhibitor activity",
  "GO:0005518": "collagen binding",
  "GO:0005519": "cytoskeletal regulatory protein binding",
  "GO:0005520": "insulin-like growth factor binding",
  "GO:0005521": "lamin binding",
  "GO:0005522": "profilin binding",
  "GO:0005523": "tropomyosin binding",
  "GO:0005524": "ATP binding",
  "GO:0005525": "GTP binding",
  "GO:0005527": "macrolide binding",
  "GO:0005528": "FK506 binding",
  "GO:0005530": "obsolete lectin",
  "GO:0005531": "obsolete galactose binding lectin",
  "GO:0005532": "obsolete mannose binding lectin",
  "GO:0005533": "obsolete N-acetylgalactosamine lectin",
  "GO:0005534": "galactose binding",
  "GO:0005536": "glucose binding",
  "GO:0005537": "mannose binding",
  "GO:0005539": "glycosaminoglycan binding",
  "GO:0005540": "hyaluronic acid binding",
  "GO:0005541": "obsolete acyl-CoA or acyl binding",
  "GO:0005542": "folic acid binding",
  "GO:0005543": "phospholipid binding",
  "GO:0005544": "calcium-dependent phospholipid binding",
  "GO:0005545": "1-phosphatidylinositol binding",
  "GO:0005546": "phosphatidylinositol-4,5-bisphosphate binding",
  "GO:0005547": "phosphatidylinositol-3,4,5-trisphosphate binding",
  "GO:0005548": "phospholipid transporter activity",
  "GO:0005549": "odorant binding",
  "GO:0005550": "pheromone binding",
  "GO:0005551": "obsolete ubiquitin",
  "GO:0005552": "obsolete polyubiquitin",
  "GO:0005553": "obsolete ubiquitin-ribosomal protein fusion protein",
  "GO:0005555": "obsolete blood group antigen",
  "GO:0005557": "obsolete lymphocyte antigen",
  "GO:0005558": "obsolete minor histocompatibility antigen",
  "GO:0005559": "obsolete ribozyme",
  "GO:0005561": "obsolete nucleic acid",
  "GO:0005562": "obsolete RNA",
  "GO:0005563": "obsolete transfer RNA",
  "GO:0005564": "obsolete cytosolic tRNA",
  "GO:0005565": "obsolete mitochondrial tRNA",
  "GO:0005566": "obsolete ribosomal RNA",
  "GO:0005567": "obsolete cytosolic ribosomal RNA",
  "GO:0005568": "obsolete mitochondrial rRNA",
  "GO:0005569": "obsolete small nucleolar RNA",
  "GO:0005570": "obsolete small nuclear RNA",
  "GO:0005571": "obsolete untranslated RNA",
  "GO:0005572": "obsolete RNA polymerase II transcribed untranslated RNA",
  "GO:0005573": "obsolete telomerase RNA",
  "GO:0005574": "obsolete DNA",
  "GO:0005575": "cellular_component",
  "GO:0005576": "extracellular region",
  "GO:0005577": "fibrinogen complex",
  "GO:0005578": "proteinaceous extracellular matrix",
  "GO:0005579": "membrane attack complex",
  "GO:0005580": "obsolete membrane attack complex protein alphaM chain",
  "GO:0005581": "collagen trimer",
  "GO:0005582": "collagen type XV trimer",
  "GO:0005583": "fibrillar collagen trimer",
  "GO:0005584": "collagen type I trimer",
  "GO:0005585": "collagen type II trimer",
  "GO:0005586": "collagen type III trimer",
  "GO:0005587": "collagen type IV trimer",
  "GO:0005588": "collagen type V trimer",
  "GO:0005589": "collagen type VI trimer",
  "GO:0005590": "collagen type VII trimer",
  "GO:0005591": "collagen type VIII trimer",
  "GO:0005592": "collagen type XI trimer",
  "GO:0005593": "FACIT collagen trimer",
  "GO:0005594": "collagen type IX trimer",
  "GO:0005595": "collagen type XII trimer",
  "GO:0005596": "collagen type XIV trimer",
  "GO:0005597": "collagen type XVI trimer",
  "GO:0005598": "short-chain collagen trimer",
  "GO:0005599": "collagen type X trimer",
  "GO:0005600": "collagen type XIII trimer",
  "GO:0005601": "classical-complement-pathway C3/C5 convertase complex",
  "GO:0005602": "complement component C1 complex",
  "GO:0005603": "obsolete complement component C2 complex",
  "GO:0005604": "basement membrane",
  "GO:0005605": "basal lamina",
  "GO:0005606": "laminin-1 complex",
  "GO:0005607": "laminin-2 complex",
  "GO:0005608": "laminin-3 complex",
  "GO:0005609": "laminin-4 complex",
  "GO:0005610": "laminin-5 complex",
  "GO:0005611": "laminin-6 complex",
  "GO:0005612": "laminin-7 complex",
  "GO:0005613": "obsolete laminin receptor protein",
  "GO:0005614": "interstitial matrix",
  "GO:0005615": "extracellular space",
  "GO:0005616": "larval serum protein complex",
  "GO:0005617": "obsolete larval serum protein-1",
  "GO:0005618": "cell wall",
  "GO:0005619": "ascospore wall",
  "GO:0005621": "cellular bud scar",
  "GO:0005622": "intracellular",
  "GO:0005623": "cell",
  "GO:0005624": "obsolete membrane fraction",
  "GO:0005625": "obsolete soluble fraction",
  "GO:0005626": "obsolete insoluble fraction",
  "GO:0005627": "obsolete ascus",
  "GO:0005628": "prospore membrane",
  "GO:0005630": "dityrosine layer of spore wall",
  "GO:0005631": "chitosan layer of spore wall",
  "GO:0005632": "inner layer of spore wall",
  "GO:0005633": "ascus lipid particle",
  "GO:0005634": "nucleus",
  "GO:0005635": "nuclear envelope",
  "GO:0005637": "nuclear inner membrane",
  "GO:0005638": "lamin filament",
  "GO:0005639": "integral component of nuclear inner membrane",
  "GO:0005640": "nuclear outer membrane",
  "GO:0005641": "nuclear envelope lumen",
  "GO:0005642": "annulate lamellae",
  "GO:0005643": "nuclear pore",
  "GO:0005645": "obsolete RAN-binding protein",
  "GO:0005646": "obsolete importin",
  "GO:0005647": "obsolete importin, alpha-subunit",
  "GO:0005648": "obsolete importin, beta-subunit",
  "GO:0005649": "obsolete transportin",
  "GO:0005650": "obsolete importin, alpha-subunit transport factor",
  "GO:0005651": "obsolete exportin",
  "GO:0005652": "nuclear lamina",
  "GO:0005654": "nucleoplasm",
  "GO:0005655": "nucleolar ribonuclease P complex",
  "GO:0005656": "nuclear pre-replicative complex",
  "GO:0005657": "replication fork",
  "GO:0005658": "alpha DNA polymerase:primase complex",
  "GO:0005660": "obsolete delta-DNA polymerase cofactor complex",
  "GO:0005662": "DNA replication factor A complex",
  "GO:0005663": "DNA replication factor C complex",
  "GO:0005664": "nuclear origin of replication recognition complex",
  "GO:0005665": "DNA-directed RNA polymerase II, core complex",
  "GO:0005666": "DNA-directed RNA polymerase III complex",
  "GO:0005667": "transcription factor complex",
  "GO:0005668": "RNA polymerase transcription factor SL1 complex",
  "GO:0005669": "transcription factor TFIID complex",
  "GO:0005670": "obsolete transcription-activating factor, 30kD",
  "GO:0005671": "Ada2/Gcn5/Ada3 transcription activator complex",
  "GO:0005672": "transcription factor TFIIA complex",
  "GO:0005673": "transcription factor TFIIE complex",
  "GO:0005674": "transcription factor TFIIF complex",
  "GO:0005675": "holo TFIIH complex",
  "GO:0005677": "chromatin silencing complex",
  "GO:0005678": "obsolete chromatin assembly complex",
  "GO:0005680": "anaphase-promoting complex",
  "GO:0005681": "spliceosomal complex",
  "GO:0005682": "U5 snRNP",
  "GO:0005683": "U7 snRNP",
  "GO:0005684": "U2-type spliceosomal complex",
  "GO:0005685": "U1 snRNP",
  "GO:0005686": "U2 snRNP",
  "GO:0005687": "U4 snRNP",
  "GO:0005688": "U6 snRNP",
  "GO:0005689": "U12-type spliceosomal complex",
  "GO:0005690": "U4atac snRNP",
  "GO:0005691": "U6atac snRNP",
  "GO:0005692": "U11 snRNP",
  "GO:0005693": "U12 snRNP",
  "GO:0005694": "chromosome",
  "GO:0005695": "obsolete chromatid",
  "GO:0005696": "obsolete telomere",
  "GO:0005697": "telomerase holoenzyme complex",
  "GO:0005698": "obsolete centromere",
  "GO:0005700": "polytene chromosome",
  "GO:0005701": "polytene chromosome chromocenter",
  "GO:0005702": "polytene chromosome weak point",
  "GO:0005703": "polytene chromosome puff",
  "GO:0005704": "polytene chromosome band",
  "GO:0005705": "polytene chromosome interband",
  "GO:0005706": "polytene chromosome ectopic fiber",
  "GO:0005707": "obsolete interphase chromosome",
  "GO:0005708": "obsolete mitotic chromosome",
  "GO:0005709": "obsolete prophase chromosome",
  "GO:0005710": "obsolete metaphase chromosome",
  "GO:0005711": "obsolete meiotic chromosome",
  "GO:0005712": "chiasma",
  "GO:0005713": "recombination nodule",
  "GO:0005714": "early recombination nodule",
  "GO:0005715": "late recombination nodule",
  "GO:0005719": "nuclear euchromatin",
  "GO:0005720": "nuclear heterochromatin",
  "GO:0005721": "pericentric heterochromatin",
  "GO:0005722": "beta-heterochromatin",
  "GO:0005723": "alpha-heterochromatin",
  "GO:0005724": "nuclear telomeric heterochromatin",
  "GO:0005725": "intercalary heterochromatin",
  "GO:0005726": "perichromatin fibrils",
  "GO:0005727": "extrachromosomal circular DNA",
  "GO:0005728": "extrachromosomal rDNA circle",
  "GO:0005729": "2-micrometer circle DNA",
  "GO:0005730": "nucleolus",
  "GO:0005731": "nucleolus organizer region",
  "GO:0005732": "small nucleolar ribonucleoprotein complex",
  "GO:0005733": "obsolete small nucleolar RNA",
  "GO:0005734": "obsolete box C + D snoRNP protein",
  "GO:0005735": "obsolete box H + ACA snoRNP protein",
  "GO:0005736": "DNA-directed RNA polymerase I complex",
  "GO:0005737": "cytoplasm",
  "GO:0005739": "mitochondrion",
  "GO:0005740": "mitochondrial envelope",
  "GO:0005741": "mitochondrial outer membrane",
  "GO:0005742": "mitochondrial outer membrane translocase complex",
  "GO:0005743": "mitochondrial inner membrane",
  "GO:0005744": "mitochondrial inner membrane presequence translocase complex",
  "GO:0005745": "m-AAA complex",
  "GO:0005746": "mitochondrial respiratory chain",
  "GO:0005747": "mitochondrial respiratory chain complex I",
  "GO:0005749": "mitochondrial respiratory chain complex II, succinate dehydrogenase complex (ubiquinone)",
  "GO:0005750": "mitochondrial respiratory chain complex III",
  "GO:0005751": "mitochondrial respiratory chain complex IV",
  "GO:0005753": "mitochondrial proton-transporting ATP synthase complex",
  "GO:0005754": "mitochondrial proton-transporting ATP synthase, catalytic core",
  "GO:0005755": "obsolete hydrogen-transporting ATP synthase, coupling factor CF(0)",
  "GO:0005756": "mitochondrial proton-transporting ATP synthase, central stalk",
  "GO:0005757": "mitochondrial permeability transition pore complex",
  "GO:0005758": "mitochondrial intermembrane space",
  "GO:0005759": "mitochondrial matrix",
  "GO:0005760": "gamma DNA polymerase complex",
  "GO:0005761": "mitochondrial ribosome",
  "GO:0005762": "mitochondrial large ribosomal subunit",
  "GO:0005763": "mitochondrial small ribosomal subunit",
  "GO:0005764": "lysosome",
  "GO:0005765": "lysosomal membrane",
  "GO:0005766": "primary lysosome",
  "GO:0005767": "secondary lysosome",
  "GO:0005768": "endosome",
  "GO:0005769": "early endosome",
  "GO:0005770": "late endosome",
  "GO:0005771": "multivesicular body",
  "GO:0005773": "vacuole",
  "GO:0005774": "vacuolar membrane",
  "GO:0005775": "vacuolar lumen",
  "GO:0005776": "autophagosome",
  "GO:0005777": "peroxisome",
  "GO:0005778": "peroxisomal membrane",
  "GO:0005779": "integral component of peroxisomal membrane",
  "GO:0005780": "extrinsic component of intraperoxisomal membrane",
  "GO:0005781": "obsolete peroxisome targeting signal receptor complex",
  "GO:0005782": "peroxisomal matrix",
  "GO:0005783": "endoplasmic reticulum",
  "GO:0005784": "Sec61 translocon complex",
  "GO:0005785": "signal recognition particle receptor complex",
  "GO:0005786": "signal recognition particle, endoplasmic reticulum targeting",
  "GO:0005787": "signal peptidase complex",
  "GO:0005788": "endoplasmic reticulum lumen",
  "GO:0005789": "endoplasmic reticulum membrane",
  "GO:0005790": "smooth endoplasmic reticulum",
  "GO:0005791": "rough endoplasmic reticulum",
  "GO:0005792": "obsolete microsome",
  "GO:0005793": "endoplasmic reticulum-Golgi intermediate compartment",
  "GO:0005794": "Golgi apparatus",
  "GO:0005795": "Golgi stack",
  "GO:0005796": "Golgi lumen",
  "GO:0005797": "Golgi medial cisterna",
  "GO:0005798": "Golgi-associated vesicle",
  "GO:0005799": "obsolete coatomer",
  "GO:0005800": "obsolete COPII vesicle",
  "GO:0005801": "cis-Golgi network",
  "GO:0005802": "trans-Golgi network",
  "GO:0005803": "obsolete secretory vesicle",
  "GO:0005804": "obsolete secretory vesicle membrane",
  "GO:0005805": "obsolete ER-Golgi transport vesicle",
  "GO:0005806": "obsolete Golgi-ER transport vesicle",
  "GO:0005808": "obsolete Golgi-plasma membrane transport vesicle",
  "GO:0005809": "obsolete Golgi-vacuole transport vesicle",
  "GO:0005810": "obsolete endocytotic transport vesicle",
  "GO:0005811": "lipid particle",
  "GO:0005813": "centrosome",
  "GO:0005814": "centriole",
  "GO:0005815": "microtubule organizing center",
  "GO:0005816": "spindle pole body",
  "GO:0005817": "obsolete centrosomal mitotic factor",
  "GO:0005818": "aster",
  "GO:0005819": "spindle",
  "GO:0005821": "intermediate layer of spindle pole body",
  "GO:0005822": "inner plaque of spindle pole body",
  "GO:0005823": "central plaque of spindle pole body",
  "GO:0005824": "outer plaque of spindle pole body",
  "GO:0005825": "half bridge of spindle pole body",
  "GO:0005826": "actomyosin contractile ring",
  "GO:0005827": "polar microtubule",
  "GO:0005828": "kinetochore microtubule",
  "GO:0005829": "cytosol",
  "GO:0005831": "steroid hormone aporeceptor complex",
  "GO:0005832": "chaperonin-containing T-complex",
  "GO:0005833": "hemoglobin complex",
  "GO:0005834": "heterotrimeric G-protein complex",
  "GO:0005835": "fatty acid synthase complex",
  "GO:0005836": "fatty-acyl-CoA synthase complex",
  "GO:0005837": "obsolete 26S proteasome",
  "GO:0005838": "proteasome regulatory particle",
  "GO:0005839": "proteasome core complex",
  "GO:0005840": "ribosome",
  "GO:0005844": "polysome",
  "GO:0005845": "mRNA cap binding complex",
  "GO:0005846": "nuclear cap binding complex",
  "GO:0005847": "mRNA cleavage and polyadenylation specificity factor complex",
  "GO:0005848": "mRNA cleavage stimulating factor complex",
  "GO:0005849": "mRNA cleavage factor complex",
  "GO:0005850": "eukaryotic translation initiation factor 2 complex",
  "GO:0005851": "eukaryotic translation initiation factor 2B complex",
  "GO:0005852": "eukaryotic translation initiation factor 3 complex",
  "GO:0005853": "eukaryotic translation elongation factor 1 complex",
  "GO:0005854": "nascent polypeptide-associated complex",
  "GO:0005856": "cytoskeleton",
  "GO:0005858": "axonemal dynein complex",
  "GO:0005859": "muscle myosin complex",
  "GO:0005861": "troponin complex",
  "GO:0005862": "muscle thin filament tropomyosin",
  "GO:0005863": "striated muscle myosin thick filament",
  "GO:0005865": "striated muscle thin filament",
  "GO:0005868": "cytoplasmic dynein complex",
  "GO:0005869": "dynactin complex",
  "GO:0005870": "actin capping protein of dynactin complex",
  "GO:0005871": "kinesin complex",
  "GO:0005872": "minus-end kinesin complex",
  "GO:0005873": "plus-end kinesin complex",
  "GO:0005874": "microtubule",
  "GO:0005875": "microtubule associated complex",
  "GO:0005876": "spindle microtubule",
  "GO:0005879": "axonemal microtubule",
  "GO:0005880": "nuclear microtubule",
  "GO:0005881": "cytoplasmic microtubule",
  "GO:0005882": "intermediate filament",
  "GO:0005883": "neurofilament",
  "GO:0005884": "actin filament",
  "GO:0005885": "Arp2/3 protein complex",
  "GO:0005886": "plasma membrane",
  "GO:0005887": "integral component of plasma membrane",
  "GO:0005888": "obsolete proteoglycan integral to plasma membrane",
  "GO:0005889": "hydrogen:potassium-exchanging ATPase complex",
  "GO:0005890": "sodium:potassium-exchanging ATPase complex",
  "GO:0005891": "voltage-gated calcium channel complex",
  "GO:0005892": "acetylcholine-gated channel complex",
  "GO:0005893": "interleukin-2 receptor complex",
  "GO:0005894": "interleukin-3 receptor complex",
  "GO:0005895": "interleukin-5 receptor complex",
  "GO:0005896": "interleukin-6 receptor complex",
  "GO:0005897": "interleukin-9 receptor complex",
  "GO:0005898": "interleukin-13 receptor complex",
  "GO:0005899": "insulin receptor complex",
  "GO:0005900": "oncostatin-M receptor complex",
  "GO:0005901": "caveola",
  "GO:0005902": "microvillus",
  "GO:0005903": "brush border",
  "GO:0005905": "coated pit",
  "GO:0005906": "obsolete clathrin adaptor",
  "GO:0005907": "obsolete HA1 clathrin adaptor",
  "GO:0005908": "obsolete HA2 clathrin adaptor",
  "GO:0005911": "cell-cell junction",
  "GO:0005912": "adherens junction",
  "GO:0005913": "cell-cell adherens junction",
  "GO:0005914": "spot adherens junction",
  "GO:0005915": "zonula adherens",
  "GO:0005916": "fascia adherens",
  "GO:0005917": "nephrocyte diaphragm",
  "GO:0005918": "septate junction",
  "GO:0005919": "pleated septate junction",
  "GO:0005920": "smooth septate junction",
  "GO:0005921": "gap junction",
  "GO:0005922": "connexon complex",
  "GO:0005923": "bicellular tight junction",
  "GO:0005924": "cell-substrate adherens junction",
  "GO:0005925": "focal adhesion",
  "GO:0005926": "connecting hemi-adherens junction",
  "GO:0005927": "muscle tendon junction",
  "GO:0005928": "apical hemi-adherens junction",
  "GO:0005929": "cilium",
  "GO:0005930": "axoneme",
  "GO:0005931": "nexin complex",
  "GO:0005933": "cellular bud",
  "GO:0005934": "cellular bud tip",
  "GO:0005935": "cellular bud neck",
  "GO:0005936": "obsolete shmoo",
  "GO:0005937": "mating projection",
  "GO:0005938": "cell cortex",
  "GO:0005940": "septin ring",
  "GO:0005941": "obsolete unlocalized protein complex",
  "GO:0005942": "phosphatidylinositol 3-kinase complex",
  "GO:0005943": "phosphatidylinositol 3-kinase complex, class IA",
  "GO:0005944": "phosphatidylinositol 3-kinase complex, class IB",
  "GO:0005945": "6-phosphofructokinase complex",
  "GO:0005946": "alpha,alpha-trehalose-phosphate synthase complex (UDP-forming)",
  "GO:0005947": "mitochondrial alpha-ketoglutarate dehydrogenase complex",
  "GO:0005948": "acetolactate synthase complex",
  "GO:0005949": "obsolete aminoadipate-semialdehyde dehydrogenase complex",
  "GO:0005950": "anthranilate synthase complex",
  "GO:0005951": "carbamoyl-phosphate synthase complex",
  "GO:0005952": "cAMP-dependent protein kinase complex",
  "GO:0005953": "CAAX-protein geranylgeranyltransferase complex",
  "GO:0005954": "calcium- and calmodulin-dependent protein kinase complex",
  "GO:0005955": "calcineurin complex",
  "GO:0005956": "protein kinase CK2 complex",
  "GO:0005957": "obsolete debranching enzyme",
  "GO:0005958": "DNA-dependent protein kinase-DNA ligase 4 complex",
  "GO:0005960": "glycine cleavage complex",
  "GO:0005962": "mitochondrial isocitrate dehydrogenase complex (NAD+)",
  "GO:0005963": "magnesium-dependent protein serine/threonine phosphatase complex",
  "GO:0005964": "phosphorylase kinase complex",
  "GO:0005965": "protein farnesyltransferase complex",
  "GO:0005966": "cyclic-nucleotide phosphodiesterase complex",
  "GO:0005967": "mitochondrial pyruvate dehydrogenase complex",
  "GO:0005968": "Rab-protein geranylgeranyltransferase complex",
  "GO:0005969": "serine-pyruvate aminotransferase complex",
  "GO:0005971": "ribonucleoside-diphosphate reductase complex",
  "GO:0005972": "obsolete fibrinogen alpha chain",
  "GO:0005973": "obsolete fibrinogen beta chain",
  "GO:0005974": "obsolete fibrinogen gamma chain",
  "GO:0005975": "carbohydrate metabolic process",
  "GO:0005976": "polysaccharide metabolic process",
  "GO:0005977": "glycogen metabolic process",
  "GO:0005978": "glycogen biosynthetic process",
  "GO:0005979": "regulation of glycogen biosynthetic process",
  "GO:0005980": "glycogen catabolic process",
  "GO:0005981": "regulation of glycogen catabolic process",
  "GO:0005982": "starch metabolic process",
  "GO:0005983": "starch catabolic process",
  "GO:0005984": "disaccharide metabolic process",
  "GO:0005985": "sucrose metabolic process",
  "GO:0005986": "sucrose biosynthetic process",
  "GO:0005987": "sucrose catabolic process",
  "GO:0005988": "lactose metabolic process",
  "GO:0005989": "lactose biosynthetic process",
  "GO:0005990": "lactose catabolic process",
  "GO:0005991": "trehalose metabolic process",
  "GO:0005992": "trehalose biosynthetic process",
  "GO:0005993": "trehalose catabolic process",
  "GO:0005994": "melibiose metabolic process",
  "GO:0005995": "melibiose catabolic process",
  "GO:0005996": "monosaccharide metabolic process",
  "GO:0005997": "xylulose metabolic process",
  "GO:0005998": "xylulose catabolic process",
  "GO:0005999": "xylulose biosynthetic process",
  "GO:0006000": "fructose metabolic process",
  "GO:0006001": "fructose catabolic process",
  "GO:0006002": "fructose 6-phosphate metabolic process",
  "GO:0006003": "fructose 2,6-bisphosphate metabolic process",
  "GO:0006004": "fucose metabolic process",
  "GO:0006005": "L-fucose biosynthetic process",
  "GO:0006006": "glucose metabolic process",
  "GO:0006007": "glucose catabolic process",
  "GO:0006009": "glucose 1-phosphate phosphorylation",
  "GO:0006011": "UDP-glucose metabolic process",
  "GO:0006012": "galactose metabolic process",
  "GO:0006013": "mannose metabolic process",
  "GO:0006014": "D-ribose metabolic process",
  "GO:0006015": "5-phosphoribose 1-diphosphate biosynthetic process",
  "GO:0006016": "2-deoxyribose 1-phosphate biosynthetic process",
  "GO:0006017": "deoxyribose 1,5-bisphosphate biosynthetic process",
  "GO:0006018": "2-deoxyribose 1-phosphate catabolic process",
  "GO:0006019": "deoxyribose 5-phosphate phosphorylation",
  "GO:0006020": "inositol metabolic process",
  "GO:0006021": "inositol biosynthetic process",
  "GO:0006022": "aminoglycan metabolic process",
  "GO:0006023": "aminoglycan biosynthetic process",
  "GO:0006024": "glycosaminoglycan biosynthetic process",
  "GO:0006025": "galactosaminoglycan biosynthetic process",
  "GO:0006026": "aminoglycan catabolic process",
  "GO:0006027": "glycosaminoglycan catabolic process",
  "GO:0006028": "galactosaminoglycan catabolic process",
  "GO:0006029": "proteoglycan metabolic process",
  "GO:0006030": "chitin metabolic process",
  "GO:0006031": "chitin biosynthetic process",
  "GO:0006032": "chitin catabolic process",
  "GO:0006033": "chitin localization",
  "GO:0006034": "cuticle chitin metabolic process",
  "GO:0006035": "cuticle chitin biosynthetic process",
  "GO:0006036": "cuticle chitin catabolic process",
  "GO:0006037": "cell wall chitin metabolic process",
  "GO:0006038": "cell wall chitin biosynthetic process",
  "GO:0006039": "cell wall chitin catabolic process",
  "GO:0006040": "amino sugar metabolic process",
  "GO:0006041": "glucosamine metabolic process",
  "GO:0006042": "glucosamine biosynthetic process",
  "GO:0006043": "glucosamine catabolic process",
  "GO:0006044": "N-acetylglucosamine metabolic process",
  "GO:0006045": "N-acetylglucosamine biosynthetic process",
  "GO:0006046": "N-acetylglucosamine catabolic process",
  "GO:0006047": "UDP-N-acetylglucosamine metabolic process",
  "GO:0006048": "UDP-N-acetylglucosamine biosynthetic process",
  "GO:0006049": "UDP-N-acetylglucosamine catabolic process",
  "GO:0006050": "mannosamine metabolic process",
  "GO:0006051": "N-acetylmannosamine metabolic process",
  "GO:0006052": "N-acetylmannosamine biosynthetic process",
  "GO:0006053": "N-acetylmannosamine catabolic process",
  "GO:0006054": "N-acetylneuraminate metabolic process",
  "GO:0006055": "CMP-N-acetylneuraminate biosynthetic process",
  "GO:0006056": "mannoprotein metabolic process",
  "GO:0006057": "mannoprotein biosynthetic process",
  "GO:0006058": "mannoprotein catabolic process",
  "GO:0006059": "hexitol metabolic process",
  "GO:0006060": "sorbitol metabolic process",
  "GO:0006061": "sorbitol biosynthetic process",
  "GO:0006062": "sorbitol catabolic process",
  "GO:0006063": "uronic acid metabolic process",
  "GO:0006064": "glucuronate catabolic process",
  "GO:0006065": "UDP-glucuronate biosynthetic process",
  "GO:0006066": "alcohol metabolic process",
  "GO:0006067": "ethanol metabolic process",
  "GO:0006068": "ethanol catabolic process",
  "GO:0006069": "ethanol oxidation",
  "GO:0006070": "octanol metabolic process",
  "GO:0006071": "glycerol metabolic process",
  "GO:0006072": "glycerol-3-phosphate metabolic process",
  "GO:0006073": "cellular glucan metabolic process",
  "GO:0006074": "(1->3)-beta-D-glucan metabolic process",
  "GO:0006075": "(1->3)-beta-D-glucan biosynthetic process",
  "GO:0006076": "(1->3)-beta-D-glucan catabolic process",
  "GO:0006077": "(1->6)-beta-D-glucan metabolic process",
  "GO:0006078": "(1->6)-beta-D-glucan biosynthetic process",
  "GO:0006079": "(1->6)-beta-D-glucan catabolic process",
  "GO:0006080": "substituted mannan metabolic process",
  "GO:0006081": "cellular aldehyde metabolic process",
  "GO:0006082": "organic acid metabolic process",
  "GO:0006083": "acetate metabolic process",
  "GO:0006084": "acetyl-CoA metabolic process",
  "GO:0006085": "acetyl-CoA biosynthetic process",
  "GO:0006086": "acetyl-CoA biosynthetic process from pyruvate",
  "GO:0006088": "obsolete acetate to acetyl-CoA",
  "GO:0006089": "lactate metabolic process",
  "GO:0006090": "pyruvate metabolic process",
  "GO:0006091": "generation of precursor metabolites and energy",
  "GO:0006094": "gluconeogenesis",
  "GO:0006096": "glycolytic process",
  "GO:0006097": "glyoxylate cycle",
  "GO:0006098": "pentose-phosphate shunt",
  "GO:0006099": "tricarboxylic acid cycle",
  "GO:0006100": "obsolete tricarboxylic acid cycle intermediate metabolic process",
  "GO:0006101": "citrate metabolic process",
  "GO:0006102": "isocitrate metabolic process",
  "GO:0006103": "2-oxoglutarate metabolic process",
  "GO:0006104": "succinyl-CoA metabolic process",
  "GO:0006105": "succinate metabolic process",
  "GO:0006106": "fumarate metabolic process",
  "GO:0006107": "oxaloacetate metabolic process",
  "GO:0006108": "malate metabolic process",
  "GO:0006109": "regulation of carbohydrate metabolic process",
  "GO:0006110": "regulation of glycolytic process",
  "GO:0006111": "regulation of gluconeogenesis",
  "GO:0006112": "energy reserve metabolic process",
  "GO:0006113": "fermentation",
  "GO:0006114": "glycerol biosynthetic process",
  "GO:0006115": "ethanol biosynthetic process",
  "GO:0006116": "NADH oxidation",
  "GO:0006117": "acetaldehyde metabolic process",
  "GO:0006118": "obsolete electron transport",
  "GO:0006119": "oxidative phosphorylation",
  "GO:0006120": "mitochondrial electron transport, NADH to ubiquinone",
  "GO:0006121": "mitochondrial electron transport, succinate to ubiquinone",
  "GO:0006122": "mitochondrial electron transport, ubiquinol to cytochrome c",
  "GO:0006123": "mitochondrial electron transport, cytochrome c to oxygen",
  "GO:0006124": "ferredoxin metabolic process",
  "GO:0006125": "obsolete thioredoxin pathway",
  "GO:0006126": "obsolete other pathways of electron transport",
  "GO:0006127": "glycerophosphate shuttle",
  "GO:0006128": "obsolete oxidized glutathione reduction",
  "GO:0006129": "obsolete protein-disulfide reduction",
  "GO:0006130": "obsolete 6-phosphofructokinase reduction",
  "GO:0006131": "obsolete dihydrolipoamide reduction",
  "GO:0006132": "obsolete dihydrolipoylprotein reduction",
  "GO:0006133": "obsolete 5,10-methylenetetrahydrofolate oxidation",
  "GO:0006134": "obsolete dihydrobiopterin reduction",
  "GO:0006135": "obsolete dihydropteridine reduction",
  "GO:0006139": "nucleobase-containing compound metabolic process",
  "GO:0006140": "regulation of nucleotide metabolic process",
  "GO:0006141": "regulation of purine nucleobase metabolic process",
  "GO:0006142": "regulation of pyrimidine nucleobase metabolic process",
  "GO:0006143": "obsolete purine metabolic process",
  "GO:0006144": "purine nucleobase metabolic process",
  "GO:0006145": "purine nucleobase catabolic process",
  "GO:0006146": "adenine catabolic process",
  "GO:0006147": "guanine catabolic process",
  "GO:0006148": "inosine catabolic process",
  "GO:0006149": "deoxyinosine catabolic process",
  "GO:0006150": "hypoxanthine oxidation",
  "GO:0006151": "xanthine oxidation",
  "GO:0006152": "purine nucleoside catabolic process",
  "GO:0006153": "obsolete purine nucleosidase reaction",
  "GO:0006154": "adenosine catabolic process",
  "GO:0006155": "obsolete adenosine deaminase reaction",
  "GO:0006157": "deoxyadenosine catabolic process",
  "GO:0006158": "obsolete deoxyadenosine deaminase reaction",
  "GO:0006161": "deoxyguanosine catabolic process",
  "GO:0006162": "obsolete purine/pyrimidine nucleoside diphosphate reduction",
  "GO:0006163": "purine nucleotide metabolic process",
  "GO:0006164": "purine nucleotide biosynthetic process",
  "GO:0006165": "nucleoside diphosphate phosphorylation",
  "GO:0006166": "purine ribonucleoside salvage",
  "GO:0006167": "AMP biosynthetic process",
  "GO:0006168": "adenine salvage",
  "GO:0006169": "adenosine salvage",
  "GO:0006170": "dAMP biosynthetic process",
  "GO:0006171": "cAMP biosynthetic process",
  "GO:0006172": "ADP biosynthetic process",
  "GO:0006173": "dADP biosynthetic process",
  "GO:0006174": "dADP phosphorylation",
  "GO:0006175": "dATP biosynthetic process",
  "GO:0006176": "dATP biosynthetic process from ADP",
  "GO:0006177": "GMP biosynthetic process",
  "GO:0006178": "guanine salvage",
  "GO:0006179": "guanosine salvage",
  "GO:0006180": "deoxyguanosine salvage",
  "GO:0006181": "dGMP biosynthetic process",
  "GO:0006182": "cGMP biosynthetic process",
  "GO:0006183": "GTP biosynthetic process",
  "GO:0006184": "obsolete GTP catabolic process",
  "GO:0006185": "dGDP biosynthetic process",
  "GO:0006186": "dGDP phosphorylation",
  "GO:0006187": "dGTP biosynthetic process from dGDP",
  "GO:0006188": "IMP biosynthetic process",
  "GO:0006189": "'de novo' IMP biosynthetic process",
  "GO:0006190": "inosine salvage",
  "GO:0006191": "deoxyinosine salvage",
  "GO:0006192": "IDP phosphorylation",
  "GO:0006193": "ITP catabolic process",
  "GO:0006194": "dIDP phosphorylation",
  "GO:0006195": "purine nucleotide catabolic process",
  "GO:0006196": "AMP catabolic process",
  "GO:0006197": "obsolete adenylate deaminase reaction",
  "GO:0006198": "cAMP catabolic process",
  "GO:0006199": "obsolete ADP reduction",
  "GO:0006200": "obsolete ATP catabolic process",
  "GO:0006201": "GMP catabolic process to IMP",
  "GO:0006202": "GMP catabolic process to guanine",
  "GO:0006203": "dGTP catabolic process",
  "GO:0006204": "IMP catabolic process",
  "GO:0006205": "obsolete pyrimidine metabolic process",
  "GO:0006206": "pyrimidine nucleobase metabolic process",
  "GO:0006207": "'de novo' pyrimidine nucleobase biosynthetic process",
  "GO:0006208": "pyrimidine nucleobase catabolic process",
  "GO:0006209": "cytosine catabolic process",
  "GO:0006210": "thymine catabolic process",
  "GO:0006211": "5-methylcytosine catabolic process",
  "GO:0006212": "uracil catabolic process",
  "GO:0006213": "pyrimidine nucleoside metabolic process",
  "GO:0006214": "thymidine catabolic process",
  "GO:0006216": "cytidine catabolic process",
  "GO:0006217": "deoxycytidine catabolic process",
  "GO:0006218": "uridine catabolic process",
  "GO:0006219": "deoxyuridine catabolic process",
  "GO:0006220": "pyrimidine nucleotide metabolic process",
  "GO:0006221": "pyrimidine nucleotide biosynthetic process",
  "GO:0006222": "UMP biosynthetic process",
  "GO:0006223": "uracil salvage",
  "GO:0006224": "obsolete uridine kinase reaction",
  "GO:0006225": "UDP biosynthetic process",
  "GO:0006226": "dUMP biosynthetic process",
  "GO:0006227": "dUDP biosynthetic process",
  "GO:0006228": "UTP biosynthetic process",
  "GO:0006229": "dUTP biosynthetic process",
  "GO:0006230": "TMP biosynthetic process",
  "GO:0006231": "dTMP biosynthetic process",
  "GO:0006232": "TDP biosynthetic process",
  "GO:0006233": "dTDP biosynthetic process",
  "GO:0006234": "TTP biosynthetic process",
  "GO:0006235": "dTTP biosynthetic process",
  "GO:0006236": "cytidine salvage",
  "GO:0006237": "deoxycytidine salvage",
  "GO:0006238": "CMP salvage",
  "GO:0006239": "dCMP salvage",
  "GO:0006240": "dCDP biosynthetic process",
  "GO:0006241": "CTP biosynthetic process",
  "GO:0006242": "dCTP biosynthetic process",
  "GO:0006244": "pyrimidine nucleotide catabolic process",
  "GO:0006245": "TDP catabolic process",
  "GO:0006246": "dTDP catabolic process",
  "GO:0006247": "obsolete TTP reduction",
  "GO:0006248": "CMP catabolic process",
  "GO:0006249": "dCMP catabolic process",
  "GO:0006250": "obsolete CDP reduction",
  "GO:0006251": "dCDP catabolic process",
  "GO:0006252": "obsolete CTP reduction",
  "GO:0006253": "dCTP catabolic process",
  "GO:0006254": "CTP catabolic process",
  "GO:0006255": "obsolete UDP reduction",
  "GO:0006256": "UDP catabolic process",
  "GO:0006257": "dUDP catabolic process",
  "GO:0006258": "UDP-glucose catabolic process",
  "GO:0006259": "DNA metabolic process",
  "GO:0006260": "DNA replication",
  "GO:0006261": "DNA-dependent DNA replication",
  "GO:0006264": "mitochondrial DNA replication",
  "GO:0006265": "DNA topological change",
  "GO:0006266": "DNA ligation",
  "GO:0006267": "pre-replicative complex assembly involved in nuclear cell cycle DNA replication",
  "GO:0006268": "DNA unwinding involved in DNA replication",
  "GO:0006269": "DNA replication, synthesis of RNA primer",
  "GO:0006270": "DNA replication initiation",
  "GO:0006271": "DNA strand elongation involved in DNA replication",
  "GO:0006272": "leading strand elongation",
  "GO:0006273": "lagging strand elongation",
  "GO:0006274": "DNA replication termination",
  "GO:0006275": "regulation of DNA replication",
  "GO:0006276": "plasmid maintenance",
  "GO:0006277": "DNA amplification",
  "GO:0006278": "RNA-dependent DNA replication",
  "GO:0006279": "premeiotic DNA replication",
  "GO:0006280": "obsolete mutagenesis",
  "GO:0006281": "DNA repair",
  "GO:0006282": "regulation of DNA repair",
  "GO:0006283": "transcription-coupled nucleotide-excision repair",
  "GO:0006284": "base-excision repair",
  "GO:0006285": "base-excision repair, AP site formation",
  "GO:0006286": "base-excision repair, base-free sugar-phosphate removal",
  "GO:0006287": "base-excision repair, gap-filling",
  "GO:0006288": "base-excision repair, DNA ligation",
  "GO:0006289": "nucleotide-excision repair",
  "GO:0006290": "pyrimidine dimer repair",
  "GO:0006291": "obsolete pyrimidine-dimer repair, DNA damage excision",
  "GO:0006292": "obsolete pyrimidine-dimer repair, DNA damage recognition",
  "GO:0006293": "nucleotide-excision repair, preincision complex stabilization",
  "GO:0006294": "nucleotide-excision repair, preincision complex assembly",
  "GO:0006295": "nucleotide-excision repair, DNA incision, 3'-to lesion",
  "GO:0006296": "nucleotide-excision repair, DNA incision, 5'-to lesion",
  "GO:0006297": "nucleotide-excision repair, DNA gap filling",
  "GO:0006298": "mismatch repair",
  "GO:0006299": "obsolete short patch mismatch repair system",
  "GO:0006301": "postreplication repair",
  "GO:0006302": "double-strand break repair",
  "GO:0006303": "double-strand break repair via nonhomologous end joining",
  "GO:0006304": "DNA modification",
  "GO:0006305": "DNA alkylation",
  "GO:0006306": "DNA methylation",
  "GO:0006307": "DNA dealkylation involved in DNA repair",
  "GO:0006308": "DNA catabolic process",
  "GO:0006309": "apoptotic DNA fragmentation",
  "GO:0006310": "DNA recombination",
  "GO:0006311": "meiotic gene conversion",
  "GO:0006312": "mitotic recombination",
  "GO:0006313": "transposition, DNA-mediated",
  "GO:0006314": "intron homing",
  "GO:0006315": "homing of group II introns",
  "GO:0006316": "movement of group I intron",
  "GO:0006323": "DNA packaging",
  "GO:0006324": "obsolete S phase-specific histone modification",
  "GO:0006325": "chromatin organization",
  "GO:0006326": "obsolete bent DNA binding",
  "GO:0006327": "obsolete random coil binding",
  "GO:0006328": "obsolete AT binding",
  "GO:0006329": "obsolete satellite DNA binding",
  "GO:0006330": "obsolete single-stranded DNA binding",
  "GO:0006333": "chromatin assembly or disassembly",
  "GO:0006334": "nucleosome assembly",
  "GO:0006335": "DNA replication-dependent nucleosome assembly",
  "GO:0006336": "DNA replication-independent nucleosome assembly",
  "GO:0006337": "nucleosome disassembly",
  "GO:0006338": "chromatin remodeling",
  "GO:0006339": "obsolete positive regulation of transcription of homeotic gene (trithorax group)",
  "GO:0006340": "obsolete negative regulation of transcription of homeotic gene (Polycomb group)",
  "GO:0006341": "obsolete chromatin insulator sequence binding",
  "GO:0006342": "chromatin silencing",
  "GO:0006343": "establishment of chromatin silencing",
  "GO:0006344": "maintenance of chromatin silencing",
  "GO:0006346": "methylation-dependent chromatin silencing",
  "GO:0006348": "chromatin silencing at telomere",
  "GO:0006349": "regulation of gene expression by genetic imprinting",
  "GO:0006351": "transcription, DNA-templated",
  "GO:0006352": "DNA-templated transcription, initiation",
  "GO:0006353": "DNA-templated transcription, termination",
  "GO:0006354": "DNA-templated transcription, elongation",
  "GO:0006355": "regulation of transcription, DNA-templated",
  "GO:0006356": "regulation of transcription from RNA polymerase I promoter",
  "GO:0006357": "regulation of transcription from RNA polymerase II promoter",
  "GO:0006359": "regulation of transcription from RNA polymerase III promoter",
  "GO:0006360": "transcription from RNA polymerase I promoter",
  "GO:0006361": "transcription initiation from RNA polymerase I promoter",
  "GO:0006362": "transcription elongation from RNA polymerase I promoter",
  "GO:0006363": "termination of RNA polymerase I transcription",
  "GO:0006364": "rRNA processing",
  "GO:0006366": "transcription from RNA polymerase II promoter",
  "GO:0006367": "transcription initiation from RNA polymerase II promoter",
  "GO:0006368": "transcription elongation from RNA polymerase II promoter",
  "GO:0006369": "termination of RNA polymerase II transcription",
  "GO:0006370": "7-methylguanosine mRNA capping",
  "GO:0006371": "obsolete mRNA splicing",
  "GO:0006372": "obsolete lariat formation, 5'-splice site cleavage",
  "GO:0006373": "obsolete 3'-splice site cleavage, exon ligation",
  "GO:0006376": "mRNA splice site selection",
  "GO:0006377": "obsolete MATa1 (A1) pre-mRNA splicing",
  "GO:0006378": "mRNA polyadenylation",
  "GO:0006379": "mRNA cleavage",
  "GO:0006380": "obsolete poly-A binding",
  "GO:0006382": "adenosine to inosine editing",
  "GO:0006383": "transcription from RNA polymerase III promoter",
  "GO:0006384": "transcription initiation from RNA polymerase III promoter",
  "GO:0006385": "transcription elongation from RNA polymerase III promoter",
  "GO:0006386": "termination of RNA polymerase III transcription",
  "GO:0006387": "obsolete snRNA capping",
  "GO:0006388": "tRNA splicing, via endonucleolytic cleavage and ligation",
  "GO:0006389": "obsolete tRNA-Y splicing",
  "GO:0006390": "transcription from mitochondrial promoter",
  "GO:0006391": "transcription initiation from mitochondrial promoter",
  "GO:0006392": "transcription elongation from mitochondrial promoter",
  "GO:0006393": "termination of mitochondrial transcription",
  "GO:0006396": "RNA processing",
  "GO:0006397": "mRNA processing",
  "GO:0006398": "mRNA 3'-end processing by stem-loop binding and cleavage",
  "GO:0006399": "tRNA metabolic process",
  "GO:0006400": "tRNA modification",
  "GO:0006401": "RNA catabolic process",
  "GO:0006402": "mRNA catabolic process",
  "GO:0006403": "RNA localization",
  "GO:0006404": "RNA import into nucleus",
  "GO:0006405": "RNA export from nucleus",
  "GO:0006406": "mRNA export from nucleus",
  "GO:0006407": "rRNA export from nucleus",
  "GO:0006408": "snRNA export from nucleus",
  "GO:0006409": "tRNA export from nucleus",
  "GO:0006410": "obsolete transcription, RNA-dependent",
  "GO:0006412": "translation",
  "GO:0006413": "translational initiation",
  "GO:0006414": "translational elongation",
  "GO:0006415": "translational termination",
  "GO:0006417": "regulation of translation",
  "GO:0006418": "tRNA aminoacylation for protein translation",
  "GO:0006419": "alanyl-tRNA aminoacylation",
  "GO:0006420": "arginyl-tRNA aminoacylation",
  "GO:0006421": "asparaginyl-tRNA aminoacylation",
  "GO:0006422": "aspartyl-tRNA aminoacylation",
  "GO:0006423": "cysteinyl-tRNA aminoacylation",
  "GO:0006424": "glutamyl-tRNA aminoacylation",
  "GO:0006425": "glutaminyl-tRNA aminoacylation",
  "GO:0006426": "glycyl-tRNA aminoacylation",
  "GO:0006427": "histidyl-tRNA aminoacylation",
  "GO:0006428": "isoleucyl-tRNA aminoacylation",
  "GO:0006429": "leucyl-tRNA aminoacylation",
  "GO:0006430": "lysyl-tRNA aminoacylation",
  "GO:0006431": "methionyl-tRNA aminoacylation",
  "GO:0006432": "phenylalanyl-tRNA aminoacylation",
  "GO:0006433": "prolyl-tRNA aminoacylation",
  "GO:0006434": "seryl-tRNA aminoacylation",
  "GO:0006435": "threonyl-tRNA aminoacylation",
  "GO:0006436": "tryptophanyl-tRNA aminoacylation",
  "GO:0006437": "tyrosyl-tRNA aminoacylation",
  "GO:0006438": "valyl-tRNA aminoacylation",
  "GO:0006439": "obsolete aminoacyl-tRNA hydrolase reaction",
  "GO:0006441": "obsolete binding to mRNA cap",
  "GO:0006446": "regulation of translational initiation",
  "GO:0006447": "regulation of translational initiation by iron",
  "GO:0006448": "regulation of translational elongation",
  "GO:0006449": "regulation of translational termination",
  "GO:0006450": "regulation of translational fidelity",
  "GO:0006451": "translational readthrough",
  "GO:0006452": "translational frameshifting",
  "GO:0006457": "protein folding",
  "GO:0006458": "'de novo' protein folding",
  "GO:0006459": "obsolete binding unfolded ER proteins",
  "GO:0006460": "obsolete peptidyl-prolyl isomerase B reaction",
  "GO:0006461": "protein complex assembly",
  "GO:0006462": "obsolete protein complex assembly, multichaperone pathway",
  "GO:0006463": "steroid hormone receptor complex assembly",
  "GO:0006464": "cellular protein modification process",
  "GO:0006465": "signal peptide processing",
  "GO:0006466": "obsolete protein disulfide-isomerase reaction",
  "GO:0006468": "protein phosphorylation",
  "GO:0006469": "negative regulation of protein kinase activity",
  "GO:0006470": "protein dephosphorylation",
  "GO:0006471": "protein ADP-ribosylation",
  "GO:0006473": "protein acetylation",
  "GO:0006474": "N-terminal protein amino acid acetylation",
  "GO:0006475": "internal protein amino acid acetylation",
  "GO:0006476": "protein deacetylation",
  "GO:0006477": "protein sulfation",
  "GO:0006478": "peptidyl-tyrosine sulfation",
  "GO:0006479": "protein methylation",
  "GO:0006480": "N-terminal protein amino acid methylation",
  "GO:0006481": "C-terminal protein methylation",
  "GO:0006482": "protein demethylation",
  "GO:0006483": "obsolete peptidyl-aspartic acid/asparagine hydroxylation",
  "GO:0006484": "obsolete protein cysteine-thiol oxidation",
  "GO:0006486": "protein glycosylation",
  "GO:0006487": "protein N-linked glycosylation",
  "GO:0006488": "dolichol-linked oligosaccharide biosynthetic process",
  "GO:0006489": "dolichyl diphosphate biosynthetic process",
  "GO:0006490": "oligosaccharide-lipid intermediate biosynthetic process",
  "GO:0006491": "N-glycan processing",
  "GO:0006493": "protein O-linked glycosylation",
  "GO:0006494": "obsolete protein amino acid terminal glycosylation",
  "GO:0006495": "obsolete terminal O-glycosylation",
  "GO:0006496": "obsolete protein amino acid terminal N-glycosylation",
  "GO:0006497": "protein lipidation",
  "GO:0006498": "N-terminal protein lipidation",
  "GO:0006499": "N-terminal protein myristoylation",
  "GO:0006500": "N-terminal protein palmitoylation",
  "GO:0006501": "C-terminal protein lipidation",
  "GO:0006502": "obsolete C-terminal protein prenylation",
  "GO:0006503": "obsolete C-terminal protein farnesylation",
  "GO:0006504": "obsolete C-terminal protein geranylgeranylation",
  "GO:0006505": "GPI anchor metabolic process",
  "GO:0006506": "GPI anchor biosynthetic process",
  "GO:0006507": "GPI anchor release",
  "GO:0006508": "proteolysis",
  "GO:0006509": "membrane protein ectodomain proteolysis",
  "GO:0006510": "obsolete ATP-dependent proteolysis",
  "GO:0006511": "ubiquitin-dependent protein catabolic process",
  "GO:0006512": "obsolete ubiquitin cycle",
  "GO:0006513": "protein monoubiquitination",
  "GO:0006515": "misfolded or incompletely synthesized protein catabolic process",
  "GO:0006516": "glycoprotein catabolic process",
  "GO:0006517": "protein deglycosylation",
  "GO:0006518": "peptide metabolic process",
  "GO:0006520": "cellular amino acid metabolic process",
  "GO:0006521": "regulation of cellular amino acid metabolic process",
  "GO:0006522": "alanine metabolic process",
  "GO:0006523": "alanine biosynthetic process",
  "GO:0006524": "alanine catabolic process",
  "GO:0006525": "arginine metabolic process",
  "GO:0006526": "arginine biosynthetic process",
  "GO:0006527": "arginine catabolic process",
  "GO:0006528": "asparagine metabolic process",
  "GO:0006529": "asparagine biosynthetic process",
  "GO:0006530": "asparagine catabolic process",
  "GO:0006531": "aspartate metabolic process",
  "GO:0006532": "aspartate biosynthetic process",
  "GO:0006533": "aspartate catabolic process",
  "GO:0006534": "cysteine metabolic process",
  "GO:0006535": "cysteine biosynthetic process from serine",
  "GO:0006536": "glutamate metabolic process",
  "GO:0006537": "glutamate biosynthetic process",
  "GO:0006538": "glutamate catabolic process",
  "GO:0006539": "glutamate catabolic process via 2-oxoglutarate",
  "GO:0006540": "glutamate decarboxylation to succinate",
  "GO:0006541": "glutamine metabolic process",
  "GO:0006542": "glutamine biosynthetic process",
  "GO:0006543": "glutamine catabolic process",
  "GO:0006544": "glycine metabolic process",
  "GO:0006545": "glycine biosynthetic process",
  "GO:0006546": "glycine catabolic process",
  "GO:0006547": "histidine metabolic process",
  "GO:0006548": "histidine catabolic process",
  "GO:0006549": "isoleucine metabolic process",
  "GO:0006550": "isoleucine catabolic process",
  "GO:0006551": "leucine metabolic process",
  "GO:0006552": "leucine catabolic process",
  "GO:0006553": "lysine metabolic process",
  "GO:0006554": "lysine catabolic process",
  "GO:0006555": "methionine metabolic process",
  "GO:0006556": "S-adenosylmethionine biosynthetic process",
  "GO:0006557": "S-adenosylmethioninamine biosynthetic process",
  "GO:0006558": "L-phenylalanine metabolic process",
  "GO:0006559": "L-phenylalanine catabolic process",
  "GO:0006560": "proline metabolic process",
  "GO:0006561": "proline biosynthetic process",
  "GO:0006562": "proline catabolic process",
  "GO:0006563": "L-serine metabolic process",
  "GO:0006564": "L-serine biosynthetic process",
  "GO:0006565": "L-serine catabolic process",
  "GO:0006566": "threonine metabolic process",
  "GO:0006567": "threonine catabolic process",
  "GO:0006568": "tryptophan metabolic process",
  "GO:0006569": "tryptophan catabolic process",
  "GO:0006570": "tyrosine metabolic process",
  "GO:0006571": "tyrosine biosynthetic process",
  "GO:0006572": "tyrosine catabolic process",
  "GO:0006573": "valine metabolic process",
  "GO:0006574": "valine catabolic process",
  "GO:0006575": "cellular modified amino acid metabolic process",
  "GO:0006576": "cellular biogenic amine metabolic process",
  "GO:0006577": "amino-acid betaine metabolic process",
  "GO:0006578": "amino-acid betaine biosynthetic process",
  "GO:0006579": "amino-acid betaine catabolic process",
  "GO:0006580": "ethanolamine metabolic process",
  "GO:0006581": "acetylcholine catabolic process",
  "GO:0006582": "melanin metabolic process",
  "GO:0006583": "melanin biosynthetic process from tyrosine",
  "GO:0006584": "catecholamine metabolic process",
  "GO:0006585": "dopamine biosynthetic process from tyrosine",
  "GO:0006586": "indolalkylamine metabolic process",
  "GO:0006587": "serotonin biosynthetic process from tryptophan",
  "GO:0006588": "activation of tryptophan 5-monooxygenase activity",
  "GO:0006589": "octopamine biosynthetic process",
  "GO:0006590": "thyroid hormone generation",
  "GO:0006591": "ornithine metabolic process",
  "GO:0006592": "ornithine biosynthetic process",
  "GO:0006593": "ornithine catabolic process",
  "GO:0006595": "polyamine metabolic process",
  "GO:0006596": "polyamine biosynthetic process",
  "GO:0006597": "spermine biosynthetic process",
  "GO:0006598": "polyamine catabolic process",
  "GO:0006599": "phosphagen metabolic process",
  "GO:0006600": "creatine metabolic process",
  "GO:0006601": "creatine biosynthetic process",
  "GO:0006602": "creatinine catabolic process",
  "GO:0006603": "phosphocreatine metabolic process",
  "GO:0006604": "phosphoarginine metabolic process",
  "GO:0006605": "protein targeting",
  "GO:0006606": "protein import into nucleus",
  "GO:0006607": "NLS-bearing protein import into nucleus",
  "GO:0006608": "snRNP protein import into nucleus",
  "GO:0006609": "mRNA-binding (hnRNP) protein import into nucleus",
  "GO:0006610": "ribosomal protein import into nucleus",
  "GO:0006611": "protein export from nucleus",
  "GO:0006612": "protein targeting to membrane",
  "GO:0006613": "cotranslational protein targeting to membrane",
  "GO:0006614": "SRP-dependent cotranslational protein targeting to membrane",
  "GO:0006615": "SRP-dependent cotranslational protein targeting to membrane, docking",
  "GO:0006616": "SRP-dependent cotranslational protein targeting to membrane, translocation",
  "GO:0006617": "SRP-dependent cotranslational protein targeting to membrane, signal sequence recognition",
  "GO:0006618": "SRP-dependent cotranslational protein targeting to membrane, signal sequence processing",
  "GO:0006619": "obsolete SRP-independent cotranslational protein-membrane targeting",
  "GO:0006620": "posttranslational protein targeting to membrane",
  "GO:0006621": "protein retention in ER lumen",
  "GO:0006622": "protein targeting to lysosome",
  "GO:0006623": "protein targeting to vacuole",
  "GO:0006624": "vacuolar protein processing",
  "GO:0006625": "protein targeting to peroxisome",
  "GO:0006626": "protein targeting to mitochondrion",
  "GO:0006627": "protein processing involved in protein targeting to mitochondrion",
  "GO:0006628": "obsolete mitochondrial translocation",
  "GO:0006629": "lipid metabolic process",
  "GO:0006630": "obsolete lipid binding",
  "GO:0006631": "fatty acid metabolic process",
  "GO:0006633": "fatty acid biosynthetic process",
  "GO:0006634": "hexadecanal biosynthetic process",
  "GO:0006635": "fatty acid beta-oxidation",
  "GO:0006636": "unsaturated fatty acid biosynthetic process",
  "GO:0006637": "acyl-CoA metabolic process",
  "GO:0006638": "neutral lipid metabolic process",
  "GO:0006639": "acylglycerol metabolic process",
  "GO:0006640": "monoacylglycerol biosynthetic process",
  "GO:0006641": "triglyceride metabolic process",
  "GO:0006642": "triglyceride mobilization",
  "GO:0006643": "membrane lipid metabolic process",
  "GO:0006644": "phospholipid metabolic process",
  "GO:0006646": "phosphatidylethanolamine biosynthetic process",
  "GO:0006647": "phosphatidyl-N-monomethylethanolamine biosynthetic process",
  "GO:0006648": "dihydrosphingosine-1-P pathway",
  "GO:0006649": "phospholipid transfer to membrane",
  "GO:0006650": "glycerophospholipid metabolic process",
  "GO:0006651": "diacylglycerol biosynthetic process",
  "GO:0006653": "1,2-diacyl-sn-glycero-3-phosphocholine metabolic process",
  "GO:0006654": "phosphatidic acid biosynthetic process",
  "GO:0006655": "phosphatidylglycerol biosynthetic process",
  "GO:0006656": "phosphatidylcholine biosynthetic process",
  "GO:0006657": "CDP-choline pathway",
  "GO:0006658": "phosphatidylserine metabolic process",
  "GO:0006659": "phosphatidylserine biosynthetic process",
  "GO:0006660": "phosphatidylserine catabolic process",
  "GO:0006661": "phosphatidylinositol biosynthetic process",
  "GO:0006662": "glycerol ether metabolic process",
  "GO:0006663": "platelet activating factor biosynthetic process",
  "GO:0006664": "glycolipid metabolic process",
  "GO:0006665": "sphingolipid metabolic process",
  "GO:0006666": "3-keto-sphinganine metabolic process",
  "GO:0006667": "sphinganine metabolic process",
  "GO:0006668": "sphinganine-1-phosphate metabolic process",
  "GO:0006669": "sphinganine-1-phosphate biosynthetic process",
  "GO:0006670": "sphingosine metabolic process",
  "GO:0006671": "phytosphingosine metabolic process",
  "GO:0006672": "ceramide metabolic process",
  "GO:0006673": "inositolphosphoceramide metabolic process",
  "GO:0006675": "mannosyl-inositol phosphorylceramide metabolic process",
  "GO:0006676": "mannosyl diphosphorylinositol ceramide metabolic process",
  "GO:0006677": "glycosylceramide metabolic process",
  "GO:0006678": "glucosylceramide metabolic process",
  "GO:0006679": "glucosylceramide biosynthetic process",
  "GO:0006680": "glucosylceramide catabolic process",
  "GO:0006681": "galactosylceramide metabolic process",
  "GO:0006682": "galactosylceramide biosynthetic process",
  "GO:0006683": "galactosylceramide catabolic process",
  "GO:0006684": "sphingomyelin metabolic process",
  "GO:0006685": "sphingomyelin catabolic process",
  "GO:0006686": "sphingomyelin biosynthetic process",
  "GO:0006687": "glycosphingolipid metabolic process",
  "GO:0006688": "glycosphingolipid biosynthetic process",
  "GO:0006689": "ganglioside catabolic process",
  "GO:0006690": "icosanoid metabolic process",
  "GO:0006691": "leukotriene metabolic process",
  "GO:0006692": "prostanoid metabolic process",
  "GO:0006693": "prostaglandin metabolic process",
  "GO:0006694": "steroid biosynthetic process",
  "GO:0006695": "cholesterol biosynthetic process",
  "GO:0006696": "ergosterol biosynthetic process",
  "GO:0006697": "ecdysone biosynthetic process",
  "GO:0006698": "obsolete ecdysone modification",
  "GO:0006699": "bile acid biosynthetic process",
  "GO:0006700": "C21-steroid hormone biosynthetic process",
  "GO:0006701": "progesterone biosynthetic process",
  "GO:0006702": "androgen biosynthetic process",
  "GO:0006703": "estrogen biosynthetic process",
  "GO:0006704": "glucocorticoid biosynthetic process",
  "GO:0006705": "mineralocorticoid biosynthetic process",
  "GO:0006706": "steroid catabolic process",
  "GO:0006707": "cholesterol catabolic process",
  "GO:0006708": "ecdysone catabolic process",
  "GO:0006709": "progesterone catabolic process",
  "GO:0006710": "androgen catabolic process",
  "GO:0006711": "estrogen catabolic process",
  "GO:0006712": "mineralocorticoid catabolic process",
  "GO:0006713": "glucocorticoid catabolic process",
  "GO:0006714": "sesquiterpenoid metabolic process",
  "GO:0006715": "farnesol biosynthetic process",
  "GO:0006716": "juvenile hormone metabolic process",
  "GO:0006717": "obsolete juvenile hormone binding",
  "GO:0006718": "juvenile hormone biosynthetic process",
  "GO:0006719": "juvenile hormone catabolic process",
  "GO:0006720": "isoprenoid metabolic process",
  "GO:0006721": "terpenoid metabolic process",
  "GO:0006722": "triterpenoid metabolic process",
  "GO:0006723": "cuticle hydrocarbon biosynthetic process",
  "GO:0006725": "cellular aromatic compound metabolic process",
  "GO:0006726": "eye pigment biosynthetic process",
  "GO:0006727": "ommochrome biosynthetic process",
  "GO:0006728": "pteridine biosynthetic process",
  "GO:0006729": "tetrahydrobiopterin biosynthetic process",
  "GO:0006730": "one-carbon metabolic process",
  "GO:0006731": "obsolete coenzyme and prosthetic group metabolic process",
  "GO:0006732": "coenzyme metabolic process",
  "GO:0006733": "oxidoreduction coenzyme metabolic process",
  "GO:0006734": "NADH metabolic process",
  "GO:0006735": "NADH regeneration",
  "GO:0006738": "nicotinamide riboside catabolic process",
  "GO:0006739": "NADP metabolic process",
  "GO:0006740": "NADPH regeneration",
  "GO:0006741": "NADP biosynthetic process",
  "GO:0006742": "NADP catabolic process",
  "GO:0006743": "ubiquinone metabolic process",
  "GO:0006744": "ubiquinone biosynthetic process",
  "GO:0006746": "FADH2 metabolic process",
  "GO:0006747": "FAD biosynthetic process",
  "GO:0006748": "lipoamide metabolic process",
  "GO:0006749": "glutathione metabolic process",
  "GO:0006750": "glutathione biosynthetic process",
  "GO:0006751": "glutathione catabolic process",
  "GO:0006753": "nucleoside phosphate metabolic process",
  "GO:0006754": "ATP biosynthetic process",
  "GO:0006755": "obsolete carbamoyl phosphate-ADP transphosphorylation",
  "GO:0006756": "AMP phosphorylation",
  "GO:0006757": "ATP generation from ADP",
  "GO:0006760": "folic acid-containing compound metabolic process",
  "GO:0006761": "dihydrofolate biosynthetic process",
  "GO:0006762": "obsolete dihydrofolate reduction",
  "GO:0006766": "vitamin metabolic process",
  "GO:0006767": "water-soluble vitamin metabolic process",
  "GO:0006768": "biotin metabolic process",
  "GO:0006769": "nicotinamide metabolic process",
  "GO:0006771": "riboflavin metabolic process",
  "GO:0006772": "thiamine metabolic process",
  "GO:0006774": "obsolete vitamin B12 reduction",
  "GO:0006775": "fat-soluble vitamin metabolic process",
  "GO:0006776": "vitamin A metabolic process",
  "GO:0006777": "Mo-molybdopterin cofactor biosynthetic process",
  "GO:0006778": "porphyrin-containing compound metabolic process",
  "GO:0006779": "porphyrin-containing compound biosynthetic process",
  "GO:0006780": "uroporphyrinogen III biosynthetic process",
  "GO:0006781": "succinyl-CoA pathway",
  "GO:0006782": "protoporphyrinogen IX biosynthetic process",
  "GO:0006783": "heme biosynthetic process",
  "GO:0006784": "heme a biosynthetic process",
  "GO:0006785": "heme b biosynthetic process",
  "GO:0006786": "heme c biosynthetic process",
  "GO:0006787": "porphyrin-containing compound catabolic process",
  "GO:0006788": "heme oxidation",
  "GO:0006789": "bilirubin conjugation",
  "GO:0006790": "sulfur compound metabolic process",
  "GO:0006791": "sulfur utilization",
  "GO:0006792": "regulation of sulfur utilization",
  "GO:0006793": "phosphorus metabolic process",
  "GO:0006794": "phosphorus utilization",
  "GO:0006795": "regulation of phosphorus utilization",
  "GO:0006796": "phosphate-containing compound metabolic process",
  "GO:0006797": "polyphosphate metabolic process",
  "GO:0006798": "polyphosphate catabolic process",
  "GO:0006799": "polyphosphate biosynthetic process",
  "GO:0006800": "obsolete oxygen and reactive oxygen species metabolic process",
  "GO:0006801": "superoxide metabolic process",
  "GO:0006802": "obsolete catalase reaction",
  "GO:0006803": "obsolete glutathione conjugation reaction",
  "GO:0006804": "obsolete peroxidase reaction",
  "GO:0006805": "xenobiotic metabolic process",
  "GO:0006806": "obsolete insecticide resistance",
  "GO:0006807": "nitrogen compound metabolic process",
  "GO:0006808": "regulation of nitrogen utilization",
  "GO:0006809": "nitric oxide biosynthetic process",
  "GO:0006810": "transport",
  "GO:0006811": "ion transport",
  "GO:0006812": "cation transport",
  "GO:0006813": "potassium ion transport",
  "GO:0006814": "sodium ion transport",
  "GO:0006815": "obsolete sodium/potassium transport",
  "GO:0006816": "calcium ion transport",
  "GO:0006817": "phosphate ion transport",
  "GO:0006818": "hydrogen transport",
  "GO:0006820": "anion transport",
  "GO:0006821": "chloride transport",
  "GO:0006823": "obsolete heavy metal ion transport",
  "GO:0006824": "cobalt ion transport",
  "GO:0006825": "copper ion transport",
  "GO:0006826": "iron ion transport",
  "GO:0006827": "high-affinity iron ion transmembrane transport",
  "GO:0006828": "manganese ion transport",
  "GO:0006829": "zinc II ion transport",
  "GO:0006830": "high-affinity zinc II ion transport",
  "GO:0006831": "low-affinity zinc II ion transport",
  "GO:0006832": "obsolete small molecule transport",
  "GO:0006833": "water transport",
  "GO:0006835": "dicarboxylic acid transport",
  "GO:0006836": "neurotransmitter transport",
  "GO:0006837": "serotonin transport",
  "GO:0006838": "obsolete allantoin/allantoate transport",
  "GO:0006839": "mitochondrial transport",
  "GO:0006840": "obsolete mitochondrial alpha-ketoglutarate/malate transport",
  "GO:0006842": "tricarboxylic acid transport",
  "GO:0006843": "mitochondrial citrate transport",
  "GO:0006844": "acyl carnitine transport",
  "GO:0006845": "obsolete mitochondrial aspartate/glutamate transport",
  "GO:0006846": "acetate transport",
  "GO:0006847": "plasma membrane acetate transport",
  "GO:0006848": "pyruvate transport",
  "GO:0006849": "plasma membrane pyruvate transport",
  "GO:0006850": "mitochondrial pyruvate transport",
  "GO:0006851": "mitochondrial calcium ion transport",
  "GO:0006852": "obsolete mitochondrial sodium/calcium ion exchange",
  "GO:0006853": "carnitine shuttle",
  "GO:0006854": "obsolete ATP/ADP exchange",
  "GO:0006855": "drug transmembrane transport",
  "GO:0006856": "eye pigment precursor transport",
  "GO:0006857": "oligopeptide transport",
  "GO:0006858": "extracellular transport",
  "GO:0006859": "extracellular carbohydrate transport",
  "GO:0006860": "extracellular amino acid transport",
  "GO:0006862": "nucleotide transport",
  "GO:0006863": "purine nucleobase transport",
  "GO:0006864": "pyrimidine nucleotide transport",
  "GO:0006865": "amino acid transport",
  "GO:0006867": "asparagine transport",
  "GO:0006868": "glutamine transport",
  "GO:0006869": "lipid transport",
  "GO:0006873": "cellular ion homeostasis",
  "GO:0006874": "cellular calcium ion homeostasis",
  "GO:0006875": "cellular metal ion homeostasis",
  "GO:0006876": "cellular cadmium ion homeostasis",
  "GO:0006877": "cellular cobalt ion homeostasis",
  "GO:0006878": "cellular copper ion homeostasis",
  "GO:0006879": "cellular iron ion homeostasis",
  "GO:0006880": "intracellular sequestering of iron ion",
  "GO:0006881": "extracellular sequestering of iron ion",
  "GO:0006882": "cellular zinc ion homeostasis",
  "GO:0006883": "cellular sodium ion homeostasis",
  "GO:0006884": "cell volume homeostasis",
  "GO:0006885": "regulation of pH",
  "GO:0006886": "intracellular protein transport",
  "GO:0006887": "exocytosis",
  "GO:0006888": "ER to Golgi vesicle-mediated transport",
  "GO:0006889": "obsolete regulation of calcium in ER",
  "GO:0006890": "retrograde vesicle-mediated transport, Golgi to ER",
  "GO:0006891": "intra-Golgi vesicle-mediated transport",
  "GO:0006892": "post-Golgi vesicle-mediated transport",
  "GO:0006893": "Golgi to plasma membrane transport",
  "GO:0006894": "obsolete Golgi to secretory vesicle transport",
  "GO:0006895": "Golgi to endosome transport",
  "GO:0006896": "Golgi to vacuole transport",
  "GO:0006897": "endocytosis",
  "GO:0006898": "receptor-mediated endocytosis",
  "GO:0006900": "membrane budding",
  "GO:0006901": "vesicle coating",
  "GO:0006903": "vesicle targeting",
  "GO:0006904": "vesicle docking involved in exocytosis",
  "GO:0006905": "obsolete vesicle transport",
  "GO:0006906": "vesicle fusion",
  "GO:0006907": "pinocytosis",
  "GO:0006909": "phagocytosis",
  "GO:0006910": "phagocytosis, recognition",
  "GO:0006911": "phagocytosis, engulfment",
  "GO:0006912": "obsolete phagosome formation",
  "GO:0006913": "nucleocytoplasmic transport",
  "GO:0006914": "autophagy",
  "GO:0006915": "apoptotic process",
  "GO:0006918": "obsolete induction of apoptosis by p53",
  "GO:0006919": "activation of cysteine-type endopeptidase activity involved in apoptotic process",
  "GO:0006920": "obsolete commitment to apoptosis",
  "GO:0006921": "cellular component disassembly involved in execution phase of apoptosis",
  "GO:0006922": "obsolete cleavage of lamin involved in execution phase of apoptosis",
  "GO:0006923": "obsolete cleavage of cytoskeletal proteins involved in execution phase of apoptosis",
  "GO:0006924": "activation-induced cell death of T cells",
  "GO:0006925": "inflammatory cell apoptotic process",
  "GO:0006926": "obsolete virus-infected cell apoptotic process",
  "GO:0006927": "transformed cell apoptotic process",
  "GO:0006928": "movement of cell or subcellular component",
  "GO:0006929": "substrate-dependent cell migration",
  "GO:0006930": "substrate-dependent cell migration, cell extension",
  "GO:0006931": "substrate-dependent cell migration, cell attachment to substrate",
  "GO:0006932": "substrate-dependent cell migration, cell contraction",
  "GO:0006933": "negative regulation of cell adhesion involved in substrate-bound cell migration",
  "GO:0006934": "substrate-bound cell migration, adhesion receptor recycling",
  "GO:0006935": "chemotaxis",
  "GO:0006936": "muscle contraction",
  "GO:0006937": "regulation of muscle contraction",
  "GO:0006939": "smooth muscle contraction",
  "GO:0006940": "regulation of smooth muscle contraction",
  "GO:0006941": "striated muscle contraction",
  "GO:0006942": "regulation of striated muscle contraction",
  "GO:0006943": "obsolete chemi-mechanical coupling",
  "GO:0006945": "obsolete nuclear fusion during karyogamy",
  "GO:0006948": "induction by virus of host cell-cell fusion",
  "GO:0006949": "syncytium formation",
  "GO:0006950": "response to stress",
  "GO:0006952": "defense response",
  "GO:0006953": "acute-phase response",
  "GO:0006954": "inflammatory response",
  "GO:0006955": "immune response",
  "GO:0006956": "complement activation",
  "GO:0006957": "complement activation, alternative pathway",
  "GO:0006958": "complement activation, classical pathway",
  "GO:0006959": "humoral immune response",
  "GO:0006962": "male-specific antibacterial humoral response",
  "GO:0006963": "positive regulation of antibacterial peptide biosynthetic process",
  "GO:0006964": "positive regulation of biosynthetic process of antibacterial peptides active against Gram-negative bacteria",
  "GO:0006965": "positive regulation of biosynthetic process of antibacterial peptides active against Gram-positive bacteria",
  "GO:0006967": "positive regulation of antifungal peptide biosynthetic process",
  "GO:0006968": "cellular defense response",
  "GO:0006969": "obsolete melanotic tumor response",
  "GO:0006970": "response to osmotic stress",
  "GO:0006971": "hypotonic response",
  "GO:0006972": "hyperosmotic response",
  "GO:0006973": "intracellular accumulation of glycerol",
  "GO:0006974": "cellular response to DNA damage stimulus",
  "GO:0006975": "DNA damage induced protein phosphorylation",
  "GO:0006977": "DNA damage response, signal transduction by p53 class mediator resulting in cell cycle arrest",
  "GO:0006978": "DNA damage response, signal transduction by p53 class mediator resulting in transcription of p21 class mediator",
  "GO:0006979": "response to oxidative stress",
  "GO:0006981": "activation of SoxR protein",
  "GO:0006982": "response to lipid hydroperoxide",
  "GO:0006983": "ER overload response",
  "GO:0006984": "ER-nucleus signaling pathway",
  "GO:0006985": "positive regulation of NF-kappaB transcription factor activity by ER overload response",
  "GO:0006986": "response to unfolded protein",
  "GO:0006987": "activation of signaling protein activity involved in unfolded protein response",
  "GO:0006988": "obsolete unfolded protein response, cleavage of primary transcript encoding UFP-specific transcription factor",
  "GO:0006989": "obsolete unfolded protein response, ligation of mRNA encoding UFP-specific transcription factor by RNA ligase",
  "GO:0006990": "positive regulation of transcription from RNA polymerase II promoter involved in unfolded protein response",
  "GO:0006991": "response to sterol depletion",
  "GO:0006995": "cellular response to nitrogen starvation",
  "GO:0006996": "organelle organization",
  "GO:0006997": "nucleus organization",
  "GO:0006998": "nuclear envelope organization",
  "GO:0006999": "nuclear pore organization",
  "GO:0007000": "nucleolus organization",
  "GO:0007002": "obsolete centromere binding",
  "GO:0007003": "obsolete telomere binding",
  "GO:0007004": "telomere maintenance via telomerase",
  "GO:0007005": "mitochondrion organization",
  "GO:0007006": "mitochondrial membrane organization",
  "GO:0007007": "inner mitochondrial membrane organization",
  "GO:0007008": "outer mitochondrial membrane organization",
  "GO:0007009": "plasma membrane organization",
  "GO:0007010": "cytoskeleton organization",
  "GO:0007011": "obsolete regulation of cytoskeleton",
  "GO:0007014": "actin ubiquitination",
  "GO:0007015": "actin filament organization",
  "GO:0007016": "cytoskeletal anchoring at plasma membrane",
  "GO:0007017": "microtubule-based process",
  "GO:0007018": "microtubule-based movement",
  "GO:0007019": "microtubule depolymerization",
  "GO:0007020": "microtubule nucleation",
  "GO:0007021": "tubulin complex assembly",
  "GO:0007023": "post-chaperonin tubulin folding pathway",
  "GO:0007026": "negative regulation of microtubule depolymerization",
  "GO:0007027": "negative regulation of axonemal microtubule depolymerization",
  "GO:0007028": "cytoplasm organization",
  "GO:0007029": "endoplasmic reticulum organization",
  "GO:0007030": "Golgi organization",
  "GO:0007031": "peroxisome organization",
  "GO:0007032": "endosome organization",
  "GO:0007033": "vacuole organization",
  "GO:0007034": "vacuolar transport",
  "GO:0007035": "vacuolar acidification",
  "GO:0007036": "vacuolar calcium ion homeostasis",
  "GO:0007037": "vacuolar phosphate transport",
  "GO:0007038": "endocytosed protein transport to vacuole",
  "GO:0007039": "protein catabolic process in the vacuole",
  "GO:0007040": "lysosome organization",
  "GO:0007041": "lysosomal transport",
  "GO:0007042": "lysosomal lumen acidification",
  "GO:0007043": "cell-cell junction assembly",
  "GO:0007044": "cell-substrate junction assembly",
  "GO:0007045": "cell-substrate adherens junction assembly",
  "GO:0007048": "obsolete oncogenesis",
  "GO:0007049": "cell cycle",
  "GO:0007050": "cell cycle arrest",
  "GO:0007051": "spindle organization",
  "GO:0007052": "mitotic spindle organization",
  "GO:0007053": "spindle assembly involved in male meiosis",
  "GO:0007054": "spindle assembly involved in male meiosis I",
  "GO:0007055": "spindle assembly involved in male meiosis II",
  "GO:0007056": "spindle assembly involved in female meiosis",
  "GO:0007057": "spindle assembly involved in female meiosis I",
  "GO:0007058": "spindle assembly involved in female meiosis II",
  "GO:0007059": "chromosome segregation",
  "GO:0007060": "male meiosis chromosome segregation",
  "GO:0007062": "sister chromatid cohesion",
  "GO:0007063": "regulation of sister chromatid cohesion",
  "GO:0007064": "mitotic sister chromatid cohesion",
  "GO:0007065": "male meiosis sister chromatid cohesion",
  "GO:0007066": "female meiosis sister chromatid cohesion",
  "GO:0007067": "mitotic nuclear division",
  "GO:0007068": "negative regulation of transcription during mitosis",
  "GO:0007069": "negative regulation of transcription from RNA polymerase I promoter during mitosis",
  "GO:0007070": "negative regulation of transcription from RNA polymerase II promoter during mitosis",
  "GO:0007071": "negative regulation of transcription from RNA polymerase III promoter during mitosis",
  "GO:0007072": "positive regulation of transcription involved in exit from mitosis",
  "GO:0007073": "positive regulation of transcription involved in exit from mitosis, from RNA polymerase I promoter",
  "GO:0007074": "positive regulation of transcription involved in exit from mitosis, from RNA polymerase II promoter",
  "GO:0007075": "positive regulation of transcription involved in exit from mitosis, from RNA polymerase III promoter",
  "GO:0007076": "mitotic chromosome condensation",
  "GO:0007077": "mitotic nuclear envelope disassembly",
  "GO:0007078": "lamin depolymerization",
  "GO:0007079": "mitotic chromosome movement towards spindle pole",
  "GO:0007080": "mitotic metaphase plate congression",
  "GO:0007081": "obsolete mitotic sister-chromatid adhesion release",
  "GO:0007083": "mitotic chromosome decondensation",
  "GO:0007084": "mitotic nuclear envelope reassembly",
  "GO:0007085": "obsolete nuclear membrane vesicle binding to chromatin",
  "GO:0007086": "vesicle fusion with nuclear membrane involved in mitotic nuclear envelope reassembly",
  "GO:0007087": "mitotic nuclear pore complex reassembly",
  "GO:0007088": "regulation of mitotic nuclear division",
  "GO:0007089": "traversing start control point of mitotic cell cycle",
  "GO:0007090": "obsolete regulation of S phase of mitotic cell cycle",
  "GO:0007091": "metaphase/anaphase transition of mitotic cell cycle",
  "GO:0007092": "activation of APC-Cdc20 complex activity",
  "GO:0007093": "mitotic cell cycle checkpoint",
  "GO:0007094": "mitotic spindle assembly checkpoint",
  "GO:0007095": "mitotic G2 DNA damage checkpoint",
  "GO:0007096": "regulation of exit from mitosis",
  "GO:0007097": "nuclear migration",
  "GO:0007098": "centrosome cycle",
  "GO:0007099": "centriole replication",
  "GO:0007100": "mitotic centrosome separation",
  "GO:0007101": "male meiosis centrosome cycle",
  "GO:0007105": "cytokinesis, site selection",
  "GO:0007106": "obsolete cytokinesis, protein recruitment",
  "GO:0007107": "membrane addition at site of cytokinesis",
  "GO:0007108": "obsolete cytokinesis, initiation of separation",
  "GO:0007109": "obsolete cytokinesis, completion of separation",
  "GO:0007110": "meiosis I cytokinesis",
  "GO:0007111": "meiosis II cytokinesis",
  "GO:0007112": "male meiosis cytokinesis",
  "GO:0007113": "endomitotic cell cycle",
  "GO:0007114": "cell budding",
  "GO:0007115": "obsolete bud site selection/establishment of cell polarity (sensu Saccharomyces)",
  "GO:0007116": "regulation of cell budding",
  "GO:0007117": "budding cell bud growth",
  "GO:0007118": "budding cell apical bud growth",
  "GO:0007119": "budding cell isotropic bud growth",
  "GO:0007120": "axial cellular bud site selection",
  "GO:0007121": "bipolar cellular bud site selection",
  "GO:0007122": "obsolete loss of asymmetric budding",
  "GO:0007123": "obsolete bud scar accumulation",
  "GO:0007124": "pseudohyphal growth",
  "GO:0007125": "obsolete invasive growth",
  "GO:0007126": "meiotic nuclear division",
  "GO:0007127": "meiosis I",
  "GO:0007128": "meiotic prophase I",
  "GO:0007129": "synapsis",
  "GO:0007130": "synaptonemal complex assembly",
  "GO:0007131": "reciprocal meiotic recombination",
  "GO:0007132": "meiotic metaphase I",
  "GO:0007133": "meiotic anaphase I",
  "GO:0007134": "meiotic telophase I",
  "GO:0007135": "meiosis II",
  "GO:0007136": "meiotic prophase II",
  "GO:0007137": "meiotic metaphase II",
  "GO:0007138": "meiotic anaphase II",
  "GO:0007139": "meiotic telophase II",
  "GO:0007140": "male meiosis",
  "GO:0007141": "male meiosis I",
  "GO:0007142": "male meiosis II",
  "GO:0007143": "female meiotic division",
  "GO:0007144": "female meiosis I",
  "GO:0007146": "meiotic recombination nodule assembly",
  "GO:0007147": "female meiosis II",
  "GO:0007149": "obsolete colony morphology",
  "GO:0007150": "obsolete growth pattern",
  "GO:0007154": "cell communication",
  "GO:0007155": "cell adhesion",
  "GO:0007156": "homophilic cell adhesion via plasma membrane adhesion molecules",
  "GO:0007157": "heterophilic cell-cell adhesion via plasma membrane cell adhesion molecules",
  "GO:0007158": "neuron cell-cell adhesion",
  "GO:0007159": "leukocyte cell-cell adhesion",
  "GO:0007160": "cell-matrix adhesion",
  "GO:0007161": "calcium-independent cell-matrix adhesion",
  "GO:0007162": "negative regulation of cell adhesion",
  "GO:0007163": "establishment or maintenance of cell polarity",
  "GO:0007164": "establishment of tissue polarity",
  "GO:0007165": "signal transduction",
  "GO:0007166": "cell surface receptor signaling pathway",
  "GO:0007167": "enzyme linked receptor protein signaling pathway",
  "GO:0007168": "receptor guanylyl cyclase signaling pathway",
  "GO:0007169": "transmembrane receptor protein tyrosine kinase signaling pathway",
  "GO:0007170": "obsolete transmembrane receptor protein tyrosine kinase ligand binding",
  "GO:0007171": "activation of transmembrane receptor protein tyrosine kinase activity",
  "GO:0007172": "signal complex assembly",
  "GO:0007173": "epidermal growth factor receptor signaling pathway",
  "GO:0007174": "epidermal growth factor catabolic process",
  "GO:0007175": "negative regulation of epidermal growth factor-activated receptor activity",
  "GO:0007176": "regulation of epidermal growth factor-activated receptor activity",
  "GO:0007178": "transmembrane receptor protein serine/threonine kinase signaling pathway",
  "GO:0007179": "transforming growth factor beta receptor signaling pathway",
  "GO:0007180": "obsolete transforming growth factor beta ligand binding to type II receptor",
  "GO:0007181": "transforming growth factor beta receptor complex assembly",
  "GO:0007182": "common-partner SMAD protein phosphorylation",
  "GO:0007183": "SMAD protein complex assembly",
  "GO:0007184": "SMAD protein import into nucleus",
  "GO:0007185": "transmembrane receptor protein tyrosine phosphatase signaling pathway",
  "GO:0007186": "G-protein coupled receptor signaling pathway",
  "GO:0007187": "G-protein coupled receptor signaling pathway, coupled to cyclic nucleotide second messenger",
  "GO:0007188": "adenylate cyclase-modulating G-protein coupled receptor signaling pathway",
  "GO:0007189": "adenylate cyclase-activating G-protein coupled receptor signaling pathway",
  "GO:0007190": "activation of adenylate cyclase activity",
  "GO:0007191": "adenylate cyclase-activating dopamine receptor signaling pathway",
  "GO:0007192": "adenylate cyclase-activating serotonin receptor signaling pathway",
  "GO:0007193": "adenylate cyclase-inhibiting G-protein coupled receptor signaling pathway",
  "GO:0007194": "negative regulation of adenylate cyclase activity",
  "GO:0007195": "adenylate cyclase-inhibiting dopamine receptor signaling pathway",
  "GO:0007196": "adenylate cyclase-inhibiting G-protein coupled glutamate receptor signaling pathway",
  "GO:0007197": "adenylate cyclase-inhibiting G-protein coupled acetylcholine receptor signaling pathway",
  "GO:0007198": "adenylate cyclase-inhibiting serotonin receptor signaling pathway",
  "GO:0007199": "G-protein coupled receptor signaling pathway coupled to cGMP nucleotide second messenger",
  "GO:0007200": "phospholipase C-activating G-protein coupled receptor signaling pathway",
  "GO:0007201": "obsolete G-protein dissociation",
  "GO:0007202": "activation of phospholipase C activity",
  "GO:0007203": "obsolete phosphatidylinositol-4,5-bisphosphate hydrolysis",
  "GO:0007204": "positive regulation of cytosolic calcium ion concentration",
  "GO:0007205": "protein kinase C-activating G-protein coupled receptor signaling pathway",
  "GO:0007206": "phospholipase C-activating G-protein coupled glutamate receptor signaling pathway",
  "GO:0007207": "phospholipase C-activating G-protein coupled acetylcholine receptor signaling pathway",
  "GO:0007208": "phospholipase C-activating serotonin receptor signaling pathway",
  "GO:0007209": "phospholipase C-activating tachykinin receptor signaling pathway",
  "GO:0007210": "serotonin receptor signaling pathway",
  "GO:0007211": "octopamine or tyramine signaling pathway",
  "GO:0007212": "dopamine receptor signaling pathway",
  "GO:0007213": "G-protein coupled acetylcholine receptor signaling pathway",
  "GO:0007214": "gamma-aminobutyric acid signaling pathway",
  "GO:0007215": "glutamate receptor signaling pathway",
  "GO:0007216": "G-protein coupled glutamate receptor signaling pathway",
  "GO:0007217": "tachykinin receptor signaling pathway",
  "GO:0007218": "neuropeptide signaling pathway",
  "GO:0007219": "Notch signaling pathway",
  "GO:0007220": "Notch receptor processing",
  "GO:0007221": "positive regulation of transcription of Notch receptor target",
  "GO:0007223": "Wnt signaling pathway, calcium modulating pathway",
  "GO:0007224": "smoothened signaling pathway",
  "GO:0007225": "patched ligand maturation",
  "GO:0007227": "signal transduction downstream of smoothened",
  "GO:0007228": "positive regulation of hh target transcription factor activity",
  "GO:0007229": "integrin-mediated signaling pathway",
  "GO:0007230": "obsolete calcium-o-sensing receptor pathway",
  "GO:0007231": "osmosensory signaling pathway",
  "GO:0007232": "osmosensory signaling pathway via Sho1 osmosensor",
  "GO:0007234": "osmosensory signaling via phosphorelay pathway",
  "GO:0007235": "obsolete activation of Ypd1 protein",
  "GO:0007236": "obsolete activation of Ssk1 protein",
  "GO:0007237": "obsolete activation of Ssk2/Ssk22 proteins",
  "GO:0007238": "obsolete activation of Pbs2",
  "GO:0007239": "obsolete activation of Hog1",
  "GO:0007240": "obsolete nuclear translocation of Hog1",
  "GO:0007241": "obsolete inactivation of Hog1",
  "GO:0007244": "obsolete MAPKKK cascade (mating sensu Saccharomyces)",
  "GO:0007245": "obsolete activation of MAPKKK (mating sensu Saccharomyces)",
  "GO:0007246": "obsolete activation of MAPKK (mating sensu Saccharomyces)",
  "GO:0007247": "obsolete activation of MAPK (mating sensu Saccharomyces)",
  "GO:0007248": "obsolete nuclear translocation of MAPK (mating sensu Saccharomyces)",
  "GO:0007249": "I-kappaB kinase/NF-kappaB signaling",
  "GO:0007250": "activation of NF-kappaB-inducing kinase activity",
  "GO:0007251": "obsolete activation of the inhibitor of kappa kinase",
  "GO:0007252": "I-kappaB phosphorylation",
  "GO:0007253": "cytoplasmic sequestering of NF-kappaB",
  "GO:0007254": "JNK cascade",
  "GO:0007256": "activation of JNKK activity",
  "GO:0007257": "activation of JUN kinase activity",
  "GO:0007258": "JUN phosphorylation",
  "GO:0007259": "JAK-STAT cascade",
  "GO:0007260": "tyrosine phosphorylation of STAT protein",
  "GO:0007261": "obsolete JAK-induced STAT protein dimerization",
  "GO:0007262": "STAT protein import into nucleus",
  "GO:0007263": "nitric oxide mediated signal transduction",
  "GO:0007264": "small GTPase mediated signal transduction",
  "GO:0007265": "Ras protein signal transduction",
  "GO:0007266": "Rho protein signal transduction",
  "GO:0007267": "cell-cell signaling",
  "GO:0007268": "synaptic transmission",
  "GO:0007269": "neurotransmitter secretion",
  "GO:0007270": "neuron-neuron synaptic transmission",
  "GO:0007271": "synaptic transmission, cholinergic",
  "GO:0007272": "ensheathment of neurons",
  "GO:0007273": "obsolete regulation of synapse",
  "GO:0007274": "neuromuscular synaptic transmission",
  "GO:0007275": "multicellular organism development",
  "GO:0007276": "gamete generation",
  "GO:0007277": "pole cell development",
  "GO:0007278": "pole cell fate determination",
  "GO:0007279": "pole cell formation",
  "GO:0007280": "pole cell migration",
  "GO:0007281": "germ cell development",
  "GO:0007282": "cystoblast division",
  "GO:0007283": "spermatogenesis",
  "GO:0007284": "spermatogonial cell division",
  "GO:0007285": "primary spermatocyte growth",
  "GO:0007286": "spermatid development",
  "GO:0007287": "Nebenkern assembly",
  "GO:0007288": "sperm axoneme assembly",
  "GO:0007289": "spermatid nucleus differentiation",
  "GO:0007290": "spermatid nucleus elongation",
  "GO:0007291": "sperm individualization",
  "GO:0007292": "female gamete generation",
  "GO:0007293": "germarium-derived egg chamber formation",
  "GO:0007294": "germarium-derived oocyte fate determination",
  "GO:0007295": "growth of a germarium-derived egg chamber",
  "GO:0007296": "vitellogenesis",
  "GO:0007297": "ovarian follicle cell migration",
  "GO:0007298": "border follicle cell migration",
  "GO:0007299": "ovarian follicle cell-cell adhesion",
  "GO:0007300": "ovarian nurse cell to oocyte transport",
  "GO:0007301": "female germline ring canal formation",
  "GO:0007302": "nurse cell nucleus anchoring",
  "GO:0007303": "cytoplasmic transport, nurse cell to oocyte",
  "GO:0007304": "chorion-containing eggshell formation",
  "GO:0007305": "vitelline membrane formation involved in chorion-containing eggshell formation",
  "GO:0007306": "eggshell chorion assembly",
  "GO:0007307": "eggshell chorion gene amplification",
  "GO:0007308": "oocyte construction",
  "GO:0007309": "oocyte axis specification",
  "GO:0007310": "oocyte dorsal/ventral axis specification",
  "GO:0007311": "maternal specification of dorsal/ventral axis, oocyte, germ-line encoded",
  "GO:0007312": "oocyte nucleus migration involved in oocyte dorsal/ventral axis specification",
  "GO:0007313": "maternal specification of dorsal/ventral axis, oocyte, soma encoded",
  "GO:0007314": "oocyte anterior/posterior axis specification",
  "GO:0007315": "pole plasm assembly",
  "GO:0007316": "pole plasm RNA localization",
  "GO:0007317": "regulation of pole plasm oskar mRNA localization",
  "GO:0007318": "pole plasm protein localization",
  "GO:0007319": "negative regulation of oskar mRNA translation",
  "GO:0007320": "insemination",
  "GO:0007321": "sperm displacement",
  "GO:0007323": "peptide pheromone maturation",
  "GO:0007329": "positive regulation of transcription from RNA polymerase II promoter by pheromones",
  "GO:0007336": "obsolete bilateral process",
  "GO:0007337": "obsolete unilateral process",
  "GO:0007338": "single fertilization",
  "GO:0007339": "binding of sperm to zona pellucida",
  "GO:0007340": "acrosome reaction",
  "GO:0007341": "penetration of zona pellucida",
  "GO:0007342": "fusion of sperm to egg plasma membrane",
  "GO:0007343": "egg activation",
  "GO:0007344": "pronuclear fusion",
  "GO:0007345": "obsolete embryogenesis and morphogenesis",
  "GO:0007346": "regulation of mitotic cell cycle",
  "GO:0007347": "regulation of preblastoderm mitotic cell cycle",
  "GO:0007348": "regulation of syncytial blastoderm mitotic cell cycle",
  "GO:0007349": "cellularization",
  "GO:0007350": "blastoderm segmentation",
  "GO:0007351": "tripartite regional subdivision",
  "GO:0007352": "zygotic specification of dorsal/ventral axis",
  "GO:0007353": "obsolete ventral/lateral system",
  "GO:0007354": "zygotic determination of anterior/posterior axis, embryo",
  "GO:0007355": "anterior region determination",
  "GO:0007356": "thorax and anterior abdomen determination",
  "GO:0007357": "positive regulation of central gap gene transcription",
  "GO:0007358": "establishment of central gap gene boundaries",
  "GO:0007359": "posterior abdomen determination",
  "GO:0007360": "positive regulation of posterior gap gene transcription",
  "GO:0007361": "establishment of posterior gap gene boundaries",
  "GO:0007362": "terminal region determination",
  "GO:0007363": "positive regulation of terminal gap gene transcription",
  "GO:0007364": "establishment of terminal gap gene boundary",
  "GO:0007365": "periodic partitioning",
  "GO:0007366": "periodic partitioning by pair rule gene",
  "GO:0007367": "segment polarity determination",
  "GO:0007368": "determination of left/right symmetry",
  "GO:0007369": "gastrulation",
  "GO:0007370": "ventral furrow formation",
  "GO:0007371": "ventral midline determination",
  "GO:0007374": "posterior midgut invagination",
  "GO:0007375": "anterior midgut invagination",
  "GO:0007376": "cephalic furrow formation",
  "GO:0007377": "germ-band extension",
  "GO:0007378": "amnioserosa formation",
  "GO:0007379": "segment specification",
  "GO:0007380": "specification of segmental identity, head",
  "GO:0007381": "specification of segmental identity, labial segment",
  "GO:0007382": "specification of segmental identity, maxillary segment",
  "GO:0007383": "specification of segmental identity, antennal segment",
  "GO:0007384": "specification of segmental identity, thorax",
  "GO:0007385": "specification of segmental identity, abdomen",
  "GO:0007386": "compartment pattern specification",
  "GO:0007387": "anterior compartment pattern formation",
  "GO:0007388": "posterior compartment specification",
  "GO:0007389": "pattern specification process",
  "GO:0007390": "germ-band shortening",
  "GO:0007391": "dorsal closure",
  "GO:0007392": "initiation of dorsal closure",
  "GO:0007393": "dorsal closure, leading edge cell fate determination",
  "GO:0007394": "dorsal closure, elongation of leading edge cells",
  "GO:0007395": "dorsal closure, spreading of leading edge cells",
  "GO:0007396": "suture of dorsal opening",
  "GO:0007397": "obsolete histogenesis and organogenesis",
  "GO:0007398": "ectoderm development",
  "GO:0007399": "nervous system development",
  "GO:0007400": "neuroblast fate determination",
  "GO:0007401": "obsolete pan-neural process",
  "GO:0007402": "ganglion mother cell fate determination",
  "GO:0007403": "glial cell fate determination",
  "GO:0007405": "neuroblast proliferation",
  "GO:0007406": "negative regulation of neuroblast proliferation",
  "GO:0007407": "neuroblast activation",
  "GO:0007409": "axonogenesis",
  "GO:0007411": "axon guidance",
  "GO:0007412": "axon target recognition",
  "GO:0007413": "axonal fasciculation",
  "GO:0007414": "axonal defasciculation",
  "GO:0007415": "defasciculation of motor neuron axon",
  "GO:0007416": "synapse assembly",
  "GO:0007417": "central nervous system development",
  "GO:0007418": "ventral midline development",
  "GO:0007419": "ventral cord development",
  "GO:0007420": "brain development",
  "GO:0007421": "stomatogastric nervous system development",
  "GO:0007422": "peripheral nervous system development",
  "GO:0007423": "sensory organ development",
  "GO:0007424": "open tracheal system development",
  "GO:0007425": "epithelial cell fate determination, open tracheal system",
  "GO:0007426": "tracheal outgrowth, open tracheal system",
  "GO:0007427": "epithelial cell migration, open tracheal system",
  "GO:0007428": "primary branching, open tracheal system",
  "GO:0007429": "secondary branching, open tracheal system",
  "GO:0007430": "terminal branching, open tracheal system",
  "GO:0007431": "salivary gland development",
  "GO:0007432": "salivary gland boundary specification",
  "GO:0007433": "larval salivary gland boundary specification",
  "GO:0007434": "adult salivary gland boundary specification",
  "GO:0007435": "salivary gland morphogenesis",
  "GO:0007436": "larval salivary gland morphogenesis",
  "GO:0007437": "adult salivary gland morphogenesis",
  "GO:0007438": "oenocyte development",
  "GO:0007439": "ectodermal digestive tract development",
  "GO:0007440": "foregut morphogenesis",
  "GO:0007441": "anterior midgut (ectodermal) morphogenesis",
  "GO:0007442": "hindgut morphogenesis",
  "GO:0007443": "Malpighian tubule morphogenesis",
  "GO:0007444": "imaginal disc development",
  "GO:0007445": "determination of imaginal disc primordium",
  "GO:0007446": "imaginal disc growth",
  "GO:0007447": "imaginal disc pattern formation",
  "GO:0007448": "anterior/posterior pattern specification, imaginal disc",
  "GO:0007449": "proximal/distal pattern formation, imaginal disc",
  "GO:0007450": "dorsal/ventral pattern formation, imaginal disc",
  "GO:0007451": "dorsal/ventral lineage restriction, imaginal disc",
  "GO:0007453": "clypeo-labral disc morphogenesis",
  "GO:0007454": "labial disc morphogenesis",
  "GO:0007455": "eye-antennal disc morphogenesis",
  "GO:0007458": "progression of morphogenetic furrow involved in compound eye morphogenesis",
  "GO:0007460": "R8 cell fate commitment",
  "GO:0007462": "R1/R6 cell fate commitment",
  "GO:0007463": "R2/R5 cell fate commitment",
  "GO:0007464": "R3/R4 cell fate commitment",
  "GO:0007465": "R7 cell fate commitment",
  "GO:0007468": "regulation of rhodopsin gene expression",
  "GO:0007469": "antennal development",
  "GO:0007470": "prothoracic disc morphogenesis",
  "GO:0007471": "obsolete prothoracic morphogenesis",
  "GO:0007472": "wing disc morphogenesis",
  "GO:0007473": "wing disc proximal/distal pattern formation",
  "GO:0007474": "imaginal disc-derived wing vein specification",
  "GO:0007475": "apposition of dorsal and ventral imaginal disc-derived wing surfaces",
  "GO:0007476": "imaginal disc-derived wing morphogenesis",
  "GO:0007477": "notum development",
  "GO:0007478": "leg disc morphogenesis",
  "GO:0007479": "leg disc proximal/distal pattern formation",
  "GO:0007480": "imaginal disc-derived leg morphogenesis",
  "GO:0007481": "haltere disc morphogenesis",
  "GO:0007482": "haltere development",
  "GO:0007483": "genital disc morphogenesis",
  "GO:0007484": "imaginal disc-derived genitalia development",
  "GO:0007485": "imaginal disc-derived male genitalia development",
  "GO:0007486": "imaginal disc-derived female genitalia development",
  "GO:0007487": "analia development",
  "GO:0007488": "histoblast morphogenesis",
  "GO:0007489": "maintenance of imaginal histoblast diploidy",
  "GO:0007490": "tergite morphogenesis",
  "GO:0007491": "sternite morphogenesis",
  "GO:0007492": "endoderm development",
  "GO:0007493": "endodermal cell fate determination",
  "GO:0007494": "midgut development",
  "GO:0007495": "visceral mesoderm-endoderm interaction involved in midgut development",
  "GO:0007496": "anterior midgut development",
  "GO:0007497": "posterior midgut development",
  "GO:0007498": "mesoderm development",
  "GO:0007499": "ectoderm and mesoderm interaction",
  "GO:0007500": "mesodermal cell fate determination",
  "GO:0007501": "mesodermal cell fate specification",
  "GO:0007502": "digestive tract mesoderm development",
  "GO:0007503": "fat body development",
  "GO:0007504": "larval fat body development",
  "GO:0007505": "adult fat body development",
  "GO:0007506": "gonadal mesoderm development",
  "GO:0007507": "heart development",
  "GO:0007508": "larval heart development",
  "GO:0007509": "mesoderm migration involved in gastrulation",
  "GO:0007510": "cardioblast cell fate determination",
  "GO:0007512": "adult heart development",
  "GO:0007515": "obsolete lymph gland development",
  "GO:0007516": "hemocyte development",
  "GO:0007517": "muscle organ development",
  "GO:0007518": "myoblast fate determination",
  "GO:0007519": "skeletal muscle tissue development",
  "GO:0007520": "myoblast fusion",
  "GO:0007521": "muscle cell fate determination",
  "GO:0007522": "visceral muscle development",
  "GO:0007523": "larval visceral muscle development",
  "GO:0007524": "adult visceral muscle development",
  "GO:0007525": "somatic muscle development",
  "GO:0007526": "larval somatic muscle development",
  "GO:0007527": "adult somatic muscle development",
  "GO:0007528": "neuromuscular junction development",
  "GO:0007529": "establishment of synaptic specificity at neuromuscular junction",
  "GO:0007530": "sex determination",
  "GO:0007531": "mating type determination",
  "GO:0007532": "regulation of mating-type specific transcription, DNA-templated",
  "GO:0007533": "mating type switching",
  "GO:0007534": "gene conversion at mating-type locus",
  "GO:0007535": "donor selection",
  "GO:0007536": "activation of recombination (HML)",
  "GO:0007537": "inactivation of recombination (HML)",
  "GO:0007538": "primary sex determination",
  "GO:0007539": "primary sex determination, soma",
  "GO:0007540": "sex determination, establishment of X:A ratio",
  "GO:0007541": "sex determination, primary response to X:A ratio",
  "GO:0007542": "primary sex determination, germ-line",
  "GO:0007543": "sex determination, somatic-gonadal interaction",
  "GO:0007545": "processes downstream of sex determination signal",
  "GO:0007546": "somatic processes downstream of sex determination signal",
  "GO:0007547": "germ-line processes downstream of sex determination signal",
  "GO:0007548": "sex differentiation",
  "GO:0007549": "dosage compensation",
  "GO:0007550": "obsolete establishment of dosage compensation",
  "GO:0007551": "obsolete maintenance of dosage compensation",
  "GO:0007552": "metamorphosis",
  "GO:0007553": "regulation of ecdysteroid metabolic process",
  "GO:0007554": "regulation of ecdysteroid biosynthetic process",
  "GO:0007555": "regulation of ecdysteroid secretion",
  "GO:0007556": "regulation of juvenile hormone metabolic process",
  "GO:0007557": "regulation of juvenile hormone biosynthetic process",
  "GO:0007558": "regulation of juvenile hormone secretion",
  "GO:0007559": "obsolete histolysis",
  "GO:0007560": "imaginal disc morphogenesis",
  "GO:0007561": "imaginal disc eversion",
  "GO:0007562": "eclosion",
  "GO:0007563": "regulation of eclosion",
  "GO:0007564": "regulation of chitin-based cuticle tanning",
  "GO:0007565": "female pregnancy",
  "GO:0007566": "embryo implantation",
  "GO:0007567": "parturition",
  "GO:0007568": "aging",
  "GO:0007569": "cell aging",
  "GO:0007570": "obsolete age dependent accumulation of genetic damage",
  "GO:0007571": "age-dependent general metabolic decline",
  "GO:0007572": "obsolete age dependent decreased translational activity",
  "GO:0007573": "obsolete age dependent increased protein content",
  "GO:0007574": "obsolete cell aging (sensu Saccharomyces)",
  "GO:0007575": "obsolete nucleolar size increase",
  "GO:0007576": "nucleolar fragmentation",
  "GO:0007577": "obsolete autophagic death (sensu Saccharomyces)",
  "GO:0007578": "obsolete aging dependent sterility (sensu Saccharomyces)",
  "GO:0007579": "obsolete senescence factor accumulation",
  "GO:0007580": "extrachromosomal circular DNA accumulation involved in cell aging",
  "GO:0007581": "obsolete age-dependent yeast cell size increase",
  "GO:0007583": "obsolete killer activity",
  "GO:0007584": "response to nutrient",
  "GO:0007585": "respiratory gaseous exchange",
  "GO:0007586": "digestion",
  "GO:0007588": "excretion",
  "GO:0007589": "body fluid secretion",
  "GO:0007590": "obsolete fat body metabolic process (sensu Insecta)",
  "GO:0007591": "molting cycle, chitin-based cuticle",
  "GO:0007592": "obsolete protein-based cuticle development",
  "GO:0007593": "chitin-based cuticle sclerotization",
  "GO:0007594": "puparial adhesion",
  "GO:0007595": "lactation",
  "GO:0007596": "blood coagulation",
  "GO:0007597": "blood coagulation, intrinsic pathway",
  "GO:0007598": "blood coagulation, extrinsic pathway",
  "GO:0007599": "hemostasis",
  "GO:0007600": "sensory perception",
  "GO:0007601": "visual perception",
  "GO:0007602": "phototransduction",
  "GO:0007603": "phototransduction, visible light",
  "GO:0007604": "phototransduction, UV",
  "GO:0007605": "sensory perception of sound",
  "GO:0007606": "sensory perception of chemical stimulus",
  "GO:0007607": "obsolete taste perception",
  "GO:0007608": "sensory perception of smell",
  "GO:0007610": "behavior",
  "GO:0007611": "learning or memory",
  "GO:0007612": "learning",
  "GO:0007613": "memory",
  "GO:0007614": "short-term memory",
  "GO:0007615": "anesthesia-resistant memory",
  "GO:0007616": "long-term memory",
  "GO:0007617": "mating behavior",
  "GO:0007618": "mating",
  "GO:0007619": "courtship behavior",
  "GO:0007620": "copulation",
  "GO:0007621": "negative regulation of female receptivity",
  "GO:0007622": "rhythmic behavior",
  "GO:0007623": "circadian rhythm",
  "GO:0007624": "ultradian rhythm",
  "GO:0007625": "grooming behavior",
  "GO:0007626": "locomotory behavior",
  "GO:0007627": "obsolete larval behavior (sensu Insecta)",
  "GO:0007628": "adult walking behavior",
  "GO:0007629": "flight behavior",
  "GO:0007630": "jump response",
  "GO:0007631": "feeding behavior",
  "GO:0007632": "visual behavior",
  "GO:0007633": "pattern orientation",
  "GO:0007634": "optokinetic behavior",
  "GO:0007635": "chemosensory behavior",
  "GO:0007636": "chemosensory jump behavior",
  "GO:0007637": "proboscis extension reflex",
  "GO:0007638": "mechanosensory behavior",
  "GO:0007639": "homeostasis of number of meristem cells",
  "GO:0008001": "obsolete fibrinogen",
  "GO:0008002": "lamina lucida",
  "GO:0008003": "lamina densa",
  "GO:0008004": "lamina reticularis",
  "GO:0008008": "obsolete membrane attack complex protein beta2 chain",
  "GO:0008009": "chemokine activity",
  "GO:0008010": "structural constituent of chitin-based larval cuticle",
  "GO:0008011": "structural constituent of pupal chitin-based cuticle",
  "GO:0008012": "structural constituent of adult chitin-based cuticle",
  "GO:0008013": "beta-catenin binding",
  "GO:0008014": "obsolete calcium-dependent cell adhesion molecule activity",
  "GO:0008015": "blood circulation",
  "GO:0008016": "regulation of heart contraction",
  "GO:0008017": "microtubule binding",
  "GO:0008018": "obsolete structural protein of chorion (sensu Drosophila)",
  "GO:0008019": "obsolete macrophage receptor activity",
  "GO:0008020": "G-protein coupled photoreceptor activity",
  "GO:0008021": "synaptic vesicle",
  "GO:0008022": "protein C-terminus binding",
  "GO:0008023": "transcription elongation factor complex",
  "GO:0008024": "positive transcription elongation factor complex b",
  "GO:0008025": "obsolete diazepam binding inhibitor activity",
  "GO:0008026": "ATP-dependent helicase activity",
  "GO:0008028": "monocarboxylic acid transmembrane transporter activity",
  "GO:0008029": "pentraxin receptor activity",
  "GO:0008030": "neuronal pentraxin receptor activity",
  "GO:0008031": "eclosion hormone activity",
  "GO:0008033": "tRNA processing",
  "GO:0008034": "obsolete lipoprotein binding",
  "GO:0008035": "high-density lipoprotein particle binding",
  "GO:0008036": "diuretic hormone receptor activity",
  "GO:0008037": "cell recognition",
  "GO:0008038": "neuron recognition",
  "GO:0008039": "synaptic target recognition",
  "GO:0008041": "obsolete storage protein of fat body (sensu Insecta)",
  "GO:0008042": "obsolete iron-sulfur electron transfer carrier",
  "GO:0008043": "intracellular ferritin complex",
  "GO:0008044": "obsolete adult behavior (sensu Insecta)",
  "GO:0008045": "motor neuron axon guidance",
  "GO:0008046": "axon guidance receptor activity",
  "GO:0008047": "enzyme activator activity",
  "GO:0008048": "calcium sensitive guanylate cyclase activator activity",
  "GO:0008049": "male courtship behavior",
  "GO:0008050": "female courtship behavior",
  "GO:0008051": "obsolete farnesyl-diphosphate farnesyl transferase complex",
  "GO:0008052": "sensory organ boundary specification",
  "GO:0008053": "mitochondrial fusion",
  "GO:0008054": "negative regulation of cyclin-dependent protein serine/threonine kinase by cyclin degradation",
  "GO:0008055": "ocellus pigment biosynthetic process",
  "GO:0008056": "ocellus development",
  "GO:0008057": "eye pigment granule organization",
  "GO:0008058": "ocellus pigment granule organization",
  "GO:0008061": "chitin binding",
  "GO:0008062": "eclosion rhythm",
  "GO:0008063": "Toll signaling pathway",
  "GO:0008064": "regulation of actin polymerization or depolymerization",
  "GO:0008065": "establishment of blood-nerve barrier",
  "GO:0008066": "glutamate receptor activity",
  "GO:0008067": "obsolete metabotropic glutamate, GABA-B-like receptor activity",
  "GO:0008068": "extracellular-glutamate-gated chloride channel activity",
  "GO:0008069": "dorsal/ventral axis specification, ovarian follicular epithelium",
  "GO:0008070": "maternal determination of dorsal/ventral axis, ovarian follicular epithelium, germ-line encoded",
  "GO:0008071": "maternal determination of dorsal/ventral axis, ovarian follicular epithelium, soma encoded",
  "GO:0008073": "ornithine decarboxylase inhibitor activity",
  "GO:0008074": "guanylate cyclase complex, soluble",
  "GO:0008075": "obsolete receptor guanylate cyclase activity",
  "GO:0008076": "voltage-gated potassium channel complex",
  "GO:0008077": "obsolete Hsp70/Hsp90 organizing protein activity",
  "GO:0008078": "mesodermal cell migration",
  "GO:0008079": "translation termination factor activity",
  "GO:0008080": "N-acetyltransferase activity",
  "GO:0008081": "phosphoric diester hydrolase activity",
  "GO:0008083": "growth factor activity",
  "GO:0008084": "imaginal disc growth factor receptor binding",
  "GO:0008085": "obsolete phototransduction, visible light, light adaptation",
  "GO:0008086": "light-activated voltage-gated calcium channel activity",
  "GO:0008087": "light-activated voltage-gated calcium channel complex",
  "GO:0008088": "axo-dendritic transport",
  "GO:0008089": "anterograde axonal transport",
  "GO:0008090": "retrograde axonal transport",
  "GO:0008091": "spectrin",
  "GO:0008092": "cytoskeletal protein binding",
  "GO:0008093": "cytoskeletal adaptor activity",
  "GO:0008094": "DNA-dependent ATPase activity",
  "GO:0008096": "juvenile hormone epoxide hydrolase activity",
  "GO:0008097": "5S rRNA binding",
  "GO:0008098": "5S rRNA primary transcript binding",
  "GO:0008100": "obsolete lipophorin",
  "GO:0008101": "decapentaplegic signaling pathway",
  "GO:0008103": "oocyte microtubule cytoskeleton polarization",
  "GO:0008104": "protein localization",
  "GO:0008105": "asymmetric protein localization",
  "GO:0008106": "alcohol dehydrogenase (NADP+) activity",
  "GO:0008107": "galactoside 2-alpha-L-fucosyltransferase activity",
  "GO:0008108": "UDP-glucose:hexose-1-phosphate uridylyltransferase activity",
  "GO:0008109": "N-acetyllactosaminide beta-1,6-N-acetylglucosaminyltransferase activity",
  "GO:0008110": "L-histidine:2-oxoglutarate aminotransferase activity",
  "GO:0008111": "alpha-methylacyl-CoA racemase activity",
  "GO:0008112": "nicotinamide N-methyltransferase activity",
  "GO:0008113": "peptide-methionine (S)-S-oxide reductase activity",
  "GO:0008114": "phosphogluconate 2-dehydrogenase activity",
  "GO:0008115": "sarcosine oxidase activity",
  "GO:0008116": "prostaglandin-I synthase activity",
  "GO:0008117": "sphinganine-1-phosphate aldolase activity",
  "GO:0008118": "N-acetyllactosaminide alpha-2,3-sialyltransferase activity",
  "GO:0008119": "thiopurine S-methyltransferase activity",
  "GO:0008120": "ceramide glucosyltransferase activity",
  "GO:0008121": "ubiquinol-cytochrome-c reductase activity",
  "GO:0008123": "cholesterol 7-alpha-monooxygenase activity",
  "GO:0008124": "4-alpha-hydroxytetrahydrobiopterin dehydratase activity",
  "GO:0008125": "obsolete pancreatic elastase I activity",
  "GO:0008126": "acetylesterase activity",
  "GO:0008127": "quercetin 2,3-dioxygenase activity",
  "GO:0008129": "obsolete actinidain activity",
  "GO:0008130": "obsolete neutrophil collagenase activity",
  "GO:0008131": "primary amine oxidase activity",
  "GO:0008132": "obsolete pancreatic elastase activity",
  "GO:0008133": "obsolete collagenase activity",
  "GO:0008134": "transcription factor binding",
  "GO:0008135": "translation factor activity, RNA binding",
  "GO:0008137": "NADH dehydrogenase (ubiquinone) activity",
  "GO:0008138": "protein tyrosine/serine/threonine phosphatase activity",
  "GO:0008139": "nuclear localization sequence binding",
  "GO:0008140": "cAMP response element binding protein binding",
  "GO:0008141": "obsolete puparial glue (sensu Diptera)",
  "GO:0008142": "oxysterol binding",
  "GO:0008143": "poly(A) binding",
  "GO:0008144": "drug binding",
  "GO:0008145": "phenylalkylamine binding",
  "GO:0008146": "sulfotransferase activity",
  "GO:0008147": "structural constituent of bone",
  "GO:0008148": "obsolete negative transcription elongation factor activity",
  "GO:0008149": "obsolete para-aminobenzoic acid (PABA) synthase",
  "GO:0008150": "biological_process",
  "GO:0008152": "metabolic process",
  "GO:0008153": "para-aminobenzoic acid biosynthetic process",
  "GO:0008154": "actin polymerization or depolymerization",
  "GO:0008155": "obsolete larval behavior (sensu Drosophila)",
  "GO:0008156": "negative regulation of DNA replication",
  "GO:0008157": "protein phosphatase 1 binding",
  "GO:0008158": "hedgehog receptor activity",
  "GO:0008159": "obsolete positive transcription elongation factor activity",
  "GO:0008160": "protein tyrosine phosphatase activator activity",
  "GO:0008161": "obsolete carbamate resistance",
  "GO:0008162": "obsolete cyclodiene resistance",
  "GO:0008163": "obsolete DDT resistance",
  "GO:0008164": "obsolete organophosphorus resistance",
  "GO:0008165": "obsolete pyrethroid resistance",
  "GO:0008166": "obsolete viral replication",
  "GO:0008167": "obsolete sigma virus replication",
  "GO:0008168": "methyltransferase activity",
  "GO:0008169": "C-methyltransferase activity",
  "GO:0008170": "N-methyltransferase activity",
  "GO:0008171": "O-methyltransferase activity",
  "GO:0008172": "S-methyltransferase activity",
  "GO:0008173": "RNA methyltransferase activity",
  "GO:0008174": "mRNA methyltransferase activity",
  "GO:0008175": "tRNA methyltransferase activity",
  "GO:0008176": "tRNA (guanine-N7-)-methyltransferase activity",
  "GO:0008177": "succinate dehydrogenase (ubiquinone) activity",
  "GO:0008179": "adenylate cyclase binding",
  "GO:0008180": "COP9 signalosome",
  "GO:0008181": "obsolete tumor suppressor",
  "GO:0008184": "glycogen phosphorylase activity",
  "GO:0008186": "RNA-dependent ATPase activity",
  "GO:0008187": "poly-pyrimidine tract binding",
  "GO:0008188": "neuropeptide receptor activity",
  "GO:0008189": "obsolete apoptosis inhibitor activity",
  "GO:0008190": "eukaryotic initiation factor 4E binding",
  "GO:0008191": "metalloendopeptidase inhibitor activity",
  "GO:0008192": "RNA guanylyltransferase activity",
  "GO:0008193": "tRNA guanylyltransferase activity",
  "GO:0008194": "UDP-glycosyltransferase activity",
  "GO:0008195": "phosphatidate phosphatase activity",
  "GO:0008196": "vitellogenin receptor activity",
  "GO:0008197": "obsolete yolk protein",
  "GO:0008198": "ferrous iron binding",
  "GO:0008199": "ferric iron binding",
  "GO:0008200": "ion channel inhibitor activity",
  "GO:0008201": "heparin binding",
  "GO:0008202": "steroid metabolic process",
  "GO:0008203": "cholesterol metabolic process",
  "GO:0008204": "ergosterol metabolic process",
  "GO:0008205": "ecdysone metabolic process",
  "GO:0008206": "bile acid metabolic process",
  "GO:0008207": "C21-steroid hormone metabolic process",
  "GO:0008208": "C21-steroid hormone catabolic process",
  "GO:0008209": "androgen metabolic process",
  "GO:0008210": "estrogen metabolic process",
  "GO:0008211": "glucocorticoid metabolic process",
  "GO:0008212": "mineralocorticoid metabolic process",
  "GO:0008213": "protein alkylation",
  "GO:0008214": "protein dealkylation",
  "GO:0008215": "spermine metabolic process",
  "GO:0008216": "spermidine metabolic process",
  "GO:0008217": "regulation of blood pressure",
  "GO:0008218": "bioluminescence",
  "GO:0008219": "cell death",
  "GO:0008220": "obsolete necrosis",
  "GO:0008222": "obsolete tumor antigen",
  "GO:0008224": "obsolete Gram-positive antibacterial peptide activity",
  "GO:0008225": "obsolete Gram-negative antibacterial peptide activity",
  "GO:0008226": "tyramine receptor activity",
  "GO:0008227": "G-protein coupled amine receptor activity",
  "GO:0008228": "opsonization",
  "GO:0008229": "obsolete opsonin activity",
  "GO:0008230": "ecdysone receptor holocomplex",
  "GO:0008231": "repressor ecdysone receptor complex",
  "GO:0008232": "activator ecdysone receptor complex",
  "GO:0008233": "peptidase activity",
  "GO:0008234": "cysteine-type peptidase activity",
  "GO:0008235": "metalloexopeptidase activity",
  "GO:0008236": "serine-type peptidase activity",
  "GO:0008237": "metallopeptidase activity",
  "GO:0008238": "exopeptidase activity",
  "GO:0008239": "dipeptidyl-peptidase activity",
  "GO:0008240": "tripeptidyl-peptidase activity",
  "GO:0008241": "peptidyl-dipeptidase activity",
  "GO:0008242": "omega peptidase activity",
  "GO:0008243": "obsolete plasminogen activator activity",
  "GO:0008245": "obsolete lysosomal membrane hydrogen-transporting ATPase",
  "GO:0008246": "obsolete electron transfer flavoprotein",
  "GO:0008247": "1-alkyl-2-acetylglycerophosphocholine esterase complex",
  "GO:0008248": "obsolete pre-mRNA splicing factor activity",
  "GO:0008250": "oligosaccharyltransferase complex",
  "GO:0008251": "tRNA-specific adenosine deaminase activity",
  "GO:0008252": "nucleotidase activity",
  "GO:0008253": "5'-nucleotidase activity",
  "GO:0008254": "3'-nucleotidase activity",
  "GO:0008255": "ecdysis-triggering hormone activity",
  "GO:0008256": "protein histidine pros-kinase activity",
  "GO:0008257": "protein histidine tele-kinase activity",
  "GO:0008258": "head involution",
  "GO:0008259": "obsolete transforming growth factor beta ligand binding to type I receptor",
  "GO:0008260": "3-oxoacid CoA-transferase activity",
  "GO:0008261": "allatostatin receptor activity",
  "GO:0008263": "pyrimidine-specific mismatch base pair DNA N-glycosylase activity",
  "GO:0008265": "Mo-molybdopterin cofactor sulfurase activity",
  "GO:0008266": "poly(U) RNA binding",
  "GO:0008267": "poly-glutamine tract binding",
  "GO:0008268": "obsolete receptor signaling protein tyrosine kinase signaling protein activity",
  "GO:0008269": "JAK pathway signal transduction adaptor activity",
  "GO:0008270": "zinc ion binding",
  "GO:0008271": "secondary active sulfate transmembrane transporter activity",
  "GO:0008272": "sulfate transport",
  "GO:0008273": "calcium, potassium:sodium antiporter activity",
  "GO:0008274": "gamma-tubulin ring complex",
  "GO:0008275": "gamma-tubulin small complex",
  "GO:0008276": "protein methyltransferase activity",
  "GO:0008277": "regulation of G-protein coupled receptor protein signaling pathway",
  "GO:0008278": "cohesin complex",
  "GO:0008280": "cohesin core heterodimer",
  "GO:0008281": "sulfonylurea receptor activity",
  "GO:0008282": "ATP-sensitive potassium channel complex",
  "GO:0008283": "cell proliferation",
  "GO:0008284": "positive regulation of cell proliferation",
  "GO:0008285": "negative regulation of cell proliferation",
  "GO:0008286": "insulin receptor signaling pathway",
  "GO:0008287": "protein serine/threonine phosphatase complex",
  "GO:0008288": "boss receptor activity",
  "GO:0008289": "lipid binding",
  "GO:0008290": "F-actin capping protein complex",
  "GO:0008291": "acetylcholine metabolic process",
  "GO:0008292": "acetylcholine biosynthetic process",
  "GO:0008293": "torso signaling pathway",
  "GO:0008294": "calcium- and calmodulin-responsive adenylate cyclase activity",
  "GO:0008295": "spermidine biosynthetic process",
  "GO:0008296": "3'-5'-exodeoxyribonuclease activity",
  "GO:0008297": "single-stranded DNA exodeoxyribonuclease activity",
  "GO:0008298": "intracellular mRNA localization",
  "GO:0008299": "isoprenoid biosynthetic process",
  "GO:0008300": "isoprenoid catabolic process",
  "GO:0008301": "DNA binding, bending",
  "GO:0008302": "female germline ring canal formation, actin assembly",
  "GO:0008303": "caspase complex",
  "GO:0008304": "obsolete eukaryotic translation initiation factor 4 complex",
  "GO:0008305": "integrin complex",
  "GO:0008306": "associative learning",
  "GO:0008307": "structural constituent of muscle",
  "GO:0008308": "voltage-gated anion channel activity",
  "GO:0008309": "double-stranded DNA exodeoxyribonuclease activity",
  "GO:0008310": "single-stranded DNA 3'-5' exodeoxyribonuclease activity",
  "GO:0008311": "double-stranded DNA 3'-5' exodeoxyribonuclease activity",
  "GO:0008312": "7S RNA binding",
  "GO:0008313": "gurken-activated receptor activity",
  "GO:0008314": "gurken signaling pathway",
  "GO:0008315": "meiotic G2/MI transition",
  "GO:0008316": "structural constituent of vitelline membrane",
  "GO:0008317": "gurken receptor binding",
  "GO:0008318": "protein prenyltransferase activity",
  "GO:0008319": "obsolete prenyl protein specific endopeptidase activity",
  "GO:0008320": "protein transmembrane transporter activity",
  "GO:0008321": "Ral guanyl-nucleotide exchange factor activity",
  "GO:0008322": "obsolete Pro-X carboxypeptidase activity",
  "GO:0008324": "cation transmembrane transporter activity",
  "GO:0008327": "methyl-CpG binding",
  "GO:0008328": "ionotropic glutamate receptor complex",
  "GO:0008329": "signaling pattern recognition receptor activity",
  "GO:0008330": "protein tyrosine/threonine phosphatase activity",
  "GO:0008331": "high voltage-gated calcium channel activity",
  "GO:0008332": "low voltage-gated calcium channel activity",
  "GO:0008333": "endosome to lysosome transport",
  "GO:0008334": "histone mRNA metabolic process",
  "GO:0008335": "female germline ring canal stabilization",
  "GO:0008336": "gamma-butyrobetaine dioxygenase activity",
  "GO:0008337": "obsolete selectin",
  "GO:0008340": "determination of adult lifespan",
  "GO:0008341": "obsolete response to cocaine (sensu Insecta)",
  "GO:0008342": "obsolete larval feeding behavior (sensu Insecta)",
  "GO:0008343": "adult feeding behavior",
  "GO:0008344": "adult locomotory behavior",
  "GO:0008345": "larval locomotory behavior",
  "GO:0008346": "larval walking behavior",
  "GO:0008347": "glial cell migration",
  "GO:0008348": "negative regulation of antimicrobial humoral response",
  "GO:0008349": "MAP kinase kinase kinase kinase activity",
  "GO:0008350": "obsolete kinetochore motor activity",
  "GO:0008351": "obsolete microtubule severing activity",
  "GO:0008352": "katanin complex",
  "GO:0008353": "RNA polymerase II carboxy-terminal domain kinase activity",
  "GO:0008354": "germ cell migration",
  "GO:0008355": "olfactory learning",
  "GO:0008356": "asymmetric cell division",
  "GO:0008358": "maternal determination of anterior/posterior axis, embryo",
  "GO:0008359": "regulation of bicoid mRNA localization",
  "GO:0008360": "regulation of cell shape",
  "GO:0008361": "regulation of cell size",
  "GO:0008362": "chitin-based embryonic cuticle biosynthetic process",
  "GO:0008363": "larval chitin-based cuticle development",
  "GO:0008364": "pupal chitin-based cuticle development",
  "GO:0008365": "adult chitin-based cuticle development",
  "GO:0008366": "axon ensheathment",
  "GO:0008369": "obsolete molecular function",
  "GO:0008370": "obsolete cellular component",
  "GO:0008371": "obsolete biological process",
  "GO:0008373": "sialyltransferase activity",
  "GO:0008374": "O-acyltransferase activity",
  "GO:0008375": "acetylglucosaminyltransferase activity",
  "GO:0008376": "acetylgalactosaminyltransferase activity",
  "GO:0008377": "light-induced release of internally sequestered calcium ion",
  "GO:0008378": "galactosyltransferase activity",
  "GO:0008379": "thioredoxin peroxidase activity",
  "GO:0008380": "RNA splicing",
  "GO:0008381": "mechanically-gated ion channel activity",
  "GO:0008384": "IkappaB kinase activity",
  "GO:0008385": "IkappaB kinase complex",
  "GO:0008386": "cholesterol monooxygenase (side-chain-cleaving) activity",
  "GO:0008387": "steroid 7-alpha-hydroxylase activity",
  "GO:0008388": "testosterone 15-alpha-hydroxylase activity",
  "GO:0008389": "coumarin 7-hydroxylase activity",
  "GO:0008390": "testosterone 16-alpha-hydroxylase activity",
  "GO:0008391": "arachidonic acid monooxygenase activity",
  "GO:0008392": "arachidonic acid epoxygenase activity",
  "GO:0008395": "steroid hydroxylase activity",
  "GO:0008396": "oxysterol 7-alpha-hydroxylase activity",
  "GO:0008397": "sterol 12-alpha-hydroxylase activity",
  "GO:0008398": "sterol 14-demethylase activity",
  "GO:0008399": "naphthalene hydroxylase activity",
  "GO:0008401": "retinoic acid 4-hydroxylase activity",
  "GO:0008403": "25-hydroxycholecalciferol-24-hydroxylase activity",
  "GO:0008404": "arachidonic acid 14,15-epoxygenase activity",
  "GO:0008405": "arachidonic acid 11,12-epoxygenase activity",
  "GO:0008406": "gonad development",
  "GO:0008407": "chaeta morphogenesis",
  "GO:0008408": "3'-5' exonuclease activity",
  "GO:0008409": "5'-3' exonuclease activity",
  "GO:0008410": "CoA-transferase activity",
  "GO:0008411": "4-hydroxybutyrate CoA-transferase activity",
  "GO:0008412": "4-hydroxybenzoate octaprenyltransferase activity",
  "GO:0008413": "8-oxo-7,8-dihydroguanosine triphosphate pyrophosphatase activity",
  "GO:0008414": "CDP-alcohol phosphotransferase activity",
  "GO:0008416": "delta5-delta2,4-dienoyl-CoA isomerase activity",
  "GO:0008417": "fucosyltransferase activity",
  "GO:0008418": "protein-N-terminal asparagine amidohydrolase activity",
  "GO:0008419": "RNA lariat debranching enzyme activity",
  "GO:0008420": "CTD phosphatase activity",
  "GO:0008421": "long-chain fatty-acyl-glutamate deacylase activity",
  "GO:0008422": "beta-glucosidase activity",
  "GO:0008423": "obsolete bleomycin hydrolase activity",
  "GO:0008424": "glycoprotein 6-alpha-L-fucosyltransferase activity",
  "GO:0008425": "2-polyprenyl-6-methoxy-1,4-benzoquinone methyltransferase activity",
  "GO:0008426": "protein kinase C inhibitor activity",
  "GO:0008427": "calcium-dependent protein kinase inhibitor activity",
  "GO:0008428": "ribonuclease inhibitor activity",
  "GO:0008429": "phosphatidylethanolamine binding",
  "GO:0008430": "selenium binding",
  "GO:0008431": "vitamin E binding",
  "GO:0008432": "JUN kinase binding",
  "GO:0008434": "calcitriol receptor activity",
  "GO:0008435": "obsolete anticoagulant activity",
  "GO:0008436": "obsolete heterogeneous nuclear ribonucleoprotein",
  "GO:0008437": "thyrotropin-releasing hormone activity",
  "GO:0008438": "obsolete 1-phosphatidylinositol-5-phosphate kinase",
  "GO:0008439": "obsolete monophenol monooxygenase activator activity",
  "GO:0008440": "inositol-1,4,5-trisphosphate 3-kinase activity",
  "GO:0008441": "3'(2'),5'-bisphosphate nucleotidase activity",
  "GO:0008442": "3-hydroxyisobutyrate dehydrogenase activity",
  "GO:0008443": "phosphofructokinase activity",
  "GO:0008444": "CDP-diacylglycerol-glycerol-3-phosphate 3-phosphatidyltransferase activity",
  "GO:0008445": "D-aspartate oxidase activity",
  "GO:0008446": "GDP-mannose 4,6-dehydratase activity",
  "GO:0008447": "L-ascorbate oxidase activity",
  "GO:0008448": "N-acetylglucosamine-6-phosphate deacetylase activity",
  "GO:0008449": "N-acetylglucosamine-6-sulfatase activity",
  "GO:0008450": "obsolete O-sialoglycoprotein endopeptidase activity",
  "GO:0008451": "obsolete X-Pro aminopeptidase activity",
  "GO:0008452": "RNA ligase activity",
  "GO:0008453": "alanine-glyoxylate transaminase activity",
  "GO:0008454": "alpha-1,3-mannosylglycoprotein 4-beta-N-acetylglucosaminyltransferase activity",
  "GO:0008455": "alpha-1,6-mannosylglycoprotein 2-beta-N-acetylglucosaminyltransferase activity",
  "GO:0008456": "alpha-N-acetylgalactosaminidase activity",
  "GO:0008457": "beta-galactosyl-N-acetylglucosaminylgalactosylglucosyl-ceramide beta-1,3-acetylglucosaminyltransferase activity",
  "GO:0008458": "carnitine O-octanoyltransferase activity",
  "GO:0008459": "chondroitin 6-sulfotransferase activity",
  "GO:0008460": "dTDP-glucose 4,6-dehydratase activity",
  "GO:0008462": "obsolete endopeptidase Clp activity",
  "GO:0008463": "formylmethionine deformylase activity",
  "GO:0008464": "obsolete gamma-glutamyl hydrolase activity",
  "GO:0008465": "glycerate dehydrogenase activity",
  "GO:0008466": "glycogenin glucosyltransferase activity",
  "GO:0008467": "[heparan sulfate]-glucosamine 3-sulfotransferase 1 activity",
  "GO:0008469": "histone-arginine N-methyltransferase activity",
  "GO:0008470": "isovaleryl-CoA dehydrogenase activity",
  "GO:0008471": "obsolete laccase activity",
  "GO:0008472": "obsolete metallocarboxypeptidase D activity",
  "GO:0008473": "ornithine cyclodeaminase activity",
  "GO:0008474": "palmitoyl-(protein) hydrolase activity",
  "GO:0008475": "procollagen-lysine 5-dioxygenase activity",
  "GO:0008476": "protein-tyrosine sulfotransferase activity",
  "GO:0008477": "purine nucleosidase activity",
  "GO:0008478": "pyridoxal kinase activity",
  "GO:0008479": "queuine tRNA-ribosyltransferase activity",
  "GO:0008480": "sarcosine dehydrogenase activity",
  "GO:0008481": "sphinganine kinase activity",
  "GO:0008482": "sulfite oxidase activity",
  "GO:0008483": "transaminase activity",
  "GO:0008484": "sulfuric ester hydrolase activity",
  "GO:0008486": "diphosphoinositol-polyphosphate diphosphatase activity",
  "GO:0008487": "obsolete prenyl-dependent CAAX protease activity",
  "GO:0008488": "gamma-glutamyl carboxylase activity",
  "GO:0008489": "UDP-galactose:glucosylceramide beta-1,4-galactosyltransferase activity",
  "GO:0008490": "arsenite secondary active transmembrane transporter activity",
  "GO:0008492": "obsolete cAMP generating peptide activity",
  "GO:0008493": "tetracycline transporter activity",
  "GO:0008494": "translation activator activity",
  "GO:0008495": "protoheme IX farnesyltransferase activity",
  "GO:0008496": "mannan endo-1,6-alpha-mannosidase activity",
  "GO:0008498": "obsolete phospholipid scrambling",
  "GO:0008499": "UDP-galactose:beta-N-acetylglucosamine beta-1,3-galactosyltransferase activity",
  "GO:0008500": "obsolete glycine-, glutamate-, thienylcyclohexylpiperidine binding",
  "GO:0008502": "melatonin receptor activity",
  "GO:0008503": "benzodiazepine receptor activity",
  "GO:0008504": "monoamine transmembrane transporter activity",
  "GO:0008506": "sucrose:proton symporter activity",
  "GO:0008507": "sodium:iodide symporter activity",
  "GO:0008508": "bile acid:sodium symporter activity",
  "GO:0008509": "anion transmembrane transporter activity",
  "GO:0008510": "sodium:bicarbonate symporter activity",
  "GO:0008511": "sodium:potassium:chloride symporter activity",
  "GO:0008512": "sulfate:proton symporter activity",
  "GO:0008513": "secondary active organic cation transmembrane transporter activity",
  "GO:0008514": "organic anion transmembrane transporter activity",
  "GO:0008515": "sucrose transmembrane transporter activity",
  "GO:0008516": "hexose uniporter activity",
  "GO:0008517": "folic acid transporter activity",
  "GO:0008518": "reduced folate carrier activity",
  "GO:0008519": "ammonium transmembrane transporter activity",
  "GO:0008520": "L-ascorbate:sodium symporter activity",
  "GO:0008521": "acetyl-CoA transporter activity",
  "GO:0008523": "sodium-dependent multivitamin transmembrane transporter activity",
  "GO:0008524": "glucose 6-phosphate:phosphate antiporter activity",
  "GO:0008525": "phosphatidylcholine transporter activity",
  "GO:0008526": "phosphatidylinositol transporter activity",
  "GO:0008527": "taste receptor activity",
  "GO:0008528": "G-protein coupled peptide receptor activity",
  "GO:0008529": "obsolete endogenous peptide receptor activity",
  "GO:0008530": "obsolete exogenous peptide receptor activity",
  "GO:0008531": "riboflavin kinase activity",
  "GO:0008532": "N-acetyllactosaminide beta-1,3-N-acetylglucosaminyltransferase activity",
  "GO:0008533": "obsolete astacin activity",
  "GO:0008534": "oxidized purine nucleobase lesion DNA N-glycosylase activity",
  "GO:0008535": "respiratory chain complex IV assembly",
  "GO:0008536": "Ran GTPase binding",
  "GO:0008537": "proteasome activator complex",
  "GO:0008538": "obsolete proteasome activator activity",
  "GO:0008539": "obsolete proteasome inhibitor activity",
  "GO:0008540": "proteasome regulatory particle, base subcomplex",
  "GO:0008541": "proteasome regulatory particle, lid subcomplex",
  "GO:0008542": "visual learning",
  "GO:0008543": "fibroblast growth factor receptor signaling pathway",
  "GO:0008544": "epidermis development",
  "GO:0008545": "JUN kinase kinase activity",
  "GO:0008546": "obsolete microtubule/chromatin interaction",
  "GO:0008547": "obsolete protein-synthesizing GTPase activity",
  "GO:0008548": "obsolete signal-recognition-particle GTPase activity",
  "GO:0008549": "obsolete dynamin GTPase activity",
  "GO:0008550": "obsolete tubulin GTPase activity",
  "GO:0008551": "cadmium-exporting ATPase activity",
  "GO:0008552": "obsolete zinc, cadmium, cobalt, nickel, lead-efflux ATPase activity",
  "GO:0008553": "hydrogen-exporting ATPase activity, phosphorylative mechanism",
  "GO:0008554": "sodium-exporting ATPase activity, phosphorylative mechanism",
  "GO:0008555": "chloride-transporting ATPase activity",
  "GO:0008556": "potassium-transporting ATPase activity",
  "GO:0008558": "guanine-transporting ATPase activity",
  "GO:0008559": "xenobiotic-transporting ATPase activity",
  "GO:0008563": "obsolete alpha-factor sex pheromone exporter",
  "GO:0008564": "protein-exporting ATPase activity",
  "GO:0008565": "protein transporter activity",
  "GO:0008566": "mitochondrial protein-transporting ATPase activity",
  "GO:0008567": "obsolete dynein ATPase activity",
  "GO:0008568": "microtubule-severing ATPase activity",
  "GO:0008569": "ATP-dependent microtubule motor activity, minus-end-directed",
  "GO:0008570": "obsolete myosin ATPase activity",
  "GO:0008571": "obsolete non-chaperonin molecular chaperone ATPase activity",
  "GO:0008572": "obsolete nucleoplasmin ATPase activity",
  "GO:0008573": "obsolete peroxisome-assembly ATPase activity",
  "GO:0008574": "ATP-dependent microtubule motor activity, plus-end-directed",
  "GO:0008575": "obsolete proteasome ATPase activity",
  "GO:0008576": "obsolete vesicle-fusing ATPase activity",
  "GO:0008579": "JUN kinase phosphatase activity",
  "GO:0008580": "obsolete cytoskeletal regulator activity",
  "GO:0008581": "obsolete ubiquitin-specific protease 5 activity",
  "GO:0008582": "regulation of synaptic growth at neuromuscular junction",
  "GO:0008583": "mystery cell differentiation",
  "GO:0008584": "male gonad development",
  "GO:0008585": "female gonad development",
  "GO:0008586": "imaginal disc-derived wing vein morphogenesis",
  "GO:0008587": "imaginal disc-derived wing margin morphogenesis",
  "GO:0008588": "release of cytoplasmic sequestered NF-kappaB",
  "GO:0008589": "regulation of smoothened signaling pathway",
  "GO:0008591": "regulation of Wnt signaling pathway, calcium modulating pathway",
  "GO:0008592": "regulation of Toll signaling pathway",
  "GO:0008593": "regulation of Notch signaling pathway",
  "GO:0008594": "photoreceptor cell morphogenesis",
  "GO:0008595": "anterior/posterior axis specification, embryo",
  "GO:0008597": "calcium-dependent protein serine/threonine phosphatase regulator activity",
  "GO:0008599": "protein phosphatase type 1 regulator activity",
  "GO:0008601": "protein phosphatase type 2A regulator activity",
  "GO:0008603": "cAMP-dependent protein kinase regulator activity",
  "GO:0008605": "obsolete protein kinase CK2 regulator activity",
  "GO:0008607": "phosphorylase kinase regulator activity",
  "GO:0008608": "attachment of spindle microtubules to kinetochore",
  "GO:0008609": "alkylglycerone-phosphate synthase activity",
  "GO:0008610": "lipid biosynthetic process",
  "GO:0008611": "ether lipid biosynthetic process",
  "GO:0008612": "peptidyl-lysine modification to peptidyl-hypusine",
  "GO:0008613": "diuretic hormone activity",
  "GO:0008614": "pyridoxine metabolic process",
  "GO:0008615": "pyridoxine biosynthetic process",
  "GO:0008616": "queuosine biosynthetic process",
  "GO:0008617": "guanosine metabolic process",
  "GO:0008618": "7-methylguanosine metabolic process",
  "GO:0008619": "obsolete RHEB small monomeric GTPase activity",
  "GO:0008622": "epsilon DNA polymerase complex",
  "GO:0008623": "CHRAC",
  "GO:0008625": "extrinsic apoptotic signaling pathway via death domain receptors",
  "GO:0008626": "granzyme-mediated apoptotic signaling pathway",
  "GO:0008627": "intrinsic apoptotic signaling pathway in response to osmotic stress",
  "GO:0008628": "hormone-mediated apoptotic signaling pathway",
  "GO:0008630": "intrinsic apoptotic signaling pathway in response to DNA damage",
  "GO:0008631": "intrinsic apoptotic signaling pathway in response to oxidative stress",
  "GO:0008633": "obsolete activation of pro-apoptotic gene products",
  "GO:0008634": "obsolete negative regulation of survival gene product expression",
  "GO:0008635": "activation of cysteine-type endopeptidase activity involved in apoptotic process by cytochrome c",
  "GO:0008636": "obsolete activation of caspase activity by protein phosphorylation",
  "GO:0008637": "apoptotic mitochondrial changes",
  "GO:0008638": "obsolete protein tagging activity",
  "GO:0008641": "small protein activating enzyme activity",
  "GO:0008643": "carbohydrate transport",
  "GO:0008645": "hexose transport",
  "GO:0008646": "high-affinity hexose transport",
  "GO:0008647": "low-affinity hexose transport",
  "GO:0008648": "obsolete tachykinin",
  "GO:0008649": "rRNA methyltransferase activity",
  "GO:0008650": "rRNA (uridine-2'-O-)-methyltransferase activity",
  "GO:0008651": "obsolete actin polymerizing activity",
  "GO:0008652": "cellular amino acid biosynthetic process",
  "GO:0008653": "lipopolysaccharide metabolic process",
  "GO:0008654": "phospholipid biosynthetic process",
  "GO:0008655": "pyrimidine-containing compound salvage",
  "GO:0008656": "cysteine-type endopeptidase activator activity involved in apoptotic process",
  "GO:0008657": "DNA topoisomerase (ATP-hydrolyzing) inhibitor activity",
  "GO:0008658": "penicillin binding",
  "GO:0008659": "(3R)-hydroxymyristoyl-[acyl-carrier-protein] dehydratase activity",
  "GO:0008660": "1-aminocyclopropane-1-carboxylate deaminase activity",
  "GO:0008661": "1-deoxy-D-xylulose-5-phosphate synthase activity",
  "GO:0008662": "1-phosphofructokinase activity",
  "GO:0008663": "2',3'-cyclic-nucleotide 2'-phosphodiesterase activity",
  "GO:0008664": "2'-5'-RNA ligase activity",
  "GO:0008665": "2'-phosphotransferase activity",
  "GO:0008666": "2,3,4,5-tetrahydropyridine-2,6-dicarboxylate N-succinyltransferase activity",
  "GO:0008667": "2,3-dihydro-2,3-dihydroxybenzoate dehydrogenase activity",
  "GO:0008668": "(2,3-dihydroxybenzoyl)adenylate synthase activity",
  "GO:0008670": "2,4-dienoyl-CoA reductase (NADPH) activity",
  "GO:0008671": "2-dehydro-3-deoxygalactonokinase activity",
  "GO:0008672": "2-dehydro-3-deoxyglucarate aldolase activity",
  "GO:0008673": "2-dehydro-3-deoxygluconokinase activity",
  "GO:0008674": "2-dehydro-3-deoxy-6-phosphogalactonate aldolase activity",
  "GO:0008675": "2-dehydro-3-deoxy-phosphogluconate aldolase activity",
  "GO:0008676": "3-deoxy-8-phosphooctulonate synthase activity",
  "GO:0008677": "2-dehydropantoate 2-reductase activity",
  "GO:0008678": "2-deoxy-D-gluconate 3-dehydrogenase activity",
  "GO:0008679": "2-hydroxy-3-oxopropionate reductase activity",
  "GO:0008681": "2-octaprenyl-6-methoxyphenol hydroxylase activity",
  "GO:0008682": "2-octoprenyl-3-methyl-6-methoxy-1,4-benzoquinone hydroxylase activity",
  "GO:0008683": "2-oxoglutarate decarboxylase activity",
  "GO:0008684": "2-oxopent-4-enoate hydratase activity",
  "GO:0008685": "2-C-methyl-D-erythritol 2,4-cyclodiphosphate synthase activity",
  "GO:0008686": "3,4-dihydroxy-2-butanone-4-phosphate synthase activity",
  "GO:0008687": "3,4-dihydroxyphenylacetate 2,3-dioxygenase activity",
  "GO:0008688": "3-(3-hydroxyphenyl)propionate hydroxylase activity",
  "GO:0008689": "3-demethylubiquinone-9 3-O-methyltransferase activity",
  "GO:0008690": "3-deoxy-manno-octulosonate cytidylyltransferase activity",
  "GO:0008691": "3-hydroxybutyryl-CoA dehydrogenase activity",
  "GO:0008692": "3-hydroxybutyryl-CoA epimerase activity",
  "GO:0008693": "3-hydroxydecanoyl-[acyl-carrier-protein] dehydratase activity",
  "GO:0008694": "3-octaprenyl-4-hydroxybenzoate carboxy-lyase activity",
  "GO:0008695": "3-phenylpropionate dioxygenase activity",
  "GO:0008696": "4-amino-4-deoxychorismate lyase activity",
  "GO:0008697": "4-deoxy-L-threo-5-hexosulose-uronate ketol-isomerase activity",
  "GO:0008700": "4-hydroxy-2-oxoglutarate aldolase activity",
  "GO:0008701": "4-hydroxy-2-oxovalerate aldolase activity",
  "GO:0008703": "5-amino-6-(5-phosphoribosylamino)uracil reductase activity",
  "GO:0008704": "5-carboxymethyl-2-hydroxymuconate delta-isomerase activity",
  "GO:0008705": "methionine synthase activity",
  "GO:0008706": "6-phospho-beta-glucosidase activity",
  "GO:0008707": "4-phytase activity",
  "GO:0008709": "cholate 7-alpha-dehydrogenase activity",
  "GO:0008710": "8-amino-7-oxononanoate synthase activity",
  "GO:0008711": "obsolete ADP-L-glycero-D-manno-heptose synthase activity",
  "GO:0008712": "ADP-glyceromanno-heptose 6-epimerase activity",
  "GO:0008713": "ADP-heptose-lipopolysaccharide heptosyltransferase activity",
  "GO:0008714": "AMP nucleosidase activity",
  "GO:0008715": "CDP-diacylglycerol diphosphatase activity",
  "GO:0008716": "D-alanine-D-alanine ligase activity",
  "GO:0008717": "obsolete D-alanyl-D-alanine endopeptidase activity",
  "GO:0008718": "D-amino-acid dehydrogenase activity",
  "GO:0008719": "dihydroneopterin triphosphate 2'-epimerase activity",
  "GO:0008720": "D-lactate dehydrogenase activity",
  "GO:0008721": "D-serine ammonia-lyase activity",
  "GO:0008724": "obsolete DNA topoisomerase IV activity",
  "GO:0008725": "DNA-3-methyladenine glycosylase activity",
  "GO:0008726": "alkanesulfonate monooxygenase activity",
  "GO:0008727": "GDP-mannose mannosyl hydrolase activity",
  "GO:0008728": "GTP diphosphokinase activity",
  "GO:0008730": "L(+)-tartrate dehydratase activity",
  "GO:0008732": "L-allo-threonine aldolase activity",
  "GO:0008733": "L-arabinose isomerase activity",
  "GO:0008734": "L-aspartate oxidase activity",
  "GO:0008735": "carnitine dehydratase activity",
  "GO:0008736": "L-fucose isomerase activity",
  "GO:0008737": "L-fuculokinase activity",
  "GO:0008738": "L-fuculose-phosphate aldolase activity",
  "GO:0008740": "L-rhamnose isomerase activity",
  "GO:0008741": "ribulokinase activity",
  "GO:0008742": "L-ribulose-phosphate 4-epimerase activity",
  "GO:0008743": "L-threonine 3-dehydrogenase activity",
  "GO:0008744": "L-xylulokinase activity",
  "GO:0008745": "N-acetylmuramoyl-L-alanine amidase activity",
  "GO:0008746": "NAD(P)+ transhydrogenase activity",
  "GO:0008747": "N-acetylneuraminate lyase activity",
  "GO:0008748": "N-ethylmaleimide reductase activity",
  "GO:0008750": "NAD(P)+ transhydrogenase (AB-specific) activity",
  "GO:0008751": "obsolete NAD(P)H dehydrogenase",
  "GO:0008752": "FMN reductase activity",
  "GO:0008753": "NADPH dehydrogenase (quinone) activity",
  "GO:0008754": "O antigen ligase activity",
  "GO:0008755": "O antigen polymerase activity",
  "GO:0008756": "o-succinylbenzoate-CoA ligase activity",
  "GO:0008757": "S-adenosylmethionine-dependent methyltransferase activity",
  "GO:0008758": "UDP-2,3-diacylglucosamine hydrolase activity",
  "GO:0008759": "UDP-3-O-[3-hydroxymyristoyl] N-acetylglucosamine deacetylase activity",
  "GO:0008760": "UDP-N-acetylglucosamine 1-carboxyvinyltransferase activity",
  "GO:0008761": "UDP-N-acetylglucosamine 2-epimerase activity",
  "GO:0008762": "UDP-N-acetylmuramate dehydrogenase activity",
  "GO:0008763": "UDP-N-acetylmuramate-L-alanine ligase activity",
  "GO:0008764": "UDP-N-acetylmuramoylalanine-D-glutamate ligase activity",
  "GO:0008765": "UDP-N-acetylmuramoylalanyl-D-glutamate-2,6-diaminopimelate ligase activity",
  "GO:0008766": "UDP-N-acetylmuramoylalanyl-D-glutamyl-2,6-diaminopimelate-D-alanyl-D-alanine ligase activity",
  "GO:0008767": "UDP-galactopyranose mutase activity",
  "GO:0008768": "UDP-sugar diphosphatase activity",
  "GO:0008769": "obsolete X-His dipeptidase activity",
  "GO:0008770": "[acyl-carrier-protein] phosphodiesterase activity",
  "GO:0008771": "[citrate (pro-3S)-lyase] ligase activity",
  "GO:0008772": "[isocitrate dehydrogenase (NADP+)] kinase activity",
  "GO:0008773": "[protein-PII] uridylyltransferase activity",
  "GO:0008774": "acetaldehyde dehydrogenase (acetylating) activity",
  "GO:0008775": "acetate CoA-transferase activity",
  "GO:0008776": "acetate kinase activity",
  "GO:0008777": "acetylornithine deacetylase activity",
  "GO:0008779": "acyl-[acyl-carrier-protein]-phospholipid O-acyltransferase activity",
  "GO:0008780": "acyl-[acyl-carrier-protein]-UDP-N-acetylglucosamine O-acyltransferase activity",
  "GO:0008781": "N-acylneuraminate cytidylyltransferase activity",
  "GO:0008782": "adenosylhomocysteine nucleosidase activity",
  "GO:0008783": "agmatinase activity",
  "GO:0008784": "alanine racemase activity",
  "GO:0008785": "alkyl hydroperoxide reductase activity",
  "GO:0008786": "allose 6-phosphate isomerase activity",
  "GO:0008787": "allose kinase activity",
  "GO:0008788": "alpha,alpha-phosphotrehalase activity",
  "GO:0008789": "altronate dehydratase activity",
  "GO:0008790": "arabinose isomerase activity",
  "GO:0008791": "arginine N-succinyltransferase activity",
  "GO:0008792": "arginine decarboxylase activity",
  "GO:0008793": "aromatic-amino-acid:2-oxoglutarate aminotransferase activity",
  "GO:0008794": "arsenate reductase (glutaredoxin) activity",
  "GO:0008795": "NAD+ synthase activity",
  "GO:0008796": "bis(5'-nucleosyl)-tetraphosphatase activity",
  "GO:0008797": "aspartate ammonia-lyase activity",
  "GO:0008798": "beta-aspartyl-peptidase activity",
  "GO:0008800": "beta-lactamase activity",
  "GO:0008801": "beta-phosphoglucomutase activity",
  "GO:0008802": "betaine-aldehyde dehydrogenase activity",
  "GO:0008803": "bis(5'-nucleosyl)-tetraphosphatase (symmetrical) activity",
  "GO:0008804": "carbamate kinase activity",
  "GO:0008805": "carbon-monoxide oxygenase activity",
  "GO:0008806": "carboxymethylenebutenolidase activity",
  "GO:0008807": "carboxyvinyl-carboxyphosphonate phosphorylmutase activity",
  "GO:0008808": "cardiolipin synthase activity",
  "GO:0008809": "carnitine racemase activity",
  "GO:0008810": "cellulase activity",
  "GO:0008811": "chloramphenicol O-acetyltransferase activity",
  "GO:0008812": "choline dehydrogenase activity",
  "GO:0008813": "chorismate lyase activity",
  "GO:0008814": "citrate CoA-transferase activity",
  "GO:0008815": "citrate (pro-3S)-lyase activity",
  "GO:0008816": "citryl-CoA lyase activity",
  "GO:0008817": "cob(I)yrinic acid a,c-diamide adenosyltransferase activity",
  "GO:0008818": "cobalamin 5'-phosphate synthase activity",
  "GO:0008819": "cobinamide kinase activity",
  "GO:0008820": "cobinamide phosphate guanylyltransferase activity",
  "GO:0008821": "crossover junction endodeoxyribonuclease activity",
  "GO:0008822": "obsolete crotonobetaine/carnitine-CoA ligase activity",
  "GO:0008823": "cupric reductase activity",
  "GO:0008824": "cyanate hydratase activity",
  "GO:0008825": "cyclopropane-fatty-acyl-phospholipid synthase activity",
  "GO:0008826": "cysteine sulfinate desulfinase activity",
  "GO:0008827": "cytochrome o ubiquinol oxidase activity",
  "GO:0008828": "dATP pyrophosphohydrolase activity",
  "GO:0008829": "dCTP deaminase activity",
  "GO:0008830": "dTDP-4-dehydrorhamnose 3,5-epimerase activity",
  "GO:0008831": "dTDP-4-dehydrorhamnose reductase activity",
  "GO:0008832": "dGTPase activity",
  "GO:0008833": "deoxyribonuclease IV (phage-T4-induced) activity",
  "GO:0008834": "di-trans,poly-cis-decaprenylcistransferase activity",
  "GO:0008835": "diaminohydroxyphosphoribosylaminopyrimidine deaminase activity",
  "GO:0008836": "diaminopimelate decarboxylase activity",
  "GO:0008837": "diaminopimelate epimerase activity",
  "GO:0008838": "diaminopropionate ammonia-lyase activity",
  "GO:0008839": "4-hydroxy-tetrahydrodipicolinate reductase",
  "GO:0008840": "4-hydroxy-tetrahydrodipicolinate synthase",
  "GO:0008841": "dihydrofolate synthase activity",
  "GO:0008842": "diphosphate-purine nucleoside kinase activity",
  "GO:0008843": "endochitinase activity",
  "GO:0008845": "obsolete endonuclease VIII activity",
  "GO:0008846": "obsolete endopeptidase La activity",
  "GO:0008847": "Enterobacter ribonuclease activity",
  "GO:0008848": "obsolete enterobactin synthetase",
  "GO:0008849": "enterochelin esterase activity",
  "GO:0008851": "ethanolamine ammonia-lyase activity",
  "GO:0008852": "exodeoxyribonuclease I activity",
  "GO:0008853": "exodeoxyribonuclease III activity",
  "GO:0008854": "exodeoxyribonuclease V activity",
  "GO:0008855": "exodeoxyribonuclease VII activity",
  "GO:0008856": "exodeoxyribonuclease X activity",
  "GO:0008859": "exoribonuclease II activity",
  "GO:0008860": "ferredoxin-NAD+ reductase activity",
  "GO:0008861": "formate C-acetyltransferase activity",
  "GO:0008863": "formate dehydrogenase (NAD+) activity",
  "GO:0008864": "formyltetrahydrofolate deformylase activity",
  "GO:0008865": "fructokinase activity",
  "GO:0008866": "fructuronate reductase activity",
  "GO:0008867": "galactarate dehydratase activity",
  "GO:0008868": "galactitol-1-phosphate 5-dehydrogenase activity",
  "GO:0008869": "galactonate dehydratase activity",
  "GO:0008870": "galactoside O-acetyltransferase activity",
  "GO:0008871": "aminoglycoside 2''-nucleotidyltransferase activity",
  "GO:0008872": "glucarate dehydratase activity",
  "GO:0008873": "gluconate 2-dehydrogenase activity",
  "GO:0008874": "gluconate 5-dehydrogenase activity",
  "GO:0008875": "gluconate dehydrogenase activity",
  "GO:0008876": "quinoprotein glucose dehydrogenase activity",
  "GO:0008877": "glucose-1-phosphatase activity",
  "GO:0008878": "glucose-1-phosphate adenylyltransferase activity",
  "GO:0008879": "glucose-1-phosphate thymidylyltransferase activity",
  "GO:0008880": "glucuronate isomerase activity",
  "GO:0008881": "glutamate racemase activity",
  "GO:0008882": "[glutamate-ammonia-ligase] adenylyltransferase activity",
  "GO:0008883": "glutamyl-tRNA reductase activity",
  "GO:0008884": "glutathionylspermidine amidase activity",
  "GO:0008885": "glutathionylspermidine synthase activity",
  "GO:0008886": "glyceraldehyde-3-phosphate dehydrogenase (NADP+) (non-phosphorylating) activity",
  "GO:0008887": "glycerate kinase activity",
  "GO:0008888": "glycerol dehydrogenase [NAD+] activity",
  "GO:0008889": "glycerophosphodiester phosphodiesterase activity",
  "GO:0008890": "glycine C-acetyltransferase activity",
  "GO:0008891": "glycolate oxidase activity",
  "GO:0008892": "guanine deaminase activity",
  "GO:0008893": "guanosine-3',5'-bis(diphosphate) 3'-diphosphatase activity",
  "GO:0008894": "guanosine-5'-triphosphate,3'-diphosphate diphosphatase activity",
  "GO:0008897": "holo-[acyl-carrier-protein] synthase activity",
  "GO:0008898": "S-adenosylmethionine-homocysteine S-methyltransferase activity",
  "GO:0008899": "homoserine O-succinyltransferase activity",
  "GO:0008900": "hydrogen:potassium-exchanging ATPase activity",
  "GO:0008901": "ferredoxin hydrogenase activity",
  "GO:0008902": "hydroxymethylpyrimidine kinase activity",
  "GO:0008903": "hydroxypyruvate isomerase activity",
  "GO:0008904": "hygromycin-B 7''-O-phosphotransferase activity",
  "GO:0008905": "mannose-phosphate guanylyltransferase activity",
  "GO:0008906": "inosine kinase activity",
  "GO:0008907": "integrase activity",
  "GO:0008908": "isochorismatase activity",
  "GO:0008909": "isochorismate synthase activity",
  "GO:0008910": "kanamycin kinase activity",
  "GO:0008911": "lactaldehyde dehydrogenase activity",
  "GO:0008912": "lactaldehyde reductase activity",
  "GO:0008913": "lauroyltransferase activity",
  "GO:0008914": "leucyltransferase activity",
  "GO:0008915": "lipid-A-disaccharide synthase activity",
  "GO:0008917": "lipopolysaccharide N-acetylglucosaminyltransferase activity",
  "GO:0008918": "lipopolysaccharide 3-alpha-galactosyltransferase activity",
  "GO:0008919": "lipopolysaccharide glucosyltransferase I activity",
  "GO:0008920": "lipopolysaccharide heptosyltransferase activity",
  "GO:0008921": "lipopolysaccharide-1,6-galactosyltransferase activity",
  "GO:0008922": "long-chain fatty acid [acyl-carrier-protein] ligase activity",
  "GO:0008923": "lysine decarboxylase activity",
  "GO:0008924": "malate dehydrogenase (quinone) activity",
  "GO:0008925": "maltose O-acetyltransferase activity",
  "GO:0008926": "mannitol-1-phosphate 5-dehydrogenase activity",
  "GO:0008927": "mannonate dehydratase activity",
  "GO:0008928": "mannose-1-phosphate guanylyltransferase (GDP) activity",
  "GO:0008929": "methylglyoxal synthase activity",
  "GO:0008930": "methylthioadenosine nucleosidase activity",
  "GO:0008931": "obsolete murein DD-endopeptidase activity",
  "GO:0008932": "lytic endotransglycosylase activity",
  "GO:0008933": "lytic transglycosylase activity",
  "GO:0008934": "inositol monophosphate 1-phosphatase activity",
  "GO:0008935": "1,4-dihydroxy-2-naphthoyl-CoA synthase activity",
  "GO:0008936": "nicotinamidase activity",
  "GO:0008937": "ferredoxin-NAD(P) reductase activity",
  "GO:0008938": "nicotinate N-methyltransferase activity",
  "GO:0008939": "nicotinate-nucleotide-dimethylbenzimidazole phosphoribosyltransferase activity",
  "GO:0008940": "nitrate reductase activity",
  "GO:0008941": "nitric oxide dioxygenase activity",
  "GO:0008942": "nitrite reductase [NAD(P)H] activity",
  "GO:0008943": "obsolete glyceraldehyde-3-phosphate dehydrogenase activity",
  "GO:0008944": "obsolete oligopeptidase A activity",
  "GO:0008945": "obsolete oligopeptidase B activity",
  "GO:0008946": "oligonucleotidase activity",
  "GO:0008947": "obsolete omptin activity",
  "GO:0008948": "oxaloacetate decarboxylase activity",
  "GO:0008949": "oxalyl-CoA decarboxylase activity",
  "GO:0008950": "obsolete p-aminobenzoate synthetase",
  "GO:0008951": "palmitoleoyl [acyl-carrier-protein]-dependent acyltransferase activity",
  "GO:0008953": "penicillin amidase activity",
  "GO:0008954": "obsolete peptidoglycan synthetase activity",
  "GO:0008955": "peptidoglycan glycosyltransferase activity",
  "GO:0008956": "obsolete peptidyl-dipeptidase Dcp activity",
  "GO:0008957": "phenylacetaldehyde dehydrogenase activity",
  "GO:0008959": "phosphate acetyltransferase activity",
  "GO:0008960": "phosphatidylglycerol-membrane-oligosaccharide glycerophosphotransferase activity",
  "GO:0008961": "phosphatidylglycerol-prolipoprotein diacylglyceryl transferase activity",
  "GO:0008962": "phosphatidylglycerophosphatase activity",
  "GO:0008963": "phospho-N-acetylmuramoyl-pentapeptide-transferase activity",
  "GO:0008964": "phosphoenolpyruvate carboxylase activity",
  "GO:0008965": "phosphoenolpyruvate-protein phosphotransferase activity",
  "GO:0008966": "phosphoglucosamine mutase activity",
  "GO:0008967": "phosphoglycolate phosphatase activity",
  "GO:0008968": "D-sedoheptulose 7-phosphate isomerase activity",
  "GO:0008969": "phosphohistidine phosphatase activity",
  "GO:0008970": "phosphatidylcholine 1-acylhydrolase activity",
  "GO:0008972": "phosphomethylpyrimidine kinase activity",
  "GO:0008973": "phosphopentomutase activity",
  "GO:0008974": "phosphoribulokinase activity",
  "GO:0008975": "obsolete pitrilysin activity",
  "GO:0008976": "polyphosphate kinase activity",
  "GO:0008977": "prephenate dehydrogenase activity",
  "GO:0008978": "obsolete prepilin peptidase activity",
  "GO:0008979": "prophage integrase activity",
  "GO:0008980": "propionate kinase activity",
  "GO:0008981": "obsolete protease IV activity",
  "GO:0008982": "protein-N(PI)-phosphohistidine-sugar phosphotransferase activity",
  "GO:0008983": "protein-glutamate O-methyltransferase activity",
  "GO:0008984": "protein-glutamate methylesterase activity",
  "GO:0008985": "obsolete pyruvate dehydrogenase (cytochrome) activity",
  "GO:0008986": "pyruvate, water dikinase activity",
  "GO:0008987": "quinolinate synthetase A activity",
  "GO:0008988": "rRNA (adenine-N6-)-methyltransferase activity",
  "GO:0008989": "rRNA (guanine-N1-)-methyltransferase activity",
  "GO:0008990": "rRNA (guanine-N2-)-methyltransferase activity",
  "GO:0008991": "obsolete serine-type signal peptidase activity",
  "GO:0008992": "obsolete repressor LexA activity",
  "GO:0008993": "rhamnulokinase activity",
  "GO:0008994": "rhamnulose-1-phosphate aldolase activity",
  "GO:0008995": "ribonuclease E activity",
  "GO:0008996": "ribonuclease G activity",
  "GO:0008997": "ribonuclease R activity",
  "GO:0008998": "ribonucleoside-triphosphate reductase activity",
  "GO:0008999": "ribosomal-protein-alanine N-acetyltransferase activity",
  "GO:0009000": "selenocysteine lyase activity",
  "GO:0009001": "serine O-acetyltransferase activity",
  "GO:0009002": "serine-type D-Ala-D-Ala carboxypeptidase activity",
  "GO:0009003": "obsolete signal peptidase activity",
  "GO:0009004": "obsolete signal peptidase I activity",
  "GO:0009005": "obsolete signal peptidase II activity",
  "GO:0009006": "obsolete siroheme synthase activity",
  "GO:0009007": "site-specific DNA-methyltransferase (adenine-specific) activity",
  "GO:0009008": "DNA-methyltransferase activity",
  "GO:0009009": "site-specific recombinase activity",
  "GO:0009010": "sorbitol-6-phosphate 2-dehydrogenase activity",
  "GO:0009011": "starch synthase activity",
  "GO:0009012": "aminoglycoside 3''-adenylyltransferase activity",
  "GO:0009013": "succinate-semialdehyde dehydrogenase [NAD(P)+] activity",
  "GO:0009014": "succinyl-diaminopimelate desuccinylase activity",
  "GO:0009015": "N-succinylarginine dihydrolase activity",
  "GO:0009016": "succinyldiaminopimelate transaminase activity",
  "GO:0009017": "succinylglutamate desuccinylase activity",
  "GO:0009018": "sucrose phosphorylase activity",
  "GO:0009019": "tRNA (guanine-N1-)-methyltransferase activity",
  "GO:0009020": "tRNA (guanosine-2'-O-)-methyltransferase activity",
  "GO:0009022": "tRNA nucleotidyltransferase activity",
  "GO:0009023": "obsolete tRNA sulfurtransferase",
  "GO:0009024": "tagatose-6-phosphate kinase activity",
  "GO:0009025": "tagatose-bisphosphate aldolase activity",
  "GO:0009026": "tagaturonate reductase activity",
  "GO:0009027": "tartrate dehydrogenase activity",
  "GO:0009028": "tartronate-semialdehyde synthase activity",
  "GO:0009029": "tetraacyldisaccharide 4'-kinase activity",
  "GO:0009030": "thiamine-phosphate kinase activity",
  "GO:0009032": "thymidine phosphorylase activity",
  "GO:0009033": "trimethylamine-N-oxide reductase activity",
  "GO:0009034": "tryptophanase activity",
  "GO:0009035": "Type I site-specific deoxyribonuclease activity",
  "GO:0009036": "Type II site-specific deoxyribonuclease activity",
  "GO:0009037": "tyrosine-based site-specific recombinase activity",
  "GO:0009038": "undecaprenol kinase activity",
  "GO:0009039": "urease activity",
  "GO:0009040": "ureidoglycolate dehydrogenase activity",
  "GO:0009041": "uridylate kinase activity",
  "GO:0009042": "valine-pyruvate transaminase activity",
  "GO:0009044": "xylan 1,4-beta-xylosidase activity",
  "GO:0009045": "xylose isomerase activity",
  "GO:0009046": "zinc D-Ala-D-Ala carboxypeptidase activity",
  "GO:0009047": "dosage compensation by hyperactivation of X chromosome",
  "GO:0009048": "dosage compensation by inactivation of X chromosome",
  "GO:0009049": "obsolete aspartic-type signal peptidase activity",
  "GO:0009050": "glycopeptide catabolic process",
  "GO:0009051": "pentose-phosphate shunt, oxidative branch",
  "GO:0009052": "pentose-phosphate shunt, non-oxidative branch",
  "GO:0009055": "electron carrier activity",
  "GO:0009056": "catabolic process",
  "GO:0009057": "macromolecule catabolic process",
  "GO:0009058": "biosynthetic process",
  "GO:0009059": "macromolecule biosynthetic process",
  "GO:0009060": "aerobic respiration",
  "GO:0009061": "anaerobic respiration",
  "GO:0009062": "fatty acid catabolic process",
  "GO:0009063": "cellular amino acid catabolic process",
  "GO:0009064": "glutamine family amino acid metabolic process",
  "GO:0009065": "glutamine family amino acid catabolic process",
  "GO:0009066": "aspartate family amino acid metabolic process",
  "GO:0009067": "aspartate family amino acid biosynthetic process",
  "GO:0009068": "aspartate family amino acid catabolic process",
  "GO:0009069": "serine family amino acid metabolic process",
  "GO:0009070": "serine family amino acid biosynthetic process",
  "GO:0009071": "serine family amino acid catabolic process",
  "GO:0009072": "aromatic amino acid family metabolic process",
  "GO:0009073": "aromatic amino acid family biosynthetic process",
  "GO:0009074": "aromatic amino acid family catabolic process",
  "GO:0009075": "obsolete histidine family amino acid metabolic process",
  "GO:0009076": "obsolete histidine family amino acid biosynthetic process",
  "GO:0009077": "obsolete histidine family amino acid catabolic process",
  "GO:0009078": "pyruvate family amino acid metabolic process",
  "GO:0009079": "pyruvate family amino acid biosynthetic process",
  "GO:0009080": "pyruvate family amino acid catabolic process",
  "GO:0009081": "branched-chain amino acid metabolic process",
  "GO:0009082": "branched-chain amino acid biosynthetic process",
  "GO:0009083": "branched-chain amino acid catabolic process",
  "GO:0009084": "glutamine family amino acid biosynthetic process",
  "GO:0009085": "lysine biosynthetic process",
  "GO:0009086": "methionine biosynthetic process",
  "GO:0009087": "methionine catabolic process",
  "GO:0009088": "threonine biosynthetic process",
  "GO:0009089": "lysine biosynthetic process via diaminopimelate",
  "GO:0009090": "homoserine biosynthetic process",
  "GO:0009091": "homoserine catabolic process",
  "GO:0009092": "homoserine metabolic process",
  "GO:0009093": "cysteine catabolic process",
  "GO:0009094": "L-phenylalanine biosynthetic process",
  "GO:0009095": "aromatic amino acid family biosynthetic process, prephenate pathway",
  "GO:0009097": "isoleucine biosynthetic process",
  "GO:0009098": "leucine biosynthetic process",
  "GO:0009099": "valine biosynthetic process",
  "GO:0009100": "glycoprotein metabolic process",
  "GO:0009101": "glycoprotein biosynthetic process",
  "GO:0009102": "biotin biosynthetic process",
  "GO:0009103": "lipopolysaccharide biosynthetic process",
  "GO:0009104": "lipopolysaccharide catabolic process",
  "GO:0009106": "lipoate metabolic process",
  "GO:0009107": "lipoate biosynthetic process",
  "GO:0009108": "coenzyme biosynthetic process",
  "GO:0009109": "coenzyme catabolic process",
  "GO:0009110": "vitamin biosynthetic process",
  "GO:0009111": "vitamin catabolic process",
  "GO:0009112": "nucleobase metabolic process",
  "GO:0009113": "purine nucleobase biosynthetic process",
  "GO:0009114": "hypoxanthine catabolic process",
  "GO:0009115": "xanthine catabolic process",
  "GO:0009116": "nucleoside metabolic process",
  "GO:0009117": "nucleotide metabolic process",
  "GO:0009118": "regulation of nucleoside metabolic process",
  "GO:0009119": "ribonucleoside metabolic process",
  "GO:0009120": "deoxyribonucleoside metabolic process",
  "GO:0009123": "nucleoside monophosphate metabolic process",
  "GO:0009124": "nucleoside monophosphate biosynthetic process",
  "GO:0009125": "nucleoside monophosphate catabolic process",
  "GO:0009126": "purine nucleoside monophosphate metabolic process",
  "GO:0009127": "purine nucleoside monophosphate biosynthetic process",
  "GO:0009128": "purine nucleoside monophosphate catabolic process",
  "GO:0009129": "pyrimidine nucleoside monophosphate metabolic process",
  "GO:0009130": "pyrimidine nucleoside monophosphate biosynthetic process",
  "GO:0009131": "pyrimidine nucleoside monophosphate catabolic process",
  "GO:0009132": "nucleoside diphosphate metabolic process",
  "GO:0009133": "nucleoside diphosphate biosynthetic process",
  "GO:0009134": "nucleoside diphosphate catabolic process",
  "GO:0009135": "purine nucleoside diphosphate metabolic process",
  "GO:0009136": "purine nucleoside diphosphate biosynthetic process",
  "GO:0009137": "purine nucleoside diphosphate catabolic process",
  "GO:0009138": "pyrimidine nucleoside diphosphate metabolic process",
  "GO:0009139": "pyrimidine nucleoside diphosphate biosynthetic process",
  "GO:0009140": "pyrimidine nucleoside diphosphate catabolic process",
  "GO:0009141": "nucleoside triphosphate metabolic process",
  "GO:0009142": "nucleoside triphosphate biosynthetic process",
  "GO:0009143": "nucleoside triphosphate catabolic process",
  "GO:0009144": "purine nucleoside triphosphate metabolic process",
  "GO:0009145": "purine nucleoside triphosphate biosynthetic process",
  "GO:0009146": "purine nucleoside triphosphate catabolic process",
  "GO:0009147": "pyrimidine nucleoside triphosphate metabolic process",
  "GO:0009148": "pyrimidine nucleoside triphosphate biosynthetic process",
  "GO:0009149": "pyrimidine nucleoside triphosphate catabolic process",
  "GO:0009150": "purine ribonucleotide metabolic process",
  "GO:0009151": "purine deoxyribonucleotide metabolic process",
  "GO:0009152": "purine ribonucleotide biosynthetic process",
  "GO:0009153": "purine deoxyribonucleotide biosynthetic process",
  "GO:0009154": "purine ribonucleotide catabolic process",
  "GO:0009155": "purine deoxyribonucleotide catabolic process",
  "GO:0009156": "ribonucleoside monophosphate biosynthetic process",
  "GO:0009157": "deoxyribonucleoside monophosphate biosynthetic process",
  "GO:0009158": "ribonucleoside monophosphate catabolic process",
  "GO:0009159": "deoxyribonucleoside monophosphate catabolic process",
  "GO:0009161": "ribonucleoside monophosphate metabolic process",
  "GO:0009162": "deoxyribonucleoside monophosphate metabolic process",
  "GO:0009163": "nucleoside biosynthetic process",
  "GO:0009164": "nucleoside catabolic process",
  "GO:0009165": "nucleotide biosynthetic process",
  "GO:0009166": "nucleotide catabolic process",
  "GO:0009167": "purine ribonucleoside monophosphate metabolic process",
  "GO:0009168": "purine ribonucleoside monophosphate biosynthetic process",
  "GO:0009169": "purine ribonucleoside monophosphate catabolic process",
  "GO:0009170": "purine deoxyribonucleoside monophosphate metabolic process",
  "GO:0009171": "purine deoxyribonucleoside monophosphate biosynthetic process",
  "GO:0009172": "purine deoxyribonucleoside monophosphate catabolic process",
  "GO:0009173": "pyrimidine ribonucleoside monophosphate metabolic process",
  "GO:0009174": "pyrimidine ribonucleoside monophosphate biosynthetic process",
  "GO:0009175": "pyrimidine ribonucleoside monophosphate catabolic process",
  "GO:0009176": "pyrimidine deoxyribonucleoside monophosphate metabolic process",
  "GO:0009177": "pyrimidine deoxyribonucleoside monophosphate biosynthetic process",
  "GO:0009178": "pyrimidine deoxyribonucleoside monophosphate catabolic process",
  "GO:0009179": "purine ribonucleoside diphosphate metabolic process",
  "GO:0009180": "purine ribonucleoside diphosphate biosynthetic process",
  "GO:0009181": "purine ribonucleoside diphosphate catabolic process",
  "GO:0009182": "purine deoxyribonucleoside diphosphate metabolic process",
  "GO:0009183": "purine deoxyribonucleoside diphosphate biosynthetic process",
  "GO:0009184": "purine deoxyribonucleoside diphosphate catabolic process",
  "GO:0009185": "ribonucleoside diphosphate metabolic process",
  "GO:0009186": "deoxyribonucleoside diphosphate metabolic process",
  "GO:0009187": "cyclic nucleotide metabolic process",
  "GO:0009188": "ribonucleoside diphosphate biosynthetic process",
  "GO:0009189": "deoxyribonucleoside diphosphate biosynthetic process",
  "GO:0009190": "cyclic nucleotide biosynthetic process",
  "GO:0009191": "ribonucleoside diphosphate catabolic process",
  "GO:0009192": "deoxyribonucleoside diphosphate catabolic process",
  "GO:0009193": "pyrimidine ribonucleoside diphosphate metabolic process",
  "GO:0009194": "pyrimidine ribonucleoside diphosphate biosynthetic process",
  "GO:0009195": "pyrimidine ribonucleoside diphosphate catabolic process",
  "GO:0009196": "pyrimidine deoxyribonucleoside diphosphate metabolic process",
  "GO:0009197": "pyrimidine deoxyribonucleoside diphosphate biosynthetic process",
  "GO:0009198": "pyrimidine deoxyribonucleoside diphosphate catabolic process",
  "GO:0009199": "ribonucleoside triphosphate metabolic process",
  "GO:0009200": "deoxyribonucleoside triphosphate metabolic process",
  "GO:0009201": "ribonucleoside triphosphate biosynthetic process",
  "GO:0009202": "deoxyribonucleoside triphosphate biosynthetic process",
  "GO:0009203": "ribonucleoside triphosphate catabolic process",
  "GO:0009204": "deoxyribonucleoside triphosphate catabolic process",
  "GO:0009205": "purine ribonucleoside triphosphate metabolic process",
  "GO:0009206": "purine ribonucleoside triphosphate biosynthetic process",
  "GO:0009207": "purine ribonucleoside triphosphate catabolic process",
  "GO:0009208": "pyrimidine ribonucleoside triphosphate metabolic process",
  "GO:0009209": "pyrimidine ribonucleoside triphosphate biosynthetic process",
  "GO:0009210": "pyrimidine ribonucleoside triphosphate catabolic process",
  "GO:0009211": "pyrimidine deoxyribonucleoside triphosphate metabolic process",
  "GO:0009212": "pyrimidine deoxyribonucleoside triphosphate biosynthetic process",
  "GO:0009213": "pyrimidine deoxyribonucleoside triphosphate catabolic process",
  "GO:0009214": "cyclic nucleotide catabolic process",
  "GO:0009215": "purine deoxyribonucleoside triphosphate metabolic process",
  "GO:0009216": "purine deoxyribonucleoside triphosphate biosynthetic process",
  "GO:0009217": "purine deoxyribonucleoside triphosphate catabolic process",
  "GO:0009218": "pyrimidine ribonucleotide metabolic process",
  "GO:0009219": "pyrimidine deoxyribonucleotide metabolic process",
  "GO:0009220": "pyrimidine ribonucleotide biosynthetic process",
  "GO:0009221": "pyrimidine deoxyribonucleotide biosynthetic process",
  "GO:0009222": "pyrimidine ribonucleotide catabolic process",
  "GO:0009223": "pyrimidine deoxyribonucleotide catabolic process",
  "GO:0009224": "CMP biosynthetic process",
  "GO:0009225": "nucleotide-sugar metabolic process",
  "GO:0009226": "nucleotide-sugar biosynthetic process",
  "GO:0009227": "nucleotide-sugar catabolic process",
  "GO:0009228": "thiamine biosynthetic process",
  "GO:0009229": "thiamine diphosphate biosynthetic process",
  "GO:0009230": "thiamine catabolic process",
  "GO:0009231": "riboflavin biosynthetic process",
  "GO:0009232": "riboflavin catabolic process",
  "GO:0009233": "menaquinone metabolic process",
  "GO:0009234": "menaquinone biosynthetic process",
  "GO:0009235": "cobalamin metabolic process",
  "GO:0009236": "cobalamin biosynthetic process",
  "GO:0009237": "siderophore metabolic process",
  "GO:0009238": "enterobactin metabolic process",
  "GO:0009239": "enterobactin biosynthetic process",
  "GO:0009240": "isopentenyl diphosphate biosynthetic process",
  "GO:0009242": "colanic acid biosynthetic process",
  "GO:0009243": "O antigen biosynthetic process",
  "GO:0009244": "lipopolysaccharide core region biosynthetic process",
  "GO:0009245": "lipid A biosynthetic process",
  "GO:0009246": "enterobacterial common antigen biosynthetic process",
  "GO:0009247": "glycolipid biosynthetic process",
  "GO:0009248": "K antigen biosynthetic process",
  "GO:0009249": "protein lipoylation",
  "GO:0009250": "glucan biosynthetic process",
  "GO:0009251": "glucan catabolic process",
  "GO:0009252": "peptidoglycan biosynthetic process",
  "GO:0009253": "peptidoglycan catabolic process",
  "GO:0009254": "peptidoglycan turnover",
  "GO:0009255": "Entner-Doudoroff pathway through 6-phosphogluconate",
  "GO:0009256": "10-formyltetrahydrofolate metabolic process",
  "GO:0009257": "10-formyltetrahydrofolate biosynthetic process",
  "GO:0009258": "10-formyltetrahydrofolate catabolic process",
  "GO:0009259": "ribonucleotide metabolic process",
  "GO:0009260": "ribonucleotide biosynthetic process",
  "GO:0009261": "ribonucleotide catabolic process",
  "GO:0009262": "deoxyribonucleotide metabolic process",
  "GO:0009263": "deoxyribonucleotide biosynthetic process",
  "GO:0009264": "deoxyribonucleotide catabolic process",
  "GO:0009265": "2'-deoxyribonucleotide biosynthetic process",
  "GO:0009266": "response to temperature stimulus",
  "GO:0009267": "cellular response to starvation",
  "GO:0009268": "response to pH",
  "GO:0009269": "response to desiccation",
  "GO:0009270": "response to humidity",
  "GO:0009271": "phage shock",
  "GO:0009272": "fungal-type cell wall biogenesis",
  "GO:0009273": "peptidoglycan-based cell wall biogenesis",
  "GO:0009274": "peptidoglycan-based cell wall",
  "GO:0009275": "Gram-positive-bacterium-type cell wall",
  "GO:0009276": "Gram-negative-bacterium-type cell wall",
  "GO:0009277": "fungal-type cell wall",
  "GO:0009278": "obsolete murein sacculus",
  "GO:0009279": "cell outer membrane",
  "GO:0009280": "obsolete cell wall inner membrane",
  "GO:0009288": "bacterial-type flagellum",
  "GO:0009289": "pilus",
  "GO:0009290": "DNA import into cell involved in transformation",
  "GO:0009291": "unidirectional conjugation",
  "GO:0009292": "genetic transfer",
  "GO:0009293": "transduction",
  "GO:0009294": "DNA mediated transformation",
  "GO:0009295": "nucleoid",
  "GO:0009296": "obsolete flagellum assembly",
  "GO:0009297": "pilus assembly",
  "GO:0009298": "GDP-mannose biosynthetic process",
  "GO:0009299": "mRNA transcription",
  "GO:0009300": "antisense RNA transcription",
  "GO:0009301": "snRNA transcription",
  "GO:0009302": "snoRNA transcription",
  "GO:0009303": "rRNA transcription",
  "GO:0009304": "tRNA transcription",
  "GO:0009305": "protein biotinylation",
  "GO:0009306": "protein secretion",
  "GO:0009307": "DNA restriction-modification system",
  "GO:0009308": "amine metabolic process",
  "GO:0009309": "amine biosynthetic process",
  "GO:0009310": "amine catabolic process",
  "GO:0009311": "oligosaccharide metabolic process",
  "GO:0009312": "oligosaccharide biosynthetic process",
  "GO:0009313": "oligosaccharide catabolic process",
  "GO:0009314": "response to radiation",
  "GO:0009315": "obsolete drug resistance",
  "GO:0009316": "3-isopropylmalate dehydratase complex",
  "GO:0009317": "acetyl-CoA carboxylase complex",
  "GO:0009318": "exodeoxyribonuclease VII complex",
  "GO:0009319": "cytochrome o ubiquinol oxidase complex",
  "GO:0009320": "phosphoribosylaminoimidazole carboxylase complex",
  "GO:0009321": "alkyl hydroperoxide reductase complex",
  "GO:0009322": "trimethylamine-N-oxide reductase complex",
  "GO:0009323": "ribosomal-protein-alanine N-acetyltransferase complex",
  "GO:0009324": "D-amino-acid dehydrogenase complex",
  "GO:0009325": "nitrate reductase complex",
  "GO:0009326": "formate dehydrogenase complex",
  "GO:0009327": "NAD(P)+ transhydrogenase complex (AB-specific)",
  "GO:0009328": "phenylalanine-tRNA ligase complex",
  "GO:0009329": "acetate CoA-transferase complex",
  "GO:0009330": "DNA topoisomerase complex (ATP-hydrolyzing)",
  "GO:0009331": "glycerol-3-phosphate dehydrogenase complex",
  "GO:0009332": "glutamate-tRNA ligase complex",
  "GO:0009333": "cysteine synthase complex",
  "GO:0009334": "3-phenylpropionate dioxygenase complex",
  "GO:0009335": "obsolete holo-[acyl-carrier protein] synthase complex",
  "GO:0009336": "sulfate adenylyltransferase complex (ATP)",
  "GO:0009337": "sulfite reductase complex (NADPH)",
  "GO:0009338": "exodeoxyribonuclease V complex",
  "GO:0009339": "glycolate oxidase complex",
  "GO:0009340": "DNA topoisomerase IV complex",
  "GO:0009341": "beta-galactosidase complex",
  "GO:0009342": "glutamate synthase complex (NADPH)",
  "GO:0009343": "biotin carboxylase complex",
  "GO:0009344": "nitrite reductase complex [NAD(P)H]",
  "GO:0009345": "glycine-tRNA ligase complex",
  "GO:0009346": "citrate lyase complex",
  "GO:0009347": "aspartate carbamoyltransferase complex",
  "GO:0009348": "ornithine carbamoyltransferase complex",
  "GO:0009349": "riboflavin synthase complex",
  "GO:0009350": "ethanolamine ammonia-lyase complex",
  "GO:0009351": "obsolete dihydrolipoamide S-acyltransferase complex",
  "GO:0009352": "obsolete dihydrolipoyl dehydrogenase complex",
  "GO:0009353": "mitochondrial oxoglutarate dehydrogenase complex",
  "GO:0009354": "obsolete dihydrolipoamide S-succinyltransferase complex",
  "GO:0009355": "DNA polymerase V complex",
  "GO:0009356": "aminodeoxychorismate synthase complex",
  "GO:0009357": "protein-N(PI)-phosphohistidine-sugar phosphotransferase complex",
  "GO:0009358": "polyphosphate kinase complex",
  "GO:0009359": "Type II site-specific deoxyribonuclease complex",
  "GO:0009360": "DNA polymerase III complex",
  "GO:0009361": "succinate-CoA ligase complex (ADP-forming)",
  "GO:0009365": "protein histidine kinase complex",
  "GO:0009366": "enterobactin synthetase complex",
  "GO:0009367": "obsolete prepilin peptidase complex",
  "GO:0009368": "endopeptidase Clp complex",
  "GO:0009371": "positive regulation of transcription by pheromones",
  "GO:0009372": "quorum sensing",
  "GO:0009373": "regulation of transcription by pheromones",
  "GO:0009374": "biotin binding",
  "GO:0009375": "ferredoxin hydrogenase complex",
  "GO:0009376": "HslUV protease complex",
  "GO:0009377": "obsolete HslUV protease activity",
  "GO:0009378": "four-way junction helicase activity",
  "GO:0009379": "Holliday junction helicase complex",
  "GO:0009380": "excinuclease repair complex",
  "GO:0009381": "excinuclease ABC activity",
  "GO:0009382": "imidazoleglycerol-phosphate synthase complex",
  "GO:0009383": "rRNA (cytosine-C5-)-methyltransferase activity",
  "GO:0009384": "N-acylmannosamine kinase activity",
  "GO:0009385": "N-acylmannosamine-6-phosphate 2-epimerase activity",
  "GO:0009386": "translational attenuation",
  "GO:0009388": "obsolete antisense RNA",
  "GO:0009389": "dimethyl sulfoxide reductase activity",
  "GO:0009390": "dimethyl sulfoxide reductase complex",
  "GO:0009392": "N-acetyl-anhydromuramoyl-L-alanine amidase activity",
  "GO:0009394": "2'-deoxyribonucleotide metabolic process",
  "GO:0009395": "phospholipid catabolic process",
  "GO:0009396": "folic acid-containing compound biosynthetic process",
  "GO:0009397": "folic acid-containing compound catabolic process",
  "GO:0009398": "FMN biosynthetic process",
  "GO:0009399": "nitrogen fixation",
  "GO:0009400": "receptor signaling protein serine/threonine phosphatase activity",
  "GO:0009401": "phosphoenolpyruvate-dependent sugar phosphotransferase system",
  "GO:0009402": "obsolete toxin resistance",
  "GO:0009403": "toxin biosynthetic process",
  "GO:0009404": "toxin metabolic process",
  "GO:0009405": "pathogenesis",
  "GO:0009406": "obsolete virulence",
  "GO:0009407": "toxin catabolic process",
  "GO:0009408": "response to heat",
  "GO:0009409": "response to cold",
  "GO:0009410": "response to xenobiotic stimulus",
  "GO:0009411": "response to UV",
  "GO:0009412": "obsolete response to heavy metal",
  "GO:0009413": "response to flooding",
  "GO:0009414": "response to water deprivation",
  "GO:0009415": "response to water",
  "GO:0009416": "response to light stimulus",
  "GO:0009417": "obsolete fimbrin",
  "GO:0009418": "pilus shaft",
  "GO:0009419": "pilus tip",
  "GO:0009420": "bacterial-type flagellum filament",
  "GO:0009421": "bacterial-type flagellum filament cap",
  "GO:0009422": "bacterial-type flagellum hook-filament junction",
  "GO:0009423": "chorismate biosynthetic process",
  "GO:0009424": "bacterial-type flagellum hook",
  "GO:0009425": "bacterial-type flagellum basal body",
  "GO:0009426": "bacterial-type flagellum basal body, distal rod",
  "GO:0009427": "bacterial-type flagellum basal body, distal rod, L ring",
  "GO:0009428": "bacterial-type flagellum basal body, distal rod, P ring",
  "GO:0009429": "bacterial-type flagellum basal body, proximal rod",
  "GO:0009431": "bacterial-type flagellum basal body, MS ring",
  "GO:0009432": "SOS response",
  "GO:0009433": "bacterial-type flagellum basal body, C ring",
  "GO:0009435": "NAD biosynthetic process",
  "GO:0009436": "glyoxylate catabolic process",
  "GO:0009437": "carnitine metabolic process",
  "GO:0009438": "methylglyoxal metabolic process",
  "GO:0009439": "cyanate metabolic process",
  "GO:0009440": "cyanate catabolic process",
  "GO:0009441": "glycolate metabolic process",
  "GO:0009442": "allantoin assimilation pathway",
  "GO:0009443": "pyridoxal 5'-phosphate salvage",
  "GO:0009444": "pyruvate oxidation",
  "GO:0009445": "putrescine metabolic process",
  "GO:0009446": "putrescine biosynthetic process",
  "GO:0009447": "putrescine catabolic process",
  "GO:0009448": "gamma-aminobutyric acid metabolic process",
  "GO:0009449": "gamma-aminobutyric acid biosynthetic process",
  "GO:0009450": "gamma-aminobutyric acid catabolic process",
  "GO:0009451": "RNA modification",
  "GO:0009452": "7-methylguanosine RNA capping",
  "GO:0009453": "energy taxis",
  "GO:0009454": "aerotaxis",
  "GO:0009455": "redox taxis",
  "GO:0009457": "obsolete flavodoxin",
  "GO:0009458": "obsolete cytochrome",
  "GO:0009459": "obsolete cytochrome a",
  "GO:0009460": "obsolete cytochrome b",
  "GO:0009461": "obsolete cytochrome c",
  "GO:0009462": "obsolete cytochrome d",
  "GO:0009463": "obsolete cytochrome b/b6",
  "GO:0009464": "obsolete cytochrome b5",
  "GO:0009465": "obsolete soluble cytochrome b562",
  "GO:0009466": "obsolete class I cytochrome c",
  "GO:0009467": "obsolete monoheme class I cytochrome c",
  "GO:0009468": "obsolete diheme class I cytochrome c",
  "GO:0009469": "obsolete class II cytochrome c",
  "GO:0009470": "obsolete class IIa cytochrome c",
  "GO:0009471": "obsolete class III cytochrome c",
  "GO:0009472": "obsolete cytochrome c3 (tetraheme)",
  "GO:0009473": "obsolete cytochrome c7 (triheme)",
  "GO:0009474": "obsolete nonaheme cytochrome c",
  "GO:0009475": "obsolete high-molecular-weight cytochrome c (hexadecaheme)",
  "GO:0009476": "obsolete class IV cytochrome c",
  "GO:0009477": "obsolete cytochrome c1",
  "GO:0009478": "obsolete cytochrome c554",
  "GO:0009479": "obsolete cytochrome f",
  "GO:0009480": "obsolete class IIb cytochrome c",
  "GO:0009481": "obsolete aa3-type cytochrome c oxidase",
  "GO:0009482": "obsolete ba3-type cytochrome c oxidase",
  "GO:0009483": "obsolete caa3-type cytochrome c oxidase",
  "GO:0009485": "obsolete cbb3-type cytochrome c oxidase",
  "GO:0009486": "cytochrome bo3 ubiquinol oxidase activity",
  "GO:0009487": "obsolete glutaredoxin",
  "GO:0009488": "obsolete amicyanin",
  "GO:0009489": "obsolete rubredoxin",
  "GO:0009490": "obsolete mononuclear iron electron carrier",
  "GO:0009491": "obsolete redox-active disulfide bond electron carrier",
  "GO:0009492": "obsolete 2Fe-2S electron transfer carrier",
  "GO:0009493": "obsolete adrenodoxin-type ferredoxin",
  "GO:0009494": "obsolete chloroplast-type ferredoxin",
  "GO:0009495": "obsolete thioredoxin-like 2Fe-2S ferredoxin",
  "GO:0009496": "plastoquinol--plastocyanin reductase activity",
  "GO:0009497": "obsolete 3Fe-4S/4Fe-4S electron transfer carrier",
  "GO:0009498": "obsolete bacterial-type ferredoxin",
  "GO:0009499": "obsolete monocluster bacterial-type ferredoxin",
  "GO:0009500": "obsolete dicluster bacterial-type ferredoxin",
  "GO:0009501": "amyloplast",
  "GO:0009502": "obsolete photosynthetic electron transport chain",
  "GO:0009503": "thylakoid light-harvesting complex",
  "GO:0009504": "cell plate",
  "GO:0009505": "plant-type cell wall",
  "GO:0009506": "plasmodesma",
  "GO:0009507": "chloroplast",
  "GO:0009508": "plastid chromosome",
  "GO:0009509": "chromoplast",
  "GO:0009510": "plasmodesmatal desmotubule",
  "GO:0009511": "plasmodesmatal endoplasmic reticulum",
  "GO:0009512": "cytochrome b6f complex",
  "GO:0009513": "etioplast",
  "GO:0009514": "glyoxysome",
  "GO:0009515": "granal stacked thylakoid",
  "GO:0009516": "leucoplast",
  "GO:0009517": "PSII associated light-harvesting complex II",
  "GO:0009518": "PSI associated light-harvesting complex I",
  "GO:0009519": "middle lamella",
  "GO:0009521": "photosystem",
  "GO:0009522": "photosystem I",
  "GO:0009523": "photosystem II",
  "GO:0009524": "phragmoplast",
  "GO:0009525": "phragmosome",
  "GO:0009526": "plastid envelope",
  "GO:0009527": "plastid outer membrane",
  "GO:0009528": "plastid inner membrane",
  "GO:0009529": "plastid intermembrane space",
  "GO:0009530": "primary cell wall",
  "GO:0009531": "secondary cell wall",
  "GO:0009532": "plastid stroma",
  "GO:0009533": "chloroplast stromal thylakoid",
  "GO:0009534": "chloroplast thylakoid",
  "GO:0009535": "chloroplast thylakoid membrane",
  "GO:0009536": "plastid",
  "GO:0009537": "proplastid",
  "GO:0009538": "photosystem I reaction center",
  "GO:0009539": "photosystem II reaction center",
  "GO:0009540": "zeaxanthin epoxidase [overall] activity",
  "GO:0009541": "etioplast prolamellar body",
  "GO:0009542": "granum",
  "GO:0009543": "chloroplast thylakoid lumen",
  "GO:0009544": "chloroplast ATP synthase complex",
  "GO:0009545": "elaioplast",
  "GO:0009546": "plasmodesmatal cytoplasmic sleeve",
  "GO:0009547": "plastid ribosome",
  "GO:0009548": "plasmodesmatal plasma membrane",
  "GO:0009549": "cellulose microfibril",
  "GO:0009550": "primary plasmodesma",
  "GO:0009551": "secondary plasmodesma",
  "GO:0009553": "embryo sac development",
  "GO:0009554": "megasporogenesis",
  "GO:0009555": "pollen development",
  "GO:0009556": "microsporogenesis",
  "GO:0009557": "antipodal cell differentiation",
  "GO:0009558": "embryo sac cellularization",
  "GO:0009559": "embryo sac central cell differentiation",
  "GO:0009560": "embryo sac egg cell differentiation",
  "GO:0009561": "megagametogenesis",
  "GO:0009562": "embryo sac nuclear migration",
  "GO:0009563": "synergid differentiation",
  "GO:0009566": "fertilization",
  "GO:0009567": "double fertilization forming a zygote and endosperm",
  "GO:0009568": "amyloplast starch grain",
  "GO:0009569": "chloroplast starch grain",
  "GO:0009570": "chloroplast stroma",
  "GO:0009571": "proplastid stroma",
  "GO:0009573": "chloroplast ribulose bisphosphate carboxylase complex",
  "GO:0009574": "preprophase band",
  "GO:0009575": "chromoplast stroma",
  "GO:0009576": "leucoplast stroma",
  "GO:0009577": "elaioplast stroma",
  "GO:0009578": "etioplast stroma",
  "GO:0009579": "thylakoid",
  "GO:0009580": "obsolete thylakoid (sensu Bacteria)",
  "GO:0009581": "detection of external stimulus",
  "GO:0009582": "detection of abiotic stimulus",
  "GO:0009583": "detection of light stimulus",
  "GO:0009584": "detection of visible light",
  "GO:0009585": "red, far-red light phototransduction",
  "GO:0009587": "obsolete phototrophin mediated phototransduction",
  "GO:0009588": "UV-A, blue light phototransduction",
  "GO:0009589": "detection of UV",
  "GO:0009590": "detection of gravity",
  "GO:0009591": "obsolete perception of mechanical stimulus",
  "GO:0009593": "detection of chemical stimulus",
  "GO:0009594": "detection of nutrient",
  "GO:0009595": "detection of biotic stimulus",
  "GO:0009597": "detection of virus",
  "GO:0009600": "detection of nematode",
  "GO:0009601": "detection of insect",
  "GO:0009602": "detection of symbiont",
  "GO:0009603": "detection of symbiotic fungus",
  "GO:0009604": "detection of symbiotic bacterium",
  "GO:0009605": "response to external stimulus",
  "GO:0009606": "tropism",
  "GO:0009607": "response to biotic stimulus",
  "GO:0009608": "response to symbiont",
  "GO:0009609": "response to symbiotic bacterium",
  "GO:0009610": "response to symbiotic fungus",
  "GO:0009611": "response to wounding",
  "GO:0009612": "response to mechanical stimulus",
  "GO:0009614": "obsolete disease resistance",
  "GO:0009615": "response to virus",
  "GO:0009616": "virus induced gene silencing",
  "GO:0009617": "response to bacterium",
  "GO:0009619": "obsolete resistance to pathogenic bacteria",
  "GO:0009620": "response to fungus",
  "GO:0009622": "obsolete resistance to pathogenic fungi",
  "GO:0009623": "response to parasitic fungus",
  "GO:0009624": "response to nematode",
  "GO:0009625": "response to insect",
  "GO:0009626": "plant-type hypersensitive response",
  "GO:0009627": "systemic acquired resistance",
  "GO:0009628": "response to abiotic stimulus",
  "GO:0009629": "response to gravity",
  "GO:0009630": "gravitropism",
  "GO:0009631": "cold acclimation",
  "GO:0009632": "obsolete freezing tolerance",
  "GO:0009633": "obsolete drought tolerance",
  "GO:0009634": "obsolete heavy metal sensitivity/resistance",
  "GO:0009635": "response to herbicide",
  "GO:0009636": "response to toxic substance",
  "GO:0009637": "response to blue light",
  "GO:0009638": "phototropism",
  "GO:0009639": "response to red or far red light",
  "GO:0009640": "photomorphogenesis",
  "GO:0009641": "shade avoidance",
  "GO:0009642": "response to light intensity",
  "GO:0009643": "photosynthetic acclimation",
  "GO:0009644": "response to high light intensity",
  "GO:0009645": "response to low light intensity stimulus",
  "GO:0009646": "response to absence of light",
  "GO:0009647": "skotomorphogenesis",
  "GO:0009648": "photoperiodism",
  "GO:0009649": "entrainment of circadian clock",
  "GO:0009650": "UV protection",
  "GO:0009651": "response to salt stress",
  "GO:0009652": "thigmotropism",
  "GO:0009653": "anatomical structure morphogenesis",
  "GO:0009654": "photosystem II oxygen evolving complex",
  "GO:0009655": "PSII associated light-harvesting complex II, core complex",
  "GO:0009656": "PSII associated light-harvesting complex II, peripheral complex",
  "GO:0009657": "plastid organization",
  "GO:0009658": "chloroplast organization",
  "GO:0009659": "leucoplast organization",
  "GO:0009660": "amyloplast organization",
  "GO:0009661": "chromoplast organization",
  "GO:0009662": "etioplast organization",
  "GO:0009663": "plasmodesma organization",
  "GO:0009664": "plant-type cell wall organization",
  "GO:0009665": "plastid inheritance",
  "GO:0009666": "plastid outer membrane organization",
  "GO:0009667": "plastid inner membrane organization",
  "GO:0009668": "plastid membrane organization",
  "GO:0009669": "sucrose:monovalent cation symporter activity",
  "GO:0009670": "triose-phosphate:phosphate antiporter activity",
  "GO:0009671": "nitrate:proton symporter activity",
  "GO:0009672": "auxin:proton symporter activity",
  "GO:0009673": "low-affinity phosphate transmembrane transporter activity",
  "GO:0009674": "potassium:sodium symporter activity",
  "GO:0009675": "high-affinity sulfate:proton symporter activity",
  "GO:0009676": "low-affinity sulfate:proton symporter activity",
  "GO:0009677": "double fertilization forming two zygotes",
  "GO:0009678": "hydrogen-translocating pyrophosphatase activity",
  "GO:0009679": "hexose:proton symporter activity",
  "GO:0009682": "induced systemic resistance",
  "GO:0009683": "indoleacetic acid metabolic process",
  "GO:0009684": "indoleacetic acid biosynthetic process",
  "GO:0009685": "gibberellin metabolic process",
  "GO:0009686": "gibberellin biosynthetic process",
  "GO:0009687": "abscisic acid metabolic process",
  "GO:0009688": "abscisic acid biosynthetic process",
  "GO:0009689": "induction of phytoalexin biosynthetic process",
  "GO:0009690": "cytokinin metabolic process",
  "GO:0009691": "cytokinin biosynthetic process",
  "GO:0009692": "ethylene metabolic process",
  "GO:0009693": "ethylene biosynthetic process",
  "GO:0009694": "jasmonic acid metabolic process",
  "GO:0009695": "jasmonic acid biosynthetic process",
  "GO:0009696": "salicylic acid metabolic process",
  "GO:0009697": "salicylic acid biosynthetic process",
  "GO:0009698": "phenylpropanoid metabolic process",
  "GO:0009699": "phenylpropanoid biosynthetic process",
  "GO:0009700": "indole phytoalexin biosynthetic process",
  "GO:0009701": "isoflavonoid phytoalexin biosynthetic process",
  "GO:0009702": "L-arabinokinase activity",
  "GO:0009703": "nitrate reductase (NADH) activity",
  "GO:0009704": "de-etiolation",
  "GO:0009705": "plant-type vacuole membrane",
  "GO:0009706": "chloroplast inner membrane",
  "GO:0009707": "chloroplast outer membrane",
  "GO:0009708": "benzyl isoquinoline alkaloid biosynthetic process",
  "GO:0009709": "terpenoid indole alkaloid biosynthetic process",
  "GO:0009710": "tropane alkaloid biosynthetic process",
  "GO:0009711": "purine alkaloid biosynthetic process",
  "GO:0009712": "catechol-containing compound metabolic process",
  "GO:0009713": "catechol-containing compound biosynthetic process",
  "GO:0009714": "chalcone metabolic process",
  "GO:0009715": "chalcone biosynthetic process",
  "GO:0009716": "flavonoid phytoalexin biosynthetic process",
  "GO:0009717": "isoflavonoid biosynthetic process",
  "GO:0009718": "anthocyanin-containing compound biosynthetic process",
  "GO:0009719": "response to endogenous stimulus",
  "GO:0009720": "detection of hormone stimulus",
  "GO:0009721": "detection of auxin stimulus",
  "GO:0009722": "detection of cytokinin stimulus",
  "GO:0009723": "response to ethylene",
  "GO:0009724": "detection of abscisic acid stimulus",
  "GO:0009725": "response to hormone",
  "GO:0009726": "detection of endogenous stimulus",
  "GO:0009727": "detection of ethylene stimulus",
  "GO:0009728": "detection of gibberellic acid stimulus",
  "GO:0009729": "detection of brassinosteroid stimulus",
  "GO:0009730": "detection of carbohydrate stimulus",
  "GO:0009731": "detection of sucrose stimulus",
  "GO:0009732": "detection of hexose stimulus",
  "GO:0009733": "response to auxin",
  "GO:0009734": "auxin-activated signaling pathway",
  "GO:0009735": "response to cytokinin",
  "GO:0009736": "cytokinin-activated signaling pathway",
  "GO:0009737": "response to abscisic acid",
  "GO:0009738": "abscisic acid-activated signaling pathway",
  "GO:0009739": "response to gibberellin",
  "GO:0009740": "gibberellic acid mediated signaling pathway",
  "GO:0009741": "response to brassinosteroid",
  "GO:0009742": "brassinosteroid mediated signaling pathway",
  "GO:0009743": "response to carbohydrate",
  "GO:0009744": "response to sucrose",
  "GO:0009745": "sucrose mediated signaling",
  "GO:0009746": "response to hexose",
  "GO:0009747": "hexokinase-dependent signaling",
  "GO:0009748": "hexokinase-independent signaling",
  "GO:0009749": "response to glucose",
  "GO:0009750": "response to fructose",
  "GO:0009751": "response to salicylic acid",
  "GO:0009752": "detection of salicylic acid stimulus",
  "GO:0009753": "response to jasmonic acid",
  "GO:0009754": "detection of jasmonic acid stimulus",
  "GO:0009755": "hormone-mediated signaling pathway",
  "GO:0009756": "carbohydrate mediated signaling",
  "GO:0009757": "hexose mediated signaling",
  "GO:0009758": "carbohydrate utilization",
  "GO:0009759": "indole glucosinolate biosynthetic process",
  "GO:0009760": "C4 photosynthesis",
  "GO:0009761": "CAM photosynthesis",
  "GO:0009762": "NADP-malic enzyme C4 photosynthesis",
  "GO:0009763": "NAD-malic enzyme C4 photosynthesis",
  "GO:0009764": "PEP carboxykinase C4 photosynthesis",
  "GO:0009765": "photosynthesis, light harvesting",
  "GO:0009766": "primary charge separation",
  "GO:0009767": "photosynthetic electron transport chain",
  "GO:0009768": "photosynthesis, light harvesting in photosystem I",
  "GO:0009769": "photosynthesis, light harvesting in photosystem II",
  "GO:0009770": "primary charge separation in photosystem I",
  "GO:0009771": "primary charge separation in photosystem II",
  "GO:0009772": "photosynthetic electron transport in photosystem II",
  "GO:0009773": "photosynthetic electron transport in photosystem I",
  "GO:0009777": "photosynthetic phosphorylation",
  "GO:0009778": "cyclic photosynthetic phosphorylation",
  "GO:0009779": "noncyclic photosynthetic phosphorylation",
  "GO:0009780": "photosynthetic NADP+ reduction",
  "GO:0009781": "obsolete photosynthetic water oxidation",
  "GO:0009782": "photosystem I antenna complex",
  "GO:0009783": "photosystem II antenna complex",
  "GO:0009784": "transmembrane receptor histidine kinase activity",
  "GO:0009785": "blue light signaling pathway",
  "GO:0009786": "regulation of asymmetric cell division",
  "GO:0009787": "regulation of abscisic acid-activated signaling pathway",
  "GO:0009788": "negative regulation of abscisic acid-activated signaling pathway",
  "GO:0009789": "positive regulation of abscisic acid-activated signaling pathway",
  "GO:0009790": "embryo development",
  "GO:0009791": "post-embryonic development",
  "GO:0009792": "embryo development ending in birth or egg hatching",
  "GO:0009793": "embryo development ending in seed dormancy",
  "GO:0009794": "regulation of mitotic cell cycle, embryonic",
  "GO:0009798": "axis specification",
  "GO:0009799": "specification of symmetry",
  "GO:0009800": "cinnamic acid biosynthetic process",
  "GO:0009801": "cinnamic acid ester metabolic process",
  "GO:0009802": "cinnamic acid ester biosynthetic process",
  "GO:0009803": "cinnamic acid metabolic process",
  "GO:0009804": "coumarin metabolic process",
  "GO:0009805": "coumarin biosynthetic process",
  "GO:0009806": "lignan metabolic process",
  "GO:0009807": "lignan biosynthetic process",
  "GO:0009808": "lignin metabolic process",
  "GO:0009809": "lignin biosynthetic process",
  "GO:0009810": "stilbene metabolic process",
  "GO:0009811": "stilbene biosynthetic process",
  "GO:0009812": "flavonoid metabolic process",
  "GO:0009813": "flavonoid biosynthetic process",
  "GO:0009814": "defense response, incompatible interaction",
  "GO:0009815": "1-aminocyclopropane-1-carboxylate oxidase activity",
  "GO:0009816": "defense response to bacterium, incompatible interaction",
  "GO:0009817": "defense response to fungus, incompatible interaction",
  "GO:0009818": "defense response to protozoan, incompatible interaction",
  "GO:0009819": "drought recovery",
  "GO:0009820": "alkaloid metabolic process",
  "GO:0009821": "alkaloid biosynthetic process",
  "GO:0009822": "alkaloid catabolic process",
  "GO:0009823": "cytokinin catabolic process",
  "GO:0009824": "AMP dimethylallyltransferase activity",
  "GO:0009825": "multidimensional cell growth",
  "GO:0009826": "unidimensional cell growth",
  "GO:0009827": "plant-type cell wall modification",
  "GO:0009828": "plant-type cell wall loosening",
  "GO:0009829": "cell wall modification involved in fruit ripening",
  "GO:0009830": "cell wall modification involved in abscission",
  "GO:0009831": "plant-type cell wall modification involved in multidimensional cell growth",
  "GO:0009832": "plant-type cell wall biogenesis",
  "GO:0009833": "plant-type primary cell wall biogenesis",
  "GO:0009834": "plant-type secondary cell wall biogenesis",
  "GO:0009835": "fruit ripening",
  "GO:0009836": "fruit ripening, climacteric",
  "GO:0009837": "fruit ripening, non-climacteric",
  "GO:0009838": "abscission",
  "GO:0009839": "obsolete SCF complex substrate recognition subunit",
  "GO:0009840": "chloroplastic endopeptidase Clp complex",
  "GO:0009841": "mitochondrial endopeptidase Clp complex",
  "GO:0009842": "cyanelle",
  "GO:0009843": "cyanelle thylakoid",
  "GO:0009844": "obsolete germination",
  "GO:0009845": "seed germination",
  "GO:0009846": "pollen germination",
  "GO:0009847": "spore germination",
  "GO:0009848": "indoleacetic acid biosynthetic process via tryptophan",
  "GO:0009849": "tryptophan-independent indoleacetic acid biosynthetic process",
  "GO:0009850": "auxin metabolic process",
  "GO:0009851": "auxin biosynthetic process",
  "GO:0009852": "auxin catabolic process",
  "GO:0009853": "photorespiration",
  "GO:0009854": "oxidative photosynthetic carbon pathway",
  "GO:0009855": "determination of bilateral symmetry",
  "GO:0009856": "pollination",
  "GO:0009858": "obsolete compatible pollen-pistil interaction",
  "GO:0009859": "pollen hydration",
  "GO:0009860": "pollen tube growth",
  "GO:0009861": "jasmonic acid and ethylene-dependent systemic resistance",
  "GO:0009862": "systemic acquired resistance, salicylic acid mediated signaling pathway",
  "GO:0009863": "salicylic acid mediated signaling pathway",
  "GO:0009864": "induced systemic resistance, jasmonic acid mediated signaling pathway",
  "GO:0009865": "pollen tube adhesion",
  "GO:0009866": "induced systemic resistance, ethylene mediated signaling pathway",
  "GO:0009867": "jasmonic acid mediated signaling pathway",
  "GO:0009868": "jasmonic acid and ethylene-dependent systemic resistance, jasmonic acid mediated signaling pathway",
  "GO:0009869": "obsolete incompatible pollen-pistil interaction",
  "GO:0009870": "defense response signaling pathway, resistance gene-dependent",
  "GO:0009871": "jasmonic acid and ethylene-dependent systemic resistance, ethylene mediated signaling pathway",
  "GO:0009872": "obsolete gametophytic self-incompatibility",
  "GO:0009873": "ethylene-activated signaling pathway",
  "GO:0009874": "obsolete sporophytic self-incompatibility",
  "GO:0009875": "pollen-pistil interaction",
  "GO:0009876": "pollen adhesion",
  "GO:0009877": "nodulation",
  "GO:0009878": "nodule morphogenesis",
  "GO:0009879": "determination of radial symmetry",
  "GO:0009880": "embryonic pattern specification",
  "GO:0009881": "photoreceptor activity",
  "GO:0009882": "blue light photoreceptor activity",
  "GO:0009883": "red or far-red light photoreceptor activity",
  "GO:0009884": "cytokinin receptor activity",
  "GO:0009885": "transmembrane histidine kinase cytokinin receptor activity",
  "GO:0009886": "post-embryonic morphogenesis",
  "GO:0009887": "organ morphogenesis",
  "GO:0009888": "tissue development",
  "GO:0009889": "regulation of biosynthetic process",
  "GO:0009890": "negative regulation of biosynthetic process",
  "GO:0009891": "positive regulation of biosynthetic process",
  "GO:0009892": "negative regulation of metabolic process",
  "GO:0009893": "positive regulation of metabolic process",
  "GO:0009894": "regulation of catabolic process",
  "GO:0009895": "negative regulation of catabolic process",
  "GO:0009896": "positive regulation of catabolic process",
  "GO:0009897": "external side of plasma membrane",
  "GO:0009898": "cytoplasmic side of plasma membrane",
  "GO:0009899": "ent-kaurene synthase activity",
  "GO:0009900": "dehiscence",
  "GO:0009901": "anther dehiscence",
  "GO:0009902": "chloroplast relocation",
  "GO:0009903": "chloroplast avoidance movement",
  "GO:0009904": "chloroplast accumulation movement",
  "GO:0009905": "ent-copalyl diphosphate synthase activity",
  "GO:0009906": "response to photoperiod, blue light",
  "GO:0009907": "response to photoperiod, red light",
  "GO:0009908": "flower development",
  "GO:0009909": "regulation of flower development",
  "GO:0009910": "negative regulation of flower development",
  "GO:0009911": "positive regulation of flower development",
  "GO:0009912": "auditory receptor cell fate commitment",
  "GO:0009913": "epidermal cell differentiation",
  "GO:0009914": "hormone transport",
  "GO:0009915": "phloem sucrose loading",
  "GO:0009916": "alternative oxidase activity",
  "GO:0009917": "sterol 5-alpha reductase activity",
  "GO:0009918": "sterol delta7 reductase activity",
  "GO:0009919": "obsolete cytokinesis (sensu Viridiplantae)",
  "GO:0009920": "cell plate formation involved in plant-type cell wall biogenesis",
  "GO:0009921": "auxin efflux carrier complex",
  "GO:0009922": "fatty acid elongase activity",
  "GO:0009923": "fatty acid elongase complex",
  "GO:0009924": "octadecanal decarbonylase activity",
  "GO:0009925": "basal plasma membrane",
  "GO:0009926": "auxin polar transport",
  "GO:0009927": "histidine phosphotransfer kinase activity",
  "GO:0009930": "longitudinal side of cell surface",
  "GO:0009931": "calcium-dependent protein serine/threonine kinase activity",
  "GO:0009932": "cell tip growth",
  "GO:0009933": "meristem structural organization",
  "GO:0009934": "regulation of meristem structural organization",
  "GO:0009935": "obsolete nutrient import",
  "GO:0009936": "obsolete expansin",
  "GO:0009937": "regulation of gibberellic acid mediated signaling pathway",
  "GO:0009938": "negative regulation of gibberellic acid mediated signaling pathway",
  "GO:0009939": "positive regulation of gibberellic acid mediated signaling pathway",
  "GO:0009940": "amino-terminal vacuolar sorting propeptide binding",
  "GO:0009941": "chloroplast envelope",
  "GO:0009942": "longitudinal axis specification",
  "GO:0009943": "adaxial/abaxial axis specification",
  "GO:0009944": "polarity specification of adaxial/abaxial axis",
  "GO:0009945": "radial axis specification",
  "GO:0009946": "proximal/distal axis specification",
  "GO:0009947": "centrolateral axis specification",
  "GO:0009948": "anterior/posterior axis specification",
  "GO:0009949": "polarity specification of anterior/posterior axis",
  "GO:0009950": "dorsal/ventral axis specification",
  "GO:0009951": "polarity specification of dorsal/ventral axis",
  "GO:0009952": "anterior/posterior pattern specification",
  "GO:0009953": "dorsal/ventral pattern formation",
  "GO:0009954": "proximal/distal pattern formation",
  "GO:0009955": "adaxial/abaxial pattern specification",
  "GO:0009956": "radial pattern formation",
  "GO:0009957": "epidermal cell fate specification",
  "GO:0009958": "positive gravitropism",
  "GO:0009959": "negative gravitropism",
  "GO:0009960": "endosperm development",
  "GO:0009961": "response to 1-aminocyclopropane-1-carboxylic acid",
  "GO:0009962": "regulation of flavonoid biosynthetic process",
  "GO:0009963": "positive regulation of flavonoid biosynthetic process",
  "GO:0009964": "negative regulation of flavonoid biosynthetic process",
  "GO:0009965": "leaf morphogenesis",
  "GO:0009966": "regulation of signal transduction",
  "GO:0009967": "positive regulation of signal transduction",
  "GO:0009968": "negative regulation of signal transduction",
  "GO:0009969": "xyloglucan biosynthetic process",
  "GO:0009970": "cellular response to sulfate starvation",
  "GO:0009971": "anastral spindle assembly involved in male meiosis",
  "GO:0009972": "cytidine deamination",
  "GO:0009973": "adenylyl-sulfate reductase activity",
  "GO:0009974": "zeinoxanthin epsilon hydroxylase activity",
  "GO:0009975": "cyclase activity",
  "GO:0009976": "tocopherol cyclase activity",
  "GO:0009977": "proton motive force dependent protein transmembrane transporter activity",
  "GO:0009978": "allene oxide synthase activity",
  "GO:0009979": "16:0 monogalactosyldiacylglycerol desaturase activity",
  "GO:0009980": "obsolete glutamate carboxypeptidase activity",
  "GO:0009982": "pseudouridine synthase activity",
  "GO:0009983": "obsolete tyrosine aminopeptidase activity",
  "GO:0009984": "obsolete adenylate forming enzyme activity",
  "GO:0009985": "obsolete dihydroflavonol(thiole) lyase activity",
  "GO:0009986": "cell surface",
  "GO:0009987": "cellular process",
  "GO:0009988": "cell-cell recognition",
  "GO:0009989": "cell-matrix recognition",
  "GO:0009990": "contact guidance",
  "GO:0009991": "response to extracellular stimulus",
  "GO:0009992": "cellular water homeostasis",
  "GO:0009994": "oocyte differentiation",
  "GO:0009995": "soluble molecule recognition",
  "GO:0009996": "negative regulation of cell fate specification",
  "GO:0009997": "negative regulation of cardioblast cell fate specification",
  "GO:0009998": "negative regulation of retinal cone cell fate specification",
  "GO:0009999": "negative regulation of auditory receptor cell fate specification",
  "GO:0010001": "glial cell differentiation",
  "GO:0010002": "cardioblast differentiation",
  "GO:0010004": "gastrulation involving germ band extension",
  "GO:0010005": "cortical microtubule, transverse to long axis",
  "GO:0010006": "Toc complex",
  "GO:0010007": "magnesium chelatase complex",
  "GO:0010008": "endosome membrane",
  "GO:0010009": "cytoplasmic side of endosome membrane",
  "GO:0010011": "auxin binding",
  "GO:0010012": "steroid 22-alpha hydroxylase activity",
  "GO:0010013": "N-1-naphthylphthalamic acid binding",
  "GO:0010014": "meristem initiation",
  "GO:0010015": "root morphogenesis",
  "GO:0010016": "shoot system morphogenesis",
  "GO:0010017": "red or far-red light signaling pathway",
  "GO:0010018": "far-red light signaling pathway",
  "GO:0010019": "chloroplast-nucleus signaling pathway",
  "GO:0010020": "chloroplast fission",
  "GO:0010021": "amylopectin biosynthetic process",
  "GO:0010022": "meristem determinacy",
  "GO:0010023": "proanthocyanidin biosynthetic process",
  "GO:0010024": "phytochromobilin biosynthetic process",
  "GO:0010025": "wax biosynthetic process",
  "GO:0010026": "trichome differentiation",
  "GO:0010027": "thylakoid membrane organization",
  "GO:0010028": "xanthophyll cycle",
  "GO:0010029": "regulation of seed germination",
  "GO:0010030": "positive regulation of seed germination",
  "GO:0010031": "circumnutation",
  "GO:0010032": "meiotic chromosome condensation",
  "GO:0010033": "response to organic substance",
  "GO:0010034": "response to acetate",
  "GO:0010035": "response to inorganic substance",
  "GO:0010036": "response to boron-containing substance",
  "GO:0010037": "response to carbon dioxide",
  "GO:0010038": "response to metal ion",
  "GO:0010039": "response to iron ion",
  "GO:0010040": "response to iron(II) ion",
  "GO:0010041": "response to iron(III) ion",
  "GO:0010042": "response to manganese ion",
  "GO:0010043": "response to zinc ion",
  "GO:0010044": "response to aluminum ion",
  "GO:0010045": "response to nickel cation",
  "GO:0010046": "response to mycotoxin",
  "GO:0010047": "fruit dehiscence",
  "GO:0010048": "vernalization response",
  "GO:0010049": "acquisition of reproductive competence",
  "GO:0010050": "vegetative phase change",
  "GO:0010051": "xylem and phloem pattern formation",
  "GO:0010052": "guard cell differentiation",
  "GO:0010053": "root epidermal cell differentiation",
  "GO:0010054": "trichoblast differentiation",
  "GO:0010055": "atrichoblast differentiation",
  "GO:0010056": "atrichoblast fate specification",
  "GO:0010057": "trichoblast fate specification",
  "GO:0010058": "regulation of atrichoblast fate specification",
  "GO:0010059": "positive regulation of atrichoblast fate specification",
  "GO:0010060": "negative regulation of atrichoblast fate specification",
  "GO:0010061": "regulation of trichoblast fate specification",
  "GO:0010062": "negative regulation of trichoblast fate specification",
  "GO:0010063": "positive regulation of trichoblast fate specification",
  "GO:0010064": "embryonic shoot morphogenesis",
  "GO:0010065": "primary meristem tissue development",
  "GO:0010066": "ground meristem histogenesis",
  "GO:0010067": "procambium histogenesis",
  "GO:0010068": "protoderm histogenesis",
  "GO:0010069": "zygote asymmetric cytokinesis in embryo sac",
  "GO:0010070": "zygote asymmetric cell division",
  "GO:0010071": "root meristem specification",
  "GO:0010072": "primary shoot apical meristem specification",
  "GO:0010073": "meristem maintenance",
  "GO:0010074": "maintenance of meristem identity",
  "GO:0010075": "regulation of meristem growth",
  "GO:0010076": "maintenance of floral meristem identity",
  "GO:0010077": "maintenance of inflorescence meristem identity",
  "GO:0010078": "maintenance of root meristem identity",
  "GO:0010079": "maintenance of vegetative meristem identity",
  "GO:0010080": "regulation of floral meristem growth",
  "GO:0010081": "regulation of inflorescence meristem growth",
  "GO:0010082": "regulation of root meristem growth",
  "GO:0010083": "regulation of vegetative meristem growth",
  "GO:0010084": "specification of organ axis polarity",
  "GO:0010085": "polarity specification of proximal/distal axis",
  "GO:0010086": "embryonic root morphogenesis",
  "GO:0010087": "phloem or xylem histogenesis",
  "GO:0010088": "phloem development",
  "GO:0010089": "xylem development",
  "GO:0010090": "trichome morphogenesis",
  "GO:0010091": "trichome branching",
  "GO:0010092": "specification of organ identity",
  "GO:0010093": "specification of floral organ identity",
  "GO:0010094": "specification of carpel identity",
  "GO:0010095": "specification of petal identity",
  "GO:0010096": "specification of sepal identity",
  "GO:0010097": "specification of stamen identity",
  "GO:0010098": "suspensor development",
  "GO:0010099": "regulation of photomorphogenesis",
  "GO:0010100": "negative regulation of photomorphogenesis",
  "GO:0010101": "post-embryonic root morphogenesis",
  "GO:0010102": "lateral root morphogenesis",
  "GO:0010103": "stomatal complex morphogenesis",
  "GO:0010104": "regulation of ethylene-activated signaling pathway",
  "GO:0010105": "negative regulation of ethylene-activated signaling pathway",
  "GO:0010106": "cellular response to iron ion starvation",
  "GO:0010107": "potassium ion import",
  "GO:0010108": "detection of glutamine",
  "GO:0010109": "regulation of photosynthesis",
  "GO:0010110": "regulation of photosynthesis, dark reaction",
  "GO:0010111": "glyoxysome organization",
  "GO:0010112": "regulation of systemic acquired resistance",
  "GO:0010113": "negative regulation of systemic acquired resistance",
  "GO:0010114": "response to red light",
  "GO:0010115": "regulation of abscisic acid biosynthetic process",
  "GO:0010116": "positive regulation of abscisic acid biosynthetic process",
  "GO:0010117": "photoprotection",
  "GO:0010118": "stomatal movement",
  "GO:0010119": "regulation of stomatal movement",
  "GO:0010120": "camalexin biosynthetic process",
  "GO:0010121": "arginine catabolic process to proline via ornithine",
  "GO:0010122": "arginine catabolic process to alanine via ornithine",
  "GO:0010123": "acetate catabolic process to butyrate, ethanol, acetone and butanol",
  "GO:0010124": "phenylacetate catabolic process",
  "GO:0010125": "mycothiol biosynthetic process",
  "GO:0010126": "mycothiol metabolic process",
  "GO:0010127": "mycothiol-dependent detoxification",
  "GO:0010128": "benzoate catabolic process via CoA ligation",
  "GO:0010129": "anaerobic cyclohexane-1-carboxylate catabolic process",
  "GO:0010130": "anaerobic ethylbenzene catabolic process",
  "GO:0010131": "obsolete sucrose catabolic process, using invertase or sucrose synthase",
  "GO:0010132": "dhurrin biosynthetic process",
  "GO:0010133": "proline catabolic process to glutamate",
  "GO:0010134": "sulfate assimilation via adenylyl sulfate reduction",
  "GO:0010135": "ureide metabolic process",
  "GO:0010136": "ureide catabolic process",
  "GO:0010137": "ureide biosynthetic process",
  "GO:0010138": "pyrimidine ribonucleotide salvage",
  "GO:0010139": "pyrimidine deoxyribonucleotide salvage",
  "GO:0010140": "obsolete adenine, hypoxanthine and their nucleoside salvage",
  "GO:0010141": "obsolete guanine, xanthine and their nucleoside salvage",
  "GO:0010142": "farnesyl diphosphate biosynthetic process, mevalonate pathway",
  "GO:0010143": "cutin biosynthetic process",
  "GO:0010144": "pyridoxal phosphate biosynthetic process from pyridoxamine",
  "GO:0010145": "fructan metabolic process",
  "GO:0010146": "fructan biosynthetic process",
  "GO:0010147": "fructan catabolic process",
  "GO:0010148": "transpiration",
  "GO:0010149": "obsolete senescence",
  "GO:0010150": "leaf senescence",
  "GO:0010151": "chloroplast elongation",
  "GO:0010152": "pollen maturation",
  "GO:0010153": "obsolete polar cell elongation",
  "GO:0010154": "fruit development",
  "GO:0010155": "regulation of proton transport",
  "GO:0010156": "obsolete sporocyte morphogenesis",
  "GO:0010157": "response to chlorate",
  "GO:0010158": "abaxial cell fate specification",
  "GO:0010159": "specification of organ position",
  "GO:0010160": "formation of organ boundary",
  "GO:0010161": "red light signaling pathway",
  "GO:0010162": "seed dormancy process",
  "GO:0010163": "high-affinity potassium ion import",
  "GO:0010164": "response to cesium ion",
  "GO:0010165": "response to X-ray",
  "GO:0010166": "wax metabolic process",
  "GO:0010167": "response to nitrate",
  "GO:0010168": "ER body",
  "GO:0010169": "thioglucosidase complex",
  "GO:0010170": "glucose-1-phosphate adenylyltransferase complex",
  "GO:0010171": "body morphogenesis",
  "GO:0010172": "embryonic body morphogenesis",
  "GO:0010174": "nucleoside transmembrane transporter activity, against a concentration gradient",
  "GO:0010175": "sphingosine transmembrane transporter activity",
  "GO:0010176": "homogentisate phytyltransferase activity",
  "GO:0010177": "2-(2'-methylthio)ethylmalate synthase activity",
  "GO:0010178": "IAA-amino acid conjugate hydrolase activity",
  "GO:0010179": "IAA-Ala conjugate hydrolase activity",
  "GO:0010180": "thioglucosidase binding",
  "GO:0010181": "FMN binding",
  "GO:0010182": "sugar mediated signaling pathway",
  "GO:0010183": "pollen tube guidance",
  "GO:0010184": "cytokinin transport",
  "GO:0010185": "regulation of cellular defense response",
  "GO:0010186": "positive regulation of cellular defense response",
  "GO:0010187": "negative regulation of seed germination",
  "GO:0010188": "response to microbial phytotoxin",
  "GO:0010189": "vitamin E biosynthetic process",
  "GO:0010190": "cytochrome b6f complex assembly",
  "GO:0010191": "mucilage metabolic process",
  "GO:0010192": "mucilage biosynthetic process",
  "GO:0010193": "response to ozone",
  "GO:0010194": "obsolete microRNA metabolic process",
  "GO:0010195": "obsolete microRNA biosynthetic process",
  "GO:0010196": "nonphotochemical quenching",
  "GO:0010197": "polar nucleus fusion",
  "GO:0010198": "synergid death",
  "GO:0010199": "organ boundary specification between lateral organs and the meristem",
  "GO:0010200": "response to chitin",
  "GO:0010201": "response to continuous far red light stimulus by the high-irradiance response system",
  "GO:0010202": "response to low fluence red light stimulus",
  "GO:0010203": "response to very low fluence red light stimulus",
  "GO:0010204": "defense response signaling pathway, resistance gene-independent",
  "GO:0010205": "photoinhibition",
  "GO:0010206": "photosystem II repair",
  "GO:0010207": "photosystem II assembly",
  "GO:0010208": "pollen wall assembly",
  "GO:0010209": "vacuolar sorting signal binding",
  "GO:0010210": "IAA-Phe conjugate hydrolase activity",
  "GO:0010211": "IAA-Leu conjugate hydrolase activity",
  "GO:0010212": "response to ionizing radiation",
  "GO:0010213": "non-photoreactive DNA repair",
  "GO:0010214": "seed coat development",
  "GO:0010215": "cellulose microfibril organization",
  "GO:0010216": "maintenance of DNA methylation",
  "GO:0010217": "cellular aluminum ion homeostasis",
  "GO:0010218": "response to far red light",
  "GO:0010219": "regulation of vernalization response",
  "GO:0010220": "positive regulation of vernalization response",
  "GO:0010221": "negative regulation of vernalization response",
  "GO:0010222": "stem vascular tissue pattern formation",
  "GO:0010223": "secondary shoot formation",
  "GO:0010224": "response to UV-B",
  "GO:0010225": "response to UV-C",
  "GO:0010226": "response to lithium ion",
  "GO:0010227": "floral organ abscission",
  "GO:0010228": "vegetative to reproductive phase transition of meristem",
  "GO:0010229": "inflorescence development",
  "GO:0010230": "alternative respiration",
  "GO:0010231": "maintenance of seed dormancy",
  "GO:0010232": "vascular transport",
  "GO:0010233": "phloem transport",
  "GO:0010234": "anther wall tapetum cell fate specification",
  "GO:0010235": "guard mother cell cytokinesis",
  "GO:0010236": "plastoquinone biosynthetic process",
  "GO:0010238": "response to proline",
  "GO:0010239": "chloroplast mRNA processing",
  "GO:0010240": "plastid pyruvate dehydrogenase complex",
  "GO:0010241": "ent-kaurene oxidation to kaurenoic acid",
  "GO:0010242": "oxygen evolving activity",
  "GO:0010243": "response to organonitrogen compound",
  "GO:0010244": "response to low fluence blue light stimulus by blue low-fluence system",
  "GO:0010245": "radial microtubular system formation",
  "GO:0010246": "rhamnogalacturonan I biosynthetic process",
  "GO:0010247": "detection of phosphate ion",
  "GO:0010248": "establishment or maintenance of transmembrane electrochemical gradient",
  "GO:0010249": "auxin conjugate metabolic process",
  "GO:0010250": "S-methylmethionine biosynthetic process",
  "GO:0010252": "auxin homeostasis",
  "GO:0010253": "UDP-rhamnose biosynthetic process",
  "GO:0010254": "nectary development",
  "GO:0010255": "glucose mediated signaling pathway",
  "GO:0010256": "endomembrane system organization",
  "GO:0010257": "NADH dehydrogenase complex assembly",
  "GO:0010258": "NADH dehydrogenase complex (plastoquinone) assembly",
  "GO:0010259": "multicellular organism aging",
  "GO:0010260": "organ senescence",
  "GO:0010262": "somatic embryogenesis",
  "GO:0010263": "tricyclic triterpenoid biosynthetic process",
  "GO:0010264": "myo-inositol hexakisphosphate biosynthetic process",
  "GO:0010265": "SCF complex assembly",
  "GO:0010266": "response to vitamin B1",
  "GO:0010267": "production of ta-siRNAs involved in RNA interference",
  "GO:0010268": "brassinosteroid homeostasis",
  "GO:0010269": "response to selenium ion",
  "GO:0010270": "photosystem II oxygen evolving complex assembly",
  "GO:0010271": "regulation of chlorophyll catabolic process",
  "GO:0010272": "response to silver ion",
  "GO:0010273": "detoxification of copper ion",
  "GO:0010274": "hydrotropism",
  "GO:0010275": "NAD(P)H dehydrogenase complex assembly",
  "GO:0010276": "phytol kinase activity",
  "GO:0010277": "chlorophyllide a oxygenase [overall] activity",
  "GO:0010278": "chloroplast outer membrane translocon",
  "GO:0010279": "indole-3-acetic acid amido synthetase activity",
  "GO:0010280": "UDP-L-rhamnose synthase activity",
  "GO:0010282": "senescence-associated vacuole",
  "GO:0010283": "pinoresinol reductase activity",
  "GO:0010284": "lariciresinol reductase activity",
  "GO:0010285": "L,L-diaminopimelate aminotransferase activity",
  "GO:0010286": "heat acclimation",
  "GO:0010287": "plastoglobule",
  "GO:0010288": "response to lead ion",
  "GO:0010289": "homogalacturonan biosynthetic process",
  "GO:0010290": "chlorophyll catabolite transmembrane transporter activity",
  "GO:0010291": "carotene beta-ring hydroxylase activity",
  "GO:0010292": "GTP:GDP antiporter activity",
  "GO:0010293": "abscisic aldehyde oxidase activity",
  "GO:0010294": "abscisic acid glucosyltransferase activity",
  "GO:0010295": "(+)-abscisic acid 8'-hydroxylase activity",
  "GO:0010296": "prenylcysteine methylesterase activity",
  "GO:0010297": "heteropolysaccharide binding",
  "GO:0010298": "dihydrocamalexic acid decarboxylase activity",
  "GO:0010299": "detoxification of cobalt ion",
  "GO:0010301": "xanthoxin dehydrogenase activity",
  "GO:0010303": "limit dextrinase activity",
  "GO:0010304": "PSII associated light-harvesting complex II catabolic process",
  "GO:0010305": "leaf vascular tissue pattern formation",
  "GO:0010306": "rhamnogalacturonan II biosynthetic process",
  "GO:0010307": "acetylglutamate kinase regulator activity",
  "GO:0010308": "acireductone dioxygenase (Ni2+-requiring) activity",
  "GO:0010309": "acireductone dioxygenase [iron(II)-requiring] activity",
  "GO:0010310": "regulation of hydrogen peroxide metabolic process",
  "GO:0010311": "lateral root formation",
  "GO:0010312": "detoxification of zinc ion",
  "GO:0010313": "phytochrome binding",
  "GO:0010314": "phosphatidylinositol-5-phosphate binding",
  "GO:0010315": "auxin efflux",
  "GO:0010316": "pyrophosphate-dependent phosphofructokinase complex",
  "GO:0010317": "pyrophosphate-dependent phosphofructokinase complex, alpha-subunit complex",
  "GO:0010318": "pyrophosphate-dependent phosphofructokinase complex, beta-subunit complex",
  "GO:0010319": "stromule",
  "GO:0010320": "obsolete arginine/lysine endopeptidase activity",
  "GO:0010321": "regulation of vegetative phase change",
  "GO:0010322": "regulation of isopentenyl diphosphate biosynthetic process, methylerythritol 4-phosphate pathway",
  "GO:0010323": "negative regulation of isopentenyl diphosphate biosynthetic process, methylerythritol 4-phosphate pathway",
  "GO:0010324": "membrane invagination",
  "GO:0010325": "raffinose family oligosaccharide biosynthetic process",
  "GO:0010326": "methionine-oxo-acid transaminase activity",
  "GO:0010327": "acetyl CoA:(Z)-3-hexen-1-ol acetyltransferase activity",
  "GO:0010328": "auxin influx transmembrane transporter activity",
  "GO:0010329": "auxin efflux transmembrane transporter activity",
  "GO:0010330": "cellulose synthase complex",
  "GO:0010331": "gibberellin binding",
  "GO:0010332": "response to gamma radiation",
  "GO:0010333": "terpene synthase activity",
  "GO:0010334": "sesquiterpene synthase activity",
  "GO:0010335": "response to non-ionic osmotic stress",
  "GO:0010336": "gibberellic acid homeostasis",
  "GO:0010337": "regulation of salicylic acid metabolic process",
  "GO:0010338": "leaf formation",
  "GO:0010339": "external side of cell wall",
  "GO:0010340": "carboxyl-O-methyltransferase activity",
  "GO:0010341": "gibberellin carboxyl-O-methyltransferase activity",
  "GO:0010342": "endosperm cellularization",
  "GO:0010343": "singlet oxygen-mediated programmed cell death",
  "GO:0010344": "seed oilbody biogenesis",
  "GO:0010345": "suberin biosynthetic process",
  "GO:0010346": "shoot axis formation",
  "GO:0010347": "L-galactose-1-phosphate phosphatase activity",
  "GO:0010348": "lithium:proton antiporter activity",
  "GO:0010349": "L-galactose dehydrogenase activity",
  "GO:0010350": "cellular response to magnesium starvation",
  "GO:0010351": "lithium ion transport",
  "GO:0010352": "lithium ion export",
  "GO:0010353": "response to trehalose",
  "GO:0010354": "homogentisate prenyltransferase activity",
  "GO:0010355": "homogentisate farnesyltransferase activity",
  "GO:0010356": "homogentisate geranylgeranyltransferase activity",
  "GO:0010357": "homogentisate solanesyltransferase activity",
  "GO:0010358": "leaf shaping",
  "GO:0010359": "regulation of anion channel activity",
  "GO:0010360": "negative regulation of anion channel activity",
  "GO:0010361": "regulation of anion channel activity by blue light",
  "GO:0010362": "negative regulation of anion channel activity by blue light",
  "GO:0010363": "regulation of plant-type hypersensitive response",
  "GO:0010364": "regulation of ethylene biosynthetic process",
  "GO:0010365": "positive regulation of ethylene biosynthetic process",
  "GO:0010366": "negative regulation of ethylene biosynthetic process",
  "GO:0010367": "extracellular isoamylase complex",
  "GO:0010368": "chloroplast isoamylase complex",
  "GO:0010369": "chromocenter",
  "GO:0010370": "perinucleolar chromocenter",
  "GO:0010371": "regulation of gibberellin biosynthetic process",
  "GO:0010372": "positive regulation of gibberellin biosynthetic process",
  "GO:0010373": "negative regulation of gibberellin biosynthetic process",
  "GO:0010374": "stomatal complex development",
  "GO:0010375": "stomatal complex patterning",
  "GO:0010376": "stomatal complex formation",
  "GO:0010377": "guard cell fate commitment",
  "GO:0010378": "temperature compensation of the circadian clock",
  "GO:0010379": "phaseic acid biosynthetic process",
  "GO:0010380": "regulation of chlorophyll biosynthetic process",
  "GO:0010381": "attachment of peroxisome to chloroplast",
  "GO:0010383": "cell wall polysaccharide metabolic process",
  "GO:0010384": "cell wall proteoglycan metabolic process",
  "GO:0010385": "double-stranded methylated DNA binding",
  "GO:0010387": "COP9 signalosome assembly",
  "GO:0010388": "cullin deneddylation",
  "GO:0010389": "regulation of G2/M transition of mitotic cell cycle",
  "GO:0010390": "histone monoubiquitination",
  "GO:0010391": "glucomannan metabolic process",
  "GO:0010392": "galactoglucomannan metabolic process",
  "GO:0010393": "galacturonan metabolic process",
  "GO:0010394": "homogalacturonan metabolic process",
  "GO:0010395": "rhamnogalacturonan I metabolic process",
  "GO:0010396": "rhamnogalacturonan II metabolic process",
  "GO:0010397": "apiogalacturonan metabolic process",
  "GO:0010398": "xylogalacturonan metabolic process",
  "GO:0010399": "rhamnogalacturonan I backbone metabolic process",
  "GO:0010400": "rhamnogalacturonan I side chain metabolic process",
  "GO:0010401": "pectic galactan metabolic process",
  "GO:0010402": "pectic arabinan metabolic process",
  "GO:0010403": "pectic arabinogalactan I metabolic process",
  "GO:0010404": "cell wall hydroxyproline-rich glycoprotein metabolic process",
  "GO:0010405": "arabinogalactan protein metabolic process",
  "GO:0010406": "classical arabinogalactan protein metabolic process",
  "GO:0010407": "non-classical arabinogalactan protein metabolic process",
  "GO:0010408": "fasciclin-like arabinogalactan protein metabolic process",
  "GO:0010409": "extensin metabolic process",
  "GO:0010410": "hemicellulose metabolic process",
  "GO:0010411": "xyloglucan metabolic process",
  "GO:0010412": "mannan metabolic process",
  "GO:0010413": "glucuronoxylan metabolic process",
  "GO:0010414": "glucuronoarabinoxylan metabolic process",
  "GO:0010415": "unsubstituted mannan metabolic process",
  "GO:0010416": "arabinoxylan-containing compound metabolic process",
  "GO:0010417": "glucuronoxylan biosynthetic process",
  "GO:0010418": "rhamnogalacturonan II backbone metabolic process",
  "GO:0010419": "rhamnogalacturonan II side chain metabolic process",
  "GO:0010420": "polyprenyldihydroxybenzoate methyltransferase activity",
  "GO:0010421": "hydrogen peroxide-mediated programmed cell death",
  "GO:0010422": "regulation of brassinosteroid biosynthetic process",
  "GO:0010423": "negative regulation of brassinosteroid biosynthetic process",
  "GO:0010424": "DNA methylation on cytosine within a CG sequence",
  "GO:0010425": "DNA methylation on cytosine within a CNG sequence",
  "GO:0010426": "DNA methylation on cytosine within a CHH sequence",
  "GO:0010427": "abscisic acid binding",
  "GO:0010428": "methyl-CpNpG binding",
  "GO:0010429": "methyl-CpNpN binding",
  "GO:0010430": "fatty acid omega-oxidation",
  "GO:0010431": "seed maturation",
  "GO:0010432": "bract development",
  "GO:0010433": "bract morphogenesis",
  "GO:0010434": "bract formation",
  "GO:0010435": "3-oxo-2-(2'-pentenyl)cyclopentane-1-octanoic acid CoA ligase activity",
  "GO:0010436": "carotenoid dioxygenase activity",
  "GO:0010437": "9,10 (9', 10')-carotenoid-cleaving dioxygenase activity",
  "GO:0010438": "cellular response to sulfur starvation",
  "GO:0010439": "regulation of glucosinolate biosynthetic process",
  "GO:0010440": "stomatal lineage progression",
  "GO:0010441": "guard cell development",
  "GO:0010442": "guard cell morphogenesis",
  "GO:0010443": "meristemoid mother cell division",
  "GO:0010444": "guard mother cell differentiation",
  "GO:0010445": "nuclear dicing body",
  "GO:0010446": "response to alkaline pH",
  "GO:0010447": "response to acidic pH",
  "GO:0010448": "vegetative meristem growth",
  "GO:0010449": "root meristem growth",
  "GO:0010450": "inflorescence meristem growth",
  "GO:0010451": "floral meristem growth",
  "GO:0010452": "histone H3-K36 methylation",
  "GO:0010453": "regulation of cell fate commitment",
  "GO:0010454": "negative regulation of cell fate commitment",
  "GO:0010455": "positive regulation of cell fate commitment",
  "GO:0010456": "cell proliferation in dorsal spinal cord",
  "GO:0010457": "centriole-centriole cohesion",
  "GO:0010458": "exit from mitosis",
  "GO:0010459": "negative regulation of heart rate",
  "GO:0010460": "positive regulation of heart rate",
  "GO:0010461": "light-activated ion channel activity",
  "GO:0010462": "regulation of light-activated voltage-gated calcium channel activity",
  "GO:0010463": "mesenchymal cell proliferation",
  "GO:0010464": "regulation of mesenchymal cell proliferation",
  "GO:0010465": "nerve growth factor receptor activity",
  "GO:0010466": "negative regulation of peptidase activity",
  "GO:0010467": "gene expression",
  "GO:0010468": "regulation of gene expression",
  "GO:0010469": "regulation of receptor activity",
  "GO:0010470": "regulation of gastrulation",
  "GO:0010471": "GDP-galactose:mannose-1-phosphate guanylyltransferase activity",
  "GO:0010472": "GDP-galactose:glucose-1-phosphate guanylyltransferase activity",
  "GO:0010473": "GDP-galactose:myoinositol-1-phosphate guanylyltransferase activity",
  "GO:0010474": "glucose-1-phosphate guanylyltransferase (GDP) activity",
  "GO:0010475": "galactose-1-phosphate guanylyltransferase (GDP) activity",
  "GO:0010476": "gibberellin mediated signaling pathway",
  "GO:0010477": "response to sulfur dioxide",
  "GO:0010478": "chlororespiration",
  "GO:0010479": "stele development",
  "GO:0010480": "microsporocyte differentiation",
  "GO:0010481": "epidermal cell division",
  "GO:0010482": "regulation of epidermal cell division",
  "GO:0010483": "pollen tube reception",
  "GO:0010484": "H3 histone acetyltransferase activity",
  "GO:0010485": "H4 histone acetyltransferase activity",
  "GO:0010486": "manganese:proton antiporter activity",
  "GO:0010487": "thermospermine synthase activity",
  "GO:0010488": "UDP-galactose:N-glycan beta-1,3-galactosyltransferase activity",
  "GO:0010489": "UDP-4-keto-6-deoxy-glucose-3,5-epimerase activity",
  "GO:0010490": "UDP-4-keto-rhamnose-4-keto-reductase activity",
  "GO:0010491": "UTP:arabinose-1-phosphate uridylyltransferase activity",
  "GO:0010492": "maintenance of shoot apical meristem identity",
  "GO:0010493": "Lewis a epitope biosynthetic process",
  "GO:0010494": "cytoplasmic stress granule",
  "GO:0010495": "long-distance posttranscriptional gene silencing",
  "GO:0010496": "intercellular transport",
  "GO:0010497": "plasmodesmata-mediated intercellular transport",
  "GO:0010498": "proteasomal protein catabolic process",
  "GO:0010499": "proteasomal ubiquitin-independent protein catabolic process",
  "GO:0010500": "transmitting tissue development",
  "GO:0010501": "RNA secondary structure unwinding",
  "GO:0010503": "obsolete negative regulation of cell cycle arrest in response to nitrogen starvation",
  "GO:0010504": "obsolete regulation of cell cycle arrest in response to nitrogen starvation",
  "GO:0010505": "obsolete positive regulation of cell cycle arrest in response to nitrogen starvation",
  "GO:0010506": "regulation of autophagy",
  "GO:0010507": "negative regulation of autophagy",
  "GO:0010508": "positive regulation of autophagy",
  "GO:0010509": "polyamine homeostasis",
  "GO:0010510": "regulation of acetyl-CoA biosynthetic process from pyruvate",
  "GO:0010511": "regulation of phosphatidylinositol biosynthetic process",
  "GO:0010512": "negative regulation of phosphatidylinositol biosynthetic process",
  "GO:0010513": "positive regulation of phosphatidylinositol biosynthetic process",
  "GO:0010514": "induction of conjugation with cellular fusion",
  "GO:0010515": "negative regulation of induction of conjugation with cellular fusion",
  "GO:0010516": "negative regulation of cellular response to nitrogen starvation",
  "GO:0010517": "regulation of phospholipase activity",
  "GO:0010518": "positive regulation of phospholipase activity",
  "GO:0010519": "negative regulation of phospholipase activity",
  "GO:0010520": "regulation of reciprocal meiotic recombination",
  "GO:0010521": "telomerase inhibitor activity",
  "GO:0010522": "regulation of calcium ion transport into cytosol",
  "GO:0010523": "negative regulation of calcium ion transport into cytosol",
  "GO:0010524": "positive regulation of calcium ion transport into cytosol",
  "GO:0010525": "regulation of transposition, RNA-mediated",
  "GO:0010526": "negative regulation of transposition, RNA-mediated",
  "GO:0010527": "positive regulation of transposition, RNA-mediated",
  "GO:0010528": "regulation of transposition",
  "GO:0010529": "negative regulation of transposition",
  "GO:0010530": "positive regulation of transposition",
  "GO:0010531": "activation of JAK1 kinase activity",
  "GO:0010532": "regulation of activation of JAK1 kinase activity",
  "GO:0010533": "regulation of activation of Janus kinase activity",
  "GO:0010534": "regulation of activation of JAK2 kinase activity",
  "GO:0010535": "positive regulation of activation of JAK2 kinase activity",
  "GO:0010536": "positive regulation of activation of Janus kinase activity",
  "GO:0010537": "positive regulation of activation of JAK1 kinase activity",
  "GO:0010538": "obsolete Hsp27 protein regulator activity",
  "GO:0010539": "obsolete Hsp27 protein inhibitor activity",
  "GO:0010540": "basipetal auxin transport",
  "GO:0010541": "acropetal auxin transport",
  "GO:0010542": "nitrate efflux transmembrane transporter activity",
  "GO:0010543": "regulation of platelet activation",
  "GO:0010544": "negative regulation of platelet activation",
  "GO:0010545": "obsolete Hsp90 protein regulator activity",
  "GO:0010546": "obsolete Hsp90 protein inhibitor activity",
  "GO:0010547": "thylakoid membrane disassembly",
  "GO:0010548": "regulation of thylakoid membrane disassembly",
  "GO:0010549": "regulation of membrane disassembly",
  "GO:0010550": "regulation of PSII associated light-harvesting complex II catabolic process",
  "GO:0010555": "response to mannitol",
  "GO:0010556": "regulation of macromolecule biosynthetic process",
  "GO:0010557": "positive regulation of macromolecule biosynthetic process",
  "GO:0010558": "negative regulation of macromolecule biosynthetic process",
  "GO:0010559": "regulation of glycoprotein biosynthetic process",
  "GO:0010560": "positive regulation of glycoprotein biosynthetic process",
  "GO:0010561": "negative regulation of glycoprotein biosynthetic process",
  "GO:0010562": "positive regulation of phosphorus metabolic process",
  "GO:0010563": "negative regulation of phosphorus metabolic process",
  "GO:0010564": "regulation of cell cycle process",
  "GO:0010565": "regulation of cellular ketone metabolic process",
  "GO:0010566": "regulation of ketone biosynthetic process",
  "GO:0010567": "regulation of ketone catabolic process",
  "GO:0010568": "regulation of budding cell apical bud growth",
  "GO:0010569": "regulation of double-strand break repair via homologous recombination",
  "GO:0010570": "regulation of filamentous growth",
  "GO:0010571": "positive regulation of nuclear cell cycle DNA replication",
  "GO:0010572": "positive regulation of platelet activation",
  "GO:0010573": "vascular endothelial growth factor production",
  "GO:0010574": "regulation of vascular endothelial growth factor production",
  "GO:0010575": "positive regulation of vascular endothelial growth factor production",
  "GO:0010578": "regulation of adenylate cyclase activity involved in G-protein coupled receptor signaling pathway",
  "GO:0010579": "positive regulation of adenylate cyclase activity involved in G-protein coupled receptor signaling pathway",
  "GO:0010581": "regulation of starch biosynthetic process",
  "GO:0010582": "floral meristem determinacy",
  "GO:0010583": "response to cyclopentenone",
  "GO:0010584": "pollen exine formation",
  "GO:0010585": "glutamine secretion",
  "GO:0010586": "miRNA metabolic process",
  "GO:0010587": "miRNA catabolic process",
  "GO:0010588": "cotyledon vascular tissue pattern formation",
  "GO:0010589": "leaf proximal/distal pattern formation",
  "GO:0010590": "regulation of cell separation after cytokinesis",
  "GO:0010591": "regulation of lamellipodium assembly",
  "GO:0010592": "positive regulation of lamellipodium assembly",
  "GO:0010593": "negative regulation of lamellipodium assembly",
  "GO:0010594": "regulation of endothelial cell migration",
  "GO:0010595": "positive regulation of endothelial cell migration",
  "GO:0010596": "negative regulation of endothelial cell migration",
  "GO:0010597": "green leaf volatile biosynthetic process",
  "GO:0010598": "NAD(P)H dehydrogenase complex (plastoquinone)",
  "GO:0010599": "production of lsiRNA involved in RNA interference",
  "GO:0010600": "regulation of auxin biosynthetic process",
  "GO:0010601": "positive regulation of auxin biosynthetic process",
  "GO:0010602": "regulation of 1-aminocyclopropane-1-carboxylate metabolic process",
  "GO:0010603": "regulation of cytoplasmic mRNA processing body assembly",
  "GO:0010604": "positive regulation of macromolecule metabolic process",
  "GO:0010605": "negative regulation of macromolecule metabolic process",
  "GO:0010606": "positive regulation of cytoplasmic mRNA processing body assembly",
  "GO:0010607": "negative regulation of cytoplasmic mRNA processing body assembly",
  "GO:0010608": "posttranscriptional regulation of gene expression",
  "GO:0010609": "mRNA localization resulting in posttranscriptional regulation of gene expression",
  "GO:0010610": "regulation of mRNA stability involved in response to stress",
  "GO:0010611": "regulation of cardiac muscle hypertrophy",
  "GO:0010612": "regulation of cardiac muscle adaptation",
  "GO:0010613": "positive regulation of cardiac muscle hypertrophy",
  "GO:0010614": "negative regulation of cardiac muscle hypertrophy",
  "GO:0010615": "positive regulation of cardiac muscle adaptation",
  "GO:0010616": "negative regulation of cardiac muscle adaptation",
  "GO:0010617": "circadian regulation of calcium ion oscillation",
  "GO:0010618": "aerenchyma formation",
  "GO:0010619": "adenylate cyclase-activating glucose-activated G-protein coupled receptor signaling pathway",
  "GO:0010620": "negative regulation of transcription by transcription factor catabolism",
  "GO:0010621": "negative regulation of transcription by transcription factor localization",
  "GO:0010622": "specification of ovule identity",
  "GO:0010623": "developmental programmed cell death",
  "GO:0010624": "regulation of Schwann cell proliferation",
  "GO:0010625": "positive regulation of Schwann cell proliferation",
  "GO:0010626": "negative regulation of Schwann cell proliferation",
  "GO:0010628": "positive regulation of gene expression",
  "GO:0010629": "negative regulation of gene expression",
  "GO:0010630": "regulation of transcription, start site selection",
  "GO:0010631": "epithelial cell migration",
  "GO:0010632": "regulation of epithelial cell migration",
  "GO:0010633": "negative regulation of epithelial cell migration",
  "GO:0010634": "positive regulation of epithelial cell migration",
  "GO:0010635": "regulation of mitochondrial fusion",
  "GO:0010636": "positive regulation of mitochondrial fusion",
  "GO:0010637": "negative regulation of mitochondrial fusion",
  "GO:0010638": "positive regulation of organelle organization",
  "GO:0010639": "negative regulation of organelle organization",
  "GO:0010640": "regulation of platelet-derived growth factor receptor signaling pathway",
  "GO:0010641": "positive regulation of platelet-derived growth factor receptor signaling pathway",
  "GO:0010642": "negative regulation of platelet-derived growth factor receptor signaling pathway",
  "GO:0010643": "cell communication by chemical coupling",
  "GO:0010644": "cell communication by electrical coupling",
  "GO:0010645": "regulation of cell communication by chemical coupling",
  "GO:0010646": "regulation of cell communication",
  "GO:0010647": "positive regulation of cell communication",
  "GO:0010648": "negative regulation of cell communication",
  "GO:0010649": "regulation of cell communication by electrical coupling",
  "GO:0010650": "positive regulation of cell communication by electrical coupling",
  "GO:0010651": "negative regulation of cell communication by electrical coupling",
  "GO:0010652": "positive regulation of cell communication by chemical coupling",
  "GO:0010653": "negative regulation of cell communication by chemical coupling",
  "GO:0010654": "apical cell fate commitment",
  "GO:0010656": "negative regulation of muscle cell apoptotic process",
  "GO:0010657": "muscle cell apoptotic process",
  "GO:0010658": "striated muscle cell apoptotic process",
  "GO:0010659": "cardiac muscle cell apoptotic process",
  "GO:0010660": "regulation of muscle cell apoptotic process",
  "GO:0010661": "positive regulation of muscle cell apoptotic process",
  "GO:0010662": "regulation of striated muscle cell apoptotic process",
  "GO:0010663": "positive regulation of striated muscle cell apoptotic process",
  "GO:0010664": "negative regulation of striated muscle cell apoptotic process",
  "GO:0010665": "regulation of cardiac muscle cell apoptotic process",
  "GO:0010666": "positive regulation of cardiac muscle cell apoptotic process",
  "GO:0010667": "negative regulation of cardiac muscle cell apoptotic process",
  "GO:0010668": "ectodermal cell differentiation",
  "GO:0010669": "epithelial structure maintenance",
  "GO:0010670": "obsolete positive regulation of oxygen and reactive oxygen species metabolic process",
  "GO:0010671": "obsolete negative regulation of oxygen and reactive oxygen species metabolic process",
  "GO:0010672": "regulation of transcription from RNA polymerase II promoter involved in meiotic cell cycle",
  "GO:0010673": "positive regulation of transcription from RNA polymerase II promoter involved in meiotic cell cycle",
  "GO:0010674": "negative regulation of transcription from RNA polymerase II promoter involved in meiotic cell cycle",
  "GO:0010675": "regulation of cellular carbohydrate metabolic process",
  "GO:0010676": "positive regulation of cellular carbohydrate metabolic process",
  "GO:0010677": "negative regulation of cellular carbohydrate metabolic process",
  "GO:0010678": "negative regulation of cellular carbohydrate metabolic process by negative regulation of transcription, DNA-templated",
  "GO:0010679": "cinnamic acid biosynthetic process involved in salicylic acid metabolism",
  "GO:0010680": "cinnamic acid biosynthetic process involved in coumarin metabolism",
  "GO:0010681": "cinnamic acid biosynthetic process involved in stilbene metabolism",
  "GO:0010682": "cinnamic acid biosynthetic process involved in flavonoid metabolism",
  "GO:0010683": "tricyclic triterpenoid metabolic process",
  "GO:0010684": "tricyclic triterpenoid catabolic process",
  "GO:0010685": "tetracyclic triterpenoid metabolic process",
  "GO:0010686": "tetracyclic triterpenoid biosynthetic process",
  "GO:0010688": "negative regulation of ribosomal protein gene transcription from RNA polymerase II promoter",
  "GO:0010689": "negative regulation of ribosomal protein gene transcription from RNA polymerase II promoter in response to chemical stimulus",
  "GO:0010690": "negative regulation of ribosomal protein gene transcription from RNA polymerase II promoter in response to stress",
  "GO:0010691": "negative regulation of ribosomal protein gene transcription from RNA polymerase II promoter in response to nutrient levels",
  "GO:0010692": "regulation of alkaline phosphatase activity",
  "GO:0010693": "negative regulation of alkaline phosphatase activity",
  "GO:0010694": "positive regulation of alkaline phosphatase activity",
  "GO:0010695": "regulation of spindle pole body separation",
  "GO:0010696": "positive regulation of spindle pole body separation",
  "GO:0010697": "negative regulation of spindle pole body separation",
  "GO:0010698": "acetyltransferase activator activity",
  "GO:0010699": "cell-cell signaling involved in quorum sensing",
  "GO:0010700": "negative regulation of norepinephrine secretion",
  "GO:0010701": "positive regulation of norepinephrine secretion",
  "GO:0010702": "obsolete regulation of histolysis",
  "GO:0010703": "obsolete negative regulation of histolysis",
  "GO:0010704": "meiotic DNA double-strand break processing involved in meiotic gene conversion",
  "GO:0010705": "meiotic DNA double-strand break processing involved in reciprocal meiotic recombination",
  "GO:0010706": "ganglioside biosynthetic process via lactosylceramide",
  "GO:0010707": "globoside biosynthetic process via lactosylceramide",
  "GO:0010708": "heteroduplex formation involved in gene conversion at mating-type locus",
  "GO:0010709": "heteroduplex formation involved in double-strand break repair via synthesis-dependent strand annealing",
  "GO:0010710": "regulation of collagen catabolic process",
  "GO:0010711": "negative regulation of collagen catabolic process",
  "GO:0010712": "regulation of collagen metabolic process",
  "GO:0010713": "negative regulation of collagen metabolic process",
  "GO:0010714": "positive regulation of collagen metabolic process",
  "GO:0010715": "regulation of extracellular matrix disassembly",
  "GO:0010716": "negative regulation of extracellular matrix disassembly",
  "GO:0010717": "regulation of epithelial to mesenchymal transition",
  "GO:0010718": "positive regulation of epithelial to mesenchymal transition",
  "GO:0010719": "negative regulation of epithelial to mesenchymal transition",
  "GO:0010720": "positive regulation of cell development",
  "GO:0010721": "negative regulation of cell development",
  "GO:0010722": "regulation of ferrochelatase activity",
  "GO:0010723": "positive regulation of transcription from RNA polymerase II promoter in response to iron",
  "GO:0010724": "regulation of definitive erythrocyte differentiation",
  "GO:0010725": "regulation of primitive erythrocyte differentiation",
  "GO:0010726": "positive regulation of hydrogen peroxide metabolic process",
  "GO:0010727": "negative regulation of hydrogen peroxide metabolic process",
  "GO:0010728": "regulation of hydrogen peroxide biosynthetic process",
  "GO:0010729": "positive regulation of hydrogen peroxide biosynthetic process",
  "GO:0010730": "negative regulation of hydrogen peroxide biosynthetic process",
  "GO:0010731": "protein glutathionylation",
  "GO:0010732": "regulation of protein glutathionylation",
  "GO:0010733": "positive regulation of protein glutathionylation",
  "GO:0010734": "negative regulation of protein glutathionylation",
  "GO:0010735": "positive regulation of transcription via serum response element binding",
  "GO:0010736": "serum response element binding",
  "GO:0010737": "protein kinase A signaling",
  "GO:0010738": "regulation of protein kinase A signaling",
  "GO:0010739": "positive regulation of protein kinase A signaling",
  "GO:0010742": "macrophage derived foam cell differentiation",
  "GO:0010743": "regulation of macrophage derived foam cell differentiation",
  "GO:0010744": "positive regulation of macrophage derived foam cell differentiation",
  "GO:0010745": "negative regulation of macrophage derived foam cell differentiation",
  "GO:0010746": "regulation of plasma membrane long-chain fatty acid transport",
  "GO:0010747": "positive regulation of plasma membrane long-chain fatty acid transport",
  "GO:0010748": "negative regulation of plasma membrane long-chain fatty acid transport",
  "GO:0010749": "regulation of nitric oxide mediated signal transduction",
  "GO:0010750": "positive regulation of nitric oxide mediated signal transduction",
  "GO:0010751": "negative regulation of nitric oxide mediated signal transduction",
  "GO:0010752": "regulation of cGMP-mediated signaling",
  "GO:0010753": "positive regulation of cGMP-mediated signaling",
  "GO:0010754": "negative regulation of cGMP-mediated signaling",
  "GO:0010755": "regulation of plasminogen activation",
  "GO:0010756": "positive regulation of plasminogen activation",
  "GO:0010757": "negative regulation of plasminogen activation",
  "GO:0010758": "regulation of macrophage chemotaxis",
  "GO:0010759": "positive regulation of macrophage chemotaxis",
  "GO:0010760": "negative regulation of macrophage chemotaxis",
  "GO:0010761": "fibroblast migration",
  "GO:0010762": "regulation of fibroblast migration",
  "GO:0010763": "positive regulation of fibroblast migration",
  "GO:0010764": "negative regulation of fibroblast migration",
  "GO:0010765": "positive regulation of sodium ion transport",
  "GO:0010766": "negative regulation of sodium ion transport",
  "GO:0010767": "regulation of transcription from RNA polymerase II promoter in response to UV-induced DNA damage",
  "GO:0010768": "negative regulation of transcription from RNA polymerase II promoter in response to UV-induced DNA damage",
  "GO:0010769": "regulation of cell morphogenesis involved in differentiation",
  "GO:0010770": "positive regulation of cell morphogenesis involved in differentiation",
  "GO:0010771": "negative regulation of cell morphogenesis involved in differentiation",
  "GO:0010772": "meiotic DNA recombinase assembly involved in reciprocal meiotic recombination",
  "GO:0010773": "meiotic DNA recombinase assembly involved in meiotic gene conversion",
  "GO:0010774": "meiotic strand invasion involved in reciprocal meiotic recombination",
  "GO:0010775": "meiotic strand invasion involved in meiotic gene conversion",
  "GO:0010776": "meiotic mismatch repair involved in meiotic gene conversion",
  "GO:0010777": "meiotic mismatch repair involved in reciprocal meiotic recombination",
  "GO:0010778": "meiotic DNA repair synthesis involved in reciprocal meiotic recombination",
  "GO:0010779": "meiotic DNA repair synthesis involved in meiotic gene conversion",
  "GO:0010780": "meiotic DNA double-strand break formation involved in reciprocal meiotic recombination",
  "GO:0010781": "meiotic DNA double-strand break formation involved in meiotic gene conversion",
  "GO:0010782": "proboscis morphogenesis, labial disc-derived",
  "GO:0010783": "proboscis morphogenesis, eye-antennal disc-derived",
  "GO:0010784": "proboscis morphogenesis, clypeo-labral disc-derived",
  "GO:0010785": "clathrin coating of Golgi vesicle, plasma membrane to endosome targeting",
  "GO:0010786": "clathrin coating of Golgi vesicle, trans-Golgi to endosome targeting",
  "GO:0010787": "COPI coating of Golgi vesicle, inter-Golgi cisterna",
  "GO:0010788": "COPI coating of Golgi vesicle, cis-Golgi to rough ER",
  "GO:0010789": "meiotic sister chromatid cohesion involved in meiosis I",
  "GO:0010790": "meiotic sister chromatid cohesion involved in meiosis II",
  "GO:0010791": "DNA double-strand break processing involved in repair via synthesis-dependent strand annealing",
  "GO:0010792": "DNA double-strand break processing involved in repair via single-strand annealing",
  "GO:0010793": "regulation of mRNA export from nucleus",
  "GO:0010794": "regulation of dolichol biosynthetic process",
  "GO:0010795": "regulation of ubiquinone biosynthetic process",
  "GO:0010796": "regulation of multivesicular body size",
  "GO:0010797": "regulation of multivesicular body size involved in endosome transport",
  "GO:0010798": "regulation of multivesicular body size involved in ubiquitin-dependent protein catabolism",
  "GO:0010799": "regulation of peptidyl-threonine phosphorylation",
  "GO:0010800": "positive regulation of peptidyl-threonine phosphorylation",
  "GO:0010801": "negative regulation of peptidyl-threonine phosphorylation",
  "GO:0010803": "regulation of tumor necrosis factor-mediated signaling pathway",
  "GO:0010804": "negative regulation of tumor necrosis factor-mediated signaling pathway",
  "GO:0010805": "regulation of lysine import",
  "GO:0010806": "negative regulation of lysine import",
  "GO:0010807": "regulation of synaptic vesicle priming",
  "GO:0010808": "positive regulation of synaptic vesicle priming",
  "GO:0010809": "negative regulation of synaptic vesicle priming",
  "GO:0010810": "regulation of cell-substrate adhesion",
  "GO:0010811": "positive regulation of cell-substrate adhesion",
  "GO:0010812": "negative regulation of cell-substrate adhesion",
  "GO:0010813": "neuropeptide catabolic process",
  "GO:0010814": "substance P catabolic process",
  "GO:0010815": "bradykinin catabolic process",
  "GO:0010816": "calcitonin catabolic process",
  "GO:0010817": "regulation of hormone levels",
  "GO:0010818": "T cell chemotaxis",
  "GO:0010819": "regulation of T cell chemotaxis",
  "GO:0010820": "positive regulation of T cell chemotaxis",
  "GO:0010821": "regulation of mitochondrion organization",
  "GO:0010822": "positive regulation of mitochondrion organization",
  "GO:0010823": "negative regulation of mitochondrion organization",
  "GO:0010824": "regulation of centrosome duplication",
  "GO:0010825": "positive regulation of centrosome duplication",
  "GO:0010826": "negative regulation of centrosome duplication",
  "GO:0010827": "regulation of glucose transport",
  "GO:0010828": "positive regulation of glucose transport",
  "GO:0010829": "negative regulation of glucose transport",
  "GO:0010830": "regulation of myotube differentiation",
  "GO:0010831": "positive regulation of myotube differentiation",
  "GO:0010832": "negative regulation of myotube differentiation",
  "GO:0010833": "telomere maintenance via telomere lengthening",
  "GO:0010834": "obsolete telomere maintenance via telomere shortening",
  "GO:0010835": "regulation of protein ADP-ribosylation",
  "GO:0010836": "negative regulation of protein ADP-ribosylation",
  "GO:0010837": "regulation of keratinocyte proliferation",
  "GO:0010838": "positive regulation of keratinocyte proliferation",
  "GO:0010839": "negative regulation of keratinocyte proliferation",
  "GO:0010840": "regulation of circadian sleep/wake cycle, wakefulness",
  "GO:0010841": "positive regulation of circadian sleep/wake cycle, wakefulness",
  "GO:0010842": "retina layer formation",
  "GO:0010843": "obsolete promoter binding",
  "GO:0010844": "recombination hotspot binding",
  "GO:0010845": "positive regulation of reciprocal meiotic recombination",
  "GO:0010846": "activation of reciprocal meiotic recombination",
  "GO:0010847": "regulation of chromatin assembly",
  "GO:0010848": "regulation of chromatin disassembly",
  "GO:0010849": "regulation of proton-transporting ATPase activity, rotational mechanism",
  "GO:0010850": "regulation of blood pressure by chemoreceptor signaling pathway",
  "GO:0010851": "cyclase regulator activity",
  "GO:0010852": "cyclase inhibitor activity",
  "GO:0010853": "cyclase activator activity",
  "GO:0010854": "adenylate cyclase regulator activity",
  "GO:0010855": "adenylate cyclase inhibitor activity",
  "GO:0010856": "adenylate cyclase activator activity",
  "GO:0010857": "calcium-dependent protein kinase activity",
  "GO:0010858": "calcium-dependent protein kinase regulator activity",
  "GO:0010859": "calcium-dependent cysteine-type endopeptidase inhibitor activity",
  "GO:0010860": "obsolete proteasome regulator activity",
  "GO:0010861": "thyroid hormone receptor activator activity",
  "GO:0010862": "positive regulation of pathway-restricted SMAD protein phosphorylation",
  "GO:0010863": "positive regulation of phospholipase C activity",
  "GO:0010864": "positive regulation of protein histidine kinase activity",
  "GO:0010865": "stipule development",
  "GO:0010866": "regulation of triglyceride biosynthetic process",
  "GO:0010867": "positive regulation of triglyceride biosynthetic process",
  "GO:0010868": "negative regulation of triglyceride biosynthetic process",
  "GO:0010869": "regulation of receptor biosynthetic process",
  "GO:0010870": "positive regulation of receptor biosynthetic process",
  "GO:0010871": "negative regulation of receptor biosynthetic process",
  "GO:0010872": "regulation of cholesterol esterification",
  "GO:0010873": "positive regulation of cholesterol esterification",
  "GO:0010874": "regulation of cholesterol efflux",
  "GO:0010875": "positive regulation of cholesterol efflux",
  "GO:0010876": "lipid localization",
  "GO:0010877": "lipid transport involved in lipid storage",
  "GO:0010878": "cholesterol storage",
  "GO:0010879": "cholesterol transport involved in cholesterol storage",
  "GO:0010880": "regulation of release of sequestered calcium ion into cytosol by sarcoplasmic reticulum",
  "GO:0010881": "regulation of cardiac muscle contraction by regulation of the release of sequestered calcium ion",
  "GO:0010882": "regulation of cardiac muscle contraction by calcium ion signaling",
  "GO:0010883": "regulation of lipid storage",
  "GO:0010884": "positive regulation of lipid storage",
  "GO:0010885": "regulation of cholesterol storage",
  "GO:0010886": "positive regulation of cholesterol storage",
  "GO:0010887": "negative regulation of cholesterol storage",
  "GO:0010888": "negative regulation of lipid storage",
  "GO:0010889": "regulation of sequestering of triglyceride",
  "GO:0010890": "positive regulation of sequestering of triglyceride",
  "GO:0010891": "negative regulation of sequestering of triglyceride",
  "GO:0010892": "positive regulation of mitochondrial translation in response to stress",
  "GO:0010893": "positive regulation of steroid biosynthetic process",
  "GO:0010894": "negative regulation of steroid biosynthetic process",
  "GO:0010895": "negative regulation of ergosterol biosynthetic process",
  "GO:0010896": "regulation of triglyceride catabolic process",
  "GO:0010897": "negative regulation of triglyceride catabolic process",
  "GO:0010898": "positive regulation of triglyceride catabolic process",
  "GO:0010899": "regulation of phosphatidylcholine catabolic process",
  "GO:0010900": "negative regulation of phosphatidylcholine catabolic process",
  "GO:0010901": "regulation of very-low-density lipoprotein particle remodeling",
  "GO:0010902": "positive regulation of very-low-density lipoprotein particle remodeling",
  "GO:0010903": "negative regulation of very-low-density lipoprotein particle remodeling",
  "GO:0010904": "regulation of UDP-glucose catabolic process",
  "GO:0010905": "negative regulation of UDP-glucose catabolic process",
  "GO:0010906": "regulation of glucose metabolic process",
  "GO:0010907": "positive regulation of glucose metabolic process",
  "GO:0010908": "regulation of heparan sulfate proteoglycan biosynthetic process",
  "GO:0010909": "positive regulation of heparan sulfate proteoglycan biosynthetic process",
  "GO:0010910": "positive regulation of heparan sulfate proteoglycan biosynthesis by positive regulation of epimerase activity",
  "GO:0010911": "regulation of isomerase activity",
  "GO:0010912": "positive regulation of isomerase activity",
  "GO:0010913": "regulation of sterigmatocystin biosynthetic process",
  "GO:0010914": "positive regulation of sterigmatocystin biosynthetic process",
  "GO:0010915": "regulation of very-low-density lipoprotein particle clearance",
  "GO:0010916": "negative regulation of very-low-density lipoprotein particle clearance",
  "GO:0010917": "negative regulation of mitochondrial membrane potential",
  "GO:0010918": "positive regulation of mitochondrial membrane potential",
  "GO:0010919": "regulation of inositol phosphate biosynthetic process",
  "GO:0010920": "negative regulation of inositol phosphate biosynthetic process",
  "GO:0010921": "regulation of phosphatase activity",
  "GO:0010922": "positive regulation of phosphatase activity",
  "GO:0010923": "negative regulation of phosphatase activity",
  "GO:0010924": "regulation of inositol-polyphosphate 5-phosphatase activity",
  "GO:0010925": "positive regulation of inositol-polyphosphate 5-phosphatase activity",
  "GO:0010926": "obsolete anatomical structure formation",
  "GO:0010927": "cellular component assembly involved in morphogenesis",
  "GO:0010928": "regulation of auxin mediated signaling pathway",
  "GO:0010929": "positive regulation of auxin mediated signaling pathway",
  "GO:0010930": "negative regulation of auxin mediated signaling pathway",
  "GO:0010931": "macrophage tolerance induction",
  "GO:0010932": "regulation of macrophage tolerance induction",
  "GO:0010933": "positive regulation of macrophage tolerance induction",
  "GO:0010934": "macrophage cytokine production",
  "GO:0010935": "regulation of macrophage cytokine production",
  "GO:0010936": "negative regulation of macrophage cytokine production",
  "GO:0010937": "regulation of cytoplasmic microtubule depolymerization",
  "GO:0010938": "cytoplasmic microtubule depolymerization",
  "GO:0010939": "regulation of necrotic cell death",
  "GO:0010940": "positive regulation of necrotic cell death",
  "GO:0010941": "regulation of cell death",
  "GO:0010942": "positive regulation of cell death",
  "GO:0010943": "NADPH pyrophosphatase activity",
  "GO:0010944": "negative regulation of transcription by competitive promoter binding",
  "GO:0010945": "CoA pyrophosphatase activity",
  "GO:0010946": "regulation of meiotic joint molecule formation",
  "GO:0010947": "negative regulation of meiotic joint molecule formation",
  "GO:0010948": "negative regulation of cell cycle process",
  "GO:0010949": "negative regulation of intestinal phytosterol absorption",
  "GO:0010950": "positive regulation of endopeptidase activity",
  "GO:0010951": "negative regulation of endopeptidase activity",
  "GO:0010952": "positive regulation of peptidase activity",
  "GO:0010954": "positive regulation of protein processing",
  "GO:0010955": "negative regulation of protein processing",
  "GO:0010956": "negative regulation of calcidiol 1-monooxygenase activity",
  "GO:0010957": "negative regulation of vitamin D biosynthetic process",
  "GO:0010958": "regulation of amino acid import",
  "GO:0010959": "regulation of metal ion transport",
  "GO:0010960": "magnesium ion homeostasis",
  "GO:0010961": "cellular magnesium ion homeostasis",
  "GO:0010962": "regulation of glucan biosynthetic process",
  "GO:0010963": "regulation of L-arginine import",
  "GO:0010964": "regulation of chromatin silencing by small RNA",
  "GO:0010965": "regulation of mitotic sister chromatid separation",
  "GO:0010966": "regulation of phosphate transport",
  "GO:0010967": "regulation of polyamine biosynthetic process",
  "GO:0010968": "regulation of microtubule nucleation",
  "GO:0010969": "regulation of pheromone-dependent signal transduction involved in conjugation with cellular fusion",
  "GO:0010970": "establishment of localization by movement along microtubule",
  "GO:0010971": "positive regulation of G2/M transition of mitotic cell cycle",
  "GO:0010972": "negative regulation of G2/M transition of mitotic cell cycle",
  "GO:0010973": "positive regulation of barrier septum assembly",
  "GO:0010974": "negative regulation of barrier septum assembly",
  "GO:0010975": "regulation of neuron projection development",
  "GO:0010976": "positive regulation of neuron projection development",
  "GO:0010977": "negative regulation of neuron projection development",
  "GO:0010978": "gene silencing involved in chronological cell aging",
  "GO:0010979": "regulation of vitamin D 24-hydroxylase activity",
  "GO:0010980": "positive regulation of vitamin D 24-hydroxylase activity",
  "GO:0010981": "regulation of cell wall macromolecule metabolic process",
  "GO:0010982": "regulation of high-density lipoprotein particle clearance",
  "GO:0010983": "positive regulation of high-density lipoprotein particle clearance",
  "GO:0010984": "regulation of lipoprotein particle clearance",
  "GO:0010985": "negative regulation of lipoprotein particle clearance",
  "GO:0010986": "positive regulation of lipoprotein particle clearance",
  "GO:0010987": "negative regulation of high-density lipoprotein particle clearance",
  "GO:0010988": "regulation of low-density lipoprotein particle clearance",
  "GO:0010989": "negative regulation of low-density lipoprotein particle clearance",
  "GO:0010990": "regulation of SMAD protein complex assembly",
  "GO:0010991": "negative regulation of SMAD protein complex assembly",
  "GO:0010992": "ubiquitin homeostasis",
  "GO:0010993": "regulation of ubiquitin homeostasis",
  "GO:0010994": "free ubiquitin chain polymerization",
  "GO:0010995": "free ubiquitin chain depolymerization",
  "GO:0010996": "response to auditory stimulus",
  "GO:0010997": "anaphase-promoting complex binding",
  "GO:0010998": "regulation of translational initiation by eIF2 alpha phosphorylation",
  "GO:0010999": "regulation of eIF2 alpha phosphorylation by heme",
  "GO:0011000": "replication fork arrest at mating type locus",
  "GO:0012501": "programmed cell death",
  "GO:0012502": "induction of programmed cell death",
  "GO:0012505": "endomembrane system",
  "GO:0012506": "vesicle membrane",
  "GO:0012507": "ER to Golgi transport vesicle membrane",
  "GO:0012508": "Golgi to ER transport vesicle membrane",
  "GO:0012509": "inter-Golgi transport vesicle membrane",
  "GO:0012510": "trans-Golgi network transport vesicle membrane",
  "GO:0012511": "monolayer-surrounded lipid storage body",
  "GO:0014001": "sclerenchyma cell differentiation",
  "GO:0014002": "astrocyte development",
  "GO:0014003": "oligodendrocyte development",
  "GO:0014004": "microglia differentiation",
  "GO:0014005": "microglia development",
  "GO:0014006": "regulation of microglia differentiation",
  "GO:0014007": "negative regulation of microglia differentiation",
  "GO:0014008": "positive regulation of microglia differentiation",
  "GO:0014009": "glial cell proliferation",
  "GO:0014010": "Schwann cell proliferation",
  "GO:0014011": "Schwann cell proliferation involved in axon regeneration",
  "GO:0014012": "peripheral nervous system axon regeneration",
  "GO:0014013": "regulation of gliogenesis",
  "GO:0014014": "negative regulation of gliogenesis",
  "GO:0014015": "positive regulation of gliogenesis",
  "GO:0014016": "neuroblast differentiation",
  "GO:0014017": "neuroblast fate commitment",
  "GO:0014018": "neuroblast fate specification",
  "GO:0014019": "neuroblast development",
  "GO:0014020": "primary neural tube formation",
  "GO:0014021": "secondary neural tube formation",
  "GO:0014022": "neural plate elongation",
  "GO:0014023": "neural rod formation",
  "GO:0014024": "neural rod cavitation",
  "GO:0014025": "neural keel formation",
  "GO:0014027": "secondary neural tube rod cavitation",
  "GO:0014028": "notochord formation",
  "GO:0014029": "neural crest formation",
  "GO:0014030": "mesenchymal cell fate commitment",
  "GO:0014031": "mesenchymal cell development",
  "GO:0014032": "neural crest cell development",
  "GO:0014033": "neural crest cell differentiation",
  "GO:0014034": "neural crest cell fate commitment",
  "GO:0014035": "neural crest cell fate determination",
  "GO:0014036": "neural crest cell fate specification",
  "GO:0014037": "Schwann cell differentiation",
  "GO:0014038": "regulation of Schwann cell differentiation",
  "GO:0014039": "negative regulation of Schwann cell differentiation",
  "GO:0014040": "positive regulation of Schwann cell differentiation",
  "GO:0014041": "regulation of neuron maturation",
  "GO:0014042": "positive regulation of neuron maturation",
  "GO:0014043": "negative regulation of neuron maturation",
  "GO:0014044": "Schwann cell development",
  "GO:0014045": "establishment of endothelial blood-brain barrier",
  "GO:0014046": "dopamine secretion",
  "GO:0014047": "glutamate secretion",
  "GO:0014048": "regulation of glutamate secretion",
  "GO:0014049": "positive regulation of glutamate secretion",
  "GO:0014050": "negative regulation of glutamate secretion",
  "GO:0014051": "gamma-aminobutyric acid secretion",
  "GO:0014052": "regulation of gamma-aminobutyric acid secretion",
  "GO:0014053": "negative regulation of gamma-aminobutyric acid secretion",
  "GO:0014054": "positive regulation of gamma-aminobutyric acid secretion",
  "GO:0014055": "acetylcholine secretion, neurotransmission",
  "GO:0014056": "regulation of acetylcholine secretion, neurotransmission",
  "GO:0014057": "positive regulation of acetylcholine secretion, neurotransmission",
  "GO:0014058": "negative regulation of acetylcholine secretion, neurotransmission",
  "GO:0014059": "regulation of dopamine secretion",
  "GO:0014060": "regulation of epinephrine secretion",
  "GO:0014061": "regulation of norepinephrine secretion",
  "GO:0014062": "regulation of serotonin secretion",
  "GO:0014063": "negative regulation of serotonin secretion",
  "GO:0014064": "positive regulation of serotonin secretion",
  "GO:0014065": "phosphatidylinositol 3-kinase signaling",
  "GO:0014066": "regulation of phosphatidylinositol 3-kinase signaling",
  "GO:0014067": "negative regulation of phosphatidylinositol 3-kinase signaling",
  "GO:0014068": "positive regulation of phosphatidylinositol 3-kinase signaling",
  "GO:0014069": "postsynaptic density",
  "GO:0014070": "response to organic cyclic compound",
  "GO:0014071": "response to cycloalkane",
  "GO:0014072": "response to isoquinoline alkaloid",
  "GO:0014073": "response to tropane",
  "GO:0014074": "response to purine-containing compound",
  "GO:0014075": "response to amine",
  "GO:0014076": "response to fluoxetine",
  "GO:0014701": "junctional sarcoplasmic reticulum membrane",
  "GO:0014702": "free sarcoplasmic reticulum membrane",
  "GO:0014703": "oscillatory muscle contraction",
  "GO:0014704": "intercalated disc",
  "GO:0014705": "C zone",
  "GO:0014706": "striated muscle tissue development",
  "GO:0014707": "branchiomeric skeletal muscle development",
  "GO:0014708": "regulation of somitomeric trunk muscle development",
  "GO:0014709": "positive regulation of somitomeric trunk muscle development",
  "GO:0014710": "negative regulation of somitomeric trunk muscle development",
  "GO:0014711": "regulation of branchiomeric skeletal muscle development",
  "GO:0014712": "positive regulation of branchiomeric skeletal muscle development",
  "GO:0014713": "negative regulation of branchiomeric skeletal muscle development",
  "GO:0014714": "myoblast fate commitment in head",
  "GO:0014715": "myoblast fate commitment in trunk",
  "GO:0014716": "skeletal muscle satellite stem cell asymmetric division involved in skeletal muscle regeneration",
  "GO:0014717": "regulation of satellite cell activation involved in skeletal muscle regeneration",
  "GO:0014718": "positive regulation of satellite cell activation involved in skeletal muscle regeneration",
  "GO:0014719": "skeletal muscle satellite cell activation",
  "GO:0014720": "tonic skeletal muscle contraction",
  "GO:0014721": "twitch skeletal muscle contraction",
  "GO:0014722": "regulation of skeletal muscle contraction by calcium ion signaling",
  "GO:0014723": "regulation of skeletal muscle contraction by modulation of calcium ion sensitivity of myofibril",
  "GO:0014724": "regulation of twitch skeletal muscle contraction",
  "GO:0014725": "regulation of extraocular skeletal muscle development",
  "GO:0014726": "negative regulation of extraocular skeletal muscle development",
  "GO:0014727": "positive regulation of extraocular skeletal muscle development",
  "GO:0014728": "regulation of the force of skeletal muscle contraction",
  "GO:0014729": "regulation of the velocity of shortening of skeletal muscle modulating contraction",
  "GO:0014730": "skeletal muscle regeneration at neuromuscular junction",
  "GO:0014731": "spectrin-associated cytoskeleton",
  "GO:0014732": "skeletal muscle atrophy",
  "GO:0014733": "regulation of skeletal muscle adaptation",
  "GO:0014734": "skeletal muscle hypertrophy",
  "GO:0014735": "regulation of muscle atrophy",
  "GO:0014736": "negative regulation of muscle atrophy",
  "GO:0014737": "positive regulation of muscle atrophy",
  "GO:0014738": "regulation of muscle hyperplasia",
  "GO:0014739": "positive regulation of muscle hyperplasia",
  "GO:0014740": "negative regulation of muscle hyperplasia",
  "GO:0014741": "negative regulation of muscle hypertrophy",
  "GO:0014742": "positive regulation of muscle hypertrophy",
  "GO:0014743": "regulation of muscle hypertrophy",
  "GO:0014744": "positive regulation of muscle adaptation",
  "GO:0014745": "negative regulation of muscle adaptation",
  "GO:0014746": "regulation of tonic skeletal muscle contraction",
  "GO:0014747": "positive regulation of tonic skeletal muscle contraction",
  "GO:0014748": "negative regulation of tonic skeletal muscle contraction",
  "GO:0014801": "longitudinal sarcoplasmic reticulum",
  "GO:0014802": "terminal cisterna",
  "GO:0014803": "longitudinal sarcoplasmic reticulum lumen",
  "GO:0014804": "terminal cisterna lumen",
  "GO:0014805": "smooth muscle adaptation",
  "GO:0014806": "smooth muscle hyperplasia",
  "GO:0014807": "regulation of somitogenesis",
  "GO:0014808": "release of sequestered calcium ion into cytosol by sarcoplasmic reticulum",
  "GO:0014809": "regulation of skeletal muscle contraction by regulation of release of sequestered calcium ion",
  "GO:0014810": "positive regulation of skeletal muscle contraction by regulation of release of sequestered calcium ion",
  "GO:0014811": "negative regulation of skeletal muscle contraction by regulation of release of sequestered calcium ion",
  "GO:0014812": "muscle cell migration",
  "GO:0014813": "skeletal muscle satellite cell commitment",
  "GO:0014814": "axon regeneration at neuromuscular junction",
  "GO:0014815": "initiation of skeletal muscle satellite cell activation by growth factor signalling, involved in skeletal muscle regeneration",
  "GO:0014816": "skeletal muscle satellite cell differentiation",
  "GO:0014817": "skeletal muscle satellite cell fate specification",
  "GO:0014818": "skeletal muscle satellite cell fate determination",
  "GO:0014819": "regulation of skeletal muscle contraction",
  "GO:0014820": "tonic smooth muscle contraction",
  "GO:0014821": "phasic smooth muscle contraction",
  "GO:0014822": "detection of wounding",
  "GO:0014823": "response to activity",
  "GO:0014824": "artery smooth muscle contraction",
  "GO:0014825": "stomach fundus smooth muscle contraction",
  "GO:0014826": "vein smooth muscle contraction",
  "GO:0014827": "intestine smooth muscle contraction",
  "GO:0014828": "distal stomach smooth muscle contraction",
  "GO:0014829": "vascular smooth muscle contraction",
  "GO:0014830": "arteriole smooth muscle contraction",
  "GO:0014831": "gastro-intestinal system smooth muscle contraction",
  "GO:0014832": "urinary bladder smooth muscle contraction",
  "GO:0014833": "skeletal muscle satellite stem cell asymmetric division",
  "GO:0014834": "skeletal muscle satellite cell maintenance involved in skeletal muscle regeneration",
  "GO:0014835": "myoblast differentiation involved in skeletal muscle regeneration",
  "GO:0014836": "myoblast fate commitment involved in skeletal muscle regeneration",
  "GO:0014837": "myoblast fate determination involved in skeletal muscle regeneration",
  "GO:0014838": "myoblast fate specification involved in skeletal muscle regeneration",
  "GO:0014839": "myoblast migration involved in skeletal muscle regeneration",
  "GO:0014841": "skeletal muscle satellite cell proliferation",
  "GO:0014842": "regulation of skeletal muscle satellite cell proliferation",
  "GO:0014843": "growth factor dependent regulation of skeletal muscle satellite cell proliferation",
  "GO:0014844": "myoblast proliferation involved in skeletal muscle regeneration",
  "GO:0014845": "stomach body smooth muscle contraction",
  "GO:0014846": "esophagus smooth muscle contraction",
  "GO:0014847": "proximal stomach smooth muscle contraction",
  "GO:0014848": "urinary tract smooth muscle contraction",
  "GO:0014849": "ureter smooth muscle contraction",
  "GO:0014850": "response to muscle activity",
  "GO:0014852": "regulation of skeletal muscle contraction by neural stimulation via neuromuscular junction",
  "GO:0014853": "regulation of excitatory postsynaptic membrane potential involved in skeletal muscle contraction",
  "GO:0014854": "response to inactivity",
  "GO:0014855": "striated muscle cell proliferation",
  "GO:0014856": "skeletal muscle cell proliferation",
  "GO:0014857": "regulation of skeletal muscle cell proliferation",
  "GO:0014858": "positive regulation of skeletal muscle cell proliferation",
  "GO:0014859": "negative regulation of skeletal muscle cell proliferation",
  "GO:0014860": "neurotransmitter secretion involved in regulation of skeletal muscle contraction",
  "GO:0014861": "regulation of skeletal muscle contraction via regulation of action potential",
  "GO:0014862": "regulation of skeletal muscle contraction by chemo-mechanical energy conversion",
  "GO:0014863": "detection of inactivity",
  "GO:0014864": "detection of muscle activity",
  "GO:0014865": "detection of activity",
  "GO:0014866": "skeletal myofibril assembly",
  "GO:0014868": "cross bridge cycling involved in regulation of the velocity of shortening in skeletal muscle contraction",
  "GO:0014869": "detection of muscle inactivity",
  "GO:0014870": "response to muscle inactivity",
  "GO:0014871": "cross bridge formation involved in regulation of the velocity of shortening in skeletal muscle contraction",
  "GO:0014872": "myoblast division",
  "GO:0014873": "response to muscle activity involved in regulation of muscle adaptation",
  "GO:0014874": "response to stimulus involved in regulation of muscle adaptation",
  "GO:0014875": "detection of muscle activity involved in regulation of muscle adaptation",
  "GO:0014876": "response to injury involved in regulation of muscle adaptation",
  "GO:0014877": "response to muscle inactivity involved in regulation of muscle adaptation",
  "GO:0014878": "response to electrical stimulus involved in regulation of muscle adaptation",
  "GO:0014879": "detection of electrical stimulus involved in regulation of muscle adaptation",
  "GO:0014880": "regulation of muscle filament sliding involved in regulation of the velocity of shortening in skeletal muscle contraction",
  "GO:0014881": "regulation of myofibril size",
  "GO:0014882": "regulation of myofibril number",
  "GO:0014883": "transition between fast and slow fiber",
  "GO:0014884": "detection of muscle inactivity involved in regulation of muscle adaptation",
  "GO:0014885": "detection of injury involved in regulation of muscle adaptation",
  "GO:0014886": "transition between slow and fast fiber",
  "GO:0014887": "cardiac muscle adaptation",
  "GO:0014888": "striated muscle adaptation",
  "GO:0014889": "muscle atrophy",
  "GO:0014890": "smooth muscle atrophy",
  "GO:0014891": "striated muscle atrophy",
  "GO:0014893": "response to rest involved in regulation of muscle adaptation",
  "GO:0014894": "response to denervation involved in regulation of muscle adaptation",
  "GO:0014895": "smooth muscle hypertrophy",
  "GO:0014896": "muscle hypertrophy",
  "GO:0014897": "striated muscle hypertrophy",
  "GO:0014898": "cardiac muscle hypertrophy in response to stress",
  "GO:0014899": "cardiac muscle atrophy",
  "GO:0014900": "muscle hyperplasia",
  "GO:0014901": "satellite cell activation involved in skeletal muscle regeneration",
  "GO:0014902": "myotube differentiation",
  "GO:0014904": "myotube cell development",
  "GO:0014905": "myoblast fusion involved in skeletal muscle regeneration",
  "GO:0014906": "myotube cell development involved in skeletal muscle regeneration",
  "GO:0014908": "myotube differentiation involved in skeletal muscle regeneration",
  "GO:0014909": "smooth muscle cell migration",
  "GO:0014910": "regulation of smooth muscle cell migration",
  "GO:0014911": "positive regulation of smooth muscle cell migration",
  "GO:0014912": "negative regulation of smooth muscle cell migration",
  "GO:0014914": "myoblast maturation involved in muscle regeneration",
  "GO:0014915": "regulation of muscle filament sliding speed involved in regulation of the velocity of shortening in skeletal muscle contraction",
  "GO:0014916": "regulation of lung blood pressure",
  "GO:0014917": "obsolete positive regulation of diuresis by pressure natriuresis",
  "GO:0014918": "obsolete positive regulation of natriuresis by pressure natriuresis",
  "GO:0015000": "obsolete polyferredoxin",
  "GO:0015001": "obsolete high-potential iron-sulfur carrier",
  "GO:0015002": "heme-copper terminal oxidase activity",
  "GO:0015003": "obsolete copper electron carrier",
  "GO:0015004": "obsolete small blue copper electron carrier",
  "GO:0015005": "obsolete azurin",
  "GO:0015006": "obsolete plastocyanin",
  "GO:0015007": "obsolete electron carrier, chlorophyll electron transport system",
  "GO:0015009": "corrin metabolic process",
  "GO:0015010": "tetrahydrocorphin metabolic process",
  "GO:0015011": "nickel-tetrapyrrole coenzyme metabolic process",
  "GO:0015012": "heparan sulfate proteoglycan biosynthetic process",
  "GO:0015013": "heparan sulfate proteoglycan biosynthetic process, linkage to polypeptide",
  "GO:0015014": "heparan sulfate proteoglycan biosynthetic process, polysaccharide chain biosynthetic process",
  "GO:0015015": "heparan sulfate proteoglycan biosynthetic process, enzymatic modification",
  "GO:0015016": "[heparan sulfate]-glucosamine N-sulfotransferase activity",
  "GO:0015017": "obsolete glypican",
  "GO:0015018": "galactosylgalactosylxylosylprotein 3-beta-glucuronosyltransferase activity",
  "GO:0015019": "heparan-alpha-glucosaminide N-acetyltransferase activity",
  "GO:0015020": "glucuronosyltransferase activity",
  "GO:0015021": "heparin-sulfate lyase activity",
  "GO:0015023": "obsolete syndecan",
  "GO:0015024": "glucuronate-2-sulfatase activity",
  "GO:0015025": "obsolete GPI-anchored membrane-bound receptor",
  "GO:0015026": "coreceptor activity",
  "GO:0015029": "obsolete internalization receptor activity",
  "GO:0015030": "Cajal body",
  "GO:0015031": "protein transport",
  "GO:0015032": "storage protein import into fat body",
  "GO:0015034": "obsolete cytochrome P450 activity",
  "GO:0015035": "protein disulfide oxidoreductase activity",
  "GO:0015036": "disulfide oxidoreductase activity",
  "GO:0015037": "peptide disulfide oxidoreductase activity",
  "GO:0015038": "glutathione disulfide oxidoreductase activity",
  "GO:0015039": "NADPH-adrenodoxin reductase activity",
  "GO:0015040": "obsolete electron transfer flavoprotein, group I",
  "GO:0015041": "obsolete electron transfer flavoprotein, group II",
  "GO:0015042": "trypanothione-disulfide reductase activity",
  "GO:0015043": "leghemoglobin reductase activity",
  "GO:0015044": "rubredoxin-NAD+ reductase activity",
  "GO:0015045": "rubredoxin-NAD(P)+ reductase activity",
  "GO:0015046": "rubredoxin-NADP reductase activity",
  "GO:0015047": "NADPH-cytochrome-c2 reductase activity",
  "GO:0015048": "phthalate dioxygenase reductase activity",
  "GO:0015049": "methane monooxygenase activity",
  "GO:0015050": "methane monooxygenase complex",
  "GO:0015051": "obsolete X-opioid receptor activity",
  "GO:0015052": "beta3-adrenergic receptor activity",
  "GO:0015053": "obsolete opsin",
  "GO:0015054": "gastrin receptor activity",
  "GO:0015055": "secretin receptor activity",
  "GO:0015056": "corticotrophin-releasing factor receptor activity",
  "GO:0015057": "thrombin receptor activity",
  "GO:0015058": "obsolete epidermal growth factor-like module containing hormone receptor activity",
  "GO:0015059": "obsolete blue-sensitive opsin",
  "GO:0015060": "obsolete green-sensitive opsin",
  "GO:0015061": "obsolete red-sensitive opsin",
  "GO:0015062": "obsolete violet-sensitive opsin",
  "GO:0015063": "obsolete long-wave-sensitive opsin",
  "GO:0015064": "obsolete UV-sensitive opsin",
  "GO:0015065": "uridine nucleotide receptor activity",
  "GO:0015066": "alpha-amylase inhibitor activity",
  "GO:0015067": "amidinotransferase activity",
  "GO:0015068": "glycine amidinotransferase activity",
  "GO:0015069": "scyllo-inosamine-4-phosphate amidinotransferase activity",
  "GO:0015070": "obsolete toxin activity",
  "GO:0015072": "obsolete phosphatidylinositol 3-kinase, class I, catalyst activity",
  "GO:0015073": "obsolete phosphatidylinositol 3-kinase, class I, regulator activity",
  "GO:0015074": "DNA integration",
  "GO:0015075": "ion transmembrane transporter activity",
  "GO:0015076": "obsolete heavy metal ion transporter activity",
  "GO:0015077": "monovalent inorganic cation transmembrane transporter activity",
  "GO:0015078": "hydrogen ion transmembrane transporter activity",
  "GO:0015079": "potassium ion transmembrane transporter activity",
  "GO:0015080": "silver ion transmembrane transporter activity",
  "GO:0015081": "sodium ion transmembrane transporter activity",
  "GO:0015083": "aluminum ion transmembrane transporter activity",
  "GO:0015085": "calcium ion transmembrane transporter activity",
  "GO:0015086": "cadmium ion transmembrane transporter activity",
  "GO:0015087": "cobalt ion transmembrane transporter activity",
  "GO:0015088": "copper uptake transmembrane transporter activity",
  "GO:0015089": "high-affinity copper ion transmembrane transporter activity",
  "GO:0015090": "low-affinity iron ion transmembrane transporter activity",
  "GO:0015091": "ferric iron transmembrane transporter activity",
  "GO:0015092": "high-affinity ferric uptake transmembrane transporter activity",
  "GO:0015093": "ferrous iron transmembrane transporter activity",
  "GO:0015094": "lead ion transmembrane transporter activity",
  "GO:0015095": "magnesium ion transmembrane transporter activity",
  "GO:0015096": "obsolete manganese resistance permease activity",
  "GO:0015097": "mercury ion transmembrane transporter activity",
  "GO:0015098": "molybdate ion transmembrane transporter activity",
  "GO:0015099": "nickel cation transmembrane transporter activity",
  "GO:0015100": "vanadium ion transmembrane transporter activity",
  "GO:0015101": "organic cation transmembrane transporter activity",
  "GO:0015103": "inorganic anion transmembrane transporter activity",
  "GO:0015104": "antimonite transmembrane transporter activity",
  "GO:0015105": "arsenite transmembrane transporter activity",
  "GO:0015106": "bicarbonate transmembrane transporter activity",
  "GO:0015107": "chlorate transmembrane transporter activity",
  "GO:0015108": "chloride transmembrane transporter activity",
  "GO:0015109": "chromate transmembrane transporter activity",
  "GO:0015110": "cyanate transmembrane transporter activity",
  "GO:0015111": "iodide transmembrane transporter activity",
  "GO:0015112": "nitrate transmembrane transporter activity",
  "GO:0015113": "nitrite transmembrane transporter activity",
  "GO:0015114": "phosphate ion transmembrane transporter activity",
  "GO:0015115": "silicate transmembrane transporter activity",
  "GO:0015116": "sulfate transmembrane transporter activity",
  "GO:0015117": "thiosulfate transmembrane transporter activity",
  "GO:0015118": "tellurite transmembrane transporter activity",
  "GO:0015119": "hexose phosphate transmembrane transporter activity",
  "GO:0015120": "phosphoglycerate transmembrane transporter activity",
  "GO:0015121": "phosphoenolpyruvate:phosphate antiporter activity",
  "GO:0015123": "acetate transmembrane transporter activity",
  "GO:0015124": "allantoate transmembrane transporter activity",
  "GO:0015125": "bile acid transmembrane transporter activity",
  "GO:0015126": "canalicular bile acid transmembrane transporter activity",
  "GO:0015127": "bilirubin transmembrane transporter activity",
  "GO:0015128": "gluconate transmembrane transporter activity",
  "GO:0015129": "lactate transmembrane transporter activity",
  "GO:0015130": "mevalonate transmembrane transporter activity",
  "GO:0015131": "oxaloacetate transmembrane transporter activity",
  "GO:0015132": "prostaglandin transmembrane transporter activity",
  "GO:0015133": "uronic acid transmembrane transporter activity",
  "GO:0015134": "hexuronate transmembrane transporter activity",
  "GO:0015135": "glucuronate transmembrane transporter activity",
  "GO:0015136": "sialic acid transmembrane transporter activity",
  "GO:0015137": "citrate transmembrane transporter activity",
  "GO:0015138": "fumarate transmembrane transporter activity",
  "GO:0015139": "alpha-ketoglutarate transmembrane transporter activity",
  "GO:0015140": "malate transmembrane transporter activity",
  "GO:0015141": "succinate transmembrane transporter activity",
  "GO:0015142": "tricarboxylic acid transmembrane transporter activity",
  "GO:0015143": "urate transmembrane transporter activity",
  "GO:0015144": "carbohydrate transmembrane transporter activity",
  "GO:0015145": "monosaccharide transmembrane transporter activity",
  "GO:0015146": "pentose transmembrane transporter activity",
  "GO:0015147": "L-arabinose transmembrane transporter activity",
  "GO:0015148": "D-xylose transmembrane transporter activity",
  "GO:0015149": "hexose transmembrane transporter activity",
  "GO:0015150": "fucose transmembrane transporter activity",
  "GO:0015151": "alpha-glucoside transmembrane transporter activity",
  "GO:0015152": "glucose-6-phosphate transmembrane transporter activity",
  "GO:0015153": "rhamnose transmembrane transporter activity",
  "GO:0015154": "disaccharide transmembrane transporter activity",
  "GO:0015155": "lactose transmembrane transporter activity",
  "GO:0015156": "melibiose transmembrane transporter activity",
  "GO:0015157": "oligosaccharide transmembrane transporter activity",
  "GO:0015158": "raffinose transmembrane transporter activity",
  "GO:0015159": "polysaccharide transmembrane transporter activity",
  "GO:0015160": "beta-glucan transmembrane transporter activity",
  "GO:0015161": "capsular polysaccharide transmembrane transporter activity",
  "GO:0015162": "teichoic acid transmembrane transporter activity",
  "GO:0015164": "glucuronoside transmembrane transporter activity",
  "GO:0015165": "pyrimidine nucleotide-sugar transmembrane transporter activity",
  "GO:0015166": "polyol transmembrane transporter activity",
  "GO:0015167": "arabitol transmembrane transporter activity",
  "GO:0015168": "glycerol transmembrane transporter activity",
  "GO:0015169": "glycerol-3-phosphate transmembrane transporter activity",
  "GO:0015170": "propanediol transmembrane transporter activity",
  "GO:0015171": "amino acid transmembrane transporter activity",
  "GO:0015172": "acidic amino acid transmembrane transporter activity",
  "GO:0015173": "aromatic amino acid transmembrane transporter activity",
  "GO:0015174": "basic amino acid transmembrane transporter activity",
  "GO:0015175": "neutral amino acid transmembrane transporter activity",
  "GO:0015176": "obsolete holin",
  "GO:0015179": "L-amino acid transmembrane transporter activity",
  "GO:0015180": "L-alanine transmembrane transporter activity",
  "GO:0015181": "arginine transmembrane transporter activity",
  "GO:0015182": "L-asparagine transmembrane transporter activity",
  "GO:0015183": "L-aspartate transmembrane transporter activity",
  "GO:0015184": "L-cystine transmembrane transporter activity",
  "GO:0015185": "gamma-aminobutyric acid transmembrane transporter activity",
  "GO:0015186": "L-glutamine transmembrane transporter activity",
  "GO:0015187": "glycine transmembrane transporter activity",
  "GO:0015188": "L-isoleucine transmembrane transporter activity",
  "GO:0015189": "L-lysine transmembrane transporter activity",
  "GO:0015190": "L-leucine transmembrane transporter activity",
  "GO:0015191": "L-methionine transmembrane transporter activity",
  "GO:0015192": "L-phenylalanine transmembrane transporter activity",
  "GO:0015193": "L-proline transmembrane transporter activity",
  "GO:0015194": "L-serine transmembrane transporter activity",
  "GO:0015195": "L-threonine transmembrane transporter activity",
  "GO:0015196": "L-tryptophan transmembrane transporter activity",
  "GO:0015197": "peptide transporter activity",
  "GO:0015198": "oligopeptide transporter activity",
  "GO:0015199": "amino-acid betaine transmembrane transporter activity",
  "GO:0015200": "methylammonium transmembrane transporter activity",
  "GO:0015203": "polyamine transmembrane transporter activity",
  "GO:0015204": "urea transmembrane transporter activity",
  "GO:0015205": "nucleobase transmembrane transporter activity",
  "GO:0015207": "adenine transmembrane transporter activity",
  "GO:0015208": "guanine transmembrane transporter activity",
  "GO:0015209": "cytosine transmembrane transporter activity",
  "GO:0015210": "uracil transmembrane transporter activity",
  "GO:0015211": "purine nucleoside transmembrane transporter activity",
  "GO:0015212": "cytidine transmembrane transporter activity",
  "GO:0015213": "uridine transmembrane transporter activity",
  "GO:0015214": "pyrimidine nucleoside transmembrane transporter activity",
  "GO:0015215": "nucleotide transmembrane transporter activity",
  "GO:0015216": "purine nucleotide transmembrane transporter activity",
  "GO:0015217": "ADP transmembrane transporter activity",
  "GO:0015218": "pyrimidine nucleotide transmembrane transporter activity",
  "GO:0015219": "protein-DNA complex transmembrane transporter activity",
  "GO:0015220": "choline transmembrane transporter activity",
  "GO:0015221": "lipopolysaccharide transmembrane transporter activity",
  "GO:0015222": "serotonin transmembrane transporter activity",
  "GO:0015223": "obsolete vitamin or cofactor transporter activity",
  "GO:0015224": "biopterin transporter activity",
  "GO:0015225": "biotin transporter activity",
  "GO:0015226": "carnitine transmembrane transporter activity",
  "GO:0015227": "acyl carnitine transmembrane transporter activity",
  "GO:0015228": "coenzyme A transmembrane transporter activity",
  "GO:0015229": "L-ascorbic acid transporter activity",
  "GO:0015230": "FAD transmembrane transporter activity",
  "GO:0015231": "5-formyltetrahydrofolate transporter activity",
  "GO:0015232": "heme transporter activity",
  "GO:0015233": "pantothenate transmembrane transporter activity",
  "GO:0015234": "thiamine transmembrane transporter activity",
  "GO:0015235": "cobalamin transporter activity",
  "GO:0015238": "drug transmembrane transporter activity",
  "GO:0015240": "amiloride transporter activity",
  "GO:0015241": "aminotriazole transporter activity",
  "GO:0015242": "benomyl transporter activity",
  "GO:0015243": "cycloheximide transporter activity",
  "GO:0015244": "fluconazole transporter activity",
  "GO:0015245": "fatty acid transporter activity",
  "GO:0015246": "fatty-acyl group transporter activity",
  "GO:0015247": "aminophospholipid transporter activity",
  "GO:0015248": "sterol transporter activity",
  "GO:0015250": "water channel activity",
  "GO:0015251": "ammonium channel activity",
  "GO:0015252": "hydrogen ion channel activity",
  "GO:0015253": "obsolete sugar/polyol channel activity",
  "GO:0015254": "glycerol channel activity",
  "GO:0015255": "propanediol channel activity",
  "GO:0015256": "obsolete monocarboxylate channel activity",
  "GO:0015257": "obsolete organic anion channel activity",
  "GO:0015258": "obsolete gluconate channel activity",
  "GO:0015259": "obsolete glutamate channel activity",
  "GO:0015260": "obsolete isethionate channel activity",
  "GO:0015261": "obsolete lactate channel activity",
  "GO:0015262": "obsolete taurine channel activity",
  "GO:0015263": "obsolete amine/amide/polyamine channel activity",
  "GO:0015264": "methylammonium channel activity",
  "GO:0015265": "urea channel activity",
  "GO:0015266": "protein channel activity",
  "GO:0015267": "channel activity",
  "GO:0015269": "calcium-activated potassium channel activity",
  "GO:0015271": "outward rectifier potassium channel activity",
  "GO:0015272": "ATP-activated inward rectifier potassium channel activity",
  "GO:0015274": "organellar voltage-gated chloride channel activity",
  "GO:0015275": "stretch-activated, cation-selective, calcium channel activity",
  "GO:0015276": "ligand-gated ion channel activity",
  "GO:0015277": "kainate selective glutamate receptor activity",
  "GO:0015278": "calcium-release channel activity",
  "GO:0015279": "store-operated calcium channel activity",
  "GO:0015280": "ligand-gated sodium channel activity",
  "GO:0015282": "obsolete NADPH oxidase-associated cytochrome b558 hydrogen channel activity",
  "GO:0015283": "obsolete apoptogenic cytochrome c release channel activity",
  "GO:0015284": "fructose uniporter activity",
  "GO:0015288": "porin activity",
  "GO:0015289": "obsolete pore-forming toxin activity",
  "GO:0015291": "secondary active transmembrane transporter activity",
  "GO:0015292": "uniporter activity",
  "GO:0015293": "symporter activity",
  "GO:0015294": "solute:cation symporter activity",
  "GO:0015295": "solute:proton symporter activity",
  "GO:0015296": "anion:cation symporter activity",
  "GO:0015297": "antiporter activity",
  "GO:0015298": "solute:cation antiporter activity",
  "GO:0015299": "solute:proton antiporter activity",
  "GO:0015301": "anion:anion antiporter activity",
  "GO:0015303": "obsolete galactose, glucose uniporter activity",
  "GO:0015304": "glucose uniporter activity",
  "GO:0015305": "obsolete lactose, galactose:proton symporter activity",
  "GO:0015306": "sialate:cation symporter activity",
  "GO:0015307": "drug:proton antiporter activity",
  "GO:0015308": "amiloride:proton antiporter activity",
  "GO:0015309": "cycloheximide:proton antiporter activity",
  "GO:0015310": "benomyl:proton antiporter activity",
  "GO:0015311": "monoamine:proton antiporter activity",
  "GO:0015312": "polyamine:proton antiporter activity",
  "GO:0015313": "fluconazole:proton antiporter activity",
  "GO:0015314": "aminotriazole:proton antiporter activity",
  "GO:0015315": "organophosphate:inorganic phosphate antiporter activity",
  "GO:0015316": "obsolete nitrite/nitrate porter activity",
  "GO:0015317": "phosphate:proton symporter activity",
  "GO:0015318": "inorganic solute uptake transmembrane transporter activity",
  "GO:0015319": "sodium:inorganic phosphate symporter activity",
  "GO:0015320": "phosphate ion carrier activity",
  "GO:0015321": "sodium-dependent phosphate transmembrane transporter activity",
  "GO:0015322": "secondary active oligopeptide transmembrane transporter activity",
  "GO:0015323": "obsolete type V protein secretor activity",
  "GO:0015324": "peptide-acetyl-CoA secondary active transmembrane transporter activity",
  "GO:0015325": "acetyl-CoA:CoA antiporter activity",
  "GO:0015327": "cystine:glutamate antiporter activity",
  "GO:0015328": "cystine secondary active transmembrane transporter activity",
  "GO:0015330": "high-affinity glutamine transmembrane transporter activity",
  "GO:0015331": "obsolete asparagine/glutamine permease activity",
  "GO:0015332": "obsolete leucine/valine/isoleucine permease activity",
  "GO:0015333": "peptide:proton symporter activity",
  "GO:0015334": "high-affinity oligopeptide transporter activity",
  "GO:0015335": "obsolete heavy metal ion:hydrogen symporter activity",
  "GO:0015336": "obsolete high affinity metal ion uptake transporter activity",
  "GO:0015337": "obsolete low affinity metal ion uptake transporter activity",
  "GO:0015339": "obsolete cobalt, zinc uptake permease activity",
  "GO:0015340": "obsolete zinc, cadmium uptake permease activity",
  "GO:0015341": "zinc efflux active transmembrane transporter activity",
  "GO:0015342": "obsolete zinc, iron permease activity",
  "GO:0015343": "siderophore transmembrane transporter activity",
  "GO:0015344": "siderophore uptake transmembrane transporter activity",
  "GO:0015345": "ferric enterobactin:proton symporter activity",
  "GO:0015346": "ferric triacetylfusarinine C:proton symporter activity",
  "GO:0015347": "sodium-independent organic anion transmembrane transporter activity",
  "GO:0015348": "obsolete prostaglandin/thromboxane transporter activity",
  "GO:0015349": "thyroid hormone transmembrane transporter activity",
  "GO:0015350": "methotrexate transporter activity",
  "GO:0015351": "bilirubin secondary active transmembrane transporter activity",
  "GO:0015352": "secondary active sterol transmembrane transporter activity",
  "GO:0015355": "secondary active monocarboxylate transmembrane transporter activity",
  "GO:0015356": "obsolete monocarboxylate (lactate, pyruvate, mevalonate) uptake/efflux porter activity",
  "GO:0015358": "obsolete amino acid/choline transmembrane transporter activity",
  "GO:0015360": "acetate:proton symporter activity",
  "GO:0015361": "low-affinity sodium:dicarboxylate symporter activity",
  "GO:0015362": "high-affinity sodium:dicarboxylate symporter activity",
  "GO:0015363": "obsolete dicarboxylate (succinate/fumarate/malate) antiporter activity",
  "GO:0015364": "dicarboxylate:inorganic phosphate antiporter activity",
  "GO:0015366": "malate:proton symporter activity",
  "GO:0015367": "oxoglutarate:malate antiporter activity",
  "GO:0015368": "calcium:cation antiporter activity",
  "GO:0015369": "calcium:proton antiporter activity",
  "GO:0015370": "solute:sodium symporter activity",
  "GO:0015371": "galactose:sodium symporter activity",
  "GO:0015372": "obsolete glutamate/aspartate:sodium symporter activity",
  "GO:0015373": "monovalent anion:sodium symporter activity",
  "GO:0015374": "neutral, basic amino acid:sodium:chloride symporter activity",
  "GO:0015375": "glycine:sodium symporter activity",
  "GO:0015376": "obsolete betaine/GABA:sodium symporter activity",
  "GO:0015377": "cation:chloride symporter activity",
  "GO:0015378": "sodium:chloride symporter activity",
  "GO:0015379": "potassium:chloride symporter activity",
  "GO:0015381": "high-affinity sulfate transmembrane transporter activity",
  "GO:0015382": "sodium:sulfate symporter activity",
  "GO:0015383": "sulfate:bicarbonate antiporter activity",
  "GO:0015385": "sodium:proton antiporter activity",
  "GO:0015386": "potassium:proton antiporter activity",
  "GO:0015387": "potassium:proton symporter activity",
  "GO:0015388": "potassium uptake transmembrane transporter activity",
  "GO:0015389": "pyrimidine- and adenine-specific:sodium symporter activity",
  "GO:0015390": "purine-specific nucleoside:sodium symporter activity",
  "GO:0015391": "nucleobase:cation symporter activity",
  "GO:0015393": "obsolete uracil/uridine permease activity",
  "GO:0015394": "uridine:hydrogen ion symporter activity",
  "GO:0015395": "nucleoside transmembrane transporter activity, down a concentration gradient",
  "GO:0015398": "high-affinity secondary active ammonium transmembrane transporter activity",
  "GO:0015399": "primary active transmembrane transporter activity",
  "GO:0015400": "low-affinity secondary active ammonium transmembrane transporter activity",
  "GO:0015401": "urea:sodium symporter activity",
  "GO:0015403": "thiamine uptake transmembrane transporter activity",
  "GO:0015405": "P-P-bond-hydrolysis-driven transmembrane transporter activity",
  "GO:0015406": "obsolete ABC-type uptake permease activity",
  "GO:0015407": "monosaccharide-transporting ATPase activity",
  "GO:0015408": "ferric-transporting ATPase activity",
  "GO:0015410": "manganese-transporting ATPase activity",
  "GO:0015411": "taurine-transporting ATPase activity",
  "GO:0015412": "molybdate transmembrane-transporting ATPase activity",
  "GO:0015413": "nickel-transporting ATPase activity",
  "GO:0015414": "nitrate transmembrane-transporting ATPase activity",
  "GO:0015415": "phosphate ion transmembrane-transporting ATPase activity",
  "GO:0015416": "organic phosphonate transmembrane-transporting ATPase activity",
  "GO:0015417": "polyamine-transporting ATPase activity",
  "GO:0015418": "quaternary-ammonium-compound-transporting ATPase activity",
  "GO:0015419": "sulfate transmembrane-transporting ATPase activity",
  "GO:0015420": "cobalamin-transporting ATPase activity",
  "GO:0015421": "oligopeptide-transporting ATPase activity",
  "GO:0015422": "oligosaccharide-transporting ATPase activity",
  "GO:0015423": "maltose-transporting ATPase activity",
  "GO:0015424": "amino acid-transporting ATPase activity",
  "GO:0015425": "nonpolar-amino acid-transporting ATPase activity",
  "GO:0015426": "polar-amino acid-transporting ATPase activity",
  "GO:0015427": "obsolete ABC-type efflux porter activity",
  "GO:0015428": "obsolete type I protein secretor activity",
  "GO:0015429": "obsolete peroxisomal fatty acyl transporter",
  "GO:0015430": "glycerol-3-phosphate-transporting ATPase activity",
  "GO:0015431": "glutathione S-conjugate-exporting ATPase activity",
  "GO:0015432": "bile acid-exporting ATPase activity",
  "GO:0015433": "peptide antigen-transporting ATPase activity",
  "GO:0015434": "cadmium-transporting ATPase activity",
  "GO:0015435": "obsolete ABC-type efflux permease activity",
  "GO:0015436": "capsular-polysaccharide-transporting ATPase activity",
  "GO:0015437": "lipopolysaccharide-transporting ATPase activity",
  "GO:0015438": "teichoic-acid-transporting ATPase activity",
  "GO:0015439": "heme-transporting ATPase activity",
  "GO:0015440": "peptide-transporting ATPase activity",
  "GO:0015441": "beta-glucan-transporting ATPase activity",
  "GO:0015442": "obsolete hydrogen-/sodium-translocating ATPase activity",
  "GO:0015443": "obsolete sodium-transporting two-sector ATPase activity",
  "GO:0015444": "magnesium-importing ATPase activity",
  "GO:0015445": "silver-exporting ATPase activity",
  "GO:0015446": "arsenite-transmembrane transporting ATPase activity",
  "GO:0015447": "obsolete type II protein secretor activity",
  "GO:0015448": "obsolete type III protein (virulence-related) secretor activity",
  "GO:0015449": "obsolete type IV protein (DNA-protein) secretor activity",
  "GO:0015450": "P-P-bond-hydrolysis-driven protein transmembrane transporter activity",
  "GO:0015451": "decarboxylation-driven active transmembrane transporter activity",
  "GO:0015452": "methyl transfer-driven active transmembrane transporter activity",
  "GO:0015453": "oxidoreduction-driven active transmembrane transporter activity",
  "GO:0015454": "light-driven active transmembrane transporter activity",
  "GO:0015459": "potassium channel regulator activity",
  "GO:0015461": "obsolete endosomal oligosaccharide transporter",
  "GO:0015462": "protein-transmembrane transporting ATPase activity",
  "GO:0015464": "acetylcholine receptor activity",
  "GO:0015465": "obsolete lysin activity",
  "GO:0015466": "obsolete autolysin activity",
  "GO:0015467": "G-protein activated inward rectifier potassium channel activity",
  "GO:0015468": "obsolete colicin",
  "GO:0015469": "obsolete channel-forming toxin activity",
  "GO:0015470": "obsolete bacteriocin activity",
  "GO:0015471": "nucleoside-specific channel forming porin activity",
  "GO:0015472": "obsolete fimbrium-specific chaperone activity",
  "GO:0015473": "fimbrial usher porin activity",
  "GO:0015474": "autotransporter activity",
  "GO:0015475": "adhesin autotransporter activity",
  "GO:0015476": "hemaglutinin autotransporter activity",
  "GO:0015477": "obsolete receptor porin activity",
  "GO:0015478": "oligosaccharide transporting porin activity",
  "GO:0015479": "obsolete outer membrane exporter porin",
  "GO:0015480": "obsolete secretin (sensu Bacteria)",
  "GO:0015481": "maltose transporting porin activity",
  "GO:0015482": "obsolete voltage-gated anion channel porin activity",
  "GO:0015483": "long-chain fatty acid transporting porin activity",
  "GO:0015484": "obsolete hemolysin activity",
  "GO:0015485": "cholesterol binding",
  "GO:0015486": "glycoside-pentoside-hexuronide:cation symporter activity",
  "GO:0015487": "melibiose:monovalent cation symporter activity",
  "GO:0015488": "glucuronide:monovalent cation symporter activity",
  "GO:0015489": "putrescine transmembrane transporter activity",
  "GO:0015490": "cadaverine transmembrane transporter activity",
  "GO:0015491": "cation:cation antiporter activity",
  "GO:0015492": "phenylalanine:proton symporter activity",
  "GO:0015493": "lysine:proton symporter activity",
  "GO:0015494": "aromatic amino acid:proton symporter activity",
  "GO:0015495": "gamma-aminobutyric acid:proton symporter activity",
  "GO:0015496": "putrescine:ornithine antiporter activity",
  "GO:0015498": "pantothenate:sodium symporter activity",
  "GO:0015499": "formate transmembrane transporter activity",
  "GO:0015500": "obsolete threonine/serine:sodium symporter activity",
  "GO:0015501": "glutamate:sodium symporter activity",
  "GO:0015503": "glutathione-regulated potassium exporter activity",
  "GO:0015504": "cytosine:hydrogen ion symporter activity",
  "GO:0015505": "uracil:cation symporter activity",
  "GO:0015506": "nucleoside:proton symporter activity",
  "GO:0015507": "obsolete hydroxy/aromatic amino acid permease activity",
  "GO:0015513": "nitrite uptake transmembrane transporter activity",
  "GO:0015514": "nitrite efflux transmembrane transporter activity",
  "GO:0015515": "citrate:succinate antiporter activity",
  "GO:0015516": "tartrate:succinate antiporter activity",
  "GO:0015517": "galactose:proton symporter activity",
  "GO:0015518": "arabinose:proton symporter activity",
  "GO:0015519": "D-xylose:proton symporter activity",
  "GO:0015520": "tetracycline:proton antiporter activity",
  "GO:0015521": "obsolete bicyclomycin/sulfathiazole:hydrogen antiporter activity",
  "GO:0015522": "hydrophobic uncoupler:proton antiporter activity",
  "GO:0015523": "arabinose efflux transmembrane transporter activity",
  "GO:0015524": "obsolete L-arabinose/beta-D-thiogalactopyranoside:hydrogen antiporter activity",
  "GO:0015525": "obsolete carbonyl cyanide m-chlorophenylhydrazone/nalidixic acid/organomercurials:hydrogen antiporter activity",
  "GO:0015526": "hexose-phosphate:inorganic phosphate antiporter activity",
  "GO:0015527": "glycerol-phosphate:inorganic phosphate antiporter activity",
  "GO:0015528": "lactose:proton symporter activity",
  "GO:0015529": "raffinose:proton symporter activity",
  "GO:0015530": "shikimate transmembrane transporter activity",
  "GO:0015531": "citrate:proton symporter activity",
  "GO:0015532": "alpha-ketoglutarate:proton symporter activity",
  "GO:0015533": "shikimate:proton symporter activity",
  "GO:0015534": "obsolete proline/glycine/betaine:hydrogen/sodium symporter activity",
  "GO:0015535": "fucose:proton symporter activity",
  "GO:0015537": "xanthosine:hydrogen ion symporter activity",
  "GO:0015538": "sialic acid:proton symporter activity",
  "GO:0015539": "hexuronate:cation symporter activity",
  "GO:0015540": "3-hydroxyphenyl propionate:hydrogen ion symporter activity",
  "GO:0015541": "secondary active cyanate uptake transmembrane transporter activity",
  "GO:0015542": "sugar efflux transmembrane transporter activity",
  "GO:0015543": "obsolete lactose/glucose efflux transporter activity",
  "GO:0015544": "phenyl propionate uptake uniporter activity",
  "GO:0015545": "bicyclomycin transporter activity",
  "GO:0015546": "sulfathiazole transmembrane transporter activity",
  "GO:0015547": "nalidixic acid transporter activity",
  "GO:0015548": "organomercurial transporter activity",
  "GO:0015549": "carbonyl cyanide m-chlorophenylhydrazone transporter activity",
  "GO:0015550": "galacturonate transmembrane transporter activity",
  "GO:0015551": "3-hydroxyphenyl propanoate transmembrane transporter activity",
  "GO:0015552": "propionate transmembrane transporter activity",
  "GO:0015553": "xanthosine transmembrane transporter activity",
  "GO:0015554": "tartrate transmembrane transporter activity",
  "GO:0015556": "C4-dicarboxylate transmembrane transporter activity",
  "GO:0015557": "arginine targeting transmembrane transporter activity",
  "GO:0015558": "p-aminobenzoyl-glutamate uptake transmembrane transporter activity",
  "GO:0015560": "obsolete L-idonate/D-gluconate:hydrogen symporter activity",
  "GO:0015561": "rhamnose:proton symporter activity",
  "GO:0015562": "efflux transmembrane transporter activity",
  "GO:0015563": "uptake transmembrane transporter activity",
  "GO:0015565": "threonine efflux transmembrane transporter activity",
  "GO:0015566": "acriflavine transporter activity",
  "GO:0015567": "alkane transporter activity",
  "GO:0015568": "L-idonate transmembrane transporter activity",
  "GO:0015569": "p-aminobenzoyl-glutamate transmembrane transporter activity",
  "GO:0015571": "N-acetylgalactosamine transmembrane transporter activity",
  "GO:0015572": "N-acetylglucosamine transmembrane transporter activity",
  "GO:0015573": "beta-glucoside transmembrane transporter activity",
  "GO:0015574": "trehalose transmembrane transporter activity",
  "GO:0015575": "mannitol transmembrane transporter activity",
  "GO:0015576": "sorbitol transmembrane transporter activity",
  "GO:0015577": "galactitol transmembrane transporter activity",
  "GO:0015578": "mannose transmembrane transporter activity",
  "GO:0015583": "obsolete beta-glucoside [arbutin-salicin-cellobiose] permease activity",
  "GO:0015591": "D-ribose transmembrane transporter activity",
  "GO:0015592": "methylgalactoside transmembrane transporter activity",
  "GO:0015593": "allose transmembrane transporter activity",
  "GO:0015594": "putrescine-importing ATPase activity",
  "GO:0015595": "spermidine-importing ATPase activity",
  "GO:0015596": "obsolete glycine betaine/proline porter activity",
  "GO:0015597": "obsolete histidine/arginine/lysine/ornithine porter activity",
  "GO:0015598": "arginine-importing ATPase activity",
  "GO:0015599": "glutamine-importing ATPase activity",
  "GO:0015600": "obsolete glutamate/aspartate porter activity",
  "GO:0015601": "obsolete cystine/diaminopimelate porter activity",
  "GO:0015602": "obsolete leucine/isoleucine/valine porter activity",
  "GO:0015603": "iron chelate transmembrane transporter activity",
  "GO:0015604": "organic phosphonate transmembrane transporter activity",
  "GO:0015605": "organophosphate ester transmembrane transporter activity",
  "GO:0015606": "spermidine transmembrane transporter activity",
  "GO:0015607": "fatty-acyl-CoA transporter activity",
  "GO:0015608": "carbohydrate-importing ATPase activity",
  "GO:0015609": "maltooligosaccharide-importing ATPase activity",
  "GO:0015610": "glycerol phosphate-importing ATPase activity",
  "GO:0015611": "D-ribose-importing ATPase activity",
  "GO:0015612": "L-arabinose-importing ATPase activity",
  "GO:0015613": "obsolete galactose/glucose (methylgalactoside) porter activity",
  "GO:0015614": "D-xylose-importing ATPase activity",
  "GO:0015615": "D-allose-importing ATPase activity",
  "GO:0015616": "DNA translocase activity",
  "GO:0015617": "obsolete pilin/fimbrilin exporter activity",
  "GO:0015619": "thiamine pyrophosphate-transporting ATPase activity",
  "GO:0015620": "ferric-enterobactin transmembrane transporter activity",
  "GO:0015621": "ferric triacetylfusarinine C transmembrane transporter activity",
  "GO:0015622": "ferric-hydroxamate transmembrane transporter activity",
  "GO:0015623": "iron-chelate-transporting ATPase activity",
  "GO:0015624": "ferric-enterobactin-transporting ATPase activity",
  "GO:0015625": "ferric-hydroxamate-transporting ATPase activity",
  "GO:0015626": "L-diaminopimelate transmembrane transporter activity",
  "GO:0015627": "type II protein secretion system complex",
  "GO:0015628": "protein secretion by the type II secretion system",
  "GO:0015629": "actin cytoskeleton",
  "GO:0015630": "microtubule cytoskeleton",
  "GO:0015631": "tubulin binding",
  "GO:0015633": "zinc transporting ATPase activity",
  "GO:0015634": "lipopolysaccharide exporter activity",
  "GO:0015635": "short-chain fatty acid transporter activity",
  "GO:0015636": "short-chain fatty acid uptake transporter activity",
  "GO:0015638": "microcin uptake transporter activity",
  "GO:0015639": "ferrous iron uptake transmembrane transporter activity",
  "GO:0015640": "peptidoglycan peptide transporter activity",
  "GO:0015641": "obsolete lipoprotein toxin",
  "GO:0015642": "obsolete bacteriolytic toxin activity",
  "GO:0015643": "toxic substance binding",
  "GO:0015644": "obsolete lipoprotein antitoxin",
  "GO:0015645": "fatty acid ligase activity",
  "GO:0015647": "peptidoglycan transporter activity",
  "GO:0015648": "lipid-linked peptidoglycan transporter activity",
  "GO:0015649": "2-keto-3-deoxygluconate:proton symporter activity",
  "GO:0015650": "lactate:proton symporter activity",
  "GO:0015651": "quaternary ammonium group transmembrane transporter activity",
  "GO:0015652": "quaternary ammonium group:proton symporter activity",
  "GO:0015653": "glycine betaine:proton symporter activity",
  "GO:0015654": "tellurite uptake transmembrane transporter activity",
  "GO:0015655": "alanine:sodium symporter activity",
  "GO:0015657": "branched-chain amino acid:sodium symporter activity",
  "GO:0015658": "branched-chain amino acid transmembrane transporter activity",
  "GO:0015659": "formate uptake transmembrane transporter activity",
  "GO:0015660": "formate efflux transmembrane transporter activity",
  "GO:0015661": "L-lysine efflux transmembrane transporter activity",
  "GO:0015662": "ATPase activity, coupled to transmembrane movement of ions, phosphorylative mechanism",
  "GO:0015663": "nicotinamide mononucleotide transmembrane transporter activity",
  "GO:0015665": "alcohol transmembrane transporter activity",
  "GO:0015666": "restriction endodeoxyribonuclease activity",
  "GO:0015667": "site-specific DNA-methyltransferase (cytosine-N4-specific) activity",
  "GO:0015668": "Type III site-specific deoxyribonuclease activity",
  "GO:0015669": "gas transport",
  "GO:0015670": "carbon dioxide transport",
  "GO:0015671": "oxygen transport",
  "GO:0015672": "monovalent inorganic cation transport",
  "GO:0015673": "silver ion transport",
  "GO:0015675": "nickel cation transport",
  "GO:0015676": "vanadium ion transport",
  "GO:0015677": "copper ion import",
  "GO:0015678": "high-affinity copper ion transport",
  "GO:0015679": "plasma membrane copper ion transport",
  "GO:0015680": "intracellular copper ion transport",
  "GO:0015682": "ferric iron transport",
  "GO:0015683": "high-affinity ferric iron transport",
  "GO:0015684": "ferrous iron transport",
  "GO:0015685": "ferric-enterobactin transport",
  "GO:0015686": "ferric triacetylfusarinine C transport",
  "GO:0015687": "ferric-hydroxamate transport",
  "GO:0015688": "iron chelate transport",
  "GO:0015689": "molybdate ion transport",
  "GO:0015690": "aluminum cation transport",
  "GO:0015691": "cadmium ion transport",
  "GO:0015692": "lead ion transport",
  "GO:0015693": "magnesium ion transport",
  "GO:0015694": "mercury ion transport",
  "GO:0015695": "organic cation transport",
  "GO:0015696": "ammonium transport",
  "GO:0015697": "quaternary ammonium group transport",
  "GO:0015698": "inorganic anion transport",
  "GO:0015699": "antimonite transport",
  "GO:0015700": "arsenite transport",
  "GO:0015701": "bicarbonate transport",
  "GO:0015702": "chlorate transport",
  "GO:0015703": "chromate transport",
  "GO:0015704": "cyanate transport",
  "GO:0015705": "iodide transport",
  "GO:0015706": "nitrate transport",
  "GO:0015707": "nitrite transport",
  "GO:0015708": "silicate transport",
  "GO:0015709": "thiosulfate transport",
  "GO:0015710": "tellurite transport",
  "GO:0015711": "organic anion transport",
  "GO:0015712": "hexose phosphate transport",
  "GO:0015713": "phosphoglycerate transport",
  "GO:0015714": "phosphoenolpyruvate transport",
  "GO:0015715": "nucleotide-sulfate transport",
  "GO:0015716": "organic phosphonate transport",
  "GO:0015717": "triose phosphate transport",
  "GO:0015718": "monocarboxylic acid transport",
  "GO:0015719": "allantoate transport",
  "GO:0015720": "allantoin transport",
  "GO:0015721": "bile acid and bile salt transport",
  "GO:0015722": "canalicular bile acid transport",
  "GO:0015723": "bilirubin transport",
  "GO:0015724": "formate transport",
  "GO:0015725": "gluconate transport",
  "GO:0015726": "L-idonate transport",
  "GO:0015727": "lactate transport",
  "GO:0015728": "mevalonate transport",
  "GO:0015729": "oxaloacetate transport",
  "GO:0015730": "propanoate transport",
  "GO:0015731": "3-hydroxyphenyl propanoate transport",
  "GO:0015732": "prostaglandin transport",
  "GO:0015733": "shikimate transport",
  "GO:0015734": "taurine transport",
  "GO:0015735": "uronic acid transport",
  "GO:0015736": "hexuronate transport",
  "GO:0015737": "galacturonate transport",
  "GO:0015738": "glucuronate transport",
  "GO:0015739": "sialic acid transport",
  "GO:0015740": "C4-dicarboxylate transport",
  "GO:0015741": "fumarate transport",
  "GO:0015742": "alpha-ketoglutarate transport",
  "GO:0015743": "malate transport",
  "GO:0015744": "succinate transport",
  "GO:0015745": "tartrate transport",
  "GO:0015746": "citrate transport",
  "GO:0015747": "urate transport",
  "GO:0015748": "organophosphate ester transport",
  "GO:0015749": "monosaccharide transport",
  "GO:0015750": "pentose transport",
  "GO:0015751": "arabinose transport",
  "GO:0015752": "D-ribose transport",
  "GO:0015753": "D-xylose transport",
  "GO:0015754": "allose transport",
  "GO:0015755": "fructose transport",
  "GO:0015756": "fucose transport",
  "GO:0015757": "galactose transport",
  "GO:0015758": "glucose transport",
  "GO:0015759": "beta-glucoside transport",
  "GO:0015760": "glucose-6-phosphate transport",
  "GO:0015761": "mannose transport",
  "GO:0015762": "rhamnose transport",
  "GO:0015763": "N-acetylgalactosamine transport",
  "GO:0015764": "N-acetylglucosamine transport",
  "GO:0015765": "methylgalactoside transport",
  "GO:0015766": "disaccharide transport",
  "GO:0015767": "lactose transport",
  "GO:0015768": "maltose transport",
  "GO:0015769": "melibiose transport",
  "GO:0015770": "sucrose transport",
  "GO:0015771": "trehalose transport",
  "GO:0015772": "oligosaccharide transport",
  "GO:0015773": "raffinose transport",
  "GO:0015774": "polysaccharide transport",
  "GO:0015775": "beta-glucan transport",
  "GO:0015776": "capsular polysaccharide transport",
  "GO:0015777": "teichoic acid transport",
  "GO:0015778": "hexuronide transport",
  "GO:0015779": "glucuronoside transport",
  "GO:0015780": "nucleotide-sugar transport",
  "GO:0015781": "pyrimidine nucleotide-sugar transport",
  "GO:0015782": "CMP-N-acetylneuraminate transport",
  "GO:0015783": "GDP-fucose transport",
  "GO:0015784": "GDP-mannose transport",
  "GO:0015785": "UDP-galactose transport",
  "GO:0015786": "UDP-glucose transport",
  "GO:0015787": "UDP-glucuronic acid transport",
  "GO:0015788": "UDP-N-acetylglucosamine transport",
  "GO:0015789": "UDP-N-acetylgalactosamine transport",
  "GO:0015790": "UDP-xylose transport",
  "GO:0015791": "polyol transport",
  "GO:0015792": "arabinitol transport",
  "GO:0015793": "glycerol transport",
  "GO:0015794": "glycerol-3-phosphate transport",
  "GO:0015795": "sorbitol transport",
  "GO:0015796": "galactitol transport",
  "GO:0015797": "mannitol transport",
  "GO:0015798": "myo-inositol transport",
  "GO:0015799": "propanediol transport",
  "GO:0015800": "acidic amino acid transport",
  "GO:0015801": "aromatic amino acid transport",
  "GO:0015802": "basic amino acid transport",
  "GO:0015803": "branched-chain amino acid transport",
  "GO:0015804": "neutral amino acid transport",
  "GO:0015805": "S-adenosyl-L-methionine transport",
  "GO:0015806": "S-methylmethionine transport",
  "GO:0015807": "L-amino acid transport",
  "GO:0015808": "L-alanine transport",
  "GO:0015809": "arginine transport",
  "GO:0015810": "aspartate transport",
  "GO:0015811": "L-cystine transport",
  "GO:0015812": "gamma-aminobutyric acid transport",
  "GO:0015813": "L-glutamate transport",
  "GO:0015814": "p-aminobenzoyl-glutamate transport",
  "GO:0015816": "glycine transport",
  "GO:0015817": "histidine transport",
  "GO:0015818": "isoleucine transport",
  "GO:0015819": "lysine transport",
  "GO:0015820": "leucine transport",
  "GO:0015821": "methionine transport",
  "GO:0015822": "ornithine transport",
  "GO:0015823": "phenylalanine transport",
  "GO:0015824": "proline transport",
  "GO:0015825": "L-serine transport",
  "GO:0015826": "threonine transport",
  "GO:0015827": "tryptophan transport",
  "GO:0015828": "tyrosine transport",
  "GO:0015829": "valine transport",
  "GO:0015830": "diaminopimelate transport",
  "GO:0015832": "obsolete holin",
  "GO:0015833": "peptide transport",
  "GO:0015834": "peptidoglycan-associated peptide transport",
  "GO:0015835": "peptidoglycan transport",
  "GO:0015836": "lipid-linked peptidoglycan transport",
  "GO:0015837": "amine transport",
  "GO:0015838": "amino-acid betaine transport",
  "GO:0015839": "cadaverine transport",
  "GO:0015840": "urea transport",
  "GO:0015841": "chromaffin granule amine transport",
  "GO:0015842": "aminergic neurotransmitter loading into synaptic vesicle",
  "GO:0015843": "methylammonium transport",
  "GO:0015844": "monoamine transport",
  "GO:0015846": "polyamine transport",
  "GO:0015847": "putrescine transport",
  "GO:0015848": "spermidine transport",
  "GO:0015849": "organic acid transport",
  "GO:0015850": "organic hydroxy compound transport",
  "GO:0015851": "nucleobase transport",
  "GO:0015853": "adenine transport",
  "GO:0015854": "guanine transport",
  "GO:0015855": "pyrimidine nucleobase transport",
  "GO:0015856": "cytosine transport",
  "GO:0015857": "uracil transport",
  "GO:0015858": "nucleoside transport",
  "GO:0015859": "intracellular nucleoside transport",
  "GO:0015860": "purine nucleoside transmembrane transport",
  "GO:0015861": "cytidine transport",
  "GO:0015862": "uridine transport",
  "GO:0015863": "xanthosine transport",
  "GO:0015864": "pyrimidine nucleoside transport",
  "GO:0015865": "purine nucleotide transport",
  "GO:0015866": "ADP transport",
  "GO:0015867": "ATP transport",
  "GO:0015868": "purine ribonucleotide transport",
  "GO:0015869": "protein-DNA complex transport",
  "GO:0015870": "acetylcholine transport",
  "GO:0015871": "choline transport",
  "GO:0015872": "dopamine transport",
  "GO:0015874": "norepinephrine transport",
  "GO:0015875": "obsolete vitamin or cofactor transport",
  "GO:0015876": "acetyl-CoA transport",
  "GO:0015877": "biopterin transport",
  "GO:0015878": "biotin transport",
  "GO:0015879": "carnitine transport",
  "GO:0015880": "coenzyme A transport",
  "GO:0015881": "creatine transport",
  "GO:0015882": "L-ascorbic acid transport",
  "GO:0015883": "FAD transport",
  "GO:0015884": "folic acid transport",
  "GO:0015885": "5-formyltetrahydrofolate transport",
  "GO:0015886": "heme transport",
  "GO:0015887": "pantothenate transmembrane transport",
  "GO:0015888": "thiamine transport",
  "GO:0015889": "cobalamin transport",
  "GO:0015890": "nicotinamide mononucleotide transport",
  "GO:0015891": "siderophore transport",
  "GO:0015893": "drug transport",
  "GO:0015894": "acriflavine transport",
  "GO:0015895": "alkane transport",
  "GO:0015896": "nalidixic acid transport",
  "GO:0015897": "organomercurial transport",
  "GO:0015898": "amiloride transport",
  "GO:0015899": "aminotriazole transport",
  "GO:0015900": "benomyl transport",
  "GO:0015901": "cycloheximide transport",
  "GO:0015902": "carbonyl cyanide m-chlorophenylhydrazone transport",
  "GO:0015903": "fluconazole transport",
  "GO:0015904": "tetracycline transport",
  "GO:0015905": "bicyclomycin transport",
  "GO:0015906": "sulfathiazole transport",
  "GO:0015908": "fatty acid transport",
  "GO:0015909": "long-chain fatty acid transport",
  "GO:0015910": "peroxisomal long-chain fatty acid import",
  "GO:0015911": "plasma membrane long-chain fatty acid transport",
  "GO:0015912": "short-chain fatty acid transport",
  "GO:0015913": "short-chain fatty acid import",
  "GO:0015914": "phospholipid transport",
  "GO:0015915": "fatty-acyl group transport",
  "GO:0015916": "fatty-acyl-CoA transport",
  "GO:0015917": "aminophospholipid transport",
  "GO:0015918": "sterol transport",
  "GO:0015919": "peroxisomal membrane transport",
  "GO:0015920": "lipopolysaccharide transport",
  "GO:0015921": "lipopolysaccharide export",
  "GO:0015922": "aspartate oxidase activity",
  "GO:0015923": "mannosidase activity",
  "GO:0015924": "mannosyl-oligosaccharide mannosidase activity",
  "GO:0015925": "galactosidase activity",
  "GO:0015926": "glucosidase activity",
  "GO:0015927": "trehalase activity",
  "GO:0015928": "fucosidase activity",
  "GO:0015929": "hexosaminidase activity",
  "GO:0015930": "glutamate synthase activity",
  "GO:0015931": "nucleobase-containing compound transport",
  "GO:0015932": "nucleobase-containing compound transmembrane transporter activity",
  "GO:0015933": "obsolete flavin-containing electron transporter",
  "GO:0015934": "large ribosomal subunit",
  "GO:0015935": "small ribosomal subunit",
  "GO:0015936": "coenzyme A metabolic process",
  "GO:0015937": "coenzyme A biosynthetic process",
  "GO:0015938": "coenzyme A catabolic process",
  "GO:0015939": "pantothenate metabolic process",
  "GO:0015940": "pantothenate biosynthetic process",
  "GO:0015941": "pantothenate catabolic process",
  "GO:0015942": "formate metabolic process",
  "GO:0015943": "formate biosynthetic process",
  "GO:0015944": "formate oxidation",
  "GO:0015945": "methanol metabolic process",
  "GO:0015946": "methanol oxidation",
  "GO:0015947": "methane metabolic process",
  "GO:0015948": "methanogenesis",
  "GO:0015949": "nucleobase-containing small molecule interconversion",
  "GO:0015950": "purine nucleotide interconversion",
  "GO:0015951": "purine ribonucleotide interconversion",
  "GO:0015952": "purine deoxyribonucleotide interconversion",
  "GO:0015953": "pyrimidine nucleotide interconversion",
  "GO:0015954": "pyrimidine ribonucleotide interconversion",
  "GO:0015955": "pyrimidine deoxyribonucleotide interconversion",
  "GO:0015956": "bis(5'-nucleosidyl) oligophosphate metabolic process",
  "GO:0015957": "bis(5'-nucleosidyl) oligophosphate biosynthetic process",
  "GO:0015958": "bis(5'-nucleosidyl) oligophosphate catabolic process",
  "GO:0015959": "diadenosine polyphosphate metabolic process",
  "GO:0015960": "diadenosine polyphosphate biosynthetic process",
  "GO:0015961": "diadenosine polyphosphate catabolic process",
  "GO:0015962": "diadenosine triphosphate metabolic process",
  "GO:0015963": "diadenosine triphosphate biosynthetic process",
  "GO:0015964": "diadenosine triphosphate catabolic process",
  "GO:0015965": "diadenosine tetraphosphate metabolic process",
  "GO:0015966": "diadenosine tetraphosphate biosynthetic process",
  "GO:0015967": "diadenosine tetraphosphate catabolic process",
  "GO:0015968": "stringent response",
  "GO:0015969": "guanosine tetraphosphate metabolic process",
  "GO:0015970": "guanosine tetraphosphate biosynthetic process",
  "GO:0015971": "guanosine tetraphosphate catabolic process",
  "GO:0015972": "guanosine pentaphosphate metabolic process",
  "GO:0015973": "guanosine pentaphosphate biosynthetic process",
  "GO:0015974": "guanosine pentaphosphate catabolic process",
  "GO:0015975": "energy derivation by oxidation of reduced inorganic compounds",
  "GO:0015976": "carbon utilization",
  "GO:0015977": "carbon fixation",
  "GO:0015979": "photosynthesis",
  "GO:0015980": "energy derivation by oxidation of organic compounds",
  "GO:0015981": "obsolete passive proton transport, down the electrochemical gradient",
  "GO:0015982": "obsolete antiport",
  "GO:0015983": "obsolete symport",
  "GO:0015984": "obsolete uniport",
  "GO:0015985": "energy coupled proton transport, down electrochemical gradient",
  "GO:0015986": "ATP synthesis coupled proton transport",
  "GO:0015987": "GTP synthesis coupled proton transport",
  "GO:0015988": "energy coupled proton transmembrane transport, against electrochemical gradient",
  "GO:0015989": "light-driven proton transport",
  "GO:0015990": "electron transport coupled proton transport",
  "GO:0015991": "ATP hydrolysis coupled proton transport",
  "GO:0015992": "proton transport",
  "GO:0015993": "molecular hydrogen transport",
  "GO:0015994": "chlorophyll metabolic process",
  "GO:0015995": "chlorophyll biosynthetic process",
  "GO:0015996": "chlorophyll catabolic process",
  "GO:0015997": "obsolete ubiquinone biosynthetic process monooxygenase activity",
  "GO:0016002": "sulfite reductase activity",
  "GO:0016004": "phospholipase activator activity",
  "GO:0016005": "phospholipase A2 activator activity",
  "GO:0016006": "Nebenkern",
  "GO:0016007": "mitochondrial derivative",
  "GO:0016008": "major mitochondrial derivative",
  "GO:0016009": "minor mitochondrial derivative",
  "GO:0016010": "dystrophin-associated glycoprotein complex",
  "GO:0016011": "dystroglycan complex",
  "GO:0016012": "sarcoglycan complex",
  "GO:0016013": "syntrophin complex",
  "GO:0016014": "dystrobrevin complex",
  "GO:0016015": "morphogen activity",
  "GO:0016016": "obsolete short-wave-sensitive opsin",
  "GO:0016018": "cyclosporin A binding",
  "GO:0016019": "peptidoglycan receptor activity",
  "GO:0016020": "membrane",
  "GO:0016021": "integral component of membrane",
  "GO:0016023": "cytoplasmic, membrane-bounded vesicle",
  "GO:0016024": "CDP-diacylglycerol biosynthetic process",
  "GO:0016025": "obsolete proteasome endopeptidase regulator",
  "GO:0016026": "obsolete proteasome endopeptidase core",
  "GO:0016027": "inaD signaling complex",
  "GO:0016028": "rhabdomere",
  "GO:0016029": "subrhabdomeral cisterna",
  "GO:0016031": "tRNA import into mitochondrion",
  "GO:0016032": "viral process",
  "GO:0016034": "maleylacetoacetate isomerase activity",
  "GO:0016035": "zeta DNA polymerase complex",
  "GO:0016036": "cellular response to phosphate starvation",
  "GO:0016037": "light absorption",
  "GO:0016038": "absorption of visible light",
  "GO:0016039": "absorption of UV light",
  "GO:0016040": "glutamate synthase (NADH) activity",
  "GO:0016041": "glutamate synthase (ferredoxin) activity",
  "GO:0016042": "lipid catabolic process",
  "GO:0016043": "cellular component organization",
  "GO:0016045": "detection of bacterium",
  "GO:0016046": "detection of fungus",
  "GO:0016047": "detection of parasitic fungus",
  "GO:0016048": "detection of temperature stimulus",
  "GO:0016049": "cell growth",
  "GO:0016050": "vesicle organization",
  "GO:0016051": "carbohydrate biosynthetic process",
  "GO:0016052": "carbohydrate catabolic process",
  "GO:0016053": "organic acid biosynthetic process",
  "GO:0016054": "organic acid catabolic process",
  "GO:0016055": "Wnt signaling pathway",
  "GO:0016056": "rhodopsin mediated signaling pathway",
  "GO:0016057": "regulation of membrane potential in photoreceptor cell",
  "GO:0016058": "maintenance of membrane potential in photoreceptor cell by rhodopsin mediated signaling",
  "GO:0016059": "deactivation of rhodopsin mediated signaling",
  "GO:0016060": "metarhodopsin inactivation",
  "GO:0016061": "regulation of light-activated channel activity",
  "GO:0016062": "adaptation of rhodopsin mediated signaling",
  "GO:0016063": "rhodopsin biosynthetic process",
  "GO:0016064": "immunoglobulin mediated immune response",
  "GO:0016065": "obsolete humoral defense mechanism (sensu Protostomia)",
  "GO:0016068": "type I hypersensitivity",
  "GO:0016070": "RNA metabolic process",
  "GO:0016071": "mRNA metabolic process",
  "GO:0016072": "rRNA metabolic process",
  "GO:0016073": "snRNA metabolic process",
  "GO:0016074": "snoRNA metabolic process",
  "GO:0016075": "rRNA catabolic process",
  "GO:0016076": "snRNA catabolic process",
  "GO:0016077": "snoRNA catabolic process",
  "GO:0016078": "tRNA catabolic process",
  "GO:0016079": "synaptic vesicle exocytosis",
  "GO:0016080": "synaptic vesicle targeting",
  "GO:0016081": "synaptic vesicle docking",
  "GO:0016082": "synaptic vesicle priming",
  "GO:0016083": "obsolete synaptic vesicle fusion",
  "GO:0016084": "myostimulatory hormone activity",
  "GO:0016085": "myoinhibitory hormone activity",
  "GO:0016086": "obsolete allatostatin",
  "GO:0016087": "ecdysiostatic hormone activity",
  "GO:0016088": "obsolete insulin",
  "GO:0016090": "prenol metabolic process",
  "GO:0016091": "prenol biosynthetic process",
  "GO:0016092": "prenol catabolic process",
  "GO:0016093": "polyprenol metabolic process",
  "GO:0016094": "polyprenol biosynthetic process",
  "GO:0016095": "polyprenol catabolic process",
  "GO:0016098": "monoterpenoid metabolic process",
  "GO:0016099": "monoterpenoid biosynthetic process",
  "GO:0016100": "monoterpenoid catabolic process",
  "GO:0016101": "diterpenoid metabolic process",
  "GO:0016102": "diterpenoid biosynthetic process",
  "GO:0016103": "diterpenoid catabolic process",
  "GO:0016104": "triterpenoid biosynthetic process",
  "GO:0016105": "triterpenoid catabolic process",
  "GO:0016106": "sesquiterpenoid biosynthetic process",
  "GO:0016107": "sesquiterpenoid catabolic process",
  "GO:0016108": "tetraterpenoid metabolic process",
  "GO:0016109": "tetraterpenoid biosynthetic process",
  "GO:0016110": "tetraterpenoid catabolic process",
  "GO:0016111": "polyterpenoid metabolic process",
  "GO:0016112": "polyterpenoid biosynthetic process",
  "GO:0016113": "polyterpenoid catabolic process",
  "GO:0016114": "terpenoid biosynthetic process",
  "GO:0016115": "terpenoid catabolic process",
  "GO:0016116": "carotenoid metabolic process",
  "GO:0016117": "carotenoid biosynthetic process",
  "GO:0016118": "carotenoid catabolic process",
  "GO:0016119": "carotene metabolic process",
  "GO:0016120": "carotene biosynthetic process",
  "GO:0016121": "carotene catabolic process",
  "GO:0016122": "xanthophyll metabolic process",
  "GO:0016123": "xanthophyll biosynthetic process",
  "GO:0016124": "xanthophyll catabolic process",
  "GO:0016125": "sterol metabolic process",
  "GO:0016126": "sterol biosynthetic process",
  "GO:0016127": "sterol catabolic process",
  "GO:0016128": "phytosteroid metabolic process",
  "GO:0016129": "phytosteroid biosynthetic process",
  "GO:0016130": "phytosteroid catabolic process",
  "GO:0016131": "brassinosteroid metabolic process",
  "GO:0016132": "brassinosteroid biosynthetic process",
  "GO:0016133": "brassinosteroid catabolic process",
  "GO:0016134": "saponin metabolic process",
  "GO:0016135": "saponin biosynthetic process",
  "GO:0016136": "saponin catabolic process",
  "GO:0016137": "glycoside metabolic process",
  "GO:0016138": "glycoside biosynthetic process",
  "GO:0016139": "glycoside catabolic process",
  "GO:0016143": "S-glycoside metabolic process",
  "GO:0016144": "S-glycoside biosynthetic process",
  "GO:0016145": "S-glycoside catabolic process",
  "GO:0016146": "obsolete protein-synthesizing GTPase activity, initiation",
  "GO:0016147": "obsolete protein-synthesizing GTPase activity, elongation",
  "GO:0016148": "obsolete protein-synthesizing GTPase activity, termination",
  "GO:0016149": "translation release factor activity, codon specific",
  "GO:0016150": "translation release factor activity, codon nonspecific",
  "GO:0016151": "nickel cation binding",
  "GO:0016152": "mercury (II) reductase activity",
  "GO:0016153": "urocanate hydratase activity",
  "GO:0016154": "pyrimidine-nucleoside phosphorylase activity",
  "GO:0016155": "formyltetrahydrofolate dehydrogenase activity",
  "GO:0016156": "fumarate reductase (NADH) activity",
  "GO:0016157": "sucrose synthase activity",
  "GO:0016158": "3-phytase activity",
  "GO:0016159": "muconolactone delta-isomerase activity",
  "GO:0016160": "amylase activity",
  "GO:0016161": "beta-amylase activity",
  "GO:0016162": "cellulose 1,4-beta-cellobiosidase activity",
  "GO:0016163": "nitrogenase activity",
  "GO:0016164": "obsolete Mo-molybdopterin oxidoreductase activity",
  "GO:0016165": "linoleate 13S-lipoxygenase activity",
  "GO:0016166": "phytoene dehydrogenase activity",
  "GO:0016167": "glial cell-derived neurotrophic factor receptor activity",
  "GO:0016168": "chlorophyll binding",
  "GO:0016169": "bacteriochlorophyll c binding",
  "GO:0016170": "interleukin-15 receptor binding",
  "GO:0016171": "obsolete cell surface antigen",
  "GO:0016172": "obsolete antifreeze activity",
  "GO:0016173": "obsolete ice nucleation inhibitor activity",
  "GO:0016174": "NAD(P)H oxidase activity",
  "GO:0016175": "superoxide-generating NADPH oxidase activity",
  "GO:0016176": "superoxide-generating NADPH oxidase activator activity",
  "GO:0016180": "snRNA processing",
  "GO:0016182": "synaptic vesicle budding from endosome",
  "GO:0016183": "synaptic vesicle coating",
  "GO:0016184": "obsolete synaptic vesicle retrieval",
  "GO:0016185": "synaptic vesicle budding from presynaptic endocytic zone membrane",
  "GO:0016186": "obsolete synaptic vesicle fission",
  "GO:0016187": "obsolete synaptic vesicle internalization",
  "GO:0016188": "synaptic vesicle maturation",
  "GO:0016189": "synaptic vesicle to endosome fusion",
  "GO:0016191": "synaptic vesicle uncoating",
  "GO:0016192": "vesicle-mediated transport",
  "GO:0016197": "endosomal transport",
  "GO:0016198": "axon choice point recognition",
  "GO:0016199": "axon midline choice point recognition",
  "GO:0016200": "synaptic target attraction",
  "GO:0016201": "synaptic target inhibition",
  "GO:0016202": "regulation of striated muscle tissue development",
  "GO:0016203": "muscle attachment",
  "GO:0016204": "determination of muscle attachment site",
  "GO:0016205": "selenocysteine methyltransferase activity",
  "GO:0016206": "catechol O-methyltransferase activity",
  "GO:0016207": "4-coumarate-CoA ligase activity",
  "GO:0016208": "AMP binding",
  "GO:0016209": "antioxidant activity",
  "GO:0016210": "naringenin-chalcone synthase activity",
  "GO:0016211": "ammonia ligase activity",
  "GO:0016212": "kynurenine-oxoglutarate transaminase activity",
  "GO:0016213": "linoleoyl-CoA desaturase activity",
  "GO:0016215": "acyl-CoA desaturase activity",
  "GO:0016216": "isopenicillin-N synthase activity",
  "GO:0016217": "N-ethylammeline chlorohydrolase activity",
  "GO:0016218": "obsolete polyketide synthase activity",
  "GO:0016222": "procollagen-proline 4-dioxygenase complex",
  "GO:0016223": "beta-alanine-pyruvate transaminase activity",
  "GO:0016226": "iron-sulfur cluster assembly",
  "GO:0016227": "obsolete tRNA sulfurtransferase activity",
  "GO:0016229": "steroid dehydrogenase activity",
  "GO:0016230": "sphingomyelin phosphodiesterase activator activity",
  "GO:0016231": "beta-N-acetylglucosaminidase activity",
  "GO:0016232": "HNK-1 sulfotransferase activity",
  "GO:0016233": "telomere capping",
  "GO:0016234": "inclusion body",
  "GO:0016235": "aggresome",
  "GO:0016236": "macroautophagy",
  "GO:0016237": "lysosomal microautophagy",
  "GO:0016239": "positive regulation of macroautophagy",
  "GO:0016240": "autophagosome docking",
  "GO:0016241": "regulation of macroautophagy",
  "GO:0016242": "negative regulation of macroautophagy",
  "GO:0016243": "regulation of autophagosome size",
  "GO:0016246": "RNA interference",
  "GO:0016247": "channel regulator activity",
  "GO:0016248": "channel inhibitor activity",
  "GO:0016250": "N-sulfoglucosamine sulfohydrolase activity",
  "GO:0016251": "obsolete general RNA polymerase II transcription factor activity",
  "GO:0016252": "obsolete nonspecific RNA polymerase II transcription factor activity",
  "GO:0016254": "preassembly of GPI anchor in ER membrane",
  "GO:0016255": "attachment of GPI anchor to protein",
  "GO:0016256": "N-glycan processing to lysosome",
  "GO:0016257": "N-glycan processing to secreted and cell-surface N-glycans",
  "GO:0016258": "N-glycan diversification",
  "GO:0016259": "selenocysteine metabolic process",
  "GO:0016260": "selenocysteine biosynthetic process",
  "GO:0016261": "selenocysteine catabolic process",
  "GO:0016262": "protein N-acetylglucosaminyltransferase activity",
  "GO:0016263": "glycoprotein-N-acetylgalactosamine 3-beta-galactosyltransferase activity",
  "GO:0016264": "gap junction assembly",
  "GO:0016265": "obsolete death",
  "GO:0016266": "O-glycan processing",
  "GO:0016267": "O-glycan processing, core 1",
  "GO:0016268": "O-glycan processing, core 2",
  "GO:0016269": "O-glycan processing, core 3",
  "GO:0016270": "O-glycan processing, core 4",
  "GO:0016271": "obsolete tissue death",
  "GO:0016272": "prefoldin complex",
  "GO:0016273": "arginine N-methyltransferase activity",
  "GO:0016274": "protein-arginine N-methyltransferase activity",
  "GO:0016275": "[cytochrome c]-arginine N-methyltransferase activity",
  "GO:0016277": "[myelin basic protein]-arginine N-methyltransferase activity",
  "GO:0016278": "lysine N-methyltransferase activity",
  "GO:0016279": "protein-lysine N-methyltransferase activity",
  "GO:0016281": "eukaryotic translation initiation factor 4F complex",
  "GO:0016282": "eukaryotic 43S preinitiation complex",
  "GO:0016284": "obsolete alanine aminopeptidase activity",
  "GO:0016285": "obsolete cytosol alanyl aminopeptidase activity",
  "GO:0016286": "small conductance calcium-activated potassium channel activity",
  "GO:0016287": "glycerone-phosphate O-acyltransferase activity",
  "GO:0016289": "CoA hydrolase activity",
  "GO:0016290": "palmitoyl-CoA hydrolase activity",
  "GO:0016295": "myristoyl-[acyl-carrier-protein] hydrolase activity",
  "GO:0016296": "palmitoyl-[acyl-carrier-protein] hydrolase activity",
  "GO:0016297": "acyl-[acyl-carrier-protein] hydrolase activity",
  "GO:0016298": "lipase activity",
  "GO:0016299": "obsolete regulator of G-protein signaling activity",
  "GO:0016300": "tRNA (uracil) methyltransferase activity",
  "GO:0016301": "kinase activity",
  "GO:0016303": "1-phosphatidylinositol-3-kinase activity",
  "GO:0016304": "obsolete phosphatidylinositol 3-kinase activity, class I",
  "GO:0016305": "obsolete phosphatidylinositol 3-kinase activity, class II",
  "GO:0016306": "obsolete phosphatidylinositol 3-kinase activity, class III",
  "GO:0016307": "phosphatidylinositol phosphate kinase activity",
  "GO:0016308": "1-phosphatidylinositol-4-phosphate 5-kinase activity",
  "GO:0016309": "1-phosphatidylinositol-5-phosphate 4-kinase activity",
  "GO:0016310": "phosphorylation",
  "GO:0016311": "dephosphorylation",
  "GO:0016312": "inositol bisphosphate phosphatase activity",
  "GO:0016313": "obsolete inositol-1,4,5-trisphosphate phosphatase",
  "GO:0016314": "phosphatidylinositol-3,4,5-trisphosphate 3-phosphatase activity",
  "GO:0016316": "phosphatidylinositol-3,4-bisphosphate 4-phosphatase activity",
  "GO:0016318": "ommatidial rotation",
  "GO:0016319": "mushroom body development",
  "GO:0016320": "endoplasmic reticulum membrane fusion",
  "GO:0016321": "female meiosis chromosome segregation",
  "GO:0016322": "neuron remodeling",
  "GO:0016323": "basolateral plasma membrane",
  "GO:0016324": "apical plasma membrane",
  "GO:0016325": "oocyte microtubule cytoskeleton organization",
  "GO:0016326": "obsolete kinesin motor activity",
  "GO:0016327": "apicolateral plasma membrane",
  "GO:0016328": "lateral plasma membrane",
  "GO:0016329": "obsolete apoptosis regulator activity",
  "GO:0016330": "second mitotic wave involved in compound eye morphogenesis",
  "GO:0016331": "morphogenesis of embryonic epithelium",
  "GO:0016332": "establishment or maintenance of polarity of embryonic epithelium",
  "GO:0016333": "morphogenesis of follicular epithelium",
  "GO:0016334": "establishment or maintenance of polarity of follicular epithelium",
  "GO:0016335": "morphogenesis of larval imaginal disc epithelium",
  "GO:0016336": "establishment or maintenance of polarity of larval imaginal disc epithelium",
  "GO:0016337": "single organismal cell-cell adhesion",
  "GO:0016338": "calcium-independent cell-cell adhesion via plasma membrane cell-adhesion molecules",
  "GO:0016339": "calcium-dependent cell-cell adhesion via plasma membrane cell adhesion molecules",
  "GO:0016340": "calcium-dependent cell-matrix adhesion",
  "GO:0016341": "obsolete other collagen",
  "GO:0016342": "catenin complex",
  "GO:0016343": "obsolete cytoskeletal anchoring activity",
  "GO:0016344": "meiotic chromosome movement towards spindle pole",
  "GO:0016345": "female meiotic chromosome movement towards spindle pole",
  "GO:0016346": "male meiotic chromosome movement towards spindle pole",
  "GO:0016347": "obsolete calcium-independent cell adhesion molecule activity",
  "GO:0016348": "imaginal disc-derived leg joint morphogenesis",
  "GO:0016351": "obsolete drug susceptibility/resistance",
  "GO:0016352": "obsolete insecticide susceptibility/resistance",
  "GO:0016353": "obsolete carbamate susceptibility/resistance",
  "GO:0016354": "obsolete cyclodiene susceptibility/resistance",
  "GO:0016355": "obsolete DDT susceptibility/resistance",
  "GO:0016356": "obsolete organophosphorus susceptibility/resistance",
  "GO:0016357": "obsolete pyrethroid susceptibility/resistance",
  "GO:0016358": "dendrite development",
  "GO:0016360": "sensory organ precursor cell fate determination",
  "GO:0016361": "activin receptor activity, type I",
  "GO:0016362": "activin receptor activity, type II",
  "GO:0016363": "nuclear matrix",
  "GO:0016401": "palmitoyl-CoA oxidase activity",
  "GO:0016402": "pristanoyl-CoA oxidase activity",
  "GO:0016403": "dimethylargininase activity",
  "GO:0016404": "15-hydroxyprostaglandin dehydrogenase (NAD+) activity",
  "GO:0016405": "CoA-ligase activity",
  "GO:0016406": "carnitine O-acyltransferase activity",
  "GO:0016407": "acetyltransferase activity",
  "GO:0016408": "C-acyltransferase activity",
  "GO:0016409": "palmitoyltransferase activity",
  "GO:0016410": "N-acyltransferase activity",
  "GO:0016411": "acylglycerol O-acyltransferase activity",
  "GO:0016412": "serine O-acyltransferase activity",
  "GO:0016413": "O-acetyltransferase activity",
  "GO:0016414": "O-octanoyltransferase activity",
  "GO:0016415": "octanoyltransferase activity",
  "GO:0016416": "O-palmitoyltransferase activity",
  "GO:0016417": "S-acyltransferase activity",
  "GO:0016418": "S-acetyltransferase activity",
  "GO:0016419": "S-malonyltransferase activity",
  "GO:0016420": "malonyltransferase activity",
  "GO:0016421": "CoA carboxylase activity",
  "GO:0016422": "mRNA (2'-O-methyladenosine-N6-)-methyltransferase activity",
  "GO:0016423": "tRNA (guanine) methyltransferase activity",
  "GO:0016426": "tRNA (adenine) methyltransferase activity",
  "GO:0016427": "tRNA (cytosine) methyltransferase activity",
  "GO:0016428": "tRNA (cytosine-5-)-methyltransferase activity",
  "GO:0016429": "tRNA (adenine-N1-)-methyltransferase activity",
  "GO:0016430": "tRNA (adenine-N6-)-methyltransferase activity",
  "GO:0016432": "tRNA-uridine aminocarboxypropyltransferase activity",
  "GO:0016433": "rRNA (adenine) methyltransferase activity",
  "GO:0016434": "rRNA (cytosine) methyltransferase activity",
  "GO:0016435": "rRNA (guanine) methyltransferase activity",
  "GO:0016436": "rRNA (uridine) methyltransferase activity",
  "GO:0016437": "tRNA cytidylyltransferase activity",
  "GO:0016438": "tRNA-queuosine beta-mannosyltransferase activity",
  "GO:0016441": "posttranscriptional gene silencing",
  "GO:0016442": "RISC complex",
  "GO:0016443": "bidentate ribonuclease III activity",
  "GO:0016444": "somatic cell DNA recombination",
  "GO:0016445": "somatic diversification of immunoglobulins",
  "GO:0016446": "somatic hypermutation of immunoglobulin genes",
  "GO:0016447": "somatic recombination of immunoglobulin gene segments",
  "GO:0016453": "C-acetyltransferase activity",
  "GO:0016454": "C-palmitoyltransferase activity",
  "GO:0016456": "X chromosome located dosage compensation complex, transcription activating",
  "GO:0016457": "dosage compensation complex assembly involved in dosage compensation by hyperactivation of X chromosome",
  "GO:0016458": "gene silencing",
  "GO:0016459": "myosin complex",
  "GO:0016460": "myosin II complex",
  "GO:0016461": "unconventional myosin complex",
  "GO:0016462": "pyrophosphatase activity",
  "GO:0016463": "zinc-exporting ATPase activity",
  "GO:0016464": "chloroplast protein-transporting ATPase activity",
  "GO:0016465": "chaperonin ATPase complex",
  "GO:0016466": "obsolete hydrogen-translocating A-type ATPase activity",
  "GO:0016467": "obsolete hydrogen-translocating F-type ATPase activity",
  "GO:0016468": "obsolete sodium-translocating F-type ATPase activity",
  "GO:0016469": "proton-transporting two-sector ATPase complex",
  "GO:0016471": "vacuolar proton-transporting V-type ATPase complex",
  "GO:0016472": "sodium ion-transporting two-sector ATPase complex",
  "GO:0016473": "sodium ion-transporting F-type ATPase complex",
  "GO:0016474": "sodium ion-transporting V-type ATPase complex",
  "GO:0016475": "detection of nuclear:cytoplasmic ratio",
  "GO:0016476": "regulation of embryonic cell shape",
  "GO:0016477": "cell migration",
  "GO:0016479": "negative regulation of transcription from RNA polymerase I promoter",
  "GO:0016480": "negative regulation of transcription from RNA polymerase III promoter",
  "GO:0016482": "cytosolic transport",
  "GO:0016483": "tryptophan hydroxylase activator activity",
  "GO:0016484": "obsolete proprotein convertase 2 activator activity",
  "GO:0016485": "protein processing",
  "GO:0016486": "peptide hormone processing",
  "GO:0016487": "farnesol metabolic process",
  "GO:0016488": "farnesol catabolic process",
  "GO:0016490": "structural constituent of peritrophic membrane",
  "GO:0016491": "oxidoreductase activity",
  "GO:0016492": "G-protein coupled neurotensin receptor activity",
  "GO:0016493": "C-C chemokine receptor activity",
  "GO:0016494": "C-X-C chemokine receptor activity",
  "GO:0016495": "C-X3-C chemokine receptor activity",
  "GO:0016496": "substance P receptor activity",
  "GO:0016497": "substance K receptor activity",
  "GO:0016498": "neuromedin K receptor activity",
  "GO:0016499": "orexin receptor activity",
  "GO:0016500": "protein-hormone receptor activity",
  "GO:0016501": "prostacyclin receptor activity",
  "GO:0016502": "nucleotide receptor activity",
  "GO:0016503": "pheromone receptor activity",
  "GO:0016504": "peptidase activator activity",
  "GO:0016505": "peptidase activator activity involved in apoptotic process",
  "GO:0016506": "obsolete apoptosis activator activity",
  "GO:0016507": "mitochondrial fatty acid beta-oxidation multienzyme complex",
  "GO:0016508": "long-chain-enoyl-CoA hydratase activity",
  "GO:0016509": "long-chain-3-hydroxyacyl-CoA dehydrogenase activity",
  "GO:0016511": "obsolete endothelin-converting enzyme activity",
  "GO:0016512": "obsolete endothelin-converting enzyme 1 activity",
  "GO:0016513": "core-binding factor complex",
  "GO:0016514": "SWI/SNF complex",
  "GO:0016515": "interleukin-13 receptor activity",
  "GO:0016516": "interleukin-4 receptor complex",
  "GO:0016517": "interleukin-12 receptor activity",
  "GO:0016518": "interleukin-14 receptor activity",
  "GO:0016519": "gastric inhibitory peptide receptor activity",
  "GO:0016520": "growth hormone-releasing hormone receptor activity",
  "GO:0016521": "pituitary adenylate cyclase activating polypeptide activity",
  "GO:0016524": "latrotoxin receptor activity",
  "GO:0016525": "negative regulation of angiogenesis",
  "GO:0016527": "obsolete brain-specific angiogenesis inhibitor activity",
  "GO:0016528": "sarcoplasm",
  "GO:0016529": "sarcoplasmic reticulum",
  "GO:0016530": "metallochaperone activity",
  "GO:0016531": "copper chaperone activity",
  "GO:0016532": "superoxide dismutase copper chaperone activity",
  "GO:0016533": "cyclin-dependent protein kinase 5 holoenzyme complex",
  "GO:0016534": "cyclin-dependent protein kinase 5 activator activity",
  "GO:0016536": "obsolete cyclin-dependent protein kinase 5 activator regulator activity",
  "GO:0016538": "cyclin-dependent protein serine/threonine kinase regulator activity",
  "GO:0016539": "intein-mediated protein splicing",
  "GO:0016540": "protein autoprocessing",
  "GO:0016541": "obsolete intein",
  "GO:0016543": "male courtship behavior, orientation prior to leg tapping and wing vibration",
  "GO:0016544": "male courtship behavior, tapping to detect pheromone",
  "GO:0016545": "male courtship behavior, veined wing vibration",
  "GO:0016546": "male courtship behavior, proboscis-mediated licking",
  "GO:0016550": "obsolete insertion or deletion editing",
  "GO:0016551": "obsolete posttranscriptional insertion or deletion editing",
  "GO:0016552": "obsolete cotranscriptional insertion or deletion editing",
  "GO:0016553": "base conversion or substitution editing",
  "GO:0016554": "cytidine to uridine editing",
  "GO:0016555": "uridine to cytidine editing",
  "GO:0016556": "mRNA modification",
  "GO:0016557": "peroxisome membrane biogenesis",
  "GO:0016558": "protein import into peroxisome matrix",
  "GO:0016559": "peroxisome fission",
  "GO:0016560": "protein import into peroxisome matrix, docking",
  "GO:0016561": "protein import into peroxisome matrix, translocation",
  "GO:0016562": "protein import into peroxisome matrix, receptor recycling",
  "GO:0016563": "obsolete transcription activator activity",
  "GO:0016564": "obsolete transcription repressor activity",
  "GO:0016565": "obsolete general transcriptional repressor activity",
  "GO:0016566": "obsolete specific transcriptional repressor activity",
  "GO:0016567": "protein ubiquitination",
  "GO:0016568": "chromatin modification",
  "GO:0016569": "covalent chromatin modification",
  "GO:0016570": "histone modification",
  "GO:0016571": "histone methylation",
  "GO:0016572": "histone phosphorylation",
  "GO:0016573": "histone acetylation",
  "GO:0016574": "histone ubiquitination",
  "GO:0016575": "histone deacetylation",
  "GO:0016576": "histone dephosphorylation",
  "GO:0016577": "histone demethylation",
  "GO:0016578": "histone deubiquitination",
  "GO:0016579": "protein deubiquitination",
  "GO:0016580": "Sin3 complex",
  "GO:0016581": "NuRD complex",
  "GO:0016582": "non-covalent chromatin modification",
  "GO:0016583": "obsolete nucleosome modeling",
  "GO:0016584": "nucleosome positioning",
  "GO:0016585": "obsolete chromatin remodeling complex",
  "GO:0016586": "RSC complex",
  "GO:0016587": "Isw1 complex",
  "GO:0016589": "NURF complex",
  "GO:0016590": "ACF complex",
  "GO:0016591": "DNA-directed RNA polymerase II, holoenzyme",
  "GO:0016592": "mediator complex",
  "GO:0016593": "Cdc73/Paf1 complex",
  "GO:0016594": "glycine binding",
  "GO:0016595": "glutamate binding",
  "GO:0016596": "thienylcyclohexylpiperidine binding",
  "GO:0016597": "amino acid binding",
  "GO:0016598": "protein arginylation",
  "GO:0016600": "flotillin complex",
  "GO:0016601": "Rac protein signal transduction",
  "GO:0016602": "CCAAT-binding factor complex",
  "GO:0016603": "glutaminyl-peptide cyclotransferase activity",
  "GO:0016604": "nuclear body",
  "GO:0016605": "PML body",
  "GO:0016606": "LYSP100-associated nuclear domain",
  "GO:0016607": "nuclear speck",
  "GO:0016608": "growth hormone-releasing hormone activity",
  "GO:0016610": "nitrogenase complex",
  "GO:0016611": "iron-iron nitrogenase complex",
  "GO:0016612": "molybdenum-iron nitrogenase complex",
  "GO:0016613": "vanadium-iron nitrogenase complex",
  "GO:0016614": "oxidoreductase activity, acting on CH-OH group of donors",
  "GO:0016615": "malate dehydrogenase activity",
  "GO:0016616": "oxidoreductase activity, acting on the CH-OH group of donors, NAD or NADP as acceptor",
  "GO:0016617": "4-oxoproline reductase activity",
  "GO:0016618": "hydroxypyruvate reductase activity",
  "GO:0016620": "oxidoreductase activity, acting on the aldehyde or oxo group of donors, NAD or NADP as acceptor",
  "GO:0016621": "cinnamoyl-CoA reductase activity",
  "GO:0016622": "oxidoreductase activity, acting on the aldehyde or oxo group of donors, cytochrome as acceptor",
  "GO:0016623": "oxidoreductase activity, acting on the aldehyde or oxo group of donors, oxygen as acceptor",
  "GO:0016624": "oxidoreductase activity, acting on the aldehyde or oxo group of donors, disulfide as acceptor",
  "GO:0016625": "oxidoreductase activity, acting on the aldehyde or oxo group of donors, iron-sulfur protein as acceptor",
  "GO:0016626": "obsolete oxidoreductase activity, acting on the aldehyde or oxo group of donors, other acceptors",
  "GO:0016627": "oxidoreductase activity, acting on the CH-CH group of donors",
  "GO:0016628": "oxidoreductase activity, acting on the CH-CH group of donors, NAD or NADP as acceptor",
  "GO:0016629": "12-oxophytodienoate reductase activity",
  "GO:0016630": "protochlorophyllide reductase activity",
  "GO:0016631": "enoyl-[acyl-carrier-protein] reductase activity",
  "GO:0016632": "oxidoreductase activity, acting on the CH-CH group of donors, cytochrome as acceptor",
  "GO:0016633": "galactonolactone dehydrogenase activity",
  "GO:0016634": "oxidoreductase activity, acting on the CH-CH group of donors, oxygen as acceptor",
  "GO:0016635": "oxidoreductase activity, acting on the CH-CH group of donors, quinone or related compound as acceptor",
  "GO:0016636": "oxidoreductase activity, acting on the CH-CH group of donors, iron-sulfur protein as acceptor",
  "GO:0016637": "obsolete oxidoreductase activity, acting on the CH-CH group of donors, other acceptors",
  "GO:0016638": "oxidoreductase activity, acting on the CH-NH2 group of donors",
  "GO:0016639": "oxidoreductase activity, acting on the CH-NH2 group of donors, NAD or NADP as acceptor",
  "GO:0016640": "oxidoreductase activity, acting on the CH-NH2 group of donors, cytochrome as acceptor",
  "GO:0016641": "oxidoreductase activity, acting on the CH-NH2 group of donors, oxygen as acceptor",
  "GO:0016642": "oxidoreductase activity, acting on the CH-NH2 group of donors, disulfide as acceptor",
  "GO:0016643": "oxidoreductase activity, acting on the CH-NH2 group of donors, iron-sulfur protein as acceptor",
  "GO:0016644": "obsolete oxidoreductase activity, acting on the CH-NH2 group of donors, other acceptors",
  "GO:0016645": "oxidoreductase activity, acting on the CH-NH group of donors",
  "GO:0016646": "oxidoreductase activity, acting on the CH-NH group of donors, NAD or NADP as acceptor",
  "GO:0016647": "oxidoreductase activity, acting on the CH-NH group of donors, oxygen as acceptor",
  "GO:0016648": "oxidoreductase activity, acting on the CH-NH group of donors, disulfide as acceptor",
  "GO:0016649": "oxidoreductase activity, acting on the CH-NH group of donors, quinone or similar compound as acceptor",
  "GO:0016650": "obsolete oxidoreductase activity, acting on the CH-NH group of donors, other acceptors",
  "GO:0016651": "oxidoreductase activity, acting on NAD(P)H",
  "GO:0016652": "oxidoreductase activity, acting on NAD(P)H, NAD(P) as acceptor",
  "GO:0016653": "oxidoreductase activity, acting on NAD(P)H, heme protein as acceptor",
  "GO:0016655": "oxidoreductase activity, acting on NAD(P)H, quinone or similar compound as acceptor",
  "GO:0016656": "monodehydroascorbate reductase (NADH) activity",
  "GO:0016657": "oxidoreductase activity, acting on NAD(P)H, nitrogenous group as acceptor",
  "GO:0016658": "obsolete oxidoreductase activity, acting on NADH or NADPH, flavin as acceptor",
  "GO:0016659": "obsolete oxidoreductase activity, acting on NADH or NADPH, other acceptor",
  "GO:0016661": "oxidoreductase activity, acting on other nitrogenous compounds as donors",
  "GO:0016662": "oxidoreductase activity, acting on other nitrogenous compounds as donors, cytochrome as acceptor",
  "GO:0016663": "oxidoreductase activity, acting on other nitrogenous compounds as donors, oxygen as acceptor",
  "GO:0016664": "oxidoreductase activity, acting on other nitrogenous compounds as donors, iron-sulfur protein as acceptor",
  "GO:0016665": "obsolete oxidoreductase activity, acting on other nitrogenous compounds as donors, other acceptors",
  "GO:0016667": "oxidoreductase activity, acting on a sulfur group of donors",
  "GO:0016668": "oxidoreductase activity, acting on a sulfur group of donors, NAD(P) as acceptor",
  "GO:0016669": "oxidoreductase activity, acting on a sulfur group of donors, cytochrome as acceptor",
  "GO:0016670": "oxidoreductase activity, acting on a sulfur group of donors, oxygen as acceptor",
  "GO:0016671": "oxidoreductase activity, acting on a sulfur group of donors, disulfide as acceptor",
  "GO:0016672": "oxidoreductase activity, acting on a sulfur group of donors, quinone or similar compound as acceptor",
  "GO:0016673": "oxidoreductase activity, acting on a sulfur group of donors, iron-sulfur protein as acceptor",
  "GO:0016674": "obsolete oxidoreductase activity, acting on sulfur group of donors, other acceptors",
  "GO:0016675": "oxidoreductase activity, acting on a heme group of donors",
  "GO:0016676": "oxidoreductase activity, acting on a heme group of donors, oxygen as acceptor",
  "GO:0016677": "oxidoreductase activity, acting on a heme group of donors, nitrogenous group as acceptor",
  "GO:0016678": "obsolete oxidoreductase activity, acting on heme group of donors, other acceptors",
  "GO:0016679": "oxidoreductase activity, acting on diphenols and related substances as donors",
  "GO:0016680": "oxidoreductase activity, acting on diphenols and related substances as donors, NAD or NADP as acceptor",
  "GO:0016681": "oxidoreductase activity, acting on diphenols and related substances as donors, cytochrome as acceptor",
  "GO:0016682": "oxidoreductase activity, acting on diphenols and related substances as donors, oxygen as acceptor",
  "GO:0016683": "obsolete oxidoreductase activity, acting on diphenols and related substances as donors, other acceptors",
  "GO:0016684": "oxidoreductase activity, acting on peroxide as acceptor",
  "GO:0016688": "L-ascorbate peroxidase activity",
  "GO:0016689": "manganese peroxidase activity",
  "GO:0016690": "diarylpropane peroxidase activity",
  "GO:0016691": "chloride peroxidase activity",
  "GO:0016692": "NADH peroxidase activity",
  "GO:0016694": "obsolete bacterial catalase-peroxidase activity",
  "GO:0016695": "oxidoreductase activity, acting on hydrogen as donor",
  "GO:0016696": "oxidoreductase activity, acting on hydrogen as donor, NAD or NADP as acceptor",
  "GO:0016697": "oxidoreductase activity, acting on hydrogen as donor, cytochrome as acceptor",
  "GO:0016699": "oxidoreductase activity, acting on hydrogen as donor, iron-sulfur protein as acceptor",
  "GO:0016700": "obsolete oxidoreductase activity, acting on hydrogen as donor, other acceptors",
  "GO:0016701": "oxidoreductase activity, acting on single donors with incorporation of molecular oxygen",
  "GO:0016702": "oxidoreductase activity, acting on single donors with incorporation of molecular oxygen, incorporation of two atoms of oxygen",
  "GO:0016703": "oxidoreductase activity, acting on single donors with incorporation of molecular oxygen, incorporation of one atom of oxygen (internal monooxygenases or internal mixed function oxidases)",
  "GO:0016704": "obsolete oxidoreductase activity, acting on single donors with incorporation of molecular oxygen, miscellaneous",
  "GO:0016705": "oxidoreductase activity, acting on paired donors, with incorporation or reduction of molecular oxygen",
  "GO:0016706": "oxidoreductase activity, acting on paired donors, with incorporation or reduction of molecular oxygen, 2-oxoglutarate as one donor, and incorporation of one atom each of oxygen into both donors",
  "GO:0016707": "gibberellin 3-beta-dioxygenase activity",
  "GO:0016708": "oxidoreductase activity, acting on paired donors, with incorporation or reduction of molecular oxygen, NAD(P)H as one donor, and incorporation of two atoms of oxygen into one donor",
  "GO:0016709": "oxidoreductase activity, acting on paired donors, with incorporation or reduction of molecular oxygen, NAD(P)H as one donor, and incorporation of one atom of oxygen",
  "GO:0016710": "trans-cinnamate 4-monooxygenase activity",
  "GO:0016711": "flavonoid 3'-monooxygenase activity",
  "GO:0016712": "oxidoreductase activity, acting on paired donors, with incorporation or reduction of molecular oxygen, reduced flavin or flavoprotein as one donor, and incorporation of one atom of oxygen",
  "GO:0016713": "oxidoreductase activity, acting on paired donors, with incorporation or reduction of molecular oxygen, reduced iron-sulfur protein as one donor, and incorporation of one atom of oxygen",
  "GO:0016714": "oxidoreductase activity, acting on paired donors, with incorporation or reduction of molecular oxygen, reduced pteridine as one donor, and incorporation of one atom of oxygen",
  "GO:0016715": "oxidoreductase activity, acting on paired donors, with incorporation or reduction of molecular oxygen, reduced ascorbate as one donor, and incorporation of one atom of oxygen",
  "GO:0016716": "oxidoreductase activity, acting on paired donors, with incorporation or reduction of molecular oxygen, another compound as one donor, and incorporation of one atom of oxygen",
  "GO:0016717": "oxidoreductase activity, acting on paired donors, with oxidation of a pair of donors resulting in the reduction of molecular oxygen to two molecules of water",
  "GO:0016718": "obsolete oxidoreductase activity, acting on paired donors, with incorporation or reduction of molecular oxygen, miscellaneous",
  "GO:0016719": "carotene 7,8-desaturase activity",
  "GO:0016720": "delta12-fatty acid dehydrogenase activity",
  "GO:0016721": "oxidoreductase activity, acting on superoxide radicals as acceptor",
  "GO:0016722": "oxidoreductase activity, oxidizing metal ions",
  "GO:0016723": "oxidoreductase activity, oxidizing metal ions, NAD or NADP as acceptor",
  "GO:0016724": "oxidoreductase activity, oxidizing metal ions, oxygen as acceptor",
  "GO:0016725": "oxidoreductase activity, acting on CH or CH2 groups",
  "GO:0016726": "oxidoreductase activity, acting on CH or CH2 groups, NAD or NADP as acceptor",
  "GO:0016727": "oxidoreductase activity, acting on CH or CH2 groups, oxygen as acceptor",
  "GO:0016728": "oxidoreductase activity, acting on CH or CH2 groups, disulfide as acceptor",
  "GO:0016729": "obsolete oxidoreductase activity, acting on CH2 groups, other acceptors",
  "GO:0016730": "oxidoreductase activity, acting on iron-sulfur proteins as donors",
  "GO:0016731": "oxidoreductase activity, acting on iron-sulfur proteins as donors, NAD or NADP as acceptor",
  "GO:0016732": "oxidoreductase activity, acting on iron-sulfur proteins as donors, dinitrogen as acceptor",
  "GO:0016733": "obsolete iron-iron nitrogenase activity",
  "GO:0016734": "obsolete molybdenum-iron nitrogenase activity",
  "GO:0016735": "obsolete vanadium-iron nitrogenase activity",
  "GO:0016737": "oxidoreductase activity, acting on reduced flavodoxin as donor",
  "GO:0016738": "oxidoreductase activity, acting on reduced flavodoxin as donor, dinitrogen as acceptor",
  "GO:0016739": "obsolete oxidoreductase activity, acting on other substrates",
  "GO:0016740": "transferase activity",
  "GO:0016741": "transferase activity, transferring one-carbon groups",
  "GO:0016742": "hydroxymethyl-, formyl- and related transferase activity",
  "GO:0016743": "carboxyl- or carbamoyltransferase activity",
  "GO:0016744": "transferase activity, transferring aldehyde or ketonic groups",
  "GO:0016746": "transferase activity, transferring acyl groups",
  "GO:0016747": "transferase activity, transferring acyl groups other than amino-acyl groups",
  "GO:0016748": "succinyltransferase activity",
  "GO:0016749": "N-succinyltransferase activity",
  "GO:0016750": "O-succinyltransferase activity",
  "GO:0016751": "S-succinyltransferase activity",
  "GO:0016752": "sinapoyltransferase activity",
  "GO:0016753": "O-sinapoyltransferase activity",
  "GO:0016754": "sinapoylglucose-malate O-sinapoyltransferase activity",
  "GO:0016755": "transferase activity, transferring amino-acyl groups",
  "GO:0016756": "glutathione gamma-glutamylcysteinyltransferase activity",
  "GO:0016757": "transferase activity, transferring glycosyl groups",
  "GO:0016758": "transferase activity, transferring hexosyl groups",
  "GO:0016759": "cellulose synthase activity",
  "GO:0016760": "cellulose synthase (UDP-forming) activity",
  "GO:0016761": "cellulose synthase (GDP-forming) activity",
  "GO:0016762": "xyloglucan:xyloglucosyl transferase activity",
  "GO:0016763": "transferase activity, transferring pentosyl groups",
  "GO:0016764": "obsolete transferase activity, transferring other glycosyl groups",
  "GO:0016765": "transferase activity, transferring alkyl or aryl (other than methyl) groups",
  "GO:0016767": "geranylgeranyl-diphosphate geranylgeranyltransferase activity",
  "GO:0016768": "spermine synthase activity",
  "GO:0016769": "transferase activity, transferring nitrogenous groups",
  "GO:0016770": "oximinotransaminase activity",
  "GO:0016771": "obsolete transferase activity, transferring other nitrogenous groups",
  "GO:0016772": "transferase activity, transferring phosphorus-containing groups",
  "GO:0016773": "phosphotransferase activity, alcohol group as acceptor",
  "GO:0016774": "phosphotransferase activity, carboxyl group as acceptor",
  "GO:0016775": "phosphotransferase activity, nitrogenous group as acceptor",
  "GO:0016776": "phosphotransferase activity, phosphate group as acceptor",
  "GO:0016778": "diphosphotransferase activity",
  "GO:0016779": "nucleotidyltransferase activity",
  "GO:0016780": "phosphotransferase activity, for other substituted phosphate groups",
  "GO:0016781": "phosphotransferase activity, paired acceptors",
  "GO:0016782": "transferase activity, transferring sulfur-containing groups",
  "GO:0016783": "sulfurtransferase activity",
  "GO:0016784": "3-mercaptopyruvate sulfurtransferase activity",
  "GO:0016785": "transferase activity, transferring selenium-containing groups",
  "GO:0016787": "hydrolase activity",
  "GO:0016788": "hydrolase activity, acting on ester bonds",
  "GO:0016790": "thiolester hydrolase activity",
  "GO:0016791": "phosphatase activity",
  "GO:0016793": "triphosphoric monoester hydrolase activity",
  "GO:0016794": "diphosphoric monoester hydrolase activity",
  "GO:0016795": "phosphoric triester hydrolase activity",
  "GO:0016796": "exonuclease activity, active with either ribo- or deoxyribonucleic acids and producing 5'-phosphomonoesters",
  "GO:0016797": "exonuclease activity, active with either ribo- or deoxyribonucleic acids and producing 3'-phosphomonoesters",
  "GO:0016798": "hydrolase activity, acting on glycosyl bonds",
  "GO:0016799": "hydrolase activity, hydrolyzing N-glycosyl compounds",
  "GO:0016801": "hydrolase activity, acting on ether bonds",
  "GO:0016802": "trialkylsulfonium hydrolase activity",
  "GO:0016803": "ether hydrolase activity",
  "GO:0016804": "obsolete prolyl aminopeptidase activity",
  "GO:0016805": "dipeptidase activity",
  "GO:0016806": "obsolete dipeptidyl-peptidase and tripeptidyl-peptidase activity",
  "GO:0016807": "cysteine-type carboxypeptidase activity",
  "GO:0016808": "obsolete proprotein convertase activity",
  "GO:0016810": "hydrolase activity, acting on carbon-nitrogen (but not peptide) bonds",
  "GO:0016811": "hydrolase activity, acting on carbon-nitrogen (but not peptide) bonds, in linear amides",
  "GO:0016812": "hydrolase activity, acting on carbon-nitrogen (but not peptide) bonds, in cyclic amides",
  "GO:0016813": "hydrolase activity, acting on carbon-nitrogen (but not peptide) bonds, in linear amidines",
  "GO:0016814": "hydrolase activity, acting on carbon-nitrogen (but not peptide) bonds, in cyclic amidines",
  "GO:0016815": "hydrolase activity, acting on carbon-nitrogen (but not peptide) bonds, in nitriles",
  "GO:0016816": "obsolete hydrolase activity, acting on carbon-nitrogen (but not peptide) bonds, in other compounds",
  "GO:0016817": "hydrolase activity, acting on acid anhydrides",
  "GO:0016818": "hydrolase activity, acting on acid anhydrides, in phosphorus-containing anhydrides",
  "GO:0016819": "hydrolase activity, acting on acid anhydrides, in sulfonyl-containing anhydrides",
  "GO:0016820": "hydrolase activity, acting on acid anhydrides, catalyzing transmembrane movement of substances",
  "GO:0016821": "obsolete hydrolase activity, acting on acid anhydrides, involved in cellular and subcellular movement",
  "GO:0016822": "hydrolase activity, acting on acid carbon-carbon bonds",
  "GO:0016823": "hydrolase activity, acting on acid carbon-carbon bonds, in ketonic substances",
  "GO:0016824": "hydrolase activity, acting on acid halide bonds",
  "GO:0016825": "hydrolase activity, acting on acid phosphorus-nitrogen bonds",
  "GO:0016826": "hydrolase activity, acting on acid sulfur-nitrogen bonds",
  "GO:0016827": "hydrolase activity, acting on acid carbon-phosphorus bonds",
  "GO:0016828": "hydrolase activity, acting on acid sulfur-sulfur bonds",
  "GO:0016829": "lyase activity",
  "GO:0016830": "carbon-carbon lyase activity",
  "GO:0016831": "carboxy-lyase activity",
  "GO:0016832": "aldehyde-lyase activity",
  "GO:0016833": "oxo-acid-lyase activity",
  "GO:0016834": "obsolete other carbon-carbon lyase activity",
  "GO:0016835": "carbon-oxygen lyase activity",
  "GO:0016836": "hydro-lyase activity",
  "GO:0016837": "carbon-oxygen lyase activity, acting on polysaccharides",
  "GO:0016838": "carbon-oxygen lyase activity, acting on phosphates",
  "GO:0016839": "obsolete other carbon-oxygen lyase activity",
  "GO:0016840": "carbon-nitrogen lyase activity",
  "GO:0016841": "ammonia-lyase activity",
  "GO:0016842": "amidine-lyase activity",
  "GO:0016843": "amine-lyase activity",
  "GO:0016844": "strictosidine synthase activity",
  "GO:0016845": "obsolete other carbon-nitrogen lyase activity",
  "GO:0016846": "carbon-sulfur lyase activity",
  "GO:0016847": "1-aminocyclopropane-1-carboxylate synthase activity",
  "GO:0016848": "carbon-halide lyase activity",
  "GO:0016849": "phosphorus-oxygen lyase activity",
  "GO:0016850": "obsolete other lyase activity",
  "GO:0016851": "magnesium chelatase activity",
  "GO:0016852": "sirohydrochlorin cobaltochelatase activity",
  "GO:0016853": "isomerase activity",
  "GO:0016854": "racemase and epimerase activity",
  "GO:0016855": "racemase and epimerase activity, acting on amino acids and derivatives",
  "GO:0016856": "racemase and epimerase activity, acting on hydroxy acids and derivatives",
  "GO:0016857": "racemase and epimerase activity, acting on carbohydrates and derivatives",
  "GO:0016858": "obsolete racemase and epimerase activity, acting on other compounds",
  "GO:0016859": "cis-trans isomerase activity",
  "GO:0016860": "intramolecular oxidoreductase activity",
  "GO:0016861": "intramolecular oxidoreductase activity, interconverting aldoses and ketoses",
  "GO:0016862": "intramolecular oxidoreductase activity, interconverting keto- and enol-groups",
  "GO:0016863": "intramolecular oxidoreductase activity, transposing C=C bonds",
  "GO:0016864": "intramolecular oxidoreductase activity, transposing S-S bonds",
  "GO:0016865": "obsolete intramolecular oxidoreductase activity, other intramolecular oxidoreductases",
  "GO:0016866": "intramolecular transferase activity",
  "GO:0016867": "intramolecular transferase activity, transferring acyl groups",
  "GO:0016868": "intramolecular transferase activity, phosphotransferases",
  "GO:0016869": "intramolecular transferase activity, transferring amino groups",
  "GO:0016870": "obsolete intramolecular transferase activity, transferring other groups",
  "GO:0016871": "cycloartenol synthase activity",
  "GO:0016872": "intramolecular lyase activity",
  "GO:0016873": "obsolete other isomerase activity",
  "GO:0016874": "ligase activity",
  "GO:0016875": "ligase activity, forming carbon-oxygen bonds",
  "GO:0016876": "ligase activity, forming aminoacyl-tRNA and related compounds",
  "GO:0016877": "ligase activity, forming carbon-sulfur bonds",
  "GO:0016878": "acid-thiol ligase activity",
  "GO:0016879": "ligase activity, forming carbon-nitrogen bonds",
  "GO:0016880": "acid-ammonia (or amide) ligase activity",
  "GO:0016881": "acid-amino acid ligase activity",
  "GO:0016882": "cyclo-ligase activity",
  "GO:0016883": "obsolete other carbon-nitrogen ligase activity",
  "GO:0016884": "carbon-nitrogen ligase activity, with glutamine as amido-N-donor",
  "GO:0016885": "ligase activity, forming carbon-carbon bonds",
  "GO:0016886": "ligase activity, forming phosphoric ester bonds",
  "GO:0016887": "ATPase activity",
  "GO:0016888": "endodeoxyribonuclease activity, producing 5'-phosphomonoesters",
  "GO:0016889": "endodeoxyribonuclease activity, producing 3'-phosphomonoesters",
  "GO:0016890": "site-specific endodeoxyribonuclease activity, specific for altered base",
  "GO:0016891": "endoribonuclease activity, producing 5'-phosphomonoesters",
  "GO:0016892": "endoribonuclease activity, producing 3'-phosphomonoesters",
  "GO:0016893": "endonuclease activity, active with either ribo- or deoxyribonucleic acids and producing 5'-phosphomonoesters",
  "GO:0016894": "endonuclease activity, active with either ribo- or deoxyribonucleic acids and producing 3'-phosphomonoesters",
  "GO:0016895": "exodeoxyribonuclease activity, producing 5'-phosphomonoesters",
  "GO:0016896": "exoribonuclease activity, producing 5'-phosphomonoesters",
  "GO:0016897": "exoribonuclease activity, producing 3'-phosphomonoesters",
  "GO:0016898": "oxidoreductase activity, acting on the CH-OH group of donors, cytochrome as acceptor",
  "GO:0016899": "oxidoreductase activity, acting on the CH-OH group of donors, oxygen as acceptor",
  "GO:0016900": "oxidoreductase activity, acting on the CH-OH group of donors, disulfide as acceptor",
  "GO:0016901": "oxidoreductase activity, acting on the CH-OH group of donors, quinone or similar compound as acceptor",
  "GO:0016902": "obsolete oxidoreductase activity, acting on the CH-OH group of donors, other acceptors",
  "GO:0016903": "oxidoreductase activity, acting on the aldehyde or oxo group of donors",
  "GO:0016905": "myosin heavy chain kinase activity",
  "GO:0016906": "sterol 3-beta-glucosyltransferase activity",
  "GO:0016907": "G-protein coupled acetylcholine receptor activity",
  "GO:0016909": "SAP kinase activity",
  "GO:0016910": "obsolete SAP kinase 3 activity",
  "GO:0016911": "obsolete SAP kinase 4 activity",
  "GO:0016912": "obsolete SAP kinase 5 activity",
  "GO:0016913": "follicle-stimulating hormone activity",
  "GO:0016914": "follicle-stimulating hormone complex",
  "GO:0016915": "obsolete activin",
  "GO:0016916": "obsolete inhibin",
  "GO:0016917": "GABA receptor activity",
  "GO:0016918": "retinal binding",
  "GO:0016919": "obsolete nardilysin activity",
  "GO:0016920": "pyroglutamyl-peptidase activity",
  "GO:0016921": "obsolete pyroglutamyl-peptidase II activity",
  "GO:0016922": "ligand-dependent nuclear receptor binding",
  "GO:0016923": "obsolete ligand-dependent thyroid hormone receptor interactor activity",
  "GO:0016925": "protein sumoylation",
  "GO:0016926": "protein desumoylation",
  "GO:0016929": "SUMO-specific protease activity",
  "GO:0016933": "extracellular-glycine-gated ion channel activity",
  "GO:0016934": "extracellular-glycine-gated chloride channel activity",
  "GO:0016935": "glycine-gated chloride channel complex",
  "GO:0016936": "galactoside binding",
  "GO:0016937": "short-branched-chain-acyl-CoA dehydrogenase activity",
  "GO:0016938": "kinesin I complex",
  "GO:0016939": "kinesin II complex",
  "GO:0016941": "natriuretic peptide receptor activity",
  "GO:0016942": "insulin-like growth factor binding protein complex",
  "GO:0016943": "obsolete RNA polymerase I transcription elongation factor activity",
  "GO:0016944": "obsolete RNA polymerase II transcription elongation factor activity",
  "GO:0016945": "obsolete RNA polymerase III transcription elongation factor activity",
  "GO:0016946": "obsolete cathepsin F activity",
  "GO:0016962": "obsolete receptor-associated protein activity",
  "GO:0016963": "obsolete alpha-2 macroglobulin receptor-associated protein activity",
  "GO:0016964": "alpha-2 macroglobulin receptor activity",
  "GO:0016966": "nitric oxide reductase activity",
  "GO:0016969": "obsolete hemerythrin",
  "GO:0016970": "obsolete hemocyanin",
  "GO:0016971": "flavin-linked sulfhydryl oxidase activity",
  "GO:0016972": "thiol oxidase activity",
  "GO:0016973": "poly(A)+ mRNA export from nucleus",
  "GO:0016975": "obsolete alpha-2 macroglobulin",
  "GO:0016977": "chitosanase activity",
  "GO:0016979": "lipoate-protein ligase activity",
  "GO:0016980": "creatinase activity",
  "GO:0016984": "ribulose-bisphosphate carboxylase activity",
  "GO:0016985": "mannan endo-1,4-beta-mannosidase activity",
  "GO:0016986": "obsolete transcription initiation factor activity",
  "GO:0016987": "sigma factor activity",
  "GO:0016988": "obsolete transcription initiation factor antagonist activity",
  "GO:0016989": "sigma factor antagonist activity",
  "GO:0016990": "arginine deiminase activity",
  "GO:0016992": "lipoate synthase activity",
  "GO:0016993": "precorrin-8X methylmutase activity",
  "GO:0016994": "precorrin-6A reductase activity",
  "GO:0016995": "cholesterol oxidase activity",
  "GO:0016996": "endo-alpha-(2,8)-sialidase activity",
  "GO:0016997": "alpha-sialidase activity",
  "GO:0016998": "cell wall macromolecule catabolic process",
  "GO:0016999": "antibiotic metabolic process",
  "GO:0017000": "antibiotic biosynthetic process",
  "GO:0017001": "antibiotic catabolic process",
  "GO:0017002": "activin-activated receptor activity",
  "GO:0017003": "protein-heme linkage",
  "GO:0017004": "cytochrome complex assembly",
  "GO:0017005": "3'-tyrosyl-DNA phosphodiesterase activity",
  "GO:0017006": "protein-tetrapyrrole linkage",
  "GO:0017007": "protein-bilin linkage",
  "GO:0017008": "protein-phycobiliviolin linkage",
  "GO:0017009": "protein-phycocyanobilin linkage",
  "GO:0017010": "protein-phycourobilin linkage",
  "GO:0017011": "protein-phycoerythrobilin linkage",
  "GO:0017012": "protein-phytochromobilin linkage",
  "GO:0017013": "protein flavinylation",
  "GO:0017014": "protein nitrosylation",
  "GO:0017015": "regulation of transforming growth factor beta receptor signaling pathway",
  "GO:0017016": "Ras GTPase binding",
  "GO:0017017": "MAP kinase tyrosine/serine/threonine phosphatase activity",
  "GO:0017018": "myosin phosphatase activity",
  "GO:0017020": "myosin phosphatase regulator activity",
  "GO:0017021": "obsolete myosin phosphatase myosin binding",
  "GO:0017022": "myosin binding",
  "GO:0017023": "myosin phosphatase complex",
  "GO:0017024": "myosin I binding",
  "GO:0017025": "TBP-class protein binding",
  "GO:0017026": "obsolete procollagen C-endopeptidase activity",
  "GO:0017027": "obsolete transmembrane receptor protein serine/threonine kinase receptor-associated protein activity",
  "GO:0017028": "obsolete protein stabilization activity",
  "GO:0017029": "obsolete lysosomal protein stabilization",
  "GO:0017030": "obsolete beta-galactosidase stabilization activity",
  "GO:0017032": "potassium:amino acid symporter activity",
  "GO:0017034": "Rap guanyl-nucleotide exchange factor activity",
  "GO:0017038": "protein import",
  "GO:0017039": "obsolete dipeptidyl-peptidase III activity",
  "GO:0017040": "ceramidase activity",
  "GO:0017041": "galactosylgalactosylglucosylceramidase activity",
  "GO:0017042": "glycosylceramidase activity",
  "GO:0017043": "obsolete adrenocorticotropin",
  "GO:0017044": "melanocyte-stimulating hormone activity",
  "GO:0017045": "corticotropin-releasing hormone activity",
  "GO:0017046": "peptide hormone binding",
  "GO:0017048": "Rho GTPase binding",
  "GO:0017049": "GTP-Rho binding",
  "GO:0017050": "D-erythro-sphingosine kinase activity",
  "GO:0017051": "retinol dehydratase activity",
  "GO:0017052": "obsolete insulin-like growth factor binding protein",
  "GO:0017053": "transcriptional repressor complex",
  "GO:0017054": "negative cofactor 2 complex",
  "GO:0017055": "negative regulation of RNA polymerase II transcriptional preinitiation complex assembly",
  "GO:0017056": "structural constituent of nuclear pore",
  "GO:0017057": "6-phosphogluconolactonase activity",
  "GO:0017058": "FH1 domain binding",
  "GO:0017059": "serine C-palmitoyltransferase complex",
  "GO:0017060": "3-galactosyl-N-acetylglucosaminide 4-alpha-L-fucosyltransferase activity",
  "GO:0017061": "S-methyl-5-thioadenosine phosphorylase activity",
  "GO:0017062": "respiratory chain complex III assembly",
  "GO:0017063": "obsolete phosphatidylserine-specific phospholipase A1 activity",
  "GO:0017064": "fatty acid amide hydrolase activity",
  "GO:0017065": "single-strand selective uracil DNA N-glycosylase activity",
  "GO:0017067": "tyrosine-ester sulfotransferase activity",
  "GO:0017069": "snRNA binding",
  "GO:0017070": "U6 snRNA binding",
  "GO:0017071": "intracellular cyclic nucleotide activated cation channel complex",
  "GO:0017072": "obsolete tubulin-specific chaperone activity",
  "GO:0017074": "obsolete procollagen N-endopeptidase activity",
  "GO:0017075": "syntaxin-1 binding",
  "GO:0017076": "purine nucleotide binding",
  "GO:0017077": "oxidative phosphorylation uncoupler activity",
  "GO:0017078": "obsolete Hsc70 protein regulator activity",
  "GO:0017080": "sodium channel regulator activity",
  "GO:0017081": "chloride channel regulator activity",
  "GO:0017082": "mineralocorticoid receptor activity",
  "GO:0017083": "4-galactosyl-N-acetylglucosaminide 3-alpha-L-fucosyltransferase activity",
  "GO:0017084": "delta1-pyrroline-5-carboxylate synthetase activity",
  "GO:0017085": "response to insecticide",
  "GO:0017086": "3-methyl-2-oxobutanoate dehydrogenase (lipoamide) complex",
  "GO:0017087": "mitochondrial processing peptidase complex",
  "GO:0017088": "obsolete X-Pro dipeptidyl-peptidase activity",
  "GO:0017089": "glycolipid transporter activity",
  "GO:0017090": "meprin A complex",
  "GO:0017091": "AU-rich element binding",
  "GO:0017092": "obsolete sterol regulatory element-binding protein site 2 protease activity",
  "GO:0017093": "obsolete sterol regulatory element-binding protein protease activity",
  "GO:0017094": "obsolete sterol regulatory element-binding protein site 1 protease activity",
  "GO:0017095": "heparan sulfate 6-O-sulfotransferase activity",
  "GO:0017096": "acetylserotonin O-methyltransferase activity",
  "GO:0017098": "sulfonylurea receptor binding",
  "GO:0017099": "very-long-chain-acyl-CoA dehydrogenase activity",
  "GO:0017101": "aminoacyl-tRNA synthetase multienzyme complex",
  "GO:0017102": "methionyl glutamyl tRNA synthetase complex",
  "GO:0017103": "UTP:galactose-1-phosphate uridylyltransferase activity",
  "GO:0017105": "acyl-CoA delta11-desaturase activity",
  "GO:0017106": "obsolete activin inhibitor activity",
  "GO:0017107": "anion exchanger adaptor activity",
  "GO:0017108": "5'-flap endonuclease activity",
  "GO:0017109": "glutamate-cysteine ligase complex",
  "GO:0017110": "nucleoside-diphosphatase activity",
  "GO:0017111": "nucleoside-triphosphatase activity",
  "GO:0017112": "Rab guanyl-nucleotide exchange factor activity",
  "GO:0017113": "dihydropyrimidine dehydrogenase (NADP+) activity",
  "GO:0017114": "obsolete wide-spectrum protease inhibitor activity",
  "GO:0017116": "single-stranded DNA-dependent ATP-dependent DNA helicase activity",
  "GO:0017117": "single-stranded DNA-dependent ATP-dependent DNA helicase complex",
  "GO:0017118": "lipoyltransferase activity",
  "GO:0017119": "Golgi transport complex",
  "GO:0017120": "obsolete polyphosphatidylinositol phosphatase activity",
  "GO:0017121": "phospholipid scrambling",
  "GO:0017122": "protein N-acetylglucosaminyltransferase complex",
  "GO:0017124": "SH3 domain binding",
  "GO:0017125": "deoxycytidyl transferase activity",
  "GO:0017126": "nucleologenesis",
  "GO:0017127": "cholesterol transporter activity",
  "GO:0017128": "phospholipid scramblase activity",
  "GO:0017129": "triglyceride binding",
  "GO:0017130": "poly(C) RNA binding",
  "GO:0017131": "uridine-rich cytoplasmic polyadenylylation element binding",
  "GO:0017132": "cyclic nucleotide-dependent guanyl-nucleotide exchange factor activity",
  "GO:0017133": "mitochondrial electron transfer flavoprotein complex",
  "GO:0017134": "fibroblast growth factor binding",
  "GO:0017135": "obsolete membrane-associated protein with guanylate kinase activity interacting",
  "GO:0017136": "NAD-dependent histone deacetylase activity",
  "GO:0017137": "Rab GTPase binding",
  "GO:0017139": "obsolete arsenate sensitivity/resistance",
  "GO:0017141": "obsolete antibiotic susceptibility/resistance",
  "GO:0017142": "obsolete toxin susceptibility/resistance",
  "GO:0017143": "insecticide metabolic process",
  "GO:0017144": "drug metabolic process",
  "GO:0017145": "stem cell division",
  "GO:0017146": "NMDA selective glutamate receptor complex",
  "GO:0017147": "Wnt-protein binding",
  "GO:0017148": "negative regulation of translation",
  "GO:0017149": "obsolete protein biosynthetic process inhibitor activity",
  "GO:0017150": "tRNA dihydrouridine synthase activity",
  "GO:0017151": "DEAD/H-box RNA helicase binding",
  "GO:0017153": "sodium:dicarboxylate symporter activity",
  "GO:0017154": "semaphorin receptor activity",
  "GO:0017155": "obsolete sodium:hydrogen antiporter regulator activity",
  "GO:0017156": "calcium ion regulated exocytosis",
  "GO:0017157": "regulation of exocytosis",
  "GO:0017158": "regulation of calcium ion-dependent exocytosis",
  "GO:0017159": "pantetheine hydrolase activity",
  "GO:0017160": "Ral GTPase binding",
  "GO:0017161": "inositol-1,3,4-trisphosphate 4-phosphatase activity",
  "GO:0017162": "aryl hydrocarbon receptor binding",
  "GO:0017163": "obsolete basal transcription repressor activity",
  "GO:0017164": "obsolete nicotinic acetylcholine receptor-associated protein activity",
  "GO:0017165": "obsolete dipeptidase E activity",
  "GO:0017166": "vinculin binding",
  "GO:0017168": "5-oxoprolinase (ATP-hydrolyzing) activity",
  "GO:0017169": "CDP-alcohol phosphatidyltransferase activity",
  "GO:0017170": "obsolete KU70 binding",
  "GO:0017171": "serine hydrolase activity",
  "GO:0017172": "cysteine dioxygenase activity",
  "GO:0017174": "glycine N-methyltransferase activity",
  "GO:0017175": "obsolete IMP-GMP specific 5'-nucleotidase activity",
  "GO:0017176": "phosphatidylinositol N-acetylglucosaminyltransferase activity",
  "GO:0017177": "glucosidase II complex",
  "GO:0017178": "diphthine-ammonia ligase activity",
  "GO:0017179": "peptidyl-diphthine metabolic process",
  "GO:0017180": "peptidyl-diphthine biosynthetic process from peptidyl-histidine",
  "GO:0017181": "peptidyl-diphthine catabolic process",
  "GO:0017182": "peptidyl-diphthamide metabolic process",
  "GO:0017183": "peptidyl-diphthamide biosynthetic process from peptidyl-histidine",
  "GO:0017184": "peptidyl-diphthamide catabolic process",
  "GO:0017185": "peptidyl-lysine hydroxylation",
  "GO:0017186": "peptidyl-pyroglutamic acid biosynthetic process, using glutaminyl-peptide cyclotransferase",
  "GO:0017187": "peptidyl-glutamic acid carboxylation",
  "GO:0017188": "aspartate N-acetyltransferase activity",
  "GO:0017189": "N-terminal peptidyl-alanine acetylation",
  "GO:0017190": "N-terminal peptidyl-aspartic acid acetylation",
  "GO:0017192": "N-terminal peptidyl-glutamine acetylation",
  "GO:0017193": "N-terminal peptidyl-glycine acetylation",
  "GO:0017194": "N-terminal peptidyl-isoleucine acetylation",
  "GO:0017195": "N-terminal peptidyl-lysine N2-acetylation",
  "GO:0017196": "N-terminal peptidyl-methionine acetylation",
  "GO:0017197": "N-terminal peptidyl-proline acetylation",
  "GO:0017198": "N-terminal peptidyl-serine acetylation",
  "GO:0017199": "N-terminal peptidyl-threonine acetylation",
  "GO:0018000": "N-terminal peptidyl-tyrosine acetylation",
  "GO:0018001": "N-terminal peptidyl-valine acetylation",
  "GO:0018002": "N-terminal peptidyl-glutamic acid acetylation",
  "GO:0018003": "peptidyl-lysine N6-acetylation",
  "GO:0018004": "N-terminal protein formylation",
  "GO:0018005": "N-terminal peptidyl-glycine N-formylation",
  "GO:0018006": "N-terminal protein amino acid glucuronylation",
  "GO:0018007": "N-terminal peptidyl-glycine N-glucuronylation",
  "GO:0018008": "N-terminal peptidyl-glycine N-myristoylation",
  "GO:0018009": "N-terminal peptidyl-L-cysteine N-palmitoylation",
  "GO:0018010": "glycoprotein N-palmitoyltransferase activity",
  "GO:0018011": "N-terminal peptidyl-alanine methylation",
  "GO:0018012": "N-terminal peptidyl-alanine trimethylation",
  "GO:0018013": "N-terminal peptidyl-glycine methylation",
  "GO:0018014": "N-terminal peptidyl-methionine methylation",
  "GO:0018015": "N-terminal peptidyl-phenylalanine methylation",
  "GO:0018016": "N-terminal peptidyl-proline dimethylation",
  "GO:0018019": "N-terminal peptidyl-glutamine methylation",
  "GO:0018020": "peptidyl-glutamic acid methylation",
  "GO:0018021": "peptidyl-histidine methylation",
  "GO:0018022": "peptidyl-lysine methylation",
  "GO:0018023": "peptidyl-lysine trimethylation",
  "GO:0018024": "histone-lysine N-methyltransferase activity",
  "GO:0018025": "calmodulin-lysine N-methyltransferase activity",
  "GO:0018026": "peptidyl-lysine monomethylation",
  "GO:0018027": "peptidyl-lysine dimethylation",
  "GO:0018028": "peptidyl-lysine myristoylation",
  "GO:0018029": "peptidyl-lysine palmitoylation",
  "GO:0018030": "peptidyl-lysine N6-myristoyltransferase activity",
  "GO:0018031": "peptidyl-lysine N6-palmitoyltransferase activity",
  "GO:0018032": "protein amidation",
  "GO:0018033": "protein C-terminal amidation",
  "GO:0018034": "C-terminal peptidyl-alanine amidation",
  "GO:0018035": "C-terminal peptidyl-arginine amidation",
  "GO:0018036": "C-terminal peptidyl-asparagine amidation",
  "GO:0018037": "C-terminal peptidyl-aspartic acid amidation",
  "GO:0018038": "C-terminal peptidyl-cysteine amidation",
  "GO:0018039": "C-terminal peptidyl-glutamine amidation",
  "GO:0018040": "C-terminal peptidyl-glutamic acid amidation",
  "GO:0018041": "C-terminal peptidyl-glycine amidation",
  "GO:0018042": "C-terminal peptidyl-histidine amidation",
  "GO:0018043": "C-terminal peptidyl-isoleucine amidation",
  "GO:0018044": "C-terminal peptidyl-leucine amidation",
  "GO:0018045": "C-terminal peptidyl-lysine amidation",
  "GO:0018046": "C-terminal peptidyl-methionine amidation",
  "GO:0018047": "C-terminal peptidyl-phenylalanine amidation",
  "GO:0018048": "C-terminal peptidyl-proline amidation",
  "GO:0018049": "C-terminal peptidyl-serine amidation",
  "GO:0018050": "C-terminal peptidyl-threonine amidation",
  "GO:0018051": "C-terminal peptidyl-tryptophan amidation",
  "GO:0018052": "C-terminal peptidyl-tyrosine amidation",
  "GO:0018053": "C-terminal peptidyl-valine amidation",
  "GO:0018054": "peptidyl-lysine biotinylation",
  "GO:0018055": "peptidyl-lysine lipoylation",
  "GO:0018057": "peptidyl-lysine oxidation",
  "GO:0018058": "N-terminal protein amino acid deamination, from amino carbon",
  "GO:0018059": "N-terminal peptidyl-serine deamination",
  "GO:0018060": "N-terminal peptidyl-cysteine deamination",
  "GO:0018061": "peptidyl-L-3-phenyllactic acid biosynthetic process from peptidyl-phenylalanine",
  "GO:0018062": "peptidyl-tryptophan succinylation",
  "GO:0018063": "cytochrome c-heme linkage",
  "GO:0018064": "protein-histidine N-methyltransferase activity",
  "GO:0018065": "protein-cofactor linkage",
  "GO:0018067": "peptidyl-L-3',4'-dihydroxyphenylalanine biosynthetic process from peptidyl-tyrosine",
  "GO:0018068": "peptidyl-L-2',4',5'-topaquinone biosynthetic process from peptidyl-tyrosine",
  "GO:0018069": "peptide cross-linking via 4'-(L-tryptophan)-L-tryptophyl quinone",
  "GO:0018070": "peptidyl-serine phosphopantetheinylation",
  "GO:0018071": "NAD(P)-cysteine ADP-ribosyltransferase activity",
  "GO:0018072": "peptidyl-L-glutamyl 5-glycerylphosphorylethanolamine biosynthetic process from peptidyl-glutamic acid",
  "GO:0018073": "protein bromination",
  "GO:0018074": "peptidyl-histidine bromination",
  "GO:0018075": "peptidyl-phenylalanine bromination",
  "GO:0018076": "N-terminal peptidyl-lysine acetylation",
  "GO:0018077": "protein iodination",
  "GO:0018078": "peptidyl-thyronine iodination",
  "GO:0018079": "protein halogenation",
  "GO:0018080": "peptidyl-tryptophan bromination",
  "GO:0018081": "peptide cross-linking via lanthionine or 3-methyl-lanthionine",
  "GO:0018082": "peptidyl-(Z)-dehydrobutyrine biosynthetic process from peptidyl-threonine",
  "GO:0018083": "peptidyl-L-3-oxoalanine biosynthetic process from peptidyl-cysteine or peptidyl-serine",
  "GO:0018084": "peptidyl-lactic acid biosynthetic process from peptidyl-serine",
  "GO:0018085": "peptidyl-L-amino acid racemization",
  "GO:0018086": "obsolete alanine racemization",
  "GO:0018091": "peptidyl-asparagine racemization",
  "GO:0018094": "protein polyglycylation",
  "GO:0018095": "protein polyglutamylation",
  "GO:0018096": "peptide cross-linking via S-(2-aminovinyl)-D-cysteine",
  "GO:0018097": "protein-chromophore linkage via peptidyl-S-4-hydroxycinnamyl-L-cysteine",
  "GO:0018101": "protein citrullination",
  "GO:0018102": "peptidyl-arginine hydroxylation to peptidyl-4-hydroxy-L-arginine",
  "GO:0018103": "protein C-linked glycosylation",
  "GO:0018104": "peptidoglycan-protein cross-linking",
  "GO:0018105": "peptidyl-serine phosphorylation",
  "GO:0018106": "peptidyl-histidine phosphorylation",
  "GO:0018107": "peptidyl-threonine phosphorylation",
  "GO:0018108": "peptidyl-tyrosine phosphorylation",
  "GO:0018109": "peptidyl-arginine phosphorylation",
  "GO:0018110": "histone arginine kinase activity",
  "GO:0018111": "methionine racemase activity",
  "GO:0018112": "proline racemase activity",
  "GO:0018113": "lysine racemase activity",
  "GO:0018114": "threonine racemase activity",
  "GO:0018115": "peptidyl-S-diphytanylglycerol diether-L-cysteine biosynthetic process from peptidyl-cysteine",
  "GO:0018116": "peptidyl-lysine adenylylation",
  "GO:0018117": "protein adenylylation",
  "GO:0018118": "peptidyl-L-cysteine glutathione disulfide biosynthetic process from peptidyl-cysteine",
  "GO:0018119": "peptidyl-cysteine S-nitrosylation",
  "GO:0018120": "peptidyl-arginine ADP-ribosylation",
  "GO:0018121": "NAD(P)-asparagine ADP-ribosyltransferase activity",
  "GO:0018122": "peptidyl-asparagine ADP-ribosylation",
  "GO:0018123": "peptidyl-cysteine ADP-ribosylation",
  "GO:0018124": "peptide cross-linking via 5'-(N6-L-lysine)-L-topaquinone",
  "GO:0018125": "peptidyl-cysteine methylation",
  "GO:0018126": "protein hydroxylation",
  "GO:0018127": "NAD(P)-serine ADP-ribosyltransferase activity",
  "GO:0018128": "obsolete peptidyl-serine cyclase activity",
  "GO:0018129": "peptidyl-oxazoline dehydrogenase activity",
  "GO:0018130": "heterocycle biosynthetic process",
  "GO:0018131": "oxazole or thiazole biosynthetic process",
  "GO:0018132": "peptide cross-linking via L-cysteine oxazolecarboxylic acid",
  "GO:0018133": "peptide cross-linking via L-cysteine oxazolinecarboxylic acid",
  "GO:0018134": "peptide cross-linking via glycine oxazolecarboxylic acid",
  "GO:0018135": "obsolete peptidyl-cysteine cyclase activity",
  "GO:0018136": "peptidyl-thiazoline dehydrogenase activity",
  "GO:0018137": "peptide cross-linking via glycine thiazolecarboxylic acid",
  "GO:0018138": "peptide cross-linking via L-serine thiazolecarboxylic acid",
  "GO:0018139": "peptide cross-linking via L-phenylalanine thiazolecarboxylic acid",
  "GO:0018140": "peptide cross-linking via L-cysteine thiazolecarboxylic acid",
  "GO:0018141": "peptide cross-linking via L-lysine thiazolecarboxylic acid",
  "GO:0018142": "protein-DNA covalent cross-linking",
  "GO:0018143": "nucleic acid-protein covalent cross-linking",
  "GO:0018144": "RNA-protein covalent cross-linking",
  "GO:0018145": "protein-DNA covalent cross-linking via peptidyl-serine",
  "GO:0018146": "keratan sulfate biosynthetic process",
  "GO:0018147": "molybdenum incorporation via L-selenocysteinyl molybdenum bis(molybdopterin guanine dinucleotide)",
  "GO:0018148": "RNA-protein covalent cross-linking via peptidyl-tyrosine",
  "GO:0018149": "peptide cross-linking",
  "GO:0018150": "peptide cross-linking via 3-(3'-L-histidyl)-L-tyrosine",
  "GO:0018151": "peptide cross-linking via L-histidyl-L-tyrosine",
  "GO:0018152": "peptide cross-linking via 3'-(1'-L-histidyl)-L-tyrosine",
  "GO:0018153": "isopeptide cross-linking via N6-(L-isoglutamyl)-L-lysine",
  "GO:0018154": "peptide cross-linking via (2R,6R)-lanthionine",
  "GO:0018155": "peptide cross-linking via sn-(2S,6R)-lanthionine",
  "GO:0018156": "peptide cross-linking via (2S,3S,6R)-3-methyl-lanthionine",
  "GO:0018157": "peptide cross-linking via an oxazole or thiazole",
  "GO:0018158": "protein oxidation",
  "GO:0018159": "peptidyl-methionine oxidation",
  "GO:0018160": "peptidyl-pyrromethane cofactor linkage",
  "GO:0018161": "dipyrrin biosynthetic process",
  "GO:0018162": "peptide cross-linking via S-(2-aminovinyl)-3-methyl-D-cysteine",
  "GO:0018163": "protein-DNA covalent cross-linking via the 5'-end to peptidyl-tyrosine",
  "GO:0018164": "protein-DNA covalent cross-linking via peptidyl-threonine",
  "GO:0018165": "peptidyl-tyrosine uridylylation",
  "GO:0018166": "C-terminal protein-tyrosinylation",
  "GO:0018167": "protein-phycoerythrobilin linkage via phycoerythrobilin-bis-L-cysteine",
  "GO:0018168": "protein-phycoerythrobilin linkage via S-phycoerythrobilin-L-cysteine",
  "GO:0018169": "ribosomal S6-glutamic acid ligase activity",
  "GO:0018170": "C-terminal peptidyl-polyglutamic acid amidation",
  "GO:0018171": "peptidyl-cysteine oxidation",
  "GO:0018172": "peptidyl-L-3',4',5'-trihydroxyphenylalanine biosynthetic process from peptidyl-tyrosine",
  "GO:0018173": "peptidyl-1-thioglycine biosynthetic process from peptidyl-glycine",
  "GO:0018174": "protein-heme P460 linkage",
  "GO:0018175": "protein nucleotidylation",
  "GO:0018177": "protein uridylylation",
  "GO:0018178": "peptidyl-threonine adenylylation",
  "GO:0018179": "obsolete peptidyl-cysteine desulfurization",
  "GO:0018180": "protein desulfurization",
  "GO:0018181": "peptidyl-arginine C5-methylation",
  "GO:0018182": "protein-heme linkage via 3'-L-histidine",
  "GO:0018183": "obsolete enzyme active site formation via S-selenyl-L-cysteine",
  "GO:0018184": "protein polyamination",
  "GO:0018185": "poly-N-methyl-propylamination",
  "GO:0018186": "peroxidase-heme linkage",
  "GO:0018187": "molybdenum incorporation via L-cysteinyl molybdopterin guanine dinucleotide",
  "GO:0018188": "peptidyl-proline di-hydroxylation",
  "GO:0018189": "pyrroloquinoline quinone biosynthetic process",
  "GO:0018190": "protein octanoylation",
  "GO:0018191": "peptidyl-serine octanoylation",
  "GO:0018192": "enzyme active site formation via cysteine modification to L-cysteine persulfide",
  "GO:0018193": "peptidyl-amino acid modification",
  "GO:0018194": "peptidyl-alanine modification",
  "GO:0018195": "peptidyl-arginine modification",
  "GO:0018196": "peptidyl-asparagine modification",
  "GO:0018197": "peptidyl-aspartic acid modification",
  "GO:0018198": "peptidyl-cysteine modification",
  "GO:0018199": "peptidyl-glutamine modification",
  "GO:0018200": "peptidyl-glutamic acid modification",
  "GO:0018201": "peptidyl-glycine modification",
  "GO:0018202": "peptidyl-histidine modification",
  "GO:0018203": "peptidyl-isoleucine modification",
  "GO:0018204": "peptidyl-leucine modification",
  "GO:0018205": "peptidyl-lysine modification",
  "GO:0018206": "peptidyl-methionine modification",
  "GO:0018207": "peptidyl-phenylalanine modification",
  "GO:0018208": "peptidyl-proline modification",
  "GO:0018209": "peptidyl-serine modification",
  "GO:0018210": "peptidyl-threonine modification",
  "GO:0018211": "peptidyl-tryptophan modification",
  "GO:0018212": "peptidyl-tyrosine modification",
  "GO:0018213": "peptidyl-valine modification",
  "GO:0018214": "protein carboxylation",
  "GO:0018215": "protein phosphopantetheinylation",
  "GO:0018216": "peptidyl-arginine methylation",
  "GO:0018217": "peptidyl-aspartic acid phosphorylation",
  "GO:0018218": "peptidyl-cysteine phosphorylation",
  "GO:0018219": "peptidyl-cysteine S-acetylation",
  "GO:0018220": "peptidyl-threonine palmitoylation",
  "GO:0018221": "peptidyl-serine palmitoylation",
  "GO:0018222": "peptidyl-L-cysteine methyl disulfide biosynthetic process from peptidyl-cysteine",
  "GO:0018226": "peptidyl-S-farnesyl-L-cysteine biosynthetic process from peptidyl-cysteine",
  "GO:0018227": "peptidyl-S-12-hydroxyfarnesyl-L-cysteine biosynthetic process from peptidyl-cysteine",
  "GO:0018228": "peptidyl-S-geranylgeranyl-L-cysteine biosynthetic process from peptidyl-cysteine",
  "GO:0018229": "peptidyl-L-cysteine methyl ester biosynthetic process from peptidyl-cysteine",
  "GO:0018230": "peptidyl-L-cysteine S-palmitoylation",
  "GO:0018231": "peptidyl-S-diacylglycerol-L-cysteine biosynthetic process from peptidyl-cysteine",
  "GO:0018232": "peptide cross-linking via S-(L-isoglutamyl)-L-cysteine",
  "GO:0018233": "peptide cross-linking via 2'-(S-L-cysteinyl)-L-histidine",
  "GO:0018234": "peptide cross-linking via 3'-(S-L-cysteinyl)-L-tyrosine",
  "GO:0018235": "peptidyl-lysine carboxylation",
  "GO:0018237": "urease activator activity",
  "GO:0018238": "peptidyl-lysine carboxyethylation",
  "GO:0018240": "protein S-linked glycosylation via cysteine",
  "GO:0018241": "protein O-linked glycosylation via hydroxylysine",
  "GO:0018242": "protein O-linked glycosylation via serine",
  "GO:0018243": "protein O-linked glycosylation via threonine",
  "GO:0018244": "protein N-linked glycosylation via tryptophan",
  "GO:0018245": "protein O-linked glycosylation via tyrosine",
  "GO:0018246": "protein-coenzyme A linkage",
  "GO:0018247": "protein-phosphoribosyl dephospho-coenzyme A linkage",
  "GO:0018248": "enzyme active site formation via peptidyl cysteine sulfation",
  "GO:0018249": "protein dehydration",
  "GO:0018250": "peptidyl-dehydroalanine biosynthetic process from peptidyl-tyrosine or peptidyl-serine",
  "GO:0018251": "peptidyl-tyrosine dehydrogenation",
  "GO:0018252": "peptide cross-linking via L-seryl-5-imidazolinone glycine",
  "GO:0018253": "peptide cross-linking via 5-imidazolinone glycine",
  "GO:0018254": "peptidyl-tyrosine adenylylation",
  "GO:0018255": "peptide cross-linking via S-glycyl-L-cysteine",
  "GO:0018256": "protein formylation",
  "GO:0018257": "peptidyl-lysine formylation",
  "GO:0018258": "protein O-linked glycosylation via hydroxyproline",
  "GO:0018259": "RNA-protein covalent cross-linking via peptidyl-serine",
  "GO:0018260": "protein guanylylation",
  "GO:0018261": "peptidyl-lysine guanylylation",
  "GO:0018262": "isopeptide cross-linking",
  "GO:0018263": "isopeptide cross-linking via N-(L-isoaspartyl)-L-cysteine",
  "GO:0018264": "isopeptide cross-linking via N-(L-isoaspartyl)-glycine",
  "GO:0018265": "GPI anchor biosynthetic process via N-asparaginyl-glycosylphosphatidylinositolethanolamine",
  "GO:0018266": "GPI anchor biosynthetic process via N-aspartyl-glycosylphosphatidylinositolethanolamine",
  "GO:0018267": "GPI anchor biosynthetic process via N-cysteinyl-glycosylphosphatidylinositolethanolamine",
  "GO:0018268": "GPI anchor biosynthetic process via N-glycyl-glycosylphosphatidylinositolethanolamine",
  "GO:0018269": "GPI anchor biosynthetic process via N-seryl-glycosylphosphatidylinositolethanolamine",
  "GO:0018270": "GPI anchor biosynthetic process via N-alanyl-glycosylphosphatidylinositolethanolamine",
  "GO:0018271": "biotin-protein ligase activity",
  "GO:0018272": "protein-pyridoxal-5-phosphate linkage via peptidyl-N6-pyridoxal phosphate-L-lysine",
  "GO:0018273": "protein-chromophore linkage via peptidyl-N6-retinal-L-lysine",
  "GO:0018274": "peptide cross-linking via L-lysinoalanine",
  "GO:0018275": "N-terminal peptidyl-cysteine acetylation",
  "GO:0018276": "isopeptide cross-linking via N6-glycyl-L-lysine",
  "GO:0018277": "protein deamination",
  "GO:0018278": "N-terminal peptidyl-threonine deamination",
  "GO:0018279": "protein N-linked glycosylation via asparagine",
  "GO:0018280": "protein S-linked glycosylation",
  "GO:0018281": "GSI anchor biosynthetic process via N-seryl-glycosylsphingolipidinositolethanolamine",
  "GO:0018282": "metal incorporation into metallo-sulfur cluster",
  "GO:0018283": "iron incorporation into metallo-sulfur cluster",
  "GO:0018284": "iron incorporation into protein via tetrakis-L-cysteinyl iron",
  "GO:0018285": "iron incorporation into iron-sulfur cluster via tetrakis-L-cysteinyl diiron disulfide",
  "GO:0018286": "obsolete iron incorporation into iron-sulfur cluster via hexakis-L-cysteinyl triiron trisulfide",
  "GO:0018287": "iron incorporation into iron-sulfur cluster via tris-L-cysteinyl triiron tetrasulfide",
  "GO:0018288": "iron incorporation into iron-sulfur cluster via tetrakis-L-cysteinyl tetrairon tetrasulfide",
  "GO:0018289": "molybdenum incorporation into metallo-sulfur cluster",
  "GO:0018290": "iron and molybdenum incorporation into iron-molybdenum-sulfur cluster via L-cysteinyl homocitryl molybdenum-heptairon-nonasulfide",
  "GO:0018291": "molybdenum incorporation into iron-sulfur cluster",
  "GO:0018292": "molybdenum incorporation via L-cysteinyl molybdopterin",
  "GO:0018293": "protein-FAD linkage",
  "GO:0018294": "protein-FAD linkage via S-(8alpha-FAD)-L-cysteine",
  "GO:0018295": "protein-FAD linkage via 3'-(8alpha-FAD)-L-histidine",
  "GO:0018296": "protein-FAD linkage via O4'-(8alpha-FAD)-L-tyrosine",
  "GO:0018297": "protein-FAD linkage via 1'-(8alpha-FAD)-L-histidine",
  "GO:0018298": "protein-chromophore linkage",
  "GO:0018299": "iron incorporation into the Rieske iron-sulfur cluster via bis-L-cysteinyl bis-L-histidino diiron disulfide",
  "GO:0018300": "obsolete iron incorporation into iron-sulfur cluster via hexakis-L-cysteinyl hexairon hexasulfide",
  "GO:0018301": "iron incorporation into iron-sulfur cluster via tris-L-cysteinyl-L-cysteine persulfido-bis-L-glutamato-L-histidino tetrairon",
  "GO:0018302": "iron incorporation into iron-sulfur cluster via tris-L-cysteinyl-L-N1'-histidino tetrairon tetrasulfide",
  "GO:0018303": "iron incorporation into iron-sulfur cluster via tris-L-cysteinyl-L-N3'-histidino tetrairon tetrasulfide",
  "GO:0018304": "iron incorporation into iron-sulfur cluster via tris-L-cysteinyl-L-aspartato tetrairon tetrasulfide",
  "GO:0018305": "iron incorporation into iron-sulfur cluster via tris-L-cysteinyl-L-serinyl tetrairon tetrasulfide",
  "GO:0018306": "iron incorporation into iron-sulfur cluster via bis-L-cysteinyl-L-N3'-histidino-L-serinyl tetrairon tetrasulfide",
  "GO:0018307": "enzyme active site formation",
  "GO:0018308": "obsolete enzyme active site formation via N6-pyruvic acid 2-iminyl-L-lysine",
  "GO:0018309": "protein-FMN linkage",
  "GO:0018310": "protein-FMN linkage via S-(6-FMN)-L-cysteine",
  "GO:0018311": "peptidyl-N4-hydroxymethyl-L-asparagine biosynthetic process from peptidyl-asparagine",
  "GO:0018312": "peptidyl-serine ADP-ribosylation",
  "GO:0018313": "peptide cross-linking via L-alanyl-5-imidazolinone glycine",
  "GO:0018314": "obsolete protein-pyrroloquinoline-quinone linkage",
  "GO:0018315": "molybdenum incorporation into molybdenum-molybdopterin complex",
  "GO:0018316": "peptide cross-linking via L-cystine",
  "GO:0018317": "protein C-linked glycosylation via tryptophan",
  "GO:0018320": "enzyme active site formation via S-methyl-L-cysteine",
  "GO:0018321": "protein glucuronylation",
  "GO:0018322": "protein tyrosinylation",
  "GO:0018323": "enzyme active site formation via L-cysteine sulfinic acid",
  "GO:0018324": "enzyme active site formation via L-cysteine sulfenic acid",
  "GO:0018325": "enzyme active site formation via S-phospho-L-cysteine",
  "GO:0018326": "enzyme active site formation via S-acetyl-L-cysteine",
  "GO:0018327": "enzyme active site formation via 1'-phospho-L-histidine",
  "GO:0018328": "enzyme active site formation via 3'-phospho-L-histidine",
  "GO:0018329": "enzyme active site formation via N6-(phospho-5'-adenosine)-L-lysine",
  "GO:0018330": "enzyme active site formation via N6-(phospho-5'-guanosine)-L-lysine",
  "GO:0018331": "enzyme active site formation via O-phospho-L-serine",
  "GO:0018332": "enzyme active site formation via O-(phospho-5'-adenosine)-L-threonine",
  "GO:0018333": "enzyme active site formation via O-phospho-L-threonine",
  "GO:0018334": "enzyme active site formation via O4'-phospho-L-tyrosine",
  "GO:0018335": "protein succinylation",
  "GO:0018336": "peptidyl-tyrosine hydroxylation",
  "GO:0018337": "obsolete enzyme active site formation via L-2',4',5'-topaquinone",
  "GO:0018338": "obsolete protein amino acid cinnamylation",
  "GO:0018339": "peptidyl-L-beta-methylthioaspartic acid biosynthetic process from peptidyl-aspartic acid",
  "GO:0018340": "peptidyl-O-(sn-1-glycerophosphoryl)-L-serine biosynthetic process from peptidyl-serine",
  "GO:0018341": "peptidyl-lysine modification to peptidyl-N6-pyruvic acid 2-iminyl-L-lysine",
  "GO:0018342": "protein prenylation",
  "GO:0018343": "protein farnesylation",
  "GO:0018344": "protein geranylgeranylation",
  "GO:0018345": "protein palmitoylation",
  "GO:0018350": "protein esterification",
  "GO:0018351": "peptidyl-cysteine esterification",
  "GO:0018352": "protein-pyridoxal-5-phosphate linkage",
  "GO:0018353": "protein-phycocyanobilin linkage via S-phycocyanobilin-L-cysteine",
  "GO:0018355": "protein-phosphoribosyl dephospho-coenzyme A linkage via O-(phosphoribosyl dephospho-coenzyme A)-L-serine",
  "GO:0018356": "protein-phycobiliviolin linkage via S-phycobiliviolin-L-cysteine",
  "GO:0018357": "protein-phycourobilin linkage via phycourobilin-bis-L-cysteine",
  "GO:0018358": "protein-phytochromobilin linkage via S-phytochromobilin-L-cysteine",
  "GO:0018359": "protein-heme P460 linkage via heme P460-bis-L-cysteine-L-tyrosine",
  "GO:0018360": "protein-heme P460 linkage via heme P460-bis-L-cysteine-L-lysine",
  "GO:0018361": "peptidyl-glutamine 2-methylation",
  "GO:0018362": "peroxidase-heme linkage via dihydroxyheme-L-aspartyl ester-L-glutamyl ester",
  "GO:0018363": "peroxidase-heme linkage via dihydroxyheme-L-aspartyl ester-L-glutamyl ester-L-methionine sulfonium",
  "GO:0018364": "peptidyl-glutamine methylation",
  "GO:0018365": "protein-serine epimerase activity",
  "GO:0018366": "chiral amino acid racemization",
  "GO:0018367": "obsolete free L-amino acid racemization",
  "GO:0018376": "peptidyl-asparagine hydroxylation to form L-erythro-beta-hydroxyasparagine",
  "GO:0018377": "protein myristoylation",
  "GO:0018378": "cytochrome c-heme linkage via heme-L-cysteine",
  "GO:0018379": "cytochrome c-heme linkage via heme-bis-L-cysteine",
  "GO:0018386": "N-terminal peptidyl-cysteine condensation with pyruvate to form N-pyruvic acid 2-iminyl-L-cysteine",
  "GO:0018387": "N-terminal peptidyl-amino acid deamination to pyruvic acid",
  "GO:0018388": "N-terminal peptidyl-valine condensation with pyruvate to form N-pyruvic acid 2-iminyl-L-valine",
  "GO:0018389": "N-terminal peptidyl-valine deamination",
  "GO:0018390": "peptidyl-L-glutamic acid 5-methyl ester biosynthetic process from peptidyl-glutamic acid or peptidyl-glutamine",
  "GO:0018391": "C-terminal peptidyl-glutamic acid tyrosinylation",
  "GO:0018392": "glycoprotein 3-alpha-L-fucosyltransferase activity",
  "GO:0018393": "internal peptidyl-lysine acetylation",
  "GO:0018394": "peptidyl-lysine acetylation",
  "GO:0018395": "peptidyl-lysine hydroxylation to 5-hydroxy-L-lysine",
  "GO:0018396": "peptidyl-lysine hydroxylation to 4-hydroxy-L-lysine",
  "GO:0018397": "peptidyl-phenylalanine bromination to L-2'-bromophenylalanine",
  "GO:0018398": "peptidyl-phenylalanine bromination to L-3'-bromophenylalanine",
  "GO:0018399": "peptidyl-phenylalanine bromination to L-4'-bromophenylalanine",
  "GO:0018400": "peptidyl-proline hydroxylation to 3-hydroxy-L-proline",
  "GO:0018401": "peptidyl-proline hydroxylation to 4-hydroxy-L-proline",
  "GO:0018402": "protein-chondroitin sulfate linkage via chondroitin sulfate D-glucuronyl-D-galactosyl-D-galactosyl-D-xylosyl-L-serine",
  "GO:0018403": "protein-dermatan sulfate linkage via dermatan 4-sulfate D-glucuronyl-D-galactosyl-D-galactosyl-D-xylosyl-L-serine",
  "GO:0018404": "protein-heparan sulfate linkage via heparan sulfate D-glucuronyl-D-galactosyl-D-galactosyl-D-xylosyl-L-serine",
  "GO:0018405": "protein-keratan sulfate linkage via keratan sulfate D-glucuronyl-D-galactosyl-D-galactosyl-D-xylosyl-L-threonine",
  "GO:0018406": "protein C-linked glycosylation via 2'-alpha-mannosyl-L-tryptophan",
  "GO:0018407": "peptidyl-thyronine iodination to form 3',3'',5'-triiodo-L-thyronine",
  "GO:0018408": "peptidyl-thyronine iodination to form 3',3'',5',5''-tetraiodo-L-thyronine",
  "GO:0018410": "C-terminal protein amino acid modification",
  "GO:0018411": "protein glucuronidation",
  "GO:0018412": "protein O-glucuronidation",
  "GO:0018413": "peptidyl-serine O-glucuronidation",
  "GO:0018414": "nickel incorporation into metallo-sulfur cluster",
  "GO:0018415": "iron incorporation into iron-sulfur cluster via tris-L-cysteinyl L-cysteine persulfido bis-L-glutamato L-histidino nickel triiron disulfide trioxide",
  "GO:0018416": "nickel incorporation into iron-sulfur cluster via tris-L-cysteinyl L-cysteine persulfido bis-L-glutamato L-histidino nickel triiron disulfide trioxide",
  "GO:0018417": "iron incorporation into iron-sulfur cluster via tris-L-cysteinyl L-cysteine persulfido L-glutamato L-histidino L-serinyl nickel triiron disulfide trioxide",
  "GO:0018418": "nickel incorporation into iron-sulfur cluster via tris-L-cysteinyl L-cysteine persulfido L-glutamato L-histidino L-serinyl nickel triiron disulfide trioxide",
  "GO:0018419": "protein catenane formation",
  "GO:0018420": "peptide cross-linking via N6-(L-isoaspartyl)-L-lysine",
  "GO:0018421": "UDP-N-acetylglucosamine:serine-protein N-acetylglucosamine-1-phosphotransferase activity",
  "GO:0018422": "GDP-mannose:serine-protein mannose-1-phosphotransferase activity",
  "GO:0018423": "protein C-terminal leucine carboxyl O-methyltransferase activity",
  "GO:0018424": "peptidyl-glutamic acid poly-ADP-ribosylation",
  "GO:0018425": "O3-(N-acetylglucosamine-1-phosphoryl)-L-serine biosynthetic process",
  "GO:0018426": "O3-(phosphoglycosyl-D-mannose-1-phosphoryl)-L-serine biosynthetic process",
  "GO:0018427": "copper incorporation into metallo-sulfur cluster",
  "GO:0018428": "copper incorporation into copper-sulfur cluster",
  "GO:0018429": "copper incorporation into copper-sulfur cluster via heptakis-L-histidino tetracopper mu4-sulfide hydroxide",
  "GO:0018439": "peptidyl-L-leucine methyl ester biosynthetic process from peptidyl-leucine",
  "GO:0018441": "iron incorporation into iron-sulfur cluster via hexakis-L-cysteinyl L-serinyl octairon heptasulfide",
  "GO:0018442": "peptidyl-glutamic acid esterification",
  "GO:0018443": "enzyme active site formation via L-aspartic 4-phosphoric anhydride",
  "GO:0018444": "translation release factor complex",
  "GO:0018445": "prothoracicotrophic hormone activity",
  "GO:0018446": "pinocarveol dehydrogenase activity",
  "GO:0018447": "chloral hydrate dehydrogenase activity",
  "GO:0018448": "hydroxymethylmethylsilanediol oxidase activity",
  "GO:0018449": "1-phenylethanol dehydrogenase activity",
  "GO:0018450": "myrtenol dehydrogenase activity",
  "GO:0018451": "epoxide dehydrogenase activity",
  "GO:0018452": "5-exo-hydroxycamphor dehydrogenase activity",
  "GO:0018453": "2-hydroxytetrahydrofuran dehydrogenase activity",
  "GO:0018454": "acetoacetyl-CoA reductase activity",
  "GO:0018455": "alcohol dehydrogenase [NAD(P)+] activity",
  "GO:0018456": "aryl-alcohol dehydrogenase (NAD+) activity",
  "GO:0018457": "perillyl-alcohol dehydrogenase activity",
  "GO:0018458": "isopiperitenol dehydrogenase activity",
  "GO:0018459": "carveol dehydrogenase activity",
  "GO:0018460": "cyclohexanol dehydrogenase activity",
  "GO:0018461": "fluoren-9-ol dehydrogenase activity",
  "GO:0018462": "4-(hydroxymethyl)benzenesulfonate dehydrogenase activity",
  "GO:0018463": "6-hydroxyhexanoate dehydrogenase activity",
  "GO:0018464": "3-hydroxypimeloyl-CoA dehydrogenase activity",
  "GO:0018465": "vanillyl-alcohol oxidase activity",
  "GO:0018466": "limonene-1,2-diol dehydrogenase activity",
  "GO:0018467": "formaldehyde dehydrogenase activity",
  "GO:0018468": "alcohol dehydrogenase (acceptor) activity",
  "GO:0018469": "myrtenal dehydrogenase activity",
  "GO:0018470": "4-hydroxybutaraldehyde dehydrogenase activity",
  "GO:0018471": "4-chlorobenzaldehyde oxidase activity",
  "GO:0018472": "1-hydroxy-2-naphthaldehyde dehydrogenase activity",
  "GO:0018473": "cis-2-methyl-5-isopropylhexa-2,5-dienal dehydrogenase activity",
  "GO:0018474": "2-carboxybenzaldehyde dehydrogenase activity",
  "GO:0018475": "trans-2-methyl-5-isopropylhexa-2,5-dienal dehydrogenase activity",
  "GO:0018477": "benzaldehyde dehydrogenase (NADP+) activity",
  "GO:0018478": "malonate-semialdehyde dehydrogenase (acetylating) activity",
  "GO:0018479": "benzaldehyde dehydrogenase (NAD+) activity",
  "GO:0018480": "5-carboxymethyl-2-hydroxymuconic-semialdehyde dehydrogenase activity",
  "GO:0018481": "4-hydroxymuconic-semialdehyde dehydrogenase activity",
  "GO:0018482": "4-formylbenzenesulfonate dehydrogenase activity",
  "GO:0018483": "6-oxohexanoate dehydrogenase activity",
  "GO:0018484": "4-hydroxybenzaldehyde dehydrogenase activity",
  "GO:0018485": "salicylaldehyde dehydrogenase activity",
  "GO:0018486": "2-butanone oxidase activity",
  "GO:0018487": "vanillate O-demethylase (anaerobic) activity",
  "GO:0018488": "aryl-aldehyde oxidase activity",
  "GO:0018489": "vanillate monooxygenase activity",
  "GO:0018490": "4-hydroxyphenylpyruvate oxidase activity",
  "GO:0018491": "2-oxobutyrate synthase activity",
  "GO:0018492": "carbon-monoxide dehydrogenase (acceptor) activity",
  "GO:0018493": "formylmethanofuran dehydrogenase activity",
  "GO:0018494": "carvone reductase activity",
  "GO:0018495": "2-hydroxycyclohexane-1-carboxyl-CoA dehydrogenase activity",
  "GO:0018496": "2,6-dihydroxycyclohexane-1-carboxyl-CoA dehydrogenase activity",
  "GO:0018497": "1-chloro-2,2-bis(4-chlorophenyl)ethane dehydrogenase activity",
  "GO:0018498": "2,3-dihydroxy-2,3-dihydro-phenylpropionate dehydrogenase activity",
  "GO:0018499": "cis-2,3-dihydrodiol DDT dehydrogenase activity",
  "GO:0018500": "trans-9R,10R-dihydrodiolphenanthrene dehydrogenase activity",
  "GO:0018501": "cis-chlorobenzene dihydrodiol dehydrogenase activity",
  "GO:0018502": "2,5-dichloro-2,5-cyclohexadiene-1,4-diol dehydrogenase activity",
  "GO:0018503": "trans-1,2-dihydrodiolphenanthrene dehydrogenase activity",
  "GO:0018504": "cis-1,2-dihydrobenzene-1,2-diol dehydrogenase activity",
  "GO:0018505": "cis-1,2-dihydro-1,2-dihydroxynaphthalene dehydrogenase activity",
  "GO:0018506": "maleylacetate reductase activity",
  "GO:0018507": "cis-3,4-dihydrophenanthrene-3,4-diol dehydrogenase activity",
  "GO:0018508": "cis-1,2-dihydroxycyclohexa-3,5-diene-1-carboxylate dehydrogenase activity",
  "GO:0018509": "cis-2,3-dihydrobiphenyl-2,3-diol dehydrogenase activity",
  "GO:0018510": "phloroglucinol reductase activity",
  "GO:0018511": "2,3-dihydroxy-2,3-dihydro-p-cumate dehydrogenase activity",
  "GO:0018512": "obsolete 1,6-dihydroxy-5-methylcyclohexa-2,4-dienecarboxylate dehydrogenase activity",
  "GO:0018513": "dibenzothiophene dihydrodiol dehydrogenase activity",
  "GO:0018515": "pimeloyl-CoA dehydrogenase activity",
  "GO:0018516": "2,4-dichlorobenzoyl-CoA reductase activity",
  "GO:0018517": "phthalate 4,5-cis-dihydrodiol dehydrogenase activity",
  "GO:0018518": "5,6-dihydroxy-3-methyl-2-oxo-1,2,5,6-tetrahydroquinoline dehydrogenase activity",
  "GO:0018519": "cis-dihydroethylcatechol dehydrogenase activity",
  "GO:0018520": "cis-1,2-dihydroxy-4-methylcyclohexa-3,5-diene-1-carboxylate dehydrogenase activity",
  "GO:0018521": "1,2-dihydroxy-6-methylcyclohexa-3,5-dienecarboxylate dehydrogenase activity",
  "GO:0018522": "benzoyl-CoA reductase activity",
  "GO:0018523": "quinoline 2-oxidoreductase activity",
  "GO:0018524": "acetophenone carboxylase activity",
  "GO:0018525": "4-hydroxybenzoyl-CoA reductase activity",
  "GO:0018526": "2-aminobenzoyl-CoA reductase activity",
  "GO:0018527": "cyclohexylamine oxidase activity",
  "GO:0018528": "iminodiacetate dehydrogenase activity",
  "GO:0018529": "nitrilotriacetate monooxygenase activity",
  "GO:0018530": "(R)-6-hydroxynicotine oxidase activity",
  "GO:0018531": "(S)-6-hydroxynicotine oxidase activity",
  "GO:0018532": "5,10-methenyl-5,6,7,8-tetrahydromethanopterin dehydrogenase activity",
  "GO:0018533": "peptidyl-cysteine acetylation",
  "GO:0018534": "nitrilotriacetate dehydrogenase activity",
  "GO:0018535": "nicotine dehydrogenase activity",
  "GO:0018537": "coenzyme F420-dependent N5,N10-methenyltetrahydromethanopterin reductase activity",
  "GO:0018538": "epoxide carboxylase activity",
  "GO:0018541": "p-benzoquinone reductase (NADPH) activity",
  "GO:0018542": "2,3-dihydroxy DDT 1,2-dioxygenase activity",
  "GO:0018543": "4-amino-2-nitroso-6-nitrotoluene reductase activity",
  "GO:0018544": "4-carboxy-4'-sulfoazobenzene reductase activity",
  "GO:0018545": "NAD(P)H nitroreductase activity",
  "GO:0018546": "nitrobenzene nitroreductase activity",
  "GO:0018547": "nitroglycerin reductase activity",
  "GO:0018548": "pentaerythritol trinitrate reductase activity",
  "GO:0018549": "methanethiol oxidase activity",
  "GO:0018550": "tetrachloro-p-hydroquinone reductive dehalogenase activity",
  "GO:0018551": "hydrogensulfite reductase activity",
  "GO:0018553": "3-(2,3-dihydroxyphenyl)propionate 1,2-dioxygenase activity",
  "GO:0018554": "1,2-dihydroxynaphthalene dioxygenase activity",
  "GO:0018555": "phenanthrene dioxygenase activity",
  "GO:0018556": "2,2',3-trihydroxybiphenyl dioxygenase activity",
  "GO:0018557": "1,2-dihydroxyfluorene 1,1-alpha-dioxygenase activity",
  "GO:0018558": "5,6-dihydroxy-3-methyl-2-oxo-1,2-dihydroquinoline dioxygenase activity",
  "GO:0018559": "1,1-dichloro-2-(dihydroxy-4-chlorophenyl)-(4-chlorophenyl)ethene 1,2-dioxygenase activity",
  "GO:0018560": "protocatechuate 3,4-dioxygenase type II activity",
  "GO:0018561": "2'-aminobiphenyl-2,3-diol 1,2-dioxygenase activity",
  "GO:0018562": "3,4-dihydroxyfluorene 4,4-alpha-dioxygenase activity",
  "GO:0018563": "2,3-dihydroxy-ethylbenzene 1,2-dioxygenase activity",
  "GO:0018564": "carbazole 1,9a-dioxygenase activity",
  "GO:0018565": "dihydroxydibenzothiophene dioxygenase activity",
  "GO:0018566": "1,2-dihydroxynaphthalene-6-sulfonate 1,8a-dioxygenase activity",
  "GO:0018567": "styrene dioxygenase activity",
  "GO:0018568": "3,4-dihydroxyphenanthrene dioxygenase activity",
  "GO:0018569": "hydroquinone 1,2-dioxygenase activity",
  "GO:0018570": "p-cumate 2,3-dioxygenase activity",
  "GO:0018571": "2,3-dihydroxy-p-cumate dioxygenase activity",
  "GO:0018572": "3,5-dichlorocatechol 1,2-dioxygenase activity",
  "GO:0018573": "2-aminophenol 1,6-dioxygenase activity",
  "GO:0018574": "2,6-dichloro-p-hydroquinone 1,2-dioxygenase activity",
  "GO:0018575": "chlorocatechol 1,2-dioxygenase activity",
  "GO:0018576": "catechol 1,2-dioxygenase activity",
  "GO:0018577": "catechol 2,3-dioxygenase activity",
  "GO:0018578": "protocatechuate 3,4-dioxygenase activity",
  "GO:0018579": "protocatechuate 4,5-dioxygenase activity",
  "GO:0018580": "nitronate monooxygenase activity",
  "GO:0018581": "hydroxyquinol 1,2-dioxygenase activity",
  "GO:0018582": "1-hydroxy-2-naphthoate 1,2-dioxygenase activity",
  "GO:0018583": "biphenyl-2,3-diol 1,2-dioxygenase activity",
  "GO:0018584": "2,4,5-trichlorophenoxyacetic acid oxygenase activity",
  "GO:0018585": "fluorene oxygenase activity",
  "GO:0018586": "mono-butyltin dioxygenase activity",
  "GO:0018587": "obsolete limonene 8-monooxygenase activity",
  "GO:0018588": "tri-n-butyltin dioxygenase activity",
  "GO:0018589": "di-n-butyltin dioxygenase activity",
  "GO:0018590": "methylsilanetriol hydroxylase activity",
  "GO:0018591": "methyl tertiary butyl ether 3-monooxygenase activity",
  "GO:0018592": "4-nitrocatechol 4-monooxygenase activity",
  "GO:0018593": "4-chlorophenoxyacetate monooxygenase activity",
  "GO:0018594": "tert-butanol 2-monooxygenase activity",
  "GO:0018595": "alpha-pinene monooxygenase activity",
  "GO:0018596": "dimethylsilanediol hydroxylase activity",
  "GO:0018597": "ammonia monooxygenase activity",
  "GO:0018598": "hydroxymethylsilanetriol oxidase activity",
  "GO:0018599": "2-hydroxyisobutyrate 3-monooxygenase activity",
  "GO:0018600": "alpha-pinene dehydrogenase activity",
  "GO:0018601": "4-nitrophenol 2-monooxygenase activity",
  "GO:0018602": "2,4-dichlorophenoxyacetate alpha-ketoglutarate dioxygenase activity",
  "GO:0018603": "nitrobenzene 1,2-dioxygenase activity",
  "GO:0018604": "4-aminobenzoate 3,4-dioxygenase (deaminating) activity",
  "GO:0018606": "benzenesulfonate dioxygenase activity",
  "GO:0018607": "1-indanone monooxygenase activity",
  "GO:0018608": "1-indanone dioxygenase activity",
  "GO:0018609": "chlorobenzene dioxygenase activity",
  "GO:0018610": "dibenzofuran 4,4a-dioxygenase activity",
  "GO:0018611": "toluate dioxygenase activity",
  "GO:0018612": "dibenzothiophene dioxygenase activity",
  "GO:0018613": "9-fluorenone dioxygenase activity",
  "GO:0018614": "ethylbenzene dioxygenase activity",
  "GO:0018615": "2-indanone monooxygenase activity",
  "GO:0018616": "trihydroxytoluene dioxygenase activity",
  "GO:0018617": "4-aminobenzenesulfonate 3,4-dioxygenase (deaminating) activity",
  "GO:0018618": "anthranilate 1,2-dioxygenase (deaminating, decarboxylating) activity",
  "GO:0018619": "benzene 1,2-dioxygenase activity",
  "GO:0018620": "phthalate 4,5-dioxygenase activity",
  "GO:0018621": "4-sulfobenzoate 3,4-dioxygenase activity",
  "GO:0018622": "4-chlorophenylacetate 3,4-dioxygenase activity",
  "GO:0018623": "benzoate 1,2-dioxygenase activity",
  "GO:0018624": "toluene dioxygenase activity",
  "GO:0018625": "naphthalene 1,2-dioxygenase activity",
  "GO:0018626": "2-chlorobenzoate 1,2-dioxygenase activity",
  "GO:0018627": "2-aminobenzenesulfonate 2,3-dioxygenase activity",
  "GO:0018628": "terephthalate 1,2-dioxygenase activity",
  "GO:0018629": "2-hydroxyquinoline 5,6-dioxygenase activity",
  "GO:0018630": "3,5-xylenol methylhydroxylase activity",
  "GO:0018631": "phenylacetate hydroxylase activity",
  "GO:0018632": "4-nitrophenol 4-monooxygenase activity",
  "GO:0018633": "dimethyl sulfide monooxygenase activity",
  "GO:0018634": "alpha-pinene monooxygenase [NADH] activity",
  "GO:0018635": "(R)-limonene 1,2-monooxygenase activity",
  "GO:0018636": "phenanthrene 9,10-monooxygenase activity",
  "GO:0018637": "1-hydroxy-2-naphthoate hydroxylase activity",
  "GO:0018638": "toluene 4-monooxygenase activity",
  "GO:0018639": "xylene monooxygenase activity",
  "GO:0018640": "dibenzothiophene monooxygenase activity",
  "GO:0018641": "6-hydroxy-3-methyl-2-oxo-1,2-dihydroquinoline 6-monooxygenase activity",
  "GO:0018642": "chlorophenol 4-monooxygenase activity",
  "GO:0018643": "carbon disulfide oxygenase activity",
  "GO:0018644": "toluene 2-monooxygenase activity",
  "GO:0018645": "alkene monooxygenase activity",
  "GO:0018646": "1-hydroxy-2-oxolimonene 1,2-monooxygenase activity",
  "GO:0018647": "phenanthrene 1,2-monooxygenase activity",
  "GO:0018648": "methanesulfonate monooxygenase activity",
  "GO:0018649": "tetrahydrofuran hydroxylase activity",
  "GO:0018650": "styrene monooxygenase activity",
  "GO:0018651": "toluene-4-sulfonate monooxygenase activity",
  "GO:0018652": "toluene-sulfonate methyl-monooxygenase activity",
  "GO:0018653": "3-methyl-2-oxo-1,2-dihydroquinoline 6-monooxygenase activity",
  "GO:0018654": "2-hydroxy-phenylacetate hydroxylase activity",
  "GO:0018655": "2-oxo-delta3-4,5,5-trimethylcyclopentenylacetyl-CoA 1,2-monooxygenase activity",
  "GO:0018656": "phenanthrene 3,4-monooxygenase activity",
  "GO:0018657": "toluene 3-monooxygenase activity",
  "GO:0018658": "salicylate 1-monooxygenase activity",
  "GO:0018659": "4-hydroxybenzoate 3-monooxygenase activity",
  "GO:0018660": "4-hydroxyphenylacetate,NADH:oxygen oxidoreductase (3-hydroxylating) activity",
  "GO:0018661": "orcinol 2-monooxygenase activity",
  "GO:0018662": "phenol 2-monooxygenase activity",
  "GO:0018663": "2,6-dihydroxypyridine 3-monooxygenase activity",
  "GO:0018664": "benzoate 4-monooxygenase activity",
  "GO:0018665": "4-hydroxyphenylacetate 1-monooxygenase activity",
  "GO:0018666": "2,4-dichlorophenol 6-monooxygenase activity",
  "GO:0018667": "cyclohexanone monooxygenase activity",
  "GO:0018668": "3-hydroxybenzoate 4-monooxygenase activity",
  "GO:0018669": "3-hydroxybenzoate 6-monooxygenase activity",
  "GO:0018670": "4-aminobenzoate 1-monooxygenase activity",
  "GO:0018671": "4-hydroxybenzoate 3-monooxygenase [NAD(P)H] activity",
  "GO:0018672": "anthranilate 3-monooxygenase (deaminating) activity",
  "GO:0018673": "anthraniloyl-CoA monooxygenase activity",
  "GO:0018674": "(S)-limonene 3-monooxygenase activity",
  "GO:0018675": "(S)-limonene 6-monooxygenase activity",
  "GO:0018676": "(S)-limonene 7-monooxygenase activity",
  "GO:0018677": "pentachlorophenol monooxygenase activity",
  "GO:0018678": "4-hydroxybenzoate 1-hydroxylase activity",
  "GO:0018679": "dibenzothiophene-5,5-dioxide monooxygenase activity",
  "GO:0018680": "deethylatrazine monooxygenase activity",
  "GO:0018681": "deisopropylatrazine monooxygenase activity",
  "GO:0018682": "atrazine N-dealkylase activity",
  "GO:0018683": "camphor 5-monooxygenase activity",
  "GO:0018684": "camphor 1,2-monooxygenase activity",
  "GO:0018685": "alkane 1-monooxygenase activity",
  "GO:0018686": "6-hydroxy pseudo-oxynicotine monooxygenase activity",
  "GO:0018687": "biphenyl 2,3-dioxygenase activity",
  "GO:0018688": "DDT 2,3-dioxygenase activity",
  "GO:0018689": "naphthalene disulfonate 1,2-dioxygenase activity",
  "GO:0018690": "4-methoxybenzoate monooxygenase (O-demethylating) activity",
  "GO:0018693": "ethylbenzene hydroxylase activity",
  "GO:0018694": "p-cymene methyl hydroxylase activity",
  "GO:0018695": "4-cresol dehydrogenase (hydroxylating) activity",
  "GO:0018697": "carbonyl sulfide nitrogenase activity",
  "GO:0018698": "vinyl chloride reductive dehalogenase activity",
  "GO:0018699": "1,1,1-trichloroethane reductive dehalogenase activity",
  "GO:0018700": "2-chloro-N-isopropylacetanilide reductive dehalogenase activity",
  "GO:0018701": "2,5-dichlorohydroquinone reductive dehalogenase activity",
  "GO:0018702": "1,1-dichloro-2,2-bis(4-chlorophenyl)ethene dehalogenase activity",
  "GO:0018703": "2,4-dichlorophenoxyacetate dehalogenase activity",
  "GO:0018704": "obsolete 5-chloro-2-hydroxymuconic semialdehyde dehalogenase activity",
  "GO:0018705": "1,2-dichloroethene reductive dehalogenase activity",
  "GO:0018706": "pyrogallol hydroxytransferase activity",
  "GO:0018707": "1-phenanthrol methyltransferase activity",
  "GO:0018708": "thiol S-methyltransferase activity",
  "GO:0018710": "acetone carboxylase activity",
  "GO:0018711": "benzoyl acetate-CoA thiolase activity",
  "GO:0018712": "3-hydroxybutyryl-CoA thiolase activity",
  "GO:0018713": "3-ketopimelyl-CoA thiolase activity",
  "GO:0018715": "9-phenanthrol UDP-glucuronosyltransferase activity",
  "GO:0018716": "1-phenanthrol glycosyltransferase activity",
  "GO:0018717": "9-phenanthrol glycosyltransferase activity",
  "GO:0018718": "1,2-dihydroxy-phenanthrene glycosyltransferase activity",
  "GO:0018719": "6-aminohexanoate transaminase activity",
  "GO:0018720": "phenol kinase activity",
  "GO:0018721": "trans-9R,10R-dihydrodiolphenanthrene sulfotransferase activity",
  "GO:0018722": "1-phenanthrol sulfotransferase activity",
  "GO:0018723": "3-phenanthrol sulfotransferase activity",
  "GO:0018724": "4-phenanthrol sulfotransferase activity",
  "GO:0018725": "trans-3,4-dihydrodiolphenanthrene sulfotransferase activity",
  "GO:0018726": "9-phenanthrol sulfotransferase activity",
  "GO:0018727": "2-phenanthrol sulfotransferase activity",
  "GO:0018729": "propionate CoA-transferase activity",
  "GO:0018730": "glutaconate CoA-transferase activity",
  "GO:0018731": "1-oxa-2-oxocycloheptane lactonase activity",
  "GO:0018732": "sulfolactone hydrolase activity",
  "GO:0018733": "3,4-dihydrocoumarin hydrolase activity",
  "GO:0018734": "butyrolactone hydrolase activity",
  "GO:0018736": "6-oxo-2-hydroxycyclohexane-1-carboxyl-CoA hydrolase activity",
  "GO:0018737": "2-ketocyclohexane-1-carboxyl-CoA hydrolase activity",
  "GO:0018738": "S-formylglutathione hydrolase activity",
  "GO:0018739": "4-hydroxybenzoyl-CoA thioesterase activity",
  "GO:0018740": "2'-hydroxybiphenyl-2-sulfinate desulfinase activity",
  "GO:0018741": "alkyl sulfatase activity",
  "GO:0018742": "epoxide hydrolase B activity",
  "GO:0018743": "phenanthrene-9,10-epoxide hydrolase (9R,10R-forming) activity",
  "GO:0018744": "limonene-1,2-epoxide hydrolase activity",
  "GO:0018745": "epoxide hydrolase A activity",
  "GO:0018746": "phenanthrene-3,4-epoxide hydrolase activity",
  "GO:0018747": "phenanthrene-1,2-epoxide hydrolase activity",
  "GO:0018748": "iprodione amidohydrolase activity",
  "GO:0018749": "(3,5-dichlorophenylurea)acetate amidohydrolase activity",
  "GO:0018750": "biuret amidohydrolase activity",
  "GO:0018751": "3,5-dichlorophenylcarboximide hydrolase activity",
  "GO:0018752": "epsilon-caprolactam lactamase activity",
  "GO:0018753": "cyanuric acid amidohydrolase activity",
  "GO:0018754": "ammelide aminohydrolase activity",
  "GO:0018755": "2-chloro-4-hydroxy-6-amino-1,3,5-triazine aminohydrolase activity",
  "GO:0018756": "ammeline aminohydrolase activity",
  "GO:0018757": "deisopropylhydroxyatrazine aminohydrolase activity",
  "GO:0018758": "2,4-dihydroxy-6-(N'-ethyl)amino-1,3,5-triazine aminohydrolase activity",
  "GO:0018759": "methenyltetrahydromethanopterin cyclohydrolase activity",
  "GO:0018760": "thiocyanate hydrolase activity",
  "GO:0018761": "bromoxynil nitrilase activity",
  "GO:0018762": "aliphatic nitrilase activity",
  "GO:0018763": "hydroxydechloroatrazine ethylaminohydrolase activity",
  "GO:0018764": "N-isopropylammelide isopropylaminohydrolase activity",
  "GO:0018765": "2-hydroxy-6-oxohepta-2,4-dienoate hydrolase activity",
  "GO:0018766": "dihydrophloroglucinol hydrolase activity",
  "GO:0018767": "2-hydroxy-6-oxo-7-methylocta-2,4-dienoate hydrolase activity",
  "GO:0018768": "2-hydroxy-6-oxo-6-(2'-aminophenyl)hexa-2,4-dienoate hydrolase activity",
  "GO:0018769": "2-hydroxy-6-oxoocta-2,4-dienoate hydrolase activity",
  "GO:0018770": "6-oxo-2-hydroxy-7-(4'-chlorophenyl)-3,8,8-trichloroocta-2E,4E,7-trienoate hydrolase activity",
  "GO:0018771": "2-hydroxy-6-oxonona-2,4-dienedioate hydrolase activity",
  "GO:0018772": "trioxoheptanoate hydrolase activity",
  "GO:0018773": "acetylpyruvate hydrolase activity",
  "GO:0018774": "2,6-dioxo-6-phenylhexa-3-enoate hydrolase activity",
  "GO:0018775": "2-hydroxymuconate-semialdehyde hydrolase activity",
  "GO:0018776": "trans-chloroacrylic acid dehalogenase activity",
  "GO:0018777": "1,3,4,6-tetrachloro-1,4-cyclohexadiene halidohydrolase activity",
  "GO:0018778": "DL-2 haloacid dehalogenase activity",
  "GO:0018779": "obsolete 2-chloro-4,6-dihydroxy-1,3,5-triazine hydrolase activity",
  "GO:0018780": "dichloroacetate halidohydrolase activity",
  "GO:0018781": "S-triazine hydrolase activity",
  "GO:0018782": "cis-chloroacrylic acid dehalogenase activity",
  "GO:0018783": "deisopropyldeethylatrazine hydrolase activity",
  "GO:0018784": "(S)-2-haloacid dehalogenase activity",
  "GO:0018785": "haloacetate dehalogenase activity",
  "GO:0018786": "haloalkane dehalogenase activity",
  "GO:0018787": "4-chlorobenzoyl-CoA dehalogenase activity",
  "GO:0018788": "atrazine chlorohydrolase activity",
  "GO:0018789": "cyclamate sulfohydrolase activity",
  "GO:0018791": "2-hydroxy-3-carboxy-6-oxo-7-methylocta-2,4-dienoate decarboxylase activity",
  "GO:0018792": "bis(4-chlorophenyl)acetate decarboxylase activity",
  "GO:0018793": "3,5-dibromo-4-hydroxybenzoate decarboxylase activity",
  "GO:0018794": "2-hydroxyisobutyrate decarboxylase activity",
  "GO:0018795": "2-hydroxy-2-methyl-1,3-dicarbonate decarboxylase activity",
  "GO:0018796": "4,5-dihydroxyphthalate decarboxylase activity",
  "GO:0018798": "gallate decarboxylase activity",
  "GO:0018799": "4-hydroxybenzoate decarboxylase activity",
  "GO:0018800": "5-oxopent-3-ene-1,2,5-tricarboxylate decarboxylase activity",
  "GO:0018801": "glutaconyl-CoA decarboxylase activity",
  "GO:0018802": "2,4-dihydroxyhept-2-ene-1,7-dioate aldolase activity",
  "GO:0018803": "4-(2-carboxyphenyl)-2-oxobut-3-enoate aldolase activity",
  "GO:0018805": "benzylsuccinate synthase activity",
  "GO:0018807": "6-hydroxycyclohex-1-ene-1-carboxyl-CoA hydratase activity",
  "GO:0018808": "trans-4-(1'-hydroxynaphth-2'-yl)-2-oxobut-3-enoate hydratase-aldolase activity",
  "GO:0018809": "E-phenylitaconyl-CoA hydratase activity",
  "GO:0018810": "trans-4-[2-(3-hydroxy)-thionaphthenyl]-2-oxo-3-butenoate hydratase activity",
  "GO:0018811": "cyclohex-1-ene-1-carboxyl-CoA hydratase activity",
  "GO:0018812": "3-hydroxyacyl-CoA dehydratase activity",
  "GO:0018813": "trans-o-hydroxybenzylidenepyruvate hydratase-aldolase activity",
  "GO:0018814": "phenylacetaldoxime dehydratase activity",
  "GO:0018815": "3-methyl-5-hydroxy-6-(3-carboxy-3-oxopropenyl)-1H-2-pyridon hydratase-aldolase activity",
  "GO:0018816": "2-hydroxyisobutyrate dehydratase activity",
  "GO:0018817": "2-oxo-hept-3-ene-1,7-dioate hydratase activity",
  "GO:0018818": "acetylene hydratase activity",
  "GO:0018819": "lactoyl-CoA dehydratase activity",
  "GO:0018820": "cyanamide hydratase activity",
  "GO:0018822": "nitrile hydratase activity",
  "GO:0018823": "cyclohexa-1,5-dienecarbonyl-CoA hydratase activity",
  "GO:0018824": "(hydroxyamino)benzene mutase activity",
  "GO:0018825": "triethanolamine lyase activity",
  "GO:0018826": "methionine gamma-lyase activity",
  "GO:0018827": "1-chloro-2,2-bis(4-chlorophenyl)ethane dehydrochlorinase activity",
  "GO:0018828": "halohydrin hydrogen-halide-lyase A activity",
  "GO:0018829": "1,1-dichloro-2,2-bis(4-chlorophenyl)ethane dehydrochlorinase activity",
  "GO:0018830": "gamma-hexachlorocyclohexane dehydrochlorinase activity",
  "GO:0018831": "5-chloro-1,2,4-trihydroxybenzene dechlorinase activity",
  "GO:0018832": "halohydrin hydrogen-halide-lyase B activity",
  "GO:0018833": "DDT-dehydrochlorinase activity",
  "GO:0018834": "dichloromethane dehalogenase activity",
  "GO:0018835": "carbon phosphorus lyase activity",
  "GO:0018836": "alkylmercury lyase activity",
  "GO:0018837": "2-hydroxy-2H-benzo[h]chromene-2-carboxylate isomerase activity",
  "GO:0018838": "mandelate racemase activity",
  "GO:0018839": "cis-4-[2-(3-hydroxy)-thionaphthenyl]-2-oxo-3-butenoate isomerase activity",
  "GO:0018842": "3-carboxymuconate cycloisomerase type II activity",
  "GO:0018844": "2-hydroxytetrahydrofuran isomerase activity",
  "GO:0018845": "2-hydroxychromene-2-carboxylate isomerase activity",
  "GO:0018846": "styrene-oxide isomerase activity",
  "GO:0018847": "alpha-pinene lyase activity",
  "GO:0018848": "pinocarveol isomerase activity",
  "GO:0018849": "muconate cycloisomerase activity",
  "GO:0018850": "chloromuconate cycloisomerase activity",
  "GO:0018851": "alpha-pinene-oxide decyclase activity",
  "GO:0018852": "dichloromuconate cycloisomerase activity",
  "GO:0018853": "obsolete perillyl-CoA synthetase activity",
  "GO:0018854": "3-isopropenyl-6-oxoheptanoyl-CoA synthetase activity",
  "GO:0018855": "2-oxo-delta3-4,5,5-trimethylcyclopentenylacetyl-CoA synthetase activity",
  "GO:0018856": "benzoyl acetate-CoA ligase activity",
  "GO:0018857": "2,4-dichlorobenzoate-CoA ligase activity",
  "GO:0018858": "benzoate-CoA ligase activity",
  "GO:0018859": "4-hydroxybenzoate-CoA ligase activity",
  "GO:0018860": "anthranilate-CoA ligase activity",
  "GO:0018861": "4-chlorobenzoate-CoA ligase activity",
  "GO:0018862": "phenylphosphate carboxylase activity",
  "GO:0018863": "phenanthrene-9,10-epoxide hydrolase (9S,10S-forming) activity",
  "GO:0018864": "acetylene metabolic process",
  "GO:0018865": "acrylonitrile metabolic process",
  "GO:0018866": "adamantanone metabolic process",
  "GO:0018867": "alpha-pinene metabolic process",
  "GO:0018868": "2-aminobenzenesulfonate metabolic process",
  "GO:0018870": "anaerobic 2-aminobenzoate metabolic process",
  "GO:0018871": "1-aminocyclopropane-1-carboxylate metabolic process",
  "GO:0018872": "arsonoacetate metabolic process",
  "GO:0018873": "atrazine metabolic process",
  "GO:0018874": "benzoate metabolic process",
  "GO:0018875": "anaerobic benzoate metabolic process",
  "GO:0018876": "benzonitrile metabolic process",
  "GO:0018877": "beta-1,2,3,4,5,6-hexachlorocyclohexane metabolic process",
  "GO:0018878": "aerobic beta-1,2,3,4,5,6-hexachlorocyclohexane metabolic process",
  "GO:0018879": "biphenyl metabolic process",
  "GO:0018880": "4-chlorobiphenyl metabolic process",
  "GO:0018881": "bromoxynil metabolic process",
  "GO:0018882": "(+)-camphor metabolic process",
  "GO:0018883": "caprolactam metabolic process",
  "GO:0018884": "carbazole metabolic process",
  "GO:0018885": "carbon tetrachloride metabolic process",
  "GO:0018886": "anaerobic carbon tetrachloride metabolic process",
  "GO:0018887": "4-carboxy-4'-sulfoazobenzene metabolic process",
  "GO:0018888": "3-chloroacrylic acid metabolic process",
  "GO:0018889": "2-chloro-N-isopropylacetanilide metabolic process",
  "GO:0018890": "cyanamide metabolic process",
  "GO:0018891": "cyclohexanol metabolic process",
  "GO:0018892": "cyclohexylsulfamate metabolic process",
  "GO:0018893": "dibenzofuran metabolic process",
  "GO:0018894": "dibenzo-p-dioxin metabolic process",
  "GO:0018895": "dibenzothiophene metabolic process",
  "GO:0018896": "dibenzothiophene catabolic process",
  "GO:0018897": "dibenzothiophene desulfurization",
  "GO:0018898": "2,4-dichlorobenzoate metabolic process",
  "GO:0018899": "1,2-dichloroethane metabolic process",
  "GO:0018900": "dichloromethane metabolic process",
  "GO:0018901": "2,4-dichlorophenoxyacetic acid metabolic process",
  "GO:0018902": "1,3-dichloro-2-propanol metabolic process",
  "GO:0018903": "1,3-dichloropropene metabolic process",
  "GO:0018904": "ether metabolic process",
  "GO:0018905": "dimethyl ether metabolic process",
  "GO:0018906": "methyl tert-butyl ether metabolic process",
  "GO:0018907": "dimethyl sulfoxide metabolic process",
  "GO:0018908": "organosulfide cycle",
  "GO:0018909": "dodecyl sulfate metabolic process",
  "GO:0018910": "benzene metabolic process",
  "GO:0018911": "1,2,4-trichlorobenzene metabolic process",
  "GO:0018912": "1,4-dichlorobenzene metabolic process",
  "GO:0018913": "anaerobic ethylbenzene metabolic process",
  "GO:0018914": "chlorobenzene metabolic process",
  "GO:0018915": "ethylbenzene metabolic process",
  "GO:0018916": "nitrobenzene metabolic process",
  "GO:0018917": "fluorene metabolic process",
  "GO:0018918": "gallate metabolic process",
  "GO:0018919": "gamma-1,2,3,4,5,6-hexachlorocyclohexane metabolic process",
  "GO:0018920": "glyphosate metabolic process",
  "GO:0018921": "3-hydroxybenzyl alcohol metabolic process",
  "GO:0018922": "iprodione metabolic process",
  "GO:0018923": "limonene metabolic process",
  "GO:0018924": "mandelate metabolic process",
  "GO:0018925": "m-cresol metabolic process",
  "GO:0018926": "methanesulfonic acid metabolic process",
  "GO:0018927": "obsolete methionine and threonine metabolic process",
  "GO:0018928": "methyl ethyl ketone metabolic process",
  "GO:0018929": "methyl fluoride metabolic process",
  "GO:0018930": "3-methylquinoline metabolic process",
  "GO:0018931": "naphthalene metabolic process",
  "GO:0018933": "nicotine metabolic process",
  "GO:0018934": "nitrilotriacetate metabolic process",
  "GO:0018935": "aerobic nitrilotriacetate metabolic process",
  "GO:0018936": "anaerobic nitrilotriacetate metabolic process",
  "GO:0018937": "nitroglycerin metabolic process",
  "GO:0018938": "2-nitropropane metabolic process",
  "GO:0018939": "n-octane metabolic process",
  "GO:0018940": "orcinol metabolic process",
  "GO:0018941": "organomercury metabolic process",
  "GO:0018942": "organometal metabolic process",
  "GO:0018943": "organotin metabolic process",
  "GO:0018944": "tri-n-butyltin metabolic process",
  "GO:0018945": "organosilicon metabolic process",
  "GO:0018946": "aerobic organosilicon metabolic process",
  "GO:0018947": "anaerobic organosilicon metabolic process",
  "GO:0018948": "xylene metabolic process",
  "GO:0018949": "m-xylene metabolic process",
  "GO:0018950": "o-xylene metabolic process",
  "GO:0018951": "p-xylene metabolic process",
  "GO:0018952": "parathion metabolic process",
  "GO:0018953": "p-cymene metabolic process",
  "GO:0018954": "pentaerythritol tetranitrate metabolic process",
  "GO:0018955": "phenanthrene metabolic process",
  "GO:0018956": "phenanthrene catabolic process via trans-9(R),10(R)-dihydrodiolphenanthrene",
  "GO:0018957": "phenanthrene catabolic process via trans-9(S),10(S)-dihydrodiolphenanthrene",
  "GO:0018958": "phenol-containing compound metabolic process",
  "GO:0018959": "aerobic phenol-containing compound metabolic process",
  "GO:0018960": "4-nitrophenol metabolic process",
  "GO:0018961": "pentachlorophenol metabolic process",
  "GO:0018962": "3-phenylpropionate metabolic process",
  "GO:0018963": "phthalate metabolic process",
  "GO:0018964": "propylene metabolic process",
  "GO:0018965": "s-triazine compound metabolic process",
  "GO:0018966": "styrene metabolic process",
  "GO:0018967": "tetrachloroethylene metabolic process",
  "GO:0018968": "tetrahydrofuran metabolic process",
  "GO:0018969": "thiocyanate metabolic process",
  "GO:0018970": "toluene metabolic process",
  "GO:0018971": "anaerobic toluene metabolic process",
  "GO:0018972": "toluene-4-sulfonate metabolic process",
  "GO:0018973": "trinitrotoluene metabolic process",
  "GO:0018974": "2,4,6-trinitrotoluene metabolic process",
  "GO:0018975": "anaerobic 2,4,6-trinitrotoluene metabolic process",
  "GO:0018976": "1,2,3-tribromopropane metabolic process",
  "GO:0018977": "1,1,1-trichloro-2,2-bis-(4-chlorophenyl)ethane metabolic process",
  "GO:0018978": "anaerobic 1,1,1-trichloro-2,2-bis-(4-chlorophenyl)ethane metabolic process",
  "GO:0018979": "trichloroethylene metabolic process",
  "GO:0018980": "2,4,5-trichlorophenoxyacetic acid metabolic process",
  "GO:0018981": "triethanolamine metabolic process",
  "GO:0018982": "vanillin metabolic process",
  "GO:0018983": "Z-phenylacetaldoxime metabolic process",
  "GO:0018984": "naphthalenesulfonate metabolic process",
  "GO:0018985": "pronuclear envelope synthesis",
  "GO:0018988": "obsolete molting cycle, protein-based cuticle",
  "GO:0018989": "apolysis",
  "GO:0018990": "ecdysis, chitin-based cuticle",
  "GO:0018991": "oviposition",
  "GO:0018992": "germ-line sex determination",
  "GO:0018993": "somatic sex determination",
  "GO:0018995": "host",
  "GO:0018996": "molting cycle, collagen and cuticulin-based cuticle",
  "GO:0018997": "obsolete electron transfer carrier",
  "GO:0018998": "obsolete metaxin",
  "GO:0019000": "obsolete endonuclease G activity",
  "GO:0019001": "guanyl nucleotide binding",
  "GO:0019002": "GMP binding",
  "GO:0019003": "GDP binding",
  "GO:0019005": "SCF ubiquitin ligase complex",
  "GO:0019008": "molybdopterin synthase complex",
  "GO:0019010": "farnesoic acid O-methyltransferase activity",
  "GO:0019011": "obsolete DNA replication accessory factor",
  "GO:0019012": "virion",
  "GO:0019013": "viral nucleocapsid",
  "GO:0019015": "viral genome",
  "GO:0019016": "non-segmented viral genome",
  "GO:0019017": "segmented viral genome",
  "GO:0019018": "bipartite viral genome",
  "GO:0019019": "tripartite viral genome",
  "GO:0019020": "multipartite viral genome",
  "GO:0019021": "DNA viral genome",
  "GO:0019022": "RNA viral genome",
  "GO:0019023": "dsRNA viral genome",
  "GO:0019024": "ssRNA viral genome",
  "GO:0019025": "positive sense viral genome",
  "GO:0019026": "negative sense viral genome",
  "GO:0019027": "ambisense viral genome",
  "GO:0019028": "viral capsid",
  "GO:0019029": "helical viral capsid",
  "GO:0019030": "icosahedral viral capsid",
  "GO:0019031": "viral envelope",
  "GO:0019032": "obsolete viral glycoprotein",
  "GO:0019033": "viral tegument",
  "GO:0019034": "viral replication complex",
  "GO:0019035": "viral integration complex",
  "GO:0019036": "viral transcriptional complex",
  "GO:0019037": "viral assembly intermediate",
  "GO:0019038": "provirus",
  "GO:0019039": "obsolete viral-cell fusion molecule activity",
  "GO:0019040": "obsolete viral host shutoff protein",
  "GO:0019042": "viral latency",
  "GO:0019043": "establishment of viral latency",
  "GO:0019044": "maintenance of viral latency",
  "GO:0019045": "latent virus replication",
  "GO:0019046": "release from viral latency",
  "GO:0019048": "modulation by virus of host morphology or physiology",
  "GO:0019049": "evasion or tolerance of host defenses by virus",
  "GO:0019050": "suppression by virus of host apoptotic process",
  "GO:0019051": "induction by virus of host apoptotic process",
  "GO:0019054": "modulation by virus of host process",
  "GO:0019055": "modification by virus of host cell cycle regulation",
  "GO:0019056": "modulation by virus of host transcription",
  "GO:0019057": "modulation by virus of host translation",
  "GO:0019058": "viral life cycle",
  "GO:0019059": "obsolete initiation of viral infection",
  "GO:0019060": "intracellular transport of viral protein in host cell",
  "GO:0019061": "uncoating of virus",
  "GO:0019062": "virion attachment to host cell",
  "GO:0019064": "fusion of virus membrane with host plasma membrane",
  "GO:0019065": "receptor-mediated endocytosis of virus by host cell",
  "GO:0019066": "obsolete translocation of virus into host cell",
  "GO:0019068": "virion assembly",
  "GO:0019069": "viral capsid assembly",
  "GO:0019070": "viral genome maturation",
  "GO:0019071": "viral DNA cleavage involved in viral genome maturation",
  "GO:0019072": "viral genome packaging",
  "GO:0019073": "viral DNA genome packaging",
  "GO:0019074": "viral RNA genome packaging",
  "GO:0019075": "virus maturation",
  "GO:0019076": "viral release from host cell",
  "GO:0019078": "obsolete lytic viral budding",
  "GO:0019079": "viral genome replication",
  "GO:0019080": "viral gene expression",
  "GO:0019081": "viral translation",
  "GO:0019082": "viral protein processing",
  "GO:0019083": "viral transcription",
  "GO:0019084": "middle viral transcription",
  "GO:0019085": "early viral transcription",
  "GO:0019086": "late viral transcription",
  "GO:0019087": "transformation of host cell by virus",
  "GO:0019088": "immortalization of host cell by virus",
  "GO:0019089": "transmission of virus",
  "GO:0019090": "mitochondrial rRNA export from mitochondrion",
  "GO:0019091": "mitochondrial lrRNA export from mitochondrion",
  "GO:0019092": "mitochondrial srRNA export from mitochondrion",
  "GO:0019093": "mitochondrial RNA localization",
  "GO:0019094": "pole plasm mRNA localization",
  "GO:0019095": "pole plasm mitochondrial rRNA localization",
  "GO:0019096": "pole plasm mitochondrial lrRNA localization",
  "GO:0019097": "pole plasm mitochondrial srRNA localization",
  "GO:0019098": "reproductive behavior",
  "GO:0019099": "female germ-line sex determination",
  "GO:0019100": "male germ-line sex determination",
  "GO:0019101": "female somatic sex determination",
  "GO:0019102": "male somatic sex determination",
  "GO:0019103": "pyrimidine nucleotide binding",
  "GO:0019104": "DNA N-glycosylase activity",
  "GO:0019105": "N-palmitoyltransferase activity",
  "GO:0019107": "myristoyltransferase activity",
  "GO:0019108": "aryl-aldehyde dehydrogenase (NAD) activity",
  "GO:0019111": "phenanthrol sulfotransferase activity",
  "GO:0019112": "phenanthrol glycosyltransferase activity",
  "GO:0019113": "limonene monooxygenase activity",
  "GO:0019114": "catechol dioxygenase activity",
  "GO:0019115": "benzaldehyde dehydrogenase activity",
  "GO:0019116": "hydroxy-nicotine oxidase activity",
  "GO:0019117": "dihydroxyfluorene dioxygenase activity",
  "GO:0019118": "phenanthrene-epoxide hydrolase activity",
  "GO:0019119": "phenanthrene-9,10-epoxide hydrolase activity",
  "GO:0019120": "hydrolase activity, acting on acid halide bonds, in C-halide compounds",
  "GO:0019121": "peptidoglycan-protein cross-linking via N6-mureinyl-L-lysine",
  "GO:0019122": "peptidyl-D-alanine racemization",
  "GO:0019123": "peptidyl-methionine racemization",
  "GO:0019124": "peptidyl-isoleucine racemization",
  "GO:0019125": "peptidyl-phenylalanine racemization",
  "GO:0019126": "peptidyl-serine racemization",
  "GO:0019128": "peptidyl-tryptophan racemization",
  "GO:0019129": "peptidyl-leucine racemization",
  "GO:0019131": "obsolete tripeptidyl-peptidase I activity",
  "GO:0019132": "obsolete C-terminal processing peptidase activity",
  "GO:0019133": "choline monooxygenase activity",
  "GO:0019134": "glucosamine-1-phosphate N-acetyltransferase activity",
  "GO:0019135": "deoxyhypusine monooxygenase activity",
  "GO:0019136": "deoxynucleoside kinase activity",
  "GO:0019137": "thioglucosidase activity",
  "GO:0019139": "cytokinin dehydrogenase activity",
  "GO:0019140": "inositol 3-kinase activity",
  "GO:0019141": "2-dehydropantolactone reductase (B-specific) activity",
  "GO:0019142": "2-hydroxyglutarate synthase activity",
  "GO:0019143": "3-deoxy-manno-octulosonate-8-phosphatase activity",
  "GO:0019144": "ADP-sugar diphosphatase activity",
  "GO:0019145": "aminobutyraldehyde dehydrogenase activity",
  "GO:0019146": "arabinose-5-phosphate isomerase activity",
  "GO:0019147": "(R)-aminopropanol dehydrogenase activity",
  "GO:0019148": "D-cysteine desulfhydrase activity",
  "GO:0019149": "3-chloro-D-alanine dehydrochlorinase activity",
  "GO:0019150": "D-ribulokinase activity",
  "GO:0019151": "galactose 1-dehydrogenase activity",
  "GO:0019152": "acetoin dehydrogenase activity",
  "GO:0019153": "protein-disulfide reductase (glutathione) activity",
  "GO:0019154": "glycolate dehydrogenase activity",
  "GO:0019155": "3-(imidazol-5-yl)lactate dehydrogenase activity",
  "GO:0019156": "isoamylase activity",
  "GO:0019157": "malate oxidase activity",
  "GO:0019158": "mannokinase activity",
  "GO:0019159": "nicotinamide-nucleotide amidase activity",
  "GO:0019160": "NMN nucleosidase activity",
  "GO:0019161": "diamine transaminase activity",
  "GO:0019162": "pyridoxamine-oxaloacetate transaminase activity",
  "GO:0019163": "pyridoxamine-phosphate transaminase activity",
  "GO:0019164": "pyruvate synthase activity",
  "GO:0019165": "thiamine kinase activity",
  "GO:0019166": "trans-2-enoyl-CoA reductase (NADPH) activity",
  "GO:0019168": "2-octaprenylphenol hydroxylase activity",
  "GO:0019170": "methylglyoxal reductase (NADH-dependent) activity",
  "GO:0019171": "3-hydroxyacyl-[acyl-carrier-protein] dehydratase activity",
  "GO:0019172": "glyoxalase III activity",
  "GO:0019174": "tetrahydrothiophene 1-oxide reductase activity",
  "GO:0019176": "dihydroneopterin monophosphate phosphatase activity",
  "GO:0019177": "dihydroneopterin triphosphate pyrophosphohydrolase activity",
  "GO:0019178": "NADP phosphatase activity",
  "GO:0019179": "dTDP-4-amino-4,6-dideoxy-D-glucose transaminase activity",
  "GO:0019180": "dTDP-4-amino-4,6-dideoxygalactose transaminase activity",
  "GO:0019181": "halohydrin hydrogen-halide-lyase activity",
  "GO:0019182": "histamine-gated chloride channel activity",
  "GO:0019183": "histamine-gated chloride channel complex",
  "GO:0019184": "nonribosomal peptide biosynthetic process",
  "GO:0019185": "snRNA-activating protein complex",
  "GO:0019186": "acyl-CoA N-acyltransferase activity",
  "GO:0019187": "beta-1,4-mannosyltransferase activity",
  "GO:0019191": "cellobiose transmembrane transporter activity",
  "GO:0019194": "sorbose transmembrane transporter activity",
  "GO:0019196": "galactosamine transmembrane transporter activity",
  "GO:0019197": "phosphoenolpyruvate-dependent sugar phosphotransferase complex",
  "GO:0019198": "transmembrane receptor protein phosphatase activity",
  "GO:0019199": "transmembrane receptor protein kinase activity",
  "GO:0019200": "carbohydrate kinase activity",
  "GO:0019201": "nucleotide kinase activity",
  "GO:0019202": "amino acid kinase activity",
  "GO:0019203": "carbohydrate phosphatase activity",
  "GO:0019204": "obsolete nucleotide phosphatase activity",
  "GO:0019205": "nucleobase-containing compound kinase activity",
  "GO:0019206": "nucleoside kinase activity",
  "GO:0019207": "kinase regulator activity",
  "GO:0019208": "phosphatase regulator activity",
  "GO:0019209": "kinase activator activity",
  "GO:0019210": "kinase inhibitor activity",
  "GO:0019211": "phosphatase activator activity",
  "GO:0019212": "phosphatase inhibitor activity",
  "GO:0019213": "deacetylase activity",
  "GO:0019214": "obsolete surfactant activity",
  "GO:0019215": "intermediate filament binding",
  "GO:0019216": "regulation of lipid metabolic process",
  "GO:0019217": "regulation of fatty acid metabolic process",
  "GO:0019218": "regulation of steroid metabolic process",
  "GO:0019219": "regulation of nucleobase-containing compound metabolic process",
  "GO:0019220": "regulation of phosphate metabolic process",
  "GO:0019221": "cytokine-mediated signaling pathway",
  "GO:0019222": "regulation of metabolic process",
  "GO:0019226": "transmission of nerve impulse",
  "GO:0019227": "neuronal action potential propagation",
  "GO:0019228": "neuronal action potential",
  "GO:0019229": "regulation of vasoconstriction",
  "GO:0019230": "proprioception",
  "GO:0019231": "perception of static position",
  "GO:0019232": "perception of rate of movement",
  "GO:0019233": "sensory perception of pain",
  "GO:0019234": "sensory perception of fast pain",
  "GO:0019235": "sensory perception of slow pain",
  "GO:0019236": "response to pheromone",
  "GO:0019237": "centromeric DNA binding",
  "GO:0019238": "cyclohydrolase activity",
  "GO:0019239": "deaminase activity",
  "GO:0019240": "citrulline biosynthetic process",
  "GO:0019241": "citrulline catabolic process",
  "GO:0019242": "methylglyoxal biosynthetic process",
  "GO:0019243": "methylglyoxal catabolic process to D-lactate via S-lactoyl-glutathione",
  "GO:0019244": "lactate biosynthetic process from pyruvate",
  "GO:0019245": "D(-)-lactate biosynthetic process from pyruvate",
  "GO:0019246": "L(+)-lactate biosynthetic process from pyruvate",
  "GO:0019247": "lactate racemization",
  "GO:0019248": "D-lactate biosynthetic process from methylglyoxal via (R)-lactaldehyde",
  "GO:0019249": "lactate biosynthetic process",
  "GO:0019250": "aerobic cobalamin biosynthetic process",
  "GO:0019251": "anaerobic cobalamin biosynthetic process",
  "GO:0019252": "starch biosynthetic process",
  "GO:0019253": "reductive pentose-phosphate cycle",
  "GO:0019254": "carnitine metabolic process, CoA-linked",
  "GO:0019255": "glucose 1-phosphate metabolic process",
  "GO:0019256": "acrylonitrile catabolic process",
  "GO:0019257": "4-nitrotoluene metabolic process",
  "GO:0019258": "4-nitrotoluene catabolic process",
  "GO:0019260": "1,2-dichloroethane catabolic process",
  "GO:0019261": "1,4-dichlorobenzene catabolic process",
  "GO:0019262": "N-acetylneuraminate catabolic process",
  "GO:0019263": "adamantanone catabolic process",
  "GO:0019264": "glycine biosynthetic process from serine",
  "GO:0019265": "glycine biosynthetic process, by transamination of glyoxylate",
  "GO:0019266": "asparagine biosynthetic process from oxaloacetate",
  "GO:0019267": "asparagine biosynthetic process from cysteine",
  "GO:0019268": "obsolete glutamate biosynthetic process, using glutamate dehydrogenase (NAD(P)+)",
  "GO:0019269": "obsolete glutamate biosynthetic process, using glutamate synthase (NADPH)",
  "GO:0019270": "aerobactin biosynthetic process",
  "GO:0019271": "aerobactin transport",
  "GO:0019272": "L-alanine biosynthetic process from pyruvate",
  "GO:0019273": "L-alanine biosynthetic process via ornithine",
  "GO:0019276": "UDP-N-acetylgalactosamine metabolic process",
  "GO:0019277": "UDP-N-acetylgalactosamine biosynthetic process",
  "GO:0019278": "UDP-N-acetylgalactosamine catabolic process",
  "GO:0019279": "L-methionine biosynthetic process from L-homoserine via cystathionine",
  "GO:0019280": "L-methionine biosynthetic process from homoserine via O-acetyl-L-homoserine and cystathionine",
  "GO:0019281": "L-methionine biosynthetic process from homoserine via O-succinyl-L-homoserine and cystathionine",
  "GO:0019283": "L-methionine biosynthetic process from O-phospho-L-homoserine and cystathionine",
  "GO:0019284": "L-methionine biosynthetic process from S-adenosylmethionine",
  "GO:0019285": "glycine betaine biosynthetic process from choline",
  "GO:0019286": "glycine betaine biosynthetic process from glycine",
  "GO:0019287": "isopentenyl diphosphate biosynthetic process, mevalonate pathway",
  "GO:0019288": "isopentenyl diphosphate biosynthetic process, methylerythritol 4-phosphate pathway",
  "GO:0019289": "rhizobactin 1021 biosynthetic process",
  "GO:0019290": "siderophore biosynthetic process",
  "GO:0019292": "tyrosine biosynthetic process from chorismate via 4-hydroxyphenylpyruvate",
  "GO:0019293": "tyrosine biosynthetic process, by oxidation of phenylalanine",
  "GO:0019294": "keto-3-deoxy-D-manno-octulosonic acid biosynthetic process",
  "GO:0019295": "coenzyme M biosynthetic process",
  "GO:0019296": "coenzyme M metabolic process",
  "GO:0019297": "coenzyme B metabolic process",
  "GO:0019298": "coenzyme B biosynthetic process",
  "GO:0019299": "rhamnose metabolic process",
  "GO:0019300": "rhamnose biosynthetic process",
  "GO:0019301": "rhamnose catabolic process",
  "GO:0019302": "D-ribose biosynthetic process",
  "GO:0019303": "D-ribose catabolic process",
  "GO:0019304": "anaerobic rhamnose catabolic process",
  "GO:0019305": "dTDP-rhamnose biosynthetic process",
  "GO:0019306": "GDP-D-rhamnose biosynthetic process",
  "GO:0019307": "mannose biosynthetic process",
  "GO:0019308": "dTDP-mannose biosynthetic process",
  "GO:0019309": "mannose catabolic process",
  "GO:0019310": "inositol catabolic process",
  "GO:0019311": "sorbose metabolic process",
  "GO:0019312": "L-sorbose metabolic process",
  "GO:0019313": "allose metabolic process",
  "GO:0019314": "D-allose metabolic process",
  "GO:0019315": "D-allose biosynthetic process",
  "GO:0019316": "D-allose catabolic process",
  "GO:0019317": "fucose catabolic process",
  "GO:0019318": "hexose metabolic process",
  "GO:0019319": "hexose biosynthetic process",
  "GO:0019320": "hexose catabolic process",
  "GO:0019321": "pentose metabolic process",
  "GO:0019322": "pentose biosynthetic process",
  "GO:0019323": "pentose catabolic process",
  "GO:0019324": "L-lyxose metabolic process",
  "GO:0019325": "anaerobic fructose catabolic process",
  "GO:0019326": "nitrotoluene metabolic process",
  "GO:0019327": "lead sulfide oxidation",
  "GO:0019328": "anaerobic gallate catabolic process",
  "GO:0019329": "ammonia oxidation",
  "GO:0019330": "aldoxime metabolic process",
  "GO:0019331": "anaerobic respiration, using ammonium as electron donor",
  "GO:0019332": "aerobic respiration, using nitrite as electron donor",
  "GO:0019333": "denitrification pathway",
  "GO:0019334": "p-cymene catabolic process",
  "GO:0019335": "3-methylquinoline catabolic process",
  "GO:0019336": "phenol-containing compound catabolic process",
  "GO:0019337": "tetrachloroethylene catabolic process",
  "GO:0019338": "pentachlorophenol catabolic process",
  "GO:0019339": "parathion catabolic process",
  "GO:0019340": "dibenzofuran catabolic process",
  "GO:0019341": "dibenzo-p-dioxin catabolic process",
  "GO:0019342": "trypanothione biosynthetic process",
  "GO:0019343": "cysteine biosynthetic process via cystathionine",
  "GO:0019344": "cysteine biosynthetic process",
  "GO:0019345": "cysteine biosynthetic process via S-sulfo-L-cysteine",
  "GO:0019346": "transsulfuration",
  "GO:0019347": "GDP-alpha-D-mannosylchitobiosyldiphosphodolichol biosynthetic process",
  "GO:0019348": "dolichol metabolic process",
  "GO:0019349": "ribitol metabolic process",
  "GO:0019350": "teichoic acid biosynthetic process",
  "GO:0019351": "dethiobiotin biosynthetic process",
  "GO:0019352": "protoporphyrinogen IX biosynthetic process from glycine",
  "GO:0019353": "protoporphyrinogen IX biosynthetic process from glutamate",
  "GO:0019354": "siroheme biosynthetic process",
  "GO:0019355": "nicotinamide nucleotide biosynthetic process from aspartate",
  "GO:0019356": "nicotinate nucleotide biosynthetic process from tryptophan",
  "GO:0019357": "nicotinate nucleotide biosynthetic process",
  "GO:0019358": "nicotinate nucleotide salvage",
  "GO:0019359": "nicotinamide nucleotide biosynthetic process",
  "GO:0019360": "nicotinamide nucleotide biosynthetic process from niacinamide",
  "GO:0019361": "2'-(5''-triphosphoribosyl)-3'-dephospho-CoA biosynthetic process",
  "GO:0019362": "pyridine nucleotide metabolic process",
  "GO:0019363": "pyridine nucleotide biosynthetic process",
  "GO:0019364": "pyridine nucleotide catabolic process",
  "GO:0019365": "pyridine nucleotide salvage",
  "GO:0019367": "fatty acid elongation, saturated fatty acid",
  "GO:0019368": "fatty acid elongation, unsaturated fatty acid",
  "GO:0019369": "arachidonic acid metabolic process",
  "GO:0019370": "leukotriene biosynthetic process",
  "GO:0019371": "cyclooxygenase pathway",
  "GO:0019372": "lipoxygenase pathway",
  "GO:0019373": "epoxygenase P450 pathway",
  "GO:0019374": "galactolipid metabolic process",
  "GO:0019375": "galactolipid biosynthetic process",
  "GO:0019376": "galactolipid catabolic process",
  "GO:0019377": "glycolipid catabolic process",
  "GO:0019379": "sulfate assimilation, phosphoadenylyl sulfate reduction by phosphoadenylyl-sulfate reductase (thioredoxin)",
  "GO:0019380": "3-phenylpropionate catabolic process",
  "GO:0019381": "atrazine catabolic process",
  "GO:0019382": "carbon tetrachloride catabolic process",
  "GO:0019383": "(+)-camphor catabolic process",
  "GO:0019384": "caprolactam catabolic process",
  "GO:0019385": "methanogenesis, from acetate",
  "GO:0019386": "methanogenesis, from carbon dioxide",
  "GO:0019387": "methanogenesis, from methanol",
  "GO:0019388": "galactose catabolic process",
  "GO:0019389": "glucuronoside metabolic process",
  "GO:0019390": "glucuronoside biosynthetic process",
  "GO:0019391": "glucuronoside catabolic process",
  "GO:0019392": "glucarate metabolic process",
  "GO:0019393": "glucarate biosynthetic process",
  "GO:0019394": "glucarate catabolic process",
  "GO:0019395": "fatty acid oxidation",
  "GO:0019396": "gallate catabolic process",
  "GO:0019397": "gallate catabolic process via 2-pyrone-4,6-dicarboxylate",
  "GO:0019398": "gallate catabolic process via gallate dioxygenase activity",
  "GO:0019399": "cyclohexanol oxidation",
  "GO:0019400": "alditol metabolic process",
  "GO:0019401": "alditol biosynthetic process",
  "GO:0019402": "galactitol metabolic process",
  "GO:0019403": "galactitol biosynthetic process",
  "GO:0019404": "galactitol catabolic process",
  "GO:0019405": "alditol catabolic process",
  "GO:0019406": "hexitol biosynthetic process",
  "GO:0019407": "hexitol catabolic process",
  "GO:0019408": "dolichol biosynthetic process",
  "GO:0019409": "aerobic respiration, using ammonia as electron donor",
  "GO:0019410": "aerobic respiration, using carbon monoxide as electron donor",
  "GO:0019411": "aerobic respiration, using ferrous ions as electron donor",
  "GO:0019412": "aerobic respiration, using hydrogen as electron donor",
  "GO:0019413": "acetate biosynthetic process",
  "GO:0019414": "aerobic respiration, using sulfur or sulfate as electron donor",
  "GO:0019415": "acetate biosynthetic process from carbon monoxide",
  "GO:0019416": "polythionate oxidation",
  "GO:0019417": "sulfur oxidation",
  "GO:0019418": "sulfide oxidation",
  "GO:0019419": "sulfate reduction",
  "GO:0019420": "dissimilatory sulfate reduction",
  "GO:0019422": "disproportionation of elemental sulfur",
  "GO:0019423": "sulfur oxidation, ferric ion-dependent",
  "GO:0019424": "sulfide oxidation, using siroheme sulfite reductase",
  "GO:0019426": "bisulfite reduction",
  "GO:0019427": "acetyl-CoA biosynthetic process from acetate",
  "GO:0019428": "allantoin biosynthetic process",
  "GO:0019429": "fluorene catabolic process",
  "GO:0019430": "removal of superoxide radicals",
  "GO:0019431": "acetyl-CoA biosynthetic process from ethanol",
  "GO:0019432": "triglyceride biosynthetic process",
  "GO:0019433": "triglyceride catabolic process",
  "GO:0019434": "sophorosyloxydocosanoate metabolic process",
  "GO:0019435": "sophorosyloxydocosanoate biosynthetic process",
  "GO:0019436": "sophorosyloxydocosanoate catabolic process",
  "GO:0019438": "aromatic compound biosynthetic process",
  "GO:0019439": "aromatic compound catabolic process",
  "GO:0019440": "tryptophan catabolic process to indole-3-acetate",
  "GO:0019441": "tryptophan catabolic process to kynurenine",
  "GO:0019442": "tryptophan catabolic process to acetyl-CoA",
  "GO:0019443": "obsolete tryptophan catabolic process, using tryptophanase",
  "GO:0019444": "tryptophan catabolic process to catechol",
  "GO:0019445": "tyrosine catabolic process to fumarate",
  "GO:0019446": "tyrosine catabolic process to phosphoenolpyruvate",
  "GO:0019447": "D-cysteine catabolic process",
  "GO:0019448": "L-cysteine catabolic process",
  "GO:0019449": "L-cysteine catabolic process to hypotaurine",
  "GO:0019450": "L-cysteine catabolic process to pyruvate",
  "GO:0019451": "L-cysteine catabolic process to pyruvate, using cysteine dioxygenase",
  "GO:0019452": "L-cysteine catabolic process to taurine",
  "GO:0019453": "L-cysteine catabolic process via cystine",
  "GO:0019454": "L-cysteine catabolic process via cystine, using glutathione-cystine transhydrogenase",
  "GO:0019455": "L-cysteine catabolic process via cystine, using cystine reductase",
  "GO:0019456": "L-cysteine catabolic process via cystine, using cysteine transaminase",
  "GO:0019457": "methionine catabolic process to succinyl-CoA",
  "GO:0019458": "methionine catabolic process via 2-oxobutanoate",
  "GO:0019460": "glutamine catabolic process to fumarate",
  "GO:0019461": "glutamine catabolic process to fumarate, using glutamate synthase (NADPH)",
  "GO:0019462": "glutamine catabolic process to fumarate, using glutaminase",
  "GO:0019463": "glycine catabolic process to creatine",
  "GO:0019464": "glycine decarboxylation via glycine cleavage system",
  "GO:0019465": "aspartate transamidation",
  "GO:0019466": "ornithine catabolic process via proline",
  "GO:0019467": "ornithine catabolic process, by decarboxylation",
  "GO:0019468": "nopaline catabolic process",
  "GO:0019469": "octopine catabolic process",
  "GO:0019470": "4-hydroxyproline catabolic process",
  "GO:0019471": "4-hydroxyproline metabolic process",
  "GO:0019472": "4-hydroxyproline biosynthetic process",
  "GO:0019473": "L-lysine catabolic process to glutarate, by acetylation",
  "GO:0019474": "L-lysine catabolic process to acetyl-CoA",
  "GO:0019475": "L-lysine catabolic process to acetate",
  "GO:0019476": "D-lysine catabolic process",
  "GO:0019477": "L-lysine catabolic process",
  "GO:0019478": "D-amino acid catabolic process",
  "GO:0019479": "L-alanine oxidation to D-lactate and ammonia",
  "GO:0019480": "L-alanine oxidation to pyruvate via D-alanine",
  "GO:0019481": "L-alanine catabolic process, by transamination",
  "GO:0019482": "beta-alanine metabolic process",
  "GO:0019483": "beta-alanine biosynthetic process",
  "GO:0019484": "beta-alanine catabolic process",
  "GO:0019485": "beta-alanine catabolic process to L-alanine",
  "GO:0019486": "beta-alanine catabolic process to mevalonate semialdehyde, by transamination",
  "GO:0019487": "anaerobic acetylene catabolic process",
  "GO:0019488": "ribitol catabolic process to xylulose 5-phosphate",
  "GO:0019489": "methylgallate metabolic process",
  "GO:0019490": "2-aminobenzenesulfonate desulfonation",
  "GO:0019491": "ectoine biosynthetic process",
  "GO:0019492": "proline salvage",
  "GO:0019493": "arginine catabolic process to proline",
  "GO:0019495": "proline catabolic process to 2-oxoglutarate",
  "GO:0019496": "serine-isocitrate lyase pathway",
  "GO:0019497": "hexachlorocyclohexane metabolic process",
  "GO:0019498": "n-octane oxidation",
  "GO:0019499": "cyanide metabolic process",
  "GO:0019500": "cyanide catabolic process",
  "GO:0019501": "arsonoacetate catabolic process",
  "GO:0019502": "stachydrine metabolic process",
  "GO:0019503": "stachydrine biosynthetic process",
  "GO:0019504": "stachydrine catabolic process",
  "GO:0019505": "resorcinol metabolic process",
  "GO:0019506": "phenylmercury acetate catabolic process",
  "GO:0019507": "pyridine metabolic process",
  "GO:0019508": "2,5-dihydroxypyridine catabolic process to fumarate",
  "GO:0019509": "L-methionine biosynthetic process from methylthioadenosine",
  "GO:0019510": "S-adenosylhomocysteine catabolic process",
  "GO:0019511": "peptidyl-proline hydroxylation",
  "GO:0019512": "lactose catabolic process via tagatose-6-phosphate",
  "GO:0019513": "lactose catabolic process, using glucoside 3-dehydrogenase",
  "GO:0019514": "obsolete lactose hydrolysis",
  "GO:0019515": "lactose catabolic process via UDP-galactose",
  "GO:0019516": "lactate oxidation",
  "GO:0019517": "L-threonine catabolic process to D-lactate",
  "GO:0019518": "L-threonine catabolic process to glycine",
  "GO:0019519": "pentitol metabolic process",
  "GO:0019520": "aldonic acid metabolic process",
  "GO:0019521": "D-gluconate metabolic process",
  "GO:0019522": "ketogluconate metabolic process",
  "GO:0019523": "L-idonate metabolic process",
  "GO:0019524": "keto-D-gluconate catabolic process",
  "GO:0019525": "keto-D-gluconate metabolic process",
  "GO:0019526": "pentitol biosynthetic process",
  "GO:0019527": "pentitol catabolic process",
  "GO:0019528": "D-arabitol catabolic process to xylulose 5-phosphate",
  "GO:0019529": "taurine catabolic process",
  "GO:0019530": "taurine metabolic process",
  "GO:0019531": "oxalate transmembrane transporter activity",
  "GO:0019532": "oxalate transport",
  "GO:0019533": "cellobiose transport",
  "GO:0019534": "toxin transporter activity",
  "GO:0019535": "ferric-vibriobactin transmembrane transporter activity",
  "GO:0019536": "vibriobactin metabolic process",
  "GO:0019537": "vibriobactin biosynthetic process",
  "GO:0019538": "protein metabolic process",
  "GO:0019539": "siderophore biosynthetic process from hydroxamic acid",
  "GO:0019540": "siderophore biosynthetic process from catechol",
  "GO:0019541": "propionate metabolic process",
  "GO:0019542": "propionate biosynthetic process",
  "GO:0019543": "propionate catabolic process",
  "GO:0019544": "arginine catabolic process to glutamate",
  "GO:0019545": "arginine catabolic process to succinate",
  "GO:0019546": "arginine deiminase pathway",
  "GO:0019547": "arginine catabolic process to ornithine",
  "GO:0019548": "arginine catabolic process to spermine",
  "GO:0019549": "glutamate catabolic process to succinate via succinate semialdehyde",
  "GO:0019550": "glutamate catabolic process to aspartate",
  "GO:0019551": "glutamate catabolic process to 2-oxoglutarate",
  "GO:0019552": "glutamate catabolic process via 2-hydroxyglutarate",
  "GO:0019553": "glutamate catabolic process via L-citramalate",
  "GO:0019554": "glutamate catabolic process to oxaloacetate",
  "GO:0019555": "glutamate catabolic process to ornithine",
  "GO:0019556": "histidine catabolic process to glutamate and formamide",
  "GO:0019557": "histidine catabolic process to glutamate and formate",
  "GO:0019558": "histidine catabolic process to 2-oxoglutarate",
  "GO:0019559": "histidine catabolic process to imidazol-5-yl-lactate",
  "GO:0019560": "histidine catabolic process to hydantoin-5-propionate",
  "GO:0019561": "anaerobic phenylalanine oxidation",
  "GO:0019562": "phenylalanine catabolic process to phosphoenolpyruvate",
  "GO:0019563": "glycerol catabolic process",
  "GO:0019564": "aerobic glycerol catabolic process",
  "GO:0019566": "arabinose metabolic process",
  "GO:0019567": "arabinose biosynthetic process",
  "GO:0019568": "arabinose catabolic process",
  "GO:0019569": "L-arabinose catabolic process to xylulose 5-phosphate",
  "GO:0019570": "L-arabinose catabolic process to 2-oxoglutarate",
  "GO:0019571": "D-arabinose catabolic process",
  "GO:0019572": "L-arabinose catabolic process",
  "GO:0019573": "D-arabinose catabolic process to xylulose 5-phosphate",
  "GO:0019574": "sucrose catabolic process via 3'-ketosucrose",
  "GO:0019575": "obsolete sucrose catabolic process, using beta-fructofuranosidase",
  "GO:0019576": "aerobic fructose catabolic process",
  "GO:0019577": "aldaric acid metabolic process",
  "GO:0019578": "aldaric acid biosynthetic process",
  "GO:0019579": "aldaric acid catabolic process",
  "GO:0019580": "galactarate metabolic process",
  "GO:0019583": "galactonate metabolic process",
  "GO:0019584": "galactonate catabolic process",
  "GO:0019585": "glucuronate metabolic process",
  "GO:0019586": "galacturonate metabolic process",
  "GO:0019588": "anaerobic glycerol catabolic process",
  "GO:0019589": "anaerobic glycerol catabolic process to propane-1,3-diol",
  "GO:0019590": "L-arabitol catabolic process to xylulose 5-phosphate",
  "GO:0019592": "mannitol catabolic process",
  "GO:0019593": "mannitol biosynthetic process",
  "GO:0019594": "mannitol metabolic process",
  "GO:0019595": "non-phosphorylated glucose catabolic process",
  "GO:0019596": "mandelate catabolic process",
  "GO:0019597": "(R)-mandelate catabolic process to benzoate",
  "GO:0019598": "(R)-mandelate catabolic process to catechol",
  "GO:0019599": "(R)-4-hydroxymandelate catabolic process",
  "GO:0019600": "toluene oxidation",
  "GO:0019601": "toluene oxidation via 2-hydroxytoluene",
  "GO:0019602": "toluene oxidation via 3-hydroxytoluene",
  "GO:0019603": "toluene oxidation via 4-hydroxytoluene",
  "GO:0019604": "toluene oxidation to catechol",
  "GO:0019605": "butyrate metabolic process",
  "GO:0019606": "2-oxobutyrate catabolic process",
  "GO:0019607": "phenylethylamine catabolic process",
  "GO:0019608": "nicotine catabolic process",
  "GO:0019609": "3-hydroxyphenylacetate metabolic process",
  "GO:0019610": "3-hydroxyphenylacetate catabolic process",
  "GO:0019611": "4-toluenecarboxylate metabolic process",
  "GO:0019612": "4-toluenecarboxylate catabolic process",
  "GO:0019614": "catechol-containing compound catabolic process",
  "GO:0019615": "catechol catabolic process, ortho-cleavage",
  "GO:0019616": "catechol catabolic process, meta-cleavage",
  "GO:0019617": "protocatechuate catabolic process, meta-cleavage",
  "GO:0019618": "protocatechuate catabolic process, ortho-cleavage",
  "GO:0019619": "3,4-dihydroxybenzoate catabolic process",
  "GO:0019620": "aerobic benzoate metabolic process",
  "GO:0019621": "creatinine catabolic process to formate",
  "GO:0019622": "3-(3-hydroxy)phenylpropionate catabolic process",
  "GO:0019623": "atrazine catabolic process to urea",
  "GO:0019624": "atrazine catabolic process to isopropylamine",
  "GO:0019625": "atrazine catabolic process to cyanuric acid",
  "GO:0019626": "short-chain fatty acid catabolic process",
  "GO:0019627": "urea metabolic process",
  "GO:0019628": "urate catabolic process",
  "GO:0019629": "propionate catabolic process, 2-methylcitrate cycle",
  "GO:0019630": "quinate metabolic process",
  "GO:0019631": "quinate catabolic process",
  "GO:0019632": "shikimate metabolic process",
  "GO:0019633": "shikimate catabolic process",
  "GO:0019634": "organic phosphonate metabolic process",
  "GO:0019635": "2-aminoethylphosphonate catabolic process",
  "GO:0019636": "phosphonoacetate metabolic process",
  "GO:0019637": "organophosphate metabolic process",
  "GO:0019638": "6-hydroxycineole metabolic process",
  "GO:0019639": "6-hydroxycineole catabolic process",
  "GO:0019640": "glucuronate catabolic process to xylulose 5-phosphate",
  "GO:0019643": "reductive tricarboxylic acid cycle",
  "GO:0019645": "anaerobic electron transport chain",
  "GO:0019646": "aerobic electron transport chain",
  "GO:0019647": "formaldehyde assimilation via ribulose monophosphate cycle",
  "GO:0019648": "formaldehyde assimilation via xylulose monophosphate cycle",
  "GO:0019649": "formaldehyde assimilation",
  "GO:0019650": "glycolytic fermentation to butanediol",
  "GO:0019651": "citrate catabolic process to diacetyl",
  "GO:0019652": "lactate fermentation to propionate and acetate",
  "GO:0019653": "anaerobic purine nucleobase catabolic process",
  "GO:0019654": "acetate fermentation",
  "GO:0019655": "glycolytic fermentation to ethanol",
  "GO:0019656": "glucose catabolic process to D-lactate and ethanol",
  "GO:0019657": "glycolytic fermentation to propionate",
  "GO:0019658": "glucose fermentation to lactate and acetate",
  "GO:0019659": "glucose catabolic process to lactate",
  "GO:0019660": "glycolytic fermentation",
  "GO:0019661": "glucose catabolic process to lactate via pyruvate",
  "GO:0019662": "non-glycolytic fermentation",
  "GO:0019664": "mixed acid fermentation",
  "GO:0019665": "anaerobic amino acid catabolic process",
  "GO:0019666": "nitrogenous compound fermentation",
  "GO:0019667": "anaerobic L-alanine catabolic process",
  "GO:0019668": "anaerobic catabolism of pairs of amino acids",
  "GO:0019669": "anaerobic glycine catabolic process",
  "GO:0019670": "anaerobic glutamate catabolic process",
  "GO:0019671": "glutamate catabolic process via mesaconate and citramalate",
  "GO:0019672": "ethanol-acetate fermentation to butyrate and caproate",
  "GO:0019673": "GDP-mannose metabolic process",
  "GO:0019674": "NAD metabolic process",
  "GO:0019675": "obsolete NAD phosphorylation and dephosphorylation",
  "GO:0019676": "ammonia assimilation cycle",
  "GO:0019677": "NAD catabolic process",
  "GO:0019678": "propionate metabolic process, methylmalonyl pathway",
  "GO:0019679": "propionate metabolic process, methylcitrate cycle",
  "GO:0019680": "L-methylmalonyl-CoA biosynthetic process",
  "GO:0019681": "acetyl-CoA assimilation pathway",
  "GO:0019682": "glyceraldehyde-3-phosphate metabolic process",
  "GO:0019683": "glyceraldehyde-3-phosphate catabolic process",
  "GO:0019684": "photosynthesis, light reaction",
  "GO:0019685": "photosynthesis, dark reaction",
  "GO:0019686": "purine nucleoside interconversion",
  "GO:0019687": "pyruvate biosynthetic process from acetate",
  "GO:0019688": "purine deoxyribonucleoside interconversion",
  "GO:0019689": "pyrimidine nucleoside interconversion",
  "GO:0019690": "pyrimidine deoxyribonucleoside interconversion",
  "GO:0019692": "deoxyribose phosphate metabolic process",
  "GO:0019693": "ribose phosphate metabolic process",
  "GO:0019694": "alkanesulfonate metabolic process",
  "GO:0019695": "choline metabolic process",
  "GO:0019696": "toluene oxidation via toluene-cis-1,2-dihydrodiol",
  "GO:0019697": "L-xylitol catabolic process to xylulose 5-phosphate",
  "GO:0019698": "D-galacturonate catabolic process",
  "GO:0019700": "organic phosphonate catabolic process",
  "GO:0019701": "peptidyl-arginine N5-methylation",
  "GO:0019702": "protein-arginine N5-methyltransferase activity",
  "GO:0019703": "coenzyme A-peptidyl-cysteine covalent linking",
  "GO:0019704": "peptidyl-S-myristoyl-L-cysteine biosynthetic process from peptidyl-cysteine",
  "GO:0019705": "protein-cysteine S-myristoyltransferase activity",
  "GO:0019706": "protein-cysteine S-palmitoyltransferase activity",
  "GO:0019707": "protein-cysteine S-acyltransferase activity",
  "GO:0019708": "peptidyl-glycine cholesteryl ester biosynthesis from peptidyl-glycine",
  "GO:0019709": "iron incorporation into iron-sulfur cluster via pentakis-L-cysteinyl L-histidino nickel tetrairon pentasulfide",
  "GO:0019710": "peptidyl-asparagine methylation",
  "GO:0019711": "peptidyl-beta-carboxyaspartic acid biosynthetic process from peptidyl-aspartic acid",
  "GO:0019712": "peptidyl-L-glutamic acid 5-methyl ester biosynthetic process from glutamic acid",
  "GO:0019713": "peptidyl-L-glutamic acid 5-methyl ester biosynthetic process from glutamine",
  "GO:0019714": "peptidyl-glutamine esterification",
  "GO:0019715": "peptidyl-aspartic acid hydroxylation to form L-erythro-beta-hydroxyaspartic acid",
  "GO:0019716": "N-terminal peptidyl-alanine monomethylation",
  "GO:0019717": "obsolete synaptosome",
  "GO:0019718": "obsolete rough microsome",
  "GO:0019719": "obsolete smooth microsome",
  "GO:0019720": "Mo-molybdopterin cofactor metabolic process",
  "GO:0019722": "calcium-mediated signaling",
  "GO:0019724": "B cell mediated immunity",
  "GO:0019725": "cellular homeostasis",
  "GO:0019726": "mevaldate reductase (NADPH) activity",
  "GO:0019727": "mevaldate reductase (NAD+) activity",
  "GO:0019728": "peptidyl-allysine oxidation to 2-aminoadipic acid",
  "GO:0019729": "peptide cross-linking via 2-imino-glutaminyl-5-imidazolinone glycine",
  "GO:0019730": "antimicrobial humoral response",
  "GO:0019731": "antibacterial humoral response",
  "GO:0019732": "antifungal humoral response",
  "GO:0019736": "peptidyl-sarcosine incorporation",
  "GO:0019740": "nitrogen utilization",
  "GO:0019741": "pentacyclic triterpenoid catabolic process",
  "GO:0019742": "pentacyclic triterpenoid metabolic process",
  "GO:0019743": "hopanoid catabolic process",
  "GO:0019744": "hopanoid metabolic process",
  "GO:0019745": "pentacyclic triterpenoid biosynthetic process",
  "GO:0019746": "hopanoid biosynthetic process",
  "GO:0019747": "regulation of isoprenoid metabolic process",
  "GO:0019748": "secondary metabolic process",
  "GO:0019749": "cytoskeleton-dependent cytoplasmic transport, nurse cell to oocyte",
  "GO:0019750": "chloroplast localization",
  "GO:0019751": "polyol metabolic process",
  "GO:0019752": "carboxylic acid metabolic process",
  "GO:0019755": "one-carbon compound transport",
  "GO:0019756": "cyanogenic glycoside biosynthetic process",
  "GO:0019757": "glycosinolate metabolic process",
  "GO:0019758": "glycosinolate biosynthetic process",
  "GO:0019759": "glycosinolate catabolic process",
  "GO:0019760": "glucosinolate metabolic process",
  "GO:0019761": "glucosinolate biosynthetic process",
  "GO:0019762": "glucosinolate catabolic process",
  "GO:0019763": "immunoglobulin receptor activity",
  "GO:0019764": "obsolete high affinity Fc receptor activity",
  "GO:0019765": "obsolete low affinity Fc receptor activity",
  "GO:0019766": "IgA receptor activity",
  "GO:0019767": "IgE receptor activity",
  "GO:0019768": "high-affinity IgE receptor activity",
  "GO:0019769": "low-affinity IgE receptor activity",
  "GO:0019770": "IgG receptor activity",
  "GO:0019771": "high-affinity IgG receptor activity",
  "GO:0019772": "low-affinity IgG receptor activity",
  "GO:0019773": "proteasome core complex, alpha-subunit complex",
  "GO:0019774": "proteasome core complex, beta-subunit complex",
  "GO:0019775": "FAT10 transferase activity",
  "GO:0019776": "Atg8 ligase activity",
  "GO:0019777": "Atg12 transferase activity",
  "GO:0019778": "Atg12 activating enzyme activity",
  "GO:0019779": "Atg8 activating enzyme activity",
  "GO:0019780": "FAT10 activating enzyme activity",
  "GO:0019781": "NEDD8 activating enzyme activity",
  "GO:0019782": "ISG15 activating enzyme activity",
  "GO:0019783": "ubiquitin-like protein-specific protease activity",
  "GO:0019784": "NEDD8-specific protease activity",
  "GO:0019785": "ISG15-specific protease activity",
  "GO:0019786": "Atg8-specific protease activity",
  "GO:0019787": "ubiquitin-like protein transferase activity",
  "GO:0019788": "NEDD8 transferase activity",
  "GO:0019789": "SUMO transferase activity",
  "GO:0019790": "obsolete ubiquitin-like hydrolase activity",
  "GO:0019791": "obsolete FAT10 hydrolase activity",
  "GO:0019792": "obsolete APG12 hydrolase activity",
  "GO:0019793": "obsolete ISG15 carrier activity",
  "GO:0019794": "obsolete nonprotein amino acid metabolic process",
  "GO:0019795": "obsolete nonprotein amino acid biosynthetic process",
  "GO:0019796": "obsolete nonprotein amino acid catabolic process",
  "GO:0019797": "procollagen-proline 3-dioxygenase activity",
  "GO:0019798": "procollagen-proline dioxygenase activity",
  "GO:0019799": "tubulin N-acetyltransferase activity",
  "GO:0019800": "peptide cross-linking via chondroitin 4-sulfate glycosaminoglycan",
  "GO:0019801": "cyclization of asparagine involved in intein-mediated protein splicing",
  "GO:0019802": "cyclization of glutamine involved in intein-mediated protein splicing",
  "GO:0019803": "peptidyl-aspartic acid carboxylation",
  "GO:0019804": "obsolete quinolinate synthetase complex",
  "GO:0019805": "quinolinate biosynthetic process",
  "GO:0019806": "bromide peroxidase activity",
  "GO:0019807": "aspartoacylase activity",
  "GO:0019808": "polyamine binding",
  "GO:0019809": "spermidine binding",
  "GO:0019810": "putrescine binding",
  "GO:0019811": "cocaine binding",
  "GO:0019812": "Type I site-specific deoxyribonuclease complex",
  "GO:0019813": "Type III site-specific deoxyribonuclease complex",
  "GO:0019814": "immunoglobulin complex",
  "GO:0019815": "B cell receptor complex",
  "GO:0019816": "obsolete B cell receptor accessory molecule complex",
  "GO:0019817": "vesicle fusion with peroxisome",
  "GO:0019819": "P1 peroxisome",
  "GO:0019820": "P2 peroxisome",
  "GO:0019821": "P3 peroxisome",
  "GO:0019822": "P4 peroxisome",
  "GO:0019823": "P5 peroxisome",
  "GO:0019824": "P6 peroxisome",
  "GO:0019825": "oxygen binding",
  "GO:0019826": "oxygen sensor activity",
  "GO:0019827": "stem cell population maintenance",
  "GO:0019828": "aspartic-type endopeptidase inhibitor activity",
  "GO:0019829": "cation-transporting ATPase activity",
  "GO:0019830": "obsolete cadmium sensitivity/resistance",
  "GO:0019831": "obsolete chromate sensitivity/resistance",
  "GO:0019832": "obsolete mercuric sensitivity/resistance",
  "GO:0019833": "obsolete ice nucleation activity",
  "GO:0019834": "phospholipase A2 inhibitor activity",
  "GO:0019835": "cytolysis",
  "GO:0019836": "hemolysis by symbiont of host erythrocytes",
  "GO:0019837": "obsolete herbicide susceptibility/resistance",
  "GO:0019838": "growth factor binding",
  "GO:0019840": "isoprenoid binding",
  "GO:0019841": "retinol binding",
  "GO:0019842": "vitamin binding",
  "GO:0019843": "rRNA binding",
  "GO:0019844": "obsolete endotoxin activity",
  "GO:0019845": "obsolete exotoxin activity",
  "GO:0019846": "obsolete enterotoxin activity",
  "GO:0019847": "obsolete neurotoxin activity",
  "GO:0019848": "obsolete conotoxin activity",
  "GO:0019849": "obsolete cytotoxin activity",
  "GO:0019852": "L-ascorbic acid metabolic process",
  "GO:0019853": "L-ascorbic acid biosynthetic process",
  "GO:0019854": "L-ascorbic acid catabolic process",
  "GO:0019855": "calcium channel inhibitor activity",
  "GO:0019856": "pyrimidine nucleobase biosynthetic process",
  "GO:0019857": "5-methylcytosine metabolic process",
  "GO:0019858": "cytosine metabolic process",
  "GO:0019859": "thymine metabolic process",
  "GO:0019860": "uracil metabolic process",
  "GO:0019861": "obsolete flagellum",
  "GO:0019862": "IgA binding",
  "GO:0019863": "IgE binding",
  "GO:0019864": "IgG binding",
  "GO:0019865": "immunoglobulin binding",
  "GO:0019866": "organelle inner membrane",
  "GO:0019867": "outer membrane",
  "GO:0019869": "chloride channel inhibitor activity",
  "GO:0019870": "potassium channel inhibitor activity",
  "GO:0019871": "sodium channel inhibitor activity",
  "GO:0019872": "streptomycin biosynthetic process",
  "GO:0019873": "obsolete tellurium sensitivity/resistance",
  "GO:0019874": "6-aminohexanoate-cyclic-dimer hydrolase activity",
  "GO:0019875": "6-aminohexanoate-dimer hydrolase activity",
  "GO:0019876": "nylon catabolic process",
  "GO:0019877": "diaminopimelate biosynthetic process",
  "GO:0019878": "lysine biosynthetic process via aminoadipic acid",
  "GO:0019879": "peptidyl-thyronine biosynthetic process from peptidyl-tyrosine",
  "GO:0019880": "obsolete bacteriocin susceptibility/resistance",
  "GO:0019881": "obsolete streptomycin susceptibility/resistance",
  "GO:0019882": "antigen processing and presentation",
  "GO:0019883": "antigen processing and presentation of endogenous antigen",
  "GO:0019884": "antigen processing and presentation of exogenous antigen",
  "GO:0019885": "antigen processing and presentation of endogenous peptide antigen via MHC class I",
  "GO:0019886": "antigen processing and presentation of exogenous peptide antigen via MHC class II",
  "GO:0019887": "protein kinase regulator activity",
  "GO:0019888": "protein phosphatase regulator activity",
  "GO:0019889": "pteridine metabolic process",
  "GO:0019893": "obsolete DNA replication inhibitor",
  "GO:0019894": "kinesin binding",
  "GO:0019895": "kinesin-associated mitochondrial adaptor activity",
  "GO:0019896": "axon transport of mitochondrion",
  "GO:0019897": "extrinsic component of plasma membrane",
  "GO:0019898": "extrinsic component of membrane",
  "GO:0019899": "enzyme binding",
  "GO:0019900": "kinase binding",
  "GO:0019901": "protein kinase binding",
  "GO:0019902": "phosphatase binding",
  "GO:0019903": "protein phosphatase binding",
  "GO:0019904": "protein domain specific binding",
  "GO:0019905": "syntaxin binding",
  "GO:0019907": "cyclin-dependent protein kinase activating kinase holoenzyme complex",
  "GO:0019908": "nuclear cyclin-dependent protein kinase holoenzyme complex",
  "GO:0019909": "[pyruvate dehydrogenase (lipoamide)] phosphatase regulator activity",
  "GO:0019910": "mitochondrial pyruvate dehydrogenase (lipoamide) phosphatase complex",
  "GO:0019911": "structural constituent of myelin sheath",
  "GO:0019912": "cyclin-dependent protein kinase activating kinase activity",
  "GO:0019914": "cyclin-dependent protein kinase activating kinase regulator activity",
  "GO:0019915": "lipid storage",
  "GO:0019916": "peptidyl-D-alanine racemization, direct",
  "GO:0019917": "peptidyl-D-alanine racemization via peptidyl-L-serine",
  "GO:0019918": "peptidyl-arginine methylation, to symmetrical-dimethyl arginine",
  "GO:0019919": "peptidyl-arginine methylation, to asymmetrical-dimethyl arginine",
  "GO:0019920": "peptidyl-1-thioglycine biosynthetic process, internal",
  "GO:0019921": "peptidyl-1-thioglycine biosynthetic process, carboxy-terminal",
  "GO:0019922": "protein-chromophore linkage via peptidyl-cysteine",
  "GO:0019923": "alpha-1-microglobulin-chromophore linkage",
  "GO:0019926": "peptidyl-tryptophan oxidation to tryptophyl quinone",
  "GO:0019927": "peptide cross-linking via 4'-(S-L-cysteinyl)-L-tryptophyl quinone",
  "GO:0019928": "peptide cross-linking via 3-(S-L-cysteinyl)-L-aspartic acid",
  "GO:0019929": "peptide cross-linking via 4-(S-L-cysteinyl)-L-glutamic acid",
  "GO:0019930": "cis-14-hydroxy-10,13-dioxo-7-heptadecenoic acid peptidyl-aspartate ester biosynthetic process from peptidyl-aspartic acid",
  "GO:0019931": "protein-chromophore linkage via peptidyl-N6-3-dehydroretinal-L-lysine",
  "GO:0019932": "second-messenger-mediated signaling",
  "GO:0019933": "cAMP-mediated signaling",
  "GO:0019934": "cGMP-mediated signaling",
  "GO:0019935": "cyclic-nucleotide-mediated signaling",
  "GO:0019936": "obsolete inositol phospholipid-mediated signaling",
  "GO:0019937": "protein catenane formation via N6-(L-isoaspartyl)-L-lysine, autocatalytic",
  "GO:0019938": "peptide cross-linking via N6-(L-isoaspartyl)-L-lysine, presumed catalytic",
  "GO:0019939": "peptidyl-S-palmitoleyl-L-cysteine biosynthetic process from peptidyl-cysteine",
  "GO:0019940": "obsolete SUMO-dependent protein catabolic process",
  "GO:0019941": "modification-dependent protein catabolic process",
  "GO:0019942": "obsolete NEDD8 class-dependent protein catabolic process",
  "GO:0019948": "SUMO activating enzyme activity",
  "GO:0019950": "SMT3-dependent protein catabolic process",
  "GO:0019951": "Smt3-protein conjugation",
  "GO:0019953": "sexual reproduction",
  "GO:0019954": "asexual reproduction",
  "GO:0019955": "cytokine binding",
  "GO:0019956": "chemokine binding",
  "GO:0019957": "C-C chemokine binding",
  "GO:0019958": "C-X-C chemokine binding",
  "GO:0019959": "interleukin-8 binding",
  "GO:0019960": "C-X3-C chemokine binding",
  "GO:0019961": "interferon binding",
  "GO:0019962": "type I interferon binding",
  "GO:0019964": "interferon-gamma binding",
  "GO:0019966": "interleukin-1 binding",
  "GO:0019969": "interleukin-10 binding",
  "GO:0019970": "interleukin-11 binding",
  "GO:0019972": "interleukin-12 binding",
  "GO:0019973": "interleukin-13 binding",
  "GO:0019974": "interleukin-14 binding",
  "GO:0019975": "interleukin-17 binding",
  "GO:0019976": "interleukin-2 binding",
  "GO:0019977": "interleukin-21 binding",
  "GO:0019978": "interleukin-3 binding",
  "GO:0019979": "interleukin-4 binding",
  "GO:0019980": "interleukin-5 binding",
  "GO:0019981": "interleukin-6 binding",
  "GO:0019982": "interleukin-7 binding",
  "GO:0019983": "interleukin-9 binding",
  "GO:0019985": "translesion synthesis",
  "GO:0019987": "obsolete negative regulation of anti-apoptosis",
  "GO:0019988": "charged-tRNA amino acid modification",
  "GO:0019990": "pteridine catabolic process",
  "GO:0019991": "septate junction assembly",
  "GO:0019992": "diacylglycerol binding",
  "GO:0020002": "host cell plasma membrane",
  "GO:0020003": "symbiont-containing vacuole",
  "GO:0020004": "symbiont-containing vacuolar space",
  "GO:0020005": "symbiont-containing vacuole membrane",
  "GO:0020006": "symbiont-containing vacuolar membrane network",
  "GO:0020007": "apical complex",
  "GO:0020008": "rhoptry",
  "GO:0020009": "microneme",
  "GO:0020010": "conoid",
  "GO:0020011": "apicoplast",
  "GO:0020012": "evasion or tolerance of host immune response",
  "GO:0020013": "modulation by symbiont of host erythrocyte aggregation",
  "GO:0020014": "schizogony",
  "GO:0020015": "glycosome",
  "GO:0020016": "ciliary pocket",
  "GO:0020018": "ciliary pocket membrane",
  "GO:0020020": "food vacuole",
  "GO:0020021": "immortalization of host cell",
  "GO:0020022": "acidocalcisome",
  "GO:0020023": "kinetoplast",
  "GO:0020025": "subpellicular microtubule",
  "GO:0020026": "merozoite dense granule",
  "GO:0020027": "hemoglobin metabolic process",
  "GO:0020028": "hemoglobin import",
  "GO:0020030": "infected host cell surface knob",
  "GO:0020031": "polar ring of apical complex",
  "GO:0020032": "basal ring of apical complex",
  "GO:0020033": "antigenic variation",
  "GO:0020035": "cytoadherence to microvasculature, mediated by symbiont protein",
  "GO:0020036": "Maurer's cleft",
  "GO:0020037": "heme binding",
  "GO:0020038": "subpellicular network",
  "GO:0020039": "pellicle",
  "GO:0021501": "prechordal plate formation",
  "GO:0021502": "neural fold elevation formation",
  "GO:0021503": "neural fold bending",
  "GO:0021504": "neural fold hinge point formation",
  "GO:0021505": "neural fold folding",
  "GO:0021506": "anterior neuropore closure",
  "GO:0021507": "posterior neuropore closure",
  "GO:0021508": "floor plate formation",
  "GO:0021509": "roof plate formation",
  "GO:0021510": "spinal cord development",
  "GO:0021511": "spinal cord patterning",
  "GO:0021512": "spinal cord anterior/posterior patterning",
  "GO:0021513": "spinal cord dorsal/ventral patterning",
  "GO:0021514": "ventral spinal cord interneuron differentiation",
  "GO:0021515": "cell differentiation in spinal cord",
  "GO:0021516": "dorsal spinal cord development",
  "GO:0021517": "ventral spinal cord development",
  "GO:0021518": "spinal cord commissural neuron specification",
  "GO:0021519": "spinal cord association neuron specification",
  "GO:0021520": "spinal cord motor neuron cell fate specification",
  "GO:0021521": "ventral spinal cord interneuron specification",
  "GO:0021522": "spinal cord motor neuron differentiation",
  "GO:0021523": "somatic motor neuron differentiation",
  "GO:0021524": "visceral motor neuron differentiation",
  "GO:0021525": "lateral motor column neuron differentiation",
  "GO:0021526": "medial motor column neuron differentiation",
  "GO:0021527": "spinal cord association neuron differentiation",
  "GO:0021528": "commissural neuron differentiation in spinal cord",
  "GO:0021529": "spinal cord oligodendrocyte cell differentiation",
  "GO:0021530": "spinal cord oligodendrocyte cell fate specification",
  "GO:0021531": "spinal cord radial glial cell differentiation",
  "GO:0021532": "neural tube patterning",
  "GO:0021533": "cell differentiation in hindbrain",
  "GO:0021534": "cell proliferation in hindbrain",
  "GO:0021535": "cell migration in hindbrain",
  "GO:0021536": "diencephalon development",
  "GO:0021537": "telencephalon development",
  "GO:0021538": "epithalamus development",
  "GO:0021539": "subthalamus development",
  "GO:0021540": "corpus callosum morphogenesis",
  "GO:0021541": "ammon gyrus development",
  "GO:0021542": "dentate gyrus development",
  "GO:0021543": "pallium development",
  "GO:0021544": "subpallium development",
  "GO:0021545": "cranial nerve development",
  "GO:0021546": "rhombomere development",
  "GO:0021547": "midbrain-hindbrain boundary initiation",
  "GO:0021548": "pons development",
  "GO:0021549": "cerebellum development",
  "GO:0021550": "medulla oblongata development",
  "GO:0021551": "central nervous system morphogenesis",
  "GO:0021552": "midbrain-hindbrain boundary structural organization",
  "GO:0021553": "olfactory nerve development",
  "GO:0021554": "optic nerve development",
  "GO:0021555": "midbrain-hindbrain boundary morphogenesis",
  "GO:0021556": "central nervous system formation",
  "GO:0021557": "oculomotor nerve development",
  "GO:0021558": "trochlear nerve development",
  "GO:0021559": "trigeminal nerve development",
  "GO:0021560": "abducens nerve development",
  "GO:0021561": "facial nerve development",
  "GO:0021562": "vestibulocochlear nerve development",
  "GO:0021563": "glossopharyngeal nerve development",
  "GO:0021564": "vagus nerve development",
  "GO:0021565": "accessory nerve development",
  "GO:0021566": "hypoglossal nerve development",
  "GO:0021567": "rhombomere 1 development",
  "GO:0021568": "rhombomere 2 development",
  "GO:0021569": "rhombomere 3 development",
  "GO:0021570": "rhombomere 4 development",
  "GO:0021571": "rhombomere 5 development",
  "GO:0021572": "rhombomere 6 development",
  "GO:0021573": "rhombomere 7 development",
  "GO:0021574": "rhombomere 8 development",
  "GO:0021575": "hindbrain morphogenesis",
  "GO:0021576": "hindbrain formation",
  "GO:0021577": "hindbrain structural organization",
  "GO:0021578": "hindbrain maturation",
  "GO:0021579": "medulla oblongata morphogenesis",
  "GO:0021580": "medulla oblongata formation",
  "GO:0021581": "medulla oblongata structural organization",
  "GO:0021582": "medulla oblongata maturation",
  "GO:0021583": "pons morphogenesis",
  "GO:0021584": "pons formation",
  "GO:0021585": "pons structural organization",
  "GO:0021586": "pons maturation",
  "GO:0021587": "cerebellum morphogenesis",
  "GO:0021588": "cerebellum formation",
  "GO:0021589": "cerebellum structural organization",
  "GO:0021590": "cerebellum maturation",
  "GO:0021591": "ventricular system development",
  "GO:0021592": "fourth ventricle development",
  "GO:0021593": "rhombomere morphogenesis",
  "GO:0021594": "rhombomere formation",
  "GO:0021595": "rhombomere structural organization",
  "GO:0021597": "central nervous system structural organization",
  "GO:0021598": "abducens nerve morphogenesis",
  "GO:0021599": "abducens nerve formation",
  "GO:0021600": "abducens nerve structural organization",
  "GO:0021601": "abducens nerve maturation",
  "GO:0021602": "cranial nerve morphogenesis",
  "GO:0021603": "cranial nerve formation",
  "GO:0021604": "cranial nerve structural organization",
  "GO:0021605": "cranial nerve maturation",
  "GO:0021606": "accessory nerve maturation",
  "GO:0021607": "accessory nerve morphogenesis",
  "GO:0021608": "accessory nerve formation",
  "GO:0021609": "accessory nerve structural organization",
  "GO:0021610": "facial nerve morphogenesis",
  "GO:0021611": "facial nerve formation",
  "GO:0021612": "facial nerve structural organization",
  "GO:0021613": "facial nerve maturation",
  "GO:0021614": "glossopharyngeal nerve maturation",
  "GO:0021615": "glossopharyngeal nerve morphogenesis",
  "GO:0021616": "glossopharyngeal nerve formation",
  "GO:0021617": "glossopharyngeal nerve structural organization",
  "GO:0021618": "hypoglossal nerve morphogenesis",
  "GO:0021619": "hypoglossal nerve maturation",
  "GO:0021620": "hypoglossal nerve formation",
  "GO:0021621": "hypoglossal nerve structural organization",
  "GO:0021622": "oculomotor nerve morphogenesis",
  "GO:0021623": "oculomotor nerve formation",
  "GO:0021624": "oculomotor nerve structural organization",
  "GO:0021625": "oculomotor nerve maturation",
  "GO:0021626": "central nervous system maturation",
  "GO:0021627": "olfactory nerve morphogenesis",
  "GO:0021628": "olfactory nerve formation",
  "GO:0021629": "olfactory nerve structural organization",
  "GO:0021630": "olfactory nerve maturation",
  "GO:0021631": "optic nerve morphogenesis",
  "GO:0021632": "optic nerve maturation",
  "GO:0021633": "optic nerve structural organization",
  "GO:0021634": "optic nerve formation",
  "GO:0021635": "trigeminal nerve maturation",
  "GO:0021636": "trigeminal nerve morphogenesis",
  "GO:0021637": "trigeminal nerve structural organization",
  "GO:0021638": "trigeminal nerve formation",
  "GO:0021639": "trochlear nerve morphogenesis",
  "GO:0021640": "trochlear nerve maturation",
  "GO:0021641": "trochlear nerve structural organization",
  "GO:0021642": "trochlear nerve formation",
  "GO:0021643": "vagus nerve maturation",
  "GO:0021644": "vagus nerve morphogenesis",
  "GO:0021645": "vagus nerve structural organization",
  "GO:0021646": "vagus nerve formation",
  "GO:0021647": "vestibulocochlear nerve maturation",
  "GO:0021648": "vestibulocochlear nerve morphogenesis",
  "GO:0021649": "vestibulocochlear nerve structural organization",
  "GO:0021650": "vestibulocochlear nerve formation",
  "GO:0021651": "rhombomere 1 morphogenesis",
  "GO:0021652": "rhombomere 1 formation",
  "GO:0021653": "rhombomere 1 structural organization",
  "GO:0021654": "rhombomere boundary formation",
  "GO:0021655": "rhombomere 2 morphogenesis",
  "GO:0021656": "rhombomere 2 structural organization",
  "GO:0021657": "rhombomere 2 formation",
  "GO:0021658": "rhombomere 3 morphogenesis",
  "GO:0021659": "rhombomere 3 structural organization",
  "GO:0021660": "rhombomere 3 formation",
  "GO:0021661": "rhombomere 4 morphogenesis",
  "GO:0021662": "rhombomere 4 structural organization",
  "GO:0021663": "rhombomere 4 formation",
  "GO:0021664": "rhombomere 5 morphogenesis",
  "GO:0021665": "rhombomere 5 structural organization",
  "GO:0021666": "rhombomere 5 formation",
  "GO:0021667": "rhombomere 6 morphogenesis",
  "GO:0021668": "rhombomere 6 structural organization",
  "GO:0021669": "rhombomere 6 formation",
  "GO:0021670": "lateral ventricle development",
  "GO:0021671": "rhombomere 7 morphogenesis",
  "GO:0021672": "rhombomere 7 structural organization",
  "GO:0021673": "rhombomere 7 formation",
  "GO:0021674": "rhombomere 8 morphogenesis",
  "GO:0021675": "nerve development",
  "GO:0021676": "rhombomere 8 structural organization",
  "GO:0021677": "rhombomere 8 formation",
  "GO:0021678": "third ventricle development",
  "GO:0021679": "cerebellar molecular layer development",
  "GO:0021680": "cerebellar Purkinje cell layer development",
  "GO:0021681": "cerebellar granular layer development",
  "GO:0021682": "nerve maturation",
  "GO:0021683": "cerebellar granular layer morphogenesis",
  "GO:0021684": "cerebellar granular layer formation",
  "GO:0021685": "cerebellar granular layer structural organization",
  "GO:0021686": "cerebellar granular layer maturation",
  "GO:0021687": "cerebellar molecular layer morphogenesis",
  "GO:0021688": "cerebellar molecular layer formation",
  "GO:0021689": "cerebellar molecular layer structural organization",
  "GO:0021690": "cerebellar molecular layer maturation",
  "GO:0021691": "cerebellar Purkinje cell layer maturation",
  "GO:0021692": "cerebellar Purkinje cell layer morphogenesis",
  "GO:0021693": "cerebellar Purkinje cell layer structural organization",
  "GO:0021694": "cerebellar Purkinje cell layer formation",
  "GO:0021695": "cerebellar cortex development",
  "GO:0021696": "cerebellar cortex morphogenesis",
  "GO:0021697": "cerebellar cortex formation",
  "GO:0021698": "cerebellar cortex structural organization",
  "GO:0021699": "cerebellar cortex maturation",
  "GO:0021700": "developmental maturation",
  "GO:0021701": "cerebellar Golgi cell differentiation",
  "GO:0021702": "cerebellar Purkinje cell differentiation",
  "GO:0021703": "locus ceruleus development",
  "GO:0021704": "locus ceruleus morphogenesis",
  "GO:0021705": "locus ceruleus formation",
  "GO:0021706": "locus ceruleus maturation",
  "GO:0021707": "cerebellar granule cell differentiation",
  "GO:0021708": "Lugaro cell differentiation",
  "GO:0021709": "cerebellar basket cell differentiation",
  "GO:0021710": "cerebellar stellate cell differentiation",
  "GO:0021711": "cerebellar unipolar brush cell differentiation",
  "GO:0021712": "candelabrum cell differentiation",
  "GO:0021713": "inferior olivary nucleus development",
  "GO:0021714": "inferior olivary nucleus morphogenesis",
  "GO:0021715": "inferior olivary nucleus formation",
  "GO:0021716": "inferior olivary nucleus structural organization",
  "GO:0021717": "inferior olivary nucleus maturation",
  "GO:0021718": "superior olivary nucleus development",
  "GO:0021719": "superior olivary nucleus morphogenesis",
  "GO:0021720": "superior olivary nucleus formation",
  "GO:0021721": "superior olivary nucleus structural organization",
  "GO:0021722": "superior olivary nucleus maturation",
  "GO:0021723": "medullary reticular formation development",
  "GO:0021724": "inferior raphe nucleus development",
  "GO:0021725": "superior raphe nucleus development",
  "GO:0021726": "lateral reticular nucleus development",
  "GO:0021727": "intermediate reticular formation development",
  "GO:0021728": "inferior reticular formation development",
  "GO:0021729": "superior reticular formation development",
  "GO:0021730": "trigeminal sensory nucleus development",
  "GO:0021731": "trigeminal motor nucleus development",
  "GO:0021732": "midbrain-hindbrain boundary maturation",
  "GO:0021735": "dentate nucleus development",
  "GO:0021736": "globose nucleus development",
  "GO:0021737": "emboliform nucleus development",
  "GO:0021738": "fastigial nucleus development",
  "GO:0021739": "mesencephalic trigeminal nucleus development",
  "GO:0021740": "principal sensory nucleus of trigeminal nerve development",
  "GO:0021741": "spinal trigeminal nucleus development",
  "GO:0021742": "abducens nucleus development",
  "GO:0021743": "hypoglossal nucleus development",
  "GO:0021744": "dorsal motor nucleus of vagus nerve development",
  "GO:0021745": "nucleus ambiguus development",
  "GO:0021746": "solitary nucleus development",
  "GO:0021747": "cochlear nucleus development",
  "GO:0021748": "dorsal cochlear nucleus development",
  "GO:0021749": "ventral cochlear nucleus development",
  "GO:0021750": "vestibular nucleus development",
  "GO:0021751": "salivary nucleus development",
  "GO:0021752": "inferior salivary nucleus development",
  "GO:0021753": "superior salivary nucleus development",
  "GO:0021754": "facial nucleus development",
  "GO:0021755": "eurydendroid cell differentiation",
  "GO:0021756": "striatum development",
  "GO:0021757": "caudate nucleus development",
  "GO:0021758": "putamen development",
  "GO:0021759": "globus pallidus development",
  "GO:0021761": "limbic system development",
  "GO:0021762": "substantia nigra development",
  "GO:0021763": "subthalamic nucleus development",
  "GO:0021764": "amygdala development",
  "GO:0021765": "cingulate gyrus development",
  "GO:0021766": "hippocampus development",
  "GO:0021767": "mammillary body development",
  "GO:0021768": "nucleus accumbens development",
  "GO:0021769": "orbitofrontal cortex development",
  "GO:0021770": "parahippocampal gyrus development",
  "GO:0021771": "lateral geniculate nucleus development",
  "GO:0021772": "olfactory bulb development",
  "GO:0021773": "striatal medium spiny neuron differentiation",
  "GO:0021774": "retinoic acid receptor signaling pathway involved in ventral spinal cord interneuron specification",
  "GO:0021775": "smoothened signaling pathway involved in ventral spinal cord interneuron specification",
  "GO:0021776": "smoothened signaling pathway involved in spinal cord motor neuron cell fate specification",
  "GO:0021777": "BMP signaling pathway involved in spinal cord association neuron specification",
  "GO:0021778": "oligodendrocyte cell fate specification",
  "GO:0021779": "oligodendrocyte cell fate commitment",
  "GO:0021780": "glial cell fate specification",
  "GO:0021781": "glial cell fate commitment",
  "GO:0021782": "glial cell development",
  "GO:0021783": "preganglionic parasympathetic fiber development",
  "GO:0021784": "postganglionic parasympathetic fiber development",
  "GO:0021785": "branchiomotor neuron axon guidance",
  "GO:0021786": "branchiomotor neuron axon guidance in neural tube",
  "GO:0021787": "chemorepulsion of branchiomotor neuron axon in neural tube",
  "GO:0021788": "chemoattraction of branchiomotor neuron axon in neural tube",
  "GO:0021789": "branchiomotor neuron axon guidance in branchial arch mesenchyme",
  "GO:0021790": "chemorepulsion of branchiomotor neuron axon in branchial arch mesenchyme",
  "GO:0021791": "chemoattraction of branchiomotor neuron axon in branchial arch mesenchyme",
  "GO:0021792": "chemoattraction of branchiomotor axon",
  "GO:0021793": "chemorepulsion of branchiomotor axon",
  "GO:0021794": "thalamus development",
  "GO:0021795": "cerebral cortex cell migration",
  "GO:0021796": "cerebral cortex regionalization",
  "GO:0021797": "forebrain anterior/posterior pattern specification",
  "GO:0021798": "forebrain dorsal/ventral pattern formation",
  "GO:0021799": "cerebral cortex radially oriented cell migration",
  "GO:0021800": "cerebral cortex tangential migration",
  "GO:0021801": "cerebral cortex radial glia guided migration",
  "GO:0021802": "somal translocation",
  "GO:0021803": "pial surface process extension",
  "GO:0021804": "negative regulation of cell adhesion in ventricular zone",
  "GO:0021805": "cell movement involved in somal translocation",
  "GO:0021806": "initiation of movement involved in cerebral cortex radial glia guided migration",
  "GO:0021807": "motogenic signaling initiating cell movement in cerebral cortex",
  "GO:0021808": "cytosolic calcium signaling involved in initiation of cell movement in glial-mediated radial cell migration",
  "GO:0021809": "neurotrophic factor signaling initiating cell movement, involved in cerebral cortex radial glia guided migration",
  "GO:0021810": "neurotransmitter signaling initiating cell movement, involved in cerebral cortex radial glia guided migration",
  "GO:0021811": "growth factor signaling initiating cell movement involved in cerebral cortex radial glia guided migration",
  "GO:0021812": "neuronal-glial interaction involved in cerebral cortex radial glia guided migration",
  "GO:0021813": "cell-cell adhesion involved in neuronal-glial interactions involved in cerebral cortex radial glia guided migration",
  "GO:0021814": "cell motility involved in cerebral cortex radial glia guided migration",
  "GO:0021815": "modulation of microtubule cytoskeleton involved in cerebral cortex radial glia guided migration",
  "GO:0021816": "extension of a leading process involved in cell motility in cerebral cortex radial glia guided migration",
  "GO:0021817": "nucleokinesis involved in cell motility in cerebral cortex radial glia guided migration",
  "GO:0021818": "modulation of the microfilament cytoskeleton involved in cell locomotion in cerebral cortex radial glia guided migration",
  "GO:0021819": "layer formation in cerebral cortex",
  "GO:0021820": "extracellular matrix organization in marginal zone involved in cerebral cortex radial glia guided migration",
  "GO:0021821": "negative regulation of cell-glial cell adhesion involved in cerebral cortex lamination",
  "GO:0021822": "negative regulation of cell motility involved in cerebral cortex radial glia guided migration",
  "GO:0021823": "cerebral cortex tangential migration using cell-cell interactions",
  "GO:0021824": "cerebral cortex tangential migration using cell-axon interactions",
  "GO:0021825": "substrate-dependent cerebral cortex tangential migration",
  "GO:0021826": "substrate-independent telencephalic tangential migration",
  "GO:0021827": "postnatal olfactory bulb interneuron migration",
  "GO:0021828": "gonadotrophin-releasing hormone neuronal migration to the hypothalamus",
  "GO:0021829": "oligodendrocyte cell migration from the subpallium to the cortex",
  "GO:0021830": "interneuron migration from the subpallium to the cortex",
  "GO:0021831": "embryonic olfactory bulb interneuron precursor migration",
  "GO:0021832": "cell-cell adhesion involved in cerebral cortex tangential migration using cell-cell interactions",
  "GO:0021833": "cell-matrix adhesion involved in tangential migration using cell-cell interactions",
  "GO:0021834": "chemorepulsion involved in embryonic olfactory bulb interneuron precursor migration",
  "GO:0021835": "chemoattraction involved in embryonic olfactory bulb interneuron precursor migration",
  "GO:0021836": "chemorepulsion involved in postnatal olfactory bulb interneuron migration",
  "GO:0021837": "motogenic signaling involved in postnatal olfactory bulb interneuron migration",
  "GO:0021838": "motogenic signaling involved in interneuron migration from the subpallium to the cortex",
  "GO:0021839": "interneuron-substratum interaction involved in interneuron migration from the subpallium to the cortex",
  "GO:0021840": "directional guidance of interneurons involved in migration from the subpallium to the cortex",
  "GO:0021841": "chemoattraction involved in interneuron migration from the subpallium to the cortex",
  "GO:0021842": "chemorepulsion involved in interneuron migration from the subpallium to the cortex",
  "GO:0021843": "substrate-independent telencephalic tangential interneuron migration",
  "GO:0021844": "interneuron sorting involved in substrate-independent cerebral cortex tangential migration",
  "GO:0021845": "neurotransmitter-mediated guidance of interneurons involved in substrate-independent cerebral cortex tangential migration",
  "GO:0021846": "cell proliferation in forebrain",
  "GO:0021847": "ventricular zone neuroblast division",
  "GO:0021848": "neuroblast division in subpallium",
  "GO:0021849": "neuroblast division in subventricular zone",
  "GO:0021850": "subpallium glioblast cell division",
  "GO:0021851": "neuroblast division in dorsal lateral ganglionic eminence",
  "GO:0021852": "pyramidal neuron migration",
  "GO:0021853": "cerebral cortex GABAergic interneuron migration",
  "GO:0021854": "hypothalamus development",
  "GO:0021855": "hypothalamus cell migration",
  "GO:0021856": "hypothalamic tangential migration using cell-axon interactions",
  "GO:0021858": "GABAergic neuron differentiation in basal ganglia",
  "GO:0021859": "pyramidal neuron differentiation",
  "GO:0021860": "pyramidal neuron development",
  "GO:0021861": "forebrain radial glial cell differentiation",
  "GO:0021862": "early neuron differentiation in forebrain",
  "GO:0021863": "forebrain neuroblast differentiation",
  "GO:0021864": "radial glial cell division in forebrain",
  "GO:0021865": "symmetric radial glial cell division in forebrain",
  "GO:0021866": "asymmetric radial glial cell division in forebrain",
  "GO:0021867": "neuron-producing asymmetric radial glial cell division in forebrain",
  "GO:0021868": "ventricular zone cell-producing asymmetric radial glial cell division in forebrain",
  "GO:0021869": "forebrain ventricular zone progenitor cell division",
  "GO:0021870": "Cajal-Retzius cell differentiation",
  "GO:0021871": "forebrain regionalization",
  "GO:0021872": "forebrain generation of neurons",
  "GO:0021873": "forebrain neuroblast division",
  "GO:0021874": "Wnt signaling pathway involved in forebrain neuroblast division",
  "GO:0021875": "fibroblast growth factor receptor signaling pathway involved in forebrain neuroblast division",
  "GO:0021876": "Notch signaling pathway involved in forebrain neuroblast division",
  "GO:0021877": "forebrain neuron fate commitment",
  "GO:0021878": "forebrain astrocyte fate commitment",
  "GO:0021879": "forebrain neuron differentiation",
  "GO:0021880": "Notch signaling pathway involved in forebrain neuron fate commitment",
  "GO:0021881": "Wnt-activated signaling pathway involved in forebrain neuron fate commitment",
  "GO:0021882": "regulation of transcription from RNA polymerase II promoter involved in forebrain neuron fate commitment",
  "GO:0021883": "cell cycle arrest of committed forebrain neuronal progenitor cell",
  "GO:0021884": "forebrain neuron development",
  "GO:0021885": "forebrain cell migration",
  "GO:0021886": "hypothalamus gonadotrophin-releasing hormone neuron differentiation",
  "GO:0021887": "hypothalamus gonadotrophin-releasing hormone neuron fate commitment",
  "GO:0021888": "hypothalamus gonadotrophin-releasing hormone neuron development",
  "GO:0021889": "olfactory bulb interneuron differentiation",
  "GO:0021890": "olfactory bulb interneuron fate commitment",
  "GO:0021891": "olfactory bulb interneuron development",
  "GO:0021892": "cerebral cortex GABAergic interneuron differentiation",
  "GO:0021893": "cerebral cortex GABAergic interneuron fate commitment",
  "GO:0021894": "cerebral cortex GABAergic interneuron development",
  "GO:0021895": "cerebral cortex neuron differentiation",
  "GO:0021896": "forebrain astrocyte differentiation",
  "GO:0021897": "forebrain astrocyte development",
  "GO:0021898": "commitment of multipotent stem cells to neuronal lineage in forebrain",
  "GO:0021899": "fibroblast growth factor receptor signaling pathway involved in forebrain neuron fate commitment",
  "GO:0021900": "ventricular zone cell fate commitment",
  "GO:0021901": "early neuron fate commitment in forebrain",
  "GO:0021902": "commitment of neuronal cell to specific neuron type in forebrain",
  "GO:0021903": "rostrocaudal neural tube patterning",
  "GO:0021904": "dorsal/ventral neural tube patterning",
  "GO:0021905": "forebrain-midbrain boundary formation",
  "GO:0021906": "hindbrain-spinal cord boundary formation",
  "GO:0021907": "fibroblast growth factor receptor signaling pathway involved in spinal cord anterior/posterior pattern formation",
  "GO:0021908": "retinoic acid receptor signaling pathway involved in spinal cord anterior/posterior pattern formation",
  "GO:0021909": "regulation of transcription from RNA polymerase II promoter involved in spinal cord anterior-posterior patterning",
  "GO:0021910": "smoothened signaling pathway involved in ventral spinal cord patterning",
  "GO:0021911": "retinoic acid metabolic process in spinal cord anterior-posterior patterning",
  "GO:0021912": "regulation of transcription from RNA polymerase II promoter involved in spinal cord motor neuron fate specification",
  "GO:0021913": "regulation of transcription from RNA polymerase II promoter involved in ventral spinal cord interneuron specification",
  "GO:0021914": "negative regulation of smoothened signaling pathway involved in ventral spinal cord patterning",
  "GO:0021915": "neural tube development",
  "GO:0021916": "inductive cell-cell signaling between paraxial mesoderm and motor neuron precursors",
  "GO:0021917": "somatic motor neuron fate commitment",
  "GO:0021918": "regulation of transcription from RNA polymerase II promoter involved in somatic motor neuron fate commitment",
  "GO:0021919": "BMP signaling pathway involved in spinal cord dorsal/ventral patterning",
  "GO:0021920": "regulation of transcription from RNA polymerase II promoter involved in spinal cord association neuron specification",
  "GO:0021921": "regulation of cell proliferation in dorsal spinal cord",
  "GO:0021922": "Wnt signaling pathway involved in regulation of cell proliferation in dorsal spinal cord",
  "GO:0021923": "cell proliferation in hindbrain ventricular zone",
  "GO:0021924": "cell proliferation in external granule layer",
  "GO:0021925": "cerebellar Purkinje cell precursor proliferation",
  "GO:0021926": "Golgi cell precursor proliferation",
  "GO:0021927": "deep nuclear neuron precursor proliferation",
  "GO:0021928": "basket cell precursor proliferation",
  "GO:0021929": "stellate cell precursor proliferation",
  "GO:0021930": "cerebellar granule cell precursor proliferation",
  "GO:0021931": "rostral hindbrain neuronal precursor cell proliferation",
  "GO:0021932": "hindbrain radial glia guided cell migration",
  "GO:0021933": "radial glia guided migration of cerebellar granule cell",
  "GO:0021934": "hindbrain tangential cell migration",
  "GO:0021935": "cerebellar granule cell precursor tangential migration",
  "GO:0021936": "regulation of cerebellar granule cell precursor proliferation",
  "GO:0021937": "cerebellar Purkinje cell-granule cell precursor cell signaling involved in regulation of granule cell precursor cell proliferation",
  "GO:0021938": "smoothened signaling pathway involved in regulation of cerebellar granule cell precursor cell proliferation",
  "GO:0021939": "extracellular matrix-granule cell signaling involved in regulation of granule cell precursor proliferation",
  "GO:0021940": "positive regulation of cerebellar granule cell precursor proliferation",
  "GO:0021941": "negative regulation of cerebellar granule cell precursor proliferation",
  "GO:0021942": "radial glia guided migration of Purkinje cell",
  "GO:0021943": "formation of radial glial scaffolds",
  "GO:0021944": "neuronal-glial interaction involved in hindbrain glial-mediated radial cell migration",
  "GO:0021945": "positive regulation of cerebellar granule cell migration by calcium",
  "GO:0021946": "deep nuclear neuron cell migration",
  "GO:0021947": "outward migration of deep nuclear neurons",
  "GO:0021948": "inward migration of deep nuclear neurons",
  "GO:0021949": "brainstem precerebellar neuron precursor migration",
  "GO:0021950": "chemorepulsion involved in precerebellar neuron migration",
  "GO:0021951": "chemoattraction involved in precerebellar neuron migration",
  "GO:0021952": "central nervous system projection neuron axonogenesis",
  "GO:0021953": "central nervous system neuron differentiation",
  "GO:0021954": "central nervous system neuron development",
  "GO:0021955": "central nervous system neuron axonogenesis",
  "GO:0021956": "central nervous system interneuron axonogenesis",
  "GO:0021957": "corticospinal tract morphogenesis",
  "GO:0021958": "gracilis tract morphogenesis",
  "GO:0021959": "cuneatus tract morphogenesis",
  "GO:0021960": "anterior commissure morphogenesis",
  "GO:0021961": "posterior commissure morphogenesis",
  "GO:0021962": "vestibulospinal tract morphogenesis",
  "GO:0021963": "spinothalamic tract morphogenesis",
  "GO:0021964": "rubrospinal tract morphogenesis",
  "GO:0021965": "spinal cord ventral commissure morphogenesis",
  "GO:0021966": "corticospinal neuron axon guidance",
  "GO:0021967": "corticospinal neuron axon guidance through the cerebral cortex",
  "GO:0021968": "corticospinal neuron axon guidance through the internal capsule",
  "GO:0021969": "corticospinal neuron axon guidance through the cerebral peduncle",
  "GO:0021970": "corticospinal neuron axon guidance through the basilar pons",
  "GO:0021971": "corticospinal neuron axon guidance through the medullary pyramid",
  "GO:0021972": "corticospinal neuron axon guidance through spinal cord",
  "GO:0021973": "corticospinal neuron axon decussation",
  "GO:0021974": "trigeminothalamic tract morphogenesis",
  "GO:0021975": "pons reticulospinal tract morphogenesis",
  "GO:0021976": "medulla reticulospinal tract morphogenesis",
  "GO:0021977": "tectospinal tract morphogenesis",
  "GO:0021978": "telencephalon regionalization",
  "GO:0021979": "hypothalamus cell differentiation",
  "GO:0021980": "subpallium cell migration",
  "GO:0021981": "subpallium radially oriented migration",
  "GO:0021982": "pineal gland development",
  "GO:0021983": "pituitary gland development",
  "GO:0021984": "adenohypophysis development",
  "GO:0021985": "neurohypophysis development",
  "GO:0021986": "habenula development",
  "GO:0021987": "cerebral cortex development",
  "GO:0021988": "olfactory lobe development",
  "GO:0021989": "olfactory cortex development",
  "GO:0021990": "neural plate formation",
  "GO:0021991": "neural plate thickening",
  "GO:0021992": "cell proliferation involved in neural plate elongation",
  "GO:0021993": "initiation of neural tube closure",
  "GO:0021994": "progression of neural tube closure",
  "GO:0021995": "neuropore closure",
  "GO:0021996": "lamina terminalis formation",
  "GO:0021997": "neural plate axis specification",
  "GO:0021998": "neural plate mediolateral regionalization",
  "GO:0021999": "neural plate anterior/posterior regionalization",
  "GO:0022000": "forebrain induction by the anterior neural ridge",
  "GO:0022001": "negative regulation of anterior neural cell fate commitment of the neural plate",
  "GO:0022002": "negative regulation of anterior neural cell fate commitment of the neural plate by Wnt signaling pathway",
  "GO:0022003": "negative regulation of anterior neural cell fate commitment of the neural plate by fibroblast growth factor receptor signaling pathway",
  "GO:0022004": "midbrain-hindbrain boundary maturation during brain development",
  "GO:0022005": "midbrain-hindbrain boundary maturation during neural plate development",
  "GO:0022006": "zona limitans intrathalamica formation",
  "GO:0022007": "convergent extension involved in neural plate elongation",
  "GO:0022008": "neurogenesis",
  "GO:0022009": "central nervous system vasculogenesis",
  "GO:0022010": "central nervous system myelination",
  "GO:0022011": "myelination in peripheral nervous system",
  "GO:0022012": "subpallium cell proliferation in forebrain",
  "GO:0022013": "pallium cell proliferation in forebrain",
  "GO:0022014": "radial glial cell division in subpallium",
  "GO:0022015": "radial glial cell division in pallium",
  "GO:0022016": "pallium glioblast division",
  "GO:0022017": "neuroblast division in pallium",
  "GO:0022018": "lateral ganglionic eminence cell proliferation",
  "GO:0022019": "dorsal lateral ganglionic eminence cell proliferation",
  "GO:0022020": "medial ganglionic eminence cell proliferation",
  "GO:0022021": "caudal ganglionic eminence cell proliferation",
  "GO:0022022": "septal cell proliferation",
  "GO:0022023": "radial glial cell fate commitment in forebrain",
  "GO:0022024": "BMP signaling pathway involved in forebrain neuron fate commitment",
  "GO:0022025": "leukemia inhibitory factor signaling pathway involved in forebrain neuron fate commitment",
  "GO:0022026": "epidermal growth factor signaling pathway involved in forebrain neuron fate commitment",
  "GO:0022027": "interkinetic nuclear migration",
  "GO:0022028": "tangential migration from the subventricular zone to the olfactory bulb",
  "GO:0022029": "telencephalon cell migration",
  "GO:0022030": "telencephalon glial cell migration",
  "GO:0022031": "telencephalon astrocyte cell migration",
  "GO:0022032": "telencephalon oligodendrocyte cell migration",
  "GO:0022033": "telencephalon microglial cell migration",
  "GO:0022034": "rhombomere cell proliferation",
  "GO:0022035": "rhombomere cell migration",
  "GO:0022036": "rhombomere cell differentiation",
  "GO:0022037": "metencephalon development",
  "GO:0022038": "corpus callosum development",
  "GO:0022400": "regulation of rhodopsin mediated signaling pathway",
  "GO:0022401": "negative adaptation of signaling pathway",
  "GO:0022402": "cell cycle process",
  "GO:0022403": "cell cycle phase",
  "GO:0022404": "molting cycle process",
  "GO:0022405": "hair cycle process",
  "GO:0022406": "membrane docking",
  "GO:0022407": "regulation of cell-cell adhesion",
  "GO:0022408": "negative regulation of cell-cell adhesion",
  "GO:0022409": "positive regulation of cell-cell adhesion",
  "GO:0022410": "circadian sleep/wake cycle process",
  "GO:0022411": "cellular component disassembly",
  "GO:0022412": "cellular process involved in reproduction in multicellular organism",
  "GO:0022413": "reproductive process in single-celled organism",
  "GO:0022414": "reproductive process",
  "GO:0022416": "chaeta development",
  "GO:0022417": "protein maturation by protein folding",
  "GO:0022600": "digestive system process",
  "GO:0022601": "menstrual cycle phase",
  "GO:0022602": "ovulation cycle process",
  "GO:0022603": "regulation of anatomical structure morphogenesis",
  "GO:0022604": "regulation of cell morphogenesis",
  "GO:0022605": "oogenesis stage",
  "GO:0022606": "establishment of proximal/distal cell polarity",
  "GO:0022607": "cellular component assembly",
  "GO:0022608": "multicellular organism adhesion",
  "GO:0022609": "multicellular organism adhesion to substrate",
  "GO:0022610": "biological adhesion",
  "GO:0022611": "dormancy process",
  "GO:0022612": "gland morphogenesis",
  "GO:0022613": "ribonucleoprotein complex biogenesis",
  "GO:0022614": "membrane to membrane docking",
  "GO:0022615": "protein to membrane docking",
  "GO:0022616": "DNA strand elongation",
  "GO:0022617": "extracellular matrix disassembly",
  "GO:0022618": "ribonucleoprotein complex assembly",
  "GO:0022619": "generative cell differentiation",
  "GO:0022620": "vegetative cell differentiation",
  "GO:0022622": "root system development",
  "GO:0022623": "proteasome-activating nucleotidase complex",
  "GO:0022624": "proteasome accessory complex",
  "GO:0022625": "cytosolic large ribosomal subunit",
  "GO:0022626": "cytosolic ribosome",
  "GO:0022627": "cytosolic small ribosomal subunit",
  "GO:0022628": "chloroplast large ribosomal subunit",
  "GO:0022629": "chloroplast small ribosomal subunit",
  "GO:0022803": "passive transmembrane transporter activity",
  "GO:0022804": "active transmembrane transporter activity",
  "GO:0022809": "mobile ion carrier activity",
  "GO:0022810": "membrane potential driven uniporter activity",
  "GO:0022814": "facilitated diffusion",
  "GO:0022815": "obsolete large uncharged polar molecule transmembrane transporter activity",
  "GO:0022818": "sodium ion uniporter activity",
  "GO:0022819": "potassium ion uniporter activity",
  "GO:0022820": "potassium ion symporter activity",
  "GO:0022821": "potassium ion antiporter activity",
  "GO:0022824": "transmitter-gated ion channel activity",
  "GO:0022825": "obsolete copper-exporting ATPase activity",
  "GO:0022828": "phosphorylation-gated channel activity",
  "GO:0022829": "wide pore channel activity",
  "GO:0022831": "narrow pore, gated channel activity",
  "GO:0022832": "voltage-gated channel activity",
  "GO:0022833": "mechanically gated channel activity",
  "GO:0022834": "ligand-gated channel activity",
  "GO:0022835": "transmitter-gated channel activity",
  "GO:0022836": "gated channel activity",
  "GO:0022838": "substrate-specific channel activity",
  "GO:0022839": "ion gated channel activity",
  "GO:0022840": "leak channel activity",
  "GO:0022841": "potassium ion leak channel activity",
  "GO:0022842": "narrow pore channel activity",
  "GO:0022843": "voltage-gated cation channel activity",
  "GO:0022848": "acetylcholine-gated cation channel activity",
  "GO:0022849": "glutamate-gated calcium ion channel activity",
  "GO:0022850": "serotonin-gated cation channel activity",
  "GO:0022851": "GABA-gated chloride ion channel activity",
  "GO:0022852": "glycine-gated chloride ion channel activity",
  "GO:0022853": "active ion transmembrane transporter activity",
  "GO:0022854": "obsolete active large uncharged polar molecule transmembrane transporter activity",
  "GO:0022855": "protein-N(PI)-phosphohistidine-glucose phosphotransferase system transporter activity",
  "GO:0022856": "protein-N(PI)-phosphohistidine-sorbitol phosphotransferase system transporter activity",
  "GO:0022857": "transmembrane transporter activity",
  "GO:0022858": "alanine transmembrane transporter activity",
  "GO:0022859": "dephosphorylation-gated channel activity",
  "GO:0022865": "transmembrane electron transfer carrier",
  "GO:0022866": "transmembrane 1-electron transfer carrier",
  "GO:0022867": "transmembrane 2-electron transfer carrier",
  "GO:0022869": "protein-N(PI)-phosphohistidine-lactose phosphotransferase system transporter activity",
  "GO:0022870": "protein-N(PI)-phosphohistidine-mannose phosphotransferase system transporter activity",
  "GO:0022871": "protein-N(PI)-phosphohistidine-sorbose phosphotransferase system transporter activity",
  "GO:0022872": "protein-N(PI)-phosphohistidine-mannitol phosphotransferase system transmembrane transporter activity",
  "GO:0022873": "protein-N(PI)-phosphohistidine-maltose phosphotransferase system transporter activity",
  "GO:0022874": "protein-N(PI)-phosphohistidine-cellobiose phosphotransferase system transporter activity",
  "GO:0022875": "protein-N(PI)-phosphohistidine-galactitol phosphotransferase system transmembrane transporter activity",
  "GO:0022876": "protein-N(PI)-phosphohistidine-galactosamine phosphotransferase system transporter activity",
  "GO:0022877": "protein-N(PI)-phosphohistidine-fructose phosphotransferase system transporter activity",
  "GO:0022878": "protein-N(PI)-phosphohistidine-sucrose phosphotransferase system transporter activity",
  "GO:0022879": "protein-N(PI)-phosphohistidine-trehalose phosphotransferase system transporter activity",
  "GO:0022880": "protein-N(PI)-phosphohistidine-N-acetylglucosamine phosphotransferase system transporter activity",
  "GO:0022881": "protein-N(PI)-phosphohistidine-N-acetylgalactosamine phosphotransferase system transporter activity",
  "GO:0022882": "protein-N(PI)-phosphohistidine-beta-glucoside phosphotransferase system transporter activity",
  "GO:0022883": "zinc efflux transmembrane transporter activity",
  "GO:0022884": "macromolecule transmembrane transporter activity",
  "GO:0022885": "bacteriocin transmembrane transporter activity",
  "GO:0022886": "channel-forming ionophore activity",
  "GO:0022889": "serine transmembrane transporter activity",
  "GO:0022890": "inorganic cation transmembrane transporter activity",
  "GO:0022891": "substrate-specific transmembrane transporter activity",
  "GO:0022892": "substrate-specific transporter activity",
  "GO:0022893": "low-affinity tryptophan transmembrane transporter activity",
  "GO:0022894": "Intermediate conductance calcium-activated potassium channel activity",
  "GO:0022897": "proton-dependent peptide secondary active transmembrane transporter activity",
  "GO:0022898": "regulation of transmembrane transporter activity",
  "GO:0022900": "electron transport chain",
  "GO:0022904": "respiratory electron transport chain",
  "GO:0023002": "nuclear migration to embryo sac poles",
  "GO:0023003": "nuclear migration to the embryo sac center",
  "GO:0023004": "obsolete activation of dopamine receptor signaling pathway",
  "GO:0023005": "obsolete signal initiation by neurotransmitter",
  "GO:0023006": "obsolete signal initiation by amino acid",
  "GO:0023007": "obsolete ligand binding to T cell receptor",
  "GO:0023009": "obsolete initiation of T cell receptor signaling",
  "GO:0023010": "obsolete regulation of initiation of T cell receptor signaling",
  "GO:0023011": "obsolete positive regulation of initiation of T cell receptor signaling",
  "GO:0023012": "obsolete initiation of T cell receptor signaling by binding of a MHC complex to T cell receptor",
  "GO:0023014": "signal transduction by protein phosphorylation",
  "GO:0023015": "signal transduction by cis-phosphorylation",
  "GO:0023016": "signal transduction by trans-phosphorylation",
  "GO:0023017": "obsolete signal transmission via diffusible molecule",
  "GO:0023018": "obsolete T cell activation of signal transmission via diffusible molecule",
  "GO:0023019": "signal transduction involved in regulation of gene expression",
  "GO:0023020": "obsolete regulation of gene expression as a consequence of T cell signal transmission",
  "GO:0023021": "termination of signal transduction",
  "GO:0023022": "termination of T cell signal transduction",
  "GO:0023023": "MHC protein complex binding",
  "GO:0023024": "MHC class I protein complex binding",
  "GO:0023025": "MHC class Ib protein complex binding",
  "GO:0023026": "MHC class II protein complex binding",
  "GO:0023027": "MHC class I protein binding, via antigen binding groove",
  "GO:0023028": "MHC class I protein binding, via lateral surface",
  "GO:0023029": "MHC class Ib protein binding",
  "GO:0023030": "MHC class Ib protein binding, via antigen binding groove",
  "GO:0023031": "MHC class Ib protein binding, via lateral surface",
  "GO:0023035": "CD40 signaling pathway",
  "GO:0023036": "obsolete initiation of signal transduction",
  "GO:0023037": "obsolete signal initiation by light",
  "GO:0023038": "obsolete signal initiation by diffusible mediator",
  "GO:0023039": "obsolete signal initiation by physical damage",
  "GO:0023040": "obsolete signaling via ionic flux",
  "GO:0023041": "neuronal signal transduction",
  "GO:0023042": "obsolete signaling via protein/peptide mediator",
  "GO:0023043": "obsolete signaling via lipid mediator",
  "GO:0023044": "obsolete signaling via chemical mediator",
  "GO:0023045": "signal transduction by conformational transition",
  "GO:0023047": "obsolete signal initiation by chemical mediator",
  "GO:0023048": "obsolete signal initiation by lipid mediator",
  "GO:0023049": "obsolete signal initiation by protein/peptide mediator",
  "GO:0023050": "obsolete consequence of signal transmission",
  "GO:0023051": "regulation of signaling",
  "GO:0023052": "signaling",
  "GO:0023053": "obsolete signal initiation by mechanical effect",
  "GO:0023054": "obsolete signal initiation by stretch effect",
  "GO:0023055": "obsolete signal initiation by peptide hormone",
  "GO:0023056": "positive regulation of signaling",
  "GO:0023057": "negative regulation of signaling",
  "GO:0023058": "adaptation of signaling pathway",
  "GO:0023059": "positive adaptation of signaling pathway",
  "GO:0023060": "obsolete signal transmission",
  "GO:0023061": "signal release",
  "GO:0023062": "obsolete signal transmission via transcytosis",
  "GO:0023065": "obsolete signal transmission via blood",
  "GO:0023066": "obsolete signal transmission via vascular system",
  "GO:0023067": "obsolete signal transmission via lymphatic system",
  "GO:0023068": "obsolete signal transmission via phloem",
  "GO:0023069": "obsolete signal transmission via xylem",
  "GO:0023070": "obsolete signal transmission via air",
  "GO:0030001": "metal ion transport",
  "GO:0030002": "cellular anion homeostasis",
  "GO:0030003": "cellular cation homeostasis",
  "GO:0030004": "cellular monovalent inorganic cation homeostasis",
  "GO:0030005": "obsolete cellular di-, tri-valent inorganic cation homeostasis",
  "GO:0030006": "obsolete heavy cellular metal ion homeostasis",
  "GO:0030007": "cellular potassium ion homeostasis",
  "GO:0030008": "TRAPP complex",
  "GO:0030009": "obsolete complement factor H activity",
  "GO:0030010": "establishment of cell polarity",
  "GO:0030011": "maintenance of cell polarity",
  "GO:0030014": "CCR4-NOT complex",
  "GO:0030015": "CCR4-NOT core complex",
  "GO:0030016": "myofibril",
  "GO:0030017": "sarcomere",
  "GO:0030018": "Z disc",
  "GO:0030019": "obsolete tryptase activity",
  "GO:0030020": "extracellular matrix structural constituent conferring tensile strength",
  "GO:0030021": "extracellular matrix structural constituent conferring compression resistance",
  "GO:0030022": "obsolete adhesive extracellular matrix constituent",
  "GO:0030023": "extracellular matrix constituent conferring elasticity",
  "GO:0030026": "cellular manganese ion homeostasis",
  "GO:0030027": "lamellipodium",
  "GO:0030029": "actin filament-based process",
  "GO:0030030": "cell projection organization",
  "GO:0030031": "cell projection assembly",
  "GO:0030032": "lamellipodium assembly",
  "GO:0030033": "microvillus assembly",
  "GO:0030034": "microvillar actin bundle assembly",
  "GO:0030035": "microspike assembly",
  "GO:0030036": "actin cytoskeleton organization",
  "GO:0030037": "actin filament reorganization involved in cell cycle",
  "GO:0030038": "contractile actin filament bundle assembly",
  "GO:0030039": "obsolete DNA unwinding factor",
  "GO:0030041": "actin filament polymerization",
  "GO:0030042": "actin filament depolymerization",
  "GO:0030043": "actin filament fragmentation",
  "GO:0030046": "parallel actin filament bundle assembly",
  "GO:0030047": "actin modification",
  "GO:0030048": "actin filament-based movement",
  "GO:0030049": "muscle filament sliding",
  "GO:0030050": "vesicle transport along actin filament",
  "GO:0030051": "obsolete FK506-sensitive peptidyl-prolyl cis-trans isomerase",
  "GO:0030052": "obsolete parvulin",
  "GO:0030053": "obsolete immunophilin",
  "GO:0030054": "cell junction",
  "GO:0030055": "cell-substrate junction",
  "GO:0030056": "hemidesmosome",
  "GO:0030057": "desmosome",
  "GO:0030058": "amine dehydrogenase activity",
  "GO:0030059": "aralkylamine dehydrogenase (azurin) activity",
  "GO:0030060": "L-malate dehydrogenase activity",
  "GO:0030061": "mitochondrial crista",
  "GO:0030062": "mitochondrial tricarboxylic acid cycle enzyme complex",
  "GO:0030063": "obsolete murein sacculus",
  "GO:0030064": "obsolete cell wall inner membrane",
  "GO:0030066": "obsolete cytochrome b6",
  "GO:0030067": "obsolete respiratory chain cytochrome b6",
  "GO:0030068": "obsolete lytic viral life cycle",
  "GO:0030070": "insulin processing",
  "GO:0030071": "regulation of mitotic metaphase/anaphase transition",
  "GO:0030072": "peptide hormone secretion",
  "GO:0030073": "insulin secretion",
  "GO:0030074": "obsolete thylakoid (sensu Proteobacteria)",
  "GO:0030075": "bacterial thylakoid",
  "GO:0030076": "light-harvesting complex",
  "GO:0030077": "plasma membrane light-harvesting complex",
  "GO:0030078": "light-harvesting complex, core complex",
  "GO:0030079": "light-harvesting complex, peripheral complex",
  "GO:0030080": "B875 antenna complex",
  "GO:0030081": "B800-820 antenna complex",
  "GO:0030082": "B800-850 antenna complex",
  "GO:0030083": "PSI associated light-harvesting complex I, LHCIa subcomplex",
  "GO:0030084": "PSI associated light-harvesting complex I, LHCIb subcomplex",
  "GO:0030085": "PSII associated light-harvesting complex II, peripheral complex, LHCIIb subcomplex",
  "GO:0030086": "obsolete PSII associated light-harvesting complex II, core complex, LHCIIa subcomplex",
  "GO:0030087": "obsolete PSII associated light-harvesting complex II, core complex, LHCIIc subcomplex",
  "GO:0030088": "obsolete PSII associated light-harvesting complex II, core complex, LHCIId subcomplex",
  "GO:0030089": "phycobilisome",
  "GO:0030091": "protein repair",
  "GO:0030092": "obsolete regulation of flagellum assembly",
  "GO:0030093": "chloroplast photosystem I",
  "GO:0030094": "plasma membrane-derived photosystem I",
  "GO:0030095": "chloroplast photosystem II",
  "GO:0030096": "plasma membrane-derived thylakoid photosystem II",
  "GO:0030097": "hemopoiesis",
  "GO:0030098": "lymphocyte differentiation",
  "GO:0030099": "myeloid cell differentiation",
  "GO:0030100": "regulation of endocytosis",
  "GO:0030101": "natural killer cell activation",
  "GO:0030103": "vasopressin secretion",
  "GO:0030104": "water homeostasis",
  "GO:0030105": "obsolete anaphylaxis",
  "GO:0030106": "obsolete MHC class I receptor activity",
  "GO:0030107": "HLA-A specific inhibitory MHC class I receptor activity",
  "GO:0030108": "HLA-A specific activating MHC class I receptor activity",
  "GO:0030109": "HLA-B specific inhibitory MHC class I receptor activity",
  "GO:0030110": "HLA-C specific inhibitory MHC class I receptor activity",
  "GO:0030111": "regulation of Wnt signaling pathway",
  "GO:0030112": "glycocalyx",
  "GO:0030114": "slime layer",
  "GO:0030115": "S-layer",
  "GO:0030116": "glial cell-derived neurotrophic factor receptor binding",
  "GO:0030117": "membrane coat",
  "GO:0030118": "clathrin coat",
  "GO:0030119": "AP-type membrane coat adaptor complex",
  "GO:0030120": "vesicle coat",
  "GO:0030121": "AP-1 adaptor complex",
  "GO:0030122": "AP-2 adaptor complex",
  "GO:0030123": "AP-3 adaptor complex",
  "GO:0030124": "AP-4 adaptor complex",
  "GO:0030125": "clathrin vesicle coat",
  "GO:0030126": "COPI vesicle coat",
  "GO:0030127": "COPII vesicle coat",
  "GO:0030128": "clathrin coat of endocytic vesicle",
  "GO:0030129": "clathrin coat of synaptic vesicle",
  "GO:0030130": "clathrin coat of trans-Golgi network vesicle",
  "GO:0030131": "clathrin adaptor complex",
  "GO:0030132": "clathrin coat of coated pit",
  "GO:0030133": "transport vesicle",
  "GO:0030134": "ER to Golgi transport vesicle",
  "GO:0030135": "coated vesicle",
  "GO:0030136": "clathrin-coated vesicle",
  "GO:0030137": "COPI-coated vesicle",
  "GO:0030139": "endocytic vesicle",
  "GO:0030140": "trans-Golgi network transport vesicle",
  "GO:0030141": "secretory granule",
  "GO:0030142": "Golgi to ER transport vesicle",
  "GO:0030143": "inter-Golgi transport vesicle",
  "GO:0030144": "alpha-1,6-mannosylglycoprotein 6-beta-N-acetylglucosaminyltransferase activity",
  "GO:0030145": "manganese ion binding",
  "GO:0030146": "obsolete diuresis",
  "GO:0030147": "obsolete natriuresis",
  "GO:0030148": "sphingolipid biosynthetic process",
  "GO:0030149": "sphingolipid catabolic process",
  "GO:0030150": "protein import into mitochondrial matrix",
  "GO:0030151": "molybdenum ion binding",
  "GO:0030152": "bacteriocin biosynthetic process",
  "GO:0030153": "bacteriocin immunity",
  "GO:0030154": "cell differentiation",
  "GO:0030155": "regulation of cell adhesion",
  "GO:0030156": "benzodiazepine receptor binding",
  "GO:0030157": "pancreatic juice secretion",
  "GO:0030158": "protein xylosyltransferase activity",
  "GO:0030159": "receptor signaling complex scaffold activity",
  "GO:0030160": "GKAP/Homer scaffold activity",
  "GO:0030161": "obsolete calpain inhibitor activity",
  "GO:0030162": "regulation of proteolysis",
  "GO:0030163": "protein catabolic process",
  "GO:0030164": "protein denaturation",
  "GO:0030165": "PDZ domain binding",
  "GO:0030166": "proteoglycan biosynthetic process",
  "GO:0030167": "proteoglycan catabolic process",
  "GO:0030168": "platelet activation",
  "GO:0030169": "low-density lipoprotein particle binding",
  "GO:0030170": "pyridoxal phosphate binding",
  "GO:0030171": "voltage-gated proton channel activity",
  "GO:0030172": "troponin C binding",
  "GO:0030173": "integral component of Golgi membrane",
  "GO:0030174": "regulation of DNA-dependent DNA replication initiation",
  "GO:0030175": "filopodium",
  "GO:0030176": "integral component of endoplasmic reticulum membrane",
  "GO:0030177": "positive regulation of Wnt signaling pathway",
  "GO:0030178": "negative regulation of Wnt signaling pathway",
  "GO:0030180": "obsolete solute:solute exchange",
  "GO:0030181": "obsolete sodium:calcium exchange",
  "GO:0030182": "neuron differentiation",
  "GO:0030183": "B cell differentiation",
  "GO:0030184": "nitric oxide transmembrane transporter activity",
  "GO:0030185": "nitric oxide transport",
  "GO:0030186": "melatonin metabolic process",
  "GO:0030187": "melatonin biosynthetic process",
  "GO:0030188": "obsolete chaperone regulator activity",
  "GO:0030189": "obsolete chaperone activator activity",
  "GO:0030190": "obsolete chaperone inhibitor activity",
  "GO:0030191": "obsolete Hsp70/Hsc70 protein inhibitor activity",
  "GO:0030192": "obsolete Hsp70/Hsc70 protein regulator activity",
  "GO:0030193": "regulation of blood coagulation",
  "GO:0030194": "positive regulation of blood coagulation",
  "GO:0030195": "negative regulation of blood coagulation",
  "GO:0030196": "cyanide hydratase activity",
  "GO:0030197": "extracellular matrix constituent, lubricant activity",
  "GO:0030198": "extracellular matrix organization",
  "GO:0030199": "collagen fibril organization",
  "GO:0030200": "heparan sulfate proteoglycan catabolic process",
  "GO:0030201": "heparan sulfate proteoglycan metabolic process",
  "GO:0030202": "heparin metabolic process",
  "GO:0030203": "glycosaminoglycan metabolic process",
  "GO:0030204": "chondroitin sulfate metabolic process",
  "GO:0030205": "dermatan sulfate metabolic process",
  "GO:0030206": "chondroitin sulfate biosynthetic process",
  "GO:0030207": "chondroitin sulfate catabolic process",
  "GO:0030208": "dermatan sulfate biosynthetic process",
  "GO:0030209": "dermatan sulfate catabolic process",
  "GO:0030210": "heparin biosynthetic process",
  "GO:0030211": "heparin catabolic process",
  "GO:0030212": "hyaluronan metabolic process",
  "GO:0030213": "hyaluronan biosynthetic process",
  "GO:0030214": "hyaluronan catabolic process",
  "GO:0030215": "semaphorin receptor binding",
  "GO:0030216": "keratinocyte differentiation",
  "GO:0030217": "T cell differentiation",
  "GO:0030218": "erythrocyte differentiation",
  "GO:0030219": "megakaryocyte differentiation",
  "GO:0030220": "platelet formation",
  "GO:0030221": "basophil differentiation",
  "GO:0030222": "eosinophil differentiation",
  "GO:0030223": "neutrophil differentiation",
  "GO:0030224": "monocyte differentiation",
  "GO:0030225": "macrophage differentiation",
  "GO:0030226": "apolipoprotein receptor activity",
  "GO:0030227": "obsolete apolipoprotein E receptor activity",
  "GO:0030228": "lipoprotein particle receptor activity",
  "GO:0030229": "very-low-density lipoprotein particle receptor activity",
  "GO:0030232": "insulin control element activator complex",
  "GO:0030233": "deoxynucleotide transmembrane transporter activity",
  "GO:0030234": "enzyme regulator activity",
  "GO:0030235": "nitric-oxide synthase regulator activity",
  "GO:0030237": "female sex determination",
  "GO:0030238": "male sex determination",
  "GO:0030239": "myofibril assembly",
  "GO:0030240": "skeletal muscle thin filament assembly",
  "GO:0030241": "skeletal muscle myosin thick filament assembly",
  "GO:0030242": "pexophagy",
  "GO:0030243": "cellulose metabolic process",
  "GO:0030244": "cellulose biosynthetic process",
  "GO:0030245": "cellulose catabolic process",
  "GO:0030246": "carbohydrate binding",
  "GO:0030247": "polysaccharide binding",
  "GO:0030248": "cellulose binding",
  "GO:0030249": "guanylate cyclase regulator activity",
  "GO:0030250": "guanylate cyclase activator activity",
  "GO:0030251": "guanylate cyclase inhibitor activity",
  "GO:0030252": "growth hormone secretion",
  "GO:0030253": "protein secretion by the type I secretion system",
  "GO:0030254": "protein secretion by the type III secretion system",
  "GO:0030255": "protein secretion by the type IV secretion system",
  "GO:0030256": "type I protein secretion system complex",
  "GO:0030257": "type III protein secretion system complex",
  "GO:0030258": "lipid modification",
  "GO:0030259": "lipid glycosylation",
  "GO:0030260": "entry into host cell",
  "GO:0030261": "chromosome condensation",
  "GO:0030262": "apoptotic nuclear changes",
  "GO:0030263": "apoptotic chromosome condensation",
  "GO:0030264": "nuclear fragmentation involved in apoptotic nuclear change",
  "GO:0030265": "phospholipase C-activating rhodopsin mediated signaling pathway",
  "GO:0030266": "quinate 3-dehydrogenase (NAD+) activity",
  "GO:0030267": "glyoxylate reductase (NADP) activity",
  "GO:0030268": "methylenetetrahydromethanopterin dehydrogenase activity",
  "GO:0030269": "tetrahydromethanopterin S-methyltransferase activity",
  "GO:0030270": "formylmethanofuran-tetrahydromethanopterin N-formyltransferase activity",
  "GO:0030271": "obsolete chymase activity",
  "GO:0030272": "5-formyltetrahydrofolate cyclo-ligase activity",
  "GO:0030273": "melanin-concentrating hormone receptor activity",
  "GO:0030274": "LIM domain binding",
  "GO:0030275": "LRR domain binding",
  "GO:0030276": "clathrin binding",
  "GO:0030277": "maintenance of gastrointestinal epithelium",
  "GO:0030278": "regulation of ossification",
  "GO:0030279": "negative regulation of ossification",
  "GO:0030280": "structural constituent of epidermis",
  "GO:0030281": "structural constituent of cutaneous appendage",
  "GO:0030282": "bone mineralization",
  "GO:0030283": "testosterone dehydrogenase [NAD(P)] activity",
  "GO:0030284": "estrogen receptor activity",
  "GO:0030285": "integral component of synaptic vesicle membrane",
  "GO:0030286": "dynein complex",
  "GO:0030287": "cell wall-bounded periplasmic space",
  "GO:0030288": "outer membrane-bounded periplasmic space",
  "GO:0030289": "protein phosphatase 4 complex",
  "GO:0030290": "sphingolipid activator protein activity",
  "GO:0030291": "protein serine/threonine kinase inhibitor activity",
  "GO:0030292": "protein tyrosine kinase inhibitor activity",
  "GO:0030293": "transmembrane receptor protein tyrosine kinase inhibitor activity",
  "GO:0030294": "receptor signaling protein tyrosine kinase inhibitor activity",
  "GO:0030295": "protein kinase activator activity",
  "GO:0030296": "protein tyrosine kinase activator activity",
  "GO:0030297": "transmembrane receptor protein tyrosine kinase activator activity",
  "GO:0030298": "receptor signaling protein tyrosine kinase activator activity",
  "GO:0030299": "intestinal cholesterol absorption",
  "GO:0030300": "regulation of intestinal cholesterol absorption",
  "GO:0030301": "cholesterol transport",
  "GO:0030302": "deoxynucleotide transport",
  "GO:0030303": "obsolete stromelysin 2 activity",
  "GO:0030304": "obsolete trypsin inhibitor activity",
  "GO:0030305": "heparanase activity",
  "GO:0030306": "ADP-ribosylation factor binding",
  "GO:0030307": "positive regulation of cell growth",
  "GO:0030308": "negative regulation of cell growth",
  "GO:0030309": "poly-N-acetyllactosamine metabolic process",
  "GO:0030310": "poly-N-acetyllactosamine catabolic process",
  "GO:0030311": "poly-N-acetyllactosamine biosynthetic process",
  "GO:0030312": "external encapsulating structure",
  "GO:0030313": "cell envelope",
  "GO:0030314": "junctional membrane complex",
  "GO:0030315": "T-tubule",
  "GO:0030316": "osteoclast differentiation",
  "GO:0030317": "sperm motility",
  "GO:0030318": "melanocyte differentiation",
  "GO:0030319": "obsolete cellular di-, tri-valent inorganic anion homeostasis",
  "GO:0030320": "cellular monovalent inorganic anion homeostasis",
  "GO:0030321": "transepithelial chloride transport",
  "GO:0030322": "stabilization of membrane potential",
  "GO:0030323": "respiratory tube development",
  "GO:0030324": "lung development",
  "GO:0030325": "adrenal gland development",
  "GO:0030326": "embryonic limb morphogenesis",
  "GO:0030327": "prenylated protein catabolic process",
  "GO:0030328": "prenylcysteine catabolic process",
  "GO:0030329": "prenylcysteine metabolic process",
  "GO:0030330": "DNA damage response, signal transduction by p53 class mediator",
  "GO:0030331": "estrogen receptor binding",
  "GO:0030332": "cyclin binding",
  "GO:0030334": "regulation of cell migration",
  "GO:0030335": "positive regulation of cell migration",
  "GO:0030336": "negative regulation of cell migration",
  "GO:0030337": "DNA polymerase processivity factor activity",
  "GO:0030338": "CMP-N-acetylneuraminate monooxygenase activity",
  "GO:0030339": "fatty-acyl-ethyl-ester synthase activity",
  "GO:0030340": "hyaluronate lyase activity",
  "GO:0030341": "chondroitin AC lyase activity",
  "GO:0030342": "1-alpha,25-dihydroxyvitamin D3 24-hydroxylase activity",
  "GO:0030343": "vitamin D3 25-hydroxylase activity",
  "GO:0030345": "structural constituent of tooth enamel",
  "GO:0030346": "protein phosphatase 2B binding",
  "GO:0030348": "syntaxin-3 binding",
  "GO:0030350": "iron-responsive element binding",
  "GO:0030351": "inositol-1,3,4,5,6-pentakisphosphate 3-phosphatase activity",
  "GO:0030352": "inositol-1,4,5,6-tetrakisphosphate 6-phosphatase activity",
  "GO:0030353": "fibroblast growth factor receptor antagonist activity",
  "GO:0030354": "melanin-concentrating hormone activity",
  "GO:0030355": "obsolete small nucleolar ribonucleoprotein",
  "GO:0030356": "obsolete small cytoplasmic ribonucleoprotein",
  "GO:0030359": "protein phosphatase type 2B regulator activity",
  "GO:0030362": "protein phosphatase type 4 regulator activity",
  "GO:0030363": "obsolete pre-mRNA cleavage factor activity",
  "GO:0030364": "obsolete cleavage and polyadenylylation specificity factor activity",
  "GO:0030365": "obsolete cleavage stimulation factor activity",
  "GO:0030366": "molybdopterin synthase activity",
  "GO:0030367": "interleukin-17 receptor binding",
  "GO:0030368": "interleukin-17 receptor activity",
  "GO:0030369": "ICAM-3 receptor activity",
  "GO:0030370": "intercellular adhesion molecule-3 receptor binding",
  "GO:0030371": "translation repressor activity",
  "GO:0030372": "high molecular weight B cell growth factor receptor binding",
  "GO:0030373": "high molecular weight B cell growth factor receptor activity",
  "GO:0030374": "ligand-dependent nuclear receptor transcription coactivator activity",
  "GO:0030375": "thyroid hormone receptor coactivator activity",
  "GO:0030377": "urokinase plasminogen activator receptor activity",
  "GO:0030378": "serine racemase activity",
  "GO:0030379": "neurotensin receptor activity, non-G-protein coupled",
  "GO:0030380": "interleukin-17E receptor binding",
  "GO:0030381": "chorion-containing eggshell pattern formation",
  "GO:0030382": "sperm mitochondrion organization",
  "GO:0030383": "obsolete host-pathogen interaction",
  "GO:0030385": "ferredoxin:thioredoxin reductase activity",
  "GO:0030386": "ferredoxin:thioredoxin reductase complex",
  "GO:0030387": "fructosamine-3-kinase activity",
  "GO:0030388": "fructose 1,6-bisphosphate metabolic process",
  "GO:0030389": "fructosamine metabolic process",
  "GO:0030391": "fructosamine biosynthetic process",
  "GO:0030392": "fructosamine catabolic process",
  "GO:0030393": "fructoselysine metabolic process",
  "GO:0030394": "fructoseglycine metabolic process",
  "GO:0030395": "lactose binding",
  "GO:0030397": "membrane disassembly",
  "GO:0030398": "peroxisomal membrane disassembly",
  "GO:0030399": "autophagosome membrane disassembly",
  "GO:0030400": "obsolete protease substrate recruitment factor activity",
  "GO:0030401": "obsolete transcription antiterminator activity",
  "GO:0030402": "obsolete matrilysin-2 activity",
  "GO:0030403": "obsolete collagenase 4 activity",
  "GO:0030404": "obsolete collagenase 3 activity",
  "GO:0030405": "obsolete matrix metalloproteinase 19 activity",
  "GO:0030406": "obsolete matrix metalloproteinase 25 activity",
  "GO:0030407": "formimidoyltransferase activity",
  "GO:0030408": "glycine formimidoyltransferase activity",
  "GO:0030409": "glutamate formimidoyltransferase activity",
  "GO:0030410": "nicotianamine synthase activity",
  "GO:0030411": "scytalone dehydratase activity",
  "GO:0030412": "formimidoyltetrahydrofolate cyclodeaminase activity",
  "GO:0030413": "competence pheromone activity",
  "GO:0030414": "peptidase inhibitor activity",
  "GO:0030415": "obsolete carboxypeptidase A inhibitor activity",
  "GO:0030416": "methylamine metabolic process",
  "GO:0030417": "nicotianamine metabolic process",
  "GO:0030418": "nicotianamine biosynthetic process",
  "GO:0030419": "nicotianamine catabolic process",
  "GO:0030420": "establishment of competence for transformation",
  "GO:0030421": "defecation",
  "GO:0030422": "production of siRNA involved in RNA interference",
  "GO:0030423": "targeting of mRNA for destruction involved in RNA interference",
  "GO:0030424": "axon",
  "GO:0030425": "dendrite",
  "GO:0030426": "growth cone",
  "GO:0030427": "site of polarized growth",
  "GO:0030428": "cell septum",
  "GO:0030429": "kynureninase activity",
  "GO:0030430": "host cell cytoplasm",
  "GO:0030431": "sleep",
  "GO:0030432": "peristalsis",
  "GO:0030433": "ER-associated ubiquitin-dependent protein catabolic process",
  "GO:0030435": "sporulation resulting in formation of a cellular spore",
  "GO:0030436": "asexual sporulation",
  "GO:0030437": "ascospore formation",
  "GO:0030438": "obsolete MAPKKK cascade during sporulation (sensu Fungi)",
  "GO:0030439": "obsolete activation of MAPK during sporulation (sensu Fungi)",
  "GO:0030440": "obsolete activation of MAPKK during sporulation (sensu Fungi)",
  "GO:0030441": "obsolete activation of MAPKKK during sporulation (sensu Fungi)",
  "GO:0030442": "obsolete inactivation of MAPK during sporulation (sensu Fungi)",
  "GO:0030443": "obsolete nuclear translocation of MAPK during sporulation (sensu Fungi)",
  "GO:0030444": "obsolete microtubule depolymerization during nuclear congression",
  "GO:0030445": "yeast-form cell wall",
  "GO:0030446": "hyphal cell wall",
  "GO:0030447": "filamentous growth",
  "GO:0030448": "hyphal growth",
  "GO:0030449": "regulation of complement activation",
  "GO:0030450": "regulation of complement activation, classical pathway",
  "GO:0030451": "regulation of complement activation, alternative pathway",
  "GO:0030455": "obsolete MAPKKK cascade (mating sensu Fungi)",
  "GO:0030456": "obsolete activation of MAPK (mating sensu Fungi)",
  "GO:0030457": "obsolete activation of MAPKK (mating sensu Fungi)",
  "GO:0030458": "obsolete activation of MAPKKK (mating sensu Fungi)",
  "GO:0030459": "obsolete inactivation of MAPK (mating sensu Fungi)",
  "GO:0030460": "obsolete nuclear translocation of MAPK (mating sensu Fungi)",
  "GO:0030463": "obsolete cell aging (sensu Fungi)",
  "GO:0030464": "obsolete aging dependent sterility (sensu Fungi)",
  "GO:0030465": "obsolete autophagic death (sensu Fungi)",
  "GO:0030466": "chromatin silencing at silent mating-type cassette",
  "GO:0030470": "obsolete spore germination (sensu Fungi)",
  "GO:0030471": "obsolete spindle pole body and microtubule cycle (sensu Fungi)",
  "GO:0030472": "mitotic spindle organization in nucleus",
  "GO:0030473": "nuclear migration along microtubule",
  "GO:0030474": "spindle pole body duplication",
  "GO:0030476": "ascospore wall assembly",
  "GO:0030478": "actin cap",
  "GO:0030479": "actin cortical patch",
  "GO:0030484": "obsolete muscle fiber",
  "GO:0030485": "smooth muscle contractile fiber",
  "GO:0030486": "smooth muscle dense body",
  "GO:0030487": "inositol-4,5-bisphosphate 5-phosphatase activity",
  "GO:0030488": "tRNA methylation",
  "GO:0030489": "obsolete processing of 27S pre-rRNA",
  "GO:0030490": "maturation of SSU-rRNA",
  "GO:0030491": "heteroduplex formation",
  "GO:0030492": "hemoglobin binding",
  "GO:0030493": "bacteriochlorophyll metabolic process",
  "GO:0030494": "bacteriochlorophyll biosynthetic process",
  "GO:0030495": "bacteriochlorophyll catabolic process",
  "GO:0030496": "midbody",
  "GO:0030497": "fatty acid elongation",
  "GO:0030500": "regulation of bone mineralization",
  "GO:0030501": "positive regulation of bone mineralization",
  "GO:0030502": "negative regulation of bone mineralization",
  "GO:0030504": "inorganic diphosphate transmembrane transporter activity",
  "GO:0030505": "inorganic diphosphate transport",
  "GO:0030506": "ankyrin binding",
  "GO:0030507": "spectrin binding",
  "GO:0030508": "obsolete thiol-disulfide exchange intermediate activity",
  "GO:0030509": "BMP signaling pathway",
  "GO:0030510": "regulation of BMP signaling pathway",
  "GO:0030511": "positive regulation of transforming growth factor beta receptor signaling pathway",
  "GO:0030512": "negative regulation of transforming growth factor beta receptor signaling pathway",
  "GO:0030513": "positive regulation of BMP signaling pathway",
  "GO:0030514": "negative regulation of BMP signaling pathway",
  "GO:0030515": "snoRNA binding",
  "GO:0030516": "regulation of axon extension",
  "GO:0030517": "negative regulation of axon extension",
  "GO:0030518": "intracellular steroid hormone receptor signaling pathway",
  "GO:0030519": "snoRNP binding",
  "GO:0030520": "intracellular estrogen receptor signaling pathway",
  "GO:0030521": "androgen receptor signaling pathway",
  "GO:0030522": "intracellular receptor signaling pathway",
  "GO:0030523": "dihydrolipoamide S-acyltransferase activity",
  "GO:0030526": "granulocyte macrophage colony-stimulating factor receptor complex",
  "GO:0030527": "structural constituent of chromatin",
  "GO:0030528": "obsolete transcription regulator activity",
  "GO:0030529": "intracellular ribonucleoprotein complex",
  "GO:0030530": "obsolete heterogeneous nuclear ribonucleoprotein complex",
  "GO:0030531": "obsolete small cytoplasmic ribonucleoprotein complex",
  "GO:0030532": "small nuclear ribonucleoprotein complex",
  "GO:0030533": "triplet codon-amino acid adaptor activity",
  "GO:0030534": "adult behavior",
  "GO:0030535": "obsolete adult feeding behavior (sensu Insecta)",
  "GO:0030536": "larval feeding behavior",
  "GO:0030537": "larval behavior",
  "GO:0030538": "embryonic genitalia morphogenesis",
  "GO:0030539": "male genitalia development",
  "GO:0030540": "female genitalia development",
  "GO:0030541": "plasmid partitioning",
  "GO:0030543": "2-micrometer plasmid partitioning",
  "GO:0030544": "Hsp70 protein binding",
  "GO:0030545": "receptor regulator activity",
  "GO:0030546": "receptor activator activity",
  "GO:0030547": "receptor inhibitor activity",
  "GO:0030548": "acetylcholine receptor regulator activity",
  "GO:0030549": "acetylcholine receptor activator activity",
  "GO:0030550": "acetylcholine receptor inhibitor activity",
  "GO:0030551": "cyclic nucleotide binding",
  "GO:0030552": "cAMP binding",
  "GO:0030553": "cGMP binding",
  "GO:0030554": "adenyl nucleotide binding",
  "GO:0030555": "RNA modification guide activity",
  "GO:0030556": "rRNA modification guide activity",
  "GO:0030557": "tRNA modification guide activity",
  "GO:0030558": "RNA pseudouridylation guide activity",
  "GO:0030559": "rRNA pseudouridylation guide activity",
  "GO:0030560": "tRNA pseudouridylation guide activity",
  "GO:0030561": "RNA 2'-O-ribose methylation guide activity",
  "GO:0030562": "rRNA 2'-O-ribose methylation guide activity",
  "GO:0030563": "snRNA 2'-O-ribose methylation guide activity",
  "GO:0030564": "tRNA 2'-O-ribose methylation guide activity",
  "GO:0030565": "snRNA pseudouridylation guide activity",
  "GO:0030566": "snRNA modification guide activity",
  "GO:0030567": "obsolete thrombin activator activity",
  "GO:0030568": "obsolete plasmin inhibitor activity",
  "GO:0030569": "obsolete chymotrypsin inhibitor activity",
  "GO:0030570": "pectate lyase activity",
  "GO:0030572": "phosphatidyltransferase activity",
  "GO:0030573": "bile acid catabolic process",
  "GO:0030574": "collagen catabolic process",
  "GO:0030575": "nuclear body organization",
  "GO:0030576": "Cajal body organization",
  "GO:0030577": "Lands organization",
  "GO:0030578": "PML body organization",
  "GO:0030579": "ubiquitin-dependent SMAD protein catabolic process",
  "GO:0030580": "quinone cofactor methyltransferase activity",
  "GO:0030581": "symbiont intracellular protein transport in host",
  "GO:0030582": "fruiting body development",
  "GO:0030583": "myxococcal fruiting body development",
  "GO:0030584": "sporocarp development",
  "GO:0030585": "phosphoenolpyruvate carboxykinase (diphosphate) activity",
  "GO:0030586": "[methionine synthase] reductase activity",
  "GO:0030587": "sorocarp development",
  "GO:0030588": "pseudocleavage",
  "GO:0030589": "pseudocleavage involved in syncytial blastoderm formation",
  "GO:0030590": "first cell cycle pseudocleavage",
  "GO:0030591": "NAD DNA ADP-ribosyltransferase activity",
  "GO:0030592": "DNA ADP-ribosylation",
  "GO:0030593": "neutrophil chemotaxis",
  "GO:0030594": "neurotransmitter receptor activity",
  "GO:0030595": "leukocyte chemotaxis",
  "GO:0030596": "alpha-L-rhamnosidase activity",
  "GO:0030597": "RNA glycosylase activity",
  "GO:0030598": "rRNA N-glycosylase activity",
  "GO:0030599": "pectinesterase activity",
  "GO:0030600": "feruloyl esterase activity",
  "GO:0030601": "obsolete aminopeptidase B activity",
  "GO:0030602": "obsolete chymosin activity",
  "GO:0030603": "oxaloacetase activity",
  "GO:0030604": "1-deoxy-D-xylulose-5-phosphate reductoisomerase activity",
  "GO:0030611": "arsenate reductase activity",
  "GO:0030612": "arsenate reductase (thioredoxin) activity",
  "GO:0030613": "oxidoreductase activity, acting on phosphorus or arsenic in donors",
  "GO:0030614": "oxidoreductase activity, acting on phosphorus or arsenic in donors, disulfide as acceptor",
  "GO:0030616": "transforming growth factor beta receptor, common-partner cytoplasmic mediator activity",
  "GO:0030617": "transforming growth factor beta receptor, inhibitory cytoplasmic mediator activity",
  "GO:0030618": "transforming growth factor beta receptor, pathway-specific cytoplasmic mediator activity",
  "GO:0030619": "U1 snRNA binding",
  "GO:0030620": "U2 snRNA binding",
  "GO:0030621": "U4 snRNA binding",
  "GO:0030622": "U4atac snRNA binding",
  "GO:0030623": "U5 snRNA binding",
  "GO:0030624": "U6atac snRNA binding",
  "GO:0030625": "U11 snRNA binding",
  "GO:0030626": "U12 snRNA binding",
  "GO:0030627": "pre-mRNA 5'-splice site binding",
  "GO:0030628": "pre-mRNA 3'-splice site binding",
  "GO:0030629": "U6 snRNA 3'-end binding",
  "GO:0030631": "pyrrolysine incorporation",
  "GO:0030632": "D-alanine biosynthetic process",
  "GO:0030633": "D-alanine family amino acid catabolic process",
  "GO:0030634": "carbon fixation by acetyl-CoA pathway",
  "GO:0030635": "obsolete acetate derivative metabolic process",
  "GO:0030636": "obsolete acetate derivative biosynthetic process",
  "GO:0030637": "obsolete acetate derivative catabolic process",
  "GO:0030638": "polyketide metabolic process",
  "GO:0030639": "polyketide biosynthetic process",
  "GO:0030640": "polyketide catabolic process",
  "GO:0030641": "regulation of cellular pH",
  "GO:0030642": "cellular sulfate ion homeostasis",
  "GO:0030643": "cellular phosphate ion homeostasis",
  "GO:0030644": "cellular chloride ion homeostasis",
  "GO:0030645": "glucose catabolic process to butyrate",
  "GO:0030647": "aminoglycoside antibiotic metabolic process",
  "GO:0030648": "aminoglycoside antibiotic biosynthetic process",
  "GO:0030649": "aminoglycoside antibiotic catabolic process",
  "GO:0030650": "peptide antibiotic metabolic process",
  "GO:0030651": "peptide antibiotic biosynthetic process",
  "GO:0030652": "peptide antibiotic catabolic process",
  "GO:0030653": "beta-lactam antibiotic metabolic process",
  "GO:0030654": "beta-lactam antibiotic biosynthetic process",
  "GO:0030655": "beta-lactam antibiotic catabolic process",
  "GO:0030656": "regulation of vitamin metabolic process",
  "GO:0030657": "obsolete regulation of coenzyme and prosthetic group metabolic process",
  "GO:0030658": "transport vesicle membrane",
  "GO:0030659": "cytoplasmic vesicle membrane",
  "GO:0030660": "Golgi-associated vesicle membrane",
  "GO:0030661": "chitosome membrane",
  "GO:0030662": "coated vesicle membrane",
  "GO:0030663": "COPI-coated vesicle membrane",
  "GO:0030665": "clathrin-coated vesicle membrane",
  "GO:0030666": "endocytic vesicle membrane",
  "GO:0030667": "secretory granule membrane",
  "GO:0030668": "merozoite dense granule membrane",
  "GO:0030669": "clathrin-coated endocytic vesicle membrane",
  "GO:0030670": "phagocytic vesicle membrane",
  "GO:0030671": "clathrin-coated phagocytic vesicle membrane",
  "GO:0030672": "synaptic vesicle membrane",
  "GO:0030673": "axolemma",
  "GO:0030674": "protein binding, bridging",
  "GO:0030676": "Rac guanyl-nucleotide exchange factor activity",
  "GO:0030677": "ribonuclease P complex",
  "GO:0030678": "mitochondrial ribonuclease P complex",
  "GO:0030679": "cyanelle ribonuclease P complex",
  "GO:0030680": "dimeric ribonuclease P complex",
  "GO:0030681": "multimeric ribonuclease P complex",
  "GO:0030682": "evasion or tolerance of host defense response",
  "GO:0030683": "evasion or tolerance by virus of host immune response",
  "GO:0030684": "preribosome",
  "GO:0030685": "nucleolar preribosome",
  "GO:0030686": "90S preribosome",
  "GO:0030687": "preribosome, large subunit precursor",
  "GO:0030688": "preribosome, small subunit precursor",
  "GO:0030689": "Noc complex",
  "GO:0030690": "Noc1p-Noc2p complex",
  "GO:0030691": "Noc2p-Noc3p complex",
  "GO:0030692": "Noc4p-Nop14p complex",
  "GO:0030693": "obsolete caspase activity",
  "GO:0030694": "bacterial-type flagellum basal body, rod",
  "GO:0030695": "GTPase regulator activity",
  "GO:0030696": "tRNA (m5U54) methyltransferase activity",
  "GO:0030697": "S-adenosylmethionine-dependent tRNA (m5U54) methyltransferase activity",
  "GO:0030698": "5,10-methylenetetrahydrofolate-dependent tRNA (m5U54) methyltransferase activity",
  "GO:0030699": "glycine reductase activity",
  "GO:0030700": "glycine reductase complex",
  "GO:0030701": "NAD+-dinitrogen-reductase ADP-D-ribosyltransferase activity",
  "GO:0030702": "chromatin silencing at centromere",
  "GO:0030703": "eggshell formation",
  "GO:0030704": "vitelline membrane formation",
  "GO:0030705": "cytoskeleton-dependent intracellular transport",
  "GO:0030706": "germarium-derived oocyte differentiation",
  "GO:0030707": "ovarian follicle cell development",
  "GO:0030708": "germarium-derived female germ-line cyst encapsulation",
  "GO:0030709": "border follicle cell delamination",
  "GO:0030710": "regulation of border follicle cell delamination",
  "GO:0030711": "positive regulation of border follicle cell delamination",
  "GO:0030712": "negative regulation of border follicle cell delamination",
  "GO:0030713": "ovarian follicle cell stalk formation",
  "GO:0030714": "anterior/posterior axis specification, follicular epithelium",
  "GO:0030715": "oocyte growth in germarium-derived egg chamber",
  "GO:0030716": "oocyte fate determination",
  "GO:0030717": "karyosome formation",
  "GO:0030718": "germ-line stem cell population maintenance",
  "GO:0030719": "P granule organization",
  "GO:0030720": "oocyte localization involved in germarium-derived egg chamber formation",
  "GO:0030721": "spectrosome organization",
  "GO:0030722": "establishment of oocyte nucleus localization involved in oocyte dorsal/ventral axis specification",
  "GO:0030723": "ovarian fusome organization",
  "GO:0030724": "testicular fusome organization",
  "GO:0030725": "germline ring canal formation",
  "GO:0030726": "male germline ring canal formation",
  "GO:0030727": "germarium-derived female germ-line cyst formation",
  "GO:0030728": "ovulation",
  "GO:0030729": "acetoacetate-CoA ligase activity",
  "GO:0030730": "sequestering of triglyceride",
  "GO:0030731": "guanidinoacetate N-methyltransferase activity",
  "GO:0030732": "methionine S-methyltransferase activity",
  "GO:0030733": "fatty acid O-methyltransferase activity",
  "GO:0030734": "polysaccharide O-methyltransferase activity",
  "GO:0030735": "carnosine N-methyltransferase activity",
  "GO:0030736": "phenol O-methyltransferase activity",
  "GO:0030737": "iodophenol O-methyltransferase activity",
  "GO:0030738": "tyramine N-methyltransferase activity",
  "GO:0030739": "O-demethylpuromycin O-methyltransferase activity",
  "GO:0030740": "inositol 3-methyltransferase activity",
  "GO:0030741": "inositol 1-methyltransferase activity",
  "GO:0030742": "GTP-dependent protein binding",
  "GO:0030743": "rRNA (adenosine-2'-O-)-methyltransferase activity",
  "GO:0030744": "luteolin O-methyltransferase activity",
  "GO:0030745": "dimethylhistidine N-methyltransferase activity",
  "GO:0030746": "isoflavone 4'-O-methyltransferase activity",
  "GO:0030747": "indolepyruvate C-methyltransferase activity",
  "GO:0030748": "amine N-methyltransferase activity",
  "GO:0030749": "loganate O-methyltransferase activity",
  "GO:0030750": "putrescine N-methyltransferase activity",
  "GO:0030751": "licodione 2'-O-methyltransferase activity",
  "GO:0030752": "5-hydroxyfuranocoumarin 5-O-methyltransferase activity",
  "GO:0030753": "8-hydroxyfuranocoumarin 8-O-methyltransferase activity",
  "GO:0030754": "apigenin 4'-O-methyltransferase activity",
  "GO:0030755": "quercetin 3-O-methyltransferase activity",
  "GO:0030756": "isoorientin 3'-O-methyltransferase activity",
  "GO:0030757": "3-methylquercitin 7-O-methyltransferase activity",
  "GO:0030758": "3,7-dimethylquercitin 4'-O-methyltransferase activity",
  "GO:0030759": "methylquercetagetin 6-O-methyltransferase activity",
  "GO:0030760": "pyridine N-methyltransferase activity",
  "GO:0030761": "8-hydroxyquercitin 8-O-methyltransferase activity",
  "GO:0030762": "tetrahydrocolumbamine 2-O-methyltransferase activity",
  "GO:0030763": "isobutyraldoxime O-methyltransferase activity",
  "GO:0030766": "11-O-demethyl-17-O-deacetylvindoline O-methyltransferase activity",
  "GO:0030767": "3-hydroxyanthranilate 4-C-methyltransferase activity",
  "GO:0030768": "16-methoxy-2,3-dihydro-3-hydroxytabersonine N-methyltransferase activity",
  "GO:0030769": "macrocin O-methyltransferase activity",
  "GO:0030770": "demethylmacrocin O-methyltransferase activity",
  "GO:0030771": "N-benzoyl-4-hydroxyanthranilate 4-O-methyltransferase activity",
  "GO:0030772": "tryptophan 2-C-methyltransferase activity",
  "GO:0030773": "6-hydroxymellein O-methyltransferase activity",
  "GO:0030774": "anthranilate N-methyltransferase activity",
  "GO:0030775": "glucuronoxylan 4-O-methyltransferase activity",
  "GO:0030776": "(RS)-1-benzyl-1,2,3,4-tetrahydroisoquinoline N-methyltransferase activity",
  "GO:0030777": "(S)-scoulerine 9-O-methyltransferase activity",
  "GO:0030778": "columbamine O-methyltransferase activity",
  "GO:0030779": "10-hydroxydihydrosanguinarine 10-O-methyltransferase activity",
  "GO:0030780": "12-hydroxydihydrochelirubine 12-O-methyltransferase activity",
  "GO:0030781": "6-O-methylnorlaudanosoline 5'-O-methyltransferase activity",
  "GO:0030782": "(S)-tetrahydroprotoberberine N-methyltransferase activity",
  "GO:0030783": "[cytochrome c]-methionine S-methyltransferase activity",
  "GO:0030784": "3'-hydroxy-N-methyl-(S)-coclaurine 4'-O-methyltransferase activity",
  "GO:0030785": "[ribulose-bisphosphate carboxylase]-lysine N-methyltransferase activity",
  "GO:0030786": "(RS)-norcoclaurine 6-O-methyltransferase activity",
  "GO:0030787": "inositol 4-methyltransferase activity",
  "GO:0030788": "precorrin-2 C20-methyltransferase activity",
  "GO:0030789": "precorrin-3B C17-methyltransferase activity",
  "GO:0030790": "chlorophenol O-methyltransferase activity",
  "GO:0030791": "arsenite methyltransferase activity",
  "GO:0030792": "methylarsonite methyltransferase activity",
  "GO:0030793": "3'-demethylstaurosporine O-methyltransferase activity",
  "GO:0030794": "(S)-coclaurine-N-methyltransferase activity",
  "GO:0030795": "jasmonate O-methyltransferase activity",
  "GO:0030796": "cycloartenol 24-C-methyltransferase activity",
  "GO:0030797": "24-methylenesterol C-methyltransferase activity",
  "GO:0030798": "trans-aconitate 2-methyltransferase activity",
  "GO:0030799": "regulation of cyclic nucleotide metabolic process",
  "GO:0030800": "negative regulation of cyclic nucleotide metabolic process",
  "GO:0030801": "positive regulation of cyclic nucleotide metabolic process",
  "GO:0030802": "regulation of cyclic nucleotide biosynthetic process",
  "GO:0030803": "negative regulation of cyclic nucleotide biosynthetic process",
  "GO:0030804": "positive regulation of cyclic nucleotide biosynthetic process",
  "GO:0030805": "regulation of cyclic nucleotide catabolic process",
  "GO:0030806": "negative regulation of cyclic nucleotide catabolic process",
  "GO:0030807": "positive regulation of cyclic nucleotide catabolic process",
  "GO:0030808": "regulation of nucleotide biosynthetic process",
  "GO:0030809": "negative regulation of nucleotide biosynthetic process",
  "GO:0030810": "positive regulation of nucleotide biosynthetic process",
  "GO:0030811": "regulation of nucleotide catabolic process",
  "GO:0030812": "negative regulation of nucleotide catabolic process",
  "GO:0030813": "positive regulation of nucleotide catabolic process",
  "GO:0030814": "regulation of cAMP metabolic process",
  "GO:0030815": "negative regulation of cAMP metabolic process",
  "GO:0030816": "positive regulation of cAMP metabolic process",
  "GO:0030817": "regulation of cAMP biosynthetic process",
  "GO:0030818": "negative regulation of cAMP biosynthetic process",
  "GO:0030819": "positive regulation of cAMP biosynthetic process",
  "GO:0030820": "regulation of cAMP catabolic process",
  "GO:0030821": "negative regulation of cAMP catabolic process",
  "GO:0030822": "positive regulation of cAMP catabolic process",
  "GO:0030823": "regulation of cGMP metabolic process",
  "GO:0030824": "negative regulation of cGMP metabolic process",
  "GO:0030825": "positive regulation of cGMP metabolic process",
  "GO:0030826": "regulation of cGMP biosynthetic process",
  "GO:0030827": "negative regulation of cGMP biosynthetic process",
  "GO:0030828": "positive regulation of cGMP biosynthetic process",
  "GO:0030829": "regulation of cGMP catabolic process",
  "GO:0030830": "negative regulation of cGMP catabolic process",
  "GO:0030831": "positive regulation of cGMP catabolic process",
  "GO:0030832": "regulation of actin filament length",
  "GO:0030833": "regulation of actin filament polymerization",
  "GO:0030834": "regulation of actin filament depolymerization",
  "GO:0030835": "negative regulation of actin filament depolymerization",
  "GO:0030836": "positive regulation of actin filament depolymerization",
  "GO:0030837": "negative regulation of actin filament polymerization",
  "GO:0030838": "positive regulation of actin filament polymerization",
  "GO:0030839": "regulation of intermediate filament polymerization",
  "GO:0030840": "negative regulation of intermediate filament polymerization",
  "GO:0030841": "positive regulation of intermediate filament polymerization",
  "GO:0030842": "regulation of intermediate filament depolymerization",
  "GO:0030843": "negative regulation of intermediate filament depolymerization",
  "GO:0030844": "positive regulation of intermediate filament depolymerization",
  "GO:0030845": "phospholipase C-inhibiting G-protein coupled receptor signaling pathway",
  "GO:0030846": "termination of RNA polymerase II transcription, poly(A)-coupled",
  "GO:0030847": "termination of RNA polymerase II transcription, exosome-dependent",
  "GO:0030848": "threo-3-hydroxyaspartate ammonia-lyase activity",
  "GO:0030849": "autosome",
  "GO:0030850": "prostate gland development",
  "GO:0030851": "granulocyte differentiation",
  "GO:0030852": "regulation of granulocyte differentiation",
  "GO:0030853": "negative regulation of granulocyte differentiation",
  "GO:0030854": "positive regulation of granulocyte differentiation",
  "GO:0030855": "epithelial cell differentiation",
  "GO:0030856": "regulation of epithelial cell differentiation",
  "GO:0030857": "negative regulation of epithelial cell differentiation",
  "GO:0030858": "positive regulation of epithelial cell differentiation",
  "GO:0030859": "polarized epithelial cell differentiation",
  "GO:0030860": "regulation of polarized epithelial cell differentiation",
  "GO:0030861": "negative regulation of polarized epithelial cell differentiation",
  "GO:0030862": "positive regulation of polarized epithelial cell differentiation",
  "GO:0030863": "cortical cytoskeleton",
  "GO:0030864": "cortical actin cytoskeleton",
  "GO:0030865": "cortical cytoskeleton organization",
  "GO:0030866": "cortical actin cytoskeleton organization",
  "GO:0030867": "rough endoplasmic reticulum membrane",
  "GO:0030868": "smooth endoplasmic reticulum membrane",
  "GO:0030869": "RENT complex",
  "GO:0030870": "Mre11 complex",
  "GO:0030874": "nucleolar chromatin",
  "GO:0030875": "rDNA protrusion",
  "GO:0030876": "interleukin-20 receptor complex",
  "GO:0030877": "beta-catenin destruction complex",
  "GO:0030878": "thyroid gland development",
  "GO:0030879": "mammary gland development",
  "GO:0030880": "RNA polymerase complex",
  "GO:0030881": "beta-2-microglobulin binding",
  "GO:0030882": "lipid antigen binding",
  "GO:0030883": "endogenous lipid antigen binding",
  "GO:0030884": "exogenous lipid antigen binding",
  "GO:0030885": "regulation of myeloid dendritic cell activation",
  "GO:0030886": "negative regulation of myeloid dendritic cell activation",
  "GO:0030887": "positive regulation of myeloid dendritic cell activation",
  "GO:0030888": "regulation of B cell proliferation",
  "GO:0030889": "negative regulation of B cell proliferation",
  "GO:0030890": "positive regulation of B cell proliferation",
  "GO:0030891": "VCB complex",
  "GO:0030892": "mitotic cohesin complex",
  "GO:0030893": "meiotic cohesin complex",
  "GO:0030894": "replisome",
  "GO:0030895": "apolipoprotein B mRNA editing enzyme complex",
  "GO:0030896": "checkpoint clamp complex",
  "GO:0030897": "HOPS complex",
  "GO:0030898": "actin-dependent ATPase activity",
  "GO:0030899": "calcium-dependent ATPase activity",
  "GO:0030900": "forebrain development",
  "GO:0030901": "midbrain development",
  "GO:0030902": "hindbrain development",
  "GO:0030903": "notochord development",
  "GO:0030904": "retromer complex",
  "GO:0030905": "retromer, tubulation complex",
  "GO:0030906": "retromer, cargo-selective complex",
  "GO:0030907": "MBF transcription complex",
  "GO:0030908": "protein splicing",
  "GO:0030909": "non-intein-mediated protein splicing",
  "GO:0030910": "olfactory placode formation",
  "GO:0030911": "TPR domain binding",
  "GO:0030912": "response to deep water",
  "GO:0030913": "paranodal junction assembly",
  "GO:0030914": "STAGA complex",
  "GO:0030915": "Smc5-Smc6 complex",
  "GO:0030916": "otic vesicle formation",
  "GO:0030917": "midbrain-hindbrain boundary development",
  "GO:0030919": "peptidyl-serine O-acetylation",
  "GO:0030920": "peptidyl-serine acetylation",
  "GO:0030921": "peptidyl-tyrosine dehydrogenation to form (Z)-2,3-didehydrotyrosine",
  "GO:0030922": "peptidyl-tyrosine dehydrogenation to form (E)-2,3-didehydrotyrosine",
  "GO:0030923": "metal incorporation into metallo-oxygen cluster",
  "GO:0030924": "manganese incorporation into metallo-oxygen cluster",
  "GO:0030925": "calcium incorporation into metallo-oxygen cluster",
  "GO:0030926": "calcium incorporation into metallo-oxygen cluster via bis-L-aspartato tris-L-glutamato L-histidino calcium tetramanganese tetroxide",
  "GO:0030927": "manganese incorporation into metallo-oxygen cluster via bis-L-aspartato tris-L-glutamato L-histidino calcium tetramanganese tetroxide",
  "GO:0030929": "ADPG pyrophosphorylase complex",
  "GO:0030930": "homotetrameric ADPG pyrophosphorylase complex",
  "GO:0030931": "heterotetrameric ADPG pyrophosphorylase complex",
  "GO:0030932": "amyloplast ADPG pyrophosphorylase complex",
  "GO:0030933": "chloroplast ADPG pyrophosphorylase complex",
  "GO:0030934": "anchoring collagen complex",
  "GO:0030935": "sheet-forming collagen trimer",
  "GO:0030936": "transmembrane collagen trimer",
  "GO:0030937": "collagen type XVII trimer",
  "GO:0030938": "collagen type XVIII trimer",
  "GO:0030939": "obsolete response to long-day photoperiod",
  "GO:0030940": "obsolete response to short-day photoperiod",
  "GO:0030941": "chloroplast targeting sequence binding",
  "GO:0030942": "endoplasmic reticulum signal peptide binding",
  "GO:0030943": "mitochondrion targeting sequence binding",
  "GO:0030944": "DDEL sequence binding",
  "GO:0030945": "protein tyrosine phosphatase activity, via thiol-phosphate intermediate",
  "GO:0030946": "protein tyrosine phosphatase activity, metal-dependent",
  "GO:0030947": "regulation of vascular endothelial growth factor receptor signaling pathway",
  "GO:0030948": "negative regulation of vascular endothelial growth factor receptor signaling pathway",
  "GO:0030949": "positive regulation of vascular endothelial growth factor receptor signaling pathway",
  "GO:0030950": "establishment or maintenance of actin cytoskeleton polarity",
  "GO:0030951": "establishment or maintenance of microtubule cytoskeleton polarity",
  "GO:0030952": "establishment or maintenance of cytoskeleton polarity",
  "GO:0030953": "astral microtubule organization",
  "GO:0030954": "astral microtubule nucleation",
  "GO:0030955": "potassium ion binding",
  "GO:0030956": "glutamyl-tRNA(Gln) amidotransferase complex",
  "GO:0030957": "Tat protein binding",
  "GO:0030958": "RITS complex",
  "GO:0030959": "peptide cross-linking via 3'-(3'-L-tyrosinyl)-L-tyrosine",
  "GO:0030960": "peptide cross-linking via 3'-(O4'-L-tyrosinyl)-L-tyrosine",
  "GO:0030961": "peptidyl-arginine hydroxylation",
  "GO:0030962": "peptidyl-arginine dihydroxylation to peptidyl-3,4-dihydroxy-L-arginine",
  "GO:0030963": "peptidyl-lysine dihydroxylation to 4,5-dihydroxy-L-lysine",
  "GO:0030964": "NADH dehydrogenase complex",
  "GO:0030965": "plasma membrane electron transport, NADH to quinone",
  "GO:0030968": "endoplasmic reticulum unfolded protein response",
  "GO:0030969": "mRNA splicing via endonucleolytic cleavage and ligation involved in unfolded protein response",
  "GO:0030970": "retrograde protein transport, ER to cytosol",
  "GO:0030971": "receptor tyrosine kinase binding",
  "GO:0030972": "obsolete cleavage of cytosolic proteins involved in execution phase of apoptosis",
  "GO:0030973": "molybdate ion binding",
  "GO:0030974": "thiamine pyrophosphate transport",
  "GO:0030975": "thiamine binding",
  "GO:0030976": "thiamine pyrophosphate binding",
  "GO:0030977": "taurine binding",
  "GO:0030978": "alpha-glucan metabolic process",
  "GO:0030979": "alpha-glucan biosynthetic process",
  "GO:0030980": "alpha-glucan catabolic process",
  "GO:0030981": "cortical microtubule cytoskeleton",
  "GO:0030982": "adventurous gliding motility",
  "GO:0030983": "mismatched DNA binding",
  "GO:0030984": "kininogen binding",
  "GO:0030985": "high molecular weight kininogen binding",
  "GO:0030986": "low molecular weight kininogen binding",
  "GO:0030987": "high molecular weight kininogen receptor binding",
  "GO:0030988": "high molecular weight kininogen receptor complex",
  "GO:0030989": "dynein-driven meiotic oscillatory nuclear movement",
  "GO:0030990": "intraciliary transport particle",
  "GO:0030991": "intraciliary transport particle A",
  "GO:0030992": "intraciliary transport particle B",
  "GO:0030993": "axonemal heterotrimeric kinesin-II complex",
  "GO:0030994": "primary cell septum disassembly",
  "GO:0030995": "cell septum edging catabolic process",
  "GO:0030996": "obsolete mitotic cell cycle arrest in response to nitrogen starvation",
  "GO:0030997": "regulation of centriole-centriole cohesion",
  "GO:0030998": "linear element",
  "GO:0030999": "linear element assembly",
  "GO:0031000": "response to caffeine",
  "GO:0031001": "response to brefeldin A",
  "GO:0031002": "actin rod",
  "GO:0031003": "actin tubule",
  "GO:0031004": "potassium ion-transporting ATPase complex",
  "GO:0031005": "filamin binding",
  "GO:0031009": "plastid ADPG pyrophosphorylase complex",
  "GO:0031010": "ISWI-type complex",
  "GO:0031011": "Ino80 complex",
  "GO:0031012": "extracellular matrix",
  "GO:0031013": "troponin I binding",
  "GO:0031014": "troponin T binding",
  "GO:0031015": "obsolete karyopherin docking complex",
  "GO:0031016": "pancreas development",
  "GO:0031017": "exocrine pancreas development",
  "GO:0031018": "endocrine pancreas development",
  "GO:0031019": "mitochondrial mRNA editing complex",
  "GO:0031020": "plastid mRNA editing complex",
  "GO:0031021": "interphase microtubule organizing center",
  "GO:0031022": "nuclear migration along microfilament",
  "GO:0031023": "microtubule organizing center organization",
  "GO:0031024": "interphase microtubule organizing center assembly",
  "GO:0031025": "equatorial microtubule organizing center disassembly",
  "GO:0031026": "glutamate synthase complex",
  "GO:0031027": "glutamate synthase complex (NADH)",
  "GO:0031028": "septation initiation signaling",
  "GO:0031029": "regulation of septation initiation signaling",
  "GO:0031030": "negative regulation of septation initiation signaling",
  "GO:0031031": "positive regulation of septation initiation signaling",
  "GO:0031032": "actomyosin structure organization",
  "GO:0031033": "myosin filament organization",
  "GO:0031034": "myosin filament assembly",
  "GO:0031035": "myosin filament disassembly",
  "GO:0031036": "myosin II filament assembly",
  "GO:0031037": "myosin II filament disassembly",
  "GO:0031038": "myosin II filament organization",
  "GO:0031039": "macronucleus",
  "GO:0031040": "micronucleus",
  "GO:0031041": "O-glycan processing, core 5",
  "GO:0031042": "O-glycan processing, core 6",
  "GO:0031043": "O-glycan processing, core 7",
  "GO:0031044": "O-glycan processing, core 8",
  "GO:0031045": "dense core granule",
  "GO:0031047": "gene silencing by RNA",
  "GO:0031048": "chromatin silencing by small RNA",
  "GO:0031049": "programmed DNA elimination",
  "GO:0031050": "dsRNA fragmentation",
  "GO:0031051": "scnRNA production",
  "GO:0031052": "chromosome breakage",
  "GO:0031053": "primary miRNA processing",
  "GO:0031054": "pre-miRNA processing",
  "GO:0031055": "chromatin remodeling at centromere",
  "GO:0031056": "regulation of histone modification",
  "GO:0031057": "negative regulation of histone modification",
  "GO:0031058": "positive regulation of histone modification",
  "GO:0031059": "histone deacetylation at centromere",
  "GO:0031060": "regulation of histone methylation",
  "GO:0031061": "negative regulation of histone methylation",
  "GO:0031062": "positive regulation of histone methylation",
  "GO:0031063": "regulation of histone deacetylation",
  "GO:0031064": "negative regulation of histone deacetylation",
  "GO:0031065": "positive regulation of histone deacetylation",
  "GO:0031066": "regulation of histone deacetylation at centromere",
  "GO:0031067": "negative regulation of histone deacetylation at centromere",
  "GO:0031068": "positive regulation of histone deacetylation at centromere",
  "GO:0031069": "hair follicle morphogenesis",
  "GO:0031070": "intronic snoRNA processing",
  "GO:0031071": "cysteine desulfurase activity",
  "GO:0031072": "heat shock protein binding",
  "GO:0031073": "cholesterol 26-hydroxylase activity",
  "GO:0031074": "nucleocytoplasmic shuttling complex",
  "GO:0031076": "embryonic camera-type eye development",
  "GO:0031077": "post-embryonic camera-type eye development",
  "GO:0031078": "histone deacetylase activity (H3-K14 specific)",
  "GO:0031079": "obsolete picornain 3C activity",
  "GO:0031080": "nuclear pore outer ring",
  "GO:0031081": "nuclear pore distribution",
  "GO:0031082": "BLOC complex",
  "GO:0031083": "BLOC-1 complex",
  "GO:0031084": "BLOC-2 complex",
  "GO:0031085": "BLOC-3 complex",
  "GO:0031086": "nuclear-transcribed mRNA catabolic process, deadenylation-independent decay",
  "GO:0031087": "deadenylation-independent decapping of nuclear-transcribed mRNA",
  "GO:0031088": "platelet dense granule membrane",
  "GO:0031089": "platelet dense granule lumen",
  "GO:0031090": "organelle membrane",
  "GO:0031091": "platelet alpha granule",
  "GO:0031092": "platelet alpha granule membrane",
  "GO:0031093": "platelet alpha granule lumen",
  "GO:0031094": "platelet dense tubular network",
  "GO:0031095": "platelet dense tubular network membrane",
  "GO:0031096": "platelet dense tubular network lumen",
  "GO:0031097": "medial cortex",
  "GO:0031098": "stress-activated protein kinase signaling cascade",
  "GO:0031099": "regeneration",
  "GO:0031100": "organ regeneration",
  "GO:0031101": "fin regeneration",
  "GO:0031102": "neuron projection regeneration",
  "GO:0031103": "axon regeneration",
  "GO:0031104": "dendrite regeneration",
  "GO:0031105": "septin complex",
  "GO:0031106": "septin ring organization",
  "GO:0031107": "septin ring disassembly",
  "GO:0031108": "holo-[acyl-carrier-protein] biosynthetic process",
  "GO:0031109": "microtubule polymerization or depolymerization",
  "GO:0031110": "regulation of microtubule polymerization or depolymerization",
  "GO:0031111": "negative regulation of microtubule polymerization or depolymerization",
  "GO:0031112": "positive regulation of microtubule polymerization or depolymerization",
  "GO:0031113": "regulation of microtubule polymerization",
  "GO:0031114": "regulation of microtubule depolymerization",
  "GO:0031115": "negative regulation of microtubule polymerization",
  "GO:0031116": "positive regulation of microtubule polymerization",
  "GO:0031117": "positive regulation of microtubule depolymerization",
  "GO:0031118": "rRNA pseudouridine synthesis",
  "GO:0031119": "tRNA pseudouridine synthesis",
  "GO:0031120": "snRNA pseudouridine synthesis",
  "GO:0031121": "equatorial microtubule organization",
  "GO:0031122": "cytoplasmic microtubule organization",
  "GO:0031123": "RNA 3'-end processing",
  "GO:0031124": "mRNA 3'-end processing",
  "GO:0031125": "rRNA 3'-end processing",
  "GO:0031126": "snoRNA 3'-end processing",
  "GO:0031127": "alpha-(1,2)-fucosyltransferase activity",
  "GO:0031128": "developmental induction",
  "GO:0031129": "inductive cell-cell signaling",
  "GO:0031130": "creation of an inductive signal",
  "GO:0031131": "reception of an inductive signal",
  "GO:0031132": "serine 3-dehydrogenase activity",
  "GO:0031133": "regulation of axon diameter",
  "GO:0031134": "sister chromatid biorientation",
  "GO:0031135": "negative regulation of conjugation",
  "GO:0031136": "positive regulation of conjugation",
  "GO:0031137": "regulation of conjugation with cellular fusion",
  "GO:0031138": "negative regulation of conjugation with cellular fusion",
  "GO:0031139": "positive regulation of conjugation with cellular fusion",
  "GO:0031140": "induction of conjugation upon nutrient starvation",
  "GO:0031141": "induction of conjugation upon carbon starvation",
  "GO:0031142": "induction of conjugation upon nitrogen starvation",
  "GO:0031143": "pseudopodium",
  "GO:0031144": "proteasome localization",
  "GO:0031145": "anaphase-promoting complex-dependent proteasomal ubiquitin-dependent protein catabolic process",
  "GO:0031146": "SCF-dependent proteasomal ubiquitin-dependent protein catabolic process",
  "GO:0031147": "1-(3,5-dichloro-2,6-dihydroxy-4-methoxyphenyl)hexan-1-one metabolic process",
  "GO:0031148": "DIF-1 biosynthetic process",
  "GO:0031149": "sorocarp stalk cell differentiation",
  "GO:0031150": "sorocarp stalk development",
  "GO:0031151": "histone methyltransferase activity (H3-K79 specific)",
  "GO:0031152": "aggregation involved in sorocarp development",
  "GO:0031153": "slug development involved in sorocarp development",
  "GO:0031154": "culmination involved in sorocarp development",
  "GO:0031155": "regulation of fruiting body development",
  "GO:0031156": "regulation of sorocarp development",
  "GO:0031157": "regulation of aggregate size involved in sorocarp development",
  "GO:0031158": "negative regulation of aggregate size involved in sorocarp development",
  "GO:0031159": "positive regulation of aggregate size involved in sorocarp development",
  "GO:0031160": "spore wall",
  "GO:0031161": "phosphatidylinositol catabolic process",
  "GO:0031162": "sulfur incorporation into metallo-sulfur cluster",
  "GO:0031163": "metallo-sulfur cluster assembly",
  "GO:0031164": "contractile vacuolar membrane",
  "GO:0031165": "integral component of contractile vacuolar membrane",
  "GO:0031166": "integral component of vacuolar membrane",
  "GO:0031167": "rRNA methylation",
  "GO:0031168": "ferrichrome metabolic process",
  "GO:0031169": "ferrichrome biosynthetic process",
  "GO:0031170": "ferricrocin metabolic process",
  "GO:0031171": "ferricrocin biosynthetic process",
  "GO:0031172": "ornithine N5-monooxygenase activity",
  "GO:0031173": "otolith mineralization completed early in development",
  "GO:0031174": "lifelong otolith mineralization",
  "GO:0031175": "neuron projection development",
  "GO:0031176": "endo-1,4-beta-xylanase activity",
  "GO:0031177": "phosphopantetheine binding",
  "GO:0031179": "peptide modification",
  "GO:0031201": "SNARE complex",
  "GO:0031203": "posttranslational protein targeting to membrane, docking",
  "GO:0031204": "posttranslational protein targeting to membrane, translocation",
  "GO:0031205": "endoplasmic reticulum Sec complex",
  "GO:0031207": "Sec62/Sec63 complex",
  "GO:0031208": "POZ domain binding",
  "GO:0031209": "SCAR complex",
  "GO:0031210": "phosphatidylcholine binding",
  "GO:0031211": "endoplasmic reticulum palmitoyltransferase complex",
  "GO:0031213": "RSF complex",
  "GO:0031214": "biomineral tissue development",
  "GO:0031215": "shell calcification",
  "GO:0031216": "neopullulanase activity",
  "GO:0031217": "glucan 1,4-beta-glucosidase activity",
  "GO:0031218": "arabinogalactan endo-1,4-beta-galactosidase activity",
  "GO:0031219": "levanase activity",
  "GO:0031220": "maltodextrin phosphorylase activity",
  "GO:0031221": "arabinan metabolic process",
  "GO:0031222": "arabinan catabolic process",
  "GO:0031223": "auditory behavior",
  "GO:0031224": "intrinsic component of membrane",
  "GO:0031225": "anchored component of membrane",
  "GO:0031226": "intrinsic component of plasma membrane",
  "GO:0031227": "intrinsic component of endoplasmic reticulum membrane",
  "GO:0031228": "intrinsic component of Golgi membrane",
  "GO:0031229": "intrinsic component of nuclear inner membrane",
  "GO:0031230": "intrinsic component of cell outer membrane",
  "GO:0031231": "intrinsic component of peroxisomal membrane",
  "GO:0031232": "extrinsic component of external side of plasma membrane",
  "GO:0031233": "intrinsic component of external side of plasma membrane",
  "GO:0031234": "extrinsic component of cytoplasmic side of plasma membrane",
  "GO:0031235": "intrinsic component of the cytoplasmic side of the plasma membrane",
  "GO:0031236": "extrinsic component of periplasmic side of plasma membrane",
  "GO:0031237": "intrinsic component of periplasmic side of plasma membrane",
  "GO:0031240": "external side of cell outer membrane",
  "GO:0031241": "periplasmic side of cell outer membrane",
  "GO:0031242": "extrinsic component of external side of cell outer membrane",
  "GO:0031243": "intrinsic component of external side of cell outer membrane",
  "GO:0031244": "extrinsic component of cell outer membrane",
  "GO:0031245": "extrinsic component of periplasmic side of cell outer membrane",
  "GO:0031246": "intrinsic component of periplasmic side of cell outer membrane",
  "GO:0031247": "actin rod assembly",
  "GO:0031248": "protein acetyltransferase complex",
  "GO:0031249": "denatured protein binding",
  "GO:0031250": "anaerobic ribonucleoside-triphosphate reductase complex",
  "GO:0031251": "PAN complex",
  "GO:0031252": "cell leading edge",
  "GO:0031253": "cell projection membrane",
  "GO:0031254": "cell trailing edge",
  "GO:0031255": "lateral part of motile cell",
  "GO:0031256": "leading edge membrane",
  "GO:0031257": "cell trailing edge membrane",
  "GO:0031258": "lamellipodium membrane",
  "GO:0031259": "uropod membrane",
  "GO:0031260": "pseudopodium membrane",
  "GO:0031261": "DNA replication preinitiation complex",
  "GO:0031262": "Ndc80 complex",
  "GO:0031263": "amine-transporting ATPase activity",
  "GO:0031264": "death-inducing signaling complex",
  "GO:0031265": "CD95 death-inducing signaling complex",
  "GO:0031266": "TRAIL death-inducing signaling complex",
  "GO:0031267": "small GTPase binding",
  "GO:0031268": "pseudopodium organization",
  "GO:0031269": "pseudopodium assembly",
  "GO:0031270": "pseudopodium retraction",
  "GO:0031271": "lateral pseudopodium assembly",
  "GO:0031272": "regulation of pseudopodium assembly",
  "GO:0031273": "negative regulation of pseudopodium assembly",
  "GO:0031274": "positive regulation of pseudopodium assembly",
  "GO:0031275": "regulation of lateral pseudopodium assembly",
  "GO:0031276": "negative regulation of lateral pseudopodium assembly",
  "GO:0031277": "positive regulation of lateral pseudopodium assembly",
  "GO:0031278": "alpha-1,2-galactosyltransferase activity",
  "GO:0031279": "regulation of cyclase activity",
  "GO:0031280": "negative regulation of cyclase activity",
  "GO:0031281": "positive regulation of cyclase activity",
  "GO:0031282": "regulation of guanylate cyclase activity",
  "GO:0031283": "negative regulation of guanylate cyclase activity",
  "GO:0031284": "positive regulation of guanylate cyclase activity",
  "GO:0031285": "regulation of sorocarp stalk cell differentiation",
  "GO:0031286": "negative regulation of sorocarp stalk cell differentiation",
  "GO:0031287": "positive regulation of sorocarp stalk cell differentiation",
  "GO:0031288": "sorocarp morphogenesis",
  "GO:0031289": "actin phosphorylation",
  "GO:0031290": "retinal ganglion cell axon guidance",
  "GO:0031291": "Ran protein signal transduction",
  "GO:0031292": "gene conversion at mating-type locus, DNA double-strand break processing",
  "GO:0031293": "membrane protein intracellular domain proteolysis",
  "GO:0031294": "lymphocyte costimulation",
  "GO:0031295": "T cell costimulation",
  "GO:0031296": "B cell costimulation",
  "GO:0031297": "replication fork processing",
  "GO:0031298": "replication fork protection complex",
  "GO:0031299": "taurine-pyruvate aminotransferase activity",
  "GO:0031300": "intrinsic component of organelle membrane",
  "GO:0031301": "integral component of organelle membrane",
  "GO:0031302": "intrinsic component of endosome membrane",
  "GO:0031303": "integral component of endosome membrane",
  "GO:0031304": "intrinsic component of mitochondrial inner membrane",
  "GO:0031305": "integral component of mitochondrial inner membrane",
  "GO:0031306": "intrinsic component of mitochondrial outer membrane",
  "GO:0031307": "integral component of mitochondrial outer membrane",
  "GO:0031308": "intrinsic component of nuclear outer membrane",
  "GO:0031309": "integral component of nuclear outer membrane",
  "GO:0031310": "intrinsic component of vacuolar membrane",
  "GO:0031311": "intrinsic component of contractile vacuolar membrane",
  "GO:0031312": "extrinsic component of organelle membrane",
  "GO:0031313": "extrinsic component of endosome membrane",
  "GO:0031314": "extrinsic component of mitochondrial inner membrane",
  "GO:0031315": "extrinsic component of mitochondrial outer membrane",
  "GO:0031316": "extrinsic component of nuclear outer membrane",
  "GO:0031317": "tripartite ATP-independent periplasmic transporter complex",
  "GO:0031318": "detection of folic acid",
  "GO:0031319": "detection of cAMP",
  "GO:0031320": "hexitol dehydrogenase activity",
  "GO:0031321": "ascospore-type prospore assembly",
  "GO:0031322": "ascospore-type prospore-specific spindle pole body remodeling",
  "GO:0031323": "regulation of cellular metabolic process",
  "GO:0031324": "negative regulation of cellular metabolic process",
  "GO:0031325": "positive regulation of cellular metabolic process",
  "GO:0031326": "regulation of cellular biosynthetic process",
  "GO:0031327": "negative regulation of cellular biosynthetic process",
  "GO:0031328": "positive regulation of cellular biosynthetic process",
  "GO:0031329": "regulation of cellular catabolic process",
  "GO:0031330": "negative regulation of cellular catabolic process",
  "GO:0031331": "positive regulation of cellular catabolic process",
  "GO:0031332": "RNAi effector complex",
  "GO:0031333": "negative regulation of protein complex assembly",
  "GO:0031334": "positive regulation of protein complex assembly",
  "GO:0031335": "regulation of sulfur amino acid metabolic process",
  "GO:0031336": "negative regulation of sulfur amino acid metabolic process",
  "GO:0031337": "positive regulation of sulfur amino acid metabolic process",
  "GO:0031338": "regulation of vesicle fusion",
  "GO:0031339": "negative regulation of vesicle fusion",
  "GO:0031340": "positive regulation of vesicle fusion",
  "GO:0031341": "regulation of cell killing",
  "GO:0031342": "negative regulation of cell killing",
  "GO:0031343": "positive regulation of cell killing",
  "GO:0031344": "regulation of cell projection organization",
  "GO:0031345": "negative regulation of cell projection organization",
  "GO:0031346": "positive regulation of cell projection organization",
  "GO:0031347": "regulation of defense response",
  "GO:0031348": "negative regulation of defense response",
  "GO:0031349": "positive regulation of defense response",
  "GO:0031350": "intrinsic component of plastid membrane",
  "GO:0031351": "integral component of plastid membrane",
  "GO:0031352": "intrinsic component of plastid inner membrane",
  "GO:0031353": "integral component of plastid inner membrane",
  "GO:0031354": "intrinsic component of plastid outer membrane",
  "GO:0031355": "integral component of plastid outer membrane",
  "GO:0031356": "intrinsic component of chloroplast inner membrane",
  "GO:0031357": "integral component of chloroplast inner membrane",
  "GO:0031358": "intrinsic component of chloroplast outer membrane",
  "GO:0031359": "integral component of chloroplast outer membrane",
  "GO:0031360": "intrinsic component of thylakoid membrane",
  "GO:0031361": "integral component of thylakoid membrane",
  "GO:0031362": "anchored component of external side of plasma membrane",
  "GO:0031363": "N-terminal protein amino acid deamination",
  "GO:0031364": "N-terminal protein amino acid deamination, from side chain",
  "GO:0031365": "N-terminal protein amino acid modification",
  "GO:0031366": "N-terminal peptidyl-asparagine deamination",
  "GO:0031367": "N-terminal peptidyl-glutamine deamination",
  "GO:0031368": "obsolete Pro-X metallocarboxypeptidase activity",
  "GO:0031369": "translation initiation factor binding",
  "GO:0031370": "eukaryotic initiation factor 4G binding",
  "GO:0031371": "ubiquitin conjugating enzyme complex",
  "GO:0031372": "UBC13-MMS2 complex",
  "GO:0031375": "obsolete type II fatty acid synthase complex",
  "GO:0031376": "obsolete cytosolic type II fatty acid synthase complex",
  "GO:0031377": "obsolete mitochondrial type II fatty acid synthase complex",
  "GO:0031378": "obsolete plastid type II fatty acid synthase complex",
  "GO:0031379": "RNA-directed RNA polymerase complex",
  "GO:0031380": "nuclear RNA-directed RNA polymerase complex",
  "GO:0031381": "viral RNA-directed RNA polymerase complex",
  "GO:0031382": "mating projection assembly",
  "GO:0031383": "regulation of mating projection assembly",
  "GO:0031384": "regulation of initiation of mating projection growth",
  "GO:0031385": "regulation of termination of mating projection growth",
  "GO:0031386": "protein tag",
  "GO:0031387": "MPF complex",
  "GO:0031388": "organic acid phosphorylation",
  "GO:0031389": "Rad17 RFC-like complex",
  "GO:0031390": "Ctf18 RFC-like complex",
  "GO:0031391": "Elg1 RFC-like complex",
  "GO:0031392": "regulation of prostaglandin biosynthetic process",
  "GO:0031393": "negative regulation of prostaglandin biosynthetic process",
  "GO:0031394": "positive regulation of prostaglandin biosynthetic process",
  "GO:0031395": "bursicon neuropeptide hormone complex",
  "GO:0031396": "regulation of protein ubiquitination",
  "GO:0031397": "negative regulation of protein ubiquitination",
  "GO:0031398": "positive regulation of protein ubiquitination",
  "GO:0031399": "regulation of protein modification process",
  "GO:0031400": "negative regulation of protein modification process",
  "GO:0031401": "positive regulation of protein modification process",
  "GO:0031402": "sodium ion binding",
  "GO:0031403": "lithium ion binding",
  "GO:0031404": "chloride ion binding",
  "GO:0031405": "lipoic acid binding",
  "GO:0031406": "carboxylic acid binding",
  "GO:0031407": "oxylipin metabolic process",
  "GO:0031408": "oxylipin biosynthetic process",
  "GO:0031409": "pigment binding",
  "GO:0031410": "cytoplasmic vesicle",
  "GO:0031411": "gas vesicle",
  "GO:0031412": "gas vesicle organization",
  "GO:0031413": "regulation of buoyancy",
  "GO:0031414": "N-terminal protein acetyltransferase complex",
  "GO:0031415": "NatA complex",
  "GO:0031416": "NatB complex",
  "GO:0031417": "NatC complex",
  "GO:0031418": "L-ascorbic acid binding",
  "GO:0031419": "cobalamin binding",
  "GO:0031420": "alkali metal ion binding",
  "GO:0031421": "invertasome",
  "GO:0031422": "RecQ helicase-Topo III complex",
  "GO:0031423": "hexon binding",
  "GO:0031424": "keratinization",
  "GO:0031425": "chloroplast RNA processing",
  "GO:0031426": "polycistronic mRNA processing",
  "GO:0031427": "response to methotrexate",
  "GO:0031428": "box C/D snoRNP complex",
  "GO:0031429": "box H/ACA snoRNP complex",
  "GO:0031430": "M band",
  "GO:0031431": "Dbf4-dependent protein kinase complex",
  "GO:0031432": "titin binding",
  "GO:0031433": "telethonin binding",
  "GO:0031434": "mitogen-activated protein kinase kinase binding",
  "GO:0031435": "mitogen-activated protein kinase kinase kinase binding",
  "GO:0031436": "BRCA1-BARD1 complex",
  "GO:0031437": "regulation of mRNA cleavage",
  "GO:0031438": "negative regulation of mRNA cleavage",
  "GO:0031439": "positive regulation of mRNA cleavage",
  "GO:0031440": "regulation of mRNA 3'-end processing",
  "GO:0031441": "negative regulation of mRNA 3'-end processing",
  "GO:0031442": "positive regulation of mRNA 3'-end processing",
  "GO:0031443": "fast-twitch skeletal muscle fiber contraction",
  "GO:0031444": "slow-twitch skeletal muscle fiber contraction",
  "GO:0031445": "regulation of heterochromatin assembly",
  "GO:0031446": "regulation of fast-twitch skeletal muscle fiber contraction",
  "GO:0031447": "negative regulation of fast-twitch skeletal muscle fiber contraction",
  "GO:0031448": "positive regulation of fast-twitch skeletal muscle fiber contraction",
  "GO:0031449": "regulation of slow-twitch skeletal muscle fiber contraction",
  "GO:0031450": "negative regulation of slow-twitch skeletal muscle fiber contraction",
  "GO:0031451": "positive regulation of slow-twitch skeletal muscle fiber contraction",
  "GO:0031452": "negative regulation of heterochromatin assembly",
  "GO:0031453": "positive regulation of heterochromatin assembly",
  "GO:0031454": "regulation of extent of heterochromatin assembly",
  "GO:0031455": "glycine betaine metabolic process",
  "GO:0031456": "glycine betaine biosynthetic process",
  "GO:0031457": "glycine betaine catabolic process",
  "GO:0031458": "betaine-transporting ATPase activity",
  "GO:0031459": "glycine betaine-transporting ATPase activity",
  "GO:0031460": "glycine betaine transport",
  "GO:0031461": "cullin-RING ubiquitin ligase complex",
  "GO:0031462": "Cul2-RING ubiquitin ligase complex",
  "GO:0031463": "Cul3-RING ubiquitin ligase complex",
  "GO:0031464": "Cul4A-RING E3 ubiquitin ligase complex",
  "GO:0031465": "Cul4B-RING E3 ubiquitin ligase complex",
  "GO:0031466": "Cul5-RING ubiquitin ligase complex",
  "GO:0031467": "Cul7-RING ubiquitin ligase complex",
  "GO:0031468": "nuclear envelope reassembly",
  "GO:0031469": "polyhedral organelle",
  "GO:0031470": "carboxysome",
  "GO:0031471": "ethanolamine degradation polyhedral organelle",
  "GO:0031472": "propanediol degradation polyhedral organelle",
  "GO:0031473": "myosin III binding",
  "GO:0031474": "myosin IV complex",
  "GO:0031475": "myosin V complex",
  "GO:0031476": "myosin VI complex",
  "GO:0031477": "myosin VII complex",
  "GO:0031478": "myosin VIII complex",
  "GO:0031479": "myosin IX complex",
  "GO:0031480": "myosin X complex",
  "GO:0031481": "myosin XI complex",
  "GO:0031482": "myosin XII complex",
  "GO:0031483": "myosin XIII complex",
  "GO:0031484": "myosin XIV complex",
  "GO:0031485": "myosin XV complex",
  "GO:0031486": "myosin XVI complex",
  "GO:0031487": "myosin XVII complex",
  "GO:0031488": "myosin XVIII complex",
  "GO:0031489": "myosin V binding",
  "GO:0031490": "chromatin DNA binding",
  "GO:0031491": "nucleosome binding",
  "GO:0031492": "nucleosomal DNA binding",
  "GO:0031493": "nucleosomal histone binding",
  "GO:0031494": "regulation of mating type switching",
  "GO:0031495": "negative regulation of mating type switching",
  "GO:0031496": "positive regulation of mating type switching",
  "GO:0031497": "chromatin assembly",
  "GO:0031498": "chromatin disassembly",
  "GO:0031499": "TRAMP complex",
  "GO:0031500": "Tea1 cell-end complex",
  "GO:0031501": "mannosyltransferase complex",
  "GO:0031502": "dolichyl-phosphate-mannose-protein mannosyltransferase complex",
  "GO:0031503": "protein complex localization",
  "GO:0031504": "peptidoglycan-based cell wall organization",
  "GO:0031505": "fungal-type cell wall organization",
  "GO:0031506": "cell wall glycoprotein biosynthetic process",
  "GO:0031507": "heterochromatin assembly",
  "GO:0031508": "pericentric heterochromatin assembly",
  "GO:0031509": "telomeric heterochromatin assembly",
  "GO:0031510": "SUMO activating enzyme complex",
  "GO:0031511": "Mis6-Sim4 complex",
  "GO:0031512": "motile primary cilium",
  "GO:0031513": "nonmotile primary cilium",
  "GO:0031514": "motile cilium",
  "GO:0031515": "tRNA (m1A) methyltransferase complex",
  "GO:0031516": "far-red light photoreceptor activity",
  "GO:0031517": "red light photoreceptor activity",
  "GO:0031518": "CBF3 complex",
  "GO:0031519": "PcG protein complex",
  "GO:0031520": "plasma membrane of cell tip",
  "GO:0031521": "spitzenkorper",
  "GO:0031522": "cell envelope Sec protein transport complex",
  "GO:0031523": "Myb complex",
  "GO:0031524": "menthol metabolic process",
  "GO:0031525": "menthol biosynthetic process",
  "GO:0031526": "brush border membrane",
  "GO:0031527": "filopodium membrane",
  "GO:0031528": "microvillus membrane",
  "GO:0031529": "ruffle organization",
  "GO:0031530": "gonadotropin-releasing hormone receptor binding",
  "GO:0031531": "thyrotropin-releasing hormone receptor binding",
  "GO:0031532": "actin cytoskeleton reorganization",
  "GO:0031533": "mRNA cap methyltransferase complex",
  "GO:0031534": "minus-end directed microtubule sliding",
  "GO:0031535": "plus-end directed microtubule sliding",
  "GO:0031536": "positive regulation of exit from mitosis",
  "GO:0031537": "regulation of anthocyanin metabolic process",
  "GO:0031538": "negative regulation of anthocyanin metabolic process",
  "GO:0031539": "positive regulation of anthocyanin metabolic process",
  "GO:0031540": "regulation of anthocyanin biosynthetic process",
  "GO:0031541": "negative regulation of anthocyanin biosynthetic process",
  "GO:0031542": "positive regulation of anthocyanin biosynthetic process",
  "GO:0031543": "peptidyl-proline dioxygenase activity",
  "GO:0031544": "peptidyl-proline 3-dioxygenase activity",
  "GO:0031545": "peptidyl-proline 4-dioxygenase activity",
  "GO:0031546": "brain-derived neurotrophic factor receptor binding",
  "GO:0031547": "brain-derived neurotrophic factor receptor signaling pathway",
  "GO:0031548": "regulation of brain-derived neurotrophic factor receptor signaling pathway",
  "GO:0031549": "negative regulation of brain-derived neurotrophic factor receptor signaling pathway",
  "GO:0031550": "positive regulation of brain-derived neurotrophic factor receptor signaling pathway",
  "GO:0031551": "regulation of brain-derived neurotrophic factor-activated receptor activity",
  "GO:0031552": "negative regulation of brain-derived neurotrophic factor-activated receptor activity",
  "GO:0031553": "positive regulation of brain-derived neurotrophic factor-activated receptor activity",
  "GO:0031554": "regulation of DNA-templated transcription, termination",
  "GO:0031555": "transcriptional attenuation",
  "GO:0031556": "transcriptional attenuation by ribosome",
  "GO:0031557": "obsolete induction of programmed cell death in response to chemical stimulus",
  "GO:0031558": "obsolete induction of apoptosis in response to chemical stimulus",
  "GO:0031559": "oxidosqualene cyclase activity",
  "GO:0031560": "cellular bud neck polarisome",
  "GO:0031561": "cellular bud tip polarisome",
  "GO:0031562": "hyphal tip polarisome",
  "GO:0031563": "mating projection tip polarisome",
  "GO:0031564": "transcription antitermination",
  "GO:0031565": "obsolete cytokinesis checkpoint",
  "GO:0031566": "actomyosin contractile ring maintenance",
  "GO:0031567": "mitotic cell size control checkpoint",
  "GO:0031568": "G1 cell size control checkpoint",
  "GO:0031569": "G2 cell size control checkpoint",
  "GO:0031570": "DNA integrity checkpoint",
  "GO:0031571": "mitotic G1 DNA damage checkpoint",
  "GO:0031572": "G2 DNA damage checkpoint",
  "GO:0031573": "intra-S DNA damage checkpoint",
  "GO:0031577": "spindle checkpoint",
  "GO:0031578": "mitotic spindle orientation checkpoint",
  "GO:0031579": "membrane raft organization",
  "GO:0031580": "membrane raft distribution",
  "GO:0031581": "hemidesmosome assembly",
  "GO:0031582": "replication fork arrest at rDNA repeats",
  "GO:0031583": "phospholipase D-activating G-protein coupled receptor signaling pathway",
  "GO:0031584": "activation of phospholipase D activity",
  "GO:0031585": "regulation of inositol 1,4,5-trisphosphate-sensitive calcium-release channel activity",
  "GO:0031586": "negative regulation of inositol 1,4,5-trisphosphate-sensitive calcium-release channel activity",
  "GO:0031587": "positive regulation of inositol 1,4,5-trisphosphate-sensitive calcium-release channel activity",
  "GO:0031588": "nucleotide-activated protein kinase complex",
  "GO:0031589": "cell-substrate adhesion",
  "GO:0031590": "wybutosine metabolic process",
  "GO:0031591": "wybutosine biosynthetic process",
  "GO:0031592": "centrosomal corona",
  "GO:0031593": "polyubiquitin binding",
  "GO:0031594": "neuromuscular junction",
  "GO:0031595": "nuclear proteasome complex",
  "GO:0031596": "obsolete ER proteasome complex",
  "GO:0031597": "cytosolic proteasome complex",
  "GO:0031598": "nuclear proteasome regulatory particle",
  "GO:0031599": "obsolete ER proteasome regulatory particle",
  "GO:0031600": "cytosolic proteasome regulatory particle",
  "GO:0031601": "nuclear proteasome core complex",
  "GO:0031602": "obsolete ER proteasome core complex",
  "GO:0031603": "cytosolic proteasome core complex",
  "GO:0031604": "nuclear proteasome core complex, alpha-subunit complex",
  "GO:0031605": "obsolete ER proteasome core complex, alpha-subunit complex",
  "GO:0031606": "cytosolic proteasome core complex, alpha-subunit complex",
  "GO:0031607": "nuclear proteasome core complex, beta-subunit complex",
  "GO:0031608": "obsolete ER proteasome core complex, beta-subunit complex",
  "GO:0031609": "cytosolic proteasome core complex, beta-subunit complex",
  "GO:0031610": "nuclear proteasome regulatory particle, base subcomplex",
  "GO:0031611": "obsolete ER proteasome regulatory particle, base subcomplex",
  "GO:0031612": "cytosolic proteasome regulatory particle, base subcomplex",
  "GO:0031613": "nuclear proteasome regulatory particle, lid subcomplex",
  "GO:0031614": "obsolete ER proteasome regulatory particle, lid subcomplex",
  "GO:0031615": "cytosolic proteasome regulatory particle, lid subcomplex",
  "GO:0031616": "spindle pole centrosome",
  "GO:0031617": "NMS complex",
  "GO:0031618": "nuclear pericentric heterochromatin",
  "GO:0031619": "homologous chromosome orientation involved in meiotic metaphase I plate congression",
  "GO:0031620": "regulation of fever generation",
  "GO:0031621": "negative regulation of fever generation",
  "GO:0031622": "positive regulation of fever generation",
  "GO:0031623": "receptor internalization",
  "GO:0031624": "ubiquitin conjugating enzyme binding",
  "GO:0031625": "ubiquitin protein ligase binding",
  "GO:0031626": "beta-endorphin binding",
  "GO:0031627": "telomeric loop formation",
  "GO:0031628": "opioid receptor binding",
  "GO:0031629": "synaptic vesicle fusion to presynaptic active zone membrane",
  "GO:0031630": "regulation of synaptic vesicle fusion to presynaptic membrane",
  "GO:0031631": "negative regulation of synaptic vesicle fusion to presynaptic membrane",
  "GO:0031632": "positive regulation of synaptic vesicle fusion to presynaptic membrane",
  "GO:0031633": "xanthophore",
  "GO:0031634": "replication fork barrier binding",
  "GO:0031635": "adenylate cyclase-inhibiting opioid receptor signaling pathway",
  "GO:0031637": "regulation of neuronal synaptic plasticity in response to neurotrophin",
  "GO:0031638": "zymogen activation",
  "GO:0031639": "plasminogen activation",
  "GO:0031640": "killing of cells of other organism",
  "GO:0031641": "regulation of myelination",
  "GO:0031642": "negative regulation of myelination",
  "GO:0031643": "positive regulation of myelination",
  "GO:0031644": "regulation of neurological system process",
  "GO:0031645": "negative regulation of neurological system process",
  "GO:0031646": "positive regulation of neurological system process",
  "GO:0031647": "regulation of protein stability",
  "GO:0031648": "protein destabilization",
  "GO:0031649": "heat generation",
  "GO:0031650": "regulation of heat generation",
  "GO:0031651": "negative regulation of heat generation",
  "GO:0031652": "positive regulation of heat generation",
  "GO:0031653": "heat dissipation",
  "GO:0031654": "regulation of heat dissipation",
  "GO:0031655": "negative regulation of heat dissipation",
  "GO:0031656": "positive regulation of heat dissipation",
  "GO:0031657": "regulation of cyclin-dependent protein serine/threonine kinase activity involved in G1/S transition of mitotic cell cycle",
  "GO:0031658": "negative regulation of cyclin-dependent protein serine/threonine kinase activity involved in G1/S transition of mitotic cell cycle",
  "GO:0031659": "positive regulation of cyclin-dependent protein serine/threonine kinase activity involved in G1/S transition of mitotic cell cycle",
  "GO:0031660": "regulation of cyclin-dependent protein serine/threonine kinase activity involved in G2/M transition of mitotic cell cycle",
  "GO:0031661": "negative regulation of cyclin-dependent protein serine/threonine kinase activity involved in G2/M transition of mitotic cell cycle",
  "GO:0031662": "positive regulation of cyclin-dependent protein serine/threonine kinase activity involved in G2/M transition of mitotic cell cycle",
  "GO:0031663": "lipopolysaccharide-mediated signaling pathway",
  "GO:0031664": "regulation of lipopolysaccharide-mediated signaling pathway",
  "GO:0031665": "negative regulation of lipopolysaccharide-mediated signaling pathway",
  "GO:0031666": "positive regulation of lipopolysaccharide-mediated signaling pathway",
  "GO:0031667": "response to nutrient levels",
  "GO:0031668": "cellular response to extracellular stimulus",
  "GO:0031669": "cellular response to nutrient levels",
  "GO:0031670": "cellular response to nutrient",
  "GO:0031671": "primary cell septum biogenesis",
  "GO:0031672": "A band",
  "GO:0031673": "H zone",
  "GO:0031674": "I band",
  "GO:0031676": "plasma membrane-derived thylakoid membrane",
  "GO:0031679": "NADH dehydrogenase (plastoquinone) activity",
  "GO:0031680": "G-protein beta/gamma-subunit complex",
  "GO:0031681": "G-protein beta-subunit binding",
  "GO:0031682": "G-protein gamma-subunit binding",
  "GO:0031683": "G-protein beta/gamma-subunit complex binding",
  "GO:0031684": "heterotrimeric G-protein complex cycle",
  "GO:0031685": "adenosine receptor binding",
  "GO:0031686": "A1 adenosine receptor binding",
  "GO:0031687": "A2A adenosine receptor binding",
  "GO:0031688": "A2B adenosine receptor binding",
  "GO:0031689": "A3 adenosine receptor binding",
  "GO:0031690": "adrenergic receptor binding",
  "GO:0031691": "alpha-1A adrenergic receptor binding",
  "GO:0031692": "alpha-1B adrenergic receptor binding",
  "GO:0031693": "alpha-1D adrenergic receptor binding",
  "GO:0031694": "alpha-2A adrenergic receptor binding",
  "GO:0031695": "alpha-2B adrenergic receptor binding",
  "GO:0031696": "alpha-2C adrenergic receptor binding",
  "GO:0031697": "beta-1 adrenergic receptor binding",
  "GO:0031698": "beta-2 adrenergic receptor binding",
  "GO:0031699": "beta-3 adrenergic receptor binding",
  "GO:0031700": "adrenomedullin receptor binding",
  "GO:0031701": "angiotensin receptor binding",
  "GO:0031702": "type 1 angiotensin receptor binding",
  "GO:0031703": "type 2 angiotensin receptor binding",
  "GO:0031704": "apelin receptor binding",
  "GO:0031705": "bombesin receptor binding",
  "GO:0031706": "subtype 3 bombesin receptor binding",
  "GO:0031707": "endothelin A receptor binding",
  "GO:0031708": "endothelin B receptor binding",
  "GO:0031709": "gastrin-releasing peptide receptor binding",
  "GO:0031710": "neuromedin B receptor binding",
  "GO:0031711": "bradykinin receptor binding",
  "GO:0031712": "B1 bradykinin receptor binding",
  "GO:0031713": "B2 bradykinin receptor binding",
  "GO:0031714": "C5a anaphylatoxin chemotactic receptor binding",
  "GO:0031715": "C5L2 anaphylatoxin chemotactic receptor binding",
  "GO:0031716": "calcitonin receptor binding",
  "GO:0031717": "cannabinoid receptor binding",
  "GO:0031718": "type 1 cannabinoid receptor binding",
  "GO:0031719": "type 2 cannabinoid receptor binding",
  "GO:0031720": "haptoglobin binding",
  "GO:0031721": "hemoglobin alpha binding",
  "GO:0031722": "hemoglobin beta binding",
  "GO:0031723": "CXCR4 chemokine receptor binding",
  "GO:0031724": "CXCR5 chemokine receptor binding",
  "GO:0031725": "CXCR6 chemokine receptor binding",
  "GO:0031726": "CCR1 chemokine receptor binding",
  "GO:0031727": "CCR2 chemokine receptor binding",
  "GO:0031728": "CCR3 chemokine receptor binding",
  "GO:0031729": "CCR4 chemokine receptor binding",
  "GO:0031730": "CCR5 chemokine receptor binding",
  "GO:0031731": "CCR6 chemokine receptor binding",
  "GO:0031732": "CCR7 chemokine receptor binding",
  "GO:0031733": "CCR8 chemokine receptor binding",
  "GO:0031734": "CCR9 chemokine receptor binding",
  "GO:0031735": "CCR10 chemokine receptor binding",
  "GO:0031736": "CCR11 chemokine receptor binding",
  "GO:0031737": "CX3C chemokine receptor binding",
  "GO:0031738": "XCR1 chemokine receptor binding",
  "GO:0031739": "cholecystokinin receptor binding",
  "GO:0031740": "type A cholecystokinin receptor binding",
  "GO:0031741": "type B gastrin/cholecystokinin receptor binding",
  "GO:0031745": "cysteinyl leukotriene receptor binding",
  "GO:0031746": "type 1 cysteinyl leukotriene receptor binding",
  "GO:0031747": "type 2 cysteinyl leukotriene receptor binding",
  "GO:0031748": "D1 dopamine receptor binding",
  "GO:0031749": "D2 dopamine receptor binding",
  "GO:0031750": "D3 dopamine receptor binding",
  "GO:0031751": "D4 dopamine receptor binding",
  "GO:0031752": "D5 dopamine receptor binding",
  "GO:0031753": "endothelial differentiation G-protein coupled receptor binding",
  "GO:0031754": "Edg-1 sphingosine 1-phosphate receptor binding",
  "GO:0031755": "Edg-2 lysophosphatidic acid receptor binding",
  "GO:0031756": "Edg-3 sphingosine 1-phosphate receptor binding",
  "GO:0031757": "Edg-4 lysophosphatidic acid receptor binding",
  "GO:0031758": "Edg-5 sphingosine 1-phosphate receptor binding",
  "GO:0031759": "Edg-6 sphingosine 1-phosphate receptor binding",
  "GO:0031760": "Edg-7 lysophosphatidic acid receptor binding",
  "GO:0031761": "fMet-Leu-Phe receptor binding",
  "GO:0031762": "follicle-stimulating hormone receptor binding",
  "GO:0031763": "galanin receptor binding",
  "GO:0031764": "type 1 galanin receptor binding",
  "GO:0031765": "type 2 galanin receptor binding",
  "GO:0031766": "type 3 galanin receptor binding",
  "GO:0031767": "gastric inhibitory polypeptide receptor binding",
  "GO:0031768": "ghrelin receptor binding",
  "GO:0031769": "glucagon receptor binding",
  "GO:0031770": "growth hormone-releasing hormone receptor binding",
  "GO:0031771": "type 1 hypocretin receptor binding",
  "GO:0031772": "type 2 hypocretin receptor binding",
  "GO:0031773": "kisspeptin receptor binding",
  "GO:0031774": "leukotriene receptor binding",
  "GO:0031775": "lutropin-choriogonadotropic hormone receptor binding",
  "GO:0031776": "melanin-concentrating hormone receptor binding",
  "GO:0031777": "type 1 melanin-concentrating hormone receptor binding",
  "GO:0031778": "type 2 melanin-concentrating hormone receptor binding",
  "GO:0031779": "melanocortin receptor binding",
  "GO:0031780": "corticotropin hormone receptor binding",
  "GO:0031781": "type 3 melanocortin receptor binding",
  "GO:0031782": "type 4 melanocortin receptor binding",
  "GO:0031783": "type 5 melanocortin receptor binding",
  "GO:0031784": "melatonin receptor binding",
  "GO:0031785": "type 1A melatonin receptor binding",
  "GO:0031786": "type 1B melatonin receptor binding",
  "GO:0031787": "H9 melatonin receptor binding",
  "GO:0031788": "motilin receptor binding",
  "GO:0031789": "G-protein coupled acetylcholine receptor binding",
  "GO:0031795": "G-protein coupled GABA receptor binding",
  "GO:0031796": "type 1 metabotropic GABA receptor binding",
  "GO:0031797": "type 2 metabotropic GABA receptor binding",
  "GO:0031798": "type 1 metabotropic glutamate receptor binding",
  "GO:0031799": "type 2 metabotropic glutamate receptor binding",
  "GO:0031800": "type 3 metabotropic glutamate receptor binding",
  "GO:0031801": "type 4 metabotropic glutamate receptor binding",
  "GO:0031802": "type 5 metabotropic glutamate receptor binding",
  "GO:0031803": "type 6 metabotropic glutamate receptor binding",
  "GO:0031804": "type 7 metabotropic glutamate receptor binding",
  "GO:0031805": "type 8 metabotropic glutamate receptor binding",
  "GO:0031806": "G-protein coupled histamine receptor binding",
  "GO:0031807": "H1 histamine receptor binding",
  "GO:0031808": "H2 histamine receptor binding",
  "GO:0031809": "H3 histamine receptor binding",
  "GO:0031810": "H4 histamine receptor binding",
  "GO:0031811": "G-protein coupled nucleotide receptor binding",
  "GO:0031812": "P2Y1 nucleotide receptor binding",
  "GO:0031813": "P2Y2 nucleotide receptor binding",
  "GO:0031814": "P2Y4 nucleotide receptor binding",
  "GO:0031815": "P2Y5 nucleotide receptor binding",
  "GO:0031816": "P2Y6 nucleotide receptor binding",
  "GO:0031817": "P2Y8 nucleotide receptor binding",
  "GO:0031818": "P2Y9 nucleotide receptor binding",
  "GO:0031819": "P2Y10 nucleotide receptor binding",
  "GO:0031820": "P2Y11 nucleotide receptor binding",
  "GO:0031821": "G-protein coupled serotonin receptor binding",
  "GO:0031822": "type 1B serotonin receptor binding",
  "GO:0031823": "type 1D serotonin receptor binding",
  "GO:0031824": "type 1E serotonin receptor binding",
  "GO:0031825": "type 1F serotonin receptor binding",
  "GO:0031826": "type 2A serotonin receptor binding",
  "GO:0031827": "type 2B serotonin receptor binding",
  "GO:0031828": "type 2C serotonin receptor binding",
  "GO:0031829": "type 4 serotonin receptor binding",
  "GO:0031830": "type 5A serotonin receptor binding",
  "GO:0031831": "type 5B serotonin receptor binding",
  "GO:0031832": "type 6 serotonin receptor binding",
  "GO:0031833": "type 7 serotonin receptor binding",
  "GO:0031834": "neurokinin receptor binding",
  "GO:0031835": "substance P receptor binding",
  "GO:0031836": "neuromedin K receptor binding",
  "GO:0031837": "substance K receptor binding",
  "GO:0031838": "haptoglobin-hemoglobin complex",
  "GO:0031839": "type 1 neuromedin U receptor binding",
  "GO:0031840": "type 2 neuromedin U receptor binding",
  "GO:0031841": "neuropeptide Y receptor binding",
  "GO:0031842": "type 1 neuropeptide Y receptor binding",
  "GO:0031843": "type 2 neuropeptide Y receptor binding",
  "GO:0031844": "type 4 neuropeptide Y receptor binding",
  "GO:0031845": "type 5 neuropeptide Y receptor binding",
  "GO:0031846": "neurotensin receptor binding",
  "GO:0031847": "type 1 neurotensin receptor binding",
  "GO:0031848": "protection from non-homologous end joining at telomere",
  "GO:0031849": "olfactory receptor binding",
  "GO:0031850": "delta-type opioid receptor binding",
  "GO:0031851": "kappa-type opioid receptor binding",
  "GO:0031852": "mu-type opioid receptor binding",
  "GO:0031853": "nociceptin receptor binding",
  "GO:0031854": "orexigenic neuropeptide QRFP receptor binding",
  "GO:0031855": "oxytocin receptor binding",
  "GO:0031856": "parathyroid hormone receptor binding",
  "GO:0031857": "type 1 parathyroid hormone receptor binding",
  "GO:0031858": "pituitary adenylate cyclase-activating polypeptide receptor binding",
  "GO:0031859": "platelet activating factor receptor binding",
  "GO:0031860": "telomeric 3' overhang formation",
  "GO:0031861": "prolactin-releasing peptide receptor binding",
  "GO:0031862": "prostanoid receptor binding",
  "GO:0031863": "prostaglandin D2 receptor binding",
  "GO:0031864": "EP1 subtype prostaglandin E2 receptor binding",
  "GO:0031865": "EP2 subtype prostaglandin E2 receptor binding",
  "GO:0031866": "EP3 subtype prostaglandin E2 receptor binding",
  "GO:0031867": "EP4 subtype prostaglandin E2 receptor binding",
  "GO:0031868": "prostaglandin F2-alpha receptor binding",
  "GO:0031869": "prostacyclin receptor binding",
  "GO:0031870": "thromboxane A2 receptor binding",
  "GO:0031871": "proteinase activated receptor binding",
  "GO:0031872": "type 1 proteinase activated receptor binding",
  "GO:0031873": "type 2 proteinase activated receptor binding",
  "GO:0031874": "type 3 proteinase activated receptor binding",
  "GO:0031875": "type 4 proteinase activated receptor binding",
  "GO:0031876": "secretin receptor binding",
  "GO:0031877": "somatostatin receptor binding",
  "GO:0031878": "type 1 somatostatin receptor binding",
  "GO:0031879": "type 2 somatostatin receptor binding",
  "GO:0031880": "type 3 somatostatin receptor binding",
  "GO:0031881": "type 4 somatostatin receptor binding",
  "GO:0031882": "type 5 somatostatin receptor binding",
  "GO:0031883": "taste receptor binding",
  "GO:0031884": "type 1 member 1 taste receptor binding",
  "GO:0031885": "type 1 member 2 taste receptor binding",
  "GO:0031886": "type 1 member 3 taste receptor binding",
  "GO:0031887": "lipid particle transport along microtubule",
  "GO:0031889": "urotensin receptor binding",
  "GO:0031890": "vasoactive intestinal polypeptide receptor binding",
  "GO:0031891": "type 1 vasoactive intestinal polypeptide receptor binding",
  "GO:0031892": "type 2 vasoactive intestinal polypeptide receptor binding",
  "GO:0031893": "vasopressin receptor binding",
  "GO:0031894": "V1A vasopressin receptor binding",
  "GO:0031895": "V1B vasopressin receptor binding",
  "GO:0031896": "V2 vasopressin receptor binding",
  "GO:0031897": "Tic complex",
  "GO:0031898": "chromoplast envelope",
  "GO:0031899": "chromoplast inner membrane",
  "GO:0031900": "chromoplast outer membrane",
  "GO:0031901": "early endosome membrane",
  "GO:0031902": "late endosome membrane",
  "GO:0031903": "microbody membrane",
  "GO:0031904": "endosome lumen",
  "GO:0031905": "early endosome lumen",
  "GO:0031906": "late endosome lumen",
  "GO:0031907": "microbody lumen",
  "GO:0031908": "glyoxysomal lumen",
  "GO:0031910": "cytostome",
  "GO:0031911": "cytoproct",
  "GO:0031912": "oral apparatus",
  "GO:0031913": "contractile vacuole pore",
  "GO:0031914": "negative regulation of synaptic plasticity",
  "GO:0031915": "positive regulation of synaptic plasticity",
  "GO:0031916": "regulation of synaptic metaplasticity",
  "GO:0031917": "negative regulation of synaptic metaplasticity",
  "GO:0031918": "positive regulation of synaptic metaplasticity",
  "GO:0031919": "vitamin B6 transport",
  "GO:0031920": "pyridoxal transport",
  "GO:0031921": "pyridoxal phosphate transport",
  "GO:0031922": "pyridoxamine transport",
  "GO:0031923": "pyridoxine transport",
  "GO:0031924": "vitamin B6 transporter activity",
  "GO:0031925": "pyridoxal transmembrane transporter activity",
  "GO:0031926": "pyridoxal phosphate transmembrane transporter activity",
  "GO:0031927": "pyridoxamine transmembrane transporter activity",
  "GO:0031928": "pyridoxine transmembrane transporter activity",
  "GO:0031929": "TOR signaling",
  "GO:0031930": "mitochondria-nucleus signaling pathway",
  "GO:0031931": "TORC1 complex",
  "GO:0031932": "TORC2 complex",
  "GO:0031933": "telomeric heterochromatin",
  "GO:0031934": "mating-type region heterochromatin",
  "GO:0031935": "regulation of chromatin silencing",
  "GO:0031936": "negative regulation of chromatin silencing",
  "GO:0031937": "positive regulation of chromatin silencing",
  "GO:0031938": "regulation of chromatin silencing at telomere",
  "GO:0031939": "negative regulation of chromatin silencing at telomere",
  "GO:0031940": "positive regulation of chromatin silencing at telomere",
  "GO:0031941": "filamentous actin",
  "GO:0031942": "i-AAA complex",
  "GO:0031943": "regulation of glucocorticoid metabolic process",
  "GO:0031944": "negative regulation of glucocorticoid metabolic process",
  "GO:0031945": "positive regulation of glucocorticoid metabolic process",
  "GO:0031946": "regulation of glucocorticoid biosynthetic process",
  "GO:0031947": "negative regulation of glucocorticoid biosynthetic process",
  "GO:0031948": "positive regulation of glucocorticoid biosynthetic process",
  "GO:0031949": "regulation of glucocorticoid catabolic process",
  "GO:0031950": "negative regulation of glucocorticoid catabolic process",
  "GO:0031951": "positive regulation of glucocorticoid catabolic process",
  "GO:0031952": "regulation of protein autophosphorylation",
  "GO:0031953": "negative regulation of protein autophosphorylation",
  "GO:0031954": "positive regulation of protein autophosphorylation",
  "GO:0031955": "short-chain fatty acid-CoA ligase activity",
  "GO:0031956": "medium-chain fatty acid-CoA ligase activity",
  "GO:0031957": "very long-chain fatty acid-CoA ligase activity",
  "GO:0031958": "corticosteroid receptor signaling pathway",
  "GO:0031959": "mineralocorticoid receptor signaling pathway",
  "GO:0031960": "response to corticosteroid",
  "GO:0031961": "cortisol receptor binding",
  "GO:0031962": "mineralocorticoid receptor binding",
  "GO:0031963": "cortisol receptor activity",
  "GO:0031964": "beta-alanyl-histamine hydrolase activity",
  "GO:0031965": "nuclear membrane",
  "GO:0031966": "mitochondrial membrane",
  "GO:0031967": "organelle envelope",
  "GO:0031968": "organelle outer membrane",
  "GO:0031969": "chloroplast membrane",
  "GO:0031970": "organelle envelope lumen",
  "GO:0031972": "chloroplast intermembrane space",
  "GO:0031973": "chromoplast intermembrane space",
  "GO:0031974": "membrane-enclosed lumen",
  "GO:0031975": "envelope",
  "GO:0031976": "plastid thylakoid",
  "GO:0031977": "thylakoid lumen",
  "GO:0031978": "plastid thylakoid lumen",
  "GO:0031979": "plasma membrane-derived thylakoid lumen",
  "GO:0031981": "nuclear lumen",
  "GO:0031982": "vesicle",
  "GO:0031983": "vesicle lumen",
  "GO:0031984": "organelle subcompartment",
  "GO:0031985": "Golgi cisterna",
  "GO:0031986": "proteinoplast",
  "GO:0031987": "locomotion involved in locomotory behavior",
  "GO:0031988": "membrane-bounded vesicle",
  "GO:0031989": "bombesin receptor signaling pathway",
  "GO:0031990": "mRNA export from nucleus in response to heat stress",
  "GO:0031991": "regulation of actomyosin contractile ring contraction",
  "GO:0031992": "energy transducer activity",
  "GO:0031993": "light transducer activity",
  "GO:0031994": "insulin-like growth factor I binding",
  "GO:0031995": "insulin-like growth factor II binding",
  "GO:0031996": "thioesterase binding",
  "GO:0031997": "N-terminal myristoylation domain binding",
  "GO:0031998": "regulation of fatty acid beta-oxidation",
  "GO:0031999": "negative regulation of fatty acid beta-oxidation",
  "GO:0032000": "positive regulation of fatty acid beta-oxidation",
  "GO:0032001": "1,4-alpha-glucan 6-alpha-glucosyltransferase activity",
  "GO:0032002": "interleukin-28 receptor complex",
  "GO:0032003": "interleukin-28 receptor binding",
  "GO:0032005": "signal transduction involved in conjugation with cellular fusion",
  "GO:0032006": "regulation of TOR signaling",
  "GO:0032007": "negative regulation of TOR signaling",
  "GO:0032008": "positive regulation of TOR signaling",
  "GO:0032009": "early phagosome",
  "GO:0032010": "phagolysosome",
  "GO:0032011": "ARF protein signal transduction",
  "GO:0032012": "regulation of ARF protein signal transduction",
  "GO:0032013": "negative regulation of ARF protein signal transduction",
  "GO:0032014": "positive regulation of ARF protein signal transduction",
  "GO:0032015": "regulation of Ran protein signal transduction",
  "GO:0032016": "negative regulation of Ran protein signal transduction",
  "GO:0032017": "positive regulation of Ran protein signal transduction",
  "GO:0032018": "2-methylbutanol:NADP oxidoreductase activity",
  "GO:0032019": "mitochondrial cloud",
  "GO:0032020": "ISG15-protein conjugation",
  "GO:0032021": "NELF complex",
  "GO:0032022": "multicellular pellicle formation",
  "GO:0032023": "trypsinogen activation",
  "GO:0032024": "positive regulation of insulin secretion",
  "GO:0032025": "response to cobalt ion",
  "GO:0032026": "response to magnesium ion",
  "GO:0032027": "myosin light chain binding",
  "GO:0032028": "myosin head/neck binding",
  "GO:0032029": "myosin tail binding",
  "GO:0032030": "myosin I light chain binding",
  "GO:0032031": "myosin I head/neck binding",
  "GO:0032032": "myosin I tail binding",
  "GO:0032033": "myosin II light chain binding",
  "GO:0032034": "myosin II head/neck binding",
  "GO:0032035": "myosin II tail binding",
  "GO:0032036": "myosin heavy chain binding",
  "GO:0032037": "myosin I heavy chain binding",
  "GO:0032038": "myosin II heavy chain binding",
  "GO:0032039": "integrator complex",
  "GO:0032040": "small-subunit processome",
  "GO:0032041": "NAD-dependent histone deacetylase activity (H3-K14 specific)",
  "GO:0032042": "mitochondrial DNA metabolic process",
  "GO:0032043": "mitochondrial DNA catabolic process",
  "GO:0032044": "DSIF complex",
  "GO:0032045": "guanyl-nucleotide exchange factor complex",
  "GO:0032046": "micropexophagy-specific membrane apparatus",
  "GO:0032047": "mitosome",
  "GO:0032048": "cardiolipin metabolic process",
  "GO:0032049": "cardiolipin biosynthetic process",
  "GO:0032050": "clathrin heavy chain binding",
  "GO:0032051": "clathrin light chain binding",
  "GO:0032052": "bile acid binding",
  "GO:0032053": "ciliary basal body organization",
  "GO:0032054": "ciliary basal body duplication",
  "GO:0032055": "negative regulation of translation in response to stress",
  "GO:0032056": "positive regulation of translation in response to stress",
  "GO:0032057": "negative regulation of translational initiation in response to stress",
  "GO:0032058": "positive regulation of translational initiation in response to stress",
  "GO:0032059": "bleb",
  "GO:0032060": "bleb assembly",
  "GO:0032061": "negative regulation of translation in response to osmotic stress",
  "GO:0032062": "positive regulation of translation in response to osmotic stress",
  "GO:0032063": "negative regulation of translational initiation in response to osmotic stress",
  "GO:0032064": "positive regulation of translational initiation in response to osmotic stress",
  "GO:0032065": "cortical protein anchoring",
  "GO:0032066": "nucleolus to nucleoplasm transport",
  "GO:0032067": "Type IV site-specific deoxyribonuclease activity",
  "GO:0032068": "Type IV site-specific deoxyribonuclease complex",
  "GO:0032069": "regulation of nuclease activity",
  "GO:0032070": "regulation of deoxyribonuclease activity",
  "GO:0032071": "regulation of endodeoxyribonuclease activity",
  "GO:0032072": "regulation of restriction endodeoxyribonuclease activity",
  "GO:0032073": "negative regulation of restriction endodeoxyribonuclease activity",
  "GO:0032074": "negative regulation of nuclease activity",
  "GO:0032075": "positive regulation of nuclease activity",
  "GO:0032076": "negative regulation of deoxyribonuclease activity",
  "GO:0032077": "positive regulation of deoxyribonuclease activity",
  "GO:0032078": "negative regulation of endodeoxyribonuclease activity",
  "GO:0032079": "positive regulation of endodeoxyribonuclease activity",
  "GO:0032080": "negative regulation of Type I site-specific deoxyribonuclease activity",
  "GO:0032081": "negative regulation of Type II site-specific deoxyribonuclease activity",
  "GO:0032082": "negative regulation of Type III site-specific deoxyribonuclease activity",
  "GO:0032083": "negative regulation of Type IV site-specific deoxyribonuclease activity",
  "GO:0032084": "regulation of Type I site-specific deoxyribonuclease activity",
  "GO:0032085": "regulation of Type II site-specific deoxyribonuclease activity",
  "GO:0032086": "regulation of Type III site-specific deoxyribonuclease activity",
  "GO:0032087": "regulation of Type IV site-specific deoxyribonuclease activity",
  "GO:0032088": "negative regulation of NF-kappaB transcription factor activity",
  "GO:0032089": "NACHT domain binding",
  "GO:0032090": "Pyrin domain binding",
  "GO:0032091": "negative regulation of protein binding",
  "GO:0032092": "positive regulation of protein binding",
  "GO:0032093": "SAM domain binding",
  "GO:0032094": "response to food",
  "GO:0032095": "regulation of response to food",
  "GO:0032096": "negative regulation of response to food",
  "GO:0032097": "positive regulation of response to food",
  "GO:0032098": "regulation of appetite",
  "GO:0032099": "negative regulation of appetite",
  "GO:0032100": "positive regulation of appetite",
  "GO:0032101": "regulation of response to external stimulus",
  "GO:0032102": "negative regulation of response to external stimulus",
  "GO:0032103": "positive regulation of response to external stimulus",
  "GO:0032104": "regulation of response to extracellular stimulus",
  "GO:0032105": "negative regulation of response to extracellular stimulus",
  "GO:0032106": "positive regulation of response to extracellular stimulus",
  "GO:0032107": "regulation of response to nutrient levels",
  "GO:0032108": "negative regulation of response to nutrient levels",
  "GO:0032109": "positive regulation of response to nutrient levels",
  "GO:0032110": "regulation of protein histidine kinase activity",
  "GO:0032111": "activation of protein histidine kinase activity",
  "GO:0032112": "negative regulation of protein histidine kinase activity",
  "GO:0032113": "regulation of carbohydrate phosphatase activity",
  "GO:0032114": "regulation of glucose-6-phosphatase activity",
  "GO:0032115": "sorbose reductase activity",
  "GO:0032116": "SMC loading complex",
  "GO:0032117": "horsetail-astral microtubule array",
  "GO:0032118": "horsetail-astral microtubule organization",
  "GO:0032119": "sequestering of zinc ion",
  "GO:0032120": "ascospore-type prospore membrane assembly",
  "GO:0032121": "meiotic attachment of telomeric heterochromatin to spindle pole body",
  "GO:0032122": "oral apparatus organization",
  "GO:0032123": "deep fiber",
  "GO:0032124": "macronucleus organization",
  "GO:0032125": "micronucleus organization",
  "GO:0032126": "eisosome",
  "GO:0032127": "dense core granule membrane",
  "GO:0032128": "flocculation via extracellular polymer",
  "GO:0032129": "histone deacetylase activity (H3-K9 specific)",
  "GO:0032130": "medial membrane band assembly",
  "GO:0032131": "alkylated DNA binding",
  "GO:0032132": "O6-alkylguanine-DNA binding",
  "GO:0032133": "chromosome passenger complex",
  "GO:0032135": "DNA insertion or deletion binding",
  "GO:0032136": "adenine/cytosine mispair binding",
  "GO:0032137": "guanine/thymine mispair binding",
  "GO:0032138": "single base insertion or deletion binding",
  "GO:0032139": "dinucleotide insertion or deletion binding",
  "GO:0032140": "single adenine insertion binding",
  "GO:0032141": "single cytosine insertion binding",
  "GO:0032142": "single guanine insertion binding",
  "GO:0032143": "single thymine insertion binding",
  "GO:0032144": "4-aminobutyrate transaminase complex",
  "GO:0032145": "succinate-semialdehyde dehydrogenase binding",
  "GO:0032146": "thiosulfate transmembrane-transporting ATPase activity",
  "GO:0032147": "activation of protein kinase activity",
  "GO:0032148": "activation of protein kinase B activity",
  "GO:0032149": "response to rhamnose",
  "GO:0032150": "ubiquinone biosynthetic process from chorismate",
  "GO:0032151": "mitotic septin complex",
  "GO:0032152": "meiotic septin complex",
  "GO:0032153": "cell division site",
  "GO:0032154": "cleavage furrow",
  "GO:0032155": "cell division site part",
  "GO:0032156": "septin cytoskeleton",
  "GO:0032157": "prospore contractile ring",
  "GO:0032158": "septin band",
  "GO:0032159": "septin cap",
  "GO:0032160": "septin filament array",
  "GO:0032161": "cleavage apparatus septin structure",
  "GO:0032162": "mating projection septin band",
  "GO:0032163": "hyphal septin band",
  "GO:0032164": "hyphal septin cap",
  "GO:0032165": "prospore septin filament array",
  "GO:0032166": "chlamydospore septin filament array",
  "GO:0032167": "obsolete septin patch",
  "GO:0032168": "hyphal septin ring",
  "GO:0032169": "prospore septin ring",
  "GO:0032170": "pseudohyphal septin ring",
  "GO:0032171": "germ tube septin cap",
  "GO:0032172": "germ tube septin ring",
  "GO:0032173": "septin collar",
  "GO:0032174": "cellular bud neck septin collar",
  "GO:0032175": "mating projection septin ring",
  "GO:0032176": "split septin rings",
  "GO:0032177": "cellular bud neck split septin rings",
  "GO:0032178": "medial membrane band",
  "GO:0032179": "germ tube",
  "GO:0032180": "ubiquinone biosynthetic process from tyrosine",
  "GO:0032181": "dinucleotide repeat insertion binding",
  "GO:0032182": "ubiquitin-like protein binding",
  "GO:0032183": "SUMO binding",
  "GO:0032184": "SUMO polymer binding",
  "GO:0032185": "septin cytoskeleton organization",
  "GO:0032186": "cellular bud neck septin ring organization",
  "GO:0032187": "actomyosin contractile ring localization",
  "GO:0032188": "establishment of actomyosin contractile ring localization",
  "GO:0032189": "maintenance of actomyosin contractile ring localization",
  "GO:0032190": "acrosin binding",
  "GO:0032193": "ubiquinone biosynthetic process via 2-polyprenylphenol",
  "GO:0032194": "ubiquinone biosynthetic process via 3,4-dihydroxy-5-polyprenylbenzoate",
  "GO:0032195": "post-lysosomal vacuole",
  "GO:0032196": "transposition",
  "GO:0032197": "transposition, RNA-mediated",
  "GO:0032198": "MITE transposition",
  "GO:0032199": "reverse transcription involved in RNA-mediated transposition",
  "GO:0032200": "telomere organization",
  "GO:0032201": "telomere maintenance via semi-conservative replication",
  "GO:0032202": "telomere assembly",
  "GO:0032203": "telomere formation via telomerase",
  "GO:0032204": "regulation of telomere maintenance",
  "GO:0032205": "negative regulation of telomere maintenance",
  "GO:0032206": "positive regulation of telomere maintenance",
  "GO:0032207": "regulation of telomere maintenance via recombination",
  "GO:0032208": "negative regulation of telomere maintenance via recombination",
  "GO:0032209": "positive regulation of telomere maintenance via recombination",
  "GO:0032210": "regulation of telomere maintenance via telomerase",
  "GO:0032211": "negative regulation of telomere maintenance via telomerase",
  "GO:0032212": "positive regulation of telomere maintenance via telomerase",
  "GO:0032213": "regulation of telomere maintenance via semi-conservative replication",
  "GO:0032214": "negative regulation of telomere maintenance via semi-conservative replication",
  "GO:0032215": "positive regulation of telomere maintenance via semi-conservative replication",
  "GO:0032216": "glucosaminyl-phosphotidylinositol O-acyltransferase activity",
  "GO:0032217": "riboflavin transporter activity",
  "GO:0032218": "riboflavin transport",
  "GO:0032219": "cell wall macromolecule catabolic process involved in cytogamy",
  "GO:0032220": "plasma membrane fusion involved in cytogamy",
  "GO:0032221": "Rpd3S complex",
  "GO:0032222": "regulation of synaptic transmission, cholinergic",
  "GO:0032223": "negative regulation of synaptic transmission, cholinergic",
  "GO:0032224": "positive regulation of synaptic transmission, cholinergic",
  "GO:0032225": "regulation of synaptic transmission, dopaminergic",
  "GO:0032226": "positive regulation of synaptic transmission, dopaminergic",
  "GO:0032227": "negative regulation of synaptic transmission, dopaminergic",
  "GO:0032228": "regulation of synaptic transmission, GABAergic",
  "GO:0032229": "negative regulation of synaptic transmission, GABAergic",
  "GO:0032230": "positive regulation of synaptic transmission, GABAergic",
  "GO:0032231": "regulation of actin filament bundle assembly",
  "GO:0032232": "negative regulation of actin filament bundle assembly",
  "GO:0032233": "positive regulation of actin filament bundle assembly",
  "GO:0032234": "obsolete regulation of calcium ion transport via store-operated calcium channel activity",
  "GO:0032235": "obsolete negative regulation of calcium ion transport via store-operated calcium channel activity",
  "GO:0032236": "obsolete positive regulation of calcium ion transport via store-operated calcium channel activity",
  "GO:0032237": "activation of store-operated calcium channel activity",
  "GO:0032238": "adenosine transport",
  "GO:0032239": "regulation of nucleobase-containing compound transport",
  "GO:0032240": "negative regulation of nucleobase-containing compound transport",
  "GO:0032241": "positive regulation of nucleobase-containing compound transport",
  "GO:0032242": "regulation of nucleoside transport",
  "GO:0032243": "negative regulation of nucleoside transport",
  "GO:0032244": "positive regulation of nucleoside transport",
  "GO:0032245": "regulation of purine nucleoside transport",
  "GO:0032246": "regulation of pyrimidine nucleoside transport",
  "GO:0032247": "negative regulation of purine nucleoside transport",
  "GO:0032248": "positive regulation of purine nucleoside transport",
  "GO:0032249": "regulation of adenosine transport",
  "GO:0032250": "negative regulation of adenosine transport",
  "GO:0032251": "positive regulation of adenosine transport",
  "GO:0032252": "secretory granule localization",
  "GO:0032253": "dense core granule localization",
  "GO:0032254": "establishment of secretory granule localization",
  "GO:0032255": "maintenance of secretory granule location",
  "GO:0032256": "establishment of dense core granule localization",
  "GO:0032257": "maintenance of dense core granule location",
  "GO:0032258": "CVT pathway",
  "GO:0032259": "methylation",
  "GO:0032260": "response to jasmonic acid stimulus involved in jasmonic acid and ethylene-dependent systemic resistance",
  "GO:0032261": "purine nucleotide salvage",
  "GO:0032262": "pyrimidine nucleotide salvage",
  "GO:0032263": "GMP salvage",
  "GO:0032264": "IMP salvage",
  "GO:0032265": "XMP salvage",
  "GO:0032266": "phosphatidylinositol-3-phosphate binding",
  "GO:0032267": "tRNA(Ile)-lysidine synthase activity",
  "GO:0032268": "regulation of cellular protein metabolic process",
  "GO:0032269": "negative regulation of cellular protein metabolic process",
  "GO:0032270": "positive regulation of cellular protein metabolic process",
  "GO:0032271": "regulation of protein polymerization",
  "GO:0032272": "negative regulation of protein polymerization",
  "GO:0032273": "positive regulation of protein polymerization",
  "GO:0032274": "gonadotropin secretion",
  "GO:0032275": "luteinizing hormone secretion",
  "GO:0032276": "regulation of gonadotropin secretion",
  "GO:0032277": "negative regulation of gonadotropin secretion",
  "GO:0032278": "positive regulation of gonadotropin secretion",
  "GO:0032279": "asymmetric synapse",
  "GO:0032280": "symmetric synapse",
  "GO:0032281": "AMPA glutamate receptor complex",
  "GO:0032282": "plastid acetyl-CoA carboxylase complex",
  "GO:0032283": "plastid acetate CoA-transferase complex",
  "GO:0032284": "plastid biotin carboxylase complex",
  "GO:0032285": "non-myelinated axon ensheathment",
  "GO:0032286": "central nervous system myelin maintenance",
  "GO:0032287": "peripheral nervous system myelin maintenance",
  "GO:0032288": "myelin assembly",
  "GO:0032289": "central nervous system myelin formation",
  "GO:0032290": "peripheral nervous system myelin formation",
  "GO:0032291": "axon ensheathment in central nervous system",
  "GO:0032292": "peripheral nervous system axon ensheathment",
  "GO:0032293": "non-myelinated axon ensheathment in central nervous system",
  "GO:0032294": "peripheral nervous system non-myelinated axon ensheathment",
  "GO:0032295": "ensheathment of neuronal cell bodies",
  "GO:0032296": "double-stranded RNA-specific ribonuclease activity",
  "GO:0032297": "negative regulation of DNA-dependent DNA replication initiation",
  "GO:0032298": "positive regulation of DNA-dependent DNA replication initiation",
  "GO:0032299": "ribonuclease H2 complex",
  "GO:0032300": "mismatch repair complex",
  "GO:0032301": "MutSalpha complex",
  "GO:0032302": "MutSbeta complex",
  "GO:0032303": "regulation of icosanoid secretion",
  "GO:0032304": "negative regulation of icosanoid secretion",
  "GO:0032305": "positive regulation of icosanoid secretion",
  "GO:0032306": "regulation of prostaglandin secretion",
  "GO:0032307": "negative regulation of prostaglandin secretion",
  "GO:0032308": "positive regulation of prostaglandin secretion",
  "GO:0032309": "icosanoid secretion",
  "GO:0032310": "prostaglandin secretion",
  "GO:0032311": "angiogenin-PRI complex",
  "GO:0032322": "ubiquinone catabolic process",
  "GO:0032323": "lipoate catabolic process",
  "GO:0032324": "molybdopterin cofactor biosynthetic process",
  "GO:0032325": "molybdopterin cofactor catabolic process",
  "GO:0032326": "Mo-molybdopterin cofactor catabolic process",
  "GO:0032327": "W-molybdopterin cofactor catabolic process",
  "GO:0032328": "alanine transport",
  "GO:0032329": "serine transport",
  "GO:0032330": "regulation of chondrocyte differentiation",
  "GO:0032331": "negative regulation of chondrocyte differentiation",
  "GO:0032332": "positive regulation of chondrocyte differentiation",
  "GO:0032333": "activin secretion",
  "GO:0032334": "inhibin secretion",
  "GO:0032335": "regulation of activin secretion",
  "GO:0032336": "negative regulation of activin secretion",
  "GO:0032337": "positive regulation of activin secretion",
  "GO:0032338": "regulation of inhibin secretion",
  "GO:0032339": "negative regulation of inhibin secretion",
  "GO:0032340": "positive regulation of inhibin secretion",
  "GO:0032341": "aldosterone metabolic process",
  "GO:0032342": "aldosterone biosynthetic process",
  "GO:0032343": "aldosterone catabolic process",
  "GO:0032344": "regulation of aldosterone metabolic process",
  "GO:0032345": "negative regulation of aldosterone metabolic process",
  "GO:0032346": "positive regulation of aldosterone metabolic process",
  "GO:0032347": "regulation of aldosterone biosynthetic process",
  "GO:0032348": "negative regulation of aldosterone biosynthetic process",
  "GO:0032349": "positive regulation of aldosterone biosynthetic process",
  "GO:0032350": "regulation of hormone metabolic process",
  "GO:0032351": "negative regulation of hormone metabolic process",
  "GO:0032352": "positive regulation of hormone metabolic process",
  "GO:0032353": "negative regulation of hormone biosynthetic process",
  "GO:0032354": "response to follicle-stimulating hormone",
  "GO:0032355": "response to estradiol",
  "GO:0032356": "oxidized DNA binding",
  "GO:0032357": "oxidized purine DNA binding",
  "GO:0032358": "oxidized pyrimidine DNA binding",
  "GO:0032359": "provirus excision",
  "GO:0032361": "pyridoxal phosphate catabolic process",
  "GO:0032362": "obsolete FAD catabolic process",
  "GO:0032363": "FMN catabolic process",
  "GO:0032364": "oxygen homeostasis",
  "GO:0032365": "intracellular lipid transport",
  "GO:0032366": "intracellular sterol transport",
  "GO:0032367": "intracellular cholesterol transport",
  "GO:0032368": "regulation of lipid transport",
  "GO:0032369": "negative regulation of lipid transport",
  "GO:0032370": "positive regulation of lipid transport",
  "GO:0032371": "regulation of sterol transport",
  "GO:0032372": "negative regulation of sterol transport",
  "GO:0032373": "positive regulation of sterol transport",
  "GO:0032374": "regulation of cholesterol transport",
  "GO:0032375": "negative regulation of cholesterol transport",
  "GO:0032376": "positive regulation of cholesterol transport",
  "GO:0032377": "regulation of intracellular lipid transport",
  "GO:0032378": "negative regulation of intracellular lipid transport",
  "GO:0032379": "positive regulation of intracellular lipid transport",
  "GO:0032380": "regulation of intracellular sterol transport",
  "GO:0032381": "negative regulation of intracellular sterol transport",
  "GO:0032382": "positive regulation of intracellular sterol transport",
  "GO:0032383": "regulation of intracellular cholesterol transport",
  "GO:0032384": "negative regulation of intracellular cholesterol transport",
  "GO:0032385": "positive regulation of intracellular cholesterol transport",
  "GO:0032386": "regulation of intracellular transport",
  "GO:0032387": "negative regulation of intracellular transport",
  "GO:0032388": "positive regulation of intracellular transport",
  "GO:0032389": "MutLalpha complex",
  "GO:0032390": "MutLbeta complex",
  "GO:0032391": "photoreceptor connecting cilium",
  "GO:0032392": "DNA geometric change",
  "GO:0032393": "MHC class I receptor activity",
  "GO:0032394": "MHC class Ib receptor activity",
  "GO:0032395": "MHC class II receptor activity",
  "GO:0032396": "inhibitory MHC class I receptor activity",
  "GO:0032397": "activating MHC class I receptor activity",
  "GO:0032398": "MHC class Ib protein complex",
  "GO:0032399": "HECT domain binding",
  "GO:0032400": "melanosome localization",
  "GO:0032401": "establishment of melanosome localization",
  "GO:0032402": "melanosome transport",
  "GO:0032403": "protein complex binding",
  "GO:0032404": "mismatch repair complex binding",
  "GO:0032405": "MutLalpha complex binding",
  "GO:0032406": "MutLbeta complex binding",
  "GO:0032407": "MutSalpha complex binding",
  "GO:0032408": "MutSbeta complex binding",
  "GO:0032409": "regulation of transporter activity",
  "GO:0032410": "negative regulation of transporter activity",
  "GO:0032411": "positive regulation of transporter activity",
  "GO:0032412": "regulation of ion transmembrane transporter activity",
  "GO:0032413": "negative regulation of ion transmembrane transporter activity",
  "GO:0032414": "positive regulation of ion transmembrane transporter activity",
  "GO:0032415": "regulation of sodium:proton antiporter activity",
  "GO:0032416": "negative regulation of sodium:proton antiporter activity",
  "GO:0032417": "positive regulation of sodium:proton antiporter activity",
  "GO:0032418": "lysosome localization",
  "GO:0032419": "extrinsic component of lysosome membrane",
  "GO:0032420": "stereocilium",
  "GO:0032421": "stereocilium bundle",
  "GO:0032422": "purine-rich negative regulatory element binding",
  "GO:0032423": "regulation of mismatch repair",
  "GO:0032424": "negative regulation of mismatch repair",
  "GO:0032425": "positive regulation of mismatch repair",
  "GO:0032426": "stereocilium tip",
  "GO:0032427": "GBD domain binding",
  "GO:0032428": "beta-N-acetylgalactosaminidase activity",
  "GO:0032429": "regulation of phospholipase A2 activity",
  "GO:0032430": "positive regulation of phospholipase A2 activity",
  "GO:0032431": "activation of phospholipase A2 activity",
  "GO:0032432": "actin filament bundle",
  "GO:0032433": "filopodium tip",
  "GO:0032434": "regulation of proteasomal ubiquitin-dependent protein catabolic process",
  "GO:0032435": "negative regulation of proteasomal ubiquitin-dependent protein catabolic process",
  "GO:0032436": "positive regulation of proteasomal ubiquitin-dependent protein catabolic process",
  "GO:0032437": "cuticular plate",
  "GO:0032438": "melanosome organization",
  "GO:0032439": "endosome localization",
  "GO:0032440": "2-alkenal reductase [NAD(P)] activity",
  "GO:0032441": "pheophorbide a oxygenase activity",
  "GO:0032442": "phenylcoumaran benzylic ether reductase activity",
  "GO:0032443": "regulation of ergosterol biosynthetic process",
  "GO:0032444": "activin responsive factor complex",
  "GO:0032445": "fructose import",
  "GO:0032446": "protein modification by small protein conjugation",
  "GO:0032447": "protein urmylation",
  "GO:0032448": "DNA hairpin binding",
  "GO:0032449": "CBM complex",
  "GO:0032450": "maltose alpha-glucosidase activity",
  "GO:0032451": "demethylase activity",
  "GO:0032452": "histone demethylase activity",
  "GO:0032453": "histone demethylase activity (H3-K4 specific)",
  "GO:0032454": "histone demethylase activity (H3-K9 specific)",
  "GO:0032455": "nerve growth factor processing",
  "GO:0032456": "endocytic recycling",
  "GO:0032457": "fast endocytic recycling",
  "GO:0032458": "slow endocytic recycling",
  "GO:0032459": "regulation of protein oligomerization",
  "GO:0032460": "negative regulation of protein oligomerization",
  "GO:0032461": "positive regulation of protein oligomerization",
  "GO:0032462": "regulation of protein homooligomerization",
  "GO:0032463": "negative regulation of protein homooligomerization",
  "GO:0032464": "positive regulation of protein homooligomerization",
  "GO:0032465": "regulation of cytokinesis",
  "GO:0032466": "negative regulation of cytokinesis",
  "GO:0032467": "positive regulation of cytokinesis",
  "GO:0032468": "Golgi calcium ion homeostasis",
  "GO:0032469": "endoplasmic reticulum calcium ion homeostasis",
  "GO:0032470": "positive regulation of endoplasmic reticulum calcium ion concentration",
  "GO:0032471": "negative regulation of endoplasmic reticulum calcium ion concentration",
  "GO:0032472": "Golgi calcium ion transport",
  "GO:0032473": "cytoplasmic side of mitochondrial outer membrane",
  "GO:0032474": "otolith morphogenesis",
  "GO:0032475": "otolith formation",
  "GO:0032476": "decaprenyl diphosphate synthase complex",
  "GO:0032477": "homodimeric decaprenyl diphosphate synthase complex",
  "GO:0032478": "heterotetrameric decaprenyl diphosphate synthase complex",
  "GO:0032479": "regulation of type I interferon production",
  "GO:0032480": "negative regulation of type I interferon production",
  "GO:0032481": "positive regulation of type I interferon production",
  "GO:0032482": "Rab protein signal transduction",
  "GO:0032483": "regulation of Rab protein signal transduction",
  "GO:0032484": "Ral protein signal transduction",
  "GO:0032485": "regulation of Ral protein signal transduction",
  "GO:0032486": "Rap protein signal transduction",
  "GO:0032487": "regulation of Rap protein signal transduction",
  "GO:0032488": "Cdc42 protein signal transduction",
  "GO:0032489": "regulation of Cdc42 protein signal transduction",
  "GO:0032490": "detection of molecule of bacterial origin",
  "GO:0032491": "detection of molecule of fungal origin",
  "GO:0032492": "detection of molecule of oomycetes origin",
  "GO:0032493": "response to bacterial lipoprotein",
  "GO:0032494": "response to peptidoglycan",
  "GO:0032495": "response to muramyl dipeptide",
  "GO:0032496": "response to lipopolysaccharide",
  "GO:0032497": "detection of lipopolysaccharide",
  "GO:0032498": "detection of muramyl dipeptide",
  "GO:0032499": "detection of peptidoglycan",
  "GO:0032500": "muramyl dipeptide binding",
  "GO:0032501": "multicellular organismal process",
  "GO:0032502": "developmental process",
  "GO:0032504": "multicellular organism reproduction",
  "GO:0032505": "reproduction of a single-celled organism",
  "GO:0032506": "cytokinetic process",
  "GO:0032507": "maintenance of protein location in cell",
  "GO:0032508": "DNA duplex unwinding",
  "GO:0032509": "endosome transport via multivesicular body sorting pathway",
  "GO:0032510": "endosome to lysosome transport via multivesicular body sorting pathway",
  "GO:0032511": "late endosome to vacuole transport via multivesicular body sorting pathway",
  "GO:0032512": "regulation of protein phosphatase type 2B activity",
  "GO:0032513": "negative regulation of protein phosphatase type 2B activity",
  "GO:0032514": "positive regulation of protein phosphatase type 2B activity",
  "GO:0032515": "negative regulation of phosphoprotein phosphatase activity",
  "GO:0032516": "positive regulation of phosphoprotein phosphatase activity",
  "GO:0032517": "SOD1-calcineurin complex",
  "GO:0032518": "amino acid-exporting ATPase activity",
  "GO:0032519": "cysteine-exporting ATPase activity",
  "GO:0032520": "amino acid-importing ATPase activity",
  "GO:0032521": "D-methionine-exporting ATPase activity",
  "GO:0032522": "D-methionine-importing ATPase activity",
  "GO:0032523": "silicon efflux transmembrane transporter activity",
  "GO:0032524": "obsolete nutrient export",
  "GO:0032525": "somite rostral/caudal axis specification",
  "GO:0032526": "response to retinoic acid",
  "GO:0032527": "protein exit from endoplasmic reticulum",
  "GO:0032528": "microvillus organization",
  "GO:0032529": "follicle cell microvillus organization",
  "GO:0032530": "regulation of microvillus organization",
  "GO:0032531": "regulation of follicle cell microvillus organization",
  "GO:0032532": "regulation of microvillus length",
  "GO:0032533": "regulation of follicle cell microvillus length",
  "GO:0032534": "regulation of microvillus assembly",
  "GO:0032535": "regulation of cellular component size",
  "GO:0032536": "regulation of cell projection size",
  "GO:0032537": "host-seeking behavior",
  "GO:0032538": "regulation of host-seeking behavior",
  "GO:0032539": "negative regulation of host-seeking behavior",
  "GO:0032540": "positive regulation of host-seeking behavior",
  "GO:0032541": "cortical endoplasmic reticulum",
  "GO:0032542": "sulfiredoxin activity",
  "GO:0032543": "mitochondrial translation",
  "GO:0032544": "plastid translation",
  "GO:0032545": "CURI complex",
  "GO:0032546": "deoxyribonucleoside binding",
  "GO:0032547": "purine deoxyribonucleoside binding",
  "GO:0032548": "pyrimidine deoxyribonucleoside binding",
  "GO:0032549": "ribonucleoside binding",
  "GO:0032550": "purine ribonucleoside binding",
  "GO:0032551": "pyrimidine ribonucleoside binding",
  "GO:0032552": "deoxyribonucleotide binding",
  "GO:0032553": "ribonucleotide binding",
  "GO:0032554": "purine deoxyribonucleotide binding",
  "GO:0032555": "purine ribonucleotide binding",
  "GO:0032556": "pyrimidine deoxyribonucleotide binding",
  "GO:0032557": "pyrimidine ribonucleotide binding",
  "GO:0032558": "adenyl deoxyribonucleotide binding",
  "GO:0032559": "adenyl ribonucleotide binding",
  "GO:0032560": "guanyl deoxyribonucleotide binding",
  "GO:0032561": "guanyl ribonucleotide binding",
  "GO:0032562": "dAMP binding",
  "GO:0032563": "dADP binding",
  "GO:0032564": "dATP binding",
  "GO:0032565": "dGMP binding",
  "GO:0032566": "dGDP binding",
  "GO:0032567": "dGTP binding",
  "GO:0032570": "response to progesterone",
  "GO:0032571": "response to vitamin K",
  "GO:0032572": "response to menaquinone",
  "GO:0032573": "response to phylloquinone",
  "GO:0032574": "5'-3' RNA helicase activity",
  "GO:0032575": "ATP-dependent 5'-3' RNA helicase activity",
  "GO:0032576": "O-linoleoyltransferase activity",
  "GO:0032577": "phosphatidylcholine:cardiolipin O-linoleoyltransferase activity",
  "GO:0032578": "aleurone grain membrane",
  "GO:0032579": "apical lamina of hyaline layer",
  "GO:0032580": "Golgi cisterna membrane",
  "GO:0032581": "ER-dependent peroxisome organization",
  "GO:0032584": "growth cone membrane",
  "GO:0032585": "multivesicular body membrane",
  "GO:0032586": "protein storage vacuole membrane",
  "GO:0032587": "ruffle membrane",
  "GO:0032588": "trans-Golgi network membrane",
  "GO:0032589": "neuron projection membrane",
  "GO:0032590": "dendrite membrane",
  "GO:0032591": "dendritic spine membrane",
  "GO:0032592": "integral component of mitochondrial membrane",
  "GO:0032593": "insulin-responsive compartment",
  "GO:0032594": "protein transport within lipid bilayer",
  "GO:0032595": "B cell receptor transport within lipid bilayer",
  "GO:0032596": "protein transport into membrane raft",
  "GO:0032597": "B cell receptor transport into membrane raft",
  "GO:0032598": "B cell receptor transport into immunological synapse",
  "GO:0032599": "protein transport out of membrane raft",
  "GO:0032600": "chemokine receptor transport out of membrane raft",
  "GO:0032601": "connective tissue growth factor production",
  "GO:0032602": "chemokine production",
  "GO:0032603": "fractalkine production",
  "GO:0032604": "granulocyte macrophage colony-stimulating factor production",
  "GO:0032605": "hepatocyte growth factor production",
  "GO:0032606": "type I interferon production",
  "GO:0032607": "interferon-alpha production",
  "GO:0032608": "interferon-beta production",
  "GO:0032609": "interferon-gamma production",
  "GO:0032610": "interleukin-1 alpha production",
  "GO:0032611": "interleukin-1 beta production",
  "GO:0032612": "interleukin-1 production",
  "GO:0032613": "interleukin-10 production",
  "GO:0032614": "interleukin-11 production",
  "GO:0032615": "interleukin-12 production",
  "GO:0032616": "interleukin-13 production",
  "GO:0032617": "interleukin-14 production",
  "GO:0032618": "interleukin-15 production",
  "GO:0032619": "interleukin-16 production",
  "GO:0032620": "interleukin-17 production",
  "GO:0032621": "interleukin-18 production",
  "GO:0032622": "interleukin-19 production",
  "GO:0032623": "interleukin-2 production",
  "GO:0032624": "interleukin-20 production",
  "GO:0032625": "interleukin-21 production",
  "GO:0032626": "interleukin-22 production",
  "GO:0032627": "interleukin-23 production",
  "GO:0032628": "interleukin-24 production",
  "GO:0032629": "interleukin-25 production",
  "GO:0032630": "interleukin-26 production",
  "GO:0032631": "interleukin-27 production",
  "GO:0032632": "interleukin-3 production",
  "GO:0032633": "interleukin-4 production",
  "GO:0032634": "interleukin-5 production",
  "GO:0032635": "interleukin-6 production",
  "GO:0032636": "interleukin-7 production",
  "GO:0032637": "interleukin-8 production",
  "GO:0032638": "interleukin-9 production",
  "GO:0032639": "TRAIL production",
  "GO:0032640": "tumor necrosis factor production",
  "GO:0032641": "lymphotoxin A production",
  "GO:0032642": "regulation of chemokine production",
  "GO:0032643": "regulation of connective tissue growth factor production",
  "GO:0032644": "regulation of fractalkine production",
  "GO:0032645": "regulation of granulocyte macrophage colony-stimulating factor production",
  "GO:0032646": "regulation of hepatocyte growth factor production",
  "GO:0032647": "regulation of interferon-alpha production",
  "GO:0032648": "regulation of interferon-beta production",
  "GO:0032649": "regulation of interferon-gamma production",
  "GO:0032650": "regulation of interleukin-1 alpha production",
  "GO:0032651": "regulation of interleukin-1 beta production",
  "GO:0032652": "regulation of interleukin-1 production",
  "GO:0032653": "regulation of interleukin-10 production",
  "GO:0032654": "regulation of interleukin-11 production",
  "GO:0032655": "regulation of interleukin-12 production",
  "GO:0032656": "regulation of interleukin-13 production",
  "GO:0032657": "regulation of interleukin-14 production",
  "GO:0032658": "regulation of interleukin-15 production",
  "GO:0032659": "regulation of interleukin-16 production",
  "GO:0032660": "regulation of interleukin-17 production",
  "GO:0032661": "regulation of interleukin-18 production",
  "GO:0032662": "regulation of interleukin-19 production",
  "GO:0032663": "regulation of interleukin-2 production",
  "GO:0032664": "regulation of interleukin-20 production",
  "GO:0032665": "regulation of interleukin-21 production",
  "GO:0032666": "regulation of interleukin-22 production",
  "GO:0032667": "regulation of interleukin-23 production",
  "GO:0032668": "regulation of interleukin-24 production",
  "GO:0032669": "regulation of interleukin-25 production",
  "GO:0032670": "regulation of interleukin-26 production",
  "GO:0032671": "regulation of interleukin-27 production",
  "GO:0032672": "regulation of interleukin-3 production",
  "GO:0032673": "regulation of interleukin-4 production",
  "GO:0032674": "regulation of interleukin-5 production",
  "GO:0032675": "regulation of interleukin-6 production",
  "GO:0032676": "regulation of interleukin-7 production",
  "GO:0032677": "regulation of interleukin-8 production",
  "GO:0032678": "regulation of interleukin-9 production",
  "GO:0032679": "regulation of TRAIL production",
  "GO:0032680": "regulation of tumor necrosis factor production",
  "GO:0032681": "regulation of lymphotoxin A production",
  "GO:0032682": "negative regulation of chemokine production",
  "GO:0032683": "negative regulation of connective tissue growth factor production",
  "GO:0032684": "negative regulation of fractalkine production",
  "GO:0032685": "negative regulation of granulocyte macrophage colony-stimulating factor production",
  "GO:0032686": "negative regulation of hepatocyte growth factor production",
  "GO:0032687": "negative regulation of interferon-alpha production",
  "GO:0032688": "negative regulation of interferon-beta production",
  "GO:0032689": "negative regulation of interferon-gamma production",
  "GO:0032690": "negative regulation of interleukin-1 alpha production",
  "GO:0032691": "negative regulation of interleukin-1 beta production",
  "GO:0032692": "negative regulation of interleukin-1 production",
  "GO:0032693": "negative regulation of interleukin-10 production",
  "GO:0032694": "negative regulation of interleukin-11 production",
  "GO:0032695": "negative regulation of interleukin-12 production",
  "GO:0032696": "negative regulation of interleukin-13 production",
  "GO:0032697": "negative regulation of interleukin-14 production",
  "GO:0032698": "negative regulation of interleukin-15 production",
  "GO:0032699": "negative regulation of interleukin-16 production",
  "GO:0032700": "negative regulation of interleukin-17 production",
  "GO:0032701": "negative regulation of interleukin-18 production",
  "GO:0032702": "negative regulation of interleukin-19 production",
  "GO:0032703": "negative regulation of interleukin-2 production",
  "GO:0032704": "negative regulation of interleukin-20 production",
  "GO:0032705": "negative regulation of interleukin-21 production",
  "GO:0032706": "negative regulation of interleukin-22 production",
  "GO:0032707": "negative regulation of interleukin-23 production",
  "GO:0032708": "negative regulation of interleukin-24 production",
  "GO:0032709": "negative regulation of interleukin-25 production",
  "GO:0032710": "negative regulation of interleukin-26 production",
  "GO:0032711": "negative regulation of interleukin-27 production",
  "GO:0032712": "negative regulation of interleukin-3 production",
  "GO:0032713": "negative regulation of interleukin-4 production",
  "GO:0032714": "negative regulation of interleukin-5 production",
  "GO:0032715": "negative regulation of interleukin-6 production",
  "GO:0032716": "negative regulation of interleukin-7 production",
  "GO:0032717": "negative regulation of interleukin-8 production",
  "GO:0032718": "negative regulation of interleukin-9 production",
  "GO:0032719": "negative regulation of TRAIL production",
  "GO:0032720": "negative regulation of tumor necrosis factor production",
  "GO:0032721": "negative regulation of lymphotoxin A production",
  "GO:0032722": "positive regulation of chemokine production",
  "GO:0032723": "positive regulation of connective tissue growth factor production",
  "GO:0032724": "positive regulation of fractalkine production",
  "GO:0032725": "positive regulation of granulocyte macrophage colony-stimulating factor production",
  "GO:0032726": "positive regulation of hepatocyte growth factor production",
  "GO:0032727": "positive regulation of interferon-alpha production",
  "GO:0032728": "positive regulation of interferon-beta production",
  "GO:0032729": "positive regulation of interferon-gamma production",
  "GO:0032730": "positive regulation of interleukin-1 alpha production",
  "GO:0032731": "positive regulation of interleukin-1 beta production",
  "GO:0032732": "positive regulation of interleukin-1 production",
  "GO:0032733": "positive regulation of interleukin-10 production",
  "GO:0032734": "positive regulation of interleukin-11 production",
  "GO:0032735": "positive regulation of interleukin-12 production",
  "GO:0032736": "positive regulation of interleukin-13 production",
  "GO:0032737": "positive regulation of interleukin-14 production",
  "GO:0032738": "positive regulation of interleukin-15 production",
  "GO:0032739": "positive regulation of interleukin-16 production",
  "GO:0032740": "positive regulation of interleukin-17 production",
  "GO:0032741": "positive regulation of interleukin-18 production",
  "GO:0032742": "positive regulation of interleukin-19 production",
  "GO:0032743": "positive regulation of interleukin-2 production",
  "GO:0032744": "positive regulation of interleukin-20 production",
  "GO:0032745": "positive regulation of interleukin-21 production",
  "GO:0032746": "positive regulation of interleukin-22 production",
  "GO:0032747": "positive regulation of interleukin-23 production",
  "GO:0032748": "positive regulation of interleukin-24 production",
  "GO:0032749": "positive regulation of interleukin-25 production",
  "GO:0032750": "positive regulation of interleukin-26 production",
  "GO:0032751": "positive regulation of interleukin-27 production",
  "GO:0032752": "positive regulation of interleukin-3 production",
  "GO:0032753": "positive regulation of interleukin-4 production",
  "GO:0032754": "positive regulation of interleukin-5 production",
  "GO:0032755": "positive regulation of interleukin-6 production",
  "GO:0032756": "positive regulation of interleukin-7 production",
  "GO:0032757": "positive regulation of interleukin-8 production",
  "GO:0032758": "positive regulation of interleukin-9 production",
  "GO:0032759": "positive regulation of TRAIL production",
  "GO:0032760": "positive regulation of tumor necrosis factor production",
  "GO:0032761": "positive regulation of lymphotoxin A production",
  "GO:0032762": "mast cell cytokine production",
  "GO:0032763": "regulation of mast cell cytokine production",
  "GO:0032764": "negative regulation of mast cell cytokine production",
  "GO:0032765": "positive regulation of mast cell cytokine production",
  "GO:0032766": "NHE3/E3KARP/ACTN4 complex",
  "GO:0032767": "copper-dependent protein binding",
  "GO:0032768": "regulation of monooxygenase activity",
  "GO:0032769": "negative regulation of monooxygenase activity",
  "GO:0032770": "positive regulation of monooxygenase activity",
  "GO:0032771": "regulation of monophenol monooxygenase activity",
  "GO:0032772": "negative regulation of monophenol monooxygenase activity",
  "GO:0032773": "positive regulation of monophenol monooxygenase activity",
  "GO:0032774": "RNA biosynthetic process",
  "GO:0032775": "DNA methylation on adenine",
  "GO:0032776": "DNA methylation on cytosine",
  "GO:0032777": "Piccolo NuA4 histone acetyltransferase complex",
  "GO:0032778": "cobalt-transporting ATPase activity",
  "GO:0032780": "negative regulation of ATPase activity",
  "GO:0032781": "positive regulation of ATPase activity",
  "GO:0032782": "bile acid secretion",
  "GO:0032783": "ELL-EAF complex",
  "GO:0032784": "regulation of DNA-templated transcription, elongation",
  "GO:0032785": "negative regulation of DNA-templated transcription, elongation",
  "GO:0032786": "positive regulation of DNA-templated transcription, elongation",
  "GO:0032787": "monocarboxylic acid metabolic process",
  "GO:0032788": "saturated monocarboxylic acid metabolic process",
  "GO:0032789": "unsaturated monocarboxylic acid metabolic process",
  "GO:0032790": "ribosome disassembly",
  "GO:0032791": "lead ion binding",
  "GO:0032792": "negative regulation of CREB transcription factor activity",
  "GO:0032793": "positive regulation of CREB transcription factor activity",
  "GO:0032794": "GTPase activating protein binding",
  "GO:0032795": "heterotrimeric G-protein binding",
  "GO:0032796": "uropod organization",
  "GO:0032797": "SMN complex",
  "GO:0032798": "Swi5-Sfr1 complex",
  "GO:0032799": "low-density lipoprotein receptor particle metabolic process",
  "GO:0032800": "receptor biosynthetic process",
  "GO:0032801": "receptor catabolic process",
  "GO:0032802": "low-density lipoprotein particle receptor catabolic process",
  "GO:0032803": "regulation of low-density lipoprotein particle receptor catabolic process",
  "GO:0032804": "negative regulation of low-density lipoprotein particle receptor catabolic process",
  "GO:0032805": "positive regulation of low-density lipoprotein particle receptor catabolic process",
  "GO:0032806": "carboxy-terminal domain protein kinase complex",
  "GO:0032807": "DNA ligase IV complex",
  "GO:0032808": "lacrimal gland development",
  "GO:0032809": "neuronal cell body membrane",
  "GO:0032810": "sterol response element binding",
  "GO:0032811": "negative regulation of epinephrine secretion",
  "GO:0032812": "positive regulation of epinephrine secretion",
  "GO:0032813": "tumor necrosis factor receptor superfamily binding",
  "GO:0032814": "regulation of natural killer cell activation",
  "GO:0032815": "negative regulation of natural killer cell activation",
  "GO:0032816": "positive regulation of natural killer cell activation",
  "GO:0032817": "regulation of natural killer cell proliferation",
  "GO:0032818": "negative regulation of natural killer cell proliferation",
  "GO:0032819": "positive regulation of natural killer cell proliferation",
  "GO:0032820": "regulation of natural killer cell proliferation involved in immune response",
  "GO:0032821": "negative regulation of natural killer cell proliferation involved in immune response",
  "GO:0032822": "positive regulation of natural killer cell proliferation involved in immune response",
  "GO:0032823": "regulation of natural killer cell differentiation",
  "GO:0032824": "negative regulation of natural killer cell differentiation",
  "GO:0032825": "positive regulation of natural killer cell differentiation",
  "GO:0032826": "regulation of natural killer cell differentiation involved in immune response",
  "GO:0032827": "negative regulation of natural killer cell differentiation involved in immune response",
  "GO:0032828": "positive regulation of natural killer cell differentiation involved in immune response",
  "GO:0032829": "regulation of CD4-positive, CD25-positive, alpha-beta regulatory T cell differentiation",
  "GO:0032830": "negative regulation of CD4-positive, CD25-positive, alpha-beta regulatory T cell differentiation",
  "GO:0032831": "positive regulation of CD4-positive, CD25-positive, alpha-beta regulatory T cell differentiation",
  "GO:0032832": "regulation of CD4-positive, CD25-positive, alpha-beta regulatory T cell differentiation involved in immune response",
  "GO:0032833": "negative regulation of CD4-positive, CD25-positive, alpha-beta regulatory T cell differentiation involved in immune response",
  "GO:0032834": "positive regulation of CD4-positive, CD25-positive, alpha-beta regulatory T cell differentiation involved in immune response",
  "GO:0032835": "glomerulus development",
  "GO:0032836": "glomerular basement membrane development",
  "GO:0032837": "distributive segregation",
  "GO:0032838": "cell projection cytoplasm",
  "GO:0032839": "dendrite cytoplasm",
  "GO:0032840": "intramolecular proline-rich ligand binding",
  "GO:0032841": "calcitonin binding",
  "GO:0032843": "hydroperoxide reductase activity",
  "GO:0032844": "regulation of homeostatic process",
  "GO:0032845": "negative regulation of homeostatic process",
  "GO:0032846": "positive regulation of homeostatic process",
  "GO:0032847": "regulation of cellular pH reduction",
  "GO:0032848": "negative regulation of cellular pH reduction",
  "GO:0032849": "positive regulation of cellular pH reduction",
  "GO:0032865": "ERMES complex",
  "GO:0032866": "D-xylose:NADP reductase activity",
  "GO:0032867": "L-arabinose:NADP reductase activity",
  "GO:0032868": "response to insulin",
  "GO:0032869": "cellular response to insulin stimulus",
  "GO:0032870": "cellular response to hormone stimulus",
  "GO:0032871": "regulation of karyogamy",
  "GO:0032872": "regulation of stress-activated MAPK cascade",
  "GO:0032873": "negative regulation of stress-activated MAPK cascade",
  "GO:0032874": "positive regulation of stress-activated MAPK cascade",
  "GO:0032875": "regulation of DNA endoreduplication",
  "GO:0032876": "negative regulation of DNA endoreduplication",
  "GO:0032877": "positive regulation of DNA endoreduplication",
  "GO:0032878": "regulation of establishment or maintenance of cell polarity",
  "GO:0032879": "regulation of localization",
  "GO:0032880": "regulation of protein localization",
  "GO:0032881": "regulation of polysaccharide metabolic process",
  "GO:0032882": "regulation of chitin metabolic process",
  "GO:0032883": "regulation of chitin biosynthetic process",
  "GO:0032884": "regulation of cell wall chitin biosynthetic process",
  "GO:0032885": "regulation of polysaccharide biosynthetic process",
  "GO:0032886": "regulation of microtubule-based process",
  "GO:0032887": "regulation of spindle elongation",
  "GO:0032888": "regulation of mitotic spindle elongation",
  "GO:0032889": "regulation of vacuole fusion, non-autophagic",
  "GO:0032890": "regulation of organic acid transport",
  "GO:0032891": "negative regulation of organic acid transport",
  "GO:0032892": "positive regulation of organic acid transport",
  "GO:0032893": "regulation of gluconate transport",
  "GO:0032894": "negative regulation of gluconate transport",
  "GO:0032895": "positive regulation of gluconate transport",
  "GO:0032896": "palmitoyl-CoA 9-desaturase activity",
  "GO:0032897": "negative regulation of viral transcription",
  "GO:0032898": "neurotrophin production",
  "GO:0032899": "regulation of neurotrophin production",
  "GO:0032900": "negative regulation of neurotrophin production",
  "GO:0032901": "positive regulation of neurotrophin production",
  "GO:0032902": "nerve growth factor production",
  "GO:0032903": "regulation of nerve growth factor production",
  "GO:0032904": "negative regulation of nerve growth factor production",
  "GO:0032905": "transforming growth factor beta1 production",
  "GO:0032906": "transforming growth factor beta2 production",
  "GO:0032907": "transforming growth factor beta3 production",
  "GO:0032908": "regulation of transforming growth factor beta1 production",
  "GO:0032909": "regulation of transforming growth factor beta2 production",
  "GO:0032910": "regulation of transforming growth factor beta3 production",
  "GO:0032911": "negative regulation of transforming growth factor beta1 production",
  "GO:0032912": "negative regulation of transforming growth factor beta2 production",
  "GO:0032913": "negative regulation of transforming growth factor beta3 production",
  "GO:0032914": "positive regulation of transforming growth factor beta1 production",
  "GO:0032915": "positive regulation of transforming growth factor beta2 production",
  "GO:0032916": "positive regulation of transforming growth factor beta3 production",
  "GO:0032917": "polyamine acetylation",
  "GO:0032918": "spermidine acetylation",
  "GO:0032919": "spermine acetylation",
  "GO:0032920": "putrescine acetylation",
  "GO:0032921": "sarcosine oxidase complex",
  "GO:0032922": "circadian regulation of gene expression",
  "GO:0032923": "organic phosphonate biosynthetic process",
  "GO:0032924": "activin receptor signaling pathway",
  "GO:0032925": "regulation of activin receptor signaling pathway",
  "GO:0032926": "negative regulation of activin receptor signaling pathway",
  "GO:0032927": "positive regulation of activin receptor signaling pathway",
  "GO:0032928": "regulation of superoxide anion generation",
  "GO:0032929": "negative regulation of superoxide anion generation",
  "GO:0032930": "positive regulation of superoxide anion generation",
  "GO:0032931": "histone acetyltransferase activity (H3-K56 specific)",
  "GO:0032932": "negative regulation of astral microtubule depolymerization",
  "GO:0032933": "SREBP signaling pathway",
  "GO:0032934": "sterol binding",
  "GO:0032935": "sterol sensor activity",
  "GO:0032936": "SREBP-SCAP complex",
  "GO:0032937": "SREBP-SCAP-Insig complex",
  "GO:0032938": "negative regulation of translation in response to oxidative stress",
  "GO:0032939": "positive regulation of translation in response to oxidative stress",
  "GO:0032940": "secretion by cell",
  "GO:0032941": "secretion by tissue",
  "GO:0032942": "inositol tetrakisphosphate 2-kinase activity",
  "GO:0032943": "mononuclear cell proliferation",
  "GO:0032944": "regulation of mononuclear cell proliferation",
  "GO:0032945": "negative regulation of mononuclear cell proliferation",
  "GO:0032946": "positive regulation of mononuclear cell proliferation",
  "GO:0032947": "protein complex scaffold",
  "GO:0032948": "regulation of alpha-glucan metabolic process",
  "GO:0032949": "regulation of alpha-glucan biosynthetic process",
  "GO:0032950": "regulation of beta-glucan metabolic process",
  "GO:0032951": "regulation of beta-glucan biosynthetic process",
  "GO:0032952": "regulation of (1->3)-beta-D-glucan metabolic process",
  "GO:0032953": "regulation of (1->3)-beta-D-glucan biosynthetic process",
  "GO:0032954": "regulation of cytokinetic process",
  "GO:0032955": "regulation of barrier septum assembly",
  "GO:0032956": "regulation of actin cytoskeleton organization",
  "GO:0032957": "inositol trisphosphate metabolic process",
  "GO:0032958": "inositol phosphate biosynthetic process",
  "GO:0032959": "inositol trisphosphate biosynthetic process",
  "GO:0032960": "regulation of inositol trisphosphate biosynthetic process",
  "GO:0032961": "negative regulation of inositol trisphosphate biosynthetic process",
  "GO:0032962": "positive regulation of inositol trisphosphate biosynthetic process",
  "GO:0032963": "collagen metabolic process",
  "GO:0032964": "collagen biosynthetic process",
  "GO:0032965": "regulation of collagen biosynthetic process",
  "GO:0032966": "negative regulation of collagen biosynthetic process",
  "GO:0032967": "positive regulation of collagen biosynthetic process",
  "GO:0032968": "positive regulation of transcription elongation from RNA polymerase II promoter",
  "GO:0032969": "endosomal scaffold complex",
  "GO:0032970": "regulation of actin filament-based process",
  "GO:0032971": "regulation of muscle filament sliding",
  "GO:0032972": "regulation of muscle filament sliding speed",
  "GO:0032973": "amino acid export",
  "GO:0032974": "amino acid transmembrane export from vacuole",
  "GO:0032975": "amino acid transmembrane import into vacuole",
  "GO:0032976": "release of matrix enzymes from mitochondria",
  "GO:0032977": "membrane insertase activity",
  "GO:0032978": "protein insertion into membrane from inner side",
  "GO:0032979": "protein insertion into mitochondrial membrane from inner side",
  "GO:0032980": "keratinocyte activation",
  "GO:0032981": "mitochondrial respiratory chain complex I assembly",
  "GO:0032982": "myosin filament",
  "GO:0032983": "kainate selective glutamate receptor complex",
  "GO:0032984": "macromolecular complex disassembly",
  "GO:0032985": "protein-carbohydrate complex disassembly",
  "GO:0032986": "protein-DNA complex disassembly",
  "GO:0032987": "protein-lipid complex disassembly",
  "GO:0032988": "ribonucleoprotein complex disassembly",
  "GO:0032989": "cellular component morphogenesis",
  "GO:0032990": "cell part morphogenesis",
  "GO:0032991": "macromolecular complex",
  "GO:0032992": "protein-carbohydrate complex",
  "GO:0032993": "protein-DNA complex",
  "GO:0032994": "protein-lipid complex",
  "GO:0032995": "regulation of fungal-type cell wall biogenesis",
  "GO:0032996": "Bcl3-Bcl10 complex",
  "GO:0032997": "Fc receptor complex",
  "GO:0032998": "Fc-epsilon receptor I complex",
  "GO:0032999": "Fc-alpha receptor I complex",
  "GO:0033000": "Fc-gamma receptor I complex",
  "GO:0033001": "Fc-gamma receptor III complex",
  "GO:0033002": "muscle cell proliferation",
  "GO:0033003": "regulation of mast cell activation",
  "GO:0033004": "negative regulation of mast cell activation",
  "GO:0033005": "positive regulation of mast cell activation",
  "GO:0033006": "regulation of mast cell activation involved in immune response",
  "GO:0033007": "negative regulation of mast cell activation involved in immune response",
  "GO:0033008": "positive regulation of mast cell activation involved in immune response",
  "GO:0033009": "nucleomorph",
  "GO:0033010": "paranodal junction",
  "GO:0033011": "perinuclear theca",
  "GO:0033012": "porosome",
  "GO:0033013": "tetrapyrrole metabolic process",
  "GO:0033014": "tetrapyrrole biosynthetic process",
  "GO:0033015": "tetrapyrrole catabolic process",
  "GO:0033016": "rhoptry membrane",
  "GO:0033017": "sarcoplasmic reticulum membrane",
  "GO:0033018": "sarcoplasmic reticulum lumen",
  "GO:0033019": "5-hydroxyvalerate dehydrogenase activity",
  "GO:0033020": "cyclopentanol metabolic process",
  "GO:0033021": "cyclopentanol biosynthetic process",
  "GO:0033022": "cyclopentanol catabolic process",
  "GO:0033023": "mast cell homeostasis",
  "GO:0033024": "mast cell apoptotic process",
  "GO:0033025": "regulation of mast cell apoptotic process",
  "GO:0033026": "negative regulation of mast cell apoptotic process",
  "GO:0033027": "positive regulation of mast cell apoptotic process",
  "GO:0033028": "myeloid cell apoptotic process",
  "GO:0033029": "regulation of neutrophil apoptotic process",
  "GO:0033030": "negative regulation of neutrophil apoptotic process",
  "GO:0033031": "positive regulation of neutrophil apoptotic process",
  "GO:0033032": "regulation of myeloid cell apoptotic process",
  "GO:0033033": "negative regulation of myeloid cell apoptotic process",
  "GO:0033034": "positive regulation of myeloid cell apoptotic process",
  "GO:0033036": "macromolecule localization",
  "GO:0033037": "polysaccharide localization",
  "GO:0033038": "bitter taste receptor activity",
  "GO:0033039": "salty taste receptor activity",
  "GO:0033040": "sour taste receptor activity",
  "GO:0033041": "sweet taste receptor activity",
  "GO:0033042": "umami taste receptor activity",
  "GO:0033043": "regulation of organelle organization",
  "GO:0033044": "regulation of chromosome organization",
  "GO:0033045": "regulation of sister chromatid segregation",
  "GO:0033046": "negative regulation of sister chromatid segregation",
  "GO:0033047": "regulation of mitotic sister chromatid segregation",
  "GO:0033048": "negative regulation of mitotic sister chromatid segregation",
  "GO:0033049": "clavulanic acid metabolic process",
  "GO:0033050": "clavulanic acid biosynthetic process",
  "GO:0033051": "aminophosphonate metabolic process",
  "GO:0033052": "cyanoamino acid metabolic process",
  "GO:0033053": "D-glutamine metabolic process",
  "GO:0033054": "D-glutamate metabolic process",
  "GO:0033055": "D-arginine metabolic process",
  "GO:0033056": "D-ornithine metabolic process",
  "GO:0033058": "directional locomotion",
  "GO:0033059": "cellular pigmentation",
  "GO:0033060": "ocellus pigmentation",
  "GO:0033061": "DNA recombinase mediator complex",
  "GO:0033062": "Rhp55-Rhp57 complex",
  "GO:0033063": "Rad51B-Rad51C-Rad51D-XRCC2 complex",
  "GO:0033064": "XRCC2-RAD51D complex",
  "GO:0033065": "Rad51C-XRCC3 complex",
  "GO:0033066": "Rad51B-Rad51C complex",
  "GO:0033067": "macrolide metabolic process",
  "GO:0033068": "macrolide biosynthetic process",
  "GO:0033069": "ansamycin metabolic process",
  "GO:0033070": "ansamycin biosynthetic process",
  "GO:0033071": "vancomycin metabolic process",
  "GO:0033072": "vancomycin biosynthetic process",
  "GO:0033073": "pinene metabolic process",
  "GO:0033074": "pinene catabolic process",
  "GO:0033075": "isoquinoline alkaloid biosynthetic process",
  "GO:0033076": "isoquinoline alkaloid metabolic process",
  "GO:0033077": "T cell differentiation in thymus",
  "GO:0033078": "extrathymic T cell differentiation",
  "GO:0033079": "immature T cell proliferation",
  "GO:0033080": "immature T cell proliferation in thymus",
  "GO:0033081": "regulation of T cell differentiation in thymus",
  "GO:0033082": "regulation of extrathymic T cell differentiation",
  "GO:0033083": "regulation of immature T cell proliferation",
  "GO:0033084": "regulation of immature T cell proliferation in thymus",
  "GO:0033085": "negative regulation of T cell differentiation in thymus",
  "GO:0033086": "negative regulation of extrathymic T cell differentiation",
  "GO:0033087": "negative regulation of immature T cell proliferation",
  "GO:0033088": "negative regulation of immature T cell proliferation in thymus",
  "GO:0033089": "positive regulation of T cell differentiation in thymus",
  "GO:0033090": "positive regulation of extrathymic T cell differentiation",
  "GO:0033091": "positive regulation of immature T cell proliferation",
  "GO:0033092": "positive regulation of immature T cell proliferation in thymus",
  "GO:0033093": "Weibel-Palade body",
  "GO:0033094": "butane-1,4-diamine:2-oxoglutarate aminotransferase activity",
  "GO:0033095": "aleurone grain",
  "GO:0033096": "amyloplast envelope",
  "GO:0033097": "amyloplast membrane",
  "GO:0033098": "amyloplast inner membrane",
  "GO:0033099": "attachment organelle",
  "GO:0033100": "NuA3 histone acetyltransferase complex",
  "GO:0033101": "cellular bud membrane",
  "GO:0033102": "acidocalcisome membrane",
  "GO:0033103": "protein secretion by the type VI secretion system",
  "GO:0033104": "type VI protein secretion system complex",
  "GO:0033105": "chlorosome envelope",
  "GO:0033106": "cis-Golgi network membrane",
  "GO:0033107": "CVT vesicle",
  "GO:0033108": "mitochondrial respiratory chain complex assembly",
  "GO:0033110": "Cvt vesicle membrane",
  "GO:0033111": "attachment organelle membrane",
  "GO:0033112": "cyanelle envelope",
  "GO:0033113": "cyanelle membrane",
  "GO:0033114": "cyanelle thylakoid lumen",
  "GO:0033115": "cyanelle thylakoid membrane",
  "GO:0033116": "endoplasmic reticulum-Golgi intermediate compartment membrane",
  "GO:0033117": "esterosome",
  "GO:0033118": "esterosome membrane",
  "GO:0033119": "negative regulation of RNA splicing",
  "GO:0033120": "positive regulation of RNA splicing",
  "GO:0033121": "regulation of purine nucleotide catabolic process",
  "GO:0033122": "negative regulation of purine nucleotide catabolic process",
  "GO:0033123": "positive regulation of purine nucleotide catabolic process",
  "GO:0033124": "obsolete regulation of GTP catabolic process",
  "GO:0033125": "obsolete negative regulation of GTP catabolic process",
  "GO:0033126": "obsolete positive regulation of GTP catabolic process",
  "GO:0033127": "regulation of histone phosphorylation",
  "GO:0033128": "negative regulation of histone phosphorylation",
  "GO:0033129": "positive regulation of histone phosphorylation",
  "GO:0033130": "acetylcholine receptor binding",
  "GO:0033131": "regulation of glucokinase activity",
  "GO:0033132": "negative regulation of glucokinase activity",
  "GO:0033133": "positive regulation of glucokinase activity",
  "GO:0033134": "ubiquitin activating enzyme binding",
  "GO:0033135": "regulation of peptidyl-serine phosphorylation",
  "GO:0033136": "serine phosphorylation of STAT3 protein",
  "GO:0033137": "negative regulation of peptidyl-serine phosphorylation",
  "GO:0033138": "positive regulation of peptidyl-serine phosphorylation",
  "GO:0033139": "regulation of peptidyl-serine phosphorylation of STAT protein",
  "GO:0033140": "negative regulation of peptidyl-serine phosphorylation of STAT protein",
  "GO:0033141": "positive regulation of peptidyl-serine phosphorylation of STAT protein",
  "GO:0033142": "progesterone receptor binding",
  "GO:0033143": "regulation of intracellular steroid hormone receptor signaling pathway",
  "GO:0033144": "negative regulation of intracellular steroid hormone receptor signaling pathway",
  "GO:0033145": "positive regulation of intracellular steroid hormone receptor signaling pathway",
  "GO:0033146": "regulation of intracellular estrogen receptor signaling pathway",
  "GO:0033147": "negative regulation of intracellular estrogen receptor signaling pathway",
  "GO:0033148": "positive regulation of intracellular estrogen receptor signaling pathway",
  "GO:0033149": "FFAT motif binding",
  "GO:0033150": "cytoskeletal calyx",
  "GO:0033151": "V(D)J recombination",
  "GO:0033152": "immunoglobulin V(D)J recombination",
  "GO:0033153": "T cell receptor V(D)J recombination",
  "GO:0033154": "oligogalacturonide transporting ATPase activity",
  "GO:0033155": "oligogalacturonide transmembrane transporter activity",
  "GO:0033156": "oligogalacturonide transport",
  "GO:0033157": "regulation of intracellular protein transport",
  "GO:0033158": "regulation of protein import into nucleus, translocation",
  "GO:0033159": "negative regulation of protein import into nucleus, translocation",
  "GO:0033160": "positive regulation of protein import into nucleus, translocation",
  "GO:0033161": "mitogen-activated protein kinase kinase kinase kinase binding",
  "GO:0033162": "melanosome membrane",
  "GO:0033163": "microneme membrane",
  "GO:0033164": "glycolipid 6-alpha-mannosyltransferase activity",
  "GO:0033165": "interphotoreceptor matrix",
  "GO:0033166": "hyaline layer",
  "GO:0033167": "ARC complex",
  "GO:0033168": "conversion of ds siRNA to ss siRNA involved in RNA interference",
  "GO:0033169": "histone H3-K9 demethylation",
  "GO:0033170": "protein-DNA loading ATPase activity",
  "GO:0033171": "obsolete nucleoprotein filament-forming ATPase activity",
  "GO:0033172": "gas vesicle shell",
  "GO:0033173": "calcineurin-NFAT signaling cascade",
  "GO:0033174": "chloroplast proton-transporting ATP synthase complex, catalytic core CF(1)",
  "GO:0033175": "chloroplast proton-transporting ATP synthase complex, coupling factor CF(o)",
  "GO:0033176": "proton-transporting V-type ATPase complex",
  "GO:0033177": "proton-transporting two-sector ATPase complex, proton-transporting domain",
  "GO:0033178": "proton-transporting two-sector ATPase complex, catalytic domain",
  "GO:0033179": "proton-transporting V-type ATPase, V0 domain",
  "GO:0033180": "proton-transporting V-type ATPase, V1 domain",
  "GO:0033181": "plasma membrane proton-transporting V-type ATPase complex",
  "GO:0033182": "regulation of histone ubiquitination",
  "GO:0033183": "negative regulation of histone ubiquitination",
  "GO:0033184": "positive regulation of histone ubiquitination",
  "GO:0033185": "dolichol-phosphate-mannose synthase complex",
  "GO:0033186": "CAF-1 complex",
  "GO:0033187": "obsolete inositol hexakisphosphate 4-kinase or 6-kinase activity",
  "GO:0033188": "sphingomyelin synthase activity",
  "GO:0033189": "response to vitamin A",
  "GO:0033190": "solanapyrone synthase activity",
  "GO:0033191": "macrophomate synthase activity",
  "GO:0033192": "calmodulin-dependent protein phosphatase activity",
  "GO:0033193": "Lsd1/2 complex",
  "GO:0033194": "response to hydroperoxide",
  "GO:0033195": "response to alkyl hydroperoxide",
  "GO:0033196": "tryparedoxin peroxidase activity",
  "GO:0033197": "response to vitamin E",
  "GO:0033198": "response to ATP",
  "GO:0033199": "obsolete inositol heptakisphosphate 4-kinase or 6-kinase activity",
  "GO:0033200": "inositol heptakisphosphate 5-kinase activity",
  "GO:0033201": "alpha-1,4-glucan synthase activity",
  "GO:0033202": "DNA helicase complex",
  "GO:0033203": "DNA helicase A complex",
  "GO:0033204": "ribonuclease P RNA binding",
  "GO:0033206": "meiotic cytokinesis",
  "GO:0033207": "beta-1,4-N-acetylgalactosaminyltransferase activity",
  "GO:0033208": "UDP-N-acetylgalactosamine:N-acetylneuraminyl-alpha-2,3-galactosyl-beta-R 1,4-N-acetylgalactosaminyltransferase activity",
  "GO:0033209": "tumor necrosis factor-mediated signaling pathway",
  "GO:0033210": "leptin-mediated signaling pathway",
  "GO:0033211": "adiponectin-activated signaling pathway",
  "GO:0033212": "iron assimilation",
  "GO:0033213": "iron assimilation by capture and transport",
  "GO:0033214": "iron assimilation by chelation and transport",
  "GO:0033215": "iron assimilation by reduction and transport",
  "GO:0033216": "ferric iron import",
  "GO:0033217": "regulation of transcription from RNA polymerase II promoter in response to iron ion starvation",
  "GO:0033218": "amide binding",
  "GO:0033219": "urea binding",
  "GO:0033220": "amide-transporting ATPase activity",
  "GO:0033221": "urea-transporting ATPase activity",
  "GO:0033222": "xylose binding",
  "GO:0033223": "2-aminoethylphosphonate transport",
  "GO:0033224": "2-aminoethylphosphonate transmembrane transporter activity",
  "GO:0033225": "2-aminoethylphosphonate transporting ATPase activity",
  "GO:0033226": "2-aminoethylphosphonate binding",
  "GO:0033227": "dsRNA transport",
  "GO:0033228": "cysteine export",
  "GO:0033229": "cysteine transmembrane transporter activity",
  "GO:0033230": "cysteine-transporting ATPase activity",
  "GO:0033231": "carbohydrate export",
  "GO:0033232": "D-methionine-transporting ATPase activity",
  "GO:0033233": "regulation of protein sumoylation",
  "GO:0033234": "negative regulation of protein sumoylation",
  "GO:0033235": "positive regulation of protein sumoylation",
  "GO:0033236": "obsolete 11-beta-hydroxysteroid dehydrogenase (NAD+) activity",
  "GO:0033237": "obsolete 11-beta-hydroxysteroid dehydrogenase (NADP+) activity",
  "GO:0033238": "regulation of cellular amine metabolic process",
  "GO:0033239": "negative regulation of cellular amine metabolic process",
  "GO:0033240": "positive regulation of cellular amine metabolic process",
  "GO:0033241": "regulation of cellular amine catabolic process",
  "GO:0033242": "negative regulation of cellular amine catabolic process",
  "GO:0033243": "positive regulation of cellular amine catabolic process",
  "GO:0033244": "regulation of penicillin metabolic process",
  "GO:0033245": "negative regulation of penicillin metabolic process",
  "GO:0033246": "positive regulation of penicillin metabolic process",
  "GO:0033247": "regulation of penicillin catabolic process",
  "GO:0033248": "negative regulation of penicillin catabolic process",
  "GO:0033249": "positive regulation of penicillin catabolic process",
  "GO:0033250": "penicillinase activity",
  "GO:0033251": "cephalosporinase activity",
  "GO:0033252": "regulation of beta-lactamase activity",
  "GO:0033253": "regulation of penicillinase activity",
  "GO:0033254": "vacuolar transporter chaperone complex",
  "GO:0033255": "SAS acetyltransferase complex",
  "GO:0033256": "I-kappaB/NF-kappaB complex",
  "GO:0033257": "Bcl3/NF-kappaB2 complex",
  "GO:0033258": "plastid DNA metabolic process",
  "GO:0033259": "plastid DNA replication",
  "GO:0033260": "nuclear DNA replication",
  "GO:0033261": "obsolete regulation of S phase",
  "GO:0033262": "regulation of nuclear cell cycle DNA replication",
  "GO:0033263": "CORVET complex",
  "GO:0033264": "obsolete bontoxilysin activity",
  "GO:0033265": "choline binding",
  "GO:0033266": "choline-transporting ATPase activity",
  "GO:0033267": "axon part",
  "GO:0033268": "node of Ranvier",
  "GO:0033269": "internode region of axon",
  "GO:0033270": "paranode region of axon",
  "GO:0033271": "myo-inositol phosphate transport",
  "GO:0033272": "myo-inositol hexakisphosphate transport",
  "GO:0033273": "response to vitamin",
  "GO:0033274": "response to vitamin B2",
  "GO:0033275": "actin-myosin filament sliding",
  "GO:0033276": "transcription factor TFTC complex",
  "GO:0033277": "abortive mitotic cell cycle",
  "GO:0033278": "cell proliferation in midbrain",
  "GO:0033280": "response to vitamin D",
  "GO:0033281": "TAT protein transport complex",
  "GO:0033282": "protein C inhibitor-acrosin complex",
  "GO:0033283": "organic acid-transporting ATPase activity",
  "GO:0033284": "carboxylic acid-transporting ATPase activity",
  "GO:0033285": "monocarboxylic acid-transporting ATPase activity",
  "GO:0033286": "ectoine-transporting ATPase activity",
  "GO:0033287": "hydroxyectoine transmembrane transporter activity",
  "GO:0033288": "hydroxyectoine-transporting ATPase activity",
  "GO:0033289": "intraconoid microtubule",
  "GO:0033290": "eukaryotic 48S preinitiation complex",
  "GO:0033291": "eukaryotic 80S initiation complex",
  "GO:0033292": "T-tubule organization",
  "GO:0033293": "monocarboxylic acid binding",
  "GO:0033294": "ectoine binding",
  "GO:0033295": "hydroxyectoine binding",
  "GO:0033296": "rhamnose binding",
  "GO:0033297": "rhamnose-transporting ATPase activity",
  "GO:0033298": "contractile vacuole organization",
  "GO:0033299": "secretion of lysosomal enzymes",
  "GO:0033300": "dehydroascorbic acid transporter activity",
  "GO:0033301": "cell cycle comprising mitosis without cytokinesis",
  "GO:0033302": "quercetin O-glucoside metabolic process",
  "GO:0033303": "quercetin O-glucoside biosynthetic process",
  "GO:0033304": "chlorophyll a metabolic process",
  "GO:0033305": "chlorophyll a biosynthetic process",
  "GO:0033306": "phytol metabolic process",
  "GO:0033307": "phytol salvage",
  "GO:0033308": "hydroxyectoine transport",
  "GO:0033309": "SBF transcription complex",
  "GO:0033310": "chlorophyll a catabolic process",
  "GO:0033311": "chlorophyll a biosynthetic process via phytyl diphosphate",
  "GO:0033312": "chlorophyll a biosynthetic process via geranylgeranyl-chlorophyll a",
  "GO:0033313": "meiotic cell cycle checkpoint",
  "GO:0033314": "mitotic DNA replication checkpoint",
  "GO:0033315": "meiotic DNA replication checkpoint",
  "GO:0033316": "meiotic spindle assembly checkpoint",
  "GO:0033317": "pantothenate biosynthetic process from valine",
  "GO:0033318": "pantothenate biosynthetic process from 2-dehydropantolactone",
  "GO:0033319": "UDP-D-xylose metabolic process",
  "GO:0033320": "UDP-D-xylose biosynthetic process",
  "GO:0033321": "homomethionine metabolic process",
  "GO:0033322": "homomethionine biosynthetic process",
  "GO:0033323": "choline biosynthetic process via CDP-choline",
  "GO:0033324": "choline biosynthetic process via N-monomethylethanolamine",
  "GO:0033325": "choline biosynthetic process via phosphoryl-ethanolamine",
  "GO:0033326": "cerebrospinal fluid secretion",
  "GO:0033327": "Leydig cell differentiation",
  "GO:0033328": "peroxisome membrane targeting sequence binding",
  "GO:0033329": "kaempferol O-glucoside metabolic process",
  "GO:0033330": "kaempferol O-glucoside biosynthetic process",
  "GO:0033331": "ent-kaurene metabolic process",
  "GO:0033332": "ent-kaurene biosynthetic process",
  "GO:0033333": "fin development",
  "GO:0033334": "fin morphogenesis",
  "GO:0033335": "anal fin development",
  "GO:0033336": "caudal fin development",
  "GO:0033337": "dorsal fin development",
  "GO:0033338": "medial fin development",
  "GO:0033339": "pectoral fin development",
  "GO:0033340": "pelvic fin development",
  "GO:0033341": "regulation of collagen binding",
  "GO:0033342": "negative regulation of collagen binding",
  "GO:0033343": "positive regulation of collagen binding",
  "GO:0033344": "cholesterol efflux",
  "GO:0033345": "asparagine catabolic process via L-aspartate",
  "GO:0033346": "asparagine catabolic process via 2-oxosuccinamate",
  "GO:0033347": "tetrose metabolic process",
  "GO:0033348": "tetrose biosynthetic process",
  "GO:0033349": "apiose metabolic process",
  "GO:0033350": "apiose biosynthetic process",
  "GO:0033351": "UDP-D-apiose metabolic process",
  "GO:0033352": "UDP-D-apiose biosynthetic process",
  "GO:0033353": "S-adenosylmethionine cycle",
  "GO:0033354": "chlorophyll cycle",
  "GO:0033355": "ascorbate glutathione cycle",
  "GO:0033356": "UDP-L-arabinose metabolic process",
  "GO:0033357": "L-arabinose biosynthetic process",
  "GO:0033358": "UDP-L-arabinose biosynthetic process",
  "GO:0033359": "lysine biosynthetic process via diaminopimelate and N-succinyl-2-amino-6-ketopimelate",
  "GO:0033360": "lysine biosynthetic process via diaminopimelate and L-2-acetamido-6-oxoheptanedioate",
  "GO:0033361": "lysine biosynthetic process via diaminopimelate, dehydrogenase pathway",
  "GO:0033362": "lysine biosynthetic process via diaminopimelate, diaminopimelate-aminotransferase pathway",
  "GO:0033363": "secretory granule organization",
  "GO:0033364": "mast cell secretory granule organization",
  "GO:0033365": "protein localization to organelle",
  "GO:0033366": "protein localization to secretory granule",
  "GO:0033367": "protein localization to mast cell secretory granule",
  "GO:0033368": "protease localization to mast cell secretory granule",
  "GO:0033369": "establishment of protein localization to mast cell secretory granule",
  "GO:0033370": "maintenance of protein location in mast cell secretory granule",
  "GO:0033371": "T cell secretory granule organization",
  "GO:0033372": "establishment of protease localization to mast cell secretory granule",
  "GO:0033373": "maintenance of protease location in mast cell secretory granule",
  "GO:0033374": "protein localization to T cell secretory granule",
  "GO:0033375": "protease localization to T cell secretory granule",
  "GO:0033376": "establishment of protein localization to T cell secretory granule",
  "GO:0033377": "maintenance of protein location in T cell secretory granule",
  "GO:0033378": "establishment of protease localization to T cell secretory granule",
  "GO:0033379": "maintenance of protease location in T cell secretory granule",
  "GO:0033380": "granzyme B localization to T cell secretory granule",
  "GO:0033381": "establishment of granzyme B localization to T cell secretory granule",
  "GO:0033382": "maintenance of granzyme B location in T cell secretory granule",
  "GO:0033383": "geranyl diphosphate metabolic process",
  "GO:0033384": "geranyl diphosphate biosynthetic process",
  "GO:0033385": "geranylgeranyl diphosphate metabolic process",
  "GO:0033386": "geranylgeranyl diphosphate biosynthetic process",
  "GO:0033387": "putrescine biosynthetic process from ornithine",
  "GO:0033388": "putrescine biosynthetic process from arginine",
  "GO:0033389": "putrescine biosynthetic process from arginine, using agmatinase",
  "GO:0033390": "putrescine biosynthetic process from arginine via N-carbamoylputrescine",
  "GO:0033391": "chromatoid body",
  "GO:0033392": "obsolete actin homodimerization activity",
  "GO:0033393": "homogalacturonan catabolic process",
  "GO:0033394": "beta-alanine biosynthetic process via 1,3 diaminopropane",
  "GO:0033395": "beta-alanine biosynthetic process via 3-hydroxypropionate",
  "GO:0033396": "beta-alanine biosynthetic process via 3-ureidopropionate",
  "GO:0033397": "zeatin metabolic process",
  "GO:0033398": "zeatin biosynthetic process",
  "GO:0033399": "cis-zeatin metabolic process",
  "GO:0033400": "trans-zeatin metabolic process",
  "GO:0033401": "UUU codon-amino acid adaptor activity",
  "GO:0033402": "UUC codon-amino acid adaptor activity",
  "GO:0033403": "UUA codon-amino acid adaptor activity",
  "GO:0033404": "UUG codon-amino acid adaptor activity",
  "GO:0033405": "UCU codon-amino acid adaptor activity",
  "GO:0033406": "UCC codon-amino acid adaptor activity",
  "GO:0033407": "UCA codon-amino acid adaptor activity",
  "GO:0033408": "UCG codon-amino acid adaptor activity",
  "GO:0033409": "UAU codon-amino acid adaptor activity",
  "GO:0033410": "UAC codon-amino acid adaptor activity",
  "GO:0033411": "UAA codon-amino acid adaptor activity",
  "GO:0033412": "UAG codon-amino acid adaptor activity",
  "GO:0033413": "UGU codon-amino acid adaptor activity",
  "GO:0033414": "UGC codon-amino acid adaptor activity",
  "GO:0033415": "UGA codon-amino acid adaptor activity",
  "GO:0033416": "UGG codon-amino acid adaptor activity",
  "GO:0033417": "CUU codon-amino acid adaptor activity",
  "GO:0033418": "CUC codon-amino acid adaptor activity",
  "GO:0033419": "CUA codon-amino acid adaptor activity",
  "GO:0033420": "CUG codon-amino acid adaptor activity",
  "GO:0033421": "CCU codon-amino acid adaptor activity",
  "GO:0033422": "CCC codon-amino acid adaptor activity",
  "GO:0033423": "CCA codon-amino acid adaptor activity",
  "GO:0033424": "CCG codon-amino acid adaptor activity",
  "GO:0033425": "CAU codon-amino acid adaptor activity",
  "GO:0033426": "CAC codon-amino acid adaptor activity",
  "GO:0033427": "CAA codon-amino acid adaptor activity",
  "GO:0033428": "CAG codon-amino acid adaptor activity",
  "GO:0033429": "CGU codon-amino acid adaptor activity",
  "GO:0033430": "CGC codon-amino acid adaptor activity",
  "GO:0033431": "CGA codon-amino acid adaptor activity",
  "GO:0033432": "CGG codon-amino acid adaptor activity",
  "GO:0033433": "AUU codon-amino acid adaptor activity",
  "GO:0033434": "AUC codon-amino acid adaptor activity",
  "GO:0033435": "AUA codon-amino acid adaptor activity",
  "GO:0033436": "AUG codon-amino acid adaptor activity",
  "GO:0033437": "ACU codon-amino acid adaptor activity",
  "GO:0033438": "ACC codon-amino acid adaptor activity",
  "GO:0033439": "ACA codon-amino acid adaptor activity",
  "GO:0033440": "ACG codon-amino acid adaptor activity",
  "GO:0033441": "AAU codon-amino acid adaptor activity",
  "GO:0033442": "AAC codon-amino acid adaptor activity",
  "GO:0033443": "AAA codon-amino acid adaptor activity",
  "GO:0033444": "AAG codon-amino acid adaptor activity",
  "GO:0033445": "AGU codon-amino acid adaptor activity",
  "GO:0033446": "AGC codon-amino acid adaptor activity",
  "GO:0033447": "AGA codon-amino acid adaptor activity",
  "GO:0033448": "AGG codon-amino acid adaptor activity",
  "GO:0033449": "GUU codon-amino acid adaptor activity",
  "GO:0033450": "GUC codon-amino acid adaptor activity",
  "GO:0033451": "GUA codon-amino acid adaptor activity",
  "GO:0033452": "GUG codon-amino acid adaptor activity",
  "GO:0033453": "GCU codon-amino acid adaptor activity",
  "GO:0033454": "GCC codon-amino acid adaptor activity",
  "GO:0033455": "GCA codon-amino acid adaptor activity",
  "GO:0033456": "GCG codon-amino acid adaptor activity",
  "GO:0033457": "GAU codon-amino acid adaptor activity",
  "GO:0033458": "GAC codon-amino acid adaptor activity",
  "GO:0033459": "GAA codon-amino acid adaptor activity",
  "GO:0033460": "GAG codon-amino acid adaptor activity",
  "GO:0033461": "GGU codon-amino acid adaptor activity",
  "GO:0033462": "GGC codon-amino acid adaptor activity",
  "GO:0033463": "GGA codon-amino acid adaptor activity",
  "GO:0033464": "GGG codon-amino acid adaptor activity",
  "GO:0033465": "cis-zeatin biosynthetic process",
  "GO:0033466": "trans-zeatin biosynthetic process",
  "GO:0033467": "CMP-keto-3-deoxy-D-manno-octulosonic acid metabolic process",
  "GO:0033468": "CMP-keto-3-deoxy-D-manno-octulosonic acid biosynthetic process",
  "GO:0033469": "gibberellin 12 metabolic process",
  "GO:0033470": "gibberellin 12 biosynthetic process",
  "GO:0033471": "GDP-L-galactose metabolic process",
  "GO:0033472": "GDP-L-galactose biosynthetic process",
  "GO:0033473": "indoleacetic acid conjugate metabolic process",
  "GO:0033474": "indoleacetic acid conjugate biosynthetic process",
  "GO:0033475": "indoleacetic acid amide conjugate biosynthetic process",
  "GO:0033476": "indoleacetic acid ester conjugate biosynthetic process",
  "GO:0033477": "S-methylmethionine metabolic process",
  "GO:0033478": "UDP-rhamnose metabolic process",
  "GO:0033479": "UDP-D-galacturonate metabolic process",
  "GO:0033480": "UDP-D-galacturonate biosynthetic process",
  "GO:0033481": "galacturonate biosynthetic process",
  "GO:0033482": "D-galacturonate biosynthetic process",
  "GO:0033483": "gas homeostasis",
  "GO:0033484": "nitric oxide homeostasis",
  "GO:0033485": "cyanidin 3-O-glucoside biosynthetic process",
  "GO:0033486": "delphinidin 3-O-glucoside biosynthetic process",
  "GO:0033487": "pelargonidin 3-O-glucoside biosynthetic process",
  "GO:0033488": "cholesterol biosynthetic process via 24,25-dihydrolanosterol",
  "GO:0033489": "cholesterol biosynthetic process via desmosterol",
  "GO:0033490": "cholesterol biosynthetic process via lathosterol",
  "GO:0033491": "coniferin metabolic process",
  "GO:0033492": "esculetin metabolic process",
  "GO:0033493": "esculetin biosynthetic process",
  "GO:0033494": "ferulate metabolic process",
  "GO:0033495": "ferulate biosynthetic process",
  "GO:0033496": "sinapate metabolic process",
  "GO:0033497": "sinapate biosynthetic process",
  "GO:0033498": "galactose catabolic process via D-galactonate",
  "GO:0033499": "galactose catabolic process via UDP-galactose",
  "GO:0033500": "carbohydrate homeostasis",
  "GO:0033501": "galactose homeostasis",
  "GO:0033502": "cellular galactose homeostasis",
  "GO:0033503": "HULC complex",
  "GO:0033504": "floor plate development",
  "GO:0033505": "floor plate morphogenesis",
  "GO:0033506": "glucosinolate biosynthetic process from homomethionine",
  "GO:0033507": "glucosinolate biosynthetic process from phenylalanine",
  "GO:0033508": "glutamate catabolic process to butyrate",
  "GO:0033509": "glutamate catabolic process to propionate",
  "GO:0033510": "luteolin metabolic process",
  "GO:0033511": "luteolin biosynthetic process",
  "GO:0033512": "L-lysine catabolic process to acetyl-CoA via saccharopine",
  "GO:0033513": "L-lysine catabolic process to acetyl-CoA via 5-aminopentanamide",
  "GO:0033514": "L-lysine catabolic process to acetyl-CoA via L-pipecolate",
  "GO:0033515": "L-lysine catabolic process using lysine 6-aminotransferase",
  "GO:0033516": "L-methionine biosynthetic process from homoserine via O-phospho-L-homoserine and cystathionine",
  "GO:0033517": "myo-inositol hexakisphosphate metabolic process",
  "GO:0033518": "myo-inositol hexakisphosphate dephosphorylation",
  "GO:0033519": "phytyl diphosphate metabolic process",
  "GO:0033520": "phytol biosynthetic process",
  "GO:0033521": "phytyl diphosphate biosynthetic process",
  "GO:0033522": "histone H2A ubiquitination",
  "GO:0033523": "histone H2B ubiquitination",
  "GO:0033524": "sinapate ester metabolic process",
  "GO:0033525": "sinapate ester biosynthetic process",
  "GO:0033526": "tetrapyrrole biosynthetic process from glutamate",
  "GO:0033527": "tetrapyrrole biosynthetic process from glycine and succinyl-CoA",
  "GO:0033528": "S-methylmethionine cycle",
  "GO:0033529": "raffinose biosynthetic process",
  "GO:0033530": "raffinose metabolic process",
  "GO:0033531": "stachyose metabolic process",
  "GO:0033532": "stachyose biosynthetic process",
  "GO:0033533": "verbascose metabolic process",
  "GO:0033534": "verbascose biosynthetic process",
  "GO:0033535": "ajugose metabolic process",
  "GO:0033536": "ajugose biosynthetic process",
  "GO:0033537": "ajugose biosynthetic process using galactinol:raffinose galactosyltransferase",
  "GO:0033538": "ajugose biosynthetic process using galactan:galactan galactosyltransferase",
  "GO:0033539": "fatty acid beta-oxidation using acyl-CoA dehydrogenase",
  "GO:0033540": "fatty acid beta-oxidation using acyl-CoA oxidase",
  "GO:0033541": "fatty acid beta-oxidation, unsaturated, odd number",
  "GO:0033542": "fatty acid beta-oxidation, unsaturated, even number",
  "GO:0033543": "fatty acid beta-oxidation, unsaturated, even number, reductase/isomerase pathway",
  "GO:0033544": "fatty acid beta-oxidation, unsaturated, even number, epimerase pathway",
  "GO:0033545": "myo-inositol hexakisphosphate biosynthetic process, lipid-dependent",
  "GO:0033546": "myo-inositol hexakisphosphate biosynthetic process, via inositol 1,3,4-trisphosphate",
  "GO:0033547": "obsolete myo-inositol hexakisphosphate biosynthetic process, via direct phosphorylation of inositol 1,4,5-trisphosphate",
  "GO:0033548": "myo-inositol hexakisphosphate biosynthetic process, lipid-independent",
  "GO:0033549": "MAP kinase phosphatase activity",
  "GO:0033550": "MAP kinase tyrosine phosphatase activity",
  "GO:0033551": "monopolin complex",
  "GO:0033552": "response to vitamin B3",
  "GO:0033553": "rDNA heterochromatin",
  "GO:0033554": "cellular response to stress",
  "GO:0033555": "multicellular organismal response to stress",
  "GO:0033556": "dolichyl pyrophosphate Man7GlcNAc2 alpha-1,3-glucosyltransferase activity",
  "GO:0033557": "Slx1-Slx4 complex",
  "GO:0033558": "protein deacetylase activity",
  "GO:0033559": "unsaturated fatty acid metabolic process",
  "GO:0033560": "folate reductase activity",
  "GO:0033561": "regulation of water loss via skin",
  "GO:0033562": "co-transcriptional gene silencing by RNA interference machinery",
  "GO:0033563": "dorsal/ventral axon guidance",
  "GO:0033564": "anterior/posterior axon guidance",
  "GO:0033565": "ESCRT-0 complex",
  "GO:0033566": "gamma-tubulin complex localization",
  "GO:0033567": "DNA replication, Okazaki fragment processing",
  "GO:0033568": "lactoferrin receptor activity",
  "GO:0033569": "lactoferrin transmembrane transporter activity",
  "GO:0033570": "transferrin transmembrane transporter activity",
  "GO:0033571": "lactoferrin transport",
  "GO:0033572": "transferrin transport",
  "GO:0033573": "high-affinity iron permease complex",
  "GO:0033574": "response to testosterone",
  "GO:0033575": "protein glycosylation at cell surface",
  "GO:0033576": "protein glycosylation in cytosol",
  "GO:0033577": "protein glycosylation in endoplasmic reticulum",
  "GO:0033578": "protein glycosylation in Golgi",
  "GO:0033579": "protein galactosylation in endoplasmic reticulum",
  "GO:0033580": "protein galactosylation at cell surface",
  "GO:0033581": "protein galactosylation in Golgi",
  "GO:0033582": "protein galactosylation in cytosol",
  "GO:0033583": "rhabdomere membrane",
  "GO:0033584": "tyrosine biosynthetic process from chorismate via L-arogenate",
  "GO:0033585": "L-phenylalanine biosynthetic process from chorismate via phenylpyruvate",
  "GO:0033586": "L-phenylalanine biosynthetic process from chorismate via L-arogenate",
  "GO:0033587": "shikimate biosynthetic process",
  "GO:0033588": "Elongator holoenzyme complex",
  "GO:0033590": "response to cobalamin",
  "GO:0033591": "response to L-ascorbic acid",
  "GO:0033592": "RNA strand annealing activity",
  "GO:0033593": "BRCA2-MAGE-D1 complex",
  "GO:0033594": "response to hydroxyisoflavone",
  "GO:0033595": "response to genistein",
  "GO:0033596": "TSC1-TSC2 complex",
  "GO:0033597": "mitotic checkpoint complex",
  "GO:0033598": "mammary gland epithelial cell proliferation",
  "GO:0033599": "regulation of mammary gland epithelial cell proliferation",
  "GO:0033600": "negative regulation of mammary gland epithelial cell proliferation",
  "GO:0033601": "positive regulation of mammary gland epithelial cell proliferation",
  "GO:0033602": "negative regulation of dopamine secretion",
  "GO:0033603": "positive regulation of dopamine secretion",
  "GO:0033604": "negative regulation of catecholamine secretion",
  "GO:0033605": "positive regulation of catecholamine secretion",
  "GO:0033606": "chemokine receptor transport within lipid bilayer",
  "GO:0033607": "SOD1-Bcl-2 complex",
  "GO:0033608": "formyl-CoA transferase activity",
  "GO:0033609": "oxalate metabolic process",
  "GO:0033610": "oxalate biosynthetic process",
  "GO:0033611": "oxalate catabolic process",
  "GO:0033612": "receptor serine/threonine kinase binding",
  "GO:0033613": "activating transcription factor binding",
  "GO:0033614": "chloroplast proton-transporting ATP synthase complex assembly",
  "GO:0033615": "mitochondrial proton-transporting ATP synthase complex assembly",
  "GO:0033616": "plasma membrane proton-transporting ATP synthase complex assembly",
  "GO:0033617": "mitochondrial respiratory chain complex IV assembly",
  "GO:0033618": "plasma membrane respiratory chain complex IV assembly",
  "GO:0033619": "membrane protein proteolysis",
  "GO:0033620": "Mei2 nuclear dot complex",
  "GO:0033621": "nuclear-transcribed mRNA catabolic process, meiosis-specific transcripts",
  "GO:0033622": "integrin activation",
  "GO:0033623": "regulation of integrin activation",
  "GO:0033624": "negative regulation of integrin activation",
  "GO:0033625": "positive regulation of integrin activation",
  "GO:0033626": "positive regulation of integrin activation by cell surface receptor linked signal transduction",
  "GO:0033627": "cell adhesion mediated by integrin",
  "GO:0033628": "regulation of cell adhesion mediated by integrin",
  "GO:0033629": "negative regulation of cell adhesion mediated by integrin",
  "GO:0033630": "positive regulation of cell adhesion mediated by integrin",
  "GO:0033631": "cell-cell adhesion mediated by integrin",
  "GO:0033632": "regulation of cell-cell adhesion mediated by integrin",
  "GO:0033633": "negative regulation of cell-cell adhesion mediated by integrin",
  "GO:0033634": "positive regulation of cell-cell adhesion mediated by integrin",
  "GO:0033635": "modulation by symbiont of host response to abiotic stimulus",
  "GO:0033636": "modulation by symbiont of host response to temperature stimulus",
  "GO:0033637": "modulation by symbiont of host response to cold",
  "GO:0033638": "modulation by symbiont of host response to heat",
  "GO:0033639": "modulation by symbiont of host response to water",
  "GO:0033640": "modulation by symbiont of host response to osmotic stress",
  "GO:0033641": "modulation by symbiont of host response to pH",
  "GO:0033642": "modulation by symbiont of host response to gravitational stimulus",
  "GO:0033643": "host cell part",
  "GO:0033644": "host cell membrane",
  "GO:0033645": "host cell endomembrane system",
  "GO:0033646": "host intracellular part",
  "GO:0033647": "host intracellular organelle",
  "GO:0033648": "host intracellular membrane-bounded organelle",
  "GO:0033650": "host cell mitochondrion",
  "GO:0033651": "host cell plastid",
  "GO:0033652": "host cell chloroplast",
  "GO:0033653": "host cell chloroplast part",
  "GO:0033654": "host cell chloroplast thylakoid membrane",
  "GO:0033655": "host cell cytoplasm part",
  "GO:0033656": "modification by symbiont of host chloroplast",
  "GO:0033657": "modification by symbiont of host chloroplast part",
  "GO:0033658": "modification by symbiont of host chloroplast thylakoid",
  "GO:0033659": "modification by symbiont of host mitochondrion",
  "GO:0033660": "negative regulation by symbiont of host resistance gene-dependent defense response",
  "GO:0033661": "negative regulation by symbiont of defense-related host reactive oxygen species production",
  "GO:0033662": "modulation by symbiont of host defense-related protein level",
  "GO:0033663": "negative regulation by symbiont of host defense-related protein level",
  "GO:0033664": "positive regulation by symbiont of host defense-related protein level",
  "GO:0033665": "obsolete regulation of growth or development of symbiont in host",
  "GO:0033666": "obsolete positive regulation of growth or development of symbiont in host",
  "GO:0033667": "obsolete negative regulation of growth or development of symbiont in host",
  "GO:0033668": "negative regulation by symbiont of host apoptotic process",
  "GO:0033670": "regulation of NAD+ kinase activity",
  "GO:0033671": "negative regulation of NAD+ kinase activity",
  "GO:0033672": "positive regulation of NAD+ kinase activity",
  "GO:0033673": "negative regulation of kinase activity",
  "GO:0033674": "positive regulation of kinase activity",
  "GO:0033675": "pericanalicular vesicle",
  "GO:0033676": "double-stranded DNA-dependent ATPase activity",
  "GO:0033677": "DNA/RNA helicase activity",
  "GO:0033678": "5'-3' DNA/RNA helicase activity",
  "GO:0033679": "3'-5' DNA/RNA helicase activity",
  "GO:0033680": "ATP-dependent DNA/RNA helicase activity",
  "GO:0033681": "ATP-dependent 3'-5' DNA/RNA helicase activity",
  "GO:0033682": "ATP-dependent 5'-3' DNA/RNA helicase activity",
  "GO:0033683": "nucleotide-excision repair, DNA incision",
  "GO:0033684": "regulation of luteinizing hormone secretion",
  "GO:0033685": "negative regulation of luteinizing hormone secretion",
  "GO:0033686": "positive regulation of luteinizing hormone secretion",
  "GO:0033687": "osteoblast proliferation",
  "GO:0033688": "regulation of osteoblast proliferation",
  "GO:0033689": "negative regulation of osteoblast proliferation",
  "GO:0033690": "positive regulation of osteoblast proliferation",
  "GO:0033691": "sialic acid binding",
  "GO:0033692": "cellular polysaccharide biosynthetic process",
  "GO:0033693": "neurofilament bundle assembly",
  "GO:0033694": "oxidoreductase activity, acting on the CH-NH group of donors, iron-sulfur protein as acceptor",
  "GO:0033695": "oxidoreductase activity, acting on CH or CH2 groups, quinone or similar compound as acceptor",
  "GO:0033696": "negative regulation of extent of heterochromatin assembly",
  "GO:0033697": "positive regulation of extent of heterochromatin assembly",
  "GO:0033698": "Rpd3L complex",
  "GO:0033699": "DNA 5'-adenosine monophosphate hydrolase activity",
  "GO:0033700": "phospholipid efflux",
  "GO:0033701": "dTDP-galactose 6-dehydrogenase activity",
  "GO:0033702": "(+)-trans-carveol dehydrogenase activity",
  "GO:0033703": "3beta-hydroxy-5beta-steroid dehydrogenase activity",
  "GO:0033704": "3beta-hydroxy-5alpha-steroid dehydrogenase activity",
  "GO:0033705": "GDP-4-dehydro-6-deoxy-D-mannose reductase activity",
  "GO:0033706": "obsolete quinate/shikimate dehydrogenase activity",
  "GO:0033707": "3''-deamino-3''-oxonicotianamine reductase activity",
  "GO:0033708": "isocitrate-homoisocitrate dehydrogenase activity",
  "GO:0033709": "D-arabinitol dehydrogenase, D-ribulose forming (NADP+) activity",
  "GO:0033711": "4-phosphoerythronate dehydrogenase activity",
  "GO:0033712": "1,5-anhydro-D-fructose reductase (1,5-anhydro-D-mannitol-forming) activity",
  "GO:0033713": "choline:oxygen 1-oxidoreductase activity",
  "GO:0033714": "secondary-alcohol oxidase activity",
  "GO:0033715": "nucleoside oxidase activity",
  "GO:0033716": "nucleoside oxidase (hydrogen peroxide-forming) activity",
  "GO:0033717": "gluconate 2-dehydrogenase (acceptor) activity",
  "GO:0033718": "pyranose dehydrogenase (acceptor) activity",
  "GO:0033719": "2-oxo-acid reductase activity",
  "GO:0033720": "(S)-mandelate dehydrogenase activity",
  "GO:0033721": "aldehyde dehydrogenase (NADP+) activity",
  "GO:0033722": "malonate-semialdehyde dehydrogenase activity",
  "GO:0033723": "fluoroacetaldehyde dehydrogenase activity",
  "GO:0033726": "aldehyde ferredoxin oxidoreductase activity",
  "GO:0033727": "aldehyde dehydrogenase (FAD-independent) activity",
  "GO:0033728": "divinyl chlorophyllide a 8-vinyl-reductase activity",
  "GO:0033729": "anthocyanidin reductase activity",
  "GO:0033730": "arogenate dehydrogenase (NADP+) activity",
  "GO:0033731": "arogenate dehydrogenase [NAD(P)+] activity",
  "GO:0033732": "pyrroloquinoline-quinone synthase activity",
  "GO:0033734": "(R)-benzylsuccinyl-CoA dehydrogenase activity",
  "GO:0033735": "aspartate dehydrogenase activity",
  "GO:0033736": "L-lysine 6-oxidase activity",
  "GO:0033737": "1-pyrroline dehydrogenase activity",
  "GO:0033738": "methylenetetrahydrofolate reductase (ferredoxin) activity",
  "GO:0033739": "preQ1 synthase activity",
  "GO:0033740": "hydroxylamine oxidoreductase activity",
  "GO:0033741": "adenylyl-sulfate reductase (glutathione) activity",
  "GO:0033743": "peptide-methionine (R)-S-oxide reductase activity",
  "GO:0033744": "L-methionine:thioredoxin-disulfide S-oxidoreductase activity",
  "GO:0033745": "L-methionine-(R)-S-oxide reductase activity",
  "GO:0033746": "histone demethylase activity (H3-R2 specific)",
  "GO:0033747": "obsolete versatile peroxidase activity",
  "GO:0033748": "hydrogenase (acceptor) activity",
  "GO:0033749": "histone demethylase activity (H4-R3 specific)",
  "GO:0033750": "ribosome localization",
  "GO:0033751": "linoleate diol synthase activity",
  "GO:0033752": "acetylacetone-cleaving enzyme activity",
  "GO:0033753": "establishment of ribosome localization",
  "GO:0033754": "indoleamine 2,3-dioxygenase activity",
  "GO:0033755": "sulfur oxygenase/reductase activity",
  "GO:0033756": "Oplophorus-luciferin 2-monooxygenase activity",
  "GO:0033757": "glucoside 3-dehydrogenase activity",
  "GO:0033758": "clavaminate synthase activity",
  "GO:0033759": "flavone synthase activity",
  "GO:0033760": "2'-deoxymugineic-acid 2'-dioxygenase activity",
  "GO:0033761": "mugineic-acid 3-dioxygenase activity",
  "GO:0033762": "response to glucagon",
  "GO:0033763": "proline 3-hydroxylase activity",
  "GO:0033764": "steroid dehydrogenase activity, acting on the CH-OH group of donors, NAD or NADP as acceptor",
  "GO:0033765": "steroid dehydrogenase activity, acting on the CH-CH group of donors",
  "GO:0033766": "2-hydroxyquinoline 8-monooxygenase activity",
  "GO:0033767": "4-hydroxyacetophenone monooxygenase activity",
  "GO:0033768": "SUMO-targeted ubiquitin ligase complex",
  "GO:0033769": "glyceollin synthase activity",
  "GO:0033770": "2-hydroxyisoflavanone synthase activity",
  "GO:0033771": "licodione synthase activity",
  "GO:0033772": "flavonoid 3',5'-hydroxylase activity",
  "GO:0033773": "isoflavone 2'-hydroxylase activity",
  "GO:0033774": "basal labyrinth",
  "GO:0033775": "deoxysarpagine hydroxylase activity",
  "GO:0033776": "phenylacetone monooxygenase activity",
  "GO:0033777": "lithocholate 6beta-hydroxylase activity",
  "GO:0033778": "7alpha-hydroxycholest-4-en-3-one 12alpha-hydroxylase activity",
  "GO:0033779": "5beta-cholestane-3alpha,7alpha-diol 12alpha-hydroxylase activity",
  "GO:0033780": "taurochenodeoxycholate 6alpha-hydroxylase activity",
  "GO:0033781": "cholesterol 24-hydroxylase activity",
  "GO:0033782": "24-hydroxycholesterol 7alpha-hydroxylase activity",
  "GO:0033783": "25-hydroxycholesterol 7alpha-hydroxylase activity",
  "GO:0033784": "senecionine N-oxygenase activity",
  "GO:0033785": "heptose 7-phosphate kinase activity",
  "GO:0033786": "heptose-1-phosphate adenylyltransferase activity",
  "GO:0033787": "cyanocobalamin reductase (cyanide-eliminating) activity",
  "GO:0033788": "leucoanthocyanidin reductase activity",
  "GO:0033789": "phenylacetyl-CoA dehydrogenase activity",
  "GO:0033790": "hydroxymethylfurfural reductase activity",
  "GO:0033791": "3alpha,7alpha,12alpha-trihydroxy-5beta-cholestanoyl-CoA 24-hydroxylase activity",
  "GO:0033792": "bile-acid 7alpha-dehydroxylase activity",
  "GO:0033793": "aureusidin synthase activity",
  "GO:0033794": "sarcosine reductase activity",
  "GO:0033795": "betaine reductase activity",
  "GO:0033796": "sulfur reductase activity",
  "GO:0033797": "selenate reductase activity",
  "GO:0033798": "thyroxine 5-deiodinase activity",
  "GO:0033799": "myricetin 3'-O-methyltransferase activity",
  "GO:0033800": "isoflavone 7-O-methyltransferase activity",
  "GO:0033801": "vitexin 2''-O-rhamnoside 7-O-methyltransferase activity",
  "GO:0033802": "isoliquiritigenin 2'-O-methyltransferase activity",
  "GO:0033803": "kaempferol 4'-O-methyltransferase activity",
  "GO:0033804": "obsolete glycine/sarcosine N-methyltransferase activity",
  "GO:0033805": "obsolete sarcosine/dimethylglycine N-methyltransferase activity",
  "GO:0033806": "fluorothreonine transaldolase activity",
  "GO:0033807": "icosanoyl-CoA synthase activity",
  "GO:0033808": "6'-deoxychalcone synthase activity",
  "GO:0033809": "anthocyanin 6''-O-malonyltransferase activity",
  "GO:0033810": "anthocyanin 5-O-glucoside 6'''-O-malonyltransferase activity",
  "GO:0033811": "flavonol-3-O-triglucoside O-coumaroyltransferase activity",
  "GO:0033812": "3-oxoadipyl-CoA thiolase activity",
  "GO:0033813": "deacetylcephalosporin-C acetyltransferase activity",
  "GO:0033814": "propanoyl-CoA C-acyltransferase activity",
  "GO:0033815": "biphenyl synthase activity",
  "GO:0033816": "diaminobutyrate acetyltransferase activity",
  "GO:0033817": "beta-ketoacyl-acyl-carrier-protein synthase II activity",
  "GO:0033818": "beta-ketoacyl-acyl-carrier-protein synthase III activity",
  "GO:0033819": "lipoyl(octanoyl) transferase activity",
  "GO:0033820": "DNA alpha-glucosyltransferase activity",
  "GO:0033821": "DNA beta-glucosyltransferase activity",
  "GO:0033822": "glucosyl-DNA beta-glucosyltransferase activity",
  "GO:0033823": "procollagen glucosyltransferase activity",
  "GO:0033824": "alternansucrase activity",
  "GO:0033825": "oligosaccharide 4-alpha-D-glucosyltransferase activity",
  "GO:0033826": "xyloglucan 4-glucosyltransferase activity",
  "GO:0033827": "high-mannose-oligosaccharide beta-1,4-N-acetylglucosaminyltransferase activity",
  "GO:0033828": "glucosylglycerol-phosphate synthase activity",
  "GO:0033829": "O-fucosylpeptide 3-beta-N-acetylglucosaminyltransferase activity",
  "GO:0033830": "Skp1-protein-hydroxyproline N-acetylglucosaminyltransferase activity",
  "GO:0033831": "kojibiose phosphorylase activity",
  "GO:0033832": "alpha,alpha-trehalose phosphorylase (configuration-retaining) activity",
  "GO:0033833": "hydroxymethylfurfural reductase (NADH) activity",
  "GO:0033834": "kaempferol 3-O-galactosyltransferase activity",
  "GO:0033835": "flavanone 7-O-glucoside 2''-O-beta-L-rhamnosyltransferase activity",
  "GO:0033836": "flavonol 7-O-beta-glucosyltransferase activity",
  "GO:0033837": "anthocyanin 3'-O-beta-glucosyltransferase activity",
  "GO:0033838": "flavonol-3-O-glucoside glucosyltransferase activity",
  "GO:0033839": "flavonol-3-O-glycoside glucosyltransferase activity",
  "GO:0033840": "NDP-glucose-starch glucosyltransferase activity",
  "GO:0033841": "6G-fructosyltransferase activity",
  "GO:0033842": "N-acetyl-beta-glucosaminyl-glycoprotein 4-beta-N-acetylgalactosaminyltransferase activity",
  "GO:0033843": "xyloglucan 6-xylosyltransferase activity",
  "GO:0033844": "galactose-6-sulfurylase activity",
  "GO:0033845": "hydroxymethylfurfural reductase (NADPH) activity",
  "GO:0033846": "adenosyl-fluoride synthase activity",
  "GO:0033847": "O-phosphoserine sulfhydrylase activity",
  "GO:0033848": "N2-(2-carboxyethyl)arginine synthase activity",
  "GO:0033849": "chrysanthemyl diphosphate synthase activity",
  "GO:0033850": "Z-farnesyl diphosphate synthase activity",
  "GO:0033851": "lavandulyl diphosphate synthase activity",
  "GO:0033852": "thyroid-hormone transaminase activity",
  "GO:0033853": "aspartate-prephenate aminotransferase activity",
  "GO:0033854": "glutamate-prephenate aminotransferase activity",
  "GO:0033855": "nicotianamine aminotransferase activity",
  "GO:0033856": "pyridoxine 5'-phosphate synthase activity",
  "GO:0033857": "diphosphoinositol-pentakisphosphate kinase activity",
  "GO:0033858": "N-acetylgalactosamine kinase activity",
  "GO:0033859": "furaldehyde metabolic process",
  "GO:0033860": "regulation of NAD(P)H oxidase activity",
  "GO:0033861": "negative regulation of NAD(P)H oxidase activity",
  "GO:0033862": "UMP kinase activity",
  "GO:0033863": "ribose 1,5-bisphosphate phosphokinase activity",
  "GO:0033864": "positive regulation of NAD(P)H oxidase activity",
  "GO:0033865": "nucleoside bisphosphate metabolic process",
  "GO:0033866": "nucleoside bisphosphate biosynthetic process",
  "GO:0033867": "Fas-activated serine/threonine kinase activity",
  "GO:0033868": "Goodpasture-antigen-binding protein kinase activity",
  "GO:0033869": "nucleoside bisphosphate catabolic process",
  "GO:0033870": "thiol sulfotransferase activity",
  "GO:0033871": "[heparan sulfate]-glucosamine 3-sulfotransferase 2 activity",
  "GO:0033872": "[heparan sulfate]-glucosamine 3-sulfotransferase 3 activity",
  "GO:0033873": "petromyzonol sulfotransferase activity",
  "GO:0033874": "scymnol sulfotransferase activity",
  "GO:0033875": "ribonucleoside bisphosphate metabolic process",
  "GO:0033876": "glycochenodeoxycholate sulfotransferase activity",
  "GO:0033877": "succinyl-CoA:(R)-benzylsuccinate CoA-transferase activity",
  "GO:0033878": "hormone-sensitive lipase activity",
  "GO:0033879": "acetylajmaline esterase activity",
  "GO:0033880": "phenylacetyl-CoA hydrolase activity",
  "GO:0033881": "bile-acid-CoA hydrolase activity",
  "GO:0033882": "choloyl-CoA hydrolase activity",
  "GO:0033883": "pyridoxal phosphatase activity",
  "GO:0033884": "obsolete phosphoethanolamine/phosphocholine phosphatase activity",
  "GO:0033885": "10-hydroxy-9-(phosphonooxy)octadecanoate phosphatase activity",
  "GO:0033886": "cellulose-polysulfatase activity",
  "GO:0033887": "chondro-4-sulfatase activity",
  "GO:0033888": "chondro-6-sulfatase activity",
  "GO:0033889": "N-sulfoglucosamine-3-sulfatase activity",
  "GO:0033890": "ribonuclease D activity",
  "GO:0033891": "CC-preferring endodeoxyribonuclease activity",
  "GO:0033892": "deoxyribonuclease (pyrimidine dimer) activity",
  "GO:0033893": "ribonuclease IV activity",
  "GO:0033894": "ribonuclease P4 activity",
  "GO:0033895": "ribonuclease [poly-(U)-specific] activity",
  "GO:0033896": "ribonuclease IX activity",
  "GO:0033897": "ribonuclease T2 activity",
  "GO:0033898": "Bacillus subtilis ribonuclease activity",
  "GO:0033899": "ribonuclease U2 activity",
  "GO:0033900": "ribonuclease F activity",
  "GO:0033901": "ribonuclease V activity",
  "GO:0033902": "rRNA endonuclease activity",
  "GO:0033903": "obsolete endo-1,3(4)-beta-glucanase activity",
  "GO:0033904": "dextranase activity",
  "GO:0033905": "xylan endo-1,3-beta-xylosidase activity",
  "GO:0033906": "hyaluronoglucuronidase activity",
  "GO:0033907": "beta-D-fucosidase activity",
  "GO:0033908": "beta-L-rhamnosidase activity",
  "GO:0033909": "fucoidanase activity",
  "GO:0033910": "glucan 1,4-alpha-maltotetraohydrolase activity",
  "GO:0033911": "mycodextranase activity",
  "GO:0033912": "2,6-beta-fructan 6-levanbiohydrolase activity",
  "GO:0033913": "glucan endo-1,2-beta-glucosidase activity",
  "GO:0033914": "xylan 1,3-beta-xylosidase activity",
  "GO:0033915": "mannan 1,2-(1,3)-alpha-mannosidase activity",
  "GO:0033916": "beta-agarase activity",
  "GO:0033917": "exo-poly-alpha-galacturonosidase activity",
  "GO:0033918": "kappa-carrageenase activity",
  "GO:0033919": "glucan 1,3-alpha-glucosidase activity",
  "GO:0033920": "6-phospho-beta-galactosidase activity",
  "GO:0033921": "capsular-polysaccharide endo-1,3-alpha-galactosidase activity",
  "GO:0033922": "peptidoglycan beta-N-acetylmuramidase activity",
  "GO:0033923": "glucan 1,6-alpha-isomaltosidase activity",
  "GO:0033924": "dextran 1,6-alpha-isomaltotriosidase activity",
  "GO:0033925": "mannosyl-glycoprotein endo-beta-N-acetylglucosaminidase activity",
  "GO:0033926": "glycopeptide alpha-N-acetylgalactosaminidase activity",
  "GO:0033927": "glucan 1,4-alpha-maltohexaosidase activity",
  "GO:0033928": "mannan 1,4-mannobiosidase activity",
  "GO:0033929": "blood-group-substance endo-1,4-beta-galactosidase activity",
  "GO:0033930": "keratan-sulfate endo-1,4-beta-galactosidase activity",
  "GO:0033931": "endogalactosaminidase activity",
  "GO:0033932": "1,3-alpha-L-fucosidase activity",
  "GO:0033933": "branched-dextran exo-1,2-alpha-glucosidase activity",
  "GO:0033934": "glucan 1,4-alpha-maltotriohydrolase activity",
  "GO:0033935": "oligoxyloglucan beta-glycosidase activity",
  "GO:0033936": "polymannuronate hydrolase activity",
  "GO:0033937": "3-deoxy-2-octulosonidase activity",
  "GO:0033938": "1,6-alpha-L-fucosidase activity",
  "GO:0033939": "xylan alpha-1,2-glucuronosidase activity",
  "GO:0033940": "glucuronoarabinoxylan endo-1,4-beta-xylanase activity",
  "GO:0033941": "mannan exo-1,2-1,6-alpha-mannosidase activity",
  "GO:0033942": "4-alpha-D-\\{(1->4)-alpha-D-glucano}trehalose trehalohydrolase activity",
  "GO:0033943": "galactan 1,3-beta-galactosidase activity",
  "GO:0033944": "beta-galactofuranosidase activity",
  "GO:0033945": "oligoxyloglucan reducing-end-specific cellobiohydrolase activity",
  "GO:0033946": "xyloglucan-specific endo-beta-1,4-glucanase activity",
  "GO:0033947": "mannosylglycoprotein endo-beta-mannosidase activity",
  "GO:0033948": "fructan beta-(2,1)-fructosidase activity",
  "GO:0033949": "fructan beta-(2,6)-fructosidase activity",
  "GO:0033950": "xyloglucan-specific exo-beta-1,4-glucanase activity",
  "GO:0033951": "oligosaccharide reducing-end xylanase activity",
  "GO:0033952": "iota-carrageenase activity",
  "GO:0033953": "alpha-agarase activity",
  "GO:0033954": "alpha-neoagaro-oligosaccharide hydrolase activity",
  "GO:0033955": "mitochondrial DNA inheritance",
  "GO:0033956": "beta-apiosyl-beta-glucosidase activity",
  "GO:0033957": "lambda-carrageenase activity",
  "GO:0033958": "DNA-deoxyinosine glycosylase activity",
  "GO:0033959": "deoxyribodipyrimidine endonucleosidase activity",
  "GO:0033960": "N-methyl nucleosidase activity",
  "GO:0033961": "cis-stilbene-oxide hydrolase activity",
  "GO:0033962": "cytoplasmic mRNA processing body assembly",
  "GO:0033963": "cholesterol-5,6-oxide hydrolase activity",
  "GO:0033964": "glycosphingolipid deacylase activity",
  "GO:0033965": "aculeacin-A deacylase activity",
  "GO:0033966": "N-substituted formamide deformylase activity",
  "GO:0033967": "box C/D snoRNA metabolic process",
  "GO:0033968": "glutaryl-7-aminocephalosporanic-acid acylase activity",
  "GO:0033969": "gamma-glutamyl-gamma-aminobutyrate hydrolase activity",
  "GO:0033970": "N-malonylurea hydrolase activity",
  "GO:0033971": "hydroxyisourate hydrolase activity",
  "GO:0033972": "proclavaminate amidinohydrolase activity",
  "GO:0033973": "dCTP deaminase (dUMP-forming) activity",
  "GO:0033974": "nucleoside phosphoacylhydrolase activity",
  "GO:0033975": "(R)-2-haloacid dehalogenase activity",
  "GO:0033976": "2-haloacid dehalogenase (configuration-inverting) activity",
  "GO:0033977": "2-haloacid dehalogenase (configuration-retaining) activity",
  "GO:0033978": "phosphonopyruvate hydrolase activity",
  "GO:0033979": "box H/ACA snoRNA metabolic process",
  "GO:0033980": "phosphonopyruvate decarboxylase activity",
  "GO:0033981": "D-dopachrome decarboxylase activity",
  "GO:0033982": "3-dehydro-L-gulonate-6-phosphate decarboxylase activity",
  "GO:0033983": "diaminobutyrate decarboxylase activity",
  "GO:0033984": "indole-3-glycerol-phosphate lyase activity",
  "GO:0033985": "acidocalcisome lumen",
  "GO:0033986": "response to methanol",
  "GO:0033987": "2-hydroxyisoflavanone dehydratase activity",
  "GO:0033988": "bile-acid 7alpha-dehydratase activity",
  "GO:0033989": "3alpha,7alpha,12alpha-trihydroxy-5beta-cholest-24-enoyl-CoA hydratase activity",
  "GO:0033990": "ectoine synthase activity",
  "GO:0033991": "aldos-2-ulose dehydratase activity",
  "GO:0033992": "1,5-anhydro-D-fructose dehydratase activity",
  "GO:0033993": "response to lipid",
  "GO:0033994": "glucuronan lyase activity",
  "GO:0033995": "anhydrosialidase activity",
  "GO:0033996": "levan fructotransferase (DFA-IV-forming) activity",
  "GO:0033997": "inulin fructotransferase (DFA-I-forming) activity",
  "GO:0033998": "inulin fructotransferase (DFA-III-forming) activity",
  "GO:0033999": "chondroitin B lyase activity",
  "GO:0034000": "chondroitin-sulfate-ABC endolyase activity",
  "GO:0034001": "chondroitin-sulfate-ABC exolyase activity",
  "GO:0034002": "(R)-limonene synthase activity",
  "GO:0034003": "vetispiradiene synthase activity",
  "GO:0034004": "germacradienol synthase activity",
  "GO:0034005": "germacrene-A synthase activity",
  "GO:0034006": "amorpha-4,11-diene synthase activity",
  "GO:0034007": "S-linalool synthase activity",
  "GO:0034008": "R-linalool synthase activity",
  "GO:0034009": "isoprene synthase activity",
  "GO:0034010": "sulfolactate sulfo-lyase activity",
  "GO:0034011": "L-cysteate sulfo-lyase activity",
  "GO:0034012": "FAD-AMP lyase (cyclizing) activity",
  "GO:0034013": "aliphatic aldoxime dehydratase activity",
  "GO:0034014": "response to triglyceride",
  "GO:0034015": "L-ribulose-5-phosphate 3-epimerase activity",
  "GO:0034016": "polyenoic fatty acid isomerase activity",
  "GO:0034017": "trans-2-decenoyl-acyl-carrier-protein isomerase activity",
  "GO:0034018": "ascopyrone tautomerase activity",
  "GO:0034019": "obsolete capsanthin/capsorubin synthase activity",
  "GO:0034020": "neoxanthin synthase activity",
  "GO:0034021": "response to silicon dioxide",
  "GO:0034022": "3-(hydroxyamino)phenol mutase activity",
  "GO:0034023": "5-(carboxyamino)imidazole ribonucleotide mutase activity",
  "GO:0034024": "glutamate-putrescine ligase activity",
  "GO:0034025": "D-aspartate ligase activity",
  "GO:0034026": "L-amino-acid alpha-ligase activity",
  "GO:0034027": "(carboxyethyl)arginine beta-lactam-synthase activity",
  "GO:0034028": "5-(carboxyamino)imidazole ribonucleotide synthase activity",
  "GO:0034029": "2-oxoglutarate carboxylase activity",
  "GO:0034030": "ribonucleoside bisphosphate biosynthetic process",
  "GO:0034031": "ribonucleoside bisphosphate catabolic process",
  "GO:0034032": "purine nucleoside bisphosphate metabolic process",
  "GO:0034033": "purine nucleoside bisphosphate biosynthetic process",
  "GO:0034034": "purine nucleoside bisphosphate catabolic process",
  "GO:0034035": "purine ribonucleoside bisphosphate metabolic process",
  "GO:0034036": "purine ribonucleoside bisphosphate biosynthetic process",
  "GO:0034037": "purine ribonucleoside bisphosphate catabolic process",
  "GO:0034038": "deoxyhypusine synthase activity",
  "GO:0034039": "8-oxo-7,8-dihydroguanine DNA N-glycosylase activity",
  "GO:0034040": "lipid-transporting ATPase activity",
  "GO:0034041": "sterol-transporting ATPase activity",
  "GO:0034042": "5-formyluracil DNA N-glycosylase activity",
  "GO:0034043": "5-hydroxymethyluracil DNA N-glycosylase activity",
  "GO:0034044": "exomer complex",
  "GO:0034045": "pre-autophagosomal structure membrane",
  "GO:0034046": "poly(G) binding",
  "GO:0034047": "regulation of protein phosphatase type 2A activity",
  "GO:0034048": "negative regulation of protein phosphatase type 2A activity",
  "GO:0034049": "positive regulation of protein phosphatase type 2A activity",
  "GO:0034050": "host programmed cell death induced by symbiont",
  "GO:0034051": "negative regulation of plant-type hypersensitive response",
  "GO:0034052": "positive regulation of plant-type hypersensitive response",
  "GO:0034053": "modulation by symbiont of host defense-related programmed cell death",
  "GO:0034054": "negative regulation by symbiont of host defense-related programmed cell death",
  "GO:0034055": "positive regulation by symbiont of host defense-related programmed cell death",
  "GO:0034056": "estrogen response element binding",
  "GO:0034057": "RNA strand-exchange activity",
  "GO:0034058": "endosomal vesicle fusion",
  "GO:0034059": "response to anoxia",
  "GO:0034060": "cyanelle stroma",
  "GO:0034061": "DNA polymerase activity",
  "GO:0034062": "RNA polymerase activity",
  "GO:0034063": "stress granule assembly",
  "GO:0034064": "Tor2-Mei2-Ste11 complex",
  "GO:0034065": "replication fork processing at rDNA locus",
  "GO:0034066": "RIC1-RGP1 guanyl-nucleotide exchange factor complex",
  "GO:0034067": "protein localization to Golgi apparatus",
  "GO:0034068": "aminoglycoside nucleotidyltransferase activity",
  "GO:0034069": "aminoglycoside N-acetyltransferase activity",
  "GO:0034070": "aminoglycoside 1-N-acetyltransferase activity",
  "GO:0034071": "aminoglycoside phosphotransferase activity",
  "GO:0034072": "squalene cyclase activity",
  "GO:0034073": "tetrahymanol cyclase activity",
  "GO:0034074": "marneral synthase activity",
  "GO:0034075": "arabidiol synthase activity",
  "GO:0034076": "cucurbitadienol synthase activity",
  "GO:0034077": "butanediol metabolic process",
  "GO:0034078": "butanediol catabolic process",
  "GO:0034079": "butanediol biosynthetic process",
  "GO:0034080": "CENP-A containing nucleosome assembly",
  "GO:0034081": "polyketide synthase complex",
  "GO:0034082": "type II polyketide synthase complex",
  "GO:0034083": "type III polyketide synthase complex",
  "GO:0034084": "steryl deacetylase activity",
  "GO:0034085": "establishment of sister chromatid cohesion",
  "GO:0034086": "maintenance of sister chromatid cohesion",
  "GO:0034087": "establishment of mitotic sister chromatid cohesion",
  "GO:0034088": "maintenance of mitotic sister chromatid cohesion",
  "GO:0034089": "establishment of meiotic sister chromatid cohesion",
  "GO:0034090": "maintenance of meiotic sister chromatid cohesion",
  "GO:0034091": "regulation of maintenance of sister chromatid cohesion",
  "GO:0034092": "negative regulation of maintenance of sister chromatid cohesion",
  "GO:0034093": "positive regulation of maintenance of sister chromatid cohesion",
  "GO:0034094": "regulation of maintenance of meiotic sister chromatid cohesion",
  "GO:0034095": "negative regulation of maintenance of meiotic sister chromatid cohesion",
  "GO:0034096": "positive regulation of maintenance of meiotic sister chromatid cohesion",
  "GO:0034097": "response to cytokine",
  "GO:0034098": "VCP-NPL4-UFD1 AAA ATPase complex",
  "GO:0034099": "luminal surveillance complex",
  "GO:0034101": "erythrocyte homeostasis",
  "GO:0034102": "erythrocyte clearance",
  "GO:0034103": "regulation of tissue remodeling",
  "GO:0034104": "negative regulation of tissue remodeling",
  "GO:0034105": "positive regulation of tissue remodeling",
  "GO:0034106": "regulation of erythrocyte clearance",
  "GO:0034107": "negative regulation of erythrocyte clearance",
  "GO:0034108": "positive regulation of erythrocyte clearance",
  "GO:0034109": "homotypic cell-cell adhesion",
  "GO:0034110": "regulation of homotypic cell-cell adhesion",
  "GO:0034111": "negative regulation of homotypic cell-cell adhesion",
  "GO:0034112": "positive regulation of homotypic cell-cell adhesion",
  "GO:0034113": "heterotypic cell-cell adhesion",
  "GO:0034114": "regulation of heterotypic cell-cell adhesion",
  "GO:0034115": "negative regulation of heterotypic cell-cell adhesion",
  "GO:0034116": "positive regulation of heterotypic cell-cell adhesion",
  "GO:0034117": "erythrocyte aggregation",
  "GO:0034118": "regulation of erythrocyte aggregation",
  "GO:0034119": "negative regulation of erythrocyte aggregation",
  "GO:0034120": "positive regulation of erythrocyte aggregation",
  "GO:0034121": "regulation of toll-like receptor signaling pathway",
  "GO:0034122": "negative regulation of toll-like receptor signaling pathway",
  "GO:0034123": "positive regulation of toll-like receptor signaling pathway",
  "GO:0034124": "regulation of MyD88-dependent toll-like receptor signaling pathway",
  "GO:0034125": "negative regulation of MyD88-dependent toll-like receptor signaling pathway",
  "GO:0034126": "positive regulation of MyD88-dependent toll-like receptor signaling pathway",
  "GO:0034127": "regulation of MyD88-independent toll-like receptor signaling pathway",
  "GO:0034128": "negative regulation of MyD88-independent toll-like receptor signaling pathway",
  "GO:0034129": "positive regulation of MyD88-independent toll-like receptor signaling pathway",
  "GO:0034130": "toll-like receptor 1 signaling pathway",
  "GO:0034131": "regulation of toll-like receptor 1 signaling pathway",
  "GO:0034132": "negative regulation of toll-like receptor 1 signaling pathway",
  "GO:0034133": "positive regulation of toll-like receptor 1 signaling pathway",
  "GO:0034134": "toll-like receptor 2 signaling pathway",
  "GO:0034135": "regulation of toll-like receptor 2 signaling pathway",
  "GO:0034136": "negative regulation of toll-like receptor 2 signaling pathway",
  "GO:0034137": "positive regulation of toll-like receptor 2 signaling pathway",
  "GO:0034138": "toll-like receptor 3 signaling pathway",
  "GO:0034139": "regulation of toll-like receptor 3 signaling pathway",
  "GO:0034140": "negative regulation of toll-like receptor 3 signaling pathway",
  "GO:0034141": "positive regulation of toll-like receptor 3 signaling pathway",
  "GO:0034142": "toll-like receptor 4 signaling pathway",
  "GO:0034143": "regulation of toll-like receptor 4 signaling pathway",
  "GO:0034144": "negative regulation of toll-like receptor 4 signaling pathway",
  "GO:0034145": "positive regulation of toll-like receptor 4 signaling pathway",
  "GO:0034146": "toll-like receptor 5 signaling pathway",
  "GO:0034147": "regulation of toll-like receptor 5 signaling pathway",
  "GO:0034148": "negative regulation of toll-like receptor 5 signaling pathway",
  "GO:0034149": "positive regulation of toll-like receptor 5 signaling pathway",
  "GO:0034150": "toll-like receptor 6 signaling pathway",
  "GO:0034151": "regulation of toll-like receptor 6 signaling pathway",
  "GO:0034152": "negative regulation of toll-like receptor 6 signaling pathway",
  "GO:0034153": "positive regulation of toll-like receptor 6 signaling pathway",
  "GO:0034154": "toll-like receptor 7 signaling pathway",
  "GO:0034155": "regulation of toll-like receptor 7 signaling pathway",
  "GO:0034156": "negative regulation of toll-like receptor 7 signaling pathway",
  "GO:0034157": "positive regulation of toll-like receptor 7 signaling pathway",
  "GO:0034158": "toll-like receptor 8 signaling pathway",
  "GO:0034159": "regulation of toll-like receptor 8 signaling pathway",
  "GO:0034160": "negative regulation of toll-like receptor 8 signaling pathway",
  "GO:0034161": "positive regulation of toll-like receptor 8 signaling pathway",
  "GO:0034162": "toll-like receptor 9 signaling pathway",
  "GO:0034163": "regulation of toll-like receptor 9 signaling pathway",
  "GO:0034164": "negative regulation of toll-like receptor 9 signaling pathway",
  "GO:0034165": "positive regulation of toll-like receptor 9 signaling pathway",
  "GO:0034166": "toll-like receptor 10 signaling pathway",
  "GO:0034167": "regulation of toll-like receptor 10 signaling pathway",
  "GO:0034168": "negative regulation of toll-like receptor 10 signaling pathway",
  "GO:0034169": "positive regulation of toll-like receptor 10 signaling pathway",
  "GO:0034170": "toll-like receptor 11 signaling pathway",
  "GO:0034171": "regulation of toll-like receptor 11 signaling pathway",
  "GO:0034172": "negative regulation of toll-like receptor 11 signaling pathway",
  "GO:0034173": "positive regulation of toll-like receptor 11 signaling pathway",
  "GO:0034174": "toll-like receptor 12 signaling pathway",
  "GO:0034175": "regulation of toll-like receptor 12 signaling pathway",
  "GO:0034176": "negative regulation of toll-like receptor 12 signaling pathway",
  "GO:0034177": "positive regulation of toll-like receptor 12 signaling pathway",
  "GO:0034178": "toll-like receptor 13 signaling pathway",
  "GO:0034179": "regulation of toll-like receptor 13 signaling pathway",
  "GO:0034180": "negative regulation of toll-like receptor 13 signaling pathway",
  "GO:0034181": "positive regulation of toll-like receptor 13 signaling pathway",
  "GO:0034182": "regulation of maintenance of mitotic sister chromatid cohesion",
  "GO:0034183": "negative regulation of maintenance of mitotic sister chromatid cohesion",
  "GO:0034184": "positive regulation of maintenance of mitotic sister chromatid cohesion",
  "GO:0034185": "apolipoprotein binding",
  "GO:0034186": "apolipoprotein A-I binding",
  "GO:0034187": "obsolete apolipoprotein E binding",
  "GO:0034188": "apolipoprotein A-I receptor activity",
  "GO:0034189": "very-low-density lipoprotein particle binding",
  "GO:0034190": "apolipoprotein receptor binding",
  "GO:0034191": "apolipoprotein A-I receptor binding",
  "GO:0034192": "D-galactonate metabolic process",
  "GO:0034193": "L-galactonate metabolic process",
  "GO:0034194": "D-galactonate catabolic process",
  "GO:0034195": "L-galactonate catabolic process",
  "GO:0034196": "acylglycerol transport",
  "GO:0034197": "triglyceride transport",
  "GO:0034198": "cellular response to amino acid starvation",
  "GO:0034199": "activation of protein kinase A activity",
  "GO:0034200": "D,D-heptose 1,7-bisphosphate phosphatase activity",
  "GO:0034201": "response to oleic acid",
  "GO:0034202": "glycolipid-translocating activity",
  "GO:0034203": "glycolipid translocation",
  "GO:0034204": "lipid translocation",
  "GO:0034205": "beta-amyloid formation",
  "GO:0034206": "enhanceosome",
  "GO:0034207": "steroid acetylation",
  "GO:0034208": "steroid deacetylation",
  "GO:0034209": "sterol acetylation",
  "GO:0034210": "sterol deacetylation",
  "GO:0034211": "GTP-dependent protein kinase activity",
  "GO:0034212": "peptide N-acetyltransferase activity",
  "GO:0034213": "quinolinate catabolic process",
  "GO:0034214": "protein hexamerization",
  "GO:0034215": "thiamine:proton symporter activity",
  "GO:0034216": "high-affinity thiamine:proton symporter activity",
  "GO:0034217": "ascospore wall chitin biosynthetic process",
  "GO:0034218": "ascospore wall chitin metabolic process",
  "GO:0034219": "carbohydrate transmembrane transport",
  "GO:0034220": "ion transmembrane transport",
  "GO:0034221": "fungal-type cell wall chitin biosynthetic process",
  "GO:0034222": "regulation of cell wall chitin metabolic process",
  "GO:0034223": "regulation of ascospore wall chitin biosynthetic process",
  "GO:0034224": "cellular response to zinc ion starvation",
  "GO:0034225": "regulation of transcription from RNA polymerase II promoter in response to zinc ion starvation",
  "GO:0034226": "lysine import",
  "GO:0034227": "tRNA thio-modification",
  "GO:0034228": "ethanolamine transmembrane transporter activity",
  "GO:0034229": "ethanolamine transport",
  "GO:0034230": "enkephalin processing",
  "GO:0034231": "islet amyloid polypeptide processing",
  "GO:0034232": "ascospore wall chitin catabolic process",
  "GO:0034233": "regulation of cell wall chitin catabolic process",
  "GO:0034234": "regulation of ascospore wall chitin catabolic process",
  "GO:0034235": "GPI anchor binding",
  "GO:0034236": "protein kinase A catalytic subunit binding",
  "GO:0034237": "protein kinase A regulatory subunit binding",
  "GO:0034238": "macrophage fusion",
  "GO:0034239": "regulation of macrophage fusion",
  "GO:0034240": "negative regulation of macrophage fusion",
  "GO:0034241": "positive regulation of macrophage fusion",
  "GO:0034242": "negative regulation of syncytium formation by plasma membrane fusion",
  "GO:0034243": "regulation of transcription elongation from RNA polymerase II promoter",
  "GO:0034244": "negative regulation of transcription elongation from RNA polymerase II promoter",
  "GO:0034245": "mitochondrial DNA-directed RNA polymerase complex",
  "GO:0034246": "mitochondrial RNA polymerase binding promoter specificity activity",
  "GO:0034247": "snoRNA splicing",
  "GO:0034248": "regulation of cellular amide metabolic process",
  "GO:0034249": "negative regulation of cellular amide metabolic process",
  "GO:0034250": "positive regulation of cellular amide metabolic process",
  "GO:0034251": "regulation of cellular amide catabolic process",
  "GO:0034252": "negative regulation of cellular amide catabolic process",
  "GO:0034253": "positive regulation of cellular amide catabolic process",
  "GO:0034254": "regulation of urea catabolic process",
  "GO:0034255": "regulation of urea metabolic process",
  "GO:0034256": "chlorophyll(ide) b reductase activity",
  "GO:0034257": "nicotinamide riboside transmembrane transporter activity",
  "GO:0034258": "nicotinamide riboside transport",
  "GO:0034260": "negative regulation of GTPase activity",
  "GO:0034263": "autophagy in response to ER overload",
  "GO:0034264": "isopentenyl adenine metabolic process",
  "GO:0034265": "isopentenyl adenine biosynthetic process",
  "GO:0034266": "isopentenyl adenine catabolic process",
  "GO:0034267": "discadenine metabolic process",
  "GO:0034268": "discadenine biosynthetic process",
  "GO:0034269": "discadenine catabolic process",
  "GO:0034270": "CVT complex",
  "GO:0034271": "phosphatidylinositol 3-kinase complex, class III, type I",
  "GO:0034272": "phosphatidylinositol 3-kinase complex, class III, type II",
  "GO:0034274": "Atg12-Atg5-Atg16 complex",
  "GO:0034275": "kynurenic acid metabolic process",
  "GO:0034276": "kynurenic acid biosynthetic process",
  "GO:0034277": "ent-cassa-12,15-diene synthase activity",
  "GO:0034278": "stemar-13-ene synthase activity",
  "GO:0034279": "syn-pimara-7,15-diene synthase activity",
  "GO:0034280": "ent-sandaracopimaradiene synthase activity",
  "GO:0034281": "ent-isokaurene synthase activity",
  "GO:0034282": "ent-pimara-8(14),15-diene synthase activity",
  "GO:0034283": "syn-stemod-13(17)-ene synthase activity",
  "GO:0034284": "response to monosaccharide",
  "GO:0034285": "response to disaccharide",
  "GO:0034286": "response to maltose",
  "GO:0034287": "detection of monosaccharide stimulus",
  "GO:0034288": "detection of disaccharide stimulus",
  "GO:0034289": "detection of maltose stimulus",
  "GO:0034290": "holin activity",
  "GO:0034291": "canonical holin activity",
  "GO:0034292": "pinholin activity",
  "GO:0034293": "sexual sporulation",
  "GO:0034294": "sexual spore wall assembly",
  "GO:0034295": "basidiospore formation",
  "GO:0034296": "zygospore formation",
  "GO:0034297": "oidium formation",
  "GO:0034298": "arthrospore formation",
  "GO:0034299": "reproductive blastospore formation",
  "GO:0034300": "sporangiospore formation",
  "GO:0034301": "endospore formation",
  "GO:0034302": "akinete formation",
  "GO:0034303": "myxospore formation",
  "GO:0034304": "actinomycete-type spore formation",
  "GO:0034305": "regulation of asexual sporulation",
  "GO:0034306": "regulation of sexual sporulation",
  "GO:0034307": "regulation of ascospore formation",
  "GO:0034308": "primary alcohol metabolic process",
  "GO:0034309": "primary alcohol biosynthetic process",
  "GO:0034310": "primary alcohol catabolic process",
  "GO:0034311": "diol metabolic process",
  "GO:0034312": "diol biosynthetic process",
  "GO:0034313": "diol catabolic process",
  "GO:0034314": "Arp2/3 complex-mediated actin nucleation",
  "GO:0034315": "regulation of Arp2/3 complex-mediated actin nucleation",
  "GO:0034316": "negative regulation of Arp2/3 complex-mediated actin nucleation",
  "GO:0034317": "nicotinic acid riboside kinase activity",
  "GO:0034318": "alcohol O-acyltransferase activity",
  "GO:0034319": "alcohol O-butanoyltransferase activity",
  "GO:0034320": "alcohol O-hexanoyltransferase activity",
  "GO:0034321": "alcohol O-octanoyltransferase activity",
  "GO:0034322": "alcohol O-decanoyltransferase activity",
  "GO:0034323": "O-butanoyltransferase activity",
  "GO:0034324": "O-hexanoyltransferase activity",
  "GO:0034325": "O-decanoyltransferase activity",
  "GO:0034326": "butanoyltransferase activity",
  "GO:0034327": "hexanoyltransferase activity",
  "GO:0034328": "decanoyltransferase activity",
  "GO:0034329": "cell junction assembly",
  "GO:0034330": "cell junction organization",
  "GO:0034331": "cell junction maintenance",
  "GO:0034332": "adherens junction organization",
  "GO:0034333": "adherens junction assembly",
  "GO:0034334": "adherens junction maintenance",
  "GO:0034335": "DNA supercoiling activity",
  "GO:0034336": "misfolded RNA binding",
  "GO:0034337": "RNA folding",
  "GO:0034338": "short-chain carboxylesterase activity",
  "GO:0034339": "obsolete regulation of transcription from RNA polymerase II promoter by nuclear hormone receptor",
  "GO:0034340": "response to type I interferon",
  "GO:0034341": "response to interferon-gamma",
  "GO:0034342": "response to type III interferon",
  "GO:0034343": "type III interferon production",
  "GO:0034344": "regulation of type III interferon production",
  "GO:0034345": "negative regulation of type III interferon production",
  "GO:0034346": "positive regulation of type III interferon production",
  "GO:0034347": "type III interferon binding",
  "GO:0034348": "type III interferon receptor activity",
  "GO:0034349": "glial cell apoptotic process",
  "GO:0034350": "regulation of glial cell apoptotic process",
  "GO:0034351": "negative regulation of glial cell apoptotic process",
  "GO:0034352": "positive regulation of glial cell apoptotic process",
  "GO:0034353": "RNA pyrophosphohydrolase activity",
  "GO:0034354": "'de novo' NAD biosynthetic process from tryptophan",
  "GO:0034355": "NAD salvage",
  "GO:0034356": "NAD biosynthesis via nicotinamide riboside salvage pathway",
  "GO:0034357": "photosynthetic membrane",
  "GO:0034358": "plasma lipoprotein particle",
  "GO:0034359": "mature chylomicron",
  "GO:0034360": "chylomicron remnant",
  "GO:0034361": "very-low-density lipoprotein particle",
  "GO:0034362": "low-density lipoprotein particle",
  "GO:0034363": "intermediate-density lipoprotein particle",
  "GO:0034364": "high-density lipoprotein particle",
  "GO:0034365": "discoidal high-density lipoprotein particle",
  "GO:0034366": "spherical high-density lipoprotein particle",
  "GO:0034367": "macromolecular complex remodeling",
  "GO:0034368": "protein-lipid complex remodeling",
  "GO:0034369": "plasma lipoprotein particle remodeling",
  "GO:0034370": "triglyceride-rich lipoprotein particle remodeling",
  "GO:0034371": "chylomicron remodeling",
  "GO:0034372": "very-low-density lipoprotein particle remodeling",
  "GO:0034373": "intermediate-density lipoprotein particle remodeling",
  "GO:0034374": "low-density lipoprotein particle remodeling",
  "GO:0034375": "high-density lipoprotein particle remodeling",
  "GO:0034376": "conversion of discoidal high-density lipoprotein particle to spherical high-density lipoprotein particle",
  "GO:0034377": "plasma lipoprotein particle assembly",
  "GO:0034378": "chylomicron assembly",
  "GO:0034379": "very-low-density lipoprotein particle assembly",
  "GO:0034380": "high-density lipoprotein particle assembly",
  "GO:0034381": "plasma lipoprotein particle clearance",
  "GO:0034382": "chylomicron remnant clearance",
  "GO:0034383": "low-density lipoprotein particle clearance",
  "GO:0034384": "high-density lipoprotein particle clearance",
  "GO:0034385": "triglyceride-rich lipoprotein particle",
  "GO:0034386": "4-aminobutyrate:2-oxoglutarate transaminase activity",
  "GO:0034387": "4-aminobutyrate:pyruvate transaminase activity",
  "GO:0034388": "Pwp2p-containing subcomplex of 90S preribosome",
  "GO:0034389": "lipid particle organization",
  "GO:0034390": "smooth muscle cell apoptotic process",
  "GO:0034391": "regulation of smooth muscle cell apoptotic process",
  "GO:0034392": "negative regulation of smooth muscle cell apoptotic process",
  "GO:0034393": "positive regulation of smooth muscle cell apoptotic process",
  "GO:0034394": "protein localization to cell surface",
  "GO:0034395": "regulation of transcription from RNA polymerase II promoter in response to iron",
  "GO:0034396": "negative regulation of transcription from RNA polymerase II promoter in response to iron",
  "GO:0034397": "telomere localization",
  "GO:0034398": "telomere tethering at nuclear periphery",
  "GO:0034399": "nuclear periphery",
  "GO:0034400": "gerontoplast",
  "GO:0034401": "chromatin organization involved in regulation of transcription",
  "GO:0034402": "recruitment of 3'-end processing factors to RNA polymerase II holoenzyme complex",
  "GO:0034403": "alignment of 3' and 5' splice sites of mRNA",
  "GO:0034404": "nucleobase-containing small molecule biosynthetic process",
  "GO:0034405": "response to fluid shear stress",
  "GO:0034406": "cell wall beta-glucan metabolic process",
  "GO:0034407": "cell wall (1->3)-beta-D-glucan metabolic process",
  "GO:0034408": "ascospore wall beta-glucan metabolic process",
  "GO:0034409": "ascospore wall (1->3)-beta-D-glucan metabolic process",
  "GO:0034410": "cell wall beta-glucan biosynthetic process",
  "GO:0034411": "cell wall (1->3)-beta-D-glucan biosynthetic process",
  "GO:0034412": "ascospore wall beta-glucan biosynthetic process",
  "GO:0034413": "ascospore wall (1->3)-beta-D-glucan biosynthetic process",
  "GO:0034414": "tRNA 3'-trailer cleavage, endonucleolytic",
  "GO:0034415": "tRNA 3'-trailer cleavage, exonucleolytic",
  "GO:0034416": "bisphosphoglycerate phosphatase activity",
  "GO:0034417": "bisphosphoglycerate 3-phosphatase activity",
  "GO:0034418": "urate biosynthetic process",
  "GO:0034419": "L-2-hydroxyglutarate oxidase activity",
  "GO:0034420": "co-translational protein acetylation",
  "GO:0034421": "post-translational protein acetylation",
  "GO:0034422": "aleurone grain lumen",
  "GO:0034423": "autophagosome lumen",
  "GO:0034424": "Vps55/Vps68 complex",
  "GO:0034425": "etioplast envelope",
  "GO:0034426": "etioplast membrane",
  "GO:0034427": "nuclear-transcribed mRNA catabolic process, exonucleolytic, 3'-5'",
  "GO:0034428": "nuclear-transcribed mRNA catabolic process, exonucleolytic, 5'-3'",
  "GO:0034429": "tectobulbar tract morphogenesis",
  "GO:0034430": "monolayer-surrounded lipid storage body outer lipid monolayer",
  "GO:0034431": "bis(5'-adenosyl)-hexaphosphatase activity",
  "GO:0034432": "bis(5'-adenosyl)-pentaphosphatase activity",
  "GO:0034433": "steroid esterification",
  "GO:0034434": "sterol esterification",
  "GO:0034435": "cholesterol esterification",
  "GO:0034436": "glycoprotein transport",
  "GO:0034437": "glycoprotein transporter activity",
  "GO:0034438": "lipoprotein amino acid oxidation",
  "GO:0034439": "lipoprotein lipid oxidation",
  "GO:0034440": "lipid oxidation",
  "GO:0034441": "plasma lipoprotein particle oxidation",
  "GO:0034442": "regulation of lipoprotein oxidation",
  "GO:0034443": "negative regulation of lipoprotein oxidation",
  "GO:0034444": "regulation of plasma lipoprotein particle oxidation",
  "GO:0034445": "negative regulation of plasma lipoprotein particle oxidation",
  "GO:0034446": "substrate adhesion-dependent cell spreading",
  "GO:0034447": "very-low-density lipoprotein particle clearance",
  "GO:0034448": "EGO complex",
  "GO:0034450": "ubiquitin-ubiquitin ligase activity",
  "GO:0034451": "centriolar satellite",
  "GO:0034452": "dynactin binding",
  "GO:0034453": "microtubule anchoring",
  "GO:0034454": "microtubule anchoring at centrosome",
  "GO:0034455": "t-UTP complex",
  "GO:0034456": "UTP-C complex",
  "GO:0034457": "Mpp10 complex",
  "GO:0034458": "3'-5' RNA helicase activity",
  "GO:0034459": "ATP-dependent 3'-5' RNA helicase activity",
  "GO:0034460": "uropod assembly",
  "GO:0034461": "uropod retraction",
  "GO:0034462": "small-subunit processome assembly",
  "GO:0034463": "90S preribosome assembly",
  "GO:0034464": "BBSome",
  "GO:0034465": "response to carbon monoxide",
  "GO:0034466": "chromaffin granule lumen",
  "GO:0034467": "esterosome lumen",
  "GO:0034468": "glycosome lumen",
  "GO:0034469": "Golgi stack lumen",
  "GO:0034470": "ncRNA processing",
  "GO:0034471": "ncRNA 5'-end processing",
  "GO:0034472": "snRNA 3'-end processing",
  "GO:0034473": "U1 snRNA 3'-end processing",
  "GO:0034474": "U2 snRNA 3'-end processing",
  "GO:0034475": "U4 snRNA 3'-end processing",
  "GO:0034476": "U5 snRNA 3'-end processing",
  "GO:0034477": "U6 snRNA 3'-end processing",
  "GO:0034478": "phosphatidylglycerol catabolic process",
  "GO:0034479": "phosphatidylglycerol phospholipase C activity",
  "GO:0034480": "phosphatidylcholine phospholipase C activity",
  "GO:0034481": "chondroitin sulfotransferase activity",
  "GO:0034482": "chondroitin 2-O-sulfotransferase activity",
  "GO:0034483": "heparan sulfate sulfotransferase activity",
  "GO:0034484": "raffinose catabolic process",
  "GO:0034485": "phosphatidylinositol-3,4,5-trisphosphate 5-phosphatase activity",
  "GO:0034486": "vacuolar transmembrane transport",
  "GO:0034487": "vacuolar amino acid transmembrane transport",
  "GO:0034488": "basic amino acid transmembrane export from vacuole",
  "GO:0034489": "neutral amino acid transmembrane export from vacuole",
  "GO:0034490": "basic amino acid transmembrane import into vacuole",
  "GO:0034491": "neutral amino acid transmembrane import into vacuole",
  "GO:0034492": "hydrogenosome lumen",
  "GO:0034493": "melanosome lumen",
  "GO:0034494": "microneme lumen",
  "GO:0034495": "protein storage vacuole lumen",
  "GO:0034496": "multivesicular body membrane disassembly",
  "GO:0034497": "protein localization to pre-autophagosomal structure",
  "GO:0034498": "early endosome to Golgi transport",
  "GO:0034499": "late endosome to Golgi transport",
  "GO:0034501": "protein localization to kinetochore",
  "GO:0034502": "protein localization to chromosome",
  "GO:0034503": "protein localization to nucleolar rDNA repeats",
  "GO:0034504": "protein localization to nucleus",
  "GO:0034505": "tooth mineralization",
  "GO:0034506": "chromosome, centromeric core domain",
  "GO:0034507": "chromosome, centromeric outer repeat region",
  "GO:0034508": "centromere complex assembly",
  "GO:0034510": "centromere separation",
  "GO:0034511": "U3 snoRNA binding",
  "GO:0034512": "box C/D snoRNA binding",
  "GO:0034513": "box H/ACA snoRNA binding",
  "GO:0034514": "mitochondrial unfolded protein response",
  "GO:0034515": "proteasome storage granule",
  "GO:0034516": "response to vitamin B6",
  "GO:0034517": "ribophagy",
  "GO:0034518": "RNA cap binding complex",
  "GO:0034519": "cytoplasmic RNA cap binding complex",
  "GO:0034520": "2-naphthaldehyde dehydrogenase activity",
  "GO:0034521": "1-naphthoic acid dioxygenase activity",
  "GO:0034522": "cis-1,2-dihydroxy-1,2-dihydro-8-carboxynaphthalene dehydrogenase activity",
  "GO:0034523": "3-formylsalicylate oxidase activity",
  "GO:0034524": "2-hydroxyisophthalate decarboxylase activity",
  "GO:0034525": "1-naphthaldehyde dehydrogenase activity",
  "GO:0034526": "2-methylnaphthalene hydroxylase activity",
  "GO:0034527": "1,2-dihydroxy-8-carboxynaphthalene dioxygenase activity",
  "GO:0034528": "2-carboxy-2-hydroxy-8-carboxychromene isomerase activity",
  "GO:0034529": "2-hydroxy-3-carboxy-benzalpyruvate hydratase-aldolase activity",
  "GO:0034530": "4-hydroxymethylsalicyaldehyde dehydrogenase activity",
  "GO:0034531": "2-hydroxy-4-hydroxymethylbenzalpyruvate hydratase-aldolase activity",
  "GO:0034532": "2-hydroxy-7-hydroxymethylchromene-2-carboxylate isomerase activity",
  "GO:0034533": "1,2-dihydroxy-7-hydroxymethylnaphthalene dioxygenase activity",
  "GO:0034534": "1-methylnaphthalene hydroxylase activity",
  "GO:0034535": "1,2-dihydroxy-8-methylnaphthalene dioxygenase activity",
  "GO:0034536": "2-hydroxy-8-methylchromene-2-carboxylate isomerase activity",
  "GO:0034537": "2-hydroxy-3-methylbenzalpyruvate hydratase-aldolase activity",
  "GO:0034538": "3-methylsalicylaldehyde dehydrogenase activity",
  "GO:0034539": "3,3',5,5'-tetrabromobisphenol A reductive dehalogenase activity",
  "GO:0034540": "3-monobromobisphenol A reductive dehalogenase activity",
  "GO:0034541": "dimethylarsinite methyltransferase activity",
  "GO:0034542": "trimethylarsine oxidase activity",
  "GO:0034543": "5-aminosalicylate dioxygenase activity",
  "GO:0034544": "trans-ACOHDA hydrolase activity",
  "GO:0034545": "fumarylpyruvate hydrolase activity",
  "GO:0034546": "2,4-dichloroaniline reductive dehalogenase activity",
  "GO:0034547": "N-cyclopropylmelamine deaminase activity",
  "GO:0034548": "N-cyclopropylammeline deaminase activity",
  "GO:0034549": "N-cyclopropylammelide alkylamino hydrolase activity",
  "GO:0034550": "dimethylarsinate reductase activity",
  "GO:0034551": "mitochondrial respiratory chain complex III assembly",
  "GO:0034552": "respiratory chain complex II assembly",
  "GO:0034553": "mitochondrial respiratory chain complex II assembly",
  "GO:0034554": "3,3',5-tribromobisphenol A reductive dehalogenase activity",
  "GO:0034555": "3,3'-dibromobisphenol A reductive dehalogenase activity",
  "GO:0034556": "nitrobenzoate nitroreductase activity",
  "GO:0034557": "2-hydroxylaminobenzoate reductase activity",
  "GO:0034558": "technetium (VII) reductase activity",
  "GO:0034559": "bisphenol A hydroxylase B activity",
  "GO:0034560": "bisphenol A hydroxylase A activity",
  "GO:0034561": "1,2-bis(4-hydroxyphenyl)-2-proponol dehydratase activity",
  "GO:0034562": "2,2-bis(4-hydroxyphenyl)-1-propanol hydroxylase activity",
  "GO:0034563": "2,3-bis(4-hydroxyphenyl)-1,2-propanediol dioxygenase activity",
  "GO:0034564": "4,4'-dihydroxy-alpha-methylstilbene dioxygenase activity",
  "GO:0034565": "1-nitro-1,2-dihydro-1,3,5-triazine hydrolase activity",
  "GO:0034567": "chromate reductase activity",
  "GO:0034568": "isoproturon dimethylaminedehydrogenase activity",
  "GO:0034569": "monodemethylisoproturon dehydrogenase activity",
  "GO:0034570": "hydroxymonomethylisoproturon dimethylaminedehydrogenase activity",
  "GO:0034571": "4'-(2-hydroxyisopropyl)phenylurea amidohydrolase activity",
  "GO:0034572": "monodemethylisoproturon dimethylaminedehydrogenase activity",
  "GO:0034573": "didemethylisoproturon amidohydrolase activity",
  "GO:0034574": "didemethylisoproturon dehydrogenase activity",
  "GO:0034575": "4-isopropylaniline dehydrogenase activity",
  "GO:0034576": "N-isopropylacetanilide amidohydrolase activity",
  "GO:0034577": "N-isopropylacetaniline monooxygenase activity",
  "GO:0034578": "limonene 8-hydratase activity",
  "GO:0034579": "(1-methylpentyl)succinate synthase activity",
  "GO:0034580": "4-methyloctanoyl-CoA dehydrogenase activity",
  "GO:0034581": "4-methyloct-2-enoyl-CoA hydratase activity",
  "GO:0034582": "3-hydroxy-4-methyloctanoyl-CoA dehydrogenase activity",
  "GO:0034583": "21U-RNA binding",
  "GO:0034584": "piRNA binding",
  "GO:0034585": "21U-RNA metabolic process",
  "GO:0034586": "21U-RNA catabolic process",
  "GO:0034587": "piRNA metabolic process",
  "GO:0034588": "piRNA catabolic process",
  "GO:0034589": "hydroxyproline transport",
  "GO:0034590": "L-hydroxyproline transmembrane transporter activity",
  "GO:0034591": "rhoptry lumen",
  "GO:0034592": "synaptic vesicle lumen",
  "GO:0034593": "phosphatidylinositol bisphosphate phosphatase activity",
  "GO:0034594": "phosphatidylinositol trisphosphate phosphatase activity",
  "GO:0034595": "phosphatidylinositol phosphate 5-phosphatase activity",
  "GO:0034596": "phosphatidylinositol phosphate 4-phosphatase activity",
  "GO:0034597": "phosphatidylinositol-4,5-bisphosphate 4-phosphatase activity",
  "GO:0034598": "phosphothreonine lyase activity",
  "GO:0034599": "cellular response to oxidative stress",
  "GO:0034601": "oxoglutarate dehydrogenase [NAD(P)+] activity",
  "GO:0034602": "oxoglutarate dehydrogenase (NAD+) activity",
  "GO:0034603": "pyruvate dehydrogenase [NAD(P)+] activity",
  "GO:0034604": "pyruvate dehydrogenase (NAD+) activity",
  "GO:0034605": "cellular response to heat",
  "GO:0034606": "response to hermaphrodite contact",
  "GO:0034607": "turning behavior involved in mating",
  "GO:0034608": "vulval location",
  "GO:0034609": "spicule insertion",
  "GO:0034610": "oligodeoxyribonucleotidase activity",
  "GO:0034611": "oligoribonucleotidase activity",
  "GO:0034612": "response to tumor necrosis factor",
  "GO:0034613": "cellular protein localization",
  "GO:0034614": "cellular response to reactive oxygen species",
  "GO:0034615": "GCH1 complex",
  "GO:0034616": "response to laminar fluid shear stress",
  "GO:0034617": "tetrahydrobiopterin binding",
  "GO:0034618": "arginine binding",
  "GO:0034620": "cellular response to unfolded protein",
  "GO:0034622": "cellular macromolecular complex assembly",
  "GO:0034624": "DNA recombinase assembly involved in gene conversion at mating-type locus",
  "GO:0034625": "fatty acid elongation, monounsaturated fatty acid",
  "GO:0034626": "fatty acid elongation, polyunsaturated fatty acid",
  "GO:0034627": "'de novo' NAD biosynthetic process",
  "GO:0034628": "'de novo' NAD biosynthetic process from aspartate",
  "GO:0034629": "cellular protein complex localization",
  "GO:0034630": "RITS complex localization",
  "GO:0034631": "microtubule anchoring at spindle pole body",
  "GO:0034632": "retinol transporter activity",
  "GO:0034633": "retinol transport",
  "GO:0034634": "glutathione transmembrane transporter activity",
  "GO:0034635": "glutathione transport",
  "GO:0034636": "strand invasion involved in gene conversion at mating-type locus",
  "GO:0034637": "cellular carbohydrate biosynthetic process",
  "GO:0034638": "phosphatidylcholine catabolic process",
  "GO:0034639": "L-amino acid efflux transmembrane transporter activity",
  "GO:0034640": "establishment of mitochondrion localization by microtubule attachment",
  "GO:0034641": "cellular nitrogen compound metabolic process",
  "GO:0034642": "mitochondrion migration along actin filament",
  "GO:0034643": "establishment of mitochondrion localization, microtubule-mediated",
  "GO:0034644": "cellular response to UV",
  "GO:0034645": "cellular macromolecule biosynthetic process",
  "GO:0034646": "organelle-enclosing lipid monolayer",
  "GO:0034647": "histone demethylase activity (H3-trimethyl-K4 specific)",
  "GO:0034648": "histone demethylase activity (H3-dimethyl-K4 specific)",
  "GO:0034649": "histone demethylase activity (H3-monomethyl-K4 specific)",
  "GO:0034650": "cortisol metabolic process",
  "GO:0034651": "cortisol biosynthetic process",
  "GO:0034652": "extrachromosomal circular DNA localization involved in cell aging",
  "GO:0034653": "retinoic acid catabolic process",
  "GO:0034654": "nucleobase-containing compound biosynthetic process",
  "GO:0034655": "nucleobase-containing compound catabolic process",
  "GO:0034656": "nucleobase-containing small molecule catabolic process",
  "GO:0034657": "GID complex",
  "GO:0034658": "isopropylmalate transmembrane transporter activity",
  "GO:0034659": "isopropylmalate transport",
  "GO:0034660": "ncRNA metabolic process",
  "GO:0034661": "ncRNA catabolic process",
  "GO:0034662": "CFTR-NHERF-ezrin complex",
  "GO:0034663": "endoplasmic reticulum chaperone complex",
  "GO:0034664": "Ig heavy chain-bound endoplasmic reticulum chaperone complex",
  "GO:0034665": "integrin alpha1-beta1 complex",
  "GO:0034666": "integrin alpha2-beta1 complex",
  "GO:0034667": "integrin alpha3-beta1 complex",
  "GO:0034668": "integrin alpha4-beta1 complex",
  "GO:0034669": "integrin alpha4-beta7 complex",
  "GO:0034670": "chemotaxis to arachidonic acid",
  "GO:0034671": "retinoic acid receptor signaling pathway involved in pronephros anterior/posterior pattern specification",
  "GO:0034672": "anterior/posterior pattern specification involved in pronephros development",
  "GO:0034673": "inhibin-betaglycan-ActRII complex",
  "GO:0034674": "integrin alpha5-beta1 complex",
  "GO:0034675": "integrin alpha6-beta1 complex",
  "GO:0034676": "integrin alpha6-beta4 complex",
  "GO:0034677": "integrin alpha7-beta1 complex",
  "GO:0034678": "integrin alpha8-beta1 complex",
  "GO:0034679": "integrin alpha9-beta1 complex",
  "GO:0034680": "integrin alpha10-beta1 complex",
  "GO:0034681": "integrin alpha11-beta1 complex",
  "GO:0034682": "integrin alphav-beta1 complex",
  "GO:0034683": "integrin alphav-beta3 complex",
  "GO:0034684": "integrin alphav-beta5 complex",
  "GO:0034685": "integrin alphav-beta6 complex",
  "GO:0034686": "integrin alphav-beta8 complex",
  "GO:0034687": "integrin alphaL-beta2 complex",
  "GO:0034688": "integrin alphaM-beta2 complex",
  "GO:0034689": "integrin alphaX-beta2 complex",
  "GO:0034690": "integrin alphaD-beta2 complex",
  "GO:0034691": "integrin alphaE-beta7 complex",
  "GO:0034692": "E.F.G complex",
  "GO:0034693": "U11/U12 snRNP",
  "GO:0034694": "response to prostaglandin",
  "GO:0034695": "response to prostaglandin E",
  "GO:0034696": "response to prostaglandin F",
  "GO:0034697": "response to prostaglandin I",
  "GO:0034698": "response to gonadotropin",
  "GO:0034699": "response to luteinizing hormone",
  "GO:0034700": "allulose 6-phosphate 3-epimerase activity",
  "GO:0034701": "tripeptidase activity",
  "GO:0034702": "ion channel complex",
  "GO:0034703": "cation channel complex",
  "GO:0034704": "calcium channel complex",
  "GO:0034705": "potassium channel complex",
  "GO:0034706": "sodium channel complex",
  "GO:0034707": "chloride channel complex",
  "GO:0034708": "methyltransferase complex",
  "GO:0034709": "methylosome",
  "GO:0034710": "inhibin complex binding",
  "GO:0034711": "inhibin binding",
  "GO:0034713": "type I transforming growth factor beta receptor binding",
  "GO:0034714": "type III transforming growth factor beta receptor binding",
  "GO:0034715": "pICln-Sm protein complex",
  "GO:0034716": "Gemin3-Gemin4-Gemin5 complex",
  "GO:0034717": "Gemin6-Gemin7-unrip complex",
  "GO:0034718": "SMN-Gemin2 complex",
  "GO:0034719": "SMN-Sm protein complex",
  "GO:0034720": "histone H3-K4 demethylation",
  "GO:0034721": "histone H3-K4 demethylation, trimethyl-H3-K4-specific",
  "GO:0034722": "gamma-glutamyl-peptidase activity",
  "GO:0034723": "DNA replication-dependent nucleosome organization",
  "GO:0034724": "DNA replication-independent nucleosome organization",
  "GO:0034725": "DNA replication-dependent nucleosome disassembly",
  "GO:0034726": "DNA replication-independent nucleosome disassembly",
  "GO:0034727": "piecemeal microautophagy of nucleus",
  "GO:0034728": "nucleosome organization",
  "GO:0034729": "histone H3-K79 methylation",
  "GO:0034730": "SmD-containing SMN-Sm protein complex",
  "GO:0034731": "Lsm-containing SMN-Sm protein complex",
  "GO:0034732": "transcription factor TFIIIB-alpha complex",
  "GO:0034733": "transcription factor TFIIIB-beta complex",
  "GO:0034734": "transcription factor TFIIIC1 complex",
  "GO:0034735": "transcription factor TFIIIC2 complex",
  "GO:0034736": "cholesterol O-acyltransferase activity",
  "GO:0034737": "ergosterol O-acyltransferase activity",
  "GO:0034738": "lanosterol O-acyltransferase activity",
  "GO:0034739": "histone deacetylase activity (H4-K16 specific)",
  "GO:0034740": "TFIIIC-TOP1-SUB1 complex",
  "GO:0034741": "APC-tubulin-IQGAP1 complex",
  "GO:0034743": "APC-IQGAP complex",
  "GO:0034744": "APC-IQGAP1-Cdc42 complex",
  "GO:0034745": "APC-IQGAP1-Rac1 complex",
  "GO:0034746": "APC-IQGAP1-CLIP-170 complex",
  "GO:0034748": "Par3-APC-KIF3A complex",
  "GO:0034749": "Scrib-APC complex",
  "GO:0034750": "Scrib-APC-beta-catenin complex",
  "GO:0034751": "aryl hydrocarbon receptor complex",
  "GO:0034752": "cytosolic aryl hydrocarbon receptor complex",
  "GO:0034753": "nuclear aryl hydrocarbon receptor complex",
  "GO:0034754": "cellular hormone metabolic process",
  "GO:0034755": "iron ion transmembrane transport",
  "GO:0034756": "regulation of iron ion transport",
  "GO:0034757": "negative regulation of iron ion transport",
  "GO:0034758": "positive regulation of iron ion transport",
  "GO:0034759": "regulation of iron ion transmembrane transport",
  "GO:0034760": "negative regulation of iron ion transmembrane transport",
  "GO:0034761": "positive regulation of iron ion transmembrane transport",
  "GO:0034762": "regulation of transmembrane transport",
  "GO:0034763": "negative regulation of transmembrane transport",
  "GO:0034764": "positive regulation of transmembrane transport",
  "GO:0034765": "regulation of ion transmembrane transport",
  "GO:0034766": "negative regulation of ion transmembrane transport",
  "GO:0034767": "positive regulation of ion transmembrane transport",
  "GO:0034768": "(E)-beta-ocimene synthase activity",
  "GO:0034769": "basement membrane disassembly",
  "GO:0034770": "histone H4-K20 methylation",
  "GO:0034771": "histone H4-K20 monomethylation",
  "GO:0034772": "histone H4-K20 dimethylation",
  "GO:0034773": "histone H4-K20 trimethylation",
  "GO:0034774": "secretory granule lumen",
  "GO:0034775": "glutathione transmembrane transport",
  "GO:0034776": "response to histamine",
  "GO:0034777": "recycling endosome lumen",
  "GO:0034778": "2-hydroxy-4-isopropenylcyclohexane-1-carboxyl-CoA dehydrogenase activity",
  "GO:0034779": "4-isopropenyl-2-ketocyclohexane-1-carboxyl-CoA hydrolase activity",
  "GO:0034780": "glyphosate dehydrogenase activity",
  "GO:0034781": "N-cyclohexylformamide amidohydrolase activity",
  "GO:0034782": "dimethylmalonate decarboxylase activity",
  "GO:0034783": "pivalate-CoA ligase activity",
  "GO:0034784": "pivalyl-CoA mutase activity",
  "GO:0034785": "salicylate 5-hydroxylase activity",
  "GO:0034786": "9-fluorenone-3,4-dioxygenase activity",
  "GO:0034787": "1-hydro-1,1a-dihydroxy-9-fluorenone dehydrogenase activity",
  "GO:0034788": "2,3-dihydroxy-2'-carboxybiphenyl 1,2-dioxygenase activity",
  "GO:0034789": "2-hydroxy-6-oxo-6-(2-carboxyphenyl)-hexa-2,4-dienoate hydrolase activity",
  "GO:0034790": "3,4-dihydroxy-3,4-dihydrofluorene dehydrogenase activity",
  "GO:0034791": "isobutylamine N-hydroxylase activity",
  "GO:0034792": "hypophosphite dioxygenase activity",
  "GO:0034793": "cyclopropanecarboxylate-CoA ligase activity",
  "GO:0034794": "cyclopropanecarboxyl-CoA decyclase activity",
  "GO:0034795": "cyclohexane monooxygenase activity",
  "GO:0034796": "adipate-CoA ligase activity",
  "GO:0034797": "fosfomycin 2-glutathione ligase activity",
  "GO:0034798": "fosfomycin 2-L-cysteine ligase activity",
  "GO:0034799": "dihydride TNP tautomerase activity",
  "GO:0034800": "trinitrophenol dihydride denitratase activity",
  "GO:0034801": "2,4-dinitrocyclohexanone hydrolase activity",
  "GO:0034802": "branched-chain dodecylbenzene sulfonate monooxygenase activity",
  "GO:0034803": "3-hydroxy-2-naphthoate 2,3-dioxygenase activity",
  "GO:0034804": "benzo(a)pyrene 11,12-epoxidase activity",
  "GO:0034805": "benzo(a)pyrene-trans-11,12-dihydrodiol dehydrogenase activity",
  "GO:0034806": "benzo(a)pyrene 11,12-dioxygenase activity",
  "GO:0034807": "4,5-dihydroxybenzo(a)pyrene methyltransferase activity",
  "GO:0034808": "benzo(a)pyrene 4,5-dioxygenase activity",
  "GO:0034809": "benzo(a)pyrene-cis-4,5-dihydrodiol dehydrogenase activity",
  "GO:0034810": "4,5-dihydroxybenzo(a)pyrene dioxygenase activity",
  "GO:0034811": "benzo(a)pyrene 9,10-dioxygenase activity",
  "GO:0034812": "9,10-dihydroxybenzo(a)pyrene dioxygenase activity",
  "GO:0034813": "benzo(a)pyrene 7,8-dioxygenase activity",
  "GO:0034814": "7,8-dihydroxy benzo(a)pyrene dioxygenase activity",
  "GO:0034815": "cis-4-(8-hydroxypyren-7-yl)-2-oxobut-3-enoate lyase activity",
  "GO:0034816": "anthracene 9,10-dioxygenase activity",
  "GO:0034817": "cis-9,10-dihydroanthracene-9,10-diol dehydrogenase activity",
  "GO:0034818": "ADD 9alpha-hydroxylase activity",
  "GO:0034819": "3-HSA hydroxylase activity",
  "GO:0034820": "4,9-DSHA hydrolase activity",
  "GO:0034821": "citronellol dehydrogenase activity",
  "GO:0034822": "citronellal dehydrogenase activity",
  "GO:0034823": "citronellyl-CoA ligase activity",
  "GO:0034824": "citronellyl-CoA dehydrogenase activity",
  "GO:0034825": "tetralin ring-hydroxylating dioxygenase activity",
  "GO:0034826": "1,2-dihydroxy-1,2,5,6,7,8-hexyhadronaphthalene dehydrogenase activity",
  "GO:0034827": "1,2-dihydroxy-5,6,7,8-tetrahydronaphthalene extradiol dioxygenase activity",
  "GO:0034828": "4-(2-oxocyclohexyl)-2-hydroxy-buta-2,4-dienoate hydrolase activity",
  "GO:0034829": "2-hydroxydec-2,4-diene-1,10-dioate hydratase activity",
  "GO:0034830": "(2Z)-2,4-dihydroxydec-2-enedioate aldolase activity",
  "GO:0034831": "(R)-(-)-1,2,3,4-tetrahydronaphthol dehydrogenase activity",
  "GO:0034832": "geranial dehydrogenase activity",
  "GO:0034833": "geranylate CoA-transferase activity",
  "GO:0034834": "2-mercaptobenzothiazole dioxygenase activity",
  "GO:0034835": "2-mercaptobenzothiazole monooxygenase activity",
  "GO:0034836": "6-hydroxy-2-mercaptobenzothiazole monooxygenase activity",
  "GO:0034837": "2-mercaptobenzothiazole-cis-6,7-dihydrodiol dehydrogenase activity",
  "GO:0034838": "menthone dehydrogenase activity",
  "GO:0034839": "menth-2-enone hydratase activity",
  "GO:0034840": "3-hydroxymenthone dehydrogenase activity",
  "GO:0034841": "mentha-1,3-dione-CoA ligase activity",
  "GO:0034842": "thiophene-2-carboxylate-CoA ligase activity",
  "GO:0034843": "2-oxoglutaryl-CoA thioesterase activity",
  "GO:0034844": "naphthyl-2-methyl-succinate CoA-transferase activity",
  "GO:0034845": "naphthyl-2-methyl-succinyl-CoA dehydrogenase activity",
  "GO:0034846": "naphthyl-2-methylene-succinyl-CoA lyase activity",
  "GO:0034847": "naphthyl-2-hydroxymethyl-succinyl-CoA dehydrogenase activity",
  "GO:0034848": "naphthyl-2-oxomethyl-succinyl-CoA succinyl transferase activity",
  "GO:0034849": "2-naphthoate CoA-transferase activity",
  "GO:0034850": "isooctane monooxygenase activity",
  "GO:0034851": "2,4,4-trimethyl-3-oxopentanoyl-CoA 2-C-propanoyl transferase activity",
  "GO:0034852": "4,4-dimethyl-3-oxopentanal dehydrogenase activity",
  "GO:0034853": "2,4,4-trimethyl-3-oxopentanoate decarboxylase activity",
  "GO:0034854": "4,4-dimethyl-3-oxopentanoate decarboxylase activity",
  "GO:0034855": "4-AD 9alpha-hydroxylase activity",
  "GO:0034856": "2-hydroxyhexa-2,4-dienoate hydratase activity",
  "GO:0034857": "2-(methylthio)benzothiazole monooxygenase activity",
  "GO:0034858": "2-hydroxybenzothiazole monooxygenase activity",
  "GO:0034859": "benzothiazole monooxygenase activity",
  "GO:0034860": "2-mercaptobenzothiazole desulfurase activity",
  "GO:0034861": "benzothiazole-2-sulfonate hydrolase activity",
  "GO:0034862": "2,6-dihydroxybenzothiazole monooxygenase activity",
  "GO:0034863": "2,4,4-trimethyl-1-pentanol dehydrogenase activity",
  "GO:0034864": "2,4,4-trimethylpentanal dehydrogenase activity",
  "GO:0034865": "2,4,4-trimethylpentanoate-CoA ligase activity",
  "GO:0034866": "2,4,4-trimethylpentanoyl-CoA dehydrogenase activity",
  "GO:0034867": "2,4,4-trimethylpent-2-enoyl-CoA hydratase activity",
  "GO:0034868": "2,4,4-trimethyl-3-hydroxypentanoyl-CoA dehydrogenase activity",
  "GO:0034869": "2,4,4-trimethyl-3-oxopentanoyl-CoA thioesterase activity",
  "GO:0034870": "pinacolone 5-monooxygenase activity",
  "GO:0034871": "1-hydroxy-4,4-dimethylpentan-3-one dehydrogenase activity",
  "GO:0034872": "trans-geranyl-CoA isomerase activity",
  "GO:0034873": "thioacetamide S-oxygenase activity",
  "GO:0034874": "thioacetamide S-oxide S-oxygenase activity",
  "GO:0034875": "caffeine oxidase activity",
  "GO:0034876": "isonicotinic acid hydrazide hydrolase activity",
  "GO:0034877": "isonicotinate dehydrogenase activity",
  "GO:0034878": "2-hydroxyisonicotinate dehydrogenase activity",
  "GO:0034879": "2,3,6-trihydroxyisonicotinate decarboxylase activity",
  "GO:0034880": "citrazinate dehydrogenase activity",
  "GO:0034881": "citrazinate hydrolase activity",
  "GO:0034882": "cis-aconitamide amidase activity",
  "GO:0034883": "obsolete isonicotinate reductase activity",
  "GO:0034884": "obsolete gamma-N-formylaminovinylacetaldehyde dehydrogenase activity",
  "GO:0034885": "gamma-N-formylaminovinylacetate hydrolase activity",
  "GO:0034886": "gamma-aminovinylacetate deaminase activity",
  "GO:0034887": "obsolete 1,4-dihydroisonicotinate 2,3-dioxygenase activity",
  "GO:0034888": "endosulfan monooxygenase I activity",
  "GO:0034889": "endosulfan hemisulfate sulfatase activity",
  "GO:0034890": "endosulfan diol hydrolyase (cyclizing) activity",
  "GO:0034891": "endosulfan diol dehydrogenase activity",
  "GO:0034892": "endosulfan lactone lactonase activity",
  "GO:0034893": "N-nitrodimethylamine hydroxylase activity",
  "GO:0034894": "4-hydroxypyridine-3-hydroxylase activity",
  "GO:0034895": "pyridine-3,4-diol dioxygenase activity",
  "GO:0034896": "3-formiminopyruvate hydrolase activity",
  "GO:0034897": "4-(1-ethyl-1,4-dimethyl-pentyl)phenol monoxygenase activity",
  "GO:0034898": "hexadecyltrimethylammonium chloride monooxygenase activity",
  "GO:0034899": "trimethylamine monooxygenase activity",
  "GO:0034900": "3-(N-formyl)-formiminopyruvate hydrolase activity",
  "GO:0034901": "endosulfan hydroxyether dehydrogenase activity",
  "GO:0034902": "endosulfan sulfate hydrolase activity",
  "GO:0034903": "endosulfan ether monooxygenase activity",
  "GO:0034904": "5-chloro-2-oxopent-4-enoate hydratase activity",
  "GO:0034905": "5-chloro-4-hydroxy-2-oxopentanate aldolase activity",
  "GO:0034906": "N-isopropylaniline 1,2-dixoxygenase activity",
  "GO:0034907": "acetanilide 1,2-dioxygenase activity",
  "GO:0034908": "2-chloro-N-isopropylacetanilide 1,2-dioxygenase activity",
  "GO:0034909": "6-hydroxypseudooxynicotine dehydrogenase activity",
  "GO:0034910": "6-hydroxy-3-succinoylpyridine hydrolase activity",
  "GO:0034911": "phthalate 3,4-dioxygenase activity",
  "GO:0034912": "phthalate 3,4-cis-dihydrodiol dehydrogenase activity",
  "GO:0034914": "trinitrophenol hydride denitratase activity",
  "GO:0034915": "2-methylhexanoyl-CoA C-acetyltransferase activity",
  "GO:0034916": "2-methylhexanoyl-CoA dehydrogenase activity",
  "GO:0034917": "2-methylhex-2-enoyl-CoA hydratase activity",
  "GO:0034918": "3-hydroxy-2-methylhexanoyl-CoA dehydrogenase activity",
  "GO:0034919": "butyryl-CoA 2-C-propionyltransferase activity",
  "GO:0034920": "pyrene dioxygenase activity",
  "GO:0034921": "cis-4,5-dihydroxy-4,5-dihydropyrene dehydrogenase activity",
  "GO:0034922": "4,5-dihydroxypyrene dioxygenase activity",
  "GO:0034923": "phenanthrene-4,5-dicarboxylate decarboxylase activity",
  "GO:0034924": "cis-3,4-phenanthrenedihydrodiol-4-carboxylate dehydrogenase activity",
  "GO:0034925": "pyrene 4,5-monooxygenase activity",
  "GO:0034926": "pyrene-4,5-epoxide hydrolase activity",
  "GO:0034927": "pyrene 1,2-monooxygenase activity",
  "GO:0034928": "1-hydroxypyrene 6,7-monooxygenase activity",
  "GO:0034929": "1-hydroxypyrene 7,8-monooxygenase activity",
  "GO:0034930": "1-hydroxypyrene sulfotransferase activity",
  "GO:0034931": "1-hydroxypyrene methyltransferase activity",
  "GO:0034932": "1-methoxypyrene 6,7-monooxygenase activity",
  "GO:0034933": "1-hydroxy-6-methoxypyrene methyltransferase activity",
  "GO:0034934": "phenanthrene-4-carboxylate dioxygenase activity",
  "GO:0034935": "tetrachlorobenzene dioxygenase activity",
  "GO:0034936": "4,6-dichloro-3-methylcatechol 1,2-dioxygenase activity",
  "GO:0034937": "perchlorate reductase activity",
  "GO:0034938": "pyrrole-2-carboxylate monooxygenase activity",
  "GO:0034939": "5-hydroxypyrrole-2-carboxylate tautomerase activity",
  "GO:0034940": "5-oxo-4,5-dihydropyrrole-2-carboxylate amidase activity",
  "GO:0034941": "pyrrole-2-carboxylate decarboxylase activity",
  "GO:0034942": "cis-2-methyl-5-isopropylhexa-2,5-dienoate-CoA ligase activity",
  "GO:0034943": "trans-2-methyl-5-isopropylhexa-2,5-dienoate-CoA ligase activity",
  "GO:0034944": "3-hydroxy-2,6-dimethyl-5-methylene-heptanoyl-CoA dehydrogenase activity",
  "GO:0034945": "2,6-dimethyl-5-methylene-3-oxo-heptanoyl-CoA C-acetyltransferase activity",
  "GO:0034946": "3-isopropylbut-3-enoyl-CoA thioesterase activity",
  "GO:0034947": "terephthalate decarboxylase activity",
  "GO:0034948": "2,6-dihydroxypseudooxynicotine hydrolase activity",
  "GO:0034949": "1,1-dichloroethane reductive dehalogenase activity",
  "GO:0034950": "phenylboronic acid monooxygenase activity",
  "GO:0034951": "o-hydroxylaminobenzoate mutase activity",
  "GO:0034952": "malonate semialdehyde decarboxylase activity",
  "GO:0034953": "perillyl-CoA hydratase activity",
  "GO:0034954": "diphenyl ether 2,3-dioxygenase activity",
  "GO:0034955": "2,3-dihydroxydiphenyl ether dioxygenase activity",
  "GO:0034956": "diphenyl ether 1,2-dioxygenase activity",
  "GO:0034957": "3-nitrophenol nitroreductase activity",
  "GO:0034958": "aminohydroquinone monooxygenase activity",
  "GO:0034959": "endothelin maturation",
  "GO:0034963": "box C/D snoRNA processing",
  "GO:0034964": "box H/ACA snoRNA processing",
  "GO:0034965": "intronic box C/D snoRNA processing",
  "GO:0034966": "intronic box H/ACA snoRNA processing",
  "GO:0034967": "Set3 complex",
  "GO:0034968": "histone lysine methylation",
  "GO:0034969": "histone arginine methylation",
  "GO:0034970": "histone H3-R2 methylation",
  "GO:0034971": "histone H3-R17 methylation",
  "GO:0034972": "histone H3-R26 methylation",
  "GO:0034973": "Sid2-Mob1 complex",
  "GO:0034974": "Swi5-Swi2 complex",
  "GO:0034975": "protein folding in endoplasmic reticulum",
  "GO:0034976": "response to endoplasmic reticulum stress",
  "GO:0034977": "ABIN2-NFKB1-MAP3K8 complex",
  "GO:0034978": "PDX1-PBX1b-MRG1 complex",
  "GO:0034979": "NAD-dependent protein deacetylase activity",
  "GO:0034980": "FHL2-CREB complex",
  "GO:0034981": "FHL3-CREB complex",
  "GO:0034982": "mitochondrial protein processing",
  "GO:0034983": "peptidyl-lysine deacetylation",
  "GO:0034985": "Ecsit-NDUFAF1 complex",
  "GO:0034986": "iron chaperone activity",
  "GO:0034987": "immunoglobulin receptor binding",
  "GO:0034988": "Fc-gamma receptor I complex binding",
  "GO:0034990": "nuclear mitotic cohesin complex",
  "GO:0034991": "nuclear meiotic cohesin complex",
  "GO:0034992": "microtubule organizing center attachment site",
  "GO:0034993": "LINC complex",
  "GO:0034994": "microtubule organizing center attachment site organization",
  "GO:0034995": "SC5b-7 complex",
  "GO:0034996": "RasGAP-Fyn-Lyn-Yes complex",
  "GO:0034997": "alphav-beta5 integrin-vitronectin complex",
  "GO:0034998": "oligosaccharyltransferase I complex",
  "GO:0034999": "oligosaccharyltransferase II complex",
  "GO:0035000": "oligosaccharyltransferase III complex",
  "GO:0035001": "dorsal trunk growth, open tracheal system",
  "GO:0035002": "liquid clearance, open tracheal system",
  "GO:0035003": "subapical complex",
  "GO:0035004": "phosphatidylinositol 3-kinase activity",
  "GO:0035005": "1-phosphatidylinositol-4-phosphate 3-kinase activity",
  "GO:0035006": "melanization defense response",
  "GO:0035007": "regulation of melanization defense response",
  "GO:0035008": "positive regulation of melanization defense response",
  "GO:0035009": "negative regulation of melanization defense response",
  "GO:0035010": "encapsulation of foreign target",
  "GO:0035011": "melanotic encapsulation of foreign target",
  "GO:0035012": "polytene chromosome, telomeric region",
  "GO:0035013": "myosuppressin receptor activity",
  "GO:0035014": "phosphatidylinositol 3-kinase regulator activity",
  "GO:0035015": "elongation of arista core",
  "GO:0035016": "elongation of arista lateral",
  "GO:0035017": "cuticle pattern formation",
  "GO:0035018": "adult chitin-based cuticle pattern formation",
  "GO:0035019": "somatic stem cell population maintenance",
  "GO:0035020": "regulation of Rac protein signal transduction",
  "GO:0035021": "negative regulation of Rac protein signal transduction",
  "GO:0035022": "positive regulation of Rac protein signal transduction",
  "GO:0035023": "regulation of Rho protein signal transduction",
  "GO:0035024": "negative regulation of Rho protein signal transduction",
  "GO:0035025": "positive regulation of Rho protein signal transduction",
  "GO:0035026": "leading edge cell differentiation",
  "GO:0035027": "leading edge cell fate commitment",
  "GO:0035028": "leading edge cell fate determination",
  "GO:0035029": "dorsal closure, leading edge cell fate commitment",
  "GO:0035032": "phosphatidylinositol 3-kinase complex, class III",
  "GO:0035033": "histone deacetylase regulator activity",
  "GO:0035034": "histone acetyltransferase regulator activity",
  "GO:0035035": "histone acetyltransferase binding",
  "GO:0035036": "sperm-egg recognition",
  "GO:0035037": "sperm entry",
  "GO:0035038": "female pronucleus assembly",
  "GO:0035039": "male pronucleus assembly",
  "GO:0035040": "sperm nuclear envelope removal",
  "GO:0035041": "sperm chromatin decondensation",
  "GO:0035042": "fertilization, exchange of chromosomal proteins",
  "GO:0035043": "male pronuclear envelope synthesis",
  "GO:0035044": "sperm aster formation",
  "GO:0035045": "sperm plasma membrane disassembly",
  "GO:0035046": "pronuclear migration",
  "GO:0035047": "centrosomal and pronuclear rotation",
  "GO:0035048": "splicing factor protein import into nucleus",
  "GO:0035049": "juvenile hormone acid methyltransferase activity",
  "GO:0035050": "embryonic heart tube development",
  "GO:0035051": "cardiocyte differentiation",
  "GO:0035052": "dorsal vessel aortic cell fate commitment",
  "GO:0035053": "dorsal vessel heart proper cell fate commitment",
  "GO:0035054": "embryonic heart tube anterior/posterior pattern specification",
  "GO:0035058": "nonmotile primary cilium assembly",
  "GO:0035059": "RCAF complex",
  "GO:0035060": "brahma complex",
  "GO:0035061": "interchromatin granule",
  "GO:0035062": "omega speckle",
  "GO:0035063": "nuclear speck organization",
  "GO:0035064": "methylated histone binding",
  "GO:0035065": "regulation of histone acetylation",
  "GO:0035066": "positive regulation of histone acetylation",
  "GO:0035067": "negative regulation of histone acetylation",
  "GO:0035068": "micro-ribonucleoprotein complex",
  "GO:0035069": "larval midgut histolysis",
  "GO:0035070": "salivary gland histolysis",
  "GO:0035071": "salivary gland cell autophagic cell death",
  "GO:0035072": "ecdysone-mediated induction of salivary gland cell autophagic cell death",
  "GO:0035073": "pupariation",
  "GO:0035074": "pupation",
  "GO:0035075": "response to ecdysone",
  "GO:0035076": "ecdysone receptor-mediated signaling pathway",
  "GO:0035077": "ecdysone-mediated polytene chromosome puffing",
  "GO:0035078": "induction of programmed cell death by ecdysone",
  "GO:0035079": "polytene chromosome puffing",
  "GO:0035080": "heat shock-mediated polytene chromosome puffing",
  "GO:0035081": "induction of programmed cell death by hormones",
  "GO:0035082": "axoneme assembly",
  "GO:0035087": "siRNA loading onto RISC involved in RNA interference",
  "GO:0035088": "establishment or maintenance of apical/basal cell polarity",
  "GO:0035089": "establishment of apical/basal cell polarity",
  "GO:0035090": "maintenance of apical/basal cell polarity",
  "GO:0035091": "phosphatidylinositol binding",
  "GO:0035092": "sperm chromatin condensation",
  "GO:0035093": "spermatogenesis, exchange of chromosomal proteins",
  "GO:0035094": "response to nicotine",
  "GO:0035095": "behavioral response to nicotine",
  "GO:0035096": "larval midgut cell programmed cell death",
  "GO:0035097": "histone methyltransferase complex",
  "GO:0035098": "ESC/E(Z) complex",
  "GO:0035099": "hemocyte migration",
  "GO:0035100": "ecdysone binding",
  "GO:0035101": "FACT complex",
  "GO:0035102": "PRC1 complex",
  "GO:0035103": "sterol regulatory element binding protein cleavage",
  "GO:0035105": "sterol regulatory element binding protein import into nucleus",
  "GO:0035106": "operant conditioning",
  "GO:0035107": "appendage morphogenesis",
  "GO:0035108": "limb morphogenesis",
  "GO:0035109": "obsolete imaginal disc-derived limb morphogenesis",
  "GO:0035110": "obsolete leg morphogenesis",
  "GO:0035111": "obsolete leg joint morphogenesis",
  "GO:0035112": "genitalia morphogenesis",
  "GO:0035113": "embryonic appendage morphogenesis",
  "GO:0035114": "imaginal disc-derived appendage morphogenesis",
  "GO:0035115": "embryonic forelimb morphogenesis",
  "GO:0035116": "embryonic hindlimb morphogenesis",
  "GO:0035118": "embryonic pectoral fin morphogenesis",
  "GO:0035119": "embryonic pelvic fin morphogenesis",
  "GO:0035120": "post-embryonic appendage morphogenesis",
  "GO:0035121": "obsolete tail morphogenesis",
  "GO:0035122": "embryonic medial fin morphogenesis",
  "GO:0035123": "embryonic dorsal fin morphogenesis",
  "GO:0035124": "embryonic caudal fin morphogenesis",
  "GO:0035125": "embryonic anal fin morphogenesis",
  "GO:0035126": "post-embryonic genitalia morphogenesis",
  "GO:0035127": "post-embryonic limb morphogenesis",
  "GO:0035128": "post-embryonic forelimb morphogenesis",
  "GO:0035129": "post-embryonic hindlimb morphogenesis",
  "GO:0035130": "post-embryonic pectoral fin morphogenesis",
  "GO:0035131": "post-embryonic pelvic fin morphogenesis",
  "GO:0035132": "post-embryonic medial fin morphogenesis",
  "GO:0035133": "post-embryonic caudal fin morphogenesis",
  "GO:0035134": "post-embryonic dorsal fin morphogenesis",
  "GO:0035135": "post-embryonic anal fin morphogenesis",
  "GO:0035136": "forelimb morphogenesis",
  "GO:0035137": "hindlimb morphogenesis",
  "GO:0035138": "pectoral fin morphogenesis",
  "GO:0035139": "pelvic fin morphogenesis",
  "GO:0035141": "medial fin morphogenesis",
  "GO:0035142": "dorsal fin morphogenesis",
  "GO:0035143": "caudal fin morphogenesis",
  "GO:0035144": "anal fin morphogenesis",
  "GO:0035145": "exon-exon junction complex",
  "GO:0035146": "tube fusion",
  "GO:0035147": "branch fusion, open tracheal system",
  "GO:0035148": "tube formation",
  "GO:0035149": "lumen formation, open tracheal system",
  "GO:0035150": "regulation of tube size",
  "GO:0035151": "regulation of tube size, open tracheal system",
  "GO:0035152": "regulation of tube architecture, open tracheal system",
  "GO:0035153": "epithelial cell type specification, open tracheal system",
  "GO:0035154": "terminal cell fate specification, open tracheal system",
  "GO:0035155": "negative regulation of terminal cell fate specification, open tracheal system",
  "GO:0035156": "fusion cell fate specification",
  "GO:0035157": "negative regulation of fusion cell fate specification",
  "GO:0035158": "regulation of tube diameter, open tracheal system",
  "GO:0035159": "regulation of tube length, open tracheal system",
  "GO:0035160": "maintenance of epithelial integrity, open tracheal system",
  "GO:0035161": "imaginal disc lineage restriction",
  "GO:0035162": "embryonic hemopoiesis",
  "GO:0035163": "embryonic hemocyte differentiation",
  "GO:0035164": "embryonic plasmatocyte differentiation",
  "GO:0035165": "embryonic crystal cell differentiation",
  "GO:0035166": "post-embryonic hemopoiesis",
  "GO:0035167": "larval lymph gland hemopoiesis",
  "GO:0035168": "larval lymph gland hemocyte differentiation",
  "GO:0035169": "lymph gland plasmatocyte differentiation",
  "GO:0035170": "lymph gland crystal cell differentiation",
  "GO:0035171": "lamellocyte differentiation",
  "GO:0035172": "hemocyte proliferation",
  "GO:0035173": "histone kinase activity",
  "GO:0035174": "histone serine kinase activity",
  "GO:0035175": "histone kinase activity (H3-S10 specific)",
  "GO:0035176": "social behavior",
  "GO:0035177": "larval foraging behavior",
  "GO:0035178": "turning behavior",
  "GO:0035179": "larval turning behavior",
  "GO:0035180": "larval wandering behavior",
  "GO:0035181": "larval burrowing behavior",
  "GO:0035182": "female germline ring canal outer rim",
  "GO:0035183": "female germline ring canal inner rim",
  "GO:0035184": "histone threonine kinase activity",
  "GO:0035185": "preblastoderm mitotic cell cycle",
  "GO:0035186": "syncytial blastoderm mitotic cell cycle",
  "GO:0035187": "hatching behavior",
  "GO:0035188": "hatching",
  "GO:0035189": "Rb-E2F complex",
  "GO:0035190": "syncytial nuclear migration",
  "GO:0035191": "nuclear axial expansion",
  "GO:0035192": "nuclear cortical migration",
  "GO:0035193": "larval central nervous system remodeling",
  "GO:0035194": "posttranscriptional gene silencing by RNA",
  "GO:0035195": "gene silencing by miRNA",
  "GO:0035196": "production of miRNAs involved in gene silencing by miRNA",
  "GO:0035197": "siRNA binding",
  "GO:0035198": "miRNA binding",
  "GO:0035199": "salt aversion",
  "GO:0035200": "leg disc anterior/posterior pattern formation",
  "GO:0035201": "leg disc anterior/posterior lineage restriction",
  "GO:0035202": "tracheal pit formation in open tracheal system",
  "GO:0035203": "regulation of lamellocyte differentiation",
  "GO:0035204": "negative regulation of lamellocyte differentiation",
  "GO:0035205": "positive regulation of lamellocyte differentiation",
  "GO:0035206": "regulation of hemocyte proliferation",
  "GO:0035207": "negative regulation of hemocyte proliferation",
  "GO:0035208": "positive regulation of hemocyte proliferation",
  "GO:0035209": "pupal development",
  "GO:0035210": "prepupal development",
  "GO:0035211": "spermathecum morphogenesis",
  "GO:0035212": "cell competition in a multicellular organism",
  "GO:0035213": "clypeo-labral disc development",
  "GO:0035214": "eye-antennal disc development",
  "GO:0035215": "genital disc development",
  "GO:0035216": "haltere disc development",
  "GO:0035217": "labial disc development",
  "GO:0035218": "leg disc development",
  "GO:0035219": "prothoracic disc development",
  "GO:0035220": "wing disc development",
  "GO:0035221": "genital disc pattern formation",
  "GO:0035222": "wing disc pattern formation",
  "GO:0035223": "leg disc pattern formation",
  "GO:0035224": "genital disc anterior/posterior pattern formation",
  "GO:0035225": "determination of genital disc primordium",
  "GO:0035226": "glutamate-cysteine ligase catalytic subunit binding",
  "GO:0035227": "regulation of glutamate-cysteine ligase activity",
  "GO:0035228": "negative regulation of glutamate-cysteine ligase activity",
  "GO:0035229": "positive regulation of glutamate-cysteine ligase activity",
  "GO:0035230": "cytoneme",
  "GO:0035231": "cytoneme assembly",
  "GO:0035232": "germ cell attraction",
  "GO:0035233": "germ cell repulsion",
  "GO:0035234": "ectopic germ cell programmed cell death",
  "GO:0035235": "ionotropic glutamate receptor signaling pathway",
  "GO:0035236": "proctolin receptor activity",
  "GO:0035237": "corazonin receptor activity",
  "GO:0035238": "vitamin A biosynthetic process",
  "GO:0035239": "tube morphogenesis",
  "GO:0035240": "dopamine binding",
  "GO:0035241": "protein-arginine omega-N monomethyltransferase activity",
  "GO:0035242": "protein-arginine omega-N asymmetric methyltransferase activity",
  "GO:0035243": "protein-arginine omega-N symmetric methyltransferase activity",
  "GO:0035244": "peptidyl-arginine C-methyltransferase activity",
  "GO:0035245": "peptidyl-arginine C-methylation",
  "GO:0035246": "peptidyl-arginine N-methylation",
  "GO:0035247": "peptidyl-arginine omega-N-methylation",
  "GO:0035248": "alpha-1,4-N-acetylgalactosaminyltransferase activity",
  "GO:0035249": "synaptic transmission, glutamatergic",
  "GO:0035250": "UDP-galactosyltransferase activity",
  "GO:0035251": "UDP-glucosyltransferase activity",
  "GO:0035252": "UDP-xylosyltransferase activity",
  "GO:0035253": "ciliary rootlet",
  "GO:0035254": "glutamate receptor binding",
  "GO:0035255": "ionotropic glutamate receptor binding",
  "GO:0035256": "G-protein coupled glutamate receptor binding",
  "GO:0035257": "nuclear hormone receptor binding",
  "GO:0035258": "steroid hormone receptor binding",
  "GO:0035259": "glucocorticoid receptor binding",
  "GO:0035260": "internal genitalia morphogenesis",
  "GO:0035261": "external genitalia morphogenesis",
  "GO:0035262": "gonad morphogenesis",
  "GO:0035263": "genital disc sexually dimorphic development",
  "GO:0035264": "multicellular organism growth",
  "GO:0035265": "organ growth",
  "GO:0035266": "meristem growth",
  "GO:0035267": "NuA4 histone acetyltransferase complex",
  "GO:0035268": "protein mannosylation",
  "GO:0035269": "protein O-linked mannosylation",
  "GO:0035270": "endocrine system development",
  "GO:0035271": "ring gland development",
  "GO:0035272": "exocrine system development",
  "GO:0035273": "phthalate binding",
  "GO:0035274": "diphenyl phthalate binding",
  "GO:0035275": "dibutyl phthalate binding",
  "GO:0035276": "ethanol binding",
  "GO:0035277": "spiracle morphogenesis, open tracheal system",
  "GO:0035278": "miRNA mediated inhibition of translation",
  "GO:0035279": "mRNA cleavage involved in gene silencing by miRNA",
  "GO:0035280": "miRNA loading onto RISC involved in gene silencing by miRNA",
  "GO:0035281": "pre-miRNA export from nucleus",
  "GO:0035282": "segmentation",
  "GO:0035283": "central nervous system segmentation",
  "GO:0035284": "brain segmentation",
  "GO:0035285": "appendage segmentation",
  "GO:0035286": "obsolete leg segmentation",
  "GO:0035287": "head segmentation",
  "GO:0035288": "anterior head segmentation",
  "GO:0035289": "posterior head segmentation",
  "GO:0035290": "trunk segmentation",
  "GO:0035291": "specification of segmental identity, intercalary segment",
  "GO:0035292": "specification of segmental identity, trunk",
  "GO:0035293": "chitin-based larval cuticle pattern formation",
  "GO:0035294": "determination of wing disc primordium",
  "GO:0035295": "tube development",
  "GO:0035296": "regulation of tube diameter",
  "GO:0035297": "regulation of Malpighian tubule diameter",
  "GO:0035298": "regulation of Malpighian tubule size",
  "GO:0035299": "inositol pentakisphosphate 2-kinase activity",
  "GO:0035300": "obsolete inositol-1,3,4-trisphosphate 5/6-kinase activity",
  "GO:0035301": "Hedgehog signaling complex",
  "GO:0035302": "ecdysteroid 25-hydroxylase activity",
  "GO:0035303": "regulation of dephosphorylation",
  "GO:0035304": "regulation of protein dephosphorylation",
  "GO:0035305": "negative regulation of dephosphorylation",
  "GO:0035306": "positive regulation of dephosphorylation",
  "GO:0035307": "positive regulation of protein dephosphorylation",
  "GO:0035308": "negative regulation of protein dephosphorylation",
  "GO:0035309": "wing and notum subfield formation",
  "GO:0035310": "notum cell fate specification",
  "GO:0035311": "wing cell fate specification",
  "GO:0035312": "5'-3' exodeoxyribonuclease activity",
  "GO:0035313": "wound healing, spreading of epidermal cells",
  "GO:0035314": "scab formation",
  "GO:0035315": "hair cell differentiation",
  "GO:0035316": "non-sensory hair organization",
  "GO:0035317": "imaginal disc-derived wing hair organization",
  "GO:0035318": "imaginal disc-derived wing hair outgrowth",
  "GO:0035319": "imaginal disc-derived wing hair elongation",
  "GO:0035320": "imaginal disc-derived wing hair site selection",
  "GO:0035321": "maintenance of imaginal disc-derived wing hair orientation",
  "GO:0035322": "mesenchymal cell migration involved in limb bud formation",
  "GO:0035323": "male germline ring canal",
  "GO:0035324": "female germline ring canal",
  "GO:0035325": "Toll-like receptor binding",
  "GO:0035326": "enhancer binding",
  "GO:0035327": "transcriptionally active chromatin",
  "GO:0035328": "transcriptionally silent chromatin",
  "GO:0035329": "hippo signaling",
  "GO:0035330": "regulation of hippo signaling",
  "GO:0035331": "negative regulation of hippo signaling",
  "GO:0035332": "positive regulation of hippo signaling",
  "GO:0035333": "Notch receptor processing, ligand-dependent",
  "GO:0035334": "Notch receptor processing, ligand-independent",
  "GO:0035335": "peptidyl-tyrosine dephosphorylation",
  "GO:0035336": "long-chain fatty-acyl-CoA metabolic process",
  "GO:0035337": "fatty-acyl-CoA metabolic process",
  "GO:0035338": "long-chain fatty-acyl-CoA biosynthetic process",
  "GO:0035339": "SPOTS complex",
  "GO:0035340": "inosine transport",
  "GO:0035341": "regulation of inosine transport",
  "GO:0035342": "positive regulation of inosine transport",
  "GO:0035343": "negative regulation of inosine transport",
  "GO:0035344": "hypoxanthine transport",
  "GO:0035345": "regulation of hypoxanthine transport",
  "GO:0035346": "positive regulation of hypoxanthine transport",
  "GO:0035347": "negative regulation of hypoxanthine transport",
  "GO:0035348": "acetyl-CoA transmembrane transport",
  "GO:0035349": "coenzyme A transmembrane transport",
  "GO:0035350": "FAD transmembrane transport",
  "GO:0035351": "heme transmembrane transport",
  "GO:0035352": "NAD transmembrane transport",
  "GO:0035353": "nicotinamide mononucleotide transmembrane transport",
  "GO:0035354": "Toll-like receptor 1-Toll-like receptor 2 protein complex",
  "GO:0035355": "Toll-like receptor 2-Toll-like receptor 6 protein complex",
  "GO:0035356": "cellular triglyceride homeostasis",
  "GO:0035357": "peroxisome proliferator activated receptor signaling pathway",
  "GO:0035358": "regulation of peroxisome proliferator activated receptor signaling pathway",
  "GO:0035359": "negative regulation of peroxisome proliferator activated receptor signaling pathway",
  "GO:0035360": "positive regulation of peroxisome proliferator activated receptor signaling pathway",
  "GO:0035361": "Cul8-RING ubiquitin ligase complex",
  "GO:0035362": "protein-DNA ISRE complex assembly",
  "GO:0035363": "histone locus body",
  "GO:0035364": "thymine transport",
  "GO:0035365": "regulation of thymine transport",
  "GO:0035366": "negative regulation of thymine transport",
  "GO:0035367": "positive regulation of thymine transport",
  "GO:0035368": "selenocysteine insertion sequence binding",
  "GO:0035369": "pre-B cell receptor complex",
  "GO:0035370": "UBC13-UEV1A complex",
  "GO:0035371": "microtubule plus-end",
  "GO:0035372": "protein localization to microtubule",
  "GO:0035373": "chondroitin sulfate proteoglycan binding",
  "GO:0035374": "chondroitin sulfate binding",
  "GO:0035375": "zymogen binding",
  "GO:0035376": "sterol import",
  "GO:0035377": "transepithelial water transport",
  "GO:0035378": "carbon dioxide transmembrane transport",
  "GO:0035379": "carbon dioxide transmembrane transporter activity",
  "GO:0035380": "very long-chain-3-hydroxyacyl-CoA dehydrogenase activity",
  "GO:0035381": "ATP-gated ion channel activity",
  "GO:0035382": "sterol transmembrane transport",
  "GO:0035383": "thioester metabolic process",
  "GO:0035384": "thioester biosynthetic process",
  "GO:0035385": "Roundabout signaling pathway",
  "GO:0035386": "regulation of Roundabout signaling pathway",
  "GO:0035387": "negative regulation of Roundabout signaling pathway",
  "GO:0035388": "positive regulation of Roundabout signaling pathway",
  "GO:0035389": "establishment of chromatin silencing at silent mating-type cassette",
  "GO:0035390": "establishment of chromatin silencing at telomere",
  "GO:0035391": "maintenance of chromatin silencing at silent mating-type cassette",
  "GO:0035392": "maintenance of chromatin silencing at telomere",
  "GO:0035393": "chemokine (C-X-C motif) ligand 9 production",
  "GO:0035394": "regulation of chemokine (C-X-C motif) ligand 9 production",
  "GO:0035395": "negative regulation of chemokine (C-X-C motif) ligand 9 production",
  "GO:0035396": "positive regulation of chemokine (C-X-C motif) ligand 9 production",
  "GO:0035397": "helper T cell enhancement of adaptive immune response",
  "GO:0035398": "helper T cell enhancement of T cell mediated immune response",
  "GO:0035399": "helper T cell enhancement of B cell mediated immune response",
  "GO:0035400": "histone tyrosine kinase activity",
  "GO:0035401": "histone kinase activity (H3-Y41 specific)",
  "GO:0035402": "histone kinase activity (H3-T11 specific)",
  "GO:0035403": "histone kinase activity (H3-T6 specific)",
  "GO:0035404": "histone-serine phosphorylation",
  "GO:0035405": "histone-threonine phosphorylation",
  "GO:0035406": "histone-tyrosine phosphorylation",
  "GO:0035407": "histone H3-T11 phosphorylation",
  "GO:0035408": "histone H3-T6 phosphorylation",
  "GO:0035409": "histone H3-Y41 phosphorylation",
  "GO:0035410": "dihydrotestosterone 17-beta-dehydrogenase activity",
  "GO:0035411": "catenin import into nucleus",
  "GO:0035412": "regulation of catenin import into nucleus",
  "GO:0035413": "positive regulation of catenin import into nucleus",
  "GO:0035414": "negative regulation of catenin import into nucleus",
  "GO:0035415": "obsolete regulation of mitotic prometaphase",
  "GO:0035416": "obsolete positive regulation of mitotic prometaphase",
  "GO:0035417": "obsolete negative regulation of mitotic prometaphase",
  "GO:0035418": "protein localization to synapse",
  "GO:0035419": "activation of MAPK activity involved in innate immune response",
  "GO:0035420": "MAPK cascade involved in innate immune response",
  "GO:0035421": "activation of MAPKK activity involved in innate immune response",
  "GO:0035422": "activation of MAPKKK activity involved in innate immune response",
  "GO:0035423": "inactivation of MAPK activity involved in innate immune response",
  "GO:0035424": "MAPK import into nucleus involved in innate immune response",
  "GO:0035425": "autocrine signaling",
  "GO:0035426": "extracellular matrix-cell signaling",
  "GO:0035428": "hexose transmembrane transport",
  "GO:0035429": "gluconate transmembrane transport",
  "GO:0035430": "regulation of gluconate transmembrane transport",
  "GO:0035431": "negative regulation of gluconate transmembrane transport",
  "GO:0035432": "positive regulation of gluconate transmembrane transport",
  "GO:0035433": "acetate transmembrane transport",
  "GO:0035434": "copper ion transmembrane transport",
  "GO:0035435": "phosphate ion transmembrane transport",
  "GO:0035436": "triose phosphate transmembrane transport",
  "GO:0035437": "maintenance of protein localization in endoplasmic reticulum",
  "GO:0035438": "cyclic-di-GMP binding",
  "GO:0035439": "halimadienyl-diphosphate synthase activity",
  "GO:0035440": "tuberculosinol biosynthetic process",
  "GO:0035441": "cell migration involved in vasculogenesis",
  "GO:0035442": "dipeptide transmembrane transport",
  "GO:0035443": "tripeptide transmembrane transport",
  "GO:0035444": "nickel cation transmembrane transport",
  "GO:0035445": "borate transmembrane transport",
  "GO:0035446": "cysteine-glucosaminylinositol ligase activity",
  "GO:0035447": "mycothiol synthase activity",
  "GO:0035448": "extrinsic component of thylakoid membrane",
  "GO:0035449": "extrinsic component of plastid thylakoid membrane",
  "GO:0035450": "extrinsic component of lumenal side of plastid thylakoid membrane",
  "GO:0035451": "extrinsic component of stromal side of plastid thylakoid membrane",
  "GO:0035452": "extrinsic component of plastid membrane",
  "GO:0035453": "extrinsic component of plastid inner membrane",
  "GO:0035454": "extrinsic component of stromal side of plastid inner membrane",
  "GO:0035455": "response to interferon-alpha",
  "GO:0035456": "response to interferon-beta",
  "GO:0035457": "cellular response to interferon-alpha",
  "GO:0035458": "cellular response to interferon-beta",
  "GO:0035459": "cargo loading into vesicle",
  "GO:0035460": "L-ascorbate 6-phosphate lactonase activity",
  "GO:0035461": "vitamin transmembrane transport",
  "GO:0035462": "determination of left/right asymmetry in diencephalon",
  "GO:0035463": "transforming growth factor beta receptor signaling pathway involved in determination of left/right asymmetry",
  "GO:0035464": "regulation of transforming growth factor receptor beta signaling pathway involved in determination of left/right asymmetry",
  "GO:0035465": "obsolete regulation of transforming growth factor beta receptor signaling pathway involved in determination of lateral mesoderm left/right asymmetry",
  "GO:0035469": "determination of pancreatic left/right asymmetry",
  "GO:0035470": "positive regulation of vascular wound healing",
  "GO:0035471": "luteinizing hormone signaling pathway involved in ovarian follicle development",
  "GO:0035472": "choriogonadotropin hormone receptor activity",
  "GO:0035473": "lipase binding",
  "GO:0035474": "selective angioblast sprouting",
  "GO:0035475": "angioblast cell migration involved in selective angioblast sprouting",
  "GO:0035476": "angioblast cell migration",
  "GO:0035477": "regulation of angioblast cell migration involved in selective angioblast sprouting",
  "GO:0035478": "chylomicron binding",
  "GO:0035479": "angioblast cell migration from lateral mesoderm to midline",
  "GO:0035480": "regulation of Notch signaling pathway involved in heart induction",
  "GO:0035481": "positive regulation of Notch signaling pathway involved in heart induction",
  "GO:0035482": "gastric motility",
  "GO:0035483": "gastric emptying",
  "GO:0035484": "adenine/adenine mispair binding",
  "GO:0035485": "adenine/guanine mispair binding",
  "GO:0035486": "cytosine/cytosine mispair binding",
  "GO:0035487": "thymine/thymine mispair binding",
  "GO:0035488": "cytosine/thymine mispair binding",
  "GO:0035489": "guanine/guanine mispair binding",
  "GO:0035490": "regulation of leukotriene production involved in inflammatory response",
  "GO:0035491": "positive regulation of leukotriene production involved in inflammatory response",
  "GO:0035492": "negative regulation of leukotriene production involved in inflammatory response",
  "GO:0035493": "SNARE complex assembly",
  "GO:0035494": "SNARE complex disassembly",
  "GO:0035495": "regulation of SNARE complex disassembly",
  "GO:0035496": "lipopolysaccharide-1,5-galactosyltransferase activity",
  "GO:0035497": "cAMP response element binding",
  "GO:0035498": "carnosine metabolic process",
  "GO:0035499": "carnosine biosynthetic process",
  "GO:0035500": "MH2 domain binding",
  "GO:0035501": "MH1 domain binding",
  "GO:0035502": "metanephric part of ureteric bud development",
  "GO:0035503": "ureter part of ureteric bud development",
  "GO:0035504": "regulation of myosin light chain kinase activity",
  "GO:0035505": "positive regulation of myosin light chain kinase activity",
  "GO:0035506": "negative regulation of myosin light chain kinase activity",
  "GO:0035507": "regulation of myosin-light-chain-phosphatase activity",
  "GO:0035508": "positive regulation of myosin-light-chain-phosphatase activity",
  "GO:0035509": "negative regulation of myosin-light-chain-phosphatase activity",
  "GO:0035510": "DNA dealkylation",
  "GO:0035511": "oxidative DNA demethylation",
  "GO:0035512": "hydrolytic DNA demethylation",
  "GO:0035513": "oxidative RNA demethylation",
  "GO:0035514": "DNA demethylase activity",
  "GO:0035515": "oxidative RNA demethylase activity",
  "GO:0035516": "oxidative DNA demethylase activity",
  "GO:0035517": "PR-DUB complex",
  "GO:0035518": "histone H2A monoubiquitination",
  "GO:0035519": "protein K29-linked ubiquitination",
  "GO:0035520": "monoubiquitinated protein deubiquitination",
  "GO:0035521": "monoubiquitinated histone deubiquitination",
  "GO:0035522": "monoubiquitinated histone H2A deubiquitination",
  "GO:0035523": "protein K29-linked deubiquitination",
  "GO:0035524": "proline transmembrane transport",
  "GO:0035525": "NF-kappaB p50/p65 complex",
  "GO:0035526": "retrograde transport, plasma membrane to Golgi",
  "GO:0035527": "3-hydroxypropionate dehydrogenase (NADP+) activity",
  "GO:0035528": "UDP-N-acetylglucosamine biosynthesis involved in chitin biosynthesis",
  "GO:0035529": "NADH pyrophosphatase activity",
  "GO:0035530": "chemokine (C-C motif) ligand 6 production",
  "GO:0035531": "regulation of chemokine (C-C motif) ligand 6 production",
  "GO:0035532": "negative regulation of chemokine (C-C motif) ligand 6 production",
  "GO:0035533": "positive regulation of chemokine (C-C motif) ligand 6 production",
  "GO:0035534": "chemokine (C-C motif) ligand 6 secretion",
  "GO:0035535": "regulation of chemokine (C-C motif) ligand 6 secretion",
  "GO:0035536": "negative regulation of chemokine (C-C motif) ligand 6 secretion",
  "GO:0035537": "positive regulation of chemokine (C-C motif) ligand 6 secretion",
  "GO:0035538": "carbohydrate response element binding",
  "GO:0035539": "8-oxo-7,8-dihydrodeoxyguanosine triphosphate pyrophosphatase activity",
  "GO:0035540": "positive regulation of SNARE complex disassembly",
  "GO:0035541": "negative regulation of SNARE complex disassembly",
  "GO:0035542": "regulation of SNARE complex assembly",
  "GO:0035543": "positive regulation of SNARE complex assembly",
  "GO:0035544": "negative regulation of SNARE complex assembly",
  "GO:0035545": "determination of left/right asymmetry in nervous system",
  "GO:0035546": "interferon-beta secretion",
  "GO:0035547": "regulation of interferon-beta secretion",
  "GO:0035548": "negative regulation of interferon-beta secretion",
  "GO:0035549": "positive regulation of interferon-beta secretion",
  "GO:0035550": "urease complex",
  "GO:0035551": "protein initiator methionine removal involved in protein maturation",
  "GO:0035552": "oxidative single-stranded DNA demethylation",
  "GO:0035553": "oxidative single-stranded RNA demethylation",
  "GO:0035554": "termination of Roundabout signal transduction",
  "GO:0035555": "obsolete initiation of Roundabout signal transduction",
  "GO:0035556": "intracellular signal transduction",
  "GO:0035557": "obsolete intracellular signal transduction involved in cell surface receptor linked signaling",
  "GO:0035558": "obsolete phosphatidylinositol 3-kinase cascade involved in insulin receptor signaling",
  "GO:0035559": "obsolete MAPKKK cascade involved in epidermal growth factor receptor signaling",
  "GO:0035560": "pheophoridase activity",
  "GO:0035561": "regulation of chromatin binding",
  "GO:0035562": "negative regulation of chromatin binding",
  "GO:0035563": "positive regulation of chromatin binding",
  "GO:0035564": "regulation of kidney size",
  "GO:0035565": "regulation of pronephros size",
  "GO:0035566": "regulation of metanephros size",
  "GO:0035567": "non-canonical Wnt signaling pathway",
  "GO:0035568": "N-terminal peptidyl-proline methylation",
  "GO:0035569": "obsolete N-terminal peptidyl-proline trimethylation",
  "GO:0035570": "N-terminal peptidyl-serine methylation",
  "GO:0035571": "N-terminal peptidyl-serine monomethylation",
  "GO:0035572": "N-terminal peptidyl-serine dimethylation",
  "GO:0035573": "N-terminal peptidyl-serine trimethylation",
  "GO:0035574": "histone H4-K20 demethylation",
  "GO:0035575": "histone demethylase activity (H4-K20 specific)",
  "GO:0035576": "retinoic acid receptor signaling pathway involved in pronephric field specification",
  "GO:0035577": "azurophil granule membrane",
  "GO:0035578": "azurophil granule lumen",
  "GO:0035579": "specific granule membrane",
  "GO:0035580": "specific granule lumen",
  "GO:0035581": "sequestering of extracellular ligand from receptor",
  "GO:0035582": "sequestering of BMP in extracellular matrix",
  "GO:0035583": "sequestering of TGFbeta in extracellular matrix",
  "GO:0035584": "calcium-mediated signaling using intracellular calcium source",
  "GO:0035585": "calcium-mediated signaling using extracellular calcium source",
  "GO:0035586": "purinergic receptor activity",
  "GO:0035587": "purinergic receptor signaling pathway",
  "GO:0035588": "G-protein coupled purinergic receptor signaling pathway",
  "GO:0035589": "G-protein coupled purinergic nucleotide receptor signaling pathway",
  "GO:0035590": "purinergic nucleotide receptor signaling pathway",
  "GO:0035591": "signaling adaptor activity",
  "GO:0035592": "establishment of protein localization to extracellular region",
  "GO:0035593": "positive regulation of Wnt signaling pathway by establishment of Wnt protein localization to extracellular region",
  "GO:0035594": "ganglioside binding",
  "GO:0035595": "N-acetylglucosaminylinositol deacetylase activity",
  "GO:0035596": "methylthiotransferase activity",
  "GO:0035597": "N6-isopentenyladenosine methylthiotransferase activity",
  "GO:0035598": "N6-threonylcarbomyladenosine methylthiotransferase activity",
  "GO:0035599": "aspartic acid methylthiotransferase activity",
  "GO:0035600": "tRNA methylthiolation",
  "GO:0035601": "protein deacylation",
  "GO:0035602": "fibroblast growth factor receptor signaling pathway involved in negative regulation of apoptotic process in bone marrow",
  "GO:0035603": "fibroblast growth factor receptor signaling pathway involved in hemopoiesis",
  "GO:0035604": "fibroblast growth factor receptor signaling pathway involved in positive regulation of cell proliferation in bone marrow",
  "GO:0035605": "peptidyl-cysteine S-nitrosylase activity",
  "GO:0035606": "peptidyl-cysteine S-trans-nitrosylation",
  "GO:0035607": "fibroblast growth factor receptor signaling pathway involved in orbitofrontal cortex development",
  "GO:0035608": "protein deglutamylation",
  "GO:0035609": "C-terminal protein deglutamylation",
  "GO:0035610": "protein side chain deglutamylation",
  "GO:0035611": "protein branching point deglutamylation",
  "GO:0035612": "AP-2 adaptor complex binding",
  "GO:0035613": "RNA stem-loop binding",
  "GO:0035614": "snRNA stem-loop binding",
  "GO:0035615": "clathrin adaptor activity",
  "GO:0035616": "histone H2B conserved C-terminal lysine deubiquitination",
  "GO:0035617": "stress granule disassembly",
  "GO:0035618": "root hair",
  "GO:0035619": "root hair tip",
  "GO:0035620": "ceramide transporter activity",
  "GO:0035621": "ER to Golgi ceramide transport",
  "GO:0035622": "intrahepatic bile duct development",
  "GO:0035623": "renal glucose absorption",
  "GO:0035624": "receptor transactivation",
  "GO:0035625": "epidermal growth factor-activated receptor transactivation by G-protein coupled receptor signaling pathway",
  "GO:0035626": "juvenile hormone mediated signaling pathway",
  "GO:0035627": "ceramide transport",
  "GO:0035628": "cystic duct development",
  "GO:0035629": "N-terminal protein amino acid N-linked glycosylation",
  "GO:0035630": "bone mineralization involved in bone maturation",
  "GO:0035631": "CD40 receptor complex",
  "GO:0035632": "mitochondrial prohibitin complex",
  "GO:0035633": "maintenance of blood-brain barrier",
  "GO:0035634": "response to stilbenoid",
  "GO:0035635": "entry of bacterium into host cell",
  "GO:0035636": "multi-organism signaling",
  "GO:0035637": "multicellular organismal signaling",
  "GO:0035638": "signal maturation",
  "GO:0035639": "purine ribonucleoside triphosphate binding",
  "GO:0035640": "exploration behavior",
  "GO:0035641": "locomotory exploration behavior",
  "GO:0035642": "histone methyltransferase activity (H3-R17 specific)",
  "GO:0035643": "L-DOPA receptor activity",
  "GO:0035644": "phosphoanandamide dephosphorylation",
  "GO:0035645": "enteric smooth muscle cell differentiation",
  "GO:0035646": "endosome to melanosome transport",
  "GO:0035647": "3-oxo-delta(4,5)-steroid 5-beta-reductase activity",
  "GO:0035648": "circadian mating behavior",
  "GO:0035649": "Nrd1 complex",
  "GO:0035650": "AP-1 adaptor complex binding",
  "GO:0035651": "AP-3 adaptor complex binding",
  "GO:0035652": "cargo loading into clathrin-coated vesicle",
  "GO:0035653": "cargo loading into clathrin-coated vesicle, AP-1-mediated",
  "GO:0035654": "cargo loading into clathrin-coated vesicle, AP-3-mediated",
  "GO:0035655": "interleukin-18-mediated signaling pathway",
  "GO:0035656": "kinesin-associated melanosomal adaptor activity",
  "GO:0035657": "eRF1 methyltransferase complex",
  "GO:0035658": "Mon1-Ccz1 complex",
  "GO:0035659": "Wnt signaling pathway involved in wound healing, spreading of epidermal cells",
  "GO:0035660": "MyD88-dependent toll-like receptor 4 signaling pathway",
  "GO:0035661": "MyD88-dependent toll-like receptor 2 signaling pathway",
  "GO:0035662": "Toll-like receptor 4 binding",
  "GO:0035663": "Toll-like receptor 2 binding",
  "GO:0035664": "TIRAP-dependent toll-like receptor signaling pathway",
  "GO:0035665": "TIRAP-dependent toll-like receptor 4 signaling pathway",
  "GO:0035666": "TRIF-dependent toll-like receptor signaling pathway",
  "GO:0035667": "TRIF-dependent toll-like receptor 4 signaling pathway",
  "GO:0035668": "TRAM-dependent toll-like receptor signaling pathway",
  "GO:0035669": "TRAM-dependent toll-like receptor 4 signaling pathway",
  "GO:0035670": "plant-type ovary development",
  "GO:0035671": "enone reductase activity",
  "GO:0035672": "oligopeptide transmembrane transport",
  "GO:0035673": "oligopeptide transmembrane transporter activity",
  "GO:0035674": "tricarboxylic acid transmembrane transport",
  "GO:0035675": "neuromast hair cell development",
  "GO:0035676": "anterior lateral line neuromast hair cell development",
  "GO:0035677": "posterior lateral line neuromast hair cell development",
  "GO:0035678": "neuromast hair cell morphogenesis",
  "GO:0035679": "anterior lateral line neuromast hair cell morphogenesis",
  "GO:0035680": "posterior lateral line neuromast hair cell morphogenesis",
  "GO:0035681": "toll-like receptor 15 signaling pathway",
  "GO:0035682": "toll-like receptor 21 signaling pathway",
  "GO:0035683": "memory T cell extravasation",
  "GO:0035684": "helper T cell extravasation",
  "GO:0035685": "helper T cell diapedesis",
  "GO:0035686": "sperm fibrous sheath",
  "GO:0035687": "T-helper 1 cell extravasation",
  "GO:0035688": "T-helper 1 cell diapedesis",
  "GO:0035689": "chemokine (C-C motif) ligand 5 signaling pathway",
  "GO:0035690": "cellular response to drug",
  "GO:0035691": "macrophage migration inhibitory factor signaling pathway",
  "GO:0035692": "macrophage migration inhibitory factor receptor complex",
  "GO:0035693": "NOS2-CD74 complex",
  "GO:0035694": "mitochondrial protein catabolic process",
  "GO:0035695": "mitophagy by induced vacuole formation",
  "GO:0035696": "monocyte extravasation",
  "GO:0035697": "CD8-positive, alpha-beta T cell extravasation",
  "GO:0035698": "CD8-positive, alpha-beta cytotoxic T cell extravasation",
  "GO:0035699": "T-helper 17 cell extravasation",
  "GO:0035700": "astrocyte chemotaxis",
  "GO:0035701": "hematopoietic stem cell migration",
  "GO:0035702": "monocyte homeostasis",
  "GO:0035703": "monocyte migration into blood stream",
  "GO:0035704": "helper T cell chemotaxis",
  "GO:0035705": "T-helper 17 cell chemotaxis",
  "GO:0035706": "T-helper 1 cell chemotaxis",
  "GO:0035707": "T-helper 2 cell chemotaxis",
  "GO:0035708": "interleukin-4-dependent isotype switching to IgE isotypes",
  "GO:0035709": "memory T cell activation",
  "GO:0035710": "CD4-positive, alpha-beta T cell activation",
  "GO:0035711": "T-helper 1 cell activation",
  "GO:0035712": "T-helper 2 cell activation",
  "GO:0035713": "response to nitrogen dioxide",
  "GO:0035714": "cellular response to nitrogen dioxide",
  "GO:0035715": "chemokine (C-C motif) ligand 2 binding",
  "GO:0035716": "chemokine (C-C motif) ligand 12 binding",
  "GO:0035717": "chemokine (C-C motif) ligand 7 binding",
  "GO:0035718": "macrophage migration inhibitory factor binding",
  "GO:0035719": "tRNA import into nucleus",
  "GO:0035720": "intraciliary anterograde transport",
  "GO:0035721": "intraciliary retrograde transport",
  "GO:0035722": "interleukin-12-mediated signaling pathway",
  "GO:0035723": "interleukin-15-mediated signaling pathway",
  "GO:0035724": "CD24 biosynthetic process",
  "GO:0035725": "sodium ion transmembrane transport",
  "GO:0035726": "common myeloid progenitor cell proliferation",
  "GO:0035727": "lysophosphatidic acid binding",
  "GO:0035728": "response to hepatocyte growth factor",
  "GO:0035729": "cellular response to hepatocyte growth factor stimulus",
  "GO:0035730": "S-nitrosoglutathione binding",
  "GO:0035731": "dinitrosyl-iron complex binding",
  "GO:0035732": "nitric oxide storage",
  "GO:0035733": "hepatic stellate cell activation",
  "GO:0035735": "intraciliary transport involved in cilium morphogenesis",
  "GO:0035736": "cell proliferation involved in compound eye morphogenesis",
  "GO:0035737": "injection of substance in to other organism",
  "GO:0035738": "envenomation resulting in modification of morphology or physiology of other organism",
  "GO:0035739": "CD4-positive, alpha-beta T cell proliferation",
  "GO:0035740": "CD8-positive, alpha-beta T cell proliferation",
  "GO:0035741": "activated CD4-positive, alpha-beta T cell proliferation",
  "GO:0035742": "activated CD8-positive, alpha-beta T cell proliferation",
  "GO:0035743": "CD4-positive, alpha-beta T cell cytokine production",
  "GO:0035744": "T-helper 1 cell cytokine production",
  "GO:0035745": "T-helper 2 cell cytokine production",
  "GO:0035746": "granzyme A production",
  "GO:0035747": "natural killer cell chemotaxis",
  "GO:0035748": "myelin sheath abaxonal region",
  "GO:0035749": "myelin sheath adaxonal region",
  "GO:0035750": "protein localization to myelin sheath abaxonal region",
  "GO:0035751": "regulation of lysosomal lumen pH",
  "GO:0035752": "lysosomal lumen pH elevation",
  "GO:0035753": "maintenance of DNA trinucleotide repeats",
  "GO:0035754": "B cell chemotaxis",
  "GO:0035755": "cardiolipin hydrolase activity",
  "GO:0035756": "transepithelial migration of symbiont in host",
  "GO:0035757": "chemokine (C-C motif) ligand 19 binding",
  "GO:0035758": "chemokine (C-C motif) ligand 21 binding",
  "GO:0035759": "mesangial cell-matrix adhesion",
  "GO:0035760": "cytoplasmic polyadenylation-dependent rRNA catabolic process",
  "GO:0035761": "dorsal motor nucleus of vagus nerve maturation",
  "GO:0035762": "dorsal motor nucleus of vagus nerve morphogenesis",
  "GO:0035763": "dorsal motor nucleus of vagus nerve structural organization",
  "GO:0035764": "dorsal motor nucleus of vagus nerve formation",
  "GO:0035765": "motor neuron precursor migration involved in dorsal motor nucleus of vagus nerve formation",
  "GO:0035766": "cell chemotaxis to fibroblast growth factor",
  "GO:0035767": "endothelial cell chemotaxis",
  "GO:0035768": "endothelial cell chemotaxis to fibroblast growth factor",
  "GO:0035769": "B cell chemotaxis across high endothelial venule",
  "GO:0035770": "ribonucleoprotein granule",
  "GO:0035771": "interleukin-4-mediated signaling pathway",
  "GO:0035772": "interleukin-13-mediated signaling pathway",
  "GO:0035773": "insulin secretion involved in cellular response to glucose stimulus",
  "GO:0035774": "positive regulation of insulin secretion involved in cellular response to glucose stimulus",
  "GO:0035775": "pronephric glomerulus morphogenesis",
  "GO:0035776": "pronephric proximal tubule development",
  "GO:0035777": "pronephric distal tubule development",
  "GO:0035778": "pronephric nephron tubule epithelial cell differentiation",
  "GO:0035779": "angioblast cell differentiation",
  "GO:0035780": "CD80 biosynthetic process",
  "GO:0035781": "CD86 biosynthetic process",
  "GO:0035782": "mature natural killer cell chemotaxis",
  "GO:0035783": "CD4-positive, alpha-beta T cell costimulation",
  "GO:0035784": "nickel cation homeostasis",
  "GO:0035785": "cellular nickel ion homeostasis",
  "GO:0035786": "protein complex oligomerization",
  "GO:0035787": "cell migration involved in kidney development",
  "GO:0035788": "cell migration involved in metanephros development",
  "GO:0035789": "metanephric mesenchymal cell migration",
  "GO:0035790": "platelet-derived growth factor receptor-alpha signaling pathway",
  "GO:0035791": "platelet-derived growth factor receptor-beta signaling pathway",
  "GO:0035792": "other organism postsynaptic membrane",
  "GO:0035793": "positive regulation of metanephric mesenchymal cell migration by platelet-derived growth factor receptor-beta signaling pathway",
  "GO:0035794": "positive regulation of mitochondrial membrane permeability",
  "GO:0035795": "negative regulation of mitochondrial membrane permeability",
  "GO:0035796": "ATP-binding cassette (ABC) transporter complex, transmembrane substrate-binding subunit-containing",
  "GO:0035797": "tellurite methyltransferase activity",
  "GO:0035798": "2-alkenal reductase (NADP+) activity",
  "GO:0035799": "ureter maturation",
  "GO:0035800": "deubiquitinase activator activity",
  "GO:0035801": "adrenal cortex development",
  "GO:0035802": "adrenal cortex formation",
  "GO:0035803": "egg coat formation",
  "GO:0035804": "structural constituent of egg coat",
  "GO:0035805": "egg coat",
  "GO:0035806": "modulation of blood coagulation in other organism",
  "GO:0035807": "positive regulation of blood coagulation in other organism",
  "GO:0035808": "meiotic recombination initiation complex",
  "GO:0035809": "regulation of urine volume",
  "GO:0035810": "positive regulation of urine volume",
  "GO:0035811": "negative regulation of urine volume",
  "GO:0035812": "renal sodium excretion",
  "GO:0035813": "regulation of renal sodium excretion",
  "GO:0035814": "negative regulation of renal sodium excretion",
  "GO:0035815": "positive regulation of renal sodium excretion",
  "GO:0035816": "renal water absorption involved in negative regulation of urine volume",
  "GO:0035817": "renal sodium ion absorption involved in negative regulation of renal sodium excretion",
  "GO:0035818": "positive regulation of urine volume by pressure natriuresis",
  "GO:0035819": "positive regulation of renal sodium excretion by pressure natriuresis",
  "GO:0035820": "negative regulation of renal sodium excretion by angiotensin",
  "GO:0035821": "modification of morphology or physiology of other organism",
  "GO:0035822": "gene conversion",
  "GO:0035823": "short tract gene conversion",
  "GO:0035824": "long tract gene conversion",
  "GO:0035825": "reciprocal DNA recombination",
  "GO:0035826": "rubidium ion transport",
  "GO:0035827": "rubidium ion transmembrane transporter activity",
  "GO:0035828": "renal rubidium ion transport",
  "GO:0035829": "renal rubidium ion absorption",
  "GO:0035830": "palmatine metabolic process",
  "GO:0035831": "palmatine biosynthetic process",
  "GO:0035832": "berbamunine metabolic process",
  "GO:0035833": "berbamunine biosynthetic process",
  "GO:0035834": "indole alkaloid metabolic process",
  "GO:0035835": "indole alkaloid biosynthetic process",
  "GO:0035836": "ergot alkaloid metabolic process",
  "GO:0035837": "ergot alkaloid biosynthetic process",
  "GO:0035838": "growing cell tip",
  "GO:0035839": "non-growing cell tip",
  "GO:0035840": "old growing cell tip",
  "GO:0035841": "new growing cell tip",
  "GO:0035842": "old cell tip after activation of bipolar cell growth",
  "GO:0035843": "endonuclear canal",
  "GO:0035844": "cloaca development",
  "GO:0035845": "photoreceptor cell outer segment organization",
  "GO:0035846": "oviduct epithelium development",
  "GO:0035847": "uterine epithelium development",
  "GO:0035848": "oviduct morphogenesis",
  "GO:0035849": "nephric duct elongation",
  "GO:0035850": "epithelial cell differentiation involved in kidney development",
  "GO:0035851": "Krueppel-associated box domain binding",
  "GO:0035852": "horizontal cell localization",
  "GO:0035853": "chromosome passenger complex localization to spindle midzone",
  "GO:0035854": "eosinophil fate commitment",
  "GO:0035855": "megakaryocyte development",
  "GO:0035857": "eosinophil fate specification",
  "GO:0035858": "eosinophil fate determination",
  "GO:0035859": "Seh1-associated complex",
  "GO:0035860": "glial cell-derived neurotrophic factor receptor signaling pathway",
  "GO:0035861": "site of double-strand break",
  "GO:0035862": "dITP metabolic process",
  "GO:0035863": "dITP catabolic process",
  "GO:0035864": "response to potassium ion",
  "GO:0035865": "cellular response to potassium ion",
  "GO:0035866": "alphav-beta3 integrin-PKCalpha complex",
  "GO:0035867": "alphav-beta3 integrin-IGF-1-IGF1R complex",
  "GO:0035868": "alphav-beta3 integrin-HMGB1 complex",
  "GO:0035869": "ciliary transition zone",
  "GO:0035870": "dITP diphosphatase activity",
  "GO:0035871": "protein K11-linked deubiquitination",
  "GO:0035872": "nucleotide-binding domain, leucine rich repeat containing receptor signaling pathway",
  "GO:0035873": "lactate transmembrane transport",
  "GO:0035874": "cellular response to copper ion starvation",
  "GO:0035875": "maintenance of meiotic sister chromatid cohesion, centromeric",
  "GO:0035876": "maintenance of meiotic sister chromatid cohesion, arms",
  "GO:0035877": "death effector domain binding",
  "GO:0035878": "nail development",
  "GO:0035879": "plasma membrane lactate transport",
  "GO:0035880": "embryonic nail plate morphogenesis",
  "GO:0035881": "amacrine cell differentiation",
  "GO:0035882": "defecation rhythm",
  "GO:0035883": "enteroendocrine cell differentiation",
  "GO:0035884": "arabinan biosynthetic process",
  "GO:0035885": "exochitinase activity",
  "GO:0035886": "vascular smooth muscle cell differentiation",
  "GO:0035887": "aortic smooth muscle cell differentiation",
  "GO:0035888": "isoguanine deaminase activity",
  "GO:0035889": "otolith tethering",
  "GO:0035890": "exit from host",
  "GO:0035891": "exit from host cell",
  "GO:0035892": "modulation of platelet aggregation in other organism",
  "GO:0035893": "negative regulation of platelet aggregation in other organism",
  "GO:0035894": "positive regulation of platelet aggregation in other organism",
  "GO:0035895": "modulation of mast cell degranulation in other organism",
  "GO:0035896": "positive regulation of mast cell degranulation in other organism",
  "GO:0035897": "proteolysis in other organism",
  "GO:0035898": "parathyroid hormone secretion",
  "GO:0035899": "negative regulation of blood coagulation in other organism",
  "GO:0035900": "response to isolation stress",
  "GO:0035901": "cellular response to isolation stress",
  "GO:0035902": "response to immobilization stress",
  "GO:0035903": "cellular response to immobilization stress",
  "GO:0035904": "aorta development",
  "GO:0035905": "ascending aorta development",
  "GO:0035906": "descending aorta development",
  "GO:0035907": "dorsal aorta development",
  "GO:0035908": "ventral aorta development",
  "GO:0035909": "aorta morphogenesis",
  "GO:0035910": "ascending aorta morphogenesis",
  "GO:0035911": "descending aorta morphogenesis",
  "GO:0035912": "dorsal aorta morphogenesis",
  "GO:0035913": "ventral aorta morphogenesis",
  "GO:0035914": "skeletal muscle cell differentiation",
  "GO:0035915": "pore formation in membrane of other organism",
  "GO:0035916": "modulation of calcium channel activity in other organism",
  "GO:0035917": "negative regulation of calcium channel activity in other organism",
  "GO:0035918": "negative regulation of voltage-gated calcium channel activity in other organism",
  "GO:0035919": "negative regulation of low voltage-gated calcium channel activity in other organism",
  "GO:0035920": "negative regulation of high voltage-gated calcium channel activity in other organism",
  "GO:0035921": "desmosome disassembly",
  "GO:0035922": "foramen ovale closure",
  "GO:0035923": "flurbiprofen binding",
  "GO:0035924": "cellular response to vascular endothelial growth factor stimulus",
  "GO:0035925": "mRNA 3'-UTR AU-rich region binding",
  "GO:0035926": "chemokine (C-C motif) ligand 2 secretion",
  "GO:0035927": "RNA import into mitochondrion",
  "GO:0035928": "rRNA import into mitochondrion",
  "GO:0035929": "steroid hormone secretion",
  "GO:0035930": "corticosteroid hormone secretion",
  "GO:0035931": "mineralocorticoid secretion",
  "GO:0035932": "aldosterone secretion",
  "GO:0035933": "glucocorticoid secretion",
  "GO:0035934": "corticosterone secretion",
  "GO:0035935": "androgen secretion",
  "GO:0035936": "testosterone secretion",
  "GO:0035937": "estrogen secretion",
  "GO:0035938": "estradiol secretion",
  "GO:0035939": "microsatellite binding",
  "GO:0035940": "negative regulation of peptidase activity in other organism",
  "GO:0035941": "androstenedione secretion",
  "GO:0035942": "dehydroepiandrosterone secretion",
  "GO:0035943": "estrone secretion",
  "GO:0035944": "perforin production",
  "GO:0035945": "mitochondrial ncRNA surveillance",
  "GO:0035946": "mitochondrial mRNA surveillance",
  "GO:0035947": "regulation of gluconeogenesis by regulation of transcription from RNA polymerase II promoter",
  "GO:0035948": "positive regulation of gluconeogenesis by positive regulation of transcription from RNA polymerase II promoter",
  "GO:0035949": "positive regulation of gluconeogenesis by negative regulation of transcription from RNA polymerase II promoter",
  "GO:0035950": "regulation of oligopeptide transport by regulation of transcription from RNA polymerase II promoter",
  "GO:0035951": "positive regulation of oligopeptide transport by positive regulation of transcription from RNA polymerase II promoter",
  "GO:0035952": "negative regulation of oligopeptide transport by negative regulation of transcription from RNA polymerase II promoter",
  "GO:0035953": "regulation of dipeptide transport by regulation of transcription from RNA polymerase II promoter",
  "GO:0035954": "positive regulation of dipeptide transport by positive regulation of transcription from RNA polymerase II promoter",
  "GO:0035955": "negative regulation of dipeptide transport by negative regulation of transcription from RNA polymerase II promoter",
  "GO:0035956": "regulation of starch catabolic process by regulation of transcription from RNA polymerase II promoter",
  "GO:0035957": "positive regulation of starch catabolic process by positive regulation of transcription from RNA polymerase II promoter",
  "GO:0035958": "regulation of glyoxylate cycle by regulation of transcription from RNA polymerase II promoter",
  "GO:0035959": "positive regulation of glyoxylate cycle by positive regulation of transcription from RNA polymerase II promoter",
  "GO:0035960": "regulation of ergosterol biosynthetic process by regulation of transcription from RNA polymerase II promoter",
  "GO:0035961": "positive regulation of ergosterol biosynthetic process by positive regulation of transcription from RNA polymerase II promoter",
  "GO:0035962": "response to interleukin-13",
  "GO:0035963": "cellular response to interleukin-13",
  "GO:0035964": "COPI-coated vesicle budding",
  "GO:0035965": "cardiolipin acyl-chain remodeling",
  "GO:0035966": "response to topologically incorrect protein",
  "GO:0035967": "cellular response to topologically incorrect protein",
  "GO:0035968": "regulation of sterol import by regulation of transcription from RNA polymerase II promoter",
  "GO:0035969": "positive regulation of sterol import by positive regulation of transcription from RNA polymerase II promoter",
  "GO:0035970": "peptidyl-threonine dephosphorylation",
  "GO:0035971": "peptidyl-histidine dephosphorylation",
  "GO:0035973": "aggrephagy",
  "GO:0035974": "meiotic spindle pole body",
  "GO:0035975": "carbamoyl phosphate catabolic process",
  "GO:0035976": "AP1 complex",
  "GO:0035977": "protein deglycosylation involved in glycoprotein catabolic process",
  "GO:0035978": "histone H2A-S139 phosphorylation",
  "GO:0035979": "histone kinase activity (H2A-S139 specific)",
  "GO:0035980": "obsolete invasive growth in response to nitrogen limitation",
  "GO:0035981": "tongue muscle cell differentiation",
  "GO:0035982": "obsolete age-dependent behavioral decline",
  "GO:0035983": "response to trichostatin A",
  "GO:0035984": "cellular response to trichostatin A",
  "GO:0035985": "senescence-associated heterochromatin focus",
  "GO:0035986": "senescence-associated heterochromatin focus assembly",
  "GO:0035987": "endodermal cell differentiation",
  "GO:0035988": "chondrocyte proliferation",
  "GO:0035989": "tendon development",
  "GO:0035990": "tendon cell differentiation",
  "GO:0035991": "nitric oxide sensor activity",
  "GO:0035992": "tendon formation",
  "GO:0035993": "deltoid tuberosity development",
  "GO:0035994": "response to muscle stretch",
  "GO:0035995": "detection of muscle stretch",
  "GO:0035996": "rhabdomere microvillus",
  "GO:0035997": "rhabdomere microvillus membrane",
  "GO:0035998": "7,8-dihydroneopterin 3'-triphosphate biosynthetic process",
  "GO:0035999": "tetrahydrofolate interconversion",
  "GO:0036000": "mucocyst",
  "GO:0036001": "'de novo' pyridoxal 5'-phosphate biosynthetic process",
  "GO:0036002": "pre-mRNA binding",
  "GO:0036003": "positive regulation of transcription from RNA polymerase II promoter in response to stress",
  "GO:0036004": "GAF domain binding",
  "GO:0036005": "response to macrophage colony-stimulating factor",
  "GO:0036006": "cellular response to macrophage colony-stimulating factor stimulus",
  "GO:0036007": "scintillon",
  "GO:0036008": "sucrose catabolic process to fructose-6-phosphate and glucose-6-phosphate",
  "GO:0036009": "protein-glutamine N-methyltransferase activity",
  "GO:0036010": "protein localization to endosome",
  "GO:0036011": "imaginal disc-derived leg segmentation",
  "GO:0036012": "cyanelle inner membrane",
  "GO:0036013": "cyanelle outer membrane",
  "GO:0036014": "cyanelle intermembrane space",
  "GO:0036015": "response to interleukin-3",
  "GO:0036016": "cellular response to interleukin-3",
  "GO:0036017": "response to erythropoietin",
  "GO:0036018": "cellular response to erythropoietin",
  "GO:0036019": "endolysosome",
  "GO:0036020": "endolysosome membrane",
  "GO:0036021": "endolysosome lumen",
  "GO:0036022": "limb joint morphogenesis",
  "GO:0036023": "embryonic skeletal limb joint morphogenesis",
  "GO:0036024": "protein C inhibitor-TMPRSS7 complex",
  "GO:0036025": "protein C inhibitor-TMPRSS11E complex",
  "GO:0036026": "protein C inhibitor-PLAT complex",
  "GO:0036027": "protein C inhibitor-PLAU complex",
  "GO:0036028": "protein C inhibitor-thrombin complex",
  "GO:0036029": "protein C inhibitor-KLK3 complex",
  "GO:0036030": "protein C inhibitor-plasma kallikrein complex",
  "GO:0036031": "recruitment of mRNA capping enzyme to RNA polymerase II holoenzyme complex",
  "GO:0036032": "neural crest cell delamination",
  "GO:0036033": "mediator complex binding",
  "GO:0036034": "mediator complex assembly",
  "GO:0036035": "osteoclast development",
  "GO:0036036": "cardiac neural crest cell delamination",
  "GO:0036037": "CD8-positive, alpha-beta T cell activation",
  "GO:0036038": "TCTN-B9D complex",
  "GO:0036039": "curcumin metabolic process",
  "GO:0036040": "curcumin catabolic process",
  "GO:0036041": "long-chain fatty acid binding",
  "GO:0036042": "long-chain fatty acyl-CoA binding",
  "GO:0036043": "obsolete microspike",
  "GO:0036044": "obsolete protein malonylation",
  "GO:0036045": "obsolete peptidyl-lysine malonylation",
  "GO:0036046": "protein demalonylation",
  "GO:0036047": "peptidyl-lysine demalonylation",
  "GO:0036048": "protein desuccinylation",
  "GO:0036049": "peptidyl-lysine desuccinylation",
  "GO:0036050": "peptidyl-lysine succinylation",
  "GO:0036051": "protein localization to trailing edge",
  "GO:0036052": "protein localization to uropod",
  "GO:0036053": "glomerular endothelium fenestra",
  "GO:0036054": "protein-malonyllysine demalonylase activity",
  "GO:0036055": "protein-succinyllysine desuccinylase activity",
  "GO:0036056": "filtration diaphragm",
  "GO:0036057": "slit diaphragm",
  "GO:0036058": "filtration diaphragm assembly",
  "GO:0036059": "nephrocyte diaphragm assembly",
  "GO:0036060": "slit diaphragm assembly",
  "GO:0036061": "muscle cell chemotaxis toward tendon cell",
  "GO:0036062": "presynaptic periactive zone",
  "GO:0036063": "acroblast",
  "GO:0036064": "ciliary basal body",
  "GO:0036065": "fucosylation",
  "GO:0036066": "protein O-linked fucosylation",
  "GO:0036067": "light-dependent chlorophyll biosynthetic process",
  "GO:0036068": "light-independent chlorophyll biosynthetic process",
  "GO:0036069": "light-dependent bacteriochlorophyll biosynthetic process",
  "GO:0036070": "light-independent bacteriochlorophyll biosynthetic process",
  "GO:0036071": "N-glycan fucosylation",
  "GO:0036072": "direct ossification",
  "GO:0036073": "perichondral ossification",
  "GO:0036074": "metaplastic ossification",
  "GO:0036075": "replacement ossification",
  "GO:0036076": "ligamentous ossification",
  "GO:0036077": "intratendonous ossification",
  "GO:0036078": "minus-end specific microtubule depolymerization",
  "GO:0036079": "purine nucleotide-sugar transport",
  "GO:0036080": "purine nucleotide-sugar transmembrane transporter activity",
  "GO:0036081": "extracellular ammonia-gated ion channel activity",
  "GO:0036082": "extracellular phenylacetaldehyde-gated ion channel activity",
  "GO:0036083": "positive regulation of unsaturated fatty acid biosynthetic process by positive regulation of transcription from RNA polymerase II promoter",
  "GO:0036084": "GDP-fucose import into endoplasmic reticulum lumen",
  "GO:0036085": "GDP-fucose import into Golgi lumen",
  "GO:0036086": "positive regulation of transcription from RNA polymerase II promoter in response to iron ion starvation",
  "GO:0036087": "glutathione synthase complex",
  "GO:0036088": "D-serine catabolic process",
  "GO:0036089": "cleavage furrow formation",
  "GO:0036090": "cleavage furrow ingression",
  "GO:0036091": "positive regulation of transcription from RNA polymerase II promoter in response to oxidative stress",
  "GO:0036092": "phosphatidylinositol-3-phosphate biosynthetic process",
  "GO:0036093": "germ cell proliferation",
  "GO:0036094": "small molecule binding",
  "GO:0036095": "positive regulation of invasive growth in response to glucose limitation by positive regulation of transcription from RNA polymerase II promoter",
  "GO:0036096": "obsolete 3'-5'-exoribonuclease activity involved in pre-miRNA 3'-end processing",
  "GO:0036097": "obsolete pre-miRNA 3'-end processing",
  "GO:0036098": "male germ-line stem cell population maintenance",
  "GO:0036099": "female germ-line stem cell population maintenance",
  "GO:0036100": "leukotriene catabolic process",
  "GO:0036101": "leukotriene B4 catabolic process",
  "GO:0036102": "leukotriene B4 metabolic process",
  "GO:0036103": "Kdo2-lipid A metabolic process",
  "GO:0036104": "Kdo2-lipid A biosynthetic process",
  "GO:0036105": "peroxisome membrane class-1 targeting sequence binding",
  "GO:0036106": "peroxisome membrane class-2 targeting sequence binding",
  "GO:0036107": "4-amino-4-deoxy-alpha-L-arabinopyranosyl undecaprenyl phosphate metabolic process",
  "GO:0036108": "4-amino-4-deoxy-alpha-L-arabinopyranosyl undecaprenyl phosphate biosynthetic process",
  "GO:0036109": "alpha-linolenic acid metabolic process",
  "GO:0036110": "cellular response to inositol starvation",
  "GO:0036111": "very long-chain fatty-acyl-CoA metabolic process",
  "GO:0036112": "medium-chain fatty-acyl-CoA metabolic process",
  "GO:0036113": "very long-chain fatty-acyl-CoA catabolic process",
  "GO:0036114": "medium-chain fatty-acyl-CoA catabolic process",
  "GO:0036115": "fatty-acyl-CoA catabolic process",
  "GO:0036116": "long-chain fatty-acyl-CoA catabolic process",
  "GO:0036117": "hyaluranon cable",
  "GO:0036118": "hyaluranon cable assembly",
  "GO:0036119": "response to platelet-derived growth factor",
  "GO:0036120": "cellular response to platelet-derived growth factor stimulus",
  "GO:0036121": "double-stranded DNA-dependent ATP-dependent DNA helicase activity",
  "GO:0036122": "BMP binding",
  "GO:0036123": "histone H3-K9 dimethylation",
  "GO:0036124": "histone H3-K9 trimethylation",
  "GO:0036125": "fatty acid beta-oxidation multienzyme complex",
  "GO:0036126": "sperm flagellum",
  "GO:0036127": "3-sulfino-L-alanine binding",
  "GO:0036128": "CatSper complex",
  "GO:0036129": "negative regulation of transcription from RNA polymerase II promoter in response to hydrogen peroxide",
  "GO:0036130": "prostaglandin H2 endoperoxidase reductase activity",
  "GO:0036131": "prostaglandin D2 11-ketoreductase activity",
  "GO:0036132": "13-prostaglandin reductase activity",
  "GO:0036133": "11-hydroxythromboxane B2 dehydrogenase activity",
  "GO:0036134": "12-hydroxyheptadecatrienoic acid synthase activity",
  "GO:0036135": "Schwann cell migration",
  "GO:0036136": "kynurenine-oxaloacetate transaminase activity",
  "GO:0036137": "kynurenine aminotransferase activity",
  "GO:0036138": "peptidyl-histidine hydroxylation",
  "GO:0036139": "peptidyl-histidine dioxygenase activity",
  "GO:0036140": "peptidyl-asparagine 3-dioxygenase activity",
  "GO:0036141": "L-phenylalanine-oxaloacetate transaminase activity",
  "GO:0036143": "kringle domain binding",
  "GO:0036145": "dendritic cell homeostasis",
  "GO:0036146": "cellular response to mycotoxin",
  "GO:0036147": "rumination",
  "GO:0036148": "phosphatidylglycerol acyl-chain remodeling",
  "GO:0036149": "phosphatidylinositol acyl-chain remodeling",
  "GO:0036150": "phosphatidylserine acyl-chain remodeling",
  "GO:0036151": "phosphatidylcholine acyl-chain remodeling",
  "GO:0036152": "phosphatidylethanolamine acyl-chain remodeling",
  "GO:0036153": "triglyceride acyl-chain remodeling",
  "GO:0036154": "diacylglycerol acyl-chain remodeling",
  "GO:0036155": "acylglycerol acyl-chain remodeling",
  "GO:0036156": "inner dynein arm",
  "GO:0036157": "outer dynein arm",
  "GO:0036158": "outer dynein arm assembly",
  "GO:0036159": "inner dynein arm assembly",
  "GO:0036160": "melanocyte-stimulating hormone secretion",
  "GO:0036161": "calcitonin secretion",
  "GO:0036162": "oxytocin secretion",
  "GO:0036163": "3-hexaprenyl-4-hydroxy-5-methoxybenzoic acid decarboxylase activity",
  "GO:0036164": "cell-abiotic substrate adhesion",
  "GO:0036165": "invasive growth in response to heat",
  "GO:0036166": "phenotypic switching",
  "GO:0036167": "phenotypic switching in response to host",
  "GO:0036168": "filamentous growth of a population of unicellular organisms in response to heat",
  "GO:0036169": "3-methoxy-4-hydroxy-5-decaprenylbenzoic acid decarboxylase activity",
  "GO:0036170": "filamentous growth of a population of unicellular organisms in response to starvation",
  "GO:0036171": "filamentous growth of a population of unicellular organisms in response to chemical stimulus",
  "GO:0036172": "thiamine salvage",
  "GO:0036173": "thiosulfate binding",
  "GO:0036174": "butane monooxygenase activity",
  "GO:0036175": "ribonucleoside-diphosphate reductase activity, glutaredoxin disulfide as acceptor",
  "GO:0036176": "response to neutral pH",
  "GO:0036177": "filamentous growth of a population of unicellular organisms in response to pH",
  "GO:0036178": "filamentous growth of a population of unicellular organisms in response to neutral pH",
  "GO:0036179": "osteoclast maturation",
  "GO:0036180": "filamentous growth of a population of unicellular organisms in response to biotic stimulus",
  "GO:0036181": "protein localization to linear element",
  "GO:0036182": "asperthecin metabolic process",
  "GO:0036183": "asperthecin catabolic process",
  "GO:0036184": "asperthecin biosynthetic process",
  "GO:0036185": "13-lipoxin reductase activity",
  "GO:0036186": "early phagosome membrane",
  "GO:0036187": "cell growth mode switching, budding to filamentous",
  "GO:0036188": "abieta-7,13-dien-18-al dehydrogenase activity",
  "GO:0036189": "abieta-7,13-diene hydroxylase activity",
  "GO:0036190": "indole-2-monooxygenase activity",
  "GO:0036191": "indolin-2-one monooxygenase activity",
  "GO:0036192": "3-hydroxyindolin-2-one monooxygenase activity",
  "GO:0036193": "2-hydroxy-1,4-benzoxazin-3-one monooxygenase activity",
  "GO:0036194": "muscle cell projection",
  "GO:0036195": "muscle cell projection membrane",
  "GO:0036196": "zymosterol metabolic process",
  "GO:0036197": "zymosterol biosynthetic process",
  "GO:0036198": "dTMP salvage",
  "GO:0036199": "cholest-4-en-3-one 26-monooxygenase activity",
  "GO:0036200": "3-ketosteroid 9-alpha-monooxygenase activity",
  "GO:0036201": "ent-isokaurene C2-hydroxylase activity",
  "GO:0036202": "ent-cassa-12,15-diene 11-hydroxylase activity",
  "GO:0036203": "taxoid 14-beta-hydroxylase activity",
  "GO:0036204": "abieta-7,13-dien-18-ol hydroxylase activity",
  "GO:0036205": "histone catabolic process",
  "GO:0036206": "regulation of histone gene expression",
  "GO:0036207": "positive regulation of histone gene expression",
  "GO:0036208": "negative regulation of histone gene expression",
  "GO:0036209": "9beta-pimara-7,15-diene oxidase activity",
  "GO:0036210": "protein modification process in other organism",
  "GO:0036211": "protein modification process",
  "GO:0036212": "contractile ring maintenance",
  "GO:0036213": "contractile ring contraction",
  "GO:0036214": "contractile ring localization",
  "GO:0036215": "response to stem cell factor",
  "GO:0036216": "cellular response to stem cell factor stimulus",
  "GO:0036217": "dGTP diphosphatase activity",
  "GO:0036218": "dTTP diphosphatase activity",
  "GO:0036219": "GTP diphosphatase activity",
  "GO:0036220": "ITP diphosphatase activity",
  "GO:0036221": "UTP diphosphatase activity",
  "GO:0036222": "XTP diphosphatase activity",
  "GO:0036223": "cellular response to adenine starvation",
  "GO:0036224": "pairing center",
  "GO:0036225": "cellular response to vitamin B1 starvation",
  "GO:0036226": "obsolete mitotic cell cycle arrest in response to glucose starvation",
  "GO:0036227": "mitotic G2 cell cycle arrest in response to glucose starvation",
  "GO:0036228": "protein targeting to nuclear inner membrane",
  "GO:0036229": "L-glutamine import",
  "GO:0036230": "granulocyte activation",
  "GO:0036231": "L-threonine import",
  "GO:0036232": "L-tyrosine import",
  "GO:0036233": "glycine import",
  "GO:0036234": "deglucuronidation",
  "GO:0036235": "acyl deglucuronidation",
  "GO:0036236": "acyl glucuronidation",
  "GO:0036237": "acyl-glucuronidase activity",
  "GO:0036238": "gallate dioxygenase activity",
  "GO:0036239": "taxoid 7beta-hydroxylase activity",
  "GO:0036240": "septal periplasm",
  "GO:0036241": "glutamate catabolic process to 4-hydroxybutyrate",
  "GO:0036242": "glutamate catabolic process to succinate via 2-oxoglutarate-dependent GABA-transaminase activity",
  "GO:0036243": "succinate-semialdehyde dehydrogenase (NADP+) activity",
  "GO:0036244": "cellular response to neutral pH",
  "GO:0036245": "cellular response to menadione",
  "GO:0036246": "phytochelatin 2 import into vacuole",
  "GO:0036247": "phytochelatin 3 import into vacuole",
  "GO:0036248": "phytochelatin 4 import into vacuole",
  "GO:0036249": "cadmium ion import into vacuole",
  "GO:0036250": "peroxisome transport along microtubule",
  "GO:0036251": "positive regulation of transcription from RNA polymerase II promoter in response to salt stress",
  "GO:0036252": "positive regulation of transcription from RNA polymerase II promoter in response to menadione",
  "GO:0036253": "response to amiloride",
  "GO:0036254": "cellular response to amiloride",
  "GO:0036255": "response to methylamine",
  "GO:0036256": "cellular response to methylamine",
  "GO:0036257": "multivesicular body organization",
  "GO:0036258": "multivesicular body assembly",
  "GO:0036259": "aerobic raffinose catabolic process",
  "GO:0036260": "RNA capping",
  "GO:0036261": "7-methylguanosine cap hypermethylation",
  "GO:0036262": "granulysin production",
  "GO:0036263": "L-DOPA monooxygenase activity",
  "GO:0036264": "dopamine monooxygenase activity",
  "GO:0036265": "RNA (guanine-N7)-methylation",
  "GO:0036266": "Cdc48p-Npl4p-Vms1p AAA ATPase complex",
  "GO:0036267": "invasive filamentous growth",
  "GO:0036268": "swimming",
  "GO:0036269": "swimming behavior",
  "GO:0036270": "response to diuretic",
  "GO:0036271": "response to methylphenidate",
  "GO:0036272": "response to gemcitabine",
  "GO:0036273": "response to statin",
  "GO:0036274": "response to lapatinib",
  "GO:0036275": "response to 5-fluorouracil",
  "GO:0036276": "response to antidepressant",
  "GO:0036277": "response to anticonvulsant",
  "GO:0036278": "positive regulation of transcription from RNA polymerase II promoter in response to nitrogen starvation",
  "GO:0036279": "positive regulation of protein export from nucleus in response to glucose starvation",
  "GO:0036280": "cellular response to L-canavanine",
  "GO:0036281": "coflocculation",
  "GO:0036282": "coflocculation via protein-carbohydrate interaction",
  "GO:0036283": "positive regulation of transcription factor import into nucleus in response to oxidative stress",
  "GO:0036284": "tubulobulbar complex",
  "GO:0036285": "SAGA complex assembly",
  "GO:0036286": "eisosome filament",
  "GO:0036287": "response to iloperidone",
  "GO:0036288": "response to ximelagatran",
  "GO:0036289": "peptidyl-serine autophosphorylation",
  "GO:0036290": "protein trans-autophosphorylation",
  "GO:0036291": "protein cis-autophosphorylation",
  "GO:0036292": "DNA rewinding",
  "GO:0036293": "response to decreased oxygen levels",
  "GO:0036294": "cellular response to decreased oxygen levels",
  "GO:0036295": "cellular response to increased oxygen levels",
  "GO:0036296": "response to increased oxygen levels",
  "GO:0036297": "interstrand cross-link repair",
  "GO:0036298": "recombinational interstrand cross-link repair",
  "GO:0036299": "non-recombinational interstrand cross-link repair",
  "GO:0036300": "B cell receptor internalization",
  "GO:0036301": "macrophage colony-stimulating factor production",
  "GO:0036302": "atrioventricular canal development",
  "GO:0036303": "lymph vessel morphogenesis",
  "GO:0036304": "umbilical cord morphogenesis",
  "GO:0036305": "ameloblast differentiation",
  "GO:0036306": "embryonic heart tube elongation",
  "GO:0036307": "23S rRNA (adenine(2030)-N(6))-methyltransferase activity",
  "GO:0036308": "16S rRNA (guanine(1516)-N(2))-methyltransferase activity",
  "GO:0036309": "protein localization to M-band",
  "GO:0036310": "annealing helicase activity",
  "GO:0036311": "chitin disaccharide deacetylase activity",
  "GO:0036312": "phosphatidylinositol 3-kinase regulatory subunit binding",
  "GO:0036313": "phosphatidylinositol 3-kinase catalytic subunit binding",
  "GO:0036314": "response to sterol",
  "GO:0036315": "cellular response to sterol",
  "GO:0036316": "SREBP-SCAP complex retention in endoplasmic reticulum",
  "GO:0036317": "tyrosyl-RNA phosphodiesterase activity",
  "GO:0036318": "peptide pheromone receptor activity",
  "GO:0036319": "mating-type M-factor pheromone receptor activity",
  "GO:0036320": "mating-type P-factor pheromone receptor activity",
  "GO:0036321": "ghrelin secretion",
  "GO:0036322": "pancreatic polypeptide secretion",
  "GO:0036323": "vascular endothelial growth factor receptor-1 signaling pathway",
  "GO:0036324": "vascular endothelial growth factor receptor-2 signaling pathway",
  "GO:0036325": "vascular endothelial growth factor receptor-3 signaling pathway",
  "GO:0036326": "VEGF-A-activated receptor activity",
  "GO:0036327": "VEGF-B-activated receptor activity",
  "GO:0036328": "VEGF-C-activated receptor activity",
  "GO:0036329": "VEGF-D-activated receptor activity",
  "GO:0036330": "VEGF-E-activated receptor activity",
  "GO:0036331": "avascular cornea development in camera-type eye",
  "GO:0036332": "placental growth factor-activated receptor activity",
  "GO:0036333": "hepatocyte homeostasis",
  "GO:0036334": "epidermal stem cell homeostasis",
  "GO:0036335": "intestinal stem cell homeostasis",
  "GO:0036336": "dendritic cell migration",
  "GO:0036337": "Fas signaling pathway",
  "GO:0036338": "viral membrane",
  "GO:0036339": "lymphocyte adhesion to endothelial cell of high endothelial venule",
  "GO:0036340": "chitin-based cuticle sclerotization by biomineralization",
  "GO:0036341": "chitin-based cuticle sclerotization by protein cross-linking",
  "GO:0036342": "post-anal tail morphogenesis",
  "GO:0036343": "psychomotor behavior",
  "GO:0036344": "platelet morphogenesis",
  "GO:0036345": "platelet maturation",
  "GO:0036346": "cellular response to L-cysteine",
  "GO:0036347": "glutathione import into cell",
  "GO:0036348": "hydantoin racemase activity",
  "GO:0036349": "galactose-specific flocculation",
  "GO:0036350": "mannose-specific flocculation",
  "GO:0036351": "histone H2A-K13 ubiquitination",
  "GO:0036352": "histone H2A-K15 ubiquitination",
  "GO:0036353": "histone H2A-K119 monoubiquitination",
  "GO:0036354": "2-desacetyl-2-hydroxyethyl bacteriochlorophyllide a dehydrogenase activity",
  "GO:0036355": "2-iminoacetate synthase activity",
  "GO:0036356": "cyclic 2,3-diphosphoglycerate synthetase activity",
  "GO:0036357": "2-phosphoglycerate kinase activity",
  "GO:0036358": "lipoteichoic acid D-alanylation",
  "GO:0036359": "renal potassium excretion",
  "GO:0036360": "sorocarp stalk morphogenesis",
  "GO:0036361": "racemase activity, acting on amino acids and derivatives",
  "GO:0036362": "ascus membrane",
  "GO:0036363": "transforming growth factor beta activation",
  "GO:0036364": "transforming growth factor beta1 activation",
  "GO:0036365": "transforming growth factor beta2 activation",
  "GO:0036366": "transforming growth factor beta3 activation",
  "GO:0036367": "light adaption",
  "GO:0036368": "cone photoresponse recovery",
  "GO:0036369": "transcription factor catabolic process",
  "GO:0036370": "D-alanyl carrier activity",
  "GO:0036371": "protein localization to T-tubule",
  "GO:0036372": "opsin transport",
  "GO:0036373": "L-fucose mutarotase activity",
  "GO:0036374": "glutathione hydrolase activity",
  "GO:0036375": "Kibra-Ex-Mer complex",
  "GO:0036376": "sodium ion export from cell",
  "GO:0036377": "arbuscular mycorrhizal association",
  "GO:0036378": "calcitriol biosynthetic process from calciol",
  "GO:0036379": "myofilament",
  "GO:0036380": "UDP-N-acetylglucosamine-undecaprenyl-phosphate N-acetylglucosaminephosphotransferase activity",
  "GO:0036381": "pyridoxal 5'-phosphate synthase (glutamine hydrolysing) activity",
  "GO:0036382": "flavin reductase (NADH) activity",
  "GO:0036383": "3-hydroxy-9,10-secoandrosta-1,3,5(10)-triene-9,17-dione monooxygenase activity",
  "GO:0036384": "cytidine diphosphatase activity",
  "GO:0036385": "nucleoid DNA packaging",
  "GO:0036386": "bacterial nucleoid DNA packaging",
  "GO:0036387": "pre-replicative complex",
  "GO:0036388": "pre-replicative complex assembly",
  "GO:0036389": "bacterial pre-replicative complex",
  "GO:0036390": "pre-replicative complex assembly involved in bacterial-type DNA replication",
  "GO:0036391": "medial cortex septin ring",
  "GO:0036392": "chemokine (C-C motif) ligand 20 production",
  "GO:0036393": "thiocyanate peroxidase activity",
  "GO:0036394": "amylase secretion",
  "GO:0036395": "pancreatic amylase secretion",
  "GO:0036396": "MIS complex",
  "GO:0036397": "formate dehydrogenase (quinone) activity",
  "GO:0036398": "TCR signalosome",
  "GO:0036399": "TCR signalosome assembly",
  "GO:0036400": "short neuropeptide F receptor activity",
  "GO:0036401": "pyrokinin receptor activity",
  "GO:0036402": "proteasome-activating ATPase activity",
  "GO:0036403": "arachidonate 8(S)-lipoxygenase activity",
  "GO:0036404": "conversion of ds siRNA to ss siRNA",
  "GO:0036405": "anchored component of cell outer membrane",
  "GO:0036406": "anchored component of periplasmic side of cell outer membrane",
  "GO:0036407": "mycolate outer membrane",
  "GO:0036408": "histone acetyltransferase activity (H3-K14 specific)",
  "GO:0036409": "histone H3-K14 acetyltransferase complex",
  "GO:0036410": "Mst2 histone acetyltransferase complex",
  "GO:0036411": "H-NS-Cnu complex",
  "GO:0036412": "acetyl-CoA:oxalate CoA-transferase",
  "GO:0036413": "histone H3-R26 citrullination",
  "GO:0036414": "histone citrullination",
  "GO:0036415": "regulation of tRNA stability",
  "GO:0036416": "tRNA stabilization",
  "GO:0036417": "tRNA destabilization",
  "GO:0036418": "intrinsic component of mycolate outer membrane",
  "GO:0036419": "integral component of mycolate outer membrane",
  "GO:0036420": "extrinsic component of mycolate outer membrane",
  "GO:0036421": "extrinsic component of external side of mycolate outer membrane",
  "GO:0036422": "heptaprenyl diphosphate synthase activity",
  "GO:0036423": "hexaprenyl-diphosphate synthase ((2E,6E)-farnesyl-diphosphate specific) activity",
  "GO:0036424": "L-phosphoserine phosphatase activity",
  "GO:0036425": "D-phosphoserine phosphatase activity",
  "GO:0036426": "ditrans, polycis-undecaprenyl-phosphate mannosyltransferase activity",
  "GO:0036427": "all-trans-undecaprenyl-phosphate mannosyltransferase activity",
  "GO:0036428": "adenosylcobinamide kinase (GTP-specific) activity",
  "GO:0036429": "adenosylcobinamide kinase (ATP-specific) activity",
  "GO:0036430": "CMP kinase activity",
  "GO:0036431": "dCMP kinase activity",
  "GO:0036432": "all-trans undecaprenol kinase activity",
  "GO:0036433": "di-trans, poly-cis-undecaprenol kinase activity",
  "GO:0036434": "nitronate monooxygenase (FMN-linked) activity",
  "GO:0036435": "K48-linked polyubiquitin binding",
  "GO:0036436": "Isw1a complex",
  "GO:0036437": "Isw1b complex",
  "GO:0036438": "maintenance of lens transparency",
  "GO:0036439": "glycerol-3-phosphate dehydrogenase [NADP+] activity",
  "GO:0036440": "citrate synthase activity",
  "GO:0036441": "2-dehydropantolactone reductase activity",
  "GO:0036442": "hydrogen-exporting ATPase activity",
  "GO:0036443": "dermatan 6-sulfotransferase activity",
  "GO:0036444": "calcium ion transmembrane import into mitochondrion",
  "GO:0036445": "neuronal stem cell division",
  "GO:0036446": "myofibroblast differentiation",
  "GO:0036447": "cellular response to sugar-phosphate stress",
  "GO:0036448": "cellular response to glucose-phosphate stress",
  "GO:0036449": "microtubule minus-end",
  "GO:0036450": "polyuridylation-dependent decapping of nuclear-transcribed mRNA",
  "GO:0036451": "cap mRNA methylation",
  "GO:0036452": "ESCRT complex",
  "GO:0036453": "transitive RNA interference",
  "GO:0036454": "growth factor complex",
  "GO:0036455": "iron-sulfur transferase activity",
  "GO:0036456": "L-methionine-(S)-S-oxide reductase activity",
  "GO:0036457": "keratohyalin granule",
  "GO:0036458": "hepatocyte growth factor binding",
  "GO:0036459": "thiol-dependent ubiquitinyl hydrolase activity",
  "GO:0036460": "cellular response to cell envelope stress",
  "GO:0036461": "BLOC-2 complex binding",
  "GO:0036462": "TRAIL-activated apoptotic signaling pathway",
  "GO:0036463": "TRAIL receptor activity",
  "GO:0036464": "cytoplasmic ribonucleoprotein granule",
  "GO:0036465": "synaptic vesicle recycling",
  "GO:0036466": "synaptic vesicle recycling via endosome",
  "GO:0036467": "5-hydroxy-L-tryptophan decarboxylase activity",
  "GO:0036468": "L-dopa decarboxylase activity",
  "GO:0036469": "L-tryptophan decarboxylase activity",
  "GO:0036470": "tyrosine 3-monooxygenase activator activity",
  "GO:0036471": "cellular response to glyoxal",
  "GO:0036472": "suppression by virus of host protein binding",
  "GO:0036473": "cell death in response to oxidative stress",
  "GO:0036474": "cell death in response to hydrogen peroxide",
  "GO:0036475": "neuron death in response to oxidative stress",
  "GO:0036476": "neuron death in response to hydrogen peroxide",
  "GO:0036477": "somatodendritic compartment",
  "GO:0036478": "L-dopa decarboxylase activator activity",
  "GO:0036479": "peroxidase inhibitor activity",
  "GO:0036480": "neuron intrinsic apoptotic signaling pathway in response to oxidative stress",
  "GO:0036481": "intrinsic apoptotic signaling pathway in response to hydrogen peroxide",
  "GO:0036482": "neuron intrinsic apoptotic signaling pathway in response to hydrogen peroxide",
  "GO:0036483": "neuron intrinsic apoptotic signaling pathway in response to endoplasmic reticulum stress",
  "GO:0036484": "trunk neural crest cell migration",
  "GO:0036485": "dorsolateral trunk neural crest cell migration",
  "GO:0036486": "ventral trunk neural crest cell migration",
  "GO:0036487": "nitric-oxide synthase inhibitor activity",
  "GO:0036488": "CHOP-C/EBP complex",
  "GO:0036489": "neuromelanin biosynthetic process",
  "GO:0036490": "regulation of translation in response to endoplasmic reticulum stress",
  "GO:0036491": "regulation of translation initiation in response to endoplasmic reticulum stress",
  "GO:0036492": "eiF2alpha phosphorylation in response to endoplasmic reticulum stress",
  "GO:0036493": "positive regulation of translation in response to endoplasmic reticulum stress",
  "GO:0036494": "positive regulation of translation initiation in response to endoplasmic reticulum stress",
  "GO:0036495": "negative regulation of translation initiation in response to endoplasmic reticulum stress",
  "GO:0036496": "regulation of translational initiation by eIF2 alpha dephosphorylation",
  "GO:0036497": "eIF2alpha dephosphorylation in response to endoplasmic reticulum stress",
  "GO:0036498": "IRE1-mediated unfolded protein response",
  "GO:0036499": "PERK-mediated unfolded protein response",
  "GO:0036500": "ATF6-mediated unfolded protein response",
  "GO:0036501": "UFD1-NPL4 complex",
  "GO:0036502": "Derlin-1-VIMP complex",
  "GO:0036503": "ERAD pathway",
  "GO:0036504": "Golgi membrane fusion",
  "GO:0036505": "prosaposin receptor activity",
  "GO:0036506": "maintenance of unfolded protein",
  "GO:0036507": "protein demannosylation",
  "GO:0036508": "protein alpha-1,2-demannosylation",
  "GO:0036509": "trimming of terminal mannose on B branch",
  "GO:0036510": "trimming of terminal mannose on C branch",
  "GO:0036511": "trimming of first mannose on A branch",
  "GO:0036512": "trimming of second mannose on A branch",
  "GO:0036513": "Derlin-1 retrotranslocation complex",
  "GO:0036514": "dopaminergic neuron axon guidance",
  "GO:0036515": "serotonergic neuron axon guidance",
  "GO:0036516": "chemoattraction of dopaminergic neuron axon",
  "GO:0036517": "chemoattraction of serotonergic neuron axon",
  "GO:0036518": "chemorepulsion of dopaminergic neuron axon",
  "GO:0036519": "chemorepulsion of serotonergic neuron axon",
  "GO:0036520": "astrocyte-dopaminergic neuron signaling",
  "GO:0038001": "paracrine signaling",
  "GO:0038002": "endocrine signaling",
  "GO:0038003": "opioid receptor signaling pathway",
  "GO:0038004": "epidermal growth factor receptor ligand maturation",
  "GO:0038005": "peptide bond cleavage involved in epidermal growth factor receptor ligand maturation",
  "GO:0038006": "netrin receptor activity involved in chemoattraction",
  "GO:0038007": "netrin-activated signaling pathway",
  "GO:0038008": "TRAF-mediated signal transduction",
  "GO:0038009": "regulation of signal transduction by receptor internalization",
  "GO:0038010": "positive regulation of signal transduction by receptor internalization",
  "GO:0038011": "negative regulation of signal transduction by receptor internalization",
  "GO:0038012": "negative regulation of Wnt signaling pathway by Wnt receptor internalization",
  "GO:0038013": "positive regulation of Wnt signaling pathway by Wnt receptor internalization",
  "GO:0038014": "negative regulation of insulin receptor signaling pathway by insulin receptor internalization",
  "GO:0038015": "positive regulation of insulin receptor signaling pathway by insulin receptor internalization",
  "GO:0038016": "insulin receptor internalization",
  "GO:0038017": "Wnt receptor internalization",
  "GO:0038018": "Wnt receptor catabolic process",
  "GO:0038019": "Wnt receptor recycling",
  "GO:0038020": "insulin receptor recycling",
  "GO:0038021": "leptin receptor activity",
  "GO:0038022": "G-protein coupled olfactory receptor activity",
  "GO:0038023": "signaling receptor activity",
  "GO:0038024": "cargo receptor activity",
  "GO:0038025": "reelin receptor activity",
  "GO:0038026": "reelin-mediated signaling pathway",
  "GO:0038027": "apolipoprotein A-I-mediated signaling pathway",
  "GO:0038028": "insulin receptor signaling pathway via phosphatidylinositol 3-kinase",
  "GO:0038029": "epidermal growth factor receptor signaling pathway via MAPK cascade",
  "GO:0038030": "non-canonical Wnt signaling pathway via MAPK cascade",
  "GO:0038031": "non-canonical Wnt signaling pathway via JNK cascade",
  "GO:0038032": "termination of G-protein coupled receptor signaling pathway",
  "GO:0038033": "positive regulation of endothelial cell chemotaxis by VEGF-activated vascular endothelial growth factor receptor signaling pathway",
  "GO:0038034": "signal transduction in absence of ligand",
  "GO:0038035": "G-protein coupled receptor signaling in absence of ligand",
  "GO:0038036": "sphingosine-1-phosphate receptor activity",
  "GO:0038037": "G-protein coupled receptor dimeric complex",
  "GO:0038038": "G-protein coupled receptor homodimeric complex",
  "GO:0038039": "G-protein coupled receptor heterodimeric complex",
  "GO:0038040": "cross-receptor activation within G-protein coupled receptor heterodimer",
  "GO:0038041": "cross-receptor inhibition within G-protein coupled receptor heterodimer",
  "GO:0038042": "dimeric G-protein coupled receptor signaling pathway",
  "GO:0038043": "interleukin-5-mediated signaling pathway",
  "GO:0038044": "transforming growth factor-beta secretion",
  "GO:0038045": "large latent transforming growth factor-beta complex",
  "GO:0038046": "enkephalin receptor activity",
  "GO:0038047": "morphine receptor activity",
  "GO:0038048": "dynorphin receptor activity",
  "GO:0038049": "transcription factor activity, ligand-activated RNA polymerase II transcription factor binding",
  "GO:0038050": "RNA polymerase II transcription factor activity, glucocorticoid-activated sequence-specific DNA binding",
  "GO:0038051": "glucocorticoid-activated RNA polymerase II transcription factor binding transcription factor activity",
  "GO:0038052": "RNA polymerase II transcription factor activity, estrogen-activated sequence-specific DNA binding",
  "GO:0038053": "transcription factor activity, estrogen-activated RNA polymerase II transcription factor binding",
  "GO:0038054": "G-protein coupled estrogen receptor activity",
  "GO:0038055": "BMP secretion",
  "GO:0038056": "negative regulation of BMP signaling pathway by negative regulation of BMP secretion",
  "GO:0038057": "TNFSF11 binding",
  "GO:0038058": "TNFSF11 receptor activity",
  "GO:0038059": "IKKalpha-IKKalpha complex",
  "GO:0038060": "nitric oxide-cGMP-mediated signaling pathway",
  "GO:0038061": "NIK/NF-kappaB signaling",
  "GO:0038062": "protein tyrosine kinase collagen receptor activity",
  "GO:0038063": "collagen-activated tyrosine kinase receptor signaling pathway",
  "GO:0038064": "collagen receptor activity",
  "GO:0038065": "collagen-activated signaling pathway",
  "GO:0038066": "p38MAPK cascade",
  "GO:0038067": "MAP kinase activity involved in cell wall organization or biogenesis",
  "GO:0038068": "MAP kinase kinase activity involved in cell wall organization or biogenesis",
  "GO:0038069": "MAP kinase phosphatase activity involved in regulation of cell wall biogenesis",
  "GO:0038070": "MAP kinase kinase kinase activity involved in cell wall organization or biogenesis",
  "GO:0038071": "MAP kinase activity involved in conjugation with cellular fusion",
  "GO:0038072": "MAP kinase kinase activity involved in conjugation with cellular fusion",
  "GO:0038073": "MAP kinase kinase kinase activity involved in conjugation with cellular fusion",
  "GO:0038074": "MAP kinase phosphatase activity involved in regulation of conjugation with cellular fusion",
  "GO:0038075": "MAP kinase activity involved in innate immune response",
  "GO:0038076": "MAP kinase kinase activity involved in innate immune response",
  "GO:0038077": "MAP kinase kinase kinase activity involved in innate immune response",
  "GO:0038078": "MAP kinase phosphatase activity involved in regulation of innate immune response",
  "GO:0038079": "MAP kinase activity involved in osmosensory signaling pathway",
  "GO:0038080": "MAP kinase kinase activity involved in osmosensory signaling pathway",
  "GO:0038081": "MAP kinase kinase kinase activity involved in osmosensory signaling pathway",
  "GO:0038082": "MAP kinase phosphatase activity involved in regulation of osmosensory signaling pathway",
  "GO:0038083": "peptidyl-tyrosine autophosphorylation",
  "GO:0038084": "vascular endothelial growth factor signaling pathway",
  "GO:0038085": "vascular endothelial growth factor binding",
  "GO:0038086": "VEGF-activated platelet-derived growth factor receptor signaling pathway",
  "GO:0038087": "VEGF-activated platelet-derived growth factor receptor-alpha signaling pathway",
  "GO:0038088": "VEGF-activated platelet-derived growth factor receptor-beta signaling pathway",
  "GO:0038089": "positive regulation of cell migration by vascular endothelial growth factor signaling pathway",
  "GO:0038090": "positive regulation of cell migration by VEGF-activated platelet derived growth factor receptor signaling pathway",
  "GO:0038091": "positive regulation of cell proliferation by VEGF-activated platelet derived growth factor receptor signaling pathway",
  "GO:0038092": "nodal signaling pathway",
  "GO:0038093": "Fc receptor signaling pathway",
  "GO:0038094": "Fc-gamma receptor signaling pathway",
  "GO:0038095": "Fc-epsilon receptor signaling pathway",
  "GO:0038096": "Fc-gamma receptor signaling pathway involved in phagocytosis",
  "GO:0038097": "positive regulation of mast cell activation by Fc-epsilon receptor signaling pathway",
  "GO:0038098": "sequestering of BMP from receptor via BMP binding",
  "GO:0038099": "nodal receptor complex assembly",
  "GO:0038100": "nodal binding",
  "GO:0038101": "sequestering of nodal from receptor via nodal binding",
  "GO:0038102": "activin receptor antagonist activity",
  "GO:0038103": "activin receptor antagonist activity involved in negative regulation of nodal signaling pathway",
  "GO:0038104": "nodal receptor complex",
  "GO:0038105": "sequestering of TGFbeta from receptor via TGFbeta binding",
  "GO:0038106": "choriogonadotropin hormone binding",
  "GO:0038107": "nodal signaling pathway involved in determination of left/right asymmetry",
  "GO:0038108": "negative regulation of appetite by leptin-mediated signaling pathway",
  "GO:0038109": "Kit signaling pathway",
  "GO:0038110": "interleukin-2-mediated signaling pathway",
  "GO:0038111": "interleukin-7-mediated signaling pathway",
  "GO:0038112": "interleukin-8-mediated signaling pathway",
  "GO:0038113": "interleukin-9-mediated signaling pathway",
  "GO:0038114": "interleukin-21-mediated signaling pathway",
  "GO:0038115": "chemokine (C-C motif) ligand 19 signaling pathway",
  "GO:0038116": "chemokine (C-C motif) ligand 21 signaling pathway",
  "GO:0038117": "C-C motif chemokine 19 receptor activity",
  "GO:0038118": "C-C chemokine receptor CCR7 signaling pathway",
  "GO:0038119": "CCL19-activated CCR7 signaling pathway",
  "GO:0038120": "CCL21-activated CCR7 signaling pathway",
  "GO:0038121": "C-C motif chemokine 21 receptor activity",
  "GO:0038122": "C-C motif chemokine 5 receptor activity",
  "GO:0038123": "toll-like receptor TLR1:TLR2 signaling pathway",
  "GO:0038124": "toll-like receptor TLR6:TLR2 signaling pathway",
  "GO:0038127": "ERBB signaling pathway",
  "GO:0038128": "ERBB2 signaling pathway",
  "GO:0038129": "ERBB3 signaling pathway",
  "GO:0038130": "ERBB4 signaling pathway",
  "GO:0038131": "neuregulin receptor activity",
  "GO:0038132": "neuregulin binding",
  "GO:0038133": "ERBB2-ERBB3 signaling pathway",
  "GO:0038134": "ERBB2-EGFR signaling pathway",
  "GO:0038135": "ERBB2-ERBB4 signaling pathway",
  "GO:0038136": "ERBB3-ERBB4 signaling pathway",
  "GO:0038137": "ERBB4-EGFR signaling pathway",
  "GO:0038138": "ERBB4-ERBB4 signaling pathway",
  "GO:0038139": "ERBB4-EGFR complex",
  "GO:0038140": "ERBB4-ERBB3 complex",
  "GO:0038141": "ERBB4-ERBB4 complex",
  "GO:0038142": "EGFR:ERBB2 complex",
  "GO:0038143": "ERBB3:ERBB2 complex",
  "GO:0038144": "ERBB4:ERBB2 complex",
  "GO:0038145": "macrophage colony-stimulating factor signaling pathway",
  "GO:0038146": "chemokine (C-X-C motif) ligand 12 signaling pathway",
  "GO:0038147": "C-X-C motif chemokine 12 receptor activity",
  "GO:0038148": "chemokine (C-C motif) ligand 2 signaling pathway",
  "GO:0038149": "C-C motif chemokine 2 receptor activity",
  "GO:0038150": "C-C chemokine receptor CCR2 signaling pathway",
  "GO:0038151": "CCL2-activated CCR2 signaling pathway",
  "GO:0038152": "C-C chemokine receptor CCR4 signaling pathway",
  "GO:0038153": "CCL2-activated CCR4 signaling pathway",
  "GO:0038154": "interleukin-11-mediated signaling pathway",
  "GO:0038155": "interleukin-23-mediated signaling pathway",
  "GO:0038156": "interleukin-3-mediated signaling pathway",
  "GO:0038157": "granulocyte-macrophage colony-stimulating factor signaling pathway",
  "GO:0038158": "granulocyte colony-stimulating factor signaling pathway",
  "GO:0038159": "C-X-C chemokine receptor CXCR4 signaling pathway",
  "GO:0038160": "CXCL12-activated CXCR4 signaling pathway",
  "GO:0038161": "prolactin signaling pathway",
  "GO:0038162": "erythropoietin-mediated signaling pathway",
  "GO:0038163": "thrombopoietin-mediated signaling pathway",
  "GO:0038164": "thrombopoietin receptor activity",
  "GO:0038165": "oncostatin-M-mediated signaling pathway",
  "GO:0038166": "angiotensin-activated signaling pathway",
  "GO:0038167": "epidermal growth factor receptor signaling pathway via positive regulation of NF-kappaB transcription factor activity",
  "GO:0038168": "epidermal growth factor receptor signaling pathway via I-kappaB kinase/NF-kappaB cascade",
  "GO:0038169": "somatostatin receptor signaling pathway",
  "GO:0038170": "somatostatin signaling pathway",
  "GO:0038171": "cannabinoid signaling pathway",
  "GO:0038172": "interleukin-33-mediated signaling pathway",
  "GO:0038173": "interleukin-17A-mediated signaling pathway",
  "GO:0038174": "interleukin-17A receptor activity",
  "GO:0038175": "negative regulation of SREBP signaling pathway in response to increased oxygen levels",
  "GO:0038176": "positive regulation of SREBP signaling pathway in response to decreased oxygen levels",
  "GO:0038177": "death receptor agonist activity",
  "GO:0038178": "complement component C5a signaling pathway",
  "GO:0038179": "neurotrophin signaling pathway",
  "GO:0038180": "nerve growth factor signaling pathway",
  "GO:0038181": "bile acid receptor activity",
  "GO:0038182": "G-protein coupled bile acid receptor activity",
  "GO:0038183": "bile acid signaling pathway",
  "GO:0038184": "cell surface bile acid receptor signaling pathway",
  "GO:0038185": "intracellular bile acid receptor signaling pathway",
  "GO:0038186": "lithocholic acid receptor activity",
  "GO:0038187": "pattern recognition receptor activity",
  "GO:0038188": "cholecystokinin signaling pathway",
  "GO:0038189": "neuropilin signaling pathway",
  "GO:0038190": "VEGF-activated neuropilin signaling pathway",
  "GO:0038191": "neuropilin binding",
  "GO:0038192": "gastric inhibitory peptide signaling pathway",
  "GO:0038193": "thromboxane A2 signaling pathway",
  "GO:0038194": "thyroid-stimulating hormone signaling pathway",
  "GO:0038195": "urokinase plasminogen activator signaling pathway",
  "GO:0038196": "type III interferon signaling pathway",
  "GO:0038197": "type I interferon receptor complex",
  "GO:0038198": "auxin receptor activity",
  "GO:0038199": "ethylene receptor activity",
  "GO:0038200": "ethylene receptor histidine kinase activity",
  "GO:0038201": "TOR complex",
  "GO:0038202": "TORC1 signaling",
  "GO:0038203": "TORC2 signaling",
  "GO:0039003": "pronephric field specification",
  "GO:0039004": "specification of pronephric proximal tubule identity",
  "GO:0039005": "specification of pronephric tubule identity",
  "GO:0039006": "pronephric nephron tubule formation",
  "GO:0039007": "pronephric nephron morphogenesis",
  "GO:0039008": "pronephric nephron tubule morphogenesis",
  "GO:0039009": "rectal diverticulum development",
  "GO:0039010": "specification of pronephric distal tubule identity",
  "GO:0039011": "pronephric proximal tubule morphogenesis",
  "GO:0039012": "pronephric sinus development",
  "GO:0039013": "pronephric distal tubule morphogenesis",
  "GO:0039014": "cell differentiation involved in pronephros development",
  "GO:0039015": "cell proliferation involved in pronephros development",
  "GO:0039016": "cell-cell signaling involved in pronephros development",
  "GO:0039017": "pattern specification involved in pronephros development",
  "GO:0039018": "nephrostome development",
  "GO:0039019": "pronephric nephron development",
  "GO:0039020": "pronephric nephron tubule development",
  "GO:0039021": "pronephric glomerulus development",
  "GO:0039022": "pronephric duct development",
  "GO:0039023": "pronephric duct morphogenesis",
  "GO:0039501": "suppression by virus of host type I interferon production",
  "GO:0039502": "suppression by virus of host type I interferon-mediated signaling pathway",
  "GO:0039503": "suppression by virus of host innate immune response",
  "GO:0039504": "suppression by virus of host adaptive immune response",
  "GO:0039505": "suppression by virus of host antigen processing and presentation of peptide antigen via MHC class II",
  "GO:0039506": "modulation by virus of host molecular function",
  "GO:0039507": "suppression by virus of host molecular function",
  "GO:0039508": "suppression by virus of host receptor activity",
  "GO:0039509": "suppression by virus of host pattern recognition receptor activity",
  "GO:0039510": "suppression by virus of host ATP-dependent RNA helicase activity",
  "GO:0039511": "suppression by virus of host interferon receptor activity",
  "GO:0039512": "suppression by virus of host protein tyrosine kinase activity",
  "GO:0039513": "suppression by virus of host catalytic activity",
  "GO:0039514": "suppression by virus of host JAK-STAT cascade",
  "GO:0039516": "modulation by virus of host catalytic activity",
  "GO:0039517": "modulation by virus of host protein serine/threonine phosphatase activity",
  "GO:0039518": "suppression by virus of host cytokine activity",
  "GO:0039519": "modulation by virus of host autophagy",
  "GO:0039520": "induction by virus of host autophagy",
  "GO:0039521": "suppression by virus of host autophagy",
  "GO:0039522": "suppression by virus of host mRNA export from nucleus",
  "GO:0039523": "suppression by virus of host RNA polymerase II activity",
  "GO:0039524": "suppression by virus of host mRNA processing",
  "GO:0039525": "modulation by virus of host chromatin organization",
  "GO:0039526": "modulation by virus of host apoptotic process",
  "GO:0039527": "suppression by virus of host TRAF-mediated signal transduction",
  "GO:0039528": "cytoplasmic pattern recognition receptor signaling pathway in response to virus",
  "GO:0039529": "RIG-I signaling pathway",
  "GO:0039530": "MDA-5 signaling pathway",
  "GO:0039531": "regulation of viral-induced cytoplasmic pattern recognition receptor signaling pathway",
  "GO:0039532": "negative regulation of viral-induced cytoplasmic pattern recognition receptor signaling pathway",
  "GO:0039533": "regulation of MDA-5 signaling pathway",
  "GO:0039534": "negative regulation of MDA-5 signaling pathway",
  "GO:0039535": "regulation of RIG-I signaling pathway",
  "GO:0039536": "negative regulation of RIG-I signaling pathway",
  "GO:0039537": "suppression by virus of host viral-induced cytoplasmic pattern recognition receptor signaling pathway",
  "GO:0039538": "suppression by virus of host RIG-I signaling pathway",
  "GO:0039539": "suppression by virus of host MDA-5 signaling pathway",
  "GO:0039540": "suppression by virus of host RIG-I activity",
  "GO:0039541": "suppression by virus of host RIG-I via RIG-I binding",
  "GO:0039542": "suppression by virus of host RIG-I K63-linked ubiquitination",
  "GO:0039543": "suppression by virus of host RIG-I activity by viral RNA 5' processing",
  "GO:0039544": "suppression by virus of host RIG-I activity by RIG-I proteolysis",
  "GO:0039545": "suppression by virus of host MAVS activity",
  "GO:0039546": "suppression by virus of host MAVS activity by MAVS proteolysis",
  "GO:0039547": "suppression by virus of host TRAF activity",
  "GO:0039548": "suppression by virus of host IRF3 activity",
  "GO:0039549": "suppression by virus of host IRF3 activity by inhibition of IRF3 phosphorylation",
  "GO:0039550": "suppression by virus of host IRF3 activity by inhibition of DNA binding",
  "GO:0039551": "suppression by virus of host IRF3 activity by positive regulation of IRF3 catabolic process",
  "GO:0039552": "RIG-I binding",
  "GO:0039553": "suppression by virus of host chemokine activity",
  "GO:0039554": "suppression by virus of host MDA-5 activity",
  "GO:0039555": "suppression by virus of host MDA-5 activity via MDA-5 binding",
  "GO:0039556": "MDA-5 binding",
  "GO:0039557": "suppression by virus of host IRF7 activity",
  "GO:0039558": "suppression by virus of host IRF7 activity by positive regulation of IRF7 sumoylation",
  "GO:0039559": "suppression by virus of host IRF7 activity by positive regulation of IRF7 catabolic process",
  "GO:0039560": "suppression by virus of host IRF9 activity",
  "GO:0039561": "suppression by virus of host IRF9 activity by positive regulation of IRF9 localization to nucleus",
  "GO:0039562": "suppression by virus of host STAT activity",
  "GO:0039563": "suppression by virus of host STAT1 activity",
  "GO:0039564": "suppression by virus of host STAT2 activity",
  "GO:0039565": "suppression by virus of host STAT1 activity by positive regulation of STAT1 catabolic process",
  "GO:0039566": "suppression by virus of host STAT1 activity by tyrosine dephosphorylation of STAT1",
  "GO:0039567": "suppression by virus of host STAT1 activity by negative regulation of STAT protein import into nucleus",
  "GO:0039568": "suppression by virus of host STAT1 activity by inhibition of DNA binding",
  "GO:0039569": "suppression by virus of host STAT2 activity by positive regulation of STAT2 catabolic process",
  "GO:0039570": "suppression by virus of host STAT2 activity by negative regulation of STAT protein import into nucleus",
  "GO:0039571": "suppression by virus of host STAT1 activity by negative regulation of STAT1 tyrosine phosphorylation",
  "GO:0039572": "suppression by virus of host STAT2 activity by negative regulation of STAT2 tyrosine phosphorylation",
  "GO:0039573": "suppression by virus of host complement activation",
  "GO:0039574": "suppression by virus of host TYK2 activity",
  "GO:0039575": "suppression by virus of host TYK2 activity by negative regulation of TYK2 tyrosine phosphorylation",
  "GO:0039576": "suppression by virus of host JAK1 activity",
  "GO:0039577": "suppression by virus of host JAK1 activity by negative regulation of JAK1 phosphorylation",
  "GO:0039578": "suppression by virus of host JAK1 activity via JAK1 binding",
  "GO:0039579": "suppression by virus of host ISG15 activity",
  "GO:0039580": "suppression by virus of host PKR activity",
  "GO:0039581": "suppression by virus of host PKR activity via double-stranded RNA binding",
  "GO:0039582": "suppression by virus of host PKR activity by positive regulation of PKR nuclear localization",
  "GO:0039583": "suppression by virus of host PKR activity by positive regulation of PKR catabolic process",
  "GO:0039584": "suppression by virus of host protein kinase activity",
  "GO:0039585": "PKR signal transduction",
  "GO:0039586": "modulation by virus of host PP1 activity",
  "GO:0039587": "suppression by virus of host tetherin activity",
  "GO:0039588": "suppression by virus of host antigen processing and presentation",
  "GO:0039589": "suppression by virus of host TAP complex",
  "GO:0039591": "suppression by virus of host tapasin activity",
  "GO:0039592": "suppression by virus of G2/M transition of host mitotic cell cycle",
  "GO:0039593": "suppression by virus of host exit from mitosis",
  "GO:0039594": "endoribonuclease activity involved in viral induction of host mRNA catabolic process",
  "GO:0039595": "induction by virus of catabolism of host mRNA",
  "GO:0039596": "modulation by virus of host protein dephosphorylation",
  "GO:0039597": "induction by virus of host endoribonuclease activity",
  "GO:0039598": "obsolete induction by virus of host nuclear polyadenylation-dependent mRNA catabolic process",
  "GO:0039599": "cleavage by virus of host mRNA",
  "GO:0039600": "induction by virus of host endonucleolytic cleavage-dependent mRNA catabolic process",
  "GO:0039602": "suppression by virus of host transcription initiation from RNA polymerase II promoter",
  "GO:0039603": "TBP-class protein binding involved in viral suppression of host transcription initiation from RNA polymerase II promoter",
  "GO:0039604": "suppression by virus of host translation",
  "GO:0039605": "TFIIB-class transcription factor binding involved in viral suppression of host transcription initiation from RNA polymerase II promoter",
  "GO:0039606": "suppression by virus of host translation initiation",
  "GO:0039607": "proteolysis by virus of host translation initiation factor",
  "GO:0039608": "suppression by virus of host translation initiation factor activity by induction of host protein dephosphorylation",
  "GO:0039611": "suppression by virus of host translation initiation factor activity",
  "GO:0039612": "modulation by virus of host protein phosphorylation",
  "GO:0039613": "suppression by virus of host protein phosphorylation",
  "GO:0039614": "induction by virus of host protein phosphorylation",
  "GO:0039615": "T=1 icosahedral viral capsid",
  "GO:0039616": "T=2 icosahedral viral capsid",
  "GO:0039617": "T=3 icosahedral viral capsid",
  "GO:0039618": "T=pseudo3 icosahedral viral capsid",
  "GO:0039619": "T=4 icosahedral viral capsid",
  "GO:0039620": "T=7 icosahedral viral capsid",
  "GO:0039621": "T=13 icosahedral viral capsid",
  "GO:0039622": "T=16 icosahedral viral capsid",
  "GO:0039623": "T=25 icosahedral viral capsid",
  "GO:0039624": "viral outer capsid",
  "GO:0039625": "viral inner capsid",
  "GO:0039626": "viral intermediate capsid",
  "GO:0039627": "T=147 icosahedral capsid",
  "GO:0039628": "T=169 icosahedral viral capsid",
  "GO:0039629": "T=219 icosahedral capsid",
  "GO:0039630": "RNA translocase activity",
  "GO:0039631": "DNA translocase activity involved in viral DNA genome packaging",
  "GO:0039632": "RNA translocase activity involved in viral RNA genome packaging",
  "GO:0039633": "killing by virus of host cell",
  "GO:0039634": "killing by virus of host cell during superinfection exclusion",
  "GO:0039635": "suppression by virus of host peptidoglycan biosynthetic process",
  "GO:0039636": "suppression by virus of host cell wall biogenesis",
  "GO:0039637": "catabolism by virus of host DNA",
  "GO:0039638": "lipopolysaccharide-mediated virion attachment to host cell",
  "GO:0039639": "suppression by virus of host cell lysis in response to superinfection",
  "GO:0039640": "cytolysis by virus via suppression of host peptidoglycan biosynthetic process",
  "GO:0039641": "viral inner membrane",
  "GO:0039642": "virion nucleoid",
  "GO:0039643": "host cell viral nucleoid",
  "GO:0039644": "suppression by virus of host NF-kappaB transcription factor activity",
  "GO:0039645": "modulation by virus of host G1/S transition checkpoint",
  "GO:0039646": "modulation by virus of host G0/G1 transition checkpoint",
  "GO:0039647": "suppression by virus of host poly(A)-binding protein activity",
  "GO:0039648": "modulation by virus of host protein ubiquitination",
  "GO:0039649": "modulation by virus of host ubiquitin-protein ligase activity",
  "GO:0039650": "suppression by virus of host cysteine-type endopeptidase activity involved in apoptotic process",
  "GO:0039651": "induction by virus of host cysteine-type endopeptidase activity involved in apoptotic process",
  "GO:0039652": "activation by virus of host NF-kappaB transcription factor activity",
  "GO:0039653": "suppression by virus of host transcription",
  "GO:0039654": "fusion of virus membrane with host endosome membrane",
  "GO:0039655": "transport of virus in host, cell to cell via plasmodesmata",
  "GO:0039656": "modulation by virus of host gene expression",
  "GO:0039657": "suppression by virus of host gene expression",
  "GO:0039658": "TBK1-IKKE-DDX3 complex",
  "GO:0039659": "suppression by virus of host TBK1-IKBKE-DDX3 complex activity",
  "GO:0039660": "structural constituent of virion",
  "GO:0039661": "host organelle outer membrane",
  "GO:0039662": "host cell outer membrane",
  "GO:0039663": "membrane fusion involved in viral entry into host cell",
  "GO:0039664": "lysis of host organelle involved in viral entry into host cell",
  "GO:0039665": "permeabilization of host organelle membrane involved in viral entry into host cell",
  "GO:0039666": "virion attachment to host cell pilus",
  "GO:0039667": "viral entry into host cell via pilus retraction",
  "GO:0039668": "viral entry into host cell via pilus basal pore",
  "GO:0039669": "viral entry into host cell via pilus retraction and membrane fusion",
  "GO:0039670": "viral capsid, turret",
  "GO:0039671": "evasion by virus of host natural killer cell activity",
  "GO:0039672": "suppression by virus of host natural killer cell activation",
  "GO:0039673": "evasion by virus of host dendritic cell activity",
  "GO:0039674": "exit of virus from host cell nucleus",
  "GO:0039675": "exit of virus from host cell nucleus through nuclear pore",
  "GO:0039677": "exit of virus from host cell nucleus via nuclear envelope disassembly",
  "GO:0039678": "viral genome ejection through host cell envelope",
  "GO:0039679": "viral occlusion body",
  "GO:0039680": "actin-dependent intracellular transport of virus towards nucleus",
  "GO:0039682": "rolling circle viral DNA replication",
  "GO:0039683": "rolling circle double-stranded viral DNA replication",
  "GO:0039684": "rolling circle single-stranded viral DNA replication",
  "GO:0039685": "rolling hairpin viral DNA replication",
  "GO:0039686": "bidirectional double-stranded viral DNA replication",
  "GO:0039687": "viral DNA strand displacement replication",
  "GO:0039688": "viral double stranded DNA replication via reverse transcription",
  "GO:0039689": "negative stranded viral RNA replication",
  "GO:0039690": "positive stranded viral RNA replication",
  "GO:0039691": "double stranded viral RNA replication",
  "GO:0039692": "single stranded viral RNA replication via double stranded DNA intermediate",
  "GO:0039693": "viral DNA genome replication",
  "GO:0039694": "viral RNA genome replication",
  "GO:0039695": "DNA-templated viral transcription",
  "GO:0039696": "RNA-templated viral transcription",
  "GO:0039697": "negative stranded viral RNA transcription",
  "GO:0039698": "polyadenylation of viral mRNA by polymerase stuttering",
  "GO:0039699": "viral mRNA cap methylation",
  "GO:0039700": "fusion of viral membrane with host outer nuclear membrane",
  "GO:0039701": "microtubule-dependent intracellular transport of viral material towards cell periphery",
  "GO:0039702": "viral budding via host ESCRT complex",
  "GO:0039703": "RNA replication",
  "GO:0039704": "viral translational shunt",
  "GO:0039705": "viral translational readthrough",
  "GO:0039706": "co-receptor binding",
  "GO:0039707": "pore formation by virus in membrane of host cell",
  "GO:0039708": "nuclear capsid assembly",
  "GO:0039709": "cytoplasmic capsid assembly",
  "GO:0039710": "cytoplasmic icosahedral capsid assembly",
  "GO:0039711": "cytoplasmic helical capsid assembly",
  "GO:0039712": "induction by virus of host catalytic activity",
  "GO:0039713": "viral factory",
  "GO:0039714": "cytoplasmic viral factory",
  "GO:0039715": "nuclear viral factory",
  "GO:0039716": "viroplasm viral factory",
  "GO:0039717": "spherule viral factory",
  "GO:0039718": "double membrane vesicle viral factory",
  "GO:0039719": "tube viral factory",
  "GO:0039720": "virogenic stroma",
  "GO:0039721": "peristromal region viral factory",
  "GO:0039722": "suppression by virus of host toll-like receptor signaling pathway",
  "GO:0039723": "suppression by virus of host TBK1 activity",
  "GO:0039724": "suppression by virus of host IKBKE activity",
  "GO:0040001": "establishment of mitotic spindle localization",
  "GO:0040002": "collagen and cuticulin-based cuticle development",
  "GO:0040003": "chitin-based cuticle development",
  "GO:0040004": "collagen and cuticulin-based cuticle attachment to epithelium",
  "GO:0040005": "chitin-based cuticle attachment to epithelium",
  "GO:0040006": "obsolete protein-based cuticle attachment to epithelium",
  "GO:0040007": "growth",
  "GO:0040008": "regulation of growth",
  "GO:0040009": "regulation of growth rate",
  "GO:0040010": "positive regulation of growth rate",
  "GO:0040011": "locomotion",
  "GO:0040012": "regulation of locomotion",
  "GO:0040013": "negative regulation of locomotion",
  "GO:0040014": "regulation of multicellular organism growth",
  "GO:0040015": "negative regulation of multicellular organism growth",
  "GO:0040016": "embryonic cleavage",
  "GO:0040017": "positive regulation of locomotion",
  "GO:0040018": "positive regulation of multicellular organism growth",
  "GO:0040019": "positive regulation of embryonic development",
  "GO:0040020": "regulation of meiotic nuclear division",
  "GO:0040021": "hermaphrodite germ-line sex determination",
  "GO:0040022": "feminization of hermaphroditic germ-line",
  "GO:0040023": "establishment of nucleus localization",
  "GO:0040024": "dauer larval development",
  "GO:0040025": "vulval development",
  "GO:0040026": "positive regulation of vulval development",
  "GO:0040027": "negative regulation of vulval development",
  "GO:0040028": "regulation of vulval development",
  "GO:0040029": "regulation of gene expression, epigenetic",
  "GO:0040030": "regulation of molecular function, epigenetic",
  "GO:0040031": "snRNA modification",
  "GO:0040032": "post-embryonic body morphogenesis",
  "GO:0040033": "negative regulation of translation, ncRNA-mediated",
  "GO:0040034": "regulation of development, heterochronic",
  "GO:0040035": "hermaphrodite genitalia development",
  "GO:0040036": "regulation of fibroblast growth factor receptor signaling pathway",
  "GO:0040037": "negative regulation of fibroblast growth factor receptor signaling pathway",
  "GO:0040038": "polar body extrusion after meiotic divisions",
  "GO:0040039": "inductive cell migration",
  "GO:0040040": "thermosensory behavior",
  "GO:0042000": "translocation of peptides or proteins into host",
  "GO:0042001": "hermaphrodite somatic sex determination",
  "GO:0042003": "masculinization of hermaphrodite soma",
  "GO:0042004": "feminization of hermaphrodite soma",
  "GO:0042006": "masculinization of hermaphroditic germ-line",
  "GO:0042007": "interleukin-18 binding",
  "GO:0042008": "interleukin-18 receptor activity",
  "GO:0042009": "interleukin-15 binding",
  "GO:0042010": "interleukin-15 receptor activity",
  "GO:0042011": "interleukin-16 binding",
  "GO:0042012": "interleukin-16 receptor activity",
  "GO:0042013": "interleukin-19 binding",
  "GO:0042014": "interleukin-19 receptor activity",
  "GO:0042015": "interleukin-20 binding",
  "GO:0042016": "interleukin-20 receptor activity",
  "GO:0042017": "interleukin-22 binding",
  "GO:0042018": "interleukin-22 receptor activity",
  "GO:0042019": "interleukin-23 binding",
  "GO:0042020": "interleukin-23 receptor activity",
  "GO:0042021": "granulocyte macrophage colony-stimulating factor complex binding",
  "GO:0042022": "interleukin-12 receptor complex",
  "GO:0042023": "DNA endoreduplication",
  "GO:0042025": "host cell nucleus",
  "GO:0042026": "protein refolding",
  "GO:0042027": "obsolete cyclophilin-type peptidyl-prolyl cis-trans isomerase activity",
  "GO:0042029": "obsolete fibrolase activity",
  "GO:0042030": "ATPase inhibitor activity",
  "GO:0042031": "obsolete angiotensin-converting enzyme inhibitor activity",
  "GO:0042033": "chemokine biosynthetic process",
  "GO:0042034": "peptidyl-L-lysine methyl ester biosynthetic process from peptidyl-lysine",
  "GO:0042035": "regulation of cytokine biosynthetic process",
  "GO:0042036": "negative regulation of cytokine biosynthetic process",
  "GO:0042037": "peptidyl-histidine methylation, to form pros-methylhistidine",
  "GO:0042038": "peptidyl-histidine methylation, to form tele-methylhistidine",
  "GO:0042039": "vanadium incorporation into metallo-sulfur cluster",
  "GO:0042040": "metal incorporation into metallo-molybdopterin complex",
  "GO:0042042": "tungsten incorporation into tungsten-molybdopterin complex",
  "GO:0042043": "neurexin family protein binding",
  "GO:0042044": "fluid transport",
  "GO:0042045": "epithelial fluid transport",
  "GO:0042046": "W-molybdopterin cofactor metabolic process",
  "GO:0042047": "W-molybdopterin cofactor biosynthetic process",
  "GO:0042048": "olfactory behavior",
  "GO:0042049": "cellular acyl-CoA homeostasis",
  "GO:0042051": "compound eye photoreceptor development",
  "GO:0042052": "rhabdomere development",
  "GO:0042053": "regulation of dopamine metabolic process",
  "GO:0042054": "histone methyltransferase activity",
  "GO:0042056": "chemoattractant activity",
  "GO:0042057": "obsolete transforming growth factor beta receptor anchoring activity",
  "GO:0042058": "regulation of epidermal growth factor receptor signaling pathway",
  "GO:0042059": "negative regulation of epidermal growth factor receptor signaling pathway",
  "GO:0042060": "wound healing",
  "GO:0042062": "long-term strengthening of neuromuscular junction",
  "GO:0042063": "gliogenesis",
  "GO:0042064": "obsolete cell adhesion receptor regulator activity",
  "GO:0042065": "glial cell growth",
  "GO:0042066": "perineurial glial growth",
  "GO:0042067": "establishment of ommatidial planar polarity",
  "GO:0042068": "regulation of pteridine metabolic process",
  "GO:0042069": "regulation of catecholamine metabolic process",
  "GO:0042070": "maintenance of oocyte nucleus location involved in oocyte dorsal/ventral axis specification",
  "GO:0042071": "leucokinin receptor activity",
  "GO:0042072": "obsolete cell adhesion receptor inhibitor activity",
  "GO:0042073": "intraciliary transport",
  "GO:0042074": "cell migration involved in gastrulation",
  "GO:0042075": "nickel incorporation into nickel-iron-sulfur cluster via pentakis-L-cysteinyl L-histidino nickel tetrairon pentasulfide",
  "GO:0042076": "protein phosphate-linked glycosylation",
  "GO:0042077": "protein phosphate-linked glycosylation via serine",
  "GO:0042078": "germ-line stem cell division",
  "GO:0042079": "obsolete GPI/GSI anchor metabolic process",
  "GO:0042080": "obsolete GPI/GSI anchor biosynthetic process",
  "GO:0042081": "GSI anchor metabolic process",
  "GO:0042082": "GSI anchor biosynthetic process",
  "GO:0042083": "5,10-methylenetetrahydrofolate-dependent methyltransferase activity",
  "GO:0042084": "5-methyltetrahydrofolate-dependent methyltransferase activity",
  "GO:0042085": "5-methyltetrahydropteroyltri-L-glutamate-dependent methyltransferase activity",
  "GO:0042086": "5-methyl-5,6,7,8-tetrahydromethanopterin-dependent methyltransferase activity",
  "GO:0042088": "T-helper 1 type immune response",
  "GO:0042089": "cytokine biosynthetic process",
  "GO:0042090": "interleukin-12 biosynthetic process",
  "GO:0042091": "interleukin-10 biosynthetic process",
  "GO:0042092": "type 2 immune response",
  "GO:0042093": "T-helper cell differentiation",
  "GO:0042094": "interleukin-2 biosynthetic process",
  "GO:0042095": "interferon-gamma biosynthetic process",
  "GO:0042096": "obsolete alpha-beta T cell receptor activity",
  "GO:0042097": "interleukin-4 biosynthetic process",
  "GO:0042098": "T cell proliferation",
  "GO:0042099": "obsolete gamma-delta T cell receptor activity",
  "GO:0042100": "B cell proliferation",
  "GO:0042101": "T cell receptor complex",
  "GO:0042102": "positive regulation of T cell proliferation",
  "GO:0042103": "positive regulation of T cell homeostatic proliferation",
  "GO:0042104": "positive regulation of activated T cell proliferation",
  "GO:0042105": "alpha-beta T cell receptor complex",
  "GO:0042106": "gamma-delta T cell receptor complex",
  "GO:0042107": "cytokine metabolic process",
  "GO:0042108": "positive regulation of cytokine biosynthetic process",
  "GO:0042109": "lymphotoxin A biosynthetic process",
  "GO:0042110": "T cell activation",
  "GO:0042113": "B cell activation",
  "GO:0042116": "macrophage activation",
  "GO:0042117": "monocyte activation",
  "GO:0042118": "endothelial cell activation",
  "GO:0042119": "neutrophil activation",
  "GO:0042120": "alginic acid metabolic process",
  "GO:0042121": "alginic acid biosynthetic process",
  "GO:0042122": "alginic acid catabolic process",
  "GO:0042123": "glucanosyltransferase activity",
  "GO:0042124": "1,3-beta-glucanosyltransferase activity",
  "GO:0042125": "protein galactosylation",
  "GO:0042126": "nitrate metabolic process",
  "GO:0042127": "regulation of cell proliferation",
  "GO:0042128": "nitrate assimilation",
  "GO:0042129": "regulation of T cell proliferation",
  "GO:0042130": "negative regulation of T cell proliferation",
  "GO:0042131": "thiamine phosphate phosphatase activity",
  "GO:0042132": "fructose 1,6-bisphosphate 1-phosphatase activity",
  "GO:0042133": "neurotransmitter metabolic process",
  "GO:0042134": "rRNA primary transcript binding",
  "GO:0042135": "neurotransmitter catabolic process",
  "GO:0042136": "neurotransmitter biosynthetic process",
  "GO:0042137": "sequestering of neurotransmitter",
  "GO:0042138": "meiotic DNA double-strand break formation",
  "GO:0042139": "early meiotic recombination nodule assembly",
  "GO:0042140": "late meiotic recombination nodule assembly",
  "GO:0042141": "obsolete mating pheromone exporter",
  "GO:0042142": "obsolete heavy metal chelation",
  "GO:0042144": "vacuole fusion, non-autophagic",
  "GO:0042147": "retrograde transport, endosome to Golgi",
  "GO:0042148": "strand invasion",
  "GO:0042149": "cellular response to glucose starvation",
  "GO:0042150": "plasmid recombination",
  "GO:0042151": "nematocyst",
  "GO:0042152": "RNA-mediated DNA recombination",
  "GO:0042153": "obsolete RPTP-like protein binding",
  "GO:0042156": "obsolete zinc-mediated transcriptional activator activity",
  "GO:0042157": "lipoprotein metabolic process",
  "GO:0042158": "lipoprotein biosynthetic process",
  "GO:0042159": "lipoprotein catabolic process",
  "GO:0042160": "lipoprotein modification",
  "GO:0042161": "lipoprotein oxidation",
  "GO:0042162": "telomeric DNA binding",
  "GO:0042163": "interleukin-12 beta subunit binding",
  "GO:0042164": "interleukin-12 alpha subunit binding",
  "GO:0042165": "neurotransmitter binding",
  "GO:0042166": "acetylcholine binding",
  "GO:0042167": "heme catabolic process",
  "GO:0042168": "heme metabolic process",
  "GO:0042169": "SH2 domain binding",
  "GO:0042170": "plastid membrane",
  "GO:0042171": "lysophosphatidic acid acyltransferase activity",
  "GO:0042173": "regulation of sporulation resulting in formation of a cellular spore",
  "GO:0042174": "negative regulation of sporulation resulting in formation of a cellular spore",
  "GO:0042175": "nuclear outer membrane-endoplasmic reticulum membrane network",
  "GO:0042176": "regulation of protein catabolic process",
  "GO:0042177": "negative regulation of protein catabolic process",
  "GO:0042178": "xenobiotic catabolic process",
  "GO:0042179": "nicotine biosynthetic process",
  "GO:0042180": "cellular ketone metabolic process",
  "GO:0042181": "ketone biosynthetic process",
  "GO:0042182": "ketone catabolic process",
  "GO:0042183": "formate catabolic process",
  "GO:0042184": "xylene catabolic process",
  "GO:0042185": "m-xylene catabolic process",
  "GO:0042186": "o-xylene catabolic process",
  "GO:0042187": "p-xylene catabolic process",
  "GO:0042188": "1,1,1-trichloro-2,2-bis-(4-chlorophenyl)ethane catabolic process",
  "GO:0042189": "vanillin biosynthetic process",
  "GO:0042190": "vanillin catabolic process",
  "GO:0042191": "methylmercury metabolic process",
  "GO:0042192": "methylmercury biosynthetic process",
  "GO:0042193": "methylmercury catabolic process",
  "GO:0042194": "quinate biosynthetic process",
  "GO:0042195": "aerobic gallate catabolic process",
  "GO:0042196": "chlorinated hydrocarbon metabolic process",
  "GO:0042197": "halogenated hydrocarbon metabolic process",
  "GO:0042198": "nylon metabolic process",
  "GO:0042199": "cyanuric acid metabolic process",
  "GO:0042200": "cyanuric acid catabolic process",
  "GO:0042201": "N-cyclopropylmelamine metabolic process",
  "GO:0042202": "N-cyclopropylmelamine catabolic process",
  "GO:0042203": "toluene catabolic process",
  "GO:0042204": "s-triazine compound catabolic process",
  "GO:0042205": "chlorinated hydrocarbon catabolic process",
  "GO:0042206": "halogenated hydrocarbon catabolic process",
  "GO:0042207": "styrene catabolic process",
  "GO:0042208": "propylene catabolic process",
  "GO:0042209": "orcinol catabolic process",
  "GO:0042210": "octamethylcyclotetrasiloxane catabolic process to dimethylsilanediol",
  "GO:0042211": "dimethylsilanediol catabolic process",
  "GO:0042212": "cresol metabolic process",
  "GO:0042213": "m-cresol catabolic process",
  "GO:0042214": "terpene metabolic process",
  "GO:0042215": "anaerobic phenol-containing compound metabolic process",
  "GO:0042216": "phenanthrene catabolic process",
  "GO:0042217": "1-aminocyclopropane-1-carboxylate catabolic process",
  "GO:0042218": "1-aminocyclopropane-1-carboxylate biosynthetic process",
  "GO:0042219": "cellular modified amino acid catabolic process",
  "GO:0042220": "response to cocaine",
  "GO:0042221": "response to chemical",
  "GO:0042222": "interleukin-1 biosynthetic process",
  "GO:0042223": "interleukin-3 biosynthetic process",
  "GO:0042225": "interleukin-5 biosynthetic process",
  "GO:0042226": "interleukin-6 biosynthetic process",
  "GO:0042227": "interleukin-7 biosynthetic process",
  "GO:0042228": "interleukin-8 biosynthetic process",
  "GO:0042229": "interleukin-9 biosynthetic process",
  "GO:0042230": "interleukin-11 biosynthetic process",
  "GO:0042231": "interleukin-13 biosynthetic process",
  "GO:0042232": "interleukin-14 biosynthetic process",
  "GO:0042233": "interleukin-15 biosynthetic process",
  "GO:0042234": "interleukin-16 biosynthetic process",
  "GO:0042235": "interleukin-17 biosynthetic process",
  "GO:0042236": "interleukin-19 biosynthetic process",
  "GO:0042237": "interleukin-20 biosynthetic process",
  "GO:0042238": "interleukin-21 biosynthetic process",
  "GO:0042239": "interleukin-22 biosynthetic process",
  "GO:0042240": "interleukin-23 biosynthetic process",
  "GO:0042241": "interleukin-18 biosynthetic process",
  "GO:0042242": "cobyrinic acid a,c-diamide synthase activity",
  "GO:0042243": "asexual spore wall assembly",
  "GO:0042244": "spore wall assembly",
  "GO:0042245": "RNA repair",
  "GO:0042246": "tissue regeneration",
  "GO:0042247": "establishment of planar polarity of follicular epithelium",
  "GO:0042248": "maintenance of polarity of follicular epithelium",
  "GO:0042249": "establishment of planar polarity of embryonic epithelium",
  "GO:0042250": "maintenance of polarity of embryonic epithelium",
  "GO:0042251": "maintenance of polarity of larval imaginal disc epithelium",
  "GO:0042252": "establishment of planar polarity of larval imaginal disc epithelium",
  "GO:0042253": "granulocyte macrophage colony-stimulating factor biosynthetic process",
  "GO:0042254": "ribosome biogenesis",
  "GO:0042255": "ribosome assembly",
  "GO:0042256": "mature ribosome assembly",
  "GO:0042258": "molybdenum incorporation via L-serinyl molybdopterin guanine dinucleotide",
  "GO:0042259": "peptidyl-L-beta-methylthioasparagine biosynthetic process from peptidyl-asparagine",
  "GO:0042262": "DNA protection",
  "GO:0042263": "neuropeptide F receptor activity",
  "GO:0042264": "peptidyl-aspartic acid hydroxylation",
  "GO:0042265": "peptidyl-asparagine hydroxylation",
  "GO:0042267": "natural killer cell mediated cytotoxicity",
  "GO:0042268": "regulation of cytolysis",
  "GO:0042269": "regulation of natural killer cell mediated cytotoxicity",
  "GO:0042270": "protection from natural killer cell mediated cytotoxicity",
  "GO:0042271": "susceptibility to natural killer cell mediated cytotoxicity",
  "GO:0042272": "nuclear RNA export factor complex",
  "GO:0042273": "ribosomal large subunit biogenesis",
  "GO:0042274": "ribosomal small subunit biogenesis",
  "GO:0042275": "error-free postreplication DNA repair",
  "GO:0042276": "error-prone translesion synthesis",
  "GO:0042277": "peptide binding",
  "GO:0042278": "purine nucleoside metabolic process",
  "GO:0042279": "nitrite reductase (cytochrome, ammonia-forming) activity",
  "GO:0042280": "obsolete cell surface antigen activity, host-interacting",
  "GO:0042281": "dolichyl pyrophosphate Man9GlcNAc2 alpha-1,3-glucosyltransferase activity",
  "GO:0042282": "hydroxymethylglutaryl-CoA reductase activity",
  "GO:0042283": "dolichyl pyrophosphate Glc1Man9GlcNAc2 alpha-1,3-glucosyltransferase activity",
  "GO:0042284": "sphingolipid delta-4 desaturase activity",
  "GO:0042285": "xylosyltransferase activity",
  "GO:0042286": "glutamate-1-semialdehyde 2,1-aminomutase activity",
  "GO:0042287": "MHC protein binding",
  "GO:0042288": "MHC class I protein binding",
  "GO:0042289": "MHC class II protein binding",
  "GO:0042290": "obsolete URM1 hydrolase activity",
  "GO:0042291": "obsolete Hub1 hydrolase activity",
  "GO:0042292": "URM1 activating enzyme activity",
  "GO:0042293": "Hub1 activating enzyme activity",
  "GO:0042294": "URM1 transferase activity",
  "GO:0042296": "ISG15 transferase activity",
  "GO:0042297": "vocal learning",
  "GO:0042299": "lupeol synthase activity",
  "GO:0042300": "beta-amyrin synthase activity",
  "GO:0042301": "phosphate ion binding",
  "GO:0042302": "structural constituent of cuticle",
  "GO:0042303": "molting cycle",
  "GO:0042304": "regulation of fatty acid biosynthetic process",
  "GO:0042305": "specification of segmental identity, mandibular segment",
  "GO:0042306": "regulation of protein import into nucleus",
  "GO:0042307": "positive regulation of protein import into nucleus",
  "GO:0042308": "negative regulation of protein import into nucleus",
  "GO:0042309": "homoiothermy",
  "GO:0042310": "vasoconstriction",
  "GO:0042311": "vasodilation",
  "GO:0042312": "regulation of vasodilation",
  "GO:0042313": "protein kinase C deactivation",
  "GO:0042314": "bacteriochlorophyll binding",
  "GO:0042315": "obsolete cytosol nonspecific dipeptidase activity",
  "GO:0042316": "penicillin metabolic process",
  "GO:0042317": "penicillin catabolic process",
  "GO:0042318": "penicillin biosynthetic process",
  "GO:0042320": "regulation of circadian sleep/wake cycle, REM sleep",
  "GO:0042321": "negative regulation of circadian sleep/wake cycle, sleep",
  "GO:0042322": "negative regulation of circadian sleep/wake cycle, REM sleep",
  "GO:0042323": "negative regulation of circadian sleep/wake cycle, non-REM sleep",
  "GO:0042324": "hypocretin receptor binding",
  "GO:0042325": "regulation of phosphorylation",
  "GO:0042326": "negative regulation of phosphorylation",
  "GO:0042327": "positive regulation of phosphorylation",
  "GO:0042328": "heparan sulfate N-acetylglucosaminyltransferase activity",
  "GO:0042329": "structural constituent of collagen and cuticulin-based cuticle",
  "GO:0042330": "taxis",
  "GO:0042331": "phototaxis",
  "GO:0042332": "gravitaxis",
  "GO:0042333": "chemotaxis to oxidizable substrate",
  "GO:0042334": "taxis to electron acceptor",
  "GO:0042335": "cuticle development",
  "GO:0042336": "obsolete cuticle development involved in protein-based cuticle molting cycle",
  "GO:0042337": "cuticle development involved in chitin-based cuticle molting cycle",
  "GO:0042338": "cuticle development involved in collagen and cuticulin-based cuticle molting cycle",
  "GO:0042339": "keratan sulfate metabolic process",
  "GO:0042340": "keratan sulfate catabolic process",
  "GO:0042341": "cyanogenic glycoside metabolic process",
  "GO:0042342": "cyanogenic glycoside catabolic process",
  "GO:0042343": "indole glucosinolate metabolic process",
  "GO:0042344": "indole glucosinolate catabolic process",
  "GO:0042345": "regulation of NF-kappaB import into nucleus",
  "GO:0042346": "positive regulation of NF-kappaB import into nucleus",
  "GO:0042347": "negative regulation of NF-kappaB import into nucleus",
  "GO:0042348": "NF-kappaB import into nucleus",
  "GO:0042349": "guiding stereospecific synthesis activity",
  "GO:0042350": "GDP-L-fucose biosynthetic process",
  "GO:0042351": "'de novo' GDP-L-fucose biosynthetic process",
  "GO:0042352": "GDP-L-fucose salvage",
  "GO:0042353": "fucose biosynthetic process",
  "GO:0042354": "L-fucose metabolic process",
  "GO:0042355": "L-fucose catabolic process",
  "GO:0042356": "GDP-4-dehydro-D-rhamnose reductase activity",
  "GO:0042357": "thiamine diphosphate metabolic process",
  "GO:0042358": "thiamine diphosphate catabolic process",
  "GO:0042359": "vitamin D metabolic process",
  "GO:0042360": "vitamin E metabolic process",
  "GO:0042361": "menaquinone catabolic process",
  "GO:0042362": "fat-soluble vitamin biosynthetic process",
  "GO:0042363": "fat-soluble vitamin catabolic process",
  "GO:0042364": "water-soluble vitamin biosynthetic process",
  "GO:0042365": "water-soluble vitamin catabolic process",
  "GO:0042366": "cobalamin catabolic process",
  "GO:0042367": "biotin catabolic process",
  "GO:0042368": "vitamin D biosynthetic process",
  "GO:0042369": "vitamin D catabolic process",
  "GO:0042370": "thiamine diphosphate dephosphorylation",
  "GO:0042371": "vitamin K biosynthetic process",
  "GO:0042372": "phylloquinone biosynthetic process",
  "GO:0042373": "vitamin K metabolic process",
  "GO:0042374": "phylloquinone metabolic process",
  "GO:0042376": "phylloquinone catabolic process",
  "GO:0042377": "vitamin K catabolic process",
  "GO:0042379": "chemokine receptor binding",
  "GO:0042380": "hydroxymethylbutenyl pyrophosphate reductase activity",
  "GO:0042381": "hemolymph coagulation",
  "GO:0042382": "paraspeckles",
  "GO:0042383": "sarcolemma",
  "GO:0042384": "cilium assembly",
  "GO:0042385": "myosin III complex",
  "GO:0042386": "hemocyte differentiation",
  "GO:0042387": "plasmatocyte differentiation",
  "GO:0042388": "gibberellic acid mediated signaling pathway, G-alpha-dependent",
  "GO:0042389": "omega-3 fatty acid desaturase activity",
  "GO:0042390": "gibberellic acid mediated signaling pathway, G-alpha-independent",
  "GO:0042391": "regulation of membrane potential",
  "GO:0042392": "sphingosine-1-phosphate phosphatase activity",
  "GO:0042393": "histone binding",
  "GO:0042394": "obsolete ecdysis, protein-based cuticle",
  "GO:0042395": "ecdysis, collagen and cuticulin-based cuticle",
  "GO:0042396": "phosphagen biosynthetic process",
  "GO:0042397": "phosphagen catabolic process",
  "GO:0042398": "cellular modified amino acid biosynthetic process",
  "GO:0042399": "ectoine metabolic process",
  "GO:0042400": "ectoine catabolic process",
  "GO:0042401": "cellular biogenic amine biosynthetic process",
  "GO:0042402": "cellular biogenic amine catabolic process",
  "GO:0042403": "thyroid hormone metabolic process",
  "GO:0042404": "thyroid hormone catabolic process",
  "GO:0042405": "nuclear inclusion body",
  "GO:0042406": "extrinsic component of endoplasmic reticulum membrane",
  "GO:0042407": "cristae formation",
  "GO:0042408": "obsolete myrcene/(E)-beta-ocimene synthase activity",
  "GO:0042409": "caffeoyl-CoA O-methyltransferase activity",
  "GO:0042410": "6-carboxyhexanoate-CoA ligase activity",
  "GO:0042412": "taurine biosynthetic process",
  "GO:0042413": "carnitine catabolic process",
  "GO:0042414": "epinephrine metabolic process",
  "GO:0042415": "norepinephrine metabolic process",
  "GO:0042416": "dopamine biosynthetic process",
  "GO:0042417": "dopamine metabolic process",
  "GO:0042418": "epinephrine biosynthetic process",
  "GO:0042419": "epinephrine catabolic process",
  "GO:0042420": "dopamine catabolic process",
  "GO:0042421": "norepinephrine biosynthetic process",
  "GO:0042422": "norepinephrine catabolic process",
  "GO:0042423": "catecholamine biosynthetic process",
  "GO:0042424": "catecholamine catabolic process",
  "GO:0042425": "choline biosynthetic process",
  "GO:0042426": "choline catabolic process",
  "GO:0042427": "serotonin biosynthetic process",
  "GO:0042428": "serotonin metabolic process",
  "GO:0042429": "serotonin catabolic process",
  "GO:0042430": "indole-containing compound metabolic process",
  "GO:0042431": "indole metabolic process",
  "GO:0042432": "indole biosynthetic process",
  "GO:0042433": "indole catabolic process",
  "GO:0042435": "indole-containing compound biosynthetic process",
  "GO:0042436": "indole-containing compound catabolic process",
  "GO:0042437": "indoleacetic acid catabolic process",
  "GO:0042438": "melanin biosynthetic process",
  "GO:0042439": "ethanolamine-containing compound metabolic process",
  "GO:0042440": "pigment metabolic process",
  "GO:0042441": "eye pigment metabolic process",
  "GO:0042442": "melatonin catabolic process",
  "GO:0042443": "phenylethylamine metabolic process",
  "GO:0042444": "phenylethylamine biosynthetic process",
  "GO:0042445": "hormone metabolic process",
  "GO:0042446": "hormone biosynthetic process",
  "GO:0042447": "hormone catabolic process",
  "GO:0042448": "progesterone metabolic process",
  "GO:0042450": "arginine biosynthetic process via ornithine",
  "GO:0042451": "purine nucleoside biosynthetic process",
  "GO:0042452": "deoxyguanosine biosynthetic process",
  "GO:0042453": "deoxyguanosine metabolic process",
  "GO:0042454": "ribonucleoside catabolic process",
  "GO:0042455": "ribonucleoside biosynthetic process",
  "GO:0042457": "ethylene catabolic process",
  "GO:0042458": "nopaline catabolic process to proline",
  "GO:0042459": "octopine catabolic process to proline",
  "GO:0042461": "photoreceptor cell development",
  "GO:0042462": "eye photoreceptor cell development",
  "GO:0042463": "ocellus photoreceptor cell development",
  "GO:0042464": "dosage compensation by hypoactivation of X chromosome",
  "GO:0042465": "kinesis",
  "GO:0042466": "chemokinesis",
  "GO:0042467": "orthokinesis",
  "GO:0042468": "klinokinesis",
  "GO:0042469": "versicolorin reductase activity",
  "GO:0042470": "melanosome",
  "GO:0042471": "ear morphogenesis",
  "GO:0042472": "inner ear morphogenesis",
  "GO:0042473": "outer ear morphogenesis",
  "GO:0042474": "middle ear morphogenesis",
  "GO:0042475": "odontogenesis of dentin-containing tooth",
  "GO:0042476": "odontogenesis",
  "GO:0042478": "regulation of eye photoreceptor cell development",
  "GO:0042479": "positive regulation of eye photoreceptor cell development",
  "GO:0042480": "negative regulation of eye photoreceptor cell development",
  "GO:0042481": "regulation of odontogenesis",
  "GO:0042482": "positive regulation of odontogenesis",
  "GO:0042483": "negative regulation of odontogenesis",
  "GO:0042487": "regulation of odontogenesis of dentin-containing tooth",
  "GO:0042488": "positive regulation of odontogenesis of dentin-containing tooth",
  "GO:0042489": "negative regulation of odontogenesis of dentin-containing tooth",
  "GO:0042490": "mechanoreceptor differentiation",
  "GO:0042491": "auditory receptor cell differentiation",
  "GO:0042492": "gamma-delta T cell differentiation",
  "GO:0042493": "response to drug",
  "GO:0042494": "detection of bacterial lipoprotein",
  "GO:0042495": "detection of triacyl bacterial lipopeptide",
  "GO:0042496": "detection of diacyl bacterial lipopeptide",
  "GO:0042497": "triacyl lipopeptide binding",
  "GO:0042498": "diacyl lipopeptide binding",
  "GO:0042499": "obsolete signal peptide peptidase activity",
  "GO:0042500": "aspartic endopeptidase activity, intramembrane cleaving",
  "GO:0042501": "serine phosphorylation of STAT protein",
  "GO:0042502": "tyrosine phosphorylation of Stat2 protein",
  "GO:0042503": "tyrosine phosphorylation of Stat3 protein",
  "GO:0042504": "tyrosine phosphorylation of Stat4 protein",
  "GO:0042505": "tyrosine phosphorylation of Stat6 protein",
  "GO:0042506": "tyrosine phosphorylation of Stat5 protein",
  "GO:0042507": "tyrosine phosphorylation of Stat7 protein",
  "GO:0042508": "tyrosine phosphorylation of Stat1 protein",
  "GO:0042509": "regulation of tyrosine phosphorylation of STAT protein",
  "GO:0042510": "regulation of tyrosine phosphorylation of Stat1 protein",
  "GO:0042511": "positive regulation of tyrosine phosphorylation of Stat1 protein",
  "GO:0042512": "negative regulation of tyrosine phosphorylation of Stat1 protein",
  "GO:0042513": "regulation of tyrosine phosphorylation of Stat2 protein",
  "GO:0042514": "negative regulation of tyrosine phosphorylation of Stat2 protein",
  "GO:0042515": "positive regulation of tyrosine phosphorylation of Stat2 protein",
  "GO:0042516": "regulation of tyrosine phosphorylation of Stat3 protein",
  "GO:0042517": "positive regulation of tyrosine phosphorylation of Stat3 protein",
  "GO:0042518": "negative regulation of tyrosine phosphorylation of Stat3 protein",
  "GO:0042519": "regulation of tyrosine phosphorylation of Stat4 protein",
  "GO:0042520": "positive regulation of tyrosine phosphorylation of Stat4 protein",
  "GO:0042521": "negative regulation of tyrosine phosphorylation of Stat4 protein",
  "GO:0042522": "regulation of tyrosine phosphorylation of Stat5 protein",
  "GO:0042523": "positive regulation of tyrosine phosphorylation of Stat5 protein",
  "GO:0042524": "negative regulation of tyrosine phosphorylation of Stat5 protein",
  "GO:0042525": "regulation of tyrosine phosphorylation of Stat6 protein",
  "GO:0042526": "positive regulation of tyrosine phosphorylation of Stat6 protein",
  "GO:0042527": "negative regulation of tyrosine phosphorylation of Stat6 protein",
  "GO:0042528": "regulation of tyrosine phosphorylation of Stat7 protein",
  "GO:0042529": "positive regulation of tyrosine phosphorylation of Stat7 protein",
  "GO:0042530": "negative regulation of tyrosine phosphorylation of Stat7 protein",
  "GO:0042531": "positive regulation of tyrosine phosphorylation of STAT protein",
  "GO:0042532": "negative regulation of tyrosine phosphorylation of STAT protein",
  "GO:0042533": "tumor necrosis factor biosynthetic process",
  "GO:0042534": "regulation of tumor necrosis factor biosynthetic process",
  "GO:0042535": "positive regulation of tumor necrosis factor biosynthetic process",
  "GO:0042536": "negative regulation of tumor necrosis factor biosynthetic process",
  "GO:0042537": "benzene-containing compound metabolic process",
  "GO:0042538": "hyperosmotic salinity response",
  "GO:0042539": "hypotonic salinity response",
  "GO:0042540": "hemoglobin catabolic process",
  "GO:0042541": "hemoglobin biosynthetic process",
  "GO:0042542": "response to hydrogen peroxide",
  "GO:0042543": "protein N-linked glycosylation via arginine",
  "GO:0042544": "melibiose biosynthetic process",
  "GO:0042545": "cell wall modification",
  "GO:0042546": "cell wall biogenesis",
  "GO:0042547": "cell wall modification involved in multidimensional cell growth",
  "GO:0042548": "regulation of photosynthesis, light reaction",
  "GO:0042549": "photosystem II stabilization",
  "GO:0042550": "photosystem I stabilization",
  "GO:0042551": "neuron maturation",
  "GO:0042552": "myelination",
  "GO:0042554": "superoxide anion generation",
  "GO:0042555": "MCM complex",
  "GO:0042556": "eukaryotic elongation factor-2 kinase regulator activity",
  "GO:0042557": "eukaryotic elongation factor-2 kinase activator activity",
  "GO:0042558": "pteridine-containing compound metabolic process",
  "GO:0042559": "pteridine-containing compound biosynthetic process",
  "GO:0042560": "pteridine-containing compound catabolic process",
  "GO:0042561": "alpha-amyrin synthase activity",
  "GO:0042562": "hormone binding",
  "GO:0042563": "importin alpha-subunit nuclear export complex",
  "GO:0042564": "NLS-dependent protein nuclear import complex",
  "GO:0042565": "RNA nuclear export complex",
  "GO:0042566": "hydrogenosome",
  "GO:0042567": "insulin-like growth factor ternary complex",
  "GO:0042568": "insulin-like growth factor binary complex",
  "GO:0042571": "immunoglobulin complex, circulating",
  "GO:0042572": "retinol metabolic process",
  "GO:0042573": "retinoic acid metabolic process",
  "GO:0042574": "retinal metabolic process",
  "GO:0042575": "DNA polymerase complex",
  "GO:0042576": "obsolete aspartyl aminopeptidase activity",
  "GO:0042577": "lipid phosphatase activity",
  "GO:0042578": "phosphoric ester hydrolase activity",
  "GO:0042579": "microbody",
  "GO:0042580": "mannosome",
  "GO:0042581": "specific granule",
  "GO:0042582": "azurophil granule",
  "GO:0042583": "chromaffin granule",
  "GO:0042584": "chromaffin granule membrane",
  "GO:0042585": "germinal vesicle",
  "GO:0042586": "peptide deformylase activity",
  "GO:0042587": "glycogen granule",
  "GO:0042588": "zymogen granule",
  "GO:0042589": "zymogen granule membrane",
  "GO:0042590": "antigen processing and presentation of exogenous peptide antigen via MHC class I",
  "GO:0042592": "homeostatic process",
  "GO:0042593": "glucose homeostasis",
  "GO:0042594": "response to starvation",
  "GO:0042595": "behavioral response to starvation",
  "GO:0042596": "fear response",
  "GO:0042597": "periplasmic space",
  "GO:0042598": "obsolete vesicular fraction",
  "GO:0042599": "lamellar body",
  "GO:0042600": "chorion",
  "GO:0042601": "endospore-forming forespore",
  "GO:0042602": "riboflavin reductase (NADPH) activity",
  "GO:0042603": "capsule",
  "GO:0042605": "peptide antigen binding",
  "GO:0042608": "T cell receptor binding",
  "GO:0042609": "CD4 receptor binding",
  "GO:0042610": "CD8 receptor binding",
  "GO:0042611": "MHC protein complex",
  "GO:0042612": "MHC class I protein complex",
  "GO:0042613": "MHC class II protein complex",
  "GO:0042614": "CD70 receptor binding",
  "GO:0042615": "CD154 receptor binding",
  "GO:0042616": "paclitaxel metabolic process",
  "GO:0042617": "paclitaxel biosynthetic process",
  "GO:0042618": "poly-hydroxybutyrate metabolic process",
  "GO:0042619": "poly-hydroxybutyrate biosynthetic process",
  "GO:0042620": "poly(3-hydroxyalkanoate) metabolic process",
  "GO:0042621": "poly(3-hydroxyalkanoate) biosynthetic process",
  "GO:0042622": "photoreceptor outer segment membrane",
  "GO:0042623": "ATPase activity, coupled",
  "GO:0042624": "ATPase activity, uncoupled",
  "GO:0042625": "ATPase coupled ion transmembrane transporter activity",
  "GO:0042626": "ATPase activity, coupled to transmembrane movement of substances",
  "GO:0042627": "chylomicron",
  "GO:0042628": "mating plug formation",
  "GO:0042629": "mast cell granule",
  "GO:0042630": "behavioral response to water deprivation",
  "GO:0042631": "cellular response to water deprivation",
  "GO:0042632": "cholesterol homeostasis",
  "GO:0042633": "hair cycle",
  "GO:0042634": "regulation of hair cycle",
  "GO:0042635": "positive regulation of hair cycle",
  "GO:0042636": "negative regulation of hair cycle",
  "GO:0042637": "catagen",
  "GO:0042638": "exogen",
  "GO:0042639": "telogen",
  "GO:0042640": "anagen",
  "GO:0042641": "actomyosin",
  "GO:0042642": "actomyosin, myosin complex part",
  "GO:0042643": "actomyosin, actin portion",
  "GO:0042644": "chloroplast nucleoid",
  "GO:0042645": "mitochondrial nucleoid",
  "GO:0042646": "plastid nucleoid",
  "GO:0042647": "proplastid nucleoid",
  "GO:0042648": "chloroplast chromosome",
  "GO:0042649": "prothylakoid",
  "GO:0042650": "prothylakoid membrane",
  "GO:0042651": "thylakoid membrane",
  "GO:0042652": "mitochondrial respiratory chain complex I, peripheral segment",
  "GO:0042653": "mitochondrial respiratory chain complex I, membrane segment",
  "GO:0042654": "ecdysis-triggering hormone receptor activity",
  "GO:0042655": "activation of JNKKK activity",
  "GO:0042656": "JUN kinase kinase kinase kinase activity",
  "GO:0042657": "MHC class II protein binding, via lateral surface",
  "GO:0042658": "MHC class II protein binding, via antigen binding groove",
  "GO:0042659": "regulation of cell fate specification",
  "GO:0042660": "positive regulation of cell fate specification",
  "GO:0042661": "regulation of mesodermal cell fate specification",
  "GO:0042662": "negative regulation of mesodermal cell fate specification",
  "GO:0042663": "regulation of endodermal cell fate specification",
  "GO:0042664": "negative regulation of endodermal cell fate specification",
  "GO:0042665": "regulation of ectodermal cell fate specification",
  "GO:0042666": "negative regulation of ectodermal cell fate specification",
  "GO:0042667": "auditory receptor cell fate specification",
  "GO:0042668": "auditory receptor cell fate determination",
  "GO:0042669": "regulation of auditory receptor cell fate specification",
  "GO:0042670": "retinal cone cell differentiation",
  "GO:0042671": "retinal cone cell fate determination",
  "GO:0042672": "retinal cone cell fate specification",
  "GO:0042673": "regulation of retinal cone cell fate specification",
  "GO:0042675": "compound eye cone cell differentiation",
  "GO:0042676": "compound eye cone cell fate commitment",
  "GO:0042679": "compound eye cone cell fate specification",
  "GO:0042680": "compound eye cone cell fate determination",
  "GO:0042682": "regulation of compound eye cone cell fate specification",
  "GO:0042683": "negative regulation of compound eye cone cell fate specification",
  "GO:0042684": "cardioblast cell fate commitment",
  "GO:0042685": "cardioblast cell fate specification",
  "GO:0042686": "regulation of cardioblast cell fate specification",
  "GO:0042688": "crystal cell differentiation",
  "GO:0042689": "regulation of crystal cell differentiation",
  "GO:0042690": "negative regulation of crystal cell differentiation",
  "GO:0042691": "positive regulation of crystal cell differentiation",
  "GO:0042692": "muscle cell differentiation",
  "GO:0042693": "muscle cell fate commitment",
  "GO:0042694": "muscle cell fate specification",
  "GO:0042695": "thelarche",
  "GO:0042696": "menarche",
  "GO:0042697": "menopause",
  "GO:0042698": "ovulation cycle",
  "GO:0042699": "follicle-stimulating hormone signaling pathway",
  "GO:0042700": "luteinizing hormone signaling pathway",
  "GO:0042701": "progesterone secretion",
  "GO:0042702": "uterine wall growth",
  "GO:0042703": "menstruation",
  "GO:0042704": "uterine wall breakdown",
  "GO:0042705": "ocellus photoreceptor cell differentiation",
  "GO:0042706": "eye photoreceptor cell fate commitment",
  "GO:0042707": "ocellus photoreceptor cell fate commitment",
  "GO:0042708": "obsolete elastase activity",
  "GO:0042709": "succinate-CoA ligase complex",
  "GO:0042710": "biofilm formation",
  "GO:0042711": "maternal behavior",
  "GO:0042712": "paternal behavior",
  "GO:0042713": "sperm ejaculation",
  "GO:0042714": "dosage compensation complex assembly",
  "GO:0042715": "dosage compensation complex assembly involved in dosage compensation by hypoactivation of X chromosome",
  "GO:0042716": "plasma membrane-derived chromatophore",
  "GO:0042717": "plasma membrane-derived chromatophore membrane",
  "GO:0042718": "yolk granule",
  "GO:0042719": "mitochondrial intermembrane space protein transporter complex",
  "GO:0042720": "mitochondrial inner membrane peptidase complex",
  "GO:0042721": "mitochondrial inner membrane protein insertion complex",
  "GO:0042722": "alpha-beta T cell activation by superantigen",
  "GO:0042723": "thiamine-containing compound metabolic process",
  "GO:0042724": "thiamine-containing compound biosynthetic process",
  "GO:0042725": "thiamine-containing compound catabolic process",
  "GO:0042726": "flavin-containing compound metabolic process",
  "GO:0042727": "flavin-containing compound biosynthetic process",
  "GO:0042728": "flavin-containing compound catabolic process",
  "GO:0042729": "DASH complex",
  "GO:0042730": "fibrinolysis",
  "GO:0042731": "PH domain binding",
  "GO:0042732": "D-xylose metabolic process",
  "GO:0042733": "embryonic digit morphogenesis",
  "GO:0042734": "presynaptic membrane",
  "GO:0042735": "protein body",
  "GO:0042736": "NADH kinase activity",
  "GO:0042737": "drug catabolic process",
  "GO:0042738": "exogenous drug catabolic process",
  "GO:0042739": "endogenous drug catabolic process",
  "GO:0042740": "exogenous antibiotic catabolic process",
  "GO:0042741": "endogenous antibiotic catabolic process",
  "GO:0042742": "defense response to bacterium",
  "GO:0042743": "hydrogen peroxide metabolic process",
  "GO:0042744": "hydrogen peroxide catabolic process",
  "GO:0042745": "circadian sleep/wake cycle",
  "GO:0042746": "circadian sleep/wake cycle, wakefulness",
  "GO:0042747": "circadian sleep/wake cycle, REM sleep",
  "GO:0042748": "circadian sleep/wake cycle, non-REM sleep",
  "GO:0042749": "regulation of circadian sleep/wake cycle",
  "GO:0042750": "hibernation",
  "GO:0042751": "estivation",
  "GO:0042752": "regulation of circadian rhythm",
  "GO:0042753": "positive regulation of circadian rhythm",
  "GO:0042754": "negative regulation of circadian rhythm",
  "GO:0042755": "eating behavior",
  "GO:0042756": "drinking behavior",
  "GO:0042757": "giant axon",
  "GO:0042758": "long-chain fatty acid catabolic process",
  "GO:0042759": "long-chain fatty acid biosynthetic process",
  "GO:0042760": "very long-chain fatty acid catabolic process",
  "GO:0042761": "very long-chain fatty acid biosynthetic process",
  "GO:0042762": "regulation of sulfur metabolic process",
  "GO:0042763": "intracellular immature spore",
  "GO:0042764": "ascospore-type prospore",
  "GO:0042765": "GPI-anchor transamidase complex",
  "GO:0042766": "nucleosome mobilization",
  "GO:0042767": "ecdysteroid 22-hydroxylase activity",
  "GO:0042768": "ecdysteroid 2-hydroxylase activity",
  "GO:0042769": "DNA damage response, detection of DNA damage",
  "GO:0042770": "signal transduction in response to DNA damage",
  "GO:0042771": "intrinsic apoptotic signaling pathway in response to DNA damage by p53 class mediator",
  "GO:0042772": "DNA damage response, signal transduction resulting in transcription",
  "GO:0042773": "ATP synthesis coupled electron transport",
  "GO:0042774": "plasma membrane ATP synthesis coupled electron transport",
  "GO:0042775": "mitochondrial ATP synthesis coupled electron transport",
  "GO:0042776": "mitochondrial ATP synthesis coupled proton transport",
  "GO:0042777": "plasma membrane ATP synthesis coupled proton transport",
  "GO:0042778": "tRNA end turnover",
  "GO:0042779": "tRNA 3'-trailer cleavage",
  "GO:0042780": "tRNA 3'-end processing",
  "GO:0042781": "3'-tRNA processing endoribonuclease activity",
  "GO:0042782": "passive evasion of host immune response",
  "GO:0042783": "active evasion of host immune response",
  "GO:0042784": "active evasion of host immune response via regulation of host complement system",
  "GO:0042785": "active evasion of host immune response via regulation of host cytokine network",
  "GO:0042786": "active evasion of host immune response via regulation of host antigen processing and presentation",
  "GO:0042787": "protein ubiquitination involved in ubiquitin-dependent protein catabolic process",
  "GO:0042788": "polysomal ribosome",
  "GO:0042789": "mRNA transcription from RNA polymerase II promoter",
  "GO:0042790": "transcription of nuclear large rRNA transcript from RNA polymerase I promoter",
  "GO:0042791": "5S class rRNA transcription from RNA polymerase III type 1 promoter",
  "GO:0042792": "rRNA transcription from mitochondrial promoter",
  "GO:0042793": "transcription from plastid promoter",
  "GO:0042794": "rRNA transcription from plastid promoter",
  "GO:0042795": "snRNA transcription from RNA polymerase II promoter",
  "GO:0042796": "snRNA transcription from RNA polymerase III promoter",
  "GO:0042797": "tRNA transcription from RNA polymerase III promoter",
  "GO:0042798": "obsolete protein neddylation during NEDD8 class-dependent protein catabolic process",
  "GO:0042799": "histone methyltransferase activity (H4-K20 specific)",
  "GO:0042800": "histone methyltransferase activity (H3-K4 specific)",
  "GO:0042801": "polo kinase kinase activity",
  "GO:0042802": "identical protein binding",
  "GO:0042803": "protein homodimerization activity",
  "GO:0042804": "obsolete protein homooligomerization activity",
  "GO:0042805": "actinin binding",
  "GO:0042806": "fucose binding",
  "GO:0042807": "central vacuole",
  "GO:0042808": "obsolete neuronal Cdc2-like kinase binding",
  "GO:0042809": "vitamin D receptor binding",
  "GO:0042810": "pheromone metabolic process",
  "GO:0042811": "pheromone biosynthetic process",
  "GO:0042812": "pheromone catabolic process",
  "GO:0042813": "Wnt-activated receptor activity",
  "GO:0042814": "monopolar cell growth",
  "GO:0042815": "bipolar cell growth",
  "GO:0042816": "vitamin B6 metabolic process",
  "GO:0042817": "pyridoxal metabolic process",
  "GO:0042818": "pyridoxamine metabolic process",
  "GO:0042819": "vitamin B6 biosynthetic process",
  "GO:0042820": "vitamin B6 catabolic process",
  "GO:0042821": "pyridoxal biosynthetic process",
  "GO:0042822": "pyridoxal phosphate metabolic process",
  "GO:0042823": "pyridoxal phosphate biosynthetic process",
  "GO:0042824": "MHC class I peptide loading complex",
  "GO:0042825": "TAP complex",
  "GO:0042826": "histone deacetylase binding",
  "GO:0042827": "platelet dense granule",
  "GO:0042832": "defense response to protozoan",
  "GO:0042834": "peptidoglycan binding",
  "GO:0042835": "BRE binding",
  "GO:0042836": "D-glucarate metabolic process",
  "GO:0042837": "D-glucarate biosynthetic process",
  "GO:0042838": "D-glucarate catabolic process",
  "GO:0042839": "D-glucuronate metabolic process",
  "GO:0042840": "D-glucuronate catabolic process",
  "GO:0042841": "D-glucuronate biosynthetic process",
  "GO:0042842": "D-xylose biosynthetic process",
  "GO:0042843": "D-xylose catabolic process",
  "GO:0042844": "glycol metabolic process",
  "GO:0042845": "glycol biosynthetic process",
  "GO:0042846": "glycol catabolic process",
  "GO:0042847": "sorbose biosynthetic process",
  "GO:0042848": "sorbose catabolic process",
  "GO:0042849": "L-sorbose biosynthetic process",
  "GO:0042850": "L-sorbose catabolic process",
  "GO:0042851": "L-alanine metabolic process",
  "GO:0042852": "L-alanine biosynthetic process",
  "GO:0042853": "L-alanine catabolic process",
  "GO:0042854": "eugenol metabolic process",
  "GO:0042855": "eugenol biosynthetic process",
  "GO:0042856": "eugenol catabolic process",
  "GO:0042857": "chrysobactin metabolic process",
  "GO:0042858": "chrysobactin biosynthetic process",
  "GO:0042859": "chrysobactin catabolic process",
  "GO:0042860": "achromobactin metabolic process",
  "GO:0042861": "achromobactin biosynthetic process",
  "GO:0042862": "achromobactin catabolic process",
  "GO:0042863": "pyochelin metabolic process",
  "GO:0042864": "pyochelin biosynthetic process",
  "GO:0042865": "pyochelin catabolic process",
  "GO:0042866": "pyruvate biosynthetic process",
  "GO:0042867": "pyruvate catabolic process",
  "GO:0042868": "antisense RNA metabolic process",
  "GO:0042869": "aldarate transport",
  "GO:0042870": "D-glucarate transport",
  "GO:0042873": "aldonate transport",
  "GO:0042874": "D-glucuronate transport",
  "GO:0042875": "D-galactonate transport",
  "GO:0042876": "aldarate transmembrane transporter activity",
  "GO:0042878": "D-glucarate transmembrane transporter activity",
  "GO:0042879": "aldonate transmembrane transporter activity",
  "GO:0042880": "D-glucuronate transmembrane transporter activity",
  "GO:0042881": "D-galactonate transmembrane transporter activity",
  "GO:0042882": "L-arabinose transport",
  "GO:0042883": "cysteine transport",
  "GO:0042884": "microcin transport",
  "GO:0042885": "microcin B17 transport",
  "GO:0042886": "amide transport",
  "GO:0042887": "amide transmembrane transporter activity",
  "GO:0042888": "molybdenum ion transmembrane transporter activity",
  "GO:0042889": "3-phenylpropionic acid transport",
  "GO:0042890": "3-phenylpropionic acid transmembrane transporter activity",
  "GO:0042891": "antibiotic transport",
  "GO:0042892": "chloramphenicol transport",
  "GO:0042893": "polymyxin transport",
  "GO:0042894": "fosmidomycin transport",
  "GO:0042895": "antibiotic transporter activity",
  "GO:0042896": "chloramphenicol transporter activity",
  "GO:0042897": "polymyxin transporter activity",
  "GO:0042898": "fosmidomycin transporter activity",
  "GO:0042899": "arabinan transport",
  "GO:0042900": "arabinose transmembrane transporter activity",
  "GO:0042901": "arabinan transmembrane transporter activity",
  "GO:0042902": "peptidoglycan-protein cross-linking via L-threonyl-pentaglycyl-murein",
  "GO:0042903": "tubulin deacetylase activity",
  "GO:0042904": "9-cis-retinoic acid biosynthetic process",
  "GO:0042905": "9-cis-retinoic acid metabolic process",
  "GO:0042906": "xanthine transport",
  "GO:0042907": "xanthine transmembrane transporter activity",
  "GO:0042908": "xenobiotic transport",
  "GO:0042909": "acridine transport",
  "GO:0042910": "xenobiotic transporter activity",
  "GO:0042911": "acridine transporter activity",
  "GO:0042912": "colicin transmembrane transporter activity",
  "GO:0042913": "group A colicin transmembrane transporter activity",
  "GO:0042914": "colicin transport",
  "GO:0042915": "group A colicin transport",
  "GO:0042916": "alkylphosphonate transport",
  "GO:0042917": "alkylphosphonate transmembrane transporter activity",
  "GO:0042918": "alkanesulfonate transport",
  "GO:0042919": "benzoate transport",
  "GO:0042920": "3-hydroxyphenylpropionic acid transport",
  "GO:0042921": "glucocorticoid receptor signaling pathway",
  "GO:0042922": "neuromedin U receptor binding",
  "GO:0042923": "neuropeptide binding",
  "GO:0042924": "neuromedin U binding",
  "GO:0042925": "benzoate transporter activity",
  "GO:0042926": "3-hydroxyphenylpropionic acid transporter activity",
  "GO:0042927": "siderophore transporter activity",
  "GO:0042928": "ferrichrome transport",
  "GO:0042929": "ferrichrome transporter activity",
  "GO:0042930": "enterobactin transport",
  "GO:0042931": "enterobactin transporter activity",
  "GO:0042932": "chrysobactin transport",
  "GO:0042933": "chrysobactin transporter activity",
  "GO:0042934": "achromobactin transporter activity",
  "GO:0042935": "achromobactin transport",
  "GO:0042936": "dipeptide transporter activity",
  "GO:0042937": "tripeptide transporter activity",
  "GO:0042938": "dipeptide transport",
  "GO:0042939": "tripeptide transport",
  "GO:0042940": "D-amino acid transport",
  "GO:0042941": "D-alanine transport",
  "GO:0042942": "D-serine transport",
  "GO:0042943": "D-amino acid transmembrane transporter activity",
  "GO:0042944": "D-alanine transmembrane transporter activity",
  "GO:0042945": "D-serine transmembrane transporter activity",
  "GO:0042946": "glucoside transport",
  "GO:0042947": "glucoside transmembrane transporter activity",
  "GO:0042948": "salicin transport",
  "GO:0042949": "arbutin transport",
  "GO:0042950": "salicin transmembrane transporter activity",
  "GO:0042951": "arbutin transmembrane transporter activity",
  "GO:0042952": "beta-ketoadipate pathway",
  "GO:0042953": "lipoprotein transport",
  "GO:0042954": "lipoprotein transporter activity",
  "GO:0042955": "dextrin transport",
  "GO:0042956": "maltodextrin transport",
  "GO:0042957": "dextrin transmembrane transporter activity",
  "GO:0042958": "maltodextrin transmembrane transporter activity",
  "GO:0042959": "alkanesulfonate transporter activity",
  "GO:0042960": "antimonite secondary active transmembrane transporter activity",
  "GO:0042961": "antimonite-transporting ATPase activity",
  "GO:0042962": "acridine:proton antiporter activity",
  "GO:0042964": "thioredoxin biosynthetic process",
  "GO:0042965": "glutaredoxin biosynthetic process",
  "GO:0042966": "biotin carboxyl carrier protein biosynthetic process",
  "GO:0042967": "acyl-carrier-protein biosynthetic process",
  "GO:0042968": "homoserine transport",
  "GO:0042969": "lactone transport",
  "GO:0042970": "homoserine transmembrane transporter activity",
  "GO:0042971": "lactone transmembrane transporter activity",
  "GO:0042972": "licheninase activity",
  "GO:0042973": "glucan endo-1,3-beta-D-glucosidase activity",
  "GO:0042974": "retinoic acid receptor binding",
  "GO:0042975": "peroxisome proliferator activated receptor binding",
  "GO:0042976": "activation of Janus kinase activity",
  "GO:0042977": "activation of JAK2 kinase activity",
  "GO:0042978": "ornithine decarboxylase activator activity",
  "GO:0042979": "ornithine decarboxylase regulator activity",
  "GO:0042980": "obsolete cystic fibrosis transmembrane conductance regulator binding",
  "GO:0042981": "regulation of apoptotic process",
  "GO:0042982": "amyloid precursor protein metabolic process",
  "GO:0042983": "amyloid precursor protein biosynthetic process",
  "GO:0042984": "regulation of amyloid precursor protein biosynthetic process",
  "GO:0042985": "negative regulation of amyloid precursor protein biosynthetic process",
  "GO:0042986": "positive regulation of amyloid precursor protein biosynthetic process",
  "GO:0042987": "amyloid precursor protein catabolic process",
  "GO:0042988": "X11-like protein binding",
  "GO:0042989": "sequestering of actin monomers",
  "GO:0042990": "regulation of transcription factor import into nucleus",
  "GO:0042991": "transcription factor import into nucleus",
  "GO:0042992": "negative regulation of transcription factor import into nucleus",
  "GO:0042993": "positive regulation of transcription factor import into nucleus",
  "GO:0042994": "cytoplasmic sequestering of transcription factor",
  "GO:0042995": "cell projection",
  "GO:0042996": "regulation of Golgi to plasma membrane protein transport",
  "GO:0042997": "negative regulation of Golgi to plasma membrane protein transport",
  "GO:0042998": "positive regulation of Golgi to plasma membrane protein transport",
  "GO:0042999": "regulation of Golgi to plasma membrane CFTR protein transport",
  "GO:0043000": "Golgi to plasma membrane CFTR protein transport",
  "GO:0043001": "Golgi to plasma membrane protein transport",
  "GO:0043002": "negative regulation of Golgi to plasma membrane CFTR protein transport",
  "GO:0043003": "positive regulation of Golgi to plasma membrane CFTR protein transport",
  "GO:0043004": "cytoplasmic sequestering of CFTR protein",
  "GO:0043005": "neuron projection",
  "GO:0043006": "activation of phospholipase A2 activity by calcium-mediated signaling",
  "GO:0043007": "maintenance of rDNA",
  "GO:0043008": "ATP-dependent protein binding",
  "GO:0043009": "chordate embryonic development",
  "GO:0043010": "camera-type eye development",
  "GO:0043011": "myeloid dendritic cell differentiation",
  "GO:0043012": "regulation of fusion of sperm to egg plasma membrane",
  "GO:0043013": "negative regulation of fusion of sperm to egg plasma membrane",
  "GO:0043014": "alpha-tubulin binding",
  "GO:0043015": "gamma-tubulin binding",
  "GO:0043016": "regulation of lymphotoxin A biosynthetic process",
  "GO:0043017": "positive regulation of lymphotoxin A biosynthetic process",
  "GO:0043018": "negative regulation of lymphotoxin A biosynthetic process",
  "GO:0043020": "NADPH oxidase complex",
  "GO:0043021": "ribonucleoprotein complex binding",
  "GO:0043022": "ribosome binding",
  "GO:0043023": "ribosomal large subunit binding",
  "GO:0043024": "ribosomal small subunit binding",
  "GO:0043025": "neuronal cell body",
  "GO:0043027": "cysteine-type endopeptidase inhibitor activity involved in apoptotic process",
  "GO:0043028": "cysteine-type endopeptidase regulator activity involved in apoptotic process",
  "GO:0043029": "T cell homeostasis",
  "GO:0043030": "regulation of macrophage activation",
  "GO:0043031": "negative regulation of macrophage activation",
  "GO:0043032": "positive regulation of macrophage activation",
  "GO:0043033": "isoamylase complex",
  "GO:0043034": "costamere",
  "GO:0043035": "chromatin insulator sequence binding",
  "GO:0043036": "starch grain",
  "GO:0043038": "amino acid activation",
  "GO:0043039": "tRNA aminoacylation",
  "GO:0043040": "tRNA aminoacylation for nonribosomal peptide biosynthetic process",
  "GO:0043041": "amino acid activation for nonribosomal peptide biosynthetic process",
  "GO:0043042": "amino acid adenylylation by nonribosomal peptide synthase",
  "GO:0043043": "peptide biosynthetic process",
  "GO:0043044": "ATP-dependent chromatin remodeling",
  "GO:0043045": "DNA methylation involved in embryo development",
  "GO:0043046": "DNA methylation involved in gamete generation",
  "GO:0043047": "single-stranded telomeric DNA binding",
  "GO:0043048": "dolichyl monophosphate biosynthetic process",
  "GO:0043049": "otic placode formation",
  "GO:0043050": "pharyngeal pumping",
  "GO:0043051": "regulation of pharyngeal pumping",
  "GO:0043052": "thermotaxis",
  "GO:0043053": "dauer entry",
  "GO:0043054": "dauer exit",
  "GO:0043055": "maintenance of dauer",
  "GO:0043056": "forward locomotion",
  "GO:0043057": "backward locomotion",
  "GO:0043058": "regulation of backward locomotion",
  "GO:0043059": "regulation of forward locomotion",
  "GO:0043060": "meiotic metaphase I plate congression",
  "GO:0043061": "meiotic metaphase II plate congression",
  "GO:0043062": "extracellular structure organization",
  "GO:0043063": "intercellular bridge organization",
  "GO:0043064": "obsolete flagellum organization",
  "GO:0043065": "positive regulation of apoptotic process",
  "GO:0043066": "negative regulation of apoptotic process",
  "GO:0043067": "regulation of programmed cell death",
  "GO:0043068": "positive regulation of programmed cell death",
  "GO:0043069": "negative regulation of programmed cell death",
  "GO:0043073": "germ cell nucleus",
  "GO:0043075": "obsolete sperm cell nucleus (sensu Magnoliophyta)",
  "GO:0043076": "megasporocyte nucleus",
  "GO:0043077": "initiation of acetate catabolic process",
  "GO:0043078": "polar nucleus",
  "GO:0043079": "antipodal cell nucleus",
  "GO:0043082": "megagametophyte egg cell nucleus",
  "GO:0043083": "synaptic cleft",
  "GO:0043084": "penile erection",
  "GO:0043085": "positive regulation of catalytic activity",
  "GO:0043086": "negative regulation of catalytic activity",
  "GO:0043087": "regulation of GTPase activity",
  "GO:0043090": "amino acid import",
  "GO:0043091": "L-arginine import",
  "GO:0043092": "L-amino acid import",
  "GO:0043093": "FtsZ-dependent cytokinesis",
  "GO:0043094": "cellular metabolic compound salvage",
  "GO:0043095": "regulation of GTP cyclohydrolase I activity",
  "GO:0043096": "purine nucleobase salvage",
  "GO:0043097": "pyrimidine nucleoside salvage",
  "GO:0043098": "purine deoxyribonucleoside salvage",
  "GO:0043099": "pyrimidine deoxyribonucleoside salvage",
  "GO:0043100": "pyrimidine nucleobase salvage",
  "GO:0043101": "purine-containing compound salvage",
  "GO:0043102": "amino acid salvage",
  "GO:0043103": "hypoxanthine salvage",
  "GO:0043104": "positive regulation of GTP cyclohydrolase I activity",
  "GO:0043105": "negative regulation of GTP cyclohydrolase I activity",
  "GO:0043107": "type IV pilus-dependent motility",
  "GO:0043108": "pilus retraction",
  "GO:0043110": "rDNA spacer replication fork barrier binding",
  "GO:0043111": "replication fork arrest",
  "GO:0043112": "receptor metabolic process",
  "GO:0043113": "receptor clustering",
  "GO:0043114": "regulation of vascular permeability",
  "GO:0043115": "precorrin-2 dehydrogenase activity",
  "GO:0043116": "negative regulation of vascular permeability",
  "GO:0043117": "positive regulation of vascular permeability",
  "GO:0043120": "tumor necrosis factor binding",
  "GO:0043121": "neurotrophin binding",
  "GO:0043122": "regulation of I-kappaB kinase/NF-kappaB signaling",
  "GO:0043123": "positive regulation of I-kappaB kinase/NF-kappaB signaling",
  "GO:0043124": "negative regulation of I-kappaB kinase/NF-kappaB signaling",
  "GO:0043125": "ErbB-3 class receptor binding",
  "GO:0043126": "regulation of 1-phosphatidylinositol 4-kinase activity",
  "GO:0043127": "negative regulation of 1-phosphatidylinositol 4-kinase activity",
  "GO:0043128": "positive regulation of 1-phosphatidylinositol 4-kinase activity",
  "GO:0043129": "surfactant homeostasis",
  "GO:0043130": "ubiquitin binding",
  "GO:0043131": "erythrocyte enucleation",
  "GO:0043132": "NAD transport",
  "GO:0043133": "hindgut contraction",
  "GO:0043134": "regulation of hindgut contraction",
  "GO:0043135": "5-phosphoribosyl 1-pyrophosphate pyrophosphatase activity",
  "GO:0043136": "glycerol-3-phosphatase activity",
  "GO:0043137": "DNA replication, removal of RNA primer",
  "GO:0043138": "3'-5' DNA helicase activity",
  "GO:0043139": "5'-3' DNA helicase activity",
  "GO:0043140": "ATP-dependent 3'-5' DNA helicase activity",
  "GO:0043141": "ATP-dependent 5'-3' DNA helicase activity",
  "GO:0043142": "single-stranded DNA-dependent ATPase activity",
  "GO:0043143": "regulation of translation by machinery localization",
  "GO:0043144": "snoRNA processing",
  "GO:0043145": "snoRNA 3'-end cleavage",
  "GO:0043149": "stress fiber assembly",
  "GO:0043150": "DNA synthesis involved in double-strand break repair via homologous recombination",
  "GO:0043151": "DNA synthesis involved in double-strand break repair via single-strand annealing",
  "GO:0043152": "induction of bacterial agglutination",
  "GO:0043153": "entrainment of circadian clock by photoperiod",
  "GO:0043154": "negative regulation of cysteine-type endopeptidase activity involved in apoptotic process",
  "GO:0043155": "negative regulation of photosynthesis, light reaction",
  "GO:0043156": "chromatin remodeling in response to cation stress",
  "GO:0043157": "response to cation stress",
  "GO:0043158": "heterocyst differentiation",
  "GO:0043159": "acrosomal matrix",
  "GO:0043160": "acrosomal lumen",
  "GO:0043161": "proteasome-mediated ubiquitin-dependent protein catabolic process",
  "GO:0043162": "ubiquitin-dependent protein catabolic process via the multivesicular body sorting pathway",
  "GO:0043163": "cell envelope organization",
  "GO:0043164": "Gram-negative-bacterium-type cell wall biogenesis",
  "GO:0043165": "Gram-negative-bacterium-type cell outer membrane assembly",
  "GO:0043167": "ion binding",
  "GO:0043168": "anion binding",
  "GO:0043169": "cation binding",
  "GO:0043170": "macromolecule metabolic process",
  "GO:0043171": "peptide catabolic process",
  "GO:0043172": "ferredoxin biosynthetic process",
  "GO:0043173": "nucleotide salvage",
  "GO:0043174": "nucleoside salvage",
  "GO:0043175": "RNA polymerase core enzyme binding",
  "GO:0043176": "amine binding",
  "GO:0043177": "organic acid binding",
  "GO:0043178": "alcohol binding",
  "GO:0043179": "rhythmic excitation",
  "GO:0043180": "rhythmic inhibition",
  "GO:0043181": "vacuolar sequestering",
  "GO:0043182": "vacuolar sequestering of sodium ion",
  "GO:0043183": "vascular endothelial growth factor receptor 1 binding",
  "GO:0043184": "vascular endothelial growth factor receptor 2 binding",
  "GO:0043185": "vascular endothelial growth factor receptor 3 binding",
  "GO:0043186": "P granule",
  "GO:0043187": "cell septum surface",
  "GO:0043188": "cell septum edging",
  "GO:0043189": "H4/H2A histone acetyltransferase complex",
  "GO:0043190": "ATP-binding cassette (ABC) transporter complex",
  "GO:0043194": "axon initial segment",
  "GO:0043195": "terminal bouton",
  "GO:0043196": "varicosity",
  "GO:0043197": "dendritic spine",
  "GO:0043198": "dendritic shaft",
  "GO:0043199": "sulfate binding",
  "GO:0043200": "response to amino acid",
  "GO:0043201": "response to leucine",
  "GO:0043202": "lysosomal lumen",
  "GO:0043203": "axon hillock",
  "GO:0043204": "perikaryon",
  "GO:0043205": "fibril",
  "GO:0043206": "extracellular fibril organization",
  "GO:0043207": "response to external biotic stimulus",
  "GO:0043208": "glycosphingolipid binding",
  "GO:0043209": "myelin sheath",
  "GO:0043210": "alkanesulfonate binding",
  "GO:0043211": "carbohydrate-transporting ATPase activity",
  "GO:0043212": "carbohydrate-exporting ATPase activity",
  "GO:0043213": "bacteriocin transport",
  "GO:0043214": "bacteriocin-transporting ATPase activity",
  "GO:0043215": "daunorubicin transport",
  "GO:0043216": "daunorubicin-transporting ATPase activity",
  "GO:0043217": "myelin maintenance",
  "GO:0043218": "compact myelin",
  "GO:0043219": "lateral loop",
  "GO:0043220": "Schmidt-Lanterman incisure",
  "GO:0043221": "SMC family protein binding",
  "GO:0043223": "cytoplasmic SCF ubiquitin ligase complex",
  "GO:0043224": "nuclear SCF ubiquitin ligase complex",
  "GO:0043225": "anion transmembrane-transporting ATPase activity",
  "GO:0043226": "organelle",
  "GO:0043227": "membrane-bounded organelle",
  "GO:0043228": "non-membrane-bounded organelle",
  "GO:0043229": "intracellular organelle",
  "GO:0043230": "extracellular organelle",
  "GO:0043231": "intracellular membrane-bounded organelle",
  "GO:0043232": "intracellular non-membrane-bounded organelle",
  "GO:0043233": "organelle lumen",
  "GO:0043234": "protein complex",
  "GO:0043235": "receptor complex",
  "GO:0043236": "laminin binding",
  "GO:0043237": "laminin-1 binding",
  "GO:0043240": "Fanconi anaemia nuclear complex",
  "GO:0043241": "protein complex disassembly",
  "GO:0043242": "negative regulation of protein complex disassembly",
  "GO:0043243": "positive regulation of protein complex disassembly",
  "GO:0043244": "regulation of protein complex disassembly",
  "GO:0043245": "extraorganismal space",
  "GO:0043246": "megasome",
  "GO:0043247": "telomere maintenance in response to DNA damage",
  "GO:0043248": "proteasome assembly",
  "GO:0043249": "erythrocyte maturation",
  "GO:0043250": "sodium-dependent organic anion transmembrane transporter activity",
  "GO:0043251": "sodium-dependent organic anion transport",
  "GO:0043252": "sodium-independent organic anion transport",
  "GO:0043253": "chloroplast ribosome",
  "GO:0043254": "regulation of protein complex assembly",
  "GO:0043255": "regulation of carbohydrate biosynthetic process",
  "GO:0043256": "laminin complex",
  "GO:0043257": "laminin-8 complex",
  "GO:0043258": "laminin-9 complex",
  "GO:0043259": "laminin-10 complex",
  "GO:0043260": "laminin-11 complex",
  "GO:0043261": "laminin-12 complex",
  "GO:0043262": "adenosine-diphosphatase activity",
  "GO:0043263": "cellulosome",
  "GO:0043264": "extracellular non-membrane-bounded organelle",
  "GO:0043265": "ectoplasm",
  "GO:0043266": "regulation of potassium ion transport",
  "GO:0043267": "negative regulation of potassium ion transport",
  "GO:0043268": "positive regulation of potassium ion transport",
  "GO:0043269": "regulation of ion transport",
  "GO:0043270": "positive regulation of ion transport",
  "GO:0043271": "negative regulation of ion transport",
  "GO:0043272": "ethylene biosynthesis involved in jasmonic acid and ethylene-dependent systemic resistance",
  "GO:0043273": "CTPase activity",
  "GO:0043274": "phospholipase binding",
  "GO:0043275": "obsolete glutamate carboxypeptidase II activity",
  "GO:0043276": "anoikis",
  "GO:0043277": "apoptotic cell clearance",
  "GO:0043278": "response to morphine",
  "GO:0043279": "response to alkaloid",
  "GO:0043280": "positive regulation of cysteine-type endopeptidase activity involved in apoptotic process",
  "GO:0043281": "regulation of cysteine-type endopeptidase activity involved in apoptotic process",
  "GO:0043282": "pharyngeal muscle development",
  "GO:0043286": "regulation of poly(3-hydroxyalkanoate) biosynthetic process",
  "GO:0043287": "poly(3-hydroxyalkanoate) binding",
  "GO:0043288": "apocarotenoid metabolic process",
  "GO:0043289": "apocarotenoid biosynthetic process",
  "GO:0043290": "apocarotenoid catabolic process",
  "GO:0043291": "RAVE complex",
  "GO:0043292": "contractile fiber",
  "GO:0043293": "apoptosome",
  "GO:0043294": "mitochondrial glutamate synthase complex (NADH)",
  "GO:0043295": "glutathione binding",
  "GO:0043296": "apical junction complex",
  "GO:0043297": "apical junction assembly",
  "GO:0043299": "leukocyte degranulation",
  "GO:0043300": "regulation of leukocyte degranulation",
  "GO:0043301": "negative regulation of leukocyte degranulation",
  "GO:0043302": "positive regulation of leukocyte degranulation",
  "GO:0043303": "mast cell degranulation",
  "GO:0043304": "regulation of mast cell degranulation",
  "GO:0043305": "negative regulation of mast cell degranulation",
  "GO:0043306": "positive regulation of mast cell degranulation",
  "GO:0043307": "eosinophil activation",
  "GO:0043308": "eosinophil degranulation",
  "GO:0043309": "regulation of eosinophil degranulation",
  "GO:0043310": "negative regulation of eosinophil degranulation",
  "GO:0043311": "positive regulation of eosinophil degranulation",
  "GO:0043312": "neutrophil degranulation",
  "GO:0043313": "regulation of neutrophil degranulation",
  "GO:0043314": "negative regulation of neutrophil degranulation",
  "GO:0043315": "positive regulation of neutrophil degranulation",
  "GO:0043316": "cytotoxic T cell degranulation",
  "GO:0043317": "regulation of cytotoxic T cell degranulation",
  "GO:0043318": "negative regulation of cytotoxic T cell degranulation",
  "GO:0043319": "positive regulation of cytotoxic T cell degranulation",
  "GO:0043320": "natural killer cell degranulation",
  "GO:0043321": "regulation of natural killer cell degranulation",
  "GO:0043322": "negative regulation of natural killer cell degranulation",
  "GO:0043323": "positive regulation of natural killer cell degranulation",
  "GO:0043324": "pigment metabolic process involved in developmental pigmentation",
  "GO:0043325": "phosphatidylinositol-3,4-bisphosphate binding",
  "GO:0043326": "chemotaxis to folate",
  "GO:0043327": "chemotaxis to cAMP",
  "GO:0043328": "protein targeting to vacuole involved in ubiquitin-dependent protein catabolic process via the multivesicular body sorting pathway",
  "GO:0043329": "protein targeting to membrane involved in ubiquitin-dependent protein catabolic process via the multivesicular body sorting pathway",
  "GO:0043330": "response to exogenous dsRNA",
  "GO:0043331": "response to dsRNA",
  "GO:0043332": "mating projection tip",
  "GO:0043333": "2-octaprenyl-6-methoxy-1,4-benzoquinone methyltransferase activity",
  "GO:0043334": "2-hexaprenyl-6-methoxy-1,4-benzoquinone methyltransferase activity",
  "GO:0043335": "protein unfolding",
  "GO:0043336": "site-specific telomere resolvase activity",
  "GO:0043337": "CDP-diacylglycerol-phosphatidylglycerol phosphatidyltransferase activity",
  "GO:0043338": "CTP:2,3-di-O-geranylgeranyl-sn-glycero-1-phosphate cytidyltransferase activity",
  "GO:0043353": "enucleate erythrocyte differentiation",
  "GO:0043354": "enucleate erythrocyte maturation",
  "GO:0043362": "nucleate erythrocyte maturation",
  "GO:0043363": "nucleate erythrocyte differentiation",
  "GO:0043364": "catalysis of free radical formation",
  "GO:0043365": "[formate-C-acetyltransferase]-activating enzyme activity",
  "GO:0043366": "beta selection",
  "GO:0043367": "CD4-positive, alpha-beta T cell differentiation",
  "GO:0043368": "positive T cell selection",
  "GO:0043369": "CD4-positive or CD8-positive, alpha-beta T cell lineage commitment",
  "GO:0043370": "regulation of CD4-positive, alpha-beta T cell differentiation",
  "GO:0043371": "negative regulation of CD4-positive, alpha-beta T cell differentiation",
  "GO:0043372": "positive regulation of CD4-positive, alpha-beta T cell differentiation",
  "GO:0043373": "CD4-positive, alpha-beta T cell lineage commitment",
  "GO:0043374": "CD8-positive, alpha-beta T cell differentiation",
  "GO:0043375": "CD8-positive, alpha-beta T cell lineage commitment",
  "GO:0043376": "regulation of CD8-positive, alpha-beta T cell differentiation",
  "GO:0043377": "negative regulation of CD8-positive, alpha-beta T cell differentiation",
  "GO:0043378": "positive regulation of CD8-positive, alpha-beta T cell differentiation",
  "GO:0043379": "memory T cell differentiation",
  "GO:0043380": "regulation of memory T cell differentiation",
  "GO:0043381": "negative regulation of memory T cell differentiation",
  "GO:0043382": "positive regulation of memory T cell differentiation",
  "GO:0043383": "negative T cell selection",
  "GO:0043384": "pre-T cell receptor complex",
  "GO:0043385": "mycotoxin metabolic process",
  "GO:0043386": "mycotoxin biosynthetic process",
  "GO:0043387": "mycotoxin catabolic process",
  "GO:0043388": "positive regulation of DNA binding",
  "GO:0043390": "aflatoxin B1 metabolic process",
  "GO:0043391": "aflatoxin B2 metabolic process",
  "GO:0043392": "negative regulation of DNA binding",
  "GO:0043393": "regulation of protein binding",
  "GO:0043394": "proteoglycan binding",
  "GO:0043395": "heparan sulfate proteoglycan binding",
  "GO:0043396": "corticotropin-releasing hormone secretion",
  "GO:0043397": "regulation of corticotropin-releasing hormone secretion",
  "GO:0043398": "HLH domain binding",
  "GO:0043399": "tRNA A64-2'-O-ribosylphosphate transferase activity",
  "GO:0043400": "cortisol secretion",
  "GO:0043401": "steroid hormone mediated signaling pathway",
  "GO:0043402": "glucocorticoid mediated signaling pathway",
  "GO:0043403": "skeletal muscle tissue regeneration",
  "GO:0043404": "corticotropin-releasing hormone receptor activity",
  "GO:0043405": "regulation of MAP kinase activity",
  "GO:0043406": "positive regulation of MAP kinase activity",
  "GO:0043407": "negative regulation of MAP kinase activity",
  "GO:0043408": "regulation of MAPK cascade",
  "GO:0043409": "negative regulation of MAPK cascade",
  "GO:0043410": "positive regulation of MAPK cascade",
  "GO:0043411": "obsolete myopalladin binding",
  "GO:0043412": "macromolecule modification",
  "GO:0043413": "macromolecule glycosylation",
  "GO:0043414": "macromolecule methylation",
  "GO:0043415": "positive regulation of skeletal muscle tissue regeneration",
  "GO:0043416": "regulation of skeletal muscle tissue regeneration",
  "GO:0043417": "negative regulation of skeletal muscle tissue regeneration",
  "GO:0043418": "homocysteine catabolic process",
  "GO:0043419": "urea catabolic process",
  "GO:0043420": "anthranilate metabolic process",
  "GO:0043421": "anthranilate catabolic process",
  "GO:0043422": "protein kinase B binding",
  "GO:0043423": "3-phosphoinositide-dependent protein kinase binding",
  "GO:0043424": "protein histidine kinase binding",
  "GO:0043425": "bHLH transcription factor binding",
  "GO:0043426": "MRF binding",
  "GO:0043427": "carbon fixation by 3-hydroxypropionate cycle",
  "GO:0043428": "2-heptaprenyl-6-methoxy-1,4-benzoquinone methyltransferase activity",
  "GO:0043429": "2-nonaprenyl-6-methoxy-1,4-benzoquinone methyltransferase activity",
  "GO:0043430": "2-decaprenyl-6-methoxy-1,4-benzoquinone methyltransferase activity",
  "GO:0043431": "2-octaprenyl-3-methyl-5-hydroxy-6-methoxy-1,4-benzoquinone methyltransferase activity",
  "GO:0043433": "negative regulation of sequence-specific DNA binding transcription factor activity",
  "GO:0043434": "response to peptide hormone",
  "GO:0043435": "response to corticotropin-releasing hormone",
  "GO:0043436": "oxoacid metabolic process",
  "GO:0043438": "acetoacetic acid metabolic process",
  "GO:0043441": "acetoacetic acid biosynthetic process",
  "GO:0043442": "acetoacetic acid catabolic process",
  "GO:0043443": "acetone metabolic process",
  "GO:0043444": "acetone catabolic process",
  "GO:0043445": "acetone biosynthetic process",
  "GO:0043446": "cellular alkane metabolic process",
  "GO:0043447": "alkane biosynthetic process",
  "GO:0043448": "alkane catabolic process",
  "GO:0043449": "cellular alkene metabolic process",
  "GO:0043450": "alkene biosynthetic process",
  "GO:0043451": "alkene catabolic process",
  "GO:0043452": "cellular alkyne metabolic process",
  "GO:0043453": "alkyne biosynthetic process",
  "GO:0043454": "alkyne catabolic process",
  "GO:0043455": "regulation of secondary metabolic process",
  "GO:0043456": "regulation of pentose-phosphate shunt",
  "GO:0043457": "regulation of cellular respiration",
  "GO:0043458": "ethanol biosynthetic process involved in glucose fermentation to ethanol",
  "GO:0043459": "obsolete response to short exposure to lithium ion",
  "GO:0043460": "obsolete response to long exposure to lithium ion",
  "GO:0043461": "proton-transporting ATP synthase complex assembly",
  "GO:0043462": "regulation of ATPase activity",
  "GO:0043463": "regulation of rhamnose catabolic process",
  "GO:0043464": "malolactic fermentation",
  "GO:0043465": "regulation of fermentation",
  "GO:0043466": "pyrimidine nucleobase fermentation",
  "GO:0043467": "regulation of generation of precursor metabolites and energy",
  "GO:0043468": "regulation of fucose catabolic process",
  "GO:0043469": "regulation of D-xylose catabolic process",
  "GO:0043470": "regulation of carbohydrate catabolic process",
  "GO:0043471": "regulation of cellular carbohydrate catabolic process",
  "GO:0043472": "IgD binding",
  "GO:0043473": "pigmentation",
  "GO:0043474": "pigment metabolic process involved in pigmentation",
  "GO:0043475": "pigment metabolic process involved in pigment accumulation",
  "GO:0043476": "pigment accumulation",
  "GO:0043477": "pigment biosynthetic process involved in pigment accumulation",
  "GO:0043478": "pigment accumulation in response to UV light",
  "GO:0043479": "pigment accumulation in tissues in response to UV light",
  "GO:0043480": "pigment accumulation in tissues",
  "GO:0043481": "anthocyanin accumulation in tissues in response to UV light",
  "GO:0043482": "cellular pigment accumulation",
  "GO:0043483": "anthocyanin biosynthetic process involved in anthocyanin accumulation in response to UV light",
  "GO:0043484": "regulation of RNA splicing",
  "GO:0043485": "endosome to pigment granule transport",
  "GO:0043486": "histone exchange",
  "GO:0043487": "regulation of RNA stability",
  "GO:0043488": "regulation of mRNA stability",
  "GO:0043489": "RNA stabilization",
  "GO:0043490": "malate-aspartate shuttle",
  "GO:0043491": "protein kinase B signaling",
  "GO:0043492": "ATPase activity, coupled to movement of substances",
  "GO:0043493": "viral terminase complex",
  "GO:0043494": "CLRC ubiquitin ligase complex",
  "GO:0043495": "protein anchor",
  "GO:0043496": "regulation of protein homodimerization activity",
  "GO:0043497": "regulation of protein heterodimerization activity",
  "GO:0043498": "obsolete cell surface binding",
  "GO:0043499": "obsolete eukaryotic cell surface binding",
  "GO:0043500": "muscle adaptation",
  "GO:0043501": "skeletal muscle adaptation",
  "GO:0043502": "regulation of muscle adaptation",
  "GO:0043503": "skeletal muscle fiber adaptation",
  "GO:0043504": "mitochondrial DNA repair",
  "GO:0043505": "CENP-A containing nucleosome",
  "GO:0043506": "regulation of JUN kinase activity",
  "GO:0043507": "positive regulation of JUN kinase activity",
  "GO:0043508": "negative regulation of JUN kinase activity",
  "GO:0043509": "activin A complex",
  "GO:0043510": "activin B complex",
  "GO:0043511": "inhibin complex",
  "GO:0043512": "inhibin A complex",
  "GO:0043513": "inhibin B complex",
  "GO:0043514": "interleukin-12 complex",
  "GO:0043515": "kinetochore binding",
  "GO:0043516": "regulation of DNA damage response, signal transduction by p53 class mediator",
  "GO:0043517": "positive regulation of DNA damage response, signal transduction by p53 class mediator",
  "GO:0043518": "negative regulation of DNA damage response, signal transduction by p53 class mediator",
  "GO:0043519": "regulation of myosin II filament organization",
  "GO:0043520": "regulation of myosin II filament assembly",
  "GO:0043521": "regulation of myosin II filament disassembly",
  "GO:0043522": "leucine zipper domain binding",
  "GO:0043523": "regulation of neuron apoptotic process",
  "GO:0043524": "negative regulation of neuron apoptotic process",
  "GO:0043525": "positive regulation of neuron apoptotic process",
  "GO:0043526": "obsolete neuroprotection",
  "GO:0043527": "tRNA methyltransferase complex",
  "GO:0043528": "tRNA (m2G10) methyltransferase complex",
  "GO:0043529": "GET complex",
  "GO:0043530": "adenosine 5'-monophosphoramidase activity",
  "GO:0043531": "ADP binding",
  "GO:0043532": "angiostatin binding",
  "GO:0043533": "inositol 1,3,4,5 tetrakisphosphate binding",
  "GO:0043534": "blood vessel endothelial cell migration",
  "GO:0043535": "regulation of blood vessel endothelial cell migration",
  "GO:0043536": "positive regulation of blood vessel endothelial cell migration",
  "GO:0043537": "negative regulation of blood vessel endothelial cell migration",
  "GO:0043538": "regulation of actin phosphorylation",
  "GO:0043539": "protein serine/threonine kinase activator activity",
  "GO:0043540": "6-phosphofructo-2-kinase/fructose-2,6-biphosphatase complex",
  "GO:0043541": "UDP-N-acetylglucosamine transferase complex",
  "GO:0043542": "endothelial cell migration",
  "GO:0043543": "protein acylation",
  "GO:0043544": "lipoamide binding",
  "GO:0043545": "molybdopterin cofactor metabolic process",
  "GO:0043546": "molybdopterin cofactor binding",
  "GO:0043547": "positive regulation of GTPase activity",
  "GO:0043548": "phosphatidylinositol 3-kinase binding",
  "GO:0043549": "regulation of kinase activity",
  "GO:0043550": "regulation of lipid kinase activity",
  "GO:0043551": "regulation of phosphatidylinositol 3-kinase activity",
  "GO:0043552": "positive regulation of phosphatidylinositol 3-kinase activity",
  "GO:0043553": "negative regulation of phosphatidylinositol 3-kinase activity",
  "GO:0043554": "aerobic respiration, using arsenite as electron donor",
  "GO:0043555": "regulation of translation in response to stress",
  "GO:0043556": "regulation of translation in response to oxidative stress",
  "GO:0043557": "regulation of translation in response to osmotic stress",
  "GO:0043558": "regulation of translational initiation in response to stress",
  "GO:0043559": "insulin binding",
  "GO:0043560": "insulin receptor substrate binding",
  "GO:0043561": "regulation of translational initiation in response to osmotic stress",
  "GO:0043562": "cellular response to nitrogen levels",
  "GO:0043563": "odorant transporter activity",
  "GO:0043564": "Ku70:Ku80 complex",
  "GO:0043565": "sequence-specific DNA binding",
  "GO:0043566": "structure-specific DNA binding",
  "GO:0043567": "regulation of insulin-like growth factor receptor signaling pathway",
  "GO:0043568": "positive regulation of insulin-like growth factor receptor signaling pathway",
  "GO:0043569": "negative regulation of insulin-like growth factor receptor signaling pathway",
  "GO:0043570": "maintenance of DNA repeat elements",
  "GO:0043571": "maintenance of CRISPR repeat elements",
  "GO:0043572": "plastid fission",
  "GO:0043573": "leucoplast fission",
  "GO:0043574": "peroxisomal transport",
  "GO:0043575": "detection of osmotic stimulus",
  "GO:0043576": "regulation of respiratory gaseous exchange",
  "GO:0043577": "chemotropism",
  "GO:0043578": "nuclear matrix organization",
  "GO:0043579": "elaioplast organization",
  "GO:0043580": "periplasmic space organization",
  "GO:0043581": "mycelium development",
  "GO:0043582": "sporangium development",
  "GO:0043583": "ear development",
  "GO:0043584": "nose development",
  "GO:0043585": "nose morphogenesis",
  "GO:0043586": "tongue development",
  "GO:0043587": "tongue morphogenesis",
  "GO:0043588": "skin development",
  "GO:0043589": "skin morphogenesis",
  "GO:0043590": "bacterial nucleoid",
  "GO:0043591": "endospore external encapsulating structure",
  "GO:0043592": "exosporium",
  "GO:0043593": "endospore coat",
  "GO:0043594": "outer endospore membrane",
  "GO:0043595": "endospore cortex",
  "GO:0043596": "nuclear replication fork",
  "GO:0043597": "cytoplasmic replication fork",
  "GO:0043598": "cytoplasmic DNA replication factor C complex",
  "GO:0043599": "nuclear DNA replication factor C complex",
  "GO:0043600": "cytoplasmic replisome",
  "GO:0043601": "nuclear replisome",
  "GO:0043602": "nitrate catabolic process",
  "GO:0043603": "cellular amide metabolic process",
  "GO:0043604": "amide biosynthetic process",
  "GO:0043605": "cellular amide catabolic process",
  "GO:0043606": "formamide metabolic process",
  "GO:0043607": "formamide biosynthetic process",
  "GO:0043608": "formamide catabolic process",
  "GO:0043609": "regulation of carbon utilization",
  "GO:0043610": "regulation of carbohydrate utilization",
  "GO:0043611": "isoprene metabolic process",
  "GO:0043612": "isoprene biosynthetic process",
  "GO:0043613": "isoprene catabolic process",
  "GO:0043614": "multi-eIF complex",
  "GO:0043615": "astrocyte cell migration",
  "GO:0043616": "keratinocyte proliferation",
  "GO:0043617": "cellular response to sucrose starvation",
  "GO:0043618": "regulation of transcription from RNA polymerase II promoter in response to stress",
  "GO:0043619": "regulation of transcription from RNA polymerase II promoter in response to oxidative stress",
  "GO:0043620": "regulation of DNA-templated transcription in response to stress",
  "GO:0043621": "protein self-association",
  "GO:0043622": "cortical microtubule organization",
  "GO:0043623": "cellular protein complex assembly",
  "GO:0043624": "cellular protein complex disassembly",
  "GO:0043625": "delta DNA polymerase complex",
  "GO:0043626": "PCNA complex",
  "GO:0043627": "response to estrogen",
  "GO:0043628": "ncRNA 3'-end processing",
  "GO:0043629": "ncRNA polyadenylation",
  "GO:0043630": "ncRNA polyadenylation involved in polyadenylation-dependent ncRNA catabolic process",
  "GO:0043631": "RNA polyadenylation",
  "GO:0043632": "modification-dependent macromolecule catabolic process",
  "GO:0043633": "polyadenylation-dependent RNA catabolic process",
  "GO:0043634": "polyadenylation-dependent ncRNA catabolic process",
  "GO:0043635": "methylnaphthalene catabolic process",
  "GO:0043636": "bisphenol A catabolic process",
  "GO:0043637": "puromycin metabolic process",
  "GO:0043638": "puromycin biosynthetic process",
  "GO:0043639": "benzoate catabolic process",
  "GO:0043640": "benzoate catabolic process via hydroxylation",
  "GO:0043641": "novobiocin metabolic process",
  "GO:0043642": "novobiocin biosynthetic process",
  "GO:0043643": "tetracycline metabolic process",
  "GO:0043644": "tetracycline biosynthetic process",
  "GO:0043645": "cephalosporin metabolic process",
  "GO:0043646": "cephalosporin biosynthetic process",
  "GO:0043647": "inositol phosphate metabolic process",
  "GO:0043648": "dicarboxylic acid metabolic process",
  "GO:0043649": "dicarboxylic acid catabolic process",
  "GO:0043650": "dicarboxylic acid biosynthetic process",
  "GO:0043651": "linoleic acid metabolic process",
  "GO:0043652": "engulfment of apoptotic cell",
  "GO:0043653": "mitochondrial fragmentation involved in apoptotic process",
  "GO:0043654": "recognition of apoptotic cell",
  "GO:0043655": "extracellular space of host",
  "GO:0043656": "intracellular region of host",
  "GO:0043657": "host cell",
  "GO:0043658": "host symbiosome",
  "GO:0043659": "symbiosome",
  "GO:0043660": "bacteroid-containing symbiosome",
  "GO:0043661": "peribacteroid membrane",
  "GO:0043662": "peribacteroid fluid",
  "GO:0043663": "host bacteroid-containing symbiosome",
  "GO:0043664": "host peribacteroid membrane",
  "GO:0043665": "host peribacteroid fluid",
  "GO:0043666": "regulation of phosphoprotein phosphatase activity",
  "GO:0043667": "pollen wall",
  "GO:0043668": "exine",
  "GO:0043669": "ectexine",
  "GO:0043670": "foot layer",
  "GO:0043671": "endexine",
  "GO:0043672": "nexine",
  "GO:0043673": "sexine",
  "GO:0043674": "columella",
  "GO:0043675": "sculpture element",
  "GO:0043676": "tectum",
  "GO:0043677": "germination pore",
  "GO:0043678": "intine",
  "GO:0043679": "axon terminus",
  "GO:0043680": "filiform apparatus",
  "GO:0043682": "copper-transporting ATPase activity",
  "GO:0043683": "type IV pilus biogenesis",
  "GO:0043684": "type IV secretion system complex",
  "GO:0043685": "conversion of glutamyl-tRNA to glutaminyl-tRNA",
  "GO:0043686": "co-translational protein modification",
  "GO:0043687": "post-translational protein modification",
  "GO:0043688": "conversion of aspartyl-tRNA to asparaginyl-tRNA",
  "GO:0043689": "cell-cell adhesion involved in flocculation",
  "GO:0043690": "cell-cell adhesion involved in flocculation via cell wall protein-carbohydrate interaction",
  "GO:0043691": "reverse cholesterol transport",
  "GO:0043692": "monoterpene metabolic process",
  "GO:0043693": "monoterpene biosynthetic process",
  "GO:0043694": "monoterpene catabolic process",
  "GO:0043695": "detection of pheromone",
  "GO:0043696": "dedifferentiation",
  "GO:0043697": "cell dedifferentiation",
  "GO:0043698": "iridosome",
  "GO:0043699": "leucosome",
  "GO:0043700": "pterinosome",
  "GO:0043701": "cyanosome",
  "GO:0043702": "carotenoid vesicle",
  "GO:0043703": "photoreceptor cell fate determination",
  "GO:0043704": "photoreceptor cell fate specification",
  "GO:0043705": "cyanophycin metabolic process",
  "GO:0043706": "heterophilic cell adhesion involved in cytoadherence to microvasculature, mediated by parasite protein",
  "GO:0043707": "cell adhesion involved in single-species biofilm formation in or on host organism",
  "GO:0043708": "cell adhesion involved in biofilm formation",
  "GO:0043709": "cell adhesion involved in single-species biofilm formation",
  "GO:0043710": "cell adhesion involved in multi-species biofilm formation",
  "GO:0043711": "pilus organization",
  "GO:0043712": "2-hydroxyisocaproate CoA-transferase activity",
  "GO:0043713": "(R)-2-hydroxyisocaproate dehydrogenase activity",
  "GO:0043714": "(R)-citramalate synthase activity",
  "GO:0043715": "2,3-diketo-5-methylthiopentyl-1-phosphate enolase activity",
  "GO:0043716": "2-hydroxy-3-keto-5-methylthiopentenyl-1-phosphate phosphatase activity",
  "GO:0043717": "2-hydroxyglutaryl-CoA dehydratase activity",
  "GO:0043718": "2-hydroxymethylglutarate dehydrogenase activity",
  "GO:0043719": "2-octaprenyl-3-methyl-6-methoxy-1,4-benzoquinol hydroxylase activity",
  "GO:0043720": "3-keto-5-aminohexanoate cleavage activity",
  "GO:0043721": "4-hydroxybutanoyl-CoA dehydratase activity",
  "GO:0043722": "4-hydroxyphenylacetate decarboxylase activity",
  "GO:0043723": "2,5-diamino-6-ribitylamino-4(3H)-pyrimidinone 5'-phosphate deaminase activity",
  "GO:0043724": "2-keto-3-deoxygalactonate aldolase activity",
  "GO:0043725": "2-keto-3-deoxygluconate aldolase activity",
  "GO:0043726": "5-amino-6-(5-phosphoribitylamino)uracil phosphatase activity",
  "GO:0043727": "5-amino-4-imidazole carboxylate lyase activity",
  "GO:0043728": "2-keto-4-methylthiobutyrate aminotransferase activity",
  "GO:0043729": "2-amino-5-formylamino-6-(5-phosphoribosylamino)pyrimidin-4(3H)-one formate-lyase activity",
  "GO:0043730": "5-ureido-4-imidazole carboxylate hydrolase activity",
  "GO:0043731": "6-hydroxynicotinate 3-monooxygenase activity",
  "GO:0043732": "6-hydroxynicotinate dehydrogenase activity",
  "GO:0043733": "DNA-3-methylbase glycosylase activity",
  "GO:0043734": "DNA-N1-methyladenine dioxygenase activity",
  "GO:0043736": "obsolete DNA-3-methyladenine glycosylase IV activity",
  "GO:0043737": "deoxyribonuclease V activity",
  "GO:0043738": "reduced coenzyme F420 dehydrogenase activity",
  "GO:0043739": "G/U mismatch-specific uracil-DNA glycosylase activity",
  "GO:0043740": "GTP cyclohydrolase IIa activity",
  "GO:0043741": "L-2-aminoadipate N-acetyltransferase activity",
  "GO:0043743": "LPPG:FO 2-phospho-L-lactate transferase activity",
  "GO:0043744": "N2-acetyl-L-aminoadipate kinase activity",
  "GO:0043745": "N2-acetyl-L-aminoadipate semialdehyde dehydrogenase activity",
  "GO:0043746": "N2-acetyl-L-lysine aminotransferase activity",
  "GO:0043747": "N2-acetyl-L-lysine deacetylase activity",
  "GO:0043748": "O-succinylbenzoate synthase activity",
  "GO:0043749": "phenol, water dikinase activity",
  "GO:0043750": "phosphatidylinositol alpha-mannosyltransferase activity",
  "GO:0043751": "polyphosphate:AMP phosphotransferase activity",
  "GO:0043752": "adenosylcobinamide kinase activity",
  "GO:0043754": "dihydrolipoyllysine-residue (2-methylpropanoyl)transferase activity",
  "GO:0043755": "alpha-ribazole phosphatase activity",
  "GO:0043756": "adenosylcobinamide hydrolase activity",
  "GO:0043757": "adenosylcobinamide-phosphate synthase activity",
  "GO:0043758": "acetate-CoA ligase (ADP-forming) activity",
  "GO:0043759": "branched-chain acyl-CoA synthetase (ADP-forming) activity",
  "GO:0043760": "acetyldiaminopimelate aminotransferase activity",
  "GO:0043761": "archaetidylserine synthase activity",
  "GO:0043762": "aryl-CoA synthetase (ADP-forming) activity",
  "GO:0043763": "UTP:glucose-1-phosphate uridylyltransferase regulator activity",
  "GO:0043764": "UDP-3-O-[3-hydroxymyristoyl] glucosamine N-acyltransferase activity",
  "GO:0043765": "T/G mismatch-specific endonuclease activity",
  "GO:0043766": "Sep-tRNA:Cys-tRNA synthase activity",
  "GO:0043767": "pyrrolysyl-tRNA synthetase activity",
  "GO:0043768": "S-ribosylhomocysteine lyase activity",
  "GO:0043769": "Tpg-containing telomere binding complex",
  "GO:0043770": "demethylmenaquinone methyltransferase activity",
  "GO:0043771": "cytidine kinase activity",
  "GO:0043772": "acyl-phosphate glycerol-3-phosphate acyltransferase activity",
  "GO:0043773": "coenzyme F420-0 gamma-glutamyl ligase activity",
  "GO:0043774": "coenzyme F420-2 alpha-glutamyl ligase activity",
  "GO:0043775": "cobyrinate a,c-diamide synthase activity",
  "GO:0043776": "cobalt-precorrin-6B C5-methyltransferase activity",
  "GO:0043777": "cobalt-precorrin-7 C15-methyltransferase activity",
  "GO:0043778": "cobalt-precorrin-8 methylmutase activity",
  "GO:0043779": "cobalt-precorrin-5A acetaldehyde-lyase activity",
  "GO:0043780": "cobalt-precorrin-5B C1-methyltransferase activity",
  "GO:0043781": "cobalt-factor II C20-methyltransferase activity",
  "GO:0043782": "cobalt-precorrin-3 C17-methyltransferase activity",
  "GO:0043783": "oxidoreductase activity, oxidizing metal ions with flavin as acceptor",
  "GO:0043784": "cob(II)yrinic acid a,c-diamide reductase activity",
  "GO:0043785": "cinnamoyl-CoA:phenyllactate CoA-transferase activity",
  "GO:0043786": "cinnamate reductase activity",
  "GO:0043791": "dimethylamine methyltransferase activity",
  "GO:0043792": "enamidase activity",
  "GO:0043793": "beta-ribofuranosylaminobenzene 5'-phosphate synthase activity",
  "GO:0043794": "formate dehydrogenase (coenzyme F420) activity",
  "GO:0043795": "glyceraldehyde oxidoreductase activity",
  "GO:0043796": "glyceraldehyde dehydrogenase (NADP) activity",
  "GO:0043797": "glyceraldehyde-3-phosphate dehydrogenase (ferredoxin) activity",
  "GO:0043798": "glycerate 2-kinase activity",
  "GO:0043799": "glycine oxidase activity",
  "GO:0043800": "hexulose-6-phosphate isomerase activity",
  "GO:0043801": "hexulose-6-phosphate synthase activity",
  "GO:0043802": "hydrogenobyrinic acid a,c-diamide synthase (glutamine-hydrolysing) activity",
  "GO:0043803": "hydroxyneurosporene-O-methyltransferase activity",
  "GO:0043804": "imidazolone hydrolase activity",
  "GO:0043805": "indolepyruvate ferredoxin oxidoreductase activity",
  "GO:0043806": "keto acid formate lyase activity",
  "GO:0043807": "3-methyl-2-oxobutanoate dehydrogenase (ferredoxin) activity",
  "GO:0043808": "lyso-ornithine lipid acyltransferase activity",
  "GO:0043810": "ornithine-acyl [acyl carrier protein] N-acyltransferase activity",
  "GO:0043811": "phosphate:acyl-[acyl carrier protein] acyltransferase activity",
  "GO:0043812": "phosphatidylinositol-4-phosphate phosphatase activity",
  "GO:0043813": "phosphatidylinositol-3,5-bisphosphate 5-phosphatase activity",
  "GO:0043814": "phospholactate guanylyltransferase activity",
  "GO:0043815": "phosphoribosylglycinamide formyltransferase 2 activity",
  "GO:0043816": "phosphoserine-tRNA(Cys) ligase activity",
  "GO:0043817": "phosphosulfolactate synthase activity",
  "GO:0043818": "precorrin-3B synthase activity",
  "GO:0043819": "precorrin-6A synthase (deacetylating) activity",
  "GO:0043820": "propionyl-CoA dehydrogenase activity",
  "GO:0043821": "propionyl-CoA:succinate CoA-transferase activity",
  "GO:0043822": "ribonuclease M5 activity",
  "GO:0043823": "spheroidene monooxygenase activity",
  "GO:0043824": "succinylglutamate-semialdehyde dehydrogenase activity",
  "GO:0043825": "succinylornithine transaminase activity",
  "GO:0043826": "sulfur oxygenase reductase activity",
  "GO:0043827": "tRNA (adenine-57, 58-N(1)-) methyltransferase activity",
  "GO:0043828": "tRNA 2-selenouridine synthase activity",
  "GO:0043829": "tRNA-specific adenosine-37 deaminase activity",
  "GO:0043830": "thiol-driven fumarate reductase activity",
  "GO:0043831": "thiosulfate dehydrogenase (quinone) activity",
  "GO:0043833": "methylamine-specific methylcobalamin:coenzyme M methyltransferase activity",
  "GO:0043834": "trimethylamine methyltransferase activity",
  "GO:0043835": "obsolete uracil/thymine dehydrogenase activity",
  "GO:0043836": "xanthine hydrolase activity",
  "GO:0043837": "valine dehydrogenase (NAD) activity",
  "GO:0043838": "phosphatidylethanolamine:Kdo2-lipid A phosphoethanolamine transferase activity",
  "GO:0043839": "lipid A phosphate methyltransferase activity",
  "GO:0043840": "branched-chain amino acid:2-keto-4-methylthiobutyrate aminotransferase activity",
  "GO:0043841": "(S)-lactate 2-kinase activity",
  "GO:0043842": "Kdo transferase activity",
  "GO:0043843": "ADP-specific glucokinase activity",
  "GO:0043844": "ADP-specific phosphofructokinase activity",
  "GO:0043845": "DNA polymerase III, proofreading complex",
  "GO:0043846": "DNA polymerase III, clamp loader complex",
  "GO:0043847": "DNA polymerase III, clamp loader chi/psi subcomplex",
  "GO:0043848": "excinuclease cho activity",
  "GO:0043849": "Ras palmitoyltransferase activity",
  "GO:0043850": "RecFOR complex",
  "GO:0043851": "methanol-specific methylcobalamin:coenzyme M methyltransferase activity",
  "GO:0043852": "monomethylamine methyltransferase activity",
  "GO:0043853": "methanol-CoM methyltransferase complex",
  "GO:0043854": "cyclic nucleotide-gated mechanosensitive ion channel activity",
  "GO:0043855": "cyclic nucleotide-gated ion channel activity",
  "GO:0043856": "anti-sigma factor antagonist activity",
  "GO:0043857": "N-acetylornithine carbamoyltransferase activity",
  "GO:0043858": "arginine:ornithine antiporter activity",
  "GO:0043859": "obsolete cyanophycinase activity",
  "GO:0043860": "cyanophycin synthetase activity",
  "GO:0043861": "agmatine:putrescine antiporter activity",
  "GO:0043862": "arginine:agmatine antiporter activity",
  "GO:0043863": "4-hydroxy-2-ketopimelate aldolase activity",
  "GO:0043864": "indoleacetamide hydrolase activity",
  "GO:0043865": "methionine transmembrane transporter activity",
  "GO:0043866": "adenylyl-sulfate reductase (thioredoxin) activity",
  "GO:0043867": "7-cyano-7-deazaguanine tRNA-ribosyltransferase activity",
  "GO:0043869": "alpha-aminoadipate acetyltransferase activity",
  "GO:0043870": "N-acetyl-gamma-aminoadipyl-phosphate reductase activity",
  "GO:0043871": "delta1-piperideine-6-carboxylate dehydrogenase activity",
  "GO:0043872": "lysine:cadaverine antiporter activity",
  "GO:0043873": "pyruvate-flavodoxin oxidoreductase activity",
  "GO:0043874": "acireductone synthase activity",
  "GO:0043875": "2-ketobutyrate formate-lyase activity",
  "GO:0043876": "D-threonine aldolase activity",
  "GO:0043877": "galactosamine-6-phosphate isomerase activity",
  "GO:0043878": "glyceraldehyde-3-phosphate dehydrogenase (NAD+) (non-phosphorylating) activity",
  "GO:0043879": "glycolate transmembrane transporter activity",
  "GO:0043880": "crotonyl-CoA reductase activity",
  "GO:0043881": "mesaconyl-CoA hydratase activity",
  "GO:0043882": "malate:sodium symporter activity",
  "GO:0043883": "malolactic enzyme activity",
  "GO:0043884": "CO-methylating acetyl-CoA synthase activity",
  "GO:0043885": "carbon-monoxide dehydrogenase (ferredoxin) activity",
  "GO:0043886": "structural constituent of carboxysome",
  "GO:0043887": "melibiose:sodium symporter activity",
  "GO:0043888": "(S)-2,3-di-O-geranylgeranylglyceryl phosphate synthase activity",
  "GO:0043889": "(S)-3-O-geranylgeranylglyceryl phosphate synthase activity",
  "GO:0043890": "N-acetylgalactosamine-6-sulfatase activity",
  "GO:0043891": "glyceraldehyde-3-phosphate dehydrogenase (NAD(P)+) (phosphorylating) activity",
  "GO:0043892": "methylglyoxal reductase (NADPH-dependent) activity",
  "GO:0043893": "acetate:cation symporter activity",
  "GO:0043894": "acetyl-CoA synthetase acetyltransferase activity",
  "GO:0043895": "cyclomaltodextrin glucanotransferase activity",
  "GO:0043896": "glucan 1,6-alpha-glucosidase activity",
  "GO:0043897": "glucan 1,4-alpha-maltohydrolase activity",
  "GO:0043898": "2,3-dihydroxybiphenyl 1,2-dioxygenase activity",
  "GO:0043899": "phosphoserine:homoserine phosphotransferase activity",
  "GO:0043900": "regulation of multi-organism process",
  "GO:0043901": "negative regulation of multi-organism process",
  "GO:0043902": "positive regulation of multi-organism process",
  "GO:0043903": "regulation of symbiosis, encompassing mutualism through parasitism",
  "GO:0043904": "isochorismate pyruvate lyase activity",
  "GO:0043905": "Ser-tRNA(Thr) hydrolase activity",
  "GO:0043906": "Ala-tRNA(Pro) hydrolase activity",
  "GO:0043907": "Cys-tRNA(Pro) hydrolase activity",
  "GO:0043908": "Ser(Gly)-tRNA(Ala) hydrolase activity",
  "GO:0043909": "N-acetylcitrulline deacetylase activity",
  "GO:0043910": "ATP:coenzyme F420 adenylyltransferase activity",
  "GO:0043911": "D-lysine transaminase activity",
  "GO:0043912": "D-lysine oxidase activity",
  "GO:0043913": "chromosome segregation-directing complex",
  "GO:0043914": "NADPH:sulfur oxidoreductase activity",
  "GO:0043915": "L-seryl-tRNA(Sec) kinase activity",
  "GO:0043916": "DNA-7-methylguanine glycosylase activity",
  "GO:0043917": "ribose 1,5-bisphosphate isomerase activity",
  "GO:0043918": "cadaverine aminopropyltransferase activity",
  "GO:0043919": "agmatine aminopropyltransferase activity",
  "GO:0043920": "aminopropylagmatine ureohydrolase activity",
  "GO:0043921": "modulation by host of viral transcription",
  "GO:0043922": "negative regulation by host of viral transcription",
  "GO:0043923": "positive regulation by host of viral transcription",
  "GO:0043924": "suramin binding",
  "GO:0043927": "exonucleolytic nuclear-transcribed mRNA catabolic process involved in endonucleolytic cleavage-dependent decay",
  "GO:0043928": "exonucleolytic nuclear-transcribed mRNA catabolic process involved in deadenylation-dependent decay",
  "GO:0043929": "primary ovarian follicle growth involved in double layer follicle stage",
  "GO:0043930": "primary ovarian follicle growth involved in primary follicle stage",
  "GO:0043931": "ossification involved in bone maturation",
  "GO:0043932": "ossification involved in bone remodeling",
  "GO:0043933": "macromolecular complex subunit organization",
  "GO:0043934": "sporulation",
  "GO:0043935": "sexual sporulation resulting in formation of a cellular spore",
  "GO:0043936": "asexual sporulation resulting in formation of a cellular spore",
  "GO:0043937": "regulation of sporulation",
  "GO:0043938": "positive regulation of sporulation",
  "GO:0043939": "negative regulation of sporulation",
  "GO:0043940": "regulation of sexual sporulation resulting in formation of a cellular spore",
  "GO:0043941": "positive regulation of sexual sporulation resulting in formation of a cellular spore",
  "GO:0043942": "negative regulation of sexual sporulation resulting in formation of a cellular spore",
  "GO:0043943": "regulation of asexual sporulation resulting in formation of a cellular spore",
  "GO:0043944": "negative regulation of asexual sporulation resulting in formation of a cellular spore",
  "GO:0043945": "positive regulation of asexual sporulation resulting in formation of a cellular spore",
  "GO:0043946": "positive regulation of catalytic activity in other organism involved in symbiotic interaction",
  "GO:0043947": "positive regulation by host of symbiont catalytic activity",
  "GO:0043948": "positive regulation by symbiont of host catalytic activity",
  "GO:0043949": "regulation of cAMP-mediated signaling",
  "GO:0043950": "positive regulation of cAMP-mediated signaling",
  "GO:0043951": "negative regulation of cAMP-mediated signaling",
  "GO:0043952": "protein transport by the Sec complex",
  "GO:0043953": "protein transport by the Tat complex",
  "GO:0043954": "cellular component maintenance",
  "GO:0043955": "3-hydroxypropionyl-CoA synthetase activity",
  "GO:0043956": "3-hydroxypropionyl-CoA dehydratase activity",
  "GO:0043957": "acryloyl-CoA reductase (NADP+) activity",
  "GO:0043958": "acryloyl-CoA reductase activity",
  "GO:0043959": "L-erythro-3-methylmalyl-CoA lyase activity",
  "GO:0043960": "L-erythro-3-methylmalyl-CoA dehydratase activity",
  "GO:0043961": "succinyl-CoA:(R)-citramalate CoA-transferase activity",
  "GO:0043962": "negative regulation by host of symbiont adenylate cyclase-mediated signal transduction",
  "GO:0043963": "modulation by symbiont of host adenylate cyclase-mediated signal transduction",
  "GO:0043964": "positive regulation by symbiont of host adenylate cyclase-mediated signal transduction",
  "GO:0043965": "negative regulation by symbiont of host adenylate cyclase-mediated signal transduction",
  "GO:0043966": "histone H3 acetylation",
  "GO:0043967": "histone H4 acetylation",
  "GO:0043968": "histone H2A acetylation",
  "GO:0043969": "histone H2B acetylation",
  "GO:0043970": "histone H3-K9 acetylation",
  "GO:0043971": "histone H3-K18 acetylation",
  "GO:0043972": "histone H3-K23 acetylation",
  "GO:0043973": "histone H3-K4 acetylation",
  "GO:0043974": "histone H3-K27 acetylation",
  "GO:0043975": "histone H3-K36 acetylation",
  "GO:0043976": "histone H3-K79 acetylation",
  "GO:0043977": "histone H2A-K5 acetylation",
  "GO:0043978": "histone H2A-K9 acetylation",
  "GO:0043979": "histone H2B-K5 acetylation",
  "GO:0043980": "histone H2B-K12 acetylation",
  "GO:0043981": "histone H4-K5 acetylation",
  "GO:0043982": "histone H4-K8 acetylation",
  "GO:0043983": "histone H4-K12 acetylation",
  "GO:0043984": "histone H4-K16 acetylation",
  "GO:0043985": "histone H4-R3 methylation",
  "GO:0043987": "histone H3-S10 phosphorylation",
  "GO:0043988": "histone H3-S28 phosphorylation",
  "GO:0043989": "histone H4-S1 phosphorylation",
  "GO:0043990": "histone H2A-S1 phosphorylation",
  "GO:0043991": "histone H2B-S14 phosphorylation",
  "GO:0043992": "histone acetyltransferase activity (H3-K9 specific)",
  "GO:0043993": "histone acetyltransferase activity (H3-K18 specific)",
  "GO:0043994": "histone acetyltransferase activity (H3-K23 specific)",
  "GO:0043995": "histone acetyltransferase activity (H4-K5 specific)",
  "GO:0043996": "histone acetyltransferase activity (H4-K8 specific)",
  "GO:0043997": "histone acetyltransferase activity (H4-K12 specific)",
  "GO:0043998": "H2A histone acetyltransferase activity",
  "GO:0043999": "histone acetyltransferase activity (H2A-K5 specific)",
  "GO:0044000": "movement in host",
  "GO:0044001": "migration in host",
  "GO:0044002": "acquisition of nutrients from host",
  "GO:0044003": "modification by symbiont of host morphology or physiology",
  "GO:0044004": "disruption by symbiont of host cell",
  "GO:0044005": "induction by symbiont in host of tumor, nodule, or growth",
  "GO:0044006": "induction by symbiont in host of tumor, nodule, or growth containing transformed cells",
  "GO:0044007": "dissemination or transmission of symbiont from host",
  "GO:0044008": "dissemination or transmission of symbiont from host by vector",
  "GO:0044009": "viral transmission by vector",
  "GO:0044010": "single-species biofilm formation",
  "GO:0044011": "single-species biofilm formation on inanimate substrate",
  "GO:0044012": "histone acetyltransferase activity (H2A-K9 specific)",
  "GO:0044013": "H2B histone acetyltransferase activity",
  "GO:0044014": "histone acetyltransferase activity (H2B-K5 specific)",
  "GO:0044015": "histone acetyltransferase activity (H2B-K12 specific)",
  "GO:0044016": "histone acetyltransferase activity (H3-K4 specific)",
  "GO:0044017": "histone acetyltransferase activity (H3-K27 specific)",
  "GO:0044018": "histone acetyltransferase activity (H3-K36 specific)",
  "GO:0044019": "histone acetyltransferase activity (H3-K72 specific)",
  "GO:0044020": "histone methyltransferase activity (H4-R3 specific)",
  "GO:0044022": "histone kinase activity (H3-S28 specific)",
  "GO:0044023": "histone kinase activity (H4-S1 specific)",
  "GO:0044024": "histone kinase activity (H2A-S1 specific)",
  "GO:0044025": "histone kinase activity (H2B-S14 specific)",
  "GO:0044026": "DNA hypermethylation",
  "GO:0044027": "hypermethylation of CpG island",
  "GO:0044028": "DNA hypomethylation",
  "GO:0044029": "hypomethylation of CpG island",
  "GO:0044030": "regulation of DNA methylation",
  "GO:0044031": "modification by symbiont of host protein by phosphorylation",
  "GO:0044032": "modulation by symbiont of indole acetic acid levels in host",
  "GO:0044033": "multi-organism metabolic process",
  "GO:0044034": "multi-organism biosynthetic process",
  "GO:0044035": "multi-organism catabolic process",
  "GO:0044036": "cell wall macromolecule metabolic process",
  "GO:0044037": "multi-organism cell wall macromolecule metabolic process",
  "GO:0044038": "cell wall macromolecule biosynthetic process",
  "GO:0044040": "multi-organism carbohydrate metabolic process",
  "GO:0044041": "multi-organism carbohydrate catabolic process",
  "GO:0044042": "glucan metabolic process",
  "GO:0044043": "multi-organism glucan metabolic process",
  "GO:0044044": "interaction with host via substance in symbiont surface",
  "GO:0044045": "interaction with host via substance in symbiont cell outer membrane",
  "GO:0044046": "interaction with host via substance released outside of symbiont",
  "GO:0044047": "interaction with host via protein secreted by type I secretion system",
  "GO:0044048": "interaction with host via protein secreted by type V secretion system",
  "GO:0044049": "interaction with host via protein secreted by type VI secretion system",
  "GO:0044050": "interaction with host via substance released by sporangium lysis",
  "GO:0044051": "interaction with host via substance released by symbiont cytolysis",
  "GO:0044052": "interaction with host via substance released by membrane budding",
  "GO:0044053": "translocation of peptides or proteins into host cell cytoplasm",
  "GO:0044054": "rounding by symbiont of host cells",
  "GO:0044055": "modulation by symbiont of host system process",
  "GO:0044056": "modulation by symbiont of host digestive system process",
  "GO:0044057": "regulation of system process",
  "GO:0044058": "regulation of digestive system process",
  "GO:0044059": "modulation by symbiont of host endocrine process",
  "GO:0044060": "regulation of endocrine process",
  "GO:0044061": "modulation by symbiont of host excretion",
  "GO:0044062": "regulation of excretion",
  "GO:0044063": "modulation by symbiont of host neurological system process",
  "GO:0044064": "modulation by symbiont of host respiratory system process",
  "GO:0044065": "regulation of respiratory system process",
  "GO:0044066": "modification by symbiont of host cell nucleus",
  "GO:0044067": "modification by symbiont of host intercellular junctions",
  "GO:0044068": "modulation by symbiont of host cellular process",
  "GO:0044069": "modulation by symbiont of host anion transport",
  "GO:0044070": "regulation of anion transport",
  "GO:0044071": "modulation by symbiont of host cell cycle",
  "GO:0044072": "negative regulation by symbiont of host cell cycle",
  "GO:0044073": "modulation by symbiont of host translation",
  "GO:0044074": "negative regulation by symbiont of host translation",
  "GO:0044075": "modulation by symbiont of host vacuole organization",
  "GO:0044076": "positive regulation by symbiont of host vacuole organization",
  "GO:0044077": "modulation by symbiont of host receptor-mediated endocytosis",
  "GO:0044078": "positive regulation by symbiont of host receptor-mediated endocytosis",
  "GO:0044079": "modulation by symbiont of host neurotransmitter secretion",
  "GO:0044080": "modulation by symbiont of host cGMP-mediated signal transduction",
  "GO:0044081": "modulation by symbiont of host nitric oxide-mediated signal transduction",
  "GO:0044082": "modulation by symbiont of host small GTPase mediated signal transduction",
  "GO:0044083": "modulation by symbiont of host Rho protein signal transduction",
  "GO:0044084": "host cell membrane pore complex",
  "GO:0044085": "cellular component biogenesis",
  "GO:0044087": "regulation of cellular component biogenesis",
  "GO:0044088": "regulation of vacuole organization",
  "GO:0044089": "positive regulation of cellular component biogenesis",
  "GO:0044090": "positive regulation of vacuole organization",
  "GO:0044091": "membrane biogenesis",
  "GO:0044092": "negative regulation of molecular function",
  "GO:0044093": "positive regulation of molecular function",
  "GO:0044094": "host cell nuclear part",
  "GO:0044095": "host cell nucleoplasm",
  "GO:0044096": "type IV pilus",
  "GO:0044097": "secretion by the type IV secretion system",
  "GO:0044098": "DNA secretion by the type IV secretion system",
  "GO:0044099": "polar tube",
  "GO:0044100": "sporoplasm",
  "GO:0044101": "(R)-citramalyl-CoA lyase activity",
  "GO:0044102": "purine deoxyribosyltransferase activity",
  "GO:0044103": "L-arabinose 1-dehydrogenase (NADP+) activity",
  "GO:0044104": "2,5-dioxovalerate dehydrogenase (NAD+) activity",
  "GO:0044105": "L-xylulose reductase (NAD+) activity",
  "GO:0044106": "cellular amine metabolic process",
  "GO:0044107": "cellular alcohol metabolic process",
  "GO:0044108": "cellular alcohol biosynthetic process",
  "GO:0044109": "cellular alcohol catabolic process",
  "GO:0044110": "growth involved in symbiotic interaction",
  "GO:0044111": "development involved in symbiotic interaction",
  "GO:0044112": "growth in other organism involved in symbiotic interaction",
  "GO:0044113": "development in other organism involved in symbiotic interaction",
  "GO:0044114": "development of symbiont in host",
  "GO:0044115": "development of symbiont involved in interaction with host",
  "GO:0044116": "growth of symbiont involved in interaction with host",
  "GO:0044117": "growth of symbiont in host",
  "GO:0044118": "development of symbiont in host cell",
  "GO:0044119": "growth of symbiont in host cell",
  "GO:0044120": "development of symbiont in host organelle",
  "GO:0044121": "growth of symbiont in host organelle",
  "GO:0044122": "development of symbiont in host vascular tissue",
  "GO:0044123": "growth of symbiont in host vascular tissue",
  "GO:0044124": "development of symbiont in host intercellular space",
  "GO:0044125": "growth of symbiont in host intercellular space",
  "GO:0044126": "regulation of growth of symbiont in host",
  "GO:0044127": "regulation of development of symbiont in host",
  "GO:0044128": "positive regulation of growth of symbiont in host",
  "GO:0044129": "positive regulation of development of symbiont in host",
  "GO:0044130": "negative regulation of growth of symbiont in host",
  "GO:0044131": "negative regulation of development of symbiont in host",
  "GO:0044132": "development of symbiont on or near host",
  "GO:0044133": "growth of symbiont on or near host",
  "GO:0044134": "development of symbiont on or near host phyllosphere",
  "GO:0044135": "growth of symbiont on or near host phyllosphere",
  "GO:0044136": "development of symbiont on or near host rhizosphere",
  "GO:0044137": "growth of symbiont on or near host rhizosphere",
  "GO:0044138": "modulation of development of symbiont on or near host",
  "GO:0044139": "modulation of growth of symbiont on or near host",
  "GO:0044140": "negative regulation of growth of symbiont on or near host surface",
  "GO:0044141": "negative regulation of development of symbiont on or near host surface",
  "GO:0044142": "positive regulation of growth of symbiont on or near host surface",
  "GO:0044143": "positive regulation of development of symbiont on or near host surface",
  "GO:0044144": "modulation of growth of symbiont involved in interaction with host",
  "GO:0044145": "modulation of development of symbiont involved in interaction with host",
  "GO:0044146": "negative regulation of growth of symbiont involved in interaction with host",
  "GO:0044147": "negative regulation of development of symbiont involved in interaction with host",
  "GO:0044148": "positive regulation of growth of symbiont involved in interaction with host",
  "GO:0044149": "positive regulation of development of symbiont involved in interaction with host",
  "GO:0044150": "development of organism on or near symbiont surface",
  "GO:0044151": "growth of organism on or near symbiont surface",
  "GO:0044152": "development on or near surface of other organism involved in symbiotic interaction",
  "GO:0044153": "growth on or near surface of other organism involved in symbiotic interaction",
  "GO:0044154": "histone H3-K14 acetylation",
  "GO:0044155": "host caveola",
  "GO:0044156": "host cell junction",
  "GO:0044157": "host cell projection",
  "GO:0044158": "host cell wall",
  "GO:0044159": "host thylakoid",
  "GO:0044160": "host thylakoid membrane",
  "GO:0044161": "host cell cytoplasmic vesicle",
  "GO:0044162": "host cell cytoplasmic vesicle membrane",
  "GO:0044163": "host cytoskeleton",
  "GO:0044164": "host cell cytosol",
  "GO:0044165": "host cell endoplasmic reticulum",
  "GO:0044166": "host cell endoplasmic reticulum lumen",
  "GO:0044167": "host cell endoplasmic reticulum membrane",
  "GO:0044168": "host cell rough endoplasmic reticulum",
  "GO:0044169": "host cell rough endoplasmic reticulum membrane",
  "GO:0044170": "host cell smooth endoplasmic reticulum",
  "GO:0044171": "host cell smooth endoplasmic reticulum membrane",
  "GO:0044172": "host cell endoplasmic reticulum-Golgi intermediate compartment",
  "GO:0044173": "host cell endoplasmic reticulum-Golgi intermediate compartment membrane",
  "GO:0044174": "host cell endosome",
  "GO:0044175": "host cell endosome membrane",
  "GO:0044176": "host cell filopodium",
  "GO:0044177": "host cell Golgi apparatus",
  "GO:0044178": "host cell Golgi membrane",
  "GO:0044179": "hemolysis in other organism",
  "GO:0044180": "filamentous growth of a unicellular organism",
  "GO:0044181": "filamentous growth of a multicellular organism",
  "GO:0044182": "filamentous growth of a population of unicellular organisms",
  "GO:0044183": "protein binding involved in protein folding",
  "GO:0044184": "host cell late endosome",
  "GO:0044185": "host cell late endosome membrane",
  "GO:0044186": "host cell lipid particle",
  "GO:0044187": "host cell lysosome",
  "GO:0044188": "host cell lysosomal membrane",
  "GO:0044189": "obsolete host cell microsome",
  "GO:0044190": "host cell mitochondrial envelope",
  "GO:0044191": "host cell mitochondrial membrane",
  "GO:0044192": "host cell mitochondrial inner membrane",
  "GO:0044193": "host cell mitochondrial outer membrane",
  "GO:0044194": "cytolytic granule",
  "GO:0044195": "nucleoplasmic reticulum",
  "GO:0044196": "host cell nucleolus",
  "GO:0044197": "Rel homology domain binding",
  "GO:0044198": "zf-TRAF domain binding",
  "GO:0044199": "host cell nuclear envelope",
  "GO:0044200": "host cell nuclear membrane",
  "GO:0044201": "host cell nuclear inner membrane",
  "GO:0044202": "host cell nuclear outer membrane",
  "GO:0044203": "host cell nuclear lamina",
  "GO:0044204": "host cell nuclear matrix",
  "GO:0044205": "'de novo' UMP biosynthetic process",
  "GO:0044206": "UMP salvage",
  "GO:0044207": "translation initiation ternary complex",
  "GO:0044208": "'de novo' AMP biosynthetic process",
  "GO:0044209": "AMP salvage",
  "GO:0044210": "'de novo' CTP biosynthetic process",
  "GO:0044211": "CTP salvage",
  "GO:0044212": "transcription regulatory region DNA binding",
  "GO:0044213": "intronic transcription regulatory region DNA binding",
  "GO:0044214": "spanning component of plasma membrane",
  "GO:0044215": "other organism",
  "GO:0044216": "other organism cell",
  "GO:0044217": "other organism part",
  "GO:0044218": "other organism cell membrane",
  "GO:0044219": "host cell plasmodesma",
  "GO:0044220": "host cell perinuclear region of cytoplasm",
  "GO:0044221": "host cell synapse",
  "GO:0044222": "anammoxosome",
  "GO:0044223": "pirellulosome",
  "GO:0044224": "juxtaparanode region of axon",
  "GO:0044225": "apical pole of neuron",
  "GO:0044226": "basal pole of neuron",
  "GO:0044227": "methane-oxidizing organelle",
  "GO:0044228": "host cell surface",
  "GO:0044229": "host cell periplasmic space",
  "GO:0044230": "host cell envelope",
  "GO:0044231": "host cell presynaptic membrane",
  "GO:0044232": "organelle membrane contact site",
  "GO:0044233": "ER-mitochondrion membrane contact site",
  "GO:0044236": "multicellular organism metabolic process",
  "GO:0044237": "cellular metabolic process",
  "GO:0044238": "primary metabolic process",
  "GO:0044239": "salivary polysaccharide catabolic process",
  "GO:0044240": "multicellular organism lipid catabolic process",
  "GO:0044241": "lipid digestion",
  "GO:0044242": "cellular lipid catabolic process",
  "GO:0044243": "multicellular organism catabolic process",
  "GO:0044244": "multicellular organismal polysaccharide catabolic process",
  "GO:0044245": "polysaccharide digestion",
  "GO:0044246": "regulation of multicellular organismal metabolic process",
  "GO:0044247": "cellular polysaccharide catabolic process",
  "GO:0044248": "cellular catabolic process",
  "GO:0044249": "cellular biosynthetic process",
  "GO:0044250": "negative regulation of metabolic activity involved in hibernation",
  "GO:0044251": "protein catabolic process by pepsin",
  "GO:0044252": "negative regulation of multicellular organismal metabolic process",
  "GO:0044253": "positive regulation of multicellular organismal metabolic process",
  "GO:0044254": "multicellular organismal protein catabolic process",
  "GO:0044255": "cellular lipid metabolic process",
  "GO:0044256": "protein digestion",
  "GO:0044257": "cellular protein catabolic process",
  "GO:0044258": "intestinal lipid catabolic process",
  "GO:0044259": "multicellular organismal macromolecule metabolic process",
  "GO:0044260": "cellular macromolecule metabolic process",
  "GO:0044261": "multicellular organism carbohydrate metabolic process",
  "GO:0044262": "cellular carbohydrate metabolic process",
  "GO:0044263": "multicellular organismal polysaccharide metabolic process",
  "GO:0044264": "cellular polysaccharide metabolic process",
  "GO:0044265": "cellular macromolecule catabolic process",
  "GO:0044266": "multicellular organismal macromolecule catabolic process",
  "GO:0044267": "cellular protein metabolic process",
  "GO:0044268": "multicellular organismal protein metabolic process",
  "GO:0044269": "glycerol ether catabolic process",
  "GO:0044270": "cellular nitrogen compound catabolic process",
  "GO:0044271": "cellular nitrogen compound biosynthetic process",
  "GO:0044272": "sulfur compound biosynthetic process",
  "GO:0044273": "sulfur compound catabolic process",
  "GO:0044274": "multicellular organism biosynthetic process",
  "GO:0044275": "cellular carbohydrate catabolic process",
  "GO:0044276": "multicellular organism carbohydrate catabolic process",
  "GO:0044277": "cell wall disassembly",
  "GO:0044278": "cell wall disruption in other organism",
  "GO:0044279": "other organism membrane",
  "GO:0044280": "subplasmalemmal coating",
  "GO:0044281": "small molecule metabolic process",
  "GO:0044282": "small molecule catabolic process",
  "GO:0044283": "small molecule biosynthetic process",
  "GO:0044284": "mitochondrial crista junction",
  "GO:0044285": "bridge contact site",
  "GO:0044286": "peg and socket contact",
  "GO:0044288": "puncta adhaerentia",
  "GO:0044289": "contact site",
  "GO:0044290": "mitochondrial intracristal space",
  "GO:0044291": "cell-cell contact zone",
  "GO:0044292": "dendrite terminus",
  "GO:0044293": "dendriole",
  "GO:0044294": "dendritic growth cone",
  "GO:0044295": "axonal growth cone",
  "GO:0044296": "dendritic tuft",
  "GO:0044297": "cell body",
  "GO:0044298": "cell body membrane",
  "GO:0044299": "C-fiber",
  "GO:0044300": "cerebellar mossy fiber",
  "GO:0044301": "climbing fiber",
  "GO:0044302": "dentate gyrus mossy fiber",
  "GO:0044303": "axon collateral",
  "GO:0044304": "main axon",
  "GO:0044305": "calyx of Held",
  "GO:0044306": "neuron projection terminus",
  "GO:0044307": "dendritic branch",
  "GO:0044308": "axonal spine",
  "GO:0044309": "neuron spine",
  "GO:0044310": "osmiophilic body",
  "GO:0044311": "exoneme",
  "GO:0044312": "crystalloid",
  "GO:0044313": "protein K6-linked deubiquitination",
  "GO:0044314": "protein K27-linked ubiquitination",
  "GO:0044315": "protein secretion by the type VII secretion system",
  "GO:0044316": "cone cell pedicle",
  "GO:0044317": "rod spherule",
  "GO:0044318": "L-aspartate:fumarate oxidoreductase activity",
  "GO:0044319": "wound healing, spreading of cells",
  "GO:0044320": "cellular response to leptin stimulus",
  "GO:0044321": "response to leptin",
  "GO:0044322": "endoplasmic reticulum quality control compartment",
  "GO:0044323": "retinoic acid-responsive element binding",
  "GO:0044324": "regulation of transcription involved in anterior/posterior axis specification",
  "GO:0044325": "ion channel binding",
  "GO:0044326": "dendritic spine neck",
  "GO:0044327": "dendritic spine head",
  "GO:0044328": "canonical Wnt signaling pathway involved in positive regulation of endothelial cell migration",
  "GO:0044329": "canonical Wnt signaling pathway involved in positive regulation of cell-cell adhesion",
  "GO:0044330": "canonical Wnt signaling pathway involved in positive regulation of wound healing",
  "GO:0044331": "cell-cell adhesion mediated by cadherin",
  "GO:0044332": "Wnt signaling pathway involved in dorsal/ventral axis specification",
  "GO:0044333": "Wnt signaling pathway involved in digestive tract morphogenesis",
  "GO:0044334": "canonical Wnt signaling pathway involved in positive regulation of epithelial to mesenchymal transition",
  "GO:0044335": "canonical Wnt signaling pathway involved in neural crest cell differentiation",
  "GO:0044336": "canonical Wnt signaling pathway involved in negative regulation of apoptotic process",
  "GO:0044337": "canonical Wnt signaling pathway involved in positive regulation of apoptotic process",
  "GO:0044338": "canonical Wnt signaling pathway involved in mesenchymal stem cell differentiation",
  "GO:0044339": "canonical Wnt signaling pathway involved in osteoblast differentiation",
  "GO:0044340": "canonical Wnt signaling pathway involved in regulation of cell proliferation",
  "GO:0044341": "sodium-dependent phosphate transport",
  "GO:0044342": "type B pancreatic cell proliferation",
  "GO:0044343": "canonical Wnt signaling pathway involved in regulation of type B pancreatic cell proliferation",
  "GO:0044344": "cellular response to fibroblast growth factor stimulus",
  "GO:0044345": "stromal-epithelial cell signaling involved in prostate gland development",
  "GO:0044346": "fibroblast apoptotic process",
  "GO:0044347": "cell wall polysaccharide catabolic process",
  "GO:0044348": "plant-type cell wall cellulose catabolic process",
  "GO:0044349": "DNA excision",
  "GO:0044350": "micropinocytosis",
  "GO:0044351": "macropinocytosis",
  "GO:0044352": "pinosome",
  "GO:0044353": "micropinosome",
  "GO:0044354": "macropinosome",
  "GO:0044355": "clearance of foreign intracellular DNA",
  "GO:0044356": "clearance of foreign intracellular DNA by conversion of DNA cytidine to uridine",
  "GO:0044357": "regulation of rRNA stability",
  "GO:0044358": "envenomation resulting in hemorrhagic damage to other organism",
  "GO:0044359": "modulation of molecular function in other organism",
  "GO:0044360": "modulation of voltage-gated potassium channel activity in other organism",
  "GO:0044361": "negative regulation of voltage-gated potassium channel activity in other organism",
  "GO:0044362": "negative regulation of molecular function in other organism",
  "GO:0044363": "modulation of potassium channel activity in other organism",
  "GO:0044364": "disruption of cells of other organism",
  "GO:0044365": "envenomation resulting in modulation of platelet aggregation in other organism",
  "GO:0044366": "feeding on or from other organism",
  "GO:0044367": "feeding from tissue of other organism",
  "GO:0044368": "feeding from vascular tissue of another organism",
  "GO:0044369": "feeding on blood of other organism",
  "GO:0044370": "injection of substance into other organism during feeding on blood of other organism",
  "GO:0044371": "feeding from phloem of other organism",
  "GO:0044372": "feeding from xylem of other organism",
  "GO:0044373": "cytokinin binding",
  "GO:0044374": "sequence-specific DNA binding, bending",
  "GO:0044375": "regulation of peroxisome size",
  "GO:0044376": "RNA polymerase II complex import to nucleus",
  "GO:0044377": "RNA polymerase II core promoter proximal region sequence-specific DNA binding, bending",
  "GO:0044378": "non-sequence-specific DNA binding, bending",
  "GO:0044379": "protein localization to actin cortical patch",
  "GO:0044380": "protein localization to cytoskeleton",
  "GO:0044381": "glucose import in response to insulin stimulus",
  "GO:0044382": "CLRC ubiquitin ligase complex localization to heterochromatin",
  "GO:0044383": "host chromosome",
  "GO:0044384": "host outer membrane",
  "GO:0044385": "integral to membrane of host cell",
  "GO:0044386": "integral to host endoplasmic reticulum membrane",
  "GO:0044387": "negative regulation of protein kinase activity by regulation of protein phosphorylation",
  "GO:0044388": "small protein activating enzyme binding",
  "GO:0044389": "ubiquitin-like protein ligase binding",
  "GO:0044390": "ubiquitin-like protein conjugating enzyme binding",
  "GO:0044391": "ribosomal subunit",
  "GO:0044392": "peptidyl-lysine malonylation",
  "GO:0044393": "microspike",
  "GO:0044394": "protein malonylation",
  "GO:0044395": "protein targeting to vacuolar membrane",
  "GO:0044396": "actin cortical patch organization",
  "GO:0044397": "actin cortical patch internalization",
  "GO:0044398": "envenomation resulting in induction of edema in other organism",
  "GO:0044399": "multi-species biofilm formation",
  "GO:0044400": "multi-species biofilm formation on inanimate substrate",
  "GO:0044401": "multi-species biofilm formation in or on host organism",
  "GO:0044402": "competition with other organism",
  "GO:0044403": "symbiosis, encompassing mutualism through parasitism",
  "GO:0044405": "recognition of host",
  "GO:0044406": "adhesion of symbiont to host",
  "GO:0044407": "single-species biofilm formation in or on host organism",
  "GO:0044408": "obsolete growth or development of symbiont on or near host",
  "GO:0044409": "entry into host",
  "GO:0044410": "entry into host through natural portals",
  "GO:0044411": "entry into host through host barriers",
  "GO:0044412": "obsolete growth or development of symbiont in host",
  "GO:0044413": "avoidance of host defenses",
  "GO:0044414": "suppression of host defenses",
  "GO:0044415": "evasion or tolerance of host defenses",
  "GO:0044416": "induction by symbiont of host defense response",
  "GO:0044417": "translocation of molecules into host",
  "GO:0044418": "translocation of DNA into host",
  "GO:0044419": "interspecies interaction between organisms",
  "GO:0044420": "extracellular matrix component",
  "GO:0044421": "extracellular region part",
  "GO:0044422": "organelle part",
  "GO:0044423": "virion part",
  "GO:0044424": "intracellular part",
  "GO:0044425": "membrane part",
  "GO:0044426": "cell wall part",
  "GO:0044427": "chromosomal part",
  "GO:0044428": "nuclear part",
  "GO:0044429": "mitochondrial part",
  "GO:0044430": "cytoskeletal part",
  "GO:0044431": "Golgi apparatus part",
  "GO:0044432": "endoplasmic reticulum part",
  "GO:0044433": "cytoplasmic vesicle part",
  "GO:0044434": "chloroplast part",
  "GO:0044435": "plastid part",
  "GO:0044436": "thylakoid part",
  "GO:0044437": "vacuolar part",
  "GO:0044438": "microbody part",
  "GO:0044439": "peroxisomal part",
  "GO:0044440": "endosomal part",
  "GO:0044441": "ciliary part",
  "GO:0044443": "pilus part",
  "GO:0044444": "cytoplasmic part",
  "GO:0044445": "cytosolic part",
  "GO:0044446": "intracellular organelle part",
  "GO:0044447": "axoneme part",
  "GO:0044448": "cell cortex part",
  "GO:0044449": "contractile fiber part",
  "GO:0044450": "microtubule organizing center part",
  "GO:0044451": "nucleoplasm part",
  "GO:0044452": "nucleolar part",
  "GO:0044453": "nuclear membrane part",
  "GO:0044454": "nuclear chromosome part",
  "GO:0044455": "mitochondrial membrane part",
  "GO:0044456": "synapse part",
  "GO:0044457": "cell septum part",
  "GO:0044458": "motile cilium assembly",
  "GO:0044459": "plasma membrane part",
  "GO:0044460": "obsolete flagellum part",
  "GO:0044461": "bacterial-type flagellum part",
  "GO:0044462": "external encapsulating structure part",
  "GO:0044463": "cell projection part",
  "GO:0044464": "cell part",
  "GO:0044465": "modulation of sensory perception of pain in other organism",
  "GO:0044466": "glutaryl-CoA hydrolase activity",
  "GO:0044467": "glial cell-derived neurotrophic factor secretion",
  "GO:0044468": "envenomation resulting in modulation of blood coagulation in other organism",
  "GO:0044469": "envenomation resulting in positive regulation of blood coagulation in other organism",
  "GO:0044470": "envenomation resulting in negative regulation of blood coagulation in other organism",
  "GO:0044471": "envenomation resulting in pore formation in membrane of other organism",
  "GO:0044472": "envenomation resulting in modulation of calcium channel activity in other organism",
  "GO:0044473": "envenomation resulting in negative regulation of calcium channel activity in other organism",
  "GO:0044474": "envenomation resulting in negative regulation of voltage-gated calcium channel activity in other organism",
  "GO:0044475": "envenomation resulting in negative regulation of high voltage-gated calcium channel activity in other organism",
  "GO:0044476": "envenomation resulting in negative regulation of low voltage-gated calcium channel activity in other organism",
  "GO:0044477": "envenomation resulting in negative regulation of platelet aggregation in other organism",
  "GO:0044478": "envenomation resulting in positive regulation of platelet aggregation in other organism",
  "GO:0044479": "envenomation resulting in modulation of mast cell degranulation in other organism",
  "GO:0044480": "envenomation resulting in positive regulation of mast cell degranulation in other organism",
  "GO:0044481": "envenomation resulting in proteolysis in other organism",
  "GO:0044482": "envenomation resulting in blood vessel extracellular matrix damage, causing hemorrhagic damage in other organism",
  "GO:0044483": "envenomation resulting in impairment of hemostasis in other organism",
  "GO:0044484": "envenomation resulting in fibrinolysis in other organism",
  "GO:0044485": "envenomation resulting in fibrinogenolysis in other organism",
  "GO:0044486": "modulation of transmission of nerve impulse in other organism",
  "GO:0044487": "envenomation resulting in modulation of transmission of nerve impulse in other organism",
  "GO:0044488": "modulation of voltage-gated sodium channel activity in other organism",
  "GO:0044489": "negative regulation of voltage-gated sodium channel activity in other organism",
  "GO:0044490": "positive regulation of voltage-gated sodium channel activity in other organism",
  "GO:0044491": "positive regulation of molecular function in other organism",
  "GO:0044492": "envenomation resulting in modulation of voltage-gated sodium channel activity in other organism",
  "GO:0044493": "envenomation resulting in negative regulation of voltage-gated sodium channel activity in other organism",
  "GO:0044494": "envenomation resulting in positive regulation of voltage-gated sodium channel activity in other organism",
  "GO:0044495": "modulation of blood pressure in other organism",
  "GO:0044496": "negative regulation of blood pressure in other organism",
  "GO:0044497": "positive regulation of blood pressure in other organism",
  "GO:0044498": "envenomation resulting in modulation of blood pressure in other organism",
  "GO:0044499": "envenomation resulting in positive regulation of blood pressure in other organism",
  "GO:0044500": "envenomation resulting in negative regulation of blood pressure in other organism",
  "GO:0044501": "modulation of signal transduction in other organism",
  "GO:0044502": "positive regulation of signal transduction in other organism",
  "GO:0044503": "modulation of G-protein coupled receptor activity in other organism",
  "GO:0044504": "modulation of receptor activity in other organism",
  "GO:0044505": "positive regulation of G-protein coupled receptor activity in other organism",
  "GO:0044506": "modulation of glucagon-like peptide receptor 1 activity in other organism",
  "GO:0044507": "positive regulation of receptor activity in other organism",
  "GO:0044508": "glucagon-like peptide 1 receptor activity",
  "GO:0044509": "envenomation resulting in modulation of signal transduction in other organism",
  "GO:0044510": "envenomation resulting in positive regulation of signal transduction in other organism",
  "GO:0044511": "envenomation resulting in modulation of receptor activity in other organism",
  "GO:0044512": "envenomation resulting in modulation of glucagon-like peptide receptor 1 activity in other organism",
  "GO:0044513": "envenomation resulting in modulation of G-protein coupled receptor activity in other organism",
  "GO:0044514": "envenomation resulting in positive regulation of G-protein coupled receptor activity in other organism",
  "GO:0044515": "envenomation resulting in positive regulation of glucagon-like peptide receptor 1 activity in other organism",
  "GO:0044516": "positive regulation of glucagon-like peptide receptor 1 activity in other organism",
  "GO:0044517": "modulation of vasoactive intestinal polypeptide receptor activity in other organism",
  "GO:0044518": "positive regulation of vasoactive intestinal polypeptide receptor activity in other organism",
  "GO:0044519": "envenomation resulting in modulation of vasoactive intestinal polypeptide receptor activity in other organism",
  "GO:0044520": "envenomation resulting in positive regulation of vasoactive intestinal polypeptide receptor activity in other organism",
  "GO:0044521": "envenomation resulting in muscle damage in other organism",
  "GO:0044522": "envenomation resulting in myocyte killing in other organism",
  "GO:0044523": "envenomation resulting in damage of muscle extracellular matrix in other organism",
  "GO:0044524": "protein sulfhydration",
  "GO:0044525": "peptidyl-cystine sulfhydration",
  "GO:0044526": "formation of peptidyl-cystine persulfide by sulphur transfer from free cysteine",
  "GO:0044527": "formation of peptidyl-cystine persulfide by sulphur transfer from H2S",
  "GO:0044528": "regulation of mitochondrial mRNA stability",
  "GO:0044529": "regulation of mitochondrial rRNA stability",
  "GO:0044530": "supraspliceosomal complex",
  "GO:0044531": "modulation of programmed cell death in other organism",
  "GO:0044532": "modulation of apoptotic process in other organism",
  "GO:0044533": "positive regulation of apoptotic process in other organism",
  "GO:0044534": "envenomation resulting in modulation of apoptotic process in other organism",
  "GO:0044535": "very-long-chain fatty acyl-CoA oxidase activity",
  "GO:0044536": "envenomation resulting in depletion of circulating fibrinogen in other organism",
  "GO:0044537": "regulation of circulating fibrinogen levels",
  "GO:0044538": "host cell periphery",
  "GO:0044539": "long-chain fatty acid import",
  "GO:0044540": "L-cystine L-cysteine-lyase (deaminating)",
  "GO:0044541": "zymogen activation in other organism",
  "GO:0044542": "plasminogen activation in other organism",
  "GO:0044543": "envenomation resulting in zymogen activation in other organism",
  "GO:0044544": "envenomation resulting in plasminogen activation in other organism",
  "GO:0044545": "NSL complex",
  "GO:0044546": "NLRP3 inflammasome complex assembly",
  "GO:0044547": "DNA topoisomerase binding",
  "GO:0044548": "S100 protein binding",
  "GO:0044549": "GTP cyclohydrolase binding",
  "GO:0044550": "secondary metabolite biosynthetic process",
  "GO:0044551": "envenomation resulting in modulation of vasodilation in other organism",
  "GO:0044552": "modulation of vasodilation in other organism",
  "GO:0044553": "modulation of biological quality in other organism",
  "GO:0044554": "modulation of heart rate in other organism",
  "GO:0044555": "negative regulation of heart rate in other organism",
  "GO:0044556": "envenomation resulting in negative regulation of heart rate of other organism",
  "GO:0044557": "relaxation of smooth muscle",
  "GO:0044558": "uterine smooth muscle relaxation",
  "GO:0044559": "envenomation resulting in modulation of voltage-gated potassium channel activity in other organism",
  "GO:0044560": "envenomation resulting in modulation of ion channel activity in other organism",
  "GO:0044561": "modulation of ion channel activity in other organism",
  "GO:0044562": "envenomation resulting in negative regulation of voltage-gated potassium channel activity in other organism",
  "GO:0044563": "envenomation resulting in slowing of activation kinetics of voltage-gated potassium channel in other organism",
  "GO:0044564": "envenomation resulting in occlusion of the pore of voltage-gated potassium channel in other organism",
  "GO:0044565": "dendritic cell proliferation",
  "GO:0044566": "chondrocyte activation",
  "GO:0044567": "primary cell wall cellulose synthase complex",
  "GO:0044568": "secondary cell wall cellulose synthase complex",
  "GO:0044569": "[Ni-Fe] hydrogenase complex",
  "GO:0044570": "starch utilization system complex",
  "GO:0044571": "[2Fe-2S] cluster assembly",
  "GO:0044572": "[4Fe-4S] cluster assembly",
  "GO:0044573": "nitrogenase P cluster assembly",
  "GO:0044574": "starch utilization system complex assembly",
  "GO:0044575": "cellulosome assembly",
  "GO:0044576": "pentose catabolic process to ethanol",
  "GO:0044577": "xylose catabolic process to ethanol",
  "GO:0044578": "butyryl-CoA biosynthetic process",
  "GO:0044579": "butyryl-CoA biosynthetic process from acetyl-CoA",
  "GO:0044580": "butyryl-CoA catabolic process",
  "GO:0044581": "butyryl-CoA catabolic process to butyrate",
  "GO:0044582": "butyryl-CoA catabolic process to butanol",
  "GO:0044583": "cellotriose binding",
  "GO:0044584": "cellodextrin binding",
  "GO:0044585": "cellobiose binding",
  "GO:0044586": "cellotetraose binding",
  "GO:0044587": "cellopentaose binding",
  "GO:0044588": "laminaribiose binding",
  "GO:0044589": "pectin binding",
  "GO:0044590": "iron-sulfur-molybdenum cofactor binding",
  "GO:0044591": "response to amylopectin",
  "GO:0044592": "response to pullulan",
  "GO:0044593": "iron-sulfur-molybdenum cofactor assembly",
  "GO:0044594": "17-beta-hydroxysteroid dehydrogenase (NAD+) activity",
  "GO:0044595": "decaprenyldihydroxybenzoate methyltransferase activity",
  "GO:0044596": "3-demethylubiquinone-10 3-O-methyltransferase activity",
  "GO:0044597": "daunorubicin metabolic process",
  "GO:0044598": "doxorubicin metabolic process",
  "GO:0044599": "AP-5 adaptor complex",
  "GO:0044600": "protein guanylyltransferase activity",
  "GO:0044601": "protein denucleotidylation",
  "GO:0044602": "protein deadenylylation",
  "GO:0044603": "protein adenylylhydrolase activity",
  "GO:0044604": "phytochelatin transmembrane transporter ATPase activity",
  "GO:0044605": "phosphocholine transferase activity",
  "GO:0044606": "phosphocholine hydrolase activity",
  "GO:0044607": "disruption by symbiont of host endothelial cells",
  "GO:0044608": "peptidyl-L-threonine methyl ester biosynthetic process from peptidyl-threonine",
  "GO:0044609": "DBIRD complex",
  "GO:0044610": "FMN transmembrane transporter activity",
  "GO:0044611": "nuclear pore inner ring",
  "GO:0044612": "nuclear pore linkers",
  "GO:0044613": "nuclear pore central transport channel",
  "GO:0044614": "nuclear pore cytoplasmic filaments",
  "GO:0044615": "nuclear pore nuclear basket",
  "GO:0044616": "modulation of relaxation of muscle in other organism",
  "GO:0044617": "modulation of relaxation of smooth muscle in other organism",
  "GO:0044618": "modulation of relaxation of uterine smooth muscle in other organism",
  "GO:0044619": "positive regulation of relaxation of uterine smooth muscle in other organism",
  "GO:0044620": "ACP phosphopantetheine attachment site binding",
  "GO:0044621": "modulation of cell migration in other organism",
  "GO:0044622": "negative regulation of cell migration in other organism",
  "GO:0044623": "positive regulation of cell migration in other organism",
  "GO:0044624": "envenomation resulting in modulation of cell migration in other organism",
  "GO:0044625": "envenomation resulting in negative regulation of cell migration in other organism",
  "GO:0044626": "envenomation resulting in positive regulation of cell migration in other organism",
  "GO:0044627": "modulation of complement activation, classical pathway in other organism",
  "GO:0044628": "positive regulation of complement activation, classical pathway in other organism",
  "GO:0044629": "negative regulation of complement activation, classical pathway in other organism",
  "GO:0044630": "modulation of complement activation, lectin pathway in other organism",
  "GO:0044631": "positive regulation of complement activation, lectin pathway in other organism",
  "GO:0044632": "negative regulation of complement activation, lectin pathway in other organism",
  "GO:0044633": "modulation of complement activation, alternative pathway in other organism",
  "GO:0044634": "negative regulation of complement activation, alternative pathway in other organism",
  "GO:0044635": "positive regulation of complement activation, alternative pathway in other organism",
  "GO:0044636": "envenomation resulting in modulation of complement activation, classical pathway in other organism",
  "GO:0044637": "envenomation resulting in negative regulation of complement activation, classical pathway in other organism",
  "GO:0044638": "envenomation resulting in positive regulation of complement activation, classical pathway in other organism",
  "GO:0044639": "envenomation resulting in modulation of complement activation, lectin pathway in other organism",
  "GO:0044640": "envenomation resulting in negative regulation of complement activation, lectin pathway in other organism",
  "GO:0044641": "envenomation resulting in positive regulation of complement activation, lectin pathway in other organism",
  "GO:0044642": "envenomation resulting in modulation of complement activation, alternative pathway in other organism",
  "GO:0044643": "envenomation resulting in positive regulation of complement activation, alternative pathway in other organism",
  "GO:0044644": "envenomation resulting in negative regulation of complement activation, alternative pathway in other organism",
  "GO:0044645": "modulation of complement activation in other organism",
  "GO:0044646": "envenomation resulting in modulation of complement activation in other organism",
  "GO:0044647": "host-symbiont bicellular tight junction",
  "GO:0044648": "histone H3-K4 dimethylation",
  "GO:0044649": "envenomation resulting in cytolysis in other organism",
  "GO:0044650": "adhesion of symbiont to host cell",
  "GO:0044651": "adhesion of symbiont to host epithelial cell",
  "GO:0044652": "adhesion of symbiont to host endothelial cell",
  "GO:0044653": "dextrin alpha-glucosidase activity",
  "GO:0044654": "starch alpha-glucosidase activity",
  "GO:0044655": "phagosome reneutralization",
  "GO:0044656": "regulation of post-lysosomal vacuole size",
  "GO:0044657": "pore formation in membrane of other organism during symbiotic interaction",
  "GO:0044658": "pore formation in membrane of host by symbiont",
  "GO:0044659": "cytolysis by virus of host cell",
  "GO:0044660": "cytolysis by virus via pore formation in host cell membrane",
  "GO:0044661": "disruption by virus of host cell",
  "GO:0044662": "disruption by virus of host cell membrane",
  "GO:0044663": "establishment or maintenance of cell type involved in phenotypic switching",
  "GO:0044664": "reversion of cell type to default state involved in phenotypic switching",
  "GO:0044665": "MLL1/2 complex",
  "GO:0044666": "MLL3/4 complex",
  "GO:0044667": "(R)-carnitine:4-(trimethylammonio)butanoate antiporter activity",
  "GO:0044668": "sodium:malonate symporter activity",
  "GO:0044669": "sodium:galactoside symporter activity",
  "GO:0044670": "sodium:alanine symporter activity",
  "GO:0044671": "sorocarp spore cell differentiation",
  "GO:0044672": "acetyl-CoA decarbonylase/synthase-carbon monoxide dehydrogenase complex",
  "GO:0044673": "7,8-didemethyl-8-hydroxy-5-deazariboflavin synthase complex",
  "GO:0044674": "methyl coenzyme M reductase complex",
  "GO:0044675": "formyl-methanofuran dehydrogenase (tungsten enzyme) complex",
  "GO:0044676": "formyl-methanofuran dehydrogenase (molybdenum enzyme) complex",
  "GO:0044677": "methyl-tetrahydromethanopterin:coenzyme M methyltransferase complex",
  "GO:0044678": "CoB-CoM heterodisulfide reductase complex",
  "GO:0044679": "methanophenazine reducing hydrogenase complex",
  "GO:0044680": "methylthiol:coenzyme M methyltransferase complex",
  "GO:0044681": "sulfopyruvate decarboxylase complex",
  "GO:0044682": "archaeal-specific GTP cyclohydrolase activity",
  "GO:0044683": "methylthiol:coenzyme M methyltransferase activity",
  "GO:0044684": "dihydromethanopterin reductase activity",
  "GO:0044685": "tetrahydromethanopterin-dependent serine hydroxymethyltransferase activity",
  "GO:0044686": "cysteate synthase activity",
  "GO:0044687": "geranylfarnesyl diphosphate synthase activity",
  "GO:0044688": "7,8-dihydro-D-neopterin 2',3'-cyclic phosphate phosphodiesterase activity",
  "GO:0044689": "7,8-didemethyl-8-hydroxy-5-deazariboflavin synthase activity",
  "GO:0044690": "methionine import",
  "GO:0044691": "tooth eruption",
  "GO:0044692": "exoribonuclease activator activity",
  "GO:0044693": "trehalose:proton symporter activity",
  "GO:0044694": "pore-mediated entry of viral genome into host cell",
  "GO:0044695": "Dsc E3 ubiquitin ligase complex",
  "GO:0044696": "killing by virus of host cell by post-segregational killing",
  "GO:0044697": "HICS complex",
  "GO:0044698": "morphogenesis of symbiont in host cell",
  "GO:0044699": "single-organism process",
  "GO:0044700": "single organism signaling",
  "GO:0044701": "obsolete response to stimulus by single organism",
  "GO:0044702": "single organism reproductive process",
  "GO:0044703": "multi-organism reproductive process",
  "GO:0044704": "single-organism reproductive behavior",
  "GO:0044705": "multi-organism reproductive behavior",
  "GO:0044706": "multi-multicellular organism process",
  "GO:0044707": "single-multicellular organism process",
  "GO:0044708": "single-organism behavior",
  "GO:0044710": "single-organism metabolic process",
  "GO:0044711": "single-organism biosynthetic process",
  "GO:0044712": "single-organism catabolic process",
  "GO:0044713": "2-hydroxy-adenosine triphosphate pyrophosphatase activity",
  "GO:0044714": "2-hydroxy-(deoxy)adenosine-triphosphate pyrophosphatase activity",
  "GO:0044715": "8-oxo-dGDP phosphatase activity",
  "GO:0044716": "8-oxo-GDP phosphatase activity",
  "GO:0044717": "8-hydroxy-dADP phosphatase activity",
  "GO:0044718": "siderophore transmembrane transport",
  "GO:0044719": "regulation of imaginal disc-derived wing size",
  "GO:0044720": "negative regulation of imaginal disc-derived wing size",
  "GO:0044721": "protein import into peroxisome matrix, substrate release",
  "GO:0044722": "renal phosphate excretion",
  "GO:0044723": "single-organism carbohydrate metabolic process",
  "GO:0044724": "single-organism carbohydrate catabolic process",
  "GO:0044725": "chromatin reprogramming in the zygote",
  "GO:0044726": "protection of DNA demethylation of female pronucleus",
  "GO:0044727": "DNA demethylation of male pronucleus",
  "GO:0044728": "DNA methylation or demethylation",
  "GO:0044729": "hemi-methylated DNA-binding",
  "GO:0044730": "bone sialoprotein binding",
  "GO:0044731": "Ost-alpha/Ost-beta complex",
  "GO:0044732": "mitotic spindle pole body",
  "GO:0044733": "envenomation resulting in modulation of acid-sensing ion channel activity in other organism",
  "GO:0044734": "envenomation resulting in positive regulation of acid-sensing ion channel activity in other organism",
  "GO:0044735": "envenomation resulting in negative regulation of acid-sensing ion channel activity in other organism",
  "GO:0044736": "acid-sensing ion channel activity",
  "GO:0044737": "modulation of acid-sensing ion channel in other organism",
  "GO:0044738": "negative regulation of acid-sensing ion channel in other organism",
  "GO:0044739": "positive regulation of acid-sensing ion channel in other organism",
  "GO:0044740": "negative regulation of sensory perception of pain in other organism",
  "GO:0044741": "envenomation resulting in negative regulation of sensory perception of pain in other organism",
  "GO:0044742": "envenomation resulting in modulation of sensory perception of pain in other organism",
  "GO:0044743": "intracellular protein transmembrane import",
  "GO:0044744": "protein targeting to nucleus",
  "GO:0044745": "amino acid transmembrane import",
  "GO:0044746": "amino acid transmembrane export",
  "GO:0044747": "mature miRNA 3'-end processing",
  "GO:0044748": "3'-5'-exoribonuclease activity involved in mature miRNA 3'-end processing",
  "GO:0044749": "high-affinity zinc II ion transmembrane import",
  "GO:0044750": "high-affinity nickel cation transmembrane transporter activity",
  "GO:0044751": "cellular response to human chorionic gonadotropin stimulus",
  "GO:0044752": "response to human chorionic gonadotropin",
  "GO:0044753": "amphisome",
  "GO:0044754": "autolysosome",
  "GO:0044755": "pantothenate import into cell",
  "GO:0044756": "biotin import into cell",
  "GO:0044757": "dethiobiotin import into cell",
  "GO:0044758": "modulation by symbiont of host synaptic transmission",
  "GO:0044759": "negative regulation by symbiont of host synaptic transmission",
  "GO:0044760": "modulation by symbiont of host cholinergic synaptic transmission",
  "GO:0044761": "negative regulation by symbiont of host cholinergic synaptic transmission",
  "GO:0044762": "negative regulation by symbiont of host neurotransmitter secretion",
  "GO:0044763": "single-organism cellular process",
  "GO:0044764": "multi-organism cellular process",
  "GO:0044765": "single-organism transport",
  "GO:0044766": "multi-organism transport",
  "GO:0044767": "single-organism developmental process",
  "GO:0044768": "NMS complex assembly involved in kinetochore assembly",
  "GO:0044769": "ATPase activity, coupled to transmembrane movement of ions, rotational mechanism",
  "GO:0044770": "cell cycle phase transition",
  "GO:0044771": "meiotic cell cycle phase transition",
  "GO:0044772": "mitotic cell cycle phase transition",
  "GO:0044773": "mitotic DNA damage checkpoint",
  "GO:0044774": "mitotic DNA integrity checkpoint",
  "GO:0044775": "DNA polymerase III, beta sliding clamp processivity factor complex",
  "GO:0044776": "DNA polymerase III, core complex",
  "GO:0044777": "single-stranded DNA-binding protein complex",
  "GO:0044778": "meiotic DNA integrity checkpoint",
  "GO:0044779": "meiotic spindle checkpoint",
  "GO:0044780": "bacterial-type flagellum assembly",
  "GO:0044781": "bacterial-type flagellum organization",
  "GO:0044782": "cilium organization",
  "GO:0044783": "G1 DNA damage checkpoint",
  "GO:0044784": "metaphase/anaphase transition of cell cycle",
  "GO:0044785": "metaphase/anaphase transition of meiotic cell cycle",
  "GO:0044786": "cell cycle DNA replication",
  "GO:0044787": "bacterial-type DNA replication",
  "GO:0044788": "modulation by host of viral process",
  "GO:0044789": "modulation by host of viral release from host cell",
  "GO:0044790": "negative regulation by host of viral release from host cell",
  "GO:0044791": "positive regulation by host of viral release from host cell",
  "GO:0044793": "negative regulation by host of viral process",
  "GO:0044794": "positive regulation by host of viral process",
  "GO:0044795": "trans-Golgi network to recycling endosome transport",
  "GO:0044796": "DNA polymerase processivity factor complex",
  "GO:0044797": "cytoplasmic transcription factor complex",
  "GO:0044798": "nuclear transcription factor complex",
  "GO:0044799": "NarGHI complex",
  "GO:0044800": "multi-organism membrane fusion",
  "GO:0044801": "single-organism membrane fusion",
  "GO:0044802": "single-organism membrane organization",
  "GO:0044803": "multi-organism membrane organization",
  "GO:0044804": "nucleophagy",
  "GO:0044805": "late nucleophagy",
  "GO:0044806": "G-quadruplex DNA unwinding",
  "GO:0044807": "macrophage migration inhibitory factor production",
  "GO:0044808": "Oncostatin M production",
  "GO:0044809": "chemokine (C-C motif) ligand 17 production",
  "GO:0044810": "Dma1-dependent checkpoint",
  "GO:0044811": "response to Dma1-dependent checkpoint signaling",
  "GO:0044812": "fermentative hydrogen production",
  "GO:0044813": "glycolytic fermentation via PFOR pathway",
  "GO:0044814": "glycolytic fermentation via PFL pathway",
  "GO:0044815": "DNA packaging complex",
  "GO:0044816": "Nsk1-Dlc1 complex",
  "GO:0044817": "hydrogen generation via biophotolysis",
  "GO:0044818": "mitotic G2/M transition checkpoint",
  "GO:0044819": "mitotic G1/S transition checkpoint",
  "GO:0044820": "mitotic telomere tethering at nuclear periphery",
  "GO:0044821": "meiotic telomere tethering at nuclear periphery",
  "GO:0044822": "poly(A) RNA binding",
  "GO:0044823": "retroviral integrase activity",
  "GO:0044824": "retroviral 3' processing activity",
  "GO:0044825": "retroviral strand transfer activity",
  "GO:0044826": "viral genome integration into host DNA",
  "GO:0044827": "modulation by host of viral genome replication",
  "GO:0044828": "negative regulation by host of viral genome replication",
  "GO:0044829": "positive regulation by host of viral genome replication",
  "GO:0044830": "modulation by host of viral RNA genome replication",
  "GO:0044831": "modulation by virus of host cytokine production",
  "GO:0044832": "positive regulation by virus of host cytokine production",
  "GO:0044833": "modulation by virus of host protein transport",
  "GO:0044834": "retroviral intasome",
  "GO:0044835": "hydrogen generation via nitrogenase",
  "GO:0044836": "D-xylose fermentation",
  "GO:0044837": "actomyosin contractile ring organization",
  "GO:0044838": "cell quiescence",
  "GO:0044839": "cell cycle G2/M phase transition",
  "GO:0044840": "gut granule",
  "GO:0044841": "gut granule membrane",
  "GO:0044842": "gut granule lumen",
  "GO:0044843": "cell cycle G1/S phase transition",
  "GO:0044844": "meiotic interphase II",
  "GO:0044845": "chain elongation of O-linked mannose residue",
  "GO:0044846": "negative regulation by symbiont of indole acetic acid levels in host",
  "GO:0044847": "iron acquisition by symbiont from host",
  "GO:0044848": "biological phase",
  "GO:0044849": "estrous cycle",
  "GO:0044850": "menstrual cycle",
  "GO:0044851": "hair cycle phase",
  "GO:0044852": "nonrepetitive DNA condensation",
  "GO:0044853": "plasma membrane raft",
  "GO:0044854": "plasma membrane raft assembly",
  "GO:0044855": "plasma membrane raft distribution",
  "GO:0044856": "plasma membrane raft localization",
  "GO:0044857": "plasma membrane raft organization",
  "GO:0044858": "plasma membrane raft polarization",
  "GO:0044859": "protein insertion into plasma membrane raft",
  "GO:0044860": "protein localization to plasma membrane raft",
  "GO:0044861": "protein transport into plasma membrane raft",
  "GO:0044862": "protein transport out of plasma membrane raft",
  "GO:0044863": "modulation by virus of host cell division",
  "GO:0044864": "positive regulation by virus of host cell division",
  "GO:0044865": "negative regulation by virus of host cell division",
  "GO:0044866": "modulation by host of viral exo-alpha-sialidase activity",
  "GO:0044867": "modulation by host of viral catalytic activity",
  "GO:0044868": "modulation by host of viral molecular function",
  "GO:0044869": "negative regulation by host of viral exo-alpha-sialidase activity",
  "GO:0044870": "modulation by host of viral glycoprotein metabolic process",
  "GO:0044871": "negative regulation by host of viral glycoprotein metabolic process",
  "GO:0044872": "lipoprotein localization",
  "GO:0044873": "lipoprotein localization to membrane",
  "GO:0044874": "lipoprotein localization to outer membrane",
  "GO:0044875": "gamma-glutamyl hercynylcysteine sulfoxide synthase",
  "GO:0044876": "hercynylselenocysteine synthase",
  "GO:0044877": "macromolecular complex binding",
  "GO:0044878": "mitotic cytokinesis checkpoint",
  "GO:0044879": "morphogenesis checkpoint",
  "GO:0045002": "double-strand break repair via single-strand annealing",
  "GO:0045003": "double-strand break repair via synthesis-dependent strand annealing",
  "GO:0045004": "DNA replication proofreading",
  "GO:0045005": "DNA-dependent DNA replication maintenance of fidelity",
  "GO:0045006": "DNA deamination",
  "GO:0045007": "depurination",
  "GO:0045008": "depyrimidination",
  "GO:0045009": "chitosome",
  "GO:0045010": "actin nucleation",
  "GO:0045012": "obsolete MHC class II receptor activity",
  "GO:0045013": "carbon catabolite repression of transcription",
  "GO:0045014": "negative regulation of transcription by glucose",
  "GO:0045015": "HDEL sequence binding",
  "GO:0045016": "mitochondrial magnesium ion transport",
  "GO:0045017": "glycerolipid biosynthetic process",
  "GO:0045018": "retrograde transport, vacuole to Golgi",
  "GO:0045019": "negative regulation of nitric oxide biosynthetic process",
  "GO:0045020": "obsolete error-prone DNA repair",
  "GO:0045021": "obsolete error-free DNA repair",
  "GO:0045022": "early endosome to late endosome transport",
  "GO:0045023": "G0 to G1 transition",
  "GO:0045024": "obsolete peptidyl-glutamyl peptide hydrolyzing enzyme activity",
  "GO:0045025": "mitochondrial degradosome",
  "GO:0045026": "plasma membrane fusion",
  "GO:0045027": "DNA end binding",
  "GO:0045028": "G-protein coupled purinergic nucleotide receptor activity",
  "GO:0045029": "UDP-activated nucleotide receptor activity",
  "GO:0045030": "UTP-activated nucleotide receptor activity",
  "GO:0045031": "ATP-activated adenosine receptor activity",
  "GO:0045032": "ADP-activated adenosine receptor activity",
  "GO:0045033": "peroxisome inheritance",
  "GO:0045034": "obsolete neuroblast division",
  "GO:0045035": "sensory organ precursor cell division",
  "GO:0045036": "protein targeting to chloroplast",
  "GO:0045037": "protein import into chloroplast stroma",
  "GO:0045038": "protein import into chloroplast thylakoid membrane",
  "GO:0045039": "protein import into mitochondrial inner membrane",
  "GO:0045040": "protein import into mitochondrial outer membrane",
  "GO:0045041": "protein import into mitochondrial intermembrane space",
  "GO:0045042": "obsolete protein import into mitochondrial intermembrane space, conservative",
  "GO:0045045": "obsolete secretory pathway",
  "GO:0045046": "protein import into peroxisome membrane",
  "GO:0045047": "protein targeting to ER",
  "GO:0045048": "protein insertion into ER membrane",
  "GO:0045049": "protein insertion into ER membrane by N-terminal cleaved signal sequence",
  "GO:0045050": "protein insertion into ER membrane by stop-transfer membrane-anchor sequence",
  "GO:0045051": "protein insertion into ER membrane by internal uncleaved signal-anchor sequence",
  "GO:0045052": "protein insertion into ER membrane by GPI attachment sequence",
  "GO:0045053": "protein retention in Golgi apparatus",
  "GO:0045054": "constitutive secretory pathway",
  "GO:0045055": "regulated exocytosis",
  "GO:0045056": "transcytosis",
  "GO:0045057": "cisternal progression",
  "GO:0045058": "T cell selection",
  "GO:0045059": "positive thymic T cell selection",
  "GO:0045060": "negative thymic T cell selection",
  "GO:0045061": "thymic T cell selection",
  "GO:0045062": "extrathymic T cell selection",
  "GO:0045063": "T-helper 1 cell differentiation",
  "GO:0045064": "T-helper 2 cell differentiation",
  "GO:0045065": "cytotoxic T cell differentiation",
  "GO:0045066": "regulatory T cell differentiation",
  "GO:0045067": "positive extrathymic T cell selection",
  "GO:0045068": "negative extrathymic T cell selection",
  "GO:0045069": "regulation of viral genome replication",
  "GO:0045070": "positive regulation of viral genome replication",
  "GO:0045071": "negative regulation of viral genome replication",
  "GO:0045072": "regulation of interferon-gamma biosynthetic process",
  "GO:0045073": "regulation of chemokine biosynthetic process",
  "GO:0045074": "regulation of interleukin-10 biosynthetic process",
  "GO:0045075": "regulation of interleukin-12 biosynthetic process",
  "GO:0045076": "regulation of interleukin-2 biosynthetic process",
  "GO:0045077": "negative regulation of interferon-gamma biosynthetic process",
  "GO:0045078": "positive regulation of interferon-gamma biosynthetic process",
  "GO:0045079": "negative regulation of chemokine biosynthetic process",
  "GO:0045080": "positive regulation of chemokine biosynthetic process",
  "GO:0045081": "negative regulation of interleukin-10 biosynthetic process",
  "GO:0045082": "positive regulation of interleukin-10 biosynthetic process",
  "GO:0045083": "negative regulation of interleukin-12 biosynthetic process",
  "GO:0045084": "positive regulation of interleukin-12 biosynthetic process",
  "GO:0045085": "negative regulation of interleukin-2 biosynthetic process",
  "GO:0045086": "positive regulation of interleukin-2 biosynthetic process",
  "GO:0045087": "innate immune response",
  "GO:0045088": "regulation of innate immune response",
  "GO:0045089": "positive regulation of innate immune response",
  "GO:0045091": "regulation of single stranded viral RNA replication via double stranded DNA intermediate",
  "GO:0045092": "interleukin-18 receptor complex",
  "GO:0045093": "interleukin-18 alpha subunit binding",
  "GO:0045094": "interleukin-18 beta subunit binding",
  "GO:0045095": "keratin filament",
  "GO:0045096": "obsolete acidic keratin",
  "GO:0045097": "obsolete basic/neutral keratin",
  "GO:0045098": "type III intermediate filament",
  "GO:0045099": "obsolete vimentin",
  "GO:0045100": "obsolete desmin",
  "GO:0045101": "obsolete glial fibrillary acidic protein",
  "GO:0045102": "obsolete peripherin",
  "GO:0045103": "intermediate filament-based process",
  "GO:0045104": "intermediate filament cytoskeleton organization",
  "GO:0045105": "intermediate filament polymerization or depolymerization",
  "GO:0045106": "intermediate filament depolymerization",
  "GO:0045107": "intermediate filament polymerization",
  "GO:0045108": "regulation of intermediate filament polymerization or depolymerization",
  "GO:0045109": "intermediate filament organization",
  "GO:0045110": "intermediate filament bundle assembly",
  "GO:0045111": "intermediate filament cytoskeleton",
  "GO:0045112": "integrin biosynthetic process",
  "GO:0045113": "regulation of integrin biosynthetic process",
  "GO:0045114": "beta 2 integrin biosynthetic process",
  "GO:0045115": "regulation of beta 2 integrin biosynthetic process",
  "GO:0045116": "protein neddylation",
  "GO:0045117": "azole transport",
  "GO:0045118": "azole transporter activity",
  "GO:0045119": "azole:proton antiporter activity",
  "GO:0045120": "pronucleus",
  "GO:0045121": "membrane raft",
  "GO:0045122": "aflatoxin biosynthetic process",
  "GO:0045123": "cellular extravasation",
  "GO:0045124": "regulation of bone resorption",
  "GO:0045125": "bioactive lipid receptor activity",
  "GO:0045127": "N-acetylglucosamine kinase activity",
  "GO:0045128": "negative regulation of reciprocal meiotic recombination",
  "GO:0045129": "NAD-independent histone deacetylase activity",
  "GO:0045130": "keratan sulfotransferase activity",
  "GO:0045131": "pre-mRNA branch point binding",
  "GO:0045132": "meiotic chromosome segregation",
  "GO:0045133": "2,3-dihydroxybenzoate 3,4-dioxygenase activity",
  "GO:0045134": "uridine-diphosphatase activity",
  "GO:0045135": "poly(beta-D-mannuronate) lyase activity",
  "GO:0045136": "development of secondary sexual characteristics",
  "GO:0045137": "development of primary sexual characteristics",
  "GO:0045138": "nematode male tail tip morphogenesis",
  "GO:0045139": "obsolete copper sensitivity/resistance",
  "GO:0045140": "inositol phosphoceramide synthase activity",
  "GO:0045141": "meiotic telomere clustering",
  "GO:0045142": "triplex DNA binding",
  "GO:0045143": "homologous chromosome segregation",
  "GO:0045144": "meiotic sister chromatid segregation",
  "GO:0045145": "single-stranded DNA 5'-3' exodeoxyribonuclease activity",
  "GO:0045146": "initiation of acetate catabolic process by acetate",
  "GO:0045147": "regulation of initiation of acetate catabolic process by acetate",
  "GO:0045148": "tripeptide aminopeptidase activity",
  "GO:0045149": "acetoin metabolic process",
  "GO:0045150": "acetoin catabolic process",
  "GO:0045151": "acetoin biosynthetic process",
  "GO:0045152": "antisigma factor binding",
  "GO:0045153": "electron transporter, transferring electrons within CoQH2-cytochrome c reductase complex activity",
  "GO:0045154": "electron transporter, transferring electrons within cytochrome c oxidase complex activity",
  "GO:0045155": "electron transporter, transferring electrons from CoQH2-cytochrome c reductase complex and cytochrome c oxidase complex activity",
  "GO:0045156": "electron transporter, transferring electrons within the cyclic electron transport pathway of photosynthesis activity",
  "GO:0045157": "electron transporter, transferring electrons within the noncyclic electron transport pathway of photosynthesis activity",
  "GO:0045158": "electron transporter, transferring electrons within cytochrome b6/f complex of photosystem II activity",
  "GO:0045159": "myosin II binding",
  "GO:0045160": "myosin I complex",
  "GO:0045161": "neuronal ion channel clustering",
  "GO:0045162": "clustering of voltage-gated sodium channels",
  "GO:0045163": "clustering of voltage-gated potassium channels",
  "GO:0045164": "obsolete secretin (sensu Mammalia)",
  "GO:0045165": "cell fate commitment",
  "GO:0045167": "asymmetric protein localization involved in cell fate determination",
  "GO:0045168": "cell-cell signaling involved in cell fate commitment",
  "GO:0045169": "fusome",
  "GO:0045170": "spectrosome",
  "GO:0045171": "intercellular bridge",
  "GO:0045172": "germline ring canal",
  "GO:0045173": "O-sialoglycoprotein catabolic process",
  "GO:0045174": "glutathione dehydrogenase (ascorbate) activity",
  "GO:0045175": "basal protein localization",
  "GO:0045176": "apical protein localization",
  "GO:0045177": "apical part of cell",
  "GO:0045178": "basal part of cell",
  "GO:0045179": "apical cortex",
  "GO:0045180": "basal cortex",
  "GO:0045181": "glutamate synthase activity, NAD(P)H as acceptor",
  "GO:0045182": "translation regulator activity",
  "GO:0045183": "translation factor activity, non-nucleic acid binding",
  "GO:0045184": "establishment of protein localization",
  "GO:0045185": "maintenance of protein location",
  "GO:0045186": "zonula adherens assembly",
  "GO:0045187": "regulation of circadian sleep/wake cycle, sleep",
  "GO:0045188": "regulation of circadian sleep/wake cycle, non-REM sleep",
  "GO:0045189": "connective tissue growth factor biosynthetic process",
  "GO:0045190": "isotype switching",
  "GO:0045191": "regulation of isotype switching",
  "GO:0045192": "obsolete low-density lipoprotein catabolic process",
  "GO:0045193": "obsolete acetylated low-density lipoprotein catabolic process",
  "GO:0045194": "obsolete oxidized low-density lipoprotein catabolic process",
  "GO:0045195": "obsolete gallstone formation",
  "GO:0045196": "establishment or maintenance of neuroblast polarity",
  "GO:0045197": "establishment or maintenance of epithelial cell apical/basal polarity",
  "GO:0045198": "establishment of epithelial cell apical/basal polarity",
  "GO:0045199": "maintenance of epithelial cell apical/basal polarity",
  "GO:0045200": "establishment of neuroblast polarity",
  "GO:0045201": "maintenance of neuroblast polarity",
  "GO:0045202": "synapse",
  "GO:0045203": "integral component of cell outer membrane",
  "GO:0045204": "MAPK export from nucleus",
  "GO:0045205": "obsolete MAPK transporter activity",
  "GO:0045206": "obsolete MAPK phosphatase transporter activity",
  "GO:0045208": "MAPK phosphatase export from nucleus",
  "GO:0045209": "MAPK phosphatase export from nucleus, leptomycin B sensitive",
  "GO:0045210": "FasL biosynthetic process",
  "GO:0045211": "postsynaptic membrane",
  "GO:0045212": "neurotransmitter receptor biosynthetic process",
  "GO:0045213": "neurotransmitter receptor metabolic process",
  "GO:0045214": "sarcomere organization",
  "GO:0045216": "cell-cell junction organization",
  "GO:0045217": "cell-cell junction maintenance",
  "GO:0045218": "zonula adherens maintenance",
  "GO:0045219": "regulation of FasL biosynthetic process",
  "GO:0045220": "positive regulation of FasL biosynthetic process",
  "GO:0045221": "negative regulation of FasL biosynthetic process",
  "GO:0045222": "CD4 biosynthetic process",
  "GO:0045223": "regulation of CD4 biosynthetic process",
  "GO:0045224": "positive regulation of CD4 biosynthetic process",
  "GO:0045225": "negative regulation of CD4 biosynthetic process",
  "GO:0045226": "extracellular polysaccharide biosynthetic process",
  "GO:0045227": "capsule polysaccharide biosynthetic process",
  "GO:0045228": "slime layer polysaccharide biosynthetic process",
  "GO:0045229": "external encapsulating structure organization",
  "GO:0045230": "capsule organization",
  "GO:0045231": "slime layer organization",
  "GO:0045232": "S-layer organization",
  "GO:0045233": "obsolete natural killer cell receptor activity",
  "GO:0045234": "protein palmitoleylation",
  "GO:0045236": "CXCR chemokine receptor binding",
  "GO:0045237": "CXCR1 chemokine receptor binding",
  "GO:0045238": "CXCR2 chemokine receptor binding",
  "GO:0045239": "tricarboxylic acid cycle enzyme complex",
  "GO:0045240": "dihydrolipoyl dehydrogenase complex",
  "GO:0045241": "cytosolic alpha-ketoglutarate dehydrogenase complex",
  "GO:0045242": "isocitrate dehydrogenase complex (NAD+)",
  "GO:0045243": "cytosolic isocitrate dehydrogenase complex (NAD+)",
  "GO:0045244": "succinate-CoA ligase complex (GDP-forming)",
  "GO:0045246": "cytosolic tricarboxylic acid cycle enzyme complex",
  "GO:0045247": "cytosolic electron transfer flavoprotein complex",
  "GO:0045248": "cytosolic oxoglutarate dehydrogenase complex",
  "GO:0045249": "cytosol pyruvate dehydrogenase (lipoamide) phosphatase complex",
  "GO:0045250": "cytosolic pyruvate dehydrogenase complex",
  "GO:0045251": "electron transfer flavoprotein complex",
  "GO:0045252": "oxoglutarate dehydrogenase complex",
  "GO:0045253": "pyruvate dehydrogenase (lipoamide) phosphatase complex",
  "GO:0045254": "pyruvate dehydrogenase complex",
  "GO:0045257": "succinate dehydrogenase complex (ubiquinone)",
  "GO:0045258": "plasma membrane succinate dehydrogenase complex (ubiquinone)",
  "GO:0045259": "proton-transporting ATP synthase complex",
  "GO:0045260": "plasma membrane proton-transporting ATP synthase complex",
  "GO:0045261": "proton-transporting ATP synthase complex, catalytic core F(1)",
  "GO:0045262": "plasma membrane proton-transporting ATP synthase complex, catalytic core F(1)",
  "GO:0045263": "proton-transporting ATP synthase complex, coupling factor F(o)",
  "GO:0045264": "plasma membrane proton-transporting ATP synthase complex, coupling factor F(o)",
  "GO:0045265": "proton-transporting ATP synthase, stator stalk",
  "GO:0045266": "plasma membrane proton-transporting ATP synthase, stator stalk",
  "GO:0045267": "proton-transporting ATP synthase, catalytic core",
  "GO:0045268": "plasma membrane proton-transporting ATP synthase, catalytic core",
  "GO:0045269": "proton-transporting ATP synthase, central stalk",
  "GO:0045270": "plasma membrane proton-transporting ATP synthase, central stalk",
  "GO:0045271": "respiratory chain complex I",
  "GO:0045272": "plasma membrane respiratory chain complex I",
  "GO:0045273": "respiratory chain complex II",
  "GO:0045274": "plasma membrane respiratory chain complex II",
  "GO:0045275": "respiratory chain complex III",
  "GO:0045276": "plasma membrane respiratory chain complex III",
  "GO:0045277": "respiratory chain complex IV",
  "GO:0045278": "plasma membrane respiratory chain complex IV",
  "GO:0045281": "succinate dehydrogenase complex",
  "GO:0045282": "plasma membrane succinate dehydrogenase complex",
  "GO:0045283": "fumarate reductase complex",
  "GO:0045284": "plasma membrane fumarate reductase complex",
  "GO:0045289": "luciferin monooxygenase activity",
  "GO:0045290": "D-arabinose 1-dehydrogenase [NAD(P)+] activity",
  "GO:0045291": "mRNA trans splicing, SL addition",
  "GO:0045292": "mRNA cis splicing, via spliceosome",
  "GO:0045293": "mRNA editing complex",
  "GO:0045294": "alpha-catenin binding",
  "GO:0045295": "gamma-catenin binding",
  "GO:0045296": "cadherin binding",
  "GO:0045297": "post-mating behavior",
  "GO:0045298": "tubulin complex",
  "GO:0045299": "otolith mineralization",
  "GO:0045300": "acyl-[acyl-carrier-protein] desaturase activity",
  "GO:0045301": "tRNA-(2-methylthio-N-6-(cis-hydroxy)isopentenyl adenosine)-hydroxylase activity",
  "GO:0045302": "choloylglycine hydrolase activity",
  "GO:0045303": "diaminobutyrate-2-oxoglutarate transaminase activity",
  "GO:0045304": "regulation of establishment of competence for transformation",
  "GO:0045305": "obsolete regulator of establishment of competence for transformation activity",
  "GO:0045306": "obsolete inhibitor of the establishment of competence for transformation activity",
  "GO:0045307": "obsolete activator of the establishment of competence for transformation activity",
  "GO:0045309": "protein phosphorylated amino acid binding",
  "GO:0045310": "obsolete phosphoserine/phosphothreonine binding",
  "GO:0045311": "invasive growth in response to pheromone",
  "GO:0045312": "nor-spermidine biosynthetic process",
  "GO:0045313": "rhabdomere membrane biogenesis",
  "GO:0045314": "regulation of compound eye photoreceptor development",
  "GO:0045315": "positive regulation of compound eye photoreceptor development",
  "GO:0045316": "negative regulation of compound eye photoreceptor development",
  "GO:0045317": "equator specification",
  "GO:0045319": "obsolete SRP-independent cotranslational protein-membrane targeting, translocation",
  "GO:0045320": "chloroplast proton-transporting ATP synthase complex",
  "GO:0045321": "leukocyte activation",
  "GO:0045322": "unmethylated CpG binding",
  "GO:0045323": "interleukin-1 receptor complex",
  "GO:0045324": "late endosome to vacuole transport",
  "GO:0045325": "peptidyl-tryptophan hydroxylation",
  "GO:0045326": "protein-DNA covalent cross-linking via the 3'-end to peptidyl-tyrosine",
  "GO:0045327": "protein-DNA covalent cross-linking via peptidyl-tyrosine",
  "GO:0045328": "cytochrome P450 4A1-heme linkage",
  "GO:0045329": "carnitine biosynthetic process",
  "GO:0045330": "aspartyl esterase activity",
  "GO:0045331": "obsolete coenzyme-M-7-mercaptoheptanoylthreonine-phosphate-heterodisulfide hydrogenase activity",
  "GO:0045332": "phospholipid translocation",
  "GO:0045333": "cellular respiration",
  "GO:0045334": "clathrin-coated endocytic vesicle",
  "GO:0045335": "phagocytic vesicle",
  "GO:0045336": "clathrin-coated phagocytic vesicle",
  "GO:0045337": "farnesyl diphosphate biosynthetic process",
  "GO:0045338": "farnesyl diphosphate metabolic process",
  "GO:0045339": "farnesyl diphosphate catabolic process",
  "GO:0045340": "mercury ion binding",
  "GO:0045341": "MHC class I biosynthetic process",
  "GO:0045342": "MHC class II biosynthetic process",
  "GO:0045343": "regulation of MHC class I biosynthetic process",
  "GO:0045344": "negative regulation of MHC class I biosynthetic process",
  "GO:0045345": "positive regulation of MHC class I biosynthetic process",
  "GO:0045346": "regulation of MHC class II biosynthetic process",
  "GO:0045347": "negative regulation of MHC class II biosynthetic process",
  "GO:0045348": "positive regulation of MHC class II biosynthetic process",
  "GO:0045349": "interferon-alpha biosynthetic process",
  "GO:0045350": "interferon-beta biosynthetic process",
  "GO:0045351": "type I interferon biosynthetic process",
  "GO:0045352": "interleukin-1 Type I receptor antagonist activity",
  "GO:0045353": "interleukin-1 Type II receptor antagonist activity",
  "GO:0045354": "regulation of interferon-alpha biosynthetic process",
  "GO:0045355": "negative regulation of interferon-alpha biosynthetic process",
  "GO:0045356": "positive regulation of interferon-alpha biosynthetic process",
  "GO:0045357": "regulation of interferon-beta biosynthetic process",
  "GO:0045358": "negative regulation of interferon-beta biosynthetic process",
  "GO:0045359": "positive regulation of interferon-beta biosynthetic process",
  "GO:0045360": "regulation of interleukin-1 biosynthetic process",
  "GO:0045361": "negative regulation of interleukin-1 biosynthetic process",
  "GO:0045362": "positive regulation of interleukin-1 biosynthetic process",
  "GO:0045363": "regulation of interleukin-11 biosynthetic process",
  "GO:0045364": "negative regulation of interleukin-11 biosynthetic process",
  "GO:0045365": "positive regulation of interleukin-11 biosynthetic process",
  "GO:0045366": "regulation of interleukin-13 biosynthetic process",
  "GO:0045367": "negative regulation of interleukin-13 biosynthetic process",
  "GO:0045368": "positive regulation of interleukin-13 biosynthetic process",
  "GO:0045369": "regulation of interleukin-14 biosynthetic process",
  "GO:0045370": "negative regulation of interleukin-14 biosynthetic process",
  "GO:0045371": "positive regulation of interleukin-14 biosynthetic process",
  "GO:0045372": "regulation of interleukin-15 biosynthetic process",
  "GO:0045373": "negative regulation of interleukin-15 biosynthetic process",
  "GO:0045374": "positive regulation of interleukin-15 biosynthetic process",
  "GO:0045375": "regulation of interleukin-16 biosynthetic process",
  "GO:0045376": "negative regulation of interleukin-16 biosynthetic process",
  "GO:0045377": "positive regulation of interleukin-16 biosynthetic process",
  "GO:0045378": "regulation of interleukin-17 biosynthetic process",
  "GO:0045379": "negative regulation of interleukin-17 biosynthetic process",
  "GO:0045380": "positive regulation of interleukin-17 biosynthetic process",
  "GO:0045381": "regulation of interleukin-18 biosynthetic process",
  "GO:0045382": "negative regulation of interleukin-18 biosynthetic process",
  "GO:0045383": "positive regulation of interleukin-18 biosynthetic process",
  "GO:0045384": "regulation of interleukin-19 biosynthetic process",
  "GO:0045385": "negative regulation of interleukin-19 biosynthetic process",
  "GO:0045386": "positive regulation of interleukin-19 biosynthetic process",
  "GO:0045387": "regulation of interleukin-20 biosynthetic process",
  "GO:0045388": "negative regulation of interleukin-20 biosynthetic process",
  "GO:0045389": "positive regulation of interleukin-20 biosynthetic process",
  "GO:0045390": "regulation of interleukin-21 biosynthetic process",
  "GO:0045391": "negative regulation of interleukin-21 biosynthetic process",
  "GO:0045392": "positive regulation of interleukin-21 biosynthetic process",
  "GO:0045393": "regulation of interleukin-22 biosynthetic process",
  "GO:0045394": "negative regulation of interleukin-22 biosynthetic process",
  "GO:0045395": "positive regulation of interleukin-22 biosynthetic process",
  "GO:0045396": "regulation of interleukin-23 biosynthetic process",
  "GO:0045397": "negative regulation of interleukin-23 biosynthetic process",
  "GO:0045398": "positive regulation of interleukin-23 biosynthetic process",
  "GO:0045399": "regulation of interleukin-3 biosynthetic process",
  "GO:0045400": "negative regulation of interleukin-3 biosynthetic process",
  "GO:0045401": "positive regulation of interleukin-3 biosynthetic process",
  "GO:0045402": "regulation of interleukin-4 biosynthetic process",
  "GO:0045403": "negative regulation of interleukin-4 biosynthetic process",
  "GO:0045404": "positive regulation of interleukin-4 biosynthetic process",
  "GO:0045405": "regulation of interleukin-5 biosynthetic process",
  "GO:0045406": "negative regulation of interleukin-5 biosynthetic process",
  "GO:0045407": "positive regulation of interleukin-5 biosynthetic process",
  "GO:0045408": "regulation of interleukin-6 biosynthetic process",
  "GO:0045409": "negative regulation of interleukin-6 biosynthetic process",
  "GO:0045410": "positive regulation of interleukin-6 biosynthetic process",
  "GO:0045411": "regulation of interleukin-7 biosynthetic process",
  "GO:0045412": "negative regulation of interleukin-7 biosynthetic process",
  "GO:0045413": "positive regulation of interleukin-7 biosynthetic process",
  "GO:0045414": "regulation of interleukin-8 biosynthetic process",
  "GO:0045415": "negative regulation of interleukin-8 biosynthetic process",
  "GO:0045416": "positive regulation of interleukin-8 biosynthetic process",
  "GO:0045417": "regulation of interleukin-9 biosynthetic process",
  "GO:0045418": "negative regulation of interleukin-9 biosynthetic process",
  "GO:0045419": "positive regulation of interleukin-9 biosynthetic process",
  "GO:0045420": "regulation of connective tissue growth factor biosynthetic process",
  "GO:0045421": "negative regulation of connective tissue growth factor biosynthetic process",
  "GO:0045422": "positive regulation of connective tissue growth factor biosynthetic process",
  "GO:0045423": "regulation of granulocyte macrophage colony-stimulating factor biosynthetic process",
  "GO:0045424": "negative regulation of granulocyte macrophage colony-stimulating factor biosynthetic process",
  "GO:0045425": "positive regulation of granulocyte macrophage colony-stimulating factor biosynthetic process",
  "GO:0045427": "enzyme active site formation via (phospho-5'-guanosine)-L-histidine",
  "GO:0045428": "regulation of nitric oxide biosynthetic process",
  "GO:0045429": "positive regulation of nitric oxide biosynthetic process",
  "GO:0045430": "chalcone isomerase activity",
  "GO:0045431": "flavonol synthase activity",
  "GO:0045433": "male courtship behavior, veined wing generated song production",
  "GO:0045434": "negative regulation of female receptivity, post-mating",
  "GO:0045435": "lycopene epsilon cyclase activity",
  "GO:0045436": "lycopene beta cyclase activity",
  "GO:0045437": "uridine nucleosidase activity",
  "GO:0045438": "delta-(L-alpha-aminoadipyl)-L-cysteinyl-D-valine synthetase activity",
  "GO:0045439": "isopenicillin-N epimerase activity",
  "GO:0045442": "deacetoxycephalosporin-C hydroxylase activity",
  "GO:0045443": "juvenile hormone secretion",
  "GO:0045444": "fat cell differentiation",
  "GO:0045445": "myoblast differentiation",
  "GO:0045446": "endothelial cell differentiation",
  "GO:0045448": "mitotic cell cycle, embryonic",
  "GO:0045450": "bicoid mRNA localization",
  "GO:0045451": "pole plasm oskar mRNA localization",
  "GO:0045453": "bone resorption",
  "GO:0045454": "cell redox homeostasis",
  "GO:0045455": "ecdysteroid metabolic process",
  "GO:0045456": "ecdysteroid biosynthetic process",
  "GO:0045457": "ecdysteroid secretion",
  "GO:0045458": "recombination within rDNA repeats",
  "GO:0045459": "iron incorporation into iron-sulfur cluster via tetrakis-L-cysteinyl triiron tetrasulfide",
  "GO:0045460": "sterigmatocystin metabolic process",
  "GO:0045461": "sterigmatocystin biosynthetic process",
  "GO:0045462": "trichothecene 3-O-acetyltransferase activity",
  "GO:0045463": "R8 cell development",
  "GO:0045464": "R8 cell fate specification",
  "GO:0045465": "R8 cell differentiation",
  "GO:0045466": "R7 cell differentiation",
  "GO:0045467": "R7 cell development",
  "GO:0045468": "regulation of R8 cell spacing in compound eye",
  "GO:0045469": "negative regulation of R8 cell spacing in compound eye",
  "GO:0045470": "R8 cell-mediated photoreceptor organization",
  "GO:0045471": "response to ethanol",
  "GO:0045472": "response to ether",
  "GO:0045473": "obsolete response to ethanol (sensu Insecta)",
  "GO:0045474": "obsolete response to ether (sensu Insecta)",
  "GO:0045475": "locomotor rhythm",
  "GO:0045476": "nurse cell apoptotic process",
  "GO:0045477": "regulation of nurse cell apoptotic process",
  "GO:0045478": "fusome organization",
  "GO:0045479": "vesicle targeting to fusome",
  "GO:0045480": "galactose oxidase activity",
  "GO:0045481": "6-endo-hydroxycineole dehydrogenase activity",
  "GO:0045482": "trichodiene synthase activity",
  "GO:0045483": "aristolochene synthase activity",
  "GO:0045484": "L-lysine 6-transaminase activity",
  "GO:0045485": "omega-6 fatty acid desaturase activity",
  "GO:0045486": "naringenin 3-dioxygenase activity",
  "GO:0045487": "gibberellin catabolic process",
  "GO:0045488": "pectin metabolic process",
  "GO:0045489": "pectin biosynthetic process",
  "GO:0045490": "pectin catabolic process",
  "GO:0045491": "xylan metabolic process",
  "GO:0045492": "xylan biosynthetic process",
  "GO:0045493": "xylan catabolic process",
  "GO:0045494": "photoreceptor cell maintenance",
  "GO:0045495": "pole plasm",
  "GO:0045496": "male analia development",
  "GO:0045497": "female analia development",
  "GO:0045498": "sex comb development",
  "GO:0045499": "chemorepellent activity",
  "GO:0045500": "sevenless signaling pathway",
  "GO:0045501": "regulation of sevenless signaling pathway",
  "GO:0045502": "dynein binding",
  "GO:0045503": "dynein light chain binding",
  "GO:0045504": "dynein heavy chain binding",
  "GO:0045505": "dynein intermediate chain binding",
  "GO:0045506": "interleukin-24 receptor activity",
  "GO:0045507": "interleukin-25 receptor activity",
  "GO:0045508": "interleukin-26 receptor activity",
  "GO:0045509": "interleukin-27 receptor activity",
  "GO:0045510": "interleukin-24 binding",
  "GO:0045511": "interleukin-25 binding",
  "GO:0045512": "interleukin-26 binding",
  "GO:0045513": "interleukin-27 binding",
  "GO:0045514": "interleukin-16 receptor binding",
  "GO:0045515": "interleukin-18 receptor binding",
  "GO:0045516": "interleukin-19 receptor binding",
  "GO:0045517": "interleukin-20 receptor binding",
  "GO:0045518": "interleukin-22 receptor binding",
  "GO:0045519": "interleukin-23 receptor binding",
  "GO:0045520": "interleukin-24 receptor binding",
  "GO:0045521": "interleukin-25 receptor binding",
  "GO:0045522": "interleukin-26 receptor binding",
  "GO:0045523": "interleukin-27 receptor binding",
  "GO:0045524": "interleukin-24 biosynthetic process",
  "GO:0045525": "interleukin-25 biosynthetic process",
  "GO:0045526": "interleukin-26 biosynthetic process",
  "GO:0045527": "interleukin-27 biosynthetic process",
  "GO:0045528": "regulation of interleukin-24 biosynthetic process",
  "GO:0045529": "regulation of interleukin-25 biosynthetic process",
  "GO:0045530": "regulation of interleukin-26 biosynthetic process",
  "GO:0045531": "regulation of interleukin-27 biosynthetic process",
  "GO:0045532": "negative regulation of interleukin-24 biosynthetic process",
  "GO:0045533": "negative regulation of interleukin-25 biosynthetic process",
  "GO:0045534": "negative regulation of interleukin-26 biosynthetic process",
  "GO:0045535": "negative regulation of interleukin-27 biosynthetic process",
  "GO:0045536": "positive regulation of interleukin-24 biosynthetic process",
  "GO:0045537": "positive regulation of interleukin-25 biosynthetic process",
  "GO:0045538": "positive regulation of interleukin-26 biosynthetic process",
  "GO:0045539": "positive regulation of interleukin-27 biosynthetic process",
  "GO:0045540": "regulation of cholesterol biosynthetic process",
  "GO:0045541": "negative regulation of cholesterol biosynthetic process",
  "GO:0045542": "positive regulation of cholesterol biosynthetic process",
  "GO:0045543": "gibberellin 2-beta-dioxygenase activity",
  "GO:0045544": "gibberellin 20-oxidase activity",
  "GO:0045545": "syndecan binding",
  "GO:0045547": "dehydrodolichyl diphosphate synthase activity",
  "GO:0045548": "phenylalanine ammonia-lyase activity",
  "GO:0045549": "9-cis-epoxycarotenoid dioxygenase activity",
  "GO:0045550": "geranylgeranyl reductase activity",
  "GO:0045551": "cinnamyl-alcohol dehydrogenase activity",
  "GO:0045552": "dihydrokaempferol 4-reductase activity",
  "GO:0045553": "TRAIL biosynthetic process",
  "GO:0045554": "regulation of TRAIL biosynthetic process",
  "GO:0045555": "negative regulation of TRAIL biosynthetic process",
  "GO:0045556": "positive regulation of TRAIL biosynthetic process",
  "GO:0045557": "TRAIL receptor biosynthetic process",
  "GO:0045558": "TRAIL receptor 1 biosynthetic process",
  "GO:0045559": "TRAIL receptor 2 biosynthetic process",
  "GO:0045560": "regulation of TRAIL receptor biosynthetic process",
  "GO:0045561": "regulation of TRAIL receptor 1 biosynthetic process",
  "GO:0045562": "regulation of TRAIL receptor 2 biosynthetic process",
  "GO:0045563": "negative regulation of TRAIL receptor biosynthetic process",
  "GO:0045564": "positive regulation of TRAIL receptor biosynthetic process",
  "GO:0045565": "negative regulation of TRAIL receptor 1 biosynthetic process",
  "GO:0045566": "positive regulation of TRAIL receptor 1 biosynthetic process",
  "GO:0045567": "negative regulation of TRAIL receptor 2 biosynthetic process",
  "GO:0045568": "positive regulation of TRAIL receptor 2 biosynthetic process",
  "GO:0045569": "TRAIL binding",
  "GO:0045570": "regulation of imaginal disc growth",
  "GO:0045571": "negative regulation of imaginal disc growth",
  "GO:0045572": "positive regulation of imaginal disc growth",
  "GO:0045574": "sterigmatocystin catabolic process",
  "GO:0045575": "basophil activation",
  "GO:0045576": "mast cell activation",
  "GO:0045577": "regulation of B cell differentiation",
  "GO:0045578": "negative regulation of B cell differentiation",
  "GO:0045579": "positive regulation of B cell differentiation",
  "GO:0045580": "regulation of T cell differentiation",
  "GO:0045581": "negative regulation of T cell differentiation",
  "GO:0045582": "positive regulation of T cell differentiation",
  "GO:0045583": "regulation of cytotoxic T cell differentiation",
  "GO:0045584": "negative regulation of cytotoxic T cell differentiation",
  "GO:0045585": "positive regulation of cytotoxic T cell differentiation",
  "GO:0045586": "regulation of gamma-delta T cell differentiation",
  "GO:0045587": "negative regulation of gamma-delta T cell differentiation",
  "GO:0045588": "positive regulation of gamma-delta T cell differentiation",
  "GO:0045589": "regulation of regulatory T cell differentiation",
  "GO:0045590": "negative regulation of regulatory T cell differentiation",
  "GO:0045591": "positive regulation of regulatory T cell differentiation",
  "GO:0045592": "regulation of cumulus cell differentiation",
  "GO:0045593": "negative regulation of cumulus cell differentiation",
  "GO:0045594": "positive regulation of cumulus cell differentiation",
  "GO:0045595": "regulation of cell differentiation",
  "GO:0045596": "negative regulation of cell differentiation",
  "GO:0045597": "positive regulation of cell differentiation",
  "GO:0045598": "regulation of fat cell differentiation",
  "GO:0045599": "negative regulation of fat cell differentiation",
  "GO:0045600": "positive regulation of fat cell differentiation",
  "GO:0045601": "regulation of endothelial cell differentiation",
  "GO:0045602": "negative regulation of endothelial cell differentiation",
  "GO:0045603": "positive regulation of endothelial cell differentiation",
  "GO:0045604": "regulation of epidermal cell differentiation",
  "GO:0045605": "negative regulation of epidermal cell differentiation",
  "GO:0045606": "positive regulation of epidermal cell differentiation",
  "GO:0045607": "regulation of auditory receptor cell differentiation",
  "GO:0045608": "negative regulation of auditory receptor cell differentiation",
  "GO:0045609": "positive regulation of auditory receptor cell differentiation",
  "GO:0045610": "regulation of hemocyte differentiation",
  "GO:0045611": "negative regulation of hemocyte differentiation",
  "GO:0045612": "positive regulation of hemocyte differentiation",
  "GO:0045613": "regulation of plasmatocyte differentiation",
  "GO:0045614": "negative regulation of plasmatocyte differentiation",
  "GO:0045615": "positive regulation of plasmatocyte differentiation",
  "GO:0045616": "regulation of keratinocyte differentiation",
  "GO:0045617": "negative regulation of keratinocyte differentiation",
  "GO:0045618": "positive regulation of keratinocyte differentiation",
  "GO:0045619": "regulation of lymphocyte differentiation",
  "GO:0045620": "negative regulation of lymphocyte differentiation",
  "GO:0045621": "positive regulation of lymphocyte differentiation",
  "GO:0045622": "regulation of T-helper cell differentiation",
  "GO:0045623": "negative regulation of T-helper cell differentiation",
  "GO:0045624": "positive regulation of T-helper cell differentiation",
  "GO:0045625": "regulation of T-helper 1 cell differentiation",
  "GO:0045626": "negative regulation of T-helper 1 cell differentiation",
  "GO:0045627": "positive regulation of T-helper 1 cell differentiation",
  "GO:0045628": "regulation of T-helper 2 cell differentiation",
  "GO:0045629": "negative regulation of T-helper 2 cell differentiation",
  "GO:0045630": "positive regulation of T-helper 2 cell differentiation",
  "GO:0045631": "regulation of mechanoreceptor differentiation",
  "GO:0045632": "negative regulation of mechanoreceptor differentiation",
  "GO:0045633": "positive regulation of mechanoreceptor differentiation",
  "GO:0045634": "regulation of melanocyte differentiation",
  "GO:0045635": "negative regulation of melanocyte differentiation",
  "GO:0045636": "positive regulation of melanocyte differentiation",
  "GO:0045637": "regulation of myeloid cell differentiation",
  "GO:0045638": "negative regulation of myeloid cell differentiation",
  "GO:0045639": "positive regulation of myeloid cell differentiation",
  "GO:0045640": "regulation of basophil differentiation",
  "GO:0045641": "negative regulation of basophil differentiation",
  "GO:0045642": "positive regulation of basophil differentiation",
  "GO:0045643": "regulation of eosinophil differentiation",
  "GO:0045644": "negative regulation of eosinophil differentiation",
  "GO:0045645": "positive regulation of eosinophil differentiation",
  "GO:0045646": "regulation of erythrocyte differentiation",
  "GO:0045647": "negative regulation of erythrocyte differentiation",
  "GO:0045648": "positive regulation of erythrocyte differentiation",
  "GO:0045649": "regulation of macrophage differentiation",
  "GO:0045650": "negative regulation of macrophage differentiation",
  "GO:0045651": "positive regulation of macrophage differentiation",
  "GO:0045652": "regulation of megakaryocyte differentiation",
  "GO:0045653": "negative regulation of megakaryocyte differentiation",
  "GO:0045654": "positive regulation of megakaryocyte differentiation",
  "GO:0045655": "regulation of monocyte differentiation",
  "GO:0045656": "negative regulation of monocyte differentiation",
  "GO:0045657": "positive regulation of monocyte differentiation",
  "GO:0045658": "regulation of neutrophil differentiation",
  "GO:0045659": "negative regulation of neutrophil differentiation",
  "GO:0045660": "positive regulation of neutrophil differentiation",
  "GO:0045661": "regulation of myoblast differentiation",
  "GO:0045662": "negative regulation of myoblast differentiation",
  "GO:0045663": "positive regulation of myoblast differentiation",
  "GO:0045664": "regulation of neuron differentiation",
  "GO:0045665": "negative regulation of neuron differentiation",
  "GO:0045666": "positive regulation of neuron differentiation",
  "GO:0045667": "regulation of osteoblast differentiation",
  "GO:0045668": "negative regulation of osteoblast differentiation",
  "GO:0045669": "positive regulation of osteoblast differentiation",
  "GO:0045670": "regulation of osteoclast differentiation",
  "GO:0045671": "negative regulation of osteoclast differentiation",
  "GO:0045672": "positive regulation of osteoclast differentiation",
  "GO:0045676": "regulation of R7 cell differentiation",
  "GO:0045677": "negative regulation of R7 cell differentiation",
  "GO:0045678": "positive regulation of R7 cell differentiation",
  "GO:0045679": "regulation of R8 cell differentiation",
  "GO:0045680": "negative regulation of R8 cell differentiation",
  "GO:0045681": "positive regulation of R8 cell differentiation",
  "GO:0045682": "regulation of epidermis development",
  "GO:0045683": "negative regulation of epidermis development",
  "GO:0045684": "positive regulation of epidermis development",
  "GO:0045685": "regulation of glial cell differentiation",
  "GO:0045686": "negative regulation of glial cell differentiation",
  "GO:0045687": "positive regulation of glial cell differentiation",
  "GO:0045688": "regulation of antipodal cell differentiation",
  "GO:0045689": "negative regulation of antipodal cell differentiation",
  "GO:0045690": "positive regulation of antipodal cell differentiation",
  "GO:0045691": "regulation of embryo sac central cell differentiation",
  "GO:0045692": "negative regulation of embryo sac central cell differentiation",
  "GO:0045693": "positive regulation of embryo sac central cell differentiation",
  "GO:0045694": "regulation of embryo sac egg cell differentiation",
  "GO:0045695": "negative regulation of embryo sac egg cell differentiation",
  "GO:0045696": "positive regulation of embryo sac egg cell differentiation",
  "GO:0045697": "regulation of synergid differentiation",
  "GO:0045698": "negative regulation of synergid differentiation",
  "GO:0045699": "positive regulation of synergid differentiation",
  "GO:0045700": "regulation of spermatid nuclear differentiation",
  "GO:0045701": "negative regulation of spermatid nuclear differentiation",
  "GO:0045702": "positive regulation of spermatid nuclear differentiation",
  "GO:0045703": "ketoreductase activity",
  "GO:0045704": "regulation of salivary gland boundary specification",
  "GO:0045705": "negative regulation of salivary gland boundary specification",
  "GO:0045706": "positive regulation of salivary gland boundary specification",
  "GO:0045707": "regulation of adult salivary gland boundary specification",
  "GO:0045708": "regulation of larval salivary gland boundary specification",
  "GO:0045709": "negative regulation of adult salivary gland boundary specification",
  "GO:0045710": "negative regulation of larval salivary gland boundary specification",
  "GO:0045711": "positive regulation of adult salivary gland boundary specification",
  "GO:0045712": "positive regulation of larval salivary gland boundary specification",
  "GO:0045713": "low-density lipoprotein particle receptor biosynthetic process",
  "GO:0045714": "regulation of low-density lipoprotein particle receptor biosynthetic process",
  "GO:0045715": "negative regulation of low-density lipoprotein particle receptor biosynthetic process",
  "GO:0045716": "positive regulation of low-density lipoprotein particle receptor biosynthetic process",
  "GO:0045717": "negative regulation of fatty acid biosynthetic process",
  "GO:0045718": "obsolete negative regulation of flagellum assembly",
  "GO:0045719": "negative regulation of glycogen biosynthetic process",
  "GO:0045720": "negative regulation of integrin biosynthetic process",
  "GO:0045721": "negative regulation of gluconeogenesis",
  "GO:0045722": "positive regulation of gluconeogenesis",
  "GO:0045723": "positive regulation of fatty acid biosynthetic process",
  "GO:0045724": "positive regulation of cilium assembly",
  "GO:0045725": "positive regulation of glycogen biosynthetic process",
  "GO:0045726": "positive regulation of integrin biosynthetic process",
  "GO:0045727": "positive regulation of translation",
  "GO:0045728": "respiratory burst after phagocytosis",
  "GO:0045729": "respiratory burst at fertilization",
  "GO:0045730": "respiratory burst",
  "GO:0045732": "positive regulation of protein catabolic process",
  "GO:0045733": "acetate catabolic process",
  "GO:0045734": "regulation of acetate catabolic process",
  "GO:0045735": "nutrient reservoir activity",
  "GO:0045736": "negative regulation of cyclin-dependent protein serine/threonine kinase activity",
  "GO:0045737": "positive regulation of cyclin-dependent protein serine/threonine kinase activity",
  "GO:0045738": "negative regulation of DNA repair",
  "GO:0045739": "positive regulation of DNA repair",
  "GO:0045740": "positive regulation of DNA replication",
  "GO:0045741": "positive regulation of epidermal growth factor-activated receptor activity",
  "GO:0045742": "positive regulation of epidermal growth factor receptor signaling pathway",
  "GO:0045743": "positive regulation of fibroblast growth factor receptor signaling pathway",
  "GO:0045744": "negative regulation of G-protein coupled receptor protein signaling pathway",
  "GO:0045745": "positive regulation of G-protein coupled receptor protein signaling pathway",
  "GO:0045746": "negative regulation of Notch signaling pathway",
  "GO:0045747": "positive regulation of Notch signaling pathway",
  "GO:0045748": "positive regulation of R8 cell spacing in compound eye",
  "GO:0045749": "obsolete negative regulation of S phase of mitotic cell cycle",
  "GO:0045750": "obsolete positive regulation of S phase of mitotic cell cycle",
  "GO:0045751": "negative regulation of Toll signaling pathway",
  "GO:0045752": "positive regulation of Toll signaling pathway",
  "GO:0045753": "negative regulation of acetate catabolic process",
  "GO:0045754": "positive regulation of acetate catabolic process",
  "GO:0045755": "negative regulation of initiation of acetate catabolic process by acetate",
  "GO:0045756": "positive regulation of initiation of acetate catabolic process by acetate",
  "GO:0045757": "obsolete negative regulation of actin polymerization and/or depolymerization",
  "GO:0045758": "obsolete positive regulation of actin polymerization and/or depolymerization",
  "GO:0045759": "negative regulation of action potential",
  "GO:0045760": "positive regulation of action potential",
  "GO:0045761": "regulation of adenylate cyclase activity",
  "GO:0045762": "positive regulation of adenylate cyclase activity",
  "GO:0045763": "negative regulation of cellular amino acid metabolic process",
  "GO:0045764": "positive regulation of cellular amino acid metabolic process",
  "GO:0045765": "regulation of angiogenesis",
  "GO:0045766": "positive regulation of angiogenesis",
  "GO:0045767": "obsolete regulation of anti-apoptosis",
  "GO:0045768": "obsolete positive regulation of anti-apoptosis",
  "GO:0045769": "negative regulation of asymmetric cell division",
  "GO:0045770": "positive regulation of asymmetric cell division",
  "GO:0045771": "negative regulation of autophagosome size",
  "GO:0045772": "positive regulation of autophagosome size",
  "GO:0045773": "positive regulation of axon extension",
  "GO:0045774": "negative regulation of beta 2 integrin biosynthetic process",
  "GO:0045775": "positive regulation of beta 2 integrin biosynthetic process",
  "GO:0045776": "negative regulation of blood pressure",
  "GO:0045777": "positive regulation of blood pressure",
  "GO:0045778": "positive regulation of ossification",
  "GO:0045779": "negative regulation of bone resorption",
  "GO:0045780": "positive regulation of bone resorption",
  "GO:0045781": "negative regulation of cell budding",
  "GO:0045782": "positive regulation of cell budding",
  "GO:0045783": "obsolete negative regulation of calcium in ER",
  "GO:0045784": "obsolete positive regulation of calcium in ER",
  "GO:0045785": "positive regulation of cell adhesion",
  "GO:0045786": "negative regulation of cell cycle",
  "GO:0045787": "positive regulation of cell cycle",
  "GO:0045792": "negative regulation of cell size",
  "GO:0045793": "positive regulation of cell size",
  "GO:0045794": "negative regulation of cell volume",
  "GO:0045795": "positive regulation of cell volume",
  "GO:0045796": "negative regulation of intestinal cholesterol absorption",
  "GO:0045797": "positive regulation of intestinal cholesterol absorption",
  "GO:0045798": "negative regulation of chromatin assembly or disassembly",
  "GO:0045799": "positive regulation of chromatin assembly or disassembly",
  "GO:0045800": "negative regulation of chitin-based cuticle tanning",
  "GO:0045801": "positive regulation of chitin-based cuticle tanning",
  "GO:0045802": "obsolete negative regulation of cytoskeleton",
  "GO:0045803": "obsolete positive regulation of cytoskeleton",
  "GO:0045804": "negative regulation of eclosion",
  "GO:0045805": "positive regulation of eclosion",
  "GO:0045806": "negative regulation of endocytosis",
  "GO:0045807": "positive regulation of endocytosis",
  "GO:0045808": "negative regulation of establishment of competence for transformation",
  "GO:0045809": "positive regulation of establishment of competence for transformation",
  "GO:0045812": "negative regulation of Wnt signaling pathway, calcium modulating pathway",
  "GO:0045813": "positive regulation of Wnt signaling pathway, calcium modulating pathway",
  "GO:0045814": "negative regulation of gene expression, epigenetic",
  "GO:0045815": "positive regulation of gene expression, epigenetic",
  "GO:0045818": "negative regulation of glycogen catabolic process",
  "GO:0045819": "positive regulation of glycogen catabolic process",
  "GO:0045820": "negative regulation of glycolytic process",
  "GO:0045821": "positive regulation of glycolytic process",
  "GO:0045822": "negative regulation of heart contraction",
  "GO:0045823": "positive regulation of heart contraction",
  "GO:0045824": "negative regulation of innate immune response",
  "GO:0045825": "obsolete negative regulation of intermediate filament polymerization and/or depolymerization",
  "GO:0045826": "obsolete positive regulation of intermediate filament polymerization and/or depolymerization",
  "GO:0045827": "negative regulation of isoprenoid metabolic process",
  "GO:0045828": "positive regulation of isoprenoid metabolic process",
  "GO:0045829": "negative regulation of isotype switching",
  "GO:0045830": "positive regulation of isotype switching",
  "GO:0045831": "negative regulation of light-activated channel activity",
  "GO:0045832": "positive regulation of light-activated channel activity",
  "GO:0045833": "negative regulation of lipid metabolic process",
  "GO:0045834": "positive regulation of lipid metabolic process",
  "GO:0045835": "negative regulation of meiotic nuclear division",
  "GO:0045836": "positive regulation of meiotic nuclear division",
  "GO:0045837": "negative regulation of membrane potential",
  "GO:0045838": "positive regulation of membrane potential",
  "GO:0045839": "negative regulation of mitotic nuclear division",
  "GO:0045840": "positive regulation of mitotic nuclear division",
  "GO:0045841": "negative regulation of mitotic metaphase/anaphase transition",
  "GO:0045842": "positive regulation of mitotic metaphase/anaphase transition",
  "GO:0045843": "negative regulation of striated muscle tissue development",
  "GO:0045844": "positive regulation of striated muscle tissue development",
  "GO:0045847": "negative regulation of nitrogen utilization",
  "GO:0045848": "positive regulation of nitrogen utilization",
  "GO:0045849": "negative regulation of nurse cell apoptotic process",
  "GO:0045850": "positive regulation of nurse cell apoptotic process",
  "GO:0045851": "pH reduction",
  "GO:0045852": "pH elevation",
  "GO:0045853": "negative regulation of bicoid mRNA localization",
  "GO:0045854": "positive regulation of bicoid mRNA localization",
  "GO:0045855": "negative regulation of pole plasm oskar mRNA localization",
  "GO:0045856": "positive regulation of pole plasm oskar mRNA localization",
  "GO:0045857": "negative regulation of molecular function, epigenetic",
  "GO:0045858": "positive regulation of molecular function, epigenetic",
  "GO:0045859": "regulation of protein kinase activity",
  "GO:0045860": "positive regulation of protein kinase activity",
  "GO:0045861": "negative regulation of proteolysis",
  "GO:0045862": "positive regulation of proteolysis",
  "GO:0045863": "negative regulation of pteridine metabolic process",
  "GO:0045864": "positive regulation of pteridine metabolic process",
  "GO:0045865": "obsolete regulation of recombination within rDNA repeats",
  "GO:0045866": "obsolete positive regulation of recombination within rDNA repeats",
  "GO:0045869": "negative regulation of single stranded viral RNA replication via double stranded DNA intermediate",
  "GO:0045870": "positive regulation of single stranded viral RNA replication via double stranded DNA intermediate",
  "GO:0045871": "negative regulation of rhodopsin gene expression",
  "GO:0045872": "positive regulation of rhodopsin gene expression",
  "GO:0045873": "negative regulation of sevenless signaling pathway",
  "GO:0045874": "positive regulation of sevenless signaling pathway",
  "GO:0045875": "negative regulation of sister chromatid cohesion",
  "GO:0045876": "positive regulation of sister chromatid cohesion",
  "GO:0045879": "negative regulation of smoothened signaling pathway",
  "GO:0045880": "positive regulation of smoothened signaling pathway",
  "GO:0045881": "positive regulation of sporulation resulting in formation of a cellular spore",
  "GO:0045882": "negative regulation of sulfur utilization",
  "GO:0045883": "positive regulation of sulfur utilization",
  "GO:0045884": "obsolete regulation of survival gene product expression",
  "GO:0045885": "obsolete positive regulation of survival gene product expression",
  "GO:0045886": "negative regulation of synaptic growth at neuromuscular junction",
  "GO:0045887": "positive regulation of synaptic growth at neuromuscular junction",
  "GO:0045888": "obsolete regulation of transcription of homeotic gene (Polycomb group)",
  "GO:0045889": "obsolete positive regulation of transcription of homeotic gene (Polycomb group)",
  "GO:0045890": "obsolete regulation of transcription of homeotic gene (trithorax group)",
  "GO:0045891": "obsolete negative regulation of transcription of homeotic gene (trithorax group)",
  "GO:0045892": "negative regulation of transcription, DNA-templated",
  "GO:0045893": "positive regulation of transcription, DNA-templated",
  "GO:0045894": "negative regulation of mating-type specific transcription, DNA-templated",
  "GO:0045895": "positive regulation of mating-type specific transcription, DNA-templated",
  "GO:0045896": "regulation of transcription during mitosis",
  "GO:0045897": "positive regulation of transcription during mitosis",
  "GO:0045898": "regulation of RNA polymerase II transcriptional preinitiation complex assembly",
  "GO:0045899": "positive regulation of RNA polymerase II transcriptional preinitiation complex assembly",
  "GO:0045900": "negative regulation of translational elongation",
  "GO:0045901": "positive regulation of translational elongation",
  "GO:0045902": "negative regulation of translational fidelity",
  "GO:0045903": "positive regulation of translational fidelity",
  "GO:0045904": "negative regulation of translational termination",
  "GO:0045905": "positive regulation of translational termination",
  "GO:0045906": "negative regulation of vasoconstriction",
  "GO:0045907": "positive regulation of vasoconstriction",
  "GO:0045908": "negative regulation of vasodilation",
  "GO:0045909": "positive regulation of vasodilation",
  "GO:0045910": "negative regulation of DNA recombination",
  "GO:0045911": "positive regulation of DNA recombination",
  "GO:0045912": "negative regulation of carbohydrate metabolic process",
  "GO:0045913": "positive regulation of carbohydrate metabolic process",
  "GO:0045914": "negative regulation of catecholamine metabolic process",
  "GO:0045915": "positive regulation of catecholamine metabolic process",
  "GO:0045916": "negative regulation of complement activation",
  "GO:0045917": "positive regulation of complement activation",
  "GO:0045918": "negative regulation of cytolysis",
  "GO:0045919": "positive regulation of cytolysis",
  "GO:0045920": "negative regulation of exocytosis",
  "GO:0045921": "positive regulation of exocytosis",
  "GO:0045922": "negative regulation of fatty acid metabolic process",
  "GO:0045923": "positive regulation of fatty acid metabolic process",
  "GO:0045924": "regulation of female receptivity",
  "GO:0045925": "positive regulation of female receptivity",
  "GO:0045926": "negative regulation of growth",
  "GO:0045927": "positive regulation of growth",
  "GO:0045928": "negative regulation of juvenile hormone metabolic process",
  "GO:0045929": "positive regulation of juvenile hormone metabolic process",
  "GO:0045930": "negative regulation of mitotic cell cycle",
  "GO:0045931": "positive regulation of mitotic cell cycle",
  "GO:0045932": "negative regulation of muscle contraction",
  "GO:0045933": "positive regulation of muscle contraction",
  "GO:0045934": "negative regulation of nucleobase-containing compound metabolic process",
  "GO:0045935": "positive regulation of nucleobase-containing compound metabolic process",
  "GO:0045936": "negative regulation of phosphate metabolic process",
  "GO:0045937": "positive regulation of phosphate metabolic process",
  "GO:0045938": "positive regulation of circadian sleep/wake cycle, sleep",
  "GO:0045939": "negative regulation of steroid metabolic process",
  "GO:0045940": "positive regulation of steroid metabolic process",
  "GO:0045942": "negative regulation of phosphorus utilization",
  "GO:0045943": "positive regulation of transcription from RNA polymerase I promoter",
  "GO:0045944": "positive regulation of transcription from RNA polymerase II promoter",
  "GO:0045945": "positive regulation of transcription from RNA polymerase III promoter",
  "GO:0045947": "negative regulation of translational initiation",
  "GO:0045948": "positive regulation of translational initiation",
  "GO:0045949": "positive regulation of phosphorus utilization",
  "GO:0045950": "negative regulation of mitotic recombination",
  "GO:0045951": "positive regulation of mitotic recombination",
  "GO:0045952": "regulation of juvenile hormone catabolic process",
  "GO:0045953": "negative regulation of natural killer cell mediated cytotoxicity",
  "GO:0045954": "positive regulation of natural killer cell mediated cytotoxicity",
  "GO:0045955": "negative regulation of calcium ion-dependent exocytosis",
  "GO:0045956": "positive regulation of calcium ion-dependent exocytosis",
  "GO:0045957": "negative regulation of complement activation, alternative pathway",
  "GO:0045958": "positive regulation of complement activation, alternative pathway",
  "GO:0045959": "negative regulation of complement activation, classical pathway",
  "GO:0045960": "positive regulation of complement activation, classical pathway",
  "GO:0045961": "negative regulation of development, heterochronic",
  "GO:0045962": "positive regulation of development, heterochronic",
  "GO:0045963": "negative regulation of dopamine metabolic process",
  "GO:0045964": "positive regulation of dopamine metabolic process",
  "GO:0045965": "negative regulation of ecdysteroid metabolic process",
  "GO:0045966": "positive regulation of ecdysteroid metabolic process",
  "GO:0045967": "negative regulation of growth rate",
  "GO:0045968": "negative regulation of juvenile hormone biosynthetic process",
  "GO:0045969": "positive regulation of juvenile hormone biosynthetic process",
  "GO:0045970": "negative regulation of juvenile hormone catabolic process",
  "GO:0045971": "positive regulation of juvenile hormone catabolic process",
  "GO:0045972": "negative regulation of juvenile hormone secretion",
  "GO:0045973": "positive regulation of juvenile hormone secretion",
  "GO:0045974": "regulation of translation, ncRNA-mediated",
  "GO:0045975": "positive regulation of translation, ncRNA-mediated",
  "GO:0045976": "negative regulation of mitotic cell cycle, embryonic",
  "GO:0045977": "positive regulation of mitotic cell cycle, embryonic",
  "GO:0045978": "negative regulation of nucleoside metabolic process",
  "GO:0045979": "positive regulation of nucleoside metabolic process",
  "GO:0045980": "negative regulation of nucleotide metabolic process",
  "GO:0045981": "positive regulation of nucleotide metabolic process",
  "GO:0045982": "negative regulation of purine nucleobase metabolic process",
  "GO:0045983": "positive regulation of purine nucleobase metabolic process",
  "GO:0045984": "negative regulation of pyrimidine nucleobase metabolic process",
  "GO:0045985": "positive regulation of pyrimidine nucleobase metabolic process",
  "GO:0045986": "negative regulation of smooth muscle contraction",
  "GO:0045987": "positive regulation of smooth muscle contraction",
  "GO:0045988": "negative regulation of striated muscle contraction",
  "GO:0045989": "positive regulation of striated muscle contraction",
  "GO:0045990": "carbon catabolite regulation of transcription",
  "GO:0045991": "carbon catabolite activation of transcription",
  "GO:0045992": "negative regulation of embryonic development",
  "GO:0045993": "negative regulation of translational initiation by iron",
  "GO:0045994": "positive regulation of translational initiation by iron",
  "GO:0045995": "regulation of embryonic development",
  "GO:0045996": "negative regulation of transcription by pheromones",
  "GO:0045997": "negative regulation of ecdysteroid biosynthetic process",
  "GO:0045998": "positive regulation of ecdysteroid biosynthetic process",
  "GO:0045999": "negative regulation of ecdysteroid secretion",
  "GO:0046000": "positive regulation of ecdysteroid secretion",
  "GO:0046001": "negative regulation of preblastoderm mitotic cell cycle",
  "GO:0046002": "positive regulation of preblastoderm mitotic cell cycle",
  "GO:0046003": "negative regulation of syncytial blastoderm mitotic cell cycle",
  "GO:0046004": "positive regulation of syncytial blastoderm mitotic cell cycle",
  "GO:0046005": "positive regulation of circadian sleep/wake cycle, REM sleep",
  "GO:0046006": "regulation of activated T cell proliferation",
  "GO:0046007": "negative regulation of activated T cell proliferation",
  "GO:0046008": "regulation of female receptivity, post-mating",
  "GO:0046009": "positive regulation of female receptivity, post-mating",
  "GO:0046010": "positive regulation of circadian sleep/wake cycle, non-REM sleep",
  "GO:0046011": "regulation of oskar mRNA translation",
  "GO:0046012": "positive regulation of oskar mRNA translation",
  "GO:0046013": "regulation of T cell homeostatic proliferation",
  "GO:0046014": "negative regulation of T cell homeostatic proliferation",
  "GO:0046015": "regulation of transcription by glucose",
  "GO:0046016": "positive regulation of transcription by glucose",
  "GO:0046017": "regulation of transcription from RNA polymerase I promoter, mitotic",
  "GO:0046018": "positive regulation of transcription from RNA polymerase I promoter during mitosis",
  "GO:0046019": "regulation of transcription from RNA polymerase II promoter by pheromones",
  "GO:0046020": "negative regulation of transcription from RNA polymerase II promoter by pheromones",
  "GO:0046021": "regulation of transcription from RNA polymerase II promoter, mitotic",
  "GO:0046022": "positive regulation of transcription from RNA polymerase II promoter during mitosis",
  "GO:0046023": "regulation of transcription from RNA polymerase III promoter, mitotic",
  "GO:0046024": "positive regulation of transcription from RNA polymerase III promoter during mitosis",
  "GO:0046025": "precorrin-6Y C5,15-methyltransferase (decarboxylating) activity",
  "GO:0046026": "precorrin-4 C11-methyltransferase activity",
  "GO:0046027": "phospholipid:diacylglycerol acyltransferase activity",
  "GO:0046028": "electron transporter, transferring electrons from cytochrome b6/f complex of photosystem II activity",
  "GO:0046029": "mannitol dehydrogenase activity",
  "GO:0046030": "inositol trisphosphate phosphatase activity",
  "GO:0046031": "ADP metabolic process",
  "GO:0046032": "ADP catabolic process",
  "GO:0046033": "AMP metabolic process",
  "GO:0046034": "ATP metabolic process",
  "GO:0046035": "CMP metabolic process",
  "GO:0046036": "CTP metabolic process",
  "GO:0046037": "GMP metabolic process",
  "GO:0046038": "GMP catabolic process",
  "GO:0046039": "GTP metabolic process",
  "GO:0046040": "IMP metabolic process",
  "GO:0046041": "ITP metabolic process",
  "GO:0046042": "ITP biosynthetic process",
  "GO:0046043": "TDP metabolic process",
  "GO:0046044": "TMP metabolic process",
  "GO:0046045": "TMP catabolic process",
  "GO:0046046": "TTP metabolic process",
  "GO:0046047": "TTP catabolic process",
  "GO:0046048": "UDP metabolic process",
  "GO:0046049": "UMP metabolic process",
  "GO:0046050": "UMP catabolic process",
  "GO:0046051": "UTP metabolic process",
  "GO:0046052": "UTP catabolic process",
  "GO:0046053": "dAMP metabolic process",
  "GO:0046054": "dGMP metabolic process",
  "GO:0046055": "dGMP catabolic process",
  "GO:0046056": "dADP metabolic process",
  "GO:0046057": "dADP catabolic process",
  "GO:0046058": "cAMP metabolic process",
  "GO:0046059": "dAMP catabolic process",
  "GO:0046060": "dATP metabolic process",
  "GO:0046061": "dATP catabolic process",
  "GO:0046062": "dCDP metabolic process",
  "GO:0046063": "dCMP metabolic process",
  "GO:0046064": "dCMP biosynthetic process",
  "GO:0046065": "dCTP metabolic process",
  "GO:0046066": "dGDP metabolic process",
  "GO:0046067": "dGDP catabolic process",
  "GO:0046068": "cGMP metabolic process",
  "GO:0046069": "cGMP catabolic process",
  "GO:0046070": "dGTP metabolic process",
  "GO:0046071": "dGTP biosynthetic process",
  "GO:0046072": "dTDP metabolic process",
  "GO:0046073": "dTMP metabolic process",
  "GO:0046074": "dTMP catabolic process",
  "GO:0046075": "dTTP metabolic process",
  "GO:0046076": "dTTP catabolic process",
  "GO:0046077": "dUDP metabolic process",
  "GO:0046078": "dUMP metabolic process",
  "GO:0046079": "dUMP catabolic process",
  "GO:0046080": "dUTP metabolic process",
  "GO:0046081": "dUTP catabolic process",
  "GO:0046082": "5-methylcytosine biosynthetic process",
  "GO:0046083": "adenine metabolic process",
  "GO:0046084": "adenine biosynthetic process",
  "GO:0046085": "adenosine metabolic process",
  "GO:0046086": "adenosine biosynthetic process",
  "GO:0046087": "cytidine metabolic process",
  "GO:0046088": "cytidine biosynthetic process",
  "GO:0046089": "cytosine biosynthetic process",
  "GO:0046090": "deoxyadenosine metabolic process",
  "GO:0046091": "deoxyadenosine biosynthetic process",
  "GO:0046092": "deoxycytidine metabolic process",
  "GO:0046093": "deoxycytidine biosynthetic process",
  "GO:0046094": "deoxyinosine metabolic process",
  "GO:0046095": "deoxyinosine biosynthetic process",
  "GO:0046096": "deoxyuridine metabolic process",
  "GO:0046097": "deoxyuridine biosynthetic process",
  "GO:0046098": "guanine metabolic process",
  "GO:0046099": "guanine biosynthetic process",
  "GO:0046100": "hypoxanthine metabolic process",
  "GO:0046101": "hypoxanthine biosynthetic process",
  "GO:0046102": "inosine metabolic process",
  "GO:0046103": "inosine biosynthetic process",
  "GO:0046104": "thymidine metabolic process",
  "GO:0046105": "thymidine biosynthetic process",
  "GO:0046106": "thymine biosynthetic process",
  "GO:0046107": "uracil biosynthetic process",
  "GO:0046108": "uridine metabolic process",
  "GO:0046109": "uridine biosynthetic process",
  "GO:0046110": "xanthine metabolic process",
  "GO:0046111": "xanthine biosynthetic process",
  "GO:0046112": "nucleobase biosynthetic process",
  "GO:0046113": "nucleobase catabolic process",
  "GO:0046114": "guanosine biosynthetic process",
  "GO:0046115": "guanosine catabolic process",
  "GO:0046116": "queuosine metabolic process",
  "GO:0046117": "queuosine catabolic process",
  "GO:0046118": "7-methylguanosine biosynthetic process",
  "GO:0046119": "7-methylguanosine catabolic process",
  "GO:0046120": "deoxyribonucleoside biosynthetic process",
  "GO:0046121": "deoxyribonucleoside catabolic process",
  "GO:0046122": "purine deoxyribonucleoside metabolic process",
  "GO:0046123": "purine deoxyribonucleoside biosynthetic process",
  "GO:0046124": "purine deoxyribonucleoside catabolic process",
  "GO:0046125": "pyrimidine deoxyribonucleoside metabolic process",
  "GO:0046126": "pyrimidine deoxyribonucleoside biosynthetic process",
  "GO:0046127": "pyrimidine deoxyribonucleoside catabolic process",
  "GO:0046128": "purine ribonucleoside metabolic process",
  "GO:0046129": "purine ribonucleoside biosynthetic process",
  "GO:0046130": "purine ribonucleoside catabolic process",
  "GO:0046131": "pyrimidine ribonucleoside metabolic process",
  "GO:0046132": "pyrimidine ribonucleoside biosynthetic process",
  "GO:0046133": "pyrimidine ribonucleoside catabolic process",
  "GO:0046134": "pyrimidine nucleoside biosynthetic process",
  "GO:0046135": "pyrimidine nucleoside catabolic process",
  "GO:0046136": "positive regulation of vitamin metabolic process",
  "GO:0046137": "negative regulation of vitamin metabolic process",
  "GO:0046138": "obsolete coenzyme and prosthetic group biosynthetic process",
  "GO:0046139": "obsolete coenzyme and prosthetic group catabolic process",
  "GO:0046140": "corrin biosynthetic process",
  "GO:0046141": "corrin catabolic process",
  "GO:0046142": "obsolete negative regulation of coenzyme and prosthetic group metabolic process",
  "GO:0046143": "obsolete positive regulation of coenzyme and prosthetic group metabolic process",
  "GO:0046144": "D-alanine family amino acid metabolic process",
  "GO:0046145": "D-alanine family amino acid biosynthetic process",
  "GO:0046146": "tetrahydrobiopterin metabolic process",
  "GO:0046147": "tetrahydrobiopterin catabolic process",
  "GO:0046148": "pigment biosynthetic process",
  "GO:0046149": "pigment catabolic process",
  "GO:0046150": "melanin catabolic process",
  "GO:0046151": "eye pigment catabolic process",
  "GO:0046152": "ommochrome metabolic process",
  "GO:0046153": "ommochrome catabolic process",
  "GO:0046154": "rhodopsin metabolic process",
  "GO:0046155": "rhodopsin catabolic process",
  "GO:0046156": "siroheme metabolic process",
  "GO:0046157": "siroheme catabolic process",
  "GO:0046158": "ocellus pigment metabolic process",
  "GO:0046159": "ocellus pigment catabolic process",
  "GO:0046160": "heme a metabolic process",
  "GO:0046161": "heme a catabolic process",
  "GO:0046162": "heme c metabolic process",
  "GO:0046163": "heme c catabolic process",
  "GO:0046164": "alcohol catabolic process",
  "GO:0046165": "alcohol biosynthetic process",
  "GO:0046166": "glyceraldehyde-3-phosphate biosynthetic process",
  "GO:0046167": "glycerol-3-phosphate biosynthetic process",
  "GO:0046168": "glycerol-3-phosphate catabolic process",
  "GO:0046169": "methanol biosynthetic process",
  "GO:0046170": "methanol catabolic process",
  "GO:0046171": "octanol biosynthetic process",
  "GO:0046172": "octanol catabolic process",
  "GO:0046173": "polyol biosynthetic process",
  "GO:0046174": "polyol catabolic process",
  "GO:0046175": "aldonic acid biosynthetic process",
  "GO:0046176": "aldonic acid catabolic process",
  "GO:0046177": "D-gluconate catabolic process",
  "GO:0046178": "D-gluconate biosynthetic process",
  "GO:0046179": "keto-D-gluconate biosynthetic process",
  "GO:0046180": "ketogluconate biosynthetic process",
  "GO:0046181": "ketogluconate catabolic process",
  "GO:0046182": "L-idonate biosynthetic process",
  "GO:0046183": "L-idonate catabolic process",
  "GO:0046184": "aldehyde biosynthetic process",
  "GO:0046185": "aldehyde catabolic process",
  "GO:0046186": "acetaldehyde biosynthetic process",
  "GO:0046187": "acetaldehyde catabolic process",
  "GO:0046188": "methane catabolic process",
  "GO:0046189": "phenol-containing compound biosynthetic process",
  "GO:0046190": "aerobic phenol-containing compound biosynthetic process",
  "GO:0046191": "aerobic phenol-containing compound catabolic process",
  "GO:0046192": "anaerobic phenol-containing compound biosynthetic process",
  "GO:0046193": "anaerobic phenol-containing compound catabolic process",
  "GO:0046194": "obsolete pentachlorophenol biosynthetic process",
  "GO:0046195": "obsolete 4-nitrophenol biosynthetic process",
  "GO:0046196": "4-nitrophenol catabolic process",
  "GO:0046197": "orcinol biosynthetic process",
  "GO:0046198": "obsolete cresol biosynthetic process",
  "GO:0046199": "cresol catabolic process",
  "GO:0046200": "obsolete m-cresol biosynthetic process",
  "GO:0046201": "cyanate biosynthetic process",
  "GO:0046202": "cyanide biosynthetic process",
  "GO:0046203": "spermidine catabolic process",
  "GO:0046204": "nor-spermidine metabolic process",
  "GO:0046205": "nor-spermidine catabolic process",
  "GO:0046206": "trypanothione metabolic process",
  "GO:0046207": "trypanothione catabolic process",
  "GO:0046208": "spermine catabolic process",
  "GO:0046209": "nitric oxide metabolic process",
  "GO:0046210": "nitric oxide catabolic process",
  "GO:0046211": "(+)-camphor biosynthetic process",
  "GO:0046212": "obsolete methyl ethyl ketone biosynthetic process",
  "GO:0046213": "methyl ethyl ketone catabolic process",
  "GO:0046214": "enterobactin catabolic process",
  "GO:0046215": "siderophore catabolic process",
  "GO:0046216": "indole phytoalexin catabolic process",
  "GO:0046217": "indole phytoalexin metabolic process",
  "GO:0046218": "indolalkylamine catabolic process",
  "GO:0046219": "indolalkylamine biosynthetic process",
  "GO:0046220": "pyridine biosynthetic process",
  "GO:0046221": "pyridine catabolic process",
  "GO:0046222": "aflatoxin metabolic process",
  "GO:0046223": "aflatoxin catabolic process",
  "GO:0046224": "bacteriocin metabolic process",
  "GO:0046225": "bacteriocin catabolic process",
  "GO:0046226": "coumarin catabolic process",
  "GO:0046227": "obsolete 2,4,5-trichlorophenoxyacetic acid biosynthetic process",
  "GO:0046228": "2,4,5-trichlorophenoxyacetic acid catabolic process",
  "GO:0046229": "obsolete 2-aminobenzenesulfonate biosynthetic process",
  "GO:0046230": "2-aminobenzenesulfonate catabolic process",
  "GO:0046231": "obsolete carbazole biosynthetic process",
  "GO:0046232": "carbazole catabolic process",
  "GO:0046233": "obsolete 3-hydroxyphenylacetate biosynthetic process",
  "GO:0046234": "obsolete fluorene biosynthetic process",
  "GO:0046235": "gallate biosynthetic process",
  "GO:0046236": "mandelate biosynthetic process",
  "GO:0046237": "obsolete phenanthrene biosynthetic process",
  "GO:0046238": "obsolete phthalate biosynthetic process",
  "GO:0046239": "phthalate catabolic process",
  "GO:0046240": "obsolete xylene biosynthetic process",
  "GO:0046241": "obsolete m-xylene biosynthetic process",
  "GO:0046242": "obsolete o-xylene biosynthetic process",
  "GO:0046243": "obsolete p-xylene biosynthetic process",
  "GO:0046244": "salicylic acid catabolic process",
  "GO:0046245": "obsolete styrene biosynthetic process",
  "GO:0046246": "terpene biosynthetic process",
  "GO:0046247": "terpene catabolic process",
  "GO:0046248": "alpha-pinene biosynthetic process",
  "GO:0046249": "alpha-pinene catabolic process",
  "GO:0046250": "limonene biosynthetic process",
  "GO:0046251": "limonene catabolic process",
  "GO:0046252": "toluene biosynthetic process",
  "GO:0046253": "anaerobic toluene biosynthetic process",
  "GO:0046254": "anaerobic toluene catabolic process",
  "GO:0046255": "obsolete 2,4,6-trinitrotoluene biosynthetic process",
  "GO:0046256": "2,4,6-trinitrotoluene catabolic process",
  "GO:0046257": "obsolete anaerobic 2,4,6-trinitrotoluene biosynthetic process",
  "GO:0046258": "anaerobic 2,4,6-trinitrotoluene catabolic process",
  "GO:0046259": "obsolete trinitrotoluene biosynthetic process",
  "GO:0046260": "trinitrotoluene catabolic process",
  "GO:0046261": "obsolete 4-nitrotoluene biosynthetic process",
  "GO:0046262": "obsolete nitrotoluene biosynthetic process",
  "GO:0046263": "nitrotoluene catabolic process",
  "GO:0046264": "obsolete thiocyanate biosynthetic process",
  "GO:0046265": "thiocyanate catabolic process",
  "GO:0046266": "obsolete triethanolamine biosynthetic process",
  "GO:0046267": "triethanolamine catabolic process",
  "GO:0046268": "obsolete toluene-4-sulfonate biosynthetic process",
  "GO:0046269": "toluene-4-sulfonate catabolic process",
  "GO:0046270": "obsolete 4-toluenecarboxylate biosynthetic process",
  "GO:0046271": "phenylpropanoid catabolic process",
  "GO:0046272": "stilbene catabolic process",
  "GO:0046273": "lignan catabolic process",
  "GO:0046274": "lignin catabolic process",
  "GO:0046275": "flavonoid catabolic process",
  "GO:0046276": "methylgallate catabolic process",
  "GO:0046277": "methylgallate biosynthetic process",
  "GO:0046278": "3,4-dihydroxybenzoate metabolic process",
  "GO:0046279": "3,4-dihydroxybenzoate biosynthetic process",
  "GO:0046280": "chalcone catabolic process",
  "GO:0046281": "cinnamic acid catabolic process",
  "GO:0046282": "cinnamic acid ester catabolic process",
  "GO:0046283": "anthocyanin-containing compound metabolic process",
  "GO:0046284": "anthocyanin-containing compound catabolic process",
  "GO:0046285": "flavonoid phytoalexin metabolic process",
  "GO:0046286": "flavonoid phytoalexin catabolic process",
  "GO:0046287": "isoflavonoid metabolic process",
  "GO:0046288": "isoflavonoid catabolic process",
  "GO:0046289": "isoflavonoid phytoalexin metabolic process",
  "GO:0046290": "isoflavonoid phytoalexin catabolic process",
  "GO:0046291": "obsolete 6-hydroxycineole biosynthetic process",
  "GO:0046292": "formaldehyde metabolic process",
  "GO:0046293": "formaldehyde biosynthetic process",
  "GO:0046294": "formaldehyde catabolic process",
  "GO:0046295": "glycolate biosynthetic process",
  "GO:0046296": "glycolate catabolic process",
  "GO:0046297": "obsolete 2,4-dichlorobenzoate biosynthetic process",
  "GO:0046298": "2,4-dichlorobenzoate catabolic process",
  "GO:0046299": "obsolete 2,4-dichlorophenoxyacetic acid biosynthetic process",
  "GO:0046300": "2,4-dichlorophenoxyacetic acid catabolic process",
  "GO:0046301": "obsolete 2-chloro-N-isopropylacetanilide biosynthetic process",
  "GO:0046302": "2-chloro-N-isopropylacetanilide catabolic process",
  "GO:0046303": "obsolete 2-nitropropane biosynthetic process",
  "GO:0046304": "2-nitropropane catabolic process",
  "GO:0046305": "alkanesulfonate biosynthetic process",
  "GO:0046306": "alkanesulfonate catabolic process",
  "GO:0046307": "Z-phenylacetaldoxime biosynthetic process",
  "GO:0046308": "Z-phenylacetaldoxime catabolic process",
  "GO:0046309": "1,3-dichloro-2-propanol biosynthetic process",
  "GO:0046310": "1,3-dichloro-2-propanol catabolic process",
  "GO:0046311": "prenylcysteine biosynthetic process",
  "GO:0046312": "phosphoarginine biosynthetic process",
  "GO:0046313": "phosphoarginine catabolic process",
  "GO:0046314": "phosphocreatine biosynthetic process",
  "GO:0046315": "phosphocreatine catabolic process",
  "GO:0046316": "gluconokinase activity",
  "GO:0046317": "regulation of glucosylceramide biosynthetic process",
  "GO:0046318": "negative regulation of glucosylceramide biosynthetic process",
  "GO:0046319": "positive regulation of glucosylceramide biosynthetic process",
  "GO:0046320": "regulation of fatty acid oxidation",
  "GO:0046321": "positive regulation of fatty acid oxidation",
  "GO:0046322": "negative regulation of fatty acid oxidation",
  "GO:0046323": "glucose import",
  "GO:0046324": "regulation of glucose import",
  "GO:0046325": "negative regulation of glucose import",
  "GO:0046326": "positive regulation of glucose import",
  "GO:0046327": "glycerol biosynthetic process from pyruvate",
  "GO:0046328": "regulation of JNK cascade",
  "GO:0046329": "negative regulation of JNK cascade",
  "GO:0046330": "positive regulation of JNK cascade",
  "GO:0046331": "lateral inhibition",
  "GO:0046332": "SMAD binding",
  "GO:0046333": "octopamine metabolic process",
  "GO:0046334": "octopamine catabolic process",
  "GO:0046335": "ethanolamine biosynthetic process",
  "GO:0046336": "ethanolamine catabolic process",
  "GO:0046337": "phosphatidylethanolamine metabolic process",
  "GO:0046338": "phosphatidylethanolamine catabolic process",
  "GO:0046339": "diacylglycerol metabolic process",
  "GO:0046340": "diacylglycerol catabolic process",
  "GO:0046341": "CDP-diacylglycerol metabolic process",
  "GO:0046342": "CDP-diacylglycerol catabolic process",
  "GO:0046343": "streptomycin metabolic process",
  "GO:0046344": "ecdysteroid catabolic process",
  "GO:0046345": "abscisic acid catabolic process",
  "GO:0046346": "mannosamine catabolic process",
  "GO:0046347": "mannosamine biosynthetic process",
  "GO:0046348": "amino sugar catabolic process",
  "GO:0046349": "amino sugar biosynthetic process",
  "GO:0046350": "galactosaminoglycan metabolic process",
  "GO:0046351": "disaccharide biosynthetic process",
  "GO:0046352": "disaccharide catabolic process",
  "GO:0046353": "aminoglycoside 3-N-acetyltransferase activity",
  "GO:0046354": "mannan biosynthetic process",
  "GO:0046355": "mannan catabolic process",
  "GO:0046356": "acetyl-CoA catabolic process",
  "GO:0046357": "galactarate biosynthetic process",
  "GO:0046358": "butyrate biosynthetic process",
  "GO:0046359": "butyrate catabolic process",
  "GO:0046360": "2-oxobutyrate biosynthetic process",
  "GO:0046361": "2-oxobutyrate metabolic process",
  "GO:0046362": "ribitol biosynthetic process",
  "GO:0046363": "ribitol catabolic process",
  "GO:0046364": "monosaccharide biosynthetic process",
  "GO:0046365": "monosaccharide catabolic process",
  "GO:0046366": "allose biosynthetic process",
  "GO:0046367": "allose catabolic process",
  "GO:0046368": "GDP-L-fucose metabolic process",
  "GO:0046369": "galactose biosynthetic process",
  "GO:0046370": "fructose biosynthetic process",
  "GO:0046371": "dTDP-mannose metabolic process",
  "GO:0046372": "D-arabinose metabolic process",
  "GO:0046373": "L-arabinose metabolic process",
  "GO:0046374": "teichoic acid metabolic process",
  "GO:0046375": "K antigen metabolic process",
  "GO:0046376": "GDP-alpha-D-mannosylchitobiosyldiphosphodolichol metabolic process",
  "GO:0046377": "colanic acid metabolic process",
  "GO:0046378": "enterobacterial common antigen metabolic process",
  "GO:0046379": "extracellular polysaccharide metabolic process",
  "GO:0046380": "N-acetylneuraminate biosynthetic process",
  "GO:0046381": "CMP-N-acetylneuraminate metabolic process",
  "GO:0046382": "GDP-D-rhamnose metabolic process",
  "GO:0046383": "dTDP-rhamnose metabolic process",
  "GO:0046384": "2-deoxyribose 1-phosphate metabolic process",
  "GO:0046385": "deoxyribose phosphate biosynthetic process",
  "GO:0046386": "deoxyribose phosphate catabolic process",
  "GO:0046387": "deoxyribose 1,5-bisphosphate metabolic process",
  "GO:0046389": "deoxyribose 5-phosphate metabolic process",
  "GO:0046390": "ribose phosphate biosynthetic process",
  "GO:0046391": "5-phosphoribose 1-diphosphate metabolic process",
  "GO:0046392": "galactarate catabolic process",
  "GO:0046394": "carboxylic acid biosynthetic process",
  "GO:0046395": "carboxylic acid catabolic process",
  "GO:0046396": "D-galacturonate metabolic process",
  "GO:0046397": "galacturonate catabolic process",
  "GO:0046398": "UDP-glucuronate metabolic process",
  "GO:0046399": "glucuronate biosynthetic process",
  "GO:0046400": "keto-3-deoxy-D-manno-octulosonic acid metabolic process",
  "GO:0046401": "lipopolysaccharide core region metabolic process",
  "GO:0046402": "O antigen metabolic process",
  "GO:0046403": "polynucleotide 3'-phosphatase activity",
  "GO:0046404": "ATP-dependent polydeoxyribonucleotide 5'-hydroxyl-kinase activity",
  "GO:0046405": "glycerol dehydratase activity",
  "GO:0046406": "magnesium protoporphyrin IX methyltransferase activity",
  "GO:0046408": "chlorophyll synthetase activity",
  "GO:0046409": "p-coumarate 3-hydroxylase activity",
  "GO:0046410": "obsolete 2-succinyl-6-hydroxy-2,4-cyclohexadiene-1-carboxylate synthase activity",
  "GO:0046411": "2-keto-3-deoxygluconate transport",
  "GO:0046412": "phenylmercury acetate metabolic process",
  "GO:0046413": "organomercury catabolic process",
  "GO:0046414": "organomercury biosynthetic process",
  "GO:0046415": "urate metabolic process",
  "GO:0046416": "D-amino acid metabolic process",
  "GO:0046417": "chorismate metabolic process",
  "GO:0046418": "nopaline metabolic process",
  "GO:0046419": "octopine metabolic process",
  "GO:0046421": "methylisocitrate lyase activity",
  "GO:0046422": "violaxanthin de-epoxidase activity",
  "GO:0046423": "allene-oxide cyclase activity",
  "GO:0046424": "ferulate 5-hydroxylase activity",
  "GO:0046425": "regulation of JAK-STAT cascade",
  "GO:0046426": "negative regulation of JAK-STAT cascade",
  "GO:0046427": "positive regulation of JAK-STAT cascade",
  "GO:0046428": "1,4-dihydroxy-2-naphthoate octaprenyltransferase activity",
  "GO:0046429": "4-hydroxy-3-methylbut-2-en-1-yl diphosphate synthase activity",
  "GO:0046430": "non-phosphorylated glucose metabolic process",
  "GO:0046431": "(R)-4-hydroxymandelate metabolic process",
  "GO:0046432": "2'-(5''-triphosphoribosyl)-3'-dephospho-CoA metabolic process",
  "GO:0046433": "2-aminoethylphosphonate metabolic process",
  "GO:0046434": "organophosphate catabolic process",
  "GO:0046435": "3-(3-hydroxy)phenylpropionate metabolic process",
  "GO:0046436": "D-alanine metabolic process",
  "GO:0046437": "D-amino acid biosynthetic process",
  "GO:0046438": "D-cysteine metabolic process",
  "GO:0046439": "L-cysteine metabolic process",
  "GO:0046440": "L-lysine metabolic process",
  "GO:0046441": "D-lysine metabolic process",
  "GO:0046442": "aerobactin metabolic process",
  "GO:0046443": "FAD metabolic process",
  "GO:0046444": "FMN metabolic process",
  "GO:0046445": "benzyl isoquinoline alkaloid metabolic process",
  "GO:0046446": "purine alkaloid metabolic process",
  "GO:0046447": "terpenoid indole alkaloid metabolic process",
  "GO:0046448": "tropane alkaloid metabolic process",
  "GO:0046449": "creatinine metabolic process",
  "GO:0046450": "dethiobiotin metabolic process",
  "GO:0046451": "diaminopimelate metabolic process",
  "GO:0046452": "dihydrofolate metabolic process",
  "GO:0046453": "dipyrrin metabolic process",
  "GO:0046454": "dimethylsilanediol metabolic process",
  "GO:0046455": "organosilicon catabolic process",
  "GO:0046456": "icosanoid biosynthetic process",
  "GO:0046457": "prostanoid biosynthetic process",
  "GO:0046458": "hexadecanal metabolic process",
  "GO:0046459": "short-chain fatty acid metabolic process",
  "GO:0046460": "neutral lipid biosynthetic process",
  "GO:0046461": "neutral lipid catabolic process",
  "GO:0046462": "monoacylglycerol metabolic process",
  "GO:0046463": "acylglycerol biosynthetic process",
  "GO:0046464": "acylglycerol catabolic process",
  "GO:0046465": "dolichyl diphosphate metabolic process",
  "GO:0046466": "membrane lipid catabolic process",
  "GO:0046467": "membrane lipid biosynthetic process",
  "GO:0046468": "phosphatidyl-N-monomethylethanolamine metabolic process",
  "GO:0046469": "platelet activating factor metabolic process",
  "GO:0046470": "phosphatidylcholine metabolic process",
  "GO:0046471": "phosphatidylglycerol metabolic process",
  "GO:0046473": "phosphatidic acid metabolic process",
  "GO:0046474": "glycerophospholipid biosynthetic process",
  "GO:0046475": "glycerophospholipid catabolic process",
  "GO:0046476": "glycosylceramide biosynthetic process",
  "GO:0046477": "glycosylceramide catabolic process",
  "GO:0046478": "lactosylceramide metabolic process",
  "GO:0046479": "glycosphingolipid catabolic process",
  "GO:0046480": "galactolipid galactosyltransferase activity",
  "GO:0046481": "digalactosyldiacylglycerol synthase activity",
  "GO:0046482": "para-aminobenzoic acid metabolic process",
  "GO:0046483": "heterocycle metabolic process",
  "GO:0046484": "oxazole or thiazole metabolic process",
  "GO:0046485": "ether lipid metabolic process",
  "GO:0046486": "glycerolipid metabolic process",
  "GO:0046487": "glyoxylate metabolic process",
  "GO:0046488": "phosphatidylinositol metabolic process",
  "GO:0046490": "isopentenyl diphosphate metabolic process",
  "GO:0046491": "L-methylmalonyl-CoA metabolic process",
  "GO:0046492": "heme b metabolic process",
  "GO:0046493": "lipid A metabolic process",
  "GO:0046494": "rhizobactin 1021 metabolic process",
  "GO:0046495": "nicotinamide riboside metabolic process",
  "GO:0046496": "nicotinamide nucleotide metabolic process",
  "GO:0046497": "nicotinate nucleotide metabolic process",
  "GO:0046498": "S-adenosylhomocysteine metabolic process",
  "GO:0046499": "S-adenosylmethioninamine metabolic process",
  "GO:0046500": "S-adenosylmethionine metabolic process",
  "GO:0046501": "protoporphyrinogen IX metabolic process",
  "GO:0046502": "uroporphyrinogen III metabolic process",
  "GO:0046503": "glycerolipid catabolic process",
  "GO:0046504": "glycerol ether biosynthetic process",
  "GO:0046505": "sulfolipid metabolic process",
  "GO:0046506": "sulfolipid biosynthetic process",
  "GO:0046507": "UDPsulfoquinovose synthase activity",
  "GO:0046508": "hydrolase activity, acting on carbon-sulfur bonds",
  "GO:0046509": "1,2-diacylglycerol 3-beta-galactosyltransferase activity",
  "GO:0046510": "UDP-sulfoquinovose:DAG sulfoquinovosyltransferase activity",
  "GO:0046511": "sphinganine biosynthetic process",
  "GO:0046512": "sphingosine biosynthetic process",
  "GO:0046513": "ceramide biosynthetic process",
  "GO:0046514": "ceramide catabolic process",
  "GO:0046516": "hypusine metabolic process",
  "GO:0046517": "octamethylcyclotetrasiloxane catabolic process",
  "GO:0046518": "octamethylcyclotetrasiloxane metabolic process",
  "GO:0046519": "sphingoid metabolic process",
  "GO:0046520": "sphingoid biosynthetic process",
  "GO:0046521": "sphingoid catabolic process",
  "GO:0046522": "S-methyl-5-thioribose kinase activity",
  "GO:0046523": "S-methyl-5-thioribose-1-phosphate isomerase activity",
  "GO:0046524": "sucrose-phosphate synthase activity",
  "GO:0046525": "xylosylprotein 4-beta-galactosyltransferase activity",
  "GO:0046526": "D-xylulose reductase activity",
  "GO:0046527": "glucosyltransferase activity",
  "GO:0046528": "imaginal disc fusion",
  "GO:0046529": "imaginal disc fusion, thorax closure",
  "GO:0046530": "photoreceptor cell differentiation",
  "GO:0046532": "regulation of photoreceptor cell differentiation",
  "GO:0046533": "negative regulation of photoreceptor cell differentiation",
  "GO:0046534": "positive regulation of photoreceptor cell differentiation",
  "GO:0046535": "detection of chemical stimulus involved in sensory perception of umami taste",
  "GO:0046536": "dosage compensation complex",
  "GO:0046537": "2,3-bisphosphoglycerate-independent phosphoglycerate mutase activity",
  "GO:0046538": "2,3-bisphosphoglycerate-dependent phosphoglycerate mutase activity",
  "GO:0046539": "histamine N-methyltransferase activity",
  "GO:0046540": "U4/U6 x U5 tri-snRNP complex",
  "GO:0046541": "saliva secretion",
  "GO:0046542": "obsolete alpha-factor export",
  "GO:0046543": "development of secondary female sexual characteristics",
  "GO:0046544": "development of secondary male sexual characteristics",
  "GO:0046545": "development of primary female sexual characteristics",
  "GO:0046546": "development of primary male sexual characteristics",
  "GO:0046547": "trans-aconitate 3-methyltransferase activity",
  "GO:0046548": "retinal rod cell development",
  "GO:0046549": "retinal cone cell development",
  "GO:0046550": "(3-aminopropyl)(L-aspartyl-1-amino)phosphoryl-5'-adenosine biosynthetic process from asparagine",
  "GO:0046551": "retinal cone cell fate commitment",
  "GO:0046552": "photoreceptor cell fate commitment",
  "GO:0046553": "D-malate dehydrogenase (decarboxylating) activity",
  "GO:0046554": "malate dehydrogenase (NADP+) activity",
  "GO:0046555": "acetylxylan esterase activity",
  "GO:0046556": "alpha-L-arabinofuranosidase activity",
  "GO:0046557": "glucan endo-1,6-beta-glucosidase activity",
  "GO:0046558": "arabinan endo-1,5-alpha-L-arabinosidase activity",
  "GO:0046559": "alpha-glucuronidase activity",
  "GO:0046560": "obsolete scytalidopepsin B activity",
  "GO:0046561": "obsolete penicillopepsin activity",
  "GO:0046562": "glucose oxidase activity",
  "GO:0046563": "methanol oxidase activity",
  "GO:0046564": "oxalate decarboxylase activity",
  "GO:0046565": "3-dehydroshikimate dehydratase activity",
  "GO:0046566": "DOPA dioxygenase activity",
  "GO:0046567": "aphidicolan-16 beta-ol synthase activity",
  "GO:0046568": "3-methylbutanol:NAD(P) oxidoreductase activity",
  "GO:0046569": "glyoxal oxidase activity",
  "GO:0046570": "methylthioribulose 1-phosphate dehydratase activity",
  "GO:0046571": "aspartate-2-keto-4-methylthiobutyrate transaminase activity",
  "GO:0046572": "versicolorin B synthase activity",
  "GO:0046573": "lactonohydrolase activity",
  "GO:0046574": "glycuronidase activity",
  "GO:0046575": "rhamnogalacturonan acetylesterase activity",
  "GO:0046576": "rhamnogalacturonan alpha-L-rhamnopyranosyl-(1->4)-alpha-D-galactopyranosyluronide lyase activity",
  "GO:0046577": "long-chain-alcohol oxidase activity",
  "GO:0046578": "regulation of Ras protein signal transduction",
  "GO:0046579": "positive regulation of Ras protein signal transduction",
  "GO:0046580": "negative regulation of Ras protein signal transduction",
  "GO:0046581": "intercellular canaliculus",
  "GO:0046583": "cation efflux transmembrane transporter activity",
  "GO:0046584": "enniatin metabolic process",
  "GO:0046585": "enniatin biosynthetic process",
  "GO:0046586": "regulation of calcium-dependent cell-cell adhesion",
  "GO:0046587": "positive regulation of calcium-dependent cell-cell adhesion",
  "GO:0046588": "negative regulation of calcium-dependent cell-cell adhesion",
  "GO:0046589": "ribonuclease T1 activity",
  "GO:0046590": "obsolete embryonic leg morphogenesis",
  "GO:0046591": "obsolete embryonic leg joint morphogenesis",
  "GO:0046592": "polyamine oxidase activity",
  "GO:0046593": "mandelonitrile lyase activity",
  "GO:0046594": "maintenance of pole plasm mRNA location",
  "GO:0046595": "establishment of pole plasm mRNA localization",
  "GO:0046596": "regulation of viral entry into host cell",
  "GO:0046597": "negative regulation of viral entry into host cell",
  "GO:0046598": "positive regulation of viral entry into host cell",
  "GO:0046599": "regulation of centriole replication",
  "GO:0046600": "negative regulation of centriole replication",
  "GO:0046601": "positive regulation of centriole replication",
  "GO:0046602": "regulation of mitotic centrosome separation",
  "GO:0046603": "negative regulation of mitotic centrosome separation",
  "GO:0046604": "positive regulation of mitotic centrosome separation",
  "GO:0046605": "regulation of centrosome cycle",
  "GO:0046606": "negative regulation of centrosome cycle",
  "GO:0046607": "positive regulation of centrosome cycle",
  "GO:0046608": "carotenoid isomerase activity",
  "GO:0046609": "voltage-gated sulfate antiporter activity",
  "GO:0046610": "lysosomal proton-transporting V-type ATPase, V0 domain",
  "GO:0046611": "lysosomal proton-transporting V-type ATPase complex",
  "GO:0046612": "lysosomal proton-transporting V-type ATPase, V1 domain",
  "GO:0046615": "obsolete re-entry into mitotic cell cycle after pheromone arrest (sensu Saccharomyces)",
  "GO:0046617": "obsolete nucleolar size increase (sensu Saccharomyces)",
  "GO:0046618": "drug export",
  "GO:0046619": "optic placode formation involved in camera-type eye formation",
  "GO:0046620": "regulation of organ growth",
  "GO:0046621": "negative regulation of organ growth",
  "GO:0046622": "positive regulation of organ growth",
  "GO:0046623": "sphingolipid-translocating ATPase activity",
  "GO:0046624": "sphingolipid transporter activity",
  "GO:0046625": "sphingolipid binding",
  "GO:0046626": "regulation of insulin receptor signaling pathway",
  "GO:0046627": "negative regulation of insulin receptor signaling pathway",
  "GO:0046628": "positive regulation of insulin receptor signaling pathway",
  "GO:0046629": "gamma-delta T cell activation",
  "GO:0046630": "gamma-delta T cell proliferation",
  "GO:0046631": "alpha-beta T cell activation",
  "GO:0046632": "alpha-beta T cell differentiation",
  "GO:0046633": "alpha-beta T cell proliferation",
  "GO:0046634": "regulation of alpha-beta T cell activation",
  "GO:0046635": "positive regulation of alpha-beta T cell activation",
  "GO:0046636": "negative regulation of alpha-beta T cell activation",
  "GO:0046637": "regulation of alpha-beta T cell differentiation",
  "GO:0046638": "positive regulation of alpha-beta T cell differentiation",
  "GO:0046639": "negative regulation of alpha-beta T cell differentiation",
  "GO:0046640": "regulation of alpha-beta T cell proliferation",
  "GO:0046641": "positive regulation of alpha-beta T cell proliferation",
  "GO:0046642": "negative regulation of alpha-beta T cell proliferation",
  "GO:0046643": "regulation of gamma-delta T cell activation",
  "GO:0046644": "negative regulation of gamma-delta T cell activation",
  "GO:0046645": "positive regulation of gamma-delta T cell activation",
  "GO:0046646": "regulation of gamma-delta T cell proliferation",
  "GO:0046647": "negative regulation of gamma-delta T cell proliferation",
  "GO:0046648": "positive regulation of gamma-delta T cell proliferation",
  "GO:0046649": "lymphocyte activation",
  "GO:0046651": "lymphocyte proliferation",
  "GO:0046653": "tetrahydrofolate metabolic process",
  "GO:0046654": "tetrahydrofolate biosynthetic process",
  "GO:0046655": "folic acid metabolic process",
  "GO:0046656": "folic acid biosynthetic process",
  "GO:0046657": "folic acid catabolic process",
  "GO:0046658": "anchored component of plasma membrane",
  "GO:0046659": "digestive hormone activity",
  "GO:0046660": "female sex differentiation",
  "GO:0046661": "male sex differentiation",
  "GO:0046662": "regulation of oviposition",
  "GO:0046663": "dorsal closure, leading edge cell differentiation",
  "GO:0046664": "dorsal closure, amnioserosa morphology change",
  "GO:0046665": "amnioserosa maintenance",
  "GO:0046666": "retinal cell programmed cell death",
  "GO:0046667": "compound eye retinal cell programmed cell death",
  "GO:0046668": "regulation of retinal cell programmed cell death",
  "GO:0046669": "regulation of compound eye retinal cell programmed cell death",
  "GO:0046670": "positive regulation of retinal cell programmed cell death",
  "GO:0046671": "negative regulation of retinal cell programmed cell death",
  "GO:0046672": "positive regulation of compound eye retinal cell programmed cell death",
  "GO:0046673": "negative regulation of compound eye retinal cell programmed cell death",
  "GO:0046676": "negative regulation of insulin secretion",
  "GO:0046677": "response to antibiotic",
  "GO:0046678": "response to bacteriocin",
  "GO:0046679": "response to streptomycin",
  "GO:0046680": "response to DDT",
  "GO:0046681": "response to carbamate",
  "GO:0046682": "response to cyclodiene",
  "GO:0046683": "response to organophosphorus",
  "GO:0046684": "response to pyrethroid",
  "GO:0046685": "response to arsenic-containing substance",
  "GO:0046686": "response to cadmium ion",
  "GO:0046687": "response to chromate",
  "GO:0046688": "response to copper ion",
  "GO:0046689": "response to mercury ion",
  "GO:0046690": "response to tellurium ion",
  "GO:0046691": "intracellular canaliculus",
  "GO:0046692": "sperm competition",
  "GO:0046693": "sperm storage",
  "GO:0046694": "sperm incapacitation",
  "GO:0046695": "SLIK (SAGA-like) complex",
  "GO:0046696": "lipopolysaccharide receptor complex",
  "GO:0046697": "decidualization",
  "GO:0046700": "heterocycle catabolic process",
  "GO:0046701": "insecticide catabolic process",
  "GO:0046702": "galactoside 6-L-fucosyltransferase activity",
  "GO:0046703": "natural killer cell lectin-like receptor binding",
  "GO:0046704": "CDP metabolic process",
  "GO:0046705": "CDP biosynthetic process",
  "GO:0046706": "CDP catabolic process",
  "GO:0046707": "IDP metabolic process",
  "GO:0046708": "IDP biosynthetic process",
  "GO:0046709": "IDP catabolic process",
  "GO:0046710": "GDP metabolic process",
  "GO:0046711": "GDP biosynthetic process",
  "GO:0046712": "GDP catabolic process",
  "GO:0046713": "borate transport",
  "GO:0046714": "borate binding",
  "GO:0046715": "borate transmembrane transporter activity",
  "GO:0046716": "muscle cell cellular homeostasis",
  "GO:0046717": "acid secretion",
  "GO:0046718": "viral entry into host cell",
  "GO:0046719": "regulation by virus of viral protein levels in host cell",
  "GO:0046720": "citric acid secretion",
  "GO:0046721": "formic acid secretion",
  "GO:0046722": "lactic acid secretion",
  "GO:0046723": "malic acid secretion",
  "GO:0046724": "oxalic acid secretion",
  "GO:0046725": "negative regulation by virus of viral protein levels in host cell",
  "GO:0046726": "positive regulation by virus of viral protein levels in host cell",
  "GO:0046727": "capsomere",
  "GO:0046729": "viral procapsid",
  "GO:0046730": "induction of host immune response by virus",
  "GO:0046731": "passive induction of host immune response by virus",
  "GO:0046732": "active induction of host immune response by virus",
  "GO:0046733": "passive induction of host humoral immune response by virus",
  "GO:0046734": "passive induction of host cell-mediated immune response by virus",
  "GO:0046735": "passive induction of host innate immune response by virus",
  "GO:0046736": "active induction of humoral immune response in host by virus",
  "GO:0046737": "active induction of cell-mediated immune response in host by virus",
  "GO:0046738": "active induction of innate immune response in host by virus",
  "GO:0046739": "transport of virus in multicellular host",
  "GO:0046740": "transport of virus in host, cell to cell",
  "GO:0046741": "transport of virus in host, tissue to tissue",
  "GO:0046745": "viral capsid secondary envelopment",
  "GO:0046752": "viral capsid precursor transport to host cell nucleus",
  "GO:0046753": "non-lytic viral release",
  "GO:0046754": "viral exocytosis",
  "GO:0046755": "viral budding",
  "GO:0046757": "obsolete lytic virus budding from ER membrane",
  "GO:0046758": "obsolete lytic virus budding from Golgi membrane",
  "GO:0046759": "obsolete lytic virus budding from plasma membrane",
  "GO:0046760": "viral budding from Golgi membrane",
  "GO:0046761": "viral budding from plasma membrane",
  "GO:0046762": "viral budding from ER membrane",
  "GO:0046765": "viral budding from nuclear membrane",
  "GO:0046771": "viral budding from inner nuclear membrane",
  "GO:0046772": "viral budding from outer nuclear membrane",
  "GO:0046773": "suppression by virus of host translation termination",
  "GO:0046774": "suppression by virus of host intracellular interferon activity",
  "GO:0046775": "suppression by virus of host cytokine production",
  "GO:0046776": "suppression by virus of host antigen processing and presentation of peptide antigen via MHC class I",
  "GO:0046777": "protein autophosphorylation",
  "GO:0046778": "modification by virus of host mRNA processing",
  "GO:0046779": "suppression by virus of expression of host genes with introns",
  "GO:0046780": "suppression by virus of host mRNA splicing",
  "GO:0046782": "regulation of viral transcription",
  "GO:0046783": "modification by virus of host polysomes",
  "GO:0046784": "viral mRNA export from host cell nucleus",
  "GO:0046785": "microtubule polymerization",
  "GO:0046786": "viral replication complex formation and maintenance",
  "GO:0046787": "viral DNA repair",
  "GO:0046789": "host cell surface receptor binding",
  "GO:0046790": "virion binding",
  "GO:0046791": "obsolete suppression by virus of host complement neutralization",
  "GO:0046792": "suppression by virus of host cell cycle arrest",
  "GO:0046793": "induction by virus of phosphorylation of host RNA polymerase II",
  "GO:0046794": "transport of virus",
  "GO:0046797": "viral procapsid maturation",
  "GO:0046798": "viral portal complex",
  "GO:0046799": "recruitment of helicase-primase complex to DNA lesions",
  "GO:0046800": "obsolete enhancement of virulence",
  "GO:0046802": "exit of virus from host cell nucleus by nuclear egress",
  "GO:0046803": "obsolete reduction of virulence",
  "GO:0046804": "peptide cross-linking via (2S,3S,4Xi,6R)-3-methyl-lanthionine sulfoxide",
  "GO:0046805": "protein-heme linkage via 1'-L-histidine",
  "GO:0046806": "viral scaffold",
  "GO:0046807": "viral scaffold assembly and maintenance",
  "GO:0046808": "assemblon",
  "GO:0046809": "replication compartment",
  "GO:0046810": "host cell extracellular matrix binding",
  "GO:0046811": "histone deacetylase inhibitor activity",
  "GO:0046812": "host cell surface binding",
  "GO:0046813": "receptor-mediated virion attachment to host cell",
  "GO:0046814": "coreceptor-mediated virion attachment to host cell",
  "GO:0046815": "genome retention in viral capsid",
  "GO:0046816": "virion transport vesicle",
  "GO:0046817": "chemokine receptor antagonist activity",
  "GO:0046818": "dense nuclear body",
  "GO:0046819": "protein secretion by the type V secretion system",
  "GO:0046820": "4-amino-4-deoxychorismate synthase activity",
  "GO:0046821": "extrachromosomal DNA",
  "GO:0046822": "regulation of nucleocytoplasmic transport",
  "GO:0046823": "negative regulation of nucleocytoplasmic transport",
  "GO:0046824": "positive regulation of nucleocytoplasmic transport",
  "GO:0046825": "regulation of protein export from nucleus",
  "GO:0046826": "negative regulation of protein export from nucleus",
  "GO:0046827": "positive regulation of protein export from nucleus",
  "GO:0046828": "regulation of RNA import into nucleus",
  "GO:0046829": "negative regulation of RNA import into nucleus",
  "GO:0046830": "positive regulation of RNA import into nucleus",
  "GO:0046831": "regulation of RNA export from nucleus",
  "GO:0046832": "negative regulation of RNA export from nucleus",
  "GO:0046833": "positive regulation of RNA export from nucleus",
  "GO:0046834": "lipid phosphorylation",
  "GO:0046835": "carbohydrate phosphorylation",
  "GO:0046836": "glycolipid transport",
  "GO:0046838": "phosphorylated carbohydrate dephosphorylation",
  "GO:0046839": "phospholipid dephosphorylation",
  "GO:0046841": "trisporic acid metabolic process",
  "GO:0046842": "trisporic acid biosynthetic process",
  "GO:0046843": "dorsal appendage formation",
  "GO:0046844": "micropyle formation",
  "GO:0046845": "branched duct epithelial cell fate determination, open tracheal system",
  "GO:0046847": "filopodium assembly",
  "GO:0046848": "hydroxyapatite binding",
  "GO:0046849": "bone remodeling",
  "GO:0046850": "regulation of bone remodeling",
  "GO:0046851": "negative regulation of bone remodeling",
  "GO:0046852": "positive regulation of bone remodeling",
  "GO:0046853": "obsolete inositol or phosphatidylinositol phosphorylation",
  "GO:0046854": "phosphatidylinositol phosphorylation",
  "GO:0046855": "inositol phosphate dephosphorylation",
  "GO:0046856": "phosphatidylinositol dephosphorylation",
  "GO:0046857": "oxidoreductase activity, acting on other nitrogenous compounds as donors, with NAD or NADP as acceptor",
  "GO:0046858": "chlorosome",
  "GO:0046859": "hydrogenosomal membrane",
  "GO:0046860": "glycosome membrane",
  "GO:0046861": "glyoxysomal membrane",
  "GO:0046862": "chromoplast membrane",
  "GO:0046863": "ribulose-1,5-bisphosphate carboxylase/oxygenase activator activity",
  "GO:0046864": "isoprenoid transport",
  "GO:0046865": "terpenoid transport",
  "GO:0046866": "tetraterpenoid transport",
  "GO:0046867": "carotenoid transport",
  "GO:0046868": "mesosome",
  "GO:0046869": "iron incorporation into iron-sulfur cluster via tris-L-cysteinyl-L-aspartato diiron disulfide",
  "GO:0046870": "cadmium ion binding",
  "GO:0046871": "N-acetylgalactosamine binding",
  "GO:0046872": "metal ion binding",
  "GO:0046873": "metal ion transmembrane transporter activity",
  "GO:0046874": "quinolinate metabolic process",
  "GO:0046875": "ephrin receptor binding",
  "GO:0046876": "3,4-didehydroretinal binding",
  "GO:0046877": "regulation of saliva secretion",
  "GO:0046878": "positive regulation of saliva secretion",
  "GO:0046879": "hormone secretion",
  "GO:0046880": "regulation of follicle-stimulating hormone secretion",
  "GO:0046881": "positive regulation of follicle-stimulating hormone secretion",
  "GO:0046882": "negative regulation of follicle-stimulating hormone secretion",
  "GO:0046883": "regulation of hormone secretion",
  "GO:0046884": "follicle-stimulating hormone secretion",
  "GO:0046885": "regulation of hormone biosynthetic process",
  "GO:0046886": "positive regulation of hormone biosynthetic process",
  "GO:0046887": "positive regulation of hormone secretion",
  "GO:0046888": "negative regulation of hormone secretion",
  "GO:0046889": "positive regulation of lipid biosynthetic process",
  "GO:0046890": "regulation of lipid biosynthetic process",
  "GO:0046891": "peptidyl-cysteine S-carbamoylation",
  "GO:0046892": "peptidyl-S-carbamoyl-L-cysteine dehydration",
  "GO:0046893": "iron incorporation into hydrogenase diiron subcluster via L-cysteine ligation",
  "GO:0046894": "enzyme active site formation via S-amidino-L-cysteine",
  "GO:0046895": "N-terminal peptidyl-isoleucine methylation",
  "GO:0046896": "N-terminal peptidyl-leucine methylation",
  "GO:0046897": "N-terminal peptidyl-tyrosine methylation",
  "GO:0046898": "response to cycloheximide",
  "GO:0046899": "nucleoside triphosphate adenylate kinase activity",
  "GO:0046900": "tetrahydrofolylpolyglutamate metabolic process",
  "GO:0046901": "tetrahydrofolylpolyglutamate biosynthetic process",
  "GO:0046902": "regulation of mitochondrial membrane permeability",
  "GO:0046903": "secretion",
  "GO:0046904": "calcium oxalate binding",
  "GO:0046905": "phytoene synthase activity",
  "GO:0046906": "tetrapyrrole binding",
  "GO:0046907": "intracellular transport",
  "GO:0046908": "obsolete negative regulation of crystal formation",
  "GO:0046909": "intermembrane transport",
  "GO:0046910": "pectinesterase inhibitor activity",
  "GO:0046911": "metal chelating activity",
  "GO:0046912": "transferase activity, transferring acyl groups, acyl groups converted into alkyl on transfer",
  "GO:0046914": "transition metal ion binding",
  "GO:0046915": "transition metal ion transmembrane transporter activity",
  "GO:0046916": "cellular transition metal ion homeostasis",
  "GO:0046917": "triphosphoribosyl-dephospho-CoA synthase activity",
  "GO:0046918": "N-terminal peptidyl-glycine N-palmitoylation",
  "GO:0046919": "pyruvyltransferase activity",
  "GO:0046920": "alpha-(1->3)-fucosyltransferase activity",
  "GO:0046921": "alpha-(1->6)-fucosyltransferase activity",
  "GO:0046922": "peptide-O-fucosyltransferase activity",
  "GO:0046923": "ER retention sequence binding",
  "GO:0046924": "peptide cross-linking via 2-(S-L-cysteinyl)-L-phenylalanine",
  "GO:0046925": "peptide cross-linking via 2-(S-L-cysteinyl)-D-phenylalanine",
  "GO:0046926": "peptide cross-linking via 2-(S-L-cysteinyl)-D-allo-threonine",
  "GO:0046927": "peptidyl-threonine racemization",
  "GO:0046928": "regulation of neurotransmitter secretion",
  "GO:0046929": "negative regulation of neurotransmitter secretion",
  "GO:0046930": "pore complex",
  "GO:0046931": "pore complex assembly",
  "GO:0046932": "sodium-transporting ATP synthase activity, rotational mechanism",
  "GO:0046933": "proton-transporting ATP synthase activity, rotational mechanism",
  "GO:0046934": "phosphatidylinositol-4,5-bisphosphate 3-kinase activity",
  "GO:0046935": "1-phosphatidylinositol-3-kinase regulator activity",
  "GO:0046936": "deoxyadenosine deaminase activity",
  "GO:0046937": "phytochelatin metabolic process",
  "GO:0046938": "phytochelatin biosynthetic process",
  "GO:0046939": "nucleotide phosphorylation",
  "GO:0046940": "nucleoside monophosphate phosphorylation",
  "GO:0046941": "azetidine-2-carboxylic acid acetyltransferase activity",
  "GO:0046942": "carboxylic acid transport",
  "GO:0046943": "carboxylic acid transmembrane transporter activity",
  "GO:0046944": "protein carbamoylation",
  "GO:0046945": "N-terminal peptidyl-alanine N-carbamoylation",
  "GO:0046946": "hydroxylysine metabolic process",
  "GO:0046947": "hydroxylysine biosynthetic process",
  "GO:0046948": "hydroxylysine catabolic process",
  "GO:0046949": "fatty-acyl-CoA biosynthetic process",
  "GO:0046950": "cellular ketone body metabolic process",
  "GO:0046951": "ketone body biosynthetic process",
  "GO:0046952": "ketone body catabolic process",
  "GO:0046956": "positive phototaxis",
  "GO:0046957": "negative phototaxis",
  "GO:0046958": "nonassociative learning",
  "GO:0046959": "habituation",
  "GO:0046960": "sensitization",
  "GO:0046961": "proton-transporting ATPase activity, rotational mechanism",
  "GO:0046962": "sodium-transporting ATPase activity, rotational mechanism",
  "GO:0046963": "3'-phosphoadenosine 5'-phosphosulfate transport",
  "GO:0046964": "3'-phosphoadenosine 5'-phosphosulfate transmembrane transporter activity",
  "GO:0046965": "retinoid X receptor binding",
  "GO:0046966": "thyroid hormone receptor binding",
  "GO:0046967": "cytosol to ER transport",
  "GO:0046968": "peptide antigen transport",
  "GO:0046969": "NAD-dependent histone deacetylase activity (H3-K9 specific)",
  "GO:0046970": "NAD-dependent histone deacetylase activity (H4-K16 specific)",
  "GO:0046972": "histone acetyltransferase activity (H4-K16 specific)",
  "GO:0046973": "obsolete histone lysine N-methyltransferase activity (H3-K24 specific)",
  "GO:0046974": "histone methyltransferase activity (H3-K9 specific)",
  "GO:0046975": "histone methyltransferase activity (H3-K36 specific)",
  "GO:0046976": "histone methyltransferase activity (H3-K27 specific)",
  "GO:0046977": "TAP binding",
  "GO:0046978": "TAP1 binding",
  "GO:0046979": "TAP2 binding",
  "GO:0046980": "tapasin binding",
  "GO:0046981": "beta-1,4-mannosylglycolipid beta-1,3-N-acetylglucosaminyltransferase activity",
  "GO:0046982": "protein heterodimerization activity",
  "GO:0046983": "protein dimerization activity",
  "GO:0046984": "regulation of hemoglobin biosynthetic process",
  "GO:0046985": "positive regulation of hemoglobin biosynthetic process",
  "GO:0046986": "negative regulation of hemoglobin biosynthetic process",
  "GO:0046987": "N-acetyllactosamine beta-1,3-glucuronosyltransferase activity",
  "GO:0046988": "asioloorosomucoid beta-1,3-glucuronosyltransferase activity",
  "GO:0046989": "galactosyl beta-1,3 N-acetylgalactosamine beta-1,3-glucuronosyltransferase activity",
  "GO:0046990": "N-hydroxyarylamine O-acetyltransferase activity",
  "GO:0046992": "oxidoreductase activity, acting on X-H and Y-H to form an X-Y bond",
  "GO:0046993": "oxidoreductase activity, acting on X-H and Y-H to form an X-Y bond, with oxygen as acceptor",
  "GO:0046994": "oxidoreductase activity, acting on hydrogen as donor, with a quinone or similar compound as acceptor",
  "GO:0046995": "oxidoreductase activity, acting on hydrogen as donor, with other known acceptors",
  "GO:0046996": "oxidoreductase activity, acting on paired donors, with incorporation or reduction of molecular oxygen, with NAD(P)H as one donor, and the other dehydrogenated",
  "GO:0046997": "oxidoreductase activity, acting on the CH-NH group of donors, flavin as acceptor",
  "GO:0046998": "(S)-usnate reductase activity",
  "GO:0046999": "regulation of conjugation",
  "GO:0047000": "2-dehydro-3-deoxy-D-gluconate 6-dehydrogenase activity",
  "GO:0047001": "2-dehydro-3-deoxy-D-gluconate 5-dehydrogenase activity",
  "GO:0047002": "L-arabinitol 2-dehydrogenase activity",
  "GO:0047003": "dTDP-6-deoxy-L-talose 4-dehydrogenase activity",
  "GO:0047004": "UDP-N-acetylglucosamine 6-dehydrogenase activity",
  "GO:0047005": "16-alpha-hydroxysteroid dehydrogenase activity",
  "GO:0047006": "17-alpha,20-alpha-dihydroxypregn-4-en-3-one dehydrogenase activity",
  "GO:0047007": "pregnan-21-ol dehydrogenase (NAD+) activity",
  "GO:0047008": "pregnan-21-ol dehydrogenase (NADP+) activity",
  "GO:0047009": "3-alpha-hydroxy-5-beta-androstane-17-one 3-alpha-dehydrogenase activity",
  "GO:0047010": "hydroxycyclohexanecarboxylate dehydrogenase activity",
  "GO:0047011": "2-dehydropantolactone reductase (A-specific) activity",
  "GO:0047012": "sterol-4-alpha-carboxylate 3-dehydrogenase (decarboxylating) activity",
  "GO:0047013": "cholate 12-alpha dehydrogenase activity",
  "GO:0047014": "glycerol-3-phosphate 1-dehydrogenase [NADP+] activity",
  "GO:0047015": "3-hydroxy-2-methylbutyryl-CoA dehydrogenase activity",
  "GO:0047016": "cholest-5-ene-3-beta,7-alpha-diol 3-beta-dehydrogenase activity",
  "GO:0047017": "prostaglandin-F synthase activity",
  "GO:0047018": "indole-3-acetaldehyde reductase (NADH) activity",
  "GO:0047019": "indole-3-acetaldehyde reductase (NADPH) activity",
  "GO:0047020": "15-hydroxyprostaglandin-D dehydrogenase (NADP+) activity",
  "GO:0047021": "15-hydroxyprostaglandin dehydrogenase (NADP+) activity",
  "GO:0047022": "7-beta-hydroxysteroid dehydrogenase (NADP+) activity",
  "GO:0047023": "androsterone dehydrogenase activity",
  "GO:0047024": "5alpha-androstane-3beta,17beta-diol dehydrogenase activity",
  "GO:0047025": "3-oxoacyl-[acyl-carrier-protein] reductase (NADH) activity",
  "GO:0047026": "androsterone dehydrogenase (A-specific) activity",
  "GO:0047027": "benzyl-2-methyl-hydroxybutyrate dehydrogenase activity",
  "GO:0047028": "6-pyruvoyltetrahydropterin 2'-reductase activity",
  "GO:0047029": "(R)-4-hydroxyphenyllactate dehydrogenase activity",
  "GO:0047030": "4-hydroxycyclohexanecarboxylate dehydrogenase activity",
  "GO:0047031": "diethyl 2-methyl-3-oxosuccinate reductase activity",
  "GO:0047032": "3-alpha-hydroxyglycyrrhetinate dehydrogenase activity",
  "GO:0047033": "15-hydroxyprostaglandin-I dehydrogenase (NADP+) activity",
  "GO:0047034": "15-hydroxyicosatetraenoate dehydrogenase activity",
  "GO:0047035": "testosterone dehydrogenase (NAD+) activity",
  "GO:0047036": "codeinone reductase (NADPH) activity",
  "GO:0047037": "salutaridine reductase (NADPH) activity",
  "GO:0047038": "D-arabinitol 2-dehydrogenase activity",
  "GO:0047039": "tetrahydroxynaphthalene reductase activity",
  "GO:0047040": "pteridine reductase activity",
  "GO:0047041": "(S)-carnitine 3-dehydrogenase activity",
  "GO:0047042": "androsterone dehydrogenase (B-specific) activity",
  "GO:0047043": "3-alpha-hydroxycholanate dehydrogenase activity",
  "GO:0047044": "androstan-3-alpha,17-beta-diol dehydrogenase activity",
  "GO:0047045": "testosterone 17-beta-dehydrogenase (NADP+) activity",
  "GO:0047046": "homoisocitrate dehydrogenase activity",
  "GO:0047047": "oxaloglycolate reductase (decarboxylating) activity",
  "GO:0047048": "3-hydroxybenzyl-alcohol dehydrogenase activity",
  "GO:0047049": "(R)-2-hydroxy-fatty acid dehydrogenase activity",
  "GO:0047050": "(S)-2-hydroxy-fatty acid dehydrogenase activity",
  "GO:0047051": "D-lactate dehydrogenase (cytochrome c-553) activity",
  "GO:0047052": "(S)-stylopine synthase activity",
  "GO:0047053": "(S)-cheilanthifoline synthase activity",
  "GO:0047054": "berbamunine synthase activity",
  "GO:0047055": "salutaridine synthase activity",
  "GO:0047056": "(S)-canadine synthase activity",
  "GO:0047057": "vitamin-K-epoxide reductase (warfarin-sensitive) activity",
  "GO:0047058": "vitamin-K-epoxide reductase (warfarin-insensitive) activity",
  "GO:0047059": "polyvinyl alcohol dehydrogenase (cytochrome) activity",
  "GO:0047060": "(R)-pantolactone dehydrogenase (flavin) activity",
  "GO:0047061": "glucose-fructose oxidoreductase activity",
  "GO:0047062": "trans-acenaphthene-1,2-diol dehydrogenase activity",
  "GO:0047063": "L-ascorbate-cytochrome-b5 reductase activity",
  "GO:0047064": "sulochrin oxidase [(+)-bisdechlorogeodin-forming] activity",
  "GO:0047065": "sulochrin oxidase [(-)-bisdechlorogeodin-forming] activity",
  "GO:0047066": "phospholipid-hydroperoxide glutathione peroxidase activity",
  "GO:0047067": "hydrogen:quinone oxidoreductase activity",
  "GO:0047068": "N5,N10-methenyltetrahydromethanopterin hydrogenase activity",
  "GO:0047069": "7,8-dihydroxykynurenate 8,8a-dioxygenase activity",
  "GO:0047070": "3-carboxyethylcatechol 2,3-dioxygenase activity",
  "GO:0047071": "3,4-dihydroxy-9,10-secoandrosta-1,3,5(10)-triene-9,17-dione 4,5-dioxygenase activity",
  "GO:0047072": "2,3-dihydroxybenzoate 2,3-dioxygenase activity",
  "GO:0047073": "2,4'-dihydroxyacetophenone dioxygenase activity",
  "GO:0047074": "4-hydroxycatechol 1,2-dioxygenase activity",
  "GO:0047075": "2,5-dihydroxypyridine 5,6-dioxygenase activity",
  "GO:0047077": "Photinus-luciferin 4-monooxygenase (ATP-hydrolyzing) activity",
  "GO:0047078": "3-hydroxy-4-oxoquinoline 2,4-dioxygenase activity",
  "GO:0047079": "deoxyuridine 1'-dioxygenase activity",
  "GO:0047080": "deoxyuridine 2'-dioxygenase activity",
  "GO:0047081": "3-hydroxy-2-methylpyridinecarboxylate dioxygenase activity",
  "GO:0047082": "3,9-dihydroxypterocarpan 6a-monooxygenase activity",
  "GO:0047083": "5-O-(4-coumaroyl)-D-quinate 3'-monooxygenase activity",
  "GO:0047084": "methyltetrahydroprotoberberine 14-monooxygenase activity",
  "GO:0047085": "hydroxyphenylacetonitrile 2-monooxygenase activity",
  "GO:0047086": "ketosteroid monooxygenase activity",
  "GO:0047087": "protopine 6-monooxygenase activity",
  "GO:0047088": "dihydrosanguinarine 10-monooxygenase activity",
  "GO:0047089": "dihydrochelirubine 12-monooxygenase activity",
  "GO:0047090": "benzoyl-CoA 3-monooxygenase activity",
  "GO:0047091": "L-lysine 6-monooxygenase (NADPH) activity",
  "GO:0047092": "27-hydroxycholesterol 7-alpha-monooxygenase activity",
  "GO:0047093": "4-hydroxyquinoline 3-monooxygenase activity",
  "GO:0047094": "3-hydroxyphenylacetate 6-hydroxylase activity",
  "GO:0047095": "2-hydroxycyclohexanone 2-monooxygenase activity",
  "GO:0047096": "androst-4-ene-3,17-dione monooxygenase activity",
  "GO:0047097": "phylloquinone monooxygenase (2,3-epoxidizing) activity",
  "GO:0047098": "Latia-luciferin monooxygenase (demethylating) activity",
  "GO:0047099": "CDP-4-dehydro-6-deoxyglucose reductase activity",
  "GO:0047100": "glyceraldehyde-3-phosphate dehydrogenase (NADP+) (phosphorylating) activity",
  "GO:0047101": "2-oxoisovalerate dehydrogenase (acylating) activity",
  "GO:0047102": "aminomuconate-semialdehyde dehydrogenase activity",
  "GO:0047103": "3-alpha,7-alpha,12-alpha-trihydroxycholestan-26-al 26-oxidoreductase activity",
  "GO:0047104": "hexadecanal dehydrogenase (acylating) activity",
  "GO:0047105": "4-trimethylammoniobutyraldehyde dehydrogenase activity",
  "GO:0047106": "4-hydroxyphenylacetaldehyde dehydrogenase activity",
  "GO:0047107": "gamma-guanidinobutyraldehyde dehydrogenase activity",
  "GO:0047108": "(R)-3-hydroxyacid-ester dehydrogenase activity",
  "GO:0047109": "(S)-3-hydroxyacid-ester dehydrogenase activity",
  "GO:0047110": "phenylglyoxylate dehydrogenase (acylating) activity",
  "GO:0047111": "formate dehydrogenase (cytochrome-c-553) activity",
  "GO:0047112": "pyruvate oxidase activity",
  "GO:0047113": "aldehyde dehydrogenase (pyrroloquinoline-quinone) activity",
  "GO:0047114": "kynurenate-7,8-dihydrodiol dehydrogenase activity",
  "GO:0047115": "trans-1,2-dihydrobenzene-1,2-diol dehydrogenase activity",
  "GO:0047116": "1,6-dihydroxycyclohexa-2,4-diene-1-carboxylate dehydrogenase activity",
  "GO:0047117": "enoyl-[acyl-carrier-protein] reductase (NADPH, A-specific) activity",
  "GO:0047118": "2-hydroxy-6-oxo-6-phenylhexa-2,4-dienoate reductase activity",
  "GO:0047119": "2-methyl-branched-chain-enoyl-CoA reductase activity",
  "GO:0047120": "(3S,4R)-3,4-dihydroxycyclohexa-1,5-diene-1,4-dicarboxylate dehydrogenase activity",
  "GO:0047121": "isoquinoline 1-oxidoreductase activity",
  "GO:0047122": "quinaldate 4-oxidoreductase activity",
  "GO:0047123": "quinoline-4-carboxylate 2-oxidoreductase activity",
  "GO:0047124": "L-erythro-3,5-diaminohexanoate dehydrogenase activity",
  "GO:0047125": "delta1-piperideine-2-carboxylate reductase activity",
  "GO:0047126": "N5-(carboxyethyl)ornithine synthase activity",
  "GO:0047127": "thiomorpholine-carboxylate dehydrogenase activity",
  "GO:0047128": "1,2-dehydroreticulinium reductase (NADPH) activity",
  "GO:0047129": "opine dehydrogenase activity",
  "GO:0047130": "saccharopine dehydrogenase (NADP+, L-lysine-forming) activity",
  "GO:0047131": "saccharopine dehydrogenase (NAD+, L-glutamate-forming) activity",
  "GO:0047132": "dihydrobenzophenanthridine oxidase activity",
  "GO:0047133": "dimethylamine dehydrogenase activity",
  "GO:0047134": "protein-disulfide reductase activity",
  "GO:0047135": "bis-gamma-glutamylcystine reductase activity",
  "GO:0047136": "4-(dimethylamino)phenylazoxybenzene reductase activity",
  "GO:0047137": "N-hydroxy-2-acetamidofluorene reductase activity",
  "GO:0047138": "aquacobalamin reductase activity",
  "GO:0047139": "glutathione-homocystine transhydrogenase activity",
  "GO:0047140": "glutathione-CoA-glutathione transhydrogenase activity",
  "GO:0047141": "glutathione-cystine transhydrogenase activity",
  "GO:0047142": "enzyme-thiol transhydrogenase (glutathione-disulfide) activity",
  "GO:0047143": "chlorate reductase activity",
  "GO:0047144": "2-acylglycerol-3-phosphate O-acyltransferase activity",
  "GO:0047145": "demethylsterigmatocystin 6-O-methyltransferase activity",
  "GO:0047146": "sterigmatocystin 7-O-methyltransferase activity",
  "GO:0047147": "trimethylsulfonium-tetrahydrofolate N-methyltransferase activity",
  "GO:0047148": "methylamine-glutamate N-methyltransferase activity",
  "GO:0047149": "thetin-homocysteine S-methyltransferase activity",
  "GO:0047150": "betaine-homocysteine S-methyltransferase activity",
  "GO:0047151": "methylenetetrahydrofolate-tRNA-(uracil-5-)-methyltransferase (FADH2-oxidizing) activity",
  "GO:0047152": "methanol-5-hydroxybenzimidazolylcobamide Co-methyltransferase activity",
  "GO:0047153": "deoxycytidylate 5-hydroxymethyltransferase activity",
  "GO:0047154": "methylmalonyl-CoA carboxytransferase activity",
  "GO:0047155": "3-hydroxymethylcephem carbamoyltransferase activity",
  "GO:0047156": "acetoin-ribose-5-phosphate transaldolase activity",
  "GO:0047157": "myelin-proteolipid O-palmitoyltransferase activity",
  "GO:0047158": "sinapoylglucose-sinapoylglucose O-sinapoyltransferase activity",
  "GO:0047159": "1-alkenylglycerophosphocholine O-acyltransferase activity",
  "GO:0047160": "alkylglycerophosphate 2-O-acetyltransferase activity",
  "GO:0047161": "tartronate O-hydroxycinnamoyltransferase activity",
  "GO:0047162": "17-O-deacetylvindoline O-acetyltransferase activity",
  "GO:0047163": "3,4-dichloroaniline N-malonyltransferase activity",
  "GO:0047164": "isoflavone-7-O-beta-glucoside 6''-O-malonyltransferase activity",
  "GO:0047165": "flavonol-3-O-beta-glucoside O-malonyltransferase activity",
  "GO:0047166": "1-alkenylglycerophosphoethanolamine O-acyltransferase activity",
  "GO:0047167": "1-alkyl-2-acetylglycerol O-acyltransferase activity",
  "GO:0047168": "isocitrate O-dihydroxycinnamoyltransferase activity",
  "GO:0047169": "galactarate O-hydroxycinnamoyltransferase activity",
  "GO:0047170": "glucarate O-hydroxycinnamoyltransferase activity",
  "GO:0047171": "glucarolactone O-hydroxycinnamoyltransferase activity",
  "GO:0047172": "shikimate O-hydroxycinnamoyltransferase activity",
  "GO:0047173": "phosphatidylcholine-retinol O-acyltransferase activity",
  "GO:0047174": "putrescine N-hydroxycinnamoyltransferase activity",
  "GO:0047175": "galactosylacylglycerol O-acyltransferase activity",
  "GO:0047176": "beta-glucogallin-tetrakisgalloylglucose O-galloyltransferase activity",
  "GO:0047177": "glycerophospholipid arachidonoyl-transferase (CoA-independent) activity",
  "GO:0047178": "glycerophospholipid acyltransferase (CoA-dependent) activity",
  "GO:0047179": "platelet-activating factor acetyltransferase activity",
  "GO:0047180": "salutaridinol 7-O-acetyltransferase activity",
  "GO:0047181": "benzophenone synthase activity",
  "GO:0047182": "alcohol O-cinnamoyltransferase activity",
  "GO:0047183": "anthocyanin 5-aromatic acyltransferase activity",
  "GO:0047184": "1-acylglycerophosphocholine O-acyltransferase activity",
  "GO:0047185": "N-acetylneuraminate 4-O-acetyltransferase activity",
  "GO:0047186": "N-acetylneuraminate 7-O(or 9-O)-acetyltransferase activity",
  "GO:0047187": "deacetyl-[citrate-(pro-3S)-lyase] S-acetyltransferase activity",
  "GO:0047188": "aromatic-hydroxylamine O-acetyltransferase activity",
  "GO:0047189": "2,3-diaminopropionate N-oxalyltransferase activity",
  "GO:0047190": "2-acylglycerophosphocholine O-acyltransferase activity",
  "GO:0047191": "1-alkylglycerophosphocholine O-acyltransferase activity",
  "GO:0047192": "1-alkylglycerophosphocholine O-acetyltransferase activity",
  "GO:0047193": "obsolete CDP-acylglycerol O-arachidonoyltransferase activity",
  "GO:0047194": "indoleacetylglucose-inositol O-acyltransferase activity",
  "GO:0047195": "diacylglycerol-sterol O-acyltransferase activity",
  "GO:0047196": "long-chain-alcohol O-fatty-acyltransferase activity",
  "GO:0047197": "triglyceride-sterol O-acyltransferase activity",
  "GO:0047198": "cysteine-S-conjugate N-acetyltransferase activity",
  "GO:0047199": "phosphatidylcholine-dolichol O-acyltransferase activity",
  "GO:0047200": "tetrahydrodipicolinate N-acetyltransferase activity",
  "GO:0047201": "beta-glucogallin O-galloyltransferase activity",
  "GO:0047202": "sinapoylglucose-choline O-sinapoyltransferase activity",
  "GO:0047203": "13-hydroxylupinine O-tigloyltransferase activity",
  "GO:0047204": "chlorogenate-glucarate O-hydroxycinnamoyltransferase activity",
  "GO:0047205": "quinate O-hydroxycinnamoyltransferase activity",
  "GO:0047206": "UDP-N-acetylmuramoylpentapeptide-lysine N6-alanyltransferase activity",
  "GO:0047207": "1,2-beta-fructan 1F-fructosyltransferase activity",
  "GO:0047208": "o-dihydroxycoumarin 7-O-glucosyltransferase activity",
  "GO:0047209": "coniferyl-alcohol glucosyltransferase activity",
  "GO:0047211": "alpha-1,4-glucan-protein synthase (ADP-forming) activity",
  "GO:0047212": "2-coumarate O-beta-glucosyltransferase activity",
  "GO:0047213": "anthocyanidin 3-O-glucosyltransferase activity",
  "GO:0047214": "cyanidin-3-rhamnosylglucoside 5-O-glucosyltransferase activity",
  "GO:0047215": "indole-3-acetate beta-glucosyltransferase activity",
  "GO:0047216": "inositol 3-alpha-galactosyltransferase activity",
  "GO:0047217": "sucrose-1,6-alpha-glucan 3(6)-alpha-glucosyltransferase activity",
  "GO:0047218": "hydroxycinnamate 4-beta-glucosyltransferase activity",
  "GO:0047219": "monoterpenol beta-glucosyltransferase activity",
  "GO:0047220": "galactosylxylosylprotein 3-beta-galactosyltransferase activity",
  "GO:0047221": "sn-glycerol-3-phosphate 2-alpha-galactosyltransferase activity",
  "GO:0047222": "mannotetraose 2-alpha-N-acetylglucosaminyltransferase activity",
  "GO:0047223": "beta-1,3-galactosyl-O-glycosyl-glycoprotein beta-1,3-N-acetylglucosaminyltransferase activity",
  "GO:0047224": "acetylgalactosaminyl-O-glycosyl-glycoprotein beta-1,3-N-acetylglucosaminyltransferase activity",
  "GO:0047225": "acetylgalactosaminyl-O-glycosyl-glycoprotein beta-1,6-N-acetylglucosaminyltransferase activity",
  "GO:0047227": "indolylacetyl-myo-inositol galactosyltransferase activity",
  "GO:0047228": "1,2-diacylglycerol 3-glucosyltransferase activity",
  "GO:0047229": "13-hydroxydocosanoate 13-beta-glucosyltransferase activity",
  "GO:0047230": "flavonol-3-O-glucoside L-rhamnosyltransferase activity",
  "GO:0047231": "pyridoxine 5'-O-beta-D-glucosyltransferase activity",
  "GO:0047232": "galactosyl-N-acetylglucosaminylgalactosylglucosyl-ceramide beta-1,6-N-acetylglucosaminyltransferase activity",
  "GO:0047233": "N-acetylneuraminylgalactosylglucosylceramide beta-1,4-N-acetylgalactosaminyltransferase activity",
  "GO:0047234": "raffinose-raffinose alpha-galactotransferase activity",
  "GO:0047235": "sucrose 6F-alpha-galactotransferase activity",
  "GO:0047236": "methyl-ONN-azoxymethanol beta-D-glucosyltransferase activity",
  "GO:0047237": "glucuronylgalactosylproteoglycan 4-beta-N-acetylgalactosaminyltransferase activity",
  "GO:0047238": "glucuronosyl-N-acetylgalactosaminyl-proteoglycan 4-beta-N-acetylgalactosaminyltransferase activity",
  "GO:0047239": "hydroxymandelonitrile glucosyltransferase activity",
  "GO:0047240": "lactosylceramide beta-1,3-galactosyltransferase activity",
  "GO:0047241": "lipopolysaccharide N-acetylmannosaminouronosyltransferase activity",
  "GO:0047242": "hydroxyanthraquinone glucosyltransferase activity",
  "GO:0047243": "flavanone 7-O-beta-glucosyltransferase activity",
  "GO:0047244": "N-acetylglucosaminyldiphosphoundecaprenol N-acetyl-beta-D-mannosaminyltransferase activity",
  "GO:0047245": "N-acetylglucosaminyldiphosphoundecaprenol glucosyltransferase activity",
  "GO:0047246": "luteolin-7-O-glucuronide 7-O-glucuronosyltransferase activity",
  "GO:0047247": "luteolin-7-O-diglucuronide 4'-O-glucuronosyltransferase activity",
  "GO:0047248": "nuatigenin 3-beta-glucosyltransferase activity",
  "GO:0047249": "sarsapogenin 3-beta-glucosyltransferase activity",
  "GO:0047250": "4-hydroxybenzoate 4-O-beta-D-glucosyltransferase activity",
  "GO:0047251": "thiohydroximate beta-D-glucosyltransferase activity",
  "GO:0047252": "beta-mannosylphosphodecaprenol-mannooligosaccharide 6-mannosyltransferase activity",
  "GO:0047253": "alpha-1,6-mannosylglycoprotein 4-beta-N-acetylglucosaminyltransferase activity",
  "GO:0047254": "2,4-dihydroxy-7-methoxy-2H-1,4-benzoxazin-3(4H)-one 2-D-glucosyltransferase activity",
  "GO:0047255": "galactogen 6-beta-galactosyltransferase activity",
  "GO:0047256": "lactosylceramide 1,3-N-acetyl-beta-D-glucosaminyltransferase activity",
  "GO:0047257": "diglucosyl diacylglycerol synthase activity",
  "GO:0047258": "sphingosine beta-galactosyltransferase activity",
  "GO:0047259": "glucomannan 4-beta-mannosyltransferase activity",
  "GO:0047260": "alpha,alpha-trehalose-phosphate synthase (GDP-forming) activity",
  "GO:0047261": "steroid N-acetylglucosaminyltransferase activity",
  "GO:0047262": "polygalacturonate 4-alpha-galacturonosyltransferase activity",
  "GO:0047263": "N-acylsphingosine galactosyltransferase activity",
  "GO:0047264": "heteroglycan alpha-mannosyltransferase activity",
  "GO:0047265": "poly(glycerol-phosphate) alpha-glucosyltransferase activity",
  "GO:0047266": "poly(ribitol-phosphate) beta-glucosyltransferase activity",
  "GO:0047267": "undecaprenyl-phosphate mannosyltransferase activity",
  "GO:0047268": "galactinol-raffinose galactosyltransferase activity",
  "GO:0047269": "poly(ribitol-phosphate) N-acetylglucosaminyltransferase activity",
  "GO:0047270": "lipopolysaccharide glucosyltransferase II activity",
  "GO:0047271": "glycosaminoglycan galactosyltransferase activity",
  "GO:0047272": "phosphopolyprenol glucosyltransferase activity",
  "GO:0047273": "galactosylgalactosylglucosylceramide beta-D-acetylgalactosaminyltransferase activity",
  "GO:0047274": "galactinol-sucrose galactosyltransferase activity",
  "GO:0047275": "glucosaminylgalactosylglucosylceramide beta-galactosyltransferase activity",
  "GO:0047276": "N-acetyllactosaminide 3-alpha-galactosyltransferase activity",
  "GO:0047277": "globoside alpha-N-acetylgalactosaminyltransferase activity",
  "GO:0047278": "bilirubin-glucuronoside glucuronosyltransferase activity",
  "GO:0047279": "sn-glycerol-3-phosphate 1-galactosyltransferase activity",
  "GO:0047280": "nicotinamide phosphoribosyltransferase activity",
  "GO:0047281": "dioxotetrahydropyrimidine phosphoribosyltransferase activity",
  "GO:0047282": "dTDP-dihydrostreptose-streptidine-6-phosphate dihydrostreptosyltransferase activity",
  "GO:0047283": "dolichyl-phosphate D-xylosyltransferase activity",
  "GO:0047284": "dolichyl-xylosyl-phosphate-protein xylosyltransferase activity",
  "GO:0047285": "flavonol-3-O-glycoside xylosyltransferase activity",
  "GO:0047286": "NAD+-diphthamide ADP-ribosyltransferase activity",
  "GO:0047287": "lactosylceramide alpha-2,6-N-sialyltransferase activity",
  "GO:0047288": "monosialoganglioside sialyltransferase activity",
  "GO:0047289": "galactosyldiacylglycerol alpha-2,3-sialyltransferase activity",
  "GO:0047290": "(alpha-N-acetylneuraminyl-2,3-beta-galactosyl-1,3)-N-acetyl-galactosaminide 6-alpha-sialyltransferase activity",
  "GO:0047291": "lactosylceramide alpha-2,3-sialyltransferase activity",
  "GO:0047292": "trihydroxypterocarpan dimethylallyltransferase activity",
  "GO:0047293": "4-hydroxybenzoate nonaprenyltransferase activity",
  "GO:0047294": "phosphoglycerol geranylgeranyltransferase activity",
  "GO:0047295": "geranylgeranylglycerol-phosphate geranylgeranyltransferase activity",
  "GO:0047296": "homospermidine synthase activity",
  "GO:0047297": "asparagine-oxo-acid transaminase activity",
  "GO:0047298": "(S)-3-amino-2-methylpropionate transaminase activity",
  "GO:0047299": "tryptophan-phenylpyruvate transaminase activity",
  "GO:0047300": "pyridoxamine-pyruvate transaminase activity",
  "GO:0047301": "valine-3-methyl-2-oxovalerate transaminase activity",
  "GO:0047302": "UDP-2-acetamido-4-amino-2,4,6-trideoxyglucose transaminase activity",
  "GO:0047303": "glycine-oxaloacetate transaminase activity",
  "GO:0047304": "2-aminoethylphosphonate-pyruvate transaminase activity",
  "GO:0047305": "(R)-3-amino-2-methylpropionate-pyruvate transaminase activity",
  "GO:0047306": "D-methionine-pyruvate transaminase activity",
  "GO:0047307": "diaminobutyrate-pyruvate transaminase activity",
  "GO:0047308": "alanine-oxomalonate transaminase activity",
  "GO:0047309": "dihydroxyphenylalanine transaminase activity",
  "GO:0047310": "glutamine-scyllo-inositol transaminase activity",
  "GO:0047311": "1D-1-guanidino-3-amino-1,3-dideoxy-scyllo-inositol transaminase activity",
  "GO:0047312": "L-phenylalanine:pyruvate aminotransferase activity",
  "GO:0047313": "aromatic-amino-acid-glyoxylate transaminase activity",
  "GO:0047315": "kynurenine-glyoxylate transaminase activity",
  "GO:0047316": "glutamine-phenylpyruvate transaminase activity",
  "GO:0047317": "N6-acetyl-beta-lysine transaminase activity",
  "GO:0047319": "aspartate-phenylpyruvate transaminase activity",
  "GO:0047320": "D-4-hydroxyphenylglycine transaminase activity",
  "GO:0047321": "diphosphate-protein phosphotransferase activity",
  "GO:0047322": "[hydroxymethylglutaryl-CoA reductase (NADPH)] kinase activity",
  "GO:0047323": "[3-methyl-2-oxobutanoate dehydrogenase (acetyl-transferring)] kinase activity",
  "GO:0047324": "phosphoenolpyruvate-glycerone phosphotransferase activity",
  "GO:0047325": "inositol tetrakisphosphate 1-kinase activity",
  "GO:0047326": "inositol tetrakisphosphate 5-kinase activity",
  "GO:0047327": "glycerol-3-phosphate-glucose phosphotransferase activity",
  "GO:0047328": "acyl-phosphate-hexose phosphotransferase activity",
  "GO:0047329": "phosphoramidate-hexose phosphotransferase activity",
  "GO:0047330": "polyphosphate-glucose phosphotransferase activity",
  "GO:0047331": "diphosphate-glycerol phosphotransferase activity",
  "GO:0047332": "diphosphate-serine phosphotransferase activity",
  "GO:0047333": "dihydrostreptomycin-6-phosphate 3'-alpha-kinase activity",
  "GO:0047334": "diphosphate-fructose-6-phosphate 1-phosphotransferase activity",
  "GO:0047335": "3-phosphoglyceroyl-phosphate-polyphosphate phosphotransferase activity",
  "GO:0047336": "5-methyldeoxycytidine-5'-phosphate kinase activity",
  "GO:0047337": "dolichyl-diphosphate-polyphosphate phosphotransferase activity",
  "GO:0047338": "UTP:xylose-1-phosphate uridylyltransferase activity",
  "GO:0047339": "nucleoside-triphosphate-hexose-1-phosphate nucleotidyltransferase activity",
  "GO:0047341": "fucose-1-phosphate guanylyltransferase activity",
  "GO:0047342": "galactose-1-phosphate thymidylyltransferase activity",
  "GO:0047343": "glucose-1-phosphate cytidylyltransferase activity",
  "GO:0047344": "glucose-1-phosphate guanylyltransferase activity",
  "GO:0047345": "ribose-5-phosphate adenylyltransferase activity",
  "GO:0047346": "aldose-1-phosphate adenylyltransferase activity",
  "GO:0047347": "aldose-1-phosphate nucleotidyltransferase activity",
  "GO:0047348": "glycerol-3-phosphate cytidylyltransferase activity",
  "GO:0047349": "D-ribitol-5-phosphate cytidylyltransferase activity",
  "GO:0047350": "glucuronate-1-phosphate uridylyltransferase activity",
  "GO:0047351": "guanosine-triphosphate guanylyltransferase activity",
  "GO:0047352": "adenylylsulfate-ammonia adenylyltransferase activity",
  "GO:0047353": "N-methylphosphoethanolamine cytidylyltransferase activity",
  "GO:0047354": "sphingosine cholinephosphotransferase activity",
  "GO:0047355": "CDP-glycerol glycerophosphotransferase activity",
  "GO:0047356": "CDP-ribitol ribitolphosphotransferase activity",
  "GO:0047357": "UDP-galactose-UDP-N-acetylglucosamine galactose phosphotransferase activity",
  "GO:0047358": "UDP-glucose-glycoprotein glucose phosphotransferase activity",
  "GO:0047359": "1-alkenyl-2-acylglycerol choline phosphotransferase activity",
  "GO:0047360": "undecaprenyl-phosphate galactose phosphotransferase activity",
  "GO:0047361": "phosphomannan mannosephosphotransferase activity",
  "GO:0047362": "thiosulfate-dithiol sulfurtransferase activity",
  "GO:0047363": "triglucosylalkylacylglycerol sulfotransferase activity",
  "GO:0047364": "desulfoglucosinolate sulfotransferase activity",
  "GO:0047365": "quercetin-3-sulfate 3'-sulfotransferase activity",
  "GO:0047366": "quercetin-3-sulfate 4'-sulfotransferase activity",
  "GO:0047367": "quercetin-3,3'-bissulfate 7-sulfotransferase activity",
  "GO:0047368": "UDP-N-acetylgalactosamine-4-sulfate sulfotransferase activity",
  "GO:0047369": "succinate-hydroxymethylglutarate CoA-transferase activity",
  "GO:0047370": "succinate-citramalate CoA-transferase activity",
  "GO:0047371": "butyrate-acetoacetate CoA-transferase activity",
  "GO:0047372": "acylglycerol lipase activity",
  "GO:0047373": "acetoxybutynylbithiophene deacetylase activity",
  "GO:0047374": "methylumbelliferyl-acetate deacetylase activity",
  "GO:0047375": "N-acetylgalactosaminoglycan deacetylase activity",
  "GO:0047376": "all-trans-retinyl-palmitate hydrolase, all-trans-retinol forming activity",
  "GO:0047377": "5-(3,4-diacetoxybut-1-ynyl)-2,2'-bithiophene deacetylase activity",
  "GO:0047378": "acetylalkylglycerol acetylhydrolase activity",
  "GO:0047379": "ADP-dependent short-chain-acyl-CoA hydrolase activity",
  "GO:0047380": "ADP-dependent medium-chain-acyl-CoA hydrolase activity",
  "GO:0047381": "dodecanoyl-[acyl-carrier-protein] hydrolase activity",
  "GO:0047382": "methylphosphothioglycerate phosphatase activity",
  "GO:0047383": "guanidinodeoxy-scyllo-inositol-4-phosphatase activity",
  "GO:0047384": "[hydroxymethylglutaryl-CoA reductase (NADPH)]-phosphatase activity",
  "GO:0047385": "[3-methyl-2-oxobutanoate dehydrogenase (lipoamide)]-phosphatase activity",
  "GO:0047386": "fructose-2,6-bisphosphate 6-phosphatase activity",
  "GO:0047387": "serine-ethanolaminephosphate phosphodiesterase activity",
  "GO:0047388": "adenylyl-[glutamate-ammonia ligase] hydrolase activity",
  "GO:0047389": "glycerophosphocholine phosphodiesterase activity",
  "GO:0047390": "glycerophosphocholine cholinephosphodiesterase activity",
  "GO:0047391": "alkylglycerophosphoethanolamine phosphodiesterase activity",
  "GO:0047392": "CMP-N-acylneuraminate phosphodiesterase activity",
  "GO:0047393": "glycerol-1,2-cyclic-phosphate 2-phosphodiesterase activity",
  "GO:0047394": "glycerophosphoinositol inositolphosphodiesterase activity",
  "GO:0047395": "glycerophosphoinositol glycerophosphodiesterase activity",
  "GO:0047396": "glycosylphosphatidylinositol diacylglycerol-lyase activity",
  "GO:0047397": "dolichylphosphate-glucose phosphodiesterase activity",
  "GO:0047398": "dolichylphosphate-mannose phosphodiesterase activity",
  "GO:0047399": "glucose-1-phospho-D-mannosylglycoprotein phosphodiesterase activity",
  "GO:0047400": "phosphonoacetate hydrolase activity",
  "GO:0047401": "trithionate hydrolase activity",
  "GO:0047402": "protein-glucosylgalactosylhydroxylysine glucosidase activity",
  "GO:0047403": "lacto-N-biosidase activity",
  "GO:0047404": "glucuronosyl-disulfoglucosamine glucuronidase activity",
  "GO:0047405": "pyrimidine-5'-nucleotide nucleosidase activity",
  "GO:0047406": "beta-aspartyl-N-acetylglucosaminidase activity",
  "GO:0047407": "ADP-ribosyl-[dinitrogen reductase] hydrolase activity",
  "GO:0047408": "alkenylglycerophosphocholine hydrolase activity",
  "GO:0047409": "alkenylglycerophosphoethanolamine hydrolase activity",
  "GO:0047410": "N-formylmethionylaminoacyl-tRNA deformylase activity",
  "GO:0047411": "2-(acetamidomethylene)succinate hydrolase activity",
  "GO:0047412": "N-(long-chain-acyl)ethanolamine deacylase activity",
  "GO:0047413": "N(alpha)-benzyloxycarbonylleucine hydrolase activity",
  "GO:0047414": "2-(hydroxymethyl)-3-(acetamidomethylene)succinate hydrolase activity",
  "GO:0047415": "D-benzoylarginine-4-nitroanilide amidase activity",
  "GO:0047416": "arylalkyl acylamidase activity",
  "GO:0047417": "N-carbamoyl-D-amino acid hydrolase activity",
  "GO:0047418": "phthalyl amidase activity",
  "GO:0047419": "N-acetylgalactosamine-6-phosphate deacetylase activity",
  "GO:0047420": "N-acyl-D-amino-acid deacylase activity",
  "GO:0047421": "N-acyl-D-glutamate deacylase activity",
  "GO:0047422": "N-acyl-D-aspartate deacylase activity",
  "GO:0047423": "N-methylhydantoinase (ATP-hydrolyzing) activity",
  "GO:0047424": "methylenediurea deaminase activity",
  "GO:0047425": "1-pyrroline-4-hydroxy-2-carboxylate deaminase activity",
  "GO:0047426": "ricinine nitrilase activity",
  "GO:0047427": "cyanoalanine nitrilase activity",
  "GO:0047428": "arylacetonitrilase activity",
  "GO:0047429": "nucleoside-triphosphate diphosphatase activity",
  "GO:0047430": "oligosaccharide-diphosphodolichol diphosphatase activity",
  "GO:0047431": "3-hydroxy-2-methylpyridine-4,5-dicarboxylate 4-decarboxylase activity",
  "GO:0047432": "2,2-dialkylglycine decarboxylase (pyruvate) activity",
  "GO:0047433": "branched-chain-2-oxoacid decarboxylase activity",
  "GO:0047434": "indolepyruvate decarboxylase activity",
  "GO:0047435": "5-guanidino-2-oxopentanoate decarboxylase activity",
  "GO:0047436": "arylmalonate decarboxylase activity",
  "GO:0047437": "4-oxalocrotonate decarboxylase activity",
  "GO:0047438": "2-dehydro-3-deoxy-L-pentonate aldolase activity",
  "GO:0047439": "3-deoxy-D-manno-octulosonate aldolase activity",
  "GO:0047440": "2-dehydro-3-deoxy-D-pentonate aldolase activity",
  "GO:0047441": "5-dehydro-2-deoxyphosphogluconate aldolase activity",
  "GO:0047442": "17-alpha-hydroxyprogesterone aldolase activity",
  "GO:0047443": "4-hydroxy-4-methyl-2-oxoglutarate aldolase activity",
  "GO:0047444": "N-acylneuraminate-9-phosphate synthase activity",
  "GO:0047445": "3-hydroxy-3-isohexenylglutaryl-CoA lyase activity",
  "GO:0047446": "(1-hydroxycyclohexan-1-yl)acetyl-CoA lyase activity",
  "GO:0047447": "erythro-3-hydroxyaspartate ammonia-lyase activity",
  "GO:0047448": "5-dehydro-4-deoxyglucarate dehydratase activity",
  "GO:0047449": "2-dehydro-3-deoxy-L-arabinonate dehydratase activity",
  "GO:0047450": "crotonoyl-[acyl-carrier-protein] hydratase activity",
  "GO:0047451": "3-hydroxyoctanoyl-[acyl-carrier-protein] dehydratase activity",
  "GO:0047452": "protoaphin-aglucone dehydratase (cyclizing) activity",
  "GO:0047453": "ATP-dependent NAD(P)H-hydrate dehydratase activity",
  "GO:0047454": "phaseollidin hydratase activity",
  "GO:0047455": "16-alpha-hydroxyprogesterone dehydratase activity",
  "GO:0047456": "2-methylisocitrate dehydratase activity",
  "GO:0047457": "exo-(1,4)-alpha-D-glucan lyase activity",
  "GO:0047458": "beta-pyrazolylalanine synthase activity",
  "GO:0047459": "3-aminobutyryl-CoA ammonia-lyase activity",
  "GO:0047460": "L-2-amino-4-chloropent-4-enoate dehydrochlorinase activity",
  "GO:0047461": "(+)-delta-cadinene synthase activity",
  "GO:0047462": "phenylalanine racemase (ATP-hydrolyzing) activity",
  "GO:0047463": "2-aminohexano-6-lactam racemase activity",
  "GO:0047464": "heparosan-N-sulfate-glucuronate 5-epimerase activity",
  "GO:0047465": "N-acylglucosamine-6-phosphate 2-epimerase activity",
  "GO:0047466": "2-chloro-4-carboxymethylenebut-2-en-1,4-olide isomerase activity",
  "GO:0047467": "4-hydroxyphenylacetaldehyde-oxime isomerase activity",
  "GO:0047468": "phosphoglucomutase (glucose-cofactor) activity",
  "GO:0047469": "4-carboxymethyl-4-methylbutenolide mutase activity",
  "GO:0047470": "(1,4)-alpha-D-glucan 1-alpha-D-glucosylmutase activity",
  "GO:0047471": "maltose alpha-D-glucosyltransferase activity",
  "GO:0047472": "3-carboxy-cis,cis-muconate cycloisomerase activity",
  "GO:0047473": "D-alanine-poly(phosphoribitol) ligase activity",
  "GO:0047474": "long-chain fatty acid luciferin component ligase activity",
  "GO:0047475": "phenylacetate-CoA ligase activity",
  "GO:0047476": "3-alpha,7-alpha-dihydroxy-5-beta-cholestanate-CoA ligase activity",
  "GO:0047478": "aspartate-ammonia ligase (ADP-forming) activity",
  "GO:0047479": "trypanothione synthase activity",
  "GO:0047480": "UDP-N-acetylmuramoyl-tripeptide-D-alanyl-D-alanine ligase activity",
  "GO:0047481": "D-alanine-alanyl-poly(glycerolphosphate) ligase activity",
  "GO:0047482": "UDP-N-acetylmuramoyl-L-alanyl-D-glutamate-L-lysine ligase activity",
  "GO:0047483": "imidazoleacetate-phosphoribosyldiphosphate ligase activity",
  "GO:0047484": "regulation of response to osmotic stress",
  "GO:0047485": "protein N-terminus binding",
  "GO:0047486": "chondroitin ABC lyase activity",
  "GO:0047487": "oligogalacturonide lyase activity",
  "GO:0047488": "heparin lyase activity",
  "GO:0047489": "pectate disaccharide-lyase activity",
  "GO:0047490": "pectin lyase activity",
  "GO:0047491": "poly(alpha-L-guluronate) lyase activity",
  "GO:0047492": "xanthan lyase activity",
  "GO:0047493": "ceramide cholinephosphotransferase activity",
  "GO:0047494": "serine-phosphoethanolamine synthase activity",
  "GO:0047495": "membrane-oligosaccharide glycerophosphotransferase activity",
  "GO:0047496": "vesicle transport along microtubule",
  "GO:0047497": "mitochondrion transport along microtubule",
  "GO:0047498": "calcium-dependent phospholipase A2 activity",
  "GO:0047499": "calcium-independent phospholipase A2 activity",
  "GO:0047500": "(+)-borneol dehydrogenase activity",
  "GO:0047501": "(+)-neomenthol dehydrogenase activity",
  "GO:0047502": "(+)-sabinol dehydrogenase activity",
  "GO:0047503": "(-)-borneol dehydrogenase activity",
  "GO:0047504": "(-)-menthol dehydrogenase activity",
  "GO:0047505": "(-)-menthol monooxygenase activity",
  "GO:0047506": "(deoxy)adenylate kinase activity",
  "GO:0047507": "(deoxy)nucleoside-phosphate kinase activity",
  "GO:0047508": "(R)-2-methylmalate dehydratase activity",
  "GO:0047509": "(R)-dehydropantoate dehydrogenase activity",
  "GO:0047510": "(S)-2-methylmalate dehydratase activity",
  "GO:0047511": "(S)-methylmalonyl-CoA hydrolase activity",
  "GO:0047512": "(S,S)-butanediol dehydrogenase activity",
  "GO:0047513": "1,2-alpha-L-fucosidase activity",
  "GO:0047514": "1,3-beta-D-glucan phosphorylase activity",
  "GO:0047515": "1,3-beta-oligoglucan phosphorylase activity",
  "GO:0047516": "1,3-propanediol dehydrogenase activity",
  "GO:0047517": "1,4-beta-D-xylan synthase activity",
  "GO:0047518": "1-methyladenosine nucleosidase activity",
  "GO:0047519": "quinate dehydrogenase (quinone) activity",
  "GO:0047520": "11-cis-retinyl-palmitate hydrolase activity",
  "GO:0047521": "3alpha,7alpha,12beta-trihydroxy-5beta-cholanate dehydrogenase activity",
  "GO:0047522": "15-oxoprostaglandin 13-oxidase activity",
  "GO:0047524": "16-hydroxysteroid epimerase activity",
  "GO:0047525": "2'-hydroxydaidzein reductase activity",
  "GO:0047526": "2'-hydroxyisoflavone reductase activity",
  "GO:0047527": "2,3-dihydroxybenzoate-serine ligase activity",
  "GO:0047528": "2,3-dihydroxyindole 2,3-dioxygenase activity",
  "GO:0047529": "2,3-dimethylmalate lyase activity",
  "GO:0047530": "2,4-diaminopentanoate dehydrogenase activity",
  "GO:0047531": "2,5-diaminovalerate transaminase activity",
  "GO:0047532": "2,5-dioxopiperazine hydrolase activity",
  "GO:0047533": "2,5-dioxovalerate dehydrogenase (NADP+) activity",
  "GO:0047534": "2-acetolactate mutase activity",
  "GO:0047535": "2-alkyn-1-ol dehydrogenase activity",
  "GO:0047536": "2-aminoadipate transaminase activity",
  "GO:0047537": "2-aminohexanoate transaminase activity",
  "GO:0047538": "2-carboxy-D-arabinitol-1-phosphatase activity",
  "GO:0047539": "2-deoxyglucosidase activity",
  "GO:0047540": "2-enoate reductase activity",
  "GO:0047541": "2-furoate-CoA ligase activity",
  "GO:0047542": "2-furoyl-CoA dehydrogenase activity",
  "GO:0047543": "2-hexadecenal reductase activity",
  "GO:0047544": "2-hydroxybiphenyl 3-monooxygenase activity",
  "GO:0047545": "2-hydroxyglutarate dehydrogenase activity",
  "GO:0047546": "2-hydroxypyridine 5-monooxygenase activity",
  "GO:0047547": "2-methylcitrate dehydratase activity",
  "GO:0047548": "2-methyleneglutarate mutase activity",
  "GO:0047549": "2-nitrophenol 2-monooxygenase activity",
  "GO:0047550": "2-oxoadipate reductase activity",
  "GO:0047551": "2-oxoaldehyde dehydrogenase (NAD) activity",
  "GO:0047552": "2-oxoaldehyde dehydrogenase (NADP+) activity",
  "GO:0047553": "2-oxoglutarate synthase activity",
  "GO:0047554": "2-pyrone-4,6-dicarboxylate lactonase activity",
  "GO:0047555": "3',5'-cyclic-GMP phosphodiesterase activity",
  "GO:0047556": "3,4-dihydroxyphthalate decarboxylase activity",
  "GO:0047557": "3-aci-nitropropanoate oxidase activity",
  "GO:0047558": "3-cyanoalanine hydratase activity",
  "GO:0047559": "3-dehydro-L-gulonate 2-dehydrogenase activity",
  "GO:0047560": "3-dehydrosphinganine reductase activity",
  "GO:0047561": "3-hydroxyanthranilate oxidase activity",
  "GO:0047562": "3-hydroxyaspartate aldolase activity",
  "GO:0047563": "3-hydroxybenzoate 2-monooxygenase activity",
  "GO:0047564": "3-hydroxycyclohexanone dehydrogenase activity",
  "GO:0047565": "3-hydroxypropionate dehydrogenase (NAD+) activity",
  "GO:0047566": "3-ketovalidoxylamine C-N-lyase activity",
  "GO:0047567": "3-methyleneoxindole reductase activity",
  "GO:0047568": "3-oxo-5-beta-steroid 4-dehydrogenase activity",
  "GO:0047569": "3-oxoadipate CoA-transferase activity",
  "GO:0047570": "3-oxoadipate enol-lactonase activity",
  "GO:0047571": "3-oxosteroid 1-dehydrogenase activity",
  "GO:0047572": "3-phosphoglycerate phosphatase activity",
  "GO:0047573": "4-acetamidobutyrate deacetylase activity",
  "GO:0047574": "4-acetamidobutyryl-CoA deacetylase activity",
  "GO:0047575": "4-carboxymuconolactone decarboxylase activity",
  "GO:0047576": "4-chlorobenzoate dehalogenase activity",
  "GO:0047577": "4-hydroxybutyrate dehydrogenase activity",
  "GO:0047578": "4-hydroxyglutamate transaminase activity",
  "GO:0047579": "4-hydroxymandelate oxidase activity",
  "GO:0047580": "4-hydroxyproline epimerase activity",
  "GO:0047581": "4-methyleneglutamate-ammonia ligase activity",
  "GO:0047582": "4-methyleneglutaminase activity",
  "GO:0047583": "4-methyloxaloacetate esterase activity",
  "GO:0047584": "4-oxalmesaconate hydratase activity",
  "GO:0047585": "4-pyridoxolactonase activity",
  "GO:0047586": "5'-acylphosphoadenosine hydrolase activity",
  "GO:0047587": "5-alpha-hydroxysteroid dehydratase activity",
  "GO:0047588": "5-aminopentanamidase activity",
  "GO:0047589": "5-aminovalerate transaminase activity",
  "GO:0047590": "5-dehydro-2-deoxygluconokinase activity",
  "GO:0047591": "5-hydroxypentanoate CoA-transferase activity",
  "GO:0047592": "5-pyridoxate dioxygenase activity",
  "GO:0047593": "6-acetylglucose deacetylase activity",
  "GO:0047594": "6-beta-hydroxyhyoscyamine epoxidase activity",
  "GO:0047595": "6-hydroxynicotinate reductase activity",
  "GO:0047596": "6-methylsalicylate decarboxylase activity",
  "GO:0047597": "6-oxocineole dehydrogenase activity",
  "GO:0047598": "7-dehydrocholesterol reductase activity",
  "GO:0047599": "8-oxocoformycin reductase activity",
  "GO:0047600": "abequosyltransferase activity",
  "GO:0047601": "acetate kinase (diphosphate) activity",
  "GO:0047602": "acetoacetate decarboxylase activity",
  "GO:0047603": "acetoacetyl-CoA hydrolase activity",
  "GO:0047604": "acetoin racemase activity",
  "GO:0047605": "acetolactate decarboxylase activity",
  "GO:0047606": "hydroxynitrilase activity",
  "GO:0047608": "acetylindoxyl oxidase activity",
  "GO:0047609": "acetylputrescine deacetylase activity",
  "GO:0047610": "acetylsalicylate deacetylase activity",
  "GO:0047611": "acetylspermidine deacetylase activity",
  "GO:0047612": "acid-CoA ligase (GDP-forming) activity",
  "GO:0047613": "aconitate decarboxylase activity",
  "GO:0047614": "aconitate delta-isomerase activity",
  "GO:0047615": "actinomycin lactonase activity",
  "GO:0047616": "acyl-CoA dehydrogenase (NADP+) activity",
  "GO:0047617": "acyl-CoA hydrolase activity",
  "GO:0047618": "acylagmatine amidase activity",
  "GO:0047619": "acylcarnitine hydrolase activity",
  "GO:0047620": "acylglycerol kinase activity",
  "GO:0047621": "acylpyruvate hydrolase activity",
  "GO:0047622": "adenosine nucleosidase activity",
  "GO:0047623": "adenosine-phosphate deaminase activity",
  "GO:0047624": "adenosine-tetraphosphatase activity",
  "GO:0047625": "adenosylmethionine cyclotransferase activity",
  "GO:0047626": "adenosylmethionine hydrolase activity",
  "GO:0047627": "adenylylsulfatase activity",
  "GO:0047628": "ADP-thymidine kinase activity",
  "GO:0047629": "ADP deaminase activity",
  "GO:0047630": "ADP-phosphoglycerate phosphatase activity",
  "GO:0047631": "ADP-ribose diphosphatase activity",
  "GO:0047632": "agmatine deiminase activity",
  "GO:0047633": "agmatine kinase activity",
  "GO:0047634": "agmatine N4-coumaroyltransferase activity",
  "GO:0047635": "alanine-oxo-acid transaminase activity",
  "GO:0047636": "alanopine dehydrogenase activity",
  "GO:0047637": "alanylphosphatidylglycerol synthase activity",
  "GO:0047638": "albendazole monooxygenase activity",
  "GO:0047639": "alcohol oxidase activity",
  "GO:0047640": "aldose 1-dehydrogenase activity",
  "GO:0047641": "aldose-6-phosphate reductase (NADPH) activity",
  "GO:0047642": "aldose beta-D-fructosyltransferase activity",
  "GO:0047643": "alginate synthase activity",
  "GO:0047644": "alizarin 2-beta-glucosyltransferase activity",
  "GO:0047645": "alkan-1-ol dehydrogenase (acceptor) activity",
  "GO:0047646": "alkanal monooxygenase (FMN-linked) activity",
  "GO:0047647": "alkylacetylglycerophosphatase activity",
  "GO:0047648": "alkylamidase activity",
  "GO:0047649": "alkylglycerol kinase activity",
  "GO:0047650": "alkylglycerone kinase activity",
  "GO:0047651": "alkylhalidase activity",
  "GO:0047652": "allantoate deiminase activity",
  "GO:0047653": "allantoin racemase activity",
  "GO:0047654": "alliin lyase activity",
  "GO:0047655": "allyl-alcohol dehydrogenase activity",
  "GO:0047656": "alpha,alpha-trehalose phosphorylase activity",
  "GO:0047657": "alpha-1,3-glucan synthase activity",
  "GO:0047658": "alpha-amino-acid esterase activity",
  "GO:0047659": "alpha-santonin 1,2-reductase activity",
  "GO:0047660": "amidinoaspartase activity",
  "GO:0047661": "amino-acid racemase activity",
  "GO:0047662": "aminobenzoate decarboxylase activity",
  "GO:0047663": "aminoglycoside 6'-N-acetyltransferase activity",
  "GO:0047664": "aminoimidazolase activity",
  "GO:0047665": "aminolevulinate transaminase activity",
  "GO:0047666": "ammonia kinase activity",
  "GO:0047667": "AMP-thymidine kinase activity",
  "GO:0047668": "amygdalin beta-glucosidase activity",
  "GO:0047669": "amylosucrase activity",
  "GO:0047670": "anhydrotetracycline monooxygenase activity",
  "GO:0047671": "anthranilate adenylyltransferase activity",
  "GO:0047672": "anthranilate N-benzoyltransferase activity",
  "GO:0047673": "anthranilate N-malonyltransferase activity",
  "GO:0047674": "apiose 1-reductase activity",
  "GO:0047675": "arabinonate dehydratase activity",
  "GO:0047676": "arachidonate-CoA ligase activity",
  "GO:0047677": "arachidonate 8(R)-lipoxygenase activity",
  "GO:0047678": "arginine 2-monooxygenase activity",
  "GO:0047679": "arginine racemase activity",
  "GO:0047680": "aryl-acylamidase activity",
  "GO:0047681": "aryl-alcohol dehydrogenase (NADP+) activity",
  "GO:0047682": "aryl-alcohol oxidase activity",
  "GO:0047683": "aryl-aldehyde dehydrogenase (NADP+) activity",
  "GO:0047684": "arylamine glucosyltransferase activity",
  "GO:0047685": "amine sulfotransferase activity",
  "GO:0047686": "arylsulfate sulfotransferase activity",
  "GO:0047687": "obsolete ascorbate 2,3-dioxygenase activity",
  "GO:0047688": "aspartate 4-decarboxylase activity",
  "GO:0047689": "aspartate racemase activity",
  "GO:0047690": "aspartyltransferase activity",
  "GO:0047691": "aspulvinone dimethylallyltransferase activity",
  "GO:0047692": "ATP deaminase activity",
  "GO:0047693": "ATP diphosphatase activity",
  "GO:0047694": "barbiturase activity",
  "GO:0047695": "benzoin aldolase activity",
  "GO:0047696": "beta-adrenergic receptor kinase activity",
  "GO:0047697": "beta-alanopine dehydrogenase activity",
  "GO:0047698": "beta-alanyl-CoA ammonia-lyase activity",
  "GO:0047699": "beta-diketone hydrolase activity",
  "GO:0047700": "beta-glucoside kinase activity",
  "GO:0047701": "beta-L-arabinosidase activity",
  "GO:0047702": "beta-lysine 5,6-aminomutase activity",
  "GO:0047703": "beta-nitroacrylate reductase activity",
  "GO:0047704": "bile-salt sulfotransferase activity",
  "GO:0047705": "bilirubin oxidase activity",
  "GO:0047706": "biochanin-A reductase activity",
  "GO:0047707": "biotin-CoA ligase activity",
  "GO:0047708": "biotinidase activity",
  "GO:0047709": "bis(2-ethylhexyl)phthalate esterase activity",
  "GO:0047710": "bis(5'-adenosyl)-triphosphatase activity",
  "GO:0047711": "blasticidin-S deaminase activity",
  "GO:0047712": "Cypridina-luciferin 2-monooxygenase activity",
  "GO:0047713": "galactitol 2-dehydrogenase activity",
  "GO:0047714": "galactolipase activity",
  "GO:0047715": "hypotaurocyamine kinase activity",
  "GO:0047716": "imidazole N-acetyltransferase activity",
  "GO:0047717": "imidazoleacetate 4-monooxygenase activity",
  "GO:0047718": "indanol dehydrogenase activity",
  "GO:0047719": "indole 2,3-dioxygenase activity",
  "GO:0047720": "indoleacetaldoxime dehydratase activity",
  "GO:0047721": "indoleacetate-lysine synthetase activity",
  "GO:0047722": "indolelactate dehydrogenase activity",
  "GO:0047723": "inosinate nucleosidase activity",
  "GO:0047724": "inosine nucleosidase activity",
  "GO:0047725": "inulosucrase activity",
  "GO:0047726": "iron-cytochrome-c reductase activity",
  "GO:0047727": "isobutyryl-CoA mutase activity",
  "GO:0047728": "carnitine 3-dehydrogenase activity",
  "GO:0047729": "carnitine decarboxylase activity",
  "GO:0047730": "carnosine synthase activity",
  "GO:0047731": "catechol oxidase (dimerizing) activity",
  "GO:0047732": "CDP-abequose epimerase activity",
  "GO:0047733": "CDP-glucose 4,6-dehydratase activity",
  "GO:0047734": "CDP-glycerol diphosphatase activity",
  "GO:0047735": "cellobiose dehydrogenase (acceptor) activity",
  "GO:0047736": "cellobiose epimerase activity",
  "GO:0047738": "cellobiose phosphorylase activity",
  "GO:0047739": "cephalosporin-C deacetylase activity",
  "GO:0047740": "cephalosporin-C transaminase activity",
  "GO:0047741": "cetraxate benzylesterase activity",
  "GO:0047742": "chenodeoxycholoyltaurine hydrolase activity",
  "GO:0047743": "chlordecone reductase activity",
  "GO:0047744": "chloridazon-catechol dioxygenase activity",
  "GO:0047745": "chlorogenate hydrolase activity",
  "GO:0047746": "chlorophyllase activity",
  "GO:0047747": "cholate-CoA ligase activity",
  "GO:0047748": "cholestanetetraol 26-dehydrogenase activity",
  "GO:0047749": "cholestanetriol 26-monooxygenase activity",
  "GO:0047750": "cholestenol delta-isomerase activity",
  "GO:0047751": "cholestenone 5-alpha-reductase activity",
  "GO:0047753": "choline-sulfatase activity",
  "GO:0047754": "choline sulfotransferase activity",
  "GO:0047755": "isocitrate epimerase activity",
  "GO:0047756": "chondroitin 4-sulfotransferase activity",
  "GO:0047757": "chondroitin-glucuronate 5-epimerase activity",
  "GO:0047758": "ATP:2-methylpropanoate phosphotransferase activity",
  "GO:0047759": "butanal dehydrogenase activity",
  "GO:0047760": "butyrate-CoA ligase activity",
  "GO:0047761": "butyrate kinase activity",
  "GO:0047762": "caffeate 3,4-dioxygenase activity",
  "GO:0047763": "caffeate O-methyltransferase activity",
  "GO:0047764": "caldesmon kinase activity",
  "GO:0047765": "caldesmon-phosphatase activity",
  "GO:0047766": "carbamoyl-serine ammonia-lyase activity",
  "GO:0047768": "carboxy-cis,cis-muconate cyclase activity",
  "GO:0047769": "arogenate dehydratase activity",
  "GO:0047770": "carboxylate reductase activity",
  "GO:0047771": "carboxymethylhydantoinase activity",
  "GO:0047772": "carboxymethyloxysuccinate lyase activity",
  "GO:0047773": "carnitinamidase activity",
  "GO:0047774": "cis-2-enoyl-CoA reductase (NADPH) activity",
  "GO:0047775": "citramalate CoA-transferase activity",
  "GO:0047776": "citramalate lyase activity",
  "GO:0047777": "(3S)-citramalyl-CoA lyase activity",
  "GO:0047778": "[citrate-(pro-3S)-lyase] thiolesterase activity",
  "GO:0047779": "citrate-CoA ligase activity",
  "GO:0047780": "citrate dehydratase activity",
  "GO:0047781": "citrullinase activity",
  "GO:0047782": "coniferin beta-glucosidase activity",
  "GO:0047783": "corticosterone 18-monooxygenase activity",
  "GO:0047784": "cortisol O-acetyltransferase activity",
  "GO:0047785": "cortisol sulfotransferase activity",
  "GO:0047786": "cortisone alpha-reductase activity",
  "GO:0047787": "delta4-3-oxosteroid 5beta-reductase activity",
  "GO:0047788": "2-coumarate reductase activity",
  "GO:0047789": "creatininase activity",
  "GO:0047790": "creatinine deaminase activity",
  "GO:0047791": "cucurbitacin delta23-reductase activity",
  "GO:0047792": "cyanohydrin beta-glucosyltransferase activity",
  "GO:0047793": "cycloeucalenol cycloisomerase activity",
  "GO:0047794": "cyclohexadienyl dehydrogenase activity",
  "GO:0047795": "cyclohexane-1,2-diol dehydrogenase activity",
  "GO:0047796": "cyclohexane-1,3-dione hydrolase activity",
  "GO:0047797": "cyclohexanone dehydrogenase activity",
  "GO:0047798": "cyclomaltodextrinase activity",
  "GO:0047799": "cyclopentanone monooxygenase activity",
  "GO:0047800": "cysteamine dioxygenase activity",
  "GO:0047801": "L-cysteine:2-oxoglutarate aminotransferase activity",
  "GO:0047802": "cysteine-conjugate transaminase activity",
  "GO:0047803": "cysteine lyase activity",
  "GO:0047804": "cysteine-S-conjugate beta-lyase activity",
  "GO:0047805": "cytidylate cyclase activity",
  "GO:0047806": "cytochrome-c3 hydrogenase activity",
  "GO:0047807": "cytokinin 7-beta-glucosyltransferase activity",
  "GO:0047808": "D(-)-tartrate dehydratase activity",
  "GO:0047809": "D-2-hydroxy-acid dehydrogenase activity",
  "GO:0047810": "D-alanine:2-oxoglutarate aminotransferase activity",
  "GO:0047811": "D-alanine gamma-glutamyltransferase activity",
  "GO:0047812": "D-amino-acid N-acetyltransferase activity",
  "GO:0047813": "D-arabinitol 4-dehydrogenase activity",
  "GO:0047814": "D-arabinokinase activity",
  "GO:0047815": "D-arabinonolactonase activity",
  "GO:0047816": "D-arabinose 1-dehydrogenase (NAD) activity",
  "GO:0047817": "D-arginase activity",
  "GO:0047818": "D-fuconate dehydratase activity",
  "GO:0047819": "D-glutamate(D-aspartate) oxidase activity",
  "GO:0047820": "D-glutamate cyclase activity",
  "GO:0047821": "D-glutamate oxidase activity",
  "GO:0047822": "hypotaurine dehydrogenase activity",
  "GO:0047823": "D-glutamyltransferase activity",
  "GO:0047824": "D-iditol 2-dehydrogenase activity",
  "GO:0047825": "D-lactate-2-sulfatase activity",
  "GO:0047826": "D-lysine 5,6-aminomutase activity",
  "GO:0047827": "D-lysopine dehydrogenase activity",
  "GO:0047828": "D-lyxose ketol-isomerase activity",
  "GO:0047829": "D-nopaline dehydrogenase activity",
  "GO:0047830": "D-octopine dehydrogenase activity",
  "GO:0047831": "D-ornithine 4,5-aminomutase activity",
  "GO:0047832": "D-pinitol dehydrogenase activity",
  "GO:0047833": "D-sorbitol dehydrogenase (acceptor) activity",
  "GO:0047834": "D-threo-aldose 1-dehydrogenase activity",
  "GO:0047835": "D-tryptophan N-acetyltransferase activity",
  "GO:0047836": "D-tryptophan N-malonyltransferase activity",
  "GO:0047837": "D-xylose 1-dehydrogenase (NADP+) activity",
  "GO:0047838": "D-xylose 1-dehydrogenase (NAD) activity",
  "GO:0047839": "dATP(dGTP)-DNA purinetransferase activity",
  "GO:0047840": "dCTP diphosphatase activity",
  "GO:0047841": "dehydrogluconokinase activity",
  "GO:0047842": "dehydro-L-gulonate decarboxylase activity",
  "GO:0047843": "dehydrogluconate dehydrogenase activity",
  "GO:0047844": "deoxycytidine deaminase activity",
  "GO:0047845": "deoxylimonate A-ring-lactonase activity",
  "GO:0047846": "deoxynucleotide 3'-phosphatase activity",
  "GO:0047847": "deoxyuridine phosphorylase activity",
  "GO:0047848": "dephospho-[reductase kinase] kinase activity",
  "GO:0047849": "dextransucrase activity",
  "GO:0047850": "diaminopimelate dehydrogenase activity",
  "GO:0047851": "dicarboxylate-CoA ligase activity",
  "GO:0047852": "diferric-transferrin reductase activity",
  "GO:0047853": "difructose-anhydride synthase activity",
  "GO:0047854": "diguanidinobutanase activity",
  "GO:0047855": "dihydrobunolol dehydrogenase activity",
  "GO:0047856": "dihydrocoumarin hydrolase activity",
  "GO:0047857": "dihydrouracil oxidase activity",
  "GO:0047858": "dihydroxyfumarate decarboxylase activity",
  "GO:0047859": "obsolete dihydroxyphenylalanine ammonia-lyase activity",
  "GO:0047860": "diiodophenylpyruvate reductase activity",
  "GO:0047861": "diiodotyrosine transaminase activity",
  "GO:0047862": "diisopropyl-fluorophosphatase activity",
  "GO:0047863": "dimethylallylcistransferase activity",
  "GO:0047864": "dimethylaniline-N-oxide aldolase activity",
  "GO:0047865": "dimethylglycine dehydrogenase activity",
  "GO:0047866": "dimethylglycine oxidase activity",
  "GO:0047867": "dimethylmalate dehydrogenase activity",
  "GO:0047868": "dimethylmaleate hydratase activity",
  "GO:0047869": "dimethylpropiothetin dethiomethylase activity",
  "GO:0047870": "discadenine synthase activity",
  "GO:0047871": "disulfoglucosamine-6-sulfatase activity",
  "GO:0047872": "dolichol O-acyltransferase activity",
  "GO:0047873": "dolichyl-phosphatase activity",
  "GO:0047874": "dolichyldiphosphatase activity",
  "GO:0047875": "ecdysone oxidase activity",
  "GO:0047876": "endoglycosylceramidase activity",
  "GO:0047877": "ephedrine dehydrogenase activity",
  "GO:0047878": "erythritol kinase activity",
  "GO:0047879": "erythronolide synthase activity",
  "GO:0047880": "erythrulose reductase activity",
  "GO:0047881": "estradiol 17-alpha-dehydrogenase activity",
  "GO:0047882": "estradiol 6-beta-monooxygenase activity",
  "GO:0047883": "ethanolamine oxidase activity",
  "GO:0047884": "FAD diphosphatase activity",
  "GO:0047885": "farnesol 2-isomerase activity",
  "GO:0047886": "farnesol dehydrogenase activity",
  "GO:0047887": "farnesyl diphosphate kinase activity",
  "GO:0047888": "fatty acid peroxidase activity",
  "GO:0047889": "ferredoxin-nitrate reductase activity",
  "GO:0047890": "flavanone 4-reductase activity",
  "GO:0047891": "flavone 7-O-beta-glucosyltransferase activity",
  "GO:0047892": "flavone apiosyltransferase activity",
  "GO:0047893": "flavonol 3-O-glucosyltransferase activity",
  "GO:0047894": "flavonol 3-sulfotransferase activity",
  "GO:0047895": "formaldehyde dismutase activity",
  "GO:0047896": "formaldehyde transketolase activity",
  "GO:0047897": "formate-dihydrofolate ligase activity",
  "GO:0047898": "formate dehydrogenase (cytochrome) activity",
  "GO:0047899": "formate dehydrogenase (NADP+) activity",
  "GO:0047900": "formate kinase activity",
  "GO:0047901": "formyl-CoA hydrolase activity",
  "GO:0047902": "formylaspartate deformylase activity",
  "GO:0047903": "fructose 5-dehydrogenase (NADP+) activity",
  "GO:0047904": "fructose 5-dehydrogenase activity",
  "GO:0047905": "fructose-6-phosphate phosphoketolase activity",
  "GO:0047906": "fucosterol-epoxide lyase activity",
  "GO:0047907": "furylfuramide isomerase activity",
  "GO:0047908": "fusarinine-C ornithinesterase activity",
  "GO:0047909": "galactolipid O-acyltransferase activity",
  "GO:0047910": "galactose 1-dehydrogenase (NADP+) activity",
  "GO:0047911": "galacturan 1,4-alpha-galacturonidase activity",
  "GO:0047912": "galacturonokinase activity",
  "GO:0047913": "gallate 1-beta-glucosyltransferase activity",
  "GO:0047914": "gamma-glutamylhistamine synthase activity",
  "GO:0047915": "ganglioside galactosyltransferase activity",
  "GO:0047916": "GDP-6-deoxy-D-talose 4-dehydrogenase activity",
  "GO:0047917": "GDP-glucosidase activity",
  "GO:0047918": "GDP-mannose 3,5-epimerase activity",
  "GO:0047919": "GDP-mannose 6-dehydrogenase activity",
  "GO:0047920": "geissoschizine dehydrogenase activity",
  "GO:0047921": "aminoglycoside 2'-N-acetyltransferase activity",
  "GO:0047922": "gentisate 1,2-dioxygenase activity",
  "GO:0047923": "gentisate decarboxylase activity",
  "GO:0047924": "geraniol dehydrogenase activity",
  "GO:0047925": "geranoyl-CoA carboxylase activity",
  "GO:0047926": "geranyl-diphosphate cyclase activity",
  "GO:0047927": "gibberellin-44 dioxygenase activity",
  "GO:0047928": "gibberellin beta-D-glucosyltransferase activity",
  "GO:0047929": "gluconate dehydratase activity",
  "GO:0047930": "glucosaminate ammonia-lyase activity",
  "GO:0047931": "glucosamine kinase activity",
  "GO:0047932": "glucosamine N-acetyltransferase activity",
  "GO:0047933": "glucose-1,6-bisphosphate synthase activity",
  "GO:0047934": "glucose 1-dehydrogenase (NAD+) activity",
  "GO:0047935": "glucose 1-dehydrogenase (NADP+) activity",
  "GO:0047936": "glucose 1-dehydrogenase [NAD(P)] activity",
  "GO:0047937": "glucose-1-phosphate phosphodismutase activity",
  "GO:0047938": "glucose-6-phosphate 1-epimerase activity",
  "GO:0047939": "L-glucuronate reductase activity",
  "GO:0047940": "glucuronokinase activity",
  "GO:0047941": "glucuronolactone reductase activity",
  "GO:0047942": "glutamate-ethylamine ligase activity",
  "GO:0047943": "glutamate-methylamine ligase activity",
  "GO:0047944": "glutamate 1-kinase activity",
  "GO:0047945": "L-glutamine:pyruvate aminotransferase activity",
  "GO:0047946": "glutamine N-acyltransferase activity",
  "GO:0047947": "glutamine N-phenylacetyltransferase activity",
  "GO:0047948": "glutarate-CoA ligase activity",
  "GO:0047949": "glutarate-semialdehyde dehydrogenase activity",
  "GO:0047950": "glutathione oxidase activity",
  "GO:0047951": "glutathione thiolesterase activity",
  "GO:0047952": "glycerol-3-phosphate dehydrogenase [NAD(P)+] activity",
  "GO:0047953": "glycerol 2-dehydrogenase (NADP+) activity",
  "GO:0047954": "glycerol-2-phosphatase activity",
  "GO:0047955": "glycerol dehydrogenase (acceptor) activity",
  "GO:0047956": "glycerol dehydrogenase [NADP+] activity",
  "GO:0047957": "4'-methoxyisoflavone 2'-hydroxylase activity",
  "GO:0047958": "glycine:2-oxoglutarate aminotransferase activity",
  "GO:0047959": "glycine dehydrogenase (cytochrome) activity",
  "GO:0047960": "glycine dehydrogenase activity",
  "GO:0047961": "glycine N-acyltransferase activity",
  "GO:0047962": "glycine N-benzoyltransferase activity",
  "GO:0047963": "glycine N-choloyltransferase activity",
  "GO:0047964": "glyoxylate reductase activity",
  "GO:0047965": "glycoprotein O-fatty-acyltransferase activity",
  "GO:0047966": "glycosulfatase activity",
  "GO:0047967": "glycyrrhizinate beta-glucuronidase activity",
  "GO:0047968": "glyoxylate dehydrogenase (acylating) activity",
  "GO:0047969": "glyoxylate oxidase activity",
  "GO:0047970": "guanidinoacetase activity",
  "GO:0047971": "guanidinobutyrase activity",
  "GO:0047972": "guanidinopropionase activity",
  "GO:0047973": "guanidinoacetate kinase activity",
  "GO:0047974": "guanosine deaminase activity",
  "GO:0047975": "guanosine phosphorylase activity",
  "GO:0047976": "hamamelose kinase activity",
  "GO:0047977": "hepoxilin-epoxide hydrolase activity",
  "GO:0047978": "hexadecanol dehydrogenase activity",
  "GO:0047979": "hexose oxidase activity",
  "GO:0047980": "hippurate hydrolase activity",
  "GO:0047981": "histidine N-acetyltransferase activity",
  "GO:0047982": "homocysteine desulfhydrase activity",
  "GO:0047983": "homoglutathione synthase activity",
  "GO:0047985": "hydrogen dehydrogenase activity",
  "GO:0047986": "hydrogen-sulfide S-acetyltransferase activity",
  "GO:0047987": "hydroperoxide dehydratase activity",
  "GO:0047988": "hydroxyacid-oxoacid transhydrogenase activity",
  "GO:0047989": "hydroxybutyrate-dimer hydrolase activity",
  "GO:0047990": "hydroxyglutamate decarboxylase activity",
  "GO:0047991": "hydroxylamine oxidase activity",
  "GO:0047992": "hydroxylysine kinase activity",
  "GO:0047993": "hydroxymalonate dehydrogenase activity",
  "GO:0047994": "hydroxymethylglutaryl-CoA hydrolase activity",
  "GO:0047995": "hydroxyphenylpyruvate reductase activity",
  "GO:0047996": "hydroxyphytanate oxidase activity",
  "GO:0047997": "hydroxypyruvate decarboxylase activity",
  "GO:0047998": "hyoscyamine (6S)-dioxygenase activity",
  "GO:0047999": "hyponitrite reductase activity",
  "GO:0048000": "isoflavone 3'-hydroxylase activity",
  "GO:0048001": "erythrose-4-phosphate dehydrogenase activity",
  "GO:0048002": "antigen processing and presentation of peptide antigen",
  "GO:0048003": "antigen processing and presentation of lipid antigen via MHC class Ib",
  "GO:0048006": "antigen processing and presentation, endogenous lipid antigen via MHC class Ib",
  "GO:0048007": "antigen processing and presentation, exogenous lipid antigen via MHC class Ib",
  "GO:0048008": "platelet-derived growth factor receptor signaling pathway",
  "GO:0048009": "insulin-like growth factor receptor signaling pathway",
  "GO:0048010": "vascular endothelial growth factor receptor signaling pathway",
  "GO:0048011": "neurotrophin TRK receptor signaling pathway",
  "GO:0048012": "hepatocyte growth factor receptor signaling pathway",
  "GO:0048013": "ephrin receptor signaling pathway",
  "GO:0048014": "Tie signaling pathway",
  "GO:0048015": "phosphatidylinositol-mediated signaling",
  "GO:0048016": "inositol phosphate-mediated signaling",
  "GO:0048017": "inositol lipid-mediated signaling",
  "GO:0048018": "receptor agonist activity",
  "GO:0048019": "receptor antagonist activity",
  "GO:0048020": "CCR chemokine receptor binding",
  "GO:0048021": "regulation of melanin biosynthetic process",
  "GO:0048022": "negative regulation of melanin biosynthetic process",
  "GO:0048023": "positive regulation of melanin biosynthetic process",
  "GO:0048024": "regulation of mRNA splicing, via spliceosome",
  "GO:0048025": "negative regulation of mRNA splicing, via spliceosome",
  "GO:0048026": "positive regulation of mRNA splicing, via spliceosome",
  "GO:0048027": "mRNA 5'-UTR binding",
  "GO:0048028": "galacturonan binding",
  "GO:0048029": "monosaccharide binding",
  "GO:0048030": "disaccharide binding",
  "GO:0048031": "trisaccharide binding",
  "GO:0048032": "galacturonate binding",
  "GO:0048033": "heme o metabolic process",
  "GO:0048034": "heme O biosynthetic process",
  "GO:0048035": "heme o catabolic process",
  "GO:0048036": "central complex development",
  "GO:0048037": "cofactor binding",
  "GO:0048038": "quinone binding",
  "GO:0048039": "ubiquinone binding",
  "GO:0048040": "UDP-glucuronate decarboxylase activity",
  "GO:0048041": "focal adhesion assembly",
  "GO:0048042": "regulation of post-mating oviposition",
  "GO:0048045": "trans-pentaprenyltranstransferase activity",
  "GO:0048046": "apoplast",
  "GO:0048047": "mating behavior, sex discrimination",
  "GO:0048048": "embryonic eye morphogenesis",
  "GO:0048050": "post-embryonic eye morphogenesis",
  "GO:0048052": "R1/R6 cell differentiation",
  "GO:0048053": "R1/R6 development",
  "GO:0048054": "R2/R5 cell differentiation",
  "GO:0048055": "R2/R5 development",
  "GO:0048056": "R3/R4 cell differentiation",
  "GO:0048057": "R3/R4 development",
  "GO:0048058": "compound eye corneal lens development",
  "GO:0048060": "negative gravitaxis",
  "GO:0048061": "positive gravitaxis",
  "GO:0048065": "male courtship behavior, veined wing extension",
  "GO:0048066": "developmental pigmentation",
  "GO:0048067": "cuticle pigmentation",
  "GO:0048069": "eye pigmentation",
  "GO:0048070": "regulation of developmental pigmentation",
  "GO:0048071": "sex-specific pigmentation",
  "GO:0048072": "compound eye pigmentation",
  "GO:0048073": "regulation of eye pigmentation",
  "GO:0048074": "negative regulation of eye pigmentation",
  "GO:0048075": "positive regulation of eye pigmentation",
  "GO:0048076": "regulation of compound eye pigmentation",
  "GO:0048077": "negative regulation of compound eye pigmentation",
  "GO:0048078": "positive regulation of compound eye pigmentation",
  "GO:0048079": "regulation of cuticle pigmentation",
  "GO:0048080": "negative regulation of cuticle pigmentation",
  "GO:0048081": "positive regulation of cuticle pigmentation",
  "GO:0048082": "regulation of adult chitin-containing cuticle pigmentation",
  "GO:0048083": "negative regulation of adult chitin-containing cuticle pigmentation",
  "GO:0048084": "positive regulation of adult chitin-containing cuticle pigmentation",
  "GO:0048085": "adult chitin-containing cuticle pigmentation",
  "GO:0048086": "negative regulation of developmental pigmentation",
  "GO:0048087": "positive regulation of developmental pigmentation",
  "GO:0048088": "regulation of male pigmentation",
  "GO:0048089": "regulation of female pigmentation",
  "GO:0048090": "negative regulation of female pigmentation",
  "GO:0048091": "positive regulation of female pigmentation",
  "GO:0048092": "negative regulation of male pigmentation",
  "GO:0048093": "positive regulation of male pigmentation",
  "GO:0048094": "male pigmentation",
  "GO:0048095": "female pigmentation",
  "GO:0048096": "chromatin-mediated maintenance of transcription",
  "GO:0048097": "long-term maintenance of gene activation",
  "GO:0048098": "antennal joint development",
  "GO:0048099": "anterior/posterior lineage restriction, imaginal disc",
  "GO:0048100": "wing disc anterior/posterior pattern formation",
  "GO:0048101": "calcium- and calmodulin-regulated 3',5'-cyclic-GMP phosphodiesterase activity",
  "GO:0048102": "autophagic cell death",
  "GO:0048103": "somatic stem cell division",
  "GO:0048104": "establishment of body hair or bristle planar orientation",
  "GO:0048105": "establishment of body hair planar orientation",
  "GO:0048106": "establishment of thoracic bristle planar orientation",
  "GO:0048107": "4-amino-3-isothiazolidinone biosynthetic process",
  "GO:0048108": "peptide cross-linking via 4-amino-3-isothiazolidinone",
  "GO:0048109": "peptide cross-linking via 2-amino-3-isothiazolidinone-L-serine",
  "GO:0048132": "female germ-line stem cell asymmetric division",
  "GO:0048133": "male germ-line stem cell asymmetric division",
  "GO:0048134": "germ-line cyst formation",
  "GO:0048135": "female germ-line cyst formation",
  "GO:0048136": "male germ-line cyst formation",
  "GO:0048137": "spermatocyte division",
  "GO:0048138": "germ-line cyst encapsulation",
  "GO:0048139": "female germ-line cyst encapsulation",
  "GO:0048140": "male germ-line cyst encapsulation",
  "GO:0048142": "germarium-derived cystoblast division",
  "GO:0048143": "astrocyte activation",
  "GO:0048144": "fibroblast proliferation",
  "GO:0048145": "regulation of fibroblast proliferation",
  "GO:0048146": "positive regulation of fibroblast proliferation",
  "GO:0048147": "negative regulation of fibroblast proliferation",
  "GO:0048148": "behavioral response to cocaine",
  "GO:0048149": "behavioral response to ethanol",
  "GO:0048150": "behavioral response to ether",
  "GO:0048151": "obsolete hyperphosphorylation",
  "GO:0048152": "S100 beta biosynthetic process",
  "GO:0048153": "S100 alpha biosynthetic process",
  "GO:0048156": "tau protein binding",
  "GO:0048158": "oogonium stage",
  "GO:0048159": "primary oocyte stage",
  "GO:0048160": "primary follicle stage",
  "GO:0048161": "double layer follicle stage",
  "GO:0048162": "multi-layer follicle stage",
  "GO:0048163": "scattered antral spaces stage",
  "GO:0048164": "distinct antral spaces stage",
  "GO:0048165": "fused antrum stage",
  "GO:0048166": "mature follicle stage",
  "GO:0048167": "regulation of synaptic plasticity",
  "GO:0048168": "regulation of neuronal synaptic plasticity",
  "GO:0048169": "regulation of long-term neuronal synaptic plasticity",
  "GO:0048170": "positive regulation of long-term neuronal synaptic plasticity",
  "GO:0048171": "negative regulation of long-term neuronal synaptic plasticity",
  "GO:0048172": "regulation of short-term neuronal synaptic plasticity",
  "GO:0048173": "positive regulation of short-term neuronal synaptic plasticity",
  "GO:0048174": "negative regulation of short-term neuronal synaptic plasticity",
  "GO:0048175": "hepatocyte growth factor biosynthetic process",
  "GO:0048176": "regulation of hepatocyte growth factor biosynthetic process",
  "GO:0048177": "positive regulation of hepatocyte growth factor biosynthetic process",
  "GO:0048178": "negative regulation of hepatocyte growth factor biosynthetic process",
  "GO:0048179": "activin receptor complex",
  "GO:0048180": "activin complex",
  "GO:0048183": "activin AB complex",
  "GO:0048184": "obsolete follistatin binding",
  "GO:0048185": "activin binding",
  "GO:0048188": "Set1C/COMPASS complex",
  "GO:0048189": "Lid2 complex",
  "GO:0048190": "wing disc dorsal/ventral pattern formation",
  "GO:0048191": "obsolete peptide stabilization activity",
  "GO:0048192": "obsolete peptide antigen stabilization activity",
  "GO:0048193": "Golgi vesicle transport",
  "GO:0048194": "Golgi vesicle budding",
  "GO:0048195": "Golgi membrane priming complex assembly",
  "GO:0048196": "obsolete plant extracellular matrix",
  "GO:0048197": "Golgi membrane coat protein complex assembly",
  "GO:0048198": "Golgi vesicle bud deformation and release",
  "GO:0048199": "vesicle targeting, to, from or within Golgi",
  "GO:0048200": "Golgi transport vesicle coating",
  "GO:0048201": "vesicle targeting, plasma membrane to endosome",
  "GO:0048202": "clathrin coating of Golgi vesicle",
  "GO:0048203": "vesicle targeting, trans-Golgi to endosome",
  "GO:0048204": "vesicle targeting, inter-Golgi cisterna",
  "GO:0048205": "COPI coating of Golgi vesicle",
  "GO:0048206": "vesicle targeting, cis-Golgi to rough ER",
  "GO:0048207": "vesicle targeting, rough ER to cis-Golgi",
  "GO:0048208": "COPII vesicle coating",
  "GO:0048209": "regulation of vesicle targeting, to, from or within Golgi",
  "GO:0048210": "Golgi vesicle fusion to target membrane",
  "GO:0048211": "Golgi vesicle docking",
  "GO:0048212": "Golgi vesicle uncoating",
  "GO:0048213": "Golgi vesicle prefusion complex stabilization",
  "GO:0048214": "regulation of Golgi vesicle fusion to target membrane",
  "GO:0048215": "positive regulation of Golgi vesicle fusion to target membrane",
  "GO:0048216": "negative regulation of Golgi vesicle fusion to target membrane",
  "GO:0048217": "pectic matrix",
  "GO:0048219": "inter-Golgi cisterna vesicle-mediated transport",
  "GO:0048222": "glycoprotein network",
  "GO:0048223": "hemicellulose network",
  "GO:0048224": "lignin network",
  "GO:0048225": "suberin network",
  "GO:0048226": "Casparian strip",
  "GO:0048227": "plasma membrane to endosome transport",
  "GO:0048228": "obsolete actin cortical patch distribution",
  "GO:0048229": "gametophyte development",
  "GO:0048232": "male gamete generation",
  "GO:0048235": "pollen sperm cell differentiation",
  "GO:0048236": "plant-type spore development",
  "GO:0048237": "rough endoplasmic reticulum lumen",
  "GO:0048238": "smooth endoplasmic reticulum lumen",
  "GO:0048239": "negative regulation of DNA recombination at telomere",
  "GO:0048240": "sperm capacitation",
  "GO:0048241": "epinephrine transport",
  "GO:0048242": "epinephrine secretion",
  "GO:0048243": "norepinephrine secretion",
  "GO:0048244": "phytanoyl-CoA dioxygenase activity",
  "GO:0048245": "eosinophil chemotaxis",
  "GO:0048246": "macrophage chemotaxis",
  "GO:0048247": "lymphocyte chemotaxis",
  "GO:0048248": "CXCR3 chemokine receptor binding",
  "GO:0048249": "high-affinity phosphate transmembrane transporter activity",
  "GO:0048250": "mitochondrial iron ion transport",
  "GO:0048251": "elastic fiber assembly",
  "GO:0048252": "lauric acid metabolic process",
  "GO:0048254": "snoRNA localization",
  "GO:0048255": "mRNA stabilization",
  "GO:0048256": "flap endonuclease activity",
  "GO:0048257": "3'-flap endonuclease activity",
  "GO:0048258": "3-ketoglucose-reductase activity",
  "GO:0048259": "regulation of receptor-mediated endocytosis",
  "GO:0048260": "positive regulation of receptor-mediated endocytosis",
  "GO:0048261": "negative regulation of receptor-mediated endocytosis",
  "GO:0048262": "determination of dorsal/ventral asymmetry",
  "GO:0048263": "determination of dorsal identity",
  "GO:0048264": "determination of ventral identity",
  "GO:0048265": "response to pain",
  "GO:0048266": "behavioral response to pain",
  "GO:0048268": "clathrin coat assembly",
  "GO:0048269": "methionine adenosyltransferase complex",
  "GO:0048270": "methionine adenosyltransferase regulator activity",
  "GO:0048273": "mitogen-activated protein kinase p38 binding",
  "GO:0048275": "N-terminal peptidyl-arginine acetylation",
  "GO:0048277": "obsolete nonexocytotic vesicle docking",
  "GO:0048278": "vesicle docking",
  "GO:0048279": "vesicle fusion with endoplasmic reticulum",
  "GO:0048280": "vesicle fusion with Golgi apparatus",
  "GO:0048281": "inflorescence morphogenesis",
  "GO:0048282": "determinate inflorescence morphogenesis",
  "GO:0048283": "indeterminate inflorescence morphogenesis",
  "GO:0048284": "organelle fusion",
  "GO:0048285": "organelle fission",
  "GO:0048286": "lung alveolus development",
  "GO:0048288": "nuclear membrane fusion involved in karyogamy",
  "GO:0048289": "isotype switching to IgE isotypes",
  "GO:0048290": "isotype switching to IgA isotypes",
  "GO:0048291": "isotype switching to IgG isotypes",
  "GO:0048292": "isotype switching to IgD isotypes",
  "GO:0048293": "regulation of isotype switching to IgE isotypes",
  "GO:0048294": "negative regulation of isotype switching to IgE isotypes",
  "GO:0048295": "positive regulation of isotype switching to IgE isotypes",
  "GO:0048296": "regulation of isotype switching to IgA isotypes",
  "GO:0048297": "negative regulation of isotype switching to IgA isotypes",
  "GO:0048298": "positive regulation of isotype switching to IgA isotypes",
  "GO:0048299": "regulation of isotype switching to IgD isotypes",
  "GO:0048300": "negative regulation of isotype switching to IgD isotypes",
  "GO:0048301": "positive regulation of isotype switching to IgD isotypes",
  "GO:0048302": "regulation of isotype switching to IgG isotypes",
  "GO:0048303": "negative regulation of isotype switching to IgG isotypes",
  "GO:0048304": "positive regulation of isotype switching to IgG isotypes",
  "GO:0048305": "immunoglobulin secretion",
  "GO:0048306": "calcium-dependent protein binding",
  "GO:0048307": "ferredoxin-nitrite reductase activity",
  "GO:0048308": "organelle inheritance",
  "GO:0048309": "endoplasmic reticulum inheritance",
  "GO:0048310": "nucleus inheritance",
  "GO:0048311": "mitochondrion distribution",
  "GO:0048312": "intracellular distribution of mitochondria",
  "GO:0048313": "Golgi inheritance",
  "GO:0048314": "embryo sac morphogenesis",
  "GO:0048315": "conidium formation",
  "GO:0048316": "seed development",
  "GO:0048317": "seed morphogenesis",
  "GO:0048318": "axial mesoderm development",
  "GO:0048319": "axial mesoderm morphogenesis",
  "GO:0048320": "axial mesoderm formation",
  "GO:0048321": "axial mesodermal cell differentiation",
  "GO:0048322": "axial mesodermal cell fate commitment",
  "GO:0048323": "axial mesodermal cell fate determination",
  "GO:0048324": "regulation of axial mesodermal cell fate determination",
  "GO:0048325": "negative regulation of axial mesodermal cell fate determination",
  "GO:0048326": "positive regulation of axial mesodermal cell fate determination",
  "GO:0048327": "axial mesodermal cell fate specification",
  "GO:0048328": "regulation of axial mesodermal cell fate specification",
  "GO:0048329": "negative regulation of axial mesodermal cell fate specification",
  "GO:0048330": "positive regulation of axial mesodermal cell fate specification",
  "GO:0048331": "axial mesoderm structural organization",
  "GO:0048332": "mesoderm morphogenesis",
  "GO:0048333": "mesodermal cell differentiation",
  "GO:0048334": "regulation of mesodermal cell fate determination",
  "GO:0048335": "negative regulation of mesodermal cell fate determination",
  "GO:0048336": "positive regulation of mesodermal cell fate determination",
  "GO:0048337": "positive regulation of mesodermal cell fate specification",
  "GO:0048338": "mesoderm structural organization",
  "GO:0048339": "paraxial mesoderm development",
  "GO:0048340": "paraxial mesoderm morphogenesis",
  "GO:0048341": "paraxial mesoderm formation",
  "GO:0048342": "paraxial mesodermal cell differentiation",
  "GO:0048343": "paraxial mesodermal cell fate commitment",
  "GO:0048344": "paraxial mesodermal cell fate determination",
  "GO:0048345": "regulation of paraxial mesodermal cell fate determination",
  "GO:0048346": "positive regulation of paraxial mesodermal cell fate determination",
  "GO:0048347": "negative regulation of paraxial mesodermal cell fate determination",
  "GO:0048348": "paraxial mesodermal cell fate specification",
  "GO:0048349": "regulation of paraxial mesodermal cell fate specification",
  "GO:0048350": "positive regulation of paraxial mesodermal cell fate specification",
  "GO:0048351": "negative regulation of paraxial mesodermal cell fate specification",
  "GO:0048352": "paraxial mesoderm structural organization",
  "GO:0048353": "primary endosperm nucleus",
  "GO:0048354": "mucilage biosynthetic process involved in seed coat development",
  "GO:0048355": "root cap mucilage biosynthetic process",
  "GO:0048356": "root epithelial mucilage biosynthetic process",
  "GO:0048357": "pedicel mucilage biosynthetic process",
  "GO:0048358": "mucilage pectin biosynthetic process",
  "GO:0048359": "mucilage metabolic process involved in seed coat development",
  "GO:0048360": "root cap mucilage metabolic process",
  "GO:0048361": "root epithelial mucilage metabolic process",
  "GO:0048362": "pedicel mucilage metabolic process",
  "GO:0048363": "mucilage pectin metabolic process",
  "GO:0048364": "root development",
  "GO:0048365": "Rac GTPase binding",
  "GO:0048366": "leaf development",
  "GO:0048367": "shoot system development",
  "GO:0048368": "lateral mesoderm development",
  "GO:0048369": "lateral mesoderm morphogenesis",
  "GO:0048370": "lateral mesoderm formation",
  "GO:0048371": "lateral mesodermal cell differentiation",
  "GO:0048372": "lateral mesodermal cell fate commitment",
  "GO:0048373": "lateral mesodermal cell fate determination",
  "GO:0048374": "regulation of lateral mesodermal cell fate determination",
  "GO:0048375": "negative regulation of lateral mesodermal cell fate determination",
  "GO:0048376": "positive regulation of lateral mesodermal cell fate determination",
  "GO:0048377": "lateral mesodermal cell fate specification",
  "GO:0048378": "regulation of lateral mesodermal cell fate specification",
  "GO:0048379": "positive regulation of lateral mesodermal cell fate specification",
  "GO:0048380": "negative regulation of lateral mesodermal cell fate specification",
  "GO:0048381": "lateral mesoderm structural organization",
  "GO:0048382": "mesendoderm development",
  "GO:0048383": "mesectoderm development",
  "GO:0048384": "retinoic acid receptor signaling pathway",
  "GO:0048385": "regulation of retinoic acid receptor signaling pathway",
  "GO:0048386": "positive regulation of retinoic acid receptor signaling pathway",
  "GO:0048387": "negative regulation of retinoic acid receptor signaling pathway",
  "GO:0048388": "endosomal lumen acidification",
  "GO:0048389": "intermediate mesoderm development",
  "GO:0048390": "intermediate mesoderm morphogenesis",
  "GO:0048391": "intermediate mesoderm formation",
  "GO:0048392": "intermediate mesodermal cell differentiation",
  "GO:0048393": "intermediate mesodermal cell fate commitment",
  "GO:0048394": "intermediate mesodermal cell fate determination",
  "GO:0048395": "regulation of intermediate mesodermal cell fate determination",
  "GO:0048396": "negative regulation of intermediate mesodermal cell fate determination",
  "GO:0048397": "positive regulation of intermediate mesodermal cell fate determination",
  "GO:0048398": "intermediate mesodermal cell fate specification",
  "GO:0048399": "regulation of intermediate mesodermal cell fate specification",
  "GO:0048400": "positive regulation of intermediate mesodermal cell fate specification",
  "GO:0048401": "negative regulation of intermediate mesodermal cell fate specification",
  "GO:0048402": "intermediate mesoderm structural organization",
  "GO:0048403": "brain-derived neurotrophic factor binding",
  "GO:0048406": "nerve growth factor binding",
  "GO:0048407": "platelet-derived growth factor binding",
  "GO:0048408": "epidermal growth factor binding",
  "GO:0048437": "floral organ development",
  "GO:0048438": "floral whorl development",
  "GO:0048439": "flower morphogenesis",
  "GO:0048440": "carpel development",
  "GO:0048441": "petal development",
  "GO:0048442": "sepal development",
  "GO:0048443": "stamen development",
  "GO:0048444": "floral organ morphogenesis",
  "GO:0048445": "carpel morphogenesis",
  "GO:0048446": "petal morphogenesis",
  "GO:0048447": "sepal morphogenesis",
  "GO:0048448": "stamen morphogenesis",
  "GO:0048449": "floral organ formation",
  "GO:0048450": "floral organ structural organization",
  "GO:0048451": "petal formation",
  "GO:0048452": "petal structural organization",
  "GO:0048453": "sepal formation",
  "GO:0048454": "sepal structural organization",
  "GO:0048455": "stamen formation",
  "GO:0048456": "stamen structural organization",
  "GO:0048457": "floral whorl morphogenesis",
  "GO:0048458": "floral whorl formation",
  "GO:0048459": "floral whorl structural organization",
  "GO:0048460": "flower formation",
  "GO:0048461": "flower structural organization",
  "GO:0048462": "carpel formation",
  "GO:0048463": "carpel structural organization",
  "GO:0048464": "flower calyx development",
  "GO:0048465": "corolla development",
  "GO:0048466": "androecium development",
  "GO:0048467": "gynoecium development",
  "GO:0048468": "cell development",
  "GO:0048469": "cell maturation",
  "GO:0048471": "perinuclear region of cytoplasm",
  "GO:0048472": "threonine-phosphate decarboxylase activity",
  "GO:0048473": "D-methionine transport",
  "GO:0048474": "D-methionine transmembrane transporter activity",
  "GO:0048475": "coated membrane",
  "GO:0048476": "Holliday junction resolvase complex",
  "GO:0048477": "oogenesis",
  "GO:0048478": "replication fork protection",
  "GO:0048479": "style development",
  "GO:0048480": "stigma development",
  "GO:0048481": "plant ovule development",
  "GO:0048482": "plant ovule morphogenesis",
  "GO:0048483": "autonomic nervous system development",
  "GO:0048484": "enteric nervous system development",
  "GO:0048485": "sympathetic nervous system development",
  "GO:0048486": "parasympathetic nervous system development",
  "GO:0048487": "beta-tubulin binding",
  "GO:0048488": "synaptic vesicle endocytosis",
  "GO:0048489": "synaptic vesicle transport",
  "GO:0048490": "anterograde synaptic vesicle transport",
  "GO:0048491": "retrograde synaptic vesicle transport",
  "GO:0048492": "ribulose bisphosphate carboxylase complex",
  "GO:0048493": "plasma membrane-derived thylakoid ribulose bisphosphate carboxylase complex",
  "GO:0048494": "chromatophore ribulose bisphosphate carboxylase complex",
  "GO:0048495": "Roundabout binding",
  "GO:0048496": "maintenance of organ identity",
  "GO:0048497": "maintenance of floral organ identity",
  "GO:0048498": "establishment of petal orientation",
  "GO:0048499": "synaptic vesicle membrane organization",
  "GO:0048500": "signal recognition particle",
  "GO:0048501": "signal recognition particle, plasma membrane targeting",
  "GO:0048502": "thiamine-transporting ATPase activity",
  "GO:0048503": "obsolete GPI anchor binding",
  "GO:0048504": "regulation of timing of organ formation",
  "GO:0048505": "regulation of timing of cell differentiation",
  "GO:0048506": "regulation of timing of meristematic phase transition",
  "GO:0048507": "meristem development",
  "GO:0048508": "embryonic meristem development",
  "GO:0048509": "regulation of meristem development",
  "GO:0048510": "regulation of timing of transition from vegetative to reproductive phase",
  "GO:0048511": "rhythmic process",
  "GO:0048512": "circadian behavior",
  "GO:0048513": "animal organ development",
  "GO:0048514": "blood vessel morphogenesis",
  "GO:0048515": "spermatid differentiation",
  "GO:0048516": "obsolete trichome initiation (sensu Magnoliophyta)",
  "GO:0048517": "obsolete positive regulation of trichome initiation (sensu Magnoliophyta)",
  "GO:0048518": "positive regulation of biological process",
  "GO:0048519": "negative regulation of biological process",
  "GO:0048520": "positive regulation of behavior",
  "GO:0048521": "negative regulation of behavior",
  "GO:0048522": "positive regulation of cellular process",
  "GO:0048523": "negative regulation of cellular process",
  "GO:0048524": "positive regulation of viral process",
  "GO:0048525": "negative regulation of viral process",
  "GO:0048526": "imaginal disc-derived wing expansion",
  "GO:0048527": "lateral root development",
  "GO:0048528": "post-embryonic root development",
  "GO:0048529": "magnesium-protoporphyrin IX monomethyl ester (oxidative) cyclase activity",
  "GO:0048530": "fruit morphogenesis",
  "GO:0048531": "beta-1,3-galactosyltransferase activity",
  "GO:0048532": "anatomical structure arrangement",
  "GO:0048533": "sporocyte differentiation",
  "GO:0048534": "hematopoietic or lymphoid organ development",
  "GO:0048535": "lymph node development",
  "GO:0048536": "spleen development",
  "GO:0048537": "mucosal-associated lymphoid tissue development",
  "GO:0048538": "thymus development",
  "GO:0048539": "bone marrow development",
  "GO:0048540": "bursa of Fabricius development",
  "GO:0048541": "Peyer's patch development",
  "GO:0048542": "lymph gland development",
  "GO:0048543": "phytochrome chromophore biosynthetic process",
  "GO:0048544": "recognition of pollen",
  "GO:0048545": "response to steroid hormone",
  "GO:0048546": "digestive tract morphogenesis",
  "GO:0048548": "regulation of pinocytosis",
  "GO:0048549": "positive regulation of pinocytosis",
  "GO:0048550": "negative regulation of pinocytosis",
  "GO:0048555": "generative cell nucleus",
  "GO:0048556": "microsporocyte nucleus",
  "GO:0048557": "embryonic digestive tract morphogenesis",
  "GO:0048559": "establishment of floral organ orientation",
  "GO:0048560": "establishment of anatomical structure orientation",
  "GO:0048561": "establishment of organ orientation",
  "GO:0048562": "embryonic organ morphogenesis",
  "GO:0048563": "post-embryonic organ morphogenesis",
  "GO:0048564": "photosystem I assembly",
  "GO:0048565": "digestive tract development",
  "GO:0048566": "embryonic digestive tract development",
  "GO:0048567": "ectodermal digestive tract morphogenesis",
  "GO:0048568": "embryonic organ development",
  "GO:0048569": "post-embryonic organ development",
  "GO:0048570": "notochord morphogenesis",
  "GO:0048571": "long-day photoperiodism",
  "GO:0048572": "short-day photoperiodism",
  "GO:0048573": "photoperiodism, flowering",
  "GO:0048574": "long-day photoperiodism, flowering",
  "GO:0048575": "short-day photoperiodism, flowering",
  "GO:0048576": "positive regulation of short-day photoperiodism, flowering",
  "GO:0048577": "negative regulation of short-day photoperiodism, flowering",
  "GO:0048578": "positive regulation of long-day photoperiodism, flowering",
  "GO:0048579": "negative regulation of long-day photoperiodism, flowering",
  "GO:0048580": "regulation of post-embryonic development",
  "GO:0048581": "negative regulation of post-embryonic development",
  "GO:0048582": "positive regulation of post-embryonic development",
  "GO:0048583": "regulation of response to stimulus",
  "GO:0048584": "positive regulation of response to stimulus",
  "GO:0048585": "negative regulation of response to stimulus",
  "GO:0048586": "regulation of long-day photoperiodism, flowering",
  "GO:0048587": "regulation of short-day photoperiodism, flowering",
  "GO:0048588": "developmental cell growth",
  "GO:0048589": "developmental growth",
  "GO:0048592": "eye morphogenesis",
  "GO:0048593": "camera-type eye morphogenesis",
  "GO:0048596": "embryonic camera-type eye morphogenesis",
  "GO:0048597": "post-embryonic camera-type eye morphogenesis",
  "GO:0048598": "embryonic morphogenesis",
  "GO:0048599": "oocyte development",
  "GO:0048600": "oocyte fate commitment",
  "GO:0048601": "oocyte morphogenesis",
  "GO:0048608": "reproductive structure development",
  "GO:0048609": "multicellular organismal reproductive process",
  "GO:0048610": "obsolete cellular process involved in reproduction",
  "GO:0048611": "embryonic ectodermal digestive tract development",
  "GO:0048612": "post-embryonic ectodermal digestive tract development",
  "GO:0048613": "embryonic ectodermal digestive tract morphogenesis",
  "GO:0048614": "post-embryonic ectodermal digestive tract morphogenesis",
  "GO:0048615": "embryonic anterior midgut (ectodermal) morphogenesis",
  "GO:0048616": "post-embryonic anterior midgut (ectodermal) morphogenesis",
  "GO:0048617": "embryonic foregut morphogenesis",
  "GO:0048618": "post-embryonic foregut morphogenesis",
  "GO:0048619": "embryonic hindgut morphogenesis",
  "GO:0048620": "post-embryonic hindgut morphogenesis",
  "GO:0048621": "post-embryonic digestive tract morphogenesis",
  "GO:0048622": "obsolete reproductive sporulation",
  "GO:0048623": "seed germination on parent plant",
  "GO:0048624": "plantlet formation on parent plant",
  "GO:0048625": "myoblast fate commitment",
  "GO:0048626": "myoblast fate specification",
  "GO:0048627": "myoblast development",
  "GO:0048628": "myoblast maturation",
  "GO:0048629": "trichome patterning",
  "GO:0048630": "skeletal muscle tissue growth",
  "GO:0048631": "regulation of skeletal muscle tissue growth",
  "GO:0048632": "negative regulation of skeletal muscle tissue growth",
  "GO:0048633": "positive regulation of skeletal muscle tissue growth",
  "GO:0048634": "regulation of muscle organ development",
  "GO:0048635": "negative regulation of muscle organ development",
  "GO:0048636": "positive regulation of muscle organ development",
  "GO:0048638": "regulation of developmental growth",
  "GO:0048639": "positive regulation of developmental growth",
  "GO:0048640": "negative regulation of developmental growth",
  "GO:0048641": "regulation of skeletal muscle tissue development",
  "GO:0048642": "negative regulation of skeletal muscle tissue development",
  "GO:0048643": "positive regulation of skeletal muscle tissue development",
  "GO:0048644": "muscle organ morphogenesis",
  "GO:0048645": "organ formation",
  "GO:0048646": "anatomical structure formation involved in morphogenesis",
  "GO:0048647": "polyphenic determination",
  "GO:0048648": "caste determination",
  "GO:0048649": "caste determination, influence by genetic factors",
  "GO:0048650": "caste determination, influence by environmental factors",
  "GO:0048651": "polyphenic determination, influence by environmental factors",
  "GO:0048652": "polyphenic determination, influence by genetic factors",
  "GO:0048653": "anther development",
  "GO:0048654": "anther morphogenesis",
  "GO:0048655": "anther wall tapetum morphogenesis",
  "GO:0048656": "anther wall tapetum formation",
  "GO:0048657": "anther wall tapetum cell differentiation",
  "GO:0048658": "anther wall tapetum development",
  "GO:0048659": "smooth muscle cell proliferation",
  "GO:0048660": "regulation of smooth muscle cell proliferation",
  "GO:0048661": "positive regulation of smooth muscle cell proliferation",
  "GO:0048662": "negative regulation of smooth muscle cell proliferation",
  "GO:0048663": "neuron fate commitment",
  "GO:0048664": "neuron fate determination",
  "GO:0048665": "neuron fate specification",
  "GO:0048666": "neuron development",
  "GO:0048667": "cell morphogenesis involved in neuron differentiation",
  "GO:0048668": "collateral sprouting",
  "GO:0048669": "collateral sprouting in absence of injury",
  "GO:0048670": "regulation of collateral sprouting",
  "GO:0048671": "negative regulation of collateral sprouting",
  "GO:0048672": "positive regulation of collateral sprouting",
  "GO:0048673": "collateral sprouting of intact axon in response to injury",
  "GO:0048674": "collateral sprouting of injured axon",
  "GO:0048675": "axon extension",
  "GO:0048677": "axon extension involved in regeneration",
  "GO:0048678": "response to axon injury",
  "GO:0048679": "regulation of axon regeneration",
  "GO:0048680": "positive regulation of axon regeneration",
  "GO:0048681": "negative regulation of axon regeneration",
  "GO:0048682": "sprouting of injured axon",
  "GO:0048683": "regulation of collateral sprouting of intact axon in response to injury",
  "GO:0048684": "positive regulation of collateral sprouting of intact axon in response to injury",
  "GO:0048685": "negative regulation of collateral sprouting of intact axon in response to injury",
  "GO:0048686": "regulation of sprouting of injured axon",
  "GO:0048687": "positive regulation of sprouting of injured axon",
  "GO:0048688": "negative regulation of sprouting of injured axon",
  "GO:0048689": "formation of growth cone in injured axon",
  "GO:0048690": "regulation of axon extension involved in regeneration",
  "GO:0048691": "positive regulation of axon extension involved in regeneration",
  "GO:0048692": "negative regulation of axon extension involved in regeneration",
  "GO:0048693": "regulation of collateral sprouting of injured axon",
  "GO:0048694": "positive regulation of collateral sprouting of injured axon",
  "GO:0048695": "negative regulation of collateral sprouting of injured axon",
  "GO:0048696": "regulation of collateral sprouting in absence of injury",
  "GO:0048697": "positive regulation of collateral sprouting in absence of injury",
  "GO:0048698": "negative regulation of collateral sprouting in absence of injury",
  "GO:0048699": "generation of neurons",
  "GO:0048700": "acquisition of desiccation tolerance in seed",
  "GO:0048701": "embryonic cranial skeleton morphogenesis",
  "GO:0048702": "embryonic neurocranium morphogenesis",
  "GO:0048703": "embryonic viscerocranium morphogenesis",
  "GO:0048704": "embryonic skeletal system morphogenesis",
  "GO:0048705": "skeletal system morphogenesis",
  "GO:0048706": "embryonic skeletal system development",
  "GO:0048707": "instar larval or pupal morphogenesis",
  "GO:0048708": "astrocyte differentiation",
  "GO:0048709": "oligodendrocyte differentiation",
  "GO:0048710": "regulation of astrocyte differentiation",
  "GO:0048711": "positive regulation of astrocyte differentiation",
  "GO:0048712": "negative regulation of astrocyte differentiation",
  "GO:0048713": "regulation of oligodendrocyte differentiation",
  "GO:0048714": "positive regulation of oligodendrocyte differentiation",
  "GO:0048715": "negative regulation of oligodendrocyte differentiation",
  "GO:0048716": "labrum morphogenesis",
  "GO:0048717": "anterior cibarial plate morphogenesis",
  "GO:0048718": "cibarial fish-trap bristle morphogenesis",
  "GO:0048719": "epistomal sclerite morphogenesis",
  "GO:0048720": "posterior cibarial plate morphogenesis",
  "GO:0048721": "clypeus morphogenesis",
  "GO:0048722": "anterior cibarial plate development",
  "GO:0048723": "clypeus development",
  "GO:0048724": "epistomal sclerite development",
  "GO:0048725": "cibarial fish-trap bristle development",
  "GO:0048726": "labrum development",
  "GO:0048727": "posterior cibarial plate development",
  "GO:0048728": "proboscis development",
  "GO:0048729": "tissue morphogenesis",
  "GO:0048730": "epidermis morphogenesis",
  "GO:0048731": "system development",
  "GO:0048732": "gland development",
  "GO:0048733": "sebaceous gland development",
  "GO:0048734": "proboscis morphogenesis",
  "GO:0048735": "haltere morphogenesis",
  "GO:0048736": "appendage development",
  "GO:0048737": "imaginal disc-derived appendage development",
  "GO:0048738": "cardiac muscle tissue development",
  "GO:0048739": "cardiac muscle fiber development",
  "GO:0048740": "obsolete striated muscle fiber development",
  "GO:0048741": "skeletal muscle fiber development",
  "GO:0048742": "regulation of skeletal muscle fiber development",
  "GO:0048743": "positive regulation of skeletal muscle fiber development",
  "GO:0048744": "negative regulation of skeletal muscle fiber development",
  "GO:0048745": "smooth muscle tissue development",
  "GO:0048746": "obsolete smooth muscle fiber development",
  "GO:0048747": "muscle fiber development",
  "GO:0048749": "compound eye development",
  "GO:0048750": "compound eye corneal lens morphogenesis",
  "GO:0048752": "semicircular canal morphogenesis",
  "GO:0048753": "pigment granule organization",
  "GO:0048754": "branching morphogenesis of an epithelial tube",
  "GO:0048755": "branching morphogenesis of a nerve",
  "GO:0048756": "sieve cell differentiation",
  "GO:0048757": "pigment granule maturation",
  "GO:0048758": "companion cell differentiation",
  "GO:0048759": "xylem vessel member cell differentiation",
  "GO:0048760": "plant parenchymal cell differentiation",
  "GO:0048761": "collenchyma cell differentiation",
  "GO:0048762": "mesenchymal cell differentiation",
  "GO:0048763": "calcium-induced calcium release activity",
  "GO:0048764": "trichoblast maturation",
  "GO:0048765": "root hair cell differentiation",
  "GO:0048766": "root hair initiation",
  "GO:0048767": "root hair elongation",
  "GO:0048768": "root hair cell tip growth",
  "GO:0048769": "sarcomerogenesis",
  "GO:0048770": "pigment granule",
  "GO:0048771": "tissue remodeling",
  "GO:0048772": "leucophore differentiation",
  "GO:0048773": "erythrophore differentiation",
  "GO:0048774": "cyanophore differentiation",
  "GO:0048775": "regulation of leucophore differentiation",
  "GO:0048776": "negative regulation of leucophore differentiation",
  "GO:0048777": "positive regulation of leucophore differentiation",
  "GO:0048778": "regulation of erythrophore differentiation",
  "GO:0048779": "negative regulation of erythrophore differentiation",
  "GO:0048780": "positive regulation of erythrophore differentiation",
  "GO:0048781": "regulation of cyanophore differentiation",
  "GO:0048782": "negative regulation of cyanophore differentiation",
  "GO:0048783": "positive regulation of cyanophore differentiation",
  "GO:0048784": "pigment biosynthetic process involved in pigment granule maturation",
  "GO:0048785": "hatching gland development",
  "GO:0048786": "presynaptic active zone",
  "GO:0048787": "presynaptic active zone membrane",
  "GO:0048788": "cytoskeleton of presynaptic active zone",
  "GO:0048789": "cytoskeletal matrix organization at active zone",
  "GO:0048790": "maintenance of presynaptic active zone structure",
  "GO:0048791": "calcium ion-regulated exocytosis of neurotransmitter",
  "GO:0048792": "spontaneous exocytosis of neurotransmitter",
  "GO:0048793": "pronephros development",
  "GO:0048794": "swim bladder development",
  "GO:0048795": "swim bladder morphogenesis",
  "GO:0048796": "swim bladder maturation",
  "GO:0048797": "swim bladder formation",
  "GO:0048798": "swim bladder inflation",
  "GO:0048799": "organ maturation",
  "GO:0048800": "antennal morphogenesis",
  "GO:0048801": "antennal joint morphogenesis",
  "GO:0048802": "notum morphogenesis",
  "GO:0048803": "imaginal disc-derived male genitalia morphogenesis",
  "GO:0048804": "imaginal disc-derived female genitalia morphogenesis",
  "GO:0048805": "imaginal disc-derived genitalia morphogenesis",
  "GO:0048806": "genitalia development",
  "GO:0048807": "female genitalia morphogenesis",
  "GO:0048808": "male genitalia morphogenesis",
  "GO:0048809": "analia morphogenesis",
  "GO:0048810": "female analia morphogenesis",
  "GO:0048811": "male analia morphogenesis",
  "GO:0048812": "neuron projection morphogenesis",
  "GO:0048813": "dendrite morphogenesis",
  "GO:0048814": "regulation of dendrite morphogenesis",
  "GO:0048815": "hermaphrodite genitalia morphogenesis",
  "GO:0048816": "ocellus morphogenesis",
  "GO:0048817": "negative regulation of hair follicle maturation",
  "GO:0048818": "positive regulation of hair follicle maturation",
  "GO:0048819": "regulation of hair follicle maturation",
  "GO:0048820": "hair follicle maturation",
  "GO:0048821": "erythrocyte development",
  "GO:0048822": "enucleate erythrocyte development",
  "GO:0048823": "nucleate erythrocyte development",
  "GO:0048824": "pigment cell precursor differentiation",
  "GO:0048825": "cotyledon development",
  "GO:0048826": "cotyledon morphogenesis",
  "GO:0048827": "phyllome development",
  "GO:0048829": "root cap development",
  "GO:0048830": "adventitious root development",
  "GO:0048831": "regulation of shoot system development",
  "GO:0048832": "specification of organ number",
  "GO:0048833": "specification of floral organ number",
  "GO:0048834": "specification of petal number",
  "GO:0048835": "specification of decreased petal number",
  "GO:0048836": "specification of increased petal number",
  "GO:0048837": "sorus development",
  "GO:0048838": "release of seed from dormancy",
  "GO:0048839": "inner ear development",
  "GO:0048840": "otolith development",
  "GO:0048841": "regulation of axon extension involved in axon guidance",
  "GO:0048842": "positive regulation of axon extension involved in axon guidance",
  "GO:0048843": "negative regulation of axon extension involved in axon guidance",
  "GO:0048844": "artery morphogenesis",
  "GO:0048845": "venous blood vessel morphogenesis",
  "GO:0048846": "axon extension involved in axon guidance",
  "GO:0048847": "adenohypophysis formation",
  "GO:0048848": "neurohypophysis morphogenesis",
  "GO:0048849": "neurohypophysis formation",
  "GO:0048850": "hypophysis morphogenesis",
  "GO:0048851": "hypophysis formation",
  "GO:0048852": "diencephalon morphogenesis",
  "GO:0048853": "forebrain morphogenesis",
  "GO:0048854": "brain morphogenesis",
  "GO:0048855": "adenohypophysis morphogenesis",
  "GO:0048856": "anatomical structure development",
  "GO:0048857": "neural nucleus development",
  "GO:0048858": "cell projection morphogenesis",
  "GO:0048859": "formation of anatomical boundary",
  "GO:0048860": "glioblast division",
  "GO:0048861": "leukemia inhibitory factor signaling pathway",
  "GO:0048863": "stem cell differentiation",
  "GO:0048864": "stem cell development",
  "GO:0048865": "stem cell fate commitment",
  "GO:0048866": "stem cell fate specification",
  "GO:0048867": "stem cell fate determination",
  "GO:0048868": "pollen tube development",
  "GO:0048869": "cellular developmental process",
  "GO:0048870": "cell motility",
  "GO:0048871": "multicellular organismal homeostasis",
  "GO:0048872": "homeostasis of number of cells",
  "GO:0048873": "homeostasis of number of cells within a tissue",
  "GO:0048874": "homeostasis of number of cells in a free-living population",
  "GO:0048875": "chemical homeostasis within a tissue",
  "GO:0048876": "chemical homeostasis within retina",
  "GO:0048877": "homeostasis of number of retina cells",
  "GO:0048878": "chemical homeostasis",
  "GO:0048880": "sensory system development",
  "GO:0048881": "mechanosensory lateral line system development",
  "GO:0048882": "lateral line development",
  "GO:0048883": "neuromast primordium migration",
  "GO:0048884": "neuromast development",
  "GO:0048885": "neuromast deposition",
  "GO:0048886": "neuromast hair cell differentiation",
  "GO:0048887": "cupula development",
  "GO:0048888": "neuromast mantle cell differentiation",
  "GO:0048889": "neuromast support cell differentiation",
  "GO:0048890": "lateral line ganglion development",
  "GO:0048891": "lateral line ganglion neuron differentiation",
  "GO:0048892": "lateral line nerve development",
  "GO:0048893": "afferent axon development in lateral line nerve",
  "GO:0048894": "efferent axon development in a lateral line nerve",
  "GO:0048895": "lateral line nerve glial cell differentiation",
  "GO:0048896": "lateral line nerve glial cell migration",
  "GO:0048897": "myelination of lateral line nerve axons",
  "GO:0048898": "anterior lateral line system development",
  "GO:0048899": "anterior lateral line development",
  "GO:0048900": "anterior lateral line neuromast primordium migration",
  "GO:0048901": "anterior lateral line neuromast development",
  "GO:0048902": "anterior lateral line neuromast deposition",
  "GO:0048903": "anterior lateral line neuromast hair cell differentiation",
  "GO:0048904": "anterior lateral line neuromast cupula development",
  "GO:0048905": "anterior lateral line neuromast mantle cell differentiation",
  "GO:0048906": "anterior lateral line neuromast support cell differentiation",
  "GO:0048907": "anterior lateral line ganglion development",
  "GO:0048908": "anterior lateral line ganglion neuron differentiation",
  "GO:0048909": "anterior lateral line nerve development",
  "GO:0048910": "afferent axon development in anterior lateral line nerve",
  "GO:0048911": "efferent axon development in anterior lateral line nerve",
  "GO:0048912": "glial cell migration in anterior lateral line nerve",
  "GO:0048913": "anterior lateral line nerve glial cell differentiation",
  "GO:0048914": "myelination of anterior lateral line nerve axons",
  "GO:0048915": "posterior lateral line system development",
  "GO:0048916": "posterior lateral line development",
  "GO:0048917": "posterior lateral line ganglion development",
  "GO:0048918": "posterior lateral line nerve development",
  "GO:0048919": "posterior lateral line neuromast development",
  "GO:0048920": "posterior lateral line neuromast primordium migration",
  "GO:0048921": "posterior lateral line neuromast cupula development",
  "GO:0048922": "posterior lateral line neuromast deposition",
  "GO:0048923": "posterior lateral line neuromast hair cell differentiation",
  "GO:0048924": "posterior lateral line neuromast mantle cell differentiation",
  "GO:0048925": "lateral line system development",
  "GO:0048926": "electrosensory lateral line system development",
  "GO:0048927": "posterior lateral line neuromast support cell differentiation",
  "GO:0048928": "posterior lateral line ganglion neuron differentiation",
  "GO:0048929": "efferent axon development in posterior lateral line nerve",
  "GO:0048930": "glial cell migration in posterior lateral line nerve",
  "GO:0048931": "posterior lateral line nerve glial cell differentiation",
  "GO:0048932": "myelination of posterior lateral line nerve axons",
  "GO:0048933": "afferent axon development in posterior lateral line nerve",
  "GO:0048934": "peripheral nervous system neuron differentiation",
  "GO:0048935": "peripheral nervous system neuron development",
  "GO:0048936": "peripheral nervous system neuron axonogenesis",
  "GO:0048937": "lateral line nerve glial cell development",
  "GO:0048938": "lateral line nerve glial cell morphogenesis involved in differentiation",
  "GO:0048939": "anterior lateral line nerve glial cell development",
  "GO:0048940": "anterior lateral line nerve glial cell morphogenesis involved in differentiation",
  "GO:0048941": "posterior lateral line nerve glial cell development",
  "GO:0048942": "posterior lateral line nerve glial cell morphogenesis involved in differentiation",
  "GO:0050000": "chromosome localization",
  "GO:0050001": "D-glutaminase activity",
  "GO:0050002": "D-proline reductase (dithiol) activity",
  "GO:0050003": "deoxycytidylate C-methyltransferase activity",
  "GO:0050004": "isoflavone 7-O-glucosyltransferase activity",
  "GO:0050005": "isohexenylglutaconyl-CoA hydratase activity",
  "GO:0050006": "isomaltulose synthase activity",
  "GO:0050007": "isonocardicin synthase activity",
  "GO:0050008": "isopiperitenone delta-isomerase activity",
  "GO:0050009": "isopropanol dehydrogenase (NADP+) activity",
  "GO:0050010": "isovitexin beta-glucosyltransferase activity",
  "GO:0050011": "itaconyl-CoA hydratase activity",
  "GO:0050012": "juglone 3-monooxygenase activity",
  "GO:0050013": "2-dehydropantoate aldolase activity",
  "GO:0050014": "ketotetrose-phosphate aldolase activity",
  "GO:0050015": "kievitone hydratase activity",
  "GO:0050016": "kynurenine 7,8-hydroxylase activity",
  "GO:0050017": "L-3-cyanoalanine synthase activity",
  "GO:0050018": "L-amino-acid dehydrogenase activity",
  "GO:0050019": "L-arabinitol 4-dehydrogenase activity",
  "GO:0050020": "L-arabinonate dehydratase activity",
  "GO:0050021": "L-arabinonolactonase activity",
  "GO:0050022": "L-arabinose 1-dehydrogenase (NAD+) activity",
  "GO:0050023": "L-fuconate dehydratase activity",
  "GO:0050024": "L-galactonolactone oxidase activity",
  "GO:0050025": "L-glutamate oxidase activity",
  "GO:0050026": "L-glycol dehydrogenase activity",
  "GO:0050027": "obsolete L-idonate 2-dehydrogenase activity",
  "GO:0050028": "L-lysine-lactamase activity",
  "GO:0050029": "L-lysine oxidase activity",
  "GO:0050030": "L-pipecolate dehydrogenase activity",
  "GO:0050031": "L-pipecolate oxidase activity",
  "GO:0050032": "L-rhamnonate dehydratase activity",
  "GO:0050033": "L-rhamnono-1,4-lactonase activity",
  "GO:0050034": "L-rhamnose 1-dehydrogenase activity",
  "GO:0050035": "L-sorbose oxidase activity",
  "GO:0050036": "L-threonate 3-dehydrogenase activity",
  "GO:0050037": "L-xylose 1-dehydrogenase activity",
  "GO:0050038": "L-xylulose reductase (NADP+) activity",
  "GO:0050039": "lactaldehyde reductase (NADPH) activity",
  "GO:0050040": "lactate 2-monooxygenase activity",
  "GO:0050041": "lactate aldolase activity",
  "GO:0050042": "lactate-malate transhydrogenase activity",
  "GO:0050043": "lactate racemase activity",
  "GO:0050044": "galactose-6-phosphate isomerase activity",
  "GO:0050045": "laminaribiose phosphorylase activity",
  "GO:0050046": "lathosterol oxidase activity",
  "GO:0050047": "leucine 2,3-aminomutase activity",
  "GO:0050048": "L-leucine:2-oxoglutarate aminotransferase activity",
  "GO:0050049": "leucine dehydrogenase activity",
  "GO:0050050": "leucine N-acetyltransferase activity",
  "GO:0050051": "leukotriene-B4 20-monooxygenase activity",
  "GO:0050052": "leukotriene-E4 20-monooxygenase activity",
  "GO:0050053": "levansucrase activity",
  "GO:0050054": "lignostilbene alpha beta-dioxygenase activity",
  "GO:0050055": "limonin-D-ring-lactonase activity",
  "GO:0050056": "linalool 8-monooxygenase activity",
  "GO:0050057": "linamarin synthase activity",
  "GO:0050058": "linoleate isomerase activity",
  "GO:0050059": "lombricine kinase activity",
  "GO:0050060": "long-chain-alcohol dehydrogenase activity",
  "GO:0050061": "long-chain-aldehyde dehydrogenase activity",
  "GO:0050062": "long-chain-fatty-acyl-CoA reductase activity",
  "GO:0050063": "low-density-lipoprotein particle receptor kinase activity",
  "GO:0050064": "luteolin 7-O-glucuronosyltransferase activity",
  "GO:0050065": "lysine-pyruvate 6-transaminase activity",
  "GO:0050066": "lysine 2,3-aminomutase activity",
  "GO:0050067": "lysine 2-monooxygenase activity",
  "GO:0050068": "lysine carbamoyltransferase activity",
  "GO:0050069": "lysine dehydrogenase activity",
  "GO:0050070": "lysolecithin acylmutase activity",
  "GO:0050071": "lysyltransferase activity",
  "GO:0050072": "m7G(5')pppN diphosphatase activity",
  "GO:0050073": "macrolide 2'-kinase activity",
  "GO:0050074": "malate-CoA ligase activity",
  "GO:0050075": "maleate hydratase activity",
  "GO:0050076": "maleate isomerase activity",
  "GO:0050077": "maleylpyruvate isomerase activity",
  "GO:0050078": "malonate CoA-transferase activity",
  "GO:0050079": "acetylenecarboxylate hydratase activity, producing 3-oxopropanoate",
  "GO:0050080": "malonyl-CoA decarboxylase activity",
  "GO:0050081": "maltose-6'-phosphate glucosidase activity",
  "GO:0050082": "maltose phosphorylase activity",
  "GO:0050083": "malyl-CoA lyase activity",
  "GO:0050084": "mannitol-1-phosphatase activity",
  "GO:0050085": "mannitol 2-dehydrogenase (NADP+) activity",
  "GO:0050086": "mannitol 2-dehydrogenase activity",
  "GO:0050087": "mannitol dehydrogenase (cytochrome) activity",
  "GO:0050088": "mannose-6-phosphate 6-reductase activity",
  "GO:0050089": "mannose isomerase activity",
  "GO:0050090": "mannuronate reductase activity",
  "GO:0050091": "melilotate 3-monooxygenase activity",
  "GO:0050092": "meso-tartrate dehydrogenase activity",
  "GO:0050093": "methanol dehydrogenase activity",
  "GO:0050094": "methionine-glyoxylate transaminase activity",
  "GO:0050095": "methionine decarboxylase activity",
  "GO:0050096": "methylaspartate ammonia-lyase activity",
  "GO:0050097": "methylaspartate mutase activity",
  "GO:0050098": "methylguanidinase activity",
  "GO:0050099": "methylglutamate dehydrogenase activity",
  "GO:0050100": "methylitaconate delta-isomerase activity",
  "GO:0050101": "mimosinase activity",
  "GO:0050102": "cellodextrin phosphorylase activity",
  "GO:0050103": "dextrin dextranase activity",
  "GO:0050104": "L-gulonate 3-dehydrogenase activity",
  "GO:0050105": "L-gulonolactone oxidase activity",
  "GO:0050106": "monomethyl-sulfatase activity",
  "GO:0050107": "monoterpenol O-acetyltransferase activity",
  "GO:0050108": "monoterpenyl-diphosphatase activity",
  "GO:0050109": "morphine 6-dehydrogenase activity",
  "GO:0050110": "mucinaminylserine mucinaminidase activity",
  "GO:0050111": "mycocerosate synthase activity",
  "GO:0050112": "inositol 2-dehydrogenase activity",
  "GO:0050113": "inositol oxygenase activity",
  "GO:0050114": "myo-inosose-2 dehydratase activity",
  "GO:0050115": "myosin-light-chain-phosphatase activity",
  "GO:0050116": "N,N-dimethylformamidase activity",
  "GO:0050117": "N-acetyl-beta-alanine deacetylase activity",
  "GO:0050118": "N-acetyldiaminopimelate deacetylase activity",
  "GO:0050119": "N-acetylglucosamine deacetylase activity",
  "GO:0050120": "N-acetylhexosamine 1-dehydrogenase activity",
  "GO:0050121": "N-acylglucosamine 2-epimerase activity",
  "GO:0050122": "N-acylhexosamine oxidase activity",
  "GO:0050123": "N-acylmannosamine 1-dehydrogenase activity",
  "GO:0050124": "N-acylneuraminate-9-phosphatase activity",
  "GO:0050125": "N-benzyloxycarbonylglycine hydrolase activity",
  "GO:0050126": "N-carbamoylputrescine amidase activity",
  "GO:0050127": "N-carbamoylsarcosine amidase activity",
  "GO:0050128": "N-feruloylglycine deacylase activity",
  "GO:0050129": "N-formylglutamate deformylase activity",
  "GO:0050130": "N-methyl-2-oxoglutaramate hydrolase activity",
  "GO:0050131": "N-methyl-L-amino-acid oxidase activity",
  "GO:0050132": "N-methylalanine dehydrogenase activity",
  "GO:0050133": "N6-hydroxylysine O-acetyltransferase activity",
  "GO:0050134": "N6-methyl-lysine oxidase activity",
  "GO:0050135": "NAD(P)+ nucleosidase activity",
  "GO:0050136": "NADH dehydrogenase (quinone) activity",
  "GO:0050137": "NADPH peroxidase activity",
  "GO:0050138": "nicotinate dehydrogenase activity",
  "GO:0050139": "nicotinate glucosyltransferase activity",
  "GO:0050140": "nitrate reductase (cytochrome) activity",
  "GO:0050141": "nitroethane oxidase activity",
  "GO:0050142": "nitrogenase (flavodoxin) activity",
  "GO:0050143": "nocardicin-A epimerase activity",
  "GO:0050144": "nucleoside deoxyribosyltransferase activity",
  "GO:0050145": "nucleoside phosphate kinase activity",
  "GO:0050146": "nucleoside phosphotransferase activity",
  "GO:0050147": "nucleoside ribosyltransferase activity",
  "GO:0050148": "nucleotide diphosphokinase activity",
  "GO:0050149": "o-aminophenol oxidase activity",
  "GO:0050150": "o-pyrocatechuate decarboxylase activity",
  "GO:0050151": "oleate hydratase activity",
  "GO:0050152": "omega-amidase activity",
  "GO:0050153": "omega-hydroxydecanoate dehydrogenase activity",
  "GO:0050154": "opheline kinase activity",
  "GO:0050155": "ornithine(lysine) transaminase activity",
  "GO:0050156": "ornithine N-benzoyltransferase activity",
  "GO:0050157": "ornithine racemase activity",
  "GO:0050158": "orotate reductase (NADPH) activity",
  "GO:0050159": "orsellinate decarboxylase activity",
  "GO:0050160": "orsellinate-depside hydrolase activity",
  "GO:0050161": "succinyl-CoA:oxalate CoA-transferase",
  "GO:0050162": "oxalate oxidase activity",
  "GO:0050163": "oxaloacetate tautomerase activity",
  "GO:0050164": "oxoglutarate dehydrogenase (NADP+) activity",
  "GO:0050165": "pantetheine kinase activity",
  "GO:0050166": "pantoate 4-dehydrogenase activity",
  "GO:0050167": "pantothenoylcysteine decarboxylase activity",
  "GO:0050168": "pentanamidase activity",
  "GO:0050169": "peptide-tryptophan 2,3-dioxygenase activity",
  "GO:0050170": "peptidyl-glutaminase activity",
  "GO:0050171": "phenol beta-glucosyltransferase activity",
  "GO:0050172": "phenylalanine 2-monooxygenase activity",
  "GO:0050173": "phenylalanine adenylyltransferase activity",
  "GO:0050174": "phenylalanine decarboxylase activity",
  "GO:0050175": "phenylalanine dehydrogenase activity",
  "GO:0050176": "phenylalanine N-acetyltransferase activity",
  "GO:0050177": "phenylpyruvate decarboxylase activity",
  "GO:0050178": "phenylpyruvate tautomerase activity",
  "GO:0050179": "phenylserine aldolase activity",
  "GO:0050180": "phloretin hydrolase activity",
  "GO:0050181": "phorbol-diester hydrolase activity",
  "GO:0050182": "phosphate butyryltransferase activity",
  "GO:0050183": "phosphatidylcholine 12-monooxygenase activity",
  "GO:0050184": "phosphatidylcholine desaturase activity",
  "GO:0050185": "phosphatidylinositol deacylase activity",
  "GO:0050186": "phosphoadenylylsulfatase activity",
  "GO:0050187": "phosphoamidase activity",
  "GO:0050188": "phosphoenolpyruvate mutase activity",
  "GO:0050189": "phosphoenolpyruvate phosphatase activity",
  "GO:0050190": "phosphoglucokinase activity",
  "GO:0050191": "phosphoglycerate kinase (GTP) activity",
  "GO:0050192": "phosphoglycerate phosphatase activity",
  "GO:0050193": "phosphoketolase activity",
  "GO:0050194": "phosphonoacetaldehyde hydrolase activity",
  "GO:0050195": "phosphoribokinase activity",
  "GO:0050196": "[phosphorylase] phosphatase activity",
  "GO:0050197": "phytanate-CoA ligase activity",
  "GO:0050198": "pinosylvin synthase activity",
  "GO:0050199": "piperidine N-piperoyltransferase activity",
  "GO:0050200": "plasmalogen synthase activity",
  "GO:0050201": "fucokinase activity",
  "GO:0050202": "octopamine dehydratase activity",
  "GO:0050203": "oxalate-CoA ligase activity",
  "GO:0050204": "oxalomalate lyase activity",
  "GO:0050205": "oxamate carbamoyltransferase activity",
  "GO:0050206": "oximinotransferase activity",
  "GO:0050207": "plasmanylethanolamine desaturase activity",
  "GO:0050208": "polysialic-acid O-acetyltransferase activity",
  "GO:0050209": "polyvinyl-alcohol oxidase activity",
  "GO:0050210": "prenyl-diphosphatase activity",
  "GO:0050211": "procollagen galactosyltransferase activity",
  "GO:0050212": "progesterone 11-alpha-monooxygenase activity",
  "GO:0050213": "progesterone 5-alpha-reductase activity",
  "GO:0050214": "progesterone monooxygenase activity",
  "GO:0050215": "propanediol dehydratase activity",
  "GO:0050216": "propanediol-phosphate dehydrogenase activity",
  "GO:0050217": "propioin synthase activity",
  "GO:0050218": "propionate-CoA ligase activity",
  "GO:0050219": "prostaglandin-A1 delta-isomerase activity",
  "GO:0050220": "prostaglandin-E synthase activity",
  "GO:0050221": "prostaglandin-E2 9-reductase activity",
  "GO:0050223": "protocatechuate decarboxylase activity",
  "GO:0050224": "prunasin beta-glucosidase activity",
  "GO:0050225": "pseudouridine kinase activity",
  "GO:0050226": "psychosine sulfotransferase activity",
  "GO:0050227": "pteridine oxidase activity",
  "GO:0050228": "pterin deaminase activity",
  "GO:0050229": "pterocarpin synthase activity",
  "GO:0050230": "purine imidazole-ring cyclase activity",
  "GO:0050231": "putrescine carbamoyltransferase activity",
  "GO:0050232": "putrescine oxidase activity",
  "GO:0050233": "pyranose oxidase activity",
  "GO:0050234": "pyrazolylalanine synthase activity",
  "GO:0050235": "pyridoxal 4-dehydrogenase activity",
  "GO:0050236": "pyridoxine:NADP 4-dehydrogenase activity",
  "GO:0050237": "pyridoxine 4-oxidase activity",
  "GO:0050238": "pyridoxine 5-dehydrogenase activity",
  "GO:0050239": "pyrithiamine deaminase activity",
  "GO:0050240": "pyrogallol 1,2-oxygenase activity",
  "GO:0050241": "pyrroline-2-carboxylate reductase activity",
  "GO:0050242": "pyruvate, phosphate dikinase activity",
  "GO:0050243": "pyruvate dehydrogenase (NADP+) activity",
  "GO:0050244": "pyruvate oxidase (CoA-acetylating) activity",
  "GO:0050245": "quercitrinase activity",
  "GO:0050246": "questin monooxygenase activity",
  "GO:0050247": "raucaffricine beta-glucosidase activity",
  "GO:0050248": "Renilla-luciferin 2-monooxygenase activity",
  "GO:0050249": "Renilla-luciferin sulfotransferase activity",
  "GO:0050250": "retinal oxidase activity",
  "GO:0050251": "retinol isomerase activity",
  "GO:0050252": "retinol O-fatty-acyltransferase activity",
  "GO:0050253": "retinyl-palmitate esterase activity",
  "GO:0050254": "rhodopsin kinase activity",
  "GO:0050255": "ribitol 2-dehydrogenase activity",
  "GO:0050256": "ribitol-5-phosphate 2-dehydrogenase activity",
  "GO:0050257": "riboflavin phosphotransferase activity",
  "GO:0050258": "riboflavinase activity",
  "GO:0050259": "ribose 1-dehydrogenase (NADP+) activity",
  "GO:0050260": "ribose-5-phosphate-ammonia ligase activity",
  "GO:0050261": "ribose isomerase activity",
  "GO:0050262": "ribosylnicotinamide kinase activity",
  "GO:0050263": "ribosylpyrimidine nucleosidase activity",
  "GO:0050264": "rifamycin-B oxidase activity",
  "GO:0050265": "RNA uridylyltransferase activity",
  "GO:0050266": "rosmarinate synthase activity",
  "GO:0050267": "rubber cis-polyprenylcistransferase activity",
  "GO:0050268": "coniferyl-alcohol dehydrogenase activity",
  "GO:0050269": "coniferyl-aldehyde dehydrogenase activity",
  "GO:0050270": "S-adenosylhomocysteine deaminase activity",
  "GO:0050271": "S-alkylcysteine lyase activity",
  "GO:0050272": "S-carboxymethylcysteine synthase activity",
  "GO:0050273": "S-succinylglutathione hydrolase activity",
  "GO:0050274": "salicyl-alcohol beta-D-glucosyltransferase activity",
  "GO:0050275": "scopoletin glucosyltransferase activity",
  "GO:0050276": "scyllo-inosamine 4-kinase activity",
  "GO:0050277": "sedoheptulokinase activity",
  "GO:0050278": "sedoheptulose-bisphosphatase activity",
  "GO:0050279": "sepiapterin deaminase activity",
  "GO:0050280": "sequoyitol dehydrogenase activity",
  "GO:0050281": "serine-glyoxylate transaminase activity",
  "GO:0050282": "serine 2-dehydrogenase activity",
  "GO:0050283": "serine-sulfate ammonia-lyase activity",
  "GO:0050284": "sinapate 1-glucosyltransferase activity",
  "GO:0050285": "sinapine esterase activity",
  "GO:0050286": "sorbitol-6-phosphatase activity",
  "GO:0050287": "sorbose 5-dehydrogenase (NADP+) activity",
  "GO:0050288": "sorbose dehydrogenase activity",
  "GO:0050289": "spermidine dehydrogenase activity",
  "GO:0050290": "sphingomyelin phosphodiesterase D activity",
  "GO:0050291": "sphingosine N-acyltransferase activity",
  "GO:0050292": "steroid 9-alpha-monooxygenase activity",
  "GO:0050293": "steroid-lactonase activity",
  "GO:0050294": "steroid sulfotransferase activity",
  "GO:0050295": "steryl-beta-glucosidase activity",
  "GO:0050296": "stipitatonate decarboxylase activity",
  "GO:0050297": "stizolobate synthase activity",
  "GO:0050298": "stizolobinate synthase activity",
  "GO:0050299": "streptomycin 3''-kinase activity",
  "GO:0050300": "aminoglycoside 6-kinase activity",
  "GO:0050301": "streptomycin-6-phosphatase activity",
  "GO:0050302": "indole-3-acetaldehyde oxidase activity",
  "GO:0050303": "lysine 6-dehydrogenase activity",
  "GO:0050304": "nitrous-oxide reductase activity",
  "GO:0050305": "strombine dehydrogenase activity",
  "GO:0050306": "sucrose 1F-fructosyltransferase activity",
  "GO:0050307": "sucrose-phosphate phosphatase activity",
  "GO:0050308": "sugar-phosphatase activity",
  "GO:0050309": "sugar-terminal-phosphatase activity",
  "GO:0050310": "sulfite dehydrogenase activity",
  "GO:0050311": "sulfite reductase (ferredoxin) activity",
  "GO:0050312": "sulfoacetaldehyde lyase activity",
  "GO:0050313": "sulfur dioxygenase activity",
  "GO:0050314": "sym-norspermidine synthase activity",
  "GO:0050315": "synephrine dehydratase activity",
  "GO:0050316": "T2-induced deoxynucleotide kinase activity",
  "GO:0050317": "tagatose kinase activity",
  "GO:0050318": "tannase activity",
  "GO:0050319": "tartrate decarboxylase activity",
  "GO:0050320": "tartrate epimerase activity",
  "GO:0050321": "tau-protein kinase activity",
  "GO:0050322": "taurine-2-oxoglutarate transaminase activity",
  "GO:0050323": "taurine dehydrogenase activity",
  "GO:0050324": "taurocyamine kinase activity",
  "GO:0050325": "tauropine dehydrogenase activity",
  "GO:0050326": "taxifolin 8-monooxygenase activity",
  "GO:0050328": "tetrahydroberberine oxidase activity",
  "GO:0050329": "tetrahydroxypteridine cycloisomerase activity",
  "GO:0050330": "theanine hydrolase activity",
  "GO:0050331": "thiamine-diphosphate kinase activity",
  "GO:0050332": "thiamine pyridinylase activity",
  "GO:0050333": "thiamin-triphosphatase activity",
  "GO:0050334": "thiaminase activity",
  "GO:0050335": "thiocyanate isomerase activity",
  "GO:0050336": "thioethanolamine S-acetyltransferase activity",
  "GO:0050337": "thiosulfate-thiol sulfurtransferase activity",
  "GO:0050338": "thiosulfate dehydrogenase activity",
  "GO:0050339": "thymidine-triphosphatase activity",
  "GO:0050340": "thymidylate 5'-phosphatase activity",
  "GO:0050341": "thymine dioxygenase activity",
  "GO:0050342": "tocopherol O-methyltransferase activity",
  "GO:0050343": "trans-2-enoyl-CoA reductase (NAD+) activity",
  "GO:0050344": "trans-cinnamate 2-monooxygenase activity",
  "GO:0050345": "trans-epoxysuccinate hydrolase activity",
  "GO:0050346": "trans-L-3-hydroxyproline dehydratase activity",
  "GO:0050347": "trans-octaprenyltranstransferase activity",
  "GO:0050348": "trehalose O-mycolyltransferase activity",
  "GO:0050349": "triacetate-lactonase activity",
  "GO:0050350": "trihydroxystilbene synthase activity",
  "GO:0050351": "trimetaphosphatase activity",
  "GO:0050352": "trimethylamine-oxide aldolase activity",
  "GO:0050353": "trimethyllysine dioxygenase activity",
  "GO:0050354": "triokinase activity",
  "GO:0050355": "triphosphatase activity",
  "GO:0050356": "tropine dehydrogenase activity",
  "GO:0050357": "tropinesterase activity",
  "GO:0050358": "tropinone reductase activity",
  "GO:0050359": "tropomyosin kinase activity",
  "GO:0050360": "tryptophan 2'-dioxygenase activity",
  "GO:0050361": "tryptophan 2-monooxygenase activity",
  "GO:0050362": "L-tryptophan:2-oxoglutarate aminotransferase activity",
  "GO:0050363": "tryptophan dehydrogenase activity",
  "GO:0050364": "tryptophan dimethylallyltransferase activity",
  "GO:0050365": "tryptophanamidase activity",
  "GO:0050366": "tyramine N-feruloyltransferase activity",
  "GO:0050367": "tyrosine-arginine ligase activity",
  "GO:0050368": "tyrosine 2,3-aminomutase activity",
  "GO:0050369": "[tyrosine 3-monooxygenase] kinase activity",
  "GO:0050370": "tyrosine N-monooxygenase activity",
  "GO:0050371": "tyrosine phenol-lyase activity",
  "GO:0050372": "ubiquitin-calmodulin ligase activity",
  "GO:0050373": "UDP-arabinose 4-epimerase activity",
  "GO:0050374": "UDP-galacturonate decarboxylase activity",
  "GO:0050376": "UDP-glucosamine 4-epimerase activity",
  "GO:0050377": "UDP-glucose 4,6-dehydratase activity",
  "GO:0050378": "UDP-glucuronate 4-epimerase activity",
  "GO:0050379": "UDP-glucuronate 5'-epimerase activity",
  "GO:0050380": "undecaprenyl-diphosphatase activity",
  "GO:0050382": "uracil-5-carboxylate decarboxylase activity",
  "GO:0050383": "uracil dehydrogenase activity",
  "GO:0050384": "urate-ribonucleotide phosphorylase activity",
  "GO:0050385": "ureidoglycolate lyase activity",
  "GO:0050386": "ureidosuccinase activity",
  "GO:0050387": "urethanase activity",
  "GO:0050388": "uronate dehydrogenase activity",
  "GO:0050389": "uronolactonase activity",
  "GO:0050390": "valine decarboxylase activity",
  "GO:0050391": "valine dehydrogenase (NADP) activity",
  "GO:0050392": "vicianin beta-glucosidase activity",
  "GO:0050393": "vinylacetyl-CoA delta-isomerase activity",
  "GO:0050394": "viomycin kinase activity",
  "GO:0050395": "vitexin beta-glucosyltransferase activity",
  "GO:0050396": "vomifoliol 4'-dehydrogenase activity",
  "GO:0050397": "Watasenia-luciferin 2-monooxygenase activity",
  "GO:0050398": "wax-ester hydrolase activity",
  "GO:0050399": "xanthommatin reductase activity",
  "GO:0050400": "xylitol kinase activity",
  "GO:0050401": "xylonate dehydratase activity",
  "GO:0050402": "xylono-1,4-lactonase activity",
  "GO:0050403": "trans-zeatin O-beta-D-glucosyltransferase activity",
  "GO:0050404": "zeatin O-beta-D-xylosyltransferase activity",
  "GO:0050405": "[acetyl-CoA carboxylase] kinase activity",
  "GO:0050406": "[acetyl-CoA carboxylase]-phosphatase activity",
  "GO:0050407": "[glycogen-synthase-D] phosphatase activity",
  "GO:0050408": "[pyruvate kinase]-phosphatase activity",
  "GO:0050409": "indolylacetylinositol arabinosyltransferase activity",
  "GO:0050410": "3-oxolaurate decarboxylase activity",
  "GO:0050411": "agaritine gamma-glutamyltransferase activity",
  "GO:0050412": "cinnamate beta-D-glucosyltransferase activity",
  "GO:0050413": "D-alanine 2-hydroxymethyltransferase activity",
  "GO:0050414": "formimidoylaspartate deiminase activity",
  "GO:0050415": "formimidoylglutamase activity",
  "GO:0050416": "formimidoylglutamate deiminase activity",
  "GO:0050417": "glutamin-(asparagin-)ase activity",
  "GO:0050418": "hydroxylamine reductase activity",
  "GO:0050419": "hydroxymandelonitrile lyase activity",
  "GO:0050420": "maltose synthase activity",
  "GO:0050421": "nitrite reductase (NO-forming) activity",
  "GO:0050422": "strictosidine beta-glucosidase activity",
  "GO:0050423": "thiamine oxidase activity",
  "GO:0050424": "obsolete alanine carboxypeptidase activity",
  "GO:0050425": "obsolete carboxypeptidase B activity",
  "GO:0050426": "obsolete peptidyl-glycinamidase activity",
  "GO:0050427": "3'-phosphoadenosine 5'-phosphosulfate metabolic process",
  "GO:0050428": "3'-phosphoadenosine 5'-phosphosulfate biosynthetic process",
  "GO:0050429": "calcium-dependent phospholipase C activity",
  "GO:0050431": "transforming growth factor beta binding",
  "GO:0050432": "catecholamine secretion",
  "GO:0050433": "regulation of catecholamine secretion",
  "GO:0050434": "positive regulation of viral transcription",
  "GO:0050435": "beta-amyloid metabolic process",
  "GO:0050436": "microfibril binding",
  "GO:0050437": "(-)-endo-fenchol synthase activity",
  "GO:0050438": "2-ethylmalate synthase activity",
  "GO:0050439": "2-hydroxy-3-oxoadipate synthase activity",
  "GO:0050440": "2-methylcitrate synthase activity",
  "GO:0050441": "3-ethylmalate synthase activity",
  "GO:0050442": "3-propylmalate synthase activity",
  "GO:0050444": "aquacobalamin reductase (NADPH) activity",
  "GO:0050445": "asparagusate reductase activity",
  "GO:0050446": "azobenzene reductase activity",
  "GO:0050447": "zeatin 9-aminocarboxyethyltransferase activity",
  "GO:0050448": "beta-cyclopiazonate dehydrogenase activity",
  "GO:0050449": "casbene synthase activity",
  "GO:0050450": "citrate (Re)-synthase activity",
  "GO:0050451": "CoA-disulfide reductase activity",
  "GO:0050452": "CoA-glutathione reductase activity",
  "GO:0050453": "cob(II)alamin reductase activity",
  "GO:0050454": "coenzyme F420 hydrogenase activity",
  "GO:0050455": "columbamine oxidase activity",
  "GO:0050456": "cystine reductase activity",
  "GO:0050457": "decylcitrate synthase activity",
  "GO:0050458": "decylhomocitrate synthase activity",
  "GO:0050459": "ethanolamine-phosphate phospho-lyase activity",
  "GO:0050460": "hydroxylamine reductase (NADH) activity",
  "GO:0050461": "L-mimosine synthase activity",
  "GO:0050462": "N-acetylneuraminate synthase activity",
  "GO:0050463": "nitrate reductase [NAD(P)H] activity",
  "GO:0050464": "nitrate reductase (NADPH) activity",
  "GO:0050465": "nitroquinoline-N-oxide reductase activity",
  "GO:0050466": "obsolete oxidoreductase activity, acting on X-H and Y-H to form an X-Y bond, with other acceptors",
  "GO:0050467": "pentalenene synthase activity",
  "GO:0050468": "reticuline oxidase activity",
  "GO:0050469": "sabinene-hydrate synthase activity",
  "GO:0050470": "trimethylamine dehydrogenase activity",
  "GO:0050471": "uracilylalanine synthase activity",
  "GO:0050472": "zeatin reductase activity",
  "GO:0050473": "arachidonate 15-lipoxygenase activity",
  "GO:0050474": "(S)-norcoclaurine synthase activity",
  "GO:0050476": "acetylenedicarboxylate decarboxylase activity",
  "GO:0050477": "acyl-lysine deacylase activity",
  "GO:0050478": "anthranilate 3-monooxygenase activity",
  "GO:0050479": "glyceryl-ether monooxygenase activity",
  "GO:0050480": "imidazolonepropionase activity",
  "GO:0050481": "mandelate 4-monooxygenase activity",
  "GO:0050482": "arachidonic acid secretion",
  "GO:0050483": "IMP 5'-nucleotidase activity",
  "GO:0050484": "GMP 5'-nucleotidase activity",
  "GO:0050485": "oxidoreductase activity, acting on X-H and Y-H to form an X-Y bond, with a disulfide as acceptor",
  "GO:0050486": "intramolecular transferase activity, transferring hydroxy groups",
  "GO:0050487": "sulfoacetaldehyde acetyltransferase activity",
  "GO:0050488": "ecdysteroid UDP-glucosyltransferase activity",
  "GO:0050490": "1,4-lactonase activity",
  "GO:0050491": "sulcatone reductase activity",
  "GO:0050492": "glycerol-1-phosphate dehydrogenase [NAD(P)+] activity",
  "GO:0050493": "GPI anchor biosynthetic process via N-threonyl-glycosylphosphatidylinositolethanolamine",
  "GO:0050494": "GSI anchor biosynthetic process via N-glycyl-glycosylsphingolipidinositolethanolamine",
  "GO:0050495": "peptidyl-glycyl-phosphatidylethanolamine biosynthetic process from peptidyl-glycine",
  "GO:0050496": "peptidyl-L-glutamyl 5-omega-hydroxyceramide ester biosynthetic process from peptidyl-glutamine",
  "GO:0050497": "transferase activity, transferring alkylthio groups",
  "GO:0050498": "oxidoreductase activity, acting on paired donors, with incorporation or reduction of molecular oxygen, with 2-oxoglutarate as one donor, and the other dehydrogenated",
  "GO:0050499": "oxidoreductase activity, acting on phosphorus or arsenic in donors, with NAD(P)+ as acceptor",
  "GO:0050500": "1,3-beta-galactosyl-N-acetylhexosamine phosphorylase activity",
  "GO:0050501": "hyaluronan synthase activity",
  "GO:0050502": "cis-zeatin O-beta-D-glucosyltransferase activity",
  "GO:0050503": "trehalose 6-phosphate phosphorylase activity",
  "GO:0050504": "mannosyl-3-phosphoglycerate synthase activity",
  "GO:0050505": "hydroquinone glucosyltransferase activity",
  "GO:0050506": "vomilenine glucosyltransferase activity",
  "GO:0050507": "indoxyl-UDPG glucosyltransferase activity",
  "GO:0050508": "glucuronosyl-N-acetylglucosaminyl-proteoglycan 4-alpha-N-acetylglucosaminyltransferase activity",
  "GO:0050509": "N-acetylglucosaminyl-proteoglycan 4-beta-glucuronosyltransferase activity",
  "GO:0050510": "N-acetylgalactosaminyl-proteoglycan 3-beta-glucuronosyltransferase activity",
  "GO:0050511": "undecaprenyldiphospho-muramoylpentapeptide beta-N-acetylglucosaminyltransferase activity",
  "GO:0050512": "lactosylceramide 4-alpha-galactosyltransferase activity",
  "GO:0050513": "glycoprotein 2-beta-D-xylosyltransferase activity",
  "GO:0050514": "homospermidine synthase (spermidine-specific) activity",
  "GO:0050515": "4-(cytidine 5'-diphospho)-2-C-methyl-D-erythritol kinase activity",
  "GO:0050516": "obsolete inositol polyphosphate multikinase activity",
  "GO:0050517": "obsolete inositol hexakisphosphate kinase activity",
  "GO:0050518": "2-C-methyl-D-erythritol 4-phosphate cytidylyltransferase activity",
  "GO:0050519": "holo-citrate lyase synthase activity",
  "GO:0050520": "phosphatidylcholine synthase activity",
  "GO:0050521": "alpha-glucan, water dikinase activity",
  "GO:0050522": "oxidoreductase activity, acting on phosphorus or arsenic in donors, with other known acceptors",
  "GO:0050523": "obsolete oxidoreductase activity, acting on phosphorus or arsenic in donors, with other acceptors",
  "GO:0050524": "coenzyme-B sulfoethylthiotransferase activity",
  "GO:0050525": "cutinase activity",
  "GO:0050526": "poly(3-hydroxybutyrate) depolymerase activity",
  "GO:0050527": "poly(3-hydroxyoctanoate) depolymerase activity",
  "GO:0050528": "acyloxyacyl hydrolase activity",
  "GO:0050529": "polyneuridine-aldehyde esterase activity",
  "GO:0050530": "glucosylglycerol 3-phosphatase activity",
  "GO:0050531": "mannosyl-3-phosphoglycerate phosphatase activity",
  "GO:0050532": "2-phosphosulfolactate phosphatase activity",
  "GO:0050533": "5-phytase activity",
  "GO:0050534": "3-deoxyoctulosonase activity",
  "GO:0050535": "beta-primeverosidase activity",
  "GO:0050536": "(S)-N-acetyl-1-phenylethylamine hydrolase activity",
  "GO:0050537": "mandelamide amidase activity",
  "GO:0050538": "N-carbamoyl-L-amino-acid hydrolase activity",
  "GO:0050539": "maleimide hydrolase activity",
  "GO:0050540": "2-aminomuconate deaminase activity",
  "GO:0050541": "beta,beta-carotene-9',10'-dioxygenase activity",
  "GO:0050542": "icosanoid binding",
  "GO:0050543": "icosatetraenoic acid binding",
  "GO:0050544": "arachidonic acid binding",
  "GO:0050545": "sulfopyruvate decarboxylase activity",
  "GO:0050546": "4-hydroxyphenylpyruvate decarboxylase activity",
  "GO:0050547": "vanillin synthase activity",
  "GO:0050548": "trans-feruloyl-CoA hydratase activity",
  "GO:0050549": "cyclohexyl-isocyanide hydratase activity",
  "GO:0050550": "pinene synthase activity",
  "GO:0050551": "myrcene synthase activity",
  "GO:0050552": "(4S)-limonene synthase activity",
  "GO:0050553": "taxadiene synthase activity",
  "GO:0050554": "abietadiene synthase activity",
  "GO:0050555": "2-hydroxypropyl-CoM lyase activity",
  "GO:0050556": "deacetylisoipecoside synthase activity",
  "GO:0050557": "deacetylipecoside synthase activity",
  "GO:0050558": "maltose epimerase activity",
  "GO:0050559": "copalyl diphosphate synthase activity",
  "GO:0050560": "aspartate-tRNA(Asn) ligase activity",
  "GO:0050561": "glutamate-tRNA(Gln) ligase activity",
  "GO:0050562": "lysine-tRNA(Pyl) ligase activity",
  "GO:0050563": "trans-feruloyl-CoA synthase activity",
  "GO:0050564": "N-(5-amino-5-carboxypentanoyl)-L-cysteinyl-D-valine synthase activity",
  "GO:0050565": "aerobactin synthase activity",
  "GO:0050566": "asparaginyl-tRNA synthase (glutamine-hydrolyzing) activity",
  "GO:0050567": "glutaminyl-tRNA synthase (glutamine-hydrolyzing) activity",
  "GO:0050568": "protein-glutamine glutaminase activity",
  "GO:0050569": "glycolaldehyde dehydrogenase activity",
  "GO:0050570": "4-hydroxythreonine-4-phosphate dehydrogenase activity",
  "GO:0050571": "1,5-anhydro-D-fructose reductase activity",
  "GO:0050572": "L-idonate 5-dehydrogenase activity",
  "GO:0050573": "dTDP-4-dehydro-6-deoxyglucose reductase activity",
  "GO:0050574": "2-(R)-hydroxypropyl-CoM dehydrogenase activity",
  "GO:0050575": "2-(S)-hydroxypropyl-CoM dehydrogenase activity",
  "GO:0050577": "GDP-L-fucose synthase activity",
  "GO:0050578": "(R)-2-hydroxyacid dehydrogenase activity",
  "GO:0050579": "vellosimine dehydrogenase activity",
  "GO:0050580": "2,5-didehydrogluconate reductase activity",
  "GO:0050581": "D-mannitol oxidase activity",
  "GO:0050582": "xylitol oxidase activity",
  "GO:0050583": "hydrogen dehydrogenase (NADP+) activity",
  "GO:0050584": "linoleate 11-lipoxygenase activity",
  "GO:0050585": "4-hydroxymandelate synthase activity",
  "GO:0050586": "3-hydroxy-2-methylquinolin-4-one 2,4-dioxygenase activity",
  "GO:0050587": "chlorite O2-lyase activity",
  "GO:0050588": "apo-beta-carotenoid-14',13'-dioxygenase activity",
  "GO:0050589": "leucocyanidin oxygenase activity",
  "GO:0050590": "desacetoxyvindoline 4-hydroxylase activity",
  "GO:0050591": "quinine 3-monooxygenase activity",
  "GO:0050592": "4-hydroxyphenylacetaldehyde oxime monooxygenase activity",
  "GO:0050593": "N-methylcoclaurine 3'-monooxygenase activity",
  "GO:0050594": "tabersonine 16-hydroxylase activity",
  "GO:0050595": "7-deoxyloganin 7-hydroxylase activity",
  "GO:0050596": "vinorine hydroxylase activity",
  "GO:0050597": "taxane 10-beta-hydroxylase activity",
  "GO:0050598": "taxane 13-alpha-hydroxylase activity",
  "GO:0050599": "deacetoxycephalosporin-C synthase activity",
  "GO:0050600": "myristoyl-CoA 11-(E) desaturase activity",
  "GO:0050601": "myristoyl-CoA 11-(Z) desaturase activity",
  "GO:0050602": "monoprenyl isoflavone epoxidase activity",
  "GO:0050603": "thiophene-2-carbonyl-CoA monooxygenase activity",
  "GO:0050604": "taxadiene 5-alpha-hydroxylase activity",
  "GO:0050605": "superoxide reductase activity",
  "GO:0050606": "4-carboxy-2-hydroxymuconate semialdehyde hemiacetal dehydrogenase activity",
  "GO:0050607": "mycothiol-dependent formaldehyde dehydrogenase activity",
  "GO:0050608": "vanillin dehydrogenase activity",
  "GO:0050609": "phosphonate dehydrogenase activity",
  "GO:0050610": "methylarsonate reductase activity",
  "GO:0050611": "arsenate reductase (azurin) activity",
  "GO:0050612": "arsenate reductase (donor) activity",
  "GO:0050613": "delta14-sterol reductase activity",
  "GO:0050614": "delta24-sterol reductase activity",
  "GO:0050615": "1,2-dihydrovomilenine reductase activity",
  "GO:0050616": "secologanin synthase activity",
  "GO:0050617": "15,16-dihydrobiliverdin:ferredoxin oxidoreductase activity",
  "GO:0050618": "phycoerythrobilin:ferredoxin oxidoreductase activity",
  "GO:0050619": "phytochromobilin:ferredoxin oxidoreductase activity",
  "GO:0050620": "phycocyanobilin:ferredoxin oxidoreductase activity",
  "GO:0050621": "tryptophan alpha,beta-oxidase activity",
  "GO:0050622": "glycine dehydrogenase (cyanide-forming) activity",
  "GO:0050623": "berberine reductase activity",
  "GO:0050624": "vomilenine reductase activity",
  "GO:0050625": "2-hydroxy-1,4-benzoquinone reductase activity",
  "GO:0050626": "trimethylamine-N-oxide reductase (cytochrome c) activity",
  "GO:0050627": "mycothione reductase activity",
  "GO:0050628": "2-oxopropyl-CoM reductase (carboxylating) activity",
  "GO:0050629": "tetrachloroethene reductive dehalogenase activity",
  "GO:0050630": "(iso)eugenol O-methyltransferase activity",
  "GO:0050631": "corydaline synthase activity",
  "GO:0050632": "propionyl-CoA C2-trimethyltridecanoyltransferase activity",
  "GO:0050633": "acetyl-CoA C-myristoyltransferase activity",
  "GO:0050634": "phloroisovalerophenone synthase activity",
  "GO:0050635": "acridone synthase activity",
  "GO:0050636": "vinorine synthase activity",
  "GO:0050637": "lovastatin nonaketide synthase activity",
  "GO:0050638": "taxadien-5-alpha-ol O-acetyltransferase activity",
  "GO:0050639": "10-hydroxytaxane O-acetyltransferase activity",
  "GO:0050640": "isopenicillin-N N-acyltransferase activity",
  "GO:0050641": "6-methylsalicylic acid synthase activity",
  "GO:0050642": "2-alpha-hydroxytaxane 2-O-benzoyltransferase activity",
  "GO:0050643": "10-deacetylbaccatin III 10-O-acetyltransferase activity",
  "GO:0050644": "cis-p-coumarate glucosyltransferase activity",
  "GO:0050645": "limonoid glucosyltransferase activity",
  "GO:0050646": "5-oxo-6E,8Z,11Z,14Z-icosatetraenoic acid binding",
  "GO:0050647": "5-hydroxy-6E,8Z,11Z,14Z-icosatetraenoic acid binding",
  "GO:0050648": "5(S)-hydroxyperoxy-6E,8Z,11Z,14Z-icosatetraenoic acid binding",
  "GO:0050649": "testosterone 6-beta-hydroxylase activity",
  "GO:0050650": "chondroitin sulfate proteoglycan biosynthetic process",
  "GO:0050651": "dermatan sulfate proteoglycan biosynthetic process",
  "GO:0050652": "dermatan sulfate proteoglycan biosynthetic process, polysaccharide chain biosynthetic process",
  "GO:0050653": "chondroitin sulfate proteoglycan biosynthetic process, polysaccharide chain biosynthetic process",
  "GO:0050654": "chondroitin sulfate proteoglycan metabolic process",
  "GO:0050655": "dermatan sulfate proteoglycan metabolic process",
  "GO:0050656": "3'-phosphoadenosine 5'-phosphosulfate binding",
  "GO:0050657": "nucleic acid transport",
  "GO:0050658": "RNA transport",
  "GO:0050659": "N-acetylgalactosamine 4-sulfate 6-O-sulfotransferase activity",
  "GO:0050660": "flavin adenine dinucleotide binding",
  "GO:0050661": "NADP binding",
  "GO:0050662": "coenzyme binding",
  "GO:0050663": "cytokine secretion",
  "GO:0050664": "oxidoreductase activity, acting on NAD(P)H, oxygen as acceptor",
  "GO:0050665": "hydrogen peroxide biosynthetic process",
  "GO:0050666": "regulation of homocysteine metabolic process",
  "GO:0050667": "homocysteine metabolic process",
  "GO:0050668": "positive regulation of homocysteine metabolic process",
  "GO:0050669": "negative regulation of homocysteine metabolic process",
  "GO:0050670": "regulation of lymphocyte proliferation",
  "GO:0050671": "positive regulation of lymphocyte proliferation",
  "GO:0050672": "negative regulation of lymphocyte proliferation",
  "GO:0050673": "epithelial cell proliferation",
  "GO:0050674": "urothelial cell proliferation",
  "GO:0050675": "regulation of urothelial cell proliferation",
  "GO:0050676": "negative regulation of urothelial cell proliferation",
  "GO:0050677": "positive regulation of urothelial cell proliferation",
  "GO:0050678": "regulation of epithelial cell proliferation",
  "GO:0050679": "positive regulation of epithelial cell proliferation",
  "GO:0050680": "negative regulation of epithelial cell proliferation",
  "GO:0050681": "androgen receptor binding",
  "GO:0050682": "AF-2 domain binding",
  "GO:0050683": "AF-1 domain binding",
  "GO:0050684": "regulation of mRNA processing",
  "GO:0050685": "positive regulation of mRNA processing",
  "GO:0050686": "negative regulation of mRNA processing",
  "GO:0050687": "negative regulation of defense response to virus",
  "GO:0050688": "regulation of defense response to virus",
  "GO:0050689": "negative regulation of defense response to virus by host",
  "GO:0050690": "regulation of defense response to virus by virus",
  "GO:0050691": "regulation of defense response to virus by host",
  "GO:0050692": "DBD domain binding",
  "GO:0050693": "LBD domain binding",
  "GO:0050694": "galactose 3-O-sulfotransferase activity",
  "GO:0050695": "benzoylformate decarboxylase activity",
  "GO:0050696": "trichloroethylene catabolic process",
  "GO:0050697": "1,1,2-trichloroethene reductive dehalogenase activity",
  "GO:0050698": "proteoglycan sulfotransferase activity",
  "GO:0050699": "WW domain binding",
  "GO:0050700": "CARD domain binding",
  "GO:0050701": "interleukin-1 secretion",
  "GO:0050702": "interleukin-1 beta secretion",
  "GO:0050703": "interleukin-1 alpha secretion",
  "GO:0050704": "regulation of interleukin-1 secretion",
  "GO:0050705": "regulation of interleukin-1 alpha secretion",
  "GO:0050706": "regulation of interleukin-1 beta secretion",
  "GO:0050707": "regulation of cytokine secretion",
  "GO:0050708": "regulation of protein secretion",
  "GO:0050709": "negative regulation of protein secretion",
  "GO:0050710": "negative regulation of cytokine secretion",
  "GO:0050711": "negative regulation of interleukin-1 secretion",
  "GO:0050712": "negative regulation of interleukin-1 alpha secretion",
  "GO:0050713": "negative regulation of interleukin-1 beta secretion",
  "GO:0050714": "positive regulation of protein secretion",
  "GO:0050715": "positive regulation of cytokine secretion",
  "GO:0050716": "positive regulation of interleukin-1 secretion",
  "GO:0050717": "positive regulation of interleukin-1 alpha secretion",
  "GO:0050718": "positive regulation of interleukin-1 beta secretion",
  "GO:0050719": "interleukin-1 alpha biosynthetic process",
  "GO:0050720": "interleukin-1 beta biosynthetic process",
  "GO:0050721": "regulation of interleukin-1 alpha biosynthetic process",
  "GO:0050722": "regulation of interleukin-1 beta biosynthetic process",
  "GO:0050723": "negative regulation of interleukin-1 alpha biosynthetic process",
  "GO:0050724": "negative regulation of interleukin-1 beta biosynthetic process",
  "GO:0050725": "positive regulation of interleukin-1 beta biosynthetic process",
  "GO:0050726": "positive regulation of interleukin-1 alpha biosynthetic process",
  "GO:0050727": "regulation of inflammatory response",
  "GO:0050728": "negative regulation of inflammatory response",
  "GO:0050729": "positive regulation of inflammatory response",
  "GO:0050730": "regulation of peptidyl-tyrosine phosphorylation",
  "GO:0050731": "positive regulation of peptidyl-tyrosine phosphorylation",
  "GO:0050732": "negative regulation of peptidyl-tyrosine phosphorylation",
  "GO:0050733": "RS domain binding",
  "GO:0050734": "hydroxycinnamoyltransferase activity",
  "GO:0050735": "N-malonyltransferase activity",
  "GO:0050736": "O-malonyltransferase activity",
  "GO:0050737": "O-hydroxycinnamoyltransferase activity",
  "GO:0050738": "fructosyltransferase activity",
  "GO:0050739": "peptide cross-linking via S-[5'-(L-tryptoph-6'-yl)-L-tyrosin-3'-yl]-L-methionin-S-ium",
  "GO:0050740": "protein-FMN linkage via O3-riboflavin phosphoryl-L-threonine",
  "GO:0050741": "protein-FMN linkage via O3-riboflavin phosphoryl-L-serine",
  "GO:0050742": "protein-FMN linkage via S-(4a-FMN)-L-cysteine",
  "GO:0050743": "protein-FMN linkage via 1'-(8alpha-FMN)-L-histidine",
  "GO:0050744": "protein-FMN linkage via 3'-(8alpha-FMN)-L-histidine",
  "GO:0050745": "peptide cross-linking via L-cysteinyl-5-imidazolinone glycine",
  "GO:0050746": "regulation of lipoprotein metabolic process",
  "GO:0050747": "positive regulation of lipoprotein metabolic process",
  "GO:0050748": "negative regulation of lipoprotein metabolic process",
  "GO:0050749": "obsolete apolipoprotein E receptor binding",
  "GO:0050750": "low-density lipoprotein particle receptor binding",
  "GO:0050751": "fractalkine biosynthetic process",
  "GO:0050752": "regulation of fractalkine biosynthetic process",
  "GO:0050753": "negative regulation of fractalkine biosynthetic process",
  "GO:0050754": "positive regulation of fractalkine biosynthetic process",
  "GO:0050755": "chemokine metabolic process",
  "GO:0050756": "fractalkine metabolic process",
  "GO:0050757": "thymidylate synthase biosynthetic process",
  "GO:0050758": "regulation of thymidylate synthase biosynthetic process",
  "GO:0050759": "positive regulation of thymidylate synthase biosynthetic process",
  "GO:0050760": "negative regulation of thymidylate synthase biosynthetic process",
  "GO:0050761": "depsipeptide metabolic process",
  "GO:0050762": "depsipeptide catabolic process",
  "GO:0050763": "depsipeptide biosynthetic process",
  "GO:0050764": "regulation of phagocytosis",
  "GO:0050765": "negative regulation of phagocytosis",
  "GO:0050766": "positive regulation of phagocytosis",
  "GO:0050767": "regulation of neurogenesis",
  "GO:0050768": "negative regulation of neurogenesis",
  "GO:0050769": "positive regulation of neurogenesis",
  "GO:0050770": "regulation of axonogenesis",
  "GO:0050771": "negative regulation of axonogenesis",
  "GO:0050772": "positive regulation of axonogenesis",
  "GO:0050773": "regulation of dendrite development",
  "GO:0050774": "negative regulation of dendrite morphogenesis",
  "GO:0050775": "positive regulation of dendrite morphogenesis",
  "GO:0050776": "regulation of immune response",
  "GO:0050777": "negative regulation of immune response",
  "GO:0050778": "positive regulation of immune response",
  "GO:0050779": "RNA destabilization",
  "GO:0050780": "dopamine receptor binding",
  "GO:0050781": "ortho-trichlorophenol reductive dehalogenase activity",
  "GO:0050782": "galactose uniporter activity",
  "GO:0050783": "cocaine metabolic process",
  "GO:0050784": "cocaine catabolic process",
  "GO:0050785": "advanced glycation end-product receptor activity",
  "GO:0050786": "RAGE receptor binding",
  "GO:0050787": "detoxification of mercury ion",
  "GO:0050788": "sequestering of mercury",
  "GO:0050789": "regulation of biological process",
  "GO:0050790": "regulation of catalytic activity",
  "GO:0050792": "regulation of viral process",
  "GO:0050793": "regulation of developmental process",
  "GO:0050794": "regulation of cellular process",
  "GO:0050795": "regulation of behavior",
  "GO:0050796": "regulation of insulin secretion",
  "GO:0050797": "thymidylate synthase (FAD) activity",
  "GO:0050798": "activated T cell proliferation",
  "GO:0050799": "cocaine biosynthetic process",
  "GO:0050800": "obsolete hydrolase activity, acting on acid anhydrides, acting on GTP, involved in cellular and subcellular movement",
  "GO:0050801": "ion homeostasis",
  "GO:0050802": "circadian sleep/wake cycle, sleep",
  "GO:0050803": "regulation of synapse structure or activity",
  "GO:0050804": "modulation of synaptic transmission",
  "GO:0050805": "negative regulation of synaptic transmission",
  "GO:0050806": "positive regulation of synaptic transmission",
  "GO:0050807": "regulation of synapse organization",
  "GO:0050808": "synapse organization",
  "GO:0050809": "diazepam binding",
  "GO:0050810": "regulation of steroid biosynthetic process",
  "GO:0050811": "GABA receptor binding",
  "GO:0050812": "regulation of acyl-CoA biosynthetic process",
  "GO:0050813": "epothilone metabolic process",
  "GO:0050814": "epothilone biosynthetic process",
  "GO:0050815": "phosphoserine binding",
  "GO:0050816": "phosphothreonine binding",
  "GO:0050817": "coagulation",
  "GO:0050818": "regulation of coagulation",
  "GO:0050819": "negative regulation of coagulation",
  "GO:0050820": "positive regulation of coagulation",
  "GO:0050821": "protein stabilization",
  "GO:0050822": "peptide stabilization",
  "GO:0050823": "peptide antigen stabilization",
  "GO:0050824": "water binding",
  "GO:0050825": "ice binding",
  "GO:0050826": "response to freezing",
  "GO:0050827": "toxin receptor binding",
  "GO:0050828": "regulation of liquid surface tension",
  "GO:0050829": "defense response to Gram-negative bacterium",
  "GO:0050830": "defense response to Gram-positive bacterium",
  "GO:0050831": "male-specific defense response to bacterium",
  "GO:0050832": "defense response to fungus",
  "GO:0050833": "pyruvate transmembrane transporter activity",
  "GO:0050834": "molybdenum incorporation via L-cysteinyl copper sulfido molybdopterin cytosine dinucleotide",
  "GO:0050835": "iron incorporation into iron-sulfur cluster via tris-L-cysteinyl S-adenosylmethion-N,O-diyl tetrairon tetrasulfide",
  "GO:0050836": "iron incorporation into iron-sulfur cluster via tris-L-cysteinyl L-arginyl diiron disulfide",
  "GO:0050837": "peptide cross-linking via L-cysteinyl-L-selenocysteine",
  "GO:0050838": "peptidyl-5-hydroxy-L-lysine trimethylation",
  "GO:0050839": "cell adhesion molecule binding",
  "GO:0050840": "extracellular matrix binding",
  "GO:0050841": "peptidyl-N6,N6,N6-trimethyl-lysine hydroxylation to peptidyl-N6,N6,N6-trimethyl-5-hydroxy-L-lysine",
  "GO:0050842": "copper incorporation via L-cysteinyl copper sulfido molybdopterin cytosine dinucleotide",
  "GO:0050843": "S-adenosylmethionine catabolic process",
  "GO:0050844": "peptidyl-selenocysteine modification",
  "GO:0050845": "teichuronic acid biosynthetic process",
  "GO:0050846": "teichuronic acid metabolic process",
  "GO:0050847": "progesterone receptor signaling pathway",
  "GO:0050848": "regulation of calcium-mediated signaling",
  "GO:0050849": "negative regulation of calcium-mediated signaling",
  "GO:0050850": "positive regulation of calcium-mediated signaling",
  "GO:0050851": "antigen receptor-mediated signaling pathway",
  "GO:0050852": "T cell receptor signaling pathway",
  "GO:0050853": "B cell receptor signaling pathway",
  "GO:0050854": "regulation of antigen receptor-mediated signaling pathway",
  "GO:0050855": "regulation of B cell receptor signaling pathway",
  "GO:0050856": "regulation of T cell receptor signaling pathway",
  "GO:0050857": "positive regulation of antigen receptor-mediated signaling pathway",
  "GO:0050858": "negative regulation of antigen receptor-mediated signaling pathway",
  "GO:0050859": "negative regulation of B cell receptor signaling pathway",
  "GO:0050860": "negative regulation of T cell receptor signaling pathway",
  "GO:0050861": "positive regulation of B cell receptor signaling pathway",
  "GO:0050862": "positive regulation of T cell receptor signaling pathway",
  "GO:0050863": "regulation of T cell activation",
  "GO:0050864": "regulation of B cell activation",
  "GO:0050865": "regulation of cell activation",
  "GO:0050866": "negative regulation of cell activation",
  "GO:0050867": "positive regulation of cell activation",
  "GO:0050868": "negative regulation of T cell activation",
  "GO:0050869": "negative regulation of B cell activation",
  "GO:0050870": "positive regulation of T cell activation",
  "GO:0050871": "positive regulation of B cell activation",
  "GO:0050872": "white fat cell differentiation",
  "GO:0050873": "brown fat cell differentiation",
  "GO:0050877": "neurological system process",
  "GO:0050878": "regulation of body fluid levels",
  "GO:0050879": "multicellular organismal movement",
  "GO:0050880": "regulation of blood vessel size",
  "GO:0050881": "musculoskeletal movement",
  "GO:0050882": "voluntary musculoskeletal movement",
  "GO:0050883": "musculoskeletal movement, spinal reflex action",
  "GO:0050884": "neuromuscular process controlling posture",
  "GO:0050885": "neuromuscular process controlling balance",
  "GO:0050886": "endocrine process",
  "GO:0050887": "determination of sensory modality",
  "GO:0050888": "determination of stimulus location",
  "GO:0050889": "determination of stimulus intensity",
  "GO:0050890": "cognition",
  "GO:0050891": "multicellular organismal water homeostasis",
  "GO:0050892": "intestinal absorption",
  "GO:0050893": "sensory processing",
  "GO:0050894": "determination of affect",
  "GO:0050896": "response to stimulus",
  "GO:0050897": "cobalt ion binding",
  "GO:0050898": "nitrile metabolic process",
  "GO:0050899": "nitrile catabolic process",
  "GO:0050900": "leukocyte migration",
  "GO:0050901": "leukocyte tethering or rolling",
  "GO:0050902": "leukocyte adhesive activation",
  "GO:0050903": "leukocyte activation-dependent arrest",
  "GO:0050904": "diapedesis",
  "GO:0050905": "neuromuscular process",
  "GO:0050906": "detection of stimulus involved in sensory perception",
  "GO:0050907": "detection of chemical stimulus involved in sensory perception",
  "GO:0050908": "detection of light stimulus involved in visual perception",
  "GO:0050909": "sensory perception of taste",
  "GO:0050910": "detection of mechanical stimulus involved in sensory perception of sound",
  "GO:0050911": "detection of chemical stimulus involved in sensory perception of smell",
  "GO:0050912": "detection of chemical stimulus involved in sensory perception of taste",
  "GO:0050913": "sensory perception of bitter taste",
  "GO:0050914": "sensory perception of salty taste",
  "GO:0050915": "sensory perception of sour taste",
  "GO:0050916": "sensory perception of sweet taste",
  "GO:0050917": "sensory perception of umami taste",
  "GO:0050918": "positive chemotaxis",
  "GO:0050919": "negative chemotaxis",
  "GO:0050920": "regulation of chemotaxis",
  "GO:0050921": "positive regulation of chemotaxis",
  "GO:0050922": "negative regulation of chemotaxis",
  "GO:0050923": "regulation of negative chemotaxis",
  "GO:0050924": "positive regulation of negative chemotaxis",
  "GO:0050925": "negative regulation of negative chemotaxis",
  "GO:0050926": "regulation of positive chemotaxis",
  "GO:0050927": "positive regulation of positive chemotaxis",
  "GO:0050928": "negative regulation of positive chemotaxis",
  "GO:0050929": "induction of negative chemotaxis",
  "GO:0050930": "induction of positive chemotaxis",
  "GO:0050931": "pigment cell differentiation",
  "GO:0050932": "regulation of pigment cell differentiation",
  "GO:0050933": "early stripe melanocyte differentiation",
  "GO:0050934": "late stripe melanocyte differentiation",
  "GO:0050935": "iridophore differentiation",
  "GO:0050936": "xanthophore differentiation",
  "GO:0050937": "regulation of iridophore differentiation",
  "GO:0050938": "regulation of xanthophore differentiation",
  "GO:0050939": "regulation of early stripe melanocyte differentiation",
  "GO:0050940": "regulation of late stripe melanocyte differentiation",
  "GO:0050941": "negative regulation of pigment cell differentiation",
  "GO:0050942": "positive regulation of pigment cell differentiation",
  "GO:0050943": "negative regulation of iridophore differentiation",
  "GO:0050944": "negative regulation of xanthophore differentiation",
  "GO:0050945": "positive regulation of iridophore differentiation",
  "GO:0050946": "positive regulation of xanthophore differentiation",
  "GO:0050947": "negative regulation of early stripe melanocyte differentiation",
  "GO:0050948": "positive regulation of early stripe melanocyte differentiation",
  "GO:0050949": "negative regulation of late stripe melanocyte differentiation",
  "GO:0050950": "positive regulation of late stripe melanocyte differentiation",
  "GO:0050951": "sensory perception of temperature stimulus",
  "GO:0050952": "sensory perception of electrical stimulus",
  "GO:0050953": "sensory perception of light stimulus",
  "GO:0050954": "sensory perception of mechanical stimulus",
  "GO:0050955": "thermoception",
  "GO:0050956": "electroception",
  "GO:0050957": "equilibrioception",
  "GO:0050958": "magnetoreception",
  "GO:0050959": "echolocation",
  "GO:0050960": "detection of temperature stimulus involved in thermoception",
  "GO:0050961": "detection of temperature stimulus involved in sensory perception",
  "GO:0050962": "detection of light stimulus involved in sensory perception",
  "GO:0050963": "detection of electrical stimulus involved in sensory perception",
  "GO:0050964": "detection of electrical stimulus involved in electroception",
  "GO:0050965": "detection of temperature stimulus involved in sensory perception of pain",
  "GO:0050966": "detection of mechanical stimulus involved in sensory perception of pain",
  "GO:0050967": "detection of electrical stimulus involved in sensory perception of pain",
  "GO:0050968": "detection of chemical stimulus involved in sensory perception of pain",
  "GO:0050969": "detection of chemical stimulus involved in magnetoreception",
  "GO:0050970": "detection of electrical stimulus involved in magnetoreception",
  "GO:0050971": "detection of mechanical stimulus involved in magnetoreception",
  "GO:0050972": "detection of mechanical stimulus involved in echolocation",
  "GO:0050973": "detection of mechanical stimulus involved in equilibrioception",
  "GO:0050974": "detection of mechanical stimulus involved in sensory perception",
  "GO:0050975": "sensory perception of touch",
  "GO:0050976": "detection of mechanical stimulus involved in sensory perception of touch",
  "GO:0050977": "magnetoreception by sensory perception of chemical stimulus",
  "GO:0050978": "magnetoreception by sensory perception of electrical stimulus",
  "GO:0050979": "magnetoreception by sensory perception of mechanical stimulus",
  "GO:0050980": "detection of light stimulus involved in magnetoreception",
  "GO:0050981": "detection of electrical stimulus",
  "GO:0050982": "detection of mechanical stimulus",
  "GO:0050983": "deoxyhypusine biosynthetic process from spermidine",
  "GO:0050984": "peptidyl-serine sulfation",
  "GO:0050985": "peptidyl-threonine sulfation",
  "GO:0050986": "isopeptide cross-linking via N-(L-isoglutamyl)-glycine",
  "GO:0050987": "enzyme active site formation via O-sulfo-L-serine",
  "GO:0050988": "N-terminal peptidyl-methionine carboxylation",
  "GO:0050989": "N-terminal protein amino acid carboxylation",
  "GO:0050990": "N-terminal protein amino acid carbamoylation",
  "GO:0050991": "enzyme active site formation via O-sulfo-L-threonine",
  "GO:0050992": "dimethylallyl diphosphate biosynthetic process",
  "GO:0050993": "dimethylallyl diphosphate metabolic process",
  "GO:0050994": "regulation of lipid catabolic process",
  "GO:0050995": "negative regulation of lipid catabolic process",
  "GO:0050996": "positive regulation of lipid catabolic process",
  "GO:0050997": "quaternary ammonium group binding",
  "GO:0050998": "nitric-oxide synthase binding",
  "GO:0050999": "regulation of nitric-oxide synthase activity",
  "GO:0051000": "positive regulation of nitric-oxide synthase activity",
  "GO:0051001": "negative regulation of nitric-oxide synthase activity",
  "GO:0051002": "ligase activity, forming nitrogen-metal bonds",
  "GO:0051003": "ligase activity, forming nitrogen-metal bonds, forming coordination complexes",
  "GO:0051004": "regulation of lipoprotein lipase activity",
  "GO:0051005": "negative regulation of lipoprotein lipase activity",
  "GO:0051006": "positive regulation of lipoprotein lipase activity",
  "GO:0051007": "squalene-hopene cyclase activity",
  "GO:0051008": "Hsp27 protein binding",
  "GO:0051009": "O-acetylhomoserine sulfhydrylase activity",
  "GO:0051010": "microtubule plus-end binding",
  "GO:0051011": "microtubule minus-end binding",
  "GO:0051012": "microtubule sliding",
  "GO:0051013": "microtubule severing",
  "GO:0051014": "actin filament severing",
  "GO:0051015": "actin filament binding",
  "GO:0051016": "barbed-end actin filament capping",
  "GO:0051017": "actin filament bundle assembly",
  "GO:0051018": "protein kinase A binding",
  "GO:0051019": "mitogen-activated protein kinase binding",
  "GO:0051020": "GTPase binding",
  "GO:0051021": "GDP-dissociation inhibitor binding",
  "GO:0051022": "Rho GDP-dissociation inhibitor binding",
  "GO:0051023": "regulation of immunoglobulin secretion",
  "GO:0051024": "positive regulation of immunoglobulin secretion",
  "GO:0051025": "negative regulation of immunoglobulin secretion",
  "GO:0051026": "chiasma assembly",
  "GO:0051027": "DNA transport",
  "GO:0051028": "mRNA transport",
  "GO:0051029": "rRNA transport",
  "GO:0051030": "snRNA transport",
  "GO:0051031": "tRNA transport",
  "GO:0051032": "nucleic acid transmembrane transporter activity",
  "GO:0051033": "RNA transmembrane transporter activity",
  "GO:0051034": "tRNA transmembrane transporter activity",
  "GO:0051035": "DNA transmembrane transporter activity",
  "GO:0051036": "regulation of endosome size",
  "GO:0051037": "regulation of transcription involved in meiotic cell cycle",
  "GO:0051038": "negative regulation of transcription involved in meiotic cell cycle",
  "GO:0051039": "positive regulation of transcription involved in meiotic cell cycle",
  "GO:0051040": "regulation of calcium-independent cell-cell adhesion",
  "GO:0051041": "positive regulation of calcium-independent cell-cell adhesion",
  "GO:0051042": "negative regulation of calcium-independent cell-cell adhesion",
  "GO:0051043": "regulation of membrane protein ectodomain proteolysis",
  "GO:0051044": "positive regulation of membrane protein ectodomain proteolysis",
  "GO:0051045": "negative regulation of membrane protein ectodomain proteolysis",
  "GO:0051046": "regulation of secretion",
  "GO:0051047": "positive regulation of secretion",
  "GO:0051048": "negative regulation of secretion",
  "GO:0051049": "regulation of transport",
  "GO:0051050": "positive regulation of transport",
  "GO:0051051": "negative regulation of transport",
  "GO:0051052": "regulation of DNA metabolic process",
  "GO:0051053": "negative regulation of DNA metabolic process",
  "GO:0051054": "positive regulation of DNA metabolic process",
  "GO:0051055": "negative regulation of lipid biosynthetic process",
  "GO:0051056": "regulation of small GTPase mediated signal transduction",
  "GO:0051057": "positive regulation of small GTPase mediated signal transduction",
  "GO:0051058": "negative regulation of small GTPase mediated signal transduction",
  "GO:0051059": "NF-kappaB binding",
  "GO:0051060": "pullulanase activity",
  "GO:0051061": "ADP reductase activity",
  "GO:0051062": "UDP reductase activity",
  "GO:0051063": "CDP reductase activity",
  "GO:0051064": "TTP reductase activity",
  "GO:0051065": "CTP reductase activity",
  "GO:0051066": "dihydrobiopterin metabolic process",
  "GO:0051067": "dihydropteridine metabolic process",
  "GO:0051068": "dihydrolipoamide metabolic process",
  "GO:0051069": "galactomannan metabolic process",
  "GO:0051070": "galactomannan biosynthetic process",
  "GO:0051071": "4,6-pyruvylated galactose residue metabolic process",
  "GO:0051072": "4,6-pyruvylated galactose residue biosynthetic process",
  "GO:0051073": "adenosylcobinamide-GDP ribazoletransferase activity",
  "GO:0051074": "obsolete protein tetramerization activity",
  "GO:0051075": "S-adenosylmethionine:tRNA ribosyltransferase-isomerase activity",
  "GO:0051077": "secondary cell septum",
  "GO:0051078": "meiotic nuclear envelope disassembly",
  "GO:0051079": "meiosis I nuclear envelope disassembly",
  "GO:0051080": "meiosis II nuclear envelope disassembly",
  "GO:0051081": "nuclear envelope disassembly",
  "GO:0051082": "unfolded protein binding",
  "GO:0051083": "'de novo' cotranslational protein folding",
  "GO:0051084": "'de novo' posttranslational protein folding",
  "GO:0051085": "chaperone mediated protein folding requiring cofactor",
  "GO:0051086": "chaperone mediated protein folding independent of cofactor",
  "GO:0051087": "chaperone binding",
  "GO:0051088": "PMA-inducible membrane protein ectodomain proteolysis",
  "GO:0051089": "constitutive protein ectodomain proteolysis",
  "GO:0051090": "regulation of sequence-specific DNA binding transcription factor activity",
  "GO:0051091": "positive regulation of sequence-specific DNA binding transcription factor activity",
  "GO:0051092": "positive regulation of NF-kappaB transcription factor activity",
  "GO:0051093": "negative regulation of developmental process",
  "GO:0051094": "positive regulation of developmental process",
  "GO:0051095": "regulation of helicase activity",
  "GO:0051096": "positive regulation of helicase activity",
  "GO:0051097": "negative regulation of helicase activity",
  "GO:0051098": "regulation of binding",
  "GO:0051099": "positive regulation of binding",
  "GO:0051100": "negative regulation of binding",
  "GO:0051101": "regulation of DNA binding",
  "GO:0051102": "DNA ligation involved in DNA recombination",
  "GO:0051103": "DNA ligation involved in DNA repair",
  "GO:0051104": "DNA-dependent DNA replication DNA ligation",
  "GO:0051105": "regulation of DNA ligation",
  "GO:0051106": "positive regulation of DNA ligation",
  "GO:0051107": "negative regulation of DNA ligation",
  "GO:0051108": "carnitine-CoA ligase activity",
  "GO:0051109": "crotonobetaine-CoA ligase activity",
  "GO:0051110": "peptidyl-histidine uridylylation, to form peptidyl-1'-(phospho-5'-uridine)-L-histidine",
  "GO:0051111": "peptidyl-histidine adenylylation",
  "GO:0051112": "peptidyl-histidine adenylylation, to form peptidyl-1'-(phospho-5'-adenosine)-L-histidine",
  "GO:0051113": "enzyme active site formation via 1'-(phospho-5'-adenosine)-L-histidine",
  "GO:0051114": "peptidyl-histidine uridylylation",
  "GO:0051115": "enzyme active site formation via 1'-(phospho-5'-uridine)-L-histidine",
  "GO:0051116": "cobaltochelatase activity",
  "GO:0051117": "ATPase binding",
  "GO:0051118": "glucan endo-1,3-alpha-glucosidase activity",
  "GO:0051119": "sugar transmembrane transporter activity",
  "GO:0051120": "hepoxilin A3 synthase activity",
  "GO:0051121": "hepoxilin metabolic process",
  "GO:0051122": "hepoxilin biosynthetic process",
  "GO:0051123": "RNA polymerase II transcriptional preinitiation complex assembly",
  "GO:0051124": "synaptic growth at neuromuscular junction",
  "GO:0051125": "regulation of actin nucleation",
  "GO:0051126": "negative regulation of actin nucleation",
  "GO:0051127": "positive regulation of actin nucleation",
  "GO:0051128": "regulation of cellular component organization",
  "GO:0051129": "negative regulation of cellular component organization",
  "GO:0051130": "positive regulation of cellular component organization",
  "GO:0051131": "chaperone-mediated protein complex assembly",
  "GO:0051132": "NK T cell activation",
  "GO:0051133": "regulation of NK T cell activation",
  "GO:0051134": "negative regulation of NK T cell activation",
  "GO:0051135": "positive regulation of NK T cell activation",
  "GO:0051136": "regulation of NK T cell differentiation",
  "GO:0051137": "negative regulation of NK T cell differentiation",
  "GO:0051138": "positive regulation of NK T cell differentiation",
  "GO:0051139": "metal ion:proton antiporter activity",
  "GO:0051140": "regulation of NK T cell proliferation",
  "GO:0051141": "negative regulation of NK T cell proliferation",
  "GO:0051142": "positive regulation of NK T cell proliferation",
  "GO:0051143": "propanediol metabolic process",
  "GO:0051144": "propanediol catabolic process",
  "GO:0051145": "smooth muscle cell differentiation",
  "GO:0051146": "striated muscle cell differentiation",
  "GO:0051147": "regulation of muscle cell differentiation",
  "GO:0051148": "negative regulation of muscle cell differentiation",
  "GO:0051149": "positive regulation of muscle cell differentiation",
  "GO:0051150": "regulation of smooth muscle cell differentiation",
  "GO:0051151": "negative regulation of smooth muscle cell differentiation",
  "GO:0051152": "positive regulation of smooth muscle cell differentiation",
  "GO:0051153": "regulation of striated muscle cell differentiation",
  "GO:0051154": "negative regulation of striated muscle cell differentiation",
  "GO:0051155": "positive regulation of striated muscle cell differentiation",
  "GO:0051156": "glucose 6-phosphate metabolic process",
  "GO:0051157": "arabitol catabolic process",
  "GO:0051158": "L-arabitol catabolic process",
  "GO:0051159": "D-arabitol catabolic process",
  "GO:0051160": "L-xylitol catabolic process",
  "GO:0051161": "arabitol metabolic process",
  "GO:0051162": "L-arabitol metabolic process",
  "GO:0051163": "D-arabitol metabolic process",
  "GO:0051164": "L-xylitol metabolic process",
  "GO:0051165": "2,5-dihydroxypyridine metabolic process",
  "GO:0051166": "2,5-dihydroxypyridine catabolic process",
  "GO:0051167": "xylulose 5-phosphate metabolic process",
  "GO:0051168": "nuclear export",
  "GO:0051169": "nuclear transport",
  "GO:0051170": "nuclear import",
  "GO:0051171": "regulation of nitrogen compound metabolic process",
  "GO:0051172": "negative regulation of nitrogen compound metabolic process",
  "GO:0051173": "positive regulation of nitrogen compound metabolic process",
  "GO:0051174": "regulation of phosphorus metabolic process",
  "GO:0051175": "negative regulation of sulfur metabolic process",
  "GO:0051176": "positive regulation of sulfur metabolic process",
  "GO:0051177": "meiotic sister chromatid cohesion",
  "GO:0051178": "meiotic chromosome decondensation",
  "GO:0051179": "localization",
  "GO:0051180": "vitamin transport",
  "GO:0051181": "cofactor transport",
  "GO:0051182": "coenzyme transport",
  "GO:0051183": "vitamin transporter activity",
  "GO:0051184": "cofactor transporter activity",
  "GO:0051185": "coenzyme transporter activity",
  "GO:0051186": "cofactor metabolic process",
  "GO:0051187": "cofactor catabolic process",
  "GO:0051188": "cofactor biosynthetic process",
  "GO:0051189": "prosthetic group metabolic process",
  "GO:0051190": "prosthetic group catabolic process",
  "GO:0051191": "prosthetic group biosynthetic process",
  "GO:0051192": "prosthetic group binding",
  "GO:0051193": "regulation of cofactor metabolic process",
  "GO:0051194": "positive regulation of cofactor metabolic process",
  "GO:0051195": "negative regulation of cofactor metabolic process",
  "GO:0051196": "regulation of coenzyme metabolic process",
  "GO:0051197": "positive regulation of coenzyme metabolic process",
  "GO:0051198": "negative regulation of coenzyme metabolic process",
  "GO:0051199": "regulation of prosthetic group metabolic process",
  "GO:0051200": "positive regulation of prosthetic group metabolic process",
  "GO:0051201": "negative regulation of prosthetic group metabolic process",
  "GO:0051202": "phytochromobilin metabolic process",
  "GO:0051203": "peptidyl-aspartic acid reduction to form L-aspartyl aldehyde",
  "GO:0051204": "protein insertion into mitochondrial membrane",
  "GO:0051205": "protein insertion into membrane",
  "GO:0051206": "silicate metabolic process",
  "GO:0051208": "sequestering of calcium ion",
  "GO:0051209": "release of sequestered calcium ion into cytosol",
  "GO:0051210": "isotropic cell growth",
  "GO:0051211": "anisotropic cell growth",
  "GO:0051212": "vanadium ion binding",
  "GO:0051213": "dioxygenase activity",
  "GO:0051214": "RNA virus induced gene silencing",
  "GO:0051215": "DNA virus induced gene silencing",
  "GO:0051216": "cartilage development",
  "GO:0051217": "molybdenum incorporation via L-aspartyl molybdenum bis(molybdopterin guanine dinucleotide)",
  "GO:0051218": "tungsten incorporation via L-selenocysteinyl tungsten bis(molybdopterin guanine dinucleotide)",
  "GO:0051219": "phosphoprotein binding",
  "GO:0051220": "cytoplasmic sequestering of protein",
  "GO:0051221": "tungsten incorporation into metallo-sulfur cluster",
  "GO:0051222": "positive regulation of protein transport",
  "GO:0051223": "regulation of protein transport",
  "GO:0051224": "negative regulation of protein transport",
  "GO:0051225": "spindle assembly",
  "GO:0051228": "mitotic spindle disassembly",
  "GO:0051229": "meiotic spindle disassembly",
  "GO:0051230": "spindle disassembly",
  "GO:0051231": "spindle elongation",
  "GO:0051232": "meiotic spindle elongation",
  "GO:0051233": "spindle midzone",
  "GO:0051234": "establishment of localization",
  "GO:0051235": "maintenance of location",
  "GO:0051236": "establishment of RNA localization",
  "GO:0051237": "maintenance of RNA location",
  "GO:0051238": "sequestering of metal ion",
  "GO:0051239": "regulation of multicellular organismal process",
  "GO:0051240": "positive regulation of multicellular organismal process",
  "GO:0051241": "negative regulation of multicellular organismal process",
  "GO:0051245": "negative regulation of cellular defense response",
  "GO:0051246": "regulation of protein metabolic process",
  "GO:0051247": "positive regulation of protein metabolic process",
  "GO:0051248": "negative regulation of protein metabolic process",
  "GO:0051249": "regulation of lymphocyte activation",
  "GO:0051250": "negative regulation of lymphocyte activation",
  "GO:0051251": "positive regulation of lymphocyte activation",
  "GO:0051252": "regulation of RNA metabolic process",
  "GO:0051253": "negative regulation of RNA metabolic process",
  "GO:0051254": "positive regulation of RNA metabolic process",
  "GO:0051255": "spindle midzone assembly",
  "GO:0051256": "mitotic spindle midzone assembly",
  "GO:0051257": "meiotic spindle midzone assembly",
  "GO:0051258": "protein polymerization",
  "GO:0051259": "protein oligomerization",
  "GO:0051260": "protein homooligomerization",
  "GO:0051261": "protein depolymerization",
  "GO:0051262": "protein tetramerization",
  "GO:0051263": "microcin E492 biosynthetic process by siderophore ester modification of peptidyl-serine",
  "GO:0051264": "mono-olein transacylation activity",
  "GO:0051265": "diolein transacylation activity",
  "GO:0051266": "sirohydrochlorin ferrochelatase activity",
  "GO:0051267": "CP2 mannose-ethanolamine phosphotransferase activity",
  "GO:0051268": "alpha-keto amide reductase activity",
  "GO:0051269": "alpha-keto ester reductase activity",
  "GO:0051270": "regulation of cellular component movement",
  "GO:0051271": "negative regulation of cellular component movement",
  "GO:0051272": "positive regulation of cellular component movement",
  "GO:0051273": "beta-glucan metabolic process",
  "GO:0051274": "beta-glucan biosynthetic process",
  "GO:0051275": "beta-glucan catabolic process",
  "GO:0051276": "chromosome organization",
  "GO:0051278": "fungal-type cell wall polysaccharide biosynthetic process",
  "GO:0051279": "regulation of release of sequestered calcium ion into cytosol",
  "GO:0051280": "negative regulation of release of sequestered calcium ion into cytosol",
  "GO:0051281": "positive regulation of release of sequestered calcium ion into cytosol",
  "GO:0051282": "regulation of sequestering of calcium ion",
  "GO:0051283": "negative regulation of sequestering of calcium ion",
  "GO:0051284": "positive regulation of sequestering of calcium ion",
  "GO:0051285": "cell cortex of cell tip",
  "GO:0051286": "cell tip",
  "GO:0051287": "NAD binding",
  "GO:0051289": "protein homotetramerization",
  "GO:0051290": "protein heterotetramerization",
  "GO:0051291": "protein heterooligomerization",
  "GO:0051292": "nuclear pore complex assembly",
  "GO:0051293": "establishment of spindle localization",
  "GO:0051294": "establishment of spindle orientation",
  "GO:0051295": "establishment of meiotic spindle localization",
  "GO:0051296": "establishment of meiotic spindle orientation",
  "GO:0051297": "centrosome organization",
  "GO:0051298": "centrosome duplication",
  "GO:0051299": "centrosome separation",
  "GO:0051300": "spindle pole body organization",
  "GO:0051301": "cell division",
  "GO:0051302": "regulation of cell division",
  "GO:0051303": "establishment of chromosome localization",
  "GO:0051304": "chromosome separation",
  "GO:0051305": "chromosome movement towards spindle pole",
  "GO:0051306": "mitotic sister chromatid separation",
  "GO:0051307": "meiotic chromosome separation",
  "GO:0051308": "male meiosis chromosome separation",
  "GO:0051309": "female meiosis chromosome separation",
  "GO:0051310": "metaphase plate congression",
  "GO:0051311": "meiotic metaphase plate congression",
  "GO:0051312": "chromosome decondensation",
  "GO:0051315": "attachment of mitotic spindle microtubules to kinetochore",
  "GO:0051316": "attachment of spindle microtubules to kinetochore involved in meiotic chromosome segregation",
  "GO:0051318": "G1 phase",
  "GO:0051319": "G2 phase",
  "GO:0051320": "S phase",
  "GO:0051321": "meiotic cell cycle",
  "GO:0051322": "anaphase",
  "GO:0051323": "metaphase",
  "GO:0051324": "prophase",
  "GO:0051325": "interphase",
  "GO:0051326": "telophase",
  "GO:0051327": "meiotic M phase",
  "GO:0051328": "meiotic interphase",
  "GO:0051329": "mitotic interphase",
  "GO:0051330": "meiotic G1 phase",
  "GO:0051331": "meiotic G2 phase",
  "GO:0051332": "meiotic S phase",
  "GO:0051333": "meiotic nuclear envelope reassembly",
  "GO:0051334": "meiosis I nuclear envelope reassembly",
  "GO:0051335": "meiosis II nuclear envelope reassembly",
  "GO:0051336": "regulation of hydrolase activity",
  "GO:0051337": "amitosis",
  "GO:0051338": "regulation of transferase activity",
  "GO:0051339": "regulation of lyase activity",
  "GO:0051340": "regulation of ligase activity",
  "GO:0051341": "regulation of oxidoreductase activity",
  "GO:0051342": "regulation of cyclic-nucleotide phosphodiesterase activity",
  "GO:0051343": "positive regulation of cyclic-nucleotide phosphodiesterase activity",
  "GO:0051344": "negative regulation of cyclic-nucleotide phosphodiesterase activity",
  "GO:0051345": "positive regulation of hydrolase activity",
  "GO:0051346": "negative regulation of hydrolase activity",
  "GO:0051347": "positive regulation of transferase activity",
  "GO:0051348": "negative regulation of transferase activity",
  "GO:0051349": "positive regulation of lyase activity",
  "GO:0051350": "negative regulation of lyase activity",
  "GO:0051351": "positive regulation of ligase activity",
  "GO:0051352": "negative regulation of ligase activity",
  "GO:0051353": "positive regulation of oxidoreductase activity",
  "GO:0051354": "negative regulation of oxidoreductase activity",
  "GO:0051355": "proprioception involved in equilibrioception",
  "GO:0051356": "visual perception involved in equilibrioception",
  "GO:0051357": "peptide cross-linking via 3-(2-methylthio)ethyl-6-(4-hydroxybenzylidene)-5-iminopiperazin-2-one",
  "GO:0051358": "peptide cross-linking via 2-imino-glutamic acid 5-imidazolinone glycine",
  "GO:0051359": "peptide cross-linking via 2-imino-methionine 5-imidazolinone glycine",
  "GO:0051360": "peptide cross-linking via L-asparagine 5-imidazolinone glycine",
  "GO:0051361": "peptide cross-linking via L-lysine 5-imidazolinone glycine",
  "GO:0051362": "peptide cross-linking via 2-tetrahydropyridinyl-5-imidazolinone glycine",
  "GO:0051363": "peptidoglycan-protein cross-linking via L-alanyl-pentaglycyl-murein",
  "GO:0051364": "N-terminal peptidyl-proline N-formylation",
  "GO:0051365": "cellular response to potassium ion starvation",
  "GO:0051366": "protein decanoylation",
  "GO:0051367": "peptidyl-serine decanoylation",
  "GO:0051368": "peptidyl-threonine octanoylation",
  "GO:0051369": "peptidyl-threonine decanoylation",
  "GO:0051370": "obsolete ZASP binding",
  "GO:0051371": "muscle alpha-actinin binding",
  "GO:0051373": "FATZ binding",
  "GO:0051377": "mannose-ethanolamine phosphotransferase activity",
  "GO:0051378": "serotonin binding",
  "GO:0051379": "epinephrine binding",
  "GO:0051380": "norepinephrine binding",
  "GO:0051381": "histamine binding",
  "GO:0051382": "kinetochore assembly",
  "GO:0051383": "kinetochore organization",
  "GO:0051384": "response to glucocorticoid",
  "GO:0051385": "response to mineralocorticoid",
  "GO:0051386": "regulation of neurotrophin TRK receptor signaling pathway",
  "GO:0051387": "negative regulation of neurotrophin TRK receptor signaling pathway",
  "GO:0051388": "positive regulation of neurotrophin TRK receptor signaling pathway",
  "GO:0051389": "inactivation of MAPKK activity",
  "GO:0051390": "inactivation of MAPKKK activity",
  "GO:0051391": "tRNA acetylation",
  "GO:0051392": "tRNA N-acetyltransferase activity",
  "GO:0051393": "alpha-actinin binding",
  "GO:0051394": "regulation of nerve growth factor receptor activity",
  "GO:0051395": "negative regulation of nerve growth factor receptor activity",
  "GO:0051396": "positive regulation of nerve growth factor receptor activity",
  "GO:0051397": "obsolete N-terminal basic amino acid aminopeptidase activity",
  "GO:0051398": "obsolete N-terminal lysine aminopeptidase activity",
  "GO:0051399": "obsolete N-terminal arginine aminopeptidase activity",
  "GO:0051400": "BH domain binding",
  "GO:0051401": "CH domain binding",
  "GO:0051402": "neuron apoptotic process",
  "GO:0051403": "stress-activated MAPK cascade",
  "GO:0051404": "obsolete clostripain activity",
  "GO:0051405": "obsolete microbial collagenase activity",
  "GO:0051407": "glycerone phosphate:inorganic phosphate antiporter activity",
  "GO:0051408": "glyceraldehyde 3-phosphate:inorganic phosphate antiporter activity",
  "GO:0051409": "response to nitrosative stress",
  "GO:0051410": "detoxification of nitrogen compound",
  "GO:0051411": "obsolete ALP binding",
  "GO:0051412": "response to corticosterone",
  "GO:0051413": "response to cortisone",
  "GO:0051414": "response to cortisol",
  "GO:0051415": "interphase microtubule nucleation by interphase microtubule organizing center",
  "GO:0051416": "obsolete myotilin binding",
  "GO:0051417": "microtubule nucleation by spindle pole body",
  "GO:0051418": "microtubule nucleation by microtubule organizing center",
  "GO:0051419": "obsolete nebulin binding",
  "GO:0051420": "obsolete nebulette binding",
  "GO:0051421": "regulation of endo-1,4-beta-xylanase activity",
  "GO:0051422": "negative regulation of endo-1,4-beta-xylanase activity",
  "GO:0051423": "positive regulation of endo-1,4-beta-xylanase activity",
  "GO:0051424": "corticotropin-releasing hormone binding",
  "GO:0051425": "PTB domain binding",
  "GO:0051427": "hormone receptor binding",
  "GO:0051428": "peptide hormone receptor binding",
  "GO:0051429": "corticotropin-releasing hormone receptor binding",
  "GO:0051430": "corticotropin-releasing hormone receptor 1 binding",
  "GO:0051431": "corticotropin-releasing hormone receptor 2 binding",
  "GO:0051432": "BH1 domain binding",
  "GO:0051433": "BH2 domain binding",
  "GO:0051434": "BH3 domain binding",
  "GO:0051435": "BH4 domain binding",
  "GO:0051436": "negative regulation of ubiquitin-protein ligase activity involved in mitotic cell cycle",
  "GO:0051437": "positive regulation of ubiquitin-protein ligase activity involved in regulation of mitotic cell cycle transition",
  "GO:0051438": "regulation of ubiquitin-protein transferase activity",
  "GO:0051439": "regulation of ubiquitin-protein ligase activity involved in mitotic cell cycle",
  "GO:0051440": "regulation of ubiquitin-protein ligase activity involved in meiotic cell cycle",
  "GO:0051441": "positive regulation of ubiquitin-protein ligase activity involved in meiotic cell cycle",
  "GO:0051442": "negative regulation of ubiquitin-protein ligase activity involved in meiotic cell cycle",
  "GO:0051443": "positive regulation of ubiquitin-protein transferase activity",
  "GO:0051444": "negative regulation of ubiquitin-protein transferase activity",
  "GO:0051445": "regulation of meiotic cell cycle",
  "GO:0051446": "positive regulation of meiotic cell cycle",
  "GO:0051447": "negative regulation of meiotic cell cycle",
  "GO:0051448": "gonadotropin-releasing hormone binding",
  "GO:0051449": "thyrotropin-releasing hormone binding",
  "GO:0051450": "myoblast proliferation",
  "GO:0051451": "myoblast migration",
  "GO:0051452": "intracellular pH reduction",
  "GO:0051453": "regulation of intracellular pH",
  "GO:0051454": "intracellular pH elevation",
  "GO:0051455": "attachment of spindle microtubules to kinetochore involved in homologous chromosome segregation",
  "GO:0051456": "attachment of spindle microtubules to kinetochore involved in meiotic sister chromatid segregation",
  "GO:0051457": "maintenance of protein location in nucleus",
  "GO:0051458": "corticotropin secretion",
  "GO:0051459": "regulation of corticotropin secretion",
  "GO:0051460": "negative regulation of corticotropin secretion",
  "GO:0051461": "positive regulation of corticotropin secretion",
  "GO:0051462": "regulation of cortisol secretion",
  "GO:0051463": "negative regulation of cortisol secretion",
  "GO:0051464": "positive regulation of cortisol secretion",
  "GO:0051465": "negative regulation of corticotropin-releasing hormone secretion",
  "GO:0051466": "positive regulation of corticotropin-releasing hormone secretion",
  "GO:0051467": "detection of steroid hormone stimulus",
  "GO:0051468": "detection of glucocorticoid hormone stimulus",
  "GO:0051469": "vesicle fusion with vacuole",
  "GO:0051470": "ectoine transport",
  "GO:0051471": "ectoine transmembrane transporter activity",
  "GO:0051472": "glucosylglycerol metabolic process",
  "GO:0051473": "glucosylglycerol biosynthetic process",
  "GO:0051474": "glucosylglycerol transmembrane transporter activity",
  "GO:0051475": "glucosylglycerol transport",
  "GO:0051476": "mannosylglycerate transport",
  "GO:0051477": "mannosylglycerate transmembrane transporter activity",
  "GO:0051478": "mannosylglycerate metabolic process",
  "GO:0051479": "mannosylglycerate biosynthetic process",
  "GO:0051480": "regulation of cytosolic calcium ion concentration",
  "GO:0051481": "negative regulation of cytosolic calcium ion concentration",
  "GO:0051482": "positive regulation of cytosolic calcium ion concentration involved in phospholipase C-activating G-protein coupled signaling pathway",
  "GO:0051483": "terpenoid biosynthetic process, mevalonate-independent",
  "GO:0051484": "isopentenyl diphosphate biosynthetic process, methylerythritol 4-phosphate pathway involved in terpenoid biosynthetic process",
  "GO:0051485": "terpenoid biosynthetic process, mevalonate-dependent",
  "GO:0051486": "isopentenyl diphosphate biosynthetic process, mevalonate pathway involved in terpenoid biosynthetic process",
  "GO:0051487": "activation of anaphase-promoting complex activity involved in meiotic cell cycle",
  "GO:0051488": "activation of anaphase-promoting complex activity",
  "GO:0051489": "regulation of filopodium assembly",
  "GO:0051490": "negative regulation of filopodium assembly",
  "GO:0051491": "positive regulation of filopodium assembly",
  "GO:0051492": "regulation of stress fiber assembly",
  "GO:0051493": "regulation of cytoskeleton organization",
  "GO:0051494": "negative regulation of cytoskeleton organization",
  "GO:0051495": "positive regulation of cytoskeleton organization",
  "GO:0051496": "positive regulation of stress fiber assembly",
  "GO:0051497": "negative regulation of stress fiber assembly",
  "GO:0051498": "syn-copalyl diphosphate synthase activity",
  "GO:0051499": "D-aminoacyl-tRNA deacylase activity",
  "GO:0051500": "D-tyrosyl-tRNA(Tyr) deacylase activity",
  "GO:0051501": "diterpene phytoalexin metabolic process",
  "GO:0051502": "diterpene phytoalexin biosynthetic process",
  "GO:0051503": "adenine nucleotide transport",
  "GO:0051504": "diterpene phytoalexin precursor biosynthetic process pathway",
  "GO:0051505": "cholesterol UDP-glucosyltransferase activity",
  "GO:0051506": "ergosterol UDP-glucosyltransferase activity",
  "GO:0051507": "beta-sitosterol UDP-glucosyltransferase activity",
  "GO:0051508": "stigmasterol UDP-glucosyltransferase activity",
  "GO:0051509": "tomatidine UDP-glucosyltransferase activity",
  "GO:0051510": "regulation of unidimensional cell growth",
  "GO:0051511": "negative regulation of unidimensional cell growth",
  "GO:0051512": "positive regulation of unidimensional cell growth",
  "GO:0051513": "regulation of monopolar cell growth",
  "GO:0051514": "negative regulation of monopolar cell growth",
  "GO:0051515": "positive regulation of monopolar cell growth",
  "GO:0051516": "regulation of bipolar cell growth",
  "GO:0051517": "negative regulation of bipolar cell growth",
  "GO:0051518": "positive regulation of bipolar cell growth",
  "GO:0051519": "activation of bipolar cell growth",
  "GO:0051520": "termination of bipolar cell growth",
  "GO:0051521": "termination of monopolar cell growth",
  "GO:0051522": "activation of monopolar cell growth",
  "GO:0051523": "cell growth mode switching, monopolar to bipolar",
  "GO:0051524": "cell growth mode switching, bipolar to monopolar",
  "GO:0051525": "NFAT protein binding",
  "GO:0051531": "NFAT protein import into nucleus",
  "GO:0051532": "regulation of NFAT protein import into nucleus",
  "GO:0051533": "positive regulation of NFAT protein import into nucleus",
  "GO:0051534": "negative regulation of NFAT protein import into nucleus",
  "GO:0051536": "iron-sulfur cluster binding",
  "GO:0051537": "2 iron, 2 sulfur cluster binding",
  "GO:0051538": "3 iron, 4 sulfur cluster binding",
  "GO:0051539": "4 iron, 4 sulfur cluster binding",
  "GO:0051540": "metal cluster binding",
  "GO:0051541": "elastin metabolic process",
  "GO:0051542": "elastin biosynthetic process",
  "GO:0051543": "regulation of elastin biosynthetic process",
  "GO:0051544": "positive regulation of elastin biosynthetic process",
  "GO:0051545": "negative regulation of elastin biosynthetic process",
  "GO:0051546": "keratinocyte migration",
  "GO:0051547": "regulation of keratinocyte migration",
  "GO:0051548": "negative regulation of keratinocyte migration",
  "GO:0051549": "positive regulation of keratinocyte migration",
  "GO:0051550": "aurone metabolic process",
  "GO:0051551": "aurone biosynthetic process",
  "GO:0051552": "flavone metabolic process",
  "GO:0051553": "flavone biosynthetic process",
  "GO:0051554": "flavonol metabolic process",
  "GO:0051555": "flavonol biosynthetic process",
  "GO:0051556": "leucoanthocyanidin metabolic process",
  "GO:0051557": "leucoanthocyanidin biosynthetic process",
  "GO:0051558": "phlobaphene metabolic process",
  "GO:0051559": "phlobaphene biosynthetic process",
  "GO:0051560": "mitochondrial calcium ion homeostasis",
  "GO:0051561": "positive regulation of mitochondrial calcium ion concentration",
  "GO:0051562": "negative regulation of mitochondrial calcium ion concentration",
  "GO:0051563": "smooth endoplasmic reticulum calcium ion homeostasis",
  "GO:0051564": "positive regulation of smooth endoplasmic reticulum calcium ion concentration",
  "GO:0051565": "negative regulation of smooth endoplasmic reticulum calcium ion concentration",
  "GO:0051566": "anthocyanidin-3-glucoside rhamnosyltransferase activity",
  "GO:0051567": "histone H3-K9 methylation",
  "GO:0051568": "histone H3-K4 methylation",
  "GO:0051569": "regulation of histone H3-K4 methylation",
  "GO:0051570": "regulation of histone H3-K9 methylation",
  "GO:0051571": "positive regulation of histone H3-K4 methylation",
  "GO:0051572": "negative regulation of histone H3-K4 methylation",
  "GO:0051573": "negative regulation of histone H3-K9 methylation",
  "GO:0051574": "positive regulation of histone H3-K9 methylation",
  "GO:0051575": "5'-deoxyribose-5-phosphate lyase activity",
  "GO:0051580": "regulation of neurotransmitter uptake",
  "GO:0051581": "negative regulation of neurotransmitter uptake",
  "GO:0051582": "positive regulation of neurotransmitter uptake",
  "GO:0051583": "dopamine uptake involved in synaptic transmission",
  "GO:0051584": "regulation of dopamine uptake involved in synaptic transmission",
  "GO:0051585": "negative regulation of dopamine uptake involved in synaptic transmission",
  "GO:0051586": "positive regulation of dopamine uptake involved in synaptic transmission",
  "GO:0051587": "inhibition of dopamine uptake involved in synaptic transmission",
  "GO:0051588": "regulation of neurotransmitter transport",
  "GO:0051589": "negative regulation of neurotransmitter transport",
  "GO:0051590": "positive regulation of neurotransmitter transport",
  "GO:0051591": "response to cAMP",
  "GO:0051592": "response to calcium ion",
  "GO:0051593": "response to folic acid",
  "GO:0051594": "detection of glucose",
  "GO:0051595": "response to methylglyoxal",
  "GO:0051596": "methylglyoxal catabolic process",
  "GO:0051597": "response to methylmercury",
  "GO:0051598": "meiotic recombination checkpoint",
  "GO:0051599": "response to hydrostatic pressure",
  "GO:0051600": "regulation of endocytosis by exocyst localization",
  "GO:0051601": "exocyst localization",
  "GO:0051602": "response to electrical stimulus",
  "GO:0051603": "proteolysis involved in cellular protein catabolic process",
  "GO:0051604": "protein maturation",
  "GO:0051606": "detection of stimulus",
  "GO:0051607": "defense response to virus",
  "GO:0051608": "histamine transport",
  "GO:0051609": "inhibition of neurotransmitter uptake",
  "GO:0051610": "serotonin uptake",
  "GO:0051611": "regulation of serotonin uptake",
  "GO:0051612": "negative regulation of serotonin uptake",
  "GO:0051613": "positive regulation of serotonin uptake",
  "GO:0051614": "inhibition of serotonin uptake",
  "GO:0051615": "histamine uptake",
  "GO:0051616": "regulation of histamine uptake",
  "GO:0051617": "negative regulation of histamine uptake",
  "GO:0051618": "positive regulation of histamine uptake",
  "GO:0051619": "inhibition of histamine uptake",
  "GO:0051620": "norepinephrine uptake",
  "GO:0051621": "regulation of norepinephrine uptake",
  "GO:0051622": "negative regulation of norepinephrine uptake",
  "GO:0051623": "positive regulation of norepinephrine uptake",
  "GO:0051624": "inhibition of norepinephrine uptake",
  "GO:0051625": "epinephrine uptake",
  "GO:0051626": "regulation of epinephrine uptake",
  "GO:0051627": "negative regulation of epinephrine uptake",
  "GO:0051628": "positive regulation of epinephrine uptake",
  "GO:0051629": "inhibition of epinephrine uptake",
  "GO:0051630": "acetylcholine uptake",
  "GO:0051631": "regulation of acetylcholine uptake",
  "GO:0051632": "negative regulation of acetylcholine uptake",
  "GO:0051633": "positive regulation of acetylcholine uptake",
  "GO:0051634": "inhibition of acetylcholine uptake",
  "GO:0051635": "obsolete bacterial cell surface binding",
  "GO:0051636": "obsolete Gram-negative bacterial cell surface binding",
  "GO:0051637": "obsolete Gram-positive bacterial cell surface binding",
  "GO:0051638": "barbed-end actin filament uncapping",
  "GO:0051639": "actin filament network formation",
  "GO:0051640": "organelle localization",
  "GO:0051641": "cellular localization",
  "GO:0051642": "centrosome localization",
  "GO:0051643": "endoplasmic reticulum localization",
  "GO:0051644": "plastid localization",
  "GO:0051645": "Golgi localization",
  "GO:0051646": "mitochondrion localization",
  "GO:0051647": "nucleus localization",
  "GO:0051648": "vesicle localization",
  "GO:0051649": "establishment of localization in cell",
  "GO:0051650": "establishment of vesicle localization",
  "GO:0051651": "maintenance of location in cell",
  "GO:0051652": "maintenance of chromosome location",
  "GO:0051653": "spindle localization",
  "GO:0051654": "establishment of mitochondrion localization",
  "GO:0051655": "maintenance of vesicle location",
  "GO:0051656": "establishment of organelle localization",
  "GO:0051657": "maintenance of organelle location",
  "GO:0051658": "maintenance of nucleus location",
  "GO:0051659": "maintenance of mitochondrion location",
  "GO:0051660": "establishment of centrosome localization",
  "GO:0051661": "maintenance of centrosome location",
  "GO:0051663": "oocyte nucleus localization involved in oocyte dorsal/ventral axis specification",
  "GO:0051664": "nuclear pore localization",
  "GO:0051665": "membrane raft localization",
  "GO:0051666": "actin cortical patch localization",
  "GO:0051667": "establishment of plastid localization",
  "GO:0051668": "localization within membrane",
  "GO:0051669": "fructan beta-fructosidase activity",
  "GO:0051670": "inulinase activity",
  "GO:0051671": "induction of autolysin activity in other organism",
  "GO:0051672": "catabolism by organism of cell wall peptidoglycan in other organism",
  "GO:0051673": "membrane disruption in other organism",
  "GO:0051674": "localization of cell",
  "GO:0051675": "isopullulanase activity",
  "GO:0051676": "pullulan metabolic process",
  "GO:0051677": "pullulan biosynthetic process",
  "GO:0051678": "pullulan catabolic process",
  "GO:0051679": "6-alpha-maltosylglucose metabolic process",
  "GO:0051680": "6-alpha-maltosylglucose biosynthetic process",
  "GO:0051681": "6-alpha-maltosylglucose catabolic process",
  "GO:0051682": "galactomannan catabolic process",
  "GO:0051683": "establishment of Golgi localization",
  "GO:0051684": "maintenance of Golgi location",
  "GO:0051685": "maintenance of ER location",
  "GO:0051686": "establishment of ER localization",
  "GO:0051687": "maintenance of spindle location",
  "GO:0051688": "maintenance of plastid location",
  "GO:0051689": "multicellular organismal oligosaccharide catabolic process",
  "GO:0051690": "multicellular organismal oligosaccharide metabolic process",
  "GO:0051691": "cellular oligosaccharide metabolic process",
  "GO:0051692": "cellular oligosaccharide catabolic process",
  "GO:0051693": "actin filament capping",
  "GO:0051694": "pointed-end actin filament capping",
  "GO:0051695": "actin filament uncapping",
  "GO:0051696": "pointed-end actin filament uncapping",
  "GO:0051697": "protein delipidation",
  "GO:0051698": "saccharopine oxidase activity",
  "GO:0051699": "proline oxidase activity",
  "GO:0051700": "fructosyl-amino acid oxidase activity",
  "GO:0051701": "interaction with host",
  "GO:0051702": "interaction with symbiont",
  "GO:0051703": "intraspecies interaction between organisms",
  "GO:0051704": "multi-organism process",
  "GO:0051705": "multi-organism behavior",
  "GO:0051707": "response to other organism",
  "GO:0051708": "intracellular protein transport in other organism involved in symbiotic interaction",
  "GO:0051709": "regulation of killing of cells of other organism",
  "GO:0051710": "regulation of cytolysis in other organism",
  "GO:0051711": "negative regulation of killing of cells of other organism",
  "GO:0051712": "positive regulation of killing of cells of other organism",
  "GO:0051713": "negative regulation of cytolysis in other organism",
  "GO:0051714": "positive regulation of cytolysis in other organism",
  "GO:0051715": "cytolysis in other organism",
  "GO:0051716": "cellular response to stimulus",
  "GO:0051717": "inositol-1,3,4,5-tetrakisphosphate 3-phosphatase activity",
  "GO:0051718": "DNA (cytosine-5-)-methyltransferase activity, acting on CpG substrates",
  "GO:0051719": "DNA (cytosine-5-)-methyltransferase activity, acting on CpN substrates",
  "GO:0051720": "DNA (cytosine-5-)-methyltransferase activity, acting on CpNpG substrates",
  "GO:0051721": "protein phosphatase 2A binding",
  "GO:0051722": "protein C-terminal methylesterase activity",
  "GO:0051723": "protein methylesterase activity",
  "GO:0051724": "NAD transporter activity",
  "GO:0051725": "protein de-ADP-ribosylation",
  "GO:0051726": "regulation of cell cycle",
  "GO:0051727": "obsolete cell cycle switching, meiotic to mitotic cell cycle",
  "GO:0051728": "cell cycle switching, mitotic to meiotic cell cycle",
  "GO:0051729": "germline cell cycle switching, mitotic to meiotic cell cycle",
  "GO:0051730": "GTP-dependent polyribonucleotide 5'-hydroxyl-kinase activity",
  "GO:0051731": "polynucleotide 5'-hydroxyl-kinase activity",
  "GO:0051732": "polyribonucleotide kinase activity",
  "GO:0051733": "polydeoxyribonucleotide kinase activity",
  "GO:0051734": "ATP-dependent polynucleotide kinase activity",
  "GO:0051735": "GTP-dependent polynucleotide kinase activity",
  "GO:0051736": "ATP-dependent polyribonucleotide 5'-hydroxyl-kinase activity",
  "GO:0051737": "GTP-dependent polydeoxyribonucleotide 5'-hydroxyl-kinase activity",
  "GO:0051738": "xanthophyll binding",
  "GO:0051740": "ethylene binding",
  "GO:0051741": "2-methyl-6-phytyl-1,4-benzoquinone methyltransferase activity",
  "GO:0051742": "2-methyl-6-solanyl-1,4-benzoquinone methyltransferase activity",
  "GO:0051743": "red chlorophyll catabolite reductase activity",
  "GO:0051744": "3,8-divinyl protochlorophyllide a 8-vinyl reductase activity",
  "GO:0051745": "4-hydroxy-3-methylbut-2-en-1-yl diphosphate reductase activity",
  "GO:0051746": "thalianol synthase activity",
  "GO:0051747": "cytosine C-5 DNA demethylase activity",
  "GO:0051748": "UTP-monosaccharide-1-phosphate uridylyltransferase activity",
  "GO:0051749": "indole acetic acid carboxyl methyltransferase activity",
  "GO:0051750": "delta3,5-delta2,4-dienoyl-CoA isomerase activity",
  "GO:0051751": "alpha-1,4-mannosyltransferase activity",
  "GO:0051752": "phosphoglucan, water dikinase activity",
  "GO:0051753": "mannan synthase activity",
  "GO:0051754": "meiotic sister chromatid cohesion, centromeric",
  "GO:0051755": "meiotic sister chromatid arm separation",
  "GO:0051756": "meiotic sister chromatid centromere separation",
  "GO:0051757": "meiotic sister chromatid separation",
  "GO:0051758": "homologous chromosome movement towards spindle pole involved in homologous chromosome segregation",
  "GO:0051759": "sister chromosome movement towards spindle pole involved in meiotic sister chromatid segregation",
  "GO:0051760": "meiotic sister chromatid cohesion, arms",
  "GO:0051761": "sesquiterpene metabolic process",
  "GO:0051762": "sesquiterpene biosynthetic process",
  "GO:0051763": "sesquiterpene catabolic process",
  "GO:0051764": "actin crosslink formation",
  "GO:0051765": "inositol tetrakisphosphate kinase activity",
  "GO:0051766": "inositol trisphosphate kinase activity",
  "GO:0051767": "nitric-oxide synthase biosynthetic process",
  "GO:0051769": "regulation of nitric-oxide synthase biosynthetic process",
  "GO:0051770": "positive regulation of nitric-oxide synthase biosynthetic process",
  "GO:0051771": "negative regulation of nitric-oxide synthase biosynthetic process",
  "GO:0051775": "response to redox state",
  "GO:0051776": "detection of redox state",
  "GO:0051777": "ent-kaurenoate oxidase activity",
  "GO:0051778": "ent-7-alpha-hydroxykaurenoate oxidase activity",
  "GO:0051779": "gibberellin 12-aldehyde oxidase activity",
  "GO:0051780": "behavioral response to nutrient",
  "GO:0051781": "positive regulation of cell division",
  "GO:0051782": "negative regulation of cell division",
  "GO:0051783": "regulation of nuclear division",
  "GO:0051784": "negative regulation of nuclear division",
  "GO:0051785": "positive regulation of nuclear division",
  "GO:0051786": "all-trans-retinol 13,14-reductase activity",
  "GO:0051787": "misfolded protein binding",
  "GO:0051788": "response to misfolded protein",
  "GO:0051789": "obsolete response to protein",
  "GO:0051790": "short-chain fatty acid biosynthetic process",
  "GO:0051791": "medium-chain fatty acid metabolic process",
  "GO:0051792": "medium-chain fatty acid biosynthetic process",
  "GO:0051793": "medium-chain fatty acid catabolic process",
  "GO:0051794": "regulation of catagen",
  "GO:0051795": "positive regulation of catagen",
  "GO:0051796": "negative regulation of catagen",
  "GO:0051797": "regulation of hair follicle development",
  "GO:0051798": "positive regulation of hair follicle development",
  "GO:0051799": "negative regulation of hair follicle development",
  "GO:0051800": "phosphatidylinositol-3,4-bisphosphate 3-phosphatase activity",
  "GO:0051801": "cytolysis in other organism involved in symbiotic interaction",
  "GO:0051802": "regulation of cytolysis in other organism involved in symbiotic interaction",
  "GO:0051803": "negative regulation of cytolysis in other organism involved in symbiotic interaction",
  "GO:0051804": "positive regulation of cytolysis in other organism involved in symbiotic interaction",
  "GO:0051805": "evasion or tolerance of immune response of other organism involved in symbiotic interaction",
  "GO:0051806": "entry into cell of other organism involved in symbiotic interaction",
  "GO:0051807": "evasion or tolerance of defense response of other organism involved in symbiotic interaction",
  "GO:0051808": "translocation of peptides or proteins into other organism involved in symbiotic interaction",
  "GO:0051809": "passive evasion of immune response of other organism involved in symbiotic interaction",
  "GO:0051810": "active evasion of immune response of other organism involved in symbiotic interaction",
  "GO:0051811": "active evasion of immune response of other organism via regulation of complement system of other organism involved in symbiotic interaction",
  "GO:0051812": "active evasion of immune response of other organism via regulation of cytokine network of other organism involved in symbiotic interaction",
  "GO:0051813": "active evasion of immune response of other organism via regulation of antigen processing and presentation in other organism involved in symbiotic interaction",
  "GO:0051814": "movement in other organism involved in symbiotic interaction",
  "GO:0051815": "migration in other organism involved in symbiotic interaction",
  "GO:0051816": "acquisition of nutrients from other organism during symbiotic interaction",
  "GO:0051817": "modification of morphology or physiology of other organism involved in symbiotic interaction",
  "GO:0051818": "disruption of cells of other organism involved in symbiotic interaction",
  "GO:0051819": "induction of tumor, nodule, or growth in other organism involved in symbiotic interaction",
  "GO:0051820": "induction of tumor, nodule, or growth containing transformed cells in other organism involved in symbiotic interaction",
  "GO:0051821": "dissemination or transmission of organism from other organism involved in symbiotic interaction",
  "GO:0051822": "dissemination or transmission of organism from other organism by vector involved in symbiotic interaction",
  "GO:0051823": "regulation of synapse structural plasticity",
  "GO:0051824": "recognition of other organism involved in symbiotic interaction",
  "GO:0051826": "negative regulation of synapse structural plasticity",
  "GO:0051827": "obsolete growth or development on or near surface of other organism during symbiotic interaction",
  "GO:0051828": "entry into other organism involved in symbiotic interaction",
  "GO:0051829": "entry into other organism through natural portals involved in symbiotic interaction",
  "GO:0051830": "entry into other organism through barriers of other organism involved in symbiotic interaction",
  "GO:0051831": "obsolete growth or development in other organism during symbiotic interaction",
  "GO:0051832": "avoidance of defenses of other organism involved in symbiotic interaction",
  "GO:0051833": "suppression of defenses of other organism involved in symbiotic interaction",
  "GO:0051834": "evasion or tolerance of defenses of other organism involved in symbiotic interaction",
  "GO:0051835": "positive regulation of synapse structural plasticity",
  "GO:0051836": "translocation of molecules into other organism involved in symbiotic interaction",
  "GO:0051837": "translocation of DNA into other organism involved in symbiotic interaction",
  "GO:0051838": "cytolysis by host of symbiont cells",
  "GO:0051839": "regulation by host of cytolysis of symbiont cells",
  "GO:0051840": "negative regulation by host of cytolysis of symbiont cells",
  "GO:0051841": "positive regulation by host of cytolysis of symbiont cells",
  "GO:0051842": "obsolete evasion or tolerance of symbiont immune response",
  "GO:0051843": "obsolete evasion or tolerance of symbiont defense response",
  "GO:0051844": "translocation of peptides or proteins into symbiont",
  "GO:0051845": "obsolete passive evasion of symbiont immune response",
  "GO:0051846": "obsolete active evasion of symbiont immune response",
  "GO:0051847": "obsolete active evasion of symbiont immune response via regulation of symbiont complement system",
  "GO:0051848": "obsolete active evasion of symbiont immune response via regulation of symbiont cytokine network",
  "GO:0051849": "obsolete active evasion of symbiont immune response via regulation of symbiont antigen processing and presentation",
  "GO:0051850": "acquisition of nutrients from symbiont",
  "GO:0051851": "modification by host of symbiont morphology or physiology",
  "GO:0051852": "disruption by host of symbiont cells",
  "GO:0051853": "obsolete induction in symbiont of tumor, nodule, or growth",
  "GO:0051854": "obsolete induction in symbiont of tumor, nodule, or growth containing transformed cells",
  "GO:0051855": "recognition of symbiont",
  "GO:0051857": "obsolete growth or development of organism on or near symbiont surface",
  "GO:0051858": "avoidance of symbiont defenses",
  "GO:0051859": "suppression of symbiont defenses",
  "GO:0051860": "evasion or tolerance of symbiont defenses",
  "GO:0051861": "glycolipid binding",
  "GO:0051862": "translocation of molecules into symbiont",
  "GO:0051863": "obsolete translocation of DNA into symbiont",
  "GO:0051864": "histone demethylase activity (H3-K36 specific)",
  "GO:0051865": "protein autoubiquitination",
  "GO:0051866": "general adaptation syndrome",
  "GO:0051867": "general adaptation syndrome, behavioral process",
  "GO:0051870": "methotrexate binding",
  "GO:0051871": "dihydrofolic acid binding",
  "GO:0051872": "sphingosine catabolic process",
  "GO:0051873": "killing by host of symbiont cells",
  "GO:0051874": "sphinganine-1-phosphate catabolic process",
  "GO:0051875": "pigment granule localization",
  "GO:0051876": "pigment granule dispersal",
  "GO:0051877": "pigment granule aggregation in cell center",
  "GO:0051878": "lateral element assembly",
  "GO:0051879": "Hsp90 protein binding",
  "GO:0051880": "G-quadruplex DNA binding",
  "GO:0051881": "regulation of mitochondrial membrane potential",
  "GO:0051882": "mitochondrial depolarization",
  "GO:0051883": "killing of cells in other organism involved in symbiotic interaction",
  "GO:0051884": "regulation of anagen",
  "GO:0051885": "positive regulation of anagen",
  "GO:0051886": "negative regulation of anagen",
  "GO:0051887": "regulation of exogen",
  "GO:0051888": "positive regulation of exogen",
  "GO:0051889": "negative regulation of exogen",
  "GO:0051890": "regulation of cardioblast differentiation",
  "GO:0051891": "positive regulation of cardioblast differentiation",
  "GO:0051892": "negative regulation of cardioblast differentiation",
  "GO:0051893": "regulation of focal adhesion assembly",
  "GO:0051894": "positive regulation of focal adhesion assembly",
  "GO:0051895": "negative regulation of focal adhesion assembly",
  "GO:0051896": "regulation of protein kinase B signaling",
  "GO:0051897": "positive regulation of protein kinase B signaling",
  "GO:0051898": "negative regulation of protein kinase B signaling",
  "GO:0051899": "membrane depolarization",
  "GO:0051900": "regulation of mitochondrial depolarization",
  "GO:0051901": "positive regulation of mitochondrial depolarization",
  "GO:0051902": "negative regulation of mitochondrial depolarization",
  "GO:0051903": "S-(hydroxymethyl)glutathione dehydrogenase activity",
  "GO:0051904": "pigment granule transport",
  "GO:0051905": "establishment of pigment granule localization",
  "GO:0051906": "maintenance of pigment granule location",
  "GO:0051907": "S-(hydroxymethyl)glutathione synthase activity",
  "GO:0051908": "double-stranded DNA 5'-3' exodeoxyribonuclease activity",
  "GO:0051909": "acetylenecarboxylate hydratase activity, producing 3-hydroxypropenoate",
  "GO:0051911": "Methanosarcina-phenazine hydrogenase activity",
  "GO:0051912": "CoB--CoM heterodisulfide reductase activity",
  "GO:0051913": "regulation of synaptic plasticity by chemical substance",
  "GO:0051914": "positive regulation of synaptic plasticity by chemical substance",
  "GO:0051915": "induction of synaptic plasticity by chemical substance",
  "GO:0051916": "granulocyte colony-stimulating factor binding",
  "GO:0051917": "regulation of fibrinolysis",
  "GO:0051918": "negative regulation of fibrinolysis",
  "GO:0051919": "positive regulation of fibrinolysis",
  "GO:0051920": "peroxiredoxin activity",
  "GO:0051921": "adenosylcobyric acid synthase (glutamine-hydrolyzing) activity",
  "GO:0051922": "cholesterol sulfotransferase activity",
  "GO:0051923": "sulfation",
  "GO:0051924": "regulation of calcium ion transport",
  "GO:0051925": "obsolete regulation of calcium ion transport via voltage-gated calcium channel activity",
  "GO:0051926": "negative regulation of calcium ion transport",
  "GO:0051927": "obsolete negative regulation of calcium ion transport via voltage-gated calcium channel activity",
  "GO:0051928": "positive regulation of calcium ion transport",
  "GO:0051929": "obsolete positive regulation of calcium ion transport via voltage-gated calcium channel activity",
  "GO:0051930": "regulation of sensory perception of pain",
  "GO:0051931": "regulation of sensory perception",
  "GO:0051932": "synaptic transmission, GABAergic",
  "GO:0051933": "amino acid neurotransmitter reuptake",
  "GO:0051934": "catecholamine uptake involved in synaptic transmission",
  "GO:0051935": "glutamate reuptake",
  "GO:0051936": "gamma-aminobutyric acid reuptake",
  "GO:0051937": "catecholamine transport",
  "GO:0051938": "L-glutamate import",
  "GO:0051939": "gamma-aminobutyric acid import",
  "GO:0051940": "regulation of catecholamine uptake involved in synaptic transmission",
  "GO:0051941": "regulation of amino acid uptake involved in synaptic transmission",
  "GO:0051942": "negative regulation of amino acid uptake involved in synaptic transmission",
  "GO:0051943": "positive regulation of amino acid uptake involved in synaptic transmission",
  "GO:0051944": "positive regulation of catecholamine uptake involved in synaptic transmission",
  "GO:0051945": "negative regulation of catecholamine uptake involved in synaptic transmission",
  "GO:0051946": "regulation of glutamate uptake involved in transmission of nerve impulse",
  "GO:0051947": "regulation of gamma-aminobutyric acid uptake involved in transmission of nerve impulse",
  "GO:0051948": "negative regulation of glutamate uptake involved in transmission of nerve impulse",
  "GO:0051949": "negative regulation of gamma-aminobutyric acid uptake involved in transmission of nerve impulse",
  "GO:0051950": "positive regulation of gamma-aminobutyric acid uptake involved in transmission of nerve impulse",
  "GO:0051951": "positive regulation of glutamate uptake involved in transmission of nerve impulse",
  "GO:0051952": "regulation of amine transport",
  "GO:0051953": "negative regulation of amine transport",
  "GO:0051954": "positive regulation of amine transport",
  "GO:0051955": "regulation of amino acid transport",
  "GO:0051956": "negative regulation of amino acid transport",
  "GO:0051957": "positive regulation of amino acid transport",
  "GO:0051958": "methotrexate transport",
  "GO:0051959": "dynein light intermediate chain binding",
  "GO:0051960": "regulation of nervous system development",
  "GO:0051961": "negative regulation of nervous system development",
  "GO:0051962": "positive regulation of nervous system development",
  "GO:0051963": "regulation of synapse assembly",
  "GO:0051964": "negative regulation of synapse assembly",
  "GO:0051965": "positive regulation of synapse assembly",
  "GO:0051966": "regulation of synaptic transmission, glutamatergic",
  "GO:0051967": "negative regulation of synaptic transmission, glutamatergic",
  "GO:0051968": "positive regulation of synaptic transmission, glutamatergic",
  "GO:0051969": "regulation of transmission of nerve impulse",
  "GO:0051970": "negative regulation of transmission of nerve impulse",
  "GO:0051971": "positive regulation of transmission of nerve impulse",
  "GO:0051972": "regulation of telomerase activity",
  "GO:0051973": "positive regulation of telomerase activity",
  "GO:0051974": "negative regulation of telomerase activity",
  "GO:0051975": "lysine biosynthetic process via alpha-aminoadipate and saccharopine",
  "GO:0051976": "lysine biosynthetic process via alpha-aminoadipate and N2-acetyl-alpha-aminoadipate",
  "GO:0051977": "lysophospholipid transport",
  "GO:0051978": "lysophospholipid transporter activity",
  "GO:0051979": "alginic acid acetylation",
  "GO:0051980": "iron-nicotianamine transmembrane transporter activity",
  "GO:0051981": "copper chelate transmembrane transporter activity",
  "GO:0051982": "copper-nicotianamine transmembrane transporter activity",
  "GO:0051983": "regulation of chromosome segregation",
  "GO:0051984": "positive regulation of chromosome segregation",
  "GO:0051985": "negative regulation of chromosome segregation",
  "GO:0051986": "negative regulation of attachment of spindle microtubules to kinetochore",
  "GO:0051987": "positive regulation of attachment of spindle microtubules to kinetochore",
  "GO:0051988": "regulation of attachment of spindle microtubules to kinetochore",
  "GO:0051989": "coproporphyrinogen dehydrogenase activity",
  "GO:0051990": "(R)-2-hydroxyglutarate dehydrogenase activity",
  "GO:0051991": "UDP-N-acetyl-D-glucosamine:N-acetylmuramoyl-L-alanyl-D-glutamyl-meso-2,6-diaminopimelyl-D-alanyl-D-alanine-diphosphoundecaprenol 4-beta-N-acetylglucosaminlytransferase activity",
  "GO:0051992": "UDP-N-acetylmuramoyl-L-alanyl-D-glutamyl-meso-2,6-diaminopimelyl-D-alanyl-D-alanine:undecaprenyl-phosphate transferase activity",
  "GO:0051993": "abscisic acid glucose ester beta-glucosidase activity",
  "GO:0051994": "P-methyltransferase activity",
  "GO:0051995": "Se-methyltransferase activity",
  "GO:0051996": "squalene synthase activity",
  "GO:0051997": "2-oxo-4-hydroxy-4-carboxy-5-ureidoimidazoline decarboxylase activity",
  "GO:0051998": "protein carboxyl O-methyltransferase activity",
  "GO:0051999": "mannosyl-inositol phosphorylceramide biosynthetic process",
  "GO:0052000": "Type IV pili-dependent aggregation",
  "GO:0052001": "Type IV pili-dependent localized adherence to host",
  "GO:0052002": "metabolism by symbiont of substance in host",
  "GO:0052003": "negative regulation by symbiont of defense-related host salicylic acid-mediated signal transduction pathway",
  "GO:0052004": "negative regulation by symbiont of host salicylic acid-mediated defense response",
  "GO:0052005": "negative regulation by symbiont of host ethylene-mediated defense response",
  "GO:0052006": "catabolism by symbiont of substance in host",
  "GO:0052007": "biosynthesis by symbiont of substance in host",
  "GO:0052008": "disruption by symbiont of host cellular component",
  "GO:0052009": "disruption by symbiont of host cell wall",
  "GO:0052010": "catabolism by symbiont of host cell wall cellulose",
  "GO:0052011": "catabolism by symbiont of host cell wall pectin",
  "GO:0052012": "catabolism by symbiont of host cell wall chitin",
  "GO:0052013": "catabolism by symbiont of host macromolecule",
  "GO:0052014": "catabolism by symbiont of host protein",
  "GO:0052015": "catabolism by symbiont of host carbohydrate",
  "GO:0052016": "catabolism by symbiont of host glucan",
  "GO:0052017": "catabolism by symbiont of host xylan",
  "GO:0052018": "modulation by symbiont of RNA levels in host",
  "GO:0052019": "modulation by symbiont of host hormone or growth regulator levels",
  "GO:0052020": "modification by symbiont of host cell wall",
  "GO:0052021": "modulation by symbiont of ethylene levels in host",
  "GO:0052022": "modulation by symbiont of jasmonic acid levels in host",
  "GO:0052023": "modulation by symbiont of salicylic acid levels in host",
  "GO:0052024": "positive regulation by symbiont of hormone or growth regulator levels in host",
  "GO:0052025": "modification by symbiont of host cell membrane",
  "GO:0052026": "modulation by symbiont of host transcription",
  "GO:0052027": "modulation by symbiont of host signal transduction pathway",
  "GO:0052028": "positive regulation by symbiont of host signal transduction pathway",
  "GO:0052029": "negative regulation by symbiont of host signal transduction pathway",
  "GO:0052031": "modulation by symbiont of host defense response",
  "GO:0052032": "modulation by symbiont of host inflammatory response",
  "GO:0052033": "pathogen-associated molecular pattern dependent induction by symbiont of host innate immune response",
  "GO:0052034": "negative regulation by symbiont of microbe-associated molecular pattern-induced host innate immune response",
  "GO:0052035": "positive regulation by symbiont of host inflammatory response",
  "GO:0052036": "negative regulation by symbiont of host inflammatory response",
  "GO:0052037": "negative regulation by symbiont of host defense response",
  "GO:0052038": "modulation by symbiont of host intracellular transport",
  "GO:0052039": "modification by symbiont of host cytoskeleton",
  "GO:0052040": "modulation by symbiont of host programmed cell death",
  "GO:0052041": "negative regulation by symbiont of host programmed cell death",
  "GO:0052042": "positive regulation by symbiont of host programmed cell death",
  "GO:0052043": "modification by symbiont of host cellular component",
  "GO:0052046": "modification by symbiont of host morphology or physiology via secreted substance",
  "GO:0052047": "interaction with other organism via secreted substance involved in symbiotic interaction",
  "GO:0052048": "interaction with host via secreted substance involved in symbiotic interaction",
  "GO:0052049": "interaction with host via protein secreted by type III secretion system",
  "GO:0052050": "interaction with host via substance secreted by type IV secretion system",
  "GO:0052051": "interaction with host via protein secreted by type II secretion system",
  "GO:0052052": "modification by symbiont of host morphology or physiology via protein secreted by type II secretion system",
  "GO:0052053": "negative regulation by symbiont of host catalytic activity",
  "GO:0052054": "negative regulation by symbiont of host peptidase activity",
  "GO:0052055": "modulation by symbiont of host molecular function",
  "GO:0052056": "negative regulation by symbiont of host molecular function",
  "GO:0052057": "modification by symbiont of host morphology or physiology via protein secreted by type III secretion system",
  "GO:0052058": "modification by symbiont of host morphology or physiology via substance secreted by type IV secretion system",
  "GO:0052059": "evasion or tolerance by symbiont of host-produced reactive oxygen species",
  "GO:0052060": "evasion or tolerance by symbiont of host-produced nitric oxide",
  "GO:0052061": "evasion or tolerance by symbiont of host-produced phytoalexins",
  "GO:0052062": "induction by symbiont of host phytoalexin production",
  "GO:0052063": "induction by symbiont of defense-related host nitric oxide production",
  "GO:0052064": "induction by symbiont of defense-related host reactive oxygen species production",
  "GO:0052065": "positive regulation by organism of defense-related calcium ion flux in other organism involved in symbiotic interaction",
  "GO:0052066": "entry of symbiont into host cell by promotion of host phagocytosis",
  "GO:0052067": "negative regulation by symbiont of entry into host cell via phagocytosis",
  "GO:0052068": "negative regulation by symbiont of host jasmonic acid-mediated defense response",
  "GO:0052069": "negative regulation by symbiont of defense-related host jasmonic acid-mediated signal transduction pathway",
  "GO:0052070": "negative regulation by symbiont of defense-related host ethylene-mediated signal transduction pathway",
  "GO:0052071": "positive regulation by symbiont of defense-related host ethylene-mediated signal transduction pathway",
  "GO:0052072": "positive regulation by symbiont of defense-related host salicylic acid-mediated signal transduction pathway",
  "GO:0052073": "positive regulation by symbiont of defense-related host jasmonic acid-mediated signal transduction pathway",
  "GO:0052074": "positive regulation by symbiont of host salicylic acid-mediated defense response",
  "GO:0052075": "positive regulation by symbiont of host jasmonic acid-mediated defense response",
  "GO:0052076": "positive regulation by symbiont of host ethylene-mediated defense response",
  "GO:0052077": "modulation by symbiont of defense-related host ethylene-mediated signal transduction pathway",
  "GO:0052078": "negative regulation by symbiont of defense-related host MAP kinase-mediated signal transduction pathway",
  "GO:0052079": "positive regulation by symbiont of defense-related host MAP kinase-mediated signal transduction pathway",
  "GO:0052080": "modulation by symbiont of defense-related host MAP kinase-mediated signal transduction pathway",
  "GO:0052081": "modulation by symbiont of defense-related host salicylic acid-mediated signal transduction pathway",
  "GO:0052082": "modulation by symbiont of defense-related host jasmonic acid-mediated signal transduction pathway",
  "GO:0052083": "negative regulation by symbiont of host cell-mediated immune response",
  "GO:0052084": "modulation by symbiont of host ethylene-mediated defense response",
  "GO:0052085": "negative regulation by symbiont of host T-cell mediated immune response",
  "GO:0052086": "negative regulation by symbiont of host B-cell mediated immune response",
  "GO:0052087": "negative regulation by symbiont of defense-related host callose deposition",
  "GO:0052088": "modulation by symbiont of host jasmonic acid-mediated defense response",
  "GO:0052089": "modulation by symbiont of host salicylic acid-mediated defense response",
  "GO:0052090": "modulation by symbiont of defense-related host callose deposition",
  "GO:0052091": "modulation by symbiont of nutrient release from host",
  "GO:0052092": "positive regulation by symbiont of nutrient release from host",
  "GO:0052093": "formation of specialized structure for nutrient acquisition from host",
  "GO:0052094": "formation by symbiont of haustorium for nutrient acquisition from host",
  "GO:0052095": "formation of specialized structure for nutrient acquisition from other organism involved in symbiotic interaction",
  "GO:0052096": "formation by symbiont of syncytium involving giant cell for nutrient acquisition from host",
  "GO:0052097": "interspecies quorum sensing",
  "GO:0052098": "formation by host of specialized structure for nutrient acquisition from symbiont",
  "GO:0052099": "acquisition by symbiont of nutrients from host via siderophores",
  "GO:0052100": "intraspecies quorum sensing",
  "GO:0052101": "induction by symbiont of host resistance gene-dependent defense response",
  "GO:0052102": "positive regulation by symbiont of defense-related host calcium-dependent protein kinase pathway",
  "GO:0052103": "induction by symbiont of host induced systemic resistance",
  "GO:0052104": "induction by symbiont of host systemic acquired resistance",
  "GO:0052105": "induction by symbiont of defense-related host cell wall thickening",
  "GO:0052106": "quorum sensing involved in interaction with host",
  "GO:0052107": "positive regulation by symbiont of defense-related host callose deposition",
  "GO:0052108": "obsolete growth or development of symbiont during interaction with host",
  "GO:0052109": "positive regulation by symbiont of defense-related host cell wall callose deposition",
  "GO:0052110": "occlusion by symbiont of host vascular system",
  "GO:0052111": "modification by symbiont of host structure",
  "GO:0052112": "occlusion by symbiont of host xylem",
  "GO:0052113": "obsolete adaptation to host osmotic environment",
  "GO:0052114": "obsolete adaptation to host pH environment",
  "GO:0052115": "energy taxis in host environment",
  "GO:0052116": "chemotaxis in host environment",
  "GO:0052117": "aerotaxis in host environment",
  "GO:0052118": "positive energy taxis in host environment",
  "GO:0052119": "negative energy taxis in host environment",
  "GO:0052120": "positive aerotaxis in host environment",
  "GO:0052121": "positive chemotaxis in host environment",
  "GO:0052122": "negative aerotaxis in host environment",
  "GO:0052123": "negative chemotaxis in host environment",
  "GO:0052124": "energy taxis within host",
  "GO:0052125": "energy taxis on or near host",
  "GO:0052126": "movement in host environment",
  "GO:0052127": "movement on or near host",
  "GO:0052128": "positive energy taxis",
  "GO:0052129": "negative energy taxis",
  "GO:0052130": "negative aerotaxis",
  "GO:0052131": "positive aerotaxis",
  "GO:0052132": "positive aerotaxis on or near host",
  "GO:0052133": "positive aerotaxis in host",
  "GO:0052134": "negative aerotaxis on or near host",
  "GO:0052135": "negative aerotaxis in host",
  "GO:0052136": "negative chemotaxis on or near host",
  "GO:0052137": "aerotaxis in host",
  "GO:0052138": "aerotaxis on or near host",
  "GO:0052139": "negative chemotaxis in host",
  "GO:0052140": "positive chemotaxis in host",
  "GO:0052141": "positive chemotaxis on or near host",
  "GO:0052142": "chemotaxis within host",
  "GO:0052143": "chemotaxis on or near host involved in symbiotic interaction",
  "GO:0052144": "negative energy taxis in host",
  "GO:0052145": "negative energy taxis on or near host",
  "GO:0052146": "positive energy taxis on or near host",
  "GO:0052147": "positive energy taxis in host",
  "GO:0052148": "modulation by symbiont of host catalytic activity",
  "GO:0052149": "modulation by symbiont of host peptidase activity",
  "GO:0052150": "modulation by symbiont of host apoptotic process",
  "GO:0052151": "positive regulation by symbiont of host apoptotic process",
  "GO:0052154": "modulation by symbiont of host B-cell mediated immune response",
  "GO:0052155": "modulation by symbiont of host cell-mediated immune response",
  "GO:0052156": "modulation by symbiont of host T-cell mediated immune response",
  "GO:0052157": "modulation by symbiont of microbe-associated molecular pattern-induced host innate immune response",
  "GO:0052158": "modulation by symbiont of host resistance gene-dependent defense response",
  "GO:0052159": "modulation by symbiont of host induced systemic resistance",
  "GO:0052160": "modulation by symbiont of host systemic acquired resistance",
  "GO:0052161": "modulation by symbiont of defense-related host cell wall thickening",
  "GO:0052162": "modulation by symbiont of defense-related host calcium ion flux",
  "GO:0052163": "modulation by symbiont of defense-related host nitric oxide production",
  "GO:0052164": "modulation by symbiont of defense-related host reactive oxygen species production",
  "GO:0052165": "modulation by symbiont of host phytoalexin production",
  "GO:0052166": "positive regulation by symbiont of host innate immune response",
  "GO:0052167": "modulation by symbiont of host innate immune response",
  "GO:0052168": "modulation by symbiont of defense-related host calcium-dependent protein kinase pathway",
  "GO:0052169": "pathogen-associated molecular pattern dependent modulation by symbiont of host innate immune response",
  "GO:0052170": "negative regulation by symbiont of host innate immune response",
  "GO:0052171": "obsolete growth or development during symbiotic interaction",
  "GO:0052172": "metabolism by symbiont of host cell wall cellulose",
  "GO:0052173": "response to defenses of other organism involved in symbiotic interaction",
  "GO:0052174": "metabolism by symbiont of host macromolecule",
  "GO:0052175": "metabolism by symbiont of host carbohydrate",
  "GO:0052176": "metabolism by symbiont of host glucan",
  "GO:0052177": "metabolism by symbiont of host xylan",
  "GO:0052178": "metabolism by symbiont of host cell wall chitin",
  "GO:0052179": "metabolism by symbiont of host cell wall pectin",
  "GO:0052180": "negative regulation of peptidase activity in other organism involved in symbiotic interaction",
  "GO:0052181": "modulation by host of symbiont defense response",
  "GO:0052182": "modification by host of symbiont morphology or physiology via secreted substance",
  "GO:0052183": "modification by host of symbiont structure",
  "GO:0052184": "obsolete modulation by organism of symbiont hormone or growth regulator levels",
  "GO:0052185": "modification of structure of other organism involved in symbiotic interaction",
  "GO:0052186": "modulation by organism of hormone or growth regulator levels in other organism involved in symbiotic interaction",
  "GO:0052187": "modification by host of symbiont cellular component",
  "GO:0052188": "modification of cellular component in other organism involved in symbiotic interaction",
  "GO:0052189": "modulation by symbiont of defense-related host cell wall callose deposition",
  "GO:0052190": "modulation by symbiont of host phagocytosis",
  "GO:0052191": "positive regulation by symbiont of host phagocytosis",
  "GO:0052192": "movement in environment of other organism involved in symbiotic interaction",
  "GO:0052193": "movement in symbiont environment",
  "GO:0052194": "movement on or near symbiont",
  "GO:0052195": "movement on or near other organism involved in symbiotic interaction",
  "GO:0052196": "negative regulation by host of symbiont defense response",
  "GO:0052197": "positive regulation by host of symbiont defense response",
  "GO:0052198": "modulation of peptidase activity in other organism involved in symbiotic interaction",
  "GO:0052199": "negative regulation of catalytic activity in other organism involved in symbiotic interaction",
  "GO:0052200": "response to host defenses",
  "GO:0052201": "response to symbiont defenses",
  "GO:0052202": "negative regulation by symbiont of defense-related host cell wall callose deposition",
  "GO:0052203": "modulation of catalytic activity in other organism involved in symbiotic interaction",
  "GO:0052204": "negative regulation of molecular function in other organism involved in symbiotic interaction",
  "GO:0052205": "modulation of molecular function in other organism involved in symbiotic interaction",
  "GO:0052206": "modification of morphology or physiology of other organism via protein secreted by type II secretion system involved in symbiotic interaction",
  "GO:0052207": "modification of morphology or physiology of other organism via protein secreted by type III secretion system involved in symbiotic interaction",
  "GO:0052208": "modification of morphology or physiology of other organism via substance secreted by type IV secretion system involved in symbiotic interaction",
  "GO:0052209": "interaction with other organism via substance secreted by type IV secretion system involved in symbiotic interaction",
  "GO:0052210": "interaction with other organism via protein secreted by type III secretion system involved in symbiotic interaction",
  "GO:0052211": "interaction with other organism via protein secreted by type II secretion system involved in symbiotic interaction",
  "GO:0052212": "modification of morphology or physiology of other organism via secreted substance involved in symbiotic interaction",
  "GO:0052213": "interaction with symbiont via secreted substance involved in symbiotic interaction",
  "GO:0052214": "metabolism of substance in other organism involved in symbiotic interaction",
  "GO:0052215": "energy taxis in environment of other organism involved in symbiotic interaction",
  "GO:0052216": "chemotaxis in environment of other organism involved in symbiotic interaction",
  "GO:0052217": "aerotaxis in environment of other organism involved in symbiotic interaction",
  "GO:0052218": "positive energy taxis in environment of other organism involved in symbiotic interaction",
  "GO:0052219": "negative energy taxis in environment of other organism involved in symbiotic interaction",
  "GO:0052220": "positive aerotaxis in environment of other organism involved in symbiotic interaction",
  "GO:0052221": "positive chemotaxis in environment of other organism involved in symbiotic interaction",
  "GO:0052222": "negative aerotaxis in environment of other organism involved in symbiotic interaction",
  "GO:0052223": "negative chemotaxis in environment of other organism involved in symbiotic interaction",
  "GO:0052224": "energy taxis in other organism involved in symbiotic interaction",
  "GO:0052225": "energy taxis on or near other organism involved in symbiotic interaction",
  "GO:0052226": "biosynthesis of substance in other organism involved in symbiotic interaction",
  "GO:0052227": "catabolism of substance in other organism involved in symbiotic interaction",
  "GO:0052228": "metabolism by symbiont of host protein",
  "GO:0052229": "metabolism of macromolecule in other organism involved in symbiotic interaction",
  "GO:0052230": "modulation of intracellular transport in other organism involved in symbiotic interaction",
  "GO:0052231": "modulation of phagocytosis in other organism involved in symbiotic interaction",
  "GO:0052232": "positive aerotaxis on or near other organism involved in symbiotic interaction",
  "GO:0052233": "positive aerotaxis in other organism involved in symbiotic interaction",
  "GO:0052234": "negative aerotaxis on or near other organism involved in symbiotic interaction",
  "GO:0052235": "negative aerotaxis in other organism involved in symbiotic interaction",
  "GO:0052236": "negative chemotaxis on or near other organism involved in symbiotic interaction",
  "GO:0052237": "aerotaxis in other organism involved in symbiotic interaction",
  "GO:0052238": "aerotaxis on or near other organism involved in symbiotic interaction",
  "GO:0052239": "negative chemotaxis in other organism involved in symbiotic interaction",
  "GO:0052240": "positive chemotaxis in other organism involved in symbiotic interaction",
  "GO:0052241": "positive chemotaxis on or near other organism involved in symbiotic interaction",
  "GO:0052242": "chemotaxis in other organism involved in symbiotic interaction",
  "GO:0052243": "chemotaxis on or near other organism involved in symbiotic interaction",
  "GO:0052244": "negative energy taxis in other organism involved in symbiotic interaction",
  "GO:0052245": "negative energy taxis on or near other organism involved in symbiotic interaction",
  "GO:0052246": "positive energy taxis on or near other organism involved in symbiotic interaction",
  "GO:0052247": "positive energy taxis in other organism involved in symbiotic interaction",
  "GO:0052248": "modulation of programmed cell death in other organism involved in symbiotic interaction",
  "GO:0052249": "modulation of RNA levels in other organism involved in symbiotic interaction",
  "GO:0052250": "modulation of signal transduction in other organism involved in symbiotic interaction",
  "GO:0052251": "induction by organism of defense response of other organism involved in symbiotic interaction",
  "GO:0052252": "negative regulation by organism of defense-related salicylic acid-mediated signal transduction pathway of other organism involved in symbiotic interaction",
  "GO:0052253": "negative regulation by organism of salicylic acid-mediated defense response of other organism involved in symbiotic interaction",
  "GO:0052254": "negative regulation by organism of ethylene-mediated defense response of other organism involved in symbiotic interaction",
  "GO:0052255": "modulation by organism of defense response of other organism involved in symbiotic interaction",
  "GO:0052256": "modulation by organism of inflammatory response of other organism involved in symbiotic interaction",
  "GO:0052257": "pathogen-associated molecular pattern dependent induction by organism of innate immune response of other organism involved in symbiotic interaction",
  "GO:0052258": "negative regulation by organism of pathogen-associated molecular pattern-induced innate immune response of other organism involved in symbiotic interaction",
  "GO:0052259": "positive regulation by organism of inflammatory response of other organism involved in symbiotic interaction",
  "GO:0052260": "negative regulation by organism of inflammatory response of other organism involved in symbiotic interaction",
  "GO:0052261": "suppression of defense response of other organism involved in symbiotic interaction",
  "GO:0052262": "induction by organism of phytoalexin production in other organism involved in symbiotic interaction",
  "GO:0052263": "induction by organism of defense-related nitric oxide production in other organism involved in symbiotic interaction",
  "GO:0052264": "induction by organism of defense-related reactive oxygen species production in other organism involved in symbiotic interaction",
  "GO:0052265": "induction by organism of defense-related calcium ion flux in other organism involved in symbiotic interaction",
  "GO:0052266": "negative regulation by organism of jasmonic acid-mediated defense response of other organism involved in symbiotic interaction",
  "GO:0052267": "negative regulation by organism of defense-related jasmonic acid-mediated signal transduction pathway in other organism involved in symbiotic interaction",
  "GO:0052268": "negative regulation by organism of defense-related ethylene-mediated signal transduction pathway in other organism involved in symbiotic interaction",
  "GO:0052269": "positive regulation by organism of defense-related ethylene-mediated signal transduction pathway in other organism involved in symbiotic interaction",
  "GO:0052270": "positive regulation by organism of defense-related salicylic acid-mediated signal transduction pathway in other organism involved in symbiotic interaction",
  "GO:0052271": "positive regulation by organism of defense-related jasmonic acid-mediated signal transduction pathway in other organism involved in symbiotic interaction",
  "GO:0052272": "positive regulation by organism of salicylic acid-mediated defense response of other organism involved in symbiotic interaction",
  "GO:0052273": "positive regulation by organism of jasmonic acid-mediated defense response of other organism involved in symbiotic interaction",
  "GO:0052274": "positive regulation by organism of ethylene-mediated defense response of other organism involved in symbiotic interaction",
  "GO:0052275": "negative regulation by organism of defense-related MAP kinase-mediated signal transduction pathway in other organism involved in symbiotic interaction",
  "GO:0052276": "positive regulation by organism of defense-related MAP kinase-mediated signal transduction pathway in other organism involved in symbiotic interaction",
  "GO:0052277": "modulation by organism of defense-related MAP kinase-mediated signal transduction pathway in other organism involved in symbiotic interaction",
  "GO:0052278": "negative regulation by organism of cell-mediated immune response of other organism involved in symbiotic interaction",
  "GO:0052279": "modulation by organism of ethylene-mediated defense response of other organism involved in symbiotic interaction",
  "GO:0052280": "negative regulation by organism of T-cell mediated immune response of other organism involved in symbiotic interaction",
  "GO:0052281": "negative regulation by organism of B-cell mediated immune response of other organism involved in symbiotic interaction",
  "GO:0052282": "negative regulation by organism of defense-related callose deposition in other organism involved in symbiotic interaction",
  "GO:0052283": "modulation by organism of jasmonic acid-mediated defense response of other organism involved in symbiotic interaction",
  "GO:0052284": "modulation by organism of salicylic acid-mediated defense response of other organism involved in symbiotic interaction",
  "GO:0052285": "modulation by organism of defense-related callose deposition of other organism involved in symbiotic interaction",
  "GO:0052286": "induction by organism of resistance gene-dependent defense response of other organism involved in symbiotic interaction",
  "GO:0052287": "positive regulation by organism of defense-related calcium-dependent protein kinase pathway in other organism involved in symbiotic interaction",
  "GO:0052288": "induction by organism of induced systemic resistance in other organism involved in symbiotic interaction",
  "GO:0052289": "induction by organism of systemic acquired resistance in other organism involved in symbiotic interaction",
  "GO:0052290": "induction by organism of defense-related cell wall thickening in other organism involved in symbiotic interaction",
  "GO:0052291": "positive regulation by organism of defense-related callose deposition in other organism involved in symbiotic interaction",
  "GO:0052292": "positive regulation by organism of defense-related cell wall callose deposition in other organism involved in symbiotic interaction",
  "GO:0052293": "modulation by organism of B-cell mediated immune response of other organism involved in symbiotic interaction",
  "GO:0052294": "modulation by organism of cell-mediated immune response of other organism involved in symbiotic interaction",
  "GO:0052295": "modulation by organism of T-cell mediated immune response of other organism involved in symbiotic interaction",
  "GO:0052296": "modulation by organism of microbe-associated molecular pattern-induced innate immune response in other organism involved in symbiotic interaction",
  "GO:0052297": "modulation by organism of resistance gene-dependent defense response of other organism involved in symbiotic interaction",
  "GO:0052298": "modulation by organism of induced systemic resistance in other organism involved in symbiotic interaction",
  "GO:0052299": "modulation by organism of systemic acquired resistance in other organism involved in symbiotic interaction",
  "GO:0052300": "modulation by organism of defense-related cell wall thickening in other organism involved in symbiotic interaction",
  "GO:0052301": "modulation by organism of defense-related calcium ion flux in other organism involved in symbiotic interaction",
  "GO:0052302": "modulation by organism of defense-related nitric oxide production in other organism involved in symbiotic interaction",
  "GO:0052303": "modulation by organism of defense-related reactive oxygen species production in other organism involved in symbiotic interaction",
  "GO:0052304": "modulation by organism of phytoalexin production in other organism involved in symbiotic interaction",
  "GO:0052305": "positive regulation by organism of innate immune response in other organism involved in symbiotic interaction",
  "GO:0052306": "modulation by organism of innate immune response in other organism involved in symbiotic interaction",
  "GO:0052307": "modulation by organism of defense-related calcium-dependent protein kinase pathway in other organism involved in symbiotic interaction",
  "GO:0052308": "pathogen-associated molecular pattern dependent modulation by organism of innate immune response in other organism involved in symbiotic interaction",
  "GO:0052309": "negative regulation by organism of innate immune response in other organism involved in symbiotic interaction",
  "GO:0052310": "modulation by organism of defense-related cell wall callose deposition in other organism involved in symbiotic interaction",
  "GO:0052311": "negative regulation by organism of defense-related cell wall callose deposition in other organism involved in symbiotic interaction",
  "GO:0052312": "modulation of transcription in other organism involved in symbiotic interaction",
  "GO:0052313": "modulation of nutrient release from other organism involved in symbiotic interaction",
  "GO:0052314": "phytoalexin metabolic process",
  "GO:0052315": "phytoalexin biosynthetic process",
  "GO:0052316": "phytoalexin catabolic process",
  "GO:0052317": "camalexin metabolic process",
  "GO:0052318": "regulation of phytoalexin metabolic process",
  "GO:0052319": "regulation of phytoalexin biosynthetic process",
  "GO:0052320": "positive regulation of phytoalexin metabolic process",
  "GO:0052321": "negative regulation of phytoalexin metabolic process",
  "GO:0052322": "positive regulation of phytoalexin biosynthetic process",
  "GO:0052323": "negative regulation of phytoalexin biosynthetic process",
  "GO:0052324": "plant-type cell wall cellulose biosynthetic process",
  "GO:0052325": "cell wall pectin biosynthetic process",
  "GO:0052326": "obsolete interaction with symbiont via protein secreted by type IV secretion system",
  "GO:0052327": "obsolete interaction with symbiont via protein secreted by type II secretion system",
  "GO:0052328": "obsolete interaction with symbiont via protein secreted by type III secretion system",
  "GO:0052329": "positive regulation by organism of phytoalexin production in other organism involved in symbiotic interaction",
  "GO:0052330": "positive regulation by organism of programmed cell death in other organism involved in symbiotic interaction",
  "GO:0052331": "hemolysis in other organism involved in symbiotic interaction",
  "GO:0052332": "modification by organism of membrane in other organism involved in symbiotic interaction",
  "GO:0052333": "modification by organism of cell wall of other organism involved in symbiotic interaction",
  "GO:0052334": "modification by organism of cytoskeleton of other organism involved in symbiotic interaction",
  "GO:0052335": "modification by host of symbiont cytoskeleton",
  "GO:0052336": "modification by host of symbiont cell wall",
  "GO:0052337": "modification by host of symbiont membrane",
  "GO:0052338": "disruption by host of symbiont cell wall",
  "GO:0052339": "disruption by organism of cell wall of other organism involved in symbiotic interaction",
  "GO:0052340": "catabolism by organism of cell wall cellulose in other organism involved in symbiotic interaction",
  "GO:0052341": "catabolism by organism of cell wall pectin in other organism involved in symbiotic interaction",
  "GO:0052342": "catabolism by organism of cell wall chitin in other organism involved in symbiotic interaction",
  "GO:0052343": "obsolete positive regulation by organism of symbiont phytoalexin production",
  "GO:0052344": "positive regulation by symbiont of host phytoalexin production",
  "GO:0052345": "positive regulation by organism of defense-related nitric oxide production in other organism involved in symbiotic interaction",
  "GO:0052346": "obsolete positive regulation by organism of defense-related symbiont nitric oxide production",
  "GO:0052347": "positive regulation by symbiont of defense-related host nitric oxide production",
  "GO:0052348": "positive regulation by organism of defense-related reactive oxygen species production in other organism involved in symbiotic interaction",
  "GO:0052349": "obsolete positive regulation by organism of defense-related symbiont reactive oxygen species production",
  "GO:0052350": "obsolete induction by organism of induced systemic resistance in symbiont",
  "GO:0052351": "obsolete induction by organism of systemic acquired resistance in symbiont",
  "GO:0052352": "biosynthesis by host of substance in symbiont",
  "GO:0052353": "catabolism by host of symbiont carbohydrate",
  "GO:0052354": "catabolism by organism of carbohydrate in other organism involved in symbiotic interaction",
  "GO:0052355": "catabolism by host of symbiont cell wall cellulose",
  "GO:0052356": "catabolism by host of symbiont cell wall chitin",
  "GO:0052357": "catabolism by host of symbiont cell wall pectin",
  "GO:0052358": "catabolism by host of symbiont glucan",
  "GO:0052359": "catabolism by organism of glucan in other organism involved in symbiotic interaction",
  "GO:0052360": "catabolism by host of symbiont macromolecule",
  "GO:0052361": "catabolism by organism of macromolecule in other organism involved in symbiotic interaction",
  "GO:0052362": "catabolism by host of symbiont protein",
  "GO:0052363": "catabolism by organism of protein in other organism involved in symbiotic interaction",
  "GO:0052364": "catabolism by host of substance in symbiont",
  "GO:0052365": "catabolism by host of symbiont xylan",
  "GO:0052366": "catabolism by organism of xylan in other organism involved in symbiotic interaction",
  "GO:0052367": "disruption by host of symbiont cellular component",
  "GO:0052368": "disruption by organism of cellular component in other organism involved in symbiotic interaction",
  "GO:0052369": "positive regulation by symbiont of defense-related host reactive oxygen species production",
  "GO:0052370": "entry of organism into cell of other organism by promotion of phagocytosis in other organism involved in symbiotic interaction",
  "GO:0052371": "regulation by organism of entry into other organism involved in symbiotic interaction",
  "GO:0052372": "modulation by symbiont of entry into host",
  "GO:0052373": "negative regulation by organism of entry into other organism involved in symbiotic interaction",
  "GO:0052374": "negative regulation by symbiont of entry into host",
  "GO:0052375": "obsolete evasion or tolerance by organism of symbiont-produced nitric oxide",
  "GO:0052376": "evasion or tolerance by organism of nitric oxide produced by other organism involved in symbiotic interaction",
  "GO:0052377": "obsolete evasion or tolerance by organism of symbiont-produced phytoalexins",
  "GO:0052378": "evasion or tolerance by organism of phytoalexins produced by other organism involved in symbiotic interaction",
  "GO:0052379": "modulation by organism of entry into other organism via phagocytosis involved in symbiotic interaction",
  "GO:0052380": "modulation by symbiont of entry into host via phagocytosis",
  "GO:0052381": "tRNA dimethylallyltransferase activity",
  "GO:0052382": "induction by organism of innate immune response in other organism involved in symbiotic interaction",
  "GO:0052383": "obsolete induction by organism of symbiont innate immunity",
  "GO:0052384": "obsolete evasion or tolerance by organism of symbiont-produced reactive oxygen species",
  "GO:0052385": "evasion or tolerance by organism of reactive oxygen species produced by other organism involved in symbiotic interaction",
  "GO:0052386": "cell wall thickening",
  "GO:0052387": "obsolete induction by organism of symbiont apoptosis",
  "GO:0052389": "positive regulation by symbiont of defense-related host calcium ion flux",
  "GO:0052390": "induction by symbiont of host innate immune response",
  "GO:0052391": "induction by symbiont of defense-related host calcium ion flux",
  "GO:0052392": "obsolete induction by organism of defense-related symbiont calcium ion flux",
  "GO:0052393": "induction by host of symbiont defense response",
  "GO:0052394": "obsolete induction by organism of defense-related symbiont cell wall thickening",
  "GO:0052395": "obsolete induction by organism of defense-related symbiont nitric oxide production",
  "GO:0052396": "obsolete induction by organism of symbiont non-apoptotic programmed cell death",
  "GO:0052398": "obsolete induction by organism of symbiont phytoalexin production",
  "GO:0052399": "obsolete induction by organism of symbiont programmed cell death",
  "GO:0052401": "obsolete induction by organism of defense-related symbiont reactive oxygen species production",
  "GO:0052402": "obsolete induction by organism of symbiont resistance gene-dependent defense response",
  "GO:0052403": "negative regulation by host of symbiont catalytic activity",
  "GO:0052404": "negative regulation by host of symbiont peptidase activity",
  "GO:0052405": "negative regulation by host of symbiont molecular function",
  "GO:0052406": "metabolism by host of symbiont carbohydrate",
  "GO:0052407": "metabolism by organism of carbohydrate in other organism involved in symbiotic interaction",
  "GO:0052408": "metabolism by host of symbiont cell wall cellulose",
  "GO:0052409": "metabolism by organism of cell wall cellulose in other organism involved in symbiotic interaction",
  "GO:0052410": "metabolism by host of symbiont cell wall chitin",
  "GO:0052411": "metabolism by organism of cell wall chitin in other organism involved in symbiotic interaction",
  "GO:0052412": "metabolism by host of symbiont cell wall pectin",
  "GO:0052413": "metabolism by organism of cell wall pectin in other organism involved in symbiotic interaction",
  "GO:0052414": "metabolism by host of symbiont glucan",
  "GO:0052415": "metabolism by organism of glucan in other organism involved in symbiotic interaction",
  "GO:0052416": "metabolism by host of symbiont macromolecule",
  "GO:0052417": "metabolism by host of symbiont protein",
  "GO:0052418": "metabolism by organism of protein in other organism involved in symbiotic interaction",
  "GO:0052419": "metabolism by host of substance in symbiont",
  "GO:0052420": "metabolism by host of symbiont xylan",
  "GO:0052421": "metabolism by organism of xylan in other organism involved in symbiotic interaction",
  "GO:0052422": "modulation by host of symbiont catalytic activity",
  "GO:0052423": "positive regulation by organism of resistance gene-dependent defense response of other organism involved in symbiotic interaction",
  "GO:0052424": "obsolete modification by organism of symbiont morphology or physiology via protein secreted by type III secretion system",
  "GO:0052425": "obsolete modification by organism of symbiont morphology or physiology via protein secreted by type II secretion system",
  "GO:0052426": "obsolete modification by organism of symbiont morphology or physiology via substance secreted by type IV secretion system",
  "GO:0052427": "modulation by host of symbiont peptidase activity",
  "GO:0052428": "modification by host of symbiont molecular function",
  "GO:0052429": "obsolete modulation by organism of symbiont B-cell mediated immune response",
  "GO:0052430": "modulation by host of symbiont RNA levels",
  "GO:0052431": "obsolete modulation by organism of symbiont T-cell mediated immune response",
  "GO:0052432": "obsolete modulation by organism of symbiont apoptosis",
  "GO:0052433": "modulation by organism of apoptotic process in other organism involved in symbiotic interaction",
  "GO:0052434": "obsolete modulation by organism of symbiont cell-mediated immune response",
  "GO:0052435": "modulation by host of defense-related symbiont MAP kinase-mediated signal transduction pathway",
  "GO:0052436": "obsolete modulation by organism of defense-related symbiont calcium-dependent protein kinase pathway",
  "GO:0052437": "obsolete modulation by organism of defense-related symbiont calcium ion flux",
  "GO:0052438": "obsolete modulation by organism of defense-related symbiont callose deposition",
  "GO:0052439": "obsolete modulation by organism of defense-related symbiont cell wall callose deposition",
  "GO:0052440": "obsolete modulation by organism of defense-related symbiont ethylene-mediated signal transduction pathway",
  "GO:0052441": "modulation by organism of defense-related ethylene-mediated signal transduction pathway in other organism involved in symbiotic interaction",
  "GO:0052442": "obsolete modulation by organism of defense-related symbiont jasmonic acid-mediated signal transduction pathway",
  "GO:0052443": "modulation by organism of defense-related jasmonic acid-mediated signal transduction pathway in other organism involved in symbiotic interaction",
  "GO:0052444": "obsolete modulation by organism of defense-related symbiont salicylic acid-mediated signal transduction pathway",
  "GO:0052445": "modulation by organism of defense-related salicylic acid-mediated signal transduction pathway in other organism involved in symbiotic interaction",
  "GO:0052446": "obsolete modulation by organism of defense-related symbiont cell wall thickening",
  "GO:0052447": "obsolete modulation by organism of symbiont ethylene-mediated defense response",
  "GO:0052448": "obsolete modulation by organism of ethylene levels in symbiont",
  "GO:0052449": "modulation by organism of ethylene levels in other organism involved in symbiotic interaction",
  "GO:0052450": "obsolete modulation by organism of induced systemic resistance in symbiont",
  "GO:0052451": "obsolete modulation by organism of symbiont inflammatory response",
  "GO:0052452": "obsolete modulation by organism of symbiont innate immunity",
  "GO:0052453": "obsolete modulation by organism of symbiont intracellular transport",
  "GO:0052454": "obsolete modulation by organism of symbiont jasmonic acid-mediated defense response",
  "GO:0052455": "obsolete modulation by organism of jasmonic acid levels in symbiont",
  "GO:0052456": "modulation by organism of jasmonic acid levels in other organism involved in symbiotic interaction",
  "GO:0052457": "obsolete modulation by organism of defense-related symbiont nitric oxide production",
  "GO:0052458": "obsolete modulation by organism of symbiont non-apoptotic programmed cell death",
  "GO:0052460": "modulation by host of nutrient release from symbiont",
  "GO:0052461": "obsolete modulation by organism of pathogen-associated molecular pattern-induced symbiont innate immunity",
  "GO:0052462": "modulation by host of symbiont phagocytosis",
  "GO:0052463": "obsolete modulation by organism of symbiont phytoalexin production",
  "GO:0052464": "obsolete modulation by organism of symbiont programmed cell death",
  "GO:0052465": "obsolete modulation by organism of defense-related symbiont reactive oxygen species production",
  "GO:0052466": "obsolete modulation by organism of symbiont resistance gene-dependent defense response",
  "GO:0052467": "obsolete modulation by organism of symbiont salicylic acid-mediated defense response",
  "GO:0052468": "obsolete modulation by organism of salicylic acid levels in symbiont",
  "GO:0052469": "modulation by organism of salicylic acid levels in other organism involved in symbiotic interaction",
  "GO:0052470": "modulation by host of symbiont signal transduction pathway",
  "GO:0052471": "obsolete modulation by organism of systemic acquired resistance in symbiont",
  "GO:0052472": "modulation by host of symbiont transcription",
  "GO:0052473": "obsolete negative regulation by organism of symbiont B-cell mediated immune response",
  "GO:0052474": "obsolete negative regulation by organism of symbiont T-cell mediated immune response",
  "GO:0052475": "obsolete negative regulation by organism of symbiont cell-mediated immune response",
  "GO:0052476": "obsolete negative regulation by organism of defense-related symbiont MAP kinase-mediated signal transduction pathway",
  "GO:0052477": "obsolete negative regulation by organism of defense-related symbiont callose deposition",
  "GO:0052478": "obsolete negative regulation by organism of defense-related symbiont cell wall callose deposition",
  "GO:0052479": "obsolete negative regulation by organism of defense-related symbiont ethylene-mediated signal transduction pathway",
  "GO:0052480": "obsolete negative regulation by organism of defense-related symbiont jasmonic acid-mediated signal transduction pathway",
  "GO:0052481": "obsolete negative regulation by organism of defense-related symbiont salicylic acid-mediated signal transduction pathway",
  "GO:0052482": "defense response by cell wall thickening",
  "GO:0052483": "negative regulation by organism of entry into cell of other organism via phagocytosis involved in symbiotic interaction",
  "GO:0052484": "obsolete negative regulation by organism of symbiont ethylene-mediated defense response",
  "GO:0052485": "obsolete negative regulation by organism of symbiont inflammatory response",
  "GO:0052486": "obsolete negative regulation by organism of symbiont innate immunity",
  "GO:0052487": "obsolete negative regulation by organism of symbiont jasmonic acid-mediated defense response",
  "GO:0052488": "obsolete negative regulation by organism of pathogen-associated molecular pattern-induced symbiont innate immunity",
  "GO:0052489": "negative regulation by host of symbiont programmed cell death",
  "GO:0052490": "negative regulation by organism of programmed cell death in other organism involved in symbiotic interaction",
  "GO:0052491": "obsolete negative regulation by organism of symbiont salicylic acid-mediated defense response",
  "GO:0052492": "negative regulation by host of symbiont signal transduction pathway",
  "GO:0052493": "negative regulation by organism of signal transduction in other organism involved in symbiotic interaction",
  "GO:0052494": "occlusion by host of symbiont vascular system",
  "GO:0052495": "occlusion by organism of vascular system in other organism involved in symbiotic interaction",
  "GO:0052496": "occlusion by host of symbiont xylem",
  "GO:0052497": "occlusion by organism of xylem in other organism involved in symbiotic interaction",
  "GO:0052498": "obsolete pathogen-associated molecular pattern dependent induction by organism of symbiont innate immunity",
  "GO:0052499": "obsolete pathogen-associated molecular pattern dependent modulation by organism of symbiont innate immunity",
  "GO:0052500": "obsolete positive regulation by organism of symbiont apoptosis",
  "GO:0052501": "positive regulation by organism of apoptotic process in other organism involved in symbiotic interaction",
  "GO:0052502": "positive regulation by host of defense-related symbiont MAP kinase-mediated signal transduction pathway",
  "GO:0052503": "obsolete positive regulation by organism of defense-related symbiont calcium-dependent protein kinase pathway",
  "GO:0052504": "obsolete positive regulation by organism of defense-related symbiont callose deposition",
  "GO:0052505": "obsolete positive regulation by organism of defense-related symbiont cell wall callose deposition",
  "GO:0052506": "obsolete positive regulation by organism of defense-related symbiont ethylene-mediated signal transduction pathway",
  "GO:0052507": "obsolete positive regulation by organism of defense-related symbiont jasmonic acid-mediated signal transduction pathway",
  "GO:0052508": "obsolete positive regulation by organism of defense-related symbiont salicylic acid-mediated signal transduction pathway",
  "GO:0052509": "positive regulation by symbiont of host defense response",
  "GO:0052510": "positive regulation by organism of defense response of other organism involved in symbiotic interaction",
  "GO:0052511": "obsolete positive regulation by organism of symbiont ethylene-mediated defense response",
  "GO:0052512": "obsolete positive regulation by organism of hormone or growth regulator levels in symbiont",
  "GO:0052513": "positive regulation by organism of hormone or growth regulator levels in other organism involved in symbiotic interaction",
  "GO:0052514": "obsolete positive regulation by organism of symbiont inflammatory response",
  "GO:0052515": "obsolete positive regulation by organism of symbiont innate immunity",
  "GO:0052516": "obsolete positive regulation by organism of symbiont jasmonic acid-mediated defense response",
  "GO:0052517": "obsolete positive regulation by organism of symbiont non-apoptotic programmed cell death",
  "GO:0052519": "positive regulation by host of nutrient release from symbiont",
  "GO:0052520": "positive regulation by organism of nutrient release from other organism involved in symbiotic interaction",
  "GO:0052521": "positive regulation by host of symbiont phagocytosis",
  "GO:0052522": "positive regulation by organism of phagocytosis in other organism involved in symbiotic interaction",
  "GO:0052523": "obsolete positive regulation by organism of symbiont programmed cell death",
  "GO:0052524": "obsolete positive regulation by organism of symbiont salicylic acid-mediated defense response",
  "GO:0052525": "positive regulation by host of symbiont signal transduction pathway",
  "GO:0052526": "positive regulation by organism of signal transduction in other organism involved in symbiotic interaction",
  "GO:0052527": "positive regulation by symbiont of host resistance gene-dependent defense response",
  "GO:0052528": "obsolete upregulation by organism of symbiont programmed cell death",
  "GO:0052530": "obsolete positive regulation by organism of symbiont resistance gene-dependent defense response",
  "GO:0052531": "obsolete positive regulation by organism of defense-related symbiont calcium ion flux",
  "GO:0052532": "positive regulation by organism of induced systemic resistance in other organism involved in symbiotic interaction",
  "GO:0052533": "positive regulation by symbiont of host induced systemic resistance",
  "GO:0052534": "obsolete positive regulation by organism of induced systemic resistance in symbiont",
  "GO:0052535": "positive regulation by organism of systemic acquired resistance in other organism involved in symbiotic interaction",
  "GO:0052536": "obsolete positive regulation by organism of systemic acquired resistance in symbiont",
  "GO:0052537": "positive regulation by symbiont of host systemic acquired resistance",
  "GO:0052538": "positive regulation by organism of defense-related cell wall thickening in other organism involved in symbiotic interaction",
  "GO:0052539": "positive regulation by symbiont of defense-related host cell wall thickening",
  "GO:0052540": "obsolete positive regulation by organism of defense-related symbiont cell wall thickening",
  "GO:0052541": "plant-type cell wall cellulose metabolic process",
  "GO:0052542": "defense response by callose deposition",
  "GO:0052543": "callose deposition in cell wall",
  "GO:0052544": "defense response by callose deposition in cell wall",
  "GO:0052545": "callose localization",
  "GO:0052546": "cell wall pectin metabolic process",
  "GO:0052547": "regulation of peptidase activity",
  "GO:0052548": "regulation of endopeptidase activity",
  "GO:0052549": "response to phytoalexin production by other organism involved in symbiotic interaction",
  "GO:0052550": "response to defense-related reactive oxygen species production by other organism involved in symbiotic interaction",
  "GO:0052551": "response to defense-related nitric oxide production by other organism involved in symbiotic interaction",
  "GO:0052552": "modulation by organism of immune response of other organism involved in symbiotic interaction",
  "GO:0052553": "modulation by symbiont of host immune response",
  "GO:0052554": "obsolete modulation by organism of symbiont immune response",
  "GO:0052555": "positive regulation by organism of immune response of other organism involved in symbiotic interaction",
  "GO:0052556": "positive regulation by symbiont of host immune response",
  "GO:0052557": "obsolete positive regulation by organism of symbiont immune response",
  "GO:0052558": "induction by organism of immune response of other organism involved in symbiotic interaction",
  "GO:0052559": "induction by symbiont of host immune response",
  "GO:0052560": "obsolete induction by organism of symbiont immune response",
  "GO:0052561": "negative regulation by organism of immune response of other organism involved in symbiotic interaction",
  "GO:0052562": "negative regulation by symbiont of host immune response",
  "GO:0052563": "obsolete negative regulation by organism of symbiont immune response",
  "GO:0052564": "response to immune response of other organism involved in symbiotic interaction",
  "GO:0052565": "response to defense-related host nitric oxide production",
  "GO:0052566": "response to host phytoalexin production",
  "GO:0052567": "response to defense-related host reactive oxygen species production",
  "GO:0052568": "obsolete response to symbiont phytoalexin production",
  "GO:0052569": "obsolete response to defense-related symbiont nitric oxide production",
  "GO:0052570": "obsolete response to defense-related symbiont reactive oxygen species production",
  "GO:0052571": "obsolete response to symbiont immune response",
  "GO:0052572": "response to host immune response",
  "GO:0052573": "UDP-D-galactose metabolic process",
  "GO:0052574": "UDP-D-galactose biosynthetic process",
  "GO:0052575": "carbohydrate localization",
  "GO:0052576": "carbohydrate storage",
  "GO:0052577": "germacrene-D synthase activity",
  "GO:0052578": "alpha-farnesene synthase activity",
  "GO:0052579": "(+)-pulegone reductase, (+)-isomenthone as substrate, activity",
  "GO:0052580": "(+)-pulegone reductase, (-)-menthone as substrate, activity",
  "GO:0052581": "(-)-isopiperitenone reductase activity",
  "GO:0052582": "(+)-menthofuran synthase activity",
  "GO:0052583": "oxidoreductase activity, acting on halogen in donors",
  "GO:0052584": "oxidoreductase activity, acting on halogen in donors, with NAD or NADP as acceptor",
  "GO:0052585": "oxidoreductase activity, acting on the CH-NH2 group of donors, with a quinone or similar compound as acceptor",
  "GO:0052586": "oxidoreductase activity, acting on other nitrogenous compounds as donors, with a quinone or similar compound as acceptor",
  "GO:0052587": "diacetyl reductase ((R)-acetoin forming) activity",
  "GO:0052588": "diacetyl reductase ((S)-acetoin forming) activity",
  "GO:0052589": "malate dehydrogenase (menaquinone) activity",
  "GO:0052590": "sn-glycerol-3-phosphate:ubiquinone oxidoreductase activity",
  "GO:0052591": "sn-glycerol-3-phosphate:ubiquinone-8 oxidoreductase activity",
  "GO:0052592": "oxidoreductase activity, acting on CH or CH2 groups, with an iron-sulfur protein as acceptor",
  "GO:0052593": "tryptamine:oxygen oxidoreductase (deaminating) activity",
  "GO:0052594": "aminoacetone:oxygen oxidoreductase(deaminating) activity",
  "GO:0052595": "aliphatic-amine oxidase activity",
  "GO:0052596": "phenethylamine:oxygen oxidoreductase (deaminating) activity",
  "GO:0052597": "diamine oxidase activity",
  "GO:0052598": "histamine oxidase activity",
  "GO:0052599": "methylputrescine oxidase activity",
  "GO:0052600": "propane-1,3-diamine oxidase activity",
  "GO:0052601": "(S)-limonene 1,2-monooxygenase activity",
  "GO:0052602": "4-chloronitrobenzene nitroreductase activity",
  "GO:0052603": "1-chloro-4-nitrosobenzene nitroreductase activity",
  "GO:0052604": "delta-tocopherol cyclase activity",
  "GO:0052605": "gamma-tocopherol cyclase activity",
  "GO:0052606": "chlorophyllide a oxygenase activity",
  "GO:0052607": "7-hydroxy-chlorophyllide a oxygenase activity",
  "GO:0052608": "echinenone 3-hydroxylase activity",
  "GO:0052609": "4-ketotorulene 3-hydroxylase activity",
  "GO:0052610": "beta-cryptoxanthin hydroxylase activity",
  "GO:0052611": "beta-carotene 3-hydroxylase activity",
  "GO:0052612": "adonirubin 3-hydroxylase activity",
  "GO:0052613": "canthaxanthin 3-hydroxylase activity",
  "GO:0052614": "uracil oxygenase activity",
  "GO:0052615": "ent-kaurene oxidase activity",
  "GO:0052616": "ent-kaur-16-en-19-ol oxidase activity",
  "GO:0052617": "ent-kaur-16-en-19-al oxidase activity",
  "GO:0052618": "coenzyme F420-0:L-glutamate ligase activity",
  "GO:0052619": "coenzyme F420-1:gamma-L-glutamate ligase activity",
  "GO:0052620": "thymine dehydrogenase activity",
  "GO:0052621": "diguanylate cyclase activity",
  "GO:0052622": "ATP dimethylallyltransferase activity",
  "GO:0052623": "ADP dimethylallyltransferase activity",
  "GO:0052624": "2-phytyl-1,4-naphthoquinone methyltransferase activity",
  "GO:0052625": "4-aminobenzoate amino acid synthetase activity",
  "GO:0052626": "benzoate amino acid synthetase activity",
  "GO:0052627": "vanillate amino acid synthetase activity",
  "GO:0052628": "4-hydroxybenzoate amino acid synthetase activity",
  "GO:0052629": "phosphatidylinositol-3,5-bisphosphate 3-phosphatase activity",
  "GO:0052630": "UDP-N-acetylgalactosamine diphosphorylase activity",
  "GO:0052631": "sphingolipid delta-8 desaturase activity",
  "GO:0052633": "isocitrate hydro-lyase (cis-aconitate-forming) activity",
  "GO:0052634": "C-19 gibberellin 2-beta-dioxygenase activity",
  "GO:0052635": "C-20 gibberellin 2-beta-dioxygenase activity",
  "GO:0052636": "arabinosyltransferase activity",
  "GO:0052637": "delta 3-trans-hexadecenoic acid phosphatidylglycerol desaturase activity",
  "GO:0052638": "indole-3-butyrate beta-glucosyltransferase activity",
  "GO:0052639": "salicylic acid glucosyltransferase (ester-forming) activity",
  "GO:0052640": "salicylic acid glucosyltransferase (glucoside-forming) activity",
  "GO:0052641": "benzoic acid glucosyltransferase activity",
  "GO:0052642": "lysophosphatidic acid phosphatase activity",
  "GO:0052643": "chlorophyllide metabolic process",
  "GO:0052644": "chlorophyllide a metabolic process",
  "GO:0052645": "F420-0 metabolic process",
  "GO:0052646": "alditol phosphate metabolic process",
  "GO:0052647": "pentitol phosphate metabolic process",
  "GO:0052648": "ribitol phosphate metabolic process",
  "GO:0052649": "coenzyme gamma-F420-2 metabolic process",
  "GO:0052650": "NADP-retinol dehydrogenase activity",
  "GO:0052651": "monoacylglycerol catabolic process",
  "GO:0052652": "cyclic purine nucleotide metabolic process",
  "GO:0052653": "3',5'-cyclic diguanylic acid metabolic process",
  "GO:0052654": "L-leucine transaminase activity",
  "GO:0052655": "L-valine transaminase activity",
  "GO:0052656": "L-isoleucine transaminase activity",
  "GO:0052657": "guanine phosphoribosyltransferase activity",
  "GO:0052658": "inositol-1,4,5-trisphosphate 5-phosphatase activity",
  "GO:0052659": "inositol-1,3,4,5-tetrakisphosphate 5-phosphatase activity",
  "GO:0052660": "R-lactaldehyde reductase activity",
  "GO:0052661": "S-lactaldehyde reductase activity",
  "GO:0052662": "zeaxanthin epoxidase activity",
  "GO:0052663": "antheraxanthin epoxidase activity",
  "GO:0052664": "nitroalkane oxidase activity",
  "GO:0052665": "tRNA (uracil-2'-O-)-methyltransferase activity",
  "GO:0052666": "tRNA (cytosine-2'-O-)-methyltransferase activity",
  "GO:0052667": "phosphomethylethanolamine N-methyltransferase activity",
  "GO:0052668": "farnesol kinase activity",
  "GO:0052669": "CTP:2-trans,-6-trans-farnesol kinase activity",
  "GO:0052670": "geraniol kinase activity",
  "GO:0052671": "geranylgeraniol kinase activity",
  "GO:0052672": "CTP:geranylgeraniol kinase activity",
  "GO:0052673": "prenol kinase activity",
  "GO:0052674": "ent-pimara-9(11),15-diene synthase activity",
  "GO:0052675": "3-methylbutanol:NADP oxidoreductase activity",
  "GO:0052676": "3-methylbutanol:NAD oxidoreductase activity",
  "GO:0052677": "D-arabinitol dehydrogenase, D-xylulose forming (NADP+) activity",
  "GO:0052678": "levopimaradiene synthase activity",
  "GO:0052679": "terpentetriene synthase activity",
  "GO:0052680": "epi-isozizaene synthase activity",
  "GO:0052681": "alpha-bisabolene synthase activity",
  "GO:0052682": "epi-cedrol synthase activity",
  "GO:0052683": "(Z)-gamma-bisabolene synthase activity",
  "GO:0052684": "L-serine hydro-lyase (adding indole, L-tryptophan-forming) activity",
  "GO:0052685": "perillic acid:CoA ligase (ADP-forming) activity",
  "GO:0052686": "perillic acid:CoA ligase (AMP-forming) activity",
  "GO:0052687": "(3R)-3-isopropenyl-6-oxoheptanoate:CoA ligase (ADP-forming) activity",
  "GO:0052688": "(3R)-3-isopropenyl-6-oxoheptanoate:CoA ligase (AMP-forming) activity",
  "GO:0052689": "carboxylic ester hydrolase activity",
  "GO:0052690": "trichloro-p-hydroquinone reductive dehalogenase activity",
  "GO:0052691": "UDP-arabinopyranose mutase activity",
  "GO:0052692": "raffinose alpha-galactosidase activity",
  "GO:0052693": "epoxyqueuosine reductase activity",
  "GO:0052694": "jasmonoyl-isoleucine-12-hydroxylase activity",
  "GO:0052695": "cellular glucuronidation",
  "GO:0052696": "flavonoid glucuronidation",
  "GO:0052697": "xenobiotic glucuronidation",
  "GO:0052698": "ergothioneine metabolic process",
  "GO:0052699": "ergothioneine biosynthetic process",
  "GO:0052700": "ergothioneine catabolic process",
  "GO:0052701": "cellular modified histidine metabolic process",
  "GO:0052702": "cellular modified histidine catabolic process",
  "GO:0052703": "cellular modified histidine biosynthetic process",
  "GO:0052704": "ergothioneine biosynthesis from histidine via N-alpha,N-alpha,N-alpha-trimethyl-L-histidine",
  "GO:0052705": "methylhistidine N-methyltransferase activity",
  "GO:0052706": "histidine N-methyltransferase activity",
  "GO:0052707": "N-alpha,N-alpha,N-alpha-trimethyl-L-histidine biosynthesis from histidine",
  "GO:0052708": "N-alpha,N-alpha,N-alpha-trimethyl-L-histidine metabolic process",
  "GO:0052709": "N-alpha,N-alpha,N-alpha-trimethyl-L-histidine biosynthetic process",
  "GO:0052710": "N-alpha,N-alpha,N-alpha-trimethyl-L-histidine catabolic process",
  "GO:0052711": "ergothioneine biosynthesis from N-alpha,N-alpha,N-alpha-trimethyl-L-histidine",
  "GO:0052712": "inositol phosphosphingolipid phospholipase activity",
  "GO:0052713": "inositol phosphorylceramide phospholipase activity",
  "GO:0052714": "mannosyl-inositol phosphorylceramide phospholipase activity",
  "GO:0052715": "mannosyl-diinositol phosphorylceramide phospholipase activity",
  "GO:0052716": "hydroquinone:oxygen oxidoreductase activity",
  "GO:0052717": "tRNA-specific adenosine-34 deaminase activity",
  "GO:0052718": "tRNA-specific adenosine-34 deaminase complex",
  "GO:0052719": "apurinic/apyrimidinic endoribonuclease activity",
  "GO:0052720": "apurinic/apyrimidinic endodeoxyribonuclease activity",
  "GO:0052721": "regulation of apurinic/apyrimidinic endodeoxyribonuclease activity",
  "GO:0052722": "fatty acid in-chain hydroxylase activity",
  "GO:0052723": "inositol hexakisphosphate 1-kinase activity",
  "GO:0052724": "inositol hexakisphosphate 3-kinase activity",
  "GO:0052725": "inositol-1,3,4-trisphosphate 6-kinase activity",
  "GO:0052726": "inositol-1,3,4-trisphosphate 5-kinase activity",
  "GO:0052727": "capsanthin synthase activity",
  "GO:0052728": "capsorubin synthase activity",
  "GO:0052729": "dimethylglycine N-methyltransferase activity",
  "GO:0052730": "sarcosine N-methyltransferase activity",
  "GO:0052731": "phosphocholine phosphatase activity",
  "GO:0052732": "phosphoethanolamine phosphatase activity",
  "GO:0052733": "quinate 3-dehydrogenase (NADP+) activity",
  "GO:0052734": "shikimate 3-dehydrogenase (NAD+) activity",
  "GO:0052735": "tRNA (cytosine-3-)-methyltransferase activity",
  "GO:0052736": "beta-glucanase activity",
  "GO:0052737": "pyruvate dehydrogenase (quinone) activity",
  "GO:0052738": "oxidoreductase activity, acting on the aldehyde or oxo group of donors, with a quinone or similar compound as acceptor",
  "GO:0052739": "phosphatidylserine 1-acylhydrolase activity",
  "GO:0052740": "1-acyl-2-lysophosphatidylserine acylhydrolase activity",
  "GO:0052741": "(R)-limonene 6-monooxygenase activity",
  "GO:0052742": "phosphatidylinositol kinase activity",
  "GO:0052743": "inositol tetrakisphosphate phosphatase activity",
  "GO:0052744": "phosphatidylinositol monophosphate phosphatase activity",
  "GO:0052745": "inositol phosphate phosphatase activity",
  "GO:0052746": "inositol phosphorylation",
  "GO:0052747": "sinapyl alcohol dehydrogenase activity",
  "GO:0052748": "baicalin beta-D-glucuronidase activity",
  "GO:0052749": "glucose-6-phosphate dehydrogenase (coenzyme F420) activity",
  "GO:0052750": "reactive-black-5:hydrogen-peroxide oxidoreductase activity",
  "GO:0052751": "GDP-mannose hydrolase activity",
  "GO:0052752": "reduced coenzyme F420:heterodisulfide oxidoreductase activity",
  "GO:0052753": "propan-2-ol:coenzyme F420 oxidoreductase activity",
  "GO:0052754": "GTP:coenzyme F420 guanyltransferase activity",
  "GO:0052755": "reduced coenzyme F420:quinone oxidoreductase activity",
  "GO:0052756": "chitobiose phosphorylase activity",
  "GO:0052757": "chondroitin hydrolase activity",
  "GO:0052758": "coenzyme F420-dependent 2,4,6-trinitrophenol reductase activity",
  "GO:0052759": "coenzyme F420-dependent 2,4,6-trinitrophenol hydride reductase activity",
  "GO:0052760": "coenzyme F420-dependent 2,4-dinitrophenol reductase activity",
  "GO:0052761": "exo-1,4-beta-D-glucosaminidase activity",
  "GO:0052762": "gellan lyase activity",
  "GO:0052763": "ulvan lyase activity",
  "GO:0052764": "exo-oligoalginate lyase activity",
  "GO:0052765": "reduced coenzyme F420 oxidase activity",
  "GO:0052766": "mannoside alpha-1,4-mannosidase activity",
  "GO:0052767": "mannosyl-oligosaccharide 1,6-alpha-mannosidase activity",
  "GO:0052768": "mannosyl-oligosaccharide 1,3-alpha-mannosidase activity",
  "GO:0052769": "beta-6-sulfate-N-acetylglucosaminidase activity",
  "GO:0052770": "coenzyme F390-A hydrolase activity",
  "GO:0052771": "coenzyme F390-G hydrolase activity",
  "GO:0052772": "brefeldin A esterase activity",
  "GO:0052773": "diacetylchitobiose deacetylase activity",
  "GO:0052774": "glucosyl-N-acetylglucosamine glucosaminidase activity",
  "GO:0052775": "endo-1,3-alpha-L-rhamnosidase activity",
  "GO:0052776": "diacetylchitobiose catabolic process to glucosamine and acetate",
  "GO:0052777": "diacetylchitobiose catabolic process",
  "GO:0052778": "diacetylchitobiose metabolic process",
  "GO:0052779": "amino disaccharide metabolic process",
  "GO:0052780": "chitobiose metabolic process",
  "GO:0052781": "chitobiose catabolic process",
  "GO:0052782": "amino disaccharide catabolic process",
  "GO:0052783": "reuteran metabolic process",
  "GO:0052784": "reuteran biosynthetic process",
  "GO:0052785": "cellulose catabolism by endo-processive cellulases",
  "GO:0052786": "alpha-linked polysaccharide catabolism to maltotriose",
  "GO:0052787": "alpha-linked polysaccharide catabolism to maltopentaose",
  "GO:0052788": "d-4,5 unsaturated beta-glucuronyl hydrolase activity",
  "GO:0052789": "mannan 1,3-beta-mannosidase activity",
  "GO:0052790": "chitooligosaccharide deacetylase activity",
  "GO:0052791": "3-deoxy-D-glycero-D-galacto-2-nonulosonic acid hydrolase activity",
  "GO:0052792": "endo-xylogalacturonan hydrolase activity",
  "GO:0052793": "pectin acetylesterase activity",
  "GO:0052794": "exo-alpha-(2->3)-sialidase activity",
  "GO:0052795": "exo-alpha-(2->6)-sialidase activity",
  "GO:0052796": "exo-alpha-(2->8)-sialidase activity",
  "GO:0052797": "4-O-methyl-glucuronoyl methylesterase activity",
  "GO:0052798": "beta-galactoside alpha-2,3-sialyltransferase activity",
  "GO:0052799": "coenzyme F420-dependent bicyclic nitroimidazole catabolic process",
  "GO:0052800": "bicyclic nitroimidazole catabolic process",
  "GO:0052801": "bicyclic nitroimidazole metabolic process",
  "GO:0052802": "nitroimidazole metabolic process",
  "GO:0052803": "imidazole-containing compound metabolic process",
  "GO:0052804": "nitroimidazole catabolic process",
  "GO:0052805": "imidazole-containing compound catabolic process",
  "GO:0052806": "sulfite reductase (coenzyme F420) activity",
  "GO:0052807": "aflatoxin reductase (coenzyme F420) activity",
  "GO:0052808": "reduced coenzyme F420:NADP+ oxidoreductase activity",
  "GO:0052809": "acharan sulfate lyase activity",
  "GO:0052810": "1-phosphatidylinositol-5-kinase activity",
  "GO:0052811": "1-phosphatidylinositol-3-phosphate 4-kinase activity",
  "GO:0052812": "phosphatidylinositol-3,4-bisphosphate 5-kinase activity",
  "GO:0052813": "phosphatidylinositol bisphosphate kinase activity",
  "GO:0052814": "medium-chain-aldehyde dehydrogenase activity",
  "GO:0052815": "medium-chain acyl-CoA hydrolase activity",
  "GO:0052816": "long-chain acyl-CoA hydrolase activity",
  "GO:0052817": "very long chain acyl-CoA hydrolase activity",
  "GO:0052818": "heteroglycan 3-alpha-mannosyltransferase activity",
  "GO:0052819": "heteroglycan 2-alpha-mannosyltransferase activity",
  "GO:0052820": "DNA-1,N6-ethenoadenine N-glycosylase activity",
  "GO:0052821": "DNA-7-methyladenine glycosylase activity",
  "GO:0052822": "DNA-3-methylguanine glycosylase activity",
  "GO:0052823": "2-hydroxy-6-oxonona-2,4,7-trienedioate hydrolase activity",
  "GO:0052824": "dolichyl-pyrophosphate Man7GlcNAc2 alpha-1,6-mannosyltransferase activity",
  "GO:0052825": "inositol-1,3,4,5,6-pentakisphosphate 1-phosphatase activity",
  "GO:0052826": "inositol hexakisphosphate 2-phosphatase activity",
  "GO:0052827": "inositol pentakisphosphate phosphatase activity",
  "GO:0052828": "inositol-3,4-bisphosphate 4-phosphatase activity",
  "GO:0052829": "inositol-1,3,4-trisphosphate 1-phosphatase activity",
  "GO:0052830": "inositol-1,3,4,6-tetrakisphosphate 6-phosphatase activity",
  "GO:0052831": "inositol-1,3,4,6-tetrakisphosphate 1-phosphatase activity",
  "GO:0052832": "inositol monophosphate 3-phosphatase activity",
  "GO:0052833": "inositol monophosphate 4-phosphatase activity",
  "GO:0052834": "inositol monophosphate phosphatase activity",
  "GO:0052835": "inositol-3,4,6-trisphosphate 1-kinase activity",
  "GO:0052836": "inositol 5-diphosphate pentakisphosphate 5-kinase activity",
  "GO:0052837": "thiazole biosynthetic process",
  "GO:0052838": "thiazole metabolic process",
  "GO:0052839": "inositol diphosphate tetrakisphosphate kinase activity",
  "GO:0052840": "inositol diphosphate tetrakisphosphate diphosphatase activity",
  "GO:0052841": "inositol bisdiphosphate tetrakisphosphate diphosphatase activity",
  "GO:0052842": "inositol diphosphate pentakisphosphate diphosphatase activity",
  "GO:0052843": "inositol-1-diphosphate-2,3,4,5,6-pentakisphosphate diphosphatase activity",
  "GO:0052844": "inositol-3-diphosphate-1,2,4,5,6-pentakisphosphate diphosphatase activity",
  "GO:0052845": "inositol-5-diphosphate-1,2,3,4,6-pentakisphosphate diphosphatase activity",
  "GO:0052846": "inositol-1,5-bisdiphosphate-2,3,4,6-tetrakisphosphate 1-diphosphatase activity",
  "GO:0052847": "inositol-1,5-bisdiphosphate-2,3,4,6-tetrakisphosphate 5-diphosphatase activity",
  "GO:0052848": "inositol-3,5-bisdiphosphate-2,3,4,6-tetrakisphosphate 5-diphosphatase activity",
  "GO:0052849": "NADPH-dependent curcumin reductase activity",
  "GO:0052850": "NADPH-dependent dihydrocurcumin reductase activity",
  "GO:0052851": "ferric-chelate reductase (NADPH) activity",
  "GO:0052852": "very-long-chain-(S)-2-hydroxy-acid oxidase activity",
  "GO:0052853": "long-chain-(S)-2-hydroxy-long-chain-acid oxidase activity",
  "GO:0052854": "medium-chain-(S)-2-hydroxy-acid oxidase activity",
  "GO:0052855": "ADP-dependent NAD(P)H-hydrate dehydratase activity",
  "GO:0052856": "NADHX epimerase activity",
  "GO:0052857": "NADPHX epimerase activity",
  "GO:0052858": "peptidyl-lysine N-acetyltransferase activity, acting on acetyl phosphate as donor",
  "GO:0052859": "glucan endo-1,4-beta-glucosidase activity",
  "GO:0052860": "2'-deoxymugineic-acid 3-dioxygenase activity",
  "GO:0052861": "glucan endo-1,3-beta-glucanase activity, C-3 substituted reducing group",
  "GO:0052862": "glucan endo-1,4-beta-glucanase activity, C-3 substituted reducing group",
  "GO:0052863": "1-deoxy-D-xylulose 5-phosphate metabolic process",
  "GO:0052864": "1-deoxy-D-xylulose 5-phosphate catabolic process",
  "GO:0052865": "1-deoxy-D-xylulose 5-phosphate biosynthetic process",
  "GO:0052866": "phosphatidylinositol phosphate phosphatase activity",
  "GO:0052867": "phosphatidylinositol-1,4,5-trisphosphate 5-phosphatase activity",
  "GO:0052868": "protein-lysine lysyltransferase activity",
  "GO:0052869": "arachidonic acid omega-hydroxylase activity",
  "GO:0052870": "tocopherol omega-hydroxylase activity",
  "GO:0052871": "alpha-tocopherol omega-hydroxylase activity",
  "GO:0052872": "tocotrienol omega-hydroxylase activity",
  "GO:0052873": "FMN reductase (NADPH) activity",
  "GO:0052874": "FMN reductase (NADH) activity",
  "GO:0052875": "riboflavin reductase (NADH) activity",
  "GO:0052876": "methylamine dehydrogenase (amicyanin) activity",
  "GO:0052877": "oxidoreductase activity, acting on the CH-NH2 group of donors, with a copper protein as acceptor",
  "GO:0052878": "linoleate 8R-lipoxygenase activity",
  "GO:0052879": "9,12-octadecadienoate 8-hydroperoxide 8S-isomerase activity",
  "GO:0052880": "oxidoreductase activity, acting on diphenols and related substances as donors, with copper protein as acceptor",
  "GO:0052881": "4-hydroxyphenylacetate 3-monooxygenase activity",
  "GO:0052882": "oxidoreductase activity, acting on phosphorus or arsenic in donors, with a copper protein as acceptor",
  "GO:0052883": "tyrosine ammonia-lyase activity",
  "GO:0052884": "all-trans-retinyl-palmitate hydrolase, 11-cis retinol forming activity",
  "GO:0052885": "all-trans-retinyl-ester hydrolase, 11-cis retinol forming activity",
  "GO:0052886": "9,9'-dicis-carotene:quinone oxidoreductase activity",
  "GO:0052887": "7,9,9'-tricis-neurosporene:quinone oxidoreductase activity",
  "GO:0052888": "obsolete OBSOLETE:dihydroorotate oxidase (fumarate) activity",
  "GO:0052889": "9,9'-di-cis-zeta-carotene desaturation to 7,9,7',9'-tetra-cis-lycopene",
  "GO:0052890": "oxidoreductase activity, acting on the CH-CH group of donors, with a flavin as acceptor",
  "GO:0052891": "aliphatic (S)-hydroxynitrile lyase activity",
  "GO:0052892": "aromatic (S)-hydroxynitrile lyase activity",
  "GO:0052893": "N1-acetylspermine:oxygen oxidoreductase (propane-1,3-diamine-forming) activity",
  "GO:0052894": "norspermine:oxygen oxidoreductase activity",
  "GO:0052895": "N1-acetylspermine:oxygen oxidoreductase (N1-acetylspermidine-forming) activity",
  "GO:0052896": "spermidine oxidase (propane-1,3-diamine-forming) activity",
  "GO:0052897": "N8-acetylspermidine:oxygen oxidoreductase (propane-1,3-diamine-forming) activity",
  "GO:0052898": "N1-acetylspermidine:oxygen oxidoreductase (propane-1,3-diamine-forming) activity",
  "GO:0052899": "N(1),N(12)-diacetylspermine:oxygen oxidoreductase (3-acetamidopropanal-forming) activity",
  "GO:0052900": "spermine oxidase (propane-1,3-diamine-forming) activity",
  "GO:0052901": "spermine:oxygen oxidoreductase (spermidine-forming) activity",
  "GO:0052902": "spermidine:oxygen oxidoreductase (3-aminopropanal-forming) activity",
  "GO:0052903": "N1-acetylspermine:oxygen oxidoreductase (3-acetamidopropanal-forming) activity",
  "GO:0052904": "N1-acetylspermidine:oxygen oxidoreductase (3-acetamidopropanal-forming) activity",
  "GO:0052905": "tRNA (guanine(9)-N(1))-methyltransferase activity",
  "GO:0052906": "tRNA (guanine(37)-N(1))-methyltransferase activity",
  "GO:0052907": "23S rRNA (adenine(1618)-N(6))-methyltransferase activity",
  "GO:0052908": "16S rRNA (adenine(1518)-N(6)/adenine(1519)-N(6))-dimethyltransferase activity",
  "GO:0052909": "18S rRNA (adenine(1779)-N(6)/adenine(1780)-N(6))-dimethyltransferase activity",
  "GO:0052910": "23S rRNA (adenine(2085)-N(6))-dimethyltransferase activity",
  "GO:0052911": "23S rRNA (guanine(745)-N(1))-methyltransferase activity",
  "GO:0052912": "23S rRNA (guanine(748)-N(1))-methyltransferase activity",
  "GO:0052913": "16S rRNA (guanine(966)-N(2))-methyltransferase activity",
  "GO:0052914": "16S rRNA (guanine(1207)-N(2))-methyltransferase activity",
  "GO:0052915": "23S rRNA (guanine(2445)-N(2))-methyltransferase activity",
  "GO:0052916": "23S rRNA (guanine(1835)-N(2))-methyltransferase activity",
  "GO:0052917": "dol-P-Man:Man(7)GlcNAc(2)-PP-Dol alpha-1,6-mannosyltransferase activity",
  "GO:0052918": "dol-P-Man:Man(8)GlcNAc(2)-PP-Dol alpha-1,2-mannosyltransferase activity",
  "GO:0052919": "aliphatic (R)-hydroxynitrile lyase activity",
  "GO:0052920": "(2R)-2-hydroxy-2-methylbutanenitrile lyase activity",
  "GO:0052921": "acetone-cyanohydrin acetone-lyase (cyanide-forming) activity",
  "GO:0052922": "hexaprenyl diphosphate synthase (geranylgeranyl-diphosphate specific) activity",
  "GO:0052923": "all-trans-nonaprenyl-diphosphate synthase (geranyl-diphosphate specific) activity",
  "GO:0052924": "all-trans-nonaprenyl-diphosphate synthase (geranylgeranyl-diphosphate specific) activity",
  "GO:0052925": "dol-P-Man:Man(5)GlcNAc(2)-PP-Dol alpha-1,3-mannosyltransferase activity",
  "GO:0052926": "dol-P-Man:Man(6)GlcNAc(2)-PP-Dol alpha-1,2-mannosyltransferase activity",
  "GO:0052927": "CTP:tRNA cytidylyltransferase activity",
  "GO:0052928": "CTP:3'-cytidine-tRNA cytidylyltransferase activity",
  "GO:0052929": "ATP:3'-cytidine-cytidine-tRNA adenylyltransferase activity",
  "GO:0052930": "methanol ferricytochrome-c oxidoreductase activity",
  "GO:0052931": "ethanol cytochrome-c oxidoreductase activity",
  "GO:0052932": "2-chloroethanol cytochrome-c oxidoreductase activity",
  "GO:0052933": "alcohol dehydrogenase (cytochrome c(L)) activity",
  "GO:0052934": "alcohol dehydrogenase (cytochrome c) activity",
  "GO:0052935": "ethanol:cytochrome c oxidoreductase activity",
  "GO:0052936": "2-chloroethanol:cytochrome c oxidoreductase activity",
  "GO:0055001": "muscle cell development",
  "GO:0055002": "striated muscle cell development",
  "GO:0055003": "cardiac myofibril assembly",
  "GO:0055004": "atrial cardiac myofibril assembly",
  "GO:0055005": "ventricular cardiac myofibril assembly",
  "GO:0055006": "cardiac cell development",
  "GO:0055007": "cardiac muscle cell differentiation",
  "GO:0055008": "cardiac muscle tissue morphogenesis",
  "GO:0055009": "atrial cardiac muscle tissue morphogenesis",
  "GO:0055010": "ventricular cardiac muscle tissue morphogenesis",
  "GO:0055011": "atrial cardiac muscle cell differentiation",
  "GO:0055012": "ventricular cardiac muscle cell differentiation",
  "GO:0055013": "cardiac muscle cell development",
  "GO:0055014": "atrial cardiac muscle cell development",
  "GO:0055015": "ventricular cardiac muscle cell development",
  "GO:0055016": "hypochord development",
  "GO:0055017": "cardiac muscle tissue growth",
  "GO:0055018": "regulation of cardiac muscle fiber development",
  "GO:0055019": "negative regulation of cardiac muscle fiber development",
  "GO:0055020": "positive regulation of cardiac muscle fiber development",
  "GO:0055021": "regulation of cardiac muscle tissue growth",
  "GO:0055022": "negative regulation of cardiac muscle tissue growth",
  "GO:0055023": "positive regulation of cardiac muscle tissue growth",
  "GO:0055024": "regulation of cardiac muscle tissue development",
  "GO:0055025": "positive regulation of cardiac muscle tissue development",
  "GO:0055026": "negative regulation of cardiac muscle tissue development",
  "GO:0055028": "cortical microtubule",
  "GO:0055029": "nuclear DNA-directed RNA polymerase complex",
  "GO:0055031": "gamma-tubulin large complex, equatorial microtubule organizing center",
  "GO:0055032": "gamma-tubulin large complex, spindle pole body",
  "GO:0055033": "gamma-tubulin large complex, interphase microtubule organizing center",
  "GO:0055034": "Bolwig's organ development",
  "GO:0055035": "plastid thylakoid membrane",
  "GO:0055036": "virion membrane",
  "GO:0055037": "recycling endosome",
  "GO:0055038": "recycling endosome membrane",
  "GO:0055039": "trichocyst",
  "GO:0055040": "periplasmic flagellum",
  "GO:0055041": "cyclopentanol dehydrogenase activity",
  "GO:0055042": "5-valerolactone hydrolase activity",
  "GO:0055043": "5-oxovalerate dehydrogenase activity",
  "GO:0055044": "symplast",
  "GO:0055045": "antipodal cell degeneration",
  "GO:0055046": "microgametogenesis",
  "GO:0055047": "generative cell mitosis",
  "GO:0055048": "anastral spindle assembly",
  "GO:0055049": "astral spindle assembly",
  "GO:0055050": "astral spindle assembly involved in male meiosis",
  "GO:0055051": "ATP-binding cassette (ABC) transporter complex, integrated substrate binding",
  "GO:0055052": "ATP-binding cassette (ABC) transporter complex, substrate-binding subunit-containing",
  "GO:0055053": "mannose:proton symporter activity",
  "GO:0055054": "fructose:proton symporter activity",
  "GO:0055055": "D-glucose:proton symporter activity",
  "GO:0055056": "D-glucose transmembrane transporter activity",
  "GO:0055057": "neuroblast division",
  "GO:0055058": "symmetric neuroblast division",
  "GO:0055059": "asymmetric neuroblast division",
  "GO:0055060": "asymmetric neuroblast division resulting in ganglion mother cell formation",
  "GO:0055061": "obsolete di-, tri-valent inorganic anion homeostasis",
  "GO:0055062": "phosphate ion homeostasis",
  "GO:0055063": "sulfate ion homeostasis",
  "GO:0055064": "chloride ion homeostasis",
  "GO:0055065": "metal ion homeostasis",
  "GO:0055066": "obsolete di-, tri-valent inorganic cation homeostasis",
  "GO:0055067": "monovalent inorganic cation homeostasis",
  "GO:0055068": "cobalt ion homeostasis",
  "GO:0055069": "zinc ion homeostasis",
  "GO:0055070": "copper ion homeostasis",
  "GO:0055071": "manganese ion homeostasis",
  "GO:0055072": "iron ion homeostasis",
  "GO:0055073": "cadmium ion homeostasis",
  "GO:0055074": "calcium ion homeostasis",
  "GO:0055075": "potassium ion homeostasis",
  "GO:0055076": "transition metal ion homeostasis",
  "GO:0055077": "gap junction hemi-channel activity",
  "GO:0055078": "sodium ion homeostasis",
  "GO:0055079": "aluminum ion homeostasis",
  "GO:0055080": "cation homeostasis",
  "GO:0055081": "anion homeostasis",
  "GO:0055082": "cellular chemical homeostasis",
  "GO:0055083": "monovalent inorganic anion homeostasis",
  "GO:0055085": "transmembrane transport",
  "GO:0055086": "nucleobase-containing small molecule metabolic process",
  "GO:0055087": "Ski complex",
  "GO:0055088": "lipid homeostasis",
  "GO:0055089": "fatty acid homeostasis",
  "GO:0055090": "acylglycerol homeostasis",
  "GO:0055091": "phospholipid homeostasis",
  "GO:0055092": "sterol homeostasis",
  "GO:0055093": "response to hyperoxia",
  "GO:0055094": "response to lipoprotein particle",
  "GO:0055095": "lipoprotein particle mediated signaling",
  "GO:0055096": "low-density lipoprotein particle mediated signaling",
  "GO:0055097": "high density lipoprotein particle mediated signaling",
  "GO:0055098": "response to low-density lipoprotein particle",
  "GO:0055099": "response to high density lipoprotein particle",
  "GO:0055100": "adiponectin binding",
  "GO:0055101": "obsolete glycerophospholipase inhibitor activity",
  "GO:0055102": "lipase inhibitor activity",
  "GO:0055103": "ligase regulator activity",
  "GO:0055104": "ligase inhibitor activity",
  "GO:0055105": "ubiquitin-protein transferase inhibitor activity",
  "GO:0055106": "ubiquitin-protein transferase regulator activity",
  "GO:0055107": "Golgi to secretory granule transport",
  "GO:0055108": "Golgi to transport vesicle transport",
  "GO:0055109": "invagination involved in gastrulation with mouth forming second",
  "GO:0055110": "involution involved in gastrulation with mouth forming second",
  "GO:0055111": "ingression involved in gastrulation with mouth forming second",
  "GO:0055112": "delamination involved in gastrulation with mouth forming second",
  "GO:0055113": "epiboly involved in gastrulation with mouth forming second",
  "GO:0055114": "oxidation-reduction process",
  "GO:0055115": "entry into diapause",
  "GO:0055116": "entry into reproductive diapause",
  "GO:0055117": "regulation of cardiac muscle contraction",
  "GO:0055118": "negative regulation of cardiac muscle contraction",
  "GO:0055119": "relaxation of cardiac muscle",
  "GO:0055120": "striated muscle dense body",
  "GO:0055121": "response to high fluence blue light stimulus by blue high-fluence system",
  "GO:0055122": "response to very low light intensity stimulus",
  "GO:0055123": "digestive system development",
  "GO:0055124": "obsolete premature neural plate formation",
  "GO:0055125": "obsolete Nic96 complex",
  "GO:0055126": "obsolete Nup82 complex",
  "GO:0055127": "vibrational conductance of sound to the inner ear",
  "GO:0055129": "L-proline biosynthetic process",
  "GO:0055130": "D-alanine catabolic process",
  "GO:0055131": "C3HC4-type RING finger domain binding",
  "GO:0060001": "minus-end directed microfilament motor activity",
  "GO:0060002": "plus-end directed microfilament motor activity",
  "GO:0060003": "copper ion export",
  "GO:0060004": "reflex",
  "GO:0060005": "vestibular reflex",
  "GO:0060006": "angular vestibuloocular reflex",
  "GO:0060007": "linear vestibuloocular reflex",
  "GO:0060008": "Sertoli cell differentiation",
  "GO:0060009": "Sertoli cell development",
  "GO:0060010": "Sertoli cell fate commitment",
  "GO:0060011": "Sertoli cell proliferation",
  "GO:0060012": "synaptic transmission, glycinergic",
  "GO:0060013": "righting reflex",
  "GO:0060014": "granulosa cell differentiation",
  "GO:0060015": "granulosa cell fate commitment",
  "GO:0060016": "granulosa cell development",
  "GO:0060017": "parathyroid gland development",
  "GO:0060018": "astrocyte fate commitment",
  "GO:0060019": "radial glial cell differentiation",
  "GO:0060020": "Bergmann glial cell differentiation",
  "GO:0060021": "palate development",
  "GO:0060022": "hard palate development",
  "GO:0060023": "soft palate development",
  "GO:0060024": "rhythmic synaptic transmission",
  "GO:0060025": "regulation of synaptic activity",
  "GO:0060026": "convergent extension",
  "GO:0060027": "convergent extension involved in gastrulation",
  "GO:0060028": "convergent extension involved in axis elongation",
  "GO:0060029": "convergent extension involved in organogenesis",
  "GO:0060030": "dorsal convergence",
  "GO:0060031": "mediolateral intercalation",
  "GO:0060032": "notochord regression",
  "GO:0060033": "anatomical structure regression",
  "GO:0060034": "notochord cell differentiation",
  "GO:0060035": "notochord cell development",
  "GO:0060036": "notochord cell vacuolation",
  "GO:0060037": "pharyngeal system development",
  "GO:0060038": "cardiac muscle cell proliferation",
  "GO:0060039": "pericardium development",
  "GO:0060040": "retinal bipolar neuron differentiation",
  "GO:0060041": "retina development in camera-type eye",
  "GO:0060042": "retina morphogenesis in camera-type eye",
  "GO:0060043": "regulation of cardiac muscle cell proliferation",
  "GO:0060044": "negative regulation of cardiac muscle cell proliferation",
  "GO:0060045": "positive regulation of cardiac muscle cell proliferation",
  "GO:0060046": "regulation of acrosome reaction",
  "GO:0060047": "heart contraction",
  "GO:0060048": "cardiac muscle contraction",
  "GO:0060049": "regulation of protein glycosylation",
  "GO:0060050": "positive regulation of protein glycosylation",
  "GO:0060051": "negative regulation of protein glycosylation",
  "GO:0060052": "neurofilament cytoskeleton organization",
  "GO:0060053": "neurofilament cytoskeleton",
  "GO:0060054": "positive regulation of epithelial cell proliferation involved in wound healing",
  "GO:0060055": "angiogenesis involved in wound healing",
  "GO:0060056": "mammary gland involution",
  "GO:0060057": "apoptotic process involved in mammary gland involution",
  "GO:0060058": "positive regulation of apoptotic process involved in mammary gland involution",
  "GO:0060059": "embryonic retina morphogenesis in camera-type eye",
  "GO:0060060": "post-embryonic retina morphogenesis in camera-type eye",
  "GO:0060061": "Spemann organizer formation",
  "GO:0060062": "Spemann organizer formation at the dorsal lip of the blastopore",
  "GO:0060063": "Spemann organizer formation at the embryonic shield",
  "GO:0060064": "Spemann organizer formation at the anterior end of the primitive streak",
  "GO:0060065": "uterus development",
  "GO:0060066": "oviduct development",
  "GO:0060067": "cervix development",
  "GO:0060068": "vagina development",
  "GO:0060069": "Wnt signaling pathway, regulating spindle positioning",
  "GO:0060070": "canonical Wnt signaling pathway",
  "GO:0060071": "Wnt signaling pathway, planar cell polarity pathway",
  "GO:0060072": "large conductance calcium-activated potassium channel activity",
  "GO:0060073": "micturition",
  "GO:0060074": "synapse maturation",
  "GO:0060075": "regulation of resting membrane potential",
  "GO:0060076": "excitatory synapse",
  "GO:0060077": "inhibitory synapse",
  "GO:0060078": "regulation of postsynaptic membrane potential",
  "GO:0060079": "excitatory postsynaptic potential",
  "GO:0060080": "inhibitory postsynaptic potential",
  "GO:0060081": "membrane hyperpolarization",
  "GO:0060082": "eye blink reflex",
  "GO:0060083": "smooth muscle contraction involved in micturition",
  "GO:0060084": "synaptic transmission involved in micturition",
  "GO:0060085": "smooth muscle relaxation of the bladder outlet",
  "GO:0060086": "circadian temperature homeostasis",
  "GO:0060087": "relaxation of vascular smooth muscle",
  "GO:0060088": "auditory receptor cell stereocilium organization",
  "GO:0060089": "molecular transducer activity",
  "GO:0060090": "binding, bridging",
  "GO:0060091": "kinocilium",
  "GO:0060092": "regulation of synaptic transmission, glycinergic",
  "GO:0060093": "negative regulation of synaptic transmission, glycinergic",
  "GO:0060094": "positive regulation of synaptic transmission, glycinergic",
  "GO:0060095": "zinc potentiation of synaptic transmission, glycinergic",
  "GO:0060096": "serotonin secretion, neurotransmission",
  "GO:0060097": "cytoskeletal rearrangement involved in phagocytosis, engulfment",
  "GO:0060098": "membrane reorganization involved in phagocytosis, engulfment",
  "GO:0060099": "regulation of phagocytosis, engulfment",
  "GO:0060100": "positive regulation of phagocytosis, engulfment",
  "GO:0060101": "negative regulation of phagocytosis, engulfment",
  "GO:0060102": "collagen and cuticulin-based cuticle extracellular matrix",
  "GO:0060103": "collagen and cuticulin-based cuticle extracellular matrix part",
  "GO:0060104": "surface coat of collagen and cuticulin-based cuticle extracellular matrix",
  "GO:0060105": "epicuticle of collagen and cuticulin-based cuticle extracellular matrix",
  "GO:0060106": "cortical layer of collagen and cuticulin-based cuticle extracellular matrix",
  "GO:0060107": "annuli extracellular matrix",
  "GO:0060108": "annular furrow extracellular matrix",
  "GO:0060109": "medial layer of collagen and cuticulin-based cuticle extracellular matrix",
  "GO:0060110": "basal layer of collagen and cuticulin-based cuticle extracellular matrix",
  "GO:0060111": "alae of collagen and cuticulin-based cuticle extracellular matrix",
  "GO:0060112": "generation of ovulation cycle rhythm",
  "GO:0060113": "inner ear receptor cell differentiation",
  "GO:0060114": "vestibular receptor cell differentiation",
  "GO:0060115": "vestibular receptor cell fate commitment",
  "GO:0060116": "vestibular receptor cell morphogenesis",
  "GO:0060117": "auditory receptor cell development",
  "GO:0060118": "vestibular receptor cell development",
  "GO:0060119": "inner ear receptor cell development",
  "GO:0060120": "inner ear receptor cell fate commitment",
  "GO:0060121": "vestibular receptor cell stereocilium organization",
  "GO:0060122": "inner ear receptor stereocilium organization",
  "GO:0060123": "regulation of growth hormone secretion",
  "GO:0060124": "positive regulation of growth hormone secretion",
  "GO:0060125": "negative regulation of growth hormone secretion",
  "GO:0060126": "somatotropin secreting cell differentiation",
  "GO:0060127": "prolactin secreting cell differentiation",
  "GO:0060128": "corticotropin hormone secreting cell differentiation",
  "GO:0060129": "thyroid-stimulating hormone-secreting cell differentiation",
  "GO:0060130": "thyroid-stimulating hormone-secreting cell development",
  "GO:0060131": "corticotropin hormone secreting cell development",
  "GO:0060132": "prolactin secreting cell development",
  "GO:0060133": "somatotropin secreting cell development",
  "GO:0060134": "prepulse inhibition",
  "GO:0060135": "maternal process involved in female pregnancy",
  "GO:0060136": "embryonic process involved in female pregnancy",
  "GO:0060137": "maternal process involved in parturition",
  "GO:0060138": "fetal process involved in parturition",
  "GO:0060139": "positive regulation of apoptotic process by virus",
  "GO:0060140": "modulation by virus of syncytium formation via plasma membrane fusion",
  "GO:0060141": "positive regulation of syncytium formation by virus",
  "GO:0060142": "regulation of syncytium formation by plasma membrane fusion",
  "GO:0060143": "positive regulation of syncytium formation by plasma membrane fusion",
  "GO:0060144": "host cellular process involved in virus induced gene silencing",
  "GO:0060145": "viral gene silencing in virus induced gene silencing",
  "GO:0060146": "host gene silencing in virus induced gene silencing",
  "GO:0060147": "regulation of posttranscriptional gene silencing",
  "GO:0060148": "positive regulation of posttranscriptional gene silencing",
  "GO:0060149": "negative regulation of posttranscriptional gene silencing",
  "GO:0060150": "viral triggering of virus induced gene silencing",
  "GO:0060151": "peroxisome localization",
  "GO:0060152": "microtubule-based peroxisome localization",
  "GO:0060153": "modulation by virus of host cell cycle",
  "GO:0060154": "cellular process regulating host cell cycle in response to virus",
  "GO:0060155": "platelet dense granule organization",
  "GO:0060156": "milk ejection",
  "GO:0060157": "urinary bladder development",
  "GO:0060158": "phospholipase C-activating dopamine receptor signaling pathway",
  "GO:0060159": "regulation of dopamine receptor signaling pathway",
  "GO:0060160": "negative regulation of dopamine receptor signaling pathway",
  "GO:0060161": "positive regulation of dopamine receptor signaling pathway",
  "GO:0060162": "negative regulation of phospholipase C-activating dopamine receptor signaling pathway",
  "GO:0060163": "subpallium neuron fate commitment",
  "GO:0060164": "regulation of timing of neuron differentiation",
  "GO:0060165": "regulation of timing of subpallium neuron differentiation",
  "GO:0060166": "olfactory pit development",
  "GO:0060167": "regulation of adenosine receptor signaling pathway",
  "GO:0060168": "positive regulation of adenosine receptor signaling pathway",
  "GO:0060169": "negative regulation of adenosine receptor signaling pathway",
  "GO:0060170": "ciliary membrane",
  "GO:0060171": "stereocilium membrane",
  "GO:0060172": "astral microtubule depolymerization",
  "GO:0060173": "limb development",
  "GO:0060174": "limb bud formation",
  "GO:0060175": "brain-derived neurotrophic factor-activated receptor activity",
  "GO:0060176": "regulation of aggregation involved in sorocarp development",
  "GO:0060177": "regulation of angiotensin metabolic process",
  "GO:0060178": "regulation of exocyst localization",
  "GO:0060179": "male mating behavior",
  "GO:0060180": "female mating behavior",
  "GO:0060182": "apelin receptor activity",
  "GO:0060183": "apelin receptor signaling pathway",
  "GO:0060184": "cell cycle switching",
  "GO:0060185": "outer ear unfolding",
  "GO:0060186": "outer ear emergence",
  "GO:0060187": "cell pole",
  "GO:0060188": "regulation of protein desumoylation",
  "GO:0060189": "positive regulation of protein desumoylation",
  "GO:0060190": "negative regulation of protein desumoylation",
  "GO:0060191": "regulation of lipase activity",
  "GO:0060192": "negative regulation of lipase activity",
  "GO:0060193": "positive regulation of lipase activity",
  "GO:0060194": "regulation of antisense RNA transcription",
  "GO:0060195": "negative regulation of antisense RNA transcription",
  "GO:0060196": "positive regulation of antisense RNA transcription",
  "GO:0060197": "cloacal septation",
  "GO:0060198": "clathrin-sculpted vesicle",
  "GO:0060199": "clathrin-sculpted glutamate transport vesicle",
  "GO:0060200": "clathrin-sculpted acetylcholine transport vesicle",
  "GO:0060201": "clathrin-sculpted acetylcholine transport vesicle membrane",
  "GO:0060202": "clathrin-sculpted acetylcholine transport vesicle lumen",
  "GO:0060203": "clathrin-sculpted glutamate transport vesicle membrane",
  "GO:0060204": "clathrin-sculpted glutamate transport vesicle lumen",
  "GO:0060205": "cytoplasmic membrane-bounded vesicle lumen",
  "GO:0060206": "estrous cycle phase",
  "GO:0060207": "diestrus",
  "GO:0060208": "proestrus",
  "GO:0060209": "estrus",
  "GO:0060210": "metestrus",
  "GO:0060211": "regulation of nuclear-transcribed mRNA poly(A) tail shortening",
  "GO:0060212": "negative regulation of nuclear-transcribed mRNA poly(A) tail shortening",
  "GO:0060213": "positive regulation of nuclear-transcribed mRNA poly(A) tail shortening",
  "GO:0060214": "endocardium formation",
  "GO:0060215": "primitive hemopoiesis",
  "GO:0060216": "definitive hemopoiesis",
  "GO:0060217": "hemangioblast cell differentiation",
  "GO:0060218": "hematopoietic stem cell differentiation",
  "GO:0060219": "camera-type eye photoreceptor cell differentiation",
  "GO:0060220": "camera-type eye photoreceptor cell fate commitment",
  "GO:0060221": "retinal rod cell differentiation",
  "GO:0060222": "regulation of retinal cone cell fate commitment",
  "GO:0060223": "retinal rod cell fate commitment",
  "GO:0060224": "regulation of retinal rod cell fate commitment",
  "GO:0060225": "positive regulation of retinal rod cell fate commitment",
  "GO:0060226": "negative regulation of retinal cone cell fate commitment",
  "GO:0060227": "Notch signaling pathway involved in camera-type eye photoreceptor fate commitment",
  "GO:0060228": "phosphatidylcholine-sterol O-acyltransferase activator activity",
  "GO:0060229": "lipase activator activity",
  "GO:0060230": "lipoprotein lipase activator activity",
  "GO:0060231": "mesenchymal to epithelial transition",
  "GO:0060232": "delamination",
  "GO:0060233": "oenocyte delamination",
  "GO:0060234": "neuroblast delamination",
  "GO:0060235": "lens induction in camera-type eye",
  "GO:0060236": "regulation of mitotic spindle organization",
  "GO:0060237": "regulation of fungal-type cell wall organization",
  "GO:0060238": "regulation of signal transduction involved in conjugation with cellular fusion",
  "GO:0060239": "positive regulation of signal transduction involved in conjugation with cellular fusion",
  "GO:0060240": "negative regulation of signal transduction involved in conjugation with cellular fusion",
  "GO:0060241": "lysozyme inhibitor activity",
  "GO:0060242": "contact inhibition",
  "GO:0060243": "negative regulation of cell growth involved in contact inhibition",
  "GO:0060244": "negative regulation of cell proliferation involved in contact inhibition",
  "GO:0060245": "detection of cell density",
  "GO:0060246": "detection of cell density by contact stimulus",
  "GO:0060247": "detection of cell density by secreted molecule",
  "GO:0060248": "detection of cell density by contact stimulus involved in contact inhibition",
  "GO:0060249": "anatomical structure homeostasis",
  "GO:0060250": "germ-line stem-cell niche homeostasis",
  "GO:0060251": "regulation of glial cell proliferation",
  "GO:0060252": "positive regulation of glial cell proliferation",
  "GO:0060253": "negative regulation of glial cell proliferation",
  "GO:0060254": "regulation of N-terminal protein palmitoylation",
  "GO:0060255": "regulation of macromolecule metabolic process",
  "GO:0060256": "regulation of flocculation",
  "GO:0060257": "negative regulation of flocculation",
  "GO:0060258": "negative regulation of filamentous growth",
  "GO:0060259": "regulation of feeding behavior",
  "GO:0060260": "regulation of transcription initiation from RNA polymerase II promoter",
  "GO:0060261": "positive regulation of transcription initiation from RNA polymerase II promoter",
  "GO:0060262": "negative regulation of N-terminal protein palmitoylation",
  "GO:0060263": "regulation of respiratory burst",
  "GO:0060264": "regulation of respiratory burst involved in inflammatory response",
  "GO:0060265": "positive regulation of respiratory burst involved in inflammatory response",
  "GO:0060266": "negative regulation of respiratory burst involved in inflammatory response",
  "GO:0060267": "positive regulation of respiratory burst",
  "GO:0060268": "negative regulation of respiratory burst",
  "GO:0060269": "centripetally migrating follicle cell migration",
  "GO:0060270": "main body follicle cell migration",
  "GO:0060271": "cilium morphogenesis",
  "GO:0060272": "embryonic skeletal joint morphogenesis",
  "GO:0060273": "crying behavior",
  "GO:0060274": "maintenance of stationary phase",
  "GO:0060275": "maintenance of stationary phase in response to starvation",
  "GO:0060276": "maintenance of stationary phase in response to toxin",
  "GO:0060277": "obsolete negative regulation of transcription involved in G1 phase of mitotic cell cycle",
  "GO:0060278": "regulation of ovulation",
  "GO:0060279": "positive regulation of ovulation",
  "GO:0060280": "negative regulation of ovulation",
  "GO:0060281": "regulation of oocyte development",
  "GO:0060282": "positive regulation of oocyte development",
  "GO:0060283": "negative regulation of oocyte development",
  "GO:0060284": "regulation of cell development",
  "GO:0060285": "cilium-dependent cell motility",
  "GO:0060286": "obsolete flagellar cell motility",
  "GO:0060287": "epithelial cilium movement involved in determination of left/right asymmetry",
  "GO:0060288": "formation of a compartment boundary",
  "GO:0060289": "compartment boundary maintenance",
  "GO:0060290": "transdifferentiation",
  "GO:0060291": "long-term synaptic potentiation",
  "GO:0060292": "long term synaptic depression",
  "GO:0060293": "germ plasm",
  "GO:0060294": "cilium movement involved in cell motility",
  "GO:0060295": "regulation of cilium movement involved in cell motility",
  "GO:0060296": "regulation of cilium beat frequency involved in ciliary motility",
  "GO:0060297": "regulation of sarcomere organization",
  "GO:0060298": "positive regulation of sarcomere organization",
  "GO:0060299": "negative regulation of sarcomere organization",
  "GO:0060300": "regulation of cytokine activity",
  "GO:0060301": "positive regulation of cytokine activity",
  "GO:0060302": "negative regulation of cytokine activity",
  "GO:0060303": "regulation of nucleosome density",
  "GO:0060304": "regulation of phosphatidylinositol dephosphorylation",
  "GO:0060305": "regulation of cell diameter",
  "GO:0060306": "regulation of membrane repolarization",
  "GO:0060307": "regulation of ventricular cardiac muscle cell membrane repolarization",
  "GO:0060308": "GTP cyclohydrolase I regulator activity",
  "GO:0060309": "elastin catabolic process",
  "GO:0060310": "regulation of elastin catabolic process",
  "GO:0060311": "negative regulation of elastin catabolic process",
  "GO:0060312": "regulation of blood vessel remodeling",
  "GO:0060313": "negative regulation of blood vessel remodeling",
  "GO:0060314": "regulation of ryanodine-sensitive calcium-release channel activity",
  "GO:0060315": "negative regulation of ryanodine-sensitive calcium-release channel activity",
  "GO:0060316": "positive regulation of ryanodine-sensitive calcium-release channel activity",
  "GO:0060317": "cardiac epithelial to mesenchymal transition",
  "GO:0060318": "definitive erythrocyte differentiation",
  "GO:0060319": "primitive erythrocyte differentiation",
  "GO:0060320": "rejection of self pollen",
  "GO:0060321": "acceptance of pollen",
  "GO:0060322": "head development",
  "GO:0060323": "head morphogenesis",
  "GO:0060324": "face development",
  "GO:0060325": "face morphogenesis",
  "GO:0060326": "cell chemotaxis",
  "GO:0060327": "cytoplasmic actin-based contraction involved in cell motility",
  "GO:0060328": "cytoplasmic actin-based contraction involved in forward cell motility",
  "GO:0060329": "cytoplasmic actin-based contraction involved in rearward cell motility",
  "GO:0060330": "regulation of response to interferon-gamma",
  "GO:0060331": "negative regulation of response to interferon-gamma",
  "GO:0060332": "positive regulation of response to interferon-gamma",
  "GO:0060333": "interferon-gamma-mediated signaling pathway",
  "GO:0060334": "regulation of interferon-gamma-mediated signaling pathway",
  "GO:0060335": "positive regulation of interferon-gamma-mediated signaling pathway",
  "GO:0060336": "negative regulation of interferon-gamma-mediated signaling pathway",
  "GO:0060337": "type I interferon signaling pathway",
  "GO:0060338": "regulation of type I interferon-mediated signaling pathway",
  "GO:0060339": "negative regulation of type I interferon-mediated signaling pathway",
  "GO:0060340": "positive regulation of type I interferon-mediated signaling pathway",
  "GO:0060341": "regulation of cellular localization",
  "GO:0060342": "photoreceptor inner segment membrane",
  "GO:0060343": "trabecula formation",
  "GO:0060344": "liver trabecula formation",
  "GO:0060345": "spleen trabecula formation",
  "GO:0060346": "bone trabecula formation",
  "GO:0060347": "heart trabecula formation",
  "GO:0060348": "bone development",
  "GO:0060349": "bone morphogenesis",
  "GO:0060350": "endochondral bone morphogenesis",
  "GO:0060351": "cartilage development involved in endochondral bone morphogenesis",
  "GO:0060352": "cell adhesion molecule production",
  "GO:0060353": "regulation of cell adhesion molecule production",
  "GO:0060354": "negative regulation of cell adhesion molecule production",
  "GO:0060355": "positive regulation of cell adhesion molecule production",
  "GO:0060356": "leucine import",
  "GO:0060357": "regulation of leucine import",
  "GO:0060358": "negative regulation of leucine import",
  "GO:0060359": "response to ammonium ion",
  "GO:0060360": "negative regulation of leucine import in response to ammonium ion",
  "GO:0060361": "flight",
  "GO:0060362": "flight involved in flight behavior",
  "GO:0060363": "cranial suture morphogenesis",
  "GO:0060364": "frontal suture morphogenesis",
  "GO:0060365": "coronal suture morphogenesis",
  "GO:0060366": "lambdoid suture morphogenesis",
  "GO:0060367": "sagittal suture morphogenesis",
  "GO:0060368": "regulation of Fc receptor mediated stimulatory signaling pathway",
  "GO:0060369": "positive regulation of Fc receptor mediated stimulatory signaling pathway",
  "GO:0060370": "susceptibility to T cell mediated cytotoxicity",
  "GO:0060371": "regulation of atrial cardiac muscle cell membrane depolarization",
  "GO:0060372": "regulation of atrial cardiac muscle cell membrane repolarization",
  "GO:0060373": "regulation of ventricular cardiac muscle cell membrane depolarization",
  "GO:0060374": "mast cell differentiation",
  "GO:0060375": "regulation of mast cell differentiation",
  "GO:0060376": "positive regulation of mast cell differentiation",
  "GO:0060377": "negative regulation of mast cell differentiation",
  "GO:0060378": "regulation of brood size",
  "GO:0060379": "cardiac muscle cell myoblast differentiation",
  "GO:0060380": "regulation of single-stranded telomeric DNA binding",
  "GO:0060381": "positive regulation of single-stranded telomeric DNA binding",
  "GO:0060382": "regulation of DNA strand elongation",
  "GO:0060383": "positive regulation of DNA strand elongation",
  "GO:0060384": "innervation",
  "GO:0060385": "axonogenesis involved in innervation",
  "GO:0060386": "synapse assembly involved in innervation",
  "GO:0060387": "fertilization envelope",
  "GO:0060388": "vitelline envelope",
  "GO:0060389": "pathway-restricted SMAD protein phosphorylation",
  "GO:0060390": "regulation of SMAD protein import into nucleus",
  "GO:0060391": "positive regulation of SMAD protein import into nucleus",
  "GO:0060392": "negative regulation of SMAD protein import into nucleus",
  "GO:0060393": "regulation of pathway-restricted SMAD protein phosphorylation",
  "GO:0060394": "negative regulation of pathway-restricted SMAD protein phosphorylation",
  "GO:0060395": "SMAD protein signal transduction",
  "GO:0060396": "growth hormone receptor signaling pathway",
  "GO:0060397": "JAK-STAT cascade involved in growth hormone signaling pathway",
  "GO:0060398": "regulation of growth hormone receptor signaling pathway",
  "GO:0060399": "positive regulation of growth hormone receptor signaling pathway",
  "GO:0060400": "negative regulation of growth hormone receptor signaling pathway",
  "GO:0060401": "cytosolic calcium ion transport",
  "GO:0060402": "calcium ion transport into cytosol",
  "GO:0060403": "post-mating oviposition",
  "GO:0060404": "axonemal microtubule depolymerization",
  "GO:0060405": "regulation of penile erection",
  "GO:0060406": "positive regulation of penile erection",
  "GO:0060407": "negative regulation of penile erection",
  "GO:0060408": "regulation of acetylcholine metabolic process",
  "GO:0060409": "positive regulation of acetylcholine metabolic process",
  "GO:0060410": "negative regulation of acetylcholine metabolic process",
  "GO:0060411": "cardiac septum morphogenesis",
  "GO:0060412": "ventricular septum morphogenesis",
  "GO:0060413": "atrial septum morphogenesis",
  "GO:0060414": "aorta smooth muscle tissue morphogenesis",
  "GO:0060415": "muscle tissue morphogenesis",
  "GO:0060416": "response to growth hormone",
  "GO:0060417": "yolk",
  "GO:0060418": "yolk plasma",
  "GO:0060419": "heart growth",
  "GO:0060420": "regulation of heart growth",
  "GO:0060421": "positive regulation of heart growth",
  "GO:0060422": "peptidyl-dipeptidase inhibitor activity",
  "GO:0060423": "foregut regionalization",
  "GO:0060424": "lung field specification",
  "GO:0060425": "lung morphogenesis",
  "GO:0060426": "lung vasculature development",
  "GO:0060427": "lung connective tissue development",
  "GO:0060428": "lung epithelium development",
  "GO:0060429": "epithelium development",
  "GO:0060430": "lung saccule development",
  "GO:0060431": "primary lung bud formation",
  "GO:0060432": "lung pattern specification process",
  "GO:0060433": "bronchus development",
  "GO:0060434": "bronchus morphogenesis",
  "GO:0060435": "bronchiole development",
  "GO:0060436": "bronchiole morphogenesis",
  "GO:0060437": "lung growth",
  "GO:0060438": "trachea development",
  "GO:0060439": "trachea morphogenesis",
  "GO:0060440": "trachea formation",
  "GO:0060441": "epithelial tube branching involved in lung morphogenesis",
  "GO:0060442": "branching involved in prostate gland morphogenesis",
  "GO:0060443": "mammary gland morphogenesis",
  "GO:0060444": "branching involved in mammary gland duct morphogenesis",
  "GO:0060445": "branching involved in salivary gland morphogenesis",
  "GO:0060446": "branching involved in open tracheal system development",
  "GO:0060447": "bud outgrowth involved in lung branching",
  "GO:0060448": "dichotomous subdivision of terminal units involved in lung branching",
  "GO:0060449": "bud elongation involved in lung branching",
  "GO:0060450": "positive regulation of hindgut contraction",
  "GO:0060451": "negative regulation of hindgut contraction",
  "GO:0060452": "positive regulation of cardiac muscle contraction",
  "GO:0060453": "regulation of gastric acid secretion",
  "GO:0060454": "positive regulation of gastric acid secretion",
  "GO:0060455": "negative regulation of gastric acid secretion",
  "GO:0060456": "positive regulation of digestive system process",
  "GO:0060457": "negative regulation of digestive system process",
  "GO:0060458": "right lung development",
  "GO:0060459": "left lung development",
  "GO:0060460": "left lung morphogenesis",
  "GO:0060461": "right lung morphogenesis",
  "GO:0060462": "lung lobe development",
  "GO:0060463": "lung lobe morphogenesis",
  "GO:0060464": "lung lobe formation",
  "GO:0060465": "pharynx development",
  "GO:0060466": "activation of meiosis involved in egg activation",
  "GO:0060467": "negative regulation of fertilization",
  "GO:0060468": "prevention of polyspermy",
  "GO:0060469": "positive regulation of transcription involved in egg activation",
  "GO:0060470": "positive regulation of cytosolic calcium ion concentration involved in egg activation",
  "GO:0060471": "cortical granule exocytosis",
  "GO:0060472": "positive regulation of cortical granule exocytosis by positive regulation of cytosolic calcium ion concentration",
  "GO:0060473": "cortical granule",
  "GO:0060474": "positive regulation of sperm motility involved in capacitation",
  "GO:0060475": "positive regulation of actin filament polymerization involved in acrosome reaction",
  "GO:0060476": "protein localization involved in acrosome reaction",
  "GO:0060477": "peptidyl-serine phosphorylation involved in acrosome reaction",
  "GO:0060478": "acrosomal vesicle exocytosis",
  "GO:0060479": "lung cell differentiation",
  "GO:0060480": "lung goblet cell differentiation",
  "GO:0060481": "lobar bronchus epithelium development",
  "GO:0060482": "lobar bronchus development",
  "GO:0060483": "lobar bronchus mesenchyme development",
  "GO:0060484": "lung-associated mesenchyme development",
  "GO:0060485": "mesenchyme development",
  "GO:0060486": "Clara cell differentiation",
  "GO:0060487": "lung epithelial cell differentiation",
  "GO:0060488": "orthogonal dichotomous subdivision of terminal units involved in lung branching morphogenesis",
  "GO:0060489": "planar dichotomous subdivision of terminal units involved in lung branching morphogenesis",
  "GO:0060490": "lateral sprouting involved in lung morphogenesis",
  "GO:0060491": "regulation of cell projection assembly",
  "GO:0060492": "lung induction",
  "GO:0060493": "mesenchymal-endodermal cell signaling involved in lung induction",
  "GO:0060494": "inductive mesenchymal-endodermal cell signaling",
  "GO:0060495": "cell-cell signaling involved in lung development",
  "GO:0060496": "mesenchymal-epithelial cell signaling involved in lung development",
  "GO:0060497": "mesenchymal-endodermal cell signaling",
  "GO:0060498": "retinoic acid receptor signaling pathway involved in lung bud formation",
  "GO:0060499": "fibroblast growth factor receptor signaling pathway involved in lung induction",
  "GO:0060500": "regulation of transcription from RNA polymerase II promoter involved in lung bud formation",
  "GO:0060501": "positive regulation of epithelial cell proliferation involved in lung morphogenesis",
  "GO:0060502": "epithelial cell proliferation involved in lung morphogenesis",
  "GO:0060503": "bud dilation involved in lung branching",
  "GO:0060504": "positive regulation of epithelial cell proliferation involved in lung bud dilation",
  "GO:0060505": "epithelial cell proliferation involved in lung bud dilation",
  "GO:0060506": "smoothened signaling pathway involved in lung development",
  "GO:0060507": "epidermal growth factor receptor signaling pathway involved in lung development",
  "GO:0060508": "lung basal cell differentiation",
  "GO:0060509": "Type I pneumocyte differentiation",
  "GO:0060510": "Type II pneumocyte differentiation",
  "GO:0060511": "creation of an inductive signal by a mesenchymal cell involved in lung induction",
  "GO:0060512": "prostate gland morphogenesis",
  "GO:0060513": "prostatic bud formation",
  "GO:0060514": "prostate induction",
  "GO:0060515": "prostate field specification",
  "GO:0060516": "primary prostatic bud elongation",
  "GO:0060517": "epithelial cell proliferation involved in prostatic bud elongation",
  "GO:0060518": "cell migration involved in prostatic bud elongation",
  "GO:0060519": "cell adhesion involved in prostatic bud elongation",
  "GO:0060520": "activation of prostate induction by androgen receptor signaling pathway",
  "GO:0060521": "mesenchymal-epithelial cell signaling involved in prostate induction",
  "GO:0060522": "inductive mesenchymal to epithelial cell signaling",
  "GO:0060523": "prostate epithelial cord elongation",
  "GO:0060524": "dichotomous subdivision of prostate epithelial cord terminal unit",
  "GO:0060525": "prostate glandular acinus development",
  "GO:0060526": "prostate glandular acinus morphogenesis",
  "GO:0060527": "prostate epithelial cord arborization involved in prostate glandular acinus morphogenesis",
  "GO:0060528": "secretory columnal luminar epithelial cell differentiation involved in prostate glandular acinus development",
  "GO:0060529": "squamous basal epithelial stem cell differentiation involved in prostate gland acinus development",
  "GO:0060530": "smooth muscle cell differentiation involved in prostate glandular acinus development",
  "GO:0060531": "neuroendocrine cell differentiation involved in prostate gland acinus development",
  "GO:0060532": "bronchus cartilage development",
  "GO:0060533": "bronchus cartilage morphogenesis",
  "GO:0060534": "trachea cartilage development",
  "GO:0060535": "trachea cartilage morphogenesis",
  "GO:0060536": "cartilage morphogenesis",
  "GO:0060537": "muscle tissue development",
  "GO:0060538": "skeletal muscle organ development",
  "GO:0060539": "diaphragm development",
  "GO:0060540": "diaphragm morphogenesis",
  "GO:0060541": "respiratory system development",
  "GO:0060542": "regulation of strand invasion",
  "GO:0060543": "negative regulation of strand invasion",
  "GO:0060544": "regulation of necroptotic process",
  "GO:0060545": "positive regulation of necroptotic process",
  "GO:0060546": "negative regulation of necroptotic process",
  "GO:0060547": "negative regulation of necrotic cell death",
  "GO:0060548": "negative regulation of cell death",
  "GO:0060549": "regulation of fructose 1,6-bisphosphate 1-phosphatase activity",
  "GO:0060550": "positive regulation of fructose 1,6-bisphosphate 1-phosphatase activity",
  "GO:0060551": "regulation of fructose 1,6-bisphosphate metabolic process",
  "GO:0060552": "positive regulation of fructose 1,6-bisphosphate metabolic process",
  "GO:0060556": "regulation of vitamin D biosynthetic process",
  "GO:0060557": "positive regulation of vitamin D biosynthetic process",
  "GO:0060558": "regulation of calcidiol 1-monooxygenase activity",
  "GO:0060559": "positive regulation of calcidiol 1-monooxygenase activity",
  "GO:0060560": "developmental growth involved in morphogenesis",
  "GO:0060561": "apoptotic process involved in morphogenesis",
  "GO:0060562": "epithelial tube morphogenesis",
  "GO:0060563": "neuroepithelial cell differentiation",
  "GO:0060564": "negative regulation of APC-Cdc20 complex activity",
  "GO:0060565": "obsolete inhibition of APC-Cdc20 complex activity",
  "GO:0060566": "positive regulation of DNA-templated transcription, termination",
  "GO:0060567": "negative regulation of DNA-templated transcription, termination",
  "GO:0060568": "regulation of peptide hormone processing",
  "GO:0060569": "positive regulation of peptide hormone processing",
  "GO:0060570": "negative regulation of peptide hormone processing",
  "GO:0060571": "morphogenesis of an epithelial fold",
  "GO:0060572": "morphogenesis of an epithelial bud",
  "GO:0060573": "cell fate specification involved in pattern specification",
  "GO:0060574": "intestinal epithelial cell maturation",
  "GO:0060575": "intestinal epithelial cell differentiation",
  "GO:0060576": "intestinal epithelial cell development",
  "GO:0060577": "pulmonary vein morphogenesis",
  "GO:0060578": "superior vena cava morphogenesis",
  "GO:0060579": "ventral spinal cord interneuron fate commitment",
  "GO:0060580": "ventral spinal cord interneuron fate determination",
  "GO:0060581": "cell fate commitment involved in pattern specification",
  "GO:0060582": "cell fate determination involved in pattern specification",
  "GO:0060583": "regulation of actin cortical patch localization",
  "GO:0060584": "regulation of prostaglandin-endoperoxide synthase activity",
  "GO:0060585": "positive regulation of prostaglandin-endoperoxide synthase activity",
  "GO:0060586": "multicellular organismal iron ion homeostasis",
  "GO:0060587": "regulation of lipoprotein lipid oxidation",
  "GO:0060588": "negative regulation of lipoprotein lipid oxidation",
  "GO:0060589": "nucleoside-triphosphatase regulator activity",
  "GO:0060590": "ATPase regulator activity",
  "GO:0060591": "chondroblast differentiation",
  "GO:0060592": "mammary gland formation",
  "GO:0060593": "Wnt signaling pathway involved in mammary gland specification",
  "GO:0060594": "mammary gland specification",
  "GO:0060595": "fibroblast growth factor receptor signaling pathway involved in mammary gland specification",
  "GO:0060596": "mammary placode formation",
  "GO:0060597": "regulation of transcription from RNA polymerase II promoter involved in mammary gland formation",
  "GO:0060598": "dichotomous subdivision of terminal units involved in mammary gland duct morphogenesis",
  "GO:0060599": "lateral sprouting involved in mammary gland duct morphogenesis",
  "GO:0060600": "dichotomous subdivision of an epithelial terminal unit",
  "GO:0060601": "lateral sprouting from an epithelium",
  "GO:0060602": "branch elongation of an epithelium",
  "GO:0060603": "mammary gland duct morphogenesis",
  "GO:0060604": "mammary gland duct cavitation",
  "GO:0060605": "tube lumen cavitation",
  "GO:0060606": "tube closure",
  "GO:0060607": "cell-cell adhesion involved in sealing an epithelial fold",
  "GO:0060608": "cell-cell adhesion involved in neural tube closure",
  "GO:0060609": "apoptotic process involved in tube lumen cavitation",
  "GO:0060610": "mesenchymal cell differentiation involved in mammary gland development",
  "GO:0060611": "mammary gland fat development",
  "GO:0060612": "adipose tissue development",
  "GO:0060613": "fat pad development",
  "GO:0060614": "negative regulation of mammary gland development in males by androgen receptor signaling pathway",
  "GO:0060615": "mammary gland bud formation",
  "GO:0060616": "mammary gland cord formation",
  "GO:0060617": "positive regulation of mammary placode formation by mesenchymal-epithelial signaling",
  "GO:0060618": "nipple development",
  "GO:0060619": "cell migration involved in mammary placode formation",
  "GO:0060620": "regulation of cholesterol import",
  "GO:0060621": "negative regulation of cholesterol import",
  "GO:0060622": "regulation of ascospore wall beta-glucan biosynthetic process",
  "GO:0060623": "regulation of chromosome condensation",
  "GO:0060624": "regulation of ascospore wall (1->3)-beta-D-glucan biosynthetic process",
  "GO:0060625": "regulation of protein deneddylation",
  "GO:0060626": "regulation of cullin deneddylation",
  "GO:0060627": "regulation of vesicle-mediated transport",
  "GO:0060628": "regulation of ER to Golgi vesicle-mediated transport",
  "GO:0060629": "regulation of homologous chromosome segregation",
  "GO:0060630": "obsolete regulation of M/G1 transition of mitotic cell cycle",
  "GO:0060631": "regulation of meiosis I",
  "GO:0060632": "regulation of microtubule-based movement",
  "GO:0060633": "negative regulation of transcription initiation from RNA polymerase II promoter",
  "GO:0060634": "regulation of 4,6-pyruvylated galactose residue biosynthetic process",
  "GO:0060635": "positive regulation of (1->3)-beta-D-glucan biosynthetic process",
  "GO:0060636": "negative regulation of (1->3)-beta-D-glucan biosynthetic process",
  "GO:0060637": "positive regulation of lactation by mesenchymal-epithelial cell signaling",
  "GO:0060638": "mesenchymal-epithelial cell signaling",
  "GO:0060639": "positive regulation of salivary gland formation by mesenchymal-epithelial signaling",
  "GO:0060640": "positive regulation of dentin-containing tooth bud formation by mesenchymal-epithelial signaling",
  "GO:0060641": "mammary gland duct regression in males",
  "GO:0060642": "white fat cell differentiation involved in mammary gland fat development",
  "GO:0060643": "epithelial cell differentiation involved in mammary gland bud morphogenesis",
  "GO:0060644": "mammary gland epithelial cell differentiation",
  "GO:0060645": "peripheral mammary gland bud epithelial cell differentiation",
  "GO:0060646": "internal mammary gland bud epithelial cell differentiation",
  "GO:0060647": "mesenchymal cell condensation involved in mammary fat development",
  "GO:0060648": "mammary gland bud morphogenesis",
  "GO:0060649": "mammary gland bud elongation",
  "GO:0060650": "epithelial cell proliferation involved in mammary gland bud elongation",
  "GO:0060651": "regulation of epithelial cell proliferation involved in mammary gland bud elongation",
  "GO:0060652": "mammary gland cord morphogenesis",
  "GO:0060653": "epithelial cell differentiation involved in mammary gland cord morphogenesis",
  "GO:0060654": "mammary gland cord elongation",
  "GO:0060655": "branching involved in mammary gland cord morphogenesis",
  "GO:0060656": "regulation of branching involved in mammary cord morphogenesis by fat precursor cell-epithelial cell signaling",
  "GO:0060657": "regulation of mammary gland cord elongation by mammary fat precursor cell-epithelial cell signaling",
  "GO:0060658": "nipple morphogenesis",
  "GO:0060659": "nipple sheath formation",
  "GO:0060660": "epidermis morphogenesis involved in nipple formation",
  "GO:0060661": "submandibular salivary gland formation",
  "GO:0060662": "salivary gland cavitation",
  "GO:0060663": "apoptotic process involved in salivary gland cavitation",
  "GO:0060664": "epithelial cell proliferation involved in salivary gland morphogenesis",
  "GO:0060665": "regulation of branching involved in salivary gland morphogenesis by mesenchymal-epithelial signaling",
  "GO:0060666": "dichotomous subdivision of terminal units involved in salivary gland branching",
  "GO:0060667": "branch elongation involved in salivary gland morphogenesis",
  "GO:0060668": "regulation of branching involved in salivary gland morphogenesis by extracellular matrix-epithelial cell signaling",
  "GO:0060669": "embryonic placenta morphogenesis",
  "GO:0060670": "branching involved in labyrinthine layer morphogenesis",
  "GO:0060671": "epithelial cell differentiation involved in embryonic placenta development",
  "GO:0060672": "epithelial cell morphogenesis involved in placental branching",
  "GO:0060673": "cell-cell signaling involved in placenta development",
  "GO:0060674": "placenta blood vessel development",
  "GO:0060675": "ureteric bud morphogenesis",
  "GO:0060676": "ureteric bud formation",
  "GO:0060677": "ureteric bud elongation",
  "GO:0060678": "dichotomous subdivision of terminal units involved in ureteric bud branching",
  "GO:0060679": "trifid subdivision of terminal units involved in ureteric bud branching",
  "GO:0060680": "lateral sprouting involved in ureteric bud morphogenesis",
  "GO:0060681": "branch elongation involved in ureteric bud branching",
  "GO:0060682": "primary ureteric bud growth",
  "GO:0060683": "regulation of branching involved in salivary gland morphogenesis by epithelial-mesenchymal signaling",
  "GO:0060684": "epithelial-mesenchymal cell signaling",
  "GO:0060685": "regulation of prostatic bud formation",
  "GO:0060686": "negative regulation of prostatic bud formation",
  "GO:0060687": "regulation of branching involved in prostate gland morphogenesis",
  "GO:0060688": "regulation of morphogenesis of a branching structure",
  "GO:0060689": "cell differentiation involved in salivary gland development",
  "GO:0060690": "epithelial cell differentiation involved in salivary gland development",
  "GO:0060691": "epithelial cell maturation involved in salivary gland development",
  "GO:0060692": "mesenchymal cell differentiation involved in salivary gland development",
  "GO:0060693": "regulation of branching involved in salivary gland morphogenesis",
  "GO:0060694": "regulation of cholesterol transporter activity",
  "GO:0060695": "negative regulation of cholesterol transporter activity",
  "GO:0060696": "regulation of phospholipid catabolic process",
  "GO:0060697": "positive regulation of phospholipid catabolic process",
  "GO:0060698": "endoribonuclease inhibitor activity",
  "GO:0060699": "regulation of endoribonuclease activity",
  "GO:0060700": "regulation of ribonuclease activity",
  "GO:0060701": "negative regulation of ribonuclease activity",
  "GO:0060702": "negative regulation of endoribonuclease activity",
  "GO:0060703": "deoxyribonuclease inhibitor activity",
  "GO:0060704": "acinar cell differentiation involved in salivary gland development",
  "GO:0060705": "neuron differentiation involved in salivary gland development",
  "GO:0060706": "cell differentiation involved in embryonic placenta development",
  "GO:0060707": "trophoblast giant cell differentiation",
  "GO:0060708": "spongiotrophoblast differentiation",
  "GO:0060709": "glycogen cell differentiation involved in embryonic placenta development",
  "GO:0060710": "chorio-allantoic fusion",
  "GO:0060711": "labyrinthine layer development",
  "GO:0060712": "spongiotrophoblast layer development",
  "GO:0060713": "labyrinthine layer morphogenesis",
  "GO:0060714": "labyrinthine layer formation",
  "GO:0060715": "syncytiotrophoblast cell differentiation involved in labyrinthine layer development",
  "GO:0060716": "labyrinthine layer blood vessel development",
  "GO:0060717": "chorion development",
  "GO:0060718": "chorionic trophoblast cell differentiation",
  "GO:0060719": "chorionic trophoblast cell development",
  "GO:0060720": "spongiotrophoblast cell proliferation",
  "GO:0060721": "regulation of spongiotrophoblast cell proliferation",
  "GO:0060722": "cell proliferation involved in embryonic placenta development",
  "GO:0060723": "regulation of cell proliferation involved in embryonic placenta development",
  "GO:0060724": "coreceptor activity involved in epidermal growth factor receptor signaling pathway",
  "GO:0060725": "regulation of coreceptor activity",
  "GO:0060726": "regulation of coreceptor activity involved in epidermal growth factor receptor signaling pathway",
  "GO:0060727": "positive regulation of coreceptor activity involved in epidermal growth factor receptor signaling pathway",
  "GO:0060728": "negative regulation of coreceptor activity involved in epidermal growth factor receptor signaling pathway",
  "GO:0060729": "intestinal epithelial structure maintenance",
  "GO:0060730": "regulation of intestinal epithelial structure maintenance",
  "GO:0060731": "positive regulation of intestinal epithelial structure maintenance",
  "GO:0060732": "positive regulation of inositol phosphate biosynthetic process",
  "GO:0060733": "regulation of eIF2 alpha phosphorylation by amino acid starvation",
  "GO:0060734": "regulation of endoplasmic reticulum stress-induced eIF2 alpha phosphorylation",
  "GO:0060735": "regulation of eIF2 alpha phosphorylation by dsRNA",
  "GO:0060736": "prostate gland growth",
  "GO:0060737": "prostate gland morphogenetic growth",
  "GO:0060738": "epithelial-mesenchymal signaling involved in prostate gland development",
  "GO:0060739": "mesenchymal-epithelial cell signaling involved in prostate gland development",
  "GO:0060740": "prostate gland epithelium morphogenesis",
  "GO:0060741": "prostate gland stromal morphogenesis",
  "GO:0060742": "epithelial cell differentiation involved in prostate gland development",
  "GO:0060743": "epithelial cell maturation involved in prostate gland development",
  "GO:0060744": "mammary gland branching involved in thelarche",
  "GO:0060745": "mammary gland branching involved in pregnancy",
  "GO:0060746": "parental behavior",
  "GO:0060747": "oral incubation",
  "GO:0060748": "tertiary branching involved in mammary gland duct morphogenesis",
  "GO:0060749": "mammary gland alveolus development",
  "GO:0060750": "epithelial cell proliferation involved in mammary gland duct elongation",
  "GO:0060751": "branch elongation involved in mammary gland duct branching",
  "GO:0060752": "intestinal phytosterol absorption",
  "GO:0060753": "regulation of mast cell chemotaxis",
  "GO:0060754": "positive regulation of mast cell chemotaxis",
  "GO:0060755": "negative regulation of mast cell chemotaxis",
  "GO:0060756": "foraging behavior",
  "GO:0060757": "adult foraging behavior",
  "GO:0060758": "foraging behavior by probing substrate",
  "GO:0060759": "regulation of response to cytokine stimulus",
  "GO:0060760": "positive regulation of response to cytokine stimulus",
  "GO:0060761": "negative regulation of response to cytokine stimulus",
  "GO:0060762": "regulation of branching involved in mammary gland duct morphogenesis",
  "GO:0060763": "mammary duct terminal end bud growth",
  "GO:0060764": "cell-cell signaling involved in mammary gland development",
  "GO:0060765": "regulation of androgen receptor signaling pathway",
  "GO:0060766": "negative regulation of androgen receptor signaling pathway",
  "GO:0060767": "epithelial cell proliferation involved in prostate gland development",
  "GO:0060768": "regulation of epithelial cell proliferation involved in prostate gland development",
  "GO:0060769": "positive regulation of epithelial cell proliferation involved in prostate gland development",
  "GO:0060770": "negative regulation of epithelial cell proliferation involved in prostate gland development",
  "GO:0060771": "phyllotactic patterning",
  "GO:0060772": "leaf phyllotactic patterning",
  "GO:0060773": "flower phyllotactic patterning",
  "GO:0060774": "auxin mediated signaling pathway involved in phyllotactic patterning",
  "GO:0060775": "planar cell polarity pathway involved in gastrula mediolateral intercalation",
  "GO:0060776": "simple leaf morphogenesis",
  "GO:0060777": "compound leaf morphogenesis",
  "GO:0060778": "primary leaflet morphogenesis",
  "GO:0060779": "secondary leaflet morphogenesis",
  "GO:0060780": "intercalary leaflet morphogenesis",
  "GO:0060781": "mesenchymal cell proliferation involved in prostate gland development",
  "GO:0060782": "regulation of mesenchymal cell proliferation involved in prostate gland development",
  "GO:0060783": "mesenchymal smoothened signaling pathway involved in prostate gland development",
  "GO:0060784": "regulation of cell proliferation involved in tissue homeostasis",
  "GO:0060785": "regulation of apoptosis involved in tissue homeostasis",
  "GO:0060786": "regulation of cell differentiation involved in tissue homeostasis",
  "GO:0060787": "positive regulation of posterior neural plate formation by fibroblast growth factor receptor signaling pathway",
  "GO:0060788": "ectodermal placode formation",
  "GO:0060789": "hair follicle placode formation",
  "GO:0060790": "tooth placode formation",
  "GO:0060791": "sebaceous gland placode formation",
  "GO:0060792": "sweat gland development",
  "GO:0060793": "sweat gland placode formation",
  "GO:0060794": "leaflet morphogenesis",
  "GO:0060795": "cell fate commitment involved in formation of primary germ layer",
  "GO:0060796": "regulation of transcription involved in primary germ layer cell fate commitment",
  "GO:0060797": "transforming growth factor beta receptor signaling pathway involved in primary germ layer cell fate commitment",
  "GO:0060798": "transforming growth factor beta receptor signaling pathway involved in mesodermal cell fate specification",
  "GO:0060799": "transforming growth factor beta receptor signaling pathway involved in endodermal cell fate specification",
  "GO:0060800": "regulation of cell differentiation involved in embryonic placenta development",
  "GO:0060801": "negative regulation of trophoblast cell differentiation by transforming growth factor beta signaling pathway",
  "GO:0060802": "epiblast cell-extraembryonic ectoderm cell signaling involved in anterior/posterior axis specification",
  "GO:0060803": "BMP signaling pathway involved in mesodermal cell fate specification",
  "GO:0060804": "positive regulation of Wnt signaling pathway by BMP signaling pathway",
  "GO:0060805": "negative regulation of trophoblast cell differentiation by transcription regulation from RNA polymerase II promoter",
  "GO:0060806": "negative regulation of cell differentiation involved in embryonic placenta development",
  "GO:0060807": "regulation of transcription from RNA polymerase II promoter involved in definitive endodermal cell fate specification",
  "GO:0060808": "positive regulation of mesodermal to mesenchymal transition involved in gastrulation",
  "GO:0060809": "mesodermal to mesenchymal transition involved in gastrulation",
  "GO:0060810": "intracellular mRNA localization involved in pattern specification process",
  "GO:0060811": "intracellular mRNA localization involved in anterior/posterior axis specification",
  "GO:0060812": "orthodenticle mRNA localization",
  "GO:0060813": "anterior mRNA localization involved in anterior/posterior axis specification",
  "GO:0060814": "posterior mRNA localization involved in anterior/posterior axis specification",
  "GO:0060815": "regulation of translation involved in anterior/posterior axis specification",
  "GO:0060816": "random inactivation of X chromosome",
  "GO:0060817": "inactivation of paternal X chromosome",
  "GO:0060818": "inactivation of paternal X chromosome by genetic imprinting",
  "GO:0060819": "inactivation of X chromosome by genetic imprinting",
  "GO:0060820": "inactivation of X chromosome by heterochromatin assembly",
  "GO:0060821": "inactivation of X chromosome by DNA methylation",
  "GO:0060822": "transforming growth factor beta receptor signaling pathway involved in axial mesodermal cell fate specification",
  "GO:0060823": "canonical Wnt signaling pathway involved in neural plate anterior/posterior pattern formation",
  "GO:0060824": "retinoic acid receptor signaling pathway involved in neural plate anterior/posterior pattern formation",
  "GO:0060825": "fibroblast growth factor receptor signaling pathway involved in neural plate anterior/posterior pattern formation",
  "GO:0060826": "transforming growth factor beta receptor signaling pathway involved in neural plate anterior/posterior pattern formation",
  "GO:0060827": "regulation of canonical Wnt signaling pathway involved in neural plate anterior/posterior pattern formation",
  "GO:0060828": "regulation of canonical Wnt signaling pathway",
  "GO:0060829": "negative regulation of canonical Wnt signaling pathway involved in neural plate anterior/posterior pattern formation",
  "GO:0060830": "ciliary receptor clustering involved in smoothened signaling pathway",
  "GO:0060831": "smoothened signaling pathway involved in dorsal/ventral neural tube patterning",
  "GO:0060832": "oocyte animal/vegetal axis specification",
  "GO:0060833": "Wnt signaling pathway involved in animal/vegetal axis specification",
  "GO:0060834": "oral/aboral axis specification",
  "GO:0060835": "transforming growth factor receptor beta signaling pathway involved in oral/aboral axis specification",
  "GO:0060836": "lymphatic endothelial cell differentiation",
  "GO:0060837": "blood vessel endothelial cell differentiation",
  "GO:0060838": "lymphatic endothelial cell fate commitment",
  "GO:0060839": "endothelial cell fate commitment",
  "GO:0060840": "artery development",
  "GO:0060841": "venous blood vessel development",
  "GO:0060842": "arterial endothelial cell differentiation",
  "GO:0060843": "venous endothelial cell differentiation",
  "GO:0060844": "arterial endothelial cell fate commitment",
  "GO:0060845": "venous endothelial cell fate commitment",
  "GO:0060846": "blood vessel endothelial cell fate commitment",
  "GO:0060847": "endothelial cell fate specification",
  "GO:0060848": "endothelial cell fate determination",
  "GO:0060849": "regulation of transcription involved in lymphatic endothelial cell fate commitment",
  "GO:0060850": "regulation of transcription involved in cell fate commitment",
  "GO:0060851": "vascular endothelial growth factor receptor signaling pathway involved in lymphatic endothelial cell fate commitment",
  "GO:0060852": "regulation of transcription involved in venous endothelial cell fate commitment",
  "GO:0060853": "Notch signaling pathway involved in arterial endothelial cell fate commitment",
  "GO:0060854": "patterning of lymph vessels",
  "GO:0060855": "venous endothelial cell migration involved in lymph vessel development",
  "GO:0060856": "establishment of blood-brain barrier",
  "GO:0060857": "establishment of glial blood-brain barrier",
  "GO:0060858": "vesicle-mediated transport involved in floral organ abscission",
  "GO:0060859": "regulation of vesicle-mediated transport involved in floral organ abscission",
  "GO:0060860": "regulation of floral organ abscission",
  "GO:0060861": "positive regulation of floral organ abscission",
  "GO:0060862": "negative regulation of floral organ abscission",
  "GO:0060863": "regulation of floral organ abscission by signal transduction",
  "GO:0060864": "positive regulation of floral organ abscission by small GTPase mediated signal transduction",
  "GO:0060865": "negative regulation of floral organ abscission by transmembrane receptor protein serine/threonine kinase signaling pathway",
  "GO:0060866": "leaf abscission",
  "GO:0060867": "fruit abscission",
  "GO:0060868": "regulation of vesicle-mediated transport involved in floral organ abscission by small GTPase mediated signal transduction",
  "GO:0060869": "transmembrane receptor protein serine/threonine kinase signaling pathway involved in floral organ abscission",
  "GO:0060870": "cell wall disassembly involved in floral organ abscission",
  "GO:0060872": "semicircular canal development",
  "GO:0060873": "anterior semicircular canal development",
  "GO:0060874": "posterior semicircular canal development",
  "GO:0060875": "lateral semicircular canal development",
  "GO:0060876": "semicircular canal formation",
  "GO:0060877": "regionalization involved in semicircular canal formation",
  "GO:0060878": "pouch outgrowth involved in semicircular canal formation",
  "GO:0060879": "semicircular canal fusion",
  "GO:0060880": "cell morphogenesis involved in semicircular canal fusion",
  "GO:0060881": "basal lamina disassembly",
  "GO:0060882": "basal lamina disassembly involved in semicircular canal fusion",
  "GO:0060883": "regulation of basal lamina disassembly involved in semicircular canal fusion by cell communication",
  "GO:0060884": "clearance of cells from fusion plate",
  "GO:0060885": "clearance of cells from fusion plate by apoptotic process",
  "GO:0060886": "clearance of cells from fusion plate by epithelial to mesenchymal transition",
  "GO:0060887": "limb epidermis development",
  "GO:0060888": "limb epidermis stratification",
  "GO:0060889": "limb basal epidermal cell differentiation",
  "GO:0060890": "limb spinous cell differentiation",
  "GO:0060891": "limb granular cell differentiation",
  "GO:0060892": "limb basal epidermal cell fate specification",
  "GO:0060893": "limb granular cell fate specification",
  "GO:0060894": "limb spinous cell fate specification",
  "GO:0060895": "retinoic acid receptor signaling pathway involved in spinal cord dorsal/ventral patterning",
  "GO:0060896": "neural plate pattern specification",
  "GO:0060897": "neural plate regionalization",
  "GO:0060898": "eye field cell fate commitment involved in camera-type eye formation",
  "GO:0060899": "regulation of transcription involved in eye field cell fate commitment of camera-type eye",
  "GO:0060900": "embryonic camera-type eye formation",
  "GO:0060901": "regulation of hair cycle by canonical Wnt signaling pathway",
  "GO:0060902": "regulation of hair cycle by BMP signaling pathway",
  "GO:0060903": "positive regulation of meiosis I",
  "GO:0060904": "regulation of protein folding in endoplasmic reticulum",
  "GO:0060905": "regulation of induction of conjugation upon nitrogen starvation",
  "GO:0060906": "negative regulation of chromatin silencing by small RNA",
  "GO:0060907": "positive regulation of macrophage cytokine production",
  "GO:0060908": "plasmid copy number maintenance",
  "GO:0060909": "regulation of DNA replication initiation involved in plasmid copy number maintenance",
  "GO:0060910": "negative regulation of DNA replication initiation involved in plasmid copy number maintenance",
  "GO:0060911": "cardiac cell fate commitment",
  "GO:0060912": "cardiac cell fate specification",
  "GO:0060913": "cardiac cell fate determination",
  "GO:0060914": "heart formation",
  "GO:0060915": "mesenchymal cell differentiation involved in lung development",
  "GO:0060916": "mesenchymal cell proliferation involved in lung development",
  "GO:0060917": "regulation of (1->6)-beta-D-glucan biosynthetic process",
  "GO:0060918": "auxin transport",
  "GO:0060919": "auxin influx",
  "GO:0060920": "cardiac pacemaker cell differentiation",
  "GO:0060921": "sinoatrial node cell differentiation",
  "GO:0060922": "atrioventricular node cell differentiation",
  "GO:0060923": "cardiac muscle cell fate commitment",
  "GO:0060924": "atrial cardiac muscle cell fate commitment",
  "GO:0060925": "ventricular cardiac muscle cell fate commitment",
  "GO:0060926": "cardiac pacemaker cell development",
  "GO:0060927": "cardiac pacemaker cell fate commitment",
  "GO:0060928": "atrioventricular node cell development",
  "GO:0060929": "atrioventricular node cell fate commitment",
  "GO:0060930": "sinoatrial node cell fate commitment",
  "GO:0060931": "sinoatrial node cell development",
  "GO:0060932": "His-Purkinje system cell differentiation",
  "GO:0060933": "His-Purkinje system cell development",
  "GO:0060934": "His-Purkinje system cell fate commitment",
  "GO:0060935": "cardiac fibroblast cell differentiation",
  "GO:0060936": "cardiac fibroblast cell development",
  "GO:0060937": "cardiac fibroblast cell fate commitment",
  "GO:0060938": "epicardium-derived cardiac fibroblast cell differentiation",
  "GO:0060939": "epicardium-derived cardiac fibroblast cell development",
  "GO:0060940": "epithelial to mesenchymal transition involved in cardiac fibroblast development",
  "GO:0060941": "epicardium-derived cardiac fibroblast cell fate commitment",
  "GO:0060942": "neural crest-derived cardiac fibroblast cell differentiation",
  "GO:0060943": "neural crest-derived cardiac fibroblast cell development",
  "GO:0060944": "neural crest-derived cardiac fibroblast cell fate commitment",
  "GO:0060945": "cardiac neuron differentiation",
  "GO:0060946": "cardiac blood vessel endothelial cell differentiation",
  "GO:0060947": "cardiac vascular smooth muscle cell differentiation",
  "GO:0060948": "cardiac vascular smooth muscle cell development",
  "GO:0060949": "cardiac vascular smooth muscle cell fate commitment",
  "GO:0060950": "cardiac glial cell differentiation",
  "GO:0060951": "neural crest-derived cardiac glial cell differentiation",
  "GO:0060952": "cardiac glial cell development",
  "GO:0060953": "cardiac glial cell fate commitment",
  "GO:0060954": "neural crest-derived cardiac glial cell development",
  "GO:0060955": "neural crest-derived cardiac glial cell fate commitment",
  "GO:0060956": "endocardial cell differentiation",
  "GO:0060957": "endocardial cell fate commitment",
  "GO:0060958": "endocardial cell development",
  "GO:0060959": "cardiac neuron development",
  "GO:0060960": "cardiac neuron fate commitment",
  "GO:0060961": "phospholipase D inhibitor activity",
  "GO:0060962": "regulation of ribosomal protein gene transcription from RNA polymerase II promoter",
  "GO:0060963": "positive regulation of ribosomal protein gene transcription from RNA polymerase II promoter",
  "GO:0060964": "regulation of gene silencing by miRNA",
  "GO:0060965": "negative regulation of gene silencing by miRNA",
  "GO:0060966": "regulation of gene silencing by RNA",
  "GO:0060967": "negative regulation of gene silencing by RNA",
  "GO:0060968": "regulation of gene silencing",
  "GO:0060969": "negative regulation of gene silencing",
  "GO:0060970": "embryonic heart tube dorsal/ventral pattern formation",
  "GO:0060971": "embryonic heart tube left/right pattern formation",
  "GO:0060972": "left/right pattern formation",
  "GO:0060973": "cell migration involved in heart development",
  "GO:0060974": "cell migration involved in heart formation",
  "GO:0060975": "cardioblast migration to the midline involved in heart field formation",
  "GO:0060976": "coronary vasculature development",
  "GO:0060977": "coronary vasculature morphogenesis",
  "GO:0060978": "angiogenesis involved in coronary vascular morphogenesis",
  "GO:0060979": "vasculogenesis involved in coronary vascular morphogenesis",
  "GO:0060980": "cell migration involved in coronary vasculogenesis",
  "GO:0060981": "cell migration involved in coronary angiogenesis",
  "GO:0060982": "coronary artery morphogenesis",
  "GO:0060983": "epicardium-derived cardiac vascular smooth muscle cell differentiation",
  "GO:0060984": "epicardium-derived cardiac vascular smooth muscle cell development",
  "GO:0060985": "epicardium-derived cardiac vascular smooth muscle cell fate commitment",
  "GO:0060986": "endocrine hormone secretion",
  "GO:0060987": "lipid tube",
  "GO:0060988": "lipid tube assembly",
  "GO:0060989": "lipid tube assembly involved in organelle fusion",
  "GO:0060990": "lipid tube assembly involved in organelle fission",
  "GO:0060991": "obsolete lipid tube assembly involved in cytokinesis",
  "GO:0060992": "response to fungicide",
  "GO:0060993": "kidney morphogenesis",
  "GO:0060994": "regulation of transcription from RNA polymerase II promoter involved in kidney development",
  "GO:0060995": "cell-cell signaling involved in kidney development",
  "GO:0060996": "dendritic spine development",
  "GO:0060997": "dendritic spine morphogenesis",
  "GO:0060998": "regulation of dendritic spine development",
  "GO:0060999": "positive regulation of dendritic spine development",
  "GO:0061000": "negative regulation of dendritic spine development",
  "GO:0061001": "regulation of dendritic spine morphogenesis",
  "GO:0061002": "negative regulation of dendritic spine morphogenesis",
  "GO:0061003": "positive regulation of dendritic spine morphogenesis",
  "GO:0061004": "pattern specification involved in kidney development",
  "GO:0061005": "cell differentiation involved in kidney development",
  "GO:0061006": "regulation of cell proliferation involved in kidney morphogenesis",
  "GO:0061007": "hepaticobiliary system process",
  "GO:0061008": "hepaticobiliary system development",
  "GO:0061009": "common bile duct development",
  "GO:0061010": "gall bladder development",
  "GO:0061011": "hepatic duct development",
  "GO:0061013": "regulation of mRNA catabolic process",
  "GO:0061014": "positive regulation of mRNA catabolic process",
  "GO:0061015": "snRNA import into nucleus",
  "GO:0061016": "snRNA import into Cajal body",
  "GO:0061017": "hepatoblast differentiation",
  "GO:0061024": "membrane organization",
  "GO:0061025": "membrane fusion",
  "GO:0061026": "cardiac muscle tissue regeneration",
  "GO:0061027": "umbilical cord development",
  "GO:0061028": "establishment of endothelial barrier",
  "GO:0061029": "eyelid development in camera-type eye",
  "GO:0061030": "epithelial cell differentiation involved in mammary gland alveolus development",
  "GO:0061031": "endodermal digestive tract morphogenesis",
  "GO:0061032": "visceral serous pericardium development",
  "GO:0061033": "secretion by lung epithelial cell involved in lung growth",
  "GO:0061034": "olfactory bulb mitral cell layer development",
  "GO:0061035": "regulation of cartilage development",
  "GO:0061036": "positive regulation of cartilage development",
  "GO:0061037": "negative regulation of cartilage development",
  "GO:0061038": "uterus morphogenesis",
  "GO:0061040": "female gonad morphogenesis",
  "GO:0061041": "regulation of wound healing",
  "GO:0061042": "vascular wound healing",
  "GO:0061043": "regulation of vascular wound healing",
  "GO:0061044": "negative regulation of vascular wound healing",
  "GO:0061045": "negative regulation of wound healing",
  "GO:0061046": "regulation of branching involved in lung morphogenesis",
  "GO:0061047": "positive regulation of branching involved in lung morphogenesis",
  "GO:0061048": "negative regulation of branching involved in lung morphogenesis",
  "GO:0061049": "cell growth involved in cardiac muscle cell development",
  "GO:0061050": "regulation of cell growth involved in cardiac muscle cell development",
  "GO:0061051": "positive regulation of cell growth involved in cardiac muscle cell development",
  "GO:0061052": "negative regulation of cell growth involved in cardiac muscle cell development",
  "GO:0061053": "somite development",
  "GO:0061054": "dermatome development",
  "GO:0061055": "myotome development",
  "GO:0061056": "sclerotome development",
  "GO:0061057": "peptidoglycan recognition protein signaling pathway",
  "GO:0061058": "regulation of peptidoglycan recognition protein signaling pathway",
  "GO:0061059": "positive regulation of peptidoglycan recognition protein signaling pathway",
  "GO:0061060": "negative regulation of peptidoglycan recognition protein signaling pathway",
  "GO:0061061": "muscle structure development",
  "GO:0061062": "regulation of nematode larval development",
  "GO:0061063": "positive regulation of nematode larval development",
  "GO:0061064": "negative regulation of nematode larval development",
  "GO:0061065": "regulation of dauer larval development",
  "GO:0061066": "positive regulation of dauer larval development",
  "GO:0061067": "negative regulation of dauer larval development",
  "GO:0061068": "urethra development",
  "GO:0061069": "male urethra development",
  "GO:0061070": "female urethra development",
  "GO:0061071": "urethra epithelium development",
  "GO:0061072": "iris morphogenesis",
  "GO:0061073": "ciliary body morphogenesis",
  "GO:0061074": "regulation of neural retina development",
  "GO:0061075": "positive regulation of neural retina development",
  "GO:0061076": "negative regulation of neural retina development",
  "GO:0061077": "chaperone-mediated protein folding",
  "GO:0061078": "positive regulation of prostaglandin secretion involved in immune response",
  "GO:0061079": "left horn of sinus venosus development",
  "GO:0061080": "right horn of sinus venosus development",
  "GO:0061081": "positive regulation of myeloid leukocyte cytokine production involved in immune response",
  "GO:0061082": "myeloid leukocyte cytokine production",
  "GO:0061083": "regulation of protein refolding",
  "GO:0061084": "negative regulation of protein refolding",
  "GO:0061085": "regulation of histone H3-K27 methylation",
  "GO:0061086": "negative regulation of histone H3-K27 methylation",
  "GO:0061087": "positive regulation of histone H3-K27 methylation",
  "GO:0061088": "regulation of sequestering of zinc ion",
  "GO:0061089": "negative regulation of sequestering of zinc ion",
  "GO:0061090": "positive regulation of sequestering of zinc ion",
  "GO:0061091": "regulation of phospholipid translocation",
  "GO:0061092": "positive regulation of phospholipid translocation",
  "GO:0061093": "negative regulation of phospholipid translocation",
  "GO:0061094": "regulation of turning behavior involved in mating",
  "GO:0061095": "positive regulation of turning behavior involved in mating",
  "GO:0061096": "negative regulation of turning behavior involved in mating",
  "GO:0061097": "regulation of protein tyrosine kinase activity",
  "GO:0061098": "positive regulation of protein tyrosine kinase activity",
  "GO:0061099": "negative regulation of protein tyrosine kinase activity",
  "GO:0061100": "lung neuroendocrine cell differentiation",
  "GO:0061101": "neuroendocrine cell differentiation",
  "GO:0061102": "stomach neuroendocrine cell differentiation",
  "GO:0061103": "carotid body glomus cell differentiation",
  "GO:0061104": "adrenal chromaffin cell differentiation",
  "GO:0061105": "regulation of stomach neuroendocrine cell differentiation",
  "GO:0061106": "negative regulation of stomach neuroendocrine cell differentiation",
  "GO:0061107": "seminal vesicle development",
  "GO:0061108": "seminal vesicle epithelium development",
  "GO:0061109": "dense core granule organization",
  "GO:0061110": "dense core granule biogenesis",
  "GO:0061111": "epithelial-mesenchymal cell signaling involved in lung development",
  "GO:0061112": "negative regulation of bud outgrowth involved in lung branching",
  "GO:0061113": "pancreas morphogenesis",
  "GO:0061114": "branching involved in pancreas morphogenesis",
  "GO:0061115": "lung proximal/distal axis specification",
  "GO:0061116": "ductus venosus closure",
  "GO:0061117": "negative regulation of heart growth",
  "GO:0061118": "regulation of positive chemotaxis to cAMP",
  "GO:0061119": "regulation of positive chemotaxis to cAMP by chlorinated alkylphenone",
  "GO:0061120": "regulation of positive chemotaxis to cAMP by DIF-1",
  "GO:0061121": "regulation of positive chemotaxis to cAMP by DIF-2",
  "GO:0061122": "positive regulation of positive chemotaxis to cAMP",
  "GO:0061123": "negative regulation of positive chemotaxis to cAMP",
  "GO:0061124": "positive regulation of positive chemotaxis to cAMP by chlorinated alkylphenone",
  "GO:0061125": "negative regulation of positive chemotaxis to cAMP by chlorinated alkylphenone",
  "GO:0061126": "positive regulation of positive chemotaxis to cAMP by DIF-1",
  "GO:0061127": "negative regulation of positive chemotaxis to cAMP by DIF-1",
  "GO:0061128": "positive regulation of chemotaxis to cAMP by DIF-2",
  "GO:0061129": "negative regulation of positive chemotaxis to cAMP by DIF-2",
  "GO:0061130": "pancreatic bud formation",
  "GO:0061131": "pancreas field specification",
  "GO:0061132": "pancreas induction",
  "GO:0061133": "endopeptidase activator activity",
  "GO:0061134": "peptidase regulator activity",
  "GO:0061135": "endopeptidase regulator activity",
  "GO:0061136": "regulation of proteasomal protein catabolic process",
  "GO:0061137": "bud dilation",
  "GO:0061138": "morphogenesis of a branching epithelium",
  "GO:0061139": "bud field specification",
  "GO:0061140": "lung secretory cell differentiation",
  "GO:0061141": "lung ciliated cell differentiation",
  "GO:0061142": "mesothelial-mesenchymal cell signaling involved in early lung development",
  "GO:0061143": "alveolar primary septum development",
  "GO:0061144": "alveolar secondary septum development",
  "GO:0061145": "lung smooth muscle development",
  "GO:0061146": "Peyer's patch morphogenesis",
  "GO:0061147": "endocardial endothelium development",
  "GO:0061148": "extracellular matrix organization involved in endocardium development",
  "GO:0061149": "BMP signaling pathway involved in ureter morphogenesis",
  "GO:0061150": "renal system segmentation",
  "GO:0061151": "BMP signaling pathway involved in renal system segmentation",
  "GO:0061152": "trachea submucosa development",
  "GO:0061153": "trachea gland development",
  "GO:0061154": "endothelial tube morphogenesis",
  "GO:0061155": "pulmonary artery endothelial tube morphogenesis",
  "GO:0061156": "pulmonary artery morphogenesis",
  "GO:0061157": "mRNA destabilization",
  "GO:0061158": "3'-UTR-mediated mRNA destabilization",
  "GO:0061159": "establishment of bipolar cell polarity involved in cell morphogenesis",
  "GO:0061160": "regulation of establishment of bipolar cell polarity regulating cell shape",
  "GO:0061161": "positive regulation of establishment of bipolar cell polarity regulating cell shape",
  "GO:0061162": "establishment of monopolar cell polarity",
  "GO:0061163": "endoplasmic reticulum polarization",
  "GO:0061164": "transitional endoplasmic reticulum polarization at cell division site",
  "GO:0061165": "endoplasmic reticulum localization involved in endoplasmic reticulum polarization at cell division site",
  "GO:0061166": "establishment of endoplasmic reticulum localization involved in endoplasmic reticulum polarization at cell division site",
  "GO:0061167": "maintenance of endoplasmic reticulum location involved in endoplasmic reticulum polarization at cell division site",
  "GO:0061168": "regulation of hair follicle placode formation",
  "GO:0061169": "positive regulation of hair placode formation",
  "GO:0061170": "negative regulation of hair follicle placode formation",
  "GO:0061171": "establishment of bipolar cell polarity",
  "GO:0061172": "regulation of establishment of bipolar cell polarity",
  "GO:0061173": "positive regulation of establishment of bipolar cell polarity",
  "GO:0061174": "type I terminal bouton",
  "GO:0061175": "type II terminal bouton",
  "GO:0061176": "type Ib terminal bouton",
  "GO:0061177": "type Is terminal bouton",
  "GO:0061178": "regulation of insulin secretion involved in cellular response to glucose stimulus",
  "GO:0061179": "negative regulation of insulin secretion involved in cellular response to glucose stimulus",
  "GO:0061180": "mammary gland epithelium development",
  "GO:0061181": "regulation of chondrocyte development",
  "GO:0061182": "negative regulation of chondrocyte development",
  "GO:0061183": "regulation of dermatome development",
  "GO:0061184": "positive regulation of dermatome development",
  "GO:0061185": "negative regulation of dermatome development",
  "GO:0061186": "negative regulation of chromatin silencing at silent mating-type cassette",
  "GO:0061187": "regulation of chromatin silencing at rDNA",
  "GO:0061188": "negative regulation of chromatin silencing at rDNA",
  "GO:0061189": "positive regulation of sclerotome development",
  "GO:0061190": "regulation of sclerotome development",
  "GO:0061191": "positive regulation of vacuole fusion, non-autophagic",
  "GO:0061192": "negative regulation of vacuole fusion, non-autophagic",
  "GO:0061193": "taste bud development",
  "GO:0061194": "taste bud morphogenesis",
  "GO:0061195": "taste bud formation",
  "GO:0061196": "fungiform papilla development",
  "GO:0061197": "fungiform papilla morphogenesis",
  "GO:0061198": "fungiform papilla formation",
  "GO:0061199": "striated muscle contraction involved in embryonic body morphogenesis",
  "GO:0061200": "clathrin-sculpted gamma-aminobutyric acid transport vesicle",
  "GO:0061201": "clathrin-sculpted gamma-aminobutyric acid transport vesicle lumen",
  "GO:0061202": "clathrin-sculpted gamma-aminobutyric acid transport vesicle membrane",
  "GO:0061203": "striated muscle paramyosin thick filament assembly",
  "GO:0061204": "paramyosin filament assembly or disassembly",
  "GO:0061205": "paramesonephric duct development",
  "GO:0061206": "mesonephros morphogenesis",
  "GO:0061207": "mesonephric juxtaglomerulus cell differentiation",
  "GO:0061208": "cell differentiation involved in mesonephros development",
  "GO:0061209": "cell proliferation involved in mesonephros development",
  "GO:0061210": "cell-cell signaling involved in mesonephros development",
  "GO:0061211": "mesonephric collecting duct development",
  "GO:0061212": "mesonephric juxtaglomerular apparatus development",
  "GO:0061213": "positive regulation of mesonephros development",
  "GO:0061214": "mesonephric smooth muscle tissue development",
  "GO:0061215": "mesonephric nephron development",
  "GO:0061216": "regulation of transcription from RNA polymerase II promoter involved in mesonephros development",
  "GO:0061217": "regulation of mesonephros development",
  "GO:0061218": "negative regulation of mesonephros development",
  "GO:0061219": "mesonephric mesenchyme development",
  "GO:0061220": "mesonephric macula densa development",
  "GO:0061221": "mesonephric mesenchyme morphogenesis",
  "GO:0061222": "mesonephric mesenchymal cell proliferation involved in mesonephros development",
  "GO:0061223": "mesonephric mesenchymal cell differentiation",
  "GO:0061224": "mesonephric glomerulus development",
  "GO:0061225": "mesonephric extraglomerular mesangial cell proliferation involved in mesonephros development",
  "GO:0061226": "proximal/distal pattern formation involved in mesonephric nephron development",
  "GO:0061227": "pattern specification involved in mesonephros development",
  "GO:0061228": "mesonephric nephron morphogenesis",
  "GO:0061229": "mesonephric juxtaglomerulus cell development",
  "GO:0061230": "mesonephric juxtaglomerulus cell fate commitment",
  "GO:0061231": "mesonephric glomerulus vasculature development",
  "GO:0061232": "mesonephric glomerular epithelium development",
  "GO:0061233": "mesonephric glomerular basement membrane development",
  "GO:0061234": "mesonephric glomerulus morphogenesis",
  "GO:0061235": "mesenchymal stem cell maintenance involved in mesonephric nephron morphogenesis",
  "GO:0061236": "mesonephric comma-shaped body morphogenesis",
  "GO:0061237": "convergent extension involved in mesonephric nephron morphogenesis",
  "GO:0061238": "establishment of planar polarity involved in mesonephric nephron morphogenesis",
  "GO:0061239": "mesenchymal stem cell differentiation involved in mesonephric nephron morphogenesis",
  "GO:0061240": "mesonephric nephron tubule morphogenesis",
  "GO:0061241": "mesonephric nephron epithelium development",
  "GO:0061242": "mesonephric nephron tubule development",
  "GO:0061243": "mesonephric renal vesicle morphogenesis",
  "GO:0061244": "mesonephric S-shaped body morphogenesis",
  "GO:0061245": "establishment or maintenance of bipolar cell polarity",
  "GO:0061246": "establishment or maintenance of bipolar cell polarity regulating cell shape",
  "GO:0061247": "mesonephric glomerular mesangium development",
  "GO:0061248": "mesonephric glomerulus vasculature morphogenesis",
  "GO:0061249": "mesonephric glomerular capillary formation",
  "GO:0061250": "mesonephric glomerular epithelial cell differentiation",
  "GO:0061251": "mesonephric glomerular epithelial cell development",
  "GO:0061252": "mesonephric glomerular epithelial cell fate commitment",
  "GO:0061253": "mesonephric glomerular parietal epithelial cell differentiation",
  "GO:0061254": "mesonephric glomerular parietal epithelial cell development",
  "GO:0061255": "mesonephric glomerular parietal epithelial cell fate commitment",
  "GO:0061256": "mesonephric glomerular visceral epithelial cell differentiation",
  "GO:0061257": "mesonephric glomerular visceral epithelial cell development",
  "GO:0061258": "mesonephric glomerular visceral epithelial cell fate commitment",
  "GO:0061259": "mesonephric glomerular mesangial cell differentiation",
  "GO:0061260": "mesonephric mesangial cell differentiation",
  "GO:0061261": "mesenchymal to epithelial transition involved in mesonephros morphogenesis",
  "GO:0061262": "mesonephric renal vesicle formation",
  "GO:0061263": "mesonephric glomerular mesangial cell development",
  "GO:0061264": "mesonephric glomerular mesangial cell fate commitment",
  "GO:0061265": "mesonephric nephron tubule epithelial cell differentiation",
  "GO:0061266": "mesonephric interstitial fibroblast differentiation",
  "GO:0061267": "mesonephric interstitial fibroblast development",
  "GO:0061268": "mesonephric interstitial fibroblast fate commitment",
  "GO:0061269": "mesonephric glomerular mesangial cell proliferation involved in mesonephros development",
  "GO:0061270": "mesonephric intraglomerular mesangial cell proliferation",
  "GO:0061271": "mesenchymal to epithelial transition involved in mesonephric renal vesicle formation",
  "GO:0061272": "mesonephric connecting tubule development",
  "GO:0061273": "mesonephric distal tubule morphogenesis",
  "GO:0061274": "mesonephric distal tubule development",
  "GO:0061275": "mesonephric proximal tubule development",
  "GO:0061276": "mesonephric proximal tubule morphogenesis",
  "GO:0061277": "mesonephric nephron tubule formation",
  "GO:0061278": "epithelial cell migration involved in mesonephric nephron tubule morphogenesis",
  "GO:0061279": "epithelial cell migration involved in mesonephric distal tubule morphogenesis",
  "GO:0061280": "epithelial cell migration involved in mesonephric proximal tubule morphogenesis",
  "GO:0061281": "specification of mesonephric connecting tubule identity",
  "GO:0061282": "specification of mesonephric nephron tubule identity",
  "GO:0061283": "specification of mesonephric distal tubule identity",
  "GO:0061284": "specification of mesonephric proximal tubule identity",
  "GO:0061285": "mesonephric capsule development",
  "GO:0061286": "mesonephric capsule morphogenesis",
  "GO:0061287": "mesonephric capsule formation",
  "GO:0061288": "mesonephric capsule specification",
  "GO:0061289": "Wnt signaling pathway involved in kidney development",
  "GO:0061290": "canonical Wnt signaling pathway involved in metanephric kidney development",
  "GO:0061291": "canonical Wnt signaling pathway involved in ureteric bud branching",
  "GO:0061292": "canonical Wnt signaling pathway involved in mesonephros development",
  "GO:0061293": "canonical Wnt signaling pathway involved in mesonephric nephron development",
  "GO:0061294": "mesonephric renal vesicle induction",
  "GO:0061295": "regulation of mesenchymal cell apoptotic process involved in mesonephric nephron morphogenesis",
  "GO:0061296": "negative regulation of mesenchymal cell apoptotic process involved in mesonephric nephron morphogenesis",
  "GO:0061297": "positive regulation of mesenchymal cell apoptotic process involved in mesonephric nephron morphogenesis",
  "GO:0061298": "retina vasculature development in camera-type eye",
  "GO:0061299": "retina vasculature morphogenesis in camera-type eye",
  "GO:0061300": "cerebellum vasculature development",
  "GO:0061301": "cerebellum vasculature morphogenesis",
  "GO:0061302": "smooth muscle cell-matrix adhesion",
  "GO:0061303": "cornea development in camera-type eye",
  "GO:0061304": "retinal blood vessel morphogenesis",
  "GO:0061305": "maintenance of bipolar cell polarity regulating cell shape",
  "GO:0061306": "DNA strand renaturation involved in double-strand break repair",
  "GO:0061307": "cardiac neural crest cell differentiation involved in heart development",
  "GO:0061308": "cardiac neural crest cell development involved in heart development",
  "GO:0061309": "cardiac neural crest cell development involved in outflow tract morphogenesis",
  "GO:0061310": "canonical Wnt signaling pathway involved in cardiac neural crest cell differentiation involved in heart development",
  "GO:0061311": "cell surface receptor signaling pathway involved in heart development",
  "GO:0061312": "BMP signaling pathway involved in heart development",
  "GO:0061313": "fibroblast growth factor receptor signaling pathway involved in heart development",
  "GO:0061314": "Notch signaling involved in heart development",
  "GO:0061315": "canonical Wnt signaling pathway involved in positive regulation of cardiac muscle cell proliferation",
  "GO:0061316": "canonical Wnt signaling pathway involved in heart development",
  "GO:0061317": "canonical Wnt signaling pathway involved in cardiac muscle cell fate commitment",
  "GO:0061318": "renal filtration cell differentiation",
  "GO:0061319": "nephrocyte differentiation",
  "GO:0061320": "pericardial nephrocyte differentiation",
  "GO:0061321": "garland nephrocyte differentiation",
  "GO:0061322": "disseminated nephrocyte differentiation",
  "GO:0061323": "cell proliferation involved in heart morphogenesis",
  "GO:0061324": "canonical Wnt signaling pathway involved in positive regulation of cardiac outflow tract cell proliferation",
  "GO:0061325": "cell proliferation involved in outflow tract morphogenesis",
  "GO:0061326": "renal tubule development",
  "GO:0061327": "anterior Malpighian tubule development",
  "GO:0061328": "posterior Malpighian tubule development",
  "GO:0061329": "Malpighian tubule principal cell differentiation",
  "GO:0061330": "Malpighian tubule stellate cell differentiation",
  "GO:0061331": "epithelial cell proliferation involved in Malpighian tubule morphogenesis",
  "GO:0061332": "Malpighian tubule bud morphogenesis",
  "GO:0061333": "renal tubule morphogenesis",
  "GO:0061334": "cell rearrangement involved in Malpighian tubule morphogenesis",
  "GO:0061335": "cell growth involved in Malpighian tubule morphogenesis",
  "GO:0061336": "cell morphogenesis involved in Malpighian tubule morphogenesis",
  "GO:0061337": "cardiac conduction",
  "GO:0061338": "obsolete atrioventricular node impulse conduction delay",
  "GO:0061339": "establishment or maintenance of monopolar cell polarity",
  "GO:0061340": "establishment or maintenance of monopolar cell polarity regulating cell shape",
  "GO:0061341": "non-canonical Wnt signaling pathway involved in heart development",
  "GO:0061342": "regulation of cell adhesion involved in heart morphogenesis by non-canonical Wnt signaling pathway",
  "GO:0061343": "cell adhesion involved in heart morphogenesis",
  "GO:0061344": "regulation of cell adhesion involved in heart morphogenesis",
  "GO:0061345": "planar cell polarity pathway involved in cardiac muscle cell fate commitment",
  "GO:0061346": "planar cell polarity pathway involved in heart morphogenesis",
  "GO:0061347": "planar cell polarity pathway involved in outflow tract morphogenesis",
  "GO:0061348": "planar cell polarity pathway involved in ventricular septum morphogenesis",
  "GO:0061349": "planar cell polarity pathway involved in cardiac right atrium morphogenesis",
  "GO:0061350": "planar cell polarity pathway involved in cardiac muscle tissue morphogenesis",
  "GO:0061351": "neural precursor cell proliferation",
  "GO:0061352": "cell chemotaxis involved in Malpighian tubule morphogenesis",
  "GO:0061353": "BMP signaling pathway involved in Malpighian tubule cell chemotaxis",
  "GO:0061354": "planar cell polarity pathway involved in pericardium morphogenesis",
  "GO:0061355": "Wnt protein secretion",
  "GO:0061356": "regulation of Wnt protein secretion",
  "GO:0061357": "positive regulation of Wnt protein secretion",
  "GO:0061358": "negative regulation of Wnt protein secretion",
  "GO:0061359": "regulation of Wnt signaling pathway by Wnt protein secretion",
  "GO:0061360": "optic chiasma development",
  "GO:0061361": "positive regulation of maintenance of bipolar cell polarity regulating cell shape",
  "GO:0061362": "negative regulation of maintenance of bipolar cell polarity regulating cell shape",
  "GO:0061363": "negative regulation of progesterone biosynthesis involved in luteolysis",
  "GO:0061364": "apoptotic process involved in luteolysis",
  "GO:0061365": "positive regulation of triglyceride lipase activity",
  "GO:0061366": "behavioral response to chemical pain",
  "GO:0061367": "behavioral response to acetic acid induced pain",
  "GO:0061368": "behavioral response to formalin induced pain",
  "GO:0061369": "negative regulation of testicular blood vessel morphogenesis",
  "GO:0061370": "testosterone biosynthetic process",
  "GO:0061371": "determination of heart left/right asymmetry",
  "GO:0061372": "activin receptor signaling pathway involved in heart jogging",
  "GO:0061373": "mammillary axonal complex development",
  "GO:0061374": "mammillothalamic axonal tract development",
  "GO:0061375": "mammillotectal axonal tract development",
  "GO:0061376": "mammillotegmental axonal tract development",
  "GO:0061377": "mammary gland lobule development",
  "GO:0061378": "corpora quadrigemina development",
  "GO:0061379": "inferior colliculus development",
  "GO:0061380": "superior colliculus development",
  "GO:0061381": "cell migration in diencephalon",
  "GO:0061382": "Malpighian tubule tip cell differentiation",
  "GO:0061383": "trabecula morphogenesis",
  "GO:0061384": "heart trabecula morphogenesis",
  "GO:0061385": "fibroblast proliferation involved in heart morphogenesis",
  "GO:0061386": "closure of optic fissure",
  "GO:0061387": "regulation of extent of cell growth",
  "GO:0061388": "regulation of rate of cell growth",
  "GO:0061389": "regulation of direction of cell growth",
  "GO:0061390": "positive regulation of direction of cell growth",
  "GO:0061391": "negative regulation of direction of cell growth",
  "GO:0061392": "regulation of transcription from RNA polymerase II promoter in response to osmotic stress",
  "GO:0061393": "positive regulation of transcription from RNA polymerase II promoter in response to osmotic stress",
  "GO:0061394": "regulation of transcription from RNA polymerase II promoter in response to arsenic-containing substance",
  "GO:0061395": "positive regulation of transcription from RNA polymerase II promoter in response to arsenic-containing substance",
  "GO:0061396": "regulation of transcription from RNA polymerase II promoter in response to copper ion",
  "GO:0061397": "positive regulation of transcription from RNA polymerase II promoter in response to copper ion",
  "GO:0061398": "negative regulation of transcription from RNA polymerase II promoter in response to copper ion",
  "GO:0061399": "positive regulation of transcription from RNA polymerase II promoter in response to cobalt ion",
  "GO:0061400": "positive regulation of transcription from RNA polymerase II promoter in response to calcium ion",
  "GO:0061401": "positive regulation of transcription from RNA polymerase II promoter in response to a hypotonic environment",
  "GO:0061402": "positive regulation of transcription from RNA polymerase II promoter in response to acidic pH",
  "GO:0061403": "positive regulation of transcription from RNA polymerase II promoter in response to nitrosative stress",
  "GO:0061404": "positive regulation of transcription from RNA polymerase II promoter in response to increased salt",
  "GO:0061405": "positive regulation of transcription from RNA polymerase II promoter in response to hydrostatic pressure",
  "GO:0061406": "positive regulation of transcription from RNA polymerase II promoter in response to glucose starvation",
  "GO:0061407": "positive regulation of transcription from RNA polymerase II promoter in response to hydrogen peroxide",
  "GO:0061408": "positive regulation of transcription from RNA polymerase II promoter in response to heat stress",
  "GO:0061409": "positive regulation of transcription from RNA polymerase II promoter in response to freezing",
  "GO:0061410": "positive regulation of transcription from RNA polymerase II promoter in response to ethanol",
  "GO:0061411": "positive regulation of transcription from RNA polymerase II promoter in response to cold",
  "GO:0061412": "positive regulation of transcription from RNA polymerase II promoter in response to amino acid starvation",
  "GO:0061413": "regulation of transcription from RNA polymerase II promoter by a nonfermentable carbon source",
  "GO:0061414": "positive regulation of transcription from RNA polymerase II promoter by a nonfermentable carbon source",
  "GO:0061415": "negative regulation of transcription from RNA polymerase II promoter by a nonfermentable carbon source",
  "GO:0061416": "regulation of transcription from RNA polymerase II promoter in response to salt stress",
  "GO:0061417": "negative regulation of transcription from RNA polymerase II promoter in response to oxidative stress",
  "GO:0061418": "regulation of transcription from RNA polymerase II promoter in response to hypoxia",
  "GO:0061419": "positive regulation of transcription from RNA polymerase II promoter in response to hypoxia",
  "GO:0061420": "regulation of transcription from RNA polymerase II promoter in response to biotin starvation",
  "GO:0061421": "positive regulation of transcription by oleic acid",
  "GO:0061422": "positive regulation of transcription from RNA polymerase II promoter in response to alkaline pH",
  "GO:0061423": "positive regulation of sodium ion transport by positive regulation of transcription from RNA polymerase II promoter",
  "GO:0061424": "positive regulation of peroxisome organization by positive regulation of transcription from RNA polymerase II promoter",
  "GO:0061425": "positive regulation of ethanol catabolic process by positive regulation of transcription from RNA polymerase II promoter",
  "GO:0061426": "positive regulation of sulfite transport by positive regulation of transcription from RNA polymerase II promoter",
  "GO:0061427": "negative regulation of ceramide biosynthetic process by negative regulation of transcription from RNA Polymerase II promoter",
  "GO:0061428": "negative regulation of transcription from RNA polymerase II promoter in response to hypoxia",
  "GO:0061429": "positive regulation of transcription from RNA polymerase II promoter by oleic acid",
  "GO:0061430": "bone trabecula morphogenesis",
  "GO:0061431": "cellular response to methionine",
  "GO:0061432": "regulation of transcription from RNA polymerase II promoter in response to methionine",
  "GO:0061433": "cellular response to caloric restriction",
  "GO:0061434": "regulation of replicative cell aging by regulation of transcription from RNA polymerase II promoter in response to caloric restriction",
  "GO:0061435": "positive regulation of transcription from a mobile element promoter",
  "GO:0061436": "establishment of skin barrier",
  "GO:0061437": "renal system vasculature development",
  "GO:0061438": "renal system vasculature morphogenesis",
  "GO:0061439": "kidney vasculature morphogenesis",
  "GO:0061440": "kidney vasculature development",
  "GO:0061441": "renal artery morphogenesis",
  "GO:0061442": "cardiac muscle cell fate determination",
  "GO:0061443": "endocardial cushion cell differentiation",
  "GO:0061444": "endocardial cushion cell development",
  "GO:0061445": "endocardial cushion cell fate commitment",
  "GO:0061446": "endocardial cushion cell fate determination",
  "GO:0061447": "endocardial cushion cell fate specification",
  "GO:0061448": "connective tissue development",
  "GO:0061449": "olfactory bulb tufted cell development",
  "GO:0061450": "trophoblast cell migration",
  "GO:0061451": "retrotrapezoid nucleus development",
  "GO:0061452": "retrotrapezoid nucleus neuron differentiation",
  "GO:0061453": "interstitial cell of Cajal differentiation",
  "GO:0061454": "Golgi calcium ion export",
  "GO:0061455": "integral component of muscle cell projection membrane",
  "GO:0061456": "mesenchymal stem cell migration involved in uteric bud morphogenesis",
  "GO:0061457": "mesonephric cell migration involved in male gonad development",
  "GO:0061458": "reproductive system development",
  "GO:0061459": "L-arginine transmembrane transporter activity",
  "GO:0061460": "L-histidine import",
  "GO:0061461": "L-lysine import",
  "GO:0061462": "protein localization to lysosome",
  "GO:0061463": "O-acetyl-ADP-ribose deacetylase activity",
  "GO:0061464": "plasma membrane part of cell-substrate junction.",
  "GO:0061465": "plasma membrane part of hemidesmosome",
  "GO:0061466": "plasma membrane part of cell junction",
  "GO:0061467": "basolateral protein localization",
  "GO:0061468": "karyomere",
  "GO:0061469": "regulation of type B pancreatic cell proliferation",
  "GO:0061470": "T follicular helper cell differentiation",
  "GO:0061471": "karyomere assembly",
  "GO:0061472": "karyomere membrane fusion",
  "GO:0061473": "murein tripeptide carboxypeptidase activity",
  "GO:0061474": "phagolysosome membrane",
  "GO:0061475": "cytosolic valyl-tRNA aminoacylation",
  "GO:0061476": "response to anticoagulant",
  "GO:0061477": "response to aromatase inhibitor",
  "GO:0061478": "response to platelet aggregation inhibitor",
  "GO:0061479": "response to reverse transcriptase inhibitor",
  "GO:0061480": "response to asparaginase",
  "GO:0061481": "response to TNF agonist",
  "GO:0061482": "response to irinotecan",
  "GO:0061483": "sulfinylpropanyl adenylate synthase",
  "GO:0061484": "hematopoietic stem cell homeostasis",
  "GO:0061485": "memory T cell proliferation",
  "GO:0061486": "high-affinity fructose transmembrane transporter activity",
  "GO:0061487": "DNA replication initiation from late origin",
  "GO:0061488": "adenine import into cell",
  "GO:0061489": "guanine import into cell",
  "GO:0061490": "glucose import into cell",
  "GO:0061491": "serine import into cell",
  "GO:0061492": "asymmetric protein localization to old or new spindle pole body",
  "GO:0061493": "central plaque of mitotic spindle pole body",
  "GO:0061494": "gamma-tubulin large complex, mitotic spindle pole body",
  "GO:0061495": "gamma-tubulin small complex, mitotic spindle pole body",
  "GO:0061496": "half bridge of mitotic spindle pole body",
  "GO:0061497": "inner plaque of mitotic spindle pole body",
  "GO:0061498": "intermediate layer of mitotic spindle pole body",
  "GO:0061499": "outer plaque of mitotic spindle pole body",
  "GO:0061500": "gene conversion at mating-type locus, termination of copy-synthesis",
  "GO:0061501": "cyclic-GMP-AMP synthase activity",
  "GO:0061502": "early endosome to recycling endosome transport",
  "GO:0061503": "tRNA threonylcarbamoyladenosine dehydratase",
  "GO:0061504": "cyclic threonylcarbamoyladenosine biosynthetic process",
  "GO:0061505": "DNA topoisomerase II activity",
  "GO:0061506": "DNA topoisomerase type II (ATP-independent) activity",
  "GO:0061507": "cyclic-GMP-AMP binding",
  "GO:0061508": "CDP phosphorylation",
  "GO:0061509": "asymmetric protein localization to old mitotic spindle pole body",
  "GO:0061510": "asymmetric protein localization to new mitotic spindle pole body",
  "GO:0061511": "centriole elongation",
  "GO:0061512": "protein localization to cilium",
  "GO:0061513": "glucose 6-phosphate:inorganic phosphate antiporter activity",
  "GO:0061514": "interleukin-34-mediated signaling pathway",
  "GO:0061515": "myeloid cell development",
  "GO:0061516": "monocyte proliferation",
  "GO:0061517": "macrophage proliferation",
  "GO:0061518": "microglial cell proliferation",
  "GO:0061519": "macrophage homeostasis",
  "GO:0061520": "Langerhans cell differentiation",
  "GO:0061521": "hepatic stellate cell differentiation",
  "GO:0061522": "1,4-dihydroxy-2-naphthoyl-CoA thioesterase activity",
  "GO:0061523": "cilium disassembly",
  "GO:0061524": "central canal development",
  "GO:0061525": "hindgut development",
  "GO:0061526": "acetylcholine secretion",
  "GO:0061527": "dopamine secretion, neurotransmission",
  "GO:0061528": "aspartate secretion",
  "GO:0061529": "epinephrine secretion, neurotransmission",
  "GO:0061530": "aspartate secretion, neurotransmission",
  "GO:0061531": "primary amine secretion",
  "GO:0061532": "primary amine secretion, neurotransmission",
  "GO:0061533": "norepinephrine secretion, neurotransmission",
  "GO:0061534": "gamma-aminobutyric acid secretion, neurotransmission",
  "GO:0061535": "glutamate secretion, neurotransmission",
  "GO:0061536": "glycine secretion",
  "GO:0061537": "glycine secretion, neurotransmission",
  "GO:0061538": "histamine secretion, neurotransmission",
  "GO:0061539": "octopamine secretion",
  "GO:0061540": "octopamine secretion, neurotransmission",
  "GO:0061541": "rhabdomere morphogenesis",
  "GO:0061542": "3-demethylubiquinone-n 3-O-methyltransferase activity",
  "GO:0061543": "3-demethylubiquinone-6 3-O-methyltransferase activity",
  "GO:0061544": "peptide secretion, neurotransmission",
  "GO:0061545": "tyramine secretion",
  "GO:0061546": "tyramine secretion, neurotransmission",
  "GO:0061547": "glycogen synthase activity, transferring glucose-1-phosphate",
  "GO:0061548": "ganglion development",
  "GO:0061549": "sympathetic ganglion development",
  "GO:0061550": "cranial ganglion development",
  "GO:0061551": "trigeminal ganglion development",
  "GO:0061552": "ganglion morphogenesis",
  "GO:0061553": "ganglion maturation",
  "GO:0061554": "ganglion formation",
  "GO:0061555": "ganglion structural organization",
  "GO:0061556": "trigeminal ganglion morphogenesis",
  "GO:0061557": "trigeminal ganglion maturation",
  "GO:0061558": "cranial ganglion maturation",
  "GO:0061559": "cranial ganglion morphogenesis",
  "GO:0061560": "cranial ganglion formation",
  "GO:0061561": "trigeminal ganglion formation",
  "GO:0061562": "cranial ganglion structural organization",
  "GO:0061563": "trigeminal ganglion structural organization",
  "GO:0061564": "axon development",
  "GO:0061565": "dAMP phosphorylation",
  "GO:0061566": "CMP phosphorylation",
  "GO:0061567": "dCMP phosphorylation",
  "GO:0061568": "GDP phosphorylation",
  "GO:0061569": "UDP phosphorylation",
  "GO:0061570": "dCDP phosphorylation",
  "GO:0061571": "TDP phosphorylation",
  "GO:0061572": "actin filament bundle organization",
  "GO:0061573": "actin filament bundle retrograde transport",
  "GO:0061574": "ASAP complex",
  "GO:0061575": "cyclin-dependent protein serine/threonine kinase activator activity",
  "GO:0061576": "acyl-CoA ceramide synthase complex",
  "GO:0061577": "calcium ion transmembrane transport via high voltage-gated calcium channel",
  "GO:0061578": "Lys63-specific deubiquitinase activity",
  "GO:0061579": "N-acyl homoserine lactone synthase activity",
  "GO:0061580": "colon epithelial cell migration",
  "GO:0061581": "corneal epithelial cell migration",
  "GO:0061582": "intestinal epithelial cell migration",
  "GO:0061583": "colon epithelial cell chemotaxis",
  "GO:0061584": "hypocretin secretion",
  "GO:0061585": "hypocretin secretion, neurotransmission",
  "GO:0061586": "positive regulation of transcription by transcription factor localization",
  "GO:0061587": "transfer RNA gene-mediated silencing",
  "GO:0061588": "calcium activated phospholipid scrambling",
  "GO:0061589": "calcium activated phosphatidylserine scrambling",
  "GO:0061590": "calcium activated phosphatidylcholine scrambling",
  "GO:0061591": "calcium activated galactosylceramide scrambling",
  "GO:0061592": "phosphatidylserine exposure on osteoblast involved in bone mineralization",
  "GO:0061593": "sulfoquinovose isomerase activity",
  "GO:0061594": "6-deoxy-6-sulfofructose kinase activity",
  "GO:0061595": "6-deoxy-6-sulfofructose-1-phosphate aldolase activity",
  "GO:0061596": "3-sulfolactaldehyde reductase activity",
  "GO:0061597": "cyclic pyranopterin monophosphate synthase activity",
  "GO:0061598": "molybdopterin adenylyltransferase activity",
  "GO:0061599": "molybdopterin molybdotransferase activity",
  "GO:0061602": "molybdenum cofactor cytidylyltransferase activity",
  "GO:0061603": "molybdenum cofactor guanylyltransferase activity",
  "GO:0061604": "molybdopterin-synthase sulfurtransferase activity",
  "GO:0061605": "molybdopterin-synthase adenylyltransferase activity",
  "GO:0061606": "N-terminal protein amino acid propionylation",
  "GO:0061607": "peptide alpha-N-propionyltransferase activity",
  "GO:0061608": "nuclear import signal receptor activity",
  "GO:0061609": "fructose-1-phosphate aldolase activity",
  "GO:0061610": "glycerol to glycerone phosphate metabolic process",
  "GO:0061611": "mannose to fructose-6-phosphate metabolic process",
  "GO:0061612": "galactose to glucose-1-phosphate metabolic process",
  "GO:0061613": "glycolytic process from glycerol",
  "GO:0061614": "pri-miRNA transcription from RNA polymerase II promoter",
  "GO:0061615": "glycolytic process through fructose-6-phosphate",
  "GO:0061616": "glycolytic process from fructose through fructose-6-phosphate",
  "GO:0061617": "MICOS complex",
  "GO:0061618": "sublamina densa",
  "GO:0061619": "glycolytic process from mannose through fructose-6-phosphate",
  "GO:0061620": "glycolytic process through glucose-6-phosphate",
  "GO:0061621": "canonical glycolysis",
  "GO:0061622": "glycolytic process through glucose-1-phosphate",
  "GO:0061623": "glycolytic process from galactose",
  "GO:0061624": "fructose catabolic process to hydroxyacetone phosphate and glyceraldehyde-3-phosphate",
  "GO:0061625": "glycolytic process through fructose-1-phosphate",
  "GO:0061626": "pharyngeal arch artery morphogenesis",
  "GO:0061627": "S-methylmethionine-homocysteine S-methyltransferase activity",
  "GO:0061628": "H3K27me3 modified histone binding",
  "GO:0061629": "RNA polymerase II sequence-specific DNA binding transcription factor binding",
  "GO:0061630": "ubiquitin protein ligase activity",
  "GO:0061631": "ubiquitin conjugating enzyme activity",
  "GO:0061632": "RNA lariat debranching enzyme activator activity",
  "GO:0061633": "transport-coupled glycolytic process through glucose-6-phosphate",
  "GO:0061634": "alpha-D-xyloside xylohydrolase",
  "GO:0061635": "regulation of protein complex stability",
  "GO:0061636": "mitotic anaphase-promoting complex activator activity",
  "GO:0061637": "mitotic anaphase-promoting complex inhibitor activity",
  "GO:0061638": "CENP-A containing chromatin",
  "GO:0061639": "Cdv-dependent cytokinesis",
  "GO:0061640": "cytoskeleton-dependent cytokinesis",
  "GO:0061641": "CENP-A containing chromatin organization",
  "GO:0061642": "chemoattraction of axon",
  "GO:0061643": "chemorepulsion of axon",
  "GO:0061644": "protein localization to CENP-A containing chromatin",
  "GO:0061645": "endocytic patch",
  "GO:0061646": "positive regulation of glutamate neurotransmitter secretion in response to membrane depolarization",
  "GO:0061647": "histone H3-K9 modification",
  "GO:0061648": "tooth replacement",
  "GO:0061649": "ubiquitinated histone binding",
  "GO:0061650": "ubiquitin-like protein conjugating enzyme activity",
  "GO:0061651": "Atg12 conjugating enzyme activity",
  "GO:0061652": "FAT10 conjugating enzyme activity",
  "GO:0061653": "ISG15 conjugating enzyme activity",
  "GO:0061654": "NEDD8 conjugating enzyme activity",
  "GO:0061655": "Pup conjugating enzyme activity",
  "GO:0061656": "SUMO conjugating enzyme activity",
  "GO:0061657": "UFM1 conjugating enzyme activity",
  "GO:0061658": "URM1 conjugating enzyme activity",
  "GO:0061659": "ubiquitin-like protein ligase activity",
  "GO:0061660": "Atg12 ligase activity",
  "GO:0061661": "FAT10 ligase activity",
  "GO:0061662": "ISG15 ligase activity",
  "GO:0061663": "NEDD8 ligase activity",
  "GO:0061664": "Pup ligase activity",
  "GO:0061665": "SUMO ligase activity",
  "GO:0061666": "UFM1 ligase activity",
  "GO:0061667": "URM1 ligase activity",
  "GO:0061668": "mitochondrial ribosome assembly",
  "GO:0061669": "spontaneous neurotransmitter secretion",
  "GO:0061670": "evoked neurotransmitter secretion",
  "GO:0061671": "Cbp3p-Cbp6 complex",
  "GO:0061672": "glutathione hydrolase complex",
  "GO:0061673": "mitotic spindle astral microtubule",
  "GO:0061674": "gap filling involved in double-strand break repair via nonhomologous end joining",
  "GO:0061675": "RBL family protein binding",
  "GO:0061676": "importin-alpha family protein binding",
  "GO:0061677": "2-dehydro-3-deoxy-D-gluconate aldolase activity",
  "GO:0061678": "Entner-Doudoroff pathway",
  "GO:0061679": "Entner-Doudoroff pathway through gluconate",
  "GO:0061680": "Entner-Doudoroff pathway through gluconate to D-glyceraldehyde",
  "GO:0061681": "Entner-Doudoroff pathway through gluconate to D-glyceraldehyde-3-phosphate",
  "GO:0061682": "seminal vesicle morphogenesis",
  "GO:0061683": "branching involved in seminal vesicle morphogenesis",
  "GO:0061684": "chaperone-mediated autophagy",
  "GO:0061685": "diphthine methylesterase activity",
  "GO:0061686": "hercynylcysteine sulfoxide synthase",
  "GO:0061687": "detoxification of inorganic compound",
  "GO:0061688": "glycolytic process via Entner-Doudoroff Pathway",
  "GO:0061689": "tricellular tight junction",
  "GO:0061690": "lipoamidase activity",
  "GO:0061691": "detoxification of hydrogen peroxide",
  "GO:0061692": "cellular detoxification of hydrogen peroxide",
  "GO:0061693": "alpha-D-ribose 1-methylphosphonate 5-triphosphate synthase activity",
  "GO:0061694": "alpha-D-ribose 1-methylphosphonate 5-triphosphate synthase complex",
  "GO:0061695": "transferase complex, transferring phosphorus-containing groups",
  "GO:0061696": "pituitary gonadotropin complex",
  "GO:0061697": "protein-glutaryllysine deglutarylase activity",
  "GO:0061698": "protein deglutarylation",
  "GO:0061699": "peptidyl-lysine deglutarylation",
  "GO:0061700": "GATOR2 complex",
  "GO:0061701": "bacterial outer membrane vesicle",
  "GO:0061702": "inflammasome complex",
  "GO:0061703": "pyroptosome complex",
  "GO:0061704": "glycolytic process from sucrose",
  "GO:0061705": "sucrose catabolic process to fructose-6-phosphate through glucose and fructose",
  "GO:0061706": "glycolytic process from sucrose through glucose and fructose",
  "GO:0061707": "extracellular exosome macropinocytosis",
  "GO:0061708": "tRNA-5-taurinomethyluridine 2-sulfurtransferase",
  "GO:0061709": "reticulophagy",
  "GO:0061710": "L-threonylcarbamoyladenylate synthase",
  "GO:0061711": "N(6)-L-threonylcarbamoyladenine synthase",
  "GO:0061712": "tRNA (N(6)-L-threonylcarbamoyladenosine(37)-C(2))-methylthiotransferase",
  "GO:0061713": "anterior neural tube closure",
  "GO:0061714": "folic acid receptor activity",
  "GO:0061715": "miRNA 2'-O-methylation",
  "GO:0061716": "miRNA export from nucleus",
  "GO:0061717": "miRNA transporter activity",
  "GO:0061718": "glucose catabolic process to pyruvate",
  "GO:0061719": "glucose catabolic process to pyruvate utilizing ADP",
  "GO:0061720": "6-sulfoquinovose(1-) catabolic process to glycerone phosphate and 3-sulfolactaldehyde",
  "GO:0061721": "6-sulfoquinovose(1-) catabolic process to 3-sulfopropanediol(1-)",
  "GO:0061722": "sulphoglycolysis",
  "GO:0061723": "glycophagy",
  "GO:0061724": "lipophagy",
  "GO:0061725": "cytosolic lipolysis",
  "GO:0061726": "mitochondrion disassembly",
  "GO:0061727": "methylglyoxal catabolic process to lactate",
  "GO:0061728": "GDP-mannose biosynthetic process from mannose",
  "GO:0061729": "GDP-mannose biosynthetic process from fructose-6-phosphate",
  "GO:0061730": "C-rich strand telomeric DNA binding",
  "GO:0061731": "ribonucleoside-diphosphate reductase activity",
  "GO:0061732": "mitochondrial acetyl-CoA biosynthetic process from pyruvate",
  "GO:0061733": "peptide-lysine-N-acetyltransferase activity",
  "GO:0061734": "parkin-mediated mitophagy in response to mitochondrial depolarization",
  "GO:0061735": "dynamin-like protein-mediated mitophagy in response to mitochondrial depolarization",
  "GO:0061736": "engulfment of target by autophagosome",
  "GO:0061737": "leukotriene signaling pathway",
  "GO:0061738": "late endosomal microautophagy",
  "GO:0061739": "protein lipidation involved in autophagosome assembly",
  "GO:0061740": "protein targeting to lysosome involved in chaperone-mediated autophagy",
  "GO:0061741": "chaperone-mediated protein transport involved in chaperone-mediated autophagy",
  "GO:0061742": "chaperone-mediated autophagy translocation complex",
  "GO:0061743": "motor learning",
  "GO:0061744": "motor behavior",
  "GO:0061745": "GTPase activity, coupled",
  "GO:0061746": "single-stranded DNA-dependent GTPase activity",
  "GO:0061747": "CTPase activity, coupled",
  "GO:0061748": "single-stranded DNA-dependent CTPase activity",
  "GO:0061749": "forked DNA-dependent helicase activity",
  "GO:0061750": "acid sphingomyelin phosphodiesterase activity",
  "GO:0061751": "neutral sphingomyelin phosphodiesterase activity",
  "GO:0061752": "telomeric repeat-containing RNA binding",
  "GO:0061753": "substrate localization to autophagosome",
  "GO:0061754": "negative regulation of circulating fibrinogen levels",
  "GO:0061755": "positive regulation of circulating fibrinogen levels",
  "GO:0061756": "leukocyte adhesion to vascular endothelial cell",
  "GO:0061757": "leukocyte adhesion to arterial endothelial cell",
  "GO:0061758": "2-hydroxyglutarate dehydrogenase activity, forward reaction",
  "GO:0061759": "alpha-ketoglutarate reductase activity",
  "GO:0061760": "antifungal innate immune response",
  "GO:0061761": "alpha-latrotoxin receptor binding",
  "GO:0065001": "specification of axis polarity",
  "GO:0065002": "intracellular protein transmembrane transport",
  "GO:0065003": "macromolecular complex assembly",
  "GO:0065004": "protein-DNA complex assembly",
  "GO:0065005": "protein-lipid complex assembly",
  "GO:0065006": "protein-carbohydrate complex assembly",
  "GO:0065007": "biological regulation",
  "GO:0065008": "regulation of biological quality",
  "GO:0065009": "regulation of molecular function",
  "GO:0065010": "extracellular membrane-bounded organelle",
  "GO:0070001": "aspartic-type peptidase activity",
  "GO:0070002": "glutamic-type peptidase activity",
  "GO:0070003": "threonine-type peptidase activity",
  "GO:0070004": "cysteine-type exopeptidase activity",
  "GO:0070005": "cysteine-type aminopeptidase activity",
  "GO:0070006": "metalloaminopeptidase activity",
  "GO:0070007": "glutamic-type endopeptidase activity",
  "GO:0070008": "serine-type exopeptidase activity",
  "GO:0070009": "serine-type aminopeptidase activity",
  "GO:0070010": "peptidase activity, acting on D-amino acid peptides",
  "GO:0070011": "peptidase activity, acting on L-amino acid peptides",
  "GO:0070012": "oligopeptidase activity",
  "GO:0070013": "intracellular organelle lumen",
  "GO:0070014": "sucrase-isomaltase complex",
  "GO:0070016": "armadillo repeat domain binding",
  "GO:0070017": "alphav-beta3 integrin-thrombospondin complex",
  "GO:0070018": "transforming growth factor beta type I receptor homodimeric complex",
  "GO:0070019": "transforming growth factor beta type II receptor homodimeric complex",
  "GO:0070020": "transforming growth factor beta1-type II receptor complex",
  "GO:0070021": "transforming growth factor beta1-type II receptor-type I receptor complex",
  "GO:0070022": "transforming growth factor beta receptor homodimeric complex",
  "GO:0070023": "interleukin-12-interleukin-12 receptor complex",
  "GO:0070024": "CD19-Vav-PIK3R1 complex",
  "GO:0070025": "carbon monoxide binding",
  "GO:0070026": "nitric oxide binding",
  "GO:0070027": "carbon monoxide sensor activity",
  "GO:0070028": "regulation of transcription by carbon monoxide",
  "GO:0070029": "alphav-beta3 integrin-osteopontin complex",
  "GO:0070030": "alphav-beta1 integrin-osteopontin complex",
  "GO:0070031": "alphav-beta5 integrin-osteopontin complex",
  "GO:0070032": "synaptobrevin 2-SNAP-25-syntaxin-1a-complexin I complex",
  "GO:0070033": "synaptobrevin 2-SNAP-25-syntaxin-1a-complexin II complex",
  "GO:0070034": "telomerase RNA binding",
  "GO:0070035": "purine NTP-dependent helicase activity",
  "GO:0070036": "GTP-dependent helicase activity",
  "GO:0070037": "rRNA (pseudouridine) methyltransferase activity",
  "GO:0070038": "rRNA (pseudouridine-N3-)-methyltransferase activity",
  "GO:0070039": "rRNA (guanosine-2'-O-)-methyltransferase activity",
  "GO:0070040": "rRNA (adenine-C2-)-methyltransferase activity",
  "GO:0070041": "rRNA (uridine-C5-)-methyltransferase activity",
  "GO:0070042": "rRNA (uridine-N3-)-methyltransferase activity",
  "GO:0070043": "rRNA (guanine-N7-)-methyltransferase activity",
  "GO:0070044": "synaptobrevin 2-SNAP-25-syntaxin-1a complex",
  "GO:0070045": "synaptobrevin 2-SNAP-25-syntaxin-2 complex",
  "GO:0070046": "synaptobrevin 2-SNAP-25-syntaxin-3 complex",
  "GO:0070047": "synaptobrevin 2-SNAP-25-syntaxin-4 complex",
  "GO:0070048": "endobrevin-SNAP-25-syntaxin-1a complex",
  "GO:0070049": "endobrevin-SNAP-25-syntaxin-2 complex",
  "GO:0070050": "neuron cellular homeostasis",
  "GO:0070051": "fibrinogen binding",
  "GO:0070052": "collagen V binding",
  "GO:0070053": "thrombospondin receptor activity",
  "GO:0070054": "mRNA splicing, via endonucleolytic cleavage and ligation",
  "GO:0070055": "mRNA endonucleolytic cleavage involved in unfolded protein response",
  "GO:0070056": "prospore membrane leading edge",
  "GO:0070057": "prospore membrane spindle pole body attachment site",
  "GO:0070058": "tRNA gene clustering",
  "GO:0070059": "intrinsic apoptotic signaling pathway in response to endoplasmic reticulum stress",
  "GO:0070060": "'de novo' actin filament nucleation",
  "GO:0070061": "fructose binding",
  "GO:0070062": "extracellular exosome",
  "GO:0070063": "RNA polymerase binding",
  "GO:0070064": "proline-rich region binding",
  "GO:0070065": "cellubrevin-VAMP4-syntaxin-16 complex",
  "GO:0070066": "cellubrevin-VAMP4-endobrevin-syntaxin-6 complex",
  "GO:0070067": "syntaxin-6-syntaxin-16-Vti1a complex",
  "GO:0070068": "VAMP4-syntaxin-6-syntaxin-16-Vti1a complex",
  "GO:0070069": "cytochrome complex",
  "GO:0070070": "proton-transporting V-type ATPase complex assembly",
  "GO:0070071": "proton-transporting two-sector ATPase complex assembly",
  "GO:0070072": "vacuolar proton-transporting V-type ATPase complex assembly",
  "GO:0070073": "clustering of voltage-gated calcium channels",
  "GO:0070074": "mononeme",
  "GO:0070075": "tear secretion",
  "GO:0070076": "histone lysine demethylation",
  "GO:0070077": "histone arginine demethylation",
  "GO:0070078": "histone H3-R2 demethylation",
  "GO:0070079": "histone H4-R3 demethylation",
  "GO:0070080": "titin Z domain binding",
  "GO:0070081": "clathrin-sculpted monoamine transport vesicle",
  "GO:0070082": "clathrin-sculpted monoamine transport vesicle lumen",
  "GO:0070083": "clathrin-sculpted monoamine transport vesicle membrane",
  "GO:0070084": "protein initiator methionine removal",
  "GO:0070085": "glycosylation",
  "GO:0070086": "ubiquitin-dependent endocytosis",
  "GO:0070087": "chromo shadow domain binding",
  "GO:0070088": "PHA granule",
  "GO:0070089": "chloride-activated potassium channel activity",
  "GO:0070090": "metaphase plate",
  "GO:0070091": "glucagon secretion",
  "GO:0070092": "regulation of glucagon secretion",
  "GO:0070093": "negative regulation of glucagon secretion",
  "GO:0070094": "positive regulation of glucagon secretion",
  "GO:0070095": "fructose-6-phosphate binding",
  "GO:0070096": "mitochondrial outer membrane translocase complex assembly",
  "GO:0070097": "delta-catenin binding",
  "GO:0070098": "chemokine-mediated signaling pathway",
  "GO:0070099": "regulation of chemokine-mediated signaling pathway",
  "GO:0070100": "negative regulation of chemokine-mediated signaling pathway",
  "GO:0070101": "positive regulation of chemokine-mediated signaling pathway",
  "GO:0070102": "interleukin-6-mediated signaling pathway",
  "GO:0070103": "regulation of interleukin-6-mediated signaling pathway",
  "GO:0070104": "negative regulation of interleukin-6-mediated signaling pathway",
  "GO:0070105": "positive regulation of interleukin-6-mediated signaling pathway",
  "GO:0070106": "interleukin-27-mediated signaling pathway",
  "GO:0070107": "regulation of interleukin-27-mediated signaling pathway",
  "GO:0070108": "negative regulation of interleukin-27-mediated signaling pathway",
  "GO:0070109": "positive regulation of interleukin-27-mediated signaling pathway",
  "GO:0070110": "ciliary neurotrophic factor receptor complex",
  "GO:0070111": "organellar chromatophore",
  "GO:0070112": "organellar chromatophore membrane",
  "GO:0070113": "organellar chromatophore inner membrane",
  "GO:0070114": "organellar chromatophore outer membrane",
  "GO:0070115": "organellar chromatophore intermembrane space",
  "GO:0070116": "organellar chromatophore thylakoid",
  "GO:0070117": "organellar chromatophore thylakoid lumen",
  "GO:0070118": "organellar chromatophore thylakoid membrane",
  "GO:0070119": "ciliary neurotrophic factor binding",
  "GO:0070120": "ciliary neurotrophic factor-mediated signaling pathway",
  "GO:0070121": "Kupffer's vesicle development",
  "GO:0070122": "isopeptidase activity",
  "GO:0070123": "transforming growth factor beta receptor activity, type III",
  "GO:0070124": "mitochondrial translational initiation",
  "GO:0070125": "mitochondrial translational elongation",
  "GO:0070126": "mitochondrial translational termination",
  "GO:0070127": "tRNA aminoacylation for mitochondrial protein translation",
  "GO:0070129": "regulation of mitochondrial translation",
  "GO:0070130": "negative regulation of mitochondrial translation",
  "GO:0070131": "positive regulation of mitochondrial translation",
  "GO:0070132": "regulation of mitochondrial translational initiation",
  "GO:0070133": "negative regulation of mitochondrial translational initiation",
  "GO:0070134": "positive regulation of mitochondrial translational initiation",
  "GO:0070135": "beta-1,2-oligomannoside metabolic process",
  "GO:0070136": "beta-1,2-oligomannoside biosynthetic process",
  "GO:0070137": "ubiquitin-like protein-specific endopeptidase activity",
  "GO:0070138": "ubiquitin-like protein-specific isopeptidase activity",
  "GO:0070139": "SUMO-specific endopeptidase activity",
  "GO:0070140": "SUMO-specific isopeptidase activity",
  "GO:0070141": "response to UV-A",
  "GO:0070142": "synaptic vesicle budding",
  "GO:0070143": "mitochondrial alanyl-tRNA aminoacylation",
  "GO:0070144": "mitochondrial arginyl-tRNA aminoacylation",
  "GO:0070145": "mitochondrial asparaginyl-tRNA aminoacylation",
  "GO:0070146": "mitochondrial aspartyl-tRNA aminoacylation",
  "GO:0070147": "mitochondrial cysteinyl-tRNA aminoacylation",
  "GO:0070148": "mitochondrial glutaminyl-tRNA aminoacylation",
  "GO:0070149": "mitochondrial glutamyl-tRNA aminoacylation",
  "GO:0070150": "mitochondrial glycyl-tRNA aminoacylation",
  "GO:0070151": "mitochondrial histidyl-tRNA aminoacylation",
  "GO:0070152": "mitochondrial isoleucyl-tRNA aminoacylation",
  "GO:0070153": "mitochondrial leucyl-tRNA aminoacylation",
  "GO:0070154": "mitochondrial lysyl-tRNA aminoacylation",
  "GO:0070155": "mitochondrial methionyl-tRNA aminoacylation",
  "GO:0070156": "mitochondrial phenylalanyl-tRNA aminoacylation",
  "GO:0070157": "mitochondrial prolyl-tRNA aminoacylation",
  "GO:0070158": "mitochondrial seryl-tRNA aminoacylation",
  "GO:0070159": "mitochondrial threonyl-tRNA aminoacylation",
  "GO:0070160": "occluding junction",
  "GO:0070161": "anchoring junction",
  "GO:0070162": "adiponectin secretion",
  "GO:0070163": "regulation of adiponectin secretion",
  "GO:0070164": "negative regulation of adiponectin secretion",
  "GO:0070165": "positive regulation of adiponectin secretion",
  "GO:0070166": "enamel mineralization",
  "GO:0070167": "regulation of biomineral tissue development",
  "GO:0070168": "negative regulation of biomineral tissue development",
  "GO:0070169": "positive regulation of biomineral tissue development",
  "GO:0070170": "regulation of tooth mineralization",
  "GO:0070171": "negative regulation of tooth mineralization",
  "GO:0070172": "positive regulation of tooth mineralization",
  "GO:0070173": "regulation of enamel mineralization",
  "GO:0070174": "negative regulation of enamel mineralization",
  "GO:0070175": "positive regulation of enamel mineralization",
  "GO:0070176": "DRM complex",
  "GO:0070177": "contractile vacuole discharge",
  "GO:0070178": "D-serine metabolic process",
  "GO:0070179": "D-serine biosynthetic process",
  "GO:0070180": "large ribosomal subunit rRNA binding",
  "GO:0070181": "small ribosomal subunit rRNA binding",
  "GO:0070182": "DNA polymerase binding",
  "GO:0070183": "mitochondrial tryptophanyl-tRNA aminoacylation",
  "GO:0070184": "mitochondrial tyrosyl-tRNA aminoacylation",
  "GO:0070185": "mitochondrial valyl-tRNA aminoacylation",
  "GO:0070186": "growth hormone activity",
  "GO:0070187": "telosome",
  "GO:0070188": "obsolete Stn1-Ten1 complex",
  "GO:0070189": "kynurenine metabolic process",
  "GO:0070190": "obsolete inositol hexakisphosphate 1-kinase or 3-kinase activity",
  "GO:0070191": "methionine-R-sulfoxide reductase activity",
  "GO:0070192": "chromosome organization involved in meiotic cell cycle",
  "GO:0070193": "synaptonemal complex organization",
  "GO:0070194": "synaptonemal complex disassembly",
  "GO:0070195": "growth hormone receptor complex",
  "GO:0070196": "eukaryotic translation initiation factor 3 complex assembly",
  "GO:0070197": "meiotic attachment of telomere to nuclear envelope",
  "GO:0070198": "protein localization to chromosome, telomeric region",
  "GO:0070199": "establishment of protein localization to chromosome",
  "GO:0070200": "establishment of protein localization to telomere",
  "GO:0070201": "regulation of establishment of protein localization",
  "GO:0070202": "regulation of establishment of protein localization to chromosome",
  "GO:0070203": "regulation of establishment of protein localization to telomere",
  "GO:0070204": "2-succinyl-5-enolpyruvyl-6-hydroxy-3-cyclohexene-1-carboxylic-acid synthase activity",
  "GO:0070205": "2-succinyl-6-hydroxy-2,4-cyclohexadiene-1-carboxylate synthase activity",
  "GO:0070206": "protein trimerization",
  "GO:0070207": "protein homotrimerization",
  "GO:0070208": "protein heterotrimerization",
  "GO:0070209": "ASTRA complex",
  "GO:0070210": "Rpd3L-Expanded complex",
  "GO:0070211": "Snt2C complex",
  "GO:0070212": "protein poly-ADP-ribosylation",
  "GO:0070213": "protein auto-ADP-ribosylation",
  "GO:0070214": "CSK-GAP-A.p62 complex",
  "GO:0070215": "obsolete MDM2 binding",
  "GO:0070216": "obsolete MDM4 binding",
  "GO:0070217": "transcription factor TFIIIB complex assembly",
  "GO:0070218": "sulfide ion homeostasis",
  "GO:0070219": "cellular sulfide ion homeostasis",
  "GO:0070220": "aerobic sulfur oxidation",
  "GO:0070221": "sulfide oxidation, using sulfide:quinone oxidoreductase",
  "GO:0070222": "sulfide oxidation, using sulfide dehydrogenase",
  "GO:0070223": "sulfide oxidation, using sulfur dioxygenase",
  "GO:0070224": "sulfide:quinone oxidoreductase activity",
  "GO:0070225": "sulfide dehydrogenase activity",
  "GO:0070226": "sulfur:ferric ion oxidoreductase activity",
  "GO:0070227": "lymphocyte apoptotic process",
  "GO:0070228": "regulation of lymphocyte apoptotic process",
  "GO:0070229": "negative regulation of lymphocyte apoptotic process",
  "GO:0070230": "positive regulation of lymphocyte apoptotic process",
  "GO:0070231": "T cell apoptotic process",
  "GO:0070232": "regulation of T cell apoptotic process",
  "GO:0070233": "negative regulation of T cell apoptotic process",
  "GO:0070234": "positive regulation of T cell apoptotic process",
  "GO:0070235": "regulation of activation-induced cell death of T cells",
  "GO:0070236": "negative regulation of activation-induced cell death of T cells",
  "GO:0070237": "positive regulation of activation-induced cell death of T cells",
  "GO:0070238": "activated T cell autonomous cell death",
  "GO:0070239": "regulation of activated T cell autonomous cell death",
  "GO:0070240": "negative regulation of activated T cell autonomous cell death",
  "GO:0070241": "positive regulation of activated T cell autonomous cell death",
  "GO:0070242": "thymocyte apoptotic process",
  "GO:0070243": "regulation of thymocyte apoptotic process",
  "GO:0070244": "negative regulation of thymocyte apoptotic process",
  "GO:0070245": "positive regulation of thymocyte apoptotic process",
  "GO:0070246": "natural killer cell apoptotic process",
  "GO:0070247": "regulation of natural killer cell apoptotic process",
  "GO:0070248": "negative regulation of natural killer cell apoptotic process",
  "GO:0070249": "positive regulation of natural killer cell apoptotic process",
  "GO:0070250": "mating projection membrane",
  "GO:0070251": "pristanate-CoA ligase activity",
  "GO:0070252": "actin-mediated cell contraction",
  "GO:0070253": "somatostatin secretion",
  "GO:0070254": "mucus secretion",
  "GO:0070255": "regulation of mucus secretion",
  "GO:0070256": "negative regulation of mucus secretion",
  "GO:0070257": "positive regulation of mucus secretion",
  "GO:0070258": "inner membrane complex",
  "GO:0070259": "tyrosyl-DNA phosphodiesterase activity",
  "GO:0070260": "5'-tyrosyl-DNA phosphodiesterase activity",
  "GO:0070262": "peptidyl-serine dephosphorylation",
  "GO:0070263": "external side of fungal-type cell wall",
  "GO:0070264": "transcription factor TFIIIE complex",
  "GO:0070265": "necrotic cell death",
  "GO:0070266": "necroptotic process",
  "GO:0070267": "oncosis",
  "GO:0070268": "cornification",
  "GO:0070269": "pyroptosis",
  "GO:0070270": "obsolete mitotic catastrophe",
  "GO:0070271": "protein complex biogenesis",
  "GO:0070272": "proton-transporting ATP synthase complex biogenesis",
  "GO:0070273": "phosphatidylinositol-4-phosphate binding",
  "GO:0070274": "RES complex",
  "GO:0070275": "aerobic ammonia oxidation to nitrite via pyruvic oxime",
  "GO:0070276": "halogen metabolic process",
  "GO:0070277": "iodide oxidation",
  "GO:0070278": "extracellular matrix constituent secretion",
  "GO:0070279": "vitamin B6 binding",
  "GO:0070280": "pyridoxal binding",
  "GO:0070281": "pyridoxamine binding",
  "GO:0070282": "pyridoxine binding",
  "GO:0070283": "radical SAM enzyme activity",
  "GO:0070284": "4-amino-5-hydroxymethyl-2-methylpyrimidine phosphate synthase activity",
  "GO:0070285": "pigment cell development",
  "GO:0070286": "axonemal dynein complex assembly",
  "GO:0070287": "ferritin receptor activity",
  "GO:0070288": "ferritin complex",
  "GO:0070289": "extracellular ferritin complex",
  "GO:0070290": "N-acylphosphatidylethanolamine-specific phospholipase D activity",
  "GO:0070291": "N-acylethanolamine metabolic process",
  "GO:0070292": "N-acylphosphatidylethanolamine metabolic process",
  "GO:0070293": "renal absorption",
  "GO:0070294": "renal sodium ion absorption",
  "GO:0070295": "renal water absorption",
  "GO:0070296": "sarcoplasmic reticulum calcium ion transport",
  "GO:0070297": "regulation of phosphorelay signal transduction system",
  "GO:0070298": "negative regulation of phosphorelay signal transduction system",
  "GO:0070299": "positive regulation of phosphorelay signal transduction system",
  "GO:0070300": "phosphatidic acid binding",
  "GO:0070301": "cellular response to hydrogen peroxide",
  "GO:0070302": "regulation of stress-activated protein kinase signaling cascade",
  "GO:0070303": "negative regulation of stress-activated protein kinase signaling cascade",
  "GO:0070304": "positive regulation of stress-activated protein kinase signaling cascade",
  "GO:0070305": "response to cGMP",
  "GO:0070306": "lens fiber cell differentiation",
  "GO:0070307": "lens fiber cell development",
  "GO:0070308": "lens fiber cell fate commitment",
  "GO:0070309": "lens fiber cell morphogenesis",
  "GO:0070310": "ATR-ATRIP complex",
  "GO:0070311": "nucleosomal methylation activator complex",
  "GO:0070312": "RAD52-ERCC4-ERCC1 complex",
  "GO:0070313": "RGS6-DNMT1-DMAP1 complex",
  "GO:0070314": "G1 to G0 transition",
  "GO:0070315": "G1 to G0 transition involved in cell differentiation",
  "GO:0070316": "regulation of G0 to G1 transition",
  "GO:0070317": "negative regulation of G0 to G1 transition",
  "GO:0070318": "positive regulation of G0 to G1 transition",
  "GO:0070319": "Golgi to plasma membrane transport vesicle",
  "GO:0070320": "inward rectifier potassium channel inhibitor activity",
  "GO:0070321": "regulation of translation in response to nitrogen starvation",
  "GO:0070322": "negative regulation of translation in response to nitrogen starvation",
  "GO:0070323": "positive regulation of translation in response to nitrogen starvation",
  "GO:0070324": "thyroid hormone binding",
  "GO:0070325": "lipoprotein particle receptor binding",
  "GO:0070326": "very-low-density lipoprotein particle receptor binding",
  "GO:0070327": "thyroid hormone transport",
  "GO:0070328": "triglyceride homeostasis",
  "GO:0070329": "tRNA seleno-modification",
  "GO:0070330": "aromatase activity",
  "GO:0070331": "CD20-Lck-Fyn complex",
  "GO:0070332": "CD20-Lck-Lyn-Fyn complex",
  "GO:0070333": "alpha6-beta4 integrin-Shc-Grb2 complex",
  "GO:0070334": "alpha6-beta4 integrin-laminin 5 complex",
  "GO:0070335": "aspartate binding",
  "GO:0070336": "flap-structured DNA binding",
  "GO:0070337": "3'-flap-structured DNA binding",
  "GO:0070338": "5'-flap-structured DNA binding",
  "GO:0070339": "response to bacterial lipopeptide",
  "GO:0070340": "detection of bacterial lipopeptide",
  "GO:0070341": "fat cell proliferation",
  "GO:0070342": "brown fat cell proliferation",
  "GO:0070343": "white fat cell proliferation",
  "GO:0070344": "regulation of fat cell proliferation",
  "GO:0070345": "negative regulation of fat cell proliferation",
  "GO:0070346": "positive regulation of fat cell proliferation",
  "GO:0070347": "regulation of brown fat cell proliferation",
  "GO:0070348": "negative regulation of brown fat cell proliferation",
  "GO:0070349": "positive regulation of brown fat cell proliferation",
  "GO:0070350": "regulation of white fat cell proliferation",
  "GO:0070351": "negative regulation of white fat cell proliferation",
  "GO:0070352": "positive regulation of white fat cell proliferation",
  "GO:0070353": "GATA1-TAL1-TCF3-Lmo2 complex",
  "GO:0070354": "GATA2-TAL1-TCF3-Lmo2 complex",
  "GO:0070355": "synaptotagmin-synaptobrevin 2-SNAP-25-syntaxin-1a-syntaxin-1b-Rab3a-complexin II complex",
  "GO:0070356": "synaptotagmin-synaptobrevin 2-SNAP-25-syntaxin-1a-syntaxin-1b-Rab3a complex",
  "GO:0070357": "alphav-beta3 integrin-CD47 complex",
  "GO:0070358": "actin polymerization-dependent cell motility",
  "GO:0070359": "actin polymerization-dependent cell motility involved in migration of symbiont in host",
  "GO:0070360": "migration of symbiont within host by polymerization of host actin",
  "GO:0070361": "mitochondrial light strand promoter anti-sense binding",
  "GO:0070362": "mitochondrial heavy strand promoter anti-sense binding",
  "GO:0070363": "mitochondrial light strand promoter sense binding",
  "GO:0070364": "mitochondrial heavy strand promoter sense binding",
  "GO:0070365": "hepatocyte differentiation",
  "GO:0070366": "regulation of hepatocyte differentiation",
  "GO:0070367": "negative regulation of hepatocyte differentiation",
  "GO:0070368": "positive regulation of hepatocyte differentiation",
  "GO:0070369": "beta-catenin-TCF7L2 complex",
  "GO:0070370": "cellular heat acclimation",
  "GO:0070371": "ERK1 and ERK2 cascade",
  "GO:0070372": "regulation of ERK1 and ERK2 cascade",
  "GO:0070373": "negative regulation of ERK1 and ERK2 cascade",
  "GO:0070374": "positive regulation of ERK1 and ERK2 cascade",
  "GO:0070375": "ERK5 cascade",
  "GO:0070376": "regulation of ERK5 cascade",
  "GO:0070377": "negative regulation of ERK5 cascade",
  "GO:0070378": "positive regulation of ERK5 cascade",
  "GO:0070379": "high mobility group box 1 binding",
  "GO:0070380": "high mobility group box 1 receptor activity",
  "GO:0070381": "endosome to plasma membrane transport vesicle",
  "GO:0070382": "exocytic vesicle",
  "GO:0070383": "DNA cytosine deamination",
  "GO:0070384": "Harderian gland development",
  "GO:0070385": "egasyn-beta-glucuronidase complex",
  "GO:0070386": "procollagen-proline 4-dioxygenase complex, alpha(I) type",
  "GO:0070387": "procollagen-proline 4-dioxygenase complex, alpha(II) type",
  "GO:0070388": "procollagen-proline 4-dioxygenase complex, alpha(III) type",
  "GO:0070389": "chaperone cofactor-dependent protein refolding",
  "GO:0070390": "transcription export complex 2",
  "GO:0070391": "response to lipoteichoic acid",
  "GO:0070392": "detection of lipoteichoic acid",
  "GO:0070393": "teichoic acid catabolic process",
  "GO:0070394": "lipoteichoic acid metabolic process",
  "GO:0070395": "lipoteichoic acid biosynthetic process",
  "GO:0070396": "lipoteichoic acid catabolic process",
  "GO:0070397": "wall teichoic acid metabolic process",
  "GO:0070398": "wall teichoic acid biosynthetic process",
  "GO:0070399": "wall teichoic acid catabolic process",
  "GO:0070400": "teichoic acid D-alanylation",
  "GO:0070401": "NADP+ binding",
  "GO:0070402": "NADPH binding",
  "GO:0070403": "NAD+ binding",
  "GO:0070404": "NADH binding",
  "GO:0070405": "ammonium ion binding",
  "GO:0070406": "glutamine binding",
  "GO:0070407": "oxidation-dependent protein catabolic process",
  "GO:0070408": "carbamoyl phosphate metabolic process",
  "GO:0070409": "carbamoyl phosphate biosynthetic process",
  "GO:0070410": "co-SMAD binding",
  "GO:0070411": "I-SMAD binding",
  "GO:0070412": "R-SMAD binding",
  "GO:0070413": "trehalose metabolism in response to stress",
  "GO:0070414": "trehalose metabolism in response to heat stress",
  "GO:0070415": "trehalose metabolism in response to cold stress",
  "GO:0070416": "trehalose metabolism in response to water deprivation",
  "GO:0070417": "cellular response to cold",
  "GO:0070418": "DNA-dependent protein kinase complex",
  "GO:0070419": "nonhomologous end joining complex",
  "GO:0070420": "Ku-DNA ligase complex",
  "GO:0070421": "DNA ligase III-XRCC1 complex",
  "GO:0070422": "G-protein beta/gamma-Raf-1 complex",
  "GO:0070423": "nucleotide-binding oligomerization domain containing signaling pathway",
  "GO:0070424": "regulation of nucleotide-binding oligomerization domain containing signaling pathway",
  "GO:0070425": "negative regulation of nucleotide-binding oligomerization domain containing signaling pathway",
  "GO:0070426": "positive regulation of nucleotide-binding oligomerization domain containing signaling pathway",
  "GO:0070427": "nucleotide-binding oligomerization domain containing 1 signaling pathway",
  "GO:0070428": "regulation of nucleotide-binding oligomerization domain containing 1 signaling pathway",
  "GO:0070429": "negative regulation of nucleotide-binding oligomerization domain containing 1 signaling pathway",
  "GO:0070430": "positive regulation of nucleotide-binding oligomerization domain containing 1 signaling pathway",
  "GO:0070431": "nucleotide-binding oligomerization domain containing 2 signaling pathway",
  "GO:0070432": "regulation of nucleotide-binding oligomerization domain containing 2 signaling pathway",
  "GO:0070433": "negative regulation of nucleotide-binding oligomerization domain containing 2 signaling pathway",
  "GO:0070434": "positive regulation of nucleotide-binding oligomerization domain containing 2 signaling pathway",
  "GO:0070435": "Shc-EGFR complex",
  "GO:0070436": "Grb2-EGFR complex",
  "GO:0070437": "Grb2-Shc complex",
  "GO:0070438": "obsolete mTOR-FKBP12-rapamycin complex",
  "GO:0070439": "Mad-Max-mSin3A complex",
  "GO:0070440": "Mad-Max-mSin3B complex",
  "GO:0070441": "G-protein beta/gamma-Btk complex",
  "GO:0070442": "integrin alphaIIb-beta3 complex",
  "GO:0070443": "Mad-Max complex",
  "GO:0070444": "oligodendrocyte progenitor proliferation",
  "GO:0070445": "regulation of oligodendrocyte progenitor proliferation",
  "GO:0070446": "negative regulation of oligodendrocyte progenitor proliferation",
  "GO:0070447": "positive regulation of oligodendrocyte progenitor proliferation",
  "GO:0070448": "laricitrin 5'-O-methyltransferase activity",
  "GO:0070449": "elongin complex",
  "GO:0070450": "interleukin4-interleukin-4 receptor complex",
  "GO:0070451": "cell hair",
  "GO:0070452": "positive regulation of ergosterol biosynthetic process",
  "GO:0070453": "regulation of heme biosynthetic process",
  "GO:0070454": "negative regulation of heme biosynthetic process",
  "GO:0070455": "positive regulation of heme biosynthetic process",
  "GO:0070456": "galactose-1-phosphate phosphatase activity",
  "GO:0070457": "D-galactose-1-phosphate phosphatase activity",
  "GO:0070458": "cellular detoxification of nitrogen compound",
  "GO:0070459": "prolactin secretion",
  "GO:0070460": "thyroid-stimulating hormone secretion",
  "GO:0070461": "SAGA-type complex",
  "GO:0070462": "plus-end specific microtubule depolymerization",
  "GO:0070463": "tubulin-dependent ATPase activity",
  "GO:0070464": "alphav-beta3 integrin-collagen alpha3(VI) complex",
  "GO:0070465": "alpha1-beta1 integrin-alpha3(VI) complex",
  "GO:0070466": "alpha2-beta1 integrin-alpha3(VI) complex",
  "GO:0070467": "RC-1 DNA recombination complex",
  "GO:0070468": "dentin secretion",
  "GO:0070469": "respiratory chain",
  "GO:0070470": "plasma membrane respiratory chain",
  "GO:0070471": "uterine smooth muscle contraction",
  "GO:0070472": "regulation of uterine smooth muscle contraction",
  "GO:0070473": "negative regulation of uterine smooth muscle contraction",
  "GO:0070474": "positive regulation of uterine smooth muscle contraction",
  "GO:0070475": "rRNA base methylation",
  "GO:0070476": "rRNA (guanine-N7)-methylation",
  "GO:0070477": "endospore core",
  "GO:0070478": "nuclear-transcribed mRNA catabolic process, 3'-5' exonucleolytic nonsense-mediated decay",
  "GO:0070479": "nuclear-transcribed mRNA catabolic process, 5'-3' exonucleolytic nonsense-mediated decay",
  "GO:0070480": "exonucleolytic nuclear-transcribed mRNA catabolic process involved in deadenylation-independent decay",
  "GO:0070481": "nuclear-transcribed mRNA catabolic process, non-stop decay",
  "GO:0070482": "response to oxygen levels",
  "GO:0070483": "detection of hypoxia",
  "GO:0070484": "dehydro-D-arabinono-1,4-lactone metabolic process",
  "GO:0070485": "dehydro-D-arabinono-1,4-lactone biosynthetic process",
  "GO:0070486": "leukocyte aggregation",
  "GO:0070487": "monocyte aggregation",
  "GO:0070488": "neutrophil aggregation",
  "GO:0070489": "T cell aggregation",
  "GO:0070490": "protein pupylation",
  "GO:0070491": "repressing transcription factor binding",
  "GO:0070492": "oligosaccharide binding",
  "GO:0070493": "thrombin receptor signaling pathway",
  "GO:0070494": "regulation of thrombin receptor signaling pathway",
  "GO:0070495": "negative regulation of thrombin receptor signaling pathway",
  "GO:0070496": "positive regulation of thrombin receptor signaling pathway",
  "GO:0070497": "6-carboxy-5,6,7,8-tetrahydropterin synthase activity",
  "GO:0070498": "interleukin-1-mediated signaling pathway",
  "GO:0070499": "exosporium assembly",
  "GO:0070500": "poly-gamma-glutamate metabolic process",
  "GO:0070501": "poly-gamma-glutamate biosynthetic process",
  "GO:0070502": "capsule poly-gamma-glutamate biosynthetic process",
  "GO:0070503": "selenium-containing prosthetic group metabolic process",
  "GO:0070504": "selenium-containing prosthetic group biosynthetic process",
  "GO:0070505": "pollen coat",
  "GO:0070506": "high-density lipoprotein particle receptor activity",
  "GO:0070507": "regulation of microtubule cytoskeleton organization",
  "GO:0070508": "cholesterol import",
  "GO:0070509": "calcium ion import",
  "GO:0070510": "regulation of histone H4-K20 methylation",
  "GO:0070511": "negative regulation of histone H4-K20 methylation",
  "GO:0070512": "positive regulation of histone H4-K20 methylation",
  "GO:0070513": "death domain binding",
  "GO:0070514": "SRF-myogenin-E12 complex",
  "GO:0070515": "alphaIIb-beta3 integrin-talin complex",
  "GO:0070516": "CAK-ERCC2 complex",
  "GO:0070517": "DNA replication factor C core complex",
  "GO:0070518": "alpha4-beta1 integrin-CD53 complex",
  "GO:0070519": "alpha4-beta1 integrin-CD63 complex",
  "GO:0070520": "alpha4-beta1 integrin-CD81 complex",
  "GO:0070521": "alpha4-beta1 integrin-CD82 complex",
  "GO:0070522": "ERCC4-ERCC1 complex",
  "GO:0070523": "11-beta-hydroxysteroid dehydrogenase (NAD+) activity",
  "GO:0070524": "11-beta-hydroxysteroid dehydrogenase (NADP+) activity",
  "GO:0070525": "tRNA threonylcarbamoyladenosine metabolic process",
  "GO:0070527": "platelet aggregation",
  "GO:0070528": "protein kinase C signaling",
  "GO:0070529": "L-tryptophan aminotransferase activity",
  "GO:0070530": "K63-linked polyubiquitin binding",
  "GO:0070531": "BRCA1-A complex",
  "GO:0070532": "BRCA1-B complex",
  "GO:0070533": "BRCA1-C complex",
  "GO:0070534": "protein K63-linked ubiquitination",
  "GO:0070535": "histone H2A K63-linked ubiquitination",
  "GO:0070536": "protein K63-linked deubiquitination",
  "GO:0070537": "histone H2A K63-linked deubiquitination",
  "GO:0070538": "oleic acid binding",
  "GO:0070539": "linoleic acid binding",
  "GO:0070540": "stearic acid binding",
  "GO:0070541": "response to platinum ion",
  "GO:0070542": "response to fatty acid",
  "GO:0070543": "response to linoleic acid",
  "GO:0070544": "histone H3-K36 demethylation",
  "GO:0070545": "PeBoW complex",
  "GO:0070546": "L-phenylalanine aminotransferase activity",
  "GO:0070547": "L-tyrosine aminotransferase activity",
  "GO:0070548": "L-glutamine aminotransferase activity",
  "GO:0070549": "negative regulation of translation involved in RNA interference",
  "GO:0070550": "rDNA condensation",
  "GO:0070551": "endoribonuclease activity, cleaving siRNA-paired mRNA",
  "GO:0070552": "BRISC complex",
  "GO:0070553": "nicotinic acid receptor activity",
  "GO:0070554": "synaptobrevin 2-SNAP-25-syntaxin-3-complexin complex",
  "GO:0070555": "response to interleukin-1",
  "GO:0070556": "TAF4B-containing transcription factor TFIID complex",
  "GO:0070557": "PCNA-p21 complex",
  "GO:0070558": "alphaM-beta2 integrin-CD63 complex",
  "GO:0070559": "lysosomal multienzyme complex",
  "GO:0070560": "protein secretion by platelet",
  "GO:0070561": "vitamin D receptor signaling pathway",
  "GO:0070562": "regulation of vitamin D receptor signaling pathway",
  "GO:0070563": "negative regulation of vitamin D receptor signaling pathway",
  "GO:0070564": "positive regulation of vitamin D receptor signaling pathway",
  "GO:0070565": "telomere-telomerase complex",
  "GO:0070566": "adenylyltransferase activity",
  "GO:0070567": "cytidylyltransferase activity",
  "GO:0070568": "guanylyltransferase activity",
  "GO:0070569": "uridylyltransferase activity",
  "GO:0070570": "regulation of neuron projection regeneration",
  "GO:0070571": "negative regulation of neuron projection regeneration",
  "GO:0070572": "positive regulation of neuron projection regeneration",
  "GO:0070573": "metallodipeptidase activity",
  "GO:0070574": "cadmium ion transmembrane transport",
  "GO:0070575": "peptide mating pheromone maturation involved in pheromone-induced unidirectional conjugation",
  "GO:0070576": "vitamin D 24-hydroxylase activity",
  "GO:0070577": "lysine-acetylated histone binding",
  "GO:0070578": "RISC-loading complex",
  "GO:0070579": "methylcytosine dioxygenase activity",
  "GO:0070580": "base J metabolic process",
  "GO:0070581": "rolling circle DNA replication",
  "GO:0070582": "theta DNA replication",
  "GO:0070583": "spore membrane bending pathway",
  "GO:0070584": "mitochondrion morphogenesis",
  "GO:0070585": "protein localization to mitochondrion",
  "GO:0070586": "cell-cell adhesion involved in gastrulation",
  "GO:0070587": "regulation of cell-cell adhesion involved in gastrulation",
  "GO:0070588": "calcium ion transmembrane transport",
  "GO:0070589": "cellular component macromolecule biosynthetic process",
  "GO:0070590": "spore wall biogenesis",
  "GO:0070591": "ascospore wall biogenesis",
  "GO:0070592": "cell wall polysaccharide biosynthetic process",
  "GO:0070593": "dendrite self-avoidance",
  "GO:0070594": "juvenile hormone response element binding",
  "GO:0070595": "(1->3)-alpha-glucan metabolic process",
  "GO:0070596": "(1->3)-alpha-glucan biosynthetic process",
  "GO:0070597": "cell wall (1->3)-alpha-glucan metabolic process",
  "GO:0070598": "cell wall (1->3)-alpha-glucan biosynthetic process",
  "GO:0070599": "fungal-type cell wall (1->3)-alpha-glucan metabolic process",
  "GO:0070600": "fungal-type cell wall (1->3)-alpha-glucan biosynthetic process",
  "GO:0070601": "centromeric sister chromatid cohesion",
  "GO:0070602": "regulation of centromeric sister chromatid cohesion",
  "GO:0070603": "SWI/SNF superfamily-type complex",
  "GO:0070604": "PBAF complex",
  "GO:0070605": "regulation of (1->3)-alpha-glucan metabolic process",
  "GO:0070606": "regulation of (1->3)-alpha-glucan biosynthetic process",
  "GO:0070607": "regulation of cell wall (1->3)-alpha-glucan metabolic process",
  "GO:0070608": "regulation of cell wall (1->3)-alpha-glucan biosynthetic process",
  "GO:0070609": "regulation of fungal-type cell wall (1->3)-alpha-glucan metabolic process",
  "GO:0070610": "regulation of fungal-type cell wall (1->3)-alpha-glucan biosynthetic process",
  "GO:0070611": "histone methyltransferase activity (H3-R2 specific)",
  "GO:0070612": "histone methyltransferase activity (H2A-R3 specific)",
  "GO:0070613": "regulation of protein processing",
  "GO:0070614": "tungstate ion transport",
  "GO:0070615": "nucleosome-dependent ATPase activity",
  "GO:0070616": "regulation of thiamine diphosphate biosynthetic process",
  "GO:0070617": "negative regulation of thiamine diphosphate biosynthetic process",
  "GO:0070618": "Grb2-Sos complex",
  "GO:0070619": "Shc-Grb2-Sos complex",
  "GO:0070620": "EGFR-Grb2-Sos complex",
  "GO:0070621": "EGFR-Shc-Grb2-Sos complex",
  "GO:0070622": "UDP-N-acetylglucosamine-lysosomal-enzyme N-acetylglucosaminephosphotransferase complex",
  "GO:0070623": "regulation of thiamine biosynthetic process",
  "GO:0070624": "negative regulation of thiamine biosynthetic process",
  "GO:0070625": "zymogen granule exocytosis",
  "GO:0070626": "(S)-2-(5-amino-1-(5-phospho-D-ribosyl)imidazole-4-carboxamido)succinate AMP-lyase (fumarate-forming) activity",
  "GO:0070627": "ferrous iron import",
  "GO:0070628": "proteasome binding",
  "GO:0070629": "(1->4)-alpha-glucan metabolic process",
  "GO:0070630": "(1->4)-alpha-glucan biosynthetic process",
  "GO:0070631": "spindle pole body localization",
  "GO:0070632": "establishment of spindle pole body localization",
  "GO:0070633": "transepithelial transport",
  "GO:0070634": "transepithelial ammonium transport",
  "GO:0070635": "nicotinamide riboside hydrolase activity",
  "GO:0070636": "nicotinic acid riboside hydrolase activity",
  "GO:0070637": "pyridine nucleoside metabolic process",
  "GO:0070638": "pyridine nucleoside catabolic process",
  "GO:0070639": "vitamin D2 metabolic process",
  "GO:0070640": "vitamin D3 metabolic process",
  "GO:0070641": "vitamin D4 metabolic process",
  "GO:0070642": "vitamin D5 metabolic process",
  "GO:0070643": "vitamin D 25-hydroxylase activity",
  "GO:0070644": "vitamin D response element binding",
  "GO:0070645": "Ubisch body",
  "GO:0070646": "protein modification by small protein removal",
  "GO:0070647": "protein modification by small protein conjugation or removal",
  "GO:0070648": "formin-nucleated actin cable",
  "GO:0070649": "formin-nucleated actin cable assembly",
  "GO:0070650": "actin filament bundle distribution",
  "GO:0070651": "nonfunctional rRNA decay",
  "GO:0070652": "HAUS complex",
  "GO:0070653": "high-density lipoprotein particle receptor binding",
  "GO:0070654": "sensory epithelium regeneration",
  "GO:0070655": "mechanosensory epithelium regeneration",
  "GO:0070656": "mechanoreceptor differentiation involved in mechanosensory epithelium regeneration",
  "GO:0070657": "neuromast regeneration",
  "GO:0070658": "neuromast hair cell differentiation involved in neuromast regeneration",
  "GO:0070659": "inner ear sensory epithelium regeneration",
  "GO:0070660": "inner ear receptor cell differentiation involved in inner ear sensory epithelium regeneration",
  "GO:0070661": "leukocyte proliferation",
  "GO:0070662": "mast cell proliferation",
  "GO:0070663": "regulation of leukocyte proliferation",
  "GO:0070664": "negative regulation of leukocyte proliferation",
  "GO:0070665": "positive regulation of leukocyte proliferation",
  "GO:0070666": "regulation of mast cell proliferation",
  "GO:0070667": "negative regulation of mast cell proliferation",
  "GO:0070668": "positive regulation of mast cell proliferation",
  "GO:0070669": "response to interleukin-2",
  "GO:0070670": "response to interleukin-4",
  "GO:0070671": "response to interleukin-12",
  "GO:0070672": "response to interleukin-15",
  "GO:0070673": "response to interleukin-18",
  "GO:0070674": "hypoxanthine dehydrogenase activity",
  "GO:0070675": "hypoxanthine oxidase activity",
  "GO:0070676": "intralumenal vesicle formation",
  "GO:0070677": "rRNA (cytosine-2'-O-)-methyltransferase activity",
  "GO:0070678": "preprotein binding",
  "GO:0070679": "inositol 1,4,5 trisphosphate binding",
  "GO:0070680": "asparaginyl-tRNAAsn biosynthesis via transamidation",
  "GO:0070681": "glutaminyl-tRNAGln biosynthesis via transamidation",
  "GO:0070682": "proteasome regulatory particle assembly",
  "GO:0070684": "seminal clot liquefaction",
  "GO:0070685": "macropinocytic cup",
  "GO:0070686": "macropinocytic cup membrane",
  "GO:0070687": "macropinocytic cup cytoskeleton",
  "GO:0070688": "MLL5-L complex",
  "GO:0070689": "L-threonine catabolic process to propionate",
  "GO:0070690": "L-threonine catabolic process to acetyl-CoA",
  "GO:0070691": "dimeric positive transcription elongation factor complex b",
  "GO:0070692": "trimeric positive transcription elongation factor complex b",
  "GO:0070693": "P-TEFb-cap methyltransferase complex",
  "GO:0070694": "deoxyribonucleoside 5'-monophosphate N-glycosidase activity",
  "GO:0070695": "FHF complex",
  "GO:0070696": "transmembrane receptor protein serine/threonine kinase binding",
  "GO:0070697": "activin receptor binding",
  "GO:0070698": "type I activin receptor binding",
  "GO:0070699": "type II activin receptor binding",
  "GO:0070700": "BMP receptor binding",
  "GO:0070701": "mucus layer",
  "GO:0070702": "inner mucus layer",
  "GO:0070703": "outer mucus layer",
  "GO:0070704": "sterol desaturase activity",
  "GO:0070705": "RNA nucleotide insertion",
  "GO:0070706": "RNA nucleotide deletion",
  "GO:0070707": "RNA dinucleotide insertion",
  "GO:0070708": "RNA cytidine insertion",
  "GO:0070709": "RNA guanosine insertion",
  "GO:0070710": "RNA uridine deletion",
  "GO:0070711": "RNA adenosine-uridine insertion",
  "GO:0070712": "RNA cytidine-uridine insertion",
  "GO:0070713": "RNA guanosine-cytidine insertion",
  "GO:0070714": "RNA guanosine-uridine insertion",
  "GO:0070715": "sodium-dependent organic cation transport",
  "GO:0070716": "mismatch repair involved in maintenance of fidelity involved in DNA-dependent DNA replication",
  "GO:0070717": "poly-purine tract binding",
  "GO:0070718": "alphaPDGFR-SHP-2 complex",
  "GO:0070719": "alphaPDGFR-PLC-gamma-1-PI3K-SHP-2 complex",
  "GO:0070720": "Grb2-SHP-2 complex",
  "GO:0070721": "ISGF3 complex",
  "GO:0070722": "Tle3-Aes complex",
  "GO:0070723": "response to cholesterol",
  "GO:0070724": "BMP receptor complex",
  "GO:0070725": "Yb body",
  "GO:0070726": "cell wall assembly",
  "GO:0070727": "cellular macromolecule localization",
  "GO:0070728": "leucine binding",
  "GO:0070729": "cyclic nucleotide transport",
  "GO:0070730": "cAMP transport",
  "GO:0070731": "cGMP transport",
  "GO:0070732": "spindle envelope",
  "GO:0070733": "protein adenylyltransferase activity",
  "GO:0070734": "histone H3-K27 methylation",
  "GO:0070735": "protein-glycine ligase activity",
  "GO:0070736": "protein-glycine ligase activity, initiating",
  "GO:0070737": "protein-glycine ligase activity, elongating",
  "GO:0070738": "tubulin-glycine ligase activity",
  "GO:0070739": "protein-glutamic acid ligase activity",
  "GO:0070740": "tubulin-glutamic acid ligase activity",
  "GO:0070741": "response to interleukin-6",
  "GO:0070742": "C2H2 zinc finger domain binding",
  "GO:0070743": "interleukin-23 complex",
  "GO:0070744": "interleukin-27 complex",
  "GO:0070745": "interleukin-35 complex",
  "GO:0070746": "interleukin-35 binding",
  "GO:0070747": "interleukin-35 receptor activity",
  "GO:0070748": "interleukin-35 receptor binding",
  "GO:0070749": "interleukin-35 biosynthetic process",
  "GO:0070750": "regulation of interleukin-35 biosynthetic process",
  "GO:0070751": "negative regulation of interleukin-35 biosynthetic process",
  "GO:0070752": "positive regulation of interleukin-35 biosynthetic process",
  "GO:0070753": "interleukin-35 production",
  "GO:0070754": "regulation of interleukin-35 production",
  "GO:0070755": "negative regulation of interleukin-35 production",
  "GO:0070756": "positive regulation of interleukin-35 production",
  "GO:0070757": "interleukin-35-mediated signaling pathway",
  "GO:0070758": "regulation of interleukin-35-mediated signaling pathway",
  "GO:0070759": "negative regulation of interleukin-35-mediated signaling pathway",
  "GO:0070760": "positive regulation of interleukin-35-mediated signaling pathway",
  "GO:0070761": "pre-snoRNP complex",
  "GO:0070762": "nuclear pore transmembrane ring",
  "GO:0070763": "Delta1 complex",
  "GO:0070764": "gamma-secretase-Delta1 complex",
  "GO:0070765": "gamma-secretase complex",
  "GO:0070766": "endobrevin-synaptobrevin 2-alpha-SNAP-NSF-syntaxin-4 complex",
  "GO:0070767": "BRCA1-Rad51 complex",
  "GO:0070768": "synaptotagmin-synaptobrevin 2-SNAP-25-syntaxin-1a-syntaxin-1b-Unc13 complex",
  "GO:0070769": "alphaIIb-beta3 integrin-CIB complex",
  "GO:0070770": "alphaIIb-beta3 integrin-CD47-FAK complex",
  "GO:0070771": "alphaIIb-beta3 integrin-CD47-Src complex",
  "GO:0070772": "PAS complex",
  "GO:0070773": "protein-N-terminal glutamine amidohydrolase activity",
  "GO:0070774": "phytoceramidase activity",
  "GO:0070775": "H3 histone acetyltransferase complex",
  "GO:0070776": "MOZ/MORF histone acetyltransferase complex",
  "GO:0070777": "D-aspartate transport",
  "GO:0070778": "L-aspartate transport",
  "GO:0070779": "D-aspartate import",
  "GO:0070780": "dihydrosphingosine-1-phosphate phosphatase activity",
  "GO:0070781": "response to biotin",
  "GO:0070782": "phosphatidylserine exposure on apoptotic cell surface",
  "GO:0070783": "growth of unicellular organism as a thread of attached cells",
  "GO:0070784": "regulation of growth of unicellular organism as a thread of attached cells",
  "GO:0070785": "negative regulation of growth of unicellular organism as a thread of attached cells",
  "GO:0070786": "positive regulation of growth of unicellular organism as a thread of attached cells",
  "GO:0070787": "conidiophore development",
  "GO:0070788": "conidiophore stalk development",
  "GO:0070789": "metula development",
  "GO:0070790": "phialide development",
  "GO:0070791": "cleistothecium development",
  "GO:0070792": "Hulle cell development",
  "GO:0070793": "regulation of conidiophore development",
  "GO:0070794": "negative regulation of conidiophore development",
  "GO:0070795": "positive regulation of conidiophore development",
  "GO:0070796": "regulation of cleistothecium development",
  "GO:0070797": "negative regulation of cleistothecium development",
  "GO:0070798": "positive regulation of cleistothecium development",
  "GO:0070799": "regulation of conidiophore stalk development",
  "GO:0070800": "negative regulation of conidiophore stalk development",
  "GO:0070801": "positive regulation of conidiophore stalk development",
  "GO:0070802": "regulation of metula development",
  "GO:0070803": "negative regulation of metula development",
  "GO:0070804": "positive regulation of metula development",
  "GO:0070805": "regulation of phialide development",
  "GO:0070806": "negative regulation of phialide development",
  "GO:0070807": "positive regulation of phialide development",
  "GO:0070808": "regulation of Hulle cell development",
  "GO:0070809": "negative regulation of Hulle cell development",
  "GO:0070810": "positive regulation of Hulle cell development",
  "GO:0070811": "glycerol-2-phosphate transport",
  "GO:0070812": "glycerol-2-phosphate-transporting ATPase activity",
  "GO:0070813": "hydrogen sulfide metabolic process",
  "GO:0070814": "hydrogen sulfide biosynthetic process",
  "GO:0070815": "peptidyl-lysine 5-dioxygenase activity",
  "GO:0070816": "phosphorylation of RNA polymerase II C-terminal domain",
  "GO:0070817": "P-TEFb-cap methyltransferase complex localization",
  "GO:0070818": "protoporphyrinogen oxidase activity",
  "GO:0070819": "menaquinone-dependent protoporphyrinogen oxidase activity",
  "GO:0070820": "tertiary granule",
  "GO:0070821": "tertiary granule membrane",
  "GO:0070822": "Sin3-type complex",
  "GO:0070823": "HDA1 complex",
  "GO:0070824": "SHREC complex",
  "GO:0070825": "micropyle",
  "GO:0070826": "paraferritin complex",
  "GO:0070827": "chromatin maintenance",
  "GO:0070828": "heterochromatin organization",
  "GO:0070829": "heterochromatin maintenance",
  "GO:0070830": "bicellular tight junction assembly",
  "GO:0070831": "basement membrane assembly",
  "GO:0070832": "phosphatidylcholine biosynthesis from phosphoryl-ethanolamine via N-dimethylethanolamine phosphate and CDP-choline",
  "GO:0070833": "phosphatidylcholine biosynthesis from phosphoryl-ethanolamine via CDP-N-methylethanolamine",
  "GO:0070834": "phosphatidylcholine biosynthesis from phosphoryl-ethanolamine via N-dimethylethanolamine phosphate and CDP-N-dimethylethanolamine",
  "GO:0070835": "chromium ion transmembrane transporter activity",
  "GO:0070836": "caveola assembly",
  "GO:0070837": "dehydroascorbic acid transport",
  "GO:0070838": "divalent metal ion transport",
  "GO:0070839": "divalent metal ion export",
  "GO:0070840": "dynein complex binding",
  "GO:0070841": "inclusion body assembly",
  "GO:0070842": "aggresome assembly",
  "GO:0070843": "misfolded protein transport",
  "GO:0070844": "polyubiquitinated protein transport",
  "GO:0070845": "polyubiquitinated misfolded protein transport",
  "GO:0070846": "Hsp90 deacetylation",
  "GO:0070847": "core mediator complex",
  "GO:0070848": "response to growth factor",
  "GO:0070849": "response to epidermal growth factor",
  "GO:0070850": "TACC/TOG complex",
  "GO:0070851": "growth factor receptor binding",
  "GO:0070852": "cell body fiber",
  "GO:0070853": "myosin VI binding",
  "GO:0070854": "myosin VI heavy chain binding",
  "GO:0070855": "myosin VI head/neck binding",
  "GO:0070856": "myosin VI light chain binding",
  "GO:0070857": "regulation of bile acid biosynthetic process",
  "GO:0070858": "negative regulation of bile acid biosynthetic process",
  "GO:0070859": "positive regulation of bile acid biosynthetic process",
  "GO:0070860": "RNA polymerase I core factor complex",
  "GO:0070861": "regulation of protein exit from endoplasmic reticulum",
  "GO:0070862": "negative regulation of protein exit from endoplasmic reticulum",
  "GO:0070863": "positive regulation of protein exit from endoplasmic reticulum",
  "GO:0070864": "sperm individualization complex",
  "GO:0070865": "investment cone",
  "GO:0070866": "sterol-dependent protein binding",
  "GO:0070867": "mating projection tip membrane",
  "GO:0070868": "heterochromatin organization involved in chromatin silencing",
  "GO:0070869": "heterochromatin assembly involved in chromatin silencing",
  "GO:0070870": "heterochromatin maintenance involved in chromatin silencing",
  "GO:0070871": "cell wall organization involved in conjugation with cellular fusion",
  "GO:0070872": "plasma membrane organization involved in conjugation with cellular fusion",
  "GO:0070873": "regulation of glycogen metabolic process",
  "GO:0070874": "negative regulation of glycogen metabolic process",
  "GO:0070875": "positive regulation of glycogen metabolic process",
  "GO:0070876": "SOSS complex",
  "GO:0070877": "microprocessor complex",
  "GO:0070878": "primary miRNA binding",
  "GO:0070879": "fungal-type cell wall beta-glucan metabolic process",
  "GO:0070880": "fungal-type cell wall beta-glucan biosynthetic process",
  "GO:0070881": "regulation of proline transport",
  "GO:0070883": "pre-miRNA binding",
  "GO:0070884": "regulation of calcineurin-NFAT signaling cascade",
  "GO:0070885": "negative regulation of calcineurin-NFAT signaling cascade",
  "GO:0070886": "positive regulation of calcineurin-NFAT signaling cascade",
  "GO:0070887": "cellular response to chemical stimulus",
  "GO:0070888": "E-box binding",
  "GO:0070889": "platelet alpha granule organization",
  "GO:0070890": "sodium-dependent L-ascorbate transmembrane transporter activity",
  "GO:0070891": "lipoteichoic acid binding",
  "GO:0070892": "lipoteichoic acid receptor activity",
  "GO:0070893": "transposon integration",
  "GO:0070894": "regulation of transposon integration",
  "GO:0070895": "negative regulation of transposon integration",
  "GO:0070896": "positive regulation of transposon integration",
  "GO:0070897": "DNA-templated transcriptional preinitiation complex assembly",
  "GO:0070898": "RNA polymerase III transcriptional preinitiation complex assembly",
  "GO:0070899": "mitochondrial tRNA wobble uridine modification",
  "GO:0070900": "mitochondrial tRNA modification",
  "GO:0070901": "mitochondrial tRNA methylation",
  "GO:0070902": "mitochondrial tRNA pseudouridine synthesis",
  "GO:0070903": "mitochondrial tRNA thio-modification",
  "GO:0070904": "transepithelial L-ascorbic acid transport",
  "GO:0070905": "serine binding",
  "GO:0070906": "aspartate:alanine antiporter activity",
  "GO:0070907": "histidine:histamine antiporter activity",
  "GO:0070908": "tyrosine:tyramine antiporter activity",
  "GO:0070909": "glutamate:gamma-aminobutyric acid antiporter activity",
  "GO:0070910": "cell wall macromolecule catabolic process involved in cell wall disassembly",
  "GO:0070911": "global genome nucleotide-excision repair",
  "GO:0070912": "Ddb1-Ckn1 complex",
  "GO:0070913": "Ddb1-Wdr21 complex",
  "GO:0070914": "UV-damage excision repair",
  "GO:0070915": "lysophosphatidic acid receptor activity",
  "GO:0070916": "inositol phosphoceramide synthase complex",
  "GO:0070917": "inositol phosphoceramide synthase regulator activity",
  "GO:0070918": "production of small RNA involved in gene silencing by RNA",
  "GO:0070919": "production of siRNA involved in chromatin silencing by small RNA",
  "GO:0070920": "regulation of production of small RNA involved in gene silencing by RNA",
  "GO:0070921": "regulation of production of siRNA involved in chromatin silencing by small RNA",
  "GO:0070922": "small RNA loading onto RISC",
  "GO:0070923": "siRNA loading onto RISC involved in chromatin silencing by small RNA",
  "GO:0070924": "heterochromatin assembly involved in chromatin silencing by small RNA",
  "GO:0070925": "organelle assembly",
  "GO:0070926": "regulation of ATP:ADP antiporter activity",
  "GO:0070927": "negative regulation of ATP:ADP antiporter activity",
  "GO:0070928": "regulation of mRNA stability, ncRNA-mediated",
  "GO:0070929": "trans-translation",
  "GO:0070930": "trans-translation-dependent protein tagging",
  "GO:0070931": "Golgi-associated vesicle lumen",
  "GO:0070932": "histone H3 deacetylation",
  "GO:0070933": "histone H4 deacetylation",
  "GO:0070934": "CRD-mediated mRNA stabilization",
  "GO:0070935": "3'-UTR-mediated mRNA stabilization",
  "GO:0070936": "protein K48-linked ubiquitination",
  "GO:0070937": "CRD-mediated mRNA stability complex",
  "GO:0070938": "contractile ring",
  "GO:0070939": "Dsl1p complex",
  "GO:0070940": "dephosphorylation of RNA polymerase II C-terminal domain",
  "GO:0070941": "eisosome assembly",
  "GO:0070942": "neutrophil mediated cytotoxicity",
  "GO:0070943": "neutrophil mediated killing of symbiont cell",
  "GO:0070944": "neutrophil mediated killing of bacterium",
  "GO:0070945": "neutrophil mediated killing of gram-negative bacterium",
  "GO:0070946": "neutrophil mediated killing of gram-positive bacterium",
  "GO:0070947": "neutrophil mediated killing of fungus",
  "GO:0070948": "regulation of neutrophil mediated cytotoxicity",
  "GO:0070949": "regulation of neutrophil mediated killing of symbiont cell",
  "GO:0070950": "regulation of neutrophil mediated killing of bacterium",
  "GO:0070951": "regulation of neutrophil mediated killing of gram-negative bacterium",
  "GO:0070952": "regulation of neutrophil mediated killing of gram-positive bacterium",
  "GO:0070953": "regulation of neutrophil mediated killing of fungus",
  "GO:0070954": "negative regulation of neutrophil mediated cytotoxicity",
  "GO:0070955": "negative regulation of neutrophil mediated killing of symbiont cell",
  "GO:0070956": "negative regulation of neutrophil mediated killing of bacterium",
  "GO:0070957": "negative regulation of neutrophil mediated killing of gram-negative bacterium",
  "GO:0070958": "negative regulation of neutrophil mediated killing of gram-positive bacterium",
  "GO:0070959": "negative regulation of neutrophil mediated killing of fungus",
  "GO:0070960": "positive regulation of neutrophil mediated cytotoxicity",
  "GO:0070961": "positive regulation of neutrophil mediated killing of symbiont cell",
  "GO:0070962": "positive regulation of neutrophil mediated killing of bacterium",
  "GO:0070963": "positive regulation of neutrophil mediated killing of gram-negative bacterium",
  "GO:0070964": "positive regulation of neutrophil mediated killing of gram-positive bacterium",
  "GO:0070965": "positive regulation of neutrophil mediated killing of fungus",
  "GO:0070966": "nuclear-transcribed mRNA catabolic process, no-go decay",
  "GO:0070967": "coenzyme F420 binding",
  "GO:0070968": "pyrroloquinoline quinone binding",
  "GO:0070970": "interleukin-2 secretion",
  "GO:0070971": "endoplasmic reticulum exit site",
  "GO:0070972": "protein localization to endoplasmic reticulum",
  "GO:0070973": "protein localization to endoplasmic reticulum exit site",
  "GO:0070974": "POU domain binding",
  "GO:0070975": "FHA domain binding",
  "GO:0070976": "TIR domain binding",
  "GO:0070977": "bone maturation",
  "GO:0070978": "voltage-gated calcium channel complex assembly",
  "GO:0070979": "protein K11-linked ubiquitination",
  "GO:0070980": "biphenyl catabolic process",
  "GO:0070981": "L-asparagine biosynthetic process",
  "GO:0070982": "L-asparagine metabolic process",
  "GO:0070983": "dendrite guidance",
  "GO:0070984": "SET domain binding",
  "GO:0070985": "TFIIK complex",
  "GO:0070986": "left/right axis specification",
  "GO:0070987": "error-free translesion synthesis",
  "GO:0070988": "demethylation",
  "GO:0070989": "oxidative demethylation",
  "GO:0070990": "snRNP binding",
  "GO:0070991": "medium-chain-acyl-CoA dehydrogenase activity",
  "GO:0070992": "translation initiation complex",
  "GO:0070993": "translation preinitiation complex",
  "GO:0070994": "detection of oxidative stress",
  "GO:0070995": "NADPH oxidation",
  "GO:0070996": "type 1 melanocortin receptor binding",
  "GO:0070997": "neuron death",
  "GO:0070998": "sensory perception of gravity",
  "GO:0070999": "detection of mechanical stimulus involved in sensory perception of gravity",
  "GO:0071000": "response to magnetism",
  "GO:0071001": "U4/U6 snRNP",
  "GO:0071002": "U4atac/U6atac snRNP",
  "GO:0071003": "penta-snRNP complex",
  "GO:0071004": "U2-type prespliceosome",
  "GO:0071005": "U2-type precatalytic spliceosome",
  "GO:0071006": "U2-type catalytic step 1 spliceosome",
  "GO:0071007": "U2-type catalytic step 2 spliceosome",
  "GO:0071008": "U2-type post-mRNA release spliceosomal complex",
  "GO:0071009": "U4atac/U6atac x U5 tri-snRNP complex",
  "GO:0071010": "prespliceosome",
  "GO:0071011": "precatalytic spliceosome",
  "GO:0071012": "catalytic step 1 spliceosome",
  "GO:0071013": "catalytic step 2 spliceosome",
  "GO:0071014": "post-mRNA release spliceosomal complex",
  "GO:0071015": "U12-type prespliceosome",
  "GO:0071016": "U12-type precatalytic spliceosome",
  "GO:0071017": "U12-type catalytic step 1 spliceosome",
  "GO:0071018": "U12-type catalytic step 2 spliceosome",
  "GO:0071019": "U12-type post-mRNA release spliceosomal complex",
  "GO:0071020": "post-spliceosomal complex",
  "GO:0071021": "U2-type post-spliceosomal complex",
  "GO:0071022": "U12-type post-spliceosomal complex",
  "GO:0071023": "trans spliceosomal complex",
  "GO:0071024": "SL snRNP",
  "GO:0071025": "RNA surveillance",
  "GO:0071026": "cytoplasmic RNA surveillance",
  "GO:0071027": "nuclear RNA surveillance",
  "GO:0071028": "nuclear mRNA surveillance",
  "GO:0071029": "nuclear ncRNA surveillance",
  "GO:0071030": "nuclear mRNA surveillance of spliceosomal pre-mRNA splicing",
  "GO:0071031": "nuclear mRNA surveillance of mRNA 3'-end processing",
  "GO:0071032": "nuclear mRNA surveillance of mRNP export",
  "GO:0071033": "nuclear retention of pre-mRNA at the site of transcription",
  "GO:0071034": "CUT catabolic process",
  "GO:0071035": "nuclear polyadenylation-dependent rRNA catabolic process",
  "GO:0071036": "nuclear polyadenylation-dependent snoRNA catabolic process",
  "GO:0071037": "nuclear polyadenylation-dependent snRNA catabolic process",
  "GO:0071038": "nuclear polyadenylation-dependent tRNA catabolic process",
  "GO:0071039": "nuclear polyadenylation-dependent CUT catabolic process",
  "GO:0071040": "nuclear polyadenylation-dependent antisense transcript catabolic process",
  "GO:0071041": "antisense RNA transcript catabolic process",
  "GO:0071042": "nuclear polyadenylation-dependent mRNA catabolic process",
  "GO:0071043": "CUT metabolic process",
  "GO:0071044": "histone mRNA catabolic process",
  "GO:0071045": "nuclear histone mRNA catabolic process",
  "GO:0071046": "nuclear polyadenylation-dependent ncRNA catabolic process",
  "GO:0071047": "polyadenylation-dependent mRNA catabolic process",
  "GO:0071048": "nuclear retention of unspliced pre-mRNA at the site of transcription",
  "GO:0071049": "nuclear retention of pre-mRNA with aberrant 3'-ends at the site of transcription",
  "GO:0071050": "snoRNA polyadenylation",
  "GO:0071051": "polyadenylation-dependent snoRNA 3'-end processing",
  "GO:0071052": "alpha9-beta1 integrin-ADAM1 complex",
  "GO:0071053": "alpha9-beta1 integrin-ADAM2 complex",
  "GO:0071054": "alpha9-beta1 integrin-ADAM3 complex",
  "GO:0071055": "alpha9-beta1 integrin-ADAM9 complex",
  "GO:0071056": "alpha9-beta1 integrin-ADAM15 complex",
  "GO:0071057": "alphav-beta3 integrin-ADAM15 complex",
  "GO:0071058": "alpha3-beta1 integrin-CD151 complex",
  "GO:0071059": "alpha6-beta1 integrin-CD151 complex",
  "GO:0071060": "alpha7-beta1 integrin-CD151 complex",
  "GO:0071061": "alpha6-beta4 integrin-CD151 complex",
  "GO:0071062": "alphav-beta3 integrin-vitronectin complex",
  "GO:0071063": "sensory perception of wind",
  "GO:0071064": "alphaE-beta7 integrin-E-cadherin complex",
  "GO:0071065": "alpha9-beta1 integrin-vascular cell adhesion molecule-1 complex",
  "GO:0071066": "detection of mechanical stimulus involved in sensory perception of wind",
  "GO:0071067": "alphav-beta3 integrin-ADAM23 complex",
  "GO:0071068": "alpha9-beta1 integrin-ADAM12 complex",
  "GO:0071069": "alpha4-beta1 integrin-thrombospondin-1 complex",
  "GO:0071070": "alpha4-beta1 integrin-thrombospondin-2 complex",
  "GO:0071071": "regulation of phospholipid biosynthetic process",
  "GO:0071072": "negative regulation of phospholipid biosynthetic process",
  "GO:0071073": "positive regulation of phospholipid biosynthetic process",
  "GO:0071074": "eukaryotic initiation factor eIF2 binding",
  "GO:0071075": "CUGBP1-eIF2 complex",
  "GO:0071076": "RNA 3' uridylation",
  "GO:0071077": "adenosine 3',5'-bisphosphate transmembrane transporter activity",
  "GO:0071078": "fibronectin-tissue transglutaminase complex",
  "GO:0071079": "alpha2-beta1 integrin-chondroadherin complex",
  "GO:0071080": "alpha3-beta1 integrin-basigin complex",
  "GO:0071081": "alpha3-beta1 integrin-CD63 complex",
  "GO:0071082": "alpha9-beta1 integrin-tenascin complex",
  "GO:0071083": "alphaV-beta3 integrin-CD47-FCER2 complex",
  "GO:0071084": "alpha2-beta1 integrin-CD47 complex",
  "GO:0071085": "alphaIIb-beta3 integrin-CD9 complex",
  "GO:0071086": "alphaIIb-beta3 integrin-CD9-CD47-platelet glycoprotein Ib complex",
  "GO:0071087": "alpha11-beta1 integrin-collagen type I complex",
  "GO:0071088": "alpha5-beta1 integrin-tissue transglutaminase complex",
  "GO:0071089": "alphaV-beta3 integrin-tissue transglutaminase complex",
  "GO:0071090": "alphaIIb-beta3 integrin-fibronectin-tissue transglutaminase complex",
  "GO:0071091": "alpha1-beta1 integrin-tissue transglutaminase complex",
  "GO:0071092": "alpha3-beta1 integrin-tissue transglutaminase complex",
  "GO:0071093": "alpha5-beta1 integrin-fibronectin-tissue transglutaminase complex",
  "GO:0071094": "alpha6-beta4 integrin-CD9 complex",
  "GO:0071095": "alpha3-beta1 integrin-thrombospondin complex",
  "GO:0071096": "alphaV-beta3 integrin-gelsolin complex",
  "GO:0071097": "alphaV-beta3 integrin-paxillin-Pyk2 complex",
  "GO:0071098": "alpha6-beta4 integrin-Fyn complex",
  "GO:0071099": "alphaV-beta6 integrin-TGFbeta-3 complex",
  "GO:0071100": "alphaV-beta8 integrin-MMP14-TGFbeta-1 complex",
  "GO:0071101": "alpha4-beta1 integrin-JAM2 complex",
  "GO:0071102": "alpha4-beta1 integrin-paxillin complex",
  "GO:0071103": "DNA conformation change",
  "GO:0071104": "response to interleukin-9",
  "GO:0071105": "response to interleukin-11",
  "GO:0071106": "adenosine 3',5'-bisphosphate transmembrane transport",
  "GO:0071107": "response to parathyroid hormone",
  "GO:0071108": "protein K48-linked deubiquitination",
  "GO:0071109": "superior temporal gyrus development",
  "GO:0071110": "histone biotinylation",
  "GO:0071111": "cyclic-guanylate-specific phosphodiesterase activity",
  "GO:0071112": "alpha4-beta4 integrin-EMILIN-1 complex",
  "GO:0071113": "alphaIIb-beta3 integrin-ICAM-4 complex",
  "GO:0071114": "alphaV-beta3 integrin-tumstatin complex",
  "GO:0071115": "alpha5-beta1 integrin-endostatin complex",
  "GO:0071116": "alpha6-beta1 integrin-CYR61 complex",
  "GO:0071117": "alpha5-beta1 integrin-fibronectin-NOV complex",
  "GO:0071118": "alphaV-beta3 integrin-NOV complex",
  "GO:0071119": "alpha7-beta1 integrin-nicotinamide riboside kinase complex",
  "GO:0071120": "alpha4-beta1 integrin-CD47 complex",
  "GO:0071121": "alpha9-beta1 integrin-VEGF-D complex",
  "GO:0071122": "alpha9-beta1 integrin-VEGF-A complex",
  "GO:0071123": "alpha9-beta1 integrin-VEGF-C complex",
  "GO:0071124": "alpha1-beta1 integrin-tyrosine-protein phosphatase non-receptor type 2 complex",
  "GO:0071125": "alphaV-beta3 integrin-EGFR complex",
  "GO:0071126": "alphaV-beta6 integrin-osteopontin complex",
  "GO:0071127": "alpha9-beta1 integrin-osteopontin complex",
  "GO:0071128": "alpha5-beta1 integrin-osteopontin complex",
  "GO:0071129": "alphaV-beta3 integrin-LPP3 complex",
  "GO:0071130": "alpha5-beta1 integrin-LPP3 complex",
  "GO:0071131": "alphaV-beta3 integrin-laminin alpha-4 complex",
  "GO:0071132": "alphaX-beta2 integrin-ICAM-4 complex",
  "GO:0071133": "alpha9-beta1 integrin-ADAM8 complex",
  "GO:0071134": "alpha9-beta1 integrin-thrombospondin-1 complex",
  "GO:0071135": "alpha7-beta1 integrin-focal adhesion kinase complex",
  "GO:0071136": "alpha7-beta1 integrin-laminin alpha-2 complex",
  "GO:0071137": "alphaV-beta3 integrin-CD98 complex",
  "GO:0071138": "alpha5-beta5-fibronectin-SFRP2 complex",
  "GO:0071139": "resolution of recombination intermediates",
  "GO:0071140": "resolution of mitotic recombination intermediates",
  "GO:0071141": "SMAD protein complex",
  "GO:0071142": "SMAD2 protein complex",
  "GO:0071143": "SMAD3 protein complex",
  "GO:0071144": "SMAD2-SMAD3 protein complex",
  "GO:0071145": "SMAD2-SMAD4 protein complex",
  "GO:0071146": "SMAD3-SMAD4 protein complex",
  "GO:0071147": "TEAD-2 multiprotein complex",
  "GO:0071148": "TEAD-1-YAP complex",
  "GO:0071149": "TEAD-2-YAP complex",
  "GO:0071150": "TEAD-3-YAP complex",
  "GO:0071151": "TEAD-4-YAP complex",
  "GO:0071152": "G-protein alpha(q)-synembrin complex",
  "GO:0071153": "G-protein alpha(o)-synembrin complex",
  "GO:0071154": "G-protein alpha(i)1-synembrin complex",
  "GO:0071155": "G-protein alpha(13)-synembrin complex",
  "GO:0071156": "regulation of cell cycle arrest",
  "GO:0071157": "negative regulation of cell cycle arrest",
  "GO:0071158": "positive regulation of cell cycle arrest",
  "GO:0071159": "NF-kappaB complex",
  "GO:0071160": "cyanophycin synthetase activity (L-aspartate-adding)",
  "GO:0071161": "cyanophycin synthetase activity (L-arginine-adding)",
  "GO:0071162": "CMG complex",
  "GO:0071163": "DNA replication preinitiation complex assembly",
  "GO:0071164": "RNA trimethylguanosine synthase activity",
  "GO:0071165": "GINS complex assembly",
  "GO:0071166": "ribonucleoprotein complex localization",
  "GO:0071167": "ribonucleoprotein complex import into nucleus",
  "GO:0071168": "protein localization to chromatin",
  "GO:0071169": "establishment of protein localization to chromatin",
  "GO:0071170": "site-specific DNA replication termination",
  "GO:0071171": "site-specific DNA replication termination at RTS1 barrier",
  "GO:0071172": "dihydromonapterin reductase activity",
  "GO:0071173": "spindle assembly checkpoint",
  "GO:0071174": "mitotic spindle checkpoint",
  "GO:0071175": "MAML2-RBP-Jkappa-ICN1 complex",
  "GO:0071176": "MAML2-RBP-Jkappa-ICN2 complex",
  "GO:0071177": "MAML2-RBP-Jkappa-ICN3 complex",
  "GO:0071178": "MAML2-RBP-Jkappa-ICN4 complex",
  "GO:0071179": "MAML3-RBP-Jkappa-ICN1 complex",
  "GO:0071180": "MAML3-RBP-Jkappa-ICN2 complex",
  "GO:0071181": "MAML3-RBP-Jkappa-ICN3 complex",
  "GO:0071182": "MAML3-RBP-Jkappa-ICN4 complex",
  "GO:0071183": "protocadherin-alpha-protocadherin-gamma complex",
  "GO:0071184": "protocadherin-alpha-v4-protocadherin-gamma-a1 complex",
  "GO:0071185": "protocadherin-alpha-v4-protocadherin-gamma-a3 complex",
  "GO:0071186": "protocadherin-alpha-v4-protocadherin-gamma-b2 complex",
  "GO:0071187": "protocadherin-alpha-v4-protocadherin-gamma-b4 complex",
  "GO:0071188": "protocadherin-alpha-v7-protocadherin-gamma-a1 complex",
  "GO:0071189": "protocadherin-alpha-v7-protocadherin-gamma-a3 complex",
  "GO:0071190": "protocadherin-alpha-v7-protocadherin-gamma-b2 complex",
  "GO:0071191": "protocadherin-alpha-v7-protocadherin-gamma-b4 complex",
  "GO:0071192": "Kv4.2-KChIP1 channel complex",
  "GO:0071193": "Kv4.2-KChIP2 channel complex",
  "GO:0071194": "Kv4.2-KChIP3 channel complex",
  "GO:0071195": "Kv4.2-KChIP4 channel complex",
  "GO:0071196": "Kv4.3-KChIP1 channel complex",
  "GO:0071197": "Kv4.2-Kv4.3 channel complex",
  "GO:0071198": "Kv4.1-DPP6 channel complex",
  "GO:0071199": "Kv4.1-DPP10 channel complex",
  "GO:0071200": "Kv4.2-DPP6 channel complex",
  "GO:0071201": "Kv4.3-DPP6 channel complex",
  "GO:0071202": "Kv4.3-DPP10 channel complex",
  "GO:0071203": "WASH complex",
  "GO:0071204": "histone pre-mRNA 3'end processing complex",
  "GO:0071205": "protein localization to juxtaparanode region of axon",
  "GO:0071206": "establishment of protein localization to juxtaparanode region of axon",
  "GO:0071207": "histone pre-mRNA stem-loop binding",
  "GO:0071208": "histone pre-mRNA DCP binding",
  "GO:0071209": "U7 snRNA binding",
  "GO:0071210": "protein insertion into membrane raft",
  "GO:0071211": "protein targeting to vacuole involved in autophagy",
  "GO:0071212": "subsynaptic reticulum",
  "GO:0071213": "cellular response to 1-aminocyclopropane-1-carboxylic acid",
  "GO:0071214": "cellular response to abiotic stimulus",
  "GO:0071215": "cellular response to abscisic acid stimulus",
  "GO:0071216": "cellular response to biotic stimulus",
  "GO:0071217": "cellular response to external biotic stimulus",
  "GO:0071218": "cellular response to misfolded protein",
  "GO:0071219": "cellular response to molecule of bacterial origin",
  "GO:0071220": "cellular response to bacterial lipoprotein",
  "GO:0071221": "cellular response to bacterial lipopeptide",
  "GO:0071222": "cellular response to lipopolysaccharide",
  "GO:0071223": "cellular response to lipoteichoic acid",
  "GO:0071224": "cellular response to peptidoglycan",
  "GO:0071225": "cellular response to muramyl dipeptide",
  "GO:0071226": "cellular response to molecule of fungal origin",
  "GO:0071227": "cellular response to molecule of oomycetes origin",
  "GO:0071228": "cellular response to tumor cell",
  "GO:0071229": "cellular response to acid chemical",
  "GO:0071230": "cellular response to amino acid stimulus",
  "GO:0071231": "cellular response to folic acid",
  "GO:0071232": "cellular response to histidine",
  "GO:0071233": "cellular response to leucine",
  "GO:0071234": "cellular response to phenylalanine",
  "GO:0071235": "cellular response to proline",
  "GO:0071236": "cellular response to antibiotic",
  "GO:0071237": "cellular response to bacteriocin",
  "GO:0071238": "cellular response to brefeldin A",
  "GO:0071239": "cellular response to streptomycin",
  "GO:0071240": "cellular response to food",
  "GO:0071241": "cellular response to inorganic substance",
  "GO:0071242": "cellular response to ammonium ion",
  "GO:0071243": "cellular response to arsenic-containing substance",
  "GO:0071244": "cellular response to carbon dioxide",
  "GO:0071245": "cellular response to carbon monoxide",
  "GO:0071246": "cellular response to chlorate",
  "GO:0071247": "cellular response to chromate",
  "GO:0071248": "cellular response to metal ion",
  "GO:0071249": "cellular response to nitrate",
  "GO:0071250": "cellular response to nitrite",
  "GO:0071251": "cellular response to silicon dioxide",
  "GO:0071252": "cellular response to sulfur dioxide",
  "GO:0071253": "connexin binding",
  "GO:0071254": "cytoplasmic U snRNP body",
  "GO:0071255": "CVT vesicle assembly",
  "GO:0071256": "translocon complex",
  "GO:0071257": "cellular response to electrical stimulus",
  "GO:0071258": "cellular response to gravity",
  "GO:0071259": "cellular response to magnetism",
  "GO:0071260": "cellular response to mechanical stimulus",
  "GO:0071261": "Ssh1 translocon complex",
  "GO:0071262": "regulation of translational initiation in response to starvation",
  "GO:0071263": "negative regulation of translational initiation in response to starvation",
  "GO:0071264": "positive regulation of translational initiation in response to starvation",
  "GO:0071265": "L-methionine biosynthetic process",
  "GO:0071266": "'de novo' L-methionine biosynthetic process",
  "GO:0071267": "L-methionine salvage",
  "GO:0071268": "homocysteine biosynthetic process",
  "GO:0071269": "L-homocysteine biosynthetic process",
  "GO:0071270": "1-butanol metabolic process",
  "GO:0071271": "1-butanol biosynthetic process",
  "GO:0071272": "morphine metabolic process",
  "GO:0071273": "morphine catabolic process",
  "GO:0071274": "isoquinoline alkaloid catabolic process",
  "GO:0071275": "cellular response to aluminum ion",
  "GO:0071276": "cellular response to cadmium ion",
  "GO:0071277": "cellular response to calcium ion",
  "GO:0071278": "cellular response to cesium ion",
  "GO:0071279": "cellular response to cobalt ion",
  "GO:0071280": "cellular response to copper ion",
  "GO:0071281": "cellular response to iron ion",
  "GO:0071282": "cellular response to iron(II) ion",
  "GO:0071283": "cellular response to iron(III) ion",
  "GO:0071284": "cellular response to lead ion",
  "GO:0071285": "cellular response to lithium ion",
  "GO:0071286": "cellular response to magnesium ion",
  "GO:0071287": "cellular response to manganese ion",
  "GO:0071288": "cellular response to mercury ion",
  "GO:0071289": "cellular response to nickel ion",
  "GO:0071290": "cellular response to platinum ion",
  "GO:0071291": "cellular response to selenium ion",
  "GO:0071292": "cellular response to silver ion",
  "GO:0071293": "cellular response to tellurium ion",
  "GO:0071294": "cellular response to zinc ion",
  "GO:0071295": "cellular response to vitamin",
  "GO:0071296": "cellular response to biotin",
  "GO:0071297": "cellular response to cobalamin",
  "GO:0071298": "cellular response to L-ascorbic acid",
  "GO:0071299": "cellular response to vitamin A",
  "GO:0071300": "cellular response to retinoic acid",
  "GO:0071301": "cellular response to vitamin B1",
  "GO:0071302": "cellular response to vitamin B2",
  "GO:0071303": "cellular response to vitamin B3",
  "GO:0071304": "cellular response to vitamin B6",
  "GO:0071305": "cellular response to vitamin D",
  "GO:0071306": "cellular response to vitamin E",
  "GO:0071307": "cellular response to vitamin K",
  "GO:0071308": "cellular response to menaquinone",
  "GO:0071309": "cellular response to phylloquinone",
  "GO:0071310": "cellular response to organic substance",
  "GO:0071311": "cellular response to acetate",
  "GO:0071312": "cellular response to alkaloid",
  "GO:0071313": "cellular response to caffeine",
  "GO:0071314": "cellular response to cocaine",
  "GO:0071315": "cellular response to morphine",
  "GO:0071316": "cellular response to nicotine",
  "GO:0071317": "cellular response to isoquinoline alkaloid",
  "GO:0071318": "cellular response to ATP",
  "GO:0071319": "cellular response to benzoic acid",
  "GO:0071320": "cellular response to cAMP",
  "GO:0071321": "cellular response to cGMP",
  "GO:0071322": "cellular response to carbohydrate stimulus",
  "GO:0071323": "cellular response to chitin",
  "GO:0071324": "cellular response to disaccharide stimulus",
  "GO:0071325": "cellular response to mannitol stimulus",
  "GO:0071326": "cellular response to monosaccharide stimulus",
  "GO:0071327": "cellular response to trehalose stimulus",
  "GO:0071328": "cellular response to maltose stimulus",
  "GO:0071329": "cellular response to sucrose stimulus",
  "GO:0071330": "cellular response to trehalose-6-phosphate stimulus",
  "GO:0071331": "cellular response to hexose stimulus",
  "GO:0071332": "cellular response to fructose stimulus",
  "GO:0071333": "cellular response to glucose stimulus",
  "GO:0071334": "cellular response to rhamnose stimulus",
  "GO:0071335": "hair follicle cell proliferation",
  "GO:0071336": "regulation of hair follicle cell proliferation",
  "GO:0071337": "negative regulation of hair follicle cell proliferation",
  "GO:0071338": "positive regulation of hair follicle cell proliferation",
  "GO:0071339": "MLL1 complex",
  "GO:0071340": "skeletal muscle acetylcholine-gated channel clustering",
  "GO:0071341": "medial cortical node",
  "GO:0071342": "regulation of establishment of actomyosin contractile ring localization",
  "GO:0071343": "obsolete negative regulation of establishment of actomyosin contractile ring localization",
  "GO:0071344": "diphosphate metabolic process",
  "GO:0071345": "cellular response to cytokine stimulus",
  "GO:0071346": "cellular response to interferon-gamma",
  "GO:0071347": "cellular response to interleukin-1",
  "GO:0071348": "cellular response to interleukin-11",
  "GO:0071349": "cellular response to interleukin-12",
  "GO:0071350": "cellular response to interleukin-15",
  "GO:0071351": "cellular response to interleukin-18",
  "GO:0071352": "cellular response to interleukin-2",
  "GO:0071353": "cellular response to interleukin-4",
  "GO:0071354": "cellular response to interleukin-6",
  "GO:0071355": "cellular response to interleukin-9",
  "GO:0071356": "cellular response to tumor necrosis factor",
  "GO:0071357": "cellular response to type I interferon",
  "GO:0071358": "cellular response to type III interferon",
  "GO:0071359": "cellular response to dsRNA",
  "GO:0071360": "cellular response to exogenous dsRNA",
  "GO:0071361": "cellular response to ethanol",
  "GO:0071362": "cellular response to ether",
  "GO:0071363": "cellular response to growth factor stimulus",
  "GO:0071364": "cellular response to epidermal growth factor stimulus",
  "GO:0071365": "cellular response to auxin stimulus",
  "GO:0071366": "cellular response to indolebutyric acid stimulus",
  "GO:0071367": "cellular response to brassinosteroid stimulus",
  "GO:0071368": "cellular response to cytokinin stimulus",
  "GO:0071369": "cellular response to ethylene stimulus",
  "GO:0071370": "cellular response to gibberellin stimulus",
  "GO:0071371": "cellular response to gonadotropin stimulus",
  "GO:0071372": "cellular response to follicle-stimulating hormone stimulus",
  "GO:0071373": "cellular response to luteinizing hormone stimulus",
  "GO:0071374": "cellular response to parathyroid hormone stimulus",
  "GO:0071375": "cellular response to peptide hormone stimulus",
  "GO:0071376": "cellular response to corticotropin-releasing hormone stimulus",
  "GO:0071377": "cellular response to glucagon stimulus",
  "GO:0071378": "cellular response to growth hormone stimulus",
  "GO:0071379": "cellular response to prostaglandin stimulus",
  "GO:0071380": "cellular response to prostaglandin E stimulus",
  "GO:0071381": "cellular response to prostaglandin F stimulus",
  "GO:0071382": "cellular response to prostaglandin I stimulus",
  "GO:0071383": "cellular response to steroid hormone stimulus",
  "GO:0071384": "cellular response to corticosteroid stimulus",
  "GO:0071385": "cellular response to glucocorticoid stimulus",
  "GO:0071386": "cellular response to corticosterone stimulus",
  "GO:0071387": "cellular response to cortisol stimulus",
  "GO:0071388": "cellular response to cortisone stimulus",
  "GO:0071389": "cellular response to mineralocorticoid stimulus",
  "GO:0071390": "cellular response to ecdysone",
  "GO:0071391": "cellular response to estrogen stimulus",
  "GO:0071392": "cellular response to estradiol stimulus",
  "GO:0071393": "cellular response to progesterone stimulus",
  "GO:0071394": "cellular response to testosterone stimulus",
  "GO:0071395": "cellular response to jasmonic acid stimulus",
  "GO:0071396": "cellular response to lipid",
  "GO:0071397": "cellular response to cholesterol",
  "GO:0071398": "cellular response to fatty acid",
  "GO:0071399": "cellular response to linoleic acid",
  "GO:0071400": "cellular response to oleic acid",
  "GO:0071401": "cellular response to triglyceride",
  "GO:0071402": "cellular response to lipoprotein particle stimulus",
  "GO:0071403": "cellular response to high density lipoprotein particle stimulus",
  "GO:0071404": "cellular response to low-density lipoprotein particle stimulus",
  "GO:0071405": "cellular response to methanol",
  "GO:0071406": "cellular response to methylmercury",
  "GO:0071407": "cellular response to organic cyclic compound",
  "GO:0071408": "cellular response to cycloalkane",
  "GO:0071409": "cellular response to cycloheximide",
  "GO:0071410": "cellular response to cyclopentenone",
  "GO:0071411": "cellular response to fluoxetine",
  "GO:0071412": "cellular response to genistein",
  "GO:0071413": "cellular response to hydroxyisoflavone",
  "GO:0071414": "cellular response to methotrexate",
  "GO:0071415": "cellular response to purine-containing compound",
  "GO:0071416": "cellular response to tropane",
  "GO:0071417": "cellular response to organonitrogen compound",
  "GO:0071418": "cellular response to amine stimulus",
  "GO:0071419": "cellular response to amphetamine",
  "GO:0071420": "cellular response to histamine",
  "GO:0071421": "manganese ion transmembrane transport",
  "GO:0071422": "succinate transmembrane transport",
  "GO:0071423": "malate transmembrane transport",
  "GO:0071424": "rRNA (cytosine-N4-)-methyltransferase activity",
  "GO:0071425": "hematopoietic stem cell proliferation",
  "GO:0071426": "ribonucleoprotein complex export from nucleus",
  "GO:0071427": "mRNA-containing ribonucleoprotein complex export from nucleus",
  "GO:0071428": "rRNA-containing ribonucleoprotein complex export from nucleus",
  "GO:0071429": "snRNA-containing ribonucleoprotein complex export from nucleus",
  "GO:0071430": "pre-miRNA-containing ribonucleoprotein complex export from nucleus",
  "GO:0071431": "tRNA-containing ribonucleoprotein complex export from nucleus",
  "GO:0071432": "peptide mating pheromone maturation involved in conjugation with cellular fusion",
  "GO:0071433": "cell wall repair",
  "GO:0071434": "cell chemotaxis to angiotensin",
  "GO:0071435": "potassium ion export",
  "GO:0071436": "sodium ion export",
  "GO:0071437": "invadopodium",
  "GO:0071438": "invadopodium membrane",
  "GO:0071439": "clathrin complex",
  "GO:0071440": "regulation of histone H3-K14 acetylation",
  "GO:0071441": "negative regulation of histone H3-K14 acetylation",
  "GO:0071442": "positive regulation of histone H3-K14 acetylation",
  "GO:0071443": "tDNA binding",
  "GO:0071444": "cellular response to pheromone",
  "GO:0071445": "obsolete cellular response to protein stimulus",
  "GO:0071446": "cellular response to salicylic acid stimulus",
  "GO:0071447": "cellular response to hydroperoxide",
  "GO:0071448": "cellular response to alkyl hydroperoxide",
  "GO:0071449": "cellular response to lipid hydroperoxide",
  "GO:0071450": "cellular response to oxygen radical",
  "GO:0071451": "cellular response to superoxide",
  "GO:0071452": "cellular response to singlet oxygen",
  "GO:0071453": "cellular response to oxygen levels",
  "GO:0071454": "cellular response to anoxia",
  "GO:0071455": "cellular response to hyperoxia",
  "GO:0071456": "cellular response to hypoxia",
  "GO:0071457": "cellular response to ozone",
  "GO:0071458": "integral component of cytoplasmic side of endoplasmic reticulum membrane",
  "GO:0071459": "protein localization to chromosome, centromeric region",
  "GO:0071460": "cellular response to cell-matrix adhesion",
  "GO:0071461": "cellular response to redox state",
  "GO:0071462": "cellular response to water stimulus",
  "GO:0071463": "cellular response to humidity",
  "GO:0071464": "cellular response to hydrostatic pressure",
  "GO:0071465": "cellular response to desiccation",
  "GO:0071466": "cellular response to xenobiotic stimulus",
  "GO:0071467": "cellular response to pH",
  "GO:0071468": "cellular response to acidic pH",
  "GO:0071469": "cellular response to alkaline pH",
  "GO:0071470": "cellular response to osmotic stress",
  "GO:0071471": "cellular response to non-ionic osmotic stress",
  "GO:0071472": "cellular response to salt stress",
  "GO:0071473": "cellular response to cation stress",
  "GO:0071474": "cellular hyperosmotic response",
  "GO:0071475": "cellular hyperosmotic salinity response",
  "GO:0071476": "cellular hypotonic response",
  "GO:0071477": "cellular hypotonic salinity response",
  "GO:0071478": "cellular response to radiation",
  "GO:0071479": "cellular response to ionizing radiation",
  "GO:0071480": "cellular response to gamma radiation",
  "GO:0071481": "cellular response to X-ray",
  "GO:0071482": "cellular response to light stimulus",
  "GO:0071483": "cellular response to blue light",
  "GO:0071484": "cellular response to light intensity",
  "GO:0071485": "cellular response to absence of light",
  "GO:0071486": "cellular response to high light intensity",
  "GO:0071487": "cellular response to low light intensity stimulus",
  "GO:0071488": "cellular response to very low light intensity stimulus",
  "GO:0071489": "cellular response to red or far red light",
  "GO:0071490": "cellular response to far red light",
  "GO:0071491": "cellular response to red light",
  "GO:0071492": "cellular response to UV-A",
  "GO:0071493": "cellular response to UV-B",
  "GO:0071494": "cellular response to UV-C",
  "GO:0071495": "cellular response to endogenous stimulus",
  "GO:0071496": "cellular response to external stimulus",
  "GO:0071497": "cellular response to freezing",
  "GO:0071498": "cellular response to fluid shear stress",
  "GO:0071499": "cellular response to laminar fluid shear stress",
  "GO:0071500": "cellular response to nitrosative stress",
  "GO:0071501": "cellular response to sterol depletion",
  "GO:0071502": "cellular response to temperature stimulus",
  "GO:0071503": "response to heparin",
  "GO:0071504": "cellular response to heparin",
  "GO:0071505": "response to mycophenolic acid",
  "GO:0071506": "cellular response to mycophenolic acid",
  "GO:0071507": "MAPK cascade involved in conjugation with cellular fusion",
  "GO:0071508": "activation of MAPK activity involved in conjugation with cellular fusion",
  "GO:0071509": "activation of MAPKK activity involved in conjugation with cellular fusion",
  "GO:0071510": "activation of MAPKKK activity involved in conjugation with cellular fusion",
  "GO:0071511": "inactivation of MAPK activity involved in conjugation with cellular fusion",
  "GO:0071512": "MAPK import into nucleus involved in conjugation with cellular fusion",
  "GO:0071513": "phosphopantothenoylcysteine decarboxylase complex",
  "GO:0071514": "genetic imprinting",
  "GO:0071515": "genetic imprinting at mating-type locus",
  "GO:0071516": "establishment of imprinting at mating-type locus",
  "GO:0071517": "maintenance of imprinting at mating-type locus",
  "GO:0071518": "autoinducer-2 kinase activity",
  "GO:0071519": "actomyosin contractile ring actin filament bundle assembly",
  "GO:0071520": "actomyosin contractile ring assembly actin filament bundle convergence",
  "GO:0071521": "Cdc42 GTPase complex",
  "GO:0071522": "ureidoglycine aminohydrolase activity",
  "GO:0071523": "TIR domain-mediated complex assembly",
  "GO:0071524": "pyrrolysine biosynthetic process",
  "GO:0071525": "pyrrolysine metabolic process",
  "GO:0071526": "semaphorin-plexin signaling pathway",
  "GO:0071527": "semaphorin-plexin signaling pathway involved in outflow tract morphogenesis",
  "GO:0071528": "tRNA re-export from nucleus",
  "GO:0071529": "cementum mineralization",
  "GO:0071530": "FHA domain-mediated complex assembly",
  "GO:0071531": "Rel homology domain-mediated complex assembly",
  "GO:0071532": "ankyrin repeat binding",
  "GO:0071533": "ankyrin repeat-mediated complex assembly",
  "GO:0071534": "zf-TRAF domain-mediated complex assembly",
  "GO:0071535": "RING-like zinc finger domain binding",
  "GO:0071536": "RING-like zinc finger domain-mediated complex assembly",
  "GO:0071537": "C3HC4-type RING finger domain-mediated complex assembly",
  "GO:0071538": "SH2 domain-mediated complex assembly",
  "GO:0071539": "protein localization to centrosome",
  "GO:0071540": "eukaryotic translation initiation factor 3 complex, eIF3e",
  "GO:0071541": "eukaryotic translation initiation factor 3 complex, eIF3m",
  "GO:0071542": "dopaminergic neuron differentiation",
  "GO:0071543": "diphosphoinositol polyphosphate metabolic process",
  "GO:0071544": "diphosphoinositol polyphosphate catabolic process",
  "GO:0071545": "inositol phosphate catabolic process",
  "GO:0071546": "pi-body",
  "GO:0071547": "piP-body",
  "GO:0071548": "response to dexamethasone",
  "GO:0071549": "cellular response to dexamethasone stimulus",
  "GO:0071550": "death-inducing signaling complex assembly",
  "GO:0071551": "RIP homotypic interaction motif binding",
  "GO:0071552": "RIP homotypic interaction motif-mediated complex assembly",
  "GO:0071553": "G-protein coupled pyrimidinergic nucleotide receptor activity",
  "GO:0071554": "cell wall organization or biogenesis",
  "GO:0071555": "cell wall organization",
  "GO:0071556": "integral component of lumenal side of endoplasmic reticulum membrane",
  "GO:0071557": "histone H3-K27 demethylation",
  "GO:0071558": "histone demethylase activity (H3-K27 specific)",
  "GO:0071559": "response to transforming growth factor beta",
  "GO:0071560": "cellular response to transforming growth factor beta stimulus",
  "GO:0071561": "nucleus-vacuole junction",
  "GO:0071562": "nucleus-vacuole junction assembly",
  "GO:0071563": "Myo2p-Vac17p-Vac8p transport complex",
  "GO:0071564": "npBAF complex",
  "GO:0071565": "nBAF complex",
  "GO:0071566": "UFM1 activating enzyme activity",
  "GO:0071567": "UFM1 hydrolase activity",
  "GO:0071568": "UFM1 transferase activity",
  "GO:0071569": "protein ufmylation",
  "GO:0071570": "cement gland development",
  "GO:0071571": "LRR domain-mediated complex assembly",
  "GO:0071572": "histone H3-K56 deacetylation",
  "GO:0071573": "telosome assembly",
  "GO:0071574": "protein localization to medial cortex",
  "GO:0071575": "integral component of external side of plasma membrane",
  "GO:0071576": "tetrahydrodictyopterin binding",
  "GO:0071577": "zinc II ion transmembrane transport",
  "GO:0071578": "zinc II ion transmembrane import",
  "GO:0071579": "regulation of zinc ion transport",
  "GO:0071580": "regulation of zinc ion transmembrane transport",
  "GO:0071581": "regulation of zinc ion transmembrane import",
  "GO:0071582": "negative regulation of zinc ion transport",
  "GO:0071583": "negative regulation of zinc ion transmembrane transport",
  "GO:0071584": "negative regulation of zinc ion transmembrane import",
  "GO:0071585": "detoxification of cadmium ion",
  "GO:0071586": "CAAX-box protein processing",
  "GO:0071587": "CAAX-box protein modification",
  "GO:0071588": "hydrogen peroxide mediated signaling pathway",
  "GO:0071589": "pyridine nucleoside biosynthetic process",
  "GO:0071590": "nicotinamide riboside biosynthetic process",
  "GO:0071591": "nicotinic acid riboside metabolic process",
  "GO:0071592": "nicotinic acid riboside biosynthetic process",
  "GO:0071593": "lymphocyte aggregation",
  "GO:0071594": "thymocyte aggregation",
  "GO:0071595": "Nem1-Spo7 phosphatase complex",
  "GO:0071596": "ubiquitin-dependent protein catabolic process via the N-end rule pathway",
  "GO:0071597": "cellular birth scar",
  "GO:0071598": "neuronal ribonucleoprotein granule",
  "GO:0071599": "otic vesicle development",
  "GO:0071600": "otic vesicle morphogenesis",
  "GO:0071601": "sphere organelle",
  "GO:0071602": "phytosphingosine biosynthetic process",
  "GO:0071603": "endothelial cell-cell adhesion",
  "GO:0071604": "transforming growth factor beta production",
  "GO:0071605": "monocyte chemotactic protein-1 production",
  "GO:0071606": "chemokine (C-C motif) ligand 4 production",
  "GO:0071607": "macrophage inflammatory protein-1 gamma production",
  "GO:0071608": "macrophage inflammatory protein-1 alpha production",
  "GO:0071609": "chemokine (C-C motif) ligand 5 production",
  "GO:0071610": "chemokine (C-C motif) ligand 1 production",
  "GO:0071611": "granulocyte colony-stimulating factor production",
  "GO:0071612": "IP-10 production",
  "GO:0071613": "granzyme B production",
  "GO:0071614": "linoleic acid epoxygenase activity",
  "GO:0071615": "oxidative deethylation",
  "GO:0071616": "acyl-CoA biosynthetic process",
  "GO:0071617": "lysophospholipid acyltransferase activity",
  "GO:0071618": "lysophosphatidylethanolamine acyltransferase activity",
  "GO:0071619": "phosphorylation of RNA polymerase II C-terminal domain serine 2 residues",
  "GO:0071620": "phosphorylation of RNA polymerase II C-terminal domain serine 5 residues",
  "GO:0071621": "granulocyte chemotaxis",
  "GO:0071622": "regulation of granulocyte chemotaxis",
  "GO:0071623": "negative regulation of granulocyte chemotaxis",
  "GO:0071624": "positive regulation of granulocyte chemotaxis",
  "GO:0071625": "vocalization behavior",
  "GO:0071626": "mastication",
  "GO:0071627": "integral component of fungal-type vacuolar membrane",
  "GO:0071628": "intrinsic component of fungal-type vacuolar membrane",
  "GO:0071629": "cytoplasm-associated proteasomal ubiquitin-dependent protein catabolic process",
  "GO:0071630": "nucleus-associated proteasomal ubiquitin-dependent protein catabolic process",
  "GO:0071631": "mating pheromone secretion involved in conjugation with cellular fusion",
  "GO:0071632": "optomotor response",
  "GO:0071633": "dihydroceramidase activity",
  "GO:0071634": "regulation of transforming growth factor beta production",
  "GO:0071635": "negative regulation of transforming growth factor beta production",
  "GO:0071636": "positive regulation of transforming growth factor beta production",
  "GO:0071637": "regulation of monocyte chemotactic protein-1 production",
  "GO:0071638": "negative regulation of monocyte chemotactic protein-1 production",
  "GO:0071639": "positive regulation of monocyte chemotactic protein-1 production",
  "GO:0071640": "regulation of macrophage inflammatory protein 1 alpha production",
  "GO:0071641": "negative regulation of macrophage inflammatory protein 1 alpha production",
  "GO:0071642": "positive regulation of macrophage inflammatory protein 1 alpha production",
  "GO:0071643": "regulation of chemokine (C-C motif) ligand 4 production",
  "GO:0071644": "negative regulation of chemokine (C-C motif) ligand 4 production",
  "GO:0071645": "positive regulation of chemokine (C-C motif) ligand 4 production",
  "GO:0071646": "regulation of macrophage inflammatory protein-1 gamma production",
  "GO:0071647": "negative regulation of macrophage inflammatory protein-1 gamma production",
  "GO:0071648": "positive regulation of macrophage inflammatory protein-1 gamma production",
  "GO:0071649": "regulation of chemokine (C-C motif) ligand 5 production",
  "GO:0071650": "negative regulation of chemokine (C-C motif) ligand 5 production",
  "GO:0071651": "positive regulation of chemokine (C-C motif) ligand 5 production",
  "GO:0071652": "regulation of chemokine (C-C motif) ligand 1 production",
  "GO:0071653": "negative regulation of chemokine (C-C motif) ligand 1 production",
  "GO:0071654": "positive regulation of chemokine (C-C motif) ligand 1 production",
  "GO:0071655": "regulation of granulocyte colony-stimulating factor production",
  "GO:0071656": "negative regulation of granulocyte colony-stimulating factor production",
  "GO:0071657": "positive regulation of granulocyte colony-stimulating factor production",
  "GO:0071658": "regulation of IP-10 production",
  "GO:0071659": "negative regulation of IP-10 production",
  "GO:0071660": "positive regulation of IP-10 production",
  "GO:0071661": "regulation of granzyme B production",
  "GO:0071662": "negative regulation of granzyme B production",
  "GO:0071663": "positive regulation of granzyme B production",
  "GO:0071664": "catenin-TCF7L2 complex",
  "GO:0071665": "gamma-catenin-TCF7L2 complex",
  "GO:0071666": "Slit-Robo signaling complex",
  "GO:0071667": "DNA/RNA hybrid binding",
  "GO:0071668": "plant-type cell wall assembly",
  "GO:0071669": "plant-type cell wall organization or biogenesis",
  "GO:0071670": "smooth muscle cell chemotaxis",
  "GO:0071671": "regulation of smooth muscle cell chemotaxis",
  "GO:0071672": "negative regulation of smooth muscle cell chemotaxis",
  "GO:0071673": "positive regulation of smooth muscle cell chemotaxis",
  "GO:0071674": "mononuclear cell migration",
  "GO:0071675": "regulation of mononuclear cell migration",
  "GO:0071676": "negative regulation of mononuclear cell migration",
  "GO:0071677": "positive regulation of mononuclear cell migration",
  "GO:0071678": "olfactory bulb axon guidance",
  "GO:0071679": "commissural neuron axon guidance",
  "GO:0071680": "response to indole-3-methanol",
  "GO:0071681": "cellular response to indole-3-methanol",
  "GO:0071682": "endocytic vesicle lumen",
  "GO:0071683": "sensory dendrite",
  "GO:0071684": "organism emergence from protective structure",
  "GO:0071685": "NADH dehydrogenase complex (plastoquinone)",
  "GO:0071686": "horsetail nucleus",
  "GO:0071687": "horsetail nucleus leading edge",
  "GO:0071688": "striated muscle myosin thick filament assembly",
  "GO:0071689": "muscle thin filament assembly",
  "GO:0071690": "cardiac muscle myosin thick filament assembly",
  "GO:0071691": "cardiac muscle thin filament assembly",
  "GO:0071692": "protein localization to extracellular region",
  "GO:0071693": "protein transport within extracellular region",
  "GO:0071694": "maintenance of protein location in extracellular region",
  "GO:0071695": "anatomical structure maturation",
  "GO:0071696": "ectodermal placode development",
  "GO:0071697": "ectodermal placode morphogenesis",
  "GO:0071698": "olfactory placode development",
  "GO:0071699": "olfactory placode morphogenesis",
  "GO:0071700": "olfactory placode maturation",
  "GO:0071701": "regulation of MAPK export from nucleus",
  "GO:0071702": "organic substance transport",
  "GO:0071703": "detection of organic substance",
  "GO:0071704": "organic substance metabolic process",
  "GO:0071705": "nitrogen compound transport",
  "GO:0071706": "tumor necrosis factor superfamily cytokine production",
  "GO:0071707": "immunoglobulin heavy chain V-D-J recombination",
  "GO:0071708": "immunoglobulin light chain V-J recombination",
  "GO:0071709": "membrane assembly",
  "GO:0071710": "membrane macromolecule biosynthetic process",
  "GO:0071711": "basement membrane organization",
  "GO:0071712": "ER-associated misfolded protein catabolic process",
  "GO:0071713": "para-aminobenzoyl-glutamate hydrolase activity",
  "GO:0071714": "icosanoid transmembrane transporter activity",
  "GO:0071715": "icosanoid transport",
  "GO:0071716": "leukotriene transport",
  "GO:0071717": "thromboxane transport",
  "GO:0071718": "sodium-independent icosanoid transport",
  "GO:0071719": "sodium-independent leukotriene transport",
  "GO:0071720": "sodium-independent prostaglandin transport",
  "GO:0071721": "sodium-independent thromboxane transport",
  "GO:0071722": "detoxification of arsenic-containing substance",
  "GO:0071723": "lipopeptide binding",
  "GO:0071724": "response to diacyl bacterial lipopeptide",
  "GO:0071725": "response to triacyl bacterial lipopeptide",
  "GO:0071726": "cellular response to diacyl bacterial lipopeptide",
  "GO:0071727": "cellular response to triacyl bacterial lipopeptide",
  "GO:0071728": "beak development",
  "GO:0071729": "beak morphogenesis",
  "GO:0071730": "beak formation",
  "GO:0071731": "response to nitric oxide",
  "GO:0071732": "cellular response to nitric oxide",
  "GO:0071733": "transcriptional activation by promoter-enhancer looping",
  "GO:0071734": "biotin-[pyruvate-carboxylase] ligase activity",
  "GO:0071735": "IgG immunoglobulin complex",
  "GO:0071736": "IgG immunoglobulin complex, circulating",
  "GO:0071737": "IgG B cell receptor complex",
  "GO:0071738": "IgD immunoglobulin complex",
  "GO:0071739": "IgD immunoglobulin complex, circulating",
  "GO:0071740": "IgD B cell receptor complex",
  "GO:0071741": "IgD immunoglobulin complex, GPI-anchored",
  "GO:0071742": "IgE immunoglobulin complex",
  "GO:0071743": "IgE immunoglobulin complex, circulating",
  "GO:0071744": "IgE B cell receptor complex",
  "GO:0071745": "IgA immunoglobulin complex",
  "GO:0071746": "IgA immunoglobulin complex, circulating",
  "GO:0071747": "IgA B cell receptor complex",
  "GO:0071748": "monomeric IgA immunoglobulin complex",
  "GO:0071749": "polymeric IgA immunoglobulin complex",
  "GO:0071750": "dimeric IgA immunoglobulin complex",
  "GO:0071751": "secretory IgA immunoglobulin complex",
  "GO:0071752": "secretory dimeric IgA immunoglobulin complex",
  "GO:0071753": "IgM immunoglobulin complex",
  "GO:0071754": "IgM immunoglobulin complex, circulating",
  "GO:0071755": "IgM B cell receptor complex",
  "GO:0071756": "pentameric IgM immunoglobulin complex",
  "GO:0071757": "hexameric IgM immunoglobulin complex",
  "GO:0071758": "IgW immunoglobulin complex",
  "GO:0071759": "IgX immunoglobulin complex",
  "GO:0071760": "IgY immunoglobulin complex",
  "GO:0071761": "IgZ immunoglobulin complex",
  "GO:0071762": "heavy chain immunoglobulin complex",
  "GO:0071763": "nuclear membrane organization",
  "GO:0071764": "nuclear outer membrane organization",
  "GO:0071765": "nuclear inner membrane organization",
  "GO:0071766": "Actinobacterium-type cell wall biogenesis",
  "GO:0071767": "mycolic acid metabolic process",
  "GO:0071768": "mycolic acid biosynthetic process",
  "GO:0071769": "mycolate cell wall layer assembly",
  "GO:0071770": "DIM/DIP cell wall layer assembly",
  "GO:0071771": "aldehyde decarbonylase activity",
  "GO:0071772": "response to BMP",
  "GO:0071773": "cellular response to BMP stimulus",
  "GO:0071774": "response to fibroblast growth factor",
  "GO:0071778": "obsolete WINAC complex",
  "GO:0071781": "endoplasmic reticulum cisternal network",
  "GO:0071782": "endoplasmic reticulum tubular network",
  "GO:0071783": "endoplasmic reticulum cisternal network organization",
  "GO:0071784": "endoplasmic reticulum cisternal network assembly",
  "GO:0071785": "endoplasmic reticulum cisternal network maintenance",
  "GO:0071786": "endoplasmic reticulum tubular network organization",
  "GO:0071787": "endoplasmic reticulum tubular network assembly",
  "GO:0071788": "endoplasmic reticulum tubular network maintenance",
  "GO:0071789": "spindle pole body localization to nuclear envelope",
  "GO:0071790": "establishment of spindle pole body localization to nuclear envelope",
  "GO:0071791": "chemokine (C-C motif) ligand 5 binding",
  "GO:0071792": "bacillithiol metabolic process",
  "GO:0071793": "bacillithiol biosynthetic process",
  "GO:0071794": "CAP-Gly domain binding",
  "GO:0071795": "K11-linked polyubiquitin binding",
  "GO:0071796": "K6-linked polyubiquitin binding",
  "GO:0071797": "LUBAC complex",
  "GO:0071798": "response to prostaglandin D",
  "GO:0071799": "cellular response to prostaglandin D stimulus",
  "GO:0071800": "podosome assembly",
  "GO:0071801": "regulation of podosome assembly",
  "GO:0071802": "negative regulation of podosome assembly",
  "GO:0071803": "positive regulation of podosome assembly",
  "GO:0071804": "cellular potassium ion transport",
  "GO:0071805": "potassium ion transmembrane transport",
  "GO:0071806": "protein transmembrane transport",
  "GO:0071807": "replication fork arrest involved in DNA replication termination",
  "GO:0071808": "satellite fibril",
  "GO:0071809": "regulation of fever generation by regulation of prostaglandin biosynthesis",
  "GO:0071810": "regulation of fever generation by regulation of prostaglandin secretion",
  "GO:0071811": "positive regulation of fever generation by positive regulation of prostaglandin biosynthesis",
  "GO:0071812": "positive regulation of fever generation by positive regulation of prostaglandin secretion",
  "GO:0071813": "lipoprotein particle binding",
  "GO:0071814": "protein-lipid complex binding",
  "GO:0071815": "intermediate-density lipoprotein particle binding",
  "GO:0071816": "tail-anchored membrane protein insertion into ER membrane",
  "GO:0071817": "MMXD complex",
  "GO:0071818": "BAT3 complex",
  "GO:0071819": "DUBm complex",
  "GO:0071820": "N-box binding",
  "GO:0071821": "FANCM-MHF complex",
  "GO:0071822": "protein complex subunit organization",
  "GO:0071823": "protein-carbohydrate complex subunit organization",
  "GO:0071824": "protein-DNA complex subunit organization",
  "GO:0071825": "protein-lipid complex subunit organization",
  "GO:0071826": "ribonucleoprotein complex subunit organization",
  "GO:0071827": "plasma lipoprotein particle organization",
  "GO:0071828": "apolipoprotein E recycling",
  "GO:0071829": "plasma lipoprotein particle disassembly",
  "GO:0071830": "triglyceride-rich lipoprotein particle clearance",
  "GO:0071831": "intermediate-density lipoprotein particle clearance",
  "GO:0071832": "peptide pheromone export involved in conjugation",
  "GO:0071833": "peptide pheromone export involved in conjugation with cellular fusion",
  "GO:0071834": "mating pheromone secretion",
  "GO:0071835": "mating pheromone secretion involved in conjugation",
  "GO:0071836": "nectar secretion",
  "GO:0071837": "HMG box domain binding",
  "GO:0071838": "cell proliferation in bone marrow",
  "GO:0071839": "apoptotic process in bone marrow",
  "GO:0071840": "cellular component organization or biogenesis",
  "GO:0071846": "actin filament debranching",
  "GO:0071847": "TNFSF11-mediated signaling pathway",
  "GO:0071848": "positive regulation of ERK1 and ERK2 cascade via TNFSF11-mediated signaling",
  "GO:0071849": "G1 cell cycle arrest in response to nitrogen starvation",
  "GO:0071850": "mitotic cell cycle arrest",
  "GO:0071851": "mitotic G1 cell cycle arrest in response to nitrogen starvation",
  "GO:0071852": "fungal-type cell wall organization or biogenesis",
  "GO:0071853": "fungal-type cell wall disassembly",
  "GO:0071854": "cell wall macromolecule catabolic process involved in fungal-type cell wall disassembly",
  "GO:0071855": "neuropeptide receptor binding",
  "GO:0071857": "beta-endorphin receptor binding",
  "GO:0071858": "corazonin receptor binding",
  "GO:0071859": "neuropeptide F receptor binding",
  "GO:0071860": "proctolin receptor binding",
  "GO:0071861": "tachykinin receptor binding",
  "GO:0071862": "protein phosphatase type 1 activator activity",
  "GO:0071863": "regulation of cell proliferation in bone marrow",
  "GO:0071864": "positive regulation of cell proliferation in bone marrow",
  "GO:0071865": "regulation of apoptotic process in bone marrow",
  "GO:0071866": "negative regulation of apoptotic process in bone marrow",
  "GO:0071867": "response to monoamine",
  "GO:0071868": "cellular response to monoamine stimulus",
  "GO:0071869": "response to catecholamine",
  "GO:0071870": "cellular response to catecholamine stimulus",
  "GO:0071871": "response to epinephrine",
  "GO:0071872": "cellular response to epinephrine stimulus",
  "GO:0071873": "response to norepinephrine",
  "GO:0071874": "cellular response to norepinephrine stimulus",
  "GO:0071875": "adrenergic receptor signaling pathway",
  "GO:0071876": "obsolete initiation of adrenergic receptor signal transduction",
  "GO:0071877": "regulation of adrenergic receptor signaling pathway",
  "GO:0071878": "negative regulation of adrenergic receptor signaling pathway",
  "GO:0071879": "positive regulation of adrenergic receptor signaling pathway",
  "GO:0071880": "adenylate cyclase-activating adrenergic receptor signaling pathway",
  "GO:0071881": "adenylate cyclase-inhibiting adrenergic receptor signaling pathway",
  "GO:0071882": "phospholipase C-activating adrenergic receptor signaling pathway",
  "GO:0071883": "activation of MAPK activity by adrenergic receptor signaling pathway",
  "GO:0071884": "vitamin D receptor activator activity",
  "GO:0071885": "N-terminal protein N-methyltransferase activity",
  "GO:0071886": "1-(4-iodo-2,5-dimethoxyphenyl)propan-2-amine binding",
  "GO:0071887": "leukocyte apoptotic process",
  "GO:0071888": "macrophage apoptotic process",
  "GO:0071889": "14-3-3 protein binding",
  "GO:0071890": "bicarbonate binding",
  "GO:0071891": "N-terminal peptidyl-proline dimethylation involved in translation",
  "GO:0071892": "thrombocyte activation",
  "GO:0071893": "BMP signaling pathway involved in nephric duct formation",
  "GO:0071894": "histone H2B conserved C-terminal lysine ubiquitination",
  "GO:0071895": "odontoblast differentiation",
  "GO:0071896": "protein localization to adherens junction",
  "GO:0071897": "DNA biosynthetic process",
  "GO:0071898": "regulation of estrogen receptor binding",
  "GO:0071899": "negative regulation of estrogen receptor binding",
  "GO:0071900": "regulation of protein serine/threonine kinase activity",
  "GO:0071901": "negative regulation of protein serine/threonine kinase activity",
  "GO:0071902": "positive regulation of protein serine/threonine kinase activity",
  "GO:0071903": "protein N-linked N-acetylglucosaminylation via asparagine",
  "GO:0071904": "protein N-linked N-acetylgalactosaminylation via asparagine",
  "GO:0071905": "protein N-linked glucosylation via asparagine",
  "GO:0071906": "CRD domain binding",
  "GO:0071907": "determination of digestive tract left/right asymmetry",
  "GO:0071908": "determination of intestine left/right asymmetry",
  "GO:0071909": "determination of stomach left/right asymmetry",
  "GO:0071910": "determination of liver left/right asymmetry",
  "GO:0071911": "synchronous neurotransmitter secretion",
  "GO:0071912": "asynchronous neurotransmitter secretion",
  "GO:0071913": "citrate secondary active transmembrane transporter activity",
  "GO:0071914": "prominosome",
  "GO:0071915": "protein-lysine lysylation",
  "GO:0071916": "dipeptide transmembrane transporter activity",
  "GO:0071917": "triose-phosphate transmembrane transporter activity",
  "GO:0071918": "urea transmembrane transport",
  "GO:0071919": "G-quadruplex DNA formation",
  "GO:0071920": "cleavage body",
  "GO:0071921": "cohesin localization to chromatin",
  "GO:0071922": "regulation of cohesin localization to chromatin",
  "GO:0071923": "negative regulation of cohesin localization to chromatin",
  "GO:0071924": "chemokine (C-C motif) ligand 22 production",
  "GO:0071925": "thymic stromal lymphopoietin production",
  "GO:0071926": "endocannabinoid signaling pathway",
  "GO:0071927": "octopamine signaling pathway",
  "GO:0071928": "tyramine signaling pathway",
  "GO:0071929": "alpha-tubulin acetylation",
  "GO:0071930": "negative regulation of transcription involved in G1/S transition of mitotic cell cycle",
  "GO:0071931": "positive regulation of transcription involved in G1/S transition of mitotic cell cycle",
  "GO:0071932": "replication fork reversal",
  "GO:0071933": "Arp2/3 complex binding",
  "GO:0071934": "thiamine transmembrane transport",
  "GO:0071935": "octopamine signaling pathway involved in response to food",
  "GO:0071936": "coreceptor activity involved in Wnt signaling pathway",
  "GO:0071938": "vitamin A transport",
  "GO:0071939": "vitamin A import",
  "GO:0071940": "fungal-type cell wall assembly",
  "GO:0071941": "nitrogen cycle metabolic process",
  "GO:0071942": "XPC complex",
  "GO:0071943": "Myc-Max complex",
  "GO:0071944": "cell periphery",
  "GO:0071945": "regulation of bacterial-type flagellum-dependent cell motility by regulation of motor speed",
  "GO:0071946": "cis-acting DNA replication termination",
  "GO:0071947": "protein deubiquitination involved in ubiquitin-dependent protein catabolic process",
  "GO:0071948": "activation-induced B cell apoptotic process",
  "GO:0071949": "FAD binding",
  "GO:0071950": "FADH2 binding",
  "GO:0071951": "conversion of methionyl-tRNA to N-formyl-methionyl-tRNA",
  "GO:0071952": "conversion of O-phosphoseryl-tRNA to cysteinyl-tRNA",
  "GO:0071953": "elastic fiber",
  "GO:0071954": "chemokine (C-C motif) ligand 11 production",
  "GO:0071955": "recycling endosome to Golgi transport",
  "GO:0071957": "old mitotic spindle pole body",
  "GO:0071958": "new mitotic spindle pole body",
  "GO:0071959": "maintenance of mitotic sister chromatid cohesion, arms",
  "GO:0071960": "maintenance of mitotic sister chromatid cohesion, centromeric",
  "GO:0071961": "mitotic sister chromatid cohesion, arms",
  "GO:0071962": "mitotic sister chromatid cohesion, centromeric",
  "GO:0071963": "establishment or maintenance of cell polarity regulating cell shape",
  "GO:0071964": "establishment of cell polarity regulating cell shape",
  "GO:0071965": "multicellular organismal locomotion",
  "GO:0071966": "fungal-type cell wall polysaccharide metabolic process",
  "GO:0071967": "lipopolysaccharide core heptosyltransferase activity",
  "GO:0071968": "lipid A-core heptosyltransferase activity",
  "GO:0071969": "fungal-type cell wall (1->3)-beta-D-glucan metabolic process",
  "GO:0071970": "fungal-type cell wall (1->3)-beta-D-glucan biosynthetic process",
  "GO:0071971": "extracellular exosome assembly",
  "GO:0071972": "peptidoglycan L,D-transpeptidase activity",
  "GO:0071973": "bacterial-type flagellum-dependent cell motility",
  "GO:0071975": "cell swimming",
  "GO:0071976": "cell gliding",
  "GO:0071977": "bacterial-type flagellum-dependent swimming motility",
  "GO:0071978": "bacterial-type flagellum-dependent swarming motility",
  "GO:0071979": "cytoskeleton-mediated cell swimming",
  "GO:0071980": "cell surface adhesin-mediated gliding motility",
  "GO:0071981": "exit from diapause",
  "GO:0071982": "maintenance of diapause",
  "GO:0071983": "exit from reproductive diapause",
  "GO:0071984": "maintenance of reproductive diapause",
  "GO:0071985": "multivesicular body sorting pathway",
  "GO:0071986": "Ragulator complex",
  "GO:0071987": "WD40-repeat domain binding",
  "GO:0071988": "protein localization to spindle pole body",
  "GO:0071989": "establishment of protein localization to spindle pole body",
  "GO:0071990": "maintenance of protein location in spindle pole body",
  "GO:0071991": "phytochelatin transporter activity",
  "GO:0071992": "phytochelatin transmembrane transporter activity",
  "GO:0071993": "phytochelatin transport",
  "GO:0071994": "phytochelatin transmembrane transport",
  "GO:0071995": "phytochelatin import into vacuole",
  "GO:0071996": "glutathione transmembrane import into vacuole",
  "GO:0071997": "glutathione S-conjugate-transporting ATPase activity",
  "GO:0071998": "ascospore release from ascus",
  "GO:0071999": "extracellular polysaccharide catabolic process",
  "GO:0072000": "extracellular polysaccharide catabolic process involved in ascospore release from ascus",
  "GO:0072001": "renal system development",
  "GO:0072002": "Malpighian tubule development",
  "GO:0072003": "kidney rudiment formation",
  "GO:0072004": "kidney field specification",
  "GO:0072005": "maintenance of kidney identity",
  "GO:0072006": "nephron development",
  "GO:0072007": "mesangial cell differentiation",
  "GO:0072008": "glomerular mesangial cell differentiation",
  "GO:0072009": "nephron epithelium development",
  "GO:0072010": "glomerular epithelium development",
  "GO:0072011": "glomerular endothelium development",
  "GO:0072012": "glomerulus vasculature development",
  "GO:0072013": "glomus development",
  "GO:0072014": "proximal tubule development",
  "GO:0072015": "glomerular visceral epithelial cell development",
  "GO:0072016": "glomerular parietal epithelial cell development",
  "GO:0072017": "distal tubule development",
  "GO:0072019": "proximal convoluted tubule development",
  "GO:0072020": "proximal straight tubule development",
  "GO:0072021": "ascending thin limb development",
  "GO:0072022": "descending thin limb development",
  "GO:0072023": "thick ascending limb development",
  "GO:0072024": "macula densa development",
  "GO:0072025": "distal convoluted tubule development",
  "GO:0072027": "connecting tubule development",
  "GO:0072028": "nephron morphogenesis",
  "GO:0072029": "long nephron development",
  "GO:0072030": "short nephron development",
  "GO:0072031": "proximal convoluted tubule segment 1 development",
  "GO:0072032": "proximal convoluted tubule segment 2 development",
  "GO:0072033": "renal vesicle formation",
  "GO:0072034": "renal vesicle induction",
  "GO:0072035": "pre-tubular aggregate formation",
  "GO:0072036": "mesenchymal to epithelial transition involved in renal vesicle formation",
  "GO:0072037": "mesenchymal stem cell differentiation involved in nephron morphogenesis",
  "GO:0072038": "mesenchymal stem cell maintenance involved in nephron morphogenesis",
  "GO:0072039": "regulation of mesenchymal cell apoptotic process involved in nephron morphogenesis",
  "GO:0072040": "negative regulation of mesenchymal cell apoptotic process involved in nephron morphogenesis",
  "GO:0072041": "positive regulation of mesenchymal cell apoptotic process involved in nephron morphogenesis",
  "GO:0072042": "regulation of mesenchymal stem cell proliferation involved in nephron morphogenesis",
  "GO:0072043": "regulation of pre-tubular aggregate formation by cell-cell signaling",
  "GO:0072044": "collecting duct development",
  "GO:0072045": "convergent extension involved in nephron morphogenesis",
  "GO:0072046": "establishment of planar polarity involved in nephron morphogenesis",
  "GO:0072047": "proximal/distal pattern formation involved in nephron development",
  "GO:0072048": "renal system pattern specification",
  "GO:0072049": "comma-shaped body morphogenesis",
  "GO:0072050": "S-shaped body morphogenesis",
  "GO:0072051": "juxtaglomerular apparatus development",
  "GO:0072052": "juxtaglomerulus cell differentiation",
  "GO:0072053": "renal inner medulla development",
  "GO:0072054": "renal outer medulla development",
  "GO:0072055": "renal cortex development",
  "GO:0072056": "pyramid development",
  "GO:0072057": "inner stripe development",
  "GO:0072058": "outer stripe development",
  "GO:0072059": "cortical collecting duct development",
  "GO:0072060": "outer medullary collecting duct development",
  "GO:0072061": "inner medullary collecting duct development",
  "GO:0072062": "proximal convoluted tubule segment 1 cell differentiation",
  "GO:0072063": "short descending thin limb development",
  "GO:0072064": "long descending thin limb development",
  "GO:0072065": "long descending thin limb bend development",
  "GO:0072066": "prebend segment development",
  "GO:0072067": "early distal convoluted tubule development",
  "GO:0072068": "late distal convoluted tubule development",
  "GO:0072069": "DCT cell differentiation",
  "GO:0072070": "loop of Henle development",
  "GO:0072071": "kidney interstitial fibroblast differentiation",
  "GO:0072072": "kidney stroma development",
  "GO:0072073": "kidney epithelium development",
  "GO:0072074": "kidney mesenchyme development",
  "GO:0072075": "metanephric mesenchyme development",
  "GO:0072076": "nephrogenic mesenchyme development",
  "GO:0072077": "renal vesicle morphogenesis",
  "GO:0072078": "nephron tubule morphogenesis",
  "GO:0072079": "nephron tubule formation",
  "GO:0072080": "nephron tubule development",
  "GO:0072081": "specification of nephron tubule identity",
  "GO:0072082": "specification of proximal tubule identity",
  "GO:0072084": "specification of distal tubule identity",
  "GO:0072085": "specification of connecting tubule identity",
  "GO:0072086": "specification of loop of Henle identity",
  "GO:0072087": "renal vesicle development",
  "GO:0072088": "nephron epithelium morphogenesis",
  "GO:0072089": "stem cell proliferation",
  "GO:0072090": "mesenchymal stem cell proliferation involved in nephron morphogenesis",
  "GO:0072091": "regulation of stem cell proliferation",
  "GO:0072092": "ureteric bud invasion",
  "GO:0072093": "metanephric renal vesicle formation",
  "GO:0072094": "metanephric renal vesicle induction",
  "GO:0072095": "regulation of branch elongation involved in ureteric bud branching",
  "GO:0072096": "negative regulation of branch elongation involved in ureteric bud branching",
  "GO:0072097": "negative regulation of branch elongation involved in ureteric bud branching by BMP signaling pathway",
  "GO:0072098": "anterior/posterior pattern specification involved in kidney development",
  "GO:0072099": "anterior/posterior pattern specification involved in ureteric bud development",
  "GO:0072100": "specification of ureteric bud anterior/posterior symmetry",
  "GO:0072101": "specification of ureteric bud anterior/posterior symmetry by BMP signaling pathway",
  "GO:0072102": "glomerulus morphogenesis",
  "GO:0072103": "glomerulus vasculature morphogenesis",
  "GO:0072104": "glomerular capillary formation",
  "GO:0072105": "ureteric peristalsis",
  "GO:0072106": "regulation of ureteric bud formation",
  "GO:0072107": "positive regulation of ureteric bud formation",
  "GO:0072108": "positive regulation of mesenchymal to epithelial transition involved in metanephros morphogenesis",
  "GO:0072109": "glomerular mesangium development",
  "GO:0072110": "glomerular mesangial cell proliferation",
  "GO:0072111": "cell proliferation involved in kidney development",
  "GO:0072112": "glomerular visceral epithelial cell differentiation",
  "GO:0072113": "head kidney development",
  "GO:0072114": "pronephros morphogenesis",
  "GO:0072115": "head kidney morphogenesis",
  "GO:0072116": "pronephros formation",
  "GO:0072117": "head kidney formation",
  "GO:0072118": "pronephros structural organization",
  "GO:0072119": "head kidney structural organization",
  "GO:0072120": "pronephros maturation",
  "GO:0072121": "head kidney maturation",
  "GO:0072122": "extraglomerular mesangial cell proliferation",
  "GO:0072123": "intraglomerular mesangial cell proliferation",
  "GO:0072124": "regulation of glomerular mesangial cell proliferation",
  "GO:0072125": "negative regulation of glomerular mesangial cell proliferation",
  "GO:0072126": "positive regulation of glomerular mesangial cell proliferation",
  "GO:0072127": "renal capsule development",
  "GO:0072128": "renal capsule morphogenesis",
  "GO:0072129": "renal capsule formation",
  "GO:0072130": "renal capsule specification",
  "GO:0072131": "kidney mesenchyme morphogenesis",
  "GO:0072132": "mesenchyme morphogenesis",
  "GO:0072133": "metanephric mesenchyme morphogenesis",
  "GO:0072134": "nephrogenic mesenchyme morphogenesis",
  "GO:0072135": "kidney mesenchymal cell proliferation",
  "GO:0072136": "metanephric mesenchymal cell proliferation involved in metanephros development",
  "GO:0072137": "condensed mesenchymal cell proliferation",
  "GO:0072138": "mesenchymal cell proliferation involved in ureteric bud development",
  "GO:0072139": "glomerular parietal epithelial cell differentiation",
  "GO:0072140": "DCT cell development",
  "GO:0072141": "renal interstitial fibroblast development",
  "GO:0072142": "juxtaglomerulus cell development",
  "GO:0072143": "mesangial cell development",
  "GO:0072144": "glomerular mesangial cell development",
  "GO:0072145": "proximal convoluted tubule segment 1 cell development",
  "GO:0072146": "DCT cell fate commitment",
  "GO:0072147": "glomerular parietal epithelial cell fate commitment",
  "GO:0072148": "epithelial cell fate commitment",
  "GO:0072149": "glomerular visceral epithelial cell fate commitment",
  "GO:0072150": "juxtaglomerulus cell fate commitment",
  "GO:0072151": "mesangial cell fate commitment",
  "GO:0072152": "glomerular mesangial cell fate commitment",
  "GO:0072153": "renal interstitial fibroblast fate commitment",
  "GO:0072154": "proximal convoluted tubule segment 1 cell fate commitment",
  "GO:0072155": "epithelial cell migration involved in nephron tubule morphogenesis",
  "GO:0072156": "distal tubule morphogenesis",
  "GO:0072157": "epithelial cell migration involved in distal tubule morphogenesis",
  "GO:0072158": "proximal tubule morphogenesis",
  "GO:0072159": "epithelial cell migration involved in proximal tubule morphogenesis",
  "GO:0072160": "nephron tubule epithelial cell differentiation",
  "GO:0072161": "mesenchymal cell differentiation involved in kidney development",
  "GO:0072162": "metanephric mesenchymal cell differentiation",
  "GO:0072163": "mesonephric epithelium development",
  "GO:0072164": "mesonephric tubule development",
  "GO:0072165": "anterior mesonephric tubule development",
  "GO:0072166": "posterior mesonephric tubule development",
  "GO:0072167": "specification of mesonephric tubule identity",
  "GO:0072168": "specification of anterior mesonephric tubule identity",
  "GO:0072169": "specification of posterior mesonephric tubule identity",
  "GO:0072170": "metanephric tubule development",
  "GO:0072171": "mesonephric tubule morphogenesis",
  "GO:0072172": "mesonephric tubule formation",
  "GO:0072173": "metanephric tubule morphogenesis",
  "GO:0072174": "metanephric tubule formation",
  "GO:0072175": "epithelial tube formation",
  "GO:0072176": "nephric duct development",
  "GO:0072177": "mesonephric duct development",
  "GO:0072178": "nephric duct morphogenesis",
  "GO:0072179": "nephric duct formation",
  "GO:0072180": "mesonephric duct morphogenesis",
  "GO:0072181": "mesonephric duct formation",
  "GO:0072182": "regulation of nephron tubule epithelial cell differentiation",
  "GO:0072183": "negative regulation of nephron tubule epithelial cell differentiation",
  "GO:0072184": "renal vesicle progenitor cell differentiation",
  "GO:0072185": "metanephric cap development",
  "GO:0072186": "metanephric cap morphogenesis",
  "GO:0072187": "metanephric cap formation",
  "GO:0072188": "metanephric cap specification",
  "GO:0072189": "ureter development",
  "GO:0072190": "ureter urothelium development",
  "GO:0072191": "ureter smooth muscle development",
  "GO:0072192": "ureter epithelial cell differentiation",
  "GO:0072193": "ureter smooth muscle cell differentiation",
  "GO:0072194": "kidney smooth muscle tissue development",
  "GO:0072195": "kidney smooth muscle cell differentiation",
  "GO:0072196": "proximal/distal pattern formation involved in pronephric nephron development",
  "GO:0072197": "ureter morphogenesis",
  "GO:0072198": "mesenchymal cell proliferation involved in ureter development",
  "GO:0072199": "regulation of mesenchymal cell proliferation involved in ureter development",
  "GO:0072200": "negative regulation of mesenchymal cell proliferation involved in ureter development",
  "GO:0072201": "negative regulation of mesenchymal cell proliferation",
  "GO:0072202": "cell differentiation involved in metanephros development",
  "GO:0072203": "cell proliferation involved in metanephros development",
  "GO:0072204": "cell-cell signaling involved in metanephros development",
  "GO:0072205": "metanephric collecting duct development",
  "GO:0072206": "metanephric juxtaglomerular apparatus development",
  "GO:0072207": "metanephric epithelium development",
  "GO:0072208": "metanephric smooth muscle tissue development",
  "GO:0072209": "metanephric mesangial cell differentiation",
  "GO:0072210": "metanephric nephron development",
  "GO:0072211": "metanephric pyramids development",
  "GO:0072212": "regulation of transcription from RNA polymerase II promoter involved in metanephros development",
  "GO:0072213": "metanephric capsule development",
  "GO:0072214": "metanephric cortex development",
  "GO:0072215": "regulation of metanephros development",
  "GO:0072216": "positive regulation of metanephros development",
  "GO:0072217": "negative regulation of metanephros development",
  "GO:0072218": "metanephric ascending thin limb development",
  "GO:0072219": "metanephric cortical collecting duct development",
  "GO:0072220": "metanephric descending thin limb development",
  "GO:0072221": "metanephric distal convoluted tubule development",
  "GO:0072222": "metanephric early distal convoluted tubule development",
  "GO:0072223": "metanephric glomerular mesangium development",
  "GO:0072224": "metanephric glomerulus development",
  "GO:0072225": "metanephric late distal convoluted tubule development",
  "GO:0072226": "metanephric long descending thin limb bend development",
  "GO:0072227": "metanephric macula densa development",
  "GO:0072228": "metanephric prebend segment development",
  "GO:0072229": "metanephric proximal convoluted tubule development",
  "GO:0072230": "metanephric proximal straight tubule development",
  "GO:0072231": "metanephric proximal convoluted tubule segment 1 development",
  "GO:0072232": "metanephric proximal convoluted tubule segment 2 development",
  "GO:0072233": "metanephric thick ascending limb development",
  "GO:0072234": "metanephric nephron tubule development",
  "GO:0072235": "metanephric distal tubule development",
  "GO:0072236": "metanephric loop of Henle development",
  "GO:0072237": "metanephric proximal tubule development",
  "GO:0072238": "metanephric long nephron development",
  "GO:0072239": "metanephric glomerulus vasculature development",
  "GO:0072240": "metanephric DCT cell differentiation",
  "GO:0072241": "metanephric DCT cell development",
  "GO:0072242": "metanephric DCT cell fate commitment",
  "GO:0072243": "metanephric nephron epithelium development",
  "GO:0072244": "metanephric glomerular epithelium development",
  "GO:0072245": "metanephric glomerular parietal epithelial cell differentiation",
  "GO:0072246": "metanephric glomerular parietal epithelial cell development",
  "GO:0072247": "metanephric glomerular parietal epithelial cell fate commitment",
  "GO:0072248": "metanephric glomerular visceral epithelial cell differentiation",
  "GO:0072249": "metanephric glomerular visceral epithelial cell development",
  "GO:0072250": "metanephric glomerular visceral epithelial cell fate commitment",
  "GO:0072251": "metanephric juxtaglomerulus cell differentiation",
  "GO:0072252": "metanephric juxtaglomerulus cell development",
  "GO:0072253": "metanephric juxtaglomerulus cell fate commitment",
  "GO:0072254": "metanephric glomerular mesangial cell differentiation",
  "GO:0072255": "metanephric glomerular mesangial cell development",
  "GO:0072256": "metanephric glomerular mesangial cell fate commitment",
  "GO:0072257": "metanephric nephron tubule epithelial cell differentiation",
  "GO:0072258": "metanephric interstitial fibroblast differentiation",
  "GO:0072259": "metanephric interstitial fibroblast development",
  "GO:0072260": "metanephric interstitial fibroblast fate commitment",
  "GO:0072261": "metanephric extraglomerular mesangial cell proliferation involved in metanephros development",
  "GO:0072262": "metanephric glomerular mesangial cell proliferation involved in metanephros development",
  "GO:0072263": "metanephric intraglomerular mesangial cell proliferation",
  "GO:0072264": "metanephric glomerular endothelium development",
  "GO:0072265": "metanephric capsule morphogenesis",
  "GO:0072266": "metanephric capsule formation",
  "GO:0072267": "metanephric capsule specification",
  "GO:0072268": "pattern specification involved in metanephros development",
  "GO:0072269": "metanephric long descending thin limb development",
  "GO:0072270": "metanephric short nephron development",
  "GO:0072271": "metanephric short descending thin limb development",
  "GO:0072272": "proximal/distal pattern formation involved in metanephric nephron development",
  "GO:0072273": "metanephric nephron morphogenesis",
  "GO:0072274": "metanephric glomerular basement membrane development",
  "GO:0072275": "metanephric glomerulus morphogenesis",
  "GO:0072276": "metanephric glomerulus vasculature morphogenesis",
  "GO:0072277": "metanephric glomerular capillary formation",
  "GO:0072278": "metanephric comma-shaped body morphogenesis",
  "GO:0072279": "convergent extension involved in metanephric nephron morphogenesis",
  "GO:0072280": "establishment of planar polarity involved in metanephric nephron morphogenesis",
  "GO:0072281": "mesenchymal stem cell differentiation involved in metanephric nephron morphogenesis",
  "GO:0072282": "metanephric nephron tubule morphogenesis",
  "GO:0072283": "metanephric renal vesicle morphogenesis",
  "GO:0072284": "metanephric S-shaped body morphogenesis",
  "GO:0072285": "mesenchymal to epithelial transition involved in metanephric renal vesicle formation",
  "GO:0072286": "metanephric connecting tubule development",
  "GO:0072287": "metanephric distal tubule morphogenesis",
  "GO:0072288": "metanephric proximal tubule morphogenesis",
  "GO:0072289": "metanephric nephron tubule formation",
  "GO:0072290": "epithelial cell migration involved in metanephric nephron tubule morphogenesis",
  "GO:0072291": "epithelial cell migration involved in metanephric distal tubule morphogenesis",
  "GO:0072292": "epithelial cell migration involved in metanephric proximal tubule morphogenesis",
  "GO:0072293": "specification of metanephric nephron tubule identity",
  "GO:0072294": "specification of metanephric connecting tubule identity",
  "GO:0072295": "specification of metanephric distal tubule identity",
  "GO:0072296": "specification of metanephric loop of Henle identity",
  "GO:0072297": "specification of metanephric proximal tubule identity",
  "GO:0072298": "regulation of metanephric glomerulus development",
  "GO:0072299": "negative regulation of metanephric glomerulus development",
  "GO:0072300": "positive regulation of metanephric glomerulus development",
  "GO:0072301": "regulation of metanephric glomerular mesangial cell proliferation",
  "GO:0072302": "negative regulation of metanephric glomerular mesangial cell proliferation",
  "GO:0072303": "positive regulation of glomerular metanephric mesangial cell proliferation",
  "GO:0072304": "regulation of mesenchymal cell apoptotic process involved in metanephric nephron morphogenesis",
  "GO:0072305": "negative regulation of mesenchymal cell apoptotic process involved in metanephric nephron morphogenesis",
  "GO:0072306": "positive regulation of mesenchymal cell apoptotic process involved in metanephric nephron morphogenesis",
  "GO:0072307": "regulation of metanephric nephron tubule epithelial cell differentiation",
  "GO:0072308": "negative regulation of metanephric nephron tubule epithelial cell differentiation",
  "GO:0072309": "mesenchymal stem cell maintenance involved in metanephric nephron morphogenesis",
  "GO:0072310": "glomerular epithelial cell development",
  "GO:0072311": "glomerular epithelial cell differentiation",
  "GO:0072312": "metanephric glomerular epithelial cell differentiation",
  "GO:0072313": "metanephric glomerular epithelial cell development",
  "GO:0072314": "glomerular epithelial cell fate commitment",
  "GO:0072315": "metanephric glomerular epithelial cell fate commitment",
  "GO:0072316": "alpha-glucan catabolic process involved in ascospore release from ascus",
  "GO:0072317": "glucan endo-1,3-beta-D-glucosidase activity involved in ascospore release from ascus",
  "GO:0072318": "clathrin coat disassembly",
  "GO:0072319": "vesicle uncoating",
  "GO:0072320": "volume-sensitive chloride channel activity",
  "GO:0072321": "chaperone-mediated protein transport",
  "GO:0072322": "protein transport across periplasmic space",
  "GO:0072323": "chaperone-mediated protein transport across periplasmic space",
  "GO:0072324": "ascus epiplasm",
  "GO:0072325": "vulval cell fate commitment",
  "GO:0072326": "vulval cell fate determination",
  "GO:0072327": "vulval cell fate specification",
  "GO:0072328": "alkene binding",
  "GO:0072329": "monocarboxylic acid catabolic process",
  "GO:0072330": "monocarboxylic acid biosynthetic process",
  "GO:0072331": "signal transduction by p53 class mediator",
  "GO:0072332": "intrinsic apoptotic signaling pathway by p53 class mediator",
  "GO:0072333": "obsolete anoikis by p53 class mediator",
  "GO:0072334": "UDP-galactose transmembrane transport",
  "GO:0072335": "regulation of canonical Wnt signaling pathway involved in neural crest cell differentiation",
  "GO:0072336": "negative regulation of canonical Wnt signaling pathway involved in neural crest cell differentiation",
  "GO:0072337": "modified amino acid transport",
  "GO:0072338": "cellular lactam metabolic process",
  "GO:0072339": "cellular lactam biosynthetic process",
  "GO:0072340": "cellular lactam catabolic process",
  "GO:0072341": "modified amino acid binding",
  "GO:0072342": "response to anion stress",
  "GO:0072343": "pancreatic stellate cell proliferation",
  "GO:0072344": "rescue of stalled ribosome",
  "GO:0072345": "NAADP-sensitive calcium-release channel activity",
  "GO:0072346": "cADPR-sensitive calcium-release channel activity",
  "GO:0072347": "response to anesthetic",
  "GO:0072348": "sulfur compound transport",
  "GO:0072349": "modified amino acid transmembrane transporter activity",
  "GO:0072350": "tricarboxylic acid metabolic process",
  "GO:0072351": "tricarboxylic acid biosynthetic process",
  "GO:0072352": "tricarboxylic acid catabolic process",
  "GO:0072353": "cellular age-dependent response to reactive oxygen species",
  "GO:0072354": "histone kinase activity (H3-T3 specific)",
  "GO:0072355": "histone H3-T3 phosphorylation",
  "GO:0072356": "chromosome passenger complex localization to kinetochore",
  "GO:0072357": "PTW/PP1 phosphatase complex",
  "GO:0072358": "cardiovascular system development",
  "GO:0072359": "circulatory system development",
  "GO:0072360": "vascular cord development",
  "GO:0072361": "regulation of glycolytic process by regulation of transcription from RNA polymerase II promoter",
  "GO:0072362": "regulation of glycolytic process by negative regulation of transcription from RNA polymerase II promoter",
  "GO:0072363": "regulation of glycolytic process by positive regulation of transcription from RNA polymerase II promoter",
  "GO:0072364": "regulation of cellular ketone metabolic process by regulation of transcription from RNA polymerase II promoter",
  "GO:0072365": "regulation of cellular ketone metabolic process by negative regulation of transcription from RNA polymerase II promoter",
  "GO:0072366": "regulation of cellular ketone metabolic process by positive regulation of transcription from RNA polymerase II promoter",
  "GO:0072367": "regulation of lipid transport by regulation of transcription from RNA polymerase II promoter",
  "GO:0072368": "regulation of lipid transport by negative regulation of transcription from RNA polymerase II promoter",
  "GO:0072369": "regulation of lipid transport by positive regulation of transcription from RNA polymerase II promoter",
  "GO:0072370": "histone H2A-S121 phosphorylation",
  "GO:0072371": "histone kinase activity (H2A-S121 specific)",
  "GO:0072372": "primary cilium",
  "GO:0072373": "alpha-carotene epsilon hydroxylase activity",
  "GO:0072374": "carotene epsilon hydroxylase activity",
  "GO:0072375": "medium-term memory",
  "GO:0072376": "protein activation cascade",
  "GO:0072377": "blood coagulation, common pathway",
  "GO:0072378": "blood coagulation, fibrin clot formation",
  "GO:0072379": "ER membrane insertion complex",
  "GO:0072380": "TRC complex",
  "GO:0072381": "positive regulation of canonical Wnt signaling pathway involved in neural crest cell differentiation",
  "GO:0072382": "minus-end-directed vesicle transport along microtubule",
  "GO:0072383": "plus-end-directed vesicle transport along microtubule",
  "GO:0072384": "organelle transport along microtubule",
  "GO:0072385": "minus-end-directed organelle transport along microtubule",
  "GO:0072386": "plus-end-directed organelle transport along microtubule",
  "GO:0072387": "flavin adenine dinucleotide metabolic process",
  "GO:0072388": "flavin adenine dinucleotide biosynthetic process",
  "GO:0072389": "flavin adenine dinucleotide catabolic process",
  "GO:0072390": "phenol metabolic process",
  "GO:0072391": "phenol biosynthetic process",
  "GO:0072392": "phenol catabolic process",
  "GO:0072393": "microtubule anchoring at microtubule organizing center",
  "GO:0072394": "detection of stimulus involved in cell cycle checkpoint",
  "GO:0072395": "signal transduction involved in cell cycle checkpoint",
  "GO:0072396": "response to cell cycle checkpoint signaling",
  "GO:0072397": "detection of stimulus involved in cytokinesis checkpoint",
  "GO:0072398": "signal transduction involved in cytokinesis checkpoint",
  "GO:0072399": "response to cytokinesis checkpoint signaling",
  "GO:0072400": "detection of stimulus involved in mitotic DNA integrity checkpoint",
  "GO:0072401": "signal transduction involved in DNA integrity checkpoint",
  "GO:0072402": "response to DNA integrity checkpoint signaling",
  "GO:0072409": "detection of stimulus involved in meiotic cell cycle checkpoint",
  "GO:0072410": "response to meiotic cell cycle checkpoint signaling",
  "GO:0072411": "signal transduction involved in meiotic cell cycle checkpoint",
  "GO:0072412": "detection of stimulus involved in mitotic cell cycle checkpoint",
  "GO:0072413": "signal transduction involved in mitotic cell cycle checkpoint",
  "GO:0072414": "response to mitotic cell cycle checkpoint signaling",
  "GO:0072415": "detection of stimulus involved in spindle checkpoint",
  "GO:0072416": "signal transduction involved in spindle checkpoint",
  "GO:0072417": "response to spindle checkpoint signaling",
  "GO:0072421": "detection of DNA damage stimulus involved in DNA damage checkpoint",
  "GO:0072422": "signal transduction involved in DNA damage checkpoint",
  "GO:0072423": "response to DNA damage checkpoint signaling",
  "GO:0072424": "detection of DNA damage stimulus involved in G2 DNA damage checkpoint",
  "GO:0072425": "signal transduction involved in G2 DNA damage checkpoint",
  "GO:0072426": "response to G2 DNA damage checkpoint signaling",
  "GO:0072427": "detection of DNA damage stimulus involved in intra-S DNA damage checkpoint",
  "GO:0072428": "signal transduction involved in intra-S DNA damage checkpoint",
  "GO:0072429": "response to intra-S DNA damage checkpoint signaling",
  "GO:0072430": "detection of DNA damage stimulus involved in mitotic G1 DNA damage checkpoint",
  "GO:0072431": "signal transduction involved in mitotic G1 DNA damage checkpoint",
  "GO:0072432": "response to G1 DNA damage checkpoint signaling",
  "GO:0072433": "detection of DNA damage stimulus involved in mitotic G2 DNA damage checkpoint",
  "GO:0072434": "signal transduction involved in mitotic G2 DNA damage checkpoint",
  "GO:0072435": "response to mitotic G2 DNA damage checkpoint signaling",
  "GO:0072436": "detection of stimulus involved in DNA replication checkpoint",
  "GO:0072437": "signal transduction involved in DNA replication checkpoint",
  "GO:0072438": "response to DNA replication checkpoint signaling",
  "GO:0072439": "detection of stimulus involved in meiotic DNA replication checkpoint",
  "GO:0072440": "signal transduction involved in meiotic DNA replication checkpoint",
  "GO:0072441": "response to meiotic DNA replication checkpoint signaling",
  "GO:0072442": "detection of stimulus involved in mitotic DNA replication checkpoint",
  "GO:0072443": "signal transduction involved in mitotic DNA replication checkpoint",
  "GO:0072444": "response to mitotic DNA replication checkpoint signaling",
  "GO:0072448": "detection of stimulus involved in G1 cell size control checkpoint",
  "GO:0072449": "response to G1 cell size control checkpoint signaling",
  "GO:0072450": "signal transduction involved in G1 cell size control checkpoint",
  "GO:0072451": "detection of stimulus involved in G2 cell size control checkpoint",
  "GO:0072452": "response to G2 transition size control checkpoint signaling",
  "GO:0072453": "signal transduction involved in G2 cell size control checkpoint",
  "GO:0072460": "detection of stimulus involved in meiotic recombination checkpoint",
  "GO:0072461": "response to meiotic recombination checkpoint signaling",
  "GO:0072462": "signal transduction involved in meiotic recombination checkpoint",
  "GO:0072463": "detection of stimulus involved in meiotic spindle assembly checkpoint",
  "GO:0072464": "response to meiotic spindle assembly checkpoint signaling",
  "GO:0072465": "signal transduction involved in meiotic spindle assembly checkpoint",
  "GO:0072466": "detection of stimulus involved in cell shape checkpoint",
  "GO:0072467": "response to cell shape checkpoint signaling",
  "GO:0072468": "signal transduction involved in cell shape checkpoint",
  "GO:0072469": "detection of stimulus involved in cell size control checkpoint",
  "GO:0072470": "response to cell size control checkpoint signaling",
  "GO:0072471": "signal transduction involved in cell size control checkpoint",
  "GO:0072475": "detection of stimulus involved in mitotic spindle checkpoint",
  "GO:0072476": "response to mitotic spindle checkpoint signaling",
  "GO:0072477": "signal transduction involved in mitotic spindle checkpoint",
  "GO:0072478": "detection of stimulus involved in mitotic spindle assembly checkpoint",
  "GO:0072479": "response to mitotic cell cycle spindle assembly checkpoint signaling",
  "GO:0072480": "signal transduction involved in mitotic spindle assembly checkpoint",
  "GO:0072481": "detection of stimulus involved in mitotic spindle orientation checkpoint",
  "GO:0072482": "response to mitotic cell cycle spindle orientation checkpoint signaling",
  "GO:0072483": "signal transduction involved in mitotic cell cycle spindle orientation checkpoint",
  "GO:0072484": "detection of stimulus involved in spindle assembly checkpoint",
  "GO:0072485": "response to spindle assembly checkpoint signaling",
  "GO:0072486": "signal transduction involved in spindle assembly checkpoint",
  "GO:0072487": "MSL complex",
  "GO:0072488": "ammonium transmembrane transport",
  "GO:0072489": "methylammonium transmembrane transport",
  "GO:0072490": "toluene-containing compound metabolic process",
  "GO:0072491": "toluene-containing compound catabolic process",
  "GO:0072492": "host cell mitochondrial intermembrane space",
  "GO:0072493": "host cell endosome lumen",
  "GO:0072494": "host multivesicular body",
  "GO:0072495": "host cell Cajal body",
  "GO:0072496": "Pup transferase activity",
  "GO:0072497": "mesenchymal stem cell differentiation",
  "GO:0072498": "embryonic skeletal joint development",
  "GO:0072499": "photoreceptor cell axon guidance",
  "GO:0072500": "obsolete negative regulation of transcription from RNA polymerase II promoter by nuclear hormone receptor",
  "GO:0072501": "cellular divalent inorganic anion homeostasis",
  "GO:0072502": "cellular trivalent inorganic anion homeostasis",
  "GO:0072503": "cellular divalent inorganic cation homeostasis",
  "GO:0072504": "cellular trivalent inorganic cation homeostasis",
  "GO:0072505": "divalent inorganic anion homeostasis",
  "GO:0072506": "trivalent inorganic anion homeostasis",
  "GO:0072507": "divalent inorganic cation homeostasis",
  "GO:0072508": "trivalent inorganic cation homeostasis",
  "GO:0072509": "divalent inorganic cation transmembrane transporter activity",
  "GO:0072510": "trivalent inorganic cation transmembrane transporter activity",
  "GO:0072511": "divalent inorganic cation transport",
  "GO:0072512": "trivalent inorganic cation transport",
  "GO:0072513": "positive regulation of secondary heart field cardioblast proliferation",
  "GO:0072514": "trehalose transport in response to water deprivation",
  "GO:0072515": "trehalose transport in response to desiccation",
  "GO:0072516": "viral assembly compartment",
  "GO:0072517": "host cell viral assembly compartment",
  "GO:0072518": "Rho-dependent protein serine/threonine kinase activity",
  "GO:0072519": "parasitism",
  "GO:0072520": "seminiferous tubule development",
  "GO:0072521": "purine-containing compound metabolic process",
  "GO:0072522": "purine-containing compound biosynthetic process",
  "GO:0072523": "purine-containing compound catabolic process",
  "GO:0072524": "pyridine-containing compound metabolic process",
  "GO:0072525": "pyridine-containing compound biosynthetic process",
  "GO:0072526": "pyridine-containing compound catabolic process",
  "GO:0072527": "pyrimidine-containing compound metabolic process",
  "GO:0072528": "pyrimidine-containing compound biosynthetic process",
  "GO:0072529": "pyrimidine-containing compound catabolic process",
  "GO:0072530": "purine-containing compound transmembrane transport",
  "GO:0072531": "pyrimidine-containing compound transmembrane transport",
  "GO:0072532": "tri-(feruloyl or hydroxyferuloyl) spermidine meta-hydroxylase activity",
  "GO:0072533": "tri-(coumaroyl or caffeoyl) spermidine meta-hydroxylase activity",
  "GO:0072534": "perineuronal net",
  "GO:0072535": "tumor necrosis factor (ligand) superfamily member 11 production",
  "GO:0072536": "interleukin-23 receptor complex",
  "GO:0072537": "fibroblast activation",
  "GO:0072538": "T-helper 17 type immune response",
  "GO:0072539": "T-helper 17 cell differentiation",
  "GO:0072540": "T-helper 17 cell lineage commitment",
  "GO:0072541": "peroxynitrite reductase activity",
  "GO:0072542": "protein phosphatase activator activity",
  "GO:0072543": "protein phosphatase type 2A activator activity",
  "GO:0072544": "L-DOPA binding",
  "GO:0072545": "tyrosine binding",
  "GO:0072546": "ER membrane protein complex",
  "GO:0072547": "tricoumaroylspermidine meta-hydroxylase activity",
  "GO:0072548": "dicoumaroyl monocaffeoyl spermidine meta-hydroxylase activity",
  "GO:0072549": "monocoumaroyl dicaffeoyl spermidine meta-hydroxylase activity",
  "GO:0072550": "triferuloylspermidine meta-hydroxylase activity",
  "GO:0072551": "diferuloyl mono-(hydroxyferuloyl) spermidine meta-hydroxylase activity",
  "GO:0072552": "monoferuloyl di-(hydroxyferuloyl) spermidine meta-hydroxylase activity",
  "GO:0072553": "terminal button organization",
  "GO:0072554": "blood vessel lumenization",
  "GO:0072555": "17-beta-ketosteroid reductase activity",
  "GO:0072556": "other organism presynaptic membrane",
  "GO:0072557": "IPAF inflammasome complex",
  "GO:0072558": "NLRP1 inflammasome complex",
  "GO:0072559": "NLRP3 inflammasome complex",
  "GO:0072560": "type B pancreatic cell maturation",
  "GO:0072562": "blood microparticle",
  "GO:0072563": "endothelial microparticle",
  "GO:0072564": "blood microparticle formation",
  "GO:0072565": "endothelial microparticle formation",
  "GO:0072566": "chemokine (C-X-C motif) ligand 1 production",
  "GO:0072567": "chemokine (C-X-C motif) ligand 2 production",
  "GO:0072570": "ADP-D-ribose binding",
  "GO:0072571": "mono-ADP-D-ribose binding",
  "GO:0072572": "poly-ADP-D-ribose binding",
  "GO:0072573": "tolerance induction to lipopolysaccharide",
  "GO:0072574": "hepatocyte proliferation",
  "GO:0072575": "epithelial cell proliferation involved in liver morphogenesis",
  "GO:0072576": "liver morphogenesis",
  "GO:0072577": "endothelial cell apoptotic process",
  "GO:0072578": "neurotransmitter-gated ion channel clustering",
  "GO:0072579": "glycine receptor clustering",
  "GO:0072580": "bacterial-type EF-P lysine modification",
  "GO:0072581": "protein-N6-(L-lysyl)-L-lysine modification to protein-N6-(beta-lysyl)-L-lysine",
  "GO:0072582": "17-beta-hydroxysteroid dehydrogenase (NADP+) activity",
  "GO:0072583": "clathrin-mediated endocytosis",
  "GO:0072584": "caveolin-mediated endocytosis",
  "GO:0072585": "xanthosine nucleotidase activity",
  "GO:0072586": "DNA topoisomerase (ATP-hydrolyzing) regulator activity",
  "GO:0072587": "DNA topoisomerase (ATP-hydrolyzing) activator activity",
  "GO:0072588": "box H/ACA RNP complex",
  "GO:0072589": "box H/ACA scaRNP complex",
  "GO:0072590": "N-acetyl-L-aspartate-L-glutamate ligase activity",
  "GO:0072591": "citrate-L-glutamate ligase activity",
  "GO:0072592": "oxygen metabolic process",
  "GO:0072593": "reactive oxygen species metabolic process",
  "GO:0072594": "establishment of protein localization to organelle",
  "GO:0072595": "maintenance of protein localization in organelle",
  "GO:0072596": "establishment of protein localization to chloroplast",
  "GO:0072597": "maintenance of protein location in chloroplast",
  "GO:0072598": "protein localization to chloroplast",
  "GO:0072599": "establishment of protein localization to endoplasmic reticulum",
  "GO:0072600": "establishment of protein localization to Golgi",
  "GO:0072601": "interleukin-3 secretion",
  "GO:0072602": "interleukin-4 secretion",
  "GO:0072603": "interleukin-5 secretion",
  "GO:0072604": "interleukin-6 secretion",
  "GO:0072605": "interleukin-7 secretion",
  "GO:0072606": "interleukin-8 secretion",
  "GO:0072607": "interleukin-9 secretion",
  "GO:0072608": "interleukin-10 secretion",
  "GO:0072609": "interleukin-11 secretion",
  "GO:0072610": "interleukin-12 secretion",
  "GO:0072611": "interleukin-13 secretion",
  "GO:0072612": "interleukin-14 secretion",
  "GO:0072613": "interleukin-15 secretion",
  "GO:0072614": "interleukin-16 secretion",
  "GO:0072615": "interleukin-17 secretion",
  "GO:0072616": "interleukin-18 secretion",
  "GO:0072617": "interleukin-19 secretion",
  "GO:0072618": "interleukin-20 secretion",
  "GO:0072619": "interleukin-21 secretion",
  "GO:0072620": "interleukin-22 secretion",
  "GO:0072621": "interleukin-23 secretion",
  "GO:0072622": "interleukin-24 secretion",
  "GO:0072623": "interleukin-25 secretion",
  "GO:0072624": "interleukin-26 secretion",
  "GO:0072625": "interleukin-27 secretion",
  "GO:0072626": "interleukin-35 secretion",
  "GO:0072627": "interleukin-28A production",
  "GO:0072628": "interleukin-28A secretion",
  "GO:0072629": "interleukin-28B production",
  "GO:0072630": "interleukin-28B secretion",
  "GO:0072631": "interleukin-29 production",
  "GO:0072632": "interleukin-29 secretion",
  "GO:0072633": "interleukin-30 production",
  "GO:0072634": "interleukin-30 secretion",
  "GO:0072635": "interleukin-31 production",
  "GO:0072636": "interleukin-31 secretion",
  "GO:0072637": "interleukin-32 production",
  "GO:0072638": "interleukin-32 secretion",
  "GO:0072639": "interleukin-33 production",
  "GO:0072640": "interleukin-33 secretion",
  "GO:0072641": "type I interferon secretion",
  "GO:0072642": "interferon-alpha secretion",
  "GO:0072643": "interferon-gamma secretion",
  "GO:0072644": "type III interferon secretion",
  "GO:0072645": "interferon-delta production",
  "GO:0072646": "interferon-delta secretion",
  "GO:0072647": "interferon-epsilon production",
  "GO:0072648": "interferon-epsilon secretion",
  "GO:0072649": "interferon-kappa production",
  "GO:0072650": "interferon-kappa secretion",
  "GO:0072651": "interferon-tau production",
  "GO:0072652": "interferon-tau secretion",
  "GO:0072653": "interferon-omega production",
  "GO:0072654": "interferon-omega secretion",
  "GO:0072655": "establishment of protein localization to mitochondrion",
  "GO:0072656": "maintenance of protein location in mitochondrion",
  "GO:0072657": "protein localization to membrane",
  "GO:0072658": "maintenance of protein location in membrane",
  "GO:0072659": "protein localization to plasma membrane",
  "GO:0072660": "maintenance of protein location in plasma membrane",
  "GO:0072661": "protein targeting to plasma membrane",
  "GO:0072662": "protein localization to peroxisome",
  "GO:0072663": "establishment of protein localization to peroxisome",
  "GO:0072664": "maintenance of protein location in peroxisome",
  "GO:0072665": "protein localization to vacuole",
  "GO:0072666": "establishment of protein localization to vacuole",
  "GO:0072667": "maintenance of protein location in vacuole",
  "GO:0072668": "obsolete tubulin complex biogenesis",
  "GO:0072669": "tRNA-splicing ligase complex",
  "GO:0072670": "mitochondrial tRNA threonylcarbamoyladenosine modification",
  "GO:0072671": "mitochondria-associated ubiquitin-dependent protein catabolic process",
  "GO:0072672": "neutrophil extravasation",
  "GO:0072673": "lamellipodium morphogenesis",
  "GO:0072674": "multinuclear osteoclast differentiation",
  "GO:0072675": "osteoclast fusion",
  "GO:0072676": "lymphocyte migration",
  "GO:0072677": "eosinophil migration",
  "GO:0072678": "T cell migration",
  "GO:0072679": "thymocyte migration",
  "GO:0072680": "extracellular matrix-dependent thymocyte migration",
  "GO:0072681": "fibronectin-dependent thymocyte migration",
  "GO:0072682": "eosinophil extravasation",
  "GO:0072683": "T cell extravasation",
  "GO:0072684": "mitochondrial tRNA 3'-trailer cleavage, endonucleolytic",
  "GO:0072685": "Mre11 complex assembly",
  "GO:0072686": "mitotic spindle",
  "GO:0072687": "meiotic spindle",
  "GO:0072688": "SHREC complex localization",
  "GO:0072689": "MCM complex assembly",
  "GO:0072690": "single-celled organism vegetative growth phase",
  "GO:0072691": "initiation of premeiotic DNA replication",
  "GO:0072692": "chromatin silencing at centromere central core",
  "GO:0072693": "protein targeting to prospore membrane",
  "GO:0072694": "obsolete cell cycle arrest in response to caffeine",
  "GO:0072695": "regulation of DNA recombination at telomere",
  "GO:0072696": "positive regulation of DNA recombination at telomere",
  "GO:0072697": "protein localization to cell cortex",
  "GO:0072698": "protein localization to microtubule cytoskeleton",
  "GO:0072699": "protein localization to cortical microtubule cytoskeleton",
  "GO:0072700": "response to bismuth",
  "GO:0072701": "cellular response to bismuth",
  "GO:0072702": "response to methyl methanesulfonate",
  "GO:0072703": "cellular response to methyl methanesulfonate",
  "GO:0072704": "response to mercaptoethanol",
  "GO:0072705": "cellular response to mercaptoethanol",
  "GO:0072706": "response to sodium dodecyl sulfate",
  "GO:0072707": "cellular response to sodium dodecyl sulfate",
  "GO:0072708": "response to sorbitol",
  "GO:0072709": "cellular response to sorbitol",
  "GO:0072710": "response to hydroxyurea",
  "GO:0072711": "cellular response to hydroxyurea",
  "GO:0072712": "response to thiabendazole",
  "GO:0072713": "cellular response to thiabendazole",
  "GO:0072714": "response to selenite ion",
  "GO:0072715": "cellular response to selenite ion",
  "GO:0072716": "response to actinomycin D",
  "GO:0072717": "cellular response to actinomycin D",
  "GO:0072718": "response to cisplatin",
  "GO:0072719": "cellular response to cisplatin",
  "GO:0072720": "response to dithiothreitol",
  "GO:0072721": "cellular response to dithiothreitol",
  "GO:0072722": "response to amitrole",
  "GO:0072723": "cellular response to amitrole",
  "GO:0072724": "response to 4-nitroquinoline N-oxide",
  "GO:0072725": "cellular response to 4-nitroquinoline N-oxide",
  "GO:0072726": "response to CCCP",
  "GO:0072727": "cellular response to CCCP",
  "GO:0072728": "response to Gentian violet",
  "GO:0072729": "cellular response to Gentian violet",
  "GO:0072730": "response to papulacandin B",
  "GO:0072731": "cellular response to papulacandin B",
  "GO:0072732": "cellular response to calcium ion starvation",
  "GO:0072733": "response to staurosporine",
  "GO:0072734": "cellular response to staurosporine",
  "GO:0072735": "response to t-BOOH",
  "GO:0072736": "cellular response to t-BOOH",
  "GO:0072737": "response to diamide",
  "GO:0072738": "cellular response to diamide",
  "GO:0072739": "response to anisomycin",
  "GO:0072740": "cellular response to anisomycin",
  "GO:0072741": "protein localization to cell division site",
  "GO:0072742": "SAGA complex localization to transcription regulatory region",
  "GO:0072743": "cellular response to erythromycin",
  "GO:0072744": "cellular response to trichodermin",
  "GO:0072745": "cellular response to antimycin A",
  "GO:0072746": "cellular response to tetracycline",
  "GO:0072747": "cellular response to chloramphenicol",
  "GO:0072748": "cellular response to tacrolimus",
  "GO:0072749": "cellular response to cytochalasin B",
  "GO:0072750": "cellular response to leptomycin B",
  "GO:0072751": "cellular response to L-thialysine",
  "GO:0072752": "cellular response to rapamycin",
  "GO:0072753": "cellular response to glutathione",
  "GO:0072754": "cellular response to purvalanol A",
  "GO:0072755": "cellular response to benomyl",
  "GO:0072756": "cellular response to paraquat",
  "GO:0072757": "cellular response to camptothecin",
  "GO:0072758": "response to topoisomerase inhibitor",
  "GO:0072759": "cellular response to topoisomerase inhibitor",
  "GO:0072760": "cellular response to GW 7647",
  "GO:0072761": "cellular response to capsazepine",
  "GO:0072762": "cellular response to carbendazim",
  "GO:0072763": "cellular response to hesperadin",
  "GO:0072764": "cellular response to reversine",
  "GO:0072765": "centromere localization",
  "GO:0072766": "centromere clustering at the nuclear envelope",
  "GO:0075000": "response to host osmotic environment",
  "GO:0075001": "adhesion of symbiont infection structure to host",
  "GO:0075002": "adhesion of symbiont germination tube to host",
  "GO:0075003": "adhesion of symbiont appressorium to host",
  "GO:0075004": "adhesion of symbiont spore to host",
  "GO:0075005": "spore germination on or near host",
  "GO:0075006": "modulation of spore germination on or near host",
  "GO:0075007": "positive regulation of spore germination on or near host",
  "GO:0075008": "negative regulation of spore germination on or near host",
  "GO:0075009": "germ tube formation on or near host",
  "GO:0075010": "modulation of germ tube formation on or near host",
  "GO:0075011": "positive regulation of germ tube formation on or near host",
  "GO:0075012": "negative regulation of germ tube formation on or near host",
  "GO:0075013": "obsolete growth or development of symbiont on or near host phyllosphere",
  "GO:0075014": "obsolete growth or development of symbiont on or near host rhizosphere",
  "GO:0075015": "formation of infection structure on or near host",
  "GO:0075016": "appressorium formation on or near host",
  "GO:0075017": "regulation of appressorium formation on or near host",
  "GO:0075018": "positive regulation of appressorium formation on or near host",
  "GO:0075019": "negative regulation of appressorium formation on or near host",
  "GO:0075020": "calcium or calmodulin-mediated activation of appressorium formation",
  "GO:0075021": "cAMP-mediated activation of appressorium formation",
  "GO:0075022": "ethylene-mediated activation of appressorium formation",
  "GO:0075023": "MAPK-mediated regulation of appressorium formation",
  "GO:0075024": "phospholipase C-mediated activation of appressorium formation",
  "GO:0075025": "initiation of appressorium on or near host",
  "GO:0075026": "regulation of appressorium initiation on or near host",
  "GO:0075027": "positive regulation of appressorium initiation on or near host",
  "GO:0075028": "negative regulation of appressorium initiation on or near host",
  "GO:0075029": "formation of symbiont germ tube hook structure on or near host",
  "GO:0075030": "modulation of symbiont germ tube hook structure formation on or near host",
  "GO:0075031": "positive regulation of symbiont germ tube hook structure formation on or near host",
  "GO:0075032": "negative regulation of symbiont germ tube hook structure formation on or near host",
  "GO:0075033": "septum formation involved in appressorium formation on or near host",
  "GO:0075034": "nuclear division involved in appressorium formation on or near host",
  "GO:0075035": "maturation of appressorium on or near host",
  "GO:0075036": "regulation of appressorium maturation on or near host",
  "GO:0075037": "positive regulation of appressorium maturation on or near host",
  "GO:0075038": "negative regulation of appressorium maturation on or near host",
  "GO:0075039": "establishment of turgor in appressorium",
  "GO:0075040": "regulation of establishment of turgor in appressorium",
  "GO:0075041": "positive regulation of establishment of turgor in appressorium",
  "GO:0075042": "negative regulation of establishment of turgor in appressorium",
  "GO:0075043": "maintenance of turgor in appressorium by melanization",
  "GO:0075044": "autophagy of host cells involved in interaction with symbiont",
  "GO:0075045": "regulation of formation by symbiont of haustorium for nutrient acquisition from host",
  "GO:0075046": "positive regulation of formation by symbiont of haustorium for nutrient acquisition from host",
  "GO:0075047": "negative regulation of formation by symbiont of haustorium for nutrient acquisition from host",
  "GO:0075048": "cell wall strengthening in symbiont involved in entry into host",
  "GO:0075049": "modulation of symbiont cell wall strengthening involved in entry into host",
  "GO:0075050": "positive regulation of symbiont cell wall strengthening involved in entry into host",
  "GO:0075051": "negative regulation of symbiont cell wall strengthening involved in entry into host",
  "GO:0075052": "entry into host via a specialized structure",
  "GO:0075053": "formation of symbiont penetration peg for entry into host",
  "GO:0075054": "modulation of symbiont penetration peg formation for entry into host",
  "GO:0075055": "positive regulation of symbiont penetration peg formation for entry into host",
  "GO:0075056": "negative regulation of symbiont penetration peg formation for entry into host",
  "GO:0075057": "initiation of symbiont penetration peg",
  "GO:0075058": "modulation of symbiont penetration peg initiation",
  "GO:0075059": "positive regulation of symbiont penetration peg initiation",
  "GO:0075060": "negative regulation of symbiont penetration peg initiation",
  "GO:0075061": "formation of symbiont invasive hypha in host",
  "GO:0075062": "regulation of symbiont invasive hypha formation in host",
  "GO:0075063": "positive regulation of symbiont invasive hypha formation in host",
  "GO:0075064": "negative regulation of symbiont invasive hypha formation in host",
  "GO:0075065": "obsolete growth or development of symbiont in host cell",
  "GO:0075066": "obsolete growth or development of symbiont in host organelle",
  "GO:0075067": "obsolete growth or development of symbiont in host intercellular space",
  "GO:0075068": "obsolete growth or development of symbiont in host vascular tissue",
  "GO:0075069": "adhesion of symbiont infection cushion to host",
  "GO:0075070": "adhesion of symbiont hyphopodium to host",
  "GO:0075071": "autophagy involved in symbiotic interaction",
  "GO:0075072": "autophagy of symbiont cells involved in interaction with host",
  "GO:0075073": "autophagy of symbiont cells on or near host surface",
  "GO:0075074": "spore autophagy involved in appressorium formation on or near host",
  "GO:0075075": "modulation by host of symbiont adenylate cyclase activity",
  "GO:0075076": "positive regulation by host of symbiont adenylate cyclase activity",
  "GO:0075077": "negative regulation by host of symbiont adenylate cyclase activity",
  "GO:0075078": "modulation by host of symbiont receptor-mediated signal transduction",
  "GO:0075079": "positive regulation by host of symbiont receptor-mediated signal transduction",
  "GO:0075080": "negative regulation by host of symbiont receptor-mediated signal transduction",
  "GO:0075081": "modulation by host of symbiont transmembrane receptor-mediated signal transduction",
  "GO:0075082": "positive regulation by host of symbiont transmembrane receptor-mediated signal transduction",
  "GO:0075083": "negative regulation by host of symbiont transmembrane receptor-mediated signal transduction",
  "GO:0075084": "modulation by host of symbiont transmembrane receptor-mediated cAMP signal transduction",
  "GO:0075085": "positive regulation by host of symbiont transmembrane receptor-mediated cAMP signal transduction",
  "GO:0075086": "negative regulation by host of symbiont transmembrane receptor-mediated cAMP signal transduction",
  "GO:0075087": "modulation by host of symbiont G-protein coupled receptor protein signal transduction",
  "GO:0075088": "positive regulation by host of symbiont G-protein coupled receptor protein signal transduction",
  "GO:0075089": "negative regulation by host of symbiont G-protein coupled receptor protein signal transduction",
  "GO:0075090": "modulation by host of symbiont signal transduction mediated by G-protein alpha subunit",
  "GO:0075091": "positive regulation by host of symbiont signal transduction mediated by G-protein alpha subunit",
  "GO:0075092": "negative regulation by host of symbiont signal transduction mediated by G-protein alpha subunit",
  "GO:0075093": "modulation by host of symbiont signal transduction mediated by G-protein beta subunit",
  "GO:0075094": "positive regulation by host of symbiont signal transduction mediated by G-protein beta subunit",
  "GO:0075095": "negative regulation by host of symbiont signal transduction mediated by G-protein beta subunit",
  "GO:0075096": "modulation by host of symbiont signal transduction mediated by G-protein gamma subunit",
  "GO:0075097": "positive regulation by host of symbiont signal transduction mediated by G-protein gamma subunit",
  "GO:0075098": "negative regulation by host of symbiont signal transduction mediated by G-protein gamma subunit",
  "GO:0075099": "modulation by host of symbiont protein kinase-mediated signal transduction",
  "GO:0075100": "positive regulation by host of symbiont protein kinase-mediated signal transduction",
  "GO:0075101": "negative regulation by host of symbiont protein kinase-mediated signal transduction",
  "GO:0075102": "negative regulation by host of symbiont MAP kinase-mediated signal transduction",
  "GO:0075103": "modulation by host of symbiont calcium or calmodulin-mediated signal transduction",
  "GO:0075104": "positive regulation by host of symbiont calcium or calmodulin-mediated signal transduction",
  "GO:0075105": "negative regulation by host of symbiont calcium or calmodulin-mediated signal transduction",
  "GO:0075106": "modulation by symbiont of host adenylate cyclase activity",
  "GO:0075107": "positive regulation by symbiont of host adenylate cyclase activity",
  "GO:0075108": "negative regulation by symbiont of host adenylate cyclase activity",
  "GO:0075109": "modulation by symbiont of host receptor-mediated signal transduction",
  "GO:0075110": "positive regulation by symbiont of host receptor-mediated signal transduction",
  "GO:0075111": "negative regulation by symbiont of host receptor-mediated signal transduction",
  "GO:0075112": "modulation by symbiont of host transmembrane receptor-mediated signal transduction",
  "GO:0075113": "positive regulation by symbiont of host transmembrane receptor-mediated signal transduction",
  "GO:0075114": "negative regulation by symbiont of host transmembrane receptor-mediated signal transduction",
  "GO:0075115": "modulation by symbiont of host transmembrane receptor-mediated cAMP signal transduction",
  "GO:0075116": "positive regulation by symbiont of host transmembrane receptor-mediated cAMP signal transduction",
  "GO:0075117": "negative regulation by symbiont of host transmembrane receptor-mediated cAMP signal transduction",
  "GO:0075118": "modulation by symbiont of host G-protein coupled receptor protein signal transduction",
  "GO:0075119": "positive regulation by symbiont of host G-protein coupled receptor protein signal transduction",
  "GO:0075120": "negative regulation by symbiont of host G-protein coupled receptor protein signal transduction",
  "GO:0075121": "modulation by symbiont of host signal transduction mediated by G-protein alpha subunit",
  "GO:0075122": "positive regulation by symbiont of host signal transduction mediated by G-protein alpha subunit",
  "GO:0075123": "negative regulation by symbiont of host signal transduction mediated by G-protein alpha subunit",
  "GO:0075124": "modulation by symbiont of host signal transduction mediated by G-protein beta subunit",
  "GO:0075125": "positive regulation by symbiont of host signal transduction mediated by G-protein beta subunit",
  "GO:0075126": "negative regulation by symbiont of host signal transduction mediated by G-protein beta subunit",
  "GO:0075127": "modulation by symbiont of host signal transduction mediated by G-protein gamma subunit",
  "GO:0075128": "positive regulation by symbiont of host signal transduction mediated by G-protein gamma subunit",
  "GO:0075129": "negative regulation by symbiont of host signal transduction mediated by G-protein gamma subunit",
  "GO:0075130": "modulation by symbiont of host protein kinase-mediated signal transduction",
  "GO:0075131": "positive regulation by symbiont of host protein kinase-mediated signal transduction",
  "GO:0075132": "negative regulation by symbiont of host protein kinase-mediated signal transduction",
  "GO:0075133": "modulation by symbiont of host calcium or calmodulin-mediated signal transduction",
  "GO:0075134": "positive regulation by symbiont of host calcium or calmodulin-mediated signal transduction",
  "GO:0075135": "negative regulation by symbiont of host calcium or calmodulin-mediated signal transduction",
  "GO:0075136": "response to host",
  "GO:0075137": "response to host redox environment",
  "GO:0075138": "response to host oxygen tension environment",
  "GO:0075139": "response to host iron concentration",
  "GO:0075140": "response to host defense molecules",
  "GO:0075141": "maintenance of symbiont tolerance to host environment",
  "GO:0075142": "maintenance of symbiont tolerance to host oxygen tension environment",
  "GO:0075143": "maintenance of symbiont tolerance to host redox environment",
  "GO:0075144": "maintenance of symbiont tolerance to host iron concentration",
  "GO:0075145": "maintenance of symbiont tolerance to host defense molecules",
  "GO:0075146": "maintenance of symbiont tolerance to host osmotic environment",
  "GO:0075147": "regulation of signal transduction in response to host",
  "GO:0075148": "positive regulation of signal transduction in response to host",
  "GO:0075149": "negative regulation of signal transduction in response to host",
  "GO:0075150": "regulation of receptor-mediated signal transduction in response to host",
  "GO:0075151": "positive regulation of receptor-mediated signal transduction in response to host",
  "GO:0075152": "negative regulation of receptor-mediated signal transduction in response to host",
  "GO:0075153": "regulation of transmembrane receptor-mediated signal transduction in response to host",
  "GO:0075154": "positive regulation of transmembrane receptor-mediated signal transduction in response to host",
  "GO:0075155": "negative regulation of transmembrane receptor-mediated signal transduction in response to host",
  "GO:0075156": "regulation of G-protein coupled receptor protein signaling pathway in response to host",
  "GO:0075157": "positive regulation of G-protein coupled receptor protein signaling pathway in response to host",
  "GO:0075158": "negative regulation of G-protein coupled receptor protein signaling pathway in response to host",
  "GO:0075159": "regulation of G-protein alpha subunit-mediated signal transduction in response to host",
  "GO:0075160": "positive regulation of G-protein alpha subunit-mediated signal transduction in response to host",
  "GO:0075161": "negative regulation of G-protein alpha subunit-mediated signal transduction in response to host",
  "GO:0075162": "regulation of G-protein beta subunit-mediated signal transduction in response to host",
  "GO:0075163": "positive regulation of G-protein beta subunit-mediated signal transduction in response to host",
  "GO:0075164": "negative regulation of G-protein beta subunit-mediated signal transduction in response to host",
  "GO:0075165": "regulation of G-protein gamma subunit-mediated signal transduction in response to host",
  "GO:0075166": "positive regulation of G-protein gamma subunit-mediated signal transduction in response to host",
  "GO:0075167": "negative regulation of G-protein gamma subunit-mediated signal transduction in response to host",
  "GO:0075168": "regulation of protein kinase-mediated signal transduction in response to host",
  "GO:0075169": "positive regulation of symbiont protein kinase-mediated signal transduction in response to host",
  "GO:0075170": "negative regulation of protein kinase-mediated signal transduction in response to host",
  "GO:0075171": "regulation of MAP kinase-mediated signal transduction in response to host",
  "GO:0075172": "positive regulation of MAP kinase-mediated signal transduction in response to host",
  "GO:0075173": "negative regulation of MAP kinase-mediated signal transduction in response to host",
  "GO:0075174": "regulation of cAMP-mediated signaling in response to host",
  "GO:0075175": "positive regulation of cAMP-mediated signaling in response to host",
  "GO:0075176": "negative regulation of cAMP-mediated signaling in response to host",
  "GO:0075177": "regulation of calcium or calmodulin-mediated signal transduction in response to host",
  "GO:0075178": "positive regulation of calcium or calmodulin-mediated signal transduction in response to host",
  "GO:0075179": "negative regulation of calcium or calmodulin-mediated signal transduction in response to host",
  "GO:0075180": "regulation of transcription in response to host",
  "GO:0075181": "positive regulation of symbiont transcription in response to host",
  "GO:0075182": "negative regulation of symbiont transcription in response to host",
  "GO:0075183": "infection cushion formation on or near host",
  "GO:0075184": "regulation of infection cushion formation on or near host",
  "GO:0075185": "positive regulation of infection cushion formation on or near host",
  "GO:0075186": "negative regulation of infection cushion formation on or near host",
  "GO:0075187": "hyphopodium formation on or near host",
  "GO:0075188": "regulation of hyphopodium formation on or near host",
  "GO:0075189": "positive regulation of hyphopodium formation on or near host",
  "GO:0075190": "negative regulation of hyphopodium formation on or near host",
  "GO:0075191": "autophagy of host cells on or near symbiont surface",
  "GO:0075192": "haustorium mother cell formation on or near host",
  "GO:0075193": "regulation of haustorium mother cell formation on or near host",
  "GO:0075194": "positive regulation of haustorium mother cell formation on or near host",
  "GO:0075195": "negative regulation of haustorium mother cell formation on or near host",
  "GO:0075196": "adhesion of symbiont haustorium mother cell to host",
  "GO:0075197": "formation of symbiont haustorium neck for entry into host",
  "GO:0075198": "modulation of symbiont haustorium neck formation for entry into host",
  "GO:0075199": "positive regulation of symbiont haustorium neck formation for entry into host",
  "GO:0075200": "negative regulation of symbiont haustorium neck formation for entry into host",
  "GO:0075201": "formation of symbiont penetration hypha for entry into host",
  "GO:0075202": "modulation of symbiont penetration hypha formation for entry into host",
  "GO:0075203": "positive regulation of symbiont penetration hypha formation for entry into host",
  "GO:0075204": "negative regulation of symbiont penetration hypha formation for entry into host",
  "GO:0075205": "modulation by host of symbiont cAMP-mediated signal transduction",
  "GO:0075206": "positive regulation by host of symbiont cAMP-mediated signal transduction",
  "GO:0075207": "negative regulation by host of symbiont cAMP-mediated signal transduction",
  "GO:0075208": "modulation by symbiont of host cAMP-mediated signal transduction",
  "GO:0075209": "positive regulation by symbiont of host cAMP-mediated signal transduction",
  "GO:0075210": "negative regulation by symbiont of host cAMP-mediated signal transduction",
  "GO:0075211": "regulation of transmembrane receptor-mediated cAMP signaling in response to host",
  "GO:0075212": "positive regulation of transmembrane receptor-mediated cAMP signal transduction in response to host",
  "GO:0075213": "negative regulation of transmembrane receptor-mediated cAMP signal transduction in response to host",
  "GO:0075214": "spore encystment on host",
  "GO:0075215": "modulation of spore encystment on host",
  "GO:0075216": "positive regulation of spore encystment on host",
  "GO:0075217": "negative regulation of spore encystment on host",
  "GO:0075218": "zoospore encystment on host",
  "GO:0075219": "modulation of zoospore encystment on host",
  "GO:0075220": "positive regulation of zoospore encystment on host",
  "GO:0075221": "negative regulation of zoospore encystment on host",
  "GO:0075222": "sporangium germination on or near host",
  "GO:0075223": "modulation of sporangium germination on or near host",
  "GO:0075224": "positive regulation of sporangium germination on or near host",
  "GO:0075225": "negative regulation of sporangium germination on or near host",
  "GO:0075226": "encysted zoospore germination on or near host",
  "GO:0075227": "modulation of encysted zoospore germination on or near host",
  "GO:0075228": "positive regulation of encysted zoospore germination on or near host",
  "GO:0075229": "negative regulation of encysted zoospore germination on or near host",
  "GO:0075230": "spore movement on or near host",
  "GO:0075231": "modulation of spore movement on or near host",
  "GO:0075232": "positive regulation of spore movement on or near host",
  "GO:0075233": "negative regulation of spore movement on or near host",
  "GO:0075234": "zoospore movement on or near host",
  "GO:0075235": "modulation of zoospore movement on or near host",
  "GO:0075236": "positive regulation of zoospore movement on or near host",
  "GO:0075237": "negative regulation of zoospore movement on or near host",
  "GO:0075238": "maintenance of symbiont tolerance to host pH environment",
  "GO:0075239": "zoospore formation",
  "GO:0075240": "regulation of zoospore formation",
  "GO:0075241": "positive regulation of zoospore formation",
  "GO:0075242": "negative regulation of zoospore formation",
  "GO:0075243": "oospore formation",
  "GO:0075244": "regulation of oospore formation",
  "GO:0075245": "positive regulation of oospore formation",
  "GO:0075246": "negative regulation of oospore formation",
  "GO:0075247": "aeciospore formation",
  "GO:0075248": "regulation of aeciospore formation",
  "GO:0075249": "positive regulation of aeciospore formation",
  "GO:0075250": "negative regulation of aeciospore formation",
  "GO:0075251": "uredospore formation",
  "GO:0075252": "regulation of uredospore formation",
  "GO:0075253": "positive regulation of uredospore formation",
  "GO:0075254": "negative regulation of uredospore formation",
  "GO:0075255": "teliospore formation",
  "GO:0075256": "regulation of teliospore formation",
  "GO:0075257": "positive regulation of teliospore formation",
  "GO:0075258": "negative regulation of teliospore formation",
  "GO:0075259": "spore-bearing organ development",
  "GO:0075260": "regulation of spore-bearing organ development",
  "GO:0075261": "positive regulation of spore-bearing organ development",
  "GO:0075262": "negative regulation of spore-bearing organ development",
  "GO:0075263": "oogonium development",
  "GO:0075264": "regulation of oogonium development",
  "GO:0075265": "positive regulation of oogonium development",
  "GO:0075266": "negative regulation of oogonium development",
  "GO:0075267": "aecium development",
  "GO:0075268": "regulation of aecium development",
  "GO:0075269": "positive regulation of aecium development",
  "GO:0075270": "negative regulation of aecium development",
  "GO:0075271": "zygosporangium development",
  "GO:0075272": "regulation of zygosporangium development",
  "GO:0075273": "positive regulation of zygosporangium development",
  "GO:0075274": "negative regulation of zygosporangium development",
  "GO:0075275": "telium development",
  "GO:0075276": "regulation of telium development",
  "GO:0075277": "positive regulation of telium development",
  "GO:0075278": "negative regulation of telium development",
  "GO:0075279": "uredinium development",
  "GO:0075280": "regulation of uredinium development",
  "GO:0075281": "positive regulation of uredinium development",
  "GO:0075282": "negative regulation of uredinium development",
  "GO:0075283": "sporulation resulting in formation of a multicellular or syncytial spore",
  "GO:0075284": "asexual sporulation resulting in formation of a multicellular or syncytial spore",
  "GO:0075285": "sexual sporulation resulting in formation of a multicellular or syncytial spore",
  "GO:0075286": "regulation of sporangiospore formation",
  "GO:0075287": "positive regulation of sporangiospore formation",
  "GO:0075288": "negative regulation of sporangiospore formation",
  "GO:0075289": "aplanospore formation",
  "GO:0075290": "regulation of aplanospore formation",
  "GO:0075291": "positive regulation of aplanospore formation",
  "GO:0075292": "negative regulation of aplanospore formation",
  "GO:0075293": "response to host pH environment",
  "GO:0075294": "positive regulation by symbiont of entry into host",
  "GO:0075295": "positive regulation by organism of entry into other organism involved in symbiotic interaction",
  "GO:0075296": "positive regulation of ascospore formation",
  "GO:0075297": "negative regulation of ascospore formation",
  "GO:0075298": "regulation of zygospore formation",
  "GO:0075299": "positive regulation of zygospore formation",
  "GO:0075300": "negative regulation of zygospore formation",
  "GO:0075301": "cell differentiation involved in spore germination",
  "GO:0075302": "regulation of basidiospore formation",
  "GO:0075303": "positive regulation of basidiospore formation",
  "GO:0075304": "negative regulation of basidiospore formation",
  "GO:0075305": "obsolete modulation of growth or development of symbiont on or near host",
  "GO:0075306": "regulation of conidium formation",
  "GO:0075307": "positive regulation of conidium formation",
  "GO:0075308": "negative regulation of conidium formation",
  "GO:0075309": "obsolete negative regulation of growth or development of symbiont on or near host surface",
  "GO:0075310": "regulation of sporangium development",
  "GO:0075311": "positive regulation of sporangium development",
  "GO:0075312": "negative regulation of sporangium development",
  "GO:0075313": "basidium development",
  "GO:0075314": "regulation of basidium development",
  "GO:0075315": "positive regulation of basidium development",
  "GO:0075316": "negative regulation of basidium development",
  "GO:0075317": "ascus development",
  "GO:0075318": "regulation of ascus development",
  "GO:0075319": "positive regulation of ascus development",
  "GO:0075320": "negative regulation of ascus development",
  "GO:0075321": "oomycete sporangium development",
  "GO:0075322": "regulation of oomycete sporangium development",
  "GO:0075323": "positive regulation of oomycete sporangium development",
  "GO:0075324": "negative regulation of oomycete sporangium development",
  "GO:0075325": "spore dispersal on or near host",
  "GO:0075326": "active spore dispersal on or near host",
  "GO:0075327": "passive spore dispersal on or near host",
  "GO:0075328": "formation by symbiont of arbuscule for nutrient acquisition from host",
  "GO:0075329": "regulation of arbuscule formation for nutrient acquisition from host",
  "GO:0075330": "positive regulation of arbuscule formation for nutrient acquisition from host",
  "GO:0075331": "negative regulation of arbuscule formation for nutrient acquisition from host",
  "GO:0075332": "modulation by host of symbiont adenylate cyclase-mediated signal transduction",
  "GO:0075333": "positive regulation by host of symbiont adenylate cyclase-mediated signal transduction",
  "GO:0075334": "modulation of symbiont adenylate cyclase-mediated signal transduction in response to host",
  "GO:0075335": "positive regulation of symbiont adenylate cyclase-mediated signal transduction in response to host",
  "GO:0075336": "negative regulation of symbiont adenylate cyclase-mediated signal transduction in response to host",
  "GO:0075337": "obsolete positive regulation of growth or development of symbiont on or near host surface",
  "GO:0075338": "obsolete modulation of growth or development of symbiont during interaction with host",
  "GO:0075339": "obsolete positive regulation of growth or development of symbiont during interaction with host",
  "GO:0075340": "obsolete negative regulation of growth or development of symbiont during interaction with host",
  "GO:0075341": "host cell PML body",
  "GO:0075342": "disruption by symbiont of host cell PML body",
  "GO:0075343": "modulation by symbiont of abscisic acid levels in host",
  "GO:0075344": "modulation by symbiont of host protein levels",
  "GO:0075345": "modification by symbiont of host protein",
  "GO:0075346": "modification by symbiont of host protein by ubiquitination",
  "GO:0075502": "endosome membrane permeabilization involved in viral entry into host cell",
  "GO:0075503": "fusion of virus membrane with host macropinosome membrane",
  "GO:0075504": "macropinosomal membrane permeabilization involved in viral entry into host cell",
  "GO:0075505": "entry of intact viral capsid into host nucleus through nuclear pore complex",
  "GO:0075506": "entry of viral genome into host nucleus through nuclear pore complex via importin",
  "GO:0075507": "entry of viral genome into host nucleus via docking of viral capsid to the nuclear pore complex and injection of viral genome",
  "GO:0075508": "entry of viral genome into host nucleus via retainment of capsid in nuclear pore complex and release of genome into nucleoplasm",
  "GO:0075509": "endocytosis involved in viral entry into host cell",
  "GO:0075510": "macropinocytosis involved in viral entry into host cell",
  "GO:0075511": "macropinosome lysis involved in viral entry into host cell",
  "GO:0075512": "clathrin-mediated endocytosis of virus by host cell",
  "GO:0075513": "caveolin-mediated endocytosis of virus by host cell",
  "GO:0075514": "endosome lysis involved in viral entry into host cell",
  "GO:0075515": "obsolete viral entry into host cell via caveolin-mediated endocytosis followed by genetic injection through the endosome membrane",
  "GO:0075519": "microtubule-dependent intracellular transport of viral material",
  "GO:0075520": "actin-dependent intracellular transport of virus",
  "GO:0075521": "microtubule-dependent intracellular transport of viral material towards nucleus",
  "GO:0075522": "IRES-dependent viral translational initiation",
  "GO:0075523": "viral translational frameshifting",
  "GO:0075524": "ribosomal skipping",
  "GO:0075525": "viral translational termination-reinitiation",
  "GO:0075526": "cap snatching",
  "GO:0075527": "viral RNA editing",
  "GO:0075528": "modulation by virus of host immune response",
  "GO:0075529": "establishment of latency as a circular episome",
  "GO:0075530": "establishment of latency as a linear episome",
  "GO:0075606": "transport of viral material towards nucleus",
  "GO:0075705": "obsolete viral entry into host cell via clathrin-mediated endocytosis followed by genetic injection through the endosome membrane",
  "GO:0075713": "establishment of integrated proviral latency",
  "GO:0075720": "establishment of episomal latency",
  "GO:0075732": "viral penetration into host nucleus",
  "GO:0075733": "intracellular transport of virus",
  "GO:0080001": "mucilage extrusion from seed coat",
  "GO:0080002": "UDP-glucose:4-aminobenzoate acylglucosyltransferase activity",
  "GO:0080003": "thalianol metabolic process",
  "GO:0080004": "thalian-diol desaturase activity",
  "GO:0080005": "photosystem stoichiometry adjustment",
  "GO:0080006": "internode patterning",
  "GO:0080007": "S-nitrosoglutathione reductase activity",
  "GO:0080008": "Cul4-RING E3 ubiquitin ligase complex",
  "GO:0080009": "mRNA methylation",
  "GO:0080010": "obsolete regulation of oxygen and reactive oxygen species metabolic process",
  "GO:0080011": "baruol synthase activity",
  "GO:0080012": "trihydroxyferuloyl spermidine O-methyltransferase activity",
  "GO:0080013": "(E,E)-geranyllinalool synthase activity",
  "GO:0080014": "thalianol hydroxylase activity",
  "GO:0080015": "sabinene synthase activity",
  "GO:0080016": "(-)-E-beta-caryophyllene synthase activity",
  "GO:0080017": "alpha-humulene synthase activity",
  "GO:0080018": "anthocyanin 5-O-glucosyltransferase activity",
  "GO:0080019": "fatty-acyl-CoA reductase (alcohol-forming) activity",
  "GO:0080020": "regulation of coenzyme A biosynthetic process",
  "GO:0080021": "response to benzoic acid",
  "GO:0080022": "primary root development",
  "GO:0080023": "3R-hydroxyacyl-CoA dehydratase activity",
  "GO:0080024": "indolebutyric acid metabolic process",
  "GO:0080025": "phosphatidylinositol-3,5-bisphosphate binding",
  "GO:0080026": "response to indolebutyric acid",
  "GO:0080027": "response to herbivore",
  "GO:0080028": "nitrile biosynthetic process",
  "GO:0080029": "cellular response to boron-containing substance levels",
  "GO:0080030": "methyl indole-3-acetate esterase activity",
  "GO:0080031": "methyl salicylate esterase activity",
  "GO:0080032": "methyl jasmonate esterase activity",
  "GO:0080033": "response to nitrite",
  "GO:0080034": "host response to induction by symbiont of tumor, nodule or growth in host",
  "GO:0080035": "2-hydroxy-but-3-enyl glucosinolate biosynthetic process",
  "GO:0080036": "regulation of cytokinin-activated signaling pathway",
  "GO:0080037": "negative regulation of cytokinin-activated signaling pathway",
  "GO:0080038": "positive regulation of cytokinin-activated signaling pathway",
  "GO:0080039": "xyloglucan endotransglucosylase activity",
  "GO:0080040": "positive regulation of cellular response to phosphate starvation",
  "GO:0080041": "ADP-ribose pyrophosphohydrolase activity",
  "GO:0080042": "ADP-glucose pyrophosphohydrolase activity",
  "GO:0080043": "quercetin 3-O-glucosyltransferase activity",
  "GO:0080044": "quercetin 7-O-glucosyltransferase activity",
  "GO:0080045": "quercetin 3'-O-glucosyltransferase activity",
  "GO:0080046": "quercetin 4'-O-glucosyltransferase activity",
  "GO:0080047": "GDP-L-galactose phosphorylase activity",
  "GO:0080048": "GDP-D-glucose phosphorylase activity",
  "GO:0080049": "L-gulono-1,4-lactone dehydrogenase activity",
  "GO:0080050": "regulation of seed development",
  "GO:0080051": "cutin transport",
  "GO:0080052": "response to histidine",
  "GO:0080053": "response to phenylalanine",
  "GO:0080054": "low-affinity nitrate transmembrane transporter activity",
  "GO:0080055": "low-affinity nitrate transport",
  "GO:0080056": "petal vascular tissue pattern formation",
  "GO:0080057": "sepal vascular tissue pattern formation",
  "GO:0080058": "protein deglutathionylation",
  "GO:0080059": "flavonol 3-O-arabinosyltransferase activity",
  "GO:0080060": "integument development",
  "GO:0080061": "indole-3-acetonitrile nitrilase activity",
  "GO:0080062": "cytokinin 9-beta-glucosyltransferase activity",
  "GO:0080064": "4,4-dimethyl-9beta,19-cyclopropylsterol oxidation",
  "GO:0080065": "4-alpha-methyl-delta7-sterol oxidation",
  "GO:0080066": "3-methylthiopropyl-desulfoglucosinolate sulfotransferase activity",
  "GO:0080067": "4-methylthiobutyl-desulfoglucosinolate sulfotransferase activity",
  "GO:0080068": "5-methylthiopentyl-desulfoglucosinolate sulfotransferase activity",
  "GO:0080069": "7-methylthioheptyl-desulfoglucosinolate sulfotransferase activity",
  "GO:0080070": "8-methylthiooctyl-desulfoglucosinolate sulfotransferase activity",
  "GO:0080071": "indol-3-yl-methyl-desulfoglucosinolate sulfotransferase activity",
  "GO:0080072": "spermidine:sinapoyl CoA N-acyltransferase activity",
  "GO:0080073": "spermidine:coumaroyl CoA N-acyltransferase activity",
  "GO:0080074": "spermidine:caffeoyl CoA N-acyltransferase activity",
  "GO:0080075": "spermidine:feruloyl CoA N-acyltransferase activity",
  "GO:0080076": "caffeoyl CoA:S-adenosyl-L-methionine O-methyltransferase activity",
  "GO:0080077": "trihydroxyferuloyl spermidine:S-adenosyl-L-methionine O-methyltransferase activity",
  "GO:0080078": "tricaffeoyl spermidine:S-adenosyl-L-methionine O-methyltransferase activity",
  "GO:0080079": "cellobiose glucosidase activity",
  "GO:0080081": "4-methylumbelliferyl-beta-D-glucopyranoside beta-glucosidase activity",
  "GO:0080082": "esculin beta-glucosidase activity",
  "GO:0080083": "beta-gentiobiose beta-glucosidase activity",
  "GO:0080084": "5S rDNA binding",
  "GO:0080085": "signal recognition particle, chloroplast targeting",
  "GO:0080086": "stamen filament development",
  "GO:0080088": "spermidine hydroxycinnamate conjugate biosynthetic process",
  "GO:0080089": "sinapoyl spermidine:sinapoyl CoA N-acyltransferase activity",
  "GO:0080090": "regulation of primary metabolic process",
  "GO:0080091": "regulation of raffinose metabolic process",
  "GO:0080092": "regulation of pollen tube growth",
  "GO:0080093": "regulation of photorespiration",
  "GO:0080094": "response to trehalose-6-phosphate",
  "GO:0080095": "phosphatidylethanolamine-sterol O-acyltransferase activity",
  "GO:0080096": "phosphatidate-sterol O-acyltransferase activity",
  "GO:0080097": "L-tryptophan:pyruvate aminotransferase activity",
  "GO:0080098": "L-tyrosine:pyruvate aminotransferase activity",
  "GO:0080099": "L-methionine:2-oxoglutarate aminotransferase activity",
  "GO:0080100": "L-glutamine:2-oxoglutarate aminotransferase activity",
  "GO:0080101": "phosphatidyl-N-dimethylethanolamine N-methyltransferase activity",
  "GO:0080102": "3-methylthiopropyl glucosinolate S-oxygenase activity",
  "GO:0080103": "4-methylthiopropyl glucosinolate S-oxygenase activity",
  "GO:0080104": "5-methylthiopropyl glucosinolate S-oxygenase activity",
  "GO:0080105": "6-methylthiopropyl glucosinolate S-oxygenase activity",
  "GO:0080106": "7-methylthiopropyl glucosinolate S-oxygenase activity",
  "GO:0080107": "8-methylthiopropyl glucosinolate S-oxygenase activity",
  "GO:0080108": "S-alkylthiohydroximate lyase activity",
  "GO:0080109": "indole-3-acetonitrile nitrile hydratase activity",
  "GO:0080110": "sporopollenin biosynthetic process",
  "GO:0080111": "DNA demethylation",
  "GO:0080112": "seed growth",
  "GO:0080113": "regulation of seed growth",
  "GO:0080114": "positive regulation of glycine hydroxymethyltransferase activity",
  "GO:0080115": "myosin XI tail binding",
  "GO:0080116": "glucuronoxylan glucuronosyltransferase activity",
  "GO:0080117": "secondary growth",
  "GO:0080118": "brassinosteroid sulfotransferase activity",
  "GO:0080119": "ER body organization",
  "GO:0080120": "CAAX-box protein maturation",
  "GO:0080121": "AMP transport",
  "GO:0080122": "AMP transmembrane transporter activity",
  "GO:0080123": "jasmonate-amino synthetase activity",
  "GO:0080124": "pheophytinase activity",
  "GO:0080125": "multicellular structure septum development",
  "GO:0080126": "ovary septum development",
  "GO:0080127": "fruit septum development",
  "GO:0080128": "anther septum development",
  "GO:0080129": "proteasome core complex assembly",
  "GO:0080130": "L-phenylalanine:2-oxoglutarate aminotransferase activity",
  "GO:0080131": "hydroxyjasmonate sulfotransferase activity",
  "GO:0080132": "fatty acid alpha-hydroxylase activity",
  "GO:0080133": "midchain alkane hydroxylase activity",
  "GO:0080134": "regulation of response to stress",
  "GO:0080135": "regulation of cellular response to stress",
  "GO:0080136": "priming of cellular response to stress",
  "GO:0080138": "borate uptake transmembrane transporter activity",
  "GO:0080139": "borate efflux transmembrane transporter activity",
  "GO:0080140": "regulation of jasmonic acid metabolic process",
  "GO:0080141": "regulation of jasmonic acid biosynthetic process",
  "GO:0080142": "regulation of salicylic acid biosynthetic process",
  "GO:0080143": "regulation of amino acid export",
  "GO:0080144": "amino acid homeostasis",
  "GO:0080145": "cysteine homeostasis",
  "GO:0080146": "L-cysteine desulfhydrase activity",
  "GO:0080147": "root hair cell development",
  "GO:0080148": "negative regulation of response to water deprivation",
  "GO:0080149": "sucrose induced translational repression",
  "GO:0080150": "S-adenosyl-L-methionine:benzoic acid carboxyl methyl transferase activity",
  "GO:0080151": "positive regulation of salicylic acid mediated signaling pathway",
  "GO:0080152": "regulation of reductive pentose-phosphate cycle",
  "GO:0080153": "negative regulation of reductive pentose-phosphate cycle",
  "GO:0080154": "regulation of fertilization",
  "GO:0080155": "regulation of double fertilization forming a zygote and endosperm",
  "GO:0080156": "mitochondrial mRNA modification",
  "GO:0080157": "regulation of plant-type cell wall organization or biogenesis",
  "GO:0080158": "chloroplast ribulose bisphosphate carboxylase complex biogenesis",
  "GO:0080159": "zygote elongation",
  "GO:0080160": "selenate transport",
  "GO:0080161": "auxin transmembrane transporter activity",
  "GO:0080162": "intracellular auxin transport",
  "GO:0080163": "regulation of protein serine/threonine phosphatase activity",
  "GO:0080164": "regulation of nitric oxide metabolic process",
  "GO:0080165": "callose deposition in phloem sieve plate",
  "GO:0080166": "stomium development",
  "GO:0080167": "response to karrikin",
  "GO:0080168": "abscisic acid transport",
  "GO:0080169": "cellular response to boron-containing substance deprivation",
  "GO:0080170": "hydrogen peroxide transmembrane transport",
  "GO:0080171": "lytic vacuole organization",
  "GO:0080172": "petal epidermis patterning",
  "GO:0080173": "male-female gamete recognition during double fertilization",
  "GO:0080175": "phragmoplast microtubule organization",
  "GO:0080176": "xyloglucan 1,6-alpha-xylosidase activity",
  "GO:0080177": "plastoglobule organization",
  "GO:0080178": "5-carbamoylmethyluridine metabolic process",
  "GO:0080179": "1-methylguanosine metabolic process",
  "GO:0080180": "2-methylguanosine metabolic process",
  "GO:0080181": "lateral root branching",
  "GO:0080182": "histone H3-K4 trimethylation",
  "GO:0080183": "response to photooxidative stress",
  "GO:0080184": "response to phenylpropanoid",
  "GO:0080185": "effector dependent induction by symbiont of host immune response",
  "GO:0080186": "developmental vegetative growth",
  "GO:0080187": "floral organ senescence",
  "GO:0080188": "RNA-directed DNA methylation",
  "GO:0080189": "primary growth",
  "GO:0080190": "lateral growth",
  "GO:0080191": "secondary thickening",
  "GO:0080192": "primary thickening",
  "GO:0080193": "diffuse secondary thickening",
  "GO:0085000": "modification by symbiont of host morphology or physiology via protein secreted by type V secretion system",
  "GO:0085001": "formation by symbiont of stylet for nutrient acquisition from host",
  "GO:0085002": "interaction with host mediated by secreted substance released by symbiont from symbiotic structure",
  "GO:0085003": "interaction with host via secreted substance released from stylet",
  "GO:0085004": "interaction with host via secreted substance released from haustorium",
  "GO:0085005": "interaction with host via secreted substance released from invasive hyphae",
  "GO:0085006": "interaction with host mediated by symbiont secreted substance released from symbiont-containing vacuole",
  "GO:0085007": "interaction with host via secreted substance released from rhoptry",
  "GO:0085008": "interaction with host via secreted substance released from microneme",
  "GO:0085009": "interaction with host mediated by symbiont secreted substance released from Maurer's cleft",
  "GO:0085010": "interaction with host mediated by secreted substance entering host via endocytosis",
  "GO:0085011": "interaction with host via protein secreted by Sec complex",
  "GO:0085012": "interaction with host via protein secreted by Tat complex",
  "GO:0085013": "interaction with host via protein secreted by type VII secretion system",
  "GO:0085014": "dormancy entry of symbiont in host",
  "GO:0085015": "dormancy maintenance of symbiont in host",
  "GO:0085016": "dormancy exit of symbiont in host",
  "GO:0085017": "symbiont entry into host cell forming a symbiont-containing vacuole",
  "GO:0085018": "maintenance of symbiont-containing vacuole by host",
  "GO:0085019": "formation by symbiont of a tubovesicular network for nutrient acquisition from host",
  "GO:0085020": "protein K6-linked ubiquitination",
  "GO:0085021": "modification by symbiont of host morphology or physiology via protein secreted by type I secretion system",
  "GO:0085022": "modification by symbiont of host morphology or physiology via protein secreted by type VI secretion system",
  "GO:0085023": "modification by symbiont of host morphology or physiology via protein secreted by type VII secretion system",
  "GO:0085024": "modification by symbiont of host morphology or physiology via protein secreted by Sec complex",
  "GO:0085025": "modification by symbiont of host morphology or physiology via protein secreted by Tat complex",
  "GO:0085026": "tubovesicular membrane network",
  "GO:0085027": "entry into host via enzymatic degradation of host anatomical structure",
  "GO:0085028": "entry into host via enzymatic degradation of host cuticle",
  "GO:0085029": "extracellular matrix assembly",
  "GO:0085030": "mutualism",
  "GO:0085031": "commensalism",
  "GO:0085032": "modulation by symbiont of host I-kappaB kinase/NF-kappaB cascade",
  "GO:0085033": "positive regulation by symbiont of host I-kappaB kinase/NF-kappaB cascade",
  "GO:0085034": "negative regulation by symbiont of host I-kappaB kinase/NF-kappaB cascade",
  "GO:0085035": "haustorium",
  "GO:0085036": "extrahaustorial matrix",
  "GO:0085037": "extrahaustorial membrane",
  "GO:0085039": "extra-invasive hyphal membrane",
  "GO:0085040": "extra-invasive hyphal space",
  "GO:0085041": "arbuscule",
  "GO:0085042": "periarbuscular membrane",
  "GO:0085044": "disassembly by symbiont of host cuticle",
  "GO:0086001": "cardiac muscle cell action potential",
  "GO:0086002": "cardiac muscle cell action potential involved in contraction",
  "GO:0086003": "cardiac muscle cell contraction",
  "GO:0086004": "regulation of cardiac muscle cell contraction",
  "GO:0086005": "ventricular cardiac muscle cell action potential",
  "GO:0086006": "voltage-gated sodium channel activity involved in cardiac muscle cell action potential",
  "GO:0086007": "voltage-gated calcium channel activity involved in cardiac muscle cell action potential",
  "GO:0086008": "voltage-gated potassium channel activity involved in cardiac muscle cell action potential repolarization",
  "GO:0086009": "membrane repolarization",
  "GO:0086010": "membrane depolarization during action potential",
  "GO:0086011": "membrane repolarization during action potential",
  "GO:0086012": "membrane depolarization during cardiac muscle cell action potential",
  "GO:0086013": "membrane repolarization during cardiac muscle cell action potential",
  "GO:0086014": "atrial cardiac muscle cell action potential",
  "GO:0086015": "SA node cell action potential",
  "GO:0086016": "AV node cell action potential",
  "GO:0086017": "Purkinje myocyte action potential",
  "GO:0086018": "SA node cell to atrial cardiac muscle cell signalling",
  "GO:0086019": "cell-cell signaling involved in cardiac conduction",
  "GO:0086020": "gap junction channel activity involved in SA node cell-atrial cardiac muscle cell electrical coupling",
  "GO:0086021": "SA node cell to atrial cardiac muscle cell communication by electrical coupling",
  "GO:0086022": "SA node cell-atrial cardiac muscle cell adhesion involved in cell communication",
  "GO:0086023": "adrenergic receptor signaling pathway involved in heart process",
  "GO:0086024": "adrenergic receptor signaling pathway involved in positive regulation of heart rate",
  "GO:0086026": "atrial cardiac muscle cell to AV node cell signaling",
  "GO:0086027": "AV node cell to bundle of His cell signaling",
  "GO:0086028": "bundle of His cell to Purkinje myocyte signaling",
  "GO:0086029": "Purkinje myocyte to ventricular cardiac muscle cell signaling",
  "GO:0086030": "adrenergic receptor signaling pathway involved in cardiac muscle relaxation",
  "GO:0086033": "G-protein coupled acetylcholine receptor signaling pathway involved in negative regulation of heart rate",
  "GO:0086036": "regulation of cardiac muscle cell membrane potential",
  "GO:0086037": "sodium:potassium-exchanging ATPase activity involved in regulation of cardiac muscle cell membrane potential",
  "GO:0086038": "calcium:sodium antiporter activity involved in regulation of cardiac muscle cell membrane potential",
  "GO:0086039": "calcium-transporting ATPase activity involved in regulation of cardiac muscle cell membrane potential",
  "GO:0086040": "sodium:proton antiporter activity involved in regulation of cardiac muscle cell membrane potential",
  "GO:0086041": "voltage-gated potassium channel activity involved in SA node cell action potential depolarization",
  "GO:0086042": "cardiac muscle cell-cardiac muscle cell adhesion",
  "GO:0086043": "bundle of His cell action potential",
  "GO:0086044": "atrial cardiac muscle cell to AV node cell communication by electrical coupling",
  "GO:0086045": "membrane depolarization during AV node cell action potential",
  "GO:0086046": "membrane depolarization during SA node cell action potential",
  "GO:0086047": "membrane depolarization during Purkinje myocyte cell action potential",
  "GO:0086048": "membrane depolarization during bundle of His cell action potential",
  "GO:0086049": "membrane repolarization during AV node cell action potential",
  "GO:0086050": "membrane repolarization during bundle of His cell action potential",
  "GO:0086051": "membrane repolarization during Purkinje myocyte action potential",
  "GO:0086052": "membrane repolarization during SA node cell action potential",
  "GO:0086053": "AV node cell to bundle of His cell communication by electrical coupling",
  "GO:0086054": "bundle of His cell to Purkinje myocyte communication by electrical coupling",
  "GO:0086055": "Purkinje myocyte to ventricular cardiac muscle cell communication by electrical coupling",
  "GO:0086056": "voltage-gated calcium channel activity involved in AV node cell action potential",
  "GO:0086057": "voltage-gated calcium channel activity involved in bundle of His cell action potential",
  "GO:0086058": "voltage-gated calcium channel activity involved in Purkinje myocyte cell action potential",
  "GO:0086059": "voltage-gated calcium channel activity involved SA node cell action potential",
  "GO:0086060": "voltage-gated sodium channel activity involved in AV node cell action potential",
  "GO:0086061": "voltage-gated sodium channel activity involved in bundle of His cell action potential",
  "GO:0086062": "voltage-gated sodium channel activity involved in Purkinje myocyte action potential",
  "GO:0086063": "voltage-gated sodium channel activity involved in SA node cell action potential",
  "GO:0086064": "cell communication by electrical coupling involved in cardiac conduction",
  "GO:0086065": "cell communication involved in cardiac conduction",
  "GO:0086066": "atrial cardiac muscle cell to AV node cell communication",
  "GO:0086067": "AV node cell to bundle of His cell communication",
  "GO:0086068": "Purkinje myocyte to ventricular cardiac muscle cell communication",
  "GO:0086069": "bundle of His cell to Purkinje myocyte communication",
  "GO:0086070": "SA node cell to atrial cardiac muscle cell communication",
  "GO:0086071": "atrial cardiac muscle cell-AV node cell adhesion involved in cell communication",
  "GO:0086072": "AV node cell-bundle of His cell adhesion involved in cell communication",
  "GO:0086073": "bundle of His cell-Purkinje myocyte adhesion involved in cell communication",
  "GO:0086074": "Purkinje myocyte-ventricular cardiac muscle cell adhesion involved in cell communication",
  "GO:0086075": "gap junction channel activity involved in cardiac conduction electrical coupling",
  "GO:0086076": "gap junction channel activity involved in atrial cardiac muscle cell-AV node cell electrical coupling",
  "GO:0086077": "gap junction channel activity involved in AV node cell-bundle of His cell electrical coupling",
  "GO:0086078": "gap junction channel activity involved in bundle of His cell-Purkinje myocyte electrical coupling",
  "GO:0086079": "gap junction channel activity involved in Purkinje myocyte-ventricular cardiac muscle cell electrical coupling",
  "GO:0086080": "protein binding involved in heterotypic cell-cell adhesion",
  "GO:0086081": "cell adhesive protein binding involved in atrial cardiac muscle cell-AV node cell communication",
  "GO:0086082": "cell adhesive protein binding involved in AV node cell-bundle of His cell communication",
  "GO:0086083": "cell adhesive protein binding involved in bundle of His cell-Purkinje myocyte communication",
  "GO:0086084": "cell adhesive protein binding involved in Purkinje myocyte-ventricular cardiac muscle cell communication",
  "GO:0086085": "cell adhesive protein binding involved in SA cardiac muscle cell-atrial cardiac muscle cell communication",
  "GO:0086086": "voltage-gated potassium channel activity involved in AV node cell action potential repolarization",
  "GO:0086087": "voltage-gated potassium channel activity involved in bundle of His cell action potential repolarization",
  "GO:0086088": "voltage-gated potassium channel activity involved in Purkinje myocyte action potential repolarization",
  "GO:0086089": "voltage-gated potassium channel activity involved in atrial cardiac muscle cell action potential repolarization",
  "GO:0086090": "voltage-gated potassium channel activity involved in SA node cell action potential repolarization",
  "GO:0086091": "regulation of heart rate by cardiac conduction",
  "GO:0086092": "regulation of the force of heart contraction by cardiac conduction",
  "GO:0086093": "G-protein coupled acetylcholine receptor signaling pathway involved in heart process",
  "GO:0086094": "positive regulation of ryanodine-sensitive calcium-release channel activity by adrenergic receptor signaling pathway involved in positive regulation of cardiac muscle contraction",
  "GO:0086095": "positive regulation of IKACh channel activity by G-protein coupled acetylcholine receptor signaling pathway involved in negative regulation of heart rate",
  "GO:0086096": "adenylate cyclase-inhibiting adrenergic receptor signaling pathway involved in heart process",
  "GO:0086097": "phospholipase C-activating angiotensin-activated signaling pathway",
  "GO:0086098": "angiotensin-activated signaling pathway involved in heart process",
  "GO:0086099": "phospholipase C-activating angiotensin-activated signaling pathway involved in heart process",
  "GO:0086100": "endothelin receptor signaling pathway",
  "GO:0086101": "endothelin receptor signaling pathway involved in heart process",
  "GO:0086102": "adenylate cyclase-inhibiting G-protein coupled acetylcholine receptor signaling pathway involved in negative regulation of heart rate",
  "GO:0086103": "G-protein coupled receptor signaling pathway involved in heart process",
  "GO:0089700": "protein kinase D signaling",
  "GO:0089701": "U2AF",
  "GO:0089702": "undecaprenyl-phosphate glucose phosphotransferase activity",
  "GO:0089703": "L-aspartate transmembrane export from vacuole",
  "GO:0089704": "L-glutamate transmembrane export from vacuole",
  "GO:0089705": "protein localization to outer membrane",
  "GO:0089706": "L-ornithine transmembrane export from vacuole",
  "GO:0089707": "L-lysine transmembrane export from vacuole",
  "GO:0089708": "L-histidine transmembrane export from vacuole",
  "GO:0089709": "L-histidine transmembrane transport",
  "GO:0089710": "endocytic targeting sequence binding",
  "GO:0089711": "L-glutamate transmembrane transport",
  "GO:0089712": "L-aspartate transmembrane transport",
  "GO:0089713": "Cbf1-Met4-Met28 complex",
  "GO:0089714": "UDP-N-acetyl-D-mannosamine dehydrogenase activity",
  "GO:0089715": "tRNA m6t6A37 methyltransferase activity",
  "GO:0089716": "Pip2-Oaf1 complex",
  "GO:0089717": "spanning component of membrane",
  "GO:0089718": "amino acid import across plasma membrane",
  "GO:0089719": "RHG protein domain binding",
  "GO:0089720": "caspase binding",
  "GO:0089721": "phosphoenolpyruvate transmembrane transporter activity",
  "GO:0089722": "phosphoenolpyruvate transmembrane transport",
  "GO:0090001": "replication fork arrest at tRNA locus",
  "GO:0090002": "establishment of protein localization to plasma membrane",
  "GO:0090003": "regulation of establishment of protein localization to plasma membrane",
  "GO:0090004": "positive regulation of establishment of protein localization to plasma membrane",
  "GO:0090005": "negative regulation of establishment of protein localization to plasma membrane",
  "GO:0090006": "regulation of linear element assembly",
  "GO:0090007": "obsolete regulation of mitotic anaphase",
  "GO:0090008": "hypoblast development",
  "GO:0090009": "primitive streak formation",
  "GO:0090010": "transforming growth factor beta receptor signaling pathway involved in primitive streak formation",
  "GO:0090011": "Wnt signaling pathway involved in primitive streak formation",
  "GO:0090012": "negative regulation of transforming growth factor beta receptor signaling pathway involved in primitive streak formation",
  "GO:0090013": "regulation of transforming growth factor beta receptor signaling pathway involved in primitive streak formation",
  "GO:0090014": "leaflet formation",
  "GO:0090015": "positive regulation of leaflet formation by auxin mediated signaling pathway",
  "GO:0090016": "regulation of leaflet formation",
  "GO:0090017": "anterior neural plate formation",
  "GO:0090018": "posterior neural plate formation",
  "GO:0090019": "regulation of transcription involved in anterior neural plate formation",
  "GO:0090020": "regulation of transcription involved in posterior neural plate formation",
  "GO:0090021": "positive regulation of posterior neural plate formation by Wnt signaling pathway",
  "GO:0090022": "regulation of neutrophil chemotaxis",
  "GO:0090023": "positive regulation of neutrophil chemotaxis",
  "GO:0090024": "negative regulation of neutrophil chemotaxis",
  "GO:0090025": "regulation of monocyte chemotaxis",
  "GO:0090026": "positive regulation of monocyte chemotaxis",
  "GO:0090027": "negative regulation of monocyte chemotaxis",
  "GO:0090028": "positive regulation of pheromone-dependent signal transduction involved in conjugation with cellular fusion",
  "GO:0090029": "negative regulation of pheromone-dependent signal transduction involved in conjugation with cellular fusion",
  "GO:0090030": "regulation of steroid hormone biosynthetic process",
  "GO:0090031": "positive regulation of steroid hormone biosynthetic process",
  "GO:0090032": "negative regulation of steroid hormone biosynthetic process",
  "GO:0090033": "positive regulation of filamentous growth",
  "GO:0090034": "regulation of chaperone-mediated protein complex assembly",
  "GO:0090035": "positive regulation of chaperone-mediated protein complex assembly",
  "GO:0090036": "regulation of protein kinase C signaling",
  "GO:0090037": "positive regulation of protein kinase C signaling",
  "GO:0090038": "negative regulation of protein kinase C signaling",
  "GO:0090042": "tubulin deacetylation",
  "GO:0090043": "regulation of tubulin deacetylation",
  "GO:0090044": "positive regulation of tubulin deacetylation",
  "GO:0090045": "positive regulation of deacetylase activity",
  "GO:0090046": "obsolete regulation of transcription regulator activity",
  "GO:0090047": "obsolete positive regulation of transcription regulator activity",
  "GO:0090048": "obsolete negative regulation of transcription regulator activity",
  "GO:0090049": "regulation of cell migration involved in sprouting angiogenesis",
  "GO:0090050": "positive regulation of cell migration involved in sprouting angiogenesis",
  "GO:0090051": "negative regulation of cell migration involved in sprouting angiogenesis",
  "GO:0090052": "regulation of chromatin silencing at centromere",
  "GO:0090053": "positive regulation of chromatin silencing at centromere",
  "GO:0090054": "regulation of chromatin silencing at silent mating-type cassette",
  "GO:0090055": "positive regulation of chromatin silencing at silent mating-type cassette",
  "GO:0090056": "regulation of chlorophyll metabolic process",
  "GO:0090057": "root radial pattern formation",
  "GO:0090058": "metaxylem development",
  "GO:0090059": "protoxylem development",
  "GO:0090060": "regulation of metaxylem development",
  "GO:0090062": "regulation of trehalose metabolic process",
  "GO:0090063": "positive regulation of microtubule nucleation",
  "GO:0090064": "activation of microtubule nucleation",
  "GO:0090065": "regulation of production of siRNA involved in RNA interference",
  "GO:0090066": "regulation of anatomical structure size",
  "GO:0090067": "regulation of thalamus size",
  "GO:0090068": "positive regulation of cell cycle process",
  "GO:0090069": "regulation of ribosome biogenesis",
  "GO:0090070": "positive regulation of ribosome biogenesis",
  "GO:0090071": "negative regulation of ribosome biogenesis",
  "GO:0090072": "obsolete positive regulation of sodium ion transport via voltage-gated sodium channel activity",
  "GO:0090073": "positive regulation of protein homodimerization activity",
  "GO:0090074": "negative regulation of protein homodimerization activity",
  "GO:0090075": "relaxation of muscle",
  "GO:0090076": "relaxation of skeletal muscle",
  "GO:0090077": "foam cell differentiation",
  "GO:0090078": "smooth muscle derived foam cell differentiation",
  "GO:0090079": "translation regulator activity, nucleic acid binding",
  "GO:0090080": "positive regulation of MAPKKK cascade by fibroblast growth factor receptor signaling pathway",
  "GO:0090081": "regulation of heart induction by regulation of canonical Wnt signaling pathway",
  "GO:0090082": "positive regulation of heart induction by negative regulation of canonical Wnt signaling pathway",
  "GO:0090083": "regulation of inclusion body assembly",
  "GO:0090084": "negative regulation of inclusion body assembly",
  "GO:0090085": "regulation of protein deubiquitination",
  "GO:0090086": "negative regulation of protein deubiquitination",
  "GO:0090087": "regulation of peptide transport",
  "GO:0090088": "regulation of oligopeptide transport",
  "GO:0090089": "regulation of dipeptide transport",
  "GO:0090090": "negative regulation of canonical Wnt signaling pathway",
  "GO:0090091": "positive regulation of extracellular matrix disassembly",
  "GO:0090092": "regulation of transmembrane receptor protein serine/threonine kinase signaling pathway",
  "GO:0090093": "regulation of fungal-type cell wall beta-glucan biosynthetic process",
  "GO:0090094": "metanephric cap mesenchymal cell proliferation involved in metanephros development",
  "GO:0090095": "regulation of metanephric cap mesenchymal cell proliferation",
  "GO:0090096": "positive regulation of metanephric cap mesenchymal cell proliferation",
  "GO:0090097": "regulation of decapentaplegic signaling pathway",
  "GO:0090098": "positive regulation of decapentaplegic signaling pathway",
  "GO:0090099": "negative regulation of decapentaplegic signaling pathway",
  "GO:0090100": "positive regulation of transmembrane receptor protein serine/threonine kinase signaling pathway",
  "GO:0090101": "negative regulation of transmembrane receptor protein serine/threonine kinase signaling pathway",
  "GO:0090102": "cochlea development",
  "GO:0090103": "cochlea morphogenesis",
  "GO:0090104": "pancreatic epsilon cell differentiation",
  "GO:0090105": "pancreatic E cell development",
  "GO:0090106": "pancreatic E cell fate commitment",
  "GO:0090107": "regulation of high-density lipoprotein particle assembly",
  "GO:0090108": "positive regulation of high-density lipoprotein particle assembly",
  "GO:0090109": "regulation of cell-substrate junction assembly",
  "GO:0090110": "cargo loading into COPII-coated vesicle",
  "GO:0090111": "regulation of COPII vesicle uncoating",
  "GO:0090112": "COPII vesicle uncoating",
  "GO:0090113": "regulation of ER to Golgi vesicle-mediated transport by GTP hydrolysis",
  "GO:0090114": "COPII-coated vesicle budding",
  "GO:0090115": "C-5 methylation on cytosine involved in chromatin silencing",
  "GO:0090116": "C-5 methylation of cytosine",
  "GO:0090117": "endosome to lysosome transport of low-density lipoprotein particle",
  "GO:0090118": "receptor-mediated endocytosis of low-density lipoprotein particle involved in cholesterol transport",
  "GO:0090119": "vesicle-mediated cholesterol transport",
  "GO:0090120": "lysosome to ER cholesterol transport",
  "GO:0090121": "low-density lipoprotein particle disassembly involved in cholesterol transport",
  "GO:0090122": "cholesterol ester hydrolysis involved in cholesterol transport",
  "GO:0090123": "lysosomal glycocalyx",
  "GO:0090124": "N-4 methylation of cytosine",
  "GO:0090125": "cell-cell adhesion involved in synapse maturation",
  "GO:0090126": "protein complex assembly involved in synapse maturation",
  "GO:0090127": "positive regulation of synapse maturation by synaptic transmission",
  "GO:0090128": "regulation of synapse maturation",
  "GO:0090129": "positive regulation of synapse maturation",
  "GO:0090130": "tissue migration",
  "GO:0090131": "mesenchyme migration",
  "GO:0090132": "epithelium migration",
  "GO:0090133": "mesendoderm migration",
  "GO:0090134": "cell migration involved in mesendoderm migration",
  "GO:0090135": "actin filament branching",
  "GO:0090136": "epithelial cell-cell adhesion",
  "GO:0090137": "epithelial cell-cell adhesion involved in epithelium migration",
  "GO:0090138": "regulation of actin cytoskeleton organization by cell-cell adhesion",
  "GO:0090139": "mitochondrial DNA packaging",
  "GO:0090140": "regulation of mitochondrial fission",
  "GO:0090141": "positive regulation of mitochondrial fission",
  "GO:0090143": "nucleoid organization",
  "GO:0090144": "mitochondrial nucleoid organization",
  "GO:0090145": "mitochondrial nucleoid organization involved in mitochondrial fission",
  "GO:0090146": "establishment of mitochondrion localization involved in mitochondrial fission",
  "GO:0090147": "regulation of establishment of mitochondrion localization involved in mitochondrial fission",
  "GO:0090148": "membrane fission",
  "GO:0090149": "mitochondrial membrane fission",
  "GO:0090150": "establishment of protein localization to membrane",
  "GO:0090151": "establishment of protein localization to mitochondrial membrane",
  "GO:0090152": "establishment of protein localization to mitochondrial membrane involved in mitochondrial fission",
  "GO:0090153": "regulation of sphingolipid biosynthetic process",
  "GO:0090154": "positive regulation of sphingolipid biosynthetic process",
  "GO:0090155": "negative regulation of sphingolipid biosynthetic process",
  "GO:0090156": "cellular sphingolipid homeostasis",
  "GO:0090157": "negative regulation of sphingolipid biosynthesis involved in cellular sphingolipid homeostasis",
  "GO:0090158": "endoplasmic reticulum membrane organization",
  "GO:0090159": "sphingolipid biosynthesis involved in endoplasmic reticulum membrane organization",
  "GO:0090160": "Golgi to lysosome transport",
  "GO:0090161": "Golgi ribbon formation",
  "GO:0090162": "establishment of epithelial cell polarity",
  "GO:0090163": "establishment of epithelial cell planar polarity",
  "GO:0090164": "asymmetric Golgi ribbon formation",
  "GO:0090165": "regulation of secretion by asymmetric Golgi ribbon formation",
  "GO:0090166": "Golgi disassembly",
  "GO:0090167": "Golgi distribution to daughter cells",
  "GO:0090168": "Golgi reassembly",
  "GO:0090169": "regulation of spindle assembly",
  "GO:0090170": "regulation of Golgi inheritance",
  "GO:0090171": "chondrocyte morphogenesis",
  "GO:0090172": "microtubule cytoskeleton organization involved in homologous chromosome segregation",
  "GO:0090173": "regulation of synaptonemal complex assembly",
  "GO:0090174": "organelle membrane fusion",
  "GO:0090175": "regulation of establishment of planar polarity",
  "GO:0090176": "microtubule cytoskeleton organization involved in establishment of planar polarity",
  "GO:0090177": "establishment of planar polarity involved in neural tube closure",
  "GO:0090178": "regulation of establishment of planar polarity involved in neural tube closure",
  "GO:0090179": "planar cell polarity pathway involved in neural tube closure",
  "GO:0090180": "positive regulation of thiamine biosynthetic process",
  "GO:0090181": "regulation of cholesterol metabolic process",
  "GO:0090182": "regulation of secretion of lysosomal enzymes",
  "GO:0090183": "regulation of kidney development",
  "GO:0090184": "positive regulation of kidney development",
  "GO:0090185": "negative regulation of kidney development",
  "GO:0090186": "regulation of pancreatic juice secretion",
  "GO:0090187": "positive regulation of pancreatic juice secretion",
  "GO:0090188": "negative regulation of pancreatic juice secretion",
  "GO:0090189": "regulation of branching involved in ureteric bud morphogenesis",
  "GO:0090190": "positive regulation of branching involved in ureteric bud morphogenesis",
  "GO:0090191": "negative regulation of branching involved in ureteric bud morphogenesis",
  "GO:0090192": "regulation of glomerulus development",
  "GO:0090193": "positive regulation of glomerulus development",
  "GO:0090194": "negative regulation of glomerulus development",
  "GO:0090195": "chemokine secretion",
  "GO:0090196": "regulation of chemokine secretion",
  "GO:0090197": "positive regulation of chemokine secretion",
  "GO:0090198": "negative regulation of chemokine secretion",
  "GO:0090199": "regulation of release of cytochrome c from mitochondria",
  "GO:0090200": "positive regulation of release of cytochrome c from mitochondria",
  "GO:0090201": "negative regulation of release of cytochrome c from mitochondria",
  "GO:0090202": "gene looping",
  "GO:0090203": "transcriptional activation by promoter-terminator looping",
  "GO:0090204": "protein localization to nuclear pore",
  "GO:0090205": "positive regulation of cholesterol metabolic process",
  "GO:0090206": "negative regulation of cholesterol metabolic process",
  "GO:0090207": "regulation of triglyceride metabolic process",
  "GO:0090208": "positive regulation of triglyceride metabolic process",
  "GO:0090209": "negative regulation of triglyceride metabolic process",
  "GO:0090210": "regulation of establishment of blood-brain barrier",
  "GO:0090211": "positive regulation of establishment of blood-brain barrier",
  "GO:0090212": "negative regulation of establishment of blood-brain barrier",
  "GO:0090213": "regulation of radial pattern formation",
  "GO:0090214": "spongiotrophoblast layer developmental growth",
  "GO:0090215": "regulation of 1-phosphatidylinositol-4-phosphate 5-kinase activity",
  "GO:0090216": "positive regulation of 1-phosphatidylinositol-4-phosphate 5-kinase activity",
  "GO:0090217": "negative regulation of 1-phosphatidylinositol-4-phosphate 5-kinase activity",
  "GO:0090218": "positive regulation of lipid kinase activity",
  "GO:0090219": "negative regulation of lipid kinase activity",
  "GO:0090220": "chromosome localization to nuclear envelope involved in homologous chromosome segregation",
  "GO:0090221": "mitotic spindle-templated microtubule nucleation",
  "GO:0090222": "centrosome-templated microtubule nucleation",
  "GO:0090223": "chromatin-templated microtubule nucleation",
  "GO:0090224": "regulation of spindle organization",
  "GO:0090225": "regulation of spindle density",
  "GO:0090226": "regulation of microtubule nucleation by Ran protein signal transduction",
  "GO:0090227": "regulation of red or far-red light signaling pathway",
  "GO:0090228": "positive regulation of red or far-red light signaling pathway",
  "GO:0090229": "negative regulation of red or far-red light signaling pathway",
  "GO:0090230": "regulation of centromere complex assembly",
  "GO:0090231": "regulation of spindle checkpoint",
  "GO:0090232": "positive regulation of spindle checkpoint",
  "GO:0090233": "negative regulation of spindle checkpoint",
  "GO:0090234": "regulation of kinetochore assembly",
  "GO:0090235": "regulation of metaphase plate congression",
  "GO:0090236": "regulation of transcription from RNA polymerase II promoter involved in somitogenesis",
  "GO:0090237": "regulation of arachidonic acid secretion",
  "GO:0090238": "positive regulation of arachidonic acid secretion",
  "GO:0090239": "regulation of histone H4 acetylation",
  "GO:0090240": "positive regulation of histone H4 acetylation",
  "GO:0090241": "negative regulation of histone H4 acetylation",
  "GO:0090242": "retinoic acid receptor signaling pathway involved in somitogenesis",
  "GO:0090243": "fibroblast growth factor receptor signaling pathway involved in somitogenesis",
  "GO:0090244": "Wnt signaling pathway involved in somitogenesis",
  "GO:0090245": "axis elongation involved in somitogenesis",
  "GO:0090246": "convergent extension involved in somitogenesis",
  "GO:0090247": "cell motility involved in somitogenic axis elongation",
  "GO:0090248": "cell migration involved in somitogenic axis elongation",
  "GO:0090249": "regulation of cell motility involved in somitogenic axis elongation",
  "GO:0090250": "cell-cell adhesion involved in establishment of planar polarity",
  "GO:0090251": "protein localization involved in establishment of planar polarity",
  "GO:0090252": "epithelium migration involved in imaginal disc-derived wing morphogenesis",
  "GO:0090253": "convergent extension involved in imaginal disc-derived wing morphogenesis",
  "GO:0090254": "cell elongation involved in imaginal disc-derived wing morphogenesis",
  "GO:0090255": "cell proliferation involved in imaginal disc-derived wing morphogenesis",
  "GO:0090256": "regulation of cell proliferation involved in imaginal disc-derived wing morphogenesis",
  "GO:0090257": "regulation of muscle system process",
  "GO:0090258": "negative regulation of mitochondrial fission",
  "GO:0090259": "regulation of retinal ganglion cell axon guidance",
  "GO:0090260": "negative regulation of retinal ganglion cell axon guidance",
  "GO:0090261": "positive regulation of inclusion body assembly",
  "GO:0090262": "regulation of transcription-coupled nucleotide-excision repair",
  "GO:0090263": "positive regulation of canonical Wnt signaling pathway",
  "GO:0090264": "regulation of immune complex clearance by monocytes and macrophages",
  "GO:0090265": "positive regulation of immune complex clearance by monocytes and macrophages",
  "GO:0090266": "regulation of mitotic cell cycle spindle assembly checkpoint",
  "GO:0090267": "positive regulation of mitotic cell cycle spindle assembly checkpoint",
  "GO:0090268": "activation of mitotic cell cycle spindle assembly checkpoint",
  "GO:0090269": "fibroblast growth factor production",
  "GO:0090270": "regulation of fibroblast growth factor production",
  "GO:0090271": "positive regulation of fibroblast growth factor production",
  "GO:0090272": "negative regulation of fibroblast growth factor production",
  "GO:0090273": "regulation of somatostatin secretion",
  "GO:0090274": "positive regulation of somatostatin secretion",
  "GO:0090275": "negative regulation of somatostatin secretion",
  "GO:0090276": "regulation of peptide hormone secretion",
  "GO:0090277": "positive regulation of peptide hormone secretion",
  "GO:0090278": "negative regulation of peptide hormone secretion",
  "GO:0090279": "regulation of calcium ion import",
  "GO:0090280": "positive regulation of calcium ion import",
  "GO:0090281": "negative regulation of calcium ion import",
  "GO:0090282": "positive regulation of transcription involved in G2/M transition of mitotic cell cycle",
  "GO:0090283": "regulation of protein glycosylation in Golgi",
  "GO:0090284": "positive regulation of protein glycosylation in Golgi",
  "GO:0090285": "negative regulation of protein glycosylation in Golgi",
  "GO:0090286": "cytoskeletal anchoring at nuclear membrane",
  "GO:0090287": "regulation of cellular response to growth factor stimulus",
  "GO:0090288": "negative regulation of cellular response to growth factor stimulus",
  "GO:0090289": "regulation of osteoclast proliferation",
  "GO:0090290": "positive regulation of osteoclast proliferation",
  "GO:0090291": "negative regulation of osteoclast proliferation",
  "GO:0090292": "nuclear matrix anchoring at nuclear membrane",
  "GO:0090293": "nitrogen catabolite regulation of transcription",
  "GO:0090294": "nitrogen catabolite activation of transcription",
  "GO:0090295": "nitrogen catabolite repression of transcription",
  "GO:0090296": "regulation of mitochondrial DNA replication",
  "GO:0090297": "positive regulation of mitochondrial DNA replication",
  "GO:0090298": "negative regulation of mitochondrial DNA replication",
  "GO:0090299": "regulation of neural crest formation",
  "GO:0090300": "positive regulation of neural crest formation",
  "GO:0090301": "negative regulation of neural crest formation",
  "GO:0090302": "APC-Cdc20 complex activity",
  "GO:0090303": "positive regulation of wound healing",
  "GO:0090304": "nucleic acid metabolic process",
  "GO:0090305": "nucleic acid phosphodiester bond hydrolysis",
  "GO:0090306": "spindle assembly involved in meiosis",
  "GO:0090307": "mitotic spindle assembly",
  "GO:0090308": "regulation of methylation-dependent chromatin silencing",
  "GO:0090309": "positive regulation of methylation-dependent chromatin silencing",
  "GO:0090310": "negative regulation of methylation-dependent chromatin silencing",
  "GO:0090311": "regulation of protein deacetylation",
  "GO:0090312": "positive regulation of protein deacetylation",
  "GO:0090313": "regulation of protein targeting to membrane",
  "GO:0090314": "positive regulation of protein targeting to membrane",
  "GO:0090315": "negative regulation of protein targeting to membrane",
  "GO:0090316": "positive regulation of intracellular protein transport",
  "GO:0090317": "negative regulation of intracellular protein transport",
  "GO:0090318": "regulation of chylomicron remodeling",
  "GO:0090319": "positive regulation of chylomicron remodeling",
  "GO:0090320": "regulation of chylomicron remnant clearance",
  "GO:0090321": "positive regulation of chylomicron remnant clearance",
  "GO:0090322": "regulation of superoxide metabolic process",
  "GO:0090323": "prostaglandin secretion involved in immune response",
  "GO:0090324": "negative regulation of oxidative phosphorylation",
  "GO:0090325": "regulation of locomotion involved in locomotory behavior",
  "GO:0090326": "positive regulation of locomotion involved in locomotory behavior",
  "GO:0090327": "negative regulation of locomotion involved in locomotory behavior",
  "GO:0090328": "regulation of olfactory learning",
  "GO:0090329": "regulation of DNA-dependent DNA replication",
  "GO:0090330": "regulation of platelet aggregation",
  "GO:0090331": "negative regulation of platelet aggregation",
  "GO:0090332": "stomatal closure",
  "GO:0090333": "regulation of stomatal closure",
  "GO:0090334": "regulation of cell wall (1->3)-beta-D-glucan biosynthetic process",
  "GO:0090335": "regulation of brown fat cell differentiation",
  "GO:0090336": "positive regulation of brown fat cell differentiation",
  "GO:0090337": "regulation of formin-nucleated actin cable assembly",
  "GO:0090338": "positive regulation of formin-nucleated actin cable assembly",
  "GO:0090339": "negative regulation of formin-nucleated actin cable assembly",
  "GO:0090340": "positive regulation of secretion of lysosomal enzymes",
  "GO:0090341": "negative regulation of secretion of lysosomal enzymes",
  "GO:0090342": "regulation of cell aging",
  "GO:0090343": "positive regulation of cell aging",
  "GO:0090344": "negative regulation of cell aging",
  "GO:0090345": "cellular organohalogen metabolic process",
  "GO:0090346": "cellular organofluorine metabolic process",
  "GO:0090347": "regulation of cellular organohalogen metabolic process",
  "GO:0090348": "regulation of cellular organofluorine metabolic process",
  "GO:0090349": "negative regulation of cellular organohalogen metabolic process",
  "GO:0090350": "negative regulation of cellular organofluorine metabolic process",
  "GO:0090351": "seedling development",
  "GO:0090352": "regulation of nitrate assimilation",
  "GO:0090353": "polygalacturonase inhibitor activity",
  "GO:0090354": "regulation of auxin metabolic process",
  "GO:0090355": "positive regulation of auxin metabolic process",
  "GO:0090356": "negative regulation of auxin metabolic process",
  "GO:0090357": "regulation of tryptophan metabolic process",
  "GO:0090358": "positive regulation of tryptophan metabolic process",
  "GO:0090359": "negative regulation of abscisic acid biosynthetic process",
  "GO:0090360": "platelet-derived growth factor production",
  "GO:0090361": "regulation of platelet-derived growth factor production",
  "GO:0090362": "positive regulation of platelet-derived growth factor production",
  "GO:0090363": "regulation of proteasome core complex assembly",
  "GO:0090364": "regulation of proteasome assembly",
  "GO:0090365": "regulation of mRNA modification",
  "GO:0090366": "positive regulation of mRNA modification",
  "GO:0090367": "negative regulation of mRNA modification",
  "GO:0090368": "regulation of ornithine metabolic process",
  "GO:0090369": "ornithine carbamoyltransferase inhibitor activity",
  "GO:0090370": "negative regulation of cholesterol efflux",
  "GO:0090371": "regulation of glycerol transport",
  "GO:0090372": "positive regulation of glycerol transport",
  "GO:0090373": "negative regulation of glycerol transport",
  "GO:0090374": "oligopeptide export from mitochondrion",
  "GO:0090375": "negative regulation of transcription from RNA polymerase II promoter in response to iron ion starvation",
  "GO:0090376": "seed trichome differentiation",
  "GO:0090377": "seed trichome initiation",
  "GO:0090378": "seed trichome elongation",
  "GO:0090379": "secondary cell wall biogenesis involved in seed trichome differentiation",
  "GO:0090380": "seed trichome maturation",
  "GO:0090381": "regulation of heart induction",
  "GO:0090382": "phagosome maturation",
  "GO:0090383": "phagosome acidification",
  "GO:0090384": "phagosome-lysosome docking",
  "GO:0090385": "phagosome-lysosome fusion",
  "GO:0090386": "phagosome maturation involved in apoptotic cell clearance",
  "GO:0090387": "phagolysosome assembly involved in apoptotic cell clearance",
  "GO:0090388": "phagosome-lysosome docking involved in apoptotic cell clearance",
  "GO:0090389": "phagosome-lysosome fusion involved in apoptotic cell clearance",
  "GO:0090390": "phagosome acidification involved in apoptotic cell clearance",
  "GO:0090391": "granum assembly",
  "GO:0090392": "sepal giant cell differentiation",
  "GO:0090393": "sepal giant cell development",
  "GO:0090394": "negative regulation of excitatory postsynaptic potential",
  "GO:0090395": "plant cell papilla",
  "GO:0090396": "leaf papilla",
  "GO:0090397": "stigma papilla",
  "GO:0090398": "cellular senescence",
  "GO:0090399": "replicative senescence",
  "GO:0090400": "stress-induced premature senescence",
  "GO:0090401": "viral-induced premature senescence",
  "GO:0090402": "oncogene-induced cell senescence",
  "GO:0090403": "oxidative stress-induced premature senescence",
  "GO:0090404": "pollen tube tip",
  "GO:0090405": "unicellular trichome branch",
  "GO:0090406": "pollen tube",
  "GO:0090407": "organophosphate biosynthetic process",
  "GO:0090408": "phloem nitrate loading",
  "GO:0090409": "malonyl-CoA synthetase activity",
  "GO:0090410": "malonate catabolic process",
  "GO:0090411": "brassinosteroid binding",
  "GO:0090412": "obsolete positive regulation of transcription from RNA polymerase II promoter involved in fatty acid biosynthetic process",
  "GO:0090413": "obsolete negative regulation of transcription from RNA polymerase II promoter involved in fatty acid biosynthetic process",
  "GO:0090414": "molybdate ion export from vacuole",
  "GO:0090415": "7-hydroxymethyl chlorophyll a reductase activity",
  "GO:0090416": "nicotinate transporter activity",
  "GO:0090417": "N-methylnicotinate transporter activity",
  "GO:0090418": "obsolete positive regulation of transcription involved in S-phase of mitotic cell cycle",
  "GO:0090419": "negative regulation of transcription involved in G2/M transition of mitotic cell cycle",
  "GO:0090420": "naphthalene-containing compound metabolic process",
  "GO:0090421": "embryonic meristem initiation",
  "GO:0090422": "thiamine pyrophosphate transporter activity",
  "GO:0090423": "phytochelatin-metal complex formation",
  "GO:0090424": "phytochelatin-metal-sulfur complex formation",
  "GO:0090425": "acinar cell differentiation",
  "GO:0090426": "actin filament bundle convergence",
  "GO:0090427": "activation of meiosis",
  "GO:0090428": "perianth development",
  "GO:0090429": "detection of endogenous biotic stimulus",
  "GO:0090430": "caffeoyl-CoA: alcohol caffeoyl transferase activity",
  "GO:0090431": "alkyl caffeate ester biosynthetic process",
  "GO:0090432": "myristoyl-CoA ligase activity",
  "GO:0090433": "palmitoyl-CoA ligase activity",
  "GO:0090434": "oleoyl-CoA ligase activity",
  "GO:0090435": "protein localization to nuclear envelope",
  "GO:0090436": "leaf pavement cell development",
  "GO:0090437": "socket cell differentiation",
  "GO:0090438": "camelliol C synthase activity",
  "GO:0090439": "tetraketide alpha-pyrone synthase activity",
  "GO:0090440": "abscisic acid transporter activity",
  "GO:0090441": "trehalose biosynthesis in response to heat stress",
  "GO:0090442": "trehalose catabolism in response to heat stress",
  "GO:0090443": "FAR/SIN/STRIPAK complex",
  "GO:0090444": "regulation of nematode larval development, heterochronic",
  "GO:0090445": "positive regulation of nematode larval development, heterochronic",
  "GO:0090446": "negative regulation of nematode larval development, heterochronic",
  "GO:0090447": "glycerol-3-phosphate 2-O-acyltransferase activity",
  "GO:0090448": "glucosinolate:proton symporter activity",
  "GO:0090449": "phloem glucosinolate loading",
  "GO:0090450": "inosine-diphosphatase activity",
  "GO:0090451": "cotyledon boundary formation",
  "GO:0090452": "lithium ion import",
  "GO:0090453": "aspartate transmembrane import into vacuole",
  "GO:0090454": "glutamate transmembrane import into vacuole",
  "GO:0090455": "ornithine transmembrane import into vacuole",
  "GO:0090456": "lysine transmembrane import into vacuole",
  "GO:0090457": "histidine transmembrane import into vacuole",
  "GO:0090458": "arginine transmembrane import into vacuole",
  "GO:0090459": "aspartate homeostasis",
  "GO:0090460": "threonine homeostasis",
  "GO:0090461": "glutamate homeostasis",
  "GO:0090462": "ornithine homeostasis",
  "GO:0090463": "lysine homeostasis",
  "GO:0090464": "histidine homeostasis",
  "GO:0090465": "arginine homeostasis",
  "GO:0090466": "histidine import",
  "GO:0090467": "arginine import",
  "GO:0090468": "valine import",
  "GO:0090469": "asparagine import",
  "GO:0090470": "shoot organ boundary specification",
  "GO:0090471": "9,15,9'-tri-cis-zeta-carotene isomerase activity",
  "GO:0090472": "dibasic protein processing",
  "GO:0090473": "lys-arg specific dibasic protein processing",
  "GO:0090474": "arg-arg specific dibasic protein processing",
  "GO:0090475": "lys-lys specific dibasic protein processing",
  "GO:0090476": "isoleucine import",
  "GO:0090477": "L-isoleucine import",
  "GO:0090478": "serine import",
  "GO:0090479": "L-serine import",
  "GO:0090480": "purine nucleotide-sugar transmembrane transport",
  "GO:0090481": "pyrimidine nucleotide-sugar transmembrane transport",
  "GO:0090482": "vitamin transmembrane transporter activity",
  "GO:0090483": "phosphatidylglycerol-phosphatidylethanolamine phosphatidyltransferase activity",
  "GO:0090484": "drug transporter activity",
  "GO:0090485": "chromosome number maintenance",
  "GO:0090486": "small RNA 2'-O-methyltransferase",
  "GO:0090487": "secondary metabolite catabolic process",
  "GO:0090488": "polo box domain specific binding",
  "GO:0090489": "L-tryptophan,NADPH:oxygen oxidoreductase (N-hydroxylating, decarboxylating)",
  "GO:0090490": "L-tryptophan,NADPH:oxygen oxidoreductase (N-hydroxylating)",
  "GO:0090491": "N-hydroxy-L-tryptophan,NADPH:oxygen oxidoreductase (N-hydroxylating)",
  "GO:0090492": "N,N-Dihydroxy-L-tryptophan decarboxylase activity",
  "GO:0090493": "catecholamine uptake",
  "GO:0090494": "dopamine uptake",
  "GO:0090495": "low-density lipoprotein particle disassembly",
  "GO:0090496": "mesenchyme migration involved in limb bud formation",
  "GO:0090497": "mesenchymal cell migration",
  "GO:0090498": "extrinsic component of Golgi membrane",
  "GO:0090499": "pimelyl-[acyl-carrier protein] methyl ester esterase activity",
  "GO:0090500": "endocardial cushion to mesenchymal transition",
  "GO:0090501": "RNA phosphodiester bond hydrolysis",
  "GO:0090502": "RNA phosphodiester bond hydrolysis, endonucleolytic",
  "GO:0090503": "RNA phosphodiester bond hydrolysis, exonucleolytic",
  "GO:0090504": "epiboly",
  "GO:0090505": "epiboly involved in wound healing",
  "GO:0090506": "axillary shoot meristem initiation",
  "GO:0090507": "phenylethylamine metabolic process involved in synaptic transmission",
  "GO:0090508": "phenylethylamine biosynthetic process involved in synaptic transmission",
  "GO:0090509": "nickel cation import into cell",
  "GO:0090510": "anticlinal cell division",
  "GO:0090511": "periclinal cell division",
  "GO:0090512": "eisosome membrane domain/MCC",
  "GO:0090513": "L-histidine transmembrane import into vacuole",
  "GO:0090514": "L-tyrosine transmembrane import into vacuole",
  "GO:0090515": "L-glutamate transmembrane import into vacuole",
  "GO:0090516": "L-serine transmembrane import into vacuole",
  "GO:0090517": "L-lysine transmembrane import into vacuole",
  "GO:0090518": "L-arginine transmembrane import into vacuole",
  "GO:0090519": "anoxia protection",
  "GO:0090520": "sphingolipid mediated signaling pathway",
  "GO:0090521": "glomerular visceral epithelial cell migration",
  "GO:0090522": "vesicle tethering involved in exocytosis",
  "GO:0090523": "cytochrome-b5 reductase activity, acting on NADPH",
  "GO:0090524": "cytochrome-b5 reductase activity, acting on NADH",
  "GO:0090525": "regulation of glycolysis involved in cellular glucose homeostasis",
  "GO:0090526": "regulation of gluconeogenesis involved in cellular glucose homeostasis",
  "GO:0090527": "actin filament reorganization",
  "GO:0090528": "smooth septate junction assembly",
  "GO:0090529": "cell septum assembly",
  "GO:0090531": "L-ascorbic acid biosynthetic process via GDP-alpha-D-mannose",
  "GO:0090532": "L-ascorbic acid biosynthetic process via UDP-alpha-D-glucuronate",
  "GO:0090533": "cation-transporting ATPase complex",
  "GO:0090534": "calcium ion-transporting ATPase complex",
  "GO:0090535": "WICH complex",
  "GO:0090536": "NoRC complex",
  "GO:0090537": "CERF complex",
  "GO:0090538": "peptide pheromone secretion",
  "GO:0090539": "peptide pheromone export by transmembrane transport",
  "GO:0090540": "bacterial cellulose biosynthetic process",
  "GO:0090541": "MIT domain binding",
  "GO:0090542": "ELYC domain binding",
  "GO:0090543": "Flemming body",
  "GO:0090544": "BAF-type complex",
  "GO:0090545": "CHD-type complex",
  "GO:0090546": "chlorophyll fluorescence",
  "GO:0090547": "response to low humidity",
  "GO:0090548": "response to nitrate starvation",
  "GO:0090549": "response to carbon starvation",
  "GO:0090550": "response to molybdenum starvation",
  "GO:0090551": "response to manganese starvation",
  "GO:0090552": "unicellular trichome apex",
  "GO:0090553": "unicellular trichome tip",
  "GO:0090554": "phosphatidylcholine-translocating ATPase activity",
  "GO:0090555": "phosphatidylethanolamine-translocating ATPase activity",
  "GO:0090556": "phosphatidylserine-translocating ATPase activity",
  "GO:0090557": "establishment of endothelial intestinal barrier",
  "GO:0090558": "plant epidermis development",
  "GO:0090559": "regulation of membrane permeability",
  "GO:0090560": "2-(3-amino-3-carboxypropyl)histidine synthase activity",
  "GO:0090561": "nuclear migration during mitotic telophase",
  "GO:0090562": "protein-N(PI)-phosphohistidine-N,N'-diacetylchitobiose phosphotransferase system transporter activity",
  "GO:0090563": "protein-phosphocysteine-sugar phosphotransferase activity",
  "GO:0090564": "protein-phosphocysteine-glucose phosphotransferase system transporter activity",
  "GO:0090565": "protein-phosphocysteine-mannitol phosphotransferase system transporter activity",
  "GO:0090566": "protein-phosphocysteine-N,N'-diacetylchitobiose phosphotransferase system transporter activity",
  "GO:0090567": "reproductive shoot system development",
  "GO:0090568": "nuclear transcriptional repressor complex",
  "GO:0090569": "cytoplasmic transcriptional repressor complex",
  "GO:0090570": "RNA polymerase I transcription repressor complex",
  "GO:0090571": "RNA polymerase II transcription repressor complex",
  "GO:0090572": "RNA polymerase III transcription repressor complex",
  "GO:0090573": "RNA polymerase IV transcription repressor complex",
  "GO:0090574": "RNA polymerase V transcription repressor complex",
  "GO:0090575": "RNA polymerase II transcription factor complex",
  "GO:0090576": "RNA polymerase III transcription factor complex",
  "GO:0090577": "RNA polymerase IV transcription factor complex",
  "GO:0090578": "RNA polymerase V transcription factor complex",
  "GO:0090579": "dsDNA loop formation",
  "GO:0090580": "phosphodiesterase activity, acting on 3'-phosphoglycolate-terminated DNA strands",
  "GO:0090581": "protein-phosphocysteine-mannosylglycerate-phosphotransferase system transporter activity",
  "GO:0090582": "protein-phosphocysteine-D-fructose-phosphotransferase system transporter activity",
  "GO:0090583": "protein-phosphocysteine-D-sorbitol-phosphotransferase system transporter activity",
  "GO:0090584": "protein-phosphocysteine-galactitol-phosphotransferase system transporter activity",
  "GO:0090585": "protein-phosphocysteine-L-ascorbate-phosphotransferase system transporter activity",
  "GO:0090586": "protein-phosphocysteine-N-acetylglucosamine phosphotransferase system transporter activity",
  "GO:0090587": "protein-phosphocysteine-glucosamine phosphotransferase system transporter activity",
  "GO:0090588": "protein-phosphocysteine-N-acetylmuramate phosphotransferase system transporter activity",
  "GO:0090589": "protein-phosphocysteine-trehalose phosphotransferase system transporter activity",
  "GO:0090590": "protein-N(PI)-phosphohistidine-D-glucosamine phosphotransferase system transporter activity",
  "GO:0090591": "protein-N(PI)-phosphohistidine-N-acetyl-mannosamine phosphotransferase system transporter activity",
  "GO:0090592": "DNA synthesis involved in DNA replication",
  "GO:0090593": "peptidyl-histidine autophosphorylation",
  "GO:0090594": "inflammatory response to wounding",
  "GO:0090595": "acetyl-CoA:L-lysine N6-acetyltransferase",
  "GO:0090596": "sensory organ morphogenesis",
  "GO:0090597": "nematode male tail mating organ morphogenesis",
  "GO:0090598": "male anatomical structure morphogenesis",
  "GO:0090599": "alpha-glucosidase activity",
  "GO:0090600": "alpha-1,3-glucosidase activity",
  "GO:0090601": "enucleation",
  "GO:0090602": "sieve element enucleation",
  "GO:0090603": "sieve element differentiation",
  "GO:0090604": "surface biofilm formation",
  "GO:0090605": "submerged biofilm formation",
  "GO:0090606": "single-species surface biofilm formation",
  "GO:0090607": "multi-species surface biofilm formation",
  "GO:0090608": "multi-species submerged biofilm formation",
  "GO:0090609": "single-species submerged biofilm formation",
  "GO:0090610": "bundle sheath cell fate specification",
  "GO:0090611": "ubiquitin-independent protein catabolic process via the multivesicular body sorting pathway",
  "GO:0090612": "cAMP deaminase activity",
  "GO:0090613": "5'-deoxyadenosine deaminase activity",
  "GO:0090614": "5'-methylthioadenosine deaminase activity",
  "GO:0090615": "mitochondrial mRNA processing",
  "GO:0090616": "mitochondrial mRNA 3'-end processing",
  "GO:0090617": "mitochondrial mRNA 5'-end processing",
  "GO:0090618": "DNA clamp unloading",
  "GO:0090619": "meiotic spindle pole",
  "GO:0090620": "APC-Cdc20 complex",
  "GO:0090621": "APC-fizzy-related complex",
  "GO:0090622": "APC-fizzy related complex activity",
  "GO:0090623": "activation of APC-fizzy related complex activity",
  "GO:0090624": "endoribonuclease activity, cleaving miRNA-paired mRNA",
  "GO:0090625": "mRNA cleavage involved in gene silencing by siRNA",
  "GO:0090626": "plant epidermis morphogenesis",
  "GO:0090627": "plant epidermal cell differentiation",
  "GO:0090628": "plant epidermal cell fate specification",
  "GO:0090629": "lagging strand initiation",
  "GO:0090630": "activation of GTPase activity",
  "GO:0090631": "pre-miRNA transporter activity",
  "GO:0090632": "N-glycolylneuraminic acid (Neu5Gc) cytidylyltransferase activity",
  "GO:0090633": "keto-deoxynonulosonic acid (KDN) cytidylyltransferase activity",
  "GO:0090634": "microglial cell mediated cytotoxicity",
  "GO:0090635": "extracellular core region of desmosome",
  "GO:0090636": "outer dense plaque of desmosome",
  "GO:0090637": "inner dense plaque of desmosome",
  "GO:0090638": "phosphatidylcholine biosynthesis from phosphatidylethanolamine",
  "GO:0090639": "phosphatidylcholine biosynthesis from choline and CDP-diacylglycerol",
  "GO:0090640": "phosphatidylcholine biosynthesis from sn-glycero-3-phosphocholine",
  "GO:0090641": "microsporidian-type endospore",
  "GO:0090642": "microsporidian-type exospore",
  "GO:0090643": "inflorescence phyllotactic patterning",
  "GO:0090644": "age-related resistance",
  "GO:0090645": "APC-Cdc20 complex inhibitor activity",
  "GO:0090646": "mitochondrial tRNA processing",
  "GO:0090647": "modulation of age-related behavioral decline",
  "GO:0090648": "response to environmental enrichment",
  "GO:0090649": "response to oxygen-glucose deprivation",
  "GO:0090650": "cellular response to oxygen-glucose deprivation",
  "GO:0090651": "apical cytoplasm",
  "GO:0090652": "basolateral cytoplasm",
  "GO:0090653": "apical recycling endosome",
  "GO:0090654": "basolateral recycling endosome",
  "GO:0090655": "double-stranded/single-stranded junction telomeric DNA binding",
  "GO:0090656": "t-circle formation",
  "GO:0090657": "telomeric loop disassembly",
  "GO:0090658": "cone matrix sheath",
  "GO:0090659": "walking behavior",
  "GO:0090660": "cerebrospinal fluid circulation",
  "GO:0090661": "box H/ACA telomerase RNP complex",
  "GO:0090662": "ATP hydrolysis coupled transmembrane transport",
  "GO:0090663": "galanin-activated signaling pathway",
  "GO:0090664": "response to high population density",
  "GO:0090665": "glycoprotein complex",
  "GO:0090666": "scaRNA localization to Cajal body",
  "GO:0090667": "cell chemotaxis to vascular endothelial growth factor",
  "GO:0090668": "endothelial cell chemotaxis to vascular endothelial growth factor",
  "GO:0090669": "telomerase RNA stabilization",
  "GO:0090670": "RNA localization to Cajal body",
  "GO:0090671": "telomerase RNA localization to Cajal body",
  "GO:0090672": "telomerase RNA localization",
  "GO:0090673": "endothelial cell-matrix adhesion",
  "GO:0090674": "endothelial cell-matrix adhesion via fibronectin",
  "GO:0090675": "intermicrovillar adhesion",
  "GO:0090676": "calcium ion transmembrane transport via low voltage-gated calcium channel",
  "GO:0093001": "glycolysis from storage polysaccharide through glucose-1-phosphate",
  "GO:0093002": "response to nematicide",
  "GO:0097001": "ceramide binding",
  "GO:0097002": "mitochondrial inner boundary membrane",
  "GO:0097003": "adipokinetic hormone receptor activity",
  "GO:0097004": "adipokinetic hormone binding",
  "GO:0097005": "adipokinetic hormone receptor binding",
  "GO:0097006": "regulation of plasma lipoprotein particle levels",
  "GO:0097007": "4,8,12-trimethyltrideca-1,3,7,11-tetraene synthase activity",
  "GO:0097008": "(3E)-4,8-dimethyl-1,3,7-nonatriene synthase activity",
  "GO:0097009": "energy homeostasis",
  "GO:0097010": "eukaryotic translation initiation factor 4F complex assembly",
  "GO:0097011": "cellular response to granulocyte macrophage colony-stimulating factor stimulus",
  "GO:0097012": "response to granulocyte macrophage colony-stimulating factor",
  "GO:0097013": "phagocytic vesicle lumen",
  "GO:0097014": "ciliary plasm",
  "GO:0097015": "bacterial-type flagellar cytoplasm",
  "GO:0097016": "L27 domain binding",
  "GO:0097017": "renal protein absorption",
  "GO:0097018": "renal albumin absorption",
  "GO:0097019": "neurotransmitter receptor catabolic process",
  "GO:0097020": "COPII adaptor activity",
  "GO:0097021": "lymphocyte migration into lymphoid organs",
  "GO:0097022": "lymphocyte migration into lymph node",
  "GO:0097023": "fructose 6-phosphate aldolase activity",
  "GO:0097025": "MPP7-DLG1-LIN7 complex",
  "GO:0097026": "dendritic cell dendrite assembly",
  "GO:0097027": "ubiquitin-protein transferase activator activity",
  "GO:0097028": "dendritic cell differentiation",
  "GO:0097029": "mature conventional dendritic cell differentiation",
  "GO:0097030": "CENP-A containing nucleosome binding",
  "GO:0097031": "mitochondrial respiratory chain complex I biogenesis",
  "GO:0097032": "mitochondrial respiratory chain complex II biogenesis",
  "GO:0097033": "mitochondrial respiratory chain complex III biogenesis",
  "GO:0097034": "mitochondrial respiratory chain complex IV biogenesis",
  "GO:0097035": "regulation of membrane lipid distribution",
  "GO:0097036": "regulation of plasma membrane sterol distribution",
  "GO:0097037": "heme export",
  "GO:0097038": "perinuclear endoplasmic reticulum",
  "GO:0097039": "protein linear polyubiquitination",
  "GO:0097040": "phthiocerol biosynthetic process",
  "GO:0097041": "phenolic phthiocerol biosynthetic process",
  "GO:0097042": "extrinsic component of fungal-type vacuolar membrane",
  "GO:0097043": "histone H3-K56 acetylation",
  "GO:0097044": "histone H3-K56 acetylation in response to DNA damage",
  "GO:0097045": "phosphatidylserine exposure on blood platelet",
  "GO:0097046": "replication fork progression beyond termination site",
  "GO:0097047": "DNA replication termination region",
  "GO:0097048": "dendritic cell apoptotic process",
  "GO:0097049": "motor neuron apoptotic process",
  "GO:0097050": "type B pancreatic cell apoptotic process",
  "GO:0097051": "establishment of protein localization to endoplasmic reticulum membrane",
  "GO:0097052": "L-kynurenine metabolic process",
  "GO:0097053": "L-kynurenine catabolic process",
  "GO:0097054": "L-glutamate biosynthetic process",
  "GO:0097055": "agmatine biosynthetic process",
  "GO:0097056": "selenocysteinyl-tRNA(Sec) biosynthetic process",
  "GO:0097057": "TRAF2-GSTP1 complex",
  "GO:0097058": "CRLF-CLCF1 complex",
  "GO:0097059": "CNTFR-CLCF1 complex",
  "GO:0097060": "synaptic membrane",
  "GO:0097061": "dendritic spine organization",
  "GO:0097062": "dendritic spine maintenance",
  "GO:0097063": "cadmium ion sensor activity",
  "GO:0097064": "ncRNA export from nucleus",
  "GO:0097065": "anterior head development",
  "GO:0097066": "response to thyroid hormone",
  "GO:0097067": "cellular response to thyroid hormone stimulus",
  "GO:0097068": "response to thyroxine",
  "GO:0097069": "cellular response to thyroxine stimulus",
  "GO:0097070": "ductus arteriosus closure",
  "GO:0097071": "interferon regulatory factor complex",
  "GO:0097072": "interferon regulatory factor 3 complex",
  "GO:0097073": "interferon regulatory factor 5 complex",
  "GO:0097074": "interferon regulatory factor 7 complex",
  "GO:0097075": "interferon regulatory factor 3-interferon regulatory factor 7 complex",
  "GO:0097076": "transforming growth factor beta activated kinase 1 complex",
  "GO:0097077": "copper ion sensor activity",
  "GO:0097078": "FAL1-SGD1 complex",
  "GO:0097079": "selenite:proton symporter activity",
  "GO:0097080": "plasma membrane selenite transport",
  "GO:0097081": "vascular smooth muscle cell fate commitment",
  "GO:0097082": "vascular smooth muscle cell fate specification",
  "GO:0097083": "vascular smooth muscle cell fate determination",
  "GO:0097084": "vascular smooth muscle cell development",
  "GO:0097085": "interferon regulatory factor 3-interferon regulatory factor 5 complex",
  "GO:0097086": "amniotic stem cell differentiation",
  "GO:0097087": "interleukin-17A production",
  "GO:0097088": "interleukin-17F production",
  "GO:0097089": "methyl-branched fatty acid metabolic process",
  "GO:0097090": "presynaptic membrane organization",
  "GO:0097091": "synaptic vesicle clustering",
  "GO:0097092": "polyacyltrehalose metabolic process",
  "GO:0097093": "polyacyltrehalose biosynthetic process",
  "GO:0097094": "craniofacial suture morphogenesis",
  "GO:0097095": "frontonasal suture morphogenesis",
  "GO:0097096": "facial suture morphogenesis",
  "GO:0097097": "nasal suture morphogenesis",
  "GO:0097098": "DNA/RNA hybrid annealing activity",
  "GO:0097099": "structural constituent of albumen",
  "GO:0097100": "supercoiled DNA binding",
  "GO:0097101": "blood vessel endothelial cell fate specification",
  "GO:0097102": "endothelial tip cell fate specification",
  "GO:0097103": "endothelial stalk cell fate specification",
  "GO:0097104": "postsynaptic membrane assembly",
  "GO:0097105": "presynaptic membrane assembly",
  "GO:0097106": "postsynaptic density organization",
  "GO:0097107": "postsynaptic density assembly",
  "GO:0097108": "hedgehog family protein binding",
  "GO:0097109": "neuroligin family protein binding",
  "GO:0097110": "scaffold protein binding",
  "GO:0097111": "endoplasmic reticulum-Golgi intermediate compartment organization",
  "GO:0097112": "gamma-aminobutyric acid receptor clustering",
  "GO:0097113": "AMPA glutamate receptor clustering",
  "GO:0097114": "NMDA glutamate receptor clustering",
  "GO:0097115": "neurexin clustering involved in presynaptic membrane assembly",
  "GO:0097116": "gephyrin clustering involved in postsynaptic density assembly",
  "GO:0097117": "guanylate kinase-associated protein clustering",
  "GO:0097118": "neuroligin clustering involved in postsynaptic membrane assembly",
  "GO:0097119": "postsynaptic density protein 95 clustering",
  "GO:0097120": "receptor localization to synapse",
  "GO:0097121": "cyclin A1-CDK1 complex",
  "GO:0097122": "cyclin A2-CDK1 complex",
  "GO:0097123": "cyclin A1-CDK2 complex",
  "GO:0097124": "cyclin A2-CDK2 complex",
  "GO:0097125": "cyclin B1-CDK1 complex",
  "GO:0097126": "cyclin B2-CDK1 complex",
  "GO:0097127": "cyclin B3-CDK2 complex",
  "GO:0097128": "cyclin D1-CDK4 complex",
  "GO:0097129": "cyclin D2-CDK4 complex",
  "GO:0097130": "cyclin D3-CDK4 complex",
  "GO:0097131": "cyclin D1-CDK6 complex",
  "GO:0097132": "cyclin D2-CDK6 complex",
  "GO:0097133": "cyclin D3-CDK6 complex",
  "GO:0097134": "cyclin E1-CDK2 complex",
  "GO:0097135": "cyclin E2-CDK2 complex",
  "GO:0097136": "Bcl-2 family protein complex",
  "GO:0097137": "BAD-BCL-xl complex",
  "GO:0097138": "BAD-BCL-2 complex",
  "GO:0097139": "BID-BCL-2 complex",
  "GO:0097140": "BIM-BCL-xl complex",
  "GO:0097141": "BIM-BCL-2 complex",
  "GO:0097142": "PUMA-BCL-2 complex",
  "GO:0097143": "PUMA-BCL-xl complex",
  "GO:0097144": "BAX complex",
  "GO:0097145": "BAK complex",
  "GO:0097146": "NOXA-BCL-xl complex",
  "GO:0097147": "NOXA-BCL-2 complex",
  "GO:0097148": "BCL-2 complex",
  "GO:0097149": "centralspindlin complex",
  "GO:0097150": "neuronal stem cell population maintenance",
  "GO:0097151": "positive regulation of inhibitory postsynaptic potential",
  "GO:0097152": "mesenchymal cell apoptotic process",
  "GO:0097153": "cysteine-type endopeptidase activity involved in apoptotic process",
  "GO:0097154": "GABAergic neuron differentiation",
  "GO:0097155": "fasciculation of sensory neuron axon",
  "GO:0097156": "fasciculation of motor neuron axon",
  "GO:0097157": "pre-mRNA intronic binding",
  "GO:0097158": "pre-mRNA intronic pyrimidine-rich binding",
  "GO:0097159": "organic cyclic compound binding",
  "GO:0097160": "polychlorinated biphenyl binding",
  "GO:0097161": "DH domain binding",
  "GO:0097162": "MADS box domain binding",
  "GO:0097163": "sulfur carrier activity",
  "GO:0097164": "ammonium ion metabolic process",
  "GO:0097165": "nuclear stress granule",
  "GO:0097166": "lens epithelial cell proliferation",
  "GO:0097167": "circadian regulation of translation",
  "GO:0097168": "mesenchymal stem cell proliferation",
  "GO:0097169": "AIM2 inflammasome complex",
  "GO:0097170": "ADP-L-glycero-beta-D-manno-heptose metabolic process",
  "GO:0097171": "ADP-L-glycero-beta-D-manno-heptose biosynthetic process",
  "GO:0097172": "N-acetylmuramic acid metabolic process",
  "GO:0097173": "N-acetylmuramic acid catabolic process",
  "GO:0097174": "1,6-anhydro-N-acetyl-beta-muramic acid metabolic process",
  "GO:0097175": "1,6-anhydro-N-acetyl-beta-muramic acid catabolic process",
  "GO:0097176": "epoxide metabolic process",
  "GO:0097177": "mitochondrial ribosome binding",
  "GO:0097178": "ruffle assembly",
  "GO:0097179": "protease inhibitor complex",
  "GO:0097180": "serine protease inhibitor complex",
  "GO:0097181": "protein C inhibitor-coagulation factor V complex",
  "GO:0097182": "protein C inhibitor-coagulation factor Xa complex",
  "GO:0097183": "protein C inhibitor-coagulation factor XI complex",
  "GO:0097184": "response to azide",
  "GO:0097185": "cellular response to azide",
  "GO:0097186": "amelogenesis",
  "GO:0097187": "dentinogenesis",
  "GO:0097188": "dentin mineralization",
  "GO:0097189": "apoptotic body",
  "GO:0097190": "apoptotic signaling pathway",
  "GO:0097191": "extrinsic apoptotic signaling pathway",
  "GO:0097192": "extrinsic apoptotic signaling pathway in absence of ligand",
  "GO:0097193": "intrinsic apoptotic signaling pathway",
  "GO:0097194": "execution phase of apoptosis",
  "GO:0097195": "pilomotor reflex",
  "GO:0097196": "Shu complex",
  "GO:0097197": "tetraspanin-enriched microdomain",
  "GO:0097198": "histone H3-K36 trimethylation",
  "GO:0097199": "cysteine-type endopeptidase activity involved in apoptotic signaling pathway",
  "GO:0097200": "cysteine-type endopeptidase activity involved in execution phase of apoptosis",
  "GO:0097201": "negative regulation of transcription from RNA polymerase II promoter in response to stress",
  "GO:0097202": "activation of cysteine-type endopeptidase activity",
  "GO:0097203": "phagocytic cup lip",
  "GO:0097204": "phagocytic cup base",
  "GO:0097205": "renal filtration",
  "GO:0097206": "nephrocyte filtration",
  "GO:0097207": "bud dormancy process",
  "GO:0097208": "alveolar lamellar body",
  "GO:0097209": "epidermal lamellar body",
  "GO:0097210": "response to gonadotropin-releasing hormone",
  "GO:0097211": "cellular response to gonadotropin-releasing hormone",
  "GO:0097212": "lysosomal membrane organization",
  "GO:0097213": "regulation of lysosomal membrane permeability",
  "GO:0097214": "positive regulation of lysosomal membrane permeability",
  "GO:0097215": "negative regulation of lysosomal membrane permeability",
  "GO:0097216": "guanosine tetraphosphate binding",
  "GO:0097217": "sieve area",
  "GO:0097218": "sieve plate",
  "GO:0097219": "compound sieve plate",
  "GO:0097220": "simple sieve plate",
  "GO:0097221": "M/G1 phase-specific MADS box-forkhead transcription factor complex",
  "GO:0097222": "mitochondrial mRNA polyadenylation",
  "GO:0097223": "sperm part",
  "GO:0097224": "sperm connecting piece",
  "GO:0097225": "sperm midpiece",
  "GO:0097226": "sperm mitochondrial sheath",
  "GO:0097227": "sperm annulus",
  "GO:0097228": "sperm principal piece",
  "GO:0097229": "sperm end piece",
  "GO:0097230": "cell motility in response to potassium ion",
  "GO:0097231": "cell motility in response to calcium ion",
  "GO:0097232": "lamellar body membrane",
  "GO:0097233": "alveolar lamellar body membrane",
  "GO:0097234": "epidermal lamellar body membrane",
  "GO:0097235": "positive regulation of fatty acid beta-oxidation by positive regulation of transcription from RNA polymerase II promoter",
  "GO:0097236": "positive regulation of transcription from RNA polymerase II promoter in response to zinc ion starvation",
  "GO:0097237": "cellular response to toxic substance",
  "GO:0097238": "cellular response to methylglyoxal",
  "GO:0097239": "positive regulation of transcription from RNA polymerase II promoter in response to methylglyoxal",
  "GO:0097240": "chromosome attachment to the nuclear envelope",
  "GO:0097241": "hematopoietic stem cell migration to bone marrow",
  "GO:0097242": "beta-amyloid clearance",
  "GO:0097243": "flavonoid binding",
  "GO:0097244": "flavonol binding",
  "GO:0097245": "flavanol binding",
  "GO:0097246": "catechin binding",
  "GO:0097247": "epigallocatechin 3-gallate binding",
  "GO:0097248": "maintenance of protein location in cell cortex of cell tip",
  "GO:0097249": "mitochondrial respiratory chain supercomplex",
  "GO:0097250": "mitochondrial respiratory chain supercomplex assembly",
  "GO:0097251": "leukotriene B4 biosynthetic process",
  "GO:0097252": "oligodendrocyte apoptotic process",
  "GO:0097253": "beta-hydroxybutyrate transmembrane transporter activity",
  "GO:0097254": "renal tubular secretion",
  "GO:0097255": "R2TP complex",
  "GO:0097256": "phenyllactate dehydrogenase activity",
  "GO:0097257": "leukotriene B4 12-hydroxy dehydrogenase activity",
  "GO:0097258": "20-hydroxy-leukotriene B4 omega oxidase activity",
  "GO:0097259": "20-aldehyde-leukotriene B4 20-monooxygenase activity",
  "GO:0097260": "eoxin A4 synthase activity",
  "GO:0097261": "eoxin C4 synthase activity",
  "GO:0097262": "eoxin D4 synthase activity",
  "GO:0097263": "eoxin E4 synthase activity",
  "GO:0097264": "self proteolysis",
  "GO:0097265": "5(S)-hydroxyeicosatetraenoic acid dehydrogenase activity",
  "GO:0097266": "phenylacetyl-CoA 1,2-epoxidase activity",
  "GO:0097267": "omega-hydroxylase P450 pathway",
  "GO:0097268": "cytoophidium",
  "GO:0097269": "all-trans-decaprenyl-diphosphate synthase activity",
  "GO:0097270": "dishabituation",
  "GO:0097271": "protein localization to bud neck",
  "GO:0097272": "ammonia homeostasis",
  "GO:0097273": "creatinine homeostasis",
  "GO:0097274": "urea homeostasis",
  "GO:0097275": "cellular ammonia homeostasis",
  "GO:0097276": "cellular creatinine homeostasis",
  "GO:0097277": "cellular urea homeostasis",
  "GO:0097278": "complement-dependent cytotoxicity",
  "GO:0097279": "histamine secretion mediated by IgE immunoglobulin",
  "GO:0097280": "histamine secretion mediated by immunoglobulin",
  "GO:0097281": "immune complex formation",
  "GO:0097282": "immunoglobulin-mediated neutralization",
  "GO:0097283": "keratinocyte apoptotic process",
  "GO:0097284": "hepatocyte apoptotic process",
  "GO:0097285": "obsolete cell-type specific apoptotic process",
  "GO:0097286": "iron ion import",
  "GO:0097287": "7-cyano-7-deazaguanine metabolic process",
  "GO:0097288": "7-cyano-7-deazaguanine biosynthetic process",
  "GO:0097289": "alpha-ribazole metabolic process",
  "GO:0097290": "alpha-ribazole biosynthetic process",
  "GO:0097291": "renal phosphate ion absorption",
  "GO:0097292": "XMP metabolic process",
  "GO:0097293": "XMP biosynthetic process",
  "GO:0097294": "'de novo' XMP biosynthetic process",
  "GO:0097295": "morphine biosynthetic process",
  "GO:0097296": "activation of cysteine-type endopeptidase activity involved in apoptotic signaling pathway",
  "GO:0097297": "activation of cysteine-type endopeptidase activity involved in execution phase of apoptosis",
  "GO:0097298": "regulation of nucleus size",
  "GO:0097299": "cysteine-type endopeptidase activity involved in plant-type hypersensitive response",
  "GO:0097300": "programmed necrotic cell death",
  "GO:0097301": "regulation of potassium ion concentration by positive regulation of transcription from RNA polymerase II promoter",
  "GO:0097302": "lipoprotein biosynthetic process via diacylglyceryl transfer",
  "GO:0097303": "lipoprotein biosynthetic process via N-acyl transfer",
  "GO:0097304": "lipoprotein biosynthetic process via signal peptide cleavage",
  "GO:0097305": "response to alcohol",
  "GO:0097306": "cellular response to alcohol",
  "GO:0097307": "response to farnesol",
  "GO:0097308": "cellular response to farnesol",
  "GO:0097309": "cap1 mRNA methylation",
  "GO:0097310": "cap2 mRNA methylation",
  "GO:0097311": "biofilm matrix",
  "GO:0097312": "biofilm matrix component",
  "GO:0097313": "biofilm matrix surface",
  "GO:0097314": "apoptosome assembly",
  "GO:0097315": "response to N-acetyl-D-glucosamine",
  "GO:0097316": "cellular response to N-acetyl-D-glucosamine",
  "GO:0097317": "invasive growth in response to biotic stimulus",
  "GO:0097318": "invasive growth in response to abiotic stimulus",
  "GO:0097319": "carbohydrate import into cell",
  "GO:0097320": "membrane tubulation",
  "GO:0097321": "cell growth mode switching, filamentous to budding",
  "GO:0097322": "7SK snRNA binding",
  "GO:0097323": "B cell adhesion",
  "GO:0097324": "melanocyte migration",
  "GO:0097325": "melanocyte proliferation",
  "GO:0097326": "melanocyte adhesion",
  "GO:0097327": "response to antineoplastic agent",
  "GO:0097328": "response to carboplatin",
  "GO:0097329": "response to antimetabolite",
  "GO:0097330": "response to 5-fluoro-2'-deoxyuridine",
  "GO:0097331": "response to cytarabine",
  "GO:0097332": "response to antipsychotic drug",
  "GO:0097333": "response to olanzapine",
  "GO:0097334": "response to perphenazine",
  "GO:0097335": "response to quetiapine",
  "GO:0097336": "response to risperidone",
  "GO:0097337": "response to ziprasidone",
  "GO:0097338": "response to clozapine",
  "GO:0097339": "glycolate transmembrane transport",
  "GO:0097340": "inhibition of cysteine-type endopeptidase activity",
  "GO:0097341": "zymogen inhibition",
  "GO:0097342": "ripoptosome",
  "GO:0097343": "ripoptosome assembly",
  "GO:0097344": "Rix1 complex",
  "GO:0097345": "mitochondrial outer membrane permeabilization",
  "GO:0097346": "INO80-type complex",
  "GO:0097347": "TAM protein secretion complex",
  "GO:0097348": "host cell endocytic vesicle membrane",
  "GO:0097350": "neutrophil clearance",
  "GO:0097351": "toxin-antitoxin pair type II binding",
  "GO:0097352": "autophagosome maturation",
  "GO:0097353": "centrolateral pattern formation",
  "GO:0097354": "prenylation",
  "GO:0097355": "protein localization to heterochromatin",
  "GO:0097356": "perinucleolar compartment",
  "GO:0097357": "myo-inositol import into cell",
  "GO:0097358": "D-leucyl-tRNA(Leu) deacylase activity",
  "GO:0097359": "UDP-glucosylation",
  "GO:0097360": "chorionic trophoblast cell proliferation",
  "GO:0097361": "CIA complex",
  "GO:0097362": "MCM8-MCM9 complex",
  "GO:0097363": "protein O-GlcNAc transferase activity",
  "GO:0097364": "stretch-activated, cation-selective, calcium channel activity involved in regulation of action potential",
  "GO:0097365": "stretch-activated, cation-selective, calcium channel activity involved in regulation of cardiac muscle cell action potential",
  "GO:0097366": "response to bronchodilator",
  "GO:0097367": "carbohydrate derivative binding",
  "GO:0097368": "establishment of Sertoli cell barrier",
  "GO:0097369": "sodium ion import",
  "GO:0097370": "protein O-GlcNAcylation via threonine",
  "GO:0097371": "MDM2/MDM4 family protein binding",
  "GO:0097372": "NAD-dependent histone deacetylase activity (H3-K18 specific)",
  "GO:0097373": "MCM core complex",
  "GO:0097374": "sensory neuron axon guidance",
  "GO:0097375": "spinal sensory neuron axon guidance",
  "GO:0097376": "interneuron axon guidance",
  "GO:0097377": "spinal cord interneuron axon guidance",
  "GO:0097378": "dorsal spinal cord interneuron axon guidance",
  "GO:0097379": "dorsal spinal cord interneuron posterior axon guidance",
  "GO:0097380": "dorsal spinal cord interneuron anterior axon guidance",
  "GO:0097381": "photoreceptor disc membrane",
  "GO:0097382": "deoxynucleoside-diphosphatase activity",
  "GO:0097383": "dIDP diphosphatase activity",
  "GO:0097384": "cellular lipid biosynthetic process",
  "GO:0097385": "programmed necrotic cell death in response to starvation",
  "GO:0097386": "glial cell projection",
  "GO:0097387": "capitate projection",
  "GO:0097388": "chemokine (C-C motif) ligand 19 production",
  "GO:0097389": "chemokine (C-C motif) ligand 21 production",
  "GO:0097390": "chemokine (C-X-C motif) ligand 12 production",
  "GO:0097391": "chemokine (C-X-C motif) ligand 13 production",
  "GO:0097392": "chemokine (C-X-C motif) ligand 16 production",
  "GO:0097393": "telomeric repeat-containing RNA transcription",
  "GO:0097394": "telomeric repeat-containing RNA transcription from RNA pol II promoter",
  "GO:0097395": "response to interleukin-32",
  "GO:0097396": "response to interleukin-17",
  "GO:0097397": "cellular response to interleukin-32",
  "GO:0097398": "cellular response to interleukin-17",
  "GO:0097399": "interleukin-32-mediated signaling pathway",
  "GO:0097400": "interleukin-17-mediated signaling pathway",
  "GO:0097401": "synaptic vesicle lumen acidification",
  "GO:0097402": "neuroblast migration",
  "GO:0097403": "cellular response to raffinose",
  "GO:0097404": "succinate import into cell",
  "GO:0097405": "malate import into cell",
  "GO:0097406": "malonic acid import into cell",
  "GO:0097407": "Bunina body",
  "GO:0097408": "fibrillary inclusion",
  "GO:0097409": "glial cytoplasmic inclusion",
  "GO:0097410": "hippocampal interneuron differentiation",
  "GO:0097411": "hypoxia-inducible factor-1alpha signaling pathway",
  "GO:0097412": "hyaline inclusion",
  "GO:0097413": "Lewy body",
  "GO:0097414": "classical Lewy body",
  "GO:0097415": "cortical Lewy body",
  "GO:0097416": "Lewy body-like hyaline inclusion",
  "GO:0097417": "nematosome",
  "GO:0097418": "neurofibrillary tangle",
  "GO:0097419": "Pick body",
  "GO:0097420": "skein-like inclusion",
  "GO:0097421": "liver regeneration",
  "GO:0097422": "tubular endosome",
  "GO:0097423": "mitochondrion-associated adherens complex",
  "GO:0097424": "nucleolus-associated heterochromatin",
  "GO:0097425": "smooth endoplasmic reticulum part",
  "GO:0097426": "glial filament",
  "GO:0097427": "microtubule bundle",
  "GO:0097428": "protein maturation by iron-sulfur cluster transfer",
  "GO:0097429": "amino acid ligation activity by nonribosomal peptide synthase",
  "GO:0097430": "copper ion import into ascospore-type prospore",
  "GO:0097431": "mitotic spindle pole",
  "GO:0097432": "hippocampal pyramidal neuron differentiation",
  "GO:0097433": "dense body",
  "GO:0097434": "succinate:proton symporter activity",
  "GO:0097435": "fibril organization",
  "GO:0097436": "entry into dormancy",
  "GO:0097437": "maintenance of dormancy",
  "GO:0097438": "exit from dormancy",
  "GO:0097439": "acquisition of desiccation tolerance",
  "GO:0097440": "apical dendrite",
  "GO:0097441": "basilar dendrite",
  "GO:0097442": "CA3 pyramidal cell dendrite",
  "GO:0097443": "sorting endosome",
  "GO:0097444": "spine apparatus",
  "GO:0097445": "presynaptic active zone dense projection",
  "GO:0097446": "protein localization to eisosome filament",
  "GO:0097447": "dendritic tree",
  "GO:0097448": "spine mat",
  "GO:0097449": "astrocyte projection",
  "GO:0097450": "astrocyte end-foot",
  "GO:0097451": "glial limiting end-foot",
  "GO:0097452": "GAIT complex",
  "GO:0097453": "mesaxon",
  "GO:0097454": "Schwann cell microvillus",
  "GO:0097455": "spiny bracelet of Nageotte",
  "GO:0097456": "terminal loop",
  "GO:0097457": "hippocampal mossy fiber",
  "GO:0097458": "neuron part",
  "GO:0097459": "iron ion import into cell",
  "GO:0097460": "ferrous iron import into cell",
  "GO:0097461": "ferric iron import into cell",
  "GO:0097462": "Lewy neurite",
  "GO:0097463": "gemmule",
  "GO:0097464": "thorny excrescence",
  "GO:0097465": "somatic spine",
  "GO:0097466": "glycoprotein ERAD pathway",
  "GO:0097467": "type III terminal bouton",
  "GO:0097468": "programmed cell death in response to reactive oxygen species",
  "GO:0097469": "obsolete cyclin-dependent protein tyrosine kinase activity",
  "GO:0097470": "ribbon synapse",
  "GO:0097471": "mossy fiber rosette",
  "GO:0097472": "cyclin-dependent protein kinase activity",
  "GO:0097473": "retinal rod cell apoptotic process",
  "GO:0097474": "retinal cone cell apoptotic process",
  "GO:0097475": "motor neuron migration",
  "GO:0097476": "spinal cord motor neuron migration",
  "GO:0097477": "lateral motor column neuron migration",
  "GO:0097478": "leaflet of membrane bilayer",
  "GO:0097479": "synaptic vesicle localization",
  "GO:0097480": "establishment of synaptic vesicle localization",
  "GO:0097481": "neuronal postsynaptic density",
  "GO:0097482": "muscle cell postsynaptic density",
  "GO:0097483": "glial cell postsynaptic density",
  "GO:0097484": "dendrite extension",
  "GO:0097485": "neuron projection guidance",
  "GO:0097486": "multivesicular body lumen",
  "GO:0097487": "multivesicular body, internal vesicle",
  "GO:0097488": "multivesicular body, internal vesicle membrane",
  "GO:0097489": "multivesicular body, internal vesicle lumen",
  "GO:0097490": "sympathetic neuron projection extension",
  "GO:0097491": "sympathetic neuron projection guidance",
  "GO:0097492": "sympathetic neuron axon guidance",
  "GO:0097493": "structural molecule activity conferring elasticity",
  "GO:0097494": "regulation of vesicle size",
  "GO:0097495": "H-NS-Hha complex",
  "GO:0097496": "blood vessel lumen ensheathment",
  "GO:0097497": "blood vessel endothelial cell delamination",
  "GO:0097498": "endothelial tube lumen extension",
  "GO:0097499": "protein localization to nonmotile primary cilium",
  "GO:0097500": "receptor localization to nonmotile primary cilium",
  "GO:0097501": "stress response to metal ion",
  "GO:0097502": "mannosylation",
  "GO:0097503": "sialylation",
  "GO:0097504": "Gemini of coiled bodies",
  "GO:0097505": "Rad6-Rad18 complex",
  "GO:0097506": "deaminated base DNA N-glycosylase activity",
  "GO:0097507": "hypoxanthine DNA N-glycosylase activity",
  "GO:0097508": "xanthine DNA N-glycosylase activity",
  "GO:0097509": "oxanine DNA N-glycosylase activity",
  "GO:0097510": "base-excision repair, AP site formation via deaminated base removal",
  "GO:0097511": "dendritic cell dendrite",
  "GO:0097512": "cardiac myofibril",
  "GO:0097513": "myosin II filament",
  "GO:0097514": "sexual spore wall",
  "GO:0097515": "asexual spore wall",
  "GO:0097516": "microvillar actin bundle",
  "GO:0097517": "contractile actin filament bundle",
  "GO:0097518": "parallel actin filament bundle",
  "GO:0097519": "DNA recombinase complex",
  "GO:0097520": "nucleotide-excision repair, preincision complex",
  "GO:0097522": "protein-DNA ISRE complex",
  "GO:0097523": "transcription ternary complex",
  "GO:0097524": "sperm plasma membrane",
  "GO:0097525": "spliceosomal snRNP complex",
  "GO:0097526": "spliceosomal tri-snRNP complex",
  "GO:0097527": "necroptotic signaling pathway",
  "GO:0097528": "execution phase of necroptosis",
  "GO:0097529": "myeloid leukocyte migration",
  "GO:0097530": "granulocyte migration",
  "GO:0097531": "mast cell migration",
  "GO:0097532": "stress response to acid chemical",
  "GO:0097533": "cellular stress response to acid chemical",
  "GO:0097534": "lymphoid lineage cell migration",
  "GO:0097535": "lymphoid lineage cell migration into thymus",
  "GO:0097536": "thymus epithelium morphogenesis",
  "GO:0097537": "Y-shaped link",
  "GO:0097538": "ciliary necklace",
  "GO:0097539": "ciliary transition fiber",
  "GO:0097540": "axonemal central pair",
  "GO:0097541": "axonemal basal plate",
  "GO:0097542": "ciliary tip",
  "GO:0097543": "ciliary inversin compartment",
  "GO:0097544": "ciliary shaft",
  "GO:0097545": "axonemal outer doublet",
  "GO:0097546": "ciliary base",
  "GO:0097547": "synaptic vesicle protein transport vesicle",
  "GO:0097548": "seed abscission",
  "GO:0097549": "chromatin organization involved in negative regulation of transcription",
  "GO:0097550": "transcriptional preinitiation complex",
  "GO:0097551": "mitochondrial double-strand break repair",
  "GO:0097552": "mitochondrial double-strand break repair via homologous recombination",
  "GO:0097553": "calcium ion transmembrane import into cytosol",
  "GO:0097554": "left anterior flagellum",
  "GO:0097555": "right anterior flagellum",
  "GO:0097556": "left posteriolateral flagellum",
  "GO:0097557": "right posteriolateral flagellum",
  "GO:0097558": "left ventral flagellum",
  "GO:0097559": "right ventral flagellum",
  "GO:0097560": "left caudal flagellum",
  "GO:0097561": "right caudal flagellum",
  "GO:0097562": "left lateral basal body pair",
  "GO:0097563": "left middle basal body pair",
  "GO:0097564": "right lateral basal body pair",
  "GO:0097565": "right middle basal body pair",
  "GO:0097566": "left tetrad",
  "GO:0097567": "right tetrad",
  "GO:0097568": "median body",
  "GO:0097569": "lateral shield",
  "GO:0097570": "cyst wall",
  "GO:0097571": "left nucleus",
  "GO:0097572": "right nucleus",
  "GO:0097573": "glutathione oxidoreductase activity",
  "GO:0097574": "lateral part of cell",
  "GO:0097575": "lateral cell cortex",
  "GO:0097576": "vacuole fusion",
  "GO:0097577": "sequestering of iron ion",
  "GO:0097578": "sequestering of copper ion",
  "GO:0097579": "extracellular sequestering of copper ion",
  "GO:0097580": "intracellular sequestering of copper ion",
  "GO:0097581": "lamellipodium organization",
  "GO:0097582": "dolichyl-phosphate-mannose-protein mannosyltransferase Pmt1p-Pmt2p dimer complex",
  "GO:0097583": "dolichyl-phosphate-mannose-protein mannosyltransferase Pmt1p-Pmt3p dimer complex",
  "GO:0097584": "dolichyl-phosphate-mannose-protein mannosyltransferase Pmt5p-Pmt2p dimer complex",
  "GO:0097585": "dolichyl-phosphate-mannose-protein mannosyltransferase Pmt5p-Pmt3p dimer complex",
  "GO:0097586": "dolichyl-phosphate-mannose-protein mannosyltransferase Pmt4p homodimer complex",
  "GO:0097587": "MutLgamma complex",
  "GO:0097588": "archaeal or bacterial-type flagellum-dependent cell motility",
  "GO:0097589": "archaeal-type flagellum",
  "GO:0097590": "archaeal-type flagellum-dependent cell motility",
  "GO:0097591": "ventral disc lateral crest",
  "GO:0097592": "ventral disc overlap zone",
  "GO:0097593": "ventral disc microtubule array",
  "GO:0097594": "ventral disc dorsal microribbon",
  "GO:0097595": "ventral disc crossbridge",
  "GO:0097596": "ventral disc supernumerary microtubule array",
  "GO:0097597": "ventral disc",
  "GO:0097598": "sperm cytoplasmic droplet",
  "GO:0097599": "xylanase activity",
  "GO:0097600": "exoxylanase activity",
  "GO:0097601": "retina blood vessel maintenance",
  "GO:0097602": "cullin family protein binding",
  "GO:0097603": "temperature-gated ion channel activity",
  "GO:0097604": "temperature-gated cation channel activity",
  "GO:0097605": "regulation of nuclear envelope permeability",
  "GO:0097606": "positive regulation of nuclear envelope permeability",
  "GO:0097607": "negative regulation of nuclear envelope permeability",
  "GO:0097608": "transverse flagellum",
  "GO:0097609": "longitudinal flagellum",
  "GO:0097610": "cell surface furrow",
  "GO:0097611": "dinoflagellate cingulum",
  "GO:0097612": "dinoflagellate sulcus",
  "GO:0097613": "dinoflagellate epicone",
  "GO:0097614": "dinoflagellate hypocone",
  "GO:0097615": "modulation by host of symbiont type IV pilus-dependent motility",
  "GO:0097616": "positive regulation by host of symbiont type IV pilus-dependent motility",
  "GO:0097617": "annealing activity",
  "GO:0097618": "dinoflagellate sulcal notch",
  "GO:0097619": "PTEX complex",
  "GO:0097620": "(R)-mandelate dehydrogenase activity",
  "GO:0097621": "monoamine oxidase activity",
  "GO:0097622": "cytoplasmic translational elongation through polyproline stretches",
  "GO:0097623": "potassium ion export across plasma membrane",
  "GO:0097624": "UDP-galactose transmembrane import into Golgi lumen",
  "GO:0097625": "low-affinity basic amino acid transmembrane transporter activity",
  "GO:0097626": "low-affinity L-arginine transmembrane transporter activity",
  "GO:0097627": "high-affinity L-ornithine transmembrane transporter activity",
  "GO:0097628": "distal tip cell migration",
  "GO:0097629": "extrinsic component of omegasome membrane",
  "GO:0097630": "intrinsic component of omegasome membrane",
  "GO:0097631": "integral component of omegasome membrane",
  "GO:0097632": "extrinsic component of pre-autophagosomal structure membrane",
  "GO:0097633": "intrinsic component of pre-autophagosomal structure membrane",
  "GO:0097634": "integral component of pre-autophagosomal structure membrane",
  "GO:0097635": "extrinsic component of autophagosome membrane",
  "GO:0097636": "intrinsic component of autophagosome membrane",
  "GO:0097637": "integral component of autophagosome membrane",
  "GO:0097638": "L-arginine import across plasma membrane",
  "GO:0097639": "L-lysine import across plasma membrane",
  "GO:0097640": "L-ornithine import across plasma membrane",
  "GO:0097641": "alpha-ketoglutarate-dependent xanthine dioxygenase activity",
  "GO:0097642": "calcitonin family receptor activity",
  "GO:0097643": "amylin receptor activity",
  "GO:0097644": "calcitonin family binding",
  "GO:0097645": "amylin binding",
  "GO:0097646": "calcitonin family receptor signaling pathway",
  "GO:0097647": "amylin receptor signaling pathway",
  "GO:0097648": "G-protein coupled receptor complex",
  "GO:0097649": "A axonemal microtubule",
  "GO:0097650": "B axonemal microtubule",
  "GO:0097651": "phosphatidylinositol 3-kinase complex, class I",
  "GO:0097652": "phosphatidylinositol 3-kinase complex, class II",
  "GO:0097653": "unencapsulated part of cell",
  "GO:0097654": "platelet SNARE complex",
  "GO:0097655": "serpin family protein binding",
  "GO:0097656": "cell-cell self recognition",
  "GO:0097657": "3',5'-nucleotide bisphosphate phosphatase activity",
  "GO:0097658": "Asi complex",
  "GO:0097659": "nucleic acid-templated transcription",
  "GO:0097660": "SCF-Cdc4 ubiquitin ligase complex",
  "GO:0097661": "SCF-Ctf13 ubiquitin ligase complex",
  "GO:0097662": "SCF-Das1 ubiquitin ligase complex",
  "GO:0097663": "SCF-Dia2/Pof3 ubiquitin ligase complex",
  "GO:0097664": "SCF-Grr1/Pof2 ubiquitin ligase complex",
  "GO:0097665": "SCF-Mdm30 ubiquitin ligase complex",
  "GO:0097666": "SCF-Met30/Pof1 ubiquitin ligase complex",
  "GO:0097667": "SCF-Rcy1/Pof6 ubiquitin ligase complex",
  "GO:0097668": "SCF-Saf1/Pof9 ubiquitin ligase complex",
  "GO:0097669": "SCF-Skp2 ubiquitin ligase complex",
  "GO:0097670": "SCF-Ufo1/Pof10 ubiquitin ligase complex",
  "GO:0097671": "SCF-YDR131C ubiquitin ligase complex",
  "GO:0097672": "SCF-Pof5 ubiquitin ligase complex",
  "GO:0097673": "SCF-Ucc1 ubiquitin ligase complex",
  "GO:0097674": "SCF-YLR352W ubiquitin ligase complex",
  "GO:0097675": "SCF-Hrt3/Pof7 ubiquitin ligase complex",
  "GO:0097676": "histone H3-K36 dimethylation",
  "GO:0097677": "STAT family protein binding",
  "GO:0097678": "SOCS family protein binding",
  "GO:0097679": "other organism cytoplasm",
  "GO:0097680": "double-strand break repair via classical nonhomologous end joining",
  "GO:0097681": "double-strand break repair via alternative nonhomologous end joining",
  "GO:0097682": "intracellular phosphatidylinositol-3,5-bisphosphate-sensitive cation channel activity",
  "GO:0097683": "dinoflagellate apex",
  "GO:0097684": "dinoflagellate antapex",
  "GO:0097685": "dinoflagellate apical groove",
  "GO:0097686": "dinoflagellate apical horn",
  "GO:0097687": "dinoflagellate antapical horn",
  "GO:0097688": "glutamate receptor clustering",
  "GO:0097689": "iron channel activity",
  "GO:0097690": "iron channel inhibitor activity",
  "GO:0097691": "bacterial extracellular vesicle",
  "GO:0097692": "histone H3-K4 monomethylation",
  "GO:0097693": "ocelloid",
  "GO:0097694": "establishment of RNA localization to telomere",
  "GO:0097695": "establishment of macromolecular complex localization to telomere",
  "GO:0097696": "STAT cascade",
  "GO:0097697": "tRNA 5-carboxymethoxyuridine methyltransferase activity",
  "GO:0097698": "telomere maintenance via base-excision repair",
  "GO:0097699": "vascular endothelial cell response to fluid shear stress",
  "GO:0097700": "vascular endothelial cell response to laminar fluid shear stress",
  "GO:0097701": "response to pulsatile fluid shear stress",
  "GO:0097702": "response to oscillatory fluid shear stress",
  "GO:0097703": "cellular response to pulsatile fluid shear stress",
  "GO:0097704": "cellular response to oscillatory fluid shear stress",
  "GO:0097705": "vascular endothelial cell response to pulsatile fluid shear stress",
  "GO:0097706": "vascular endothelial cell response to oscillatory fluid shear stress",
  "GO:0097707": "ferroptosis",
  "GO:0097708": "intracellular vesicle",
  "GO:0098001": "receptor-mediated bacteriophage reversible attachment to host cell",
  "GO:0098002": "receptor-mediated bacteriophage irreversible attachment to host cell",
  "GO:0098003": "viral tail assembly",
  "GO:0098004": "virus tail fiber assembly",
  "GO:0098005": "viral head-tail joining",
  "GO:0098006": "viral DNA genome packaging, headful",
  "GO:0098009": "virus terminase, large subunit",
  "GO:0098015": "virus tail",
  "GO:0098017": "viral capsid, major subunit",
  "GO:0098018": "viral capsid, minor subunit",
  "GO:0098019": "virus tail, major subunit",
  "GO:0098020": "virus tail, minor subunit",
  "GO:0098021": "viral capsid, decoration",
  "GO:0098022": "viral capsid, fiber",
  "GO:0098023": "virus tail, tip",
  "GO:0098024": "virus tail, fiber",
  "GO:0098025": "virus tail, baseplate",
  "GO:0098026": "virus tail, tube",
  "GO:0098027": "virus tail, sheath",
  "GO:0098028": "virus tail, shaft",
  "GO:0098029": "icosahedral viral capsid, spike",
  "GO:0098030": "icosahedral viral capsid, neck",
  "GO:0098031": "icosahedral viral capsid, collar",
  "GO:0098032": "icosahedral viral capsid, collar fiber",
  "GO:0098033": "icosahedral viral capsid, neck fiber",
  "GO:0098035": "viral DNA genome packaging via site-specific sequence recognition",
  "GO:0098036": "viral DNA genome packaging, 3' extended cos packaging",
  "GO:0098037": "viral DNA genome packaging, 5' extended cos packaging",
  "GO:0098038": "non-replicative transposition, DNA-mediated",
  "GO:0098039": "replicative transposition, DNA-mediated",
  "GO:0098045": "virus baseplate assembly",
  "GO:0098046": "type V protein secretion system complex",
  "GO:0098061": "viral capsid, internal space",
  "GO:0098501": "polynucleotide dephosphorylation",
  "GO:0098502": "DNA dephosphorylation",
  "GO:0098503": "DNA 3' dephosphorylation",
  "GO:0098504": "DNA 3' dephosphorylation involved in DNA repair",
  "GO:0098505": "G-rich strand telomeric DNA binding",
  "GO:0098506": "polynucleotide 3' dephosphorylation",
  "GO:0098507": "polynucleotide 5' dephosphorylation",
  "GO:0098508": "endothelial to hematopoietic transition",
  "GO:0098509": "sensory perception of humidity",
  "GO:0098510": "sensory perception of high humidity",
  "GO:0098511": "sensory perception of low humidity",
  "GO:0098512": "detection of humidity stimulus involved in sensory perception",
  "GO:0098513": "detection of humidity",
  "GO:0098514": "detection of high humidity stimulus involved in sensory perception",
  "GO:0098515": "detection of low humidity stimulus involved in sensory perception",
  "GO:0098516": "detection of high humidity",
  "GO:0098517": "detection of low humidity",
  "GO:0098518": "polynucleotide phosphatase activity",
  "GO:0098519": "nucleotide phosphatase activity, acting on free nucleotides",
  "GO:0098520": "excitatory neuromuscular junction",
  "GO:0098521": "inhibitory neuromuscular junction",
  "GO:0098522": "neuromuscular junction of skeletal muscle fiber",
  "GO:0098523": "neuromuscular junction of myotube",
  "GO:0098524": "neuromuscular junction of somatic muscle myotube",
  "GO:0098525": "excitatory neuromuscular junction of somatic myotube",
  "GO:0098526": "inhibitory neuromuscular junction of somatic myotube",
  "GO:0098527": "neuromuscular junction of somatic muscle",
  "GO:0098528": "skeletal muscle fiber differentiation",
  "GO:0098529": "neuromuscular junction development, skeletal muscle fiber",
  "GO:0098530": "positive regulation of strand invasion",
  "GO:0098531": "transcription factor activity, direct ligand regulated sequence-specific DNA binding",
  "GO:0098532": "histone H3-K27 trimethylation",
  "GO:0098533": "ATPase dependent transmembrane transport complex",
  "GO:0098534": "centriole assembly",
  "GO:0098535": "de novo centriole assembly",
  "GO:0098536": "deuterosome",
  "GO:0098537": "lobed nucleus",
  "GO:0098538": "lumenal side of transport vesicle membrane",
  "GO:0098539": "cytoplasmic side of transport vesicle membrane",
  "GO:0098540": "lumenal side of trans-Golgi network transport vesicle membrane",
  "GO:0098541": "cytoplasmic side of trans-Golgi network transport vesicle membrane",
  "GO:0098542": "defense response to other organism",
  "GO:0098543": "detection of other organism",
  "GO:0098544": "maintenance of protein complex location",
  "GO:0098545": "maintenance of protein complex location in cytoplasm",
  "GO:0098546": "2',5-3',5'-cyclic GMP-AMP binding",
  "GO:0098547": "lumenal side of Golgi membrane",
  "GO:0098548": "cytoplasmic side of Golgi membrane",
  "GO:0098549": "somatic ring canal",
  "GO:0098550": "lumenal side of early endosome membrane",
  "GO:0098551": "lumenal side of late endosome membrane",
  "GO:0098552": "side of membrane",
  "GO:0098553": "lumenal side of endoplasmic reticulum membrane",
  "GO:0098554": "cytoplasmic side of endoplasmic reticulum membrane",
  "GO:0098555": "lumenal side of rough endoplasmic reticulum membrane",
  "GO:0098556": "cytoplasmic side of rough endoplasmic reticulum membrane",
  "GO:0098557": "cytoplasmic side of smooth endoplasmic reticulum membrane",
  "GO:0098558": "lumenal side of smooth endoplasmic reticulum membrane",
  "GO:0098559": "cytoplasmic side of early endosome membrane",
  "GO:0098560": "cytoplasmic side of late endosome membrane",
  "GO:0098561": "methyl accepting chemotaxis protein complex",
  "GO:0098562": "cytoplasmic side of membrane",
  "GO:0098563": "intrinsic component of synaptic vesicle membrane",
  "GO:0098564": "trans-Golgi network transport vesicle lumen",
  "GO:0098565": "lumenal side of endosome membrane",
  "GO:0098566": "transport vesicle lumen",
  "GO:0098567": "periplasmic side of plasma membrane",
  "GO:0098568": "external side of mycolate outer membrane",
  "GO:0098569": "internal side of mycolate outer membrane",
  "GO:0098570": "stromal side of plastid inner membrane",
  "GO:0098571": "lumenal side of plastid thylakoid membrane",
  "GO:0098572": "stromal side of plastid thylakoid membrane",
  "GO:0098573": "intrinsic component of mitochondrial membrane",
  "GO:0098574": "cytoplasmic side of lysosomal membrane",
  "GO:0098575": "lumenal side of lysosomal membrane",
  "GO:0098576": "lumenal side of membrane",
  "GO:0098577": "inactive sex chromosome",
  "GO:0098578": "condensed chromatin of inactivated sex chromosome",
  "GO:0098579": "active sex chromosome",
  "GO:0098580": "chromatin of active sex chromosome",
  "GO:0098581": "detection of external biotic stimulus",
  "GO:0098582": "innate vocalization behavior",
  "GO:0098583": "learned vocalization behavior",
  "GO:0098584": "host cell synaptic vesicle",
  "GO:0098585": "host cell synaptic vesicle membrane",
  "GO:0098586": "cellular response to virus",
  "GO:0098588": "bounding membrane of organelle",
  "GO:0098589": "membrane region",
  "GO:0098590": "plasma membrane region",
  "GO:0098591": "external side of apical plasma membrane",
  "GO:0098592": "cytoplasmic side of apical plasma membrane",
  "GO:0098593": "goblet cell theca",
  "GO:0098594": "mucin granule",
  "GO:0098595": "perivitelline space",
  "GO:0098596": "imitative learning",
  "GO:0098597": "observational learning",
  "GO:0098598": "learned vocalization behavior or vocal learning",
  "GO:0098599": "palmitoyl hydrolase activity",
  "GO:0098600": "selenomethionine gamma-lyase activity",
  "GO:0098601": "selenomethionine adenosyltransferase activity",
  "GO:0098602": "single organism cell adhesion",
  "GO:0098603": "selenol Se-methyltransferase activity",
  "GO:0098604": "adenosylselenohomocysteinase activity",
  "GO:0098605": "selenocystathionine beta-synthase activity",
  "GO:0098606": "selenocystathionine gamma-lyase activity",
  "GO:0098607": "methylselenocysteine deselenhydrase activity",
  "GO:0098608": "methylselenol demethylase activity",
  "GO:0098609": "cell-cell adhesion",
  "GO:0098610": "adhesion between unicellular organisms",
  "GO:0098611": "cell-cell adhesion involved in galactose-specific flocculation",
  "GO:0098612": "cell-cell adhesion involved in mannose-specific flocculation",
  "GO:0098613": "methaneselenol methyltransferase activity",
  "GO:0098614": "hydrogen selenide methyltransferase activity",
  "GO:0098615": "dimethyl selenide methyltransferase activity",
  "GO:0098616": "selenate adenylyltransferase (ATP) activity",
  "GO:0098617": "adenylylselenate kinase activity",
  "GO:0098618": "selenomethionine-tRNA ligase activity",
  "GO:0098619": "selenocysteine-tRNA ligase activity",
  "GO:0098620": "seryl-selenocysteinyl-tRNA kinase activity",
  "GO:0098621": "phosphoseryl-selenocysteinyl-tRNA selenium transferase activity",
  "GO:0098622": "selenodiglutathione-disulfide reductase activity",
  "GO:0098623": "selenite reductase activity",
  "GO:0098624": "3'-Phosphoadenylylselenate reductase activity",
  "GO:0098625": "methylselenol reductase activity",
  "GO:0098626": "methylseleninic acid reductase activity",
  "GO:0098627": "protein arginine phosphatase activity",
  "GO:0098628": "peptidyl-N-phospho-arginine dephosphorylation",
  "GO:0098629": "trans-Golgi network membrane organization",
  "GO:0098630": "aggregation of unicellular organisms",
  "GO:0098631": "protein binding involved in cell adhesion",
  "GO:0098632": "protein binding involved in cell-cell adhesion",
  "GO:0098633": "collagen fibril binding",
  "GO:0098634": "protein binding involved in cell-matrix adhesion",
  "GO:0098635": "protein complex involved in cell-cell adhesion",
  "GO:0098636": "protein complex involved in cell adhesion",
  "GO:0098637": "protein complex involved in cell-matrix adhesion",
  "GO:0098638": "laminin binding involved in cell-matrix adhesion",
  "GO:0098639": "collagen binding involved in cell-matrix adhesion",
  "GO:0098640": "integrin binding involved in cell-matrix adhesion",
  "GO:0098641": "cadherin binding involved in cell-cell adhesion",
  "GO:0098642": "network-forming collagen trimer",
  "GO:0098643": "banded collagen fibril",
  "GO:0098644": "complex of collagen trimers",
  "GO:0098645": "collagen network",
  "GO:0098646": "collagen sheet",
  "GO:0098647": "collagen beaded filament",
  "GO:0098648": "collagen anchoring fibril",
  "GO:0098649": "response to peptidyl-dipeptidase A inhibitor",
  "GO:0098650": "peptidyl-proline 4-dioxygenase binding",
  "GO:0098651": "basement membrane collagen trimer",
  "GO:0098652": "collagen type VII anchoring fibril",
  "GO:0098653": "centromere clustering",
  "GO:0098654": "CENP-A recruiting complex",
  "GO:0098655": "cation transmembrane transport",
  "GO:0098656": "anion transmembrane transport",
  "GO:0098657": "import into cell",
  "GO:0098658": "inorganic anion import into cell",
  "GO:0098659": "inorganic cation import into cell",
  "GO:0098660": "inorganic ion transmembrane transport",
  "GO:0098661": "inorganic anion transmembrane transport",
  "GO:0098662": "inorganic cation transmembrane transport",
  "GO:0098663": "transmembrane transporter activity involved in import into cell",
  "GO:0098687": "chromosomal region",
  "GO:0098700": "neurotransmitter loading into synaptic vesicle",
  "GO:0098701": "endocytic import into cell",
  "GO:0098702": "adenine import across plasma membrane",
  "GO:0098703": "calcium ion import across plasma membrane",
  "GO:0098704": "carbohydrate import across plasma membrane",
  "GO:0098705": "copper ion import across plasma membrane",
  "GO:0098706": "ferric iron import across plasma membrane",
  "GO:0098707": "ferrous iron import across plasma membrane",
  "GO:0098708": "glucose import across plasma membrane",
  "GO:0098709": "glutathione import across plasma membrane",
  "GO:0098710": "guanine import across plasma membrane",
  "GO:0098711": "iron ion import across plasma membrane",
  "GO:0098712": "L-glutamate import across plasma membrane",
  "GO:0098713": "leucine import across plasma membrane",
  "GO:0098714": "malate import across plasma membrane",
  "GO:0098715": "malonic acid import across plasma membrane",
  "GO:0098716": "nickel cation import across plasma membrane",
  "GO:0098717": "pantothenate import across plasma membrane",
  "GO:0098718": "serine import across plasma membrane",
  "GO:0098719": "sodium ion import across plasma membrane",
  "GO:0098720": "succinate import across plasma membrane",
  "GO:0098721": "uracil import across plasma membrane",
  "GO:0098722": "asymmetric stem cell division",
  "GO:0098723": "skeletal muscle myofibril",
  "GO:0098724": "symmetric stem cell division",
  "GO:0098725": "symmetric cell division",
  "GO:0098726": "symmetric division of skeletal muscle satellite stem cell",
  "GO:0098727": "maintenance of cell number",
  "GO:0098728": "germline stem cell asymmetric division",
  "GO:0098729": "germline stem cell symmetric division",
  "GO:0098730": "male germline stem cell symmetric division",
  "GO:0098731": "skeletal muscle satellite stem cell maintenance involved in skeletal muscle regeneration",
  "GO:0098732": "macromolecule deacylation",
  "GO:0098733": "hemidesmosome associated protein complex",
  "GO:0098734": "macromolecule depalmitoylation",
  "GO:0098735": "positive regulation of the force of heart contraction",
  "GO:0098736": "negative regulation of the force of heart contraction",
  "GO:0098737": "protein insertion into plasma membrane",
  "GO:0098739": "import across plasma membrane",
  "GO:0098740": "multi organism cell adhesion",
  "GO:0098741": "adhesion between unicellular organisms via cell-wall interaction",
  "GO:0098742": "cell-cell adhesion via plasma-membrane adhesion molecules",
  "GO:0098743": "cell aggregation",
  "GO:0098744": "1-phosphatidylinositol 4-kinase activator activity",
  "GO:0098745": "Dcp1-Dcp2 complex",
  "GO:0098746": "fast, calcium ion-dependent exocytosis of neurotransmitter",
  "GO:0098747": "slow, calcium ion-dependent exocytosis of neurotransmitter",
  "GO:0098748": "endocytic adaptor activity",
  "GO:0098749": "cerebellar neuron development",
  "GO:0098750": "FYXD domain binding",
  "GO:0098751": "bone cell development",
  "GO:0098752": "integral component of the cytoplasmic side of the plasma membrane",
  "GO:0098753": "anchored component of the cytoplasmic side of the plasma membrane",
  "GO:0098754": "detoxification",
  "GO:0098755": "maintenance of seed dormancy by absisic acid",
  "GO:0098756": "response to interleukin-21",
  "GO:0098757": "cellular response to interleukin-21",
  "GO:0098758": "response to interleukin-8",
  "GO:0098759": "cellular response to interleukin-8",
  "GO:0098760": "response to interleukin-7",
  "GO:0098761": "cellular response to interleukin-7",
  "GO:0098762": "meiotic cell cycle phase",
  "GO:0098763": "mitotic cell cycle phase",
  "GO:0098764": "meiosis I cell cycle phase",
  "GO:0098765": "meiosis II cell cycle phase",
  "GO:0098766": "obsolete meiosis I M phase",
  "GO:0098767": "obsolete meiosis II M phase",
  "GO:0098768": "meiotic prometaphase I",
  "GO:0098769": "TIMP family protein binding",
  "GO:0098770": "FBXO family protein binding",
  "GO:0098771": "inorganic ion homeostasis",
  "GO:0098772": "molecular function regulator",
  "GO:0098773": "skin epidermis development",
  "GO:0098774": "curli",
  "GO:0098775": "curli assembly",
  "GO:0098776": "protein transport across the cell outer membrane",
  "GO:0098777": "protein secretion by the type VIII secretion system",
  "GO:0098778": "curli subunit secretion coupled to curli assembly",
  "GO:0098779": "mitophagy in response to mitochondrial depolarization",
  "GO:0098780": "response to mitochondrial depolarisation",
  "GO:0098781": "ncRNA transcription",
  "GO:0098782": "mechanically-gated potassium channel activity",
  "GO:0098783": "correction of merotelic kinetochore attachment, mitotic",
  "GO:0098784": "biofilm matrix organization",
  "GO:0098785": "biofilm matrix assembly",
  "GO:0098786": "biofilm matrix disassembly",
  "GO:0098787": "mRNA cleavage involved in mRNA processing",
  "GO:0098788": "dendritic knob",
  "GO:0098789": "pre-mRNA cleavage required for polyadenylation",
  "GO:0098790": "ncRNA transcription associated with protein coding gene TSS/TES",
  "GO:0098791": "Golgi subcompartment",
  "GO:0098792": "xenophagy",
  "GO:0098793": "presynapse",
  "GO:0098794": "postsynapse",
  "GO:0098795": "mRNA cleavage involved in gene silencing",
  "GO:0098796": "membrane protein complex",
  "GO:0098797": "plasma membrane protein complex",
  "GO:0098798": "mitochondrial protein complex",
  "GO:0098799": "outer mitochondrial membrane protein complex",
  "GO:0098800": "inner mitochondrial membrane protein complex",
  "GO:0098801": "regulation of renal system process",
  "GO:0098802": "plasma membrane receptor complex",
  "GO:0098803": "respiratory chain complex",
  "GO:0098804": "nonmotile primary cilium membrane",
  "GO:0098805": "whole membrane",
  "GO:0098806": "deadenylation involved in gene silencing by miRNA",
  "GO:0098807": "chloroplast thylakoid membrane protein complex",
  "GO:0098808": "mRNA cap binding",
  "GO:0098809": "nitrite reductase activity",
  "GO:0098810": "neurotransmitter reuptake",
  "GO:0098811": "transcriptional repressor activity, RNA polymerase II activating transcription factor binding",
  "GO:0098812": "nuclear rRNA polyadenylation involved in polyadenylation-dependent rRNA catabolic process",
  "GO:0098813": "nuclear chromosome segregation",
  "GO:0098814": "spontaneous synaptic transmission",
  "GO:0098815": "modulation of excitatory postsynaptic potential",
  "GO:0098816": "mini excitatory postsynaptic potential",
  "GO:0098817": "evoked excitatory postsynaptic potential",
  "GO:0098818": "hyperpolarization of postsynaptic membrane",
  "GO:0098819": "depolarization of postsynaptic membrane",
  "GO:0098820": "trans-synaptic protein complex",
  "GO:0098821": "BMP receptor activity",
  "GO:0098822": "peptidyl-cysteine modification to L-cysteine persulfide",
  "GO:0098823": "peptidyl-cysteine modification to S-amindino-L-cysteine",
  "GO:0098824": "petidyl-cysteine sulfation",
  "GO:0098825": "peptidyl-histidine guanylation",
  "GO:0098826": "endoplasmic reticulum tubular network membrane",
  "GO:0098827": "endoplasmic reticulum subcompartment",
  "GO:0098828": "modulation of inhibitory postsynaptic potential",
  "GO:0098829": "intestinal folate absorption",
  "GO:0098830": "presynaptic endosome",
  "GO:0098831": "presynaptic active zone cytoplasmic component",
  "GO:0098832": "peri-centrosomal recycling endosome",
  "GO:0098833": "presynaptic endocytic zone",
  "GO:0098834": "presynaptic endocytic zone, cytoplasmic component",
  "GO:0098835": "presynaptic endocytic zone membrane",
  "GO:0098836": "cytoskeleton of dendritic spine",
  "GO:0098837": "postsynaptic recycling endosome",
  "GO:0098838": "reduced folate transmembrane transport",
  "GO:0098839": "postsynaptic density membrane",
  "GO:0098840": "protein transport along microtubule",
  "GO:0098841": "protein localization to cell division site after cytokinesis",
  "GO:0098842": "postsynaptic early endosome",
  "GO:0098843": "postsynaptic endocytic zone",
  "GO:0098844": "postsynaptic endocytic zone membrane",
  "GO:0098845": "postsynaptic endosome",
  "GO:0098846": "podocyte foot",
  "GO:0098847": "sequence-specific single stranded DNA binding",
  "GO:0098848": "alpha-D-ribose 1-methylphosphonate 5-phosphate C-P-lyase activity",
  "GO:0098849": "cellular detoxification of cadmium ion",
  "GO:0098850": "extrinsic component of synaptic vesicle membrane",
  "GO:0098851": "double-stranded miRNA binding",
  "GO:0098852": "lytic vacuole membrane",
  "GO:0098853": "ER-vacuole membrane contact site",
  "GO:0098854": "podocyte primary projection",
  "GO:0098855": "HCN channel complex",
  "GO:0098856": "intestinal lipid absorption",
  "GO:0098857": "membrane microdomain",
  "GO:0098858": "actin-based cell projection",
  "GO:0098859": "actin filament bundle of actin-based cell projection",
  "GO:0098860": "actin filament bundle of stereocilium",
  "GO:0098861": "actin filament bundle of filopodium",
  "GO:0098862": "cluster of actin-based cell projections",
  "GO:0098863": "nuclear migration by microtubule mediated pushing forces",
  "GO:0098864": "modification by symbiont of host occluding cell-cell junction",
  "GO:0098865": "modification by symbiont of host bicellular tight junctions",
  "GO:0098866": "multivesicular body fusion to apical plasma membrane",
  "GO:0098867": "intramembranous bone growth",
  "GO:0098868": "bone growth",
  "GO:0098869": "cellular oxidant detoxification",
  "GO:0098870": "action potential propagation",
  "GO:0098873": "neuronal action potential back-propagation",
  "GO:0098874": "spike train",
  "GO:0098900": "regulation of action potential",
  "GO:0098901": "regulation of cardiac muscle cell action potential",
  "GO:0098902": "regulation of membrane depolarization during action potential",
  "GO:0098903": "regulation of membrane repolarization during action potential",
  "GO:0098904": "regulation of AV node cell action potential",
  "GO:0098905": "regulation of bundle of His cell action potential",
  "GO:0098906": "regulation of Purkinje myocyte action potential",
  "GO:0098907": "regulation of SA node cell action potential",
  "GO:0098908": "regulation of neuronal action potential",
  "GO:0098909": "regulation of cardiac muscle cell action potential involved in regulation of contraction",
  "GO:0098910": "regulation of atrial cardiac muscle cell action potential",
  "GO:0098911": "regulation of ventricular cardiac muscle cell action potential",
  "GO:0098912": "membrane depolarization during atrial cardiac muscle cell action potential",
  "GO:0098913": "membrane depolarization during ventricular cardiac muscle cell action potential",
  "GO:0098914": "membrane repolarization during atrial cardiac muscle cell action potential",
  "GO:0098915": "membrane repolarization during ventricular cardiac muscle cell action potential",
  "GO:0099400": "caveola neck",
  "GO:0099401": "caveola bulb",
  "GO:0099402": "plant organ development",
  "GO:0099403": "maintenance of mitotic sister chromatid cohesion, telomeric",
  "GO:0099404": "mitotic sister chromatid cohesion, telomeric",
  "GO:0099500": "vesicle fusion to plasma membrane",
  "GO:0099501": "exocytic vesicle membrane",
  "GO:0099502": "calcium-dependent activation of synaptic vesicle fusion",
  "GO:0099503": "secretory vesicle",
  "GO:0099504": "synaptic vesicle cycle",
  "GO:0099505": "regulation of presynaptic membrane potential",
  "GO:0099506": "synaptic vesicle transport along actin filament",
  "GO:0099507": "ligand-gated ion channel activity involved in regulation of presynaptic membrane potential",
  "GO:0099508": "voltage-gated ion channel activity involved in regulation of presynaptic membrane potential",
  "GO:0099509": "regulation of presynaptic cytosolic calcium ion concentration",
  "GO:0099510": "calcium ion binding involved in regulation of cytosolic calcium ion concentration",
  "GO:0099511": "voltage-gated calcium channel activity involved in regulation of cytosolic calcium levels",
  "GO:0099512": "supramolecular fiber",
  "GO:0099513": "polymeric cytoskeletal fiber",
  "GO:0099514": "synaptic vesicle cytoskeletal transport",
  "GO:0099515": "actin filament-based transport",
  "GO:0099516": "ion antiporter activity",
  "GO:0099517": "synaptic vesicle transport along microtubule",
  "GO:0099518": "vesicle cytoskeletal trafficking",
  "GO:0099519": "dense core granule cytoskeletal trafficking",
  "GO:0099520": "ion antiporter activity involved in regulation of presynaptic membrane potential",
  "GO:0099521": "ATPase coupled ion transmembrane transporter activity involved in regulation of presynaptic membrane potential",
  "GO:0099522": "region of cytosol",
  "GO:0099523": "presynaptic cytosol",
  "GO:0099524": "postsynaptic cytosol",
  "GO:0099525": "presynaptic dense core granule exocytosis",
  "GO:0099526": "presynapse to nucleus signaling pathway",
  "GO:0099527": "postsynapse to nucleus signaling pathway",
  "GO:0099528": "G-protein coupled neurotransmitter receptor activity",
  "GO:0099529": "neurotransmitter receptor activity involved in regulation of postsynaptic membrane potential",
  "GO:0099530": "G-protein coupled receptor activity involved in regulation of postsynaptic membrane potential",
  "GO:0099531": "presynaptic process involved in synaptic transmission",
  "GO:0099532": "synaptic vesicle processing via endosome",
  "GO:0099533": "positive regulation of presynaptic cytosolic calcium concentration",
  "GO:0099534": "calcium ion binding involved in regulation of presynaptic cytosolic calcium levels",
  "GO:0099535": "synapse associated extracellular matrix",
  "GO:0099536": "synaptic signaling",
  "GO:0099537": "trans-synaptic signaling",
  "GO:0099538": "synaptic signaling via neuropeptide",
  "GO:0099539": "neuropeptide secretion from presynapse",
  "GO:0099540": "trans-synaptic signaling by neuropeptide",
  "GO:0099541": "trans-synaptic signaling by lipid",
  "GO:0099542": "trans-synaptic signaling by endocannabinoid",
  "GO:0099543": "trans-synaptic signaling by soluble gas",
  "GO:0099544": "perisynaptic space",
  "GO:0099545": "trans-synaptic signaling by trans-synaptic complex",
  "GO:0099546": "protein catabolic process, modulating synaptic transmission",
  "GO:0099547": "regulation of translation at synapse, modulating synaptic transmission",
  "GO:0099548": "trans-synaptic signaling by nitric oxide",
  "GO:0099549": "trans-synaptic signaling by carbon monoxide",
  "GO:0099550": "trans-synaptic signalling, modulating synaptic transmission",
  "GO:0099551": "trans-synaptic signaling by neuropeptide, modulating synaptic transmission",
  "GO:0099552": "trans-synaptic signaling by lipid, modulating synaptic transmission",
  "GO:0099553": "trans-synaptic signaling by endocannabinoid, modulating synaptic transmission",
  "GO:0099554": "trans-synaptic signaling by soluble gas, modulating synaptic transmission",
  "GO:0099555": "trans-synaptic signaling by nitric oxide, modulating synaptic transmission",
  "GO:0099556": "trans-synaptic signaling by carbon monoxide, modulating synaptic transmission",
  "GO:0099557": "trans-synaptic signaling by trans-synaptic complex, modulating synaptic transmission",
  "GO:0099558": "maintenance of synapse structure",
  "GO:0099559": "maintenance of alignment of postsynaptic density and presynaptic active zone",
  "GO:0099560": "synaptic membrane adhesion",
  "GO:0099561": "synaptic membrane adhesion to extracellular matrix",
  "GO:0099562": "maintenance of postsynaptic density structure",
  "GO:0099563": "modification of synaptic structure",
  "GO:0099564": "modification of synaptic structure, modulating synaptic transmission",
  "GO:0099565": "chemical synaptic transmission, postsynaptic",
  "GO:0099566": "regulation of postsynaptic cytosolic calcium ion concentration",
  "GO:0099567": "calcium ion binding involved in regulation of postsynaptic cytosolic calcium levels",
  "GO:0099568": "cytoplasmic region",
  "GO:0099569": "presynaptic cytoskeleton",
  "GO:0099571": "postsynaptic cytoskeleton",
  "GO:0099572": "postsynaptic specialization",
  "GO:0099573": "glutamatergic postsynaptic density",
  "GO:0099574": "regulation of protein catabolic process at synapse, modulating synaptic transmission",
  "GO:0099575": "regulation of protein catabolic process at presynapse, modulating synaptic transmission",
  "GO:0099576": "regulation of protein catabolic process at postsynapse, modulating synaptic transmission",
  "GO:0099577": "regulation of translation at presynapse, modulating synaptic transmission",
  "GO:0099578": "regulation of translation at postsynapse, modulating synaptic transmission",
  "GO:0099579": "G-protein coupled neurotransmitter receptor activity involved in regulation of postsynaptic membrane potential",
  "GO:0099580": "ion antiporter activity involved in regulation of postsynaptic membrane potential",
  "GO:0099581": "ATPase coupled ion transmembrane transporter activity involved in regulation of postsynaptic membrane potential",
  "GO:0099582": "neurotransmitter receptor activity involved in regulation of presynaptic cytosolic calcium levels",
  "GO:0099583": "neurotransmitter receptor activity involved in regulation of postsynaptic cytosolic calcium levels",
  "GO:0099585": "release of sequestered calcium ion into presynaptic cytosol",
  "GO:0099586": "release of sequestered calcium ion into postsynaptic cytosol",
  "GO:0099587": "inorganic ion import into cell",
  "GO:0099588": "positive regulation of postsynaptic cytosolic calcium concentration",
  "GO:0099589": "serotonin receptor activity",
  "GO:0099590": "neurotransmitter receptor internalization",
  "GO:0099592": "endocytosed synaptic vesicle processing via endosome",
  "GO:0099593": "endocytosed synaptic vesicle to endosome fusion",
  "GO:0099600": "transmembrane receptor activity",
  "GO:0099601": "regulation of neurotransmitter receptor activity",
  "GO:0099602": "neurotransmitter receptor regulator activity",
  "GO:0099604": "ligand-gated calcium channel activity",
  "GO:0099605": "regulation of action potential firing rate",
  "GO:0099606": "microtubule plus-end directed mitotic chromosome migration",
  "GO:0099607": "lateral attachment of mitotic spindle microtubules to kinetochore",
  "GO:0099608": "regulation of action potential firing pattern",
  "GO:0099609": "microtubule lateral binding",
  "GO:0099610": "action potential initiation",
  "GO:0099611": "regulation of action potential firing threshold",
  "GO:0099612": "protein localization to axon",
  "GO:0099613": "protein targeting to cell wall",
  "GO:0099614": "protein targeting to spore cell wall",
  "GO:0099615": "(D)-2-hydroxyglutarate-pyruvate transhydrogenase activity",
  "GO:0099616": "extrinsic component of matrix side of mitochondrial inner membrane",
  "GO:0099617": "matrix side of mitochondrial inner membrane",
  "GO:0099618": "UDP-glucuronic acid dehydrogenase activity",
  "GO:0099619": "UDP-4-amino-4-deoxy-L-arabinose formyltransferase activity",
  "GO:0099620": "UDP-4-amino-4-deoxy-L-arabinose aminotransferase",
  "GO:0099621": "undecaprenyl-phosphate 4-deoxy-4-formamido-L-arabinose transferase activity",
  "GO:0099622": "cardiac muscle cell membrane repolarization",
  "GO:0099623": "regulation of cardiac muscle cell membrane repolarization",
  "GO:0099624": "atrial cardiac muscle cell membrane repolarization",
  "GO:0099625": "ventricular cardiac muscle cell membrane repolarization",
  "GO:0099626": "voltage-gated calcium channel activity involved in regulation of presynaptic cytosolic calcium levels",
  "GO:0099627": "neurotransmitter receptor cycle",
  "GO:0099628": "neurotransmitter receptor diffusion trapping",
  "GO:0099629": "postsynaptic specialization of inhibitory synapse",
  "GO:0099630": "postsynaptic neurotransmitter receptor cycle",
  "GO:0099631": "postsynaptic endocytic zone, cytoplasmic component",
  "GO:0099632": "protein transport within plasma membrane",
  "GO:0099633": "protein localization to postsynaptic specialization membrane",
  "GO:0099634": "postsynaptic specialization membrane",
  "GO:0099635": "voltage-gated calcium channel activity involved in positive regulation of presynaptic cytosolic calcium levels",
  "GO:0099636": "cytoplasmic streaming",
  "GO:0099637": "neurotransmitter receptor transport",
  "GO:0099638": "endosome to plasma membrane protein transport",
  "GO:0099639": "neurotransmitter receptor transport, endosome to plasma membrane",
  "GO:0099640": "axo-dendritic protein transport",
  "GO:0099641": "anterograde axonal protein transport",
  "GO:0099642": "retrograde axonal protein transport",
  "GO:0099643": "signal release from synapse",
  "GO:0099644": "protein localization to presynaptic membrane",
  "GO:0099645": "neurotransmitter receptor localization to postsynaptic specialization membrane",
  "GO:0099646": "neurotransmitter receptor transport, plasma membrane to endosome",
  "GO:0099703": "induction of synaptic vesicle exocytosis by positive regulation of presynaptic cytosolic calcium ion concentration",
  "GO:0099738": "cell cortex region",
  "GO:0100001": "regulation of skeletal muscle contraction by action potential",
  "GO:0100002": "negative regulation of protein kinase activity by protein phosphorylation",
  "GO:0100003": "positive regulation of sodium ion transport by transcription from RNA polymerase II promoter",
  "GO:0100004": "positive regulation of peroxisome organization by transcription from RNA polymerase II promoter",
  "GO:0100005": "positive regulation of ethanol catabolic process by transcription from RNA polymerase II promoter",
  "GO:0100006": "positive regulation of sulfite transport by transcription from RNA polymerase II promoter",
  "GO:0100007": "negative regulation of ceramide biosynthetic process by transcription from RNA polymerase II promoter",
  "GO:0100008": "regulation of fever generation by prostaglandin biosynthetic process",
  "GO:0100009": "regulation of fever generation by prostaglandin secretion",
  "GO:0100010": "positive regulation of fever generation by prostaglandin biosynthetic process",
  "GO:0100011": "positive regulation of fever generation by prostaglandin secretion",
  "GO:0100012": "regulation of heart induction by canonical Wnt signaling pathway",
  "GO:0100013": "positive regulation of fatty acid beta-oxidation by transcription from RNA polymerase II promoter",
  "GO:0100014": "positive regulation of mating type switching by transcription from RNA polymerase II promoter",
  "GO:0100015": "positive regulation of inositol biosynthetic process by transcription from RNA polymerase II promoter",
  "GO:0100016": "regulation of thiamine biosynthetic process by transcription from RNA polymerase II promoter",
  "GO:0100017": "negative regulation of cell-cell adhesion by transcription from RNA polymerase II promoter",
  "GO:0100018": "regulation of glucose import by transcription from RNA polymerase II promoter",
  "GO:0100019": "regulation of cAMP-mediated signaling by transcription from RNA polymerase II promoter",
  "GO:0100020": "regulation of transport by transcription from RNA polymerase II promoter",
  "GO:0100021": "regulation of iron ion transport by transcription from RNA polymerase II promoter",
  "GO:0100022": "regulation of iron ion import by transcription from RNA polymerase II promoter",
  "GO:0100023": "regulation of meiotic nuclear division by transcription from RNA polymerase II promoter",
  "GO:0100024": "regulation of carbohydrate metabolic process by transcription from RNA polymerase II promoter",
  "GO:0100025": "negative regulation of cellular amino acid biosynthetic process by transcription from RNA polymerase II promoter",
  "GO:0100026": "positive regulation of DNA repair by transcription from RNA polymerase II promoter",
  "GO:0100027": "regulation of cell separation after cytokinesis by transcription from RNA polymerase II promoter",
  "GO:0100028": "regulation of conjugation with cellular fusion by transcription from RNA polymerase II promoter",
  "GO:0100029": "regulation of histone modification by transcription from RNA polymerase II promoter",
  "GO:0100030": "regulation of histone acetylation by transcription from RNA polymerase II promoter",
  "GO:0100031": "regulation of histone methylation by transcription from RNA polymerase II promoter",
  "GO:0100032": "positive regulation of phospholipid biosynthetic process by transcription from RNA polymerase II promoter",
  "GO:0100033": "regulation of fungal-type cell wall biogenesis by transcription from RNA polymerase II promoter",
  "GO:0100034": "regulation of 4,6-pyruvylated galactose residue biosynthetic process by transcription from RNA polymerase II promoter",
  "GO:0100035": "negative regulation of transmembrane transport by transcription from RNA polymerase II promoter",
  "GO:0100036": "positive regulation of purine nucleotide biosynthetic process by transcription from RNA polymerase II promoter",
  "GO:0100037": "positive regulation of cellular alcohol catabolic process by transcription from RNA polymerase II promoter",
  "GO:0100038": "regulation of cellular response to oxidative stress by transcription from RNA polymerase II promoter",
  "GO:0100039": "regulation of pyrimidine nucleotide biosynthetic process by transcription from RNA polymerase II promoter",
  "GO:0100040": "negative regulation of invasive growth in response to glucose limitation by transcription from RNA polymerase II promoter",
  "GO:0100041": "positive regulation of pseudohyphal growth by transcription from RNA polymerase II promoter",
  "GO:0100042": "negative regulation of pseudohyphal growth by transcription from RNA polymerase II promoter",
  "GO:0100043": "negative regulation of cellular response to alkaline pH by transcription from RNA polymerase II promoter",
  "GO:0100044": "negative regulation of cellular hyperosmotic salinity response by transcription from RNA polymerase II promoter",
  "GO:0100045": "negative regulation of arginine catabolic process by transcription from RNA polymerase II promoter",
  "GO:0100046": "positive regulation of arginine biosynthetic process by transcription from RNA polymerase II promoter",
  "GO:0100047": "negative regulation of inositol biosynthetic process by transcription from RNA polymerase II promoter",
  "GO:0100048": "positive regulation of phosphatidylcholine biosynthetic process by transcription from RNA polymerase II promoter",
  "GO:0100049": "negative regulation of phosphatidylcholine biosynthetic process by transcription from RNA polymerase II promoter",
  "GO:0100050": "negative regulation of mating type switching by transcription from RNA polymerase II promoter",
  "GO:0100051": "positive regulation of meiotic nuclear division by transcription from RNA polymerase II promoter",
  "GO:0100052": "negative regulation of G1/S transition of mitotic cell cycle by transcription from RNA polymerase II promoter",
  "GO:0100053": "positive regulation of sulfate assimilation by transcription from RNA polymerase II promoter",
  "GO:0100054": "positive regulation of flocculation via cell wall protein-carbohydrate interaction by transcription from RNA polymerase II promoter",
  "GO:0100055": "positive regulation of phosphatidylserine biosynthetic process by transcription from RNA polymerase II promoter",
  "GO:0100056": "negative regulation of phosphatidylserine biosynthetic process by transcription from RNA polymerase II promoter",
  "GO:0100057": "regulation of phenotypic switching by transcription from RNA polymerase II promoter",
  "GO:0100058": "positive regulation of phenotypic switching by transcription from RNA polymerase II promoter",
  "GO:0100059": "negative regulation of phenotypic switching by transcription from RNA polymerase II promoter",
  "GO:0100060": "negative regulation of SREBP signaling pathway by DNA binding",
  "GO:0100061": "negative regulation of SREBP signaling pathway by transcription factor catabolic process",
  "GO:0100062": "positive regulation of SREBP signaling pathway by transcription factor catabolic process",
  "GO:0100063": "regulation of dipeptide transmembrane transport by transcription from RNA polymerase II promoter",
  "GO:0100064": "negative regulation of filamentous growth of a population of unicellular organisms in response to starvation by transcription from RNA polymerase II promoter",
  "GO:0100065": "negative regulation of leucine import by transcription from RNA polymerase II promoter",
  "GO:0100066": "negative regulation of induction of conjugation with cellular fusion by transcription from RNA polymerase II promoter",
  "GO:0100067": "positive regulation of spinal cord association neuron differentiation by canonical Wnt signaling pathway",
  "GO:0100068": "positive regulation of pyrimidine-containing compound salvage by transcription from RNA polymerase II promoter",
  "GO:0100069": "negative regulation of neuron apoptotic process by transcription from RNA polymerase II promoter",
  "GO:0100070": "regulation of fatty acid biosynthetic process by transcription from RNA polymerase II promoter",
  "GO:0101002": "ficolin-1-rich granule",
  "GO:0101003": "ficolin-1-rich granule membrane",
  "GO:0101004": "cytolytic granule membrane",
  "GO:0101005": "ubiquitinyl hydrolase activity",
  "GO:0101006": "protein histidine phosphatase activity",
  "GO:0101007": "negative regulation of transcription from RNA polymerase II promoter in response to salt stress",
  "GO:0101008": "negative regulation of transcription from RNA polymerase II promoter in response to increased salt",
  "GO:0101010": "pulmonary blood vessel remodeling",
  "GO:0101011": "inositol 1-diphosphate 2,3,4,5,6-pentakisphosphate 1-diphosphatase activity",
  "GO:0101012": "inositol 1,5-bisdiphosphate 2,3,4,6-tetrakisphosphate 1-diphosphatase activity",
  "GO:0101013": "mechanically-modulated voltage-gated sodium channel activity",
  "GO:0101014": "[isocitrate dehydrogenase (NADP+)] phosphatase activity",
  "GO:0102001": "isoleucine N-monooxygenase (oxime forming) activity",
  "GO:0102002": "valine N-monooxygenase (oxime forming) activity",
  "GO:0102003": "Delta8-sphingolipid desaturase activity",
  "GO:0102004": "2-octaprenyl-6-hydroxyphenol methylase activity",
  "GO:0102005": "2-octaprenyl-6-methoxy-1,4-benzoquinone methylase activity",
  "GO:0102006": "4-methyl-2-oxopentanoate dehydrogenase activity",
  "GO:0102007": "acyl-L-homoserine-lactone lactonohydrolase activity",
  "GO:0102008": "cytosolic dipeptidase activity",
  "GO:0102009": "proline dipeptidase activity",
  "GO:0102013": "L-glutamate-importing ATPase activity",
  "GO:0102014": "beta-D-galactose-importing ATPase activity",
  "GO:0102017": "alkylphosphonate transmembrane-transporting ATPase activity",
  "GO:0102022": "L-arginine-importing ATPase activity",
  "GO:0102027": "S-adenosylmethionine:2-demethylquinol-8 methyltransferase activity",
  "GO:0102030": "dTDP-L-rhamnose synthetase activity",
  "GO:0102031": "4-acetamido-4,6-dideoxy-D-galactose transferase activity",
  "GO:0102033": "cytochrome P450 fatty acid omega-hydroxylase activity",
  "GO:0102035": "isobutyryl-CoA:FAD oxidoreductase activity",
  "GO:0102036": "methyltetrahydrofolate:corrinoid/iron-sulfur protein methyltransferase activity",
  "GO:0102037": "4-nitrotoluene monooxygenase activity",
  "GO:0103042": "4-hydroxy-L-threonine aldolase activity",
  "GO:0103059": "UDP-L-rhamnose:kaempferol 3-O-rhamnosyltransferase activity",
  "GO:0103060": "kaempferol 3-rhamnoside 7-O-rhamnosyltransferase activity",
  "GO:0103061": "trans-methoxy-C60-meroacyl-AMP ligase activity",
  "GO:0103062": "cis-keto-C60-meroacyl-AMP ligase activity",
  "GO:0103063": "trans-keto-C61-meroacyl-AMP ligase activity",
  "GO:0103073": "anandamide amidohydrolase activity",
  "GO:0103075": "indole-3-pyruvate monooxygenase activity",
  "GO:0103077": "quercetin 3-glucoside 7-O-rhamnosyltransferase activity",
  "GO:0103078": "quercetin 3-rhamnoside 7-O-rhamnosyltransferase activity",
  "GO:0103079": "2-(3'-methylthio)propylmalate synthase activity",
  "GO:0103082": "2-(4'-methylthio)butylmalate synthase activity",
  "GO:0103085": "2-(5'-methylthio)pentylmalate synthase activity",
  "GO:0103088": "2-(6'-methylthio)hexylmalate synthase activity",
  "GO:0103091": "2-(7'-methylthio)heptylmalate synthase activity",
  "GO:0103092": "methylthioalkylmalate isomerase activity",
  "GO:0103093": "methylthioalkylmalate dehydrogenase activity",
  "GO:0103095": "wax ester synthase activity",
  "GO:0103096": "CYP79F1 dihomomethionine monooxygenase activity",
  "GO:0103097": "CYP79F1 trihomomethionine monooxygenase activity",
  "GO:0103098": "CYP79F1 tetrahomomethionine monooxygenase activity",
  "GO:0103099": "UDP-glucose:5-methylthiopentylhydroximate S-glucosyltransferase activity",
  "GO:0103100": "UDP-glucose: 6-methylthiohexylhydroximate S-glucosyltransferase activity",
  "GO:0103101": "UDP-glucose:7-methylthioheptylhydroximate S-glucosyltransferase activity",
  "GO:0103102": "UDP-glucose:8-methylthiooctylhydroximate S-glucosyltransferase activity",
  "GO:0103103": "UDP-glucose: 9-methylthiononylhydroximate S-glucosyltransferase activity",
  "GO:0103104": "6-methylthiohexyldesulfoglucosinolate sulfotransferase activity",
  "GO:0103105": "2-oxo-6-methylthiohexanoate aminotransferase activity",
  "GO:0103106": "brassinolide 23-O-glucosyltransferase activity",
  "GO:0103107": "castasterone 23-O-glucosyltransferase activity",
  "GO:0103111": "D-glucosamine PTS permease activity",
  "GO:0103113": "glucosyl-oleandomycin-exporting ATPase activity",
  "GO:0103115": "protoheme IX ABC transporter activity",
  "GO:0103116": "alpha-D-galactofuranose transporter activity",
  "GO:0103117": "UDP-3-O-acyl-N-acetylglucosamine deacetylase activity",
  "GO:0103118": "UDP-3-O-(R-3-hydroxymyristoyl)-glucosamine N-acyltransferase activity",
  "GO:1900000": "regulation of anthocyanin catabolic process",
  "GO:1900001": "negative regulation of anthocyanin catabolic process",
  "GO:1900002": "positive regulation of anthocyanin catabolic process",
  "GO:1900003": "regulation of serine-type endopeptidase activity",
  "GO:1900004": "negative regulation of serine-type endopeptidase activity",
  "GO:1900005": "positive regulation of serine-type endopeptidase activity",
  "GO:1900006": "positive regulation of dendrite development",
  "GO:1900007": "regulation of extrachromosomal rDNA circle accumulation involved in replicative cell aging",
  "GO:1900008": "negative regulation of extrachromosomal rDNA circle accumulation involved in replicative cell aging",
  "GO:1900009": "positive regulation of extrachromosomal rDNA circle accumulation involved in replicative cell aging",
  "GO:1900010": "regulation of corticotropin-releasing hormone receptor activity",
  "GO:1900011": "negative regulation of corticotropin-releasing hormone receptor activity",
  "GO:1900012": "positive regulation of corticotropin-releasing hormone receptor activity",
  "GO:1900013": "obsolete cellular response to potassium ion involved in chemotaxis to cAMP",
  "GO:1900014": "obsolete cellular response to calcium ion involved in chemotaxis to cAMP",
  "GO:1900015": "regulation of cytokine production involved in inflammatory response",
  "GO:1900016": "negative regulation of cytokine production involved in inflammatory response",
  "GO:1900017": "positive regulation of cytokine production involved in inflammatory response",
  "GO:1900018": "phosphorylation of RNA polymerase II C-terminal domain serine 5 residues involved in recruitment of mRNA capping enzyme to RNA polymerase II holoenzyme complex",
  "GO:1900019": "regulation of protein kinase C activity",
  "GO:1900020": "positive regulation of protein kinase C activity",
  "GO:1900022": "regulation of D-erythro-sphingosine kinase activity",
  "GO:1900023": "positive regulation of D-erythro-sphingosine kinase activity",
  "GO:1900024": "regulation of substrate adhesion-dependent cell spreading",
  "GO:1900025": "negative regulation of substrate adhesion-dependent cell spreading",
  "GO:1900026": "positive regulation of substrate adhesion-dependent cell spreading",
  "GO:1900027": "regulation of ruffle assembly",
  "GO:1900028": "negative regulation of ruffle assembly",
  "GO:1900029": "positive regulation of ruffle assembly",
  "GO:1900030": "regulation of pectin biosynthetic process",
  "GO:1900031": "obsolete regulation of transcription from RNA polymerase II promoter involved in calcium-mediated signaling",
  "GO:1900032": "regulation of trichome patterning",
  "GO:1900033": "negative regulation of trichome patterning",
  "GO:1900034": "regulation of cellular response to heat",
  "GO:1900035": "negative regulation of cellular response to heat",
  "GO:1900036": "positive regulation of cellular response to heat",
  "GO:1900037": "regulation of cellular response to hypoxia",
  "GO:1900038": "negative regulation of cellular response to hypoxia",
  "GO:1900039": "positive regulation of cellular response to hypoxia",
  "GO:1900040": "regulation of interleukin-2 secretion",
  "GO:1900041": "negative regulation of interleukin-2 secretion",
  "GO:1900042": "positive regulation of interleukin-2 secretion",
  "GO:1900043": "obsolete leptin-mediated signaling pathway involved in negative regulation of appetite",
  "GO:1900044": "regulation of protein K63-linked ubiquitination",
  "GO:1900045": "negative regulation of protein K63-linked ubiquitination",
  "GO:1900046": "regulation of hemostasis",
  "GO:1900047": "negative regulation of hemostasis",
  "GO:1900048": "positive regulation of hemostasis",
  "GO:1900049": "regulation of histone exchange",
  "GO:1900050": "negative regulation of histone exchange",
  "GO:1900051": "positive regulation of histone exchange",
  "GO:1900052": "regulation of retinoic acid biosynthetic process",
  "GO:1900053": "negative regulation of retinoic acid biosynthetic process",
  "GO:1900054": "positive regulation of retinoic acid biosynthetic process",
  "GO:1900055": "regulation of leaf senescence",
  "GO:1900056": "negative regulation of leaf senescence",
  "GO:1900057": "positive regulation of leaf senescence",
  "GO:1900058": "regulation of sulfate assimilation",
  "GO:1900059": "positive regulation of sulfate assimilation",
  "GO:1900060": "negative regulation of ceramide biosynthetic process",
  "GO:1900061": "obsolete positive regulation of transcription from RNA polymerase II promoter involved in calcium-mediated signaling",
  "GO:1900062": "regulation of replicative cell aging",
  "GO:1900063": "regulation of peroxisome organization",
  "GO:1900064": "positive regulation of peroxisome organization",
  "GO:1900065": "regulation of ethanol catabolic process",
  "GO:1900066": "positive regulation of ethanol catabolic process",
  "GO:1900067": "regulation of cellular response to alkaline pH",
  "GO:1900068": "negative regulation of cellular response to alkaline pH",
  "GO:1900069": "regulation of cellular hyperosmotic salinity response",
  "GO:1900070": "negative regulation of cellular hyperosmotic salinity response",
  "GO:1900071": "regulation of sulfite transport",
  "GO:1900072": "positive regulation of sulfite transport",
  "GO:1900073": "regulation of neuromuscular synaptic transmission",
  "GO:1900074": "negative regulation of neuromuscular synaptic transmission",
  "GO:1900075": "positive regulation of neuromuscular synaptic transmission",
  "GO:1900076": "regulation of cellular response to insulin stimulus",
  "GO:1900077": "negative regulation of cellular response to insulin stimulus",
  "GO:1900078": "positive regulation of cellular response to insulin stimulus",
  "GO:1900079": "regulation of arginine biosynthetic process",
  "GO:1900080": "positive regulation of arginine biosynthetic process",
  "GO:1900081": "regulation of arginine catabolic process",
  "GO:1900082": "negative regulation of arginine catabolic process",
  "GO:1900083": "obsolete regulation of Sertoli cell proliferation",
  "GO:1900084": "regulation of peptidyl-tyrosine autophosphorylation",
  "GO:1900085": "negative regulation of peptidyl-tyrosine autophosphorylation",
  "GO:1900086": "positive regulation of peptidyl-tyrosine autophosphorylation",
  "GO:1900087": "positive regulation of G1/S transition of mitotic cell cycle",
  "GO:1900088": "regulation of inositol biosynthetic process",
  "GO:1900089": "negative regulation of inositol biosynthetic process",
  "GO:1900090": "positive regulation of inositol biosynthetic process",
  "GO:1900091": "regulation of raffinose biosynthetic process",
  "GO:1900092": "negative regulation of raffinose biosynthetic process",
  "GO:1900093": "positive regulation of raffinose biosynthetic process",
  "GO:1900094": "regulation of transcription from RNA polymerase II promoter involved in determination of left/right symmetry",
  "GO:1900095": "regulation of dosage compensation by inactivation of X chromosome",
  "GO:1900096": "negative regulation of dosage compensation by inactivation of X chromosome",
  "GO:1900097": "positive regulation of dosage compensation by inactivation of X chromosome",
  "GO:1900098": "regulation of plasma cell differentiation",
  "GO:1900099": "negative regulation of plasma cell differentiation",
  "GO:1900100": "positive regulation of plasma cell differentiation",
  "GO:1900101": "regulation of endoplasmic reticulum unfolded protein response",
  "GO:1900102": "negative regulation of endoplasmic reticulum unfolded protein response",
  "GO:1900103": "positive regulation of endoplasmic reticulum unfolded protein response",
  "GO:1900104": "regulation of hyaluranon cable assembly",
  "GO:1900105": "negative regulation of hyaluranon cable assembly",
  "GO:1900106": "positive regulation of hyaluranon cable assembly",
  "GO:1900107": "regulation of nodal signaling pathway",
  "GO:1900108": "negative regulation of nodal signaling pathway",
  "GO:1900109": "regulation of histone H3-K9 dimethylation",
  "GO:1900110": "negative regulation of histone H3-K9 dimethylation",
  "GO:1900111": "positive regulation of histone H3-K9 dimethylation",
  "GO:1900112": "regulation of histone H3-K9 trimethylation",
  "GO:1900113": "negative regulation of histone H3-K9 trimethylation",
  "GO:1900114": "positive regulation of histone H3-K9 trimethylation",
  "GO:1900115": "extracellular regulation of signal transduction",
  "GO:1900116": "extracellular negative regulation of signal transduction",
  "GO:1900117": "regulation of execution phase of apoptosis",
  "GO:1900118": "negative regulation of execution phase of apoptosis",
  "GO:1900119": "positive regulation of execution phase of apoptosis",
  "GO:1900120": "regulation of receptor binding",
  "GO:1900121": "negative regulation of receptor binding",
  "GO:1900122": "positive regulation of receptor binding",
  "GO:1900123": "regulation of nodal receptor complex assembly",
  "GO:1900124": "negative regulation of nodal receptor complex assembly",
  "GO:1900125": "regulation of hyaluronan biosynthetic process",
  "GO:1900126": "negative regulation of hyaluronan biosynthetic process",
  "GO:1900127": "positive regulation of hyaluronan biosynthetic process",
  "GO:1900128": "regulation of G-protein activated inward rectifier potassium channel activity",
  "GO:1900129": "positive regulation of G-protein activated inward rectifier potassium channel activity",
  "GO:1900130": "regulation of lipid binding",
  "GO:1900131": "negative regulation of lipid binding",
  "GO:1900132": "positive regulation of lipid binding",
  "GO:1900133": "regulation of renin secretion into blood stream",
  "GO:1900134": "negative regulation of renin secretion into blood stream",
  "GO:1900135": "positive regulation of renin secretion into blood stream",
  "GO:1900136": "regulation of chemokine activity",
  "GO:1900137": "negative regulation of chemokine activity",
  "GO:1900138": "negative regulation of phospholipase A2 activity",
  "GO:1900139": "negative regulation of arachidonic acid secretion",
  "GO:1900140": "regulation of seedling development",
  "GO:1900141": "regulation of oligodendrocyte apoptotic process",
  "GO:1900142": "negative regulation of oligodendrocyte apoptotic process",
  "GO:1900143": "positive regulation of oligodendrocyte apoptotic process",
  "GO:1900144": "positive regulation of BMP secretion",
  "GO:1900145": "regulation of nodal signaling pathway involved in determination of left/right asymmetry",
  "GO:1900146": "negative regulation of nodal signaling pathway involved in determination of left/right asymmetry",
  "GO:1900147": "regulation of Schwann cell migration",
  "GO:1900148": "negative regulation of Schwann cell migration",
  "GO:1900149": "positive regulation of Schwann cell migration",
  "GO:1900150": "regulation of defense response to fungus",
  "GO:1900151": "regulation of nuclear-transcribed mRNA catabolic process, deadenylation-dependent decay",
  "GO:1900152": "negative regulation of nuclear-transcribed mRNA catabolic process, deadenylation-dependent decay",
  "GO:1900153": "positive regulation of nuclear-transcribed mRNA catabolic process, deadenylation-dependent decay",
  "GO:1900154": "regulation of bone trabecula formation",
  "GO:1900155": "negative regulation of bone trabecula formation",
  "GO:1900156": "positive regulation of bone trabecula formation",
  "GO:1900157": "regulation of bone mineralization involved in bone maturation",
  "GO:1900158": "negative regulation of bone mineralization involved in bone maturation",
  "GO:1900159": "positive regulation of bone mineralization involved in bone maturation",
  "GO:1900160": "plastid DNA packaging",
  "GO:1900161": "regulation of phospholipid scramblase activity",
  "GO:1900162": "negative regulation of phospholipid scramblase activity",
  "GO:1900163": "positive regulation of phospholipid scramblase activity",
  "GO:1900164": "nodal signaling pathway involved in determination of lateral mesoderm left/right asymmetry",
  "GO:1900165": "negative regulation of interleukin-6 secretion",
  "GO:1900166": "regulation of glial cell-derived neurotrophic factor secretion",
  "GO:1900167": "negative regulation of glial cell-derived neurotrophic factor secretion",
  "GO:1900168": "positive regulation of glial cell-derived neurotrophic factor secretion",
  "GO:1900169": "regulation of glucocorticoid mediated signaling pathway",
  "GO:1900170": "negative regulation of glucocorticoid mediated signaling pathway",
  "GO:1900171": "positive regulation of glucocorticoid mediated signaling pathway",
  "GO:1900175": "regulation of nodal signaling pathway involved in determination of lateral mesoderm left/right asymmetry",
  "GO:1900176": "negative regulation of nodal signaling pathway involved in determination of lateral mesoderm left/right asymmetry",
  "GO:1900177": "regulation of aflatoxin biosynthetic process",
  "GO:1900178": "negative regulation of aflatoxin biosynthetic process",
  "GO:1900179": "positive regulation of aflatoxin biosynthetic process",
  "GO:1900180": "regulation of protein localization to nucleus",
  "GO:1900181": "negative regulation of protein localization to nucleus",
  "GO:1900182": "positive regulation of protein localization to nucleus",
  "GO:1900183": "regulation of xanthone-containing compound biosynthetic process",
  "GO:1900184": "negative regulation of xanthone-containing compound biosynthetic process",
  "GO:1900185": "positive regulation of xanthone-containing compound biosynthetic process",
  "GO:1900186": "negative regulation of clathrin-mediated endocytosis",
  "GO:1900187": "regulation of cell adhesion involved in single-species biofilm formation",
  "GO:1900188": "negative regulation of cell adhesion involved in single-species biofilm formation",
  "GO:1900189": "positive regulation of cell adhesion involved in single-species biofilm formation",
  "GO:1900190": "regulation of single-species biofilm formation",
  "GO:1900191": "negative regulation of single-species biofilm formation",
  "GO:1900192": "positive regulation of single-species biofilm formation",
  "GO:1900193": "regulation of oocyte maturation",
  "GO:1900194": "negative regulation of oocyte maturation",
  "GO:1900195": "positive regulation of oocyte maturation",
  "GO:1900196": "regulation of penicillin biosynthetic process",
  "GO:1900197": "negative regulation of penicillin biosynthetic process",
  "GO:1900198": "positive regulation of penicillin biosynthetic process",
  "GO:1900199": "positive regulation of protein export from nucleus during meiotic anaphase II",
  "GO:1900200": "mesenchymal cell apoptotic process involved in metanephros development",
  "GO:1900201": "obsolete regulation of spread of virus in host, cell to cell",
  "GO:1900202": "obsolete negative regulation of spread of virus in host, cell to cell",
  "GO:1900203": "obsolete positive regulation of spread of virus in host, cell to cell",
  "GO:1900204": "apoptotic process involved in metanephric collecting duct development",
  "GO:1900205": "apoptotic process involved in metanephric nephron tubule development",
  "GO:1900206": "regulation of pronephric nephron tubule development",
  "GO:1900207": "negative regulation of pronephric nephron tubule development",
  "GO:1900208": "regulation of cardiolipin metabolic process",
  "GO:1900209": "negative regulation of cardiolipin metabolic process",
  "GO:1900210": "positive regulation of cardiolipin metabolic process",
  "GO:1900211": "regulation of mesenchymal cell apoptotic process involved in metanephros development",
  "GO:1900212": "negative regulation of mesenchymal cell apoptotic process involved in metanephros development",
  "GO:1900213": "positive regulation of mesenchymal cell apoptotic process involved in metanephros development",
  "GO:1900214": "regulation of apoptotic process involved in metanephric collecting duct development",
  "GO:1900215": "negative regulation of apoptotic process involved in metanephric collecting duct development",
  "GO:1900216": "positive regulation of apoptotic process involved in metanephric collecting duct development",
  "GO:1900217": "regulation of apoptotic process involved in metanephric nephron tubule development",
  "GO:1900218": "negative regulation of apoptotic process involved in metanephric nephron tubule development",
  "GO:1900219": "positive regulation of apoptotic process involved in metanephric nephron tubule development",
  "GO:1900220": "semaphorin-plexin signaling pathway involved in bone trabecula morphogenesis",
  "GO:1900221": "regulation of beta-amyloid clearance",
  "GO:1900222": "negative regulation of beta-amyloid clearance",
  "GO:1900223": "positive regulation of beta-amyloid clearance",
  "GO:1900224": "positive regulation of nodal signaling pathway involved in determination of lateral mesoderm left/right asymmetry",
  "GO:1900225": "regulation of NLRP3 inflammasome complex assembly",
  "GO:1900226": "negative regulation of NLRP3 inflammasome complex assembly",
  "GO:1900227": "positive regulation of NLRP3 inflammasome complex assembly",
  "GO:1900228": "regulation of single-species biofilm formation in or on host organism",
  "GO:1900229": "negative regulation of single-species biofilm formation in or on host organism",
  "GO:1900230": "positive regulation of single-species biofilm formation in or on host organism",
  "GO:1900231": "regulation of single-species biofilm formation on inanimate substrate",
  "GO:1900232": "negative regulation of single-species biofilm formation on inanimate substrate",
  "GO:1900233": "positive regulation of single-species biofilm formation on inanimate substrate",
  "GO:1900234": "regulation of Kit signaling pathway",
  "GO:1900235": "negative regulation of Kit signaling pathway",
  "GO:1900236": "positive regulation of Kit signaling pathway",
  "GO:1900237": "positive regulation of induction of conjugation with cellular fusion",
  "GO:1900238": "regulation of metanephric mesenchymal cell migration by platelet-derived growth factor receptor-beta signaling pathway",
  "GO:1900239": "regulation of phenotypic switching",
  "GO:1900240": "negative regulation of phenotypic switching",
  "GO:1900241": "positive regulation of phenotypic switching",
  "GO:1900242": "regulation of synaptic vesicle endocytosis",
  "GO:1900243": "negative regulation of synaptic vesicle endocytosis",
  "GO:1900244": "positive regulation of synaptic vesicle endocytosis",
  "GO:1900245": "positive regulation of MDA-5 signaling pathway",
  "GO:1900246": "positive regulation of RIG-I signaling pathway",
  "GO:1900247": "regulation of cytoplasmic translational elongation",
  "GO:1900248": "negative regulation of cytoplasmic translational elongation",
  "GO:1900249": "positive regulation of cytoplasmic translational elongation",
  "GO:1900256": "regulation of beta1-adrenergic receptor activity",
  "GO:1900257": "negative regulation of beta1-adrenergic receptor activity",
  "GO:1900258": "positive regulation of beta1-adrenergic receptor activity",
  "GO:1900259": "regulation of RNA-directed RNA polymerase activity",
  "GO:1900260": "negative regulation of RNA-directed RNA polymerase activity",
  "GO:1900261": "positive regulation of RNA-directed RNA polymerase activity",
  "GO:1900262": "regulation of DNA-directed DNA polymerase activity",
  "GO:1900263": "negative regulation of DNA-directed DNA polymerase activity",
  "GO:1900264": "positive regulation of DNA-directed DNA polymerase activity",
  "GO:1900265": "regulation of substance P receptor binding",
  "GO:1900266": "negative regulation of substance P receptor binding",
  "GO:1900267": "positive regulation of substance P receptor binding",
  "GO:1900268": "regulation of reverse transcription",
  "GO:1900269": "negative regulation of reverse transcription",
  "GO:1900270": "positive regulation of reverse transcription",
  "GO:1900271": "regulation of long-term synaptic potentiation",
  "GO:1900272": "negative regulation of long-term synaptic potentiation",
  "GO:1900273": "positive regulation of long-term synaptic potentiation",
  "GO:1900274": "regulation of phospholipase C activity",
  "GO:1900275": "negative regulation of phospholipase C activity",
  "GO:1900276": "regulation of proteinase activated receptor activity",
  "GO:1900277": "negative regulation of proteinase activated receptor activity",
  "GO:1900278": "positive regulation of proteinase activated receptor activity",
  "GO:1900279": "regulation of CD4-positive, alpha-beta T cell costimulation",
  "GO:1900280": "negative regulation of CD4-positive, alpha-beta T cell costimulation",
  "GO:1900281": "positive regulation of CD4-positive, alpha-beta T cell costimulation",
  "GO:1900282": "regulation of cellobiose catabolic process",
  "GO:1900283": "negative regulation of cellobiose catabolic process",
  "GO:1900284": "positive regulation of cellobiose catabolic process",
  "GO:1900285": "regulation of cellotriose transport",
  "GO:1900286": "negative regulation of cellotriose transport",
  "GO:1900287": "positive regulation of cellotriose transport",
  "GO:1900288": "regulation of coenzyme F420-dependent bicyclic nitroimidazole catabolic process",
  "GO:1900289": "negative regulation of coenzyme F420-dependent bicyclic nitroimidazole catabolic process",
  "GO:1900290": "positive regulation of coenzyme F420-dependent bicyclic nitroimidazole catabolic process",
  "GO:1900291": "regulation of galactotriose transport",
  "GO:1900292": "negative regulation of galactotriose transport",
  "GO:1900293": "positive regulation of galactotriose transport",
  "GO:1900294": "regulation of heptasaccharide transport",
  "GO:1900295": "negative regulation of heptasaccharide transport",
  "GO:1900296": "positive regulation of heptasaccharide transport",
  "GO:1900297": "regulation of hexasaccharide transport",
  "GO:1900298": "negative regulation of hexasaccharide transport",
  "GO:1900299": "positive regulation of hexasaccharide transport",
  "GO:1900300": "regulation of laminarabiose transport",
  "GO:1900301": "negative regulation of laminarabiose transport",
  "GO:1900302": "positive regulation of laminarabiose transport",
  "GO:1900303": "regulation of laminaritriose transport",
  "GO:1900304": "negative regulation of laminaritriose transport",
  "GO:1900305": "positive regulation of laminaritriose transport",
  "GO:1900306": "regulation of maltoheptaose transport",
  "GO:1900307": "negative regulation of maltoheptaose transport",
  "GO:1900308": "positive regulation of maltoheptaose transport",
  "GO:1900309": "regulation of maltoheptaose metabolic process",
  "GO:1900310": "negative regulation of maltoheptaose metabolic process",
  "GO:1900311": "positive regulation of maltoheptaose metabolic process",
  "GO:1900312": "regulation of maltohexaose transport",
  "GO:1900313": "negative regulation of maltohexaose transport",
  "GO:1900314": "positive regulation of maltohexaose transport",
  "GO:1900315": "regulation of maltopentaose transport",
  "GO:1900316": "negative regulation of maltopentaose transport",
  "GO:1900317": "positive regulation of maltopentaose transport",
  "GO:1900318": "regulation of methane biosynthetic process from dimethylamine",
  "GO:1900319": "negative regulation of methane biosynthetic process from dimethylamine",
  "GO:1900320": "positive regulation of methane biosynthetic process from dimethylamine",
  "GO:1900321": "regulation of maltotetraose transport",
  "GO:1900322": "negative regulation of maltotetraose transport",
  "GO:1900323": "positive regulation of maltotetraose transport",
  "GO:1900324": "regulation of maltotriulose transport",
  "GO:1900325": "negative regulation of maltotriulose transport",
  "GO:1900326": "positive regulation of maltotriulose transport",
  "GO:1900327": "regulation of mannotriose transport",
  "GO:1900328": "negative regulation of mannotriose transport",
  "GO:1900329": "positive regulation of mannotriose transport",
  "GO:1900330": "regulation of methane biosynthetic process from trimethylamine",
  "GO:1900331": "negative regulation of methane biosynthetic process from trimethylamine",
  "GO:1900332": "positive regulation of methane biosynthetic process from trimethylamine",
  "GO:1900333": "regulation of methane biosynthetic process from 3-(methylthio)propionic acid",
  "GO:1900334": "negative regulation of methane biosynthetic process from 3-(methylthio)propionic acid",
  "GO:1900335": "positive regulation of methane biosynthetic process from 3-(methylthio)propionic acid",
  "GO:1900336": "regulation of methane biosynthetic process from carbon monoxide",
  "GO:1900337": "negative regulation of methane biosynthetic process from carbon monoxide",
  "GO:1900338": "positive regulation of methane biosynthetic process from carbon monoxide",
  "GO:1900339": "regulation of methane biosynthetic process from formic acid",
  "GO:1900340": "negative regulation of methane biosynthetic process from formic acid",
  "GO:1900341": "positive regulation of methane biosynthetic process from formic acid",
  "GO:1900342": "regulation of methane biosynthetic process from dimethyl sulfide",
  "GO:1900343": "negative regulation of methane biosynthetic process from dimethyl sulfide",
  "GO:1900344": "positive regulation of methane biosynthetic process from dimethyl sulfide",
  "GO:1900345": "regulation of methane biosynthetic process from methanethiol",
  "GO:1900346": "negative regulation of methane biosynthetic process from methanethiol",
  "GO:1900347": "positive regulation of methane biosynthetic process from methanethiol",
  "GO:1900348": "regulation of methane biosynthetic process from methylamine",
  "GO:1900349": "negative regulation of methane biosynthetic process from methylamine",
  "GO:1900350": "positive regulation of methane biosynthetic process from methylamine",
  "GO:1900351": "regulation of methanofuran biosynthetic process",
  "GO:1900352": "negative regulation of methanofuran biosynthetic process",
  "GO:1900353": "positive regulation of methanofuran biosynthetic process",
  "GO:1900354": "regulation of methanofuran metabolic process",
  "GO:1900355": "negative regulation of methanofuran metabolic process",
  "GO:1900356": "positive regulation of methanofuran metabolic process",
  "GO:1900357": "regulation of nigerotriose transport",
  "GO:1900358": "negative regulation of nigerotriose transport",
  "GO:1900359": "positive regulation of nigerotriose transport",
  "GO:1900360": "regulation of pentasaccharide transport",
  "GO:1900361": "negative regulation of pentasaccharide transport",
  "GO:1900362": "positive regulation of pentasaccharide transport",
  "GO:1900363": "regulation of mRNA polyadenylation",
  "GO:1900364": "negative regulation of mRNA polyadenylation",
  "GO:1900365": "positive regulation of mRNA polyadenylation",
  "GO:1900366": "negative regulation of defense response to insect",
  "GO:1900367": "positive regulation of defense response to insect",
  "GO:1900368": "regulation of RNA interference",
  "GO:1900369": "negative regulation of RNA interference",
  "GO:1900370": "positive regulation of RNA interference",
  "GO:1900371": "regulation of purine nucleotide biosynthetic process",
  "GO:1900372": "negative regulation of purine nucleotide biosynthetic process",
  "GO:1900373": "positive regulation of purine nucleotide biosynthetic process",
  "GO:1900374": "positive regulation of mating type switching by regulation of transcription from RNA polymerase II promoter",
  "GO:1900375": "positive regulation of inositol biosynthetic process by positive regulation of transcription from RNA polymerase II promoter",
  "GO:1900376": "regulation of secondary metabolite biosynthetic process",
  "GO:1900377": "negative regulation of secondary metabolite biosynthetic process",
  "GO:1900378": "positive regulation of secondary metabolite biosynthetic process",
  "GO:1900379": "regulation of asperthecin biosynthetic process",
  "GO:1900380": "negative regulation of asperthecin biosynthetic process",
  "GO:1900381": "positive regulation of asperthecin biosynthetic process",
  "GO:1900382": "regulation of thiamine biosynthetic process by regulation of transcription from RNA polymerase II promoter",
  "GO:1900383": "regulation of synaptic plasticity by receptor localization to synapse",
  "GO:1900384": "regulation of flavonol biosynthetic process",
  "GO:1900385": "negative regulation of flavonol biosynthetic process",
  "GO:1900386": "positive regulation of flavonol biosynthetic process",
  "GO:1900387": "negative regulation of cell-cell adhesion by negative regulation of transcription from RNA polymerase II promoter",
  "GO:1900388": "obsolete regulation of vesicle-mediated transport by regulation of transcription from RNA polymerase II promoter",
  "GO:1900389": "regulation of glucose import by regulation of transcription from RNA polymerase II promoter",
  "GO:1900390": "regulation of iron ion import",
  "GO:1900391": "regulation of cAMP-mediated signaling by regulation of transcription from RNA polymerase II promoter",
  "GO:1900392": "regulation of transport by negative regulation of transcription from RNA polymerase II promoter",
  "GO:1900393": "regulation of iron ion transport by regulation of transcription from RNA polymerase II promoter",
  "GO:1900394": "regulation of kojic acid biosynthetic process",
  "GO:1900395": "negative regulation of kojic acid biosynthetic process",
  "GO:1900396": "positive regulation of kojic acid biosynthetic process",
  "GO:1900397": "regulation of pyrimidine nucleotide biosynthetic process",
  "GO:1900398": "negative regulation of pyrimidine nucleotide biosynthetic process",
  "GO:1900399": "positive regulation of pyrimidine nucleotide biosynthetic process",
  "GO:1900400": "regulation of iron ion import by regulation of transcription from RNA polymerase II promoter",
  "GO:1900401": "regulation of meiosis by regulation of transcription from RNA polymerase II promoter",
  "GO:1900402": "regulation of carbohydrate metabolic process by regulation of transcription from RNA polymerase II promoter",
  "GO:1900403": "negative regulation of cellular amino acid biosynthetic process by negative regulation of transcription from RNA polymerase II promoter",
  "GO:1900404": "positive regulation of DNA repair by positive regulation of transcription from RNA polymerase II promoter",
  "GO:1900405": "regulation of cell separation after cytokinesis by regulation of transcription from RNA polymerase II promoter",
  "GO:1900406": "regulation of conjugation with cellular fusion by regulation of transcription from RNA polymerase II promoter",
  "GO:1900407": "regulation of cellular response to oxidative stress",
  "GO:1900408": "negative regulation of cellular response to oxidative stress",
  "GO:1900409": "positive regulation of cellular response to oxidative stress",
  "GO:1900410": "regulation of histone modification by regulation of transcription from RNA polymerase II promoter",
  "GO:1900411": "regulation of histone acetylation by regulation of transcription from RNA polymerase II promoter",
  "GO:1900412": "regulation of histone methylation by regulation of transcription from RNA polymerase II promoter",
  "GO:1900413": "positive regulation of phospholipid biosynthetic process by positive regulation of transcription from RNA polymerase II promoter",
  "GO:1900414": "regulation of cytokinesis by regulation of transcription from RNA polymerase II promoter",
  "GO:1900415": "regulation of fungal-type cell wall biogenesis by regulation of transcription from RNA polymerase II promoter",
  "GO:1900416": "regulation of 4,6-pyruvylated galactose residue biosynthetic process by regulation of transcription from RNA polymerase II promoter",
  "GO:1900417": "negative regulation of transmembrane transport by negative regulation of transcription from RNA polymerase II promoter",
  "GO:1900418": "positive regulation of purine nucleotide biosynthetic process by positive regulation of transcription from RNA polymerase II promoter",
  "GO:1900419": "regulation of cellular alcohol catabolic process",
  "GO:1900420": "negative regulation of cellular alcohol catabolic process",
  "GO:1900421": "positive regulation of cellular alcohol catabolic process",
  "GO:1900422": "positive regulation of cellular alcohol catabolic process by positive regulation of transcription from RNA polymerase II promoter",
  "GO:1900423": "positive regulation of mating type switching by positive regulation of transcription from RNA polymerase II promoter",
  "GO:1900424": "regulation of defense response to bacterium",
  "GO:1900425": "negative regulation of defense response to bacterium",
  "GO:1900426": "positive regulation of defense response to bacterium",
  "GO:1900427": "regulation of cellular response to oxidative stress by regulation of transcription from RNA polymerase II promoter",
  "GO:1900428": "regulation of filamentous growth of a population of unicellular organisms",
  "GO:1900429": "negative regulation of filamentous growth of a population of unicellular organisms",
  "GO:1900430": "positive regulation of filamentous growth of a population of unicellular organisms",
  "GO:1900431": "regulation of filamentous growth of a population of unicellular organisms in response to heat",
  "GO:1900432": "negative regulation of filamentous growth of a population of unicellular organisms in response to heat",
  "GO:1900433": "positive regulation of filamentous growth of a population of unicellular organisms in response to heat",
  "GO:1900434": "regulation of filamentous growth of a population of unicellular organisms in response to starvation",
  "GO:1900435": "negative regulation of filamentous growth of a population of unicellular organisms in response to starvation",
  "GO:1900436": "positive regulation of filamentous growth of a population of unicellular organisms in response to starvation",
  "GO:1900437": "regulation of filamentous growth of a population of unicellular organisms in response to chemical stimulus",
  "GO:1900438": "negative regulation of filamentous growth of a population of unicellular organisms in response to chemical stimulus",
  "GO:1900439": "positive regulation of filamentous growth of a population of unicellular organisms in response to chemical stimulus",
  "GO:1900440": "regulation of filamentous growth of a population of unicellular organisms in response to neutral pH",
  "GO:1900441": "negative regulation of filamentous growth of a population of unicellular organisms in response to neutral pH",
  "GO:1900442": "positive regulation of filamentous growth of a population of unicellular organisms in response to neutral pH",
  "GO:1900443": "regulation of filamentous growth of a population of unicellular organisms in response to biotic stimulus",
  "GO:1900444": "negative regulation of filamentous growth of a population of unicellular organisms in response to biotic stimulus",
  "GO:1900445": "positive regulation of filamentous growth of a population of unicellular organisms in response to biotic stimulus",
  "GO:1900446": "negative regulation of tRNA transcription from RNA polymerase III promoter",
  "GO:1900447": "regulation of cell morphogenesis involved in phenotypic switching",
  "GO:1900448": "regulation of pyrimidine nucleotide biosynthetic process by positive regulation of transcription from RNA polymerase II promoter",
  "GO:1900449": "regulation of glutamate receptor signaling pathway",
  "GO:1900450": "negative regulation of glutamate receptor signaling pathway",
  "GO:1900451": "positive regulation of glutamate receptor signaling pathway",
  "GO:1900452": "regulation of long term synaptic depression",
  "GO:1900453": "negative regulation of long term synaptic depression",
  "GO:1900454": "positive regulation of long term synaptic depression",
  "GO:1900455": "regulation of flocculation via cell wall protein-carbohydrate interaction",
  "GO:1900456": "obsolete regulation of invasive growth in response to glucose limitation by regulation of transcription from RNA polymerase II promoter",
  "GO:1900457": "regulation of brassinosteroid mediated signaling pathway",
  "GO:1900458": "negative regulation of brassinosteroid mediated signaling pathway",
  "GO:1900459": "positive regulation of brassinosteroid mediated signaling pathway",
  "GO:1900460": "negative regulation of invasive growth in response to glucose limitation by negative regulation of transcription from RNA polymerase II promoter",
  "GO:1900461": "positive regulation of pseudohyphal growth by positive regulation of transcription from RNA polymerase II promoter",
  "GO:1900462": "negative regulation of pseudohyphal growth by negative regulation of transcription from RNA polymerase II promoter",
  "GO:1900463": "negative regulation of cellular response to alkaline pH by negative regulation of transcription from RNA polymerase II promoter",
  "GO:1900464": "negative regulation of cellular hyperosmotic salinity response by negative regulation of transcription from RNA polymerase II promoter",
  "GO:1900465": "negative regulation of arginine catabolic process by negative regulation of transcription from RNA polymerase II promoter",
  "GO:1900466": "positive regulation of arginine biosynthetic process by positive regulation of transcription from RNA polymerase II promoter",
  "GO:1900467": "obsolete regulation of cellular potassium ion homeostasis",
  "GO:1900468": "regulation of phosphatidylserine biosynthetic process",
  "GO:1900469": "negative regulation of phosphatidylserine biosynthetic process",
  "GO:1900470": "positive regulation of phosphatidylserine biosynthetic process",
  "GO:1900471": "negative regulation of inositol biosynthetic process by negative regulation of transcription from RNA polymerase II promoter",
  "GO:1900472": "positive regulation of phosphatidylcholine biosynthetic process by positive regulation of transcription from RNA polymerase II promoter",
  "GO:1900473": "negative regulation of phosphatidylcholine biosynthetic process by negative regulation of transcription from RNA polymerase II promoter",
  "GO:1900474": "negative regulation of mating type switching by negative regulation of transcription from RNA polymerase II promoter",
  "GO:1900475": "positive regulation of meiosis by negative regulation of transcription from RNA polymerase II promoter",
  "GO:1900476": "positive regulation of meiosis by positive regulation of transcription from RNA polymerase II promoter",
  "GO:1900477": "negative regulation of G1/S transition of mitotic cell cycle by negative regulation of transcription from RNA polymerase II promoter",
  "GO:1900478": "positive regulation of sulfate assimilation by positive regulation of transcription from RNA polymerase II promoter",
  "GO:1900479": "positive regulation of flocculation via cell wall protein-carbohydrate interaction",
  "GO:1900480": "regulation of diacylglycerol biosynthetic process",
  "GO:1900481": "negative regulation of diacylglycerol biosynthetic process",
  "GO:1900482": "positive regulation of diacylglycerol biosynthetic process",
  "GO:1900483": "regulation of protein targeting to vacuolar membrane",
  "GO:1900484": "negative regulation of protein targeting to vacuolar membrane",
  "GO:1900485": "positive regulation of protein targeting to vacuolar membrane",
  "GO:1900486": "positive regulation of isopentenyl diphosphate biosynthetic process, mevalonate pathway",
  "GO:1900487": "regulation of [2Fe-2S] cluster assembly",
  "GO:1900488": "negative regulation of [2Fe-2S] cluster assembly",
  "GO:1900489": "positive regulation of [2Fe-2S] cluster assembly",
  "GO:1900490": "positive regulation of hydroxymethylglutaryl-CoA reductase (NADPH) activity",
  "GO:1900491": "regulation of [4Fe-4S] cluster assembly",
  "GO:1900492": "negative regulation of [4Fe-4S] cluster assembly",
  "GO:1900493": "positive regulation of [4Fe-4S] cluster assembly",
  "GO:1900494": "regulation of butyryl-CoA biosynthetic process from acetyl-CoA",
  "GO:1900495": "negative regulation of butyryl-CoA biosynthetic process from acetyl-CoA",
  "GO:1900496": "positive regulation of butyryl-CoA biosynthetic process from acetyl-CoA",
  "GO:1900497": "regulation of butyryl-CoA catabolic process to butanol",
  "GO:1900498": "negative regulation of butyryl-CoA catabolic process to butanol",
  "GO:1900499": "positive regulation of butyryl-CoA catabolic process to butanol",
  "GO:1900500": "regulation of butyryl-CoA catabolic process to butyrate",
  "GO:1900501": "negative regulation of butyryl-CoA catabolic process to butyrate",
  "GO:1900502": "positive regulation of butyryl-CoA catabolic process to butyrate",
  "GO:1900503": "regulation of cellulosome assembly",
  "GO:1900504": "negative regulation of cellulosome assembly",
  "GO:1900505": "positive regulation of cellulosome assembly",
  "GO:1900506": "regulation of iron-sulfur-molybdenum cofactor assembly",
  "GO:1900507": "negative regulation of iron-sulfur-molybdenum cofactor assembly",
  "GO:1900508": "positive regulation of iron-sulfur-molybdenum cofactor assembly",
  "GO:1900509": "regulation of pentose catabolic process to ethanol",
  "GO:1900510": "negative regulation of pentose catabolic process to ethanol",
  "GO:1900511": "positive regulation of pentose catabolic process to ethanol",
  "GO:1900512": "regulation of starch utilization system complex assembly",
  "GO:1900513": "negative regulation of starch utilization system complex assembly",
  "GO:1900514": "positive regulation of starch utilization system complex assembly",
  "GO:1900515": "regulation of xylose catabolic process to ethanol",
  "GO:1900516": "negative regulation of xylose catabolic process to ethanol",
  "GO:1900517": "positive regulation of xylose catabolic process to ethanol",
  "GO:1900518": "regulation of response to pullulan",
  "GO:1900519": "negative regulation of response to pullulan",
  "GO:1900520": "positive regulation of response to pullulan",
  "GO:1900521": "regulation of response to amylopectin",
  "GO:1900522": "negative regulation of response to amylopectin",
  "GO:1900523": "positive regulation of response to amylopectin",
  "GO:1900524": "positive regulation of flocculation via cell wall protein-carbohydrate interaction by positive regulation of transcription from RNA polymerase II promoter",
  "GO:1900525": "positive regulation of phosphatidylserine biosynthetic process by positive regulation of transcription from RNA polymerase II promoter",
  "GO:1900526": "negative regulation of phosphatidylserine biosynthetic process by negative regulation of transcription from RNA polymerase II promoter",
  "GO:1900527": "obsolete regulation of nucleus size involved in G1 to G0 transition",
  "GO:1900528": "obsolete regulation of cell shape involved in G1 to G0 transition",
  "GO:1900529": "obsolete regulation of cell shape involved in cellular response to glucose starvation",
  "GO:1900530": "obsolete regulation of cell shape involved in cellular response to salt stress",
  "GO:1900531": "obsolete regulation of cell shape involved in cellular response to heat",
  "GO:1900532": "obsolete negative regulation of cell proliferation involved in cellular hyperosmotic response",
  "GO:1900533": "palmitic acid metabolic process",
  "GO:1900534": "palmitic acid catabolic process",
  "GO:1900535": "palmitic acid biosynthetic process",
  "GO:1900536": "obsolete regulation of glucose homeostasis",
  "GO:1900537": "obsolete negative regulation of glucose homeostasis",
  "GO:1900538": "obsolete positive regulation of glucose homeostasis",
  "GO:1900539": "fumonisin metabolic process",
  "GO:1900540": "fumonisin catabolic process",
  "GO:1900541": "fumonisin biosynthetic process",
  "GO:1900542": "regulation of purine nucleotide metabolic process",
  "GO:1900543": "negative regulation of purine nucleotide metabolic process",
  "GO:1900544": "positive regulation of purine nucleotide metabolic process",
  "GO:1900545": "regulation of phenotypic switching by regulation of transcription from RNA polymerase II promoter",
  "GO:1900546": "positive regulation of phenotypic switching by regulation of transcription from RNA polymerase II promoter",
  "GO:1900547": "negative regulation of phenotypic switching by regulation of transcription from RNA polymerase II promoter",
  "GO:1900548": "heme b catabolic process",
  "GO:1900549": "N',N'',N'''-triacetylfusarinine C metabolic process",
  "GO:1900550": "N',N'',N'''-triacetylfusarinine C catabolic process",
  "GO:1900551": "N',N'',N'''-triacetylfusarinine C biosynthetic process",
  "GO:1900552": "asperfuranone metabolic process",
  "GO:1900553": "asperfuranone catabolic process",
  "GO:1900554": "asperfuranone biosynthetic process",
  "GO:1900555": "emericellamide metabolic process",
  "GO:1900556": "emericellamide catabolic process",
  "GO:1900557": "emericellamide biosynthetic process",
  "GO:1900558": "austinol metabolic process",
  "GO:1900559": "austinol catabolic process",
  "GO:1900560": "austinol biosynthetic process",
  "GO:1900561": "dehydroaustinol metabolic process",
  "GO:1900562": "dehydroaustinol catabolic process",
  "GO:1900563": "dehydroaustinol biosynthetic process",
  "GO:1900564": "chanoclavine-I metabolic process",
  "GO:1900565": "chanoclavine-I catabolic process",
  "GO:1900566": "chanoclavine-I biosynthetic process",
  "GO:1900567": "chanoclavine-I aldehyde metabolic process",
  "GO:1900568": "chanoclavine-I aldehyde catabolic process",
  "GO:1900569": "chanoclavine-I aldehyde biosynthetic process",
  "GO:1900570": "diorcinol metabolic process",
  "GO:1900571": "diorcinol catabolic process",
  "GO:1900572": "diorcinol biosynthetic process",
  "GO:1900573": "emodin metabolic process",
  "GO:1900574": "emodin catabolic process",
  "GO:1900575": "emodin biosynthetic process",
  "GO:1900576": "gerfelin metabolic process",
  "GO:1900577": "gerfelin catabolic process",
  "GO:1900578": "gerfelin biosynthetic process",
  "GO:1900579": "(17Z)-protosta-17(20),24-dien-3beta-ol metabolic process",
  "GO:1900580": "(17Z)-protosta-17(20),24-dien-3beta-ol catabolic process",
  "GO:1900581": "(17Z)-protosta-17(20),24-dien-3beta-ol biosynthetic process",
  "GO:1900582": "o-orsellinic acid metabolic process",
  "GO:1900583": "o-orsellinic acid catabolic process",
  "GO:1900584": "o-orsellinic acid biosynthetic process",
  "GO:1900585": "arugosin metabolic process",
  "GO:1900586": "arugosin catabolic process",
  "GO:1900587": "arugosin biosynthetic process",
  "GO:1900588": "violaceol I metabolic process",
  "GO:1900589": "violaceol I catabolic process",
  "GO:1900590": "violaceol I biosynthetic process",
  "GO:1900591": "violaceol II metabolic process",
  "GO:1900592": "violaceol II catabolic process",
  "GO:1900593": "violaceol II biosynthetic process",
  "GO:1900594": "(+)-kotanin metabolic process",
  "GO:1900595": "(+)-kotanin catabolic process",
  "GO:1900596": "(+)-kotanin biosynthetic process",
  "GO:1900597": "demethylkotanin metabolic process",
  "GO:1900598": "demethylkotanin catabolic process",
  "GO:1900599": "demethylkotanin biosynthetic process",
  "GO:1900600": "endocrocin metabolic process",
  "GO:1900601": "endocrocin catabolic process",
  "GO:1900602": "endocrocin biosynthetic process",
  "GO:1900603": "tensidol A metabolic process",
  "GO:1900604": "tensidol A catabolic process",
  "GO:1900605": "tensidol A biosynthetic process",
  "GO:1900606": "tensidol B metabolic process",
  "GO:1900607": "tensidol B catabolic process",
  "GO:1900608": "tensidol B biosynthetic process",
  "GO:1900609": "F-9775A metabolic process",
  "GO:1900610": "F-9775A catabolic process",
  "GO:1900611": "F-9775A biosynthetic process",
  "GO:1900612": "F-9775B metabolic process",
  "GO:1900613": "F-9775B catabolic process",
  "GO:1900614": "F-9775B biosynthetic process",
  "GO:1900615": "emericellamide A metabolic process",
  "GO:1900616": "emericellamide A catabolic process",
  "GO:1900617": "emericellamide A biosynthetic process",
  "GO:1900618": "regulation of shoot system morphogenesis",
  "GO:1900619": "acetate ester metabolic process",
  "GO:1900620": "acetate ester biosynthetic process",
  "GO:1900621": "regulation of transcription from RNA polymerase II promoter by calcium-mediated signaling",
  "GO:1900622": "positive regulation of transcription from RNA polymerase II promoter by calcium-mediated signaling",
  "GO:1900623": "regulation of monocyte aggregation",
  "GO:1900624": "negative regulation of monocyte aggregation",
  "GO:1900625": "positive regulation of monocyte aggregation",
  "GO:1900626": "regulation of arugosin biosynthetic process",
  "GO:1900627": "negative regulation of arugosin biosynthetic process",
  "GO:1900628": "positive regulation of arugosin biosynthetic process",
  "GO:1900629": "methanophenazine metabolic process",
  "GO:1900630": "methanophenazine biosynthetic process",
  "GO:1900631": "tridecane metabolic process",
  "GO:1900632": "tridecane biosynthetic process",
  "GO:1900633": "pentadecane metabolic process",
  "GO:1900634": "pentadecane biosynthetic process",
  "GO:1900635": "heptadecane metabolic process",
  "GO:1900636": "heptadecane biosynthetic process",
  "GO:1900637": "regulation of asperfuranone biosynthetic process",
  "GO:1900638": "negative regulation of asperfuranone biosynthetic process",
  "GO:1900639": "positive regulation of asperfuranone biosynthetic process",
  "GO:1900640": "regulation of austinol biosynthetic process",
  "GO:1900641": "negative regulation of austinol biosynthetic process",
  "GO:1900642": "positive regulation of austinol biosynthetic process",
  "GO:1900643": "regulation of chanoclavine-I biosynthetic process",
  "GO:1900644": "negative regulation of chanoclavine-I biosynthetic process",
  "GO:1900645": "positive regulation of chanoclavine-I biosynthetic process",
  "GO:1900646": "regulation of chanoclavine-I aldehyde biosynthetic process",
  "GO:1900647": "negative regulation of chanoclavine-I aldehyde biosynthetic process",
  "GO:1900648": "positive regulation of chanoclavine-I aldehyde biosynthetic process",
  "GO:1900649": "regulation of dehydroaustinol biosynthetic process",
  "GO:1900650": "negative regulation of dehydroaustinol biosynthetic process",
  "GO:1900651": "positive regulation of dehydroaustinol biosynthetic process",
  "GO:1900652": "regulation of demethylkotanin biosynthetic process",
  "GO:1900653": "negative regulation of demethylkotanin biosynthetic process",
  "GO:1900654": "positive regulation of demethylkotanin biosynthetic process",
  "GO:1900655": "regulation of diorcinol biosynthetic process",
  "GO:1900656": "negative regulation of diorcinol biosynthetic process",
  "GO:1900657": "positive regulation of diorcinol biosynthetic process",
  "GO:1900658": "regulation of emericellamide biosynthetic process",
  "GO:1900659": "negative regulation of emericellamide biosynthetic process",
  "GO:1900660": "positive regulation of emericellamide biosynthetic process",
  "GO:1900661": "regulation of emericellamide A biosynthetic process",
  "GO:1900662": "negative regulation of emericellamide A biosynthetic process",
  "GO:1900663": "positive regulation of emericellamide A biosynthetic process",
  "GO:1900664": "regulation of emodin biosynthetic process",
  "GO:1900665": "negative regulation of emodin biosynthetic process",
  "GO:1900666": "positive regulation of emodin biosynthetic process",
  "GO:1900667": "regulation of endocrocin biosynthetic process",
  "GO:1900668": "negative regulation of endocrocin biosynthetic process",
  "GO:1900669": "positive regulation of endocrocin biosynthetic process",
  "GO:1900670": "regulation of F-9775A biosynthetic process",
  "GO:1900671": "negative regulation of F-9775A biosynthetic process",
  "GO:1900672": "positive regulation of F-9775A biosynthetic process",
  "GO:1900673": "olefin metabolic process",
  "GO:1900674": "olefin biosynthetic process",
  "GO:1900675": "regulation of F-9775B biosynthetic process",
  "GO:1900676": "negative regulation of F-9775B biosynthetic process",
  "GO:1900677": "positive regulation of F-9775B biosynthetic process",
  "GO:1900678": "regulation of ferricrocin biosynthetic process",
  "GO:1900679": "negative regulation of ferricrocin biosynthetic process",
  "GO:1900680": "positive regulation of ferricrocin biosynthetic process",
  "GO:1900681": "octadecene metabolic process",
  "GO:1900682": "octadecene biosynthetic process",
  "GO:1900683": "regulation of fumonisin biosynthetic process",
  "GO:1900684": "negative regulation of fumonisin biosynthetic process",
  "GO:1900685": "positive regulation of fumonisin biosynthetic process",
  "GO:1900686": "regulation of gerfelin biosynthetic process",
  "GO:1900687": "negative regulation of gerfelin biosynthetic process",
  "GO:1900688": "positive regulation of gerfelin biosynthetic process",
  "GO:1900689": "regulation of gliotoxin biosynthetic process",
  "GO:1900690": "negative regulation of gliotoxin biosynthetic process",
  "GO:1900691": "positive regulation of gliotoxin biosynthetic process",
  "GO:1900692": "regulation of (+)-kotanin biosynthetic process",
  "GO:1900693": "negative regulation of (+)-kotanin biosynthetic process",
  "GO:1900694": "positive regulation of (+)-kotanin biosynthetic process",
  "GO:1900695": "regulation of N',N'',N'''-triacetylfusarinine C biosynthetic process",
  "GO:1900696": "negative regulation of N',N'',N'''-triacetylfusarinine C biosynthetic process",
  "GO:1900697": "positive regulation of N',N'',N'''-triacetylfusarinine C biosynthetic process",
  "GO:1900698": "regulation of o-orsellinic acid biosynthetic process",
  "GO:1900699": "negative regulation of o-orsellinic acid biosynthetic process",
  "GO:1900700": "positive regulation of o-orsellinic acid biosynthetic process",
  "GO:1900701": "regulation of orcinol biosynthetic process",
  "GO:1900702": "negative regulation of orcinol biosynthetic process",
  "GO:1900703": "positive regulation of orcinol biosynthetic process",
  "GO:1900704": "regulation of siderophore biosynthetic process",
  "GO:1900705": "negative regulation of siderophore biosynthetic process",
  "GO:1900706": "positive regulation of siderophore biosynthetic process",
  "GO:1900707": "regulation of tensidol A biosynthetic process",
  "GO:1900708": "negative regulation of tensidol A biosynthetic process",
  "GO:1900709": "positive regulation of tensidol A biosynthetic process",
  "GO:1900710": "regulation of tensidol B biosynthetic process",
  "GO:1900711": "negative regulation of tensidol B biosynthetic process",
  "GO:1900712": "positive regulation of tensidol B biosynthetic process",
  "GO:1900713": "regulation of violaceol I biosynthetic process",
  "GO:1900714": "negative regulation of violaceol I biosynthetic process",
  "GO:1900715": "positive regulation of violaceol I biosynthetic process",
  "GO:1900716": "regulation of violaceol II biosynthetic process",
  "GO:1900717": "negative regulation of violaceol II biosynthetic process",
  "GO:1900718": "positive regulation of violaceol II biosynthetic process",
  "GO:1900719": "regulation of uterine smooth muscle relaxation",
  "GO:1900720": "negative regulation of uterine smooth muscle relaxation",
  "GO:1900721": "positive regulation of uterine smooth muscle relaxation",
  "GO:1900722": "regulation of protein adenylylation",
  "GO:1900723": "negative regulation of protein adenylylation",
  "GO:1900724": "positive regulation of protein adenylylation",
  "GO:1900725": "osmoregulated periplasmic glucan metabolic process",
  "GO:1900726": "osmoregulated periplasmic glucan catabolic process",
  "GO:1900727": "osmoregulated periplasmic glucan biosynthetic process",
  "GO:1900728": "cardiac neural crest cell delamination involved in outflow tract morphogenesis",
  "GO:1900729": "regulation of adenylate cyclase-inhibiting opioid receptor signaling pathway",
  "GO:1900730": "negative regulation of adenylate cyclase-inhibiting opioid receptor signaling pathway",
  "GO:1900731": "positive regulation of adenylate cyclase-inhibiting opioid receptor signaling pathway",
  "GO:1900732": "regulation of polyketide biosynthetic process",
  "GO:1900733": "negative regulation of polyketide biosynthetic process",
  "GO:1900734": "positive regulation of polyketide biosynthetic process",
  "GO:1900735": "positive regulation of flocculation",
  "GO:1900736": "regulation of phospholipase C-activating G-protein coupled receptor signaling pathway",
  "GO:1900737": "negative regulation of phospholipase C-activating G-protein coupled receptor signaling pathway",
  "GO:1900738": "positive regulation of phospholipase C-activating G-protein coupled receptor signaling pathway",
  "GO:1900739": "regulation of protein insertion into mitochondrial membrane involved in apoptotic signaling pathway",
  "GO:1900740": "positive regulation of protein insertion into mitochondrial membrane involved in apoptotic signaling pathway",
  "GO:1900741": "regulation of filamentous growth of a population of unicellular organisms in response to pH",
  "GO:1900742": "negative regulation of filamentous growth of a population of unicellular organisms in response to pH",
  "GO:1900743": "positive regulation of filamentous growth of a population of unicellular organisms in response to pH",
  "GO:1900744": "regulation of p38MAPK cascade",
  "GO:1900745": "positive regulation of p38MAPK cascade",
  "GO:1900746": "regulation of vascular endothelial growth factor signaling pathway",
  "GO:1900747": "negative regulation of vascular endothelial growth factor signaling pathway",
  "GO:1900748": "positive regulation of vascular endothelial growth factor signaling pathway",
  "GO:1900749": "(R)-carnitine transport",
  "GO:1900750": "oligopeptide binding",
  "GO:1900751": "4-(trimethylammonio)butanoate transport",
  "GO:1900752": "malonic acid transport",
  "GO:1900753": "doxorubicin transport",
  "GO:1900754": "4-hydroxyphenylacetate transport",
  "GO:1900756": "protein processing in phagocytic vesicle",
  "GO:1900757": "regulation of D-amino-acid oxidase activity",
  "GO:1900758": "negative regulation of D-amino-acid oxidase activity",
  "GO:1900759": "positive regulation of D-amino-acid oxidase activity",
  "GO:1900760": "negative regulation of sterigmatocystin biosynthetic process",
  "GO:1900761": "averantin metabolic process",
  "GO:1900762": "averantin catabolic process",
  "GO:1900763": "averantin biosynthetic process",
  "GO:1900764": "emericellin metabolic process",
  "GO:1900765": "emericellin catabolic process",
  "GO:1900766": "emericellin biosynthetic process",
  "GO:1900767": "fonsecin metabolic process",
  "GO:1900768": "fonsecin catabolic process",
  "GO:1900769": "fonsecin biosynthetic process",
  "GO:1900770": "fumitremorgin B metabolic process",
  "GO:1900771": "fumitremorgin B catabolic process",
  "GO:1900772": "fumitremorgin B biosynthetic process",
  "GO:1900773": "fumiquinazoline metabolic process",
  "GO:1900774": "fumiquinazoline catabolic process",
  "GO:1900775": "fumiquinazoline biosynthetic process",
  "GO:1900776": "fumiquinazoline A metabolic process",
  "GO:1900777": "fumiquinazoline A catabolic process",
  "GO:1900778": "fumiquinazoline A biosynthetic process",
  "GO:1900779": "fumiquinazoline C metabolic process",
  "GO:1900780": "fumiquinazoline C catabolic process",
  "GO:1900781": "fumiquinazoline C biosynthetic process",
  "GO:1900782": "fumiquinazoline F metabolic process",
  "GO:1900783": "fumiquinazoline F catabolic process",
  "GO:1900784": "fumiquinazoline F biosynthetic process",
  "GO:1900785": "naphtho-gamma-pyrone metabolic process",
  "GO:1900786": "naphtho-gamma-pyrone catabolic process",
  "GO:1900787": "naphtho-gamma-pyrone biosynthetic process",
  "GO:1900788": "pseurotin A metabolic process",
  "GO:1900789": "pseurotin A catabolic process",
  "GO:1900790": "pseurotin A biosynthetic process",
  "GO:1900791": "shamixanthone metabolic process",
  "GO:1900792": "shamixanthone catabolic process",
  "GO:1900793": "shamixanthone biosynthetic process",
  "GO:1900794": "terrequinone A metabolic process",
  "GO:1900795": "terrequinone A catabolic process",
  "GO:1900796": "terrequinone A biosynthetic process",
  "GO:1900797": "cordyol C metabolic process",
  "GO:1900798": "cordyol C catabolic process",
  "GO:1900799": "cordyol C biosynthetic process",
  "GO:1900800": "cspyrone B1 metabolic process",
  "GO:1900801": "cspyrone B1 catabolic process",
  "GO:1900802": "cspyrone B1 biosynthetic process",
  "GO:1900803": "brevianamide F metabolic process",
  "GO:1900804": "brevianamide F catabolic process",
  "GO:1900805": "brevianamide F biosynthetic process",
  "GO:1900806": "ergot alkaloid catabolic process",
  "GO:1900807": "fumigaclavine C metabolic process",
  "GO:1900808": "fumigaclavine C catabolic process",
  "GO:1900809": "fumigaclavine C biosynthetic process",
  "GO:1900810": "helvolic acid metabolic process",
  "GO:1900811": "helvolic acid catabolic process",
  "GO:1900812": "helvolic acid biosynthetic process",
  "GO:1900813": "monodictyphenone metabolic process",
  "GO:1900814": "monodictyphenone catabolic process",
  "GO:1900815": "monodictyphenone biosynthetic process",
  "GO:1900816": "ochratoxin A metabolic process",
  "GO:1900817": "ochratoxin A catabolic process",
  "GO:1900818": "ochratoxin A biosynthetic process",
  "GO:1900819": "orlandin metabolic process",
  "GO:1900820": "orlandin catabolic process",
  "GO:1900821": "orlandin biosynthetic process",
  "GO:1900822": "regulation of ergot alkaloid biosynthetic process",
  "GO:1900823": "negative regulation of ergot alkaloid biosynthetic process",
  "GO:1900824": "positive regulation of ergot alkaloid biosynthetic process",
  "GO:1900825": "regulation of membrane depolarization during cardiac muscle cell action potential",
  "GO:1900826": "negative regulation of membrane depolarization during cardiac muscle cell action potential",
  "GO:1900827": "positive regulation of membrane depolarization during cardiac muscle cell action potential",
  "GO:1900828": "D-tyrosine metabolic process",
  "GO:1900829": "D-tyrosine catabolic process",
  "GO:1900830": "D-tyrosine biosynthetic process",
  "GO:1900831": "D-leucine metabolic process",
  "GO:1900832": "D-leucine catabolic process",
  "GO:1900833": "D-leucine biosynthetic process",
  "GO:1900834": "regulation of emericellin biosynthetic process",
  "GO:1900835": "negative regulation of emericellin biosynthetic process",
  "GO:1900836": "positive regulation of emericellin biosynthetic process",
  "GO:1900837": "regulation of fumigaclavine C biosynthetic process",
  "GO:1900838": "negative regulation of fumigaclavine C biosynthetic process",
  "GO:1900839": "positive regulation of fumigaclavine C biosynthetic process",
  "GO:1900840": "regulation of helvolic acid biosynthetic process",
  "GO:1900841": "negative regulation of helvolic acid biosynthetic process",
  "GO:1900842": "positive regulation of helvolic acid biosynthetic process",
  "GO:1900843": "regulation of monodictyphenone biosynthetic process",
  "GO:1900844": "negative regulation of monodictyphenone biosynthetic process",
  "GO:1900845": "positive regulation of monodictyphenone biosynthetic process",
  "GO:1900846": "regulation of naphtho-gamma-pyrone biosynthetic process",
  "GO:1900847": "negative regulation of naphtho-gamma-pyrone biosynthetic process",
  "GO:1900848": "positive regulation of naphtho-gamma-pyrone biosynthetic process",
  "GO:1900849": "regulation of pseurotin A biosynthetic process",
  "GO:1900850": "negative regulation of pseurotin A biosynthetic process",
  "GO:1900851": "positive regulation of pseurotin A biosynthetic process",
  "GO:1900852": "regulation of terrequinone A biosynthetic process",
  "GO:1900853": "negative regulation of terrequinone A biosynthetic process",
  "GO:1900854": "positive regulation of terrequinone A biosynthetic process",
  "GO:1900855": "regulation of fumitremorgin B biosynthetic process",
  "GO:1900856": "negative regulation of fumitremorgin B biosynthetic process",
  "GO:1900857": "positive regulation of fumitremorgin B biosynthetic process",
  "GO:1900858": "regulation of brevianamide F biosynthetic process",
  "GO:1900859": "negative regulation of brevianamide F biosynthetic process",
  "GO:1900860": "positive regulation of brevianamide F biosynthetic process",
  "GO:1900861": "regulation of cordyol C biosynthetic process",
  "GO:1900862": "negative regulation of cordyol C biosynthetic process",
  "GO:1900863": "positive regulation of cordyol C biosynthetic process",
  "GO:1900864": "mitochondrial RNA modification",
  "GO:1900865": "chloroplast RNA modification",
  "GO:1900866": "glycolate transport",
  "GO:1900867": "sarcinapterin metabolic process",
  "GO:1900868": "sarcinapterin biosynthetic process",
  "GO:1900869": "tatiopterin metabolic process",
  "GO:1900870": "tatiopterin biosynthetic process",
  "GO:1900871": "chloroplast mRNA modification",
  "GO:1900872": "pentadec-1-ene metabolic process",
  "GO:1900873": "pentadec-1-ene biosynthetic process",
  "GO:1900874": "heptadec-1-ene metabolic process",
  "GO:1900875": "heptadec-1-ene biosynthetic process",
  "GO:1900876": "nonadec-1-ene metabolic process",
  "GO:1900877": "nonadec-1-ene biosynthetic process",
  "GO:1900878": "(Z)-nonadeca-1,14-diene metabolic process",
  "GO:1900879": "(Z)-nonadeca-1,14-diene biosynthetic process",
  "GO:1900880": "18-methylnonadec-1-ene metabolic process",
  "GO:1900881": "18-methylnonadec-1-ene biosynthetic process",
  "GO:1900882": "17-methylnonadec-1-ene metabolic process",
  "GO:1900883": "17-methylnonadec-1-ene biosynthetic process",
  "GO:1900884": "regulation of tridecane biosynthetic process",
  "GO:1900885": "negative regulation of tridecane biosynthetic process",
  "GO:1900886": "positive regulation of tridecane biosynthetic process",
  "GO:1900887": "regulation of pentadecane biosynthetic process",
  "GO:1900888": "negative regulation of pentadecane biosynthetic process",
  "GO:1900889": "positive regulation of pentadecane biosynthetic process",
  "GO:1900890": "regulation of pentadecane metabolic process",
  "GO:1900891": "negative regulation of pentadecane metabolic process",
  "GO:1900892": "positive regulation of pentadecane metabolic process",
  "GO:1900893": "regulation of tridecane metabolic process",
  "GO:1900894": "negative regulation of tridecane metabolic process",
  "GO:1900895": "positive regulation of tridecane metabolic process",
  "GO:1900896": "regulation of heptadecane biosynthetic process",
  "GO:1900897": "negative regulation of heptadecane biosynthetic process",
  "GO:1900898": "positive regulation of heptadecane biosynthetic process",
  "GO:1900899": "regulation of heptadecane metabolic process",
  "GO:1900900": "negative regulation of heptadecane metabolic process",
  "GO:1900901": "positive regulation of heptadecane metabolic process",
  "GO:1900902": "regulation of hexadecanal biosynthetic process",
  "GO:1900903": "negative regulation of hexadecanal biosynthetic process",
  "GO:1900904": "positive regulation of hexadecanal biosynthetic process",
  "GO:1900905": "regulation of hexadecanal metabolic process",
  "GO:1900906": "negative regulation of hexadecanal metabolic process",
  "GO:1900907": "positive regulation of hexadecanal metabolic process",
  "GO:1900908": "regulation of olefin metabolic process",
  "GO:1900909": "negative regulation of olefin metabolic process",
  "GO:1900910": "positive regulation of olefin metabolic process",
  "GO:1900911": "regulation of olefin biosynthetic process",
  "GO:1900912": "negative regulation of olefin biosynthetic process",
  "GO:1900913": "positive regulation of olefin biosynthetic process",
  "GO:1900914": "regulation of octadecene biosynthetic process",
  "GO:1900915": "negative regulation of octadecene biosynthetic process",
  "GO:1900916": "positive regulation of octadecene biosynthetic process",
  "GO:1900917": "regulation of octadecene metabolic process",
  "GO:1900918": "negative regulation of octadecene metabolic process",
  "GO:1900919": "positive regulation of octadecene metabolic process",
  "GO:1900920": "regulation of L-glutamate import",
  "GO:1900921": "negative regulation of L-glutamate import",
  "GO:1900922": "positive regulation of L-glutamate import",
  "GO:1900923": "regulation of glycine import",
  "GO:1900924": "negative regulation of glycine import",
  "GO:1900925": "positive regulation of glycine import",
  "GO:1900926": "regulation of L-threonine import",
  "GO:1900927": "negative regulation of L-threonine import",
  "GO:1900928": "positive regulation of L-threonine import",
  "GO:1900929": "regulation of L-tyrosine import",
  "GO:1900930": "negative regulation of L-tyrosine import",
  "GO:1900931": "positive regulation of L-tyrosine import",
  "GO:1900932": "regulation of nonadec-1-ene metabolic process",
  "GO:1900933": "negative regulation of nonadec-1-ene metabolic process",
  "GO:1900934": "positive regulation of nonadec-1-ene metabolic process",
  "GO:1900935": "regulation of nonadec-1-ene biosynthetic process",
  "GO:1900936": "negative regulation of nonadec-1-ene biosynthetic process",
  "GO:1900937": "positive regulation of nonadec-1-ene biosynthetic process",
  "GO:1900938": "regulation of (Z)-nonadeca-1,14-diene metabolic process",
  "GO:1900939": "negative regulation of (Z)-nonadeca-1,14-diene metabolic process",
  "GO:1900940": "positive regulation of (Z)-nonadeca-1,14-diene metabolic process",
  "GO:1900941": "regulation of (Z)-nonadeca-1,14-diene biosynthetic process",
  "GO:1900942": "negative regulation of (Z)-nonadeca-1,14-diene biosynthetic process",
  "GO:1900943": "positive regulation of (Z)-nonadeca-1,14-diene biosynthetic process",
  "GO:1900944": "regulation of isoprene metabolic process",
  "GO:1900945": "negative regulation of isoprene metabolic process",
  "GO:1900946": "positive regulation of isoprene metabolic process",
  "GO:1900947": "regulation of isoprene biosynthetic process",
  "GO:1900948": "negative regulation of isoprene biosynthetic process",
  "GO:1900949": "positive regulation of isoprene biosynthetic process",
  "GO:1900950": "regulation of 18-methylnonadec-1-ene biosynthetic process",
  "GO:1900951": "negative regulation of 18-methylnonadec-1-ene biosynthetic process",
  "GO:1900952": "positive regulation of 18-methylnonadec-1-ene biosynthetic process",
  "GO:1900953": "regulation of 18-methylnonadec-1-ene metabolic process",
  "GO:1900954": "negative regulation of 18-methylnonadec-1-ene metabolic process",
  "GO:1900955": "positive regulation of 18-methylnonadec-1-ene metabolic process",
  "GO:1900956": "regulation of 17-methylnonadec-1-ene biosynthetic process",
  "GO:1900957": "negative regulation of 17-methylnonadec-1-ene biosynthetic process",
  "GO:1900958": "positive regulation of 17-methylnonadec-1-ene biosynthetic process",
  "GO:1900959": "regulation of 17-methylnonadec-1-ene metabolic process",
  "GO:1900960": "negative regulation of 17-methylnonadec-1-ene metabolic process",
  "GO:1900961": "positive regulation of 17-methylnonadec-1-ene metabolic process",
  "GO:1900962": "regulation of methanophenazine biosynthetic process",
  "GO:1900963": "negative regulation of methanophenazine biosynthetic process",
  "GO:1900964": "positive regulation of methanophenazine biosynthetic process",
  "GO:1900965": "regulation of methanophenazine metabolic process",
  "GO:1900966": "negative regulation of methanophenazine metabolic process",
  "GO:1900967": "positive regulation of methanophenazine metabolic process",
  "GO:1900968": "regulation of sarcinapterin metabolic process",
  "GO:1900969": "negative regulation of sarcinapterin metabolic process",
  "GO:1900970": "positive regulation of sarcinapterin metabolic process",
  "GO:1900971": "regulation of sarcinapterin biosynthetic process",
  "GO:1900972": "negative regulation of sarcinapterin biosynthetic process",
  "GO:1900973": "positive regulation of sarcinapterin biosynthetic process",
  "GO:1900974": "regulation of tatiopterin biosynthetic process",
  "GO:1900975": "negative regulation of tatiopterin biosynthetic process",
  "GO:1900976": "positive regulation of tatiopterin biosynthetic process",
  "GO:1900977": "regulation of tatiopterin metabolic process",
  "GO:1900978": "negative regulation of tatiopterin metabolic process",
  "GO:1900979": "positive regulation of tatiopterin metabolic process",
  "GO:1900980": "regulation of phenazine biosynthetic process",
  "GO:1900981": "negative regulation of phenazine biosynthetic process",
  "GO:1900982": "positive regulation of phenazine biosynthetic process",
  "GO:1900983": "vindoline metabolic process",
  "GO:1900984": "vindoline catabolic process",
  "GO:1900985": "vindoline biosynthetic process",
  "GO:1900986": "ajmaline metabolic process",
  "GO:1900987": "ajmaline catabolic process",
  "GO:1900988": "ajmaline biosynthetic process",
  "GO:1900989": "scopolamine metabolic process",
  "GO:1900990": "scopolamine catabolic process",
  "GO:1900991": "scopolamine biosynthetic process",
  "GO:1900992": "(-)-secologanin metabolic process",
  "GO:1900993": "(-)-secologanin catabolic process",
  "GO:1900994": "(-)-secologanin biosynthetic process",
  "GO:1900995": "ubiquinone-6 binding",
  "GO:1900996": "benzene catabolic process",
  "GO:1900997": "benzene biosynthetic process",
  "GO:1900998": "nitrobenzene catabolic process",
  "GO:1900999": "nitrobenzene biosynthetic process",
  "GO:1901000": "regulation of response to salt stress",
  "GO:1901001": "negative regulation of response to salt stress",
  "GO:1901002": "positive regulation of response to salt stress",
  "GO:1901003": "negative regulation of fermentation",
  "GO:1901004": "ubiquinone-6 metabolic process",
  "GO:1901005": "ubiquinone-6 catabolic process",
  "GO:1901006": "ubiquinone-6 biosynthetic process",
  "GO:1901007": "(S)-scoulerine metabolic process",
  "GO:1901008": "(S)-scoulerine catabolic process",
  "GO:1901009": "(S)-scoulerine biosynthetic process",
  "GO:1901010": "(S)-reticuline metabolic process",
  "GO:1901011": "(S)-reticuline catabolic process",
  "GO:1901012": "(S)-reticuline biosynthetic process",
  "GO:1901013": "3alpha(S)-strictosidine metabolic process",
  "GO:1901014": "3alpha(S)-strictosidine catabolic process",
  "GO:1901015": "3alpha(S)-strictosidine biosynthetic process",
  "GO:1901016": "regulation of potassium ion transmembrane transporter activity",
  "GO:1901017": "negative regulation of potassium ion transmembrane transporter activity",
  "GO:1901018": "positive regulation of potassium ion transmembrane transporter activity",
  "GO:1901019": "regulation of calcium ion transmembrane transporter activity",
  "GO:1901020": "negative regulation of calcium ion transmembrane transporter activity",
  "GO:1901021": "positive regulation of calcium ion transmembrane transporter activity",
  "GO:1901022": "4-hydroxyphenylacetate metabolic process",
  "GO:1901023": "4-hydroxyphenylacetate catabolic process",
  "GO:1901024": "4-hydroxyphenylacetate biosynthetic process",
  "GO:1901025": "ripoptosome assembly involved in extrinsic apoptotic signaling pathway",
  "GO:1901026": "ripoptosome assembly involved in necroptotic process",
  "GO:1901027": "dextrin catabolic process",
  "GO:1901028": "regulation of mitochondrial outer membrane permeabilization involved in apoptotic signaling pathway",
  "GO:1901029": "negative regulation of mitochondrial outer membrane permeabilization involved in apoptotic signaling pathway",
  "GO:1901030": "positive regulation of mitochondrial outer membrane permeabilization involved in apoptotic signaling pathway",
  "GO:1901031": "regulation of response to reactive oxygen species",
  "GO:1901032": "negative regulation of response to reactive oxygen species",
  "GO:1901033": "positive regulation of response to reactive oxygen species",
  "GO:1901034": "regulation of L-glutamine import",
  "GO:1901035": "negative regulation of L-glutamine import",
  "GO:1901036": "positive regulation of L-glutamine import",
  "GO:1901037": "obsolete regulation of transcription from RNA polymerase II promoter during M/G1 transition of mitotic cell cycle",
  "GO:1901038": "cyanidin 3-O-glucoside metabolic process",
  "GO:1901039": "regulation of peptide antigen transport",
  "GO:1901040": "negative regulation of peptide antigen transport",
  "GO:1901041": "positive regulation of peptide antigen transport",
  "GO:1901042": "positive regulation of L-arginine import",
  "GO:1901043": "obsolete protein polyubiquitination involved in cellular response to misfolded protein",
  "GO:1901044": "protein polyubiquitination involved in nucleus-associated proteasomal ubiquitin-dependent protein catabolic process",
  "GO:1901045": "negative regulation of oviposition",
  "GO:1901046": "positive regulation of oviposition",
  "GO:1901047": "insulin receptor signaling pathway involved in determination of adult lifespan",
  "GO:1901048": "transforming growth factor beta receptor signaling pathway involved in regulation of multicellular organism growth",
  "GO:1901049": "atropine metabolic process",
  "GO:1901050": "atropine catabolic process",
  "GO:1901051": "atropine biosynthetic process",
  "GO:1901052": "sarcosine metabolic process",
  "GO:1901053": "sarcosine catabolic process",
  "GO:1901054": "sarcosine biosynthetic process",
  "GO:1901055": "trimethylenediamine metabolic process",
  "GO:1901056": "trimethylenediamine catabolic process",
  "GO:1901057": "trimethylenediamine biosynthetic process",
  "GO:1901058": "p-hydroxyphenyl lignin metabolic process",
  "GO:1901059": "p-hydroxyphenyl lignin catabolic process",
  "GO:1901060": "p-hydroxyphenyl lignin biosynthetic process",
  "GO:1901061": "guaiacyl lignin metabolic process",
  "GO:1901062": "guaiacyl lignin catabolic process",
  "GO:1901063": "guaiacyl lignin biosynthetic process",
  "GO:1901064": "syringal lignin metabolic process",
  "GO:1901065": "syringal lignin catabolic process",
  "GO:1901066": "syringal lignin biosynthetic process",
  "GO:1901067": "ferulate catabolic process",
  "GO:1901068": "guanosine-containing compound metabolic process",
  "GO:1901069": "guanosine-containing compound catabolic process",
  "GO:1901070": "guanosine-containing compound biosynthetic process",
  "GO:1901071": "glucosamine-containing compound metabolic process",
  "GO:1901072": "glucosamine-containing compound catabolic process",
  "GO:1901073": "glucosamine-containing compound biosynthetic process",
  "GO:1901074": "regulation of engulfment of apoptotic cell",
  "GO:1901075": "negative regulation of engulfment of apoptotic cell",
  "GO:1901076": "positive regulation of engulfment of apoptotic cell",
  "GO:1901077": "regulation of relaxation of muscle",
  "GO:1901078": "negative regulation of relaxation of muscle",
  "GO:1901079": "positive regulation of relaxation of muscle",
  "GO:1901080": "regulation of relaxation of smooth muscle",
  "GO:1901081": "negative regulation of relaxation of smooth muscle",
  "GO:1901082": "positive regulation of relaxation of smooth muscle",
  "GO:1901083": "pyrrolizidine alkaloid metabolic process",
  "GO:1901084": "pyrrolizidine alkaloid catabolic process",
  "GO:1901085": "pyrrolizidine alkaloid biosynthetic process",
  "GO:1901086": "benzylpenicillin metabolic process",
  "GO:1901087": "benzylpenicillin catabolic process",
  "GO:1901088": "benzylpenicillin biosynthetic process",
  "GO:1901089": "acetate ester metabolic process involved in fermentation",
  "GO:1901090": "regulation of protein tetramerization",
  "GO:1901091": "negative regulation of protein tetramerization",
  "GO:1901092": "positive regulation of protein tetramerization",
  "GO:1901093": "regulation of protein homotetramerization",
  "GO:1901094": "negative regulation of protein homotetramerization",
  "GO:1901095": "positive regulation of protein homotetramerization",
  "GO:1901096": "regulation of autophagosome maturation",
  "GO:1901097": "negative regulation of autophagosome maturation",
  "GO:1901098": "positive regulation of autophagosome maturation",
  "GO:1901099": "negative regulation of signal transduction in absence of ligand",
  "GO:1901101": "gramicidin S metabolic process",
  "GO:1901102": "gramicidin S catabolic process",
  "GO:1901103": "gramicidin S biosynthetic process",
  "GO:1901104": "tetracenomycin C metabolic process",
  "GO:1901105": "tetracenomycin C catabolic process",
  "GO:1901106": "tetracenomycin C biosynthetic process",
  "GO:1901107": "granaticin metabolic process",
  "GO:1901108": "granaticin catabolic process",
  "GO:1901109": "granaticin biosynthetic process",
  "GO:1901110": "actinorhodin metabolic process",
  "GO:1901111": "actinorhodin catabolic process",
  "GO:1901112": "actinorhodin biosynthetic process",
  "GO:1901113": "erythromycin metabolic process",
  "GO:1901114": "erythromycin catabolic process",
  "GO:1901115": "erythromycin biosynthetic process",
  "GO:1901116": "cephamycin C metabolic process",
  "GO:1901117": "cephamycin C catabolic process",
  "GO:1901118": "cephamycin C biosynthetic process",
  "GO:1901119": "tobramycin metabolic process",
  "GO:1901120": "tobramycin catabolic process",
  "GO:1901121": "tobramycin biosynthetic process",
  "GO:1901122": "bacitracin A metabolic process",
  "GO:1901123": "bacitracin A catabolic process",
  "GO:1901124": "bacitracin A biosynthetic process",
  "GO:1901125": "candicidin metabolic process",
  "GO:1901126": "candicidin catabolic process",
  "GO:1901127": "candicidin biosynthetic process",
  "GO:1901128": "gentamycin metabolic process",
  "GO:1901129": "gentamycin catabolic process",
  "GO:1901130": "gentamycin biosynthetic process",
  "GO:1901131": "kanamycin metabolic process",
  "GO:1901132": "kanamycin catabolic process",
  "GO:1901133": "kanamycin biosynthetic process",
  "GO:1901134": "negative regulation of coflocculation via protein-carbohydrate interaction",
  "GO:1901135": "carbohydrate derivative metabolic process",
  "GO:1901136": "carbohydrate derivative catabolic process",
  "GO:1901137": "carbohydrate derivative biosynthetic process",
  "GO:1901140": "p-coumaryl alcohol transport",
  "GO:1901141": "regulation of lignin biosynthetic process",
  "GO:1901142": "insulin metabolic process",
  "GO:1901143": "insulin catabolic process",
  "GO:1901144": "obsolete insulin biosynthetic process",
  "GO:1901145": "mesenchymal cell apoptotic process involved in nephron morphogenesis",
  "GO:1901146": "mesenchymal cell apoptotic process involved in mesonephric nephron morphogenesis",
  "GO:1901147": "mesenchymal cell apoptotic process involved in metanephric nephron morphogenesis",
  "GO:1901148": "gene expression involved in extracellular matrix organization",
  "GO:1901149": "salicylic acid binding",
  "GO:1901150": "vistamycin metabolic process",
  "GO:1901151": "vistamycin catabolic process",
  "GO:1901152": "vistamycin biosynthetic process",
  "GO:1901153": "paromomycin metabolic process",
  "GO:1901154": "paromomycin catabolic process",
  "GO:1901155": "paromomycin biosynthetic process",
  "GO:1901156": "neomycin metabolic process",
  "GO:1901157": "neomycin catabolic process",
  "GO:1901158": "neomycin biosynthetic process",
  "GO:1901159": "xylulose 5-phosphate biosynthetic process",
  "GO:1901160": "primary amino compound metabolic process",
  "GO:1901161": "primary amino compound catabolic process",
  "GO:1901162": "primary amino compound biosynthetic process",
  "GO:1901163": "regulation of trophoblast cell migration",
  "GO:1901164": "negative regulation of trophoblast cell migration",
  "GO:1901165": "positive regulation of trophoblast cell migration",
  "GO:1901166": "neural crest cell migration involved in autonomic nervous system development",
  "GO:1901167": "3-chlorocatechol metabolic process",
  "GO:1901168": "3-chlorocatechol catabolic process",
  "GO:1901169": "3-chlorocatechol biosynthetic process",
  "GO:1901170": "naphthalene catabolic process",
  "GO:1901171": "naphthalene biosynthetic process",
  "GO:1901172": "phytoene metabolic process",
  "GO:1901173": "phytoene catabolic process",
  "GO:1901174": "phytoene biosynthetic process",
  "GO:1901175": "lycopene metabolic process",
  "GO:1901176": "lycopene catabolic process",
  "GO:1901177": "lycopene biosynthetic process",
  "GO:1901178": "spheroidene metabolic process",
  "GO:1901179": "spheroidene catabolic process",
  "GO:1901180": "spheroidene biosynthetic process",
  "GO:1901181": "negative regulation of cellular response to caffeine",
  "GO:1901182": "regulation of camalexin biosynthetic process",
  "GO:1901183": "positive regulation of camalexin biosynthetic process",
  "GO:1901184": "regulation of ERBB signaling pathway",
  "GO:1901185": "negative regulation of ERBB signaling pathway",
  "GO:1901186": "positive regulation of ERBB signaling pathway",
  "GO:1901187": "regulation of ephrin receptor signaling pathway",
  "GO:1901188": "negative regulation of ephrin receptor signaling pathway",
  "GO:1901189": "positive regulation of ephrin receptor signaling pathway",
  "GO:1901190": "regulation of formation of translation initiation ternary complex",
  "GO:1901191": "negative regulation of formation of translation initiation ternary complex",
  "GO:1901192": "positive regulation of formation of translation initiation ternary complex",
  "GO:1901193": "regulation of formation of translation preinitiation complex",
  "GO:1901194": "negative regulation of formation of translation preinitiation complex",
  "GO:1901195": "positive regulation of formation of translation preinitiation complex",
  "GO:1901196": "positive regulation of calcium-mediated signaling involved in cellular response to salt stress",
  "GO:1901197": "positive regulation of calcium-mediated signaling involved in cellular response to calcium ion",
  "GO:1901198": "positive regulation of calcium ion transport into cytosol involved in cellular response to calcium ion",
  "GO:1901199": "positive regulation of calcium ion transport into cytosol involved in cellular response to salt stress",
  "GO:1901200": "negative regulation of calcium ion transport into cytosol involved in cellular response to salt stress",
  "GO:1901201": "regulation of extracellular matrix assembly",
  "GO:1901202": "negative regulation of extracellular matrix assembly",
  "GO:1901203": "positive regulation of extracellular matrix assembly",
  "GO:1901204": "regulation of adrenergic receptor signaling pathway involved in heart process",
  "GO:1901205": "negative regulation of adrenergic receptor signaling pathway involved in heart process",
  "GO:1901206": "positive regulation of adrenergic receptor signaling pathway involved in heart process",
  "GO:1901207": "regulation of heart looping",
  "GO:1901208": "negative regulation of heart looping",
  "GO:1901209": "positive regulation of heart looping",
  "GO:1901210": "regulation of cardiac chamber formation",
  "GO:1901211": "negative regulation of cardiac chamber formation",
  "GO:1901212": "positive regulation of cardiac chamber formation",
  "GO:1901213": "regulation of transcription from RNA polymerase II promoter involved in heart development",
  "GO:1901214": "regulation of neuron death",
  "GO:1901215": "negative regulation of neuron death",
  "GO:1901216": "positive regulation of neuron death",
  "GO:1901217": "regulation of holin activity",
  "GO:1901218": "negative regulation of holin activity",
  "GO:1901219": "regulation of cardiac chamber morphogenesis",
  "GO:1901220": "negative regulation of cardiac chamber morphogenesis",
  "GO:1901221": "positive regulation of cardiac chamber morphogenesis",
  "GO:1901222": "regulation of NIK/NF-kappaB signaling",
  "GO:1901223": "negative regulation of NIK/NF-kappaB signaling",
  "GO:1901224": "positive regulation of NIK/NF-kappaB signaling",
  "GO:1901225": "obsolete negative regulation of transcription from RNA polymerase II promoter involved in heart development",
  "GO:1901226": "obsolete positive regulation of transcription from RNA polymerase II promoter involved in heart development",
  "GO:1901227": "negative regulation of transcription from RNA polymerase II promoter involved in heart development",
  "GO:1901228": "positive regulation of transcription from RNA polymerase II promoter involved in heart development",
  "GO:1901229": "regulation of non-canonical Wnt signaling pathway via JNK cascade",
  "GO:1901230": "negative regulation of non-canonical Wnt signaling pathway via JNK cascade",
  "GO:1901231": "positive regulation of non-canonical Wnt signaling pathway via JNK cascade",
  "GO:1901232": "regulation of convergent extension involved in axis elongation",
  "GO:1901233": "negative regulation of convergent extension involved in axis elongation",
  "GO:1901234": "positive regulation of convergent extension involved in axis elongation",
  "GO:1901235": "(R)-carnitine transmembrane transporter activity",
  "GO:1901236": "4-(trimethylammonio)butanoate transmembrane transporter activity",
  "GO:1901237": "tungstate transmembrane transporter activity",
  "GO:1901238": "tungstate transmembrane-transporting ATPase activity",
  "GO:1901239": "malonate(1-) transmembrane transporter activity",
  "GO:1901241": "4-hydroxyphenylacetate transmembrane transporter activity",
  "GO:1901242": "doxorubicin transmembrane-transporting ATPase activity",
  "GO:1901243": "methionine transmembrane-transporting ATPase activity",
  "GO:1901244": "positive regulation of transcription from RNA polymerase II promoter involved in defense response to fungus",
  "GO:1901245": "positive regulation of toll-like receptor 9 signaling pathway by B cell receptor internalization",
  "GO:1901246": "regulation of lung ciliated cell differentiation",
  "GO:1901247": "negative regulation of lung ciliated cell differentiation",
  "GO:1901248": "positive regulation of lung ciliated cell differentiation",
  "GO:1901249": "regulation of lung goblet cell differentiation",
  "GO:1901250": "negative regulation of lung goblet cell differentiation",
  "GO:1901251": "positive regulation of lung goblet cell differentiation",
  "GO:1901252": "regulation of intracellular transport of viral material",
  "GO:1901253": "negative regulation of intracellular transport of viral material",
  "GO:1901254": "positive regulation of intracellular transport of viral material",
  "GO:1901255": "nucleotide-excision repair involved in interstrand cross-link repair",
  "GO:1901256": "regulation of macrophage colony-stimulating factor production",
  "GO:1901257": "negative regulation of macrophage colony-stimulating factor production",
  "GO:1901258": "positive regulation of macrophage colony-stimulating factor production",
  "GO:1901259": "chloroplast rRNA processing",
  "GO:1901260": "peptidyl-lysine hydroxylation involved in bacterial-type EF-P lysine modification",
  "GO:1901261": "regulation of sorocarp spore cell differentiation",
  "GO:1901262": "negative regulation of sorocarp spore cell differentiation",
  "GO:1901263": "positive regulation of sorocarp spore cell differentiation",
  "GO:1901264": "carbohydrate derivative transport",
  "GO:1901265": "nucleoside phosphate binding",
  "GO:1901266": "cephalosporin C metabolic process",
  "GO:1901267": "cephalosporin C catabolic process",
  "GO:1901268": "cephalosporin C biosynthetic process",
  "GO:1901269": "lipooligosaccharide metabolic process",
  "GO:1901270": "lipooligosaccharide catabolic process",
  "GO:1901271": "lipooligosaccharide biosynthetic process",
  "GO:1901272": "2-dehydro-3-deoxy-D-gluconic acid metabolic process",
  "GO:1901273": "2-dehydro-3-deoxy-D-gluconic acid catabolic process",
  "GO:1901274": "2-dehydro-3-deoxy-D-gluconic acid biosynthetic process",
  "GO:1901275": "tartrate metabolic process",
  "GO:1901276": "tartrate catabolic process",
  "GO:1901277": "tartrate biosynthetic process",
  "GO:1901278": "D-ribose 5-phosphate metabolic process",
  "GO:1901279": "D-ribose 5-phosphate catabolic process",
  "GO:1901280": "D-ribose 5-phosphate biosynthetic process",
  "GO:1901281": "fructoselysine catabolic process",
  "GO:1901282": "fructoselysine biosynthetic process",
  "GO:1901283": "5,6,7,8-tetrahydromethanopterin metabolic process",
  "GO:1901284": "5,6,7,8-tetrahydromethanopterin catabolic process",
  "GO:1901285": "5,6,7,8-tetrahydromethanopterin biosynthetic process",
  "GO:1901286": "iron-sulfur-molybdenum cofactor metabolic process",
  "GO:1901287": "iron-sulfur-molybdenum cofactor catabolic process",
  "GO:1901288": "iron-sulfur-molybdenum cofactor biosynthetic process",
  "GO:1901289": "succinyl-CoA catabolic process",
  "GO:1901290": "succinyl-CoA biosynthetic process",
  "GO:1901291": "negative regulation of double-strand break repair via single-strand annealing",
  "GO:1901292": "nucleoside phosphate catabolic process",
  "GO:1901293": "nucleoside phosphate biosynthetic process",
  "GO:1901294": "negative regulation of SREBP signaling pathway by negative regulation of DNA binding",
  "GO:1901295": "regulation of canonical Wnt signaling pathway involved in cardiac muscle cell fate commitment",
  "GO:1901296": "negative regulation of canonical Wnt signaling pathway involved in cardiac muscle cell fate commitment",
  "GO:1901297": "positive regulation of canonical Wnt signaling pathway involved in cardiac muscle cell fate commitment",
  "GO:1901298": "regulation of hydrogen peroxide-mediated programmed cell death",
  "GO:1901299": "negative regulation of hydrogen peroxide-mediated programmed cell death",
  "GO:1901300": "positive regulation of hydrogen peroxide-mediated programmed cell death",
  "GO:1901301": "regulation of cargo loading into COPII-coated vesicle",
  "GO:1901303": "negative regulation of cargo loading into COPII-coated vesicle",
  "GO:1901304": "regulation of spermidine biosynthetic process",
  "GO:1901305": "negative regulation of spermidine biosynthetic process",
  "GO:1901307": "positive regulation of spermidine biosynthetic process",
  "GO:1901308": "regulation of sterol regulatory element binding protein cleavage",
  "GO:1901309": "negative regulation of sterol regulatory element binding protein cleavage",
  "GO:1901310": "positive regulation of sterol regulatory element binding protein cleavage",
  "GO:1901311": "obsolete regulation of gene expression involved in extracellular matrix organization",
  "GO:1901312": "obsolete negative regulation of gene expression involved in extracellular matrix organization",
  "GO:1901313": "obsolete positive regulation of gene expression involved in extracellular matrix organization",
  "GO:1901314": "regulation of histone H2A K63-linked ubiquitination",
  "GO:1901315": "negative regulation of histone H2A K63-linked ubiquitination",
  "GO:1901316": "positive regulation of histone H2A K63-linked ubiquitination",
  "GO:1901317": "regulation of sperm motility",
  "GO:1901318": "negative regulation of sperm motility",
  "GO:1901319": "positive regulation of trehalose catabolic process",
  "GO:1901320": "negative regulation of heart induction",
  "GO:1901321": "positive regulation of heart induction",
  "GO:1901322": "response to chloramphenicol",
  "GO:1901323": "response to erythromycin",
  "GO:1901324": "response to trichodermin",
  "GO:1901325": "response to antimycin A",
  "GO:1901326": "response to tetracycline",
  "GO:1901327": "response to tacrolimus",
  "GO:1901328": "response to cytochalasin B",
  "GO:1901329": "regulation of odontoblast differentiation",
  "GO:1901330": "negative regulation of odontoblast differentiation",
  "GO:1901331": "positive regulation of odontoblast differentiation",
  "GO:1901332": "negative regulation of lateral root development",
  "GO:1901333": "positive regulation of lateral root development",
  "GO:1901334": "lactone metabolic process",
  "GO:1901335": "lactone catabolic process",
  "GO:1901336": "lactone biosynthetic process",
  "GO:1901337": "thioester transport",
  "GO:1901338": "catecholamine binding",
  "GO:1901339": "regulation of store-operated calcium channel activity",
  "GO:1901340": "negative regulation of store-operated calcium channel activity",
  "GO:1901341": "positive regulation of store-operated calcium channel activity",
  "GO:1901342": "regulation of vasculature development",
  "GO:1901343": "negative regulation of vasculature development",
  "GO:1901344": "response to leptomycin B",
  "GO:1901345": "response to L-thialysine",
  "GO:1901346": "negative regulation of vasculature development involved in avascular cornea development in camera-type eye",
  "GO:1901347": "negative regulation of secondary cell wall biogenesis",
  "GO:1901348": "positive regulation of secondary cell wall biogenesis",
  "GO:1901349": "glucosinolate transport",
  "GO:1901350": "cell-cell signaling involved in cell-cell junction organization",
  "GO:1901351": "regulation of phosphatidylglycerol biosynthetic process",
  "GO:1901352": "negative regulation of phosphatidylglycerol biosynthetic process",
  "GO:1901353": "positive regulation of phosphatidylglycerol biosynthetic process",
  "GO:1901354": "response to L-canavanine",
  "GO:1901355": "response to rapamycin",
  "GO:1901356": "beta-D-galactofuranose metabolic process",
  "GO:1901357": "beta-D-galactofuranose catabolic process",
  "GO:1901358": "beta-D-galactofuranose biosynthetic process",
  "GO:1901359": "tungstate binding",
  "GO:1901360": "organic cyclic compound metabolic process",
  "GO:1901361": "organic cyclic compound catabolic process",
  "GO:1901362": "organic cyclic compound biosynthetic process",
  "GO:1901363": "heterocyclic compound binding",
  "GO:1901364": "funalenone metabolic process",
  "GO:1901365": "funalenone catabolic process",
  "GO:1901366": "funalenone biosynthetic process",
  "GO:1901367": "response to L-cysteine",
  "GO:1901368": "NAD transmembrane transporter activity",
  "GO:1901369": "cyclic 2,3-bisphospho-D-glycerate biosynthetic process",
  "GO:1901370": "response to glutathione",
  "GO:1901371": "regulation of leaf morphogenesis",
  "GO:1901372": "trehalose biosynthetic process involved in ascospore formation",
  "GO:1901373": "lipid hydroperoxide transport",
  "GO:1901374": "acetate ester transport",
  "GO:1901375": "acetate ester transmembrane transporter activity",
  "GO:1901376": "organic heteropentacyclic compound metabolic process",
  "GO:1901377": "organic heteropentacyclic compound catabolic process",
  "GO:1901378": "organic heteropentacyclic compound biosynthetic process",
  "GO:1901379": "regulation of potassium ion transmembrane transport",
  "GO:1901380": "negative regulation of potassium ion transmembrane transport",
  "GO:1901381": "positive regulation of potassium ion transmembrane transport",
  "GO:1901382": "regulation of chorionic trophoblast cell proliferation",
  "GO:1901383": "negative regulation of chorionic trophoblast cell proliferation",
  "GO:1901384": "positive regulation of chorionic trophoblast cell proliferation",
  "GO:1901385": "regulation of voltage-gated calcium channel activity",
  "GO:1901386": "negative regulation of voltage-gated calcium channel activity",
  "GO:1901387": "positive regulation of voltage-gated calcium channel activity",
  "GO:1901388": "regulation of transforming growth factor beta activation",
  "GO:1901389": "negative regulation of transforming growth factor beta activation",
  "GO:1901390": "positive regulation of transforming growth factor beta activation",
  "GO:1901392": "regulation of transforming growth factor beta1 activation",
  "GO:1901393": "negative regulation of transforming growth factor beta1 activation",
  "GO:1901394": "positive regulation of transforming growth factor beta1 activation",
  "GO:1901395": "regulation of transforming growth factor beta2 activation",
  "GO:1901396": "negative regulation of transforming growth factor beta2 activation",
  "GO:1901397": "positive regulation of transforming growth factor beta2 activation",
  "GO:1901398": "regulation of transforming growth factor beta3 activation",
  "GO:1901399": "negative regulation of transforming growth factor beta3 activation",
  "GO:1901400": "positive regulation of transforming growth factor beta3 activation",
  "GO:1901401": "regulation of tetrapyrrole metabolic process",
  "GO:1901402": "negative regulation of tetrapyrrole metabolic process",
  "GO:1901403": "positive regulation of tetrapyrrole metabolic process",
  "GO:1901404": "regulation of tetrapyrrole catabolic process",
  "GO:1901405": "negative regulation of tetrapyrrole catabolic process",
  "GO:1901406": "positive regulation of tetrapyrrole catabolic process",
  "GO:1901407": "regulation of phosphorylation of RNA polymerase II C-terminal domain",
  "GO:1901408": "negative regulation of phosphorylation of RNA polymerase II C-terminal domain",
  "GO:1901409": "positive regulation of phosphorylation of RNA polymerase II C-terminal domain",
  "GO:1901410": "regulation of tetrapyrrole biosynthetic process from glutamate",
  "GO:1901411": "negative regulation of tetrapyrrole biosynthetic process from glutamate",
  "GO:1901412": "positive regulation of tetrapyrrole biosynthetic process from glutamate",
  "GO:1901413": "regulation of tetrapyrrole biosynthetic process from glycine and succinyl-CoA",
  "GO:1901414": "negative regulation of tetrapyrrole biosynthetic process from glycine and succinyl-CoA",
  "GO:1901415": "positive regulation of tetrapyrrole biosynthetic process from glycine and succinyl-CoA",
  "GO:1901416": "regulation of response to ethanol",
  "GO:1901417": "negative regulation of response to ethanol",
  "GO:1901418": "positive regulation of response to ethanol",
  "GO:1901419": "regulation of response to alcohol",
  "GO:1901420": "negative regulation of response to alcohol",
  "GO:1901421": "positive regulation of response to alcohol",
  "GO:1901422": "response to butan-1-ol",
  "GO:1901423": "response to benzene",
  "GO:1901424": "response to toluene",
  "GO:1901425": "response to formic acid",
  "GO:1901426": "response to furfural",
  "GO:1901427": "response to propan-1-ol",
  "GO:1901428": "regulation of syringal lignin biosynthetic process",
  "GO:1901429": "negative regulation of syringal lignin biosynthetic process",
  "GO:1901430": "positive regulation of syringal lignin biosynthetic process",
  "GO:1901431": "regulation of response to cycloalkane",
  "GO:1901432": "negative regulation of response to cycloalkane",
  "GO:1901433": "positive regulation of response to cycloalkane",
  "GO:1901434": "regulation of toluene catabolic process",
  "GO:1901435": "negative regulation of toluene catabolic process",
  "GO:1901436": "positive regulation of toluene catabolic process",
  "GO:1901437": "regulation of toluene metabolic process",
  "GO:1901438": "negative regulation of toluene metabolic process",
  "GO:1901439": "positive regulation of toluene metabolic process",
  "GO:1901440": "poly(hydroxyalkanoate) metabolic process",
  "GO:1901441": "poly(hydroxyalkanoate) biosynthetic process",
  "GO:1901442": "regulation of response to furfural",
  "GO:1901443": "negative regulation of response to furfural",
  "GO:1901444": "positive regulation of response to furfural",
  "GO:1901445": "regulation of response to propan-1-ol",
  "GO:1901446": "negative regulation of response to propan-1-ol",
  "GO:1901447": "positive regulation of response to propan-1-ol",
  "GO:1901448": "regulation of response to butan-1-ol",
  "GO:1901449": "negative regulation of response to butan-1-ol",
  "GO:1901450": "positive regulation of response to butan-1-ol",
  "GO:1901451": "regulation of response to benzene",
  "GO:1901452": "negative regulation of response to benzene",
  "GO:1901453": "positive regulation of response to benzene",
  "GO:1901454": "regulation of response to toluene",
  "GO:1901455": "negative regulation of response to toluene",
  "GO:1901456": "positive regulation of response to toluene",
  "GO:1901457": "regulation of response to acetate",
  "GO:1901458": "negative regulation of response to acetate",
  "GO:1901459": "positive regulation of response to acetate",
  "GO:1901460": "regulation of response to formic acid",
  "GO:1901461": "negative regulation of response to formic acid",
  "GO:1901462": "positive regulation of response to formic acid",
  "GO:1901463": "regulation of tetrapyrrole biosynthetic process",
  "GO:1901464": "negative regulation of tetrapyrrole biosynthetic process",
  "GO:1901465": "positive regulation of tetrapyrrole biosynthetic process",
  "GO:1901466": "regulation of ferulate catabolic process",
  "GO:1901467": "negative regulation of ferulate catabolic process",
  "GO:1901468": "positive regulation of ferulate catabolic process",
  "GO:1901469": "regulation of syringal lignin catabolic process",
  "GO:1901470": "negative regulation of syringal lignin catabolic process",
  "GO:1901471": "positive regulation of syringal lignin catabolic process",
  "GO:1901472": "regulation of Golgi calcium ion export",
  "GO:1901474": "azole transmembrane transporter activity",
  "GO:1901475": "pyruvate transmembrane transport",
  "GO:1901476": "carbohydrate transporter activity",
  "GO:1901477": "benomyl transmembrane transport",
  "GO:1901478": "aminotriazole transmembrane transporter activity",
  "GO:1901479": "benomyl transmembrane transporter activity",
  "GO:1901480": "oleate transporter activity",
  "GO:1901481": "L-glutamate import involved in cellular response to nitrogen starvation",
  "GO:1901482": "L-lysine import involved in cellular response to nitrogen starvation",
  "GO:1901483": "regulation of transcription factor catabolic process",
  "GO:1901484": "negative regulation of transcription factor catabolic process",
  "GO:1901485": "positive regulation of transcription factor catabolic process",
  "GO:1901486": "negative regulation of SREBP signaling pathway by positive regulation of transcription factor catabolic process",
  "GO:1901487": "negative regulation of SREBP signaling pathway by positive regulation of transcription factor catabolic process in response to increased oxygen levels",
  "GO:1901488": "positive regulation of SREBP signaling pathway by negative regulation of transcription factor catabolic process",
  "GO:1901489": "positive regulation of SREBP signaling pathway by negative regulation of transcription factor catabolic process in response to decreased oxygen levels",
  "GO:1901490": "regulation of lymphangiogenesis",
  "GO:1901491": "negative regulation of lymphangiogenesis",
  "GO:1901492": "positive regulation of lymphangiogenesis",
  "GO:1901493": "response to decalin",
  "GO:1901494": "regulation of cysteine metabolic process",
  "GO:1901495": "negative regulation of cysteine metabolic process",
  "GO:1901496": "positive regulation of cysteine metabolic process",
  "GO:1901497": "response to diphenyl ether",
  "GO:1901498": "response to tetralin",
  "GO:1901499": "response to hexane",
  "GO:1901500": "response to p-xylene",
  "GO:1901501": "response to xylene",
  "GO:1901502": "ether catabolic process",
  "GO:1901503": "ether biosynthetic process",
  "GO:1901504": "triazole transport",
  "GO:1901505": "carbohydrate derivative transporter activity",
  "GO:1901506": "regulation of acylglycerol transport",
  "GO:1901507": "negative regulation of acylglycerol transport",
  "GO:1901508": "positive regulation of acylglycerol transport",
  "GO:1901509": "regulation of endothelial tube morphogenesis",
  "GO:1901510": "(-)-microperfuranone metabolic process",
  "GO:1901511": "(-)-microperfuranone catabolic process",
  "GO:1901512": "(-)-microperfuranone biosynthetic process",
  "GO:1901513": "lipo-chitin oligosaccharide transmembrane transporter activity",
  "GO:1901514": "lipo-chitin oligosaccharide transmembrane-transporting ATPase activity",
  "GO:1901515": "poly-beta-1,6-N-acetyl-D-glucosamine transmembrane transporter activity",
  "GO:1901516": "aspyridone A metabolic process",
  "GO:1901517": "aspyridone A catabolic process",
  "GO:1901518": "aspyridone A biosynthetic process",
  "GO:1901519": "aspyridone B metabolic process",
  "GO:1901520": "aspyridone B catabolic process",
  "GO:1901521": "aspyridone B biosynthetic process",
  "GO:1901522": "positive regulation of transcription from RNA polymerase II promoter involved in cellular response to chemical stimulus",
  "GO:1901523": "icosanoid catabolic process",
  "GO:1901524": "regulation of macromitophagy",
  "GO:1901525": "negative regulation of macromitophagy",
  "GO:1901526": "positive regulation of macromitophagy",
  "GO:1901527": "abscisic acid-activated signaling pathway involved in stomatal movement",
  "GO:1901528": "hydrogen peroxide mediated signaling pathway involved in stomatal movement",
  "GO:1901529": "positive regulation of anion channel activity",
  "GO:1901530": "response to hypochlorite",
  "GO:1901531": "hypochlorite binding",
  "GO:1901532": "regulation of hematopoietic progenitor cell differentiation",
  "GO:1901533": "negative regulation of hematopoietic progenitor cell differentiation",
  "GO:1901534": "positive regulation of hematopoietic progenitor cell differentiation",
  "GO:1901535": "regulation of DNA demethylation",
  "GO:1901536": "negative regulation of DNA demethylation",
  "GO:1901537": "positive regulation of DNA demethylation",
  "GO:1901538": "changes to DNA methylation involved in embryo development",
  "GO:1901539": "ent-pimara-8(14),15-diene metabolic process",
  "GO:1901540": "ent-pimara-8(14),15-diene catabolic process",
  "GO:1901541": "ent-pimara-8(14),15-diene biosynthetic process",
  "GO:1901542": "regulation of ent-pimara-8(14),15-diene biosynthetic process",
  "GO:1901543": "negative regulation of ent-pimara-8(14),15-diene biosynthetic process",
  "GO:1901544": "positive regulation of ent-pimara-8(14),15-diene biosynthetic process",
  "GO:1901545": "response to raffinose",
  "GO:1901546": "regulation of synaptic vesicle lumen acidification",
  "GO:1901547": "negative regulation of synaptic vesicle lumen acidification",
  "GO:1901548": "positive regulation of synaptic vesicle lumen acidification",
  "GO:1901549": "malonic acid uptake transmembrane transporter activity",
  "GO:1901550": "regulation of endothelial cell development",
  "GO:1901551": "negative regulation of endothelial cell development",
  "GO:1901552": "positive regulation of endothelial cell development",
  "GO:1901553": "malonic acid transmembrane transport",
  "GO:1901554": "response to paracetamol",
  "GO:1901555": "response to paclitaxel",
  "GO:1901556": "response to candesartan",
  "GO:1901557": "response to fenofibrate",
  "GO:1901558": "response to metformin",
  "GO:1901559": "response to ribavirin",
  "GO:1901560": "response to purvalanol A",
  "GO:1901561": "response to benomyl",
  "GO:1901562": "response to paraquat",
  "GO:1901563": "response to camptothecin",
  "GO:1901564": "organonitrogen compound metabolic process",
  "GO:1901565": "organonitrogen compound catabolic process",
  "GO:1901566": "organonitrogen compound biosynthetic process",
  "GO:1901567": "fatty acid derivative binding",
  "GO:1901568": "fatty acid derivative metabolic process",
  "GO:1901569": "fatty acid derivative catabolic process",
  "GO:1901570": "fatty acid derivative biosynthetic process",
  "GO:1901571": "fatty acid derivative transport",
  "GO:1901572": "obsolete chemical substance metabolic process",
  "GO:1901573": "obsolete chemical substance catabolic process",
  "GO:1901574": "obsolete chemical substance biosynthetic process",
  "GO:1901575": "organic substance catabolic process",
  "GO:1901576": "organic substance biosynthetic process",
  "GO:1901577": "regulation of alkane biosynthetic process",
  "GO:1901578": "negative regulation of alkane biosynthetic process",
  "GO:1901579": "positive regulation of alkane biosynthetic process",
  "GO:1901580": "regulation of telomeric RNA transcription from RNA pol II promoter",
  "GO:1901581": "negative regulation of telomeric RNA transcription from RNA pol II promoter",
  "GO:1901582": "positive regulation of telomeric RNA transcription from RNA pol II promoter",
  "GO:1901583": "tetrapeptide transmembrane transport",
  "GO:1901584": "tetrapeptide transmembrane transporter activity",
  "GO:1901585": "regulation of acid-sensing ion channel activity",
  "GO:1901586": "negative regulation of acid-sensing ion channel activity",
  "GO:1901587": "positive regulation of acid-sensing ion channel activity",
  "GO:1901588": "dendritic microtubule",
  "GO:1901589": "axon microtubule bundle",
  "GO:1901591": "regulation of double-strand break repair via break-induced replication",
  "GO:1901592": "negative regulation of double-strand break repair via break-induced replication",
  "GO:1901593": "response to GW 7647",
  "GO:1901594": "response to capsazepine",
  "GO:1901595": "response to hesperadin",
  "GO:1901596": "response to reversine",
  "GO:1901597": "response to carbendazim",
  "GO:1901598": "(-)-pinoresinol metabolic process",
  "GO:1901599": "(-)-pinoresinol biosynthetic process",
  "GO:1901600": "strigolactone metabolic process",
  "GO:1901601": "strigolactone biosynthetic process",
  "GO:1901602": "dethiobiotin binding",
  "GO:1901603": "biotin transmembrane transporter activity",
  "GO:1901604": "dethiobiotin transmembrane transporter activity",
  "GO:1901605": "alpha-amino acid metabolic process",
  "GO:1901606": "alpha-amino acid catabolic process",
  "GO:1901607": "alpha-amino acid biosynthetic process",
  "GO:1901608": "regulation of vesicle transport along microtubule",
  "GO:1901609": "negative regulation of vesicle transport along microtubule",
  "GO:1901610": "positive regulation of vesicle transport along microtubule",
  "GO:1901611": "phosphatidylglycerol binding",
  "GO:1901612": "cardiolipin binding",
  "GO:1901613": "negative regulation of terminal button organization",
  "GO:1901614": "positive regulation of terminal button organization",
  "GO:1901615": "organic hydroxy compound metabolic process",
  "GO:1901616": "organic hydroxy compound catabolic process",
  "GO:1901617": "organic hydroxy compound biosynthetic process",
  "GO:1901618": "organic hydroxy compound transmembrane transporter activity",
  "GO:1901619": "tRNA methylation in response to nitrogen starvation",
  "GO:1901620": "regulation of smoothened signaling pathway involved in dorsal/ventral neural tube patterning",
  "GO:1901621": "negative regulation of smoothened signaling pathway involved in dorsal/ventral neural tube patterning",
  "GO:1901622": "positive regulation of smoothened signaling pathway involved in dorsal/ventral neural tube patterning",
  "GO:1901623": "regulation of lymphocyte chemotaxis",
  "GO:1901624": "negative regulation of lymphocyte chemotaxis",
  "GO:1901625": "cellular response to ergosterol",
  "GO:1901626": "regulation of postsynaptic membrane organization",
  "GO:1901627": "negative regulation of postsynaptic membrane organization",
  "GO:1901628": "positive regulation of postsynaptic membrane organization",
  "GO:1901629": "regulation of presynaptic membrane organization",
  "GO:1901630": "negative regulation of presynaptic membrane organization",
  "GO:1901631": "positive regulation of presynaptic membrane organization",
  "GO:1901632": "regulation of synaptic vesicle membrane organization",
  "GO:1901633": "negative regulation of synaptic vesicle membrane organization",
  "GO:1901634": "positive regulation of synaptic vesicle membrane organization",
  "GO:1901635": "obsolete regulation of maintenance of presynaptic active zone structure",
  "GO:1901636": "obsolete negative regulation of maintenance of presynaptic active zone structure",
  "GO:1901637": "obsolete positive regulation of maintenance of presynaptic active zone structure",
  "GO:1901638": "obsolete copper ion import into ascospore-type prospore",
  "GO:1901639": "XDP catabolic process",
  "GO:1901640": "XTP binding",
  "GO:1901641": "ITP binding",
  "GO:1901642": "nucleoside transmembrane transport",
  "GO:1901643": "regulation of tRNA methylation in response to nitrogen starvation",
  "GO:1901644": "positive regulation of tRNA methylation in response to nitrogen starvation",
  "GO:1901645": "regulation of synoviocyte proliferation",
  "GO:1901646": "negative regulation of synoviocyte proliferation",
  "GO:1901647": "positive regulation of synoviocyte proliferation",
  "GO:1901648": "regulation of actomyosin contractile ring localization",
  "GO:1901649": "negative regulation of actomyosin contractile ring localization",
  "GO:1901650": "positive regulation of actomyosin contractile ring localization",
  "GO:1901651": "regulation of mitotic chromosome decondensation",
  "GO:1901652": "response to peptide",
  "GO:1901653": "cellular response to peptide",
  "GO:1901654": "response to ketone",
  "GO:1901655": "cellular response to ketone",
  "GO:1901656": "glycoside transport",
  "GO:1901657": "glycosyl compound metabolic process",
  "GO:1901658": "glycosyl compound catabolic process",
  "GO:1901659": "glycosyl compound biosynthetic process",
  "GO:1901660": "calcium ion export",
  "GO:1901661": "quinone metabolic process",
  "GO:1901662": "quinone catabolic process",
  "GO:1901663": "quinone biosynthetic process",
  "GO:1901664": "regulation of NAD+ ADP-ribosyltransferase activity",
  "GO:1901665": "negative regulation of NAD+ ADP-ribosyltransferase activity",
  "GO:1901666": "positive regulation of NAD+ ADP-ribosyltransferase activity",
  "GO:1901667": "negative regulation of skeletal muscle satellite cell activation involved in skeletal muscle regeneration",
  "GO:1901668": "regulation of superoxide dismutase activity",
  "GO:1901670": "negative regulation of superoxide dismutase activity",
  "GO:1901671": "positive regulation of superoxide dismutase activity",
  "GO:1901672": "positive regulation of systemic acquired resistance",
  "GO:1901673": "regulation of mitotic spindle assembly",
  "GO:1901674": "regulation of histone H3-K27 acetylation",
  "GO:1901675": "negative regulation of histone H3-K27 acetylation",
  "GO:1901676": "positive regulation of histone H3-K27 acetylation",
  "GO:1901677": "phosphate transmembrane transporter activity",
  "GO:1901678": "iron coordination entity transport",
  "GO:1901679": "nucleotide transmembrane transport",
  "GO:1901680": "sulfur-containing amino acid secondary active transmembrane transporter activity",
  "GO:1901681": "sulfur compound binding",
  "GO:1901682": "sulfur compound transmembrane transporter activity",
  "GO:1901683": "arsenate ion transmembrane transporter activity",
  "GO:1901684": "arsenate ion transmembrane transport",
  "GO:1901685": "glutathione derivative metabolic process",
  "GO:1901686": "glutathione derivative catabolic process",
  "GO:1901687": "glutathione derivative biosynthetic process",
  "GO:1901688": "pantothenate import",
  "GO:1901689": "biotin import",
  "GO:1901690": "dethiobiotin import",
  "GO:1901691": "proton binding",
  "GO:1901692": "regulation of compound eye retinal cell apoptotic process",
  "GO:1901693": "negative regulation of compound eye retinal cell apoptotic process",
  "GO:1901694": "positive regulation of compound eye retinal cell apoptotic process",
  "GO:1901695": "tyramine biosynthetic process",
  "GO:1901696": "cannabinoid biosynthetic process",
  "GO:1901697": "olivetolic acid biosynthetic process",
  "GO:1901698": "response to nitrogen compound",
  "GO:1901699": "cellular response to nitrogen compound",
  "GO:1901700": "response to oxygen-containing compound",
  "GO:1901701": "cellular response to oxygen-containing compound",
  "GO:1901702": "salt transmembrane transporter activity",
  "GO:1901703": "protein localization involved in auxin polar transport",
  "GO:1901704": "L-glutamine biosynthetic process",
  "GO:1901705": "L-isoleucine biosynthetic process",
  "GO:1901706": "mesenchymal cell differentiation involved in bone development",
  "GO:1901707": "leptomycin B binding",
  "GO:1901708": "(+)-3'-hydroxylarreatricin biosynthetic process",
  "GO:1901709": "(+)-larreatricin metabolic process",
  "GO:1901710": "regulation of homoserine biosynthetic process",
  "GO:1901711": "negative regulation of homoserine biosynthetic process",
  "GO:1901712": "positive regulation of homoserine biosynthetic process",
  "GO:1901713": "negative regulation of urea catabolic process",
  "GO:1901714": "positive regulation of urea catabolic process",
  "GO:1901715": "regulation of gamma-aminobutyric acid catabolic process",
  "GO:1901716": "negative regulation of gamma-aminobutyric acid catabolic process",
  "GO:1901717": "positive regulation of gamma-aminobutyric acid catabolic process",
  "GO:1901718": "regulation of dipeptide transmembrane transport by regulation of transcription from RNA polymerase II promoter",
  "GO:1901719": "regulation of NMS complex assembly involved in kinetochore assembly",
  "GO:1901720": "negative regulation of NMS complex assembly involved in kinetochore assembly",
  "GO:1901721": "positive regulation of NMS complex assembly involved in kinetochore assembly",
  "GO:1901722": "regulation of cell proliferation involved in kidney development",
  "GO:1901723": "negative regulation of cell proliferation involved in kidney development",
  "GO:1901724": "positive regulation of cell proliferation involved in kidney development",
  "GO:1901725": "regulation of histone deacetylase activity",
  "GO:1901726": "negative regulation of histone deacetylase activity",
  "GO:1901727": "positive regulation of histone deacetylase activity",
  "GO:1901728": "monensin A metabolic process",
  "GO:1901729": "monensin A catabolic process",
  "GO:1901730": "monensin A biosynthetic process",
  "GO:1901731": "positive regulation of platelet aggregation",
  "GO:1901732": "quercetin metabolic process",
  "GO:1901733": "quercetin catabolic process",
  "GO:1901734": "quercetin biosynthetic process",
  "GO:1901735": "(R)-mevalonic acid metabolic process",
  "GO:1901736": "(R)-mevalonic acid catabolic process",
  "GO:1901737": "(R)-mevalonic acid biosynthetic process",
  "GO:1901738": "regulation of vitamin A metabolic process",
  "GO:1901739": "regulation of myoblast fusion",
  "GO:1901740": "negative regulation of myoblast fusion",
  "GO:1901741": "positive regulation of myoblast fusion",
  "GO:1901742": "2-deoxystreptamine metabolic process",
  "GO:1901743": "2-deoxystreptamine catabolic process",
  "GO:1901744": "2-deoxystreptamine biosynthetic process",
  "GO:1901745": "prephenate(2-) metabolic process",
  "GO:1901746": "prephenate(2-) catabolic process",
  "GO:1901747": "prephenate(2-) biosynthetic process",
  "GO:1901748": "leukotriene D4 metabolic process",
  "GO:1901749": "leukotriene D4 catabolic process",
  "GO:1901750": "leukotriene D4 biosynthetic process",
  "GO:1901751": "leukotriene A4 metabolic process",
  "GO:1901752": "leukotriene A4 catabolic process",
  "GO:1901753": "leukotriene A4 biosynthetic process",
  "GO:1901754": "vitamin D3 catabolic process",
  "GO:1901755": "vitamin D3 biosynthetic process",
  "GO:1901756": "butirosin metabolic process",
  "GO:1901757": "butirosin catabolic process",
  "GO:1901758": "butirosin biosynthetic process",
  "GO:1901759": "beta-L-Ara4N-lipid A metabolic process",
  "GO:1901760": "beta-L-Ara4N-lipid A biosynthetic process",
  "GO:1901761": "oxytetracycline metabolic process",
  "GO:1901762": "oxytetracycline catabolic process",
  "GO:1901763": "oxytetracycline biosynthetic process",
  "GO:1901764": "phosphinothricin metabolic process",
  "GO:1901765": "phosphinothricin catabolic process",
  "GO:1901766": "phosphinothricin biosynthetic process",
  "GO:1901767": "carbapenem metabolic process",
  "GO:1901768": "carbapenem catabolic process",
  "GO:1901769": "carbapenem biosynthetic process",
  "GO:1901770": "daunorubicin catabolic process",
  "GO:1901771": "daunorubicin biosynthetic process",
  "GO:1901772": "lincomycin metabolic process",
  "GO:1901773": "lincomycin catabolic process",
  "GO:1901774": "lincomycin biosynthetic process",
  "GO:1901775": "mitomycin C metabolic process",
  "GO:1901776": "mitomycin C catabolic process",
  "GO:1901777": "mitomycin C biosynthetic process",
  "GO:1901778": "pentalenolactone metabolic process",
  "GO:1901779": "pentalenolactone catabolic process",
  "GO:1901780": "pentalenolactone biosynthetic process",
  "GO:1901781": "p-cumate metabolic process",
  "GO:1901782": "p-cumate catabolic process",
  "GO:1901783": "p-cumate biosynthetic process",
  "GO:1901784": "p-cresol metabolic process",
  "GO:1901785": "p-cresol catabolic process",
  "GO:1901786": "p-cresol biosynthetic process",
  "GO:1901787": "benzoyl-CoA metabolic process",
  "GO:1901788": "benzoyl-CoA catabolic process",
  "GO:1901789": "benzoyl-CoA biosynthetic process",
  "GO:1901790": "3-(2,3-dihydroxyphenyl)propanoate metabolic process",
  "GO:1901791": "3-(2,3-dihydroxyphenyl)propanoate catabolic process",
  "GO:1901792": "3-(2,3-dihydroxyphenyl)propanoate biosynthetic process",
  "GO:1901793": "3-(3-hydroxyphenyl)propanoate metabolic process",
  "GO:1901794": "3-(3-hydroxyphenyl)propanoate catabolic process",
  "GO:1901795": "3-(3-hydroxyphenyl)propanoate biosynthetic process",
  "GO:1901796": "regulation of signal transduction by p53 class mediator",
  "GO:1901797": "negative regulation of signal transduction by p53 class mediator",
  "GO:1901798": "positive regulation of signal transduction by p53 class mediator",
  "GO:1901799": "negative regulation of proteasomal protein catabolic process",
  "GO:1901800": "positive regulation of proteasomal protein catabolic process",
  "GO:1901801": "1,5-anhydro-D-fructose metabolic process",
  "GO:1901802": "1,5-anhydro-D-fructose catabolic process",
  "GO:1901803": "1,5-anhydro-D-fructose biosynthetic process",
  "GO:1901804": "beta-glucoside metabolic process",
  "GO:1901805": "beta-glucoside catabolic process",
  "GO:1901806": "beta-glucoside biosynthetic process",
  "GO:1901807": "capsanthin metabolic process",
  "GO:1901808": "capsanthin catabolic process",
  "GO:1901809": "capsanthin biosynthetic process",
  "GO:1901810": "beta-carotene metabolic process",
  "GO:1901811": "beta-carotene catabolic process",
  "GO:1901812": "beta-carotene biosynthetic process",
  "GO:1901813": "astaxanthin metabolic process",
  "GO:1901814": "astaxanthin catabolic process",
  "GO:1901815": "astaxanthin biosynthetic process",
  "GO:1901816": "beta-zeacarotene metabolic process",
  "GO:1901817": "beta-zeacarotene catabolic process",
  "GO:1901818": "beta-zeacarotene biosynthetic process",
  "GO:1901819": "alpha-zeacarotene metabolic process",
  "GO:1901820": "alpha-zeacarotene catabolic process",
  "GO:1901821": "alpha-zeacarotene biosynthetic process",
  "GO:1901822": "delta-carotene metabolic process",
  "GO:1901823": "delta-carotene catabolic process",
  "GO:1901824": "delta-carotene biosynthetic process",
  "GO:1901825": "zeaxanthin metabolic process",
  "GO:1901826": "zeaxanthin catabolic process",
  "GO:1901827": "zeaxanthin biosynthetic process",
  "GO:1901828": "zeaxanthin bis(beta-D-glucoside) metabolic process",
  "GO:1901829": "zeaxanthin bis(beta-D-glucoside) catabolic process",
  "GO:1901830": "zeaxanthin bis(beta-D-glucoside) biosynthetic process",
  "GO:1901831": "all-trans-neoxanthin metabolic process",
  "GO:1901832": "all-trans-neoxanthin catabolic process",
  "GO:1901833": "all-trans-neoxanthin biosynthetic process",
  "GO:1901834": "regulation of deadenylation-independent decapping of nuclear-transcribed mRNA",
  "GO:1901835": "positive regulation of deadenylation-independent decapping of nuclear-transcribed mRNA",
  "GO:1901836": "regulation of transcription of nuclear large rRNA transcript from RNA polymerase I promoter",
  "GO:1901837": "negative regulation of transcription of nuclear large rRNA transcript from RNA polymerase I promoter",
  "GO:1901838": "positive regulation of transcription of nuclear large rRNA transcript from RNA polymerase I promoter",
  "GO:1901839": "regulation of RNA polymerase I regulatory region sequence-specific DNA binding",
  "GO:1901840": "negative regulation of RNA polymerase I regulatory region sequence-specific DNA binding",
  "GO:1901841": "regulation of high voltage-gated calcium channel activity",
  "GO:1901842": "negative regulation of high voltage-gated calcium channel activity",
  "GO:1901843": "positive regulation of high voltage-gated calcium channel activity",
  "GO:1901844": "regulation of cell communication by electrical coupling involved in cardiac conduction",
  "GO:1901845": "negative regulation of cell communication by electrical coupling involved in cardiac conduction",
  "GO:1901846": "positive regulation of cell communication by electrical coupling involved in cardiac conduction",
  "GO:1901847": "nicotinate metabolic process",
  "GO:1901848": "nicotinate catabolic process",
  "GO:1901849": "nicotinate biosynthetic process",
  "GO:1901850": "7,8-didemethyl-8-hydroxy-5-deazariboflavin metabolic process",
  "GO:1901851": "7,8-didemethyl-8-hydroxy-5-deazariboflavin catabolic process",
  "GO:1901852": "7,8-didemethyl-8-hydroxy-5-deazariboflavin biosynthetic process",
  "GO:1901853": "5,6,7,8-tetrahydrosarcinapterin metabolic process",
  "GO:1901854": "5,6,7,8-tetrahydrosarcinapterin catabolic process",
  "GO:1901855": "5,6,7,8-tetrahydrosarcinapterin biosynthetic process",
  "GO:1901856": "negative regulation of cellular respiration",
  "GO:1901857": "positive regulation of cellular respiration",
  "GO:1901858": "regulation of mitochondrial DNA metabolic process",
  "GO:1901859": "negative regulation of mitochondrial DNA metabolic process",
  "GO:1901860": "positive regulation of mitochondrial DNA metabolic process",
  "GO:1901861": "regulation of muscle tissue development",
  "GO:1901862": "negative regulation of muscle tissue development",
  "GO:1901863": "positive regulation of muscle tissue development",
  "GO:1901864": "capsorubin metabolic process",
  "GO:1901865": "capsorubin catabolic process",
  "GO:1901866": "capsorubin biosynthetic process",
  "GO:1901867": "ecgonine methyl ester metabolic process",
  "GO:1901868": "ecgonine methyl ester catabolic process",
  "GO:1901869": "ecgonine methyl ester biosynthetic process",
  "GO:1901870": "ecgonone methyl ester metabolic process",
  "GO:1901871": "ecgonone methyl ester catabolic process",
  "GO:1901872": "ecgonone methyl ester biosynthetic process",
  "GO:1901873": "regulation of post-translational protein modification",
  "GO:1901874": "negative regulation of post-translational protein modification",
  "GO:1901875": "positive regulation of post-translational protein modification",
  "GO:1901876": "regulation of calcium ion binding",
  "GO:1901877": "negative regulation of calcium ion binding",
  "GO:1901878": "positive regulation of calcium ion binding",
  "GO:1901879": "regulation of protein depolymerization",
  "GO:1901880": "negative regulation of protein depolymerization",
  "GO:1901881": "positive regulation of protein depolymerization",
  "GO:1901882": "4-hydroxycoumarin metabolic process",
  "GO:1901883": "4-hydroxycoumarin catabolic process",
  "GO:1901884": "4-hydroxycoumarin biosynthetic process",
  "GO:1901885": "2-hydroxybenzoyl-CoA metabolic process",
  "GO:1901886": "2-hydroxybenzoyl-CoA catabolic process",
  "GO:1901887": "2-hydroxybenzoyl-CoA biosynthetic process",
  "GO:1901888": "regulation of cell junction assembly",
  "GO:1901889": "negative regulation of cell junction assembly",
  "GO:1901890": "positive regulation of cell junction assembly",
  "GO:1901891": "regulation of cell septum assembly",
  "GO:1901892": "negative regulation of cell septum assembly",
  "GO:1901893": "positive regulation of cell septum assembly",
  "GO:1901894": "regulation of calcium-transporting ATPase activity",
  "GO:1901895": "negative regulation of calcium-transporting ATPase activity",
  "GO:1901896": "positive regulation of calcium-transporting ATPase activity",
  "GO:1901897": "regulation of relaxation of cardiac muscle",
  "GO:1901898": "negative regulation of relaxation of cardiac muscle",
  "GO:1901899": "positive regulation of relaxation of cardiac muscle",
  "GO:1901900": "regulation of protein localization to cell division site",
  "GO:1901901": "regulation of protein localization to cell division site involved in cytokinesis",
  "GO:1901902": "tyrocidine metabolic process",
  "GO:1901903": "tyrocidine catabolic process",
  "GO:1901904": "tyrocidine biosynthetic process",
  "GO:1901905": "response to tamsulosin",
  "GO:1901906": "diadenosine pentaphosphate metabolic process",
  "GO:1901907": "diadenosine pentaphosphate catabolic process",
  "GO:1901908": "diadenosine hexaphosphate metabolic process",
  "GO:1901909": "diadenosine hexaphosphate catabolic process",
  "GO:1901910": "adenosine 5'-(hexahydrogen pentaphosphate) metabolic process",
  "GO:1901911": "adenosine 5'-(hexahydrogen pentaphosphate) catabolic process",
  "GO:1901913": "regulation of capsule organization",
  "GO:1901914": "negative regulation of capsule organization",
  "GO:1901915": "positive regulation of capsule organization",
  "GO:1901916": "protein kinase activity involved in regulation of protein localization to cell division site involved in cytokinesis",
  "GO:1901917": "regulation of exoribonuclease activity",
  "GO:1901918": "negative regulation of exoribonuclease activity",
  "GO:1901919": "positive regulation of exoribonuclease activity",
  "GO:1901920": "peptidyl-tyrosine dephosphorylation involved in activation of protein kinase activity",
  "GO:1901921": "phosphorylation of RNA polymerase II C-terminal domain involved in recruitment of 3'-end processing factors to RNA polymerase II holoenzyme complex",
  "GO:1901922": "regulation of sclerotium development",
  "GO:1901923": "negative regulation of sclerotium development",
  "GO:1901924": "positive regulation of sclerotium development",
  "GO:1901925": "negative regulation of protein import into nucleus during spindle assembly checkpoint",
  "GO:1901926": "cadinene metabolic process",
  "GO:1901927": "cadinene catabolic process",
  "GO:1901928": "cadinene biosynthetic process",
  "GO:1901929": "alpha-copaene metabolic process",
  "GO:1901930": "alpha-copaene catabolic process",
  "GO:1901931": "alpha-copaene biosynthetic process",
  "GO:1901932": "bicyclogermacrene metabolic process",
  "GO:1901933": "bicyclogermacrene catabolic process",
  "GO:1901934": "bicyclogermacrene biosynthetic process",
  "GO:1901935": "beta-caryophyllene metabolic process",
  "GO:1901936": "beta-caryophyllene catabolic process",
  "GO:1901937": "beta-caryophyllene biosynthetic process",
  "GO:1901938": "(-)-exo-alpha-bergamotene metabolic process",
  "GO:1901939": "(-)-exo-alpha-bergamotene catabolic process",
  "GO:1901940": "(-)-exo-alpha-bergamotene biosynthetic process",
  "GO:1901941": "(+)-epi-alpha-bisabolol metabolic process",
  "GO:1901942": "(+)-epi-alpha-bisabolol catabolic process",
  "GO:1901943": "(+)-epi-alpha-bisabolol biosynthetic process",
  "GO:1901944": "miltiradiene metabolic process",
  "GO:1901945": "miltiradiene catabolic process",
  "GO:1901946": "miltiradiene biosynthetic process",
  "GO:1901947": "5alpha,9alpha,10beta-labda-8(20),13-dien-15-yl diphosphate metabolic process",
  "GO:1901948": "5alpha,9alpha,10beta-labda-8(20),13-dien-15-yl diphosphate catabolic process",
  "GO:1901949": "5alpha,9alpha,10beta-labda-8(20),13-dien-15-yl diphosphate biosynthetic process",
  "GO:1901950": "dense core granule transport",
  "GO:1901951": "regulation of anterograde dense core granule transport",
  "GO:1901952": "negative regulation of anterograde dense core granule transport",
  "GO:1901953": "positive regulation of anterograde dense core granule transport",
  "GO:1901954": "regulation of retrograde dense core granule transport",
  "GO:1901955": "negative regulation of retrograde dense core granule transport",
  "GO:1901956": "positive regulation of retrograde dense core granule transport",
  "GO:1901957": "regulation of cutin biosynthetic process",
  "GO:1901958": "negative regulation of cutin biosynthetic process",
  "GO:1901959": "positive regulation of cutin biosynthetic process",
  "GO:1901960": "isobutanol metabolic process",
  "GO:1901961": "isobutanol biosynthetic process",
  "GO:1901962": "S-adenosyl-L-methionine transmembrane transport",
  "GO:1901963": "regulation of cell proliferation involved in outflow tract morphogenesis",
  "GO:1901964": "positive regulation of cell proliferation involved in outflow tract morphogenesis",
  "GO:1901965": "endoplasmic reticulum to chloroplast transport",
  "GO:1901966": "regulation of cellular response to iron ion starvation",
  "GO:1901967": "negative regulation of cellular response to iron ion starvation",
  "GO:1901968": "regulation of polynucleotide 3'-phosphatase activity",
  "GO:1901969": "positive regulation of polynucleotide 3'-phosphatase activity",
  "GO:1901970": "positive regulation of mitotic sister chromatid separation",
  "GO:1901971": "regulation of DNA-5-methylcytosine glycosylase activity",
  "GO:1901972": "positive regulation of DNA-5-methylcytosine glycosylase activity",
  "GO:1901973": "proline binding",
  "GO:1901974": "glycerate transmembrane transporter activity",
  "GO:1901975": "glycerate transmembrane transport",
  "GO:1901976": "regulation of cell cycle checkpoint",
  "GO:1901977": "negative regulation of cell cycle checkpoint",
  "GO:1901978": "positive regulation of cell cycle checkpoint",
  "GO:1901979": "regulation of inward rectifier potassium channel activity",
  "GO:1901980": "positive regulation of inward rectifier potassium channel activity",
  "GO:1901981": "phosphatidylinositol phosphate binding",
  "GO:1901982": "maltose binding",
  "GO:1901983": "regulation of protein acetylation",
  "GO:1901984": "negative regulation of protein acetylation",
  "GO:1901985": "positive regulation of protein acetylation",
  "GO:1901986": "response to ketamine",
  "GO:1901987": "regulation of cell cycle phase transition",
  "GO:1901988": "negative regulation of cell cycle phase transition",
  "GO:1901989": "positive regulation of cell cycle phase transition",
  "GO:1901990": "regulation of mitotic cell cycle phase transition",
  "GO:1901991": "negative regulation of mitotic cell cycle phase transition",
  "GO:1901992": "positive regulation of mitotic cell cycle phase transition",
  "GO:1901993": "regulation of meiotic cell cycle phase transition",
  "GO:1901994": "negative regulation of meiotic cell cycle phase transition",
  "GO:1901995": "positive regulation of meiotic cell cycle phase transition",
  "GO:1901996": "regulation of indoleacetic acid biosynthetic process via tryptophan",
  "GO:1901997": "negative regulation of indoleacetic acid biosynthetic process via tryptophan",
  "GO:1901998": "toxin transport",
  "GO:1901999": "homogentisate metabolic process",
  "GO:1902000": "homogentisate catabolic process",
  "GO:1902001": "fatty acid transmembrane transport",
  "GO:1902002": "protein phosphorylation involved in cellular protein catabolic process",
  "GO:1902003": "regulation of beta-amyloid formation",
  "GO:1902004": "positive regulation of beta-amyloid formation",
  "GO:1902005": "regulation of proline biosynthetic process",
  "GO:1902006": "negative regulation of proline biosynthetic process",
  "GO:1902007": "regulation of toxin transport",
  "GO:1902008": "negative regulation of toxin transport",
  "GO:1902009": "positive regulation of toxin transport",
  "GO:1902010": "negative regulation of translation in response to endoplasmic reticulum stress",
  "GO:1902011": "poly(ribitol phosphate) teichoic acid metabolic process",
  "GO:1902012": "poly(ribitol phosphate) teichoic acid biosynthetic process",
  "GO:1902013": "poly(glycerol phosphate) teichoic acid metabolic process",
  "GO:1902014": "poly(glycerol phosphate) teichoic acid biosynthetic process",
  "GO:1902015": "poly(glucopyranosyl N-acetylgalactosamine 1-phosphate) teichoic acid metabolic process",
  "GO:1902016": "poly(glucopyranosyl N-acetylgalactosamine 1-phosphate) teichoic acid biosynthetic process",
  "GO:1902017": "regulation of cilium assembly",
  "GO:1902018": "negative regulation of cilium assembly",
  "GO:1902019": "regulation of cilium-dependent cell motility",
  "GO:1902020": "negative regulation of cilium-dependent cell motility",
  "GO:1902021": "regulation of bacterial-type flagellum-dependent cell motility",
  "GO:1902022": "L-lysine transport",
  "GO:1902023": "L-arginine transport",
  "GO:1902024": "L-histidine transport",
  "GO:1902025": "nitrate import",
  "GO:1902026": "regulation of cartilage condensation",
  "GO:1902027": "positive regulation of cartilage condensation",
  "GO:1902028": "regulation of histone H3-K18 acetylation",
  "GO:1902029": "positive regulation of histone H3-K18 acetylation",
  "GO:1902030": "negative regulation of histone H3-K18 acetylation",
  "GO:1902031": "regulation of NADP metabolic process",
  "GO:1902032": "obsolete regulation of transcription from RNA polymerase II promoter involved in response to osmotic stress",
  "GO:1902033": "regulation of hematopoietic stem cell proliferation",
  "GO:1902034": "negative regulation of hematopoietic stem cell proliferation",
  "GO:1902035": "positive regulation of hematopoietic stem cell proliferation",
  "GO:1902036": "regulation of hematopoietic stem cell differentiation",
  "GO:1902037": "negative regulation of hematopoietic stem cell differentiation",
  "GO:1902038": "positive regulation of hematopoietic stem cell differentiation",
  "GO:1902039": "negative regulation of seed dormancy process",
  "GO:1902040": "positive regulation of seed dormancy process",
  "GO:1902041": "regulation of extrinsic apoptotic signaling pathway via death domain receptors",
  "GO:1902042": "negative regulation of extrinsic apoptotic signaling pathway via death domain receptors",
  "GO:1902043": "positive regulation of extrinsic apoptotic signaling pathway via death domain receptors",
  "GO:1902044": "regulation of Fas signaling pathway",
  "GO:1902045": "negative regulation of Fas signaling pathway",
  "GO:1902046": "positive regulation of Fas signaling pathway",
  "GO:1902047": "polyamine transmembrane transport",
  "GO:1902048": "neosartoricin metabolic process",
  "GO:1902049": "neosartoricin catabolic process",
  "GO:1902050": "neosartoricin biosynthetic process",
  "GO:1902051": "(25S)-Delta(4)-dafachronate binding",
  "GO:1902052": "(25S)-Delta(7)-dafachronate binding",
  "GO:1902053": "regulation of neosartoricin biosynthetic process",
  "GO:1902054": "negative regulation of neosartoricin biosynthetic process",
  "GO:1902055": "positive regulation of neosartoricin biosynthetic process",
  "GO:1902056": "(25S)-Delta(7)-dafachronate metabolic process",
  "GO:1902057": "(25S)-Delta(4)-dafachronate metabolic process",
  "GO:1902058": "regulation of sporocarp development involved in sexual reproduction",
  "GO:1902059": "negative regulation of sporocarp development involved in sexual reproduction",
  "GO:1902060": "positive regulation of sporocarp development involved in sexual reproduction",
  "GO:1902061": "betaine aldehyde metabolic process",
  "GO:1902062": "betaine aldehyde catabolic process",
  "GO:1902063": "betaine aldehyde biosynthetic process",
  "GO:1902064": "regulation of transcription from RNA polymerase II promoter involved in spermatogenesis",
  "GO:1902065": "response to L-glutamate",
  "GO:1902066": "regulation of cell wall pectin metabolic process",
  "GO:1902067": "silicic acid import",
  "GO:1902068": "regulation of sphingolipid mediated signaling pathway",
  "GO:1902069": "negative regulation of sphingolipid mediated signaling pathway",
  "GO:1902070": "positive regulation of sphingolipid mediated signaling pathway",
  "GO:1902071": "regulation of hypoxia-inducible factor-1alpha signaling pathway",
  "GO:1902072": "negative regulation of hypoxia-inducible factor-1alpha signaling pathway",
  "GO:1902073": "positive regulation of hypoxia-inducible factor-1alpha signaling pathway",
  "GO:1902074": "response to salt",
  "GO:1902075": "cellular response to salt",
  "GO:1902076": "regulation of lateral motor column neuron migration",
  "GO:1902077": "negative regulation of lateral motor column neuron migration",
  "GO:1902078": "positive regulation of lateral motor column neuron migration",
  "GO:1902079": "D-valine catabolic process",
  "GO:1902080": "regulation of calcium ion import into sarcoplasmic reticulum",
  "GO:1902081": "negative regulation of calcium ion import into sarcoplasmic reticulum",
  "GO:1902082": "positive regulation of calcium ion import into sarcoplasmic reticulum",
  "GO:1902083": "negative regulation of peptidyl-cysteine S-nitrosylation",
  "GO:1902084": "fumagillin metabolic process",
  "GO:1902085": "fumagillin catabolic process",
  "GO:1902086": "fumagillin biosynthetic process",
  "GO:1902087": "dimethylsulfoniopropionate catabolic process",
  "GO:1902088": "plant-type cell wall loosening involved in abscission",
  "GO:1902089": "cell wall polysaccharide catabolic process involved in lateral root development",
  "GO:1902090": "regulation of fumagillin biosynthetic process",
  "GO:1902091": "negative regulation of fumagillin biosynthetic process",
  "GO:1902092": "positive regulation of fumagillin biosynthetic process",
  "GO:1902093": "positive regulation of sperm motility",
  "GO:1902094": "regulation of cartilage homeostasis",
  "GO:1902095": "negative regulation of cartilage homeostasis",
  "GO:1902096": "positive regulation of cartilage homeostasis",
  "GO:1902097": "positive regulation of transcription from RNA polymerase II promoter involved in defense response to Gram-negative bacterium",
  "GO:1902098": "calcitriol binding",
  "GO:1902099": "regulation of metaphase/anaphase transition of cell cycle",
  "GO:1902100": "negative regulation of metaphase/anaphase transition of cell cycle",
  "GO:1902101": "positive regulation of metaphase/anaphase transition of cell cycle",
  "GO:1902102": "regulation of metaphase/anaphase transition of meiotic cell cycle",
  "GO:1902103": "negative regulation of metaphase/anaphase transition of meiotic cell cycle",
  "GO:1902104": "positive regulation of metaphase/anaphase transition of meiotic cell cycle",
  "GO:1902105": "regulation of leukocyte differentiation",
  "GO:1902106": "negative regulation of leukocyte differentiation",
  "GO:1902107": "positive regulation of leukocyte differentiation",
  "GO:1902108": "regulation of mitochondrial membrane permeability involved in apoptotic process",
  "GO:1902109": "negative regulation of mitochondrial membrane permeability involved in apoptotic process",
  "GO:1902110": "positive regulation of mitochondrial membrane permeability involved in apoptotic process",
  "GO:1902111": "response to diethyl maleate",
  "GO:1902112": "cellular response to diethyl maleate",
  "GO:1902113": "nucleotide phosphorylation involved in DNA repair",
  "GO:1902114": "D-valine metabolic process",
  "GO:1902115": "regulation of organelle assembly",
  "GO:1902116": "negative regulation of organelle assembly",
  "GO:1902117": "positive regulation of organelle assembly",
  "GO:1902118": "calcidiol binding",
  "GO:1902119": "regulation of meiotic spindle elongation",
  "GO:1902120": "negative regulation of meiotic spindle elongation",
  "GO:1902121": "lithocholic acid binding",
  "GO:1902122": "chenodeoxycholic acid binding",
  "GO:1902123": "(-)-pinoresinol catabolic process",
  "GO:1902124": "(+)-pinoresinol metabolic process",
  "GO:1902125": "(+)-pinoresinol catabolic process",
  "GO:1902126": "(+)-pinoresinol biosynthetic process",
  "GO:1902127": "(-)-lariciresinol metabolic process",
  "GO:1902128": "(-)-lariciresinol catabolic process",
  "GO:1902129": "(-)-lariciresinol biosynthetic process",
  "GO:1902130": "(+)-lariciresinol metabolic process",
  "GO:1902131": "(+)-lariciresinol catabolic process",
  "GO:1902132": "(+)-lariciresinol biosynthetic process",
  "GO:1902133": "(+)-secoisolariciresinol metabolic process",
  "GO:1902134": "(+)-secoisolariciresinol catabolic process",
  "GO:1902135": "(+)-secoisolariciresinol biosynthetic process",
  "GO:1902136": "(-)-secoisolariciresinol metabolic process",
  "GO:1902137": "(-)-secoisolariciresinol catabolic process",
  "GO:1902138": "(-)-secoisolariciresinol biosynthetic process",
  "GO:1902140": "response to inositol",
  "GO:1902141": "cellular response to inositol",
  "GO:1902145": "regulation of response to cell cycle checkpoint signaling",
  "GO:1902146": "positive regulation of response to cell cycle checkpoint signaling",
  "GO:1902147": "regulation of response to cytokinesis checkpoint signaling",
  "GO:1902148": "positive regulation of response to cytokinesis checkpoint signaling",
  "GO:1902151": "regulation of response to DNA integrity checkpoint signaling",
  "GO:1902152": "positive regulation of response to DNA integrity checkpoint signaling",
  "GO:1902153": "regulation of response to DNA damage checkpoint signaling",
  "GO:1902154": "positive regulation of response to DNA damage checkpoint signaling",
  "GO:1902155": "regulation of response to G1 DNA damage checkpoint signaling",
  "GO:1902156": "positive regulation of response to G1 DNA damage checkpoint signaling",
  "GO:1902157": "regulation of response to G2 DNA damage checkpoint signaling",
  "GO:1902158": "positive regulation of response to G2 DNA damage checkpoint signaling",
  "GO:1902159": "regulation of cyclic nucleotide-gated ion channel activity",
  "GO:1902160": "negative regulation of cyclic nucleotide-gated ion channel activity",
  "GO:1902161": "positive regulation of cyclic nucleotide-gated ion channel activity",
  "GO:1902162": "regulation of DNA damage response, signal transduction by p53 class mediator resulting in transcription of p21 class mediator",
  "GO:1902163": "negative regulation of DNA damage response, signal transduction by p53 class mediator resulting in transcription of p21 class mediator",
  "GO:1902164": "positive regulation of DNA damage response, signal transduction by p53 class mediator resulting in transcription of p21 class mediator",
  "GO:1902165": "regulation of intrinsic apoptotic signaling pathway in response to DNA damage by p53 class mediator",
  "GO:1902166": "negative regulation of intrinsic apoptotic signaling pathway in response to DNA damage by p53 class mediator",
  "GO:1902167": "positive regulation of intrinsic apoptotic signaling pathway in response to DNA damage by p53 class mediator",
  "GO:1902168": "response to catechin",
  "GO:1902169": "cellular response to catechin",
  "GO:1902170": "cellular response to reactive nitrogen species",
  "GO:1902171": "regulation of tocopherol cyclase activity",
  "GO:1902172": "regulation of keratinocyte apoptotic process",
  "GO:1902173": "negative regulation of keratinocyte apoptotic process",
  "GO:1902174": "positive regulation of keratinocyte apoptotic process",
  "GO:1902175": "regulation of oxidative stress-induced intrinsic apoptotic signaling pathway",
  "GO:1902176": "negative regulation of oxidative stress-induced intrinsic apoptotic signaling pathway",
  "GO:1902177": "positive regulation of oxidative stress-induced intrinsic apoptotic signaling pathway",
  "GO:1902178": "fibroblast growth factor receptor apoptotic signaling pathway",
  "GO:1902179": "verruculogen metabolic process",
  "GO:1902180": "verruculogen catabolic process",
  "GO:1902181": "verruculogen biosynthetic process",
  "GO:1902182": "shoot apical meristem development",
  "GO:1902183": "regulation of shoot apical meristem development",
  "GO:1902184": "negative regulation of shoot apical meristem development",
  "GO:1902185": "positive regulation of shoot apical meristem development",
  "GO:1902186": "regulation of viral release from host cell",
  "GO:1902187": "negative regulation of viral release from host cell",
  "GO:1902188": "positive regulation of viral release from host cell",
  "GO:1902189": "2-methylbutanoyl-CoA(4-) metabolic process",
  "GO:1902190": "2-methylbutanoyl-CoA(4-) catabolic process",
  "GO:1902191": "2-methylbutanoyl-CoA(4-) biosynthetic process",
  "GO:1902192": "2-methylbut-2-enoyl-CoA(4-) metabolic process",
  "GO:1902193": "2-methylbut-2-enoyl-CoA(4-) catabolic process",
  "GO:1902194": "2-methylbut-2-enoyl-CoA(4-) biosynthetic process",
  "GO:1902195": "isovaleryl-CoA(4-) metabolic process",
  "GO:1902196": "isovaleryl-CoA(4-) catabolic process",
  "GO:1902197": "isovaleryl-CoA(4-) biosynthetic process",
  "GO:1902198": "3-methylbut-2-enoyl-CoA(4-) metabolic process",
  "GO:1902199": "3-methylbut-2-enoyl-CoA(4-) catabolic process",
  "GO:1902200": "3-methylbut-2-enoyl-CoA(4-) biosynthetic process",
  "GO:1902201": "negative regulation of bacterial-type flagellum-dependent cell motility",
  "GO:1902202": "regulation of hepatocyte growth factor receptor signaling pathway",
  "GO:1902203": "negative regulation of hepatocyte growth factor receptor signaling pathway",
  "GO:1902204": "positive regulation of hepatocyte growth factor receptor signaling pathway",
  "GO:1902205": "regulation of interleukin-2-mediated signaling pathway",
  "GO:1902206": "negative regulation of interleukin-2-mediated signaling pathway",
  "GO:1902207": "positive regulation of interleukin-2-mediated signaling pathway",
  "GO:1902208": "regulation of bacterial-type flagellum assembly",
  "GO:1902209": "negative regulation of bacterial-type flagellum assembly",
  "GO:1902210": "positive regulation of bacterial-type flagellum assembly",
  "GO:1902211": "regulation of prolactin signaling pathway",
  "GO:1902212": "negative regulation of prolactin signaling pathway",
  "GO:1902213": "positive regulation of prolactin signaling pathway",
  "GO:1902214": "regulation of interleukin-4-mediated signaling pathway",
  "GO:1902215": "negative regulation of interleukin-4-mediated signaling pathway",
  "GO:1902216": "positive regulation of interleukin-4-mediated signaling pathway",
  "GO:1902217": "erythrocyte apoptotic process",
  "GO:1902218": "regulation of intrinsic apoptotic signaling pathway in response to osmotic stress",
  "GO:1902219": "negative regulation of intrinsic apoptotic signaling pathway in response to osmotic stress",
  "GO:1902220": "positive regulation of intrinsic apoptotic signaling pathway in response to osmotic stress",
  "GO:1902221": "erythrose 4-phosphate/phosphoenolpyruvate family amino acid metabolic process",
  "GO:1902222": "erythrose 4-phosphate/phosphoenolpyruvate family amino acid catabolic process",
  "GO:1902223": "erythrose 4-phosphate/phosphoenolpyruvate family amino acid biosynthetic process",
  "GO:1902224": "ketone body metabolic process",
  "GO:1902225": "negative regulation of acrosome reaction",
  "GO:1902226": "regulation of macrophage colony-stimulating factor signaling pathway",
  "GO:1902227": "negative regulation of macrophage colony-stimulating factor signaling pathway",
  "GO:1902228": "positive regulation of macrophage colony-stimulating factor signaling pathway",
  "GO:1902229": "regulation of intrinsic apoptotic signaling pathway in response to DNA damage",
  "GO:1902230": "negative regulation of intrinsic apoptotic signaling pathway in response to DNA damage",
  "GO:1902231": "positive regulation of intrinsic apoptotic signaling pathway in response to DNA damage",
  "GO:1902232": "regulation of positive thymic T cell selection",
  "GO:1902233": "negative regulation of positive thymic T cell selection",
  "GO:1902234": "positive regulation of positive thymic T cell selection",
  "GO:1902235": "regulation of endoplasmic reticulum stress-induced intrinsic apoptotic signaling pathway",
  "GO:1902236": "negative regulation of endoplasmic reticulum stress-induced intrinsic apoptotic signaling pathway",
  "GO:1902237": "positive regulation of endoplasmic reticulum stress-induced intrinsic apoptotic signaling pathway",
  "GO:1902238": "regulation of intrinsic apoptotic signaling pathway in response to osmotic stress by p53 class mediator",
  "GO:1902239": "negative regulation of intrinsic apoptotic signaling pathway in response to osmotic stress by p53 class mediator",
  "GO:1902240": "positive regulation of intrinsic apoptotic signaling pathway in response to osmotic stress by p53 class mediator",
  "GO:1902241": "copal-8-ol diphosphate(3-) metabolic process",
  "GO:1902242": "copal-8-ol diphosphate(3-) catabolic process",
  "GO:1902243": "copal-8-ol diphosphate(3-) biosynthetic process",
  "GO:1902244": "cis-abienol metabolic process",
  "GO:1902245": "cis-abienol catabolic process",
  "GO:1902246": "cis-abienol biosynthetic process",
  "GO:1902247": "geranylgeranyl diphosphate catabolic process",
  "GO:1902248": "5-O-phosphono-alpha-D-ribofuranosyl diphosphate binding",
  "GO:1902249": "IMP binding",
  "GO:1902250": "regulation of erythrocyte apoptotic process",
  "GO:1902251": "negative regulation of erythrocyte apoptotic process",
  "GO:1902252": "positive regulation of erythrocyte apoptotic process",
  "GO:1902253": "regulation of intrinsic apoptotic signaling pathway by p53 class mediator",
  "GO:1902254": "negative regulation of intrinsic apoptotic signaling pathway by p53 class mediator",
  "GO:1902255": "positive regulation of intrinsic apoptotic signaling pathway by p53 class mediator",
  "GO:1902256": "regulation of apoptotic process involved in outflow tract morphogenesis",
  "GO:1902257": "negative regulation of apoptotic process involved in outflow tract morphogenesis",
  "GO:1902258": "positive regulation of apoptotic process involved in outflow tract morphogenesis",
  "GO:1902259": "regulation of delayed rectifier potassium channel activity",
  "GO:1902260": "negative regulation of delayed rectifier potassium channel activity",
  "GO:1902261": "positive regulation of delayed rectifier potassium channel activity",
  "GO:1902262": "apoptotic process involved in patterning of blood vessels",
  "GO:1902263": "apoptotic process involved in embryonic digit morphogenesis",
  "GO:1902265": "abscisic acid homeostasis",
  "GO:1902266": "cellular abscisic acid homeostasis",
  "GO:1902267": "regulation of polyamine transmembrane transport",
  "GO:1902268": "negative regulation of polyamine transmembrane transport",
  "GO:1902269": "positive regulation of polyamine transmembrane transport",
  "GO:1902270": "(R)-carnitine transmembrane transport",
  "GO:1902271": "D3 vitamins binding",
  "GO:1902272": "regulation of (R)-carnitine transmembrane transport",
  "GO:1902273": "negative regulation of (R)-carnitine transmembrane transport",
  "GO:1902274": "positive regulation of (R)-carnitine transmembrane transport",
  "GO:1902275": "regulation of chromatin organization",
  "GO:1902276": "regulation of pancreatic amylase secretion",
  "GO:1902277": "negative regulation of pancreatic amylase secretion",
  "GO:1902278": "positive regulation of pancreatic amylase secretion",
  "GO:1902279": "positive regulation of pancreatic amylase secretion by cholecystokinin signaling pathway",
  "GO:1902280": "regulation of ATP-dependent RNA helicase activity",
  "GO:1902281": "negative regulation of ATP-dependent RNA helicase activity",
  "GO:1902282": "voltage-gated potassium channel activity involved in ventricular cardiac muscle cell action potential repolarization",
  "GO:1902283": "negative regulation of primary amine oxidase activity",
  "GO:1902284": "neuron projection extension involved in neuron projection guidance",
  "GO:1902285": "semaphorin-plexin signaling pathway involved in neuron projection guidance",
  "GO:1902286": "semaphorin-plexin signaling pathway involved in dendrite guidance",
  "GO:1902287": "semaphorin-plexin signaling pathway involved in axon guidance",
  "GO:1902288": "regulation of defense response to oomycetes",
  "GO:1902289": "negative regulation of defense response to oomycetes",
  "GO:1902290": "positive regulation of defense response to oomycetes",
  "GO:1902291": "cell cycle DNA replication DNA ligation",
  "GO:1902292": "cell cycle DNA replication initiation",
  "GO:1902294": "cell cycle DNA replication termination",
  "GO:1902295": "synthesis of RNA primer involved in cell cycle DNA replication",
  "GO:1902296": "DNA strand elongation involved in cell cycle DNA replication",
  "GO:1902297": "cell cycle DNA replication DNA unwinding",
  "GO:1902298": "cell cycle DNA replication maintenance of fidelity",
  "GO:1902299": "pre-replicative complex assembly involved in cell cycle DNA replication",
  "GO:1902300": "galactarate transport",
  "GO:1902301": "galactarate transmembrane transporter activity",
  "GO:1902302": "regulation of potassium ion export",
  "GO:1902303": "negative regulation of potassium ion export",
  "GO:1902304": "positive regulation of potassium ion export",
  "GO:1902305": "regulation of sodium ion transmembrane transport",
  "GO:1902306": "negative regulation of sodium ion transmembrane transport",
  "GO:1902307": "positive regulation of sodium ion transmembrane transport",
  "GO:1902308": "regulation of peptidyl-serine dephosphorylation",
  "GO:1902309": "negative regulation of peptidyl-serine dephosphorylation",
  "GO:1902310": "positive regulation of peptidyl-serine dephosphorylation",
  "GO:1902311": "regulation of copper ion transmembrane transport",
  "GO:1902312": "negative regulation of copper ion transmembrane transport",
  "GO:1902313": "positive regulation of copper ion transmembrane transport",
  "GO:1902314": "hydroquinone binding",
  "GO:1902315": "nuclear cell cycle DNA replication initiation",
  "GO:1902317": "nuclear DNA replication termination",
  "GO:1902318": "synthesis of RNA primer involved in nuclear cell cycle DNA replication",
  "GO:1902319": "DNA strand elongation involved in nuclear cell cycle DNA replication",
  "GO:1902320": "nuclear DNA replication DNA duplex unwinding",
  "GO:1902321": "methyl-branched fatty acid biosynthetic process",
  "GO:1902322": "regulation of methyl-branched fatty acid biosynthetic process",
  "GO:1902323": "negative regulation of methyl-branched fatty acid biosynthetic process",
  "GO:1902324": "positive regulation of methyl-branched fatty acid biosynthetic process",
  "GO:1902325": "negative regulation of chlorophyll biosynthetic process",
  "GO:1902326": "positive regulation of chlorophyll biosynthetic process",
  "GO:1902327": "bacterial-type DNA replication DNA ligation",
  "GO:1902328": "bacterial-type DNA replication initiation",
  "GO:1902329": "bacterial-type DNA replication termination",
  "GO:1902330": "synthesis of RNA primer involved in bacterial-type DNA replication",
  "GO:1902331": "DNA strand elongation involved in bacterial-type DNA replication",
  "GO:1902332": "bacterial-type DNA replication DNA duplex unwinding",
  "GO:1902333": "nuclear DNA replication DNA ligation",
  "GO:1902334": "fructose export from vacuole to cytoplasm",
  "GO:1902335": "obsolete positive chemotaxis involved in neuron migration",
  "GO:1902336": "positive regulation of retinal ganglion cell axon guidance",
  "GO:1902337": "regulation of apoptotic process involved in morphogenesis",
  "GO:1902338": "negative regulation of apoptotic process involved in morphogenesis",
  "GO:1902339": "positive regulation of apoptotic process involved in morphogenesis",
  "GO:1902340": "negative regulation of chromosome condensation",
  "GO:1902341": "xylitol transport",
  "GO:1902342": "xylitol export",
  "GO:1902343": "regulation of maltose transport",
  "GO:1902344": "negative regulation of maltose transport",
  "GO:1902345": "positive regulation of maltose transport",
  "GO:1902346": "meiotic strand displacement involved in double-strand break repair via SDSA",
  "GO:1902347": "response to strigolactone",
  "GO:1902348": "cellular response to strigolactone",
  "GO:1902349": "response to chloroquine",
  "GO:1902350": "cellular response to chloroquine",
  "GO:1902351": "response to imidacloprid",
  "GO:1902352": "negative regulation of filamentous growth of a population of unicellular organisms in response to starvation by negative regulation of transcription from RNA polymerase II promoter",
  "GO:1902353": "positive regulation of induction of conjugation with cellular fusion by negative regulation of transcription from RNA polymerase II promoter by pheromones",
  "GO:1902354": "blood vessel endothelial cell delamination involved in blood vessel lumen ensheathment",
  "GO:1902355": "endothelial tube lumen extension involved in blood vessel lumen ensheathment",
  "GO:1902356": "oxaloacetate(2-) transmembrane transport",
  "GO:1902357": "2-isopropylmalate(2-) transmembrane transport",
  "GO:1902358": "sulfate transmembrane transport",
  "GO:1902359": "Notch signaling pathway involved in somitogenesis",
  "GO:1902360": "conversion of ds siRNA to ss siRNA involved in chromatin silencing by small RNA",
  "GO:1902361": "mitochondrial pyruvate transmembrane transport",
  "GO:1902362": "melanocyte apoptotic process",
  "GO:1902363": "regulation of protein localization to spindle pole body",
  "GO:1902364": "negative regulation of protein localization to spindle pole body",
  "GO:1902365": "positive regulation of protein localization to spindle pole body",
  "GO:1902366": "regulation of Notch signaling pathway involved in somitogenesis",
  "GO:1902367": "negative regulation of Notch signaling pathway involved in somitogenesis",
  "GO:1902368": "heterochromatin maintenance involved in chromatin silencing at centromere outer repeat region",
  "GO:1902369": "negative regulation of RNA catabolic process",
  "GO:1902370": "regulation of tRNA catabolic process",
  "GO:1902371": "negative regulation of tRNA catabolic process",
  "GO:1902372": "positive regulation of tRNA catabolic process",
  "GO:1902373": "negative regulation of mRNA catabolic process",
  "GO:1902374": "regulation of rRNA catabolic process",
  "GO:1902375": "nuclear tRNA 3'-trailer cleavage, endonucleolytic",
  "GO:1902376": "protein denaturation involved in proteasomal ubiquitin-dependent protein catabolic process",
  "GO:1902377": "nuclear rDNA heterochromatin",
  "GO:1902378": "VEGF-activated neuropilin signaling pathway involved in axon guidance",
  "GO:1902379": "chemoattractant activity involved in axon guidance",
  "GO:1902380": "positive regulation of endoribonuclease activity",
  "GO:1902381": "11-oxo-beta-amyrin metabolic process",
  "GO:1902382": "11-oxo-beta-amyrin catabolic process",
  "GO:1902383": "11-oxo-beta-amyrin biosynthetic process",
  "GO:1902384": "glycyrrhetinate metabolic process",
  "GO:1902385": "glycyrrhetinate catabolic process",
  "GO:1902386": "glycyrrhetinate biosynthetic process",
  "GO:1902387": "ceramide 1-phosphate binding",
  "GO:1902388": "ceramide 1-phosphate transporter activity",
  "GO:1902389": "ceramide 1-phosphate transport",
  "GO:1902390": "regulation of N-terminal peptidyl-serine acetylation",
  "GO:1902391": "positive regulation of N-terminal peptidyl-serine acetylation",
  "GO:1902392": "regulation of exodeoxyribonuclease activity",
  "GO:1902393": "negative regulation of exodeoxyribonuclease activity",
  "GO:1902394": "positive regulation of exodeoxyribonuclease activity",
  "GO:1902395": "regulation of 1-deoxy-D-xylulose-5-phosphate synthase activity",
  "GO:1902396": "protein localization to bicellular tight junction",
  "GO:1902397": "detection of stimulus involved in meiotic spindle checkpoint",
  "GO:1902398": "intracellular signal transduction involved in meiotic spindle checkpoint",
  "GO:1902399": "detection of stimulus involved in G1 DNA damage checkpoint",
  "GO:1902400": "intracellular signal transduction involved in G1 DNA damage checkpoint",
  "GO:1902401": "detection of stimulus involved in mitotic DNA damage checkpoint",
  "GO:1902402": "signal transduction involved in mitotic DNA damage checkpoint",
  "GO:1902403": "signal transduction involved in mitotic DNA integrity checkpoint",
  "GO:1902404": "mitotic actomyosin contractile ring contraction",
  "GO:1902405": "mitotic actomyosin contractile ring localization",
  "GO:1902406": "mitotic actomyosin contractile ring maintenance",
  "GO:1902407": "assembly of actomyosin apparatus involved in mitotic cytokinesis",
  "GO:1902408": "mitotic cytokinesis, site selection",
  "GO:1902410": "mitotic cytokinetic process",
  "GO:1902412": "regulation of mitotic cytokinesis",
  "GO:1902413": "negative regulation of mitotic cytokinesis",
  "GO:1902414": "protein localization to cell junction",
  "GO:1902415": "regulation of mRNA binding",
  "GO:1902416": "positive regulation of mRNA binding",
  "GO:1902417": "(+)-abscisic acid D-glucopyranosyl ester transmembrane transporter activity",
  "GO:1902418": "(+)-abscisic acid D-glucopyranosyl ester transmembrane transport",
  "GO:1902419": "detection of stimulus involved in Dma1-dependent checkpoint",
  "GO:1902420": "signal transduction involved in Dma1-dependent checkpoint",
  "GO:1902421": "hydrogen metabolic process",
  "GO:1902422": "hydrogen biosynthetic process",
  "GO:1902423": "regulation of mitotic attachment of spindle microtubules to kinetochore",
  "GO:1902424": "negative regulation of mitotic attachment of spindle microtubules to kinetochore",
  "GO:1902425": "positive regulation of attachment of mitotic spindle microtubules to kinetochore",
  "GO:1902426": "negative regulation of mitotic spindle assembly checkpoint",
  "GO:1902427": "regulation of water channel activity",
  "GO:1902428": "negative regulation of water channel activity",
  "GO:1902429": "positive regulation of water channel activity",
  "GO:1902430": "negative regulation of beta-amyloid formation",
  "GO:1902431": "uracil import into cell",
  "GO:1902432": "protein localization to barrier septum",
  "GO:1902433": "positive regulation of water channel activity involved in maintenance of lens transparency",
  "GO:1902434": "sulfate import into cell",
  "GO:1902435": "regulation of male mating behavior",
  "GO:1902436": "negative regulation of male mating behavior",
  "GO:1902437": "positive regulation of male mating behavior",
  "GO:1902438": "response to vanadate(3-)",
  "GO:1902439": "cellular response to vanadate(3-)",
  "GO:1902440": "protein localization to mitotic spindle pole body",
  "GO:1902441": "protein localization to meiotic spindle pole body",
  "GO:1902442": "regulation of ripoptosome assembly involved in necroptotic process",
  "GO:1902443": "negative regulation of ripoptosome assembly involved in necroptotic process",
  "GO:1902444": "riboflavin binding",
  "GO:1902445": "regulation of mitochondrial membrane permeability involved in programmed necrotic cell death",
  "GO:1902446": "regulation of shade avoidance",
  "GO:1902447": "negative regulation of shade avoidance",
  "GO:1902448": "positive regulation of shade avoidance",
  "GO:1902449": "regulation of ATP-dependent DNA helicase activity",
  "GO:1902450": "negative regulation of ATP-dependent DNA helicase activity",
  "GO:1902451": "positive regulation of ATP-dependent DNA helicase activity",
  "GO:1902455": "negative regulation of stem cell population maintenance",
  "GO:1902456": "regulation of stomatal opening",
  "GO:1902457": "negative regulation of stomatal opening",
  "GO:1902458": "positive regulation of stomatal opening",
  "GO:1902459": "positive regulation of stem cell population maintenance",
  "GO:1902460": "regulation of mesenchymal stem cell proliferation",
  "GO:1902461": "negative regulation of mesenchymal stem cell proliferation",
  "GO:1902462": "positive regulation of mesenchymal stem cell proliferation",
  "GO:1902463": "protein localization to cell leading edge",
  "GO:1902464": "regulation of histone H3-K27 trimethylation",
  "GO:1902465": "negative regulation of histone H3-K27 trimethylation",
  "GO:1902466": "positive regulation of histone H3-K27 trimethylation",
  "GO:1902471": "regulation of mitotic actomyosin contractile ring localization",
  "GO:1902472": "regulation of mitotic cytokinesis, site selection",
  "GO:1902473": "regulation of protein localization to synapse",
  "GO:1902474": "positive regulation of protein localization to synapse",
  "GO:1902475": "L-alpha-amino acid transmembrane transport",
  "GO:1902476": "chloride transmembrane transport",
  "GO:1902477": "regulation of defense response to bacterium, incompatible interaction",
  "GO:1902478": "negative regulation of defense response to bacterium, incompatible interaction",
  "GO:1902479": "positive regulation of defense response to bacterium, incompatible interaction",
  "GO:1902480": "protein localization to mitotic spindle",
  "GO:1902481": "gamma-tubulin complex assembly",
  "GO:1902482": "regulatory T cell apoptotic process",
  "GO:1902483": "cytotoxic T cell apoptotic process",
  "GO:1902484": "Sertoli cell apoptotic process",
  "GO:1902485": "L-cysteine binding",
  "GO:1902486": "protein localization to growing cell tip",
  "GO:1902487": "protein localization to non-growing cell tip",
  "GO:1902488": "cholangiocyte apoptotic process",
  "GO:1902489": "hepatoblast apoptotic process",
  "GO:1902490": "regulation of sperm capacitation",
  "GO:1902491": "negative regulation of sperm capacitation",
  "GO:1902492": "positive regulation of sperm capacitation",
  "GO:1902493": "acetyltransferase complex",
  "GO:1902494": "catalytic complex",
  "GO:1902495": "transmembrane transporter complex",
  "GO:1902496": "protein binding involved in negative regulation of telomere maintenance via telomerase",
  "GO:1902497": "iron-sulfur cluster transport",
  "GO:1902498": "regulation of protein autoubiquitination",
  "GO:1902499": "positive regulation of protein autoubiquitination",
  "GO:1902500": "vacuolar HOPS complex",
  "GO:1902501": "lysosomal HOPS complex",
  "GO:1902502": "multivesicular body HOPS complex",
  "GO:1902503": "adenylyltransferase complex",
  "GO:1902504": "regulation of signal transduction involved in mitotic G2 DNA damage checkpoint",
  "GO:1902505": "negative regulation of signal transduction involved in mitotic G2 DNA damage checkpoint",
  "GO:1902506": "positive regulation of signal transduction involved in mitotic G2 DNA damage checkpoint",
  "GO:1902507": "thiazole synthase complex",
  "GO:1902508": "2-iminoacetate synthase complex",
  "GO:1902509": "methionine-importing complex",
  "GO:1902510": "regulation of apoptotic DNA fragmentation",
  "GO:1902511": "negative regulation of apoptotic DNA fragmentation",
  "GO:1902512": "positive regulation of apoptotic DNA fragmentation",
  "GO:1902513": "regulation of organelle transport along microtubule",
  "GO:1902514": "regulation of calcium ion transmembrane transport via high voltage-gated calcium channel",
  "GO:1902515": "thioredoxin-disulfide reductase complex",
  "GO:1902516": "sn-glycerol 3-phosphate binding",
  "GO:1902517": "glycerol-3-phosphate-transporting ATPase complex",
  "GO:1902518": "response to cyclophosphamide",
  "GO:1902519": "response to docetaxel trihydrate",
  "GO:1902520": "response to doxorubicin",
  "GO:1902521": "response to etoposide",
  "GO:1902522": "response to 4'-epidoxorubicin",
  "GO:1902523": "positive regulation of protein K63-linked ubiquitination",
  "GO:1902524": "positive regulation of protein K48-linked ubiquitination",
  "GO:1902525": "regulation of protein monoubiquitination",
  "GO:1902526": "negative regulation of protein monoubiquitination",
  "GO:1902527": "positive regulation of protein monoubiquitination",
  "GO:1902528": "regulation of protein linear polyubiquitination",
  "GO:1902529": "negative regulation of protein linear polyubiquitination",
  "GO:1902530": "positive regulation of protein linear polyubiquitination",
  "GO:1902531": "regulation of intracellular signal transduction",
  "GO:1902532": "negative regulation of intracellular signal transduction",
  "GO:1902533": "positive regulation of intracellular signal transduction",
  "GO:1902534": "single-organism membrane invagination",
  "GO:1902535": "multi-organism membrane invagination",
  "GO:1902536": "single-organism pinocytosis",
  "GO:1902537": "multi-organism pinocytosis",
  "GO:1902538": "single-organism macropinocytosis",
  "GO:1902539": "multi-organism macropinocytosis",
  "GO:1902540": "single-organism micropinocytosis",
  "GO:1902541": "multi-organism micropinocytosis",
  "GO:1902542": "regulation of protein localization to mitotic spindle pole body",
  "GO:1902543": "negative regulation of protein localization to mitotic spindle pole body",
  "GO:1902544": "regulation of DNA N-glycosylase activity",
  "GO:1902545": "negative regulation of DNA N-glycosylase activity",
  "GO:1902546": "positive regulation of DNA N-glycosylase activity",
  "GO:1902547": "regulation of cellular response to vascular endothelial growth factor stimulus",
  "GO:1902548": "negative regulation of cellular response to vascular endothelial growth factor stimulus",
  "GO:1902549": "protein localization to Mei2 nuclear dot",
  "GO:1902550": "lymphoid lineage cell migration into thymus involved in thymus epithelium morphogenesis",
  "GO:1902551": "regulation of catalase activity",
  "GO:1902552": "negative regulation of catalase activity",
  "GO:1902553": "positive regulation of catalase activity",
  "GO:1902554": "serine/threonine protein kinase complex",
  "GO:1902555": "endoribonuclease complex",
  "GO:1902556": "phosphatidylinositol transporter complex",
  "GO:1902557": "5'-adenylyl sulfate transmembrane transporter activity",
  "GO:1902558": "5'-adenylyl sulfate transmembrane transport",
  "GO:1902559": "3'-phospho-5'-adenylyl sulfate transmembrane transport",
  "GO:1902560": "GMP reductase complex",
  "GO:1902561": "origin recognition complex assembly",
  "GO:1902562": "H4 histone acetyltransferase complex",
  "GO:1902563": "regulation of neutrophil activation",
  "GO:1902564": "negative regulation of neutrophil activation",
  "GO:1902565": "positive regulation of neutrophil activation",
  "GO:1902566": "regulation of eosinophil activation",
  "GO:1902567": "negative regulation of eosinophil activation",
  "GO:1902568": "positive regulation of eosinophil activation",
  "GO:1902569": "negative regulation of activation of JAK2 kinase activity",
  "GO:1902570": "protein localization to nucleolus",
  "GO:1902571": "regulation of serine-type peptidase activity",
  "GO:1902572": "negative regulation of serine-type peptidase activity",
  "GO:1902573": "positive regulation of serine-type peptidase activity",
  "GO:1902574": "negative regulation of leucine import by regulation of transcription from RNA polymerase II promoter",
  "GO:1902575": "protein localization to cell division site involved in cytokinesis, actomyosin contractile ring assembly",
  "GO:1902576": "negative regulation of nuclear cell cycle DNA replication",
  "GO:1902577": "protein localization to medial cortical node",
  "GO:1902578": "single-organism localization",
  "GO:1902579": "multi-organism localization",
  "GO:1902580": "single-organism cellular localization",
  "GO:1902581": "multi-organism cellular localization",
  "GO:1902582": "single-organism intracellular transport",
  "GO:1902583": "multi-organism intracellular transport",
  "GO:1902584": "positive regulation of response to water deprivation",
  "GO:1902585": "single-organism intercellular transport",
  "GO:1902586": "multi-organism intercellular transport",
  "GO:1902587": "single-organism plasmodesmata-mediated intercellular transport",
  "GO:1902588": "multi-organism plasmodesmata-mediated intercellular transport",
  "GO:1902589": "single-organism organelle organization",
  "GO:1902590": "multi-organism organelle organization",
  "GO:1902591": "single-organism membrane budding",
  "GO:1902592": "multi-organism membrane budding",
  "GO:1902593": "single-organism nuclear import",
  "GO:1902594": "multi-organism nuclear import",
  "GO:1902595": "regulation of DNA replication origin binding",
  "GO:1902596": "negative regulation of DNA replication origin binding",
  "GO:1902597": "positive regulation of DNA replication origin binding",
  "GO:1902598": "creatine transmembrane transport",
  "GO:1902599": "sulfathiazole transmembrane transport",
  "GO:1902600": "hydrogen ion transmembrane transport",
  "GO:1902601": "silver ion transmembrane transport",
  "GO:1902602": "aluminum ion transmembrane transport",
  "GO:1902603": "carnitine transmembrane transport",
  "GO:1902604": "p-aminobenzoyl-glutamate transmembrane transport",
  "GO:1902605": "heterotrimeric G-protein complex assembly",
  "GO:1902606": "regulation of large conductance calcium-activated potassium channel activity",
  "GO:1902607": "negative regulation of large conductance calcium-activated potassium channel activity",
  "GO:1902608": "positive regulation of large conductance calcium-activated potassium channel activity",
  "GO:1902609": "(R)-2-hydroxy-alpha-linolenic acid biosynthetic process",
  "GO:1902610": "response to N-phenylthiourea",
  "GO:1902611": "cellular response to N-phenylthiourea",
  "GO:1902612": "regulation of anti-Mullerian hormone signaling pathway",
  "GO:1902613": "negative regulation of anti-Mullerian hormone signaling pathway",
  "GO:1902614": "positive regulation of anti-Mullerian hormone signaling pathway",
  "GO:1902615": "immune response involved in response to exogenous dsRNA",
  "GO:1902616": "acyl carnitine transmembrane transport",
  "GO:1902617": "response to fluoride",
  "GO:1902618": "cellular response to fluoride",
  "GO:1902619": "regulation of microtubule minus-end binding",
  "GO:1902620": "positive regulation of microtubule minus-end binding",
  "GO:1902621": "actomyosin contractile ring disassembly",
  "GO:1902622": "regulation of neutrophil migration",
  "GO:1902623": "negative regulation of neutrophil migration",
  "GO:1902624": "positive regulation of neutrophil migration",
  "GO:1902625": "negative regulation of induction of conjugation with cellular fusion by negative regulation of transcription from RNA polymerase II promoter",
  "GO:1902626": "assembly of large subunit precursor of preribosome",
  "GO:1902627": "regulation of assembly of large subunit precursor of preribosome",
  "GO:1902628": "positive regulation of assembly of large subunit precursor of preribosome",
  "GO:1902629": "regulation of mRNA stability involved in cellular response to UV",
  "GO:1902630": "regulation of membrane hyperpolarization",
  "GO:1902631": "negative regulation of membrane hyperpolarization",
  "GO:1902632": "positive regulation of membrane hyperpolarization",
  "GO:1902633": "1-phosphatidyl-1D-myo-inositol 4,5-bisphosphate metabolic process",
  "GO:1902634": "1-phosphatidyl-1D-myo-inositol 4,5-bisphosphate catabolic process",
  "GO:1902635": "1-phosphatidyl-1D-myo-inositol 4,5-bisphosphate biosynthetic process",
  "GO:1902636": "kinociliary basal body",
  "GO:1902637": "neural crest cell differentiation involved in thymus development",
  "GO:1902638": "neural crest cell differentiation involved in parathyroid gland development",
  "GO:1902639": "propan-2-ol metabolic process",
  "GO:1902640": "propan-2-ol biosynthetic process",
  "GO:1902641": "regulation of 1-phosphatidyl-1D-myo-inositol 4,5-bisphosphate catabolic process",
  "GO:1902642": "negative regulation of 1-phosphatidyl-1D-myo-inositol 4,5-bisphosphate catabolic process",
  "GO:1902643": "positive regulation of 1-phosphatidyl-1D-myo-inositol 4,5-bisphosphate catabolic process",
  "GO:1902644": "tertiary alcohol metabolic process",
  "GO:1902645": "tertiary alcohol biosynthetic process",
  "GO:1902646": "regulation of 1-phosphatidyl-1D-myo-inositol 4,5-bisphosphate biosynthetic process",
  "GO:1902647": "negative regulation of 1-phosphatidyl-1D-myo-inositol 4,5-bisphosphate biosynthetic process",
  "GO:1902648": "positive regulation of 1-phosphatidyl-1D-myo-inositol 4,5-bisphosphate biosynthetic process",
  "GO:1902649": "regulation of histone H2A-H2B dimer displacement",
  "GO:1902650": "negative regulation of histone H2A-H2B dimer displacement",
  "GO:1902651": "positive regulation of histone H2A-H2B dimer displacement",
  "GO:1902652": "secondary alcohol metabolic process",
  "GO:1902653": "secondary alcohol biosynthetic process",
  "GO:1902654": "aromatic primary alcohol metabolic process",
  "GO:1902655": "aromatic primary alcohol biosynthetic process",
  "GO:1902656": "calcium ion import into cytosol",
  "GO:1902657": "protein localization to prospore membrane",
  "GO:1902658": "establishment of protein localization to prospore membrane",
  "GO:1902659": "regulation of glucose mediated signaling pathway",
  "GO:1902660": "negative regulation of glucose mediated signaling pathway",
  "GO:1902661": "positive regulation of glucose mediated signaling pathway",
  "GO:1902662": "regulation of peptidyl-L-cysteine S-palmitoylation",
  "GO:1902663": "negative regulation of peptidyl-L-cysteine S-palmitoylation",
  "GO:1902664": "positive regulation of peptidyl-L-cysteine S-palmitoylation",
  "GO:1902665": "response to isobutanol",
  "GO:1902666": "protein localization to Mmi1 nuclear focus complex",
  "GO:1902667": "regulation of axon guidance",
  "GO:1902668": "negative regulation of axon guidance",
  "GO:1902669": "positive regulation of axon guidance",
  "GO:1902670": "carbon dioxide binding",
  "GO:1902671": "left anterior basal body",
  "GO:1902672": "right anterior basal body",
  "GO:1902673": "left posteriolateral basal body",
  "GO:1902674": "right posteriolateral basal body",
  "GO:1902675": "left ventral basal body",
  "GO:1902676": "right ventral basal body",
  "GO:1902677": "left caudal basal body",
  "GO:1902678": "right caudal basal body",
  "GO:1902679": "negative regulation of RNA biosynthetic process",
  "GO:1902680": "positive regulation of RNA biosynthetic process",
  "GO:1902681": "regulation of replication fork arrest at rDNA repeats",
  "GO:1902682": "protein localization to nuclear pericentric heterochromatin",
  "GO:1902683": "regulation of receptor localization to synapse",
  "GO:1902684": "negative regulation of receptor localization to synapse",
  "GO:1902685": "positive regulation of receptor localization to synapse",
  "GO:1902686": "mitochondrial outer membrane permeabilization involved in programmed cell death",
  "GO:1902687": "glucosidase complex",
  "GO:1902688": "regulation of NAD metabolic process",
  "GO:1902689": "negative regulation of NAD metabolic process",
  "GO:1902690": "positive regulation of NAD metabolic process",
  "GO:1902691": "respiratory basal cell differentiation",
  "GO:1902692": "regulation of neuroblast proliferation",
  "GO:1902693": "superoxide dismutase complex",
  "GO:1902694": "superoxide dismutase copper chaperone complex",
  "GO:1902695": "metallochaperone complex",
  "GO:1902696": "glycine catabolic process to isobutanol",
  "GO:1902697": "valine catabolic process to isobutanol",
  "GO:1902698": "pentose catabolic process to butyrate",
  "GO:1902699": "pentose catabolic process to acetate",
  "GO:1902700": "pentose catabolic process to butan-1-ol",
  "GO:1902701": "pentose catabolic process to propan-2-ol",
  "GO:1902702": "hexose catabolic process to propan-2-ol",
  "GO:1902703": "hexose catabolic process to butan-1-ol",
  "GO:1902704": "hexose catabolic process to acetone",
  "GO:1902705": "hexose catabolic process to butyrate",
  "GO:1902706": "hexose catabolic process to acetate",
  "GO:1902707": "hexose catabolic process to ethanol",
  "GO:1902708": "response to plumbagin",
  "GO:1902709": "cellular response to plumbagin",
  "GO:1902710": "GABA receptor complex",
  "GO:1902711": "GABA-A receptor complex",
  "GO:1902712": "G-protein coupled GABA receptor complex",
  "GO:1902713": "regulation of interferon-gamma secretion",
  "GO:1902714": "negative regulation of interferon-gamma secretion",
  "GO:1902715": "positive regulation of interferon-gamma secretion",
  "GO:1902716": "cell cortex of growing cell tip",
  "GO:1902717": "obsolete sequestering of iron ion",
  "GO:1902718": "obsolete sequestering of copper ion",
  "GO:1902719": "obsolete extracellular sequestering of copper ion",
  "GO:1902720": "obsolete intracellular sequestering of copper ion",
  "GO:1902721": "negative regulation of prolactin secretion",
  "GO:1902722": "positive regulation of prolactin secretion",
  "GO:1902723": "negative regulation of skeletal muscle satellite cell proliferation",
  "GO:1902724": "positive regulation of skeletal muscle satellite cell proliferation",
  "GO:1902725": "negative regulation of satellite cell differentiation",
  "GO:1902726": "positive regulation of skeletal muscle satellite cell differentiation",
  "GO:1902727": "negative regulation of growth factor dependent skeletal muscle satellite cell proliferation",
  "GO:1902728": "positive regulation of growth factor dependent skeletal muscle satellite cell proliferation",
  "GO:1902729": "negative regulation of proteoglycan biosynthetic process",
  "GO:1902730": "positive regulation of proteoglycan biosynthetic process",
  "GO:1902731": "negative regulation of chondrocyte proliferation",
  "GO:1902732": "positive regulation of chondrocyte proliferation",
  "GO:1902733": "regulation of growth plate cartilage chondrocyte differentiation",
  "GO:1902734": "regulation of receptor-mediated virion attachment to host cell",
  "GO:1902735": "negative regulation of receptor-mediated virion attachment to host cell",
  "GO:1902736": "positive regulation of receptor-mediated virion attachment to host cell",
  "GO:1902737": "dendritic filopodium",
  "GO:1902738": "regulation of chondrocyte differentiation involved in endochondral bone morphogenesis",
  "GO:1902739": "regulation of interferon-alpha secretion",
  "GO:1902740": "negative regulation of interferon-alpha secretion",
  "GO:1902741": "positive regulation of interferon-alpha secretion",
  "GO:1902742": "apoptotic process involved in development",
  "GO:1902743": "regulation of lamellipodium organization",
  "GO:1902744": "negative regulation of lamellipodium organization",
  "GO:1902745": "positive regulation of lamellipodium organization",
  "GO:1902746": "regulation of lens fiber cell differentiation",
  "GO:1902747": "negative regulation of lens fiber cell differentiation",
  "GO:1902748": "positive regulation of lens fiber cell differentiation",
  "GO:1902749": "regulation of cell cycle G2/M phase transition",
  "GO:1902750": "negative regulation of cell cycle G2/M phase transition",
  "GO:1902751": "positive regulation of cell cycle G2/M phase transition",
  "GO:1902752": "regulation of renal amino acid absorption",
  "GO:1902753": "negative regulation of renal amino acid absorption",
  "GO:1902754": "positive regulation of renal amino acid absorption",
  "GO:1902755": "sulfurated eukaryotic molybdenum cofactor(2-) metabolic process",
  "GO:1902756": "sulfurated eukaryotic molybdenum cofactor(2-) biosynthetic process",
  "GO:1902757": "bis(molybdopterin guanine dinucleotide)molybdenum metabolic process",
  "GO:1902758": "bis(molybdopterin guanine dinucleotide)molybdenum biosynthetic process",
  "GO:1902759": "Mo(VI)-molybdopterin cytosine dinucleotide metabolic process",
  "GO:1902760": "Mo(VI)-molybdopterin cytosine dinucleotide biosynthetic process",
  "GO:1902761": "positive regulation of chondrocyte development",
  "GO:1902762": "regulation of embryonic skeletal joint development",
  "GO:1902763": "negative regulation of embryonic skeletal joint development",
  "GO:1902764": "positive regulation of embryonic skeletal joint development",
  "GO:1902765": "L-arginine import into cell",
  "GO:1902766": "skeletal muscle satellite cell migration",
  "GO:1902767": "isoprenoid biosynthetic process via mevalonate",
  "GO:1902768": "isoprenoid biosynthetic process via 1-deoxy-D-xylulose 5-phosphate",
  "GO:1902769": "regulation of choline O-acetyltransferase activity",
  "GO:1902770": "negative regulation of choline O-acetyltransferase activity",
  "GO:1902771": "positive regulation of choline O-acetyltransferase activity",
  "GO:1902772": "positive regulation of phosphorelay signal transduction system involved in hydrogen peroxide mediated signaling pathway",
  "GO:1902773": "GTPase activator complex",
  "GO:1902774": "late endosome to lysosome transport",
  "GO:1902775": "mitochondrial large ribosomal subunit assembly",
  "GO:1902776": "6-sulfoquinovose(1-) metabolic process",
  "GO:1902777": "6-sulfoquinovose(1-) catabolic process",
  "GO:1902778": "response to alkane",
  "GO:1902779": "cellular response to alkane",
  "GO:1902780": "response to nonane",
  "GO:1902781": "cellular response to nonane",
  "GO:1902782": "response to decane",
  "GO:1902783": "cellular response to decane",
  "GO:1902784": "response to undecane",
  "GO:1902785": "cellular response to undecane",
  "GO:1902786": "response to dodecane",
  "GO:1902787": "cellular response to dodecane",
  "GO:1902788": "response to isooctane",
  "GO:1902789": "cellular response to isooctane",
  "GO:1902790": "undecan-2-one metabolic process",
  "GO:1902791": "undecan-2-one biosynthetic process",
  "GO:1902792": "pyrroline-5-carboxylate reductase complex",
  "GO:1902793": "glutamate decarboxylase complex",
  "GO:1902794": "heterochromatin island assembly",
  "GO:1902795": "heterochromatin domain assembly",
  "GO:1902796": "regulation of snoRNA processing",
  "GO:1902797": "negative regulation of snoRNA processing",
  "GO:1902798": "positive regulation of snoRNA processing",
  "GO:1902799": "regulation of phosphodiesterase I activity",
  "GO:1902800": "positive regulation of phosphodiesterase I activity",
  "GO:1902801": "regulation of heterochromatin island assembly",
  "GO:1902802": "regulation of heterochromatin domain assembly",
  "GO:1902803": "regulation of synaptic vesicle transport",
  "GO:1902804": "negative regulation of synaptic vesicle transport",
  "GO:1902805": "positive regulation of synaptic vesicle transport",
  "GO:1902806": "regulation of cell cycle G1/S phase transition",
  "GO:1902807": "negative regulation of cell cycle G1/S phase transition",
  "GO:1902808": "positive regulation of cell cycle G1/S phase transition",
  "GO:1902809": "regulation of skeletal muscle fiber differentiation",
  "GO:1902810": "negative regulation of skeletal muscle fiber differentiation",
  "GO:1902811": "positive regulation of skeletal muscle fiber differentiation",
  "GO:1902812": "regulation of BMP signaling pathway involved in determination of lateral mesoderm left/right asymmetry",
  "GO:1902813": "negative regulation of BMP signaling pathway involved in determination of lateral mesoderm left/right asymmetry",
  "GO:1902814": "positive regulation of BMP signaling pathway involved in determination of lateral mesoderm left/right asymmetry",
  "GO:1902815": "N,N'-diacetylchitobiose import",
  "GO:1902816": "regulation of protein localization to microtubule",
  "GO:1902817": "negative regulation of protein localization to microtubule",
  "GO:1902818": "ethyl acetate metabolic process",
  "GO:1902819": "ethyl acetate biosynthetic process",
  "GO:1902820": "1-undecene metabolic process",
  "GO:1902821": "1-undecene biosynthetic process",
  "GO:1902822": "regulation of late endosome to lysosome transport",
  "GO:1902823": "negative regulation of late endosome to lysosome transport",
  "GO:1902824": "positive regulation of late endosome to lysosome transport",
  "GO:1902825": "proline import into cell",
  "GO:1902826": "regulation of L-arginine import into cell",
  "GO:1902827": "negative regulation of L-arginine import into cell",
  "GO:1902828": "positive regulation of L-arginine import into cell",
  "GO:1902829": "regulation of spinal cord association neuron differentiation",
  "GO:1902830": "negative regulation of spinal cord association neuron differentiation",
  "GO:1902831": "positive regulation of spinal cord association neuron differentiation",
  "GO:1902832": "negative regulation of cell proliferation in dorsal spinal cord",
  "GO:1902833": "positive regulation of cell proliferation in dorsal spinal cord",
  "GO:1902834": "regulation of proline import into cell",
  "GO:1902835": "negative regulation of proline import into cell",
  "GO:1902836": "positive regulation of proline import into cell",
  "GO:1902837": "amino acid import into cell",
  "GO:1902838": "regulation of nuclear migration along microtubule",
  "GO:1902839": "negative regulation of nuclear migration along microtubule",
  "GO:1902840": "positive regulation of nuclear migration along microtubule",
  "GO:1902841": "regulation of netrin-activated signaling pathway",
  "GO:1902842": "negative regulation of netrin-activated signaling pathway",
  "GO:1902843": "positive regulation of netrin-activated signaling pathway",
  "GO:1902844": "positive regulation of spinal cord association neuron differentiation by negative regulation of canonical Wnt signaling pathway",
  "GO:1902845": "negative regulation of mitotic spindle elongation",
  "GO:1902846": "positive regulation of mitotic spindle elongation",
  "GO:1902847": "regulation of neuronal signal transduction",
  "GO:1902848": "negative regulation of neuronal signal transduction",
  "GO:1902849": "positive regulation of neuronal signal transduction",
  "GO:1902850": "microtubule cytoskeleton organization involved in mitosis",
  "GO:1902852": "regulation of nuclear migration during mitotic telophase",
  "GO:1902853": "negative regulation of nuclear migration during mitotic telophase",
  "GO:1902854": "positive regulation of nuclear migration during mitotic telophase",
  "GO:1902855": "regulation of nonmotile primary cilium assembly",
  "GO:1902856": "negative regulation of nonmotile primary cilium assembly",
  "GO:1902857": "positive regulation of nonmotile primary cilium assembly",
  "GO:1902858": "propionyl-CoA metabolic process",
  "GO:1902859": "propionyl-CoA catabolic process",
  "GO:1902860": "propionyl-CoA biosynthetic process",
  "GO:1902861": "copper ion import into cell",
  "GO:1902862": "obsolete glycerol catabolic process to glycerone phosphate",
  "GO:1902863": "regulation of embryonic camera-type eye development",
  "GO:1902864": "negative regulation of embryonic camera-type eye development",
  "GO:1902865": "positive regulation of embryonic camera-type eye development",
  "GO:1902866": "regulation of retina development in camera-type eye",
  "GO:1902867": "negative regulation of retina development in camera-type eye",
  "GO:1902868": "positive regulation of retina development in camera-type eye",
  "GO:1902869": "regulation of amacrine cell differentiation",
  "GO:1902870": "negative regulation of amacrine cell differentiation",
  "GO:1902871": "positive regulation of amacrine cell differentiation",
  "GO:1902872": "regulation of horizontal cell localization",
  "GO:1902873": "negative regulation of horizontal cell localization",
  "GO:1902874": "positive regulation of horizontal cell localization",
  "GO:1902875": "regulation of embryonic pattern specification",
  "GO:1902876": "negative regulation of embryonic pattern specification",
  "GO:1902877": "positive regulation of embryonic pattern specification",
  "GO:1902878": "regulation of BMP signaling pathway involved in spinal cord association neuron specification",
  "GO:1902879": "negative regulation of BMP signaling pathway involved in spinal cord association neuron specification",
  "GO:1902880": "positive regulation of BMP signaling pathway involved in spinal cord association neuron specification",
  "GO:1902882": "regulation of response to oxidative stress",
  "GO:1902883": "negative regulation of response to oxidative stress",
  "GO:1902884": "positive regulation of response to oxidative stress",
  "GO:1902885": "regulation of proteasome-activating ATPase activity",
  "GO:1902886": "negative regulation of proteasome-activating ATPase activity",
  "GO:1902887": "positive regulation of proteasome-activating ATPase activity",
  "GO:1902888": "protein localization to astral microtubule",
  "GO:1902889": "protein localization to spindle microtubule",
  "GO:1902890": "regulation of root hair elongation",
  "GO:1902891": "negative regulation of root hair elongation",
  "GO:1902892": "positive regulation of root hair elongation",
  "GO:1902893": "regulation of pri-miRNA transcription from RNA polymerase II promoter",
  "GO:1902894": "negative regulation of pri-miRNA transcription from RNA polymerase II promoter",
  "GO:1902895": "positive regulation of pri-miRNA transcription from RNA polymerase II promoter",
  "GO:1902896": "terminal web assembly",
  "GO:1902897": "regulation of postsynaptic density protein 95 clustering",
  "GO:1902898": "fatty acid methyl ester metabolic process",
  "GO:1902899": "fatty acid methyl ester biosynthetic process",
  "GO:1902900": "gut granule assembly",
  "GO:1902901": "positive regulation of transcription from RNA polymerase II promoter involved in stress response to cadmium ion",
  "GO:1902902": "negative regulation of autophagosome assembly",
  "GO:1902903": "regulation of fibril organization",
  "GO:1902904": "negative regulation of fibril organization",
  "GO:1902905": "positive regulation of fibril organization",
  "GO:1902906": "proteasome storage granule assembly",
  "GO:1902907": "proteasome storage granule disassembly",
  "GO:1902908": "regulation of melanosome transport",
  "GO:1902909": "negative regulation of melanosome transport",
  "GO:1902910": "positive regulation of melanosome transport",
  "GO:1902911": "protein kinase complex",
  "GO:1902912": "pyruvate kinase complex",
  "GO:1902913": "positive regulation of neuroepithelial cell differentiation",
  "GO:1902914": "regulation of protein polyubiquitination",
  "GO:1902915": "negative regulation of protein polyubiquitination",
  "GO:1902916": "positive regulation of protein polyubiquitination",
  "GO:1902917": "positive regulation of mating projection assembly",
  "GO:1902918": "poly(5-hydroxyvalerate) metabolic process",
  "GO:1902919": "poly(5-hydroxyvalerate) biosynthetic process",
  "GO:1902920": "poly(hydroxyvalerate) metabolic process",
  "GO:1902921": "poly(hydroxyvalerate) biosynthetic process",
  "GO:1902922": "poly(3-hydroxyvalerate) metabolic process",
  "GO:1902923": "poly(3-hydroxyvalerate) biosynthetic process",
  "GO:1902924": "poly(hydroxyalkanoate) biosynthetic process from glucose",
  "GO:1902925": "poly(hydroxyalkanoate) biosynthetic process from fatty acid",
  "GO:1902926": "inulin metabolic process",
  "GO:1902927": "inulin catabolic process",
  "GO:1902928": "inulin biosynthetic process",
  "GO:1902929": "plasma membrane of growing cell tip",
  "GO:1902930": "regulation of alcohol biosynthetic process",
  "GO:1902931": "negative regulation of alcohol biosynthetic process",
  "GO:1902932": "positive regulation of alcohol biosynthetic process",
  "GO:1902933": "isopentenol metabolic process",
  "GO:1902934": "isopentenol biosynthetic process",
  "GO:1902935": "protein localization to septin ring",
  "GO:1902936": "phosphatidylinositol bisphosphate binding",
  "GO:1902937": "inward rectifier potassium channel complex",
  "GO:1902938": "regulation of intracellular calcium activated chloride channel activity",
  "GO:1902939": "negative regulation of intracellular calcium activated chloride channel activity",
  "GO:1902940": "positive regulation of intracellular calcium activated chloride channel activity",
  "GO:1902941": "regulation of voltage-gated chloride channel activity",
  "GO:1902942": "negative regulation of voltage-gated chloride channel activity",
  "GO:1902943": "positive regulation of voltage-gated chloride channel activity",
  "GO:1902944": "aspartic-type endopeptidase activity involved in amyloid precursor protein catabolic process",
  "GO:1902945": "metalloendopeptidase activity involved in amyloid precursor protein catabolic process",
  "GO:1902946": "protein localization to early endosome",
  "GO:1902947": "regulation of tau-protein kinase activity",
  "GO:1902948": "negative regulation of tau-protein kinase activity",
  "GO:1902949": "positive regulation of tau-protein kinase activity",
  "GO:1902950": "regulation of dendritic spine maintenance",
  "GO:1902951": "negative regulation of dendritic spine maintenance",
  "GO:1902952": "positive regulation of dendritic spine maintenance",
  "GO:1902953": "positive regulation of ER to Golgi vesicle-mediated transport",
  "GO:1902954": "regulation of early endosome to recycling endosome transport",
  "GO:1902955": "positive regulation of early endosome to recycling endosome transport",
  "GO:1902956": "regulation of mitochondrial electron transport, NADH to ubiquinone",
  "GO:1902957": "negative regulation of mitochondrial electron transport, NADH to ubiquinone",
  "GO:1902958": "positive regulation of mitochondrial electron transport, NADH to ubiquinone",
  "GO:1902959": "regulation of aspartic-type endopeptidase activity involved in amyloid precursor protein catabolic process",
  "GO:1902960": "negative regulation of aspartic-type endopeptidase activity involved in amyloid precursor protein catabolic process",
  "GO:1902961": "positive regulation of aspartic-type endopeptidase activity involved in amyloid precursor protein catabolic process",
  "GO:1902962": "regulation of metalloendopeptidase activity involved in amyloid precursor protein catabolic process",
  "GO:1902963": "negative regulation of metalloendopeptidase activity involved in amyloid precursor protein catabolic process",
  "GO:1902964": "positive regulation of metalloendopeptidase activity involved in amyloid precursor protein catabolic process",
  "GO:1902965": "regulation of protein localization to early endosome",
  "GO:1902966": "positive regulation of protein localization to early endosome",
  "GO:1902967": "protein localization to mitotic spindle midzone",
  "GO:1902969": "mitotic DNA replication",
  "GO:1902970": "premeiotic DNA replication DNA duplex unwinding",
  "GO:1902971": "mitotic DNA replication DNA duplex unwinding",
  "GO:1902972": "premeiotic DNA replication DNA ligation",
  "GO:1902973": "mitotic DNA replication DNA ligation",
  "GO:1902974": "meiotic DNA replication initiation",
  "GO:1902975": "mitotic DNA replication initiation",
  "GO:1902976": "premeiotic DNA replication preinitiation complex assembly",
  "GO:1902977": "mitotic DNA replication preinitiation complex assembly",
  "GO:1902978": "premeiotic DNA replication termination",
  "GO:1902979": "mitotic DNA replication termination",
  "GO:1902980": "synthesis of RNA primer involved in premeiotic DNA replication",
  "GO:1902981": "synthesis of RNA primer involved in mitotic DNA replication",
  "GO:1902982": "DNA strand elongation involved in premeiotic DNA replication",
  "GO:1902983": "DNA strand elongation involved in mitotic DNA replication",
  "GO:1902984": "pre-replicative complex assembly involved in premeiotic DNA replication",
  "GO:1902985": "mitotic pre-replicative complex assembly",
  "GO:1902986": "regulation of lysine biosynthetic process via aminoadipic acid",
  "GO:1902987": "negative regulation of lysine biosynthetic process via aminoadipic acid",
  "GO:1902988": "neurofibrillary tangle assembly",
  "GO:1902989": "meiotic telomere maintenance via semi-conservative replication",
  "GO:1902990": "mitotic telomere maintenance via semi-conservative replication",
  "GO:1902991": "regulation of amyloid precursor protein catabolic process",
  "GO:1902992": "negative regulation of amyloid precursor protein catabolic process",
  "GO:1902993": "positive regulation of amyloid precursor protein catabolic process",
  "GO:1902994": "regulation of phospholipid efflux",
  "GO:1902995": "positive regulation of phospholipid efflux",
  "GO:1902996": "regulation of neurofibrillary tangle assembly",
  "GO:1902997": "negative regulation of neurofibrillary tangle assembly",
  "GO:1902998": "positive regulation of neurofibrillary tangle assembly",
  "GO:1902999": "negative regulation of phospholipid efflux",
  "GO:1903000": "regulation of lipid transport across blood brain barrier",
  "GO:1903001": "negative regulation of lipid transport across blood brain barrier",
  "GO:1903002": "positive regulation of lipid transport across blood brain barrier",
  "GO:1903003": "positive regulation of protein deubiquitination",
  "GO:1903004": "regulation of protein K63-linked deubiquitination",
  "GO:1903005": "negative regulation of protein K63-linked deubiquitination",
  "GO:1903006": "positive regulation of protein K63-linked deubiquitination",
  "GO:1903007": "positive regulation of Lys63-specific deubiquitinase activity",
  "GO:1903008": "organelle disassembly",
  "GO:1903009": "proteasome complex disassembly",
  "GO:1903010": "regulation of bone development",
  "GO:1903011": "negative regulation of bone development",
  "GO:1903012": "positive regulation of bone development",
  "GO:1903013": "response to 1-(3,5-dichloro-2,6-dihydroxy-4-methoxyphenyl)hexan-1-one",
  "GO:1903014": "cellular response to 1-(3,5-dichloro-2,6-dihydroxy-4-methoxyphenyl)hexan-1-one",
  "GO:1903015": "regulation of exo-alpha-sialidase activity",
  "GO:1903016": "negative regulation of exo-alpha-sialidase activity",
  "GO:1903017": "positive regulation of exo-alpha-sialidase activity",
  "GO:1903018": "regulation of glycoprotein metabolic process",
  "GO:1903019": "negative regulation of glycoprotein metabolic process",
  "GO:1903020": "positive regulation of glycoprotein metabolic process",
  "GO:1903021": "regulation of phosphodiesterase activity, acting on 3'-phosphoglycolate-terminated DNA strands",
  "GO:1903022": "positive regulation of phosphodiesterase activity, acting on 3'-phosphoglycolate-terminated DNA strands",
  "GO:1903023": "regulation of ascospore-type prospore membrane assembly",
  "GO:1903024": "positive regulation of ascospore-type prospore membrane assembly",
  "GO:1903025": "regulation of RNA polymerase II regulatory region sequence-specific DNA binding",
  "GO:1903026": "negative regulation of RNA polymerase II regulatory region sequence-specific DNA binding",
  "GO:1903027": "regulation of opsonization",
  "GO:1903028": "positive regulation of opsonization",
  "GO:1903031": "regulation of microtubule plus-end binding",
  "GO:1903032": "negative regulation of microtubule plus-end binding",
  "GO:1903033": "positive regulation of microtubule plus-end binding",
  "GO:1903034": "regulation of response to wounding",
  "GO:1903035": "negative regulation of response to wounding",
  "GO:1903036": "positive regulation of response to wounding",
  "GO:1903037": "regulation of leukocyte cell-cell adhesion",
  "GO:1903038": "negative regulation of leukocyte cell-cell adhesion",
  "GO:1903039": "positive regulation of leukocyte cell-cell adhesion",
  "GO:1903040": "exon-exon junction complex assembly",
  "GO:1903041": "regulation of chondrocyte hypertrophy",
  "GO:1903042": "negative regulation of chondrocyte hypertrophy",
  "GO:1903043": "positive regulation of chondrocyte hypertrophy",
  "GO:1903044": "protein localization to membrane raft",
  "GO:1903045": "neural crest cell migration involved in sympathetic nervous system development",
  "GO:1903046": "meiotic cell cycle process",
  "GO:1903047": "mitotic cell cycle process",
  "GO:1903048": "regulation of acetylcholine-gated cation channel activity",
  "GO:1903049": "negative regulation of acetylcholine-gated cation channel activity",
  "GO:1903050": "regulation of proteolysis involved in cellular protein catabolic process",
  "GO:1903051": "negative regulation of proteolysis involved in cellular protein catabolic process",
  "GO:1903052": "positive regulation of proteolysis involved in cellular protein catabolic process",
  "GO:1903053": "regulation of extracellular matrix organization",
  "GO:1903054": "negative regulation of extracellular matrix organization",
  "GO:1903055": "positive regulation of extracellular matrix organization",
  "GO:1903056": "regulation of melanosome organization",
  "GO:1903057": "negative regulation of melanosome organization",
  "GO:1903058": "positive regulation of melanosome organization",
  "GO:1903059": "regulation of protein lipidation",
  "GO:1903060": "negative regulation of protein lipidation",
  "GO:1903061": "positive regulation of protein lipidation",
  "GO:1903062": "regulation of reverse cholesterol transport",
  "GO:1903063": "negative regulation of reverse cholesterol transport",
  "GO:1903064": "positive regulation of reverse cholesterol transport",
  "GO:1903065": "obsolete protein localization to cell tip involved in positive regulation of establishment of cell polarity regulating cell shape",
  "GO:1903066": "regulation of protein localization to cell tip",
  "GO:1903067": "negative regulation of protein localization to cell tip",
  "GO:1903068": "positive regulation of protein localization to cell tip",
  "GO:1903069": "regulation of ER-associated ubiquitin-dependent protein catabolic process",
  "GO:1903070": "negative regulation of ER-associated ubiquitin-dependent protein catabolic process",
  "GO:1903071": "positive regulation of ER-associated ubiquitin-dependent protein catabolic process",
  "GO:1903072": "regulation of death-inducing signaling complex assembly",
  "GO:1903073": "negative regulation of death-inducing signaling complex assembly",
  "GO:1903074": "TRAIL death-inducing signaling complex assembly",
  "GO:1903075": "pyridoxine import into cell",
  "GO:1903076": "regulation of protein localization to plasma membrane",
  "GO:1903077": "negative regulation of protein localization to plasma membrane",
  "GO:1903078": "positive regulation of protein localization to plasma membrane",
  "GO:1903079": "obsolete negative regulation of protein localization to cell tip involved in positive regulation of establishment of cell polarity regulating cell shape",
  "GO:1903080": "regulation of C-C chemokine receptor CCR7 signaling pathway",
  "GO:1903081": "negative regulation of C-C chemokine receptor CCR7 signaling pathway",
  "GO:1903082": "positive regulation of C-C chemokine receptor CCR7 signaling pathway",
  "GO:1903083": "protein localization to condensed chromosome",
  "GO:1903084": "protein localization to condensed nuclear chromosome",
  "GO:1903085": "regulation of sinapate ester biosynthetic process",
  "GO:1903086": "negative regulation of sinapate ester biosynthetic process",
  "GO:1903087": "mitotic spindle pole body duplication",
  "GO:1903088": "5-amino-1-ribofuranosylimidazole-4-carboxamide transmembrane transport",
  "GO:1903089": "5-amino-1-ribofuranosylimidazole-4-carboxamide transporter activity",
  "GO:1903090": "pyridoxal transmembrane transport",
  "GO:1903091": "pyridoxamine transmembrane transport",
  "GO:1903092": "pyridoxine transmembrane transport",
  "GO:1903093": "regulation of protein K48-linked deubiquitination",
  "GO:1903094": "negative regulation of protein K48-linked deubiquitination",
  "GO:1903095": "ribonuclease III complex",
  "GO:1903096": "protein localization to meiotic spindle midzone",
  "GO:1903097": "regulation of CENP-A containing nucleosome assembly",
  "GO:1903098": "negative regulation of CENP-A containing nucleosome assembly",
  "GO:1903099": "positive regulation of CENP-A containing nucleosome assembly",
  "GO:1903100": "1-phosphatidyl-1D-myo-inositol 3,5-bisphosphate metabolic process",
  "GO:1903101": "1-phosphatidyl-1D-myo-inositol 3,5-bisphosphate catabolic process",
  "GO:1903102": "1-phosphatidyl-1D-myo-inositol 3,5-bisphosphate biosynthetic process",
  "GO:1903103": "potassium:proton antiporter complex",
  "GO:1903104": "regulation of insulin receptor signaling pathway involved in determination of adult lifespan",
  "GO:1903105": "negative regulation of insulin receptor signaling pathway involved in determination of adult lifespan",
  "GO:1903106": "positive regulation of insulin receptor signaling pathway involved in determination of adult lifespan",
  "GO:1903107": "insulin receptor signaling pathway involved in dauer larval development",
  "GO:1903108": "regulation of transcription from mitochondrial promoter",
  "GO:1903109": "positive regulation of transcription from mitochondrial promoter",
  "GO:1903110": "regulation of single-strand break repair via homologous recombination",
  "GO:1903111": "negative regulation of single-strand break repair via homologous recombination",
  "GO:1903112": "positive regulation of single-strand break repair via homologous recombination",
  "GO:1903113": "copper ion transmembrane transporter complex",
  "GO:1903114": "silver ion transmembrane transporter complex",
  "GO:1903115": "regulation of actin filament-based movement",
  "GO:1903116": "positive regulation of actin filament-based movement",
  "GO:1903117": "regulation of actin filament organization involved in cytokinetic actomyosin contractile ring assembly",
  "GO:1903118": "urate homeostasis",
  "GO:1903119": "protein localization to actin cytoskeleton",
  "GO:1903120": "protein localization to actin filament bundle",
  "GO:1903121": "regulation of TRAIL-activated apoptotic signaling pathway",
  "GO:1903122": "negative regulation of TRAIL-activated apoptotic signaling pathway",
  "GO:1903123": "regulation of thioredoxin peroxidase activity",
  "GO:1903124": "negative regulation of thioredoxin peroxidase activity",
  "GO:1903125": "negative regulation of thioredoxin peroxidase activity by peptidyl-threonine phosphorylation",
  "GO:1903126": "negative regulation of centriole-centriole cohesion",
  "GO:1903127": "positive regulation of centriole-centriole cohesion",
  "GO:1903128": "regulation of leucine import into cell",
  "GO:1903129": "negative regulation of leucine import into cell",
  "GO:1903130": "positive regulation of leucine import into cell",
  "GO:1903131": "mononuclear cell differentiation",
  "GO:1903132": "regulation of tube lumen cavitation",
  "GO:1903133": "negative regulation of tube lumen cavitation",
  "GO:1903134": "trehalose catabolic process involved in cellular response to stress",
  "GO:1903135": "cupric ion binding",
  "GO:1903136": "cuprous ion binding",
  "GO:1903137": "regulation of MAPK cascade involved in cell wall organization or biogenesis",
  "GO:1903138": "negative regulation of MAPK cascade involved in cell wall organization or biogenesis",
  "GO:1903139": "positive regulation of MAPK cascade involved in cell wall organization or biogenesis",
  "GO:1903140": "regulation of establishment of endothelial barrier",
  "GO:1903141": "negative regulation of establishment of endothelial barrier",
  "GO:1903142": "positive regulation of establishment of endothelial barrier",
  "GO:1903143": "adrenomedullin receptor complex",
  "GO:1903144": "actomyosin contractile ring actin filament",
  "GO:1903145": "actin filament of cell cortex of cell tip",
  "GO:1903146": "regulation of mitophagy",
  "GO:1903147": "negative regulation of mitophagy",
  "GO:1903148": "obsolete uracil transmembrane transporter activity involved in uracil import into cell",
  "GO:1903149": "obsolete adenine transmembrane transporter activity involved in adenine import into cell",
  "GO:1903150": "obsolete calcium ion transmembrane transporter activity involved in calcium ion import into cell",
  "GO:1903151": "obsolete carbohydrate transmembrane transporter activity involved in carbohydrate import into cell",
  "GO:1903152": "obsolete copper ion transmembrane transporter activity involved in copper ion import into cell",
  "GO:1903153": "obsolete ferrous iron transmembrane transporter activity involved in ferrous iron import into cell",
  "GO:1903154": "obsolete glucose transmembrane transporter activity involved in glucose import into cell",
  "GO:1903155": "obsolete glutathione transmembrane transporter activity involved in glutathione import into cell",
  "GO:1903156": "obsolete guanine transmembrane transporter activity involved in guanine import into cell",
  "GO:1903157": "obsolete iron ion transmembrane transporter activity involved in iron ion import into cell",
  "GO:1903158": "obsolete L-glutamate transmembrane transporter activity involved in L-glutamate import into cell",
  "GO:1903159": "obsolete malate transmembrane transporter activity involved in malate import into cell",
  "GO:1903160": "obsolete nickel cation transmembrane transporter activity involved in nickel cation import into cell",
  "GO:1903161": "obsolete pantothenate transmembrane transporter activity involved in pantothenate import into cell",
  "GO:1903162": "obsolete serine transmembrane transporter activity involved in serine import into cell",
  "GO:1903163": "obsolete sodium ion transmembrane transporter activity involved in sodium ion import into cell",
  "GO:1903164": "obsolete succinate transmembrane transporter activity involved in succinate import into cell",
  "GO:1903165": "response to polycyclic arene",
  "GO:1903166": "cellular response to polycyclic arene",
  "GO:1903167": "regulation of pyrroline-5-carboxylate reductase activity",
  "GO:1903168": "positive regulation of pyrroline-5-carboxylate reductase activity",
  "GO:1903169": "regulation of calcium ion transmembrane transport",
  "GO:1903170": "negative regulation of calcium ion transmembrane transport",
  "GO:1903171": "carbon dioxide homeostasis",
  "GO:1903172": "cellular carbon dioxide homeostasis",
  "GO:1903173": "fatty alcohol metabolic process",
  "GO:1903174": "fatty alcohol catabolic process",
  "GO:1903175": "fatty alcohol biosynthetic process",
  "GO:1903176": "regulation of tyrosine 3-monooxygenase activity",
  "GO:1903177": "negative regulation of tyrosine 3-monooxygenase activity",
  "GO:1903178": "positive regulation of tyrosine 3-monooxygenase activity",
  "GO:1903179": "regulation of dopamine biosynthetic process",
  "GO:1903180": "negative regulation of dopamine biosynthetic process",
  "GO:1903181": "positive regulation of dopamine biosynthetic process",
  "GO:1903182": "regulation of SUMO transferase activity",
  "GO:1903183": "negative regulation of SUMO transferase activity",
  "GO:1903184": "L-dopa metabolic process",
  "GO:1903185": "L-dopa biosynthetic process",
  "GO:1903186": "regulation of vitellogenesis",
  "GO:1903187": "negative regulation of vitellogenesis",
  "GO:1903188": "positive regulation of vitellogenesis",
  "GO:1903189": "glyoxal metabolic process",
  "GO:1903190": "glyoxal catabolic process",
  "GO:1903191": "glyoxal biosynthetic process",
  "GO:1903192": "sesquarterpene metabolic process",
  "GO:1903193": "sesquarterpene biosynthetic process",
  "GO:1903195": "regulation of L-dopa biosynthetic process",
  "GO:1903196": "negative regulation of L-dopa biosynthetic process",
  "GO:1903197": "positive regulation of L-dopa biosynthetic process",
  "GO:1903198": "regulation of L-dopa decarboxylase activity",
  "GO:1903199": "negative regulation of L-dopa decarboxylase activity",
  "GO:1903200": "positive regulation of L-dopa decarboxylase activity",
  "GO:1903201": "regulation of oxidative stress-induced cell death",
  "GO:1903202": "negative regulation of oxidative stress-induced cell death",
  "GO:1903203": "regulation of oxidative stress-induced neuron death",
  "GO:1903204": "negative regulation of oxidative stress-induced neuron death",
  "GO:1903205": "regulation of hydrogen peroxide-induced cell death",
  "GO:1903206": "negative regulation of hydrogen peroxide-induced cell death",
  "GO:1903207": "regulation of hydrogen peroxide-induced neuron death",
  "GO:1903208": "negative regulation of hydrogen peroxide-induced neuron death",
  "GO:1903209": "positive regulation of oxidative stress-induced cell death",
  "GO:1903210": "glomerular visceral epithelial cell apoptotic process",
  "GO:1903211": "mitotic recombination involved in replication fork processing",
  "GO:1903212": "protein localization to mating-type region heterochromatin",
  "GO:1903213": "protein localization to subtelomeric heterochromatin",
  "GO:1903214": "regulation of protein targeting to mitochondrion",
  "GO:1903215": "negative regulation of protein targeting to mitochondrion",
  "GO:1903216": "regulation of protein processing involved in protein targeting to mitochondrion",
  "GO:1903217": "negative regulation of protein processing involved in protein targeting to mitochondrion",
  "GO:1903218": "regulation of malate dehydrogenase (decarboxylating) (NADP+) activity",
  "GO:1903219": "negative regulation of malate dehydrogenase (decarboxylating) (NADP+) activity",
  "GO:1903220": "positive regulation of malate dehydrogenase (decarboxylating) (NADP+) activity",
  "GO:1903221": "regulation of mitotic recombination involved in replication fork processing",
  "GO:1903222": "quinolinic acid transmembrane transport",
  "GO:1903223": "positive regulation of oxidative stress-induced neuron death",
  "GO:1903224": "regulation of endodermal cell differentiation",
  "GO:1903225": "negative regulation of endodermal cell differentiation",
  "GO:1903226": "positive regulation of endodermal cell differentiation",
  "GO:1903227": "xanthosine metabolic process",
  "GO:1903228": "xanthosine catabolic process",
  "GO:1903229": "xanthosine biosynthetic process",
  "GO:1903230": "obsolete miRNA binding involved in posttranscriptional gene silencing",
  "GO:1903231": "mRNA binding involved in posttranscriptional gene silencing",
  "GO:1903232": "melanosome assembly",
  "GO:1903233": "regulation of calcium ion-dependent exocytosis of neurotransmitter",
  "GO:1903234": "negative regulation of calcium ion-dependent exocytosis of neurotransmitter",
  "GO:1903235": "positive regulation of calcium ion-dependent exocytosis of neurotransmitter",
  "GO:1903236": "regulation of leukocyte tethering or rolling",
  "GO:1903237": "negative regulation of leukocyte tethering or rolling",
  "GO:1903238": "positive regulation of leukocyte tethering or rolling",
  "GO:1903239": "obsolete regulation of positive regulation of the force of heart contraction by chemical signal",
  "GO:1903240": "obsolete negative regulation of positive regulation of the force of heart contraction by chemical signal",
  "GO:1903241": "U2-type prespliceosome assembly",
  "GO:1903242": "regulation of cardiac muscle hypertrophy in response to stress",
  "GO:1903243": "negative regulation of cardiac muscle hypertrophy in response to stress",
  "GO:1903244": "positive regulation of cardiac muscle hypertrophy in response to stress",
  "GO:1903245": "regulation of adrenergic receptor signaling pathway involved in positive regulation of heart rate",
  "GO:1903246": "negative regulation of adrenergic receptor signaling pathway involved in positive regulation of heart rate",
  "GO:1903247": "positive regulation of adrenergic receptor signaling pathway involved in positive regulation of heart rate",
  "GO:1903248": "regulation of citrulline biosynthetic process",
  "GO:1903249": "negative regulation of citrulline biosynthetic process",
  "GO:1903250": "positive regulation of citrulline biosynthetic process",
  "GO:1903251": "multi-ciliated epithelial cell differentiation",
  "GO:1903252": "hercynylcysteine sulfoxide metabolic process",
  "GO:1903253": "hercynylcysteine sulfoxide biosynthetic process",
  "GO:1903254": "hercynylselenocysteine metabolic process",
  "GO:1903255": "hercynylselenocysteine biosynthetic process",
  "GO:1903256": "selenoneine metabolic process",
  "GO:1903257": "selenoneine biosynthetic process",
  "GO:1903258": "sorbose import into cell",
  "GO:1903259": "exon-exon junction complex disassembly",
  "GO:1903260": "protein localization to mating projection tip",
  "GO:1903261": "regulation of serine phosphorylation of STAT3 protein",
  "GO:1903262": "negative regulation of serine phosphorylation of STAT3 protein",
  "GO:1903263": "positive regulation of serine phosphorylation of STAT3 protein",
  "GO:1903264": "nitrate reductase activity involved in anaerobic electron transport chain",
  "GO:1903265": "positive regulation of tumor necrosis factor-mediated signaling pathway",
  "GO:1903266": "regulation of ornithine catabolic process",
  "GO:1903267": "negative regulation of ornithine catabolic process",
  "GO:1903268": "positive regulation of ornithine catabolic process",
  "GO:1903269": "ornithine carbamoyltransferase inhibitor complex",
  "GO:1903270": "regulation of cytoplasmic translational elongation through polyproline stretches",
  "GO:1903271": "negative regulation of cytoplasmic translational elongation through polyproline stretches",
  "GO:1903272": "positive regulation of cytoplasmic translational elongation through polyproline stretches",
  "GO:1903273": "regulation of sodium ion export",
  "GO:1903274": "negative regulation of sodium ion export",
  "GO:1903275": "positive regulation of sodium ion export",
  "GO:1903276": "regulation of sodium ion export from cell",
  "GO:1903277": "negative regulation of sodium ion export from cell",
  "GO:1903278": "positive regulation of sodium ion export from cell",
  "GO:1903279": "regulation of calcium:sodium antiporter activity",
  "GO:1903280": "negative regulation of calcium:sodium antiporter activity",
  "GO:1903281": "positive regulation of calcium:sodium antiporter activity",
  "GO:1903282": "regulation of glutathione peroxidase activity",
  "GO:1903283": "negative regulation of glutathione peroxidase activity",
  "GO:1903284": "positive regulation of glutathione peroxidase activity",
  "GO:1903285": "positive regulation of hydrogen peroxide catabolic process",
  "GO:1903286": "regulation of potassium ion import",
  "GO:1903287": "negative regulation of potassium ion import",
  "GO:1903288": "positive regulation of potassium ion import",
  "GO:1903289": "obsolete regulation of ATP catabolic process",
  "GO:1903290": "obsolete negative regulation of ATP catabolic process",
  "GO:1903291": "obsolete positive regulation of ATP catabolic process",
  "GO:1903292": "protein localization to Golgi membrane",
  "GO:1903293": "phosphatase complex",
  "GO:1903294": "regulation of glutamate secretion, neurotransmission",
  "GO:1903295": "negative regulation of glutamate secretion, neurotransmission",
  "GO:1903296": "positive regulation of glutamate secretion, neurotransmission",
  "GO:1903297": "regulation of hypoxia-induced intrinsic apoptotic signaling pathway",
  "GO:1903298": "negative regulation of hypoxia-induced intrinsic apoptotic signaling pathway",
  "GO:1903299": "regulation of hexokinase activity",
  "GO:1903300": "negative regulation of hexokinase activity",
  "GO:1903301": "positive regulation of hexokinase activity",
  "GO:1903302": "regulation of pyruvate kinase activity",
  "GO:1903303": "negative regulation of pyruvate kinase activity",
  "GO:1903304": "positive regulation of pyruvate kinase activity",
  "GO:1903305": "regulation of regulated secretory pathway",
  "GO:1903306": "negative regulation of regulated secretory pathway",
  "GO:1903307": "positive regulation of regulated secretory pathway",
  "GO:1903308": "regulation of chromatin modification",
  "GO:1903309": "negative regulation of chromatin modification",
  "GO:1903310": "positive regulation of chromatin modification",
  "GO:1903311": "regulation of mRNA metabolic process",
  "GO:1903312": "negative regulation of mRNA metabolic process",
  "GO:1903313": "positive regulation of mRNA metabolic process",
  "GO:1903314": "regulation of nitrogen cycle metabolic process",
  "GO:1903315": "negative regulation of nitrogen cycle metabolic process",
  "GO:1903316": "positive regulation of nitrogen cycle metabolic process",
  "GO:1903317": "regulation of protein maturation",
  "GO:1903318": "negative regulation of protein maturation",
  "GO:1903319": "positive regulation of protein maturation",
  "GO:1903320": "regulation of protein modification by small protein conjugation or removal",
  "GO:1903321": "negative regulation of protein modification by small protein conjugation or removal",
  "GO:1903322": "positive regulation of protein modification by small protein conjugation or removal",
  "GO:1903323": "regulation of snoRNA metabolic process",
  "GO:1903324": "negative regulation of snoRNA metabolic process",
  "GO:1903325": "positive regulation of snoRNA metabolic process",
  "GO:1903326": "regulation of tRNA metabolic process",
  "GO:1903327": "negative regulation of tRNA metabolic process",
  "GO:1903328": "positive regulation of tRNA metabolic process",
  "GO:1903329": "regulation of iron-sulfur cluster assembly",
  "GO:1903330": "negative regulation of iron-sulfur cluster assembly",
  "GO:1903331": "positive regulation of iron-sulfur cluster assembly",
  "GO:1903332": "regulation of protein folding",
  "GO:1903333": "negative regulation of protein folding",
  "GO:1903334": "positive regulation of protein folding",
  "GO:1903335": "regulation of vacuolar transport",
  "GO:1903336": "negative regulation of vacuolar transport",
  "GO:1903337": "positive regulation of vacuolar transport",
  "GO:1903338": "regulation of cell wall organization or biogenesis",
  "GO:1903339": "negative regulation of cell wall organization or biogenesis",
  "GO:1903340": "positive regulation of cell wall organization or biogenesis",
  "GO:1903341": "regulation of meiotic DNA double-strand break formation",
  "GO:1903342": "negative regulation of meiotic DNA double-strand break formation",
  "GO:1903343": "positive regulation of meiotic DNA double-strand break formation",
  "GO:1903344": "regulation of protein polyglycylation",
  "GO:1903345": "negative regulation of protein polyglycylation",
  "GO:1903346": "positive regulation of protein polyglycylation",
  "GO:1903347": "negative regulation of bicellular tight junction assembly",
  "GO:1903348": "positive regulation of bicellular tight junction assembly",
  "GO:1903349": "omegasome membrane",
  "GO:1903350": "response to dopamine",
  "GO:1903351": "cellular response to dopamine",
  "GO:1903352": "L-ornithine transmembrane transport",
  "GO:1903353": "regulation of nucleus organization",
  "GO:1903354": "regulation of distal tip cell migration",
  "GO:1903355": "negative regulation of distal tip cell migration",
  "GO:1903356": "positive regulation of distal tip cell migration",
  "GO:1903357": "regulation of transcription initiation from RNA polymerase I promoter for nuclear large rRNA transcript",
  "GO:1903358": "regulation of Golgi organization",
  "GO:1903359": "lateral cortical node assembly",
  "GO:1903360": "protein localization to lateral cortical node",
  "GO:1903361": "protein localization to basolateral plasma membrane",
  "GO:1903362": "regulation of cellular protein catabolic process",
  "GO:1903363": "negative regulation of cellular protein catabolic process",
  "GO:1903364": "positive regulation of cellular protein catabolic process",
  "GO:1903365": "regulation of fear response",
  "GO:1903366": "negative regulation of fear response",
  "GO:1903367": "positive regulation of fear response",
  "GO:1903368": "regulation of foraging behavior",
  "GO:1903369": "negative regulation of foraging behavior",
  "GO:1903370": "positive regulation of foraging behavior",
  "GO:1903371": "regulation of endoplasmic reticulum tubular network organization",
  "GO:1903372": "negative regulation of endoplasmic reticulum tubular network organization",
  "GO:1903373": "positive regulation of endoplasmic reticulum tubular network organization",
  "GO:1903374": "subarachnoid space development",
  "GO:1903375": "facioacoustic ganglion development",
  "GO:1903376": "regulation of oxidative stress-induced neuron intrinsic apoptotic signaling pathway",
  "GO:1903377": "negative regulation of oxidative stress-induced neuron intrinsic apoptotic signaling pathway",
  "GO:1903378": "positive regulation of oxidative stress-induced neuron intrinsic apoptotic signaling pathway",
  "GO:1903379": "regulation of mitotic chromosome condensation",
  "GO:1903380": "positive regulation of mitotic chromosome condensation",
  "GO:1903381": "regulation of endoplasmic reticulum stress-induced neuron intrinsic apoptotic signaling pathway",
  "GO:1903382": "negative regulation of endoplasmic reticulum stress-induced neuron intrinsic apoptotic signaling pathway",
  "GO:1903383": "regulation of hydrogen peroxide-induced neuron intrinsic apoptotic signaling pathway",
  "GO:1903384": "negative regulation of hydrogen peroxide-induced neuron intrinsic apoptotic signaling pathway",
  "GO:1903385": "regulation of homophilic cell adhesion",
  "GO:1903386": "negative regulation of homophilic cell adhesion",
  "GO:1903387": "positive regulation of homophilic cell adhesion",
  "GO:1903388": "regulation of synaptic vesicle uncoating",
  "GO:1903389": "negative regulation of synaptic vesicle uncoating",
  "GO:1903390": "positive regulation of synaptic vesicle uncoating",
  "GO:1903391": "regulation of adherens junction organization",
  "GO:1903392": "negative regulation of adherens junction organization",
  "GO:1903393": "positive regulation of adherens junction organization",
  "GO:1903394": "protein localization to kinetochore involved in kinetochore assembly",
  "GO:1903395": "regulation of secondary cell septum biogenesis",
  "GO:1903396": "negative regulation of secondary cell septum biogenesis",
  "GO:1903397": "positive regulation of secondary cell septum biogenesis",
  "GO:1903398": "regulation of m7G(5')pppN diphosphatase activity",
  "GO:1903399": "positive regulation of m7G(5')pppN diphosphatase activity",
  "GO:1903400": "L-arginine transmembrane transport",
  "GO:1903401": "L-lysine transmembrane transport",
  "GO:1903402": "regulation of renal phosphate excretion",
  "GO:1903403": "negative regulation of renal phosphate excretion",
  "GO:1903404": "positive regulation of renal phosphate excretion",
  "GO:1903405": "protein localization to nuclear body",
  "GO:1903406": "regulation of sodium:potassium-exchanging ATPase activity",
  "GO:1903407": "negative regulation of sodium:potassium-exchanging ATPase activity",
  "GO:1903408": "positive regulation of sodium:potassium-exchanging ATPase activity",
  "GO:1903409": "reactive oxygen species biosynthetic process",
  "GO:1903410": "L-lysine import into cell",
  "GO:1903411": "L-ornithine import into cell",
  "GO:1903412": "response to bile acid",
  "GO:1903413": "cellular response to bile acid",
  "GO:1903414": "iron cation export",
  "GO:1903415": "flavonoid transport from endoplasmic reticulum to plant-type vacuole",
  "GO:1903416": "response to glycoside",
  "GO:1903418": "protein localization to plasma membrane of cell tip",
  "GO:1903419": "protein localization to cortical endoplasmic reticulum",
  "GO:1903420": "protein localization to endoplasmic reticulum tubular network",
  "GO:1903421": "regulation of synaptic vesicle recycling",
  "GO:1903422": "negative regulation of synaptic vesicle recycling",
  "GO:1903423": "positive regulation of synaptic vesicle recycling",
  "GO:1903424": "fluoride transmembrane transport",
  "GO:1903425": "fluoride transmembrane transporter activity",
  "GO:1903426": "regulation of reactive oxygen species biosynthetic process",
  "GO:1903427": "negative regulation of reactive oxygen species biosynthetic process",
  "GO:1903428": "positive regulation of reactive oxygen species biosynthetic process",
  "GO:1903429": "regulation of cell maturation",
  "GO:1903430": "negative regulation of cell maturation",
  "GO:1903431": "positive regulation of cell maturation",
  "GO:1903432": "regulation of TORC1 signaling",
  "GO:1903433": "regulation of constitutive secretory pathway",
  "GO:1903434": "negative regulation of constitutive secretory pathway",
  "GO:1903435": "positive regulation of constitutive secretory pathway",
  "GO:1903436": "regulation of mitotic cytokinetic process",
  "GO:1903437": "negative regulation of mitotic cytokinetic process",
  "GO:1903438": "positive regulation of mitotic cytokinetic process",
  "GO:1903439": "calcitonin family receptor complex",
  "GO:1903440": "amylin receptor complex",
  "GO:1903441": "protein localization to ciliary membrane",
  "GO:1903442": "response to lipoic acid",
  "GO:1903443": "cellular response to lipoic acid",
  "GO:1903444": "negative regulation of brown fat cell differentiation",
  "GO:1903445": "protein transport from ciliary membrane to plasma membrane",
  "GO:1903446": "geraniol metabolic process",
  "GO:1903447": "geraniol catabolic process",
  "GO:1903448": "geraniol biosynthetic process",
  "GO:1903449": "androst-4-ene-3,17-dione biosynthetic process",
  "GO:1903450": "regulation of G1 to G0 transition",
  "GO:1903451": "negative regulation of G1 to G0 transition",
  "GO:1903452": "positive regulation of G1 to G0 transition",
  "GO:1903453": "RNA interference involved in olfactory learning",
  "GO:1903454": "regulation of androst-4-ene-3,17-dione biosynthetic process",
  "GO:1903455": "negative regulation of androst-4-ene-3,17-dione biosynthetic process",
  "GO:1903456": "positive regulation of androst-4-ene-3,17-dione biosynthetic process",
  "GO:1903457": "lactate catabolic process",
  "GO:1903459": "mitotic DNA replication lagging strand elongation",
  "GO:1903460": "mitotic DNA replication leading strand elongation",
  "GO:1903461": "Okazaki fragment processing involved in mitotic DNA replication",
  "GO:1903463": "regulation of mitotic cell cycle DNA replication",
  "GO:1903464": "negative regulation of mitotic cell cycle DNA replication",
  "GO:1903465": "positive regulation of mitotic cell cycle DNA replication",
  "GO:1903466": "regulation of mitotic DNA replication initiation",
  "GO:1903467": "negative regulation of mitotic DNA replication initiation",
  "GO:1903468": "positive regulation of DNA replication initiation",
  "GO:1903469": "removal of RNA primer involved in mitotic DNA replication",
  "GO:1903470": "obsolete actomyosin contractile ring assembly involved in mitotic cell cycle",
  "GO:1903471": "regulation of mitotic actomyosin contractile ring contraction",
  "GO:1903472": "negative regulation of mitotic actomyosin contractile ring contraction",
  "GO:1903473": "positive regulation of mitotic actomyosin contractile ring contraction",
  "GO:1903474": "maintenance of mitotic actomyosin contractile ring localization",
  "GO:1903475": "mitotic actomyosin contractile ring assembly",
  "GO:1903476": "protein localization to cell division site involved in mitotic actomyosin contractile ring assembly",
  "GO:1903477": "mitotic contractile ring actin filament bundle assembly",
  "GO:1903478": "actin filament bundle convergence involved in mitotic contractile ring assembly",
  "GO:1903479": "mitotic actomyosin contractile ring assembly actin filament organization",
  "GO:1903480": "regulation of actin filament organization involved in mitotic actomyosin contractile ring assembly",
  "GO:1903481": "negative regulation of actin filament organization involved in mitotic actomyosin contractile ring assembly",
  "GO:1903482": "positive regulation of actin filament organization involved in mitotic actomyosin contractile ring assembly",
  "GO:1903483": "regulation of maintenance of mitotic actomyosin contractile ring localization",
  "GO:1903484": "negative regulation of maintenance of mitotic actomyosin contractile ring localization",
  "GO:1903485": "positive regulation of maintenance of mitotic actomyosin contractile ring localization",
  "GO:1903486": "establishment of mitotic actomyosin contractile ring localization",
  "GO:1903487": "regulation of lactation",
  "GO:1903488": "negative regulation of lactation",
  "GO:1903489": "positive regulation of lactation",
  "GO:1903490": "positive regulation of mitotic cytokinesis",
  "GO:1903491": "response to simvastatin",
  "GO:1903492": "response to acetylsalicylate",
  "GO:1903493": "response to clopidogrel",
  "GO:1903494": "response to dehydroepiandrosterone",
  "GO:1903495": "cellular response to dehydroepiandrosterone",
  "GO:1903496": "response to 11-deoxycorticosterone",
  "GO:1903497": "cellular response to 11-deoxycorticosterone",
  "GO:1903498": "bundle sheath cell differentiation",
  "GO:1903499": "regulation of mitotic actomyosin contractile ring assembly",
  "GO:1903500": "negative regulation of mitotic actomyosin contractile ring assembly",
  "GO:1903501": "positive regulation of mitotic actomyosin contractile ring assembly",
  "GO:1903502": "translation repressor complex",
  "GO:1903503": "ATPase inhibitor complex",
  "GO:1903504": "regulation of mitotic spindle checkpoint",
  "GO:1903505": "regulation of establishment of actomyosin contractile ring localization involved in mitotic cell cycle",
  "GO:1903506": "regulation of nucleic acid-templated transcription",
  "GO:1903507": "negative regulation of nucleic acid-templated transcription",
  "GO:1903508": "positive regulation of nucleic acid-templated transcription",
  "GO:1903509": "liposaccharide metabolic process",
  "GO:1903510": "mucopolysaccharide metabolic process",
  "GO:1903511": "orotic acid metabolic process",
  "GO:1903512": "phytanic acid metabolic process",
  "GO:1903513": "endoplasmic reticulum to cytosol transport",
  "GO:1903514": "calcium ion transport from endoplasmic reticulum to cytosol",
  "GO:1903515": "calcium ion transport from cytosol to endoplasmic reticulum",
  "GO:1903516": "regulation of single strand break repair",
  "GO:1903517": "negative regulation of single strand break repair",
  "GO:1903518": "positive regulation of single strand break repair",
  "GO:1903519": "regulation of mammary gland involution",
  "GO:1903520": "negative regulation of mammary gland involution",
  "GO:1903521": "positive regulation of mammary gland involution",
  "GO:1903522": "regulation of blood circulation",
  "GO:1903523": "negative regulation of blood circulation",
  "GO:1903524": "positive regulation of blood circulation",
  "GO:1903525": "regulation of membrane tubulation",
  "GO:1903526": "negative regulation of membrane tubulation",
  "GO:1903527": "positive regulation of membrane tubulation",
  "GO:1903528": "regulation of dCDP biosynthetic process",
  "GO:1903529": "negative regulation of dCDP biosynthetic process",
  "GO:1903530": "regulation of secretion by cell",
  "GO:1903531": "negative regulation of secretion by cell",
  "GO:1903532": "positive regulation of secretion by cell",
  "GO:1903533": "regulation of protein targeting",
  "GO:1903534": "regulation of lactose biosynthetic process",
  "GO:1903535": "negative regulation of lactose biosynthetic process",
  "GO:1903536": "positive regulation of lactose biosynthetic process",
  "GO:1903537": "meiotic cell cycle process involved in oocyte maturation",
  "GO:1903538": "regulation of meiotic cell cycle process involved in oocyte maturation",
  "GO:1903539": "protein localization to postsynaptic membrane",
  "GO:1903540": "establishment of protein localization to postsynaptic membrane",
  "GO:1903541": "regulation of exosomal secretion",
  "GO:1903542": "negative regulation of exosomal secretion",
  "GO:1903543": "positive regulation of exosomal secretion",
  "GO:1903544": "response to butyrate",
  "GO:1903545": "cellular response to butyrate",
  "GO:1903546": "protein localization to photoreceptor outer segment",
  "GO:1903547": "regulation of growth hormone activity",
  "GO:1903548": "negative regulation of growth hormone activity",
  "GO:1903549": "positive regulation of growth hormone activity",
  "GO:1903551": "regulation of extracellular exosome assembly",
  "GO:1903552": "negative regulation of extracellular exosome assembly",
  "GO:1903553": "positive regulation of extracellular exosome assembly",
  "GO:1903554": "G-protein coupled receptor signaling pathway involved in defense response to Gram-negative bacterium",
  "GO:1903555": "regulation of tumor necrosis factor superfamily cytokine production",
  "GO:1903556": "negative regulation of tumor necrosis factor superfamily cytokine production",
  "GO:1903557": "positive regulation of tumor necrosis factor superfamily cytokine production",
  "GO:1903558": "3-cyano-L-alanine metabolic process",
  "GO:1903559": "3-cyano-L-alanine catabolic process",
  "GO:1903560": "3-cyano-L-alanine biosynthetic process",
  "GO:1903561": "extracellular vesicle",
  "GO:1903562": "microtubule bundle formation involved in mitotic spindle midzone assembly",
  "GO:1903563": "microtubule bundle formation involved in horsetail-astral microtubule organization",
  "GO:1903564": "regulation of protein localization to cilium",
  "GO:1903565": "negative regulation of protein localization to cilium",
  "GO:1903566": "positive regulation of protein localization to cilium",
  "GO:1903567": "regulation of protein localization to ciliary membrane",
  "GO:1903568": "negative regulation of protein localization to ciliary membrane",
  "GO:1903569": "positive regulation of protein localization to ciliary membrane",
  "GO:1903570": "regulation of protein kinase D signaling",
  "GO:1903571": "negative regulation of protein kinase D signaling",
  "GO:1903572": "positive regulation of protein kinase D signaling",
  "GO:1903573": "negative regulation of response to endoplasmic reticulum stress",
  "GO:1903574": "negative regulation of cellular response to amino acid starvation",
  "GO:1903575": "cornified envelope assembly",
  "GO:1903576": "response to L-arginine",
  "GO:1903577": "cellular response to L-arginine",
  "GO:1903578": "regulation of ATP metabolic process",
  "GO:1903579": "negative regulation of ATP metabolic process",
  "GO:1903580": "positive regulation of ATP metabolic process",
  "GO:1903581": "regulation of basophil degranulation",
  "GO:1903582": "negative regulation of basophil degranulation",
  "GO:1903583": "positive regulation of basophil degranulation",
  "GO:1903584": "regulation of histone deubiquitination",
  "GO:1903585": "negative regulation of histone deubiquitination",
  "GO:1903586": "positive regulation of histone deubiquitination",
  "GO:1903587": "regulation of blood vessel endothelial cell proliferation involved in sprouting angiogenesis",
  "GO:1903588": "negative regulation of blood vessel endothelial cell proliferation involved in sprouting angiogenesis",
  "GO:1903589": "positive regulation of blood vessel endothelial cell proliferation involved in sprouting angiogenesis",
  "GO:1903590": "regulation of lysozyme activity",
  "GO:1903591": "negative regulation of lysozyme activity",
  "GO:1903592": "positive regulation of lysozyme activity",
  "GO:1903593": "regulation of histamine secretion by mast cell",
  "GO:1903594": "negative regulation of histamine secretion by mast cell",
  "GO:1903595": "positive regulation of histamine secretion by mast cell",
  "GO:1903596": "regulation of gap junction assembly",
  "GO:1903597": "negative regulation of gap junction assembly",
  "GO:1903598": "positive regulation of gap junction assembly",
  "GO:1903599": "positive regulation of mitophagy",
  "GO:1903600": "glutaminase complex",
  "GO:1903601": "thermospermine metabolic process",
  "GO:1903602": "thermospermine catabolic process",
  "GO:1903603": "thermospermine biosynthetic process",
  "GO:1903604": "cytochrome metabolic process",
  "GO:1903605": "cytochrome biosynthetic process",
  "GO:1903606": "cytochrome c metabolic process",
  "GO:1903607": "cytochrome c biosynthetic process",
  "GO:1903608": "protein localization to cytoplasmic stress granule",
  "GO:1903609": "negative regulation of inward rectifier potassium channel activity",
  "GO:1903610": "regulation of calcium-dependent ATPase activity",
  "GO:1903611": "negative regulation of calcium-dependent ATPase activity",
  "GO:1903612": "positive regulation of calcium-dependent ATPase activity",
  "GO:1903613": "regulation of protein tyrosine phosphatase activity",
  "GO:1903614": "negative regulation of protein tyrosine phosphatase activity",
  "GO:1903615": "positive regulation of protein tyrosine phosphatase activity",
  "GO:1903616": "MAPK cascade involved in axon regeneration",
  "GO:1903617": "positive regulation of mitotic cytokinesis, site selection",
  "GO:1903618": "regulation of transdifferentiation",
  "GO:1903619": "negative regulation of transdifferentiation",
  "GO:1903620": "positive regulation of transdifferentiation",
  "GO:1903621": "protein localization to photoreceptor connecting cilium",
  "GO:1903622": "regulation of RNA polymerase III activity",
  "GO:1903623": "negative regulation of RNA polymerase III activity",
  "GO:1903624": "regulation of DNA catabolic process",
  "GO:1903625": "negative regulation of DNA catabolic process",
  "GO:1903626": "positive regulation of DNA catabolic process",
  "GO:1903627": "regulation of dUTP diphosphatase activity",
  "GO:1903628": "negative regulation of dUTP diphosphatase activity",
  "GO:1903629": "positive regulation of dUTP diphosphatase activity",
  "GO:1903630": "regulation of aminoacyl-tRNA ligase activity",
  "GO:1903631": "negative regulation of aminoacyl-tRNA ligase activity",
  "GO:1903632": "positive regulation of aminoacyl-tRNA ligase activity",
  "GO:1903633": "regulation of leucine-tRNA ligase activity",
  "GO:1903634": "negative regulation of leucine-tRNA ligase activity",
  "GO:1903635": "positive regulation of leucine-tRNA ligase activity",
  "GO:1903636": "regulation of protein import into mitochondrial outer membrane",
  "GO:1903637": "negative regulation of protein import into mitochondrial outer membrane",
  "GO:1903638": "positive regulation of protein import into mitochondrial outer membrane",
  "GO:1903639": "regulation of gastrin-induced gastric acid secretion",
  "GO:1903640": "negative regulation of gastrin-induced gastric acid secretion",
  "GO:1903641": "positive regulation of gastrin-induced gastric acid secretion",
  "GO:1903642": "regulation of recombination hotspot binding",
  "GO:1903643": "positive regulation of recombination hotspot binding",
  "GO:1903644": "regulation of chaperone-mediated protein folding",
  "GO:1903645": "negative regulation of chaperone-mediated protein folding",
  "GO:1903646": "positive regulation of chaperone-mediated protein folding",
  "GO:1903647": "negative regulation of chlorophyll catabolic process",
  "GO:1903648": "positive regulation of chlorophyll catabolic process",
  "GO:1903649": "regulation of cytoplasmic transport",
  "GO:1903650": "negative regulation of cytoplasmic transport",
  "GO:1903651": "positive regulation of cytoplasmic transport",
  "GO:1903652": "modulation by virus of host cytoplasmic transport",
  "GO:1903653": "modulation by symbiont of host cell motility",
  "GO:1903654": "phosphorylation of RNA polymerase II C-terminal domain serine 5 residues involved in positive regulation of transcription elongation from RNA polymerase II promoter",
  "GO:1903655": "phosphorylation of RNA polymerase II C-terminal domain serine 2 residues involved in positive regulation of transcription elongation from RNA polymerase II promoter",
  "GO:1903656": "regulation of type IV pilus biogenesis",
  "GO:1903657": "negative regulation of type IV pilus biogenesis",
  "GO:1903658": "positive regulation of type IV pilus biogenesis",
  "GO:1903659": "regulation of complement-dependent cytotoxicity",
  "GO:1903660": "negative regulation of complement-dependent cytotoxicity",
  "GO:1903661": "positive regulation of complement-dependent cytotoxicity",
  "GO:1903662": "L-altrarate metabolic process",
  "GO:1903663": "L-altrarate catabolic process",
  "GO:1903664": "regulation of asexual reproduction",
  "GO:1903665": "negative regulation of asexual reproduction",
  "GO:1903666": "positive regulation of asexual reproduction",
  "GO:1903667": "regulation of chemorepellent activity",
  "GO:1903668": "negative regulation of chemorepellent activity",
  "GO:1903669": "positive regulation of chemorepellent activity",
  "GO:1903670": "regulation of sprouting angiogenesis",
  "GO:1903671": "negative regulation of sprouting angiogenesis",
  "GO:1903672": "positive regulation of sprouting angiogenesis",
  "GO:1903673": "mitotic cleavage furrow formation",
  "GO:1903674": "regulation of cap-dependent translational initiation",
  "GO:1903675": "negative regulation of cap-dependent translational initiation",
  "GO:1903676": "positive regulation of cap-dependent translational initiation",
  "GO:1903677": "regulation of cap-independent translational initiation",
  "GO:1903678": "negative regulation of cap-independent translational initiation",
  "GO:1903679": "positive regulation of cap-independent translational initiation",
  "GO:1903680": "acinar cell of sebaceous gland differentiation",
  "GO:1903681": "regulation of epithelial cell-cell adhesion involved in epithelium migration",
  "GO:1903682": "negative regulation of epithelial cell-cell adhesion involved in epithelium migration",
  "GO:1903683": "positive regulation of epithelial cell-cell adhesion involved in epithelium migration",
  "GO:1903684": "regulation of border follicle cell migration",
  "GO:1903687": "negative regulation of border follicle cell migration",
  "GO:1903688": "positive regulation of border follicle cell migration",
  "GO:1903689": "regulation of wound healing, spreading of epidermal cells",
  "GO:1903690": "negative regulation of wound healing, spreading of epidermal cells",
  "GO:1903691": "positive regulation of wound healing, spreading of epidermal cells",
  "GO:1903692": "methionine import into cell",
  "GO:1903693": "regulation of mitotic G1 cell cycle arrest in response to nitrogen starvation",
  "GO:1903694": "positive regulation of mitotic G1 cell cycle arrest in response to nitrogen starvation",
  "GO:1903695": "MAPK cascade involved in ascospore formation",
  "GO:1903696": "protein localization to horsetail-astral microtubule array",
  "GO:1903697": "negative regulation of microvillus assembly",
  "GO:1903698": "positive regulation of microvillus assembly",
  "GO:1903699": "tarsal gland development",
  "GO:1903700": "caecum development",
  "GO:1903701": "substantia propria of cornea development",
  "GO:1903702": "esophagus development",
  "GO:1903703": "enterocyte differentiation",
  "GO:1903704": "negative regulation of production of siRNA involved in RNA interference",
  "GO:1903705": "positive regulation of production of siRNA involved in RNA interference",
  "GO:1903706": "regulation of hemopoiesis",
  "GO:1903707": "negative regulation of hemopoiesis",
  "GO:1903708": "positive regulation of hemopoiesis",
  "GO:1903709": "uterine gland development",
  "GO:1903710": "spermine transmembrane transport",
  "GO:1903711": "spermidine transmembrane transport",
  "GO:1903712": "cysteine transmembrane transport",
  "GO:1903713": "asparagine transmembrane transport",
  "GO:1903714": "isoleucine transmembrane transport",
  "GO:1903715": "regulation of aerobic respiration",
  "GO:1903716": "guanine transmembrane transport",
  "GO:1903717": "response to ammonia",
  "GO:1903718": "cellular response to ammonia",
  "GO:1903719": "regulation of I-kappaB phosphorylation",
  "GO:1903720": "negative regulation of I-kappaB phosphorylation",
  "GO:1903721": "positive regulation of I-kappaB phosphorylation",
  "GO:1903722": "regulation of centriole elongation",
  "GO:1903723": "negative regulation of centriole elongation",
  "GO:1903724": "positive regulation of centriole elongation",
  "GO:1903725": "regulation of phospholipid metabolic process",
  "GO:1903726": "negative regulation of phospholipid metabolic process",
  "GO:1903727": "positive regulation of phospholipid metabolic process",
  "GO:1903728": "luteal cell differentiation",
  "GO:1903729": "regulation of plasma membrane organization",
  "GO:1903730": "regulation of phosphatidate phosphatase activity",
  "GO:1903740": "positive regulation of phosphatidate phosphatase activity",
  "GO:1903741": "negative regulation of phosphatidate phosphatase activity",
  "GO:1903742": "regulation of anterograde synaptic vesicle transport",
  "GO:1903743": "negative regulation of anterograde synaptic vesicle transport",
  "GO:1903744": "positive regulation of anterograde synaptic vesicle transport",
  "GO:1903745": "negative regulation of pharyngeal pumping",
  "GO:1903746": "positive regulation of pharyngeal pumping",
  "GO:1903747": "regulation of establishment of protein localization to mitochondrion",
  "GO:1903748": "negative regulation of establishment of protein localization to mitochondrion",
  "GO:1903749": "positive regulation of establishment of protein localization to mitochondrion",
  "GO:1903750": "regulation of intrinsic apoptotic signaling pathway in response to hydrogen peroxide",
  "GO:1903751": "negative regulation of intrinsic apoptotic signaling pathway in response to hydrogen peroxide",
  "GO:1903752": "positive regulation of intrinsic apoptotic signaling pathway in response to hydrogen peroxide",
  "GO:1903753": "negative regulation of p38MAPK cascade",
  "GO:1903754": "cortical microtubule plus-end",
  "GO:1903755": "positive regulation of SUMO transferase activity",
  "GO:1903756": "regulation of transcription from RNA polymerase II promoter by histone modification",
  "GO:1903757": "positive regulation of transcription from RNA polymerase II promoter by histone modification",
  "GO:1903758": "negative regulation of transcription from RNA polymerase II promoter by histone modification",
  "GO:1903759": "signal transduction involved in regulation of aerobic respiration",
  "GO:1903760": "regulation of voltage-gated potassium channel activity involved in ventricular cardiac muscle cell action potential repolarization",
  "GO:1903761": "negative regulation of voltage-gated potassium channel activity involved in ventricular cardiac muscle cell action potential repolarization",
  "GO:1903762": "positive regulation of voltage-gated potassium channel activity involved in ventricular cardiac muscle cell action potential repolarization",
  "GO:1903763": "gap junction channel activity involved in cell communication by electrical coupling",
  "GO:1903764": "regulation of potassium ion export across plasma membrane",
  "GO:1903765": "negative regulation of potassium ion export across plasma membrane",
  "GO:1903766": "positive regulation of potassium ion export across plasma membrane",
  "GO:1903767": "sweet taste receptor complex",
  "GO:1903768": "taste receptor complex",
  "GO:1903769": "negative regulation of cell proliferation in bone marrow",
  "GO:1903770": "negative regulation of beta-galactosidase activity",
  "GO:1903771": "positive regulation of beta-galactosidase activity",
  "GO:1903772": "regulation of viral budding via host ESCRT complex",
  "GO:1903773": "negative regulation of viral budding via host ESCRT complex",
  "GO:1903774": "positive regulation of viral budding via host ESCRT complex",
  "GO:1903775": "regulation of DNA double-strand break processing",
  "GO:1903776": "regulation of double-strand break repair via single-strand annealing, removal of nonhomologous ends",
  "GO:1903777": "melibiose binding",
  "GO:1903778": "protein localization to vacuolar membrane",
  "GO:1903779": "regulation of cardiac conduction",
  "GO:1903780": "negative regulation of cardiac conduction",
  "GO:1903781": "positive regulation of cardiac conduction",
  "GO:1903782": "regulation of sodium ion import across plasma membrane",
  "GO:1903783": "negative regulation of sodium ion import across plasma membrane",
  "GO:1903784": "positive regulation of sodium ion import across plasma membrane",
  "GO:1903785": "L-valine transmembrane transport",
  "GO:1903786": "regulation of glutathione biosynthetic process",
  "GO:1903787": "negative regulation of glutathione biosynthetic process",
  "GO:1903788": "positive regulation of glutathione biosynthetic process",
  "GO:1903789": "regulation of amino acid transmembrane transport",
  "GO:1903790": "guanine nucleotide transmembrane transport",
  "GO:1903791": "uracil transmembrane transport",
  "GO:1903792": "negative regulation of anion transport",
  "GO:1903793": "positive regulation of anion transport",
  "GO:1903794": "cortisol binding",
  "GO:1903795": "regulation of inorganic anion transmembrane transport",
  "GO:1903796": "negative regulation of inorganic anion transmembrane transport",
  "GO:1903797": "positive regulation of inorganic anion transmembrane transport",
  "GO:1903798": "regulation of production of miRNAs involved in gene silencing by miRNA",
  "GO:1903799": "negative regulation of production of miRNAs involved in gene silencing by miRNA",
  "GO:1903800": "positive regulation of production of miRNAs involved in gene silencing by miRNA",
  "GO:1903801": "L-leucine import into cell",
  "GO:1903802": "L-glutamate(1-) import into cell",
  "GO:1903803": "L-glutamine import into cell",
  "GO:1903804": "glycine import into cell",
  "GO:1903805": "L-valine import into cell",
  "GO:1903806": "L-isoleucine import into cell",
  "GO:1903807": "L-threonine import into cell",
  "GO:1903808": "L-tyrosine import into cell",
  "GO:1903809": "L-proline import into cell",
  "GO:1903810": "L-histidine import into cell",
  "GO:1903811": "L-asparagine import into cell",
  "GO:1903812": "L-serine import into cell",
  "GO:1903813": "L-methionine import into cell",
  "GO:1903814": "regulation of collecting lymphatic vessel constriction",
  "GO:1903815": "negative regulation of collecting lymphatic vessel constriction",
  "GO:1903816": "positive regulation of collecting lymphatic vessel constriction",
  "GO:1903817": "negative regulation of voltage-gated potassium channel activity",
  "GO:1903818": "positive regulation of voltage-gated potassium channel activity",
  "GO:1903819": "detection of stimulus involved in cytokinesis after mitosis checkpoint",
  "GO:1903820": "signal transduction involved in cytokinesis after mitosis checkpoint",
  "GO:1903821": "detection of stimulus involved in morphogenesis checkpoint",
  "GO:1903822": "signal transduction involved in morphogenesis checkpoint",
  "GO:1903823": "telomere single strand break repair",
  "GO:1903824": "negative regulation of telomere single strand break repair",
  "GO:1903825": "organic acid transmembrane transport",
  "GO:1903826": "arginine transmembrane transport",
  "GO:1903827": "regulation of cellular protein localization",
  "GO:1903828": "negative regulation of cellular protein localization",
  "GO:1903829": "positive regulation of cellular protein localization",
  "GO:1903830": "magnesium ion transmembrane transport",
  "GO:1903831": "signal transduction involved in cellular response to ammonium ion",
  "GO:1903832": "regulation of cellular response to amino acid starvation",
  "GO:1903833": "positive regulation of cellular response to amino acid starvation",
  "GO:1903834": "regulation of APC-fizzy related complex activity",
  "GO:1903835": "positive regulation of APC-fizzy related complex activity",
  "GO:1903837": "regulation of mRNA 3'-UTR binding",
  "GO:1903838": "negative regulation of mRNA 3'-UTR binding",
  "GO:1903839": "positive regulation of mRNA 3'-UTR binding",
  "GO:1903840": "response to arsenite(3-)",
  "GO:1903841": "cellular response to arsenite(3-)",
  "GO:1903842": "response to arsenite ion",
  "GO:1903843": "cellular response to arsenite ion",
  "GO:1903844": "regulation of cellular response to transforming growth factor beta stimulus",
  "GO:1903845": "negative regulation of cellular response to transforming growth factor beta stimulus",
  "GO:1903846": "positive regulation of cellular response to transforming growth factor beta stimulus",
  "GO:1903847": "regulation of aorta morphogenesis",
  "GO:1903848": "negative regulation of aorta morphogenesis",
  "GO:1903849": "positive regulation of aorta morphogenesis",
  "GO:1903850": "regulation of cristae formation",
  "GO:1903851": "negative regulation of cristae formation",
  "GO:1903852": "positive regulation of cristae formation",
  "GO:1903853": "regulation of stress response to copper ion",
  "GO:1903854": "negative regulation of stress response to copper ion",
  "GO:1903855": "positive regulation of stress response to copper ion",
  "GO:1903856": "regulation of cytokinin dehydrogenase activity",
  "GO:1903857": "negative regulation of cytokinin dehydrogenase activity",
  "GO:1903858": "protein localization to old growing cell tip",
  "GO:1903859": "regulation of dendrite extension",
  "GO:1903860": "negative regulation of dendrite extension",
  "GO:1903861": "positive regulation of dendrite extension",
  "GO:1903862": "positive regulation of oxidative phosphorylation",
  "GO:1903863": "P granule assembly",
  "GO:1903864": "P granule disassembly",
  "GO:1903865": "sigma factor antagonist complex",
  "GO:1903866": "palisade mesophyll development",
  "GO:1903867": "extraembryonic membrane development",
  "GO:1903868": "regulation of methylenetetrahydrofolate reductase (NAD(P)H) activity",
  "GO:1903869": "negative regulation of methylenetetrahydrofolate reductase (NAD(P)H) activity",
  "GO:1903870": "positive regulation of methylenetetrahydrofolate reductase (NAD(P)H) activity",
  "GO:1903871": "DNA recombinase mediator complex assembly",
  "GO:1903872": "regulation of DNA recombinase mediator complex assembly",
  "GO:1903873": "negative regulation of DNA recombinase mediator complex assembly",
  "GO:1903874": "ferrous iron transmembrane transport",
  "GO:1903875": "corticosterone binding",
  "GO:1903876": "11-deoxycortisol binding",
  "GO:1903877": "21-deoxycortisol binding",
  "GO:1903878": "11-deoxycorticosterone binding",
  "GO:1903879": "11beta-hydroxyprogesterone binding",
  "GO:1903880": "17alpha-hydroxyprogesterone binding",
  "GO:1903881": "regulation of interleukin-17-mediated signaling pathway",
  "GO:1903882": "negative regulation of interleukin-17-mediated signaling pathway",
  "GO:1903883": "positive regulation of interleukin-17-mediated signaling pathway",
  "GO:1903884": "regulation of chemokine (C-C motif) ligand 20 production",
  "GO:1903885": "negative regulation of chemokine (C-C motif) ligand 20 production",
  "GO:1903886": "positive regulation of chemokine (C-C motif) ligand 20 production",
  "GO:1903887": "motile primary cilium assembly",
  "GO:1903888": "regulation of plant epidermal cell differentiation",
  "GO:1903889": "negative regulation of plant epidermal cell differentiation",
  "GO:1903890": "positive regulation of plant epidermal cell differentiation",
  "GO:1903891": "regulation of ATF6-mediated unfolded protein response",
  "GO:1903892": "negative regulation of ATF6-mediated unfolded protein response",
  "GO:1903893": "positive regulation of ATF6-mediated unfolded protein response",
  "GO:1903894": "regulation of IRE1-mediated unfolded protein response",
  "GO:1903895": "negative regulation of IRE1-mediated unfolded protein response",
  "GO:1903896": "positive regulation of IRE1-mediated unfolded protein response",
  "GO:1903897": "regulation of PERK-mediated unfolded protein response",
  "GO:1903898": "negative regulation of PERK-mediated unfolded protein response",
  "GO:1903899": "positive regulation of PERK-mediated unfolded protein response",
  "GO:1903900": "regulation of viral life cycle",
  "GO:1903901": "negative regulation of viral life cycle",
  "GO:1903902": "positive regulation of viral life cycle",
  "GO:1903903": "regulation of establishment of T cell polarity",
  "GO:1903904": "negative regulation of establishment of T cell polarity",
  "GO:1903905": "positive regulation of establishment of T cell polarity",
  "GO:1903906": "regulation of plasma membrane raft polarization",
  "GO:1903907": "negative regulation of plasma membrane raft polarization",
  "GO:1903908": "positive regulation of plasma membrane raft polarization",
  "GO:1903909": "regulation of receptor clustering",
  "GO:1903910": "negative regulation of receptor clustering",
  "GO:1903911": "positive regulation of receptor clustering",
  "GO:1903912": "negative regulation of endoplasmic reticulum stress-induced eIF2 alpha phosphorylation",
  "GO:1903913": "regulation of fusion of virus membrane with host plasma membrane",
  "GO:1903914": "negative regulation of fusion of virus membrane with host plasma membrane",
  "GO:1903915": "positive regulation of fusion of virus membrane with host plasma membrane",
  "GO:1903916": "regulation of endoplasmic reticulum stress-induced eIF2 alpha dephosphorylation",
  "GO:1903917": "positive regulation of endoplasmic reticulum stress-induced eIF2 alpha dephosphorylation",
  "GO:1903918": "regulation of actin filament severing",
  "GO:1903919": "negative regulation of actin filament severing",
  "GO:1903920": "positive regulation of actin filament severing",
  "GO:1903921": "regulation of protein processing in phagocytic vesicle",
  "GO:1903922": "negative regulation of protein processing in phagocytic vesicle",
  "GO:1903923": "positive regulation of protein processing in phagocytic vesicle",
  "GO:1903924": "estradiol binding",
  "GO:1903925": "response to bisphenol A",
  "GO:1903926": "cellular response to bisphenol A",
  "GO:1903927": "response to cyanide",
  "GO:1903928": "cellular response to cyanide",
  "GO:1903929": "primary palate development",
  "GO:1903930": "regulation of pyrimidine-containing compound salvage",
  "GO:1903931": "positive regulation of pyrimidine-containing compound salvage",
  "GO:1903932": "regulation of DNA primase activity",
  "GO:1903933": "negative regulation of DNA primase activity",
  "GO:1903934": "positive regulation of DNA primase activity",
  "GO:1903935": "response to sodium arsenite",
  "GO:1903936": "cellular response to sodium arsenite",
  "GO:1903937": "response to acrylamide",
  "GO:1903938": "cellular response to acrylamide",
  "GO:1903939": "regulation of TORC2 signaling",
  "GO:1903940": "negative regulation of TORC2 signaling",
  "GO:1903941": "negative regulation of respiratory gaseous exchange",
  "GO:1903942": "positive regulation of respiratory gaseous exchange",
  "GO:1903943": "regulation of hepatocyte apoptotic process",
  "GO:1903944": "negative regulation of hepatocyte apoptotic process",
  "GO:1903945": "positive regulation of hepatocyte apoptotic process",
  "GO:1903946": "negative regulation of ventricular cardiac muscle cell action potential",
  "GO:1903947": "positive regulation of ventricular cardiac muscle cell action potential",
  "GO:1903948": "negative regulation of atrial cardiac muscle cell action potential",
  "GO:1903949": "positive regulation of atrial cardiac muscle cell action potential",
  "GO:1903950": "negative regulation of AV node cell action potential",
  "GO:1903951": "positive regulation of AV node cell action potential",
  "GO:1903952": "regulation of voltage-gated potassium channel activity involved in atrial cardiac muscle cell action potential repolarization",
  "GO:1903953": "negative regulation of voltage-gated potassium channel activity involved in atrial cardiac muscle cell action potential repolarization",
  "GO:1903954": "positive regulation of voltage-gated potassium channel activity involved in atrial cardiac muscle cell action potential repolarization",
  "GO:1903955": "positive regulation of protein targeting to mitochondrion",
  "GO:1903956": "response to latrunculin B",
  "GO:1903957": "cellular response to latrunculin B",
  "GO:1903958": "nitric-oxide synthase complex",
  "GO:1903959": "regulation of anion transmembrane transport",
  "GO:1903960": "negative regulation of anion transmembrane transport",
  "GO:1903961": "positive regulation of anion transmembrane transport",
  "GO:1903962": "arachidonate transporter activity",
  "GO:1903963": "arachidonate transport",
  "GO:1903964": "monounsaturated fatty acid metabolic process",
  "GO:1903965": "monounsaturated fatty acid catabolic process",
  "GO:1903966": "monounsaturated fatty acid biosynthetic process",
  "GO:1903967": "response to micafungin",
  "GO:1903968": "cellular response to micafungin",
  "GO:1903969": "regulation of response to macrophage colony-stimulating factor",
  "GO:1903970": "negative regulation of response to macrophage colony-stimulating factor",
  "GO:1903971": "positive regulation of response to macrophage colony-stimulating factor",
  "GO:1903972": "regulation of cellular response to macrophage colony-stimulating factor stimulus",
  "GO:1903973": "negative regulation of cellular response to macrophage colony-stimulating factor stimulus",
  "GO:1903974": "positive regulation of cellular response to macrophage colony-stimulating factor stimulus",
  "GO:1903975": "regulation of glial cell migration",
  "GO:1903976": "negative regulation of glial cell migration",
  "GO:1903977": "positive regulation of glial cell migration",
  "GO:1903978": "regulation of microglial cell activation",
  "GO:1903979": "negative regulation of microglial cell activation",
  "GO:1903980": "positive regulation of microglial cell activation",
  "GO:1903981": "enterobactin binding",
  "GO:1903982": "negative regulation of microvillus length",
  "GO:1903983": "positive regulation of microvillus length",
  "GO:1903984": "positive regulation of TRAIL-activated apoptotic signaling pathway",
  "GO:1903985": "regulation of intestinal D-glucose absorption",
  "GO:1903988": "ferrous iron export",
  "GO:1903989": "regulation of ferrous iron import into cell",
  "GO:1903990": "negative regulation of ferrous iron import into cell",
  "GO:1903991": "positive regulation of ferrous iron import into cell",
  "GO:1903992": "obsolete regulation of protein stabilization",
  "GO:1903993": "obsolete negative regulation of protein stabilization",
  "GO:1903994": "obsolete positive regulation of protein stabilization",
  "GO:1903995": "regulation of non-membrane spanning protein tyrosine kinase activity",
  "GO:1903996": "negative regulation of non-membrane spanning protein tyrosine kinase activity",
  "GO:1903997": "positive regulation of non-membrane spanning protein tyrosine kinase activity",
  "GO:1903998": "regulation of eating behavior",
  "GO:1903999": "negative regulation of eating behavior",
  "GO:1904000": "positive regulation of eating behavior",
  "GO:1904001": "positive regulation of pyrimidine-containing compound salvage by positive regulation of transcription from RNA polymerase II promoter",
  "GO:1904002": "regulation of sebum secreting cell proliferation",
  "GO:1904003": "negative regulation of sebum secreting cell proliferation",
  "GO:1904004": "positive regulation of sebum secreting cell proliferation",
  "GO:1904005": "regulation of phospholipase D activity",
  "GO:1904006": "negative regulation of phospholipase D activity",
  "GO:1904007": "positive regulation of phospholipase D activity",
  "GO:1904008": "response to monosodium glutamate",
  "GO:1904009": "cellular response to monosodium glutamate",
  "GO:1904010": "response to Aroclor 1254",
  "GO:1904011": "cellular response to Aroclor 1254",
  "GO:1904012": "platinum binding",
  "GO:1904013": "xenon atom binding",
  "GO:1904014": "response to serotonin",
  "GO:1904015": "cellular response to serotonin",
  "GO:1904016": "response to Thyroglobulin triiodothyronine",
  "GO:1904017": "cellular response to Thyroglobulin triiodothyronine",
  "GO:1904018": "positive regulation of vasculature development",
  "GO:1904019": "epithelial cell apoptotic process",
  "GO:1904020": "regulation of G-protein coupled receptor internalization",
  "GO:1904021": "negative regulation of G-protein coupled receptor internalization",
  "GO:1904022": "positive regulation of G-protein coupled receptor internalization",
  "GO:1904023": "regulation of glucose catabolic process to lactate via pyruvate",
  "GO:1904024": "negative regulation of glucose catabolic process to lactate via pyruvate",
  "GO:1904025": "positive regulation of glucose catabolic process to lactate via pyruvate",
  "GO:1904026": "regulation of collagen fibril organization",
  "GO:1904027": "negative regulation of collagen fibril organization",
  "GO:1904028": "positive regulation of collagen fibril organization",
  "GO:1904029": "regulation of cyclin-dependent protein kinase activity",
  "GO:1904030": "negative regulation of cyclin-dependent protein kinase activity",
  "GO:1904031": "positive regulation of cyclin-dependent protein kinase activity",
  "GO:1904032": "regulation of t-SNARE clustering",
  "GO:1904033": "negative regulation of t-SNARE clustering",
  "GO:1904034": "positive regulation of t-SNARE clustering",
  "GO:1904035": "regulation of epithelial cell apoptotic process",
  "GO:1904036": "negative regulation of epithelial cell apoptotic process",
  "GO:1904037": "positive regulation of epithelial cell apoptotic process",
  "GO:1904038": "regulation of ferrous iron export",
  "GO:1904039": "negative regulation of ferrous iron export",
  "GO:1904040": "positive regulation of ferrous iron export",
  "GO:1904041": "regulation of cystathionine beta-synthase activity",
  "GO:1904042": "negative regulation of cystathionine beta-synthase activity",
  "GO:1904043": "positive regulation of cystathionine beta-synthase activity",
  "GO:1904044": "response to aldosterone",
  "GO:1904045": "cellular response to aldosterone",
  "GO:1904046": "negative regulation of vascular endothelial growth factor production",
  "GO:1904047": "S-adenosyl-L-methionine binding",
  "GO:1904048": "regulation of spontaneous neurotransmitter secretion",
  "GO:1904049": "negative regulation of spontaneous neurotransmitter secretion",
  "GO:1904050": "positive regulation of spontaneous neurotransmitter secretion",
  "GO:1904051": "regulation of protein targeting to vacuole involved in autophagy",
  "GO:1904052": "negative regulation of protein targeting to vacuole involved in autophagy",
  "GO:1904053": "positive regulation of protein targeting to vacuole involved in autophagy",
  "GO:1904054": "regulation of cholangiocyte proliferation",
  "GO:1904055": "negative regulation of cholangiocyte proliferation",
  "GO:1904056": "positive regulation of cholangiocyte proliferation",
  "GO:1904057": "negative regulation of sensory perception of pain",
  "GO:1904058": "positive regulation of sensory perception of pain",
  "GO:1904059": "regulation of locomotor rhythm",
  "GO:1904060": "negative regulation of locomotor rhythm",
  "GO:1904061": "positive regulation of locomotor rhythm",
  "GO:1904062": "regulation of cation transmembrane transport",
  "GO:1904063": "negative regulation of cation transmembrane transport",
  "GO:1904064": "positive regulation of cation transmembrane transport",
  "GO:1904065": "G-protein coupled acetylcholine receptor signaling pathway involved in positive regulation of acetylcholine secretion, neurotransmission",
  "GO:1904066": "G-protein coupled receptor signaling pathway involved in dauer larval development",
  "GO:1904067": "ascr#2 binding",
  "GO:1904068": "G-protein coupled receptor signaling pathway involved in social behavior",
  "GO:1904069": "ascaroside metabolic process",
  "GO:1904070": "ascaroside biosynthetic process",
  "GO:1904071": "presynaptic active zone assembly",
  "GO:1904072": "presynaptic active zone disassembly",
  "GO:1904073": "regulation of trophectodermal cell proliferation",
  "GO:1904074": "negative regulation of trophectodermal cell proliferation",
  "GO:1904075": "positive regulation of trophectodermal cell proliferation",
  "GO:1904076": "regulation of estrogen biosynthetic process",
  "GO:1904077": "negative regulation of estrogen biosynthetic process",
  "GO:1904078": "positive regulation of estrogen biosynthetic process",
  "GO:1904079": "obsolete negative regulation of transcription from RNA polymerase II promoter involved in negative regulation of neuron apoptotic process",
  "GO:1904080": "positive regulation of transcription from RNA polymerase II promoter involved in neuron fate specification",
  "GO:1904081": "positive regulation of transcription from RNA polymerase II promoter involved in neuron differentiation",
  "GO:1904082": "pyrimidine nucleobase transmembrane transport",
  "GO:1904083": "obsolete regulation of epiboly",
  "GO:1904084": "obsolete negative regulation of epiboly",
  "GO:1904085": "obsolete positive regulation of epiboly",
  "GO:1904086": "regulation of epiboly involved in gastrulation with mouth forming second",
  "GO:1904087": "negative regulation of epiboly involved in gastrulation with mouth forming second",
  "GO:1904088": "positive regulation of epiboly involved in gastrulation with mouth forming second",
  "GO:1904089": "negative regulation of neuron apoptotic process by negative regulation of transcription from RNA polymerase II promoter",
  "GO:1904090": "peptidase inhibitor complex",
  "GO:1904091": "peptidyl carrier protein activity involved in nonribosomal peptide biosynthesis",
  "GO:1904092": "regulation of autophagic cell death",
  "GO:1904093": "negative regulation of autophagic cell death",
  "GO:1904094": "positive regulation of autophagic cell death",
  "GO:1904095": "negative regulation of endosperm development",
  "GO:1904096": "protein tyrosine phosphatase complex",
  "GO:1904097": "acid phosphatase complex",
  "GO:1904098": "regulation of protein O-linked glycosylation",
  "GO:1904099": "negative regulation of protein O-linked glycosylation",
  "GO:1904100": "positive regulation of protein O-linked glycosylation",
  "GO:1904101": "response to acadesine",
  "GO:1904102": "cellular response to acadesine",
  "GO:1904103": "regulation of convergent extension involved in gastrulation",
  "GO:1904104": "negative regulation of convergent extension involved in gastrulation",
  "GO:1904105": "positive regulation of convergent extension involved in gastrulation",
  "GO:1904106": "protein localization to microvillus",
  "GO:1904107": "protein localization to microvillus membrane",
  "GO:1904108": "protein localization to ciliary inversin compartment",
  "GO:1904109": "positive regulation of cholesterol import",
  "GO:1904110": "regulation of plus-end directed microfilament motor activity",
  "GO:1904111": "negative regulation of plus-end directed microfilament motor activity",
  "GO:1904112": "positive regulation of plus-end directed microfilament motor activity",
  "GO:1904113": "negative regulation of muscle filament sliding",
  "GO:1904114": "positive regulation of muscle filament sliding",
  "GO:1904115": "axon cytoplasm",
  "GO:1904116": "response to vasopressin",
  "GO:1904117": "cellular response to vasopressin",
  "GO:1904118": "regulation of otic vesicle morphogenesis",
  "GO:1904119": "negative regulation of otic vesicle morphogenesis",
  "GO:1904120": "positive regulation of otic vesicle morphogenesis",
  "GO:1904121": "phosphatidylethanolamine transporter activity",
  "GO:1904122": "positive regulation of fatty acid beta-oxidation by octopamine signaling pathway",
  "GO:1904123": "positive regulation of fatty acid beta-oxidation by serotonin receptor signaling pathway",
  "GO:1904124": "microglial cell migration",
  "GO:1904125": "convergent extension involved in rhombomere morphogenesis",
  "GO:1904126": "convergent extension involved in notochord morphogenesis",
  "GO:1904127": "regulation of convergent extension involved in somitogenesis",
  "GO:1904128": "negative regulation of convergent extension involved in somitogenesis",
  "GO:1904129": "positive regulation of convergent extension involved in somitogenesis",
  "GO:1904130": "regulation of convergent extension involved in neural plate elongation",
  "GO:1904131": "negative regulation of convergent extension involved in neural plate elongation",
  "GO:1904132": "positive regulation of convergent extension involved in neural plate elongation",
  "GO:1904133": "regulation of convergent extension involved in rhombomere morphogenesis",
  "GO:1904134": "negative regulation of convergent extension involved in rhombomere morphogenesis",
  "GO:1904135": "positive regulation of convergent extension involved in rhombomere morphogenesis",
  "GO:1904136": "regulation of convergent extension involved in notochord morphogenesis",
  "GO:1904137": "negative regulation of convergent extension involved in notochord morphogenesis",
  "GO:1904138": "positive regulation of convergent extension involved in notochord morphogenesis",
  "GO:1904139": "regulation of microglial cell migration",
  "GO:1904140": "negative regulation of microglial cell migration",
  "GO:1904141": "positive regulation of microglial cell migration",
  "GO:1904142": "negative regulation of carotenoid biosynthetic process",
  "GO:1904143": "positive regulation of carotenoid biosynthetic process",
  "GO:1904144": "phosphatidylinositol phosphate phosphatase complex",
  "GO:1904145": "negative regulation of meiotic cell cycle process involved in oocyte maturation",
  "GO:1904146": "positive regulation of meiotic cell cycle process involved in oocyte maturation",
  "GO:1904147": "response to nonylphenol",
  "GO:1904148": "cellular response to nonylphenol",
  "GO:1904149": "regulation of microglial cell mediated cytotoxicity",
  "GO:1904150": "negative regulation of microglial cell mediated cytotoxicity",
  "GO:1904151": "positive regulation of microglial cell mediated cytotoxicity",
  "GO:1904152": "regulation of retrograde protein transport, ER to cytosol",
  "GO:1904153": "negative regulation of retrograde protein transport, ER to cytosol",
  "GO:1904154": "positive regulation of retrograde protein transport, ER to cytosol",
  "GO:1904155": "DN2 thymocyte differentiation",
  "GO:1904156": "DN3 thymocyte differentiation",
  "GO:1904157": "DN4 thymocyte differentiation",
  "GO:1904158": "axonemal central apparatus assembly",
  "GO:1904159": "megasporocyte differentiation",
  "GO:1904160": "protein localization to chloroplast starch grain",
  "GO:1904161": "DNA synthesis involved in UV-damage excision repair",
  "GO:1904162": "5'-3' exodeoxyribonuclease activity involved in UV-damage excision repair",
  "GO:1904163": "obsolete regulation of triglyceride homeostasis",
  "GO:1904164": "obsolete negative regulation of triglyceride homeostasis",
  "GO:1904165": "obsolete positive regulation of triglyceride homeostasis",
  "GO:1904166": "obsolete negative regulation of cholesterol homeostasis",
  "GO:1904167": "regulation of thyroid hormone receptor activity",
  "GO:1904168": "negative regulation of thyroid hormone receptor activity",
  "GO:1904169": "positive regulation of thyroid hormone receptor activity",
  "GO:1904170": "regulation of bleb assembly",
  "GO:1904171": "negative regulation of bleb assembly",
  "GO:1904172": "positive regulation of bleb assembly",
  "GO:1904173": "regulation of histone demethylase activity (H3-K4 specific)",
  "GO:1904174": "negative regulation of histone demethylase activity (H3-K4 specific)",
  "GO:1904175": "positive regulation of histone demethylase activity (H3-K4 specific)",
  "GO:1904176": "carbon phosphorus lyase complex",
  "GO:1904177": "regulation of adipose tissue development",
  "GO:1904178": "negative regulation of adipose tissue development",
  "GO:1904179": "positive regulation of adipose tissue development",
  "GO:1904180": "negative regulation of membrane depolarization",
  "GO:1904181": "positive regulation of membrane depolarization",
  "GO:1904182": "regulation of pyruvate dehydrogenase activity",
  "GO:1904183": "negative regulation of pyruvate dehydrogenase activity",
  "GO:1904184": "positive regulation of pyruvate dehydrogenase activity",
  "GO:1904185": "equatorial microtubule organizing center assembly",
  "GO:1904186": "post-anaphase microtubule array organization",
  "GO:1904187": "regulation of transformation of host cell by virus",
  "GO:1904188": "negative regulation of transformation of host cell by virus",
  "GO:1904189": "positive regulation of transformation of host cell by virus",
  "GO:1904190": "negative regulation of APC-fizzy related complex activity",
  "GO:1904191": "positive regulation of cyclin-dependent protein serine/threonine kinase activity involved in meiotic nuclear division",
  "GO:1904192": "regulation of cholangiocyte apoptotic process",
  "GO:1904193": "negative regulation of cholangiocyte apoptotic process",
  "GO:1904194": "positive regulation of cholangiocyte apoptotic process",
  "GO:1904195": "regulation of granulosa cell proliferation",
  "GO:1904196": "negative regulation of granulosa cell proliferation",
  "GO:1904197": "positive regulation of granulosa cell proliferation",
  "GO:1904198": "negative regulation of regulation of vascular smooth muscle cell membrane depolarization",
  "GO:1904199": "positive regulation of regulation of vascular smooth muscle cell membrane depolarization",
  "GO:1904200": "iodide transmembrane transport",
  "GO:1904201": "regulation of iodide transport",
  "GO:1904202": "negative regulation of iodide transport",
  "GO:1904203": "positive regulation of iodide transport",
  "GO:1904204": "regulation of skeletal muscle hypertrophy",
  "GO:1904205": "negative regulation of skeletal muscle hypertrophy",
  "GO:1904206": "positive regulation of skeletal muscle hypertrophy",
  "GO:1904207": "regulation of chemokine (C-C motif) ligand 2 secretion",
  "GO:1904208": "negative regulation of chemokine (C-C motif) ligand 2 secretion",
  "GO:1904209": "positive regulation of chemokine (C-C motif) ligand 2 secretion",
  "GO:1904210": "VCP-NPL4-UFD1 AAA ATPase complex assembly",
  "GO:1904211": "membrane protein proteolysis involved in retrograde protein transport, ER to cytosol",
  "GO:1904212": "regulation of iodide transmembrane transport",
  "GO:1904213": "negative regulation of iodide transmembrane transport",
  "GO:1904214": "positive regulation of iodide transmembrane transport",
  "GO:1904215": "regulation of protein import into chloroplast stroma",
  "GO:1904216": "positive regulation of protein import into chloroplast stroma",
  "GO:1904217": "regulation of CDP-diacylglycerol-serine O-phosphatidyltransferase activity",
  "GO:1904218": "negative regulation of CDP-diacylglycerol-serine O-phosphatidyltransferase activity",
  "GO:1904219": "positive regulation of CDP-diacylglycerol-serine O-phosphatidyltransferase activity",
  "GO:1904220": "regulation of serine C-palmitoyltransferase activity",
  "GO:1904221": "negative regulation of serine C-palmitoyltransferase activity",
  "GO:1904222": "positive regulation of serine C-palmitoyltransferase activity",
  "GO:1904223": "regulation of glucuronosyltransferase activity",
  "GO:1904224": "negative regulation of glucuronosyltransferase activity",
  "GO:1904225": "positive regulation of glucuronosyltransferase activity",
  "GO:1904226": "regulation of glycogen synthase activity, transferring glucose-1-phosphate",
  "GO:1904227": "negative regulation of glycogen synthase activity, transferring glucose-1-phosphate",
  "GO:1904228": "positive regulation of glycogen synthase activity, transferring glucose-1-phosphate",
  "GO:1904229": "regulation of succinate dehydrogenase activity",
  "GO:1904230": "negative regulation of succinate dehydrogenase activity",
  "GO:1904231": "positive regulation of succinate dehydrogenase activity",
  "GO:1904232": "regulation of aconitate hydratase activity",
  "GO:1904233": "negative regulation of aconitate hydratase activity",
  "GO:1904234": "positive regulation of aconitate hydratase activity",
  "GO:1904235": "regulation of substrate-dependent cell migration, cell attachment to substrate",
  "GO:1904236": "negative regulation of substrate-dependent cell migration, cell attachment to substrate",
  "GO:1904237": "positive regulation of substrate-dependent cell migration, cell attachment to substrate",
  "GO:1904238": "pericyte cell differentiation",
  "GO:1904239": "regulation of VCP-NPL4-UFD1 AAA ATPase complex assembly",
  "GO:1904240": "negative regulation of VCP-NPL4-UFD1 AAA ATPase complex assembly",
  "GO:1904241": "positive regulation of VCP-NPL4-UFD1 AAA ATPase complex assembly",
  "GO:1904242": "regulation of pancreatic trypsinogen secretion",
  "GO:1904243": "negative regulation of pancreatic trypsinogen secretion",
  "GO:1904244": "positive regulation of pancreatic trypsinogen secretion",
  "GO:1904245": "regulation of polynucleotide adenylyltransferase activity",
  "GO:1904246": "negative regulation of polynucleotide adenylyltransferase activity",
  "GO:1904247": "positive regulation of polynucleotide adenylyltransferase activity",
  "GO:1904248": "regulation of age-related resistance",
  "GO:1904249": "negative regulation of age-related resistance",
  "GO:1904250": "positive regulation of age-related resistance",
  "GO:1904251": "regulation of bile acid metabolic process",
  "GO:1904252": "negative regulation of bile acid metabolic process",
  "GO:1904253": "positive regulation of bile acid metabolic process",
  "GO:1904254": "regulation of iron channel activity",
  "GO:1904255": "negative regulation of iron channel activity",
  "GO:1904256": "positive regulation of iron channel activity",
  "GO:1904257": "zinc II ion import across Golgi membrane",
  "GO:1904258": "nuclear dicing body assembly",
  "GO:1904259": "regulation of basement membrane assembly involved in embryonic body morphogenesis",
  "GO:1904260": "negative regulation of basement membrane assembly involved in embryonic body morphogenesis",
  "GO:1904261": "positive regulation of basement membrane assembly involved in embryonic body morphogenesis",
  "GO:1904262": "negative regulation of TORC1 signaling",
  "GO:1904263": "positive regulation of TORC1 signaling",
  "GO:1904264": "ubiquitin protein ligase activity involved in ERAD pathway",
  "GO:1904265": "ubiquitin-specific protease activity involved in negative regulation of retrograde protein transport, ER to cytosol",
  "GO:1904266": "regulation of Schwann cell chemotaxis",
  "GO:1904267": "negative regulation of Schwann cell chemotaxis",
  "GO:1904268": "positive regulation of Schwann cell chemotaxis",
  "GO:1904269": "cell leading edge cell cortex",
  "GO:1904270": "pyroptosome complex assembly",
  "GO:1904271": "L-proline import across plasma membrane",
  "GO:1904272": "L-tryptophan import across plasma membrane",
  "GO:1904273": "L-alanine import across plasma membrane",
  "GO:1904274": "tricellular tight junction assembly",
  "GO:1904275": "tricellular tight junction disassembly",
  "GO:1904276": "regulation of wax biosynthetic process",
  "GO:1904277": "negative regulation of wax biosynthetic process",
  "GO:1904278": "positive regulation of wax biosynthetic process",
  "GO:1904279": "regulation of transcription from RNA polymerase V promoter",
  "GO:1904280": "negative regulation of transcription from RNA polymerase V promoter",
  "GO:1904281": "positive regulation of transcription from RNA polymerase V promoter",
  "GO:1904282": "regulation of antigen processing and presentation of endogenous peptide antigen via MHC class I",
  "GO:1904283": "negative regulation of antigen processing and presentation of endogenous peptide antigen via MHC class I",
  "GO:1904284": "positive regulation of antigen processing and presentation of endogenous peptide antigen via MHC class I",
  "GO:1904285": "regulation of protein-pyridoxal-5-phosphate linkage",
  "GO:1904286": "negative regulation of protein-pyridoxal-5-phosphate linkage",
  "GO:1904287": "positive regulation of protein-pyridoxal-5-phosphate linkage",
  "GO:1904288": "BAT3 complex binding",
  "GO:1904289": "regulation of mitotic DNA damage checkpoint",
  "GO:1904290": "negative regulation of mitotic DNA damage checkpoint",
  "GO:1904291": "positive regulation of mitotic DNA damage checkpoint",
  "GO:1904292": "regulation of ERAD pathway",
  "GO:1904293": "negative regulation of ERAD pathway",
  "GO:1904294": "positive regulation of ERAD pathway",
  "GO:1904295": "regulation of osmolarity-sensing cation channel activity",
  "GO:1904296": "negative regulation of osmolarity-sensing cation channel activity",
  "GO:1904297": "positive regulation of osmolarity-sensing cation channel activity",
  "GO:1904298": "regulation of transcytosis",
  "GO:1904299": "negative regulation of transcytosis",
  "GO:1904300": "positive regulation of transcytosis",
  "GO:1904301": "regulation of maternal process involved in parturition",
  "GO:1904302": "negative regulation of maternal process involved in parturition",
  "GO:1904303": "positive regulation of maternal process involved in parturition",
  "GO:1904304": "regulation of gastro-intestinal system smooth muscle contraction",
  "GO:1904305": "negative regulation of gastro-intestinal system smooth muscle contraction",
  "GO:1904306": "positive regulation of gastro-intestinal system smooth muscle contraction",
  "GO:1904307": "response to desipramine",
  "GO:1904308": "cellular response to desipramine",
  "GO:1904309": "response to cordycepin",
  "GO:1904310": "cellular response to cordycepin",
  "GO:1904311": "response to gold(3+)",
  "GO:1904312": "cellular response to gold(3+)",
  "GO:1904313": "response to methamphetamine hydrochloride",
  "GO:1904314": "cellular response to methamphetamine hydrochloride",
  "GO:1904315": "transmitter-gated ion channel activity involved in regulation of postsynaptic membrane potential",
  "GO:1904316": "response to 2-O-acetyl-1-O-hexadecyl-sn-glycero-3-phosphocholine",
  "GO:1904317": "cellular response to 2-O-acetyl-1-O-hexadecyl-sn-glycero-3-phosphocholine",
  "GO:1904318": "regulation of smooth muscle contraction involved in micturition",
  "GO:1904319": "negative regulation of smooth muscle contraction involved in micturition",
  "GO:1904320": "positive regulation of smooth muscle contraction involved in micturition",
  "GO:1904321": "response to forskolin",
  "GO:1904322": "cellular response to forskolin",
  "GO:1904323": "regulation of inhibitory G-protein coupled receptor phosphorylation",
  "GO:1904324": "negative regulation of inhibitory G-protein coupled receptor phosphorylation",
  "GO:1904325": "positive regulation of inhibitory G-protein coupled receptor phosphorylation",
  "GO:1904326": "negative regulation of circadian sleep/wake cycle, wakefulness",
  "GO:1904327": "protein localization to cytosolic proteasome complex",
  "GO:1904328": "regulation of myofibroblast contraction",
  "GO:1904329": "negative regulation of myofibroblast contraction",
  "GO:1904330": "positive regulation of myofibroblast contraction",
  "GO:1904331": "regulation of error-prone translesion synthesis",
  "GO:1904332": "negative regulation of error-prone translesion synthesis",
  "GO:1904333": "positive regulation of error-prone translesion synthesis",
  "GO:1904334": "heme import across plasma membrane",
  "GO:1904335": "regulation of ductus arteriosus closure",
  "GO:1904336": "negative regulation of ductus arteriosus closure",
  "GO:1904337": "positive regulation of ductus arteriosus closure",
  "GO:1904338": "regulation of dopaminergic neuron differentiation",
  "GO:1904339": "negative regulation of dopaminergic neuron differentiation",
  "GO:1904340": "positive regulation of dopaminergic neuron differentiation",
  "GO:1904341": "regulation of colon smooth muscle contraction",
  "GO:1904342": "negative regulation of colon smooth muscle contraction",
  "GO:1904343": "positive regulation of colon smooth muscle contraction",
  "GO:1904344": "regulation of gastric mucosal blood circulation",
  "GO:1904345": "negative regulation of gastric mucosal blood circulation",
  "GO:1904346": "positive regulation of gastric mucosal blood circulation",
  "GO:1904347": "regulation of small intestine smooth muscle contraction",
  "GO:1904348": "negative regulation of small intestine smooth muscle contraction",
  "GO:1904349": "positive regulation of small intestine smooth muscle contraction",
  "GO:1904350": "regulation of protein catabolic process in the vacuole",
  "GO:1904351": "negative regulation of protein catabolic process in the vacuole",
  "GO:1904352": "positive regulation of protein catabolic process in the vacuole",
  "GO:1904353": "regulation of telomere capping",
  "GO:1904354": "negative regulation of telomere capping",
  "GO:1904355": "positive regulation of telomere capping",
  "GO:1904356": "regulation of telomere maintenance via telomere lengthening",
  "GO:1904357": "negative regulation of telomere maintenance via telomere lengthening",
  "GO:1904358": "positive regulation of telomere maintenance via telomere lengthening",
  "GO:1904359": "regulation of spore germination",
  "GO:1904360": "negative regulation of spore germination",
  "GO:1904361": "positive regulation of spore germination",
  "GO:1904362": "regulation of calcitonin secretion",
  "GO:1904363": "negative regulation of calcitonin secretion",
  "GO:1904364": "positive regulation of calcitonin secretion",
  "GO:1904365": "regulation of chemokinesis",
  "GO:1904366": "negative regulation of chemokinesis",
  "GO:1904367": "positive regulation of chemokinesis",
  "GO:1904368": "regulation of sclerenchyma cell differentiation",
  "GO:1904369": "positive regulation of sclerenchyma cell differentiation",
  "GO:1904370": "regulation of protein localization to actin cortical patch",
  "GO:1904371": "negative regulation of protein localization to actin cortical patch",
  "GO:1904372": "positive regulation of protein localization to actin cortical patch",
  "GO:1904373": "response to kainic acid",
  "GO:1904374": "cellular response to kainic acid",
  "GO:1904375": "regulation of protein localization to cell periphery",
  "GO:1904376": "negative regulation of protein localization to cell periphery",
  "GO:1904377": "positive regulation of protein localization to cell periphery",
  "GO:1904378": "maintenance of unfolded protein involved in ERAD pathway",
  "GO:1904379": "protein localization to cytosolic proteasome complex involved in ERAD pathway",
  "GO:1904380": "endoplasmic reticulum mannose trimming",
  "GO:1904381": "Golgi apparatus mannose trimming",
  "GO:1904382": "mannose trimming involved in glycoprotein ERAD pathway",
  "GO:1904383": "response to sodium phosphate",
  "GO:1904384": "cellular response to sodium phosphate",
  "GO:1904385": "cellular response to angiotensin",
  "GO:1904386": "response to L-phenylalanine derivative",
  "GO:1904387": "cellular response to L-phenylalanine derivative",
  "GO:1904388": "negative regulation of ncRNA transcription associated with protein coding gene TSS/TES",
  "GO:1904389": "rod bipolar cell differentiation",
  "GO:1904390": "cone retinal bipolar cell differentiation",
  "GO:1904391": "response to ciliary neurotrophic factor",
  "GO:1904392": "cellular response to ciliary neurotrophic factor",
  "GO:1904393": "regulation of skeletal muscle acetylcholine-gated channel clustering",
  "GO:1904394": "negative regulation of skeletal muscle acetylcholine-gated channel clustering",
  "GO:1904395": "positive regulation of skeletal muscle acetylcholine-gated channel clustering",
  "GO:1904396": "regulation of neuromuscular junction development",
  "GO:1904397": "negative regulation of neuromuscular junction development",
  "GO:1904398": "positive regulation of neuromuscular junction development",
  "GO:1904399": "heparan sulfate binding",
  "GO:1904400": "response to Thyroid stimulating hormone",
  "GO:1904401": "cellular response to Thyroid stimulating hormone",
  "GO:1904402": "response to nocodazole",
  "GO:1904403": "cellular response to nocodazole",
  "GO:1904404": "response to formaldehyde",
  "GO:1904405": "cellular response to formaldehyde",
  "GO:1904406": "negative regulation of nitric oxide metabolic process",
  "GO:1904407": "positive regulation of nitric oxide metabolic process",
  "GO:1904408": "melatonin binding",
  "GO:1904409": "regulation of secretory granule organization",
  "GO:1904410": "negative regulation of secretory granule organization",
  "GO:1904411": "positive regulation of secretory granule organization",
  "GO:1904412": "regulation of cardiac ventricle development",
  "GO:1904413": "negative regulation of cardiac ventricle development",
  "GO:1904414": "positive regulation of cardiac ventricle development",
  "GO:1904415": "regulation of xenophagy",
  "GO:1904416": "negative regulation of xenophagy",
  "GO:1904417": "positive regulation of xenophagy",
  "GO:1904418": "regulation of telomeric loop formation",
  "GO:1904419": "negative regulation of telomeric loop formation",
  "GO:1904420": "positive regulation of telomeric loop formation",
  "GO:1904421": "response to D-galactosamine",
  "GO:1904422": "cellular response to D-galactosamine",
  "GO:1904423": "dehydrodolichyl diphosphate synthase complex",
  "GO:1904424": "regulation of GTP binding",
  "GO:1904425": "negative regulation of GTP binding",
  "GO:1904426": "positive regulation of GTP binding",
  "GO:1904427": "positive regulation of calcium ion transmembrane transport",
  "GO:1904428": "negative regulation of tubulin deacetylation",
  "GO:1904429": "regulation of t-circle formation",
  "GO:1904430": "negative regulation of t-circle formation",
  "GO:1904431": "positive regulation of t-circle formation",
  "GO:1904432": "regulation of ferrous iron binding",
  "GO:1904433": "negative regulation of ferrous iron binding",
  "GO:1904434": "positive regulation of ferrous iron binding",
  "GO:1904435": "regulation of transferrin receptor binding",
  "GO:1904436": "negative regulation of transferrin receptor binding",
  "GO:1904437": "positive regulation of transferrin receptor binding",
  "GO:1904438": "regulation of ferrous iron import across plasma membrane",
  "GO:1904439": "negative regulation of ferrous iron import across plasma membrane",
  "GO:1904440": "positive regulation of ferrous iron import across plasma membrane",
  "GO:1904441": "regulation of thyroid gland epithelial cell proliferation",
  "GO:1904442": "negative regulation of thyroid gland epithelial cell proliferation",
  "GO:1904443": "positive regulation of thyroid gland epithelial cell proliferation",
  "GO:1904444": "regulation of establishment of Sertoli cell barrier",
  "GO:1904445": "negative regulation of establishment of Sertoli cell barrier",
  "GO:1904446": "positive regulation of establishment of Sertoli cell barrier",
  "GO:1904447": "folic acid import into cell",
  "GO:1904448": "regulation of aspartate secretion",
  "GO:1904449": "negative regulation of aspartate secretion",
  "GO:1904450": "positive regulation of aspartate secretion",
  "GO:1904451": "regulation of hydrogen:potassium-exchanging ATPase activity",
  "GO:1904452": "negative regulation of hydrogen:potassium-exchanging ATPase activity",
  "GO:1904453": "positive regulation of hydrogen:potassium-exchanging ATPase activity",
  "GO:1904454": "ubiquitin-specific protease activity involved in positive regulation of ERAD pathway",
  "GO:1904455": "ubiquitin-specific protease activity involved in negative regulation of ERAD pathway",
  "GO:1904456": "negative regulation of neuronal action potential",
  "GO:1904457": "positive regulation of neuronal action potential",
  "GO:1904458": "regulation of substance P secretion",
  "GO:1904459": "negative regulation of substance P secretion",
  "GO:1904460": "positive regulation of substance P secretion",
  "GO:1904461": "ergosteryl 3-beta-D-glucoside metabolic process",
  "GO:1904462": "ergosteryl 3-beta-D-glucoside catabolic process",
  "GO:1904463": "ergosteryl 3-beta-D-glucoside biosynthetic process",
  "GO:1904464": "regulation of matrix metallopeptidase secretion",
  "GO:1904465": "negative regulation of matrix metallopeptidase secretion",
  "GO:1904466": "positive regulation of matrix metallopeptidase secretion",
  "GO:1904467": "regulation of tumor necrosis factor secretion",
  "GO:1904468": "negative regulation of tumor necrosis factor secretion",
  "GO:1904469": "positive regulation of tumor necrosis factor secretion",
  "GO:1904470": "regulation of endothelin secretion",
  "GO:1904471": "negative regulation of endothelin secretion",
  "GO:1904472": "positive regulation of endothelin secretion",
  "GO:1904473": "response to L-dopa",
  "GO:1904474": "cellular response to L-dopa",
  "GO:1904475": "regulation of Ras GTPase binding",
  "GO:1904476": "negative regulation of Ras GTPase binding",
  "GO:1904477": "positive regulation of Ras GTPase binding",
  "GO:1904478": "regulation of intestinal absorption",
  "GO:1904479": "negative regulation of intestinal absorption",
  "GO:1904480": "positive regulation of intestinal absorption",
  "GO:1904481": "response to tetrahydrofolate",
  "GO:1904482": "cellular response to tetrahydrofolate",
  "GO:1904483": "synthetic cannabinoid binding",
  "GO:1904484": "cloacal gland development",
  "GO:1904486": "response to 17alpha-ethynylestradiol",
  "GO:1904487": "cellular response to 17alpha-ethynylestradiol",
  "GO:1904488": "regulation of reactive oxygen species metabolic process by positive regulation of transcription from RNA polymerase II promoter",
  "GO:1904489": "regulation of reactive oxygen species metabolic process by negative regulation of transcription from RNA polymerase II promoter",
  "GO:1904490": "negative regulation of mitochondrial unfolded protein response by negative regulation of transcription from RNA polymerase II promoter",
  "GO:1904491": "protein localization to ciliary transition zone",
  "GO:1904492": "Ac-Asp-Glu binding",
  "GO:1904493": "tetrahydrofolyl-poly(glutamate) polymer binding",
  "GO:1904494": "regulation of substance P secretion, neurotransmission",
  "GO:1904495": "negative regulation of substance P secretion, neurotransmission",
  "GO:1904496": "positive regulation of substance P secretion, neurotransmission",
  "GO:1904497": "heterochromatin assembly involved in chromatin silencing at centromere outer repeat region",
  "GO:1904498": "protein localization to actomyosin contractile ring involved in mitotic cytokinesis",
  "GO:1904499": "regulation of chromatin-mediated maintenance of transcription",
  "GO:1904500": "negative regulation of chromatin-mediated maintenance of transcription",
  "GO:1904501": "positive regulation of chromatin-mediated maintenance of transcription",
  "GO:1904502": "regulation of lipophagy",
  "GO:1904503": "negative regulation of lipophagy",
  "GO:1904504": "positive regulation of lipophagy",
  "GO:1904505": "regulation of telomere maintenance in response to DNA damage",
  "GO:1904506": "negative regulation of telomere maintenance in response to DNA damage",
  "GO:1904507": "positive regulation of telomere maintenance in response to DNA damage",
  "GO:1904508": "regulation of protein localization to basolateral plasma membrane",
  "GO:1904509": "negative regulation of protein localization to basolateral plasma membrane",
  "GO:1904510": "positive regulation of protein localization to basolateral plasma membrane",
  "GO:1904511": "cytoplasmic microtubule plus-end",
  "GO:1904512": "regulation of initiation of premeiotic DNA replication",
  "GO:1904513": "negative regulation of initiation of premeiotic DNA replication",
  "GO:1904514": "positive regulation of initiation of premeiotic DNA replication",
  "GO:1904515": "positive regulation of TORC2 signaling",
  "GO:1904516": "myofibroblast cell apoptotic process",
  "GO:1904517": "MgATP(2-) binding",
  "GO:1904518": "protein localization to cytoplasmic microtubule plus-end",
  "GO:1904519": "protein localization to microtubule minus-end",
  "GO:1904520": "regulation of myofibroblast cell apoptotic process",
  "GO:1904521": "negative regulation of myofibroblast cell apoptotic process",
  "GO:1904522": "positive regulation of myofibroblast cell apoptotic process",
  "GO:1904523": "regulation of DNA amplification",
  "GO:1904524": "negative regulation of DNA amplification",
  "GO:1904525": "positive regulation of DNA amplification",
  "GO:1904526": "regulation of microtubule binding",
  "GO:1904527": "negative regulation of microtubule binding",
  "GO:1904528": "positive regulation of microtubule binding",
  "GO:1904529": "regulation of actin filament binding",
  "GO:1904530": "negative regulation of actin filament binding",
  "GO:1904531": "positive regulation of actin filament binding",
  "GO:1904532": "obsolete ATP-dependent microtubule motor activity, minus-end-directed involved in microtubule-based movement",
  "GO:1904533": "regulation of telomeric loop disassembly",
  "GO:1904534": "negative regulation of telomeric loop disassembly",
  "GO:1904535": "positive regulation of telomeric loop disassembly",
  "GO:1904536": "regulation of mitotic telomere tethering at nuclear periphery",
  "GO:1904537": "negative regulation of mitotic telomere tethering at nuclear periphery",
  "GO:1904538": "regulation of glycolytic process through fructose-6-phosphate",
  "GO:1904539": "negative regulation of glycolytic process through fructose-6-phosphate",
  "GO:1904540": "positive regulation of glycolytic process through fructose-6-phosphate",
  "GO:1904541": "fungal-type cell wall disassembly involved in conjugation with cellular fusion",
  "GO:1904542": "regulation of free ubiquitin chain polymerization",
  "GO:1904543": "negative regulation of free ubiquitin chain polymerization",
  "GO:1904544": "positive regulation of free ubiquitin chain polymerization",
  "GO:1904546": "obsolete negative regulation of cAMP-dependent protein kinase activity involved in negative regulation of glucose mediated signaling pathway",
  "GO:1904547": "regulation of cellular response to glucose starvation",
  "GO:1904550": "response to arachidonic acid",
  "GO:1904551": "cellular response to arachidonic acid",
  "GO:1904552": "regulation of chemotaxis to arachidonic acid",
  "GO:1904553": "negative regulation of chemotaxis to arachidonic acid",
  "GO:1904554": "positive regulation of chemotaxis to arachidonic acid",
  "GO:1904555": "L-proline transmembrane transport",
  "GO:1904556": "L-tryptophan transmembrane transport",
  "GO:1904557": "L-alanine transmembrane transport",
  "GO:1904558": "response to dextromethorphan",
  "GO:1904559": "cellular response to dextromethorphan",
  "GO:1904560": "response to diphenidol",
  "GO:1904561": "cellular response to diphenidol",
  "GO:1904562": "phosphatidylinositol 5-phosphate metabolic process",
  "GO:1904563": "phosphatidylinositol 5-phosphate biosynthetic process",
  "GO:1904564": "Nbp35-Cfd1 ATPase complex",
  "GO:1904565": "response to 1-oleoyl-sn-glycerol 3-phosphate",
  "GO:1904566": "cellular response to 1-oleoyl-sn-glycerol 3-phosphate",
  "GO:1904567": "response to wortmannin",
  "GO:1904568": "cellular response to wortmannin",
  "GO:1904569": "regulation of selenocysteine incorporation",
  "GO:1904570": "negative regulation of selenocysteine incorporation",
  "GO:1904571": "positive regulation of selenocysteine incorporation",
  "GO:1904572": "negative regulation of mRNA binding",
  "GO:1904573": "regulation of selenocysteine insertion sequence binding",
  "GO:1904574": "negative regulation of selenocysteine insertion sequence binding",
  "GO:1904575": "positive regulation of selenocysteine insertion sequence binding",
  "GO:1904576": "response to tunicamycin",
  "GO:1904577": "cellular response to tunicamycin",
  "GO:1904578": "response to thapsigargin",
  "GO:1904579": "cellular response to thapsigargin",
  "GO:1904580": "regulation of intracellular mRNA localization",
  "GO:1904581": "negative regulation of intracellular mRNA localization",
  "GO:1904582": "positive regulation of intracellular mRNA localization",
  "GO:1904583": "response to polyamine macromolecule",
  "GO:1904584": "cellular response to polyamine macromolecule",
  "GO:1904585": "response to putrescine",
  "GO:1904586": "cellular response to putrescine",
  "GO:1904587": "response to glycoprotein",
  "GO:1904588": "cellular response to glycoprotein",
  "GO:1904589": "regulation of protein import",
  "GO:1904590": "negative regulation of protein import",
  "GO:1904591": "positive regulation of protein import",
  "GO:1904592": "positive regulation of protein refolding",
  "GO:1904593": "prostaglandin binding",
  "GO:1904594": "regulation of termination of RNA polymerase II transcription",
  "GO:1904595": "positive regulation of termination of RNA polymerase II transcription",
  "GO:1904596": "regulation of connective tissue replacement involved in inflammatory response wound healing",
  "GO:1904597": "negative regulation of connective tissue replacement involved in inflammatory response wound healing",
  "GO:1904598": "positive regulation of connective tissue replacement involved in inflammatory response wound healing",
  "GO:1904599": "advanced glycation end-product binding",
  "GO:1904600": "actin fusion focus assembly",
  "GO:1904601": "protein localization to actin fusion focus",
  "GO:1904602": "serotonin-activated cation-selective channel complex",
  "GO:1904603": "regulation of advanced glycation end-product receptor activity",
  "GO:1904604": "negative regulation of advanced glycation end-product receptor activity",
  "GO:1904605": "positive regulation of advanced glycation end-product receptor activity",
  "GO:1904606": "fat cell apoptotic process",
  "GO:1904608": "response to monosodium L-glutamate",
  "GO:1904609": "cellular response to monosodium L-glutamate",
  "GO:1904610": "response to 3,3',4,4',5-pentachlorobiphenyl",
  "GO:1904611": "cellular response to 3,3',4,4',5-pentachlorobiphenyl",
  "GO:1904612": "response to 2,3,7,8-tetrachlorodibenzodioxine",
  "GO:1904613": "cellular response to 2,3,7,8-tetrachlorodibenzodioxine",
  "GO:1904614": "response to biphenyl",
  "GO:1904615": "cellular response to biphenyl",
  "GO:1904616": "regulation of actin binding",
  "GO:1904617": "negative regulation of actin binding",
  "GO:1904618": "positive regulation of actin binding",
  "GO:1904619": "response to dimethyl sulfoxide",
  "GO:1904620": "cellular response to dimethyl sulfoxide",
  "GO:1904621": "regulation of actin-dependent ATPase activity",
  "GO:1904622": "negative regulation of actin-dependent ATPase activity",
  "GO:1904623": "positive regulation of actin-dependent ATPase activity",
  "GO:1904624": "regulation of glycine secretion, neurotransmission",
  "GO:1904625": "negative regulation of glycine secretion, neurotransmission",
  "GO:1904626": "positive regulation of glycine secretion, neurotransmission",
  "GO:1904627": "response to phorbol 13-acetate 12-myristate",
  "GO:1904628": "cellular response to phorbol 13-acetate 12-myristate",
  "GO:1904629": "response to diterpene",
  "GO:1904630": "cellular response to diterpene",
  "GO:1904631": "response to glucoside",
  "GO:1904632": "cellular response to glucoside",
  "GO:1904633": "regulation of glomerular visceral epithelial cell apoptotic process",
  "GO:1904634": "negative regulation of glomerular visceral epithelial cell apoptotic process",
  "GO:1904635": "positive regulation of glomerular visceral epithelial cell apoptotic process",
  "GO:1904636": "response to ionomycin",
  "GO:1904637": "cellular response to ionomycin",
  "GO:1904638": "response to resveratrol",
  "GO:1904639": "cellular response to resveratrol",
  "GO:1904640": "response to methionine",
  "GO:1904641": "response to dinitrophenol",
  "GO:1904642": "cellular response to dinitrophenol",
  "GO:1904643": "response to curcumin",
  "GO:1904644": "cellular response to curcumin",
  "GO:1904645": "response to beta-amyloid",
  "GO:1904646": "cellular response to beta-amyloid",
  "GO:1904647": "response to rotenone",
  "GO:1904648": "cellular response to rotenone",
  "GO:1904649": "regulation of fat cell apoptotic process",
  "GO:1904650": "negative regulation of fat cell apoptotic process",
  "GO:1904651": "positive regulation of fat cell apoptotic process",
  "GO:1904652": "protein localization to cell division site involved in cell separation after cytokinesis",
  "GO:1904653": "regulation of lung alveolus development",
  "GO:1904654": "negative regulation of lung alveolus development",
  "GO:1904655": "positive regulation of lung alveolus development",
  "GO:1904656": "regulation of sensory perception of sweet taste",
  "GO:1904657": "negative regulation of sensory perception of sweet taste",
  "GO:1904658": "positive regulation of sensory perception of sweet taste",
  "GO:1904659": "glucose transmembrane transport",
  "GO:1904660": "regulation of sensory perception of bitter taste",
  "GO:1904661": "negative regulation of sensory perception of bitter taste",
  "GO:1904662": "positive regulation of sensory perception of bitter taste",
  "GO:1904663": "regulation of N-terminal peptidyl-methionine acetylation",
  "GO:1904664": "negative regulation of N-terminal peptidyl-methionine acetylation",
  "GO:1904665": "positive regulation of N-terminal peptidyl-methionine acetylation",
  "GO:1904666": "regulation of ubiquitin protein ligase activity",
  "GO:1904667": "negative regulation of ubiquitin protein ligase activity",
  "GO:1904668": "positive regulation of ubiquitin protein ligase activity",
  "GO:1904669": "ATP export",
  "GO:1904670": "actin filament polymerization involved in mitotic actomyosin contractile ring assembly",
  "GO:1904671": "negative regulation of cell differentiation involved in stem cell population maintenance",
  "GO:1904672": "regulation of somatic stem cell population maintenance",
  "GO:1904673": "negative regulation of somatic stem cell population maintenance",
  "GO:1904674": "positive regulation of somatic stem cell population maintenance",
  "GO:1904675": "regulation of somatic stem cell division",
  "GO:1904676": "negative regulation of somatic stem cell division",
  "GO:1904677": "positive regulation of somatic stem cell division",
  "GO:1904678": "alpha-aminoacyl-tRNA binding",
  "GO:1904679": "myo-inositol import across plasma membrane",
  "GO:1904680": "peptide transmembrane transporter activity",
  "GO:1904681": "response to 3-methylcholanthrene",
  "GO:1904682": "cellular response to 3-methylcholanthrene",
  "GO:1904683": "regulation of metalloendopeptidase activity",
  "GO:1904684": "negative regulation of metalloendopeptidase activity",
  "GO:1904685": "positive regulation of metalloendopeptidase activity",
  "GO:1904686": "regulation of mitotic spindle disassembly",
  "GO:1904687": "positive regulation of mitotic spindle disassembly",
  "GO:1904688": "regulation of cytoplasmic translational initiation",
  "GO:1904689": "negative regulation of cytoplasmic translational initiation",
  "GO:1904690": "positive regulation of cytoplasmic translational initiation",
  "GO:1904691": "negative regulation of type B pancreatic cell proliferation",
  "GO:1904692": "positive regulation of type B pancreatic cell proliferation",
  "GO:1904693": "midbrain morphogenesis",
  "GO:1904694": "negative regulation of vascular smooth muscle contraction",
  "GO:1904695": "positive regulation of vascular smooth muscle contraction",
  "GO:1904696": "protein localization to cell-cell adherens junction",
  "GO:1904697": "regulation of acinar cell proliferation",
  "GO:1904698": "negative regulation of acinar cell proliferation",
  "GO:1904699": "positive regulation of acinar cell proliferation",
  "GO:1904700": "granulosa cell apoptotic process",
  "GO:1904701": "Wnt-Frizzled-LRP5/6 complex assembly",
  "GO:1904702": "regulation of protein localization to cell-cell adherens junction",
  "GO:1904703": "negative regulation of protein localization to cell-cell adherens junction",
  "GO:1904704": "positive regulation of protein localization to cell-cell adherens junction",
  "GO:1904705": "regulation of vascular smooth muscle cell proliferation",
  "GO:1904706": "negative regulation of vascular smooth muscle cell proliferation",
  "GO:1904707": "positive regulation of vascular smooth muscle cell proliferation",
  "GO:1904708": "regulation of granulosa cell apoptotic process",
  "GO:1904709": "negative regulation of granulosa cell apoptotic process",
  "GO:1904710": "positive regulation of granulosa cell apoptotic process",
  "GO:1904711": "regulation of Wnt-Frizzled-LRP5/6 complex assembly",
  "GO:1904712": "positive regulation of Wnt-Frizzled-LRP5/6 complex assembly",
  "GO:1904713": "beta-catenin destruction complex binding",
  "GO:1904714": "regulation of chaperone-mediated autophagy",
  "GO:1904715": "negative regulation of chaperone-mediated autophagy",
  "GO:1904716": "positive regulation of chaperone-mediated autophagy",
  "GO:1904717": "regulation of AMPA glutamate receptor clustering",
  "GO:1904718": "negative regulation of AMPA glutamate receptor clustering",
  "GO:1904719": "positive regulation of AMPA glutamate receptor clustering",
  "GO:1904720": "regulation of mRNA endonucleolytic cleavage involved in unfolded protein response",
  "GO:1904721": "negative regulation of mRNA endonucleolytic cleavage involved in unfolded protein response",
  "GO:1904722": "positive regulation of mRNA endonucleolytic cleavage involved in unfolded protein response",
  "GO:1904723": "negative regulation of Wnt-Frizzled-LRP5/6 complex assembly",
  "GO:1904724": "tertiary granule lumen",
  "GO:1904725": "TFIIB-class transcription factor binding involved in negative regulation of transcription",
  "GO:1904726": "regulation of replicative senescence",
  "GO:1904727": "negative regulation of replicative senescence",
  "GO:1904728": "positive regulation of replicative senescence",
  "GO:1904729": "regulation of intestinal lipid absorption",
  "GO:1904730": "negative regulation of intestinal lipid absorption",
  "GO:1904731": "positive regulation of intestinal lipid absorption",
  "GO:1904732": "regulation of electron carrier activity",
  "GO:1904733": "negative regulation of electron carrier activity",
  "GO:1904734": "positive regulation of electron carrier activity",
  "GO:1904735": "regulation of fatty acid beta-oxidation using acyl-CoA dehydrogenase",
  "GO:1904736": "negative regulation of fatty acid beta-oxidation using acyl-CoA dehydrogenase",
  "GO:1904737": "positive regulation of fatty acid beta-oxidation using acyl-CoA dehydrogenase",
  "GO:1904738": "vascular associated smooth muscle cell migration",
  "GO:1904739": "regulation of synapse organization by posttranscriptional regulation of gene expression",
  "GO:1904740": "positive regulation of filamentous growth of a population of unicellular organisms in response to starvation by transcription from RNA polymerase II promoter",
  "GO:1904741": "positive regulation of filamentous growth of a population of unicellular organisms in response to starvation by positive regulation of transcription from RNA polymerase II promoter",
  "GO:1904742": "regulation of telomeric DNA binding",
  "GO:1904743": "negative regulation of telomeric DNA binding",
  "GO:1904744": "positive regulation of telomeric DNA binding",
  "GO:1904745": "ATG1/ULK1 kinase complex assembly",
  "GO:1904746": "negative regulation of apoptotic process involved in development",
  "GO:1904747": "positive regulation of apoptotic process involved in development",
  "GO:1904748": "regulation of apoptotic process involved in development",
  "GO:1904749": "regulation of protein localization to nucleolus",
  "GO:1904750": "negative regulation of protein localization to nucleolus",
  "GO:1904751": "positive regulation of protein localization to nucleolus",
  "GO:1904752": "regulation of vascular associated smooth muscle cell migration",
  "GO:1904753": "negative regulation of vascular associated smooth muscle cell migration",
  "GO:1904754": "positive regulation of vascular associated smooth muscle cell migration",
  "GO:1904755": "regulation of gut granule assembly",
  "GO:1904756": "negative regulation of gut granule assembly",
  "GO:1904757": "positive regulation of gut granule assembly",
  "GO:1904758": "protein localization to new growing cell tip",
  "GO:1904759": "protein localization to equatorial microtubule organizing center",
  "GO:1904760": "regulation of myofibroblast differentiation",
  "GO:1904761": "negative regulation of myofibroblast differentiation",
  "GO:1904762": "positive regulation of myofibroblast differentiation",
  "GO:1904763": "chaperone-mediated autophagy translocation complex assembly",
  "GO:1904764": "chaperone-mediated autophagy translocation complex disassembly",
  "GO:1904765": "positive regulation of transcription from RNA polymerase II promoter in response to maltose",
  "GO:1904766": "negative regulation of macroautophagy by TORC1 signaling",
  "GO:1904767": "octanoic acid binding",
  "GO:1904768": "all-trans-retinol binding",
  "GO:1904769": "isopentadecanoic acid binding",
  "GO:1904770": "intramembranous bone morphogenesis",
  "GO:1904771": "obsolete cellular response to doxorubicin",
  "GO:1904772": "response to tetrachloromethane",
  "GO:1904773": "obsolete cellular response to tetrachloromethane",
  "GO:1904774": "negative regulation of ubiquinone biosynthetic process",
  "GO:1904775": "positive regulation of ubiquinone biosynthetic process",
  "GO:1904776": "regulation of protein localization to cell cortex",
  "GO:1904777": "negative regulation of protein localization to cell cortex",
  "GO:1904778": "positive regulation of protein localization to cell cortex",
  "GO:1904779": "regulation of protein localization to centrosome",
  "GO:1904780": "negative regulation of protein localization to centrosome",
  "GO:1904781": "positive regulation of protein localization to centrosome",
  "GO:1904782": "negative regulation of NMDA glutamate receptor activity",
  "GO:1904783": "positive regulation of NMDA glutamate receptor activity",
  "GO:1904784": "NLRP1 inflammasome complex assembly",
  "GO:1904785": "regulation of asymmetric protein localization involved in cell fate determination",
  "GO:1904786": "negative regulation of asymmetric protein localization involved in cell fate determination",
  "GO:1904787": "positive regulation of asymmetric protein localization involved in cell fate determination",
  "GO:1904788": "positive regulation of induction of conjugation with cellular fusion by regulation of transcription from RNA polymerase II promoter",
  "GO:1904789": "regulation of mitotic actomyosin contractile ring maintenance",
  "GO:1904790": "regulation of telosome assembly",
  "GO:1904791": "negative regulation of telosome assembly",
  "GO:1904792": "positive regulation of telosome assembly",
  "GO:1904793": "regulation of euchromatin binding",
  "GO:1904794": "negative regulation of euchromatin binding",
  "GO:1904795": "positive regulation of euchromatin binding",
  "GO:1904796": "regulation of core promoter binding",
  "GO:1904797": "negative regulation of core promoter binding",
  "GO:1904798": "positive regulation of core promoter binding",
  "GO:1904799": "regulation of neuron remodeling",
  "GO:1904800": "negative regulation of neuron remodeling",
  "GO:1904801": "positive regulation of neuron remodeling",
  "GO:1904802": "RITS complex assembly",
  "GO:1904803": "regulation of translation involved in cellular response to UV",
  "GO:1904804": "response to latrunculin A",
  "GO:1904805": "cellular response to latrunculin A",
  "GO:1904806": "regulation of protein oxidation",
  "GO:1904807": "negative regulation of protein oxidation",
  "GO:1904808": "positive regulation of protein oxidation",
  "GO:1904809": "regulation of dense core granule transport",
  "GO:1904810": "negative regulation of dense core granule transport",
  "GO:1904811": "positive regulation of dense core granule transport",
  "GO:1904812": "rRNA acetylation involved in maturation of SSU-rRNA",
  "GO:1904813": "ficolin-1-rich granule lumen",
  "GO:1904814": "regulation of protein localization to chromosome, telomeric region",
  "GO:1904815": "negative regulation of protein localization to chromosome, telomeric region",
  "GO:1904816": "positive regulation of protein localization to chromosome, telomeric region",
  "GO:1904817": "serous membrane development",
  "GO:1904818": "visceral peritoneum development",
  "GO:1904819": "parietal peritoneum development",
  "GO:1904820": "peritoneum development",
  "GO:1904821": "chloroplast disassembly",
  "GO:1904822": "ubiquitin protein ligase activity involved in chloroplast disassembly",
  "GO:1904823": "purine nucleobase transmembrane transport",
  "GO:1904824": "anaphase-promoting complex assembly",
  "GO:1904825": "protein localization to microtubule plus-end",
  "GO:1904826": "regulation of hydrogen sulfide biosynthetic process",
  "GO:1904827": "negative regulation of hydrogen sulfide biosynthetic process",
  "GO:1904828": "positive regulation of hydrogen sulfide biosynthetic process",
  "GO:1904829": "regulation of aortic smooth muscle cell differentiation",
  "GO:1904830": "negative regulation of aortic smooth muscle cell differentiation",
  "GO:1904831": "positive regulation of aortic smooth muscle cell differentiation",
  "GO:1904832": "negative regulation of removal of superoxide radicals",
  "GO:1904833": "positive regulation of removal of superoxide radicals",
  "GO:1904834": "nuclear CENP-A containing chromatin",
  "GO:1904835": "dorsal root ganglion morphogenesis",
  "GO:1904836": "facioacoustic ganglion morphogenesis",
  "GO:1904837": "beta-catenin-TCF complex assembly",
  "GO:1904838": "regulation of male germ-line stem cell asymmetric division",
  "GO:1904839": "negative regulation of male germ-line stem cell asymmetric division",
  "GO:1904840": "positive regulation of male germ-line stem cell asymmetric division",
  "GO:1904841": "TORC2 complex binding",
  "GO:1904842": "response to nitroglycerin",
  "GO:1904843": "cellular response to nitroglycerin",
  "GO:1904844": "response to L-glutamine",
  "GO:1904845": "cellular response to L-glutamine",
  "GO:1904846": "negative regulation of establishment of bipolar cell polarity",
  "GO:1904847": "regulation of cell chemotaxis to fibroblast growth factor",
  "GO:1904848": "negative regulation of cell chemotaxis to fibroblast growth factor",
  "GO:1904849": "positive regulation of cell chemotaxis to fibroblast growth factor",
  "GO:1904850": "negative regulation of establishment of protein localization to telomere",
  "GO:1904851": "positive regulation of establishment of protein localization to telomere",
  "GO:1904852": "trimethylamine-N-oxide reductase (cytochrome c) complex",
  "GO:1904853": "protein localization to ascospore wall",
  "GO:1904854": "proteasome core complex binding",
  "GO:1904855": "proteasome regulatory particle binding",
  "GO:1904856": "cytolytic granule lumen",
  "GO:1904857": "regulation of endothelial cell chemotaxis to vascular endothelial growth factor",
  "GO:1904858": "negative regulation of endothelial cell chemotaxis to vascular endothelial growth factor",
  "GO:1904859": "positive regulation of endothelial cell chemotaxis to vascular endothelial growth factor",
  "GO:1904860": "DNA biosynthetic process involved in mitotic DNA replication",
  "GO:1904861": "excitatory synapse assembly",
  "GO:1904862": "inhibitory synapse assembly",
  "GO:1904863": "regulation of beta-catenin-TCF complex assembly",
  "GO:1904864": "negative regulation of beta-catenin-TCF complex assembly",
  "GO:1904865": "positive regulation of beta-catenin-TCF complex assembly",
  "GO:1904866": "ventral tegmental area development",
  "GO:1904867": "protein localization to Cajal body",
  "GO:1904868": "telomerase catalytic core complex assembly",
  "GO:1904869": "regulation of protein localization to Cajal body",
  "GO:1904870": "negative regulation of protein localization to Cajal body",
  "GO:1904871": "positive regulation of protein localization to Cajal body",
  "GO:1904872": "regulation of telomerase RNA localization to Cajal body",
  "GO:1904873": "negative regulation of telomerase RNA localization to Cajal body",
  "GO:1904874": "positive regulation of telomerase RNA localization to Cajal body",
  "GO:1904875": "regulation of DNA ligase activity",
  "GO:1904876": "negative regulation of DNA ligase activity",
  "GO:1904877": "positive regulation of DNA ligase activity",
  "GO:1904878": "negative regulation of calcium ion transmembrane transport via high voltage-gated calcium channel",
  "GO:1904879": "positive regulation of calcium ion transmembrane transport via high voltage-gated calcium channel",
  "GO:1904880": "response to hydrogen sulfide",
  "GO:1904881": "cellular response to hydrogen sulfide",
  "GO:1904882": "regulation of telomerase catalytic core complex assembly",
  "GO:1904883": "negative regulation of telomerase catalytic core complex assembly",
  "GO:1904884": "positive regulation of telomerase catalytic core complex assembly",
  "GO:1904885": "beta-catenin destruction complex assembly",
  "GO:1904886": "beta-catenin destruction complex disassembly",
  "GO:1904887": "Wnt signalosome assembly",
  "GO:1904888": "cranial skeletal system development",
  "GO:1904889": "regulation of excitatory synapse assembly",
  "GO:1904890": "negative regulation of excitatory synapse assembly",
  "GO:1904891": "positive regulation of excitatory synapse assembly",
  "GO:1904892": "regulation of STAT cascade",
  "GO:1904893": "negative regulation of STAT cascade",
  "GO:1904894": "positive regulation of STAT cascade",
  "GO:1904895": "ESCRT complex assembly",
  "GO:1904896": "ESCRT complex disassembly",
  "GO:1904897": "regulation of hepatic stellate cell proliferation",
  "GO:1904898": "negative regulation of hepatic stellate cell proliferation",
  "GO:1904899": "positive regulation of hepatic stellate cell proliferation",
  "GO:1904900": "negative regulation of myosin II filament organization",
  "GO:1904901": "positive regulation of myosin II filament organization",
  "GO:1904902": "ESCRT III complex assembly",
  "GO:1904903": "ESCRT III complex disassembly",
  "GO:1904904": "regulation of endothelial cell-matrix adhesion via fibronectin",
  "GO:1904905": "negative regulation of endothelial cell-matrix adhesion via fibronectin",
  "GO:1904906": "positive regulation of endothelial cell-matrix adhesion via fibronectin",
  "GO:1904907": "regulation of maintenance of mitotic sister chromatid cohesion, telomeric",
  "GO:1904908": "negative regulation of maintenance of mitotic sister chromatid cohesion, telomeric",
  "GO:1904909": "positive regulation of maintenance of mitotic sister chromatid cohesion, telomeric",
  "GO:1904910": "regulation of establishment of RNA localization to telomere",
  "GO:1904911": "negative regulation of establishment of RNA localization to telomere",
  "GO:1904912": "positive regulation of establishment of RNA localization to telomere",
  "GO:1904913": "regulation of establishment of macromolecular complex localization to telomere",
  "GO:1904914": "negative regulation of establishment of macromolecular complex localization to telomere",
  "GO:1904915": "positive regulation of establishment of macromolecular complex localization to telomere",
  "GO:1904916": "transmembrane L-lysine transport from lysosomal lumen to cytosol",
  "GO:1904917": "transmembrane L-arginine transport from lysosomal lumen to cytosol",
  "GO:1904918": "transmembrane L-histidine transport from lysosomal lumen to cytosol",
  "GO:1904919": "transmembrane L-cystine transport from lysosomal lumen to cytosol",
  "GO:1904920": "regulation of MAPK cascade involved in axon regeneration",
  "GO:1904921": "negative regulation of MAPK cascade involved in axon regeneration",
  "GO:1904922": "positive regulation of MAPK cascade involved in axon regeneration",
  "GO:1904923": "regulation of mitophagy in response to mitochondrial depolarization",
  "GO:1904924": "negative regulation of mitophagy in response to mitochondrial depolarization",
  "GO:1904925": "positive regulation of mitophagy in response to mitochondrial depolarization",
  "GO:1904926": "response to palmitoleic acid",
  "GO:1904927": "cellular response to palmitoleic acid",
  "GO:1904928": "coreceptor activity involved in canonical Wnt signaling pathway",
  "GO:1904929": "coreceptor activity involved in Wnt signaling pathway, planar cell polarity pathway",
  "GO:1904930": "amphisome membrane",
  "GO:1904931": "MCM complex binding",
  "GO:1904932": "negative regulation of cartilage condensation",
  "GO:1904933": "regulation of cell proliferation in midbrain",
  "GO:1904934": "negative regulation of cell proliferation in midbrain",
  "GO:1904935": "positive regulation of cell proliferation in midbrain",
  "GO:1904936": "interneuron migration",
  "GO:1904937": "sensory neuron migration",
  "GO:1904938": "planar cell polarity pathway involved in axon guidance",
  "GO:1904939": "regulation of DNA nucleotidylexotransferase activity",
  "GO:1904940": "negative regulation of DNA nucleotidylexotransferase activity",
  "GO:1904941": "positive regulation of DNA nucleotidylexotransferase activity",
  "GO:1904942": "regulation of cardiac ventricle formation",
  "GO:1904943": "negative regulation of cardiac ventricle formation",
  "GO:1904944": "positive regulation of cardiac ventricle formation",
  "GO:1904945": "obsolete response to cobalt(II) acetate",
  "GO:1904946": "obsolete cellular response to cobalt(II) acetate",
  "GO:1904947": "folic acid import into mitochondrion",
  "GO:1904948": "midbrain dopaminergic neuron differentiation",
  "GO:1904949": "ATPase complex",
  "GO:1904950": "negative regulation of establishment of protein localization",
  "GO:1904951": "positive regulation of establishment of protein localization",
  "GO:1904952": "hydroxycinnamic acid transport",
  "GO:1904953": "Wnt signaling pathway involved in midbrain dopaminergic neuron differentiation",
  "GO:1904954": "canonical Wnt signaling pathway involved in midbrain dopaminergic neuron differentiation",
  "GO:1904955": "planar cell polarity pathway involved in midbrain dopaminergic neuron differentiation",
  "GO:1904956": "regulation of midbrain dopaminergic neuron differentiation",
  "GO:1904957": "negative regulation of midbrain dopaminergic neuron differentiation",
  "GO:1904958": "positive regulation of midbrain dopaminergic neuron differentiation",
  "GO:1904959": "regulation of cytochrome-c oxidase activity",
  "GO:1904960": "positive regulation of cytochrome-c oxidase activity",
  "GO:1904961": "quiescent center organization",
  "GO:1904962": "plastid to vacuole vesicle-mediated transport",
  "GO:1904963": "regulation of phytol biosynthetic process",
  "GO:1904964": "positive regulation of phytol biosynthetic process",
  "GO:1904965": "regulation of vitamin E biosynthetic process",
  "GO:1904966": "positive regulation of vitamin E biosynthetic process",
  "GO:1904967": "regulation of attachment of spindle microtubules to kinetochore involved in homologous chromosome segregation",
  "GO:1904968": "positive regulation of attachment of spindle microtubules to kinetochore involved in homologous chromosome segregation",
  "GO:1904969": "slow muscle cell migration",
  "GO:1904970": "brush border assembly",
  "GO:1904971": "regulation of viral translation",
  "GO:1904972": "negative regulation of viral translation",
  "GO:1904973": "positive regulation of viral translation",
  "GO:1904974": "heparanase complex",
  "GO:1904975": "response to bleomycin",
  "GO:1904976": "cellular response to bleomycin",
  "GO:1904977": "lymphatic endothelial cell migration",
  "GO:1904978": "regulation of endosome organization",
  "GO:1904979": "negative regulation of endosome organization",
  "GO:1904980": "positive regulation of endosome organization",
  "GO:1904981": "maltose transmembrane transport",
  "GO:1904982": "sucrose transmembrane transport",
  "GO:1904983": "transmembrane glycine transport from cytosol to mitochondrion",
  "GO:1904984": "regulation of quinolinate biosynthetic process",
  "GO:1904985": "negative regulation of quinolinate biosynthetic process",
  "GO:1904986": "positive regulation of quinolinate biosynthetic process",
  "GO:1904987": "regulation of endothelial cell activation",
  "GO:1904988": "negative regulation of endothelial cell activation",
  "GO:1904989": "positive regulation of endothelial cell activation",
  "GO:1904990": "regulation of adenylate cyclase-inhibiting dopamine receptor signaling pathway",
  "GO:1904991": "negative regulation of adenylate cyclase-inhibiting dopamine receptor signaling pathway",
  "GO:1904992": "positive regulation of adenylate cyclase-inhibiting dopamine receptor signaling pathway",
  "GO:1904993": "obsolete positive regulation of cyclin-dependent protein serine/threonine kinase activity involved in positive regulation of G2/M transition of mitotic cell cycle",
  "GO:1904994": "regulation of leukocyte adhesion to vascular endothelial cell",
  "GO:1904995": "negative regulation of leukocyte adhesion to vascular endothelial cell",
  "GO:1904996": "positive regulation of leukocyte adhesion to vascular endothelial cell",
  "GO:1904997": "regulation of leukocyte adhesion to arterial endothelial cell",
  "GO:1904998": "negative regulation of leukocyte adhesion to arterial endothelial cell",
  "GO:1904999": "positive regulation of leukocyte adhesion to arterial endothelial cell",
  "GO:1905000": "regulation of membrane repolarization during atrial cardiac muscle cell action potential",
  "GO:1905001": "negative regulation of membrane repolarization during atrial cardiac muscle cell action potential",
  "GO:1905002": "positive regulation of membrane repolarization during atrial cardiac muscle cell action potential",
  "GO:1905003": "picolinic acid metabolic process",
  "GO:1905004": "picolinic acid biosynthetic process",
  "GO:1905005": "regulation of epithelial to mesenchymal transition involved in endocardial cushion formation",
  "GO:1905006": "negative regulation of epithelial to mesenchymal transition involved in endocardial cushion formation",
  "GO:1905007": "positive regulation of epithelial to mesenchymal transition involved in endocardial cushion formation",
  "GO:1905008": "regulation of L-lysine import into cell",
  "GO:1905009": "negative regulation of L-lysine import into cell",
  "GO:1905010": "positive regulation of L-lysine import into cell",
  "GO:1905011": "transmembrane phosphate ion transport from cytosol to vacuole",
  "GO:1905012": "regulation of 'de novo' NAD biosynthetic process from tryptophan",
  "GO:1905013": "negative regulation of 'de novo' NAD biosynthetic process from tryptophan",
  "GO:1905014": "positive regulation of 'de novo' NAD biosynthetic process from tryptophan",
  "GO:1905015": "regulation of isoleucine-tRNA ligase activity",
  "GO:1905016": "negative regulation of isoleucine-tRNA ligase activity",
  "GO:1905017": "positive regulation of isoleucine-tRNA ligase activity",
  "GO:1905018": "regulation of methionine-tRNA ligase activity",
  "GO:1905019": "negative regulation of methionine-tRNA ligase activity",
  "GO:1905020": "positive regulation of methionine-tRNA ligase activity",
  "GO:1905021": "regulation of threonine-tRNA ligase activity",
  "GO:1905022": "negative regulation of threonine-tRNA ligase activity",
  "GO:1905023": "positive regulation of threonine-tRNA ligase activity",
  "GO:1905024": "regulation of membrane repolarization during ventricular cardiac muscle cell action potential",
  "GO:1905025": "negative regulation of membrane repolarization during ventricular cardiac muscle cell action potential",
  "GO:1905026": "positive regulation of membrane repolarization during ventricular cardiac muscle cell action potential",
  "GO:1905027": "regulation of membrane depolarization during AV node cell action potential",
  "GO:1905028": "negative regulation of membrane depolarization during AV node cell action potential",
  "GO:1905029": "positive regulation of membrane depolarization during AV node cell action potential",
  "GO:1905030": "voltage-gated ion channel activity involved in regulation of postsynaptic membrane potential",
  "GO:1905031": "regulation of membrane repolarization during cardiac muscle cell action potential",
  "GO:1905032": "negative regulation of membrane repolarization during cardiac muscle cell action potential",
  "GO:1905033": "positive regulation of membrane repolarization during cardiac muscle cell action potential",
  "GO:1905034": "regulation of antifungal innate immune response",
  "GO:1905035": "negative regulation of antifungal innate immune response",
  "GO:1905036": "positive regulation of antifungal innate immune response",
  "GO:1905037": "autophagosome organization",
  "GO:1905038": "regulation of membrane lipid metabolic process",
  "GO:1905039": "carboxylic acid transmembrane transport",
  "GO:1905040": "otic placode development",
  "GO:1905041": "regulation of epithelium regeneration",
  "GO:1905042": "negative regulation of epithelium regeneration",
  "GO:1905043": "positive regulation of epithelium regeneration",
  "GO:1905044": "regulation of Schwann cell proliferation involved in axon regeneration",
  "GO:1905045": "negative regulation of Schwann cell proliferation involved in axon regeneration",
  "GO:1905046": "positive regulation of Schwann cell proliferation involved in axon regeneration",
  "GO:1905047": "mitotic spindle pole body organization",
  "GO:1905048": "regulation of metallopeptidase activity",
  "GO:1905049": "negative regulation of metallopeptidase activity",
  "GO:1905050": "positive regulation of metallopeptidase activity",
  "GO:1905051": "regulation of base-excision repair",
  "GO:1905052": "negative regulation of base-excision repair",
  "GO:1905053": "positive regulation of base-excision repair",
  "GO:1905054": "calcium-induced calcium release activity involved in regulation of presynaptic cytosolic calcium ion concentration",
  "GO:1905055": "calcium:cation antiporter activity involved in regulation of presynaptic cytosolic calcium ion concentration",
  "GO:1905056": "calcium-transporting ATPase activity involved in regulation of presynaptic cytosolic calcium ion concentration",
  "GO:1905057": "voltage-gated calcium channel activity involved in regulation of postsynaptic cytosolic calcium ion concentration",
  "GO:1905058": "calcium-induced calcium release activity involved in regulation of postsynaptic cytosolic calcium ion concentration",
  "GO:1905059": "calcium-transporting ATPase activity involved in regulation of postsynaptic cytosolic calcium ion concentration",
  "GO:1905060": "calcium:cation antiporter activity involved in regulation of postsynaptic cytosolic calcium ion concentration",
  "GO:1905061": "negative regulation of cardioblast proliferation",
  "GO:1905062": "positive regulation of cardioblast proliferation",
  "GO:1905063": "regulation of vascular smooth muscle cell differentiation",
  "GO:1905064": "negative regulation of vascular smooth muscle cell differentiation",
  "GO:1905065": "positive regulation of vascular smooth muscle cell differentiation",
  "GO:1905066": "regulation of canonical Wnt signaling pathway involved in heart development",
  "GO:1905067": "negative regulation of canonical Wnt signaling pathway involved in heart development",
  "GO:1905068": "positive regulation of canonical Wnt signaling pathway involved in heart development",
  "GO:1905069": "allantois development",
  "GO:1905070": "anterior visceral endoderm cell migration",
  "GO:1905071": "occluding junction disassembly",
  "GO:1905072": "cardiac jelly development",
  "GO:1905073": "regulation of occluding junction disassembly",
  "GO:1905074": "negative regulation of occluding junction disassembly",
  "GO:1905075": "positive regulation of occluding junction disassembly",
  "GO:1905076": "regulation of interleukin-17 secretion",
  "GO:1905077": "negative regulation of interleukin-17 secretion",
  "GO:1905078": "positive regulation of interleukin-17 secretion",
  "GO:1905079": "regulation of cerebellar neuron development",
  "GO:1905080": "negative regulation of cerebellar neuron development",
  "GO:1905081": "positive regulation of cerebellar neuron development",
  "GO:1905082": "regulation of mitochondrial translational elongation",
  "GO:1905083": "negative regulation of mitochondrial translational elongation",
  "GO:1905084": "positive regulation of mitochondrial translational elongation",
  "GO:1905085": "regulation of bioluminescence",
  "GO:1905086": "negative regulation of bioluminescence",
  "GO:1905087": "positive regulation of bioluminescence",
  "GO:1905088": "positive regulation of synaptonemal complex assembly",
  "GO:1905089": "regulation of parkin-mediated mitophagy in response to mitochondrial depolarization",
  "GO:1905090": "negative regulation of parkin-mediated mitophagy in response to mitochondrial depolarization",
  "GO:1905091": "positive regulation of parkin-mediated mitophagy in response to mitochondrial depolarization",
  "GO:1905092": "response to diosgenin",
  "GO:1905093": "cellular response to diosgenin",
  "GO:1905094": "regulation of apolipoprotein A-I-mediated signaling pathway",
  "GO:1905095": "negative regulation of apolipoprotein A-I-mediated signaling pathway",
  "GO:1905096": "positive regulation of apolipoprotein A-I-mediated signaling pathway",
  "GO:1905097": "regulation of guanyl-nucleotide exchange factor activity",
  "GO:1905098": "negative regulation of guanyl-nucleotide exchange factor activity",
  "GO:1905099": "positive regulation of guanyl-nucleotide exchange factor activity",
  "GO:1905100": "regulation of apoptosome assembly",
  "GO:1905101": "negative regulation of apoptosome assembly",
  "GO:1905102": "positive regulation of apoptosome assembly",
  "GO:1905103": "integral component of lysosomal membrane",
  "GO:1905104": "obsolete response to ouabain",
  "GO:1905105": "obsolete cellular response to ouabain",
  "GO:1905106": "obsolete response to Dizocilpine",
  "GO:1905107": "obsolete cellular response to Dizocilpine",
  "GO:1905108": "guanosine binding",
  "GO:1905109": "regulation of pulmonary blood vessel remodeling",
  "GO:1905110": "negative regulation of pulmonary blood vessel remodeling",
  "GO:1905111": "positive regulation of pulmonary blood vessel remodeling",
  "GO:1905112": "regulation of centromere clustering at the nuclear envelope",
  "GO:1905113": "positive regulation of centromere clustering at the nuclear envelope",
  "GO:1905114": "cell surface receptor signaling pathway involved in cell-cell signaling",
  "GO:1905115": "regulation of lateral attachment of mitotic spindle microtubules to kinetochore",
  "GO:1905116": "positive regulation of lateral attachment of mitotic spindle microtubules to kinetochore",
  "GO:1905117": "regulation of ribonucleoside-diphosphate reductase activity",
  "GO:1905118": "positive regulation of ribonucleoside-diphosphate reductase activity",
  "GO:1905119": "response to haloperidol",
  "GO:1905120": "cellular response to haloperidol",
  "GO:1905121": "microtubule sliding involved in mitotic spindle elongation",
  "GO:1905122": "polyamine import",
  "GO:1905123": "regulation of glucosylceramidase activity",
  "GO:1905124": "negative regulation of glucosylceramidase activity",
  "GO:1905125": "positive regulation of glucosylceramidase activity",
  "GO:1905126": "regulation of axo-dendritic protein transport",
  "GO:1905127": "negative regulation of axo-dendritic protein transport",
  "GO:1905128": "positive regulation of axo-dendritic protein transport",
  "GO:1905129": "endocannabinoid signaling pathway involved in trans-synaptic signaling",
  "GO:1905130": "carcinine import across plasma membrane",
  "GO:1905131": "carcinine transmembrane transporter activity",
  "GO:1905132": "regulation of meiotic chromosome separation",
  "GO:1905133": "negative regulation of meiotic chromosome separation",
  "GO:1905134": "positive regulation of meiotic chromosome separation",
  "GO:1905135": "biotin import across plasma membrane",
  "GO:1905136": "dethiobiotin import across plasma membrane",
  "GO:1905137": "regulation of viral DNA genome packaging via site-specific sequence recognition",
  "GO:1905138": "positive regulation of viral DNA genome packaging via site-specific sequence recognition",
  "GO:1905139": "apical ectodermal ridge formation",
  "GO:1905140": "regulation of apical ectodermal ridge formation",
  "GO:1905141": "negative regulation of apical ectodermal ridge formation",
  "GO:1905142": "positive regulation of apical ectodermal ridge formation",
  "GO:1905143": "eukaryotic translation initiation factor 2 complex assembly",
  "GO:1990000": "amyloid fibril formation",
  "GO:1990001": "inhibition of cysteine-type endopeptidase activity involved in apoptotic process",
  "GO:1990002": "methylglyoxal reductase (NADPH-dependent, acetol producing)",
  "GO:1990003": "IDP phosphatase activity",
  "GO:1990004": "XDP phosphatase activity",
  "GO:1990005": "granular vesicle",
  "GO:1990006": "amorphous vesicle",
  "GO:1990007": "membrane stack",
  "GO:1990008": "neurosecretory vesicle",
  "GO:1990009": "retinal cell apoptotic process",
  "GO:1990010": "compound eye retinal cell apoptotic process",
  "GO:1990011": "laminated body",
  "GO:1990012": "complex laminated body",
  "GO:1990013": "presynaptic grid",
  "GO:1990014": "orthogonal array",
  "GO:1990015": "ensheathing process",
  "GO:1990016": "neck portion of tanycyte",
  "GO:1990017": "somatic portion of tanycyte",
  "GO:1990018": "tail portion of tanycyte",
  "GO:1990019": "protein storage vacuole organization",
  "GO:1990020": "recurrent axon collateral",
  "GO:1990021": "Schaffer axon collateral",
  "GO:1990022": "RNA polymerase III complex localization to nucleus",
  "GO:1990023": "mitotic spindle midzone",
  "GO:1990024": "C bouton",
  "GO:1990025": "F bouton",
  "GO:1990026": "hippocampal mossy fiber expansion",
  "GO:1990027": "S bouton",
  "GO:1990028": "intermediate voltage-gated calcium channel activity",
  "GO:1990029": "vasomotion",
  "GO:1990030": "pericellular basket",
  "GO:1990031": "pinceau fiber",
  "GO:1990032": "parallel fiber",
  "GO:1990033": "dendritic branch point",
  "GO:1990034": "calcium ion export from cell",
  "GO:1990035": "calcium ion import into cell",
  "GO:1990036": "calcium ion import into sarcoplasmic reticulum",
  "GO:1990037": "Lewy body core",
  "GO:1990038": "Lewy body corona",
  "GO:1990039": "hypolemmal cisterna",
  "GO:1990040": "sub-surface cisterna",
  "GO:1990042": "glycerol dehydrogenase [NAD(P)+] activity",
  "GO:1990043": "5' deoxyribonuclease (pyrimidine dimer) activity",
  "GO:1990044": "protein localization to lipid particle",
  "GO:1990045": "sclerotium development",
  "GO:1990046": "stress-induced mitochondrial fusion",
  "GO:1990047": "spindle matrix",
  "GO:1990048": "anterograde dense core granule trafficking",
  "GO:1990049": "retrograde dense core granule trafficking",
  "GO:1990050": "phosphatidic acid transporter activity",
  "GO:1990051": "activation of protein kinase C activity",
  "GO:1990052": "ER to chloroplast lipid transport",
  "GO:1990053": "DNA-5-methylcytosine glycosylase activity",
  "GO:1990054": "response to temozolomide",
  "GO:1990055": "phenylacetaldehyde synthase activity",
  "GO:1990056": "obsolete protein kinase activity required for targeting substrate to proteasomal ubiquitin-dependent protein catabolic process",
  "GO:1990057": "obsolete cell cycle arrest in response to DNA damage stimulus",
  "GO:1990058": "fruit replum development",
  "GO:1990059": "fruit valve development",
  "GO:1990060": "maltose transport complex",
  "GO:1990061": "bacterial degradosome",
  "GO:1990062": "RPAP3/R2TP/prefoldin-like complex",
  "GO:1990063": "Bam protein complex",
  "GO:1990064": "ground tissue pattern formation",
  "GO:1990065": "Dxr protein complex",
  "GO:1990066": "energy quenching",
  "GO:1990067": "intrachromosomal DNA recombination",
  "GO:1990068": "seed dehydration",
  "GO:1990069": "stomatal opening",
  "GO:1990070": "TRAPPI protein complex",
  "GO:1990071": "TRAPPII protein complex",
  "GO:1990072": "TRAPPIII protein complex",
  "GO:1990073": "perforation plate",
  "GO:1990074": "polyuridylation-dependent mRNA catabolic process",
  "GO:1990075": "periciliary membrane compartment",
  "GO:1990076": "cell wall polysaccharide catabolic process involved in abscission",
  "GO:1990077": "primosome complex",
  "GO:1990078": "replication inhibiting complex",
  "GO:1990079": "cartilage homeostasis",
  "GO:1990080": "2-phenylethylamine receptor activity",
  "GO:1990081": "trimethylamine receptor activity",
  "GO:1990082": "DnaA-L2 complex",
  "GO:1990083": "DnaA-Hda complex",
  "GO:1990084": "DnaA-Dps complex",
  "GO:1990085": "Hda-beta clamp complex",
  "GO:1990086": "lens fiber cell apoptotic process",
  "GO:1990088": "[methyl-Co(III) methanol-specific corrinoid protein]:coenzyme M methyltransferase activity",
  "GO:1990089": "response to nerve growth factor",
  "GO:1990090": "cellular response to nerve growth factor stimulus",
  "GO:1990091": "sodium-dependent self proteolysis",
  "GO:1990092": "calcium-dependent self proteolysis",
  "GO:1990093": "obsolete negative regulation of N-methyl-D-aspartate receptor clustering",
  "GO:1990094": "obsolete positive regulation of N-methyl-D-aspartate receptor clustering",
  "GO:1990095": "positive regulation of transcription from RNA polymerase II promoter in response to reactive oxygen species",
  "GO:1990096": "positive regulation of transcription from RNA polymerase II promoter in response to superoxide",
  "GO:1990097": "SeqA-DNA complex",
  "GO:1990098": "core primosome complex",
  "GO:1990099": "pre-primosome complex",
  "GO:1990100": "DnaB-DnaC complex",
  "GO:1990101": "DnaA-oriC complex",
  "GO:1990102": "DnaA-DiaA complex",
  "GO:1990103": "DnaA-HU complex",
  "GO:1990104": "DNA bending complex",
  "GO:1990105": "obsolete regulation of voltage-gated potassium channel activity",
  "GO:1990107": "thiazole synthase activity",
  "GO:1990108": "protein linear deubiquitination",
  "GO:1990109": "rejection of pollen from other species",
  "GO:1990110": "callus formation",
  "GO:1990111": "spermatoproteasome complex",
  "GO:1990112": "RQC complex",
  "GO:1990113": "RNA Polymerase I assembly",
  "GO:1990114": "RNA Polymerase II core complex assembly",
  "GO:1990115": "RNA Polymerase III assembly",
  "GO:1990116": "ribosome-associated ubiquitin-dependent protein catabolic process",
  "GO:1990117": "B cell receptor apoptotic signaling pathway",
  "GO:1990118": "sodium ion import into cell",
  "GO:1990119": "ATP-dependent RNA helicase inhibitor activity",
  "GO:1990120": "messenger ribonucleoprotein complex assembly",
  "GO:1990121": "H-NS complex",
  "GO:1990122": "leucine import into cell",
  "GO:1990123": "L-glutamate import into cell",
  "GO:1990124": "messenger ribonucleoprotein complex",
  "GO:1990125": "DiaA complex",
  "GO:1990126": "retrograde transport, endosome to plasma membrane",
  "GO:1990127": "intrinsic apoptotic signaling pathway in response to osmotic stress by p53 class mediator",
  "GO:1990128": "obsolete pre-primosome complex involved in replication initiation",
  "GO:1990129": "obsolete pre-primosome complex involved in replication restart",
  "GO:1990130": "Iml1 complex",
  "GO:1990131": "Gtr1-Gtr2 GTPase complex",
  "GO:1990132": "obsolete release of misfolded protein from chaperone",
  "GO:1990133": "molybdopterin cofactor (Moco) biosynthesis adenylyltransferase complex",
  "GO:1990134": "epithelial cell apoptotic process involved in palatal shelf morphogenesis",
  "GO:1990135": "flavonoid sulfotransferase activity",
  "GO:1990136": "linoleate 9S-lipoxygenase activity",
  "GO:1990137": "plant seed peroxidase activity",
  "GO:1990138": "neuron projection extension",
  "GO:1990139": "protein localization to nuclear periphery",
  "GO:1990140": "MPT synthase complex",
  "GO:1990141": "chromatin silencing at centromere outer repeat region",
  "GO:1990142": "envenomation resulting in hemolysis in other organism",
  "GO:1990143": "CoA-synthesizing protein complex",
  "GO:1990144": "intrinsic apoptotic signaling pathway in response to hypoxia",
  "GO:1990145": "maintenance of translational fidelity",
  "GO:1990146": "protein localization to rhabdomere",
  "GO:1990147": "talin binding",
  "GO:1990148": "glutamate dehydrogenase complex",
  "GO:1990149": "obsolete COPI vesicle coating",
  "GO:1990150": "VEGF-A complex",
  "GO:1990151": "protein localization to cell tip",
  "GO:1990152": "protein localization to telomeric heterochromatin",
  "GO:1990153": "maintenance of protein localization to heterochromatin",
  "GO:1990154": "enzyme IIA-maltose transporter complex",
  "GO:1990155": "Dsc E3 ubiquitin ligase complex assembly",
  "GO:1990156": "DnaB-DnaG complex",
  "GO:1990157": "DnaA-DnaB-DnaC complex",
  "GO:1990158": "DnaB-DnaC-DnaT-PriA-PriB complex",
  "GO:1990159": "DnaB-DnaC-DnaT-PriA-PriC complex",
  "GO:1990160": "DnaB-DnaC-Rep-PriC complex",
  "GO:1990161": "DnaB helicase complex",
  "GO:1990162": "histone deacetylase activity (H3-K4 specific)",
  "GO:1990163": "ATP-dependent four-way junction helicase activity",
  "GO:1990164": "histone H2A phosphorylation",
  "GO:1990165": "single-strand break-containing DNA binding",
  "GO:1990166": "protein localization to site of double-strand break",
  "GO:1990167": "protein K27-linked deubiquitination",
  "GO:1990168": "protein K33-linked deubiquitination",
  "GO:1990169": "stress response to copper ion",
  "GO:1990170": "stress response to cadmium ion",
  "GO:1990171": "SCF complex disassembly in response to cadmium stress",
  "GO:1990172": "G-protein coupled receptor catabolic process",
  "GO:1990173": "protein localization to nucleoplasm",
  "GO:1990174": "phosphodiesterase decapping endonuclease activity",
  "GO:1990175": "EH domain binding",
  "GO:1990176": "MalFGK2 complex",
  "GO:1990177": "IHF-DNA complex",
  "GO:1990178": "HU-DNA complex",
  "GO:1990179": "protein localization to actomyosin contractile ring",
  "GO:1990180": "mitochondrial tRNA 3'-end processing",
  "GO:1990181": "acetyl-CoA biosynthetic process from pantothenate",
  "GO:1990182": "exosomal secretion",
  "GO:1990183": "lymphatic vascular process in circulatory system",
  "GO:1990184": "amino acid transport complex",
  "GO:1990185": "regulation of lymphatic vascular permeability",
  "GO:1990186": "regulation of lymphatic vessel size",
  "GO:1990187": "obsolete protein localization to mRNA",
  "GO:1990188": "euchromatin binding",
  "GO:1990189": "peptide-serine-N-acetyltransferase activity",
  "GO:1990190": "peptide-glutamate-N-acetyltransferase activity",
  "GO:1990191": "cobalamin transport complex",
  "GO:1990192": "collecting lymphatic vessel constriction",
  "GO:1990193": "BtuCD complex",
  "GO:1990194": "cytoplasmic U snRNP body assembly",
  "GO:1990195": "macrolide transmembrane transporter complex",
  "GO:1990196": "MacAB-TolC complex",
  "GO:1990197": "ATP-dependent methionine-importing complex",
  "GO:1990198": "ModE complex",
  "GO:1990199": "MsbA transporter complex",
  "GO:1990200": "SsuD-SsuE complex",
  "GO:1990201": "alkanesulfonate monooxygenase complex",
  "GO:1990202": "FMN reductase complex",
  "GO:1990203": "MdtBC Complex",
  "GO:1990204": "oxidoreductase complex",
  "GO:1990205": "taurine dioxygenase complex",
  "GO:1990206": "jasmonyl-Ile conjugate hydrolase activity",
  "GO:1990207": "EmrE multidrug transporter complex",
  "GO:1990208": "positive regulation by symbiont of RNA levels in host",
  "GO:1990209": "negative regulation by symbiont of RNA levels in host",
  "GO:1990210": "positive regulation by symbiont of indole acetic acid levels in host",
  "GO:1990211": "positive regulation by symbiont of jasmonic acid levels in host",
  "GO:1990212": "positive regulation by symbiont of ethylene levels in host",
  "GO:1990213": "negative regulation by symbiont of salicylic acid levels in host",
  "GO:1990214": "negative regulation by symbiont of host protein levels",
  "GO:1990215": "negative regulation by symbiont of host intracellular transport",
  "GO:1990216": "positive regulation by symbiont of host transcription",
  "GO:1990217": "negative regulation by symbiont of host phytoalexin production",
  "GO:1990218": "positive regulation by symbiont of abscisic acid levels in host",
  "GO:1990219": "positive regulation by symbiont of host protein levels",
  "GO:1990220": "GroEL-GroES complex",
  "GO:1990221": "L-cysteine desulfurase complex",
  "GO:1990222": "ProVWX complex",
  "GO:1990223": "positive regulation by symbiont of cytokinin levels in host",
  "GO:1990224": "NMN phosphatase activity",
  "GO:1990225": "rhoptry neck",
  "GO:1990226": "histone methyltransferase binding",
  "GO:1990227": "paranodal junction maintenance",
  "GO:1990228": "sulfurtransferase complex",
  "GO:1990229": "iron-sulfur cluster assembly complex",
  "GO:1990230": "iron-sulfur cluster transfer complex",
  "GO:1990231": "STING complex",
  "GO:1990232": "phosphomannomutase complex",
  "GO:1990233": "intramolecular phosphotransferase complex",
  "GO:1990234": "transferase complex",
  "GO:1990235": "diamine N-acetyltransferase complex",
  "GO:1990236": "proteasome core complex import into nucleus",
  "GO:1990237": "sequestration of proteasome core complex in proteasome storage granule",
  "GO:1990238": "double-stranded DNA endodeoxyribonuclease activity",
  "GO:1990239": "steroid hormone binding",
  "GO:1990240": "methionine-importing activity",
  "GO:1990241": "obsolete nucleotide binding complex",
  "GO:1990242": "obsolete innate immune response complex",
  "GO:1990243": "atf1-pcr1 complex",
  "GO:1990244": "histone kinase activity (H2A-T120 specific)",
  "GO:1990245": "histone H2A-T120 phosphorylation",
  "GO:1990246": "uniplex complex",
  "GO:1990247": "N6-methyladenosine-containing RNA binding",
  "GO:1990248": "regulation of transcription from RNA polymerase II promoter in response to DNA damage",
  "GO:1990249": "nucleotide-excision repair, DNA damage recognition complex",
  "GO:1990250": "transcription-coupled nucleotide-excision repair, DNA damage recognition complex",
  "GO:1990251": "Mmi1 nuclear focus complex",
  "GO:1990252": "Syp1 complex",
  "GO:1990253": "cellular response to leucine starvation",
  "GO:1990254": "keratin filament binding",
  "GO:1990255": "subsynaptic reticulum organization",
  "GO:1990256": "signal clustering",
  "GO:1990257": "piccolo-bassoon transport vesicle",
  "GO:1990258": "histone glutamine methylation",
  "GO:1990259": "histone-glutamine methyltransferase activity",
  "GO:1990260": "negative regulation of transcription from RNA polymerase II promoter by transcription factor localization involved in response to DNA damage checkpoint signaling",
  "GO:1990261": "pre-mRNA catabolic process",
  "GO:1990262": "anti-Mullerian hormone signaling pathway",
  "GO:1990263": "MAPK cascade in response to starvation",
  "GO:1990264": "peptidyl-tyrosine dephosphorylation involved in inactivation of protein kinase activity",
  "GO:1990265": "platelet-derived growth factor complex",
  "GO:1990266": "neutrophil migration",
  "GO:1990267": "response to transition metal nanoparticle",
  "GO:1990268": "response to gold nanoparticle",
  "GO:1990269": "RNA polymerase II C-terminal domain phosphoserine binding",
  "GO:1990270": "platelet-derived growth factor receptor-ligand complex",
  "GO:1990271": "obsolete anti-Mullerian hormone",
  "GO:1990272": "anti-Mullerian hormone receptor activity",
  "GO:1990273": "snRNA 5'-end processing",
  "GO:1990274": "mitotic actomyosin contractile ring disassembly",
  "GO:1990275": "preribosome binding",
  "GO:1990276": "RNA 5'-methyltransferase activity",
  "GO:1990277": "parasexual conjugation with cellular fusion",
  "GO:1990278": "obsolete positive regulation of MBF transcription factor activity",
  "GO:1990279": "obsolete negative regulation of MBF transcription factor activity",
  "GO:1990280": "RNA localization to chromatin",
  "GO:1990281": "efflux pump complex",
  "GO:1990294": "peptidyl-threonine trans-autophosphorylation",
  "GO:1990295": "post-anaphase microtubule array",
  "GO:1990296": "scaffoldin complex",
  "GO:1990297": "renal amino acid absorption",
  "GO:1990298": "bub1-bub3 complex",
  "GO:1990299": "Bub1-Bub3 complex localization to kinetochore",
  "GO:1990300": "cellulosome binding",
  "GO:1990301": "scaffoldin complex binding",
  "GO:1990302": "Bre1-Rad6 ubiquitin ligase complex",
  "GO:1990303": "UBR1-RAD6 ubiquitin ligase complex",
  "GO:1990304": "MUB1-RAD6-UBR2 ubiquitin ligase complex",
  "GO:1990305": "RAD6-UBR2 ubiquitin ligase complex",
  "GO:1990306": "RSP5-BUL ubiquitin ligase complex",
  "GO:1990308": "Type-I dockerin domain binding",
  "GO:1990309": "Type-II dockerin domain binding",
  "GO:1990310": "Type-III dockerin domain binding",
  "GO:1990311": "Type-I cohesin domain binding",
  "GO:1990312": "Type-II cohesin domain binding",
  "GO:1990313": "Type-III cohesin domain binding",
  "GO:1990314": "cellular response to insulin-like growth factor stimulus",
  "GO:1990315": "Mcs4 RR-MAPKKK complex",
  "GO:1990316": "ATG1/ULK1 kinase complex",
  "GO:1990317": "Gin4 complex",
  "GO:1990318": "collagen type XIX trimer",
  "GO:1990319": "collagen type XX trimer",
  "GO:1990320": "collagen type XXI trimer",
  "GO:1990321": "collagen type XXII trimer",
  "GO:1990322": "collagen type XXIII trimer",
  "GO:1990323": "collagen type XXIV trimer",
  "GO:1990324": "collagen type XXVI trimer",
  "GO:1990325": "collagen type XXVII trimer",
  "GO:1990326": "collagen type XXVIII trimer",
  "GO:1990327": "collagen type XXV trimer",
  "GO:1990328": "RNA polymerase II, RPB4-RPB7 subcomplex",
  "GO:1990329": "IscS-TusA complex",
  "GO:1990330": "IscS-IscU complex",
  "GO:1990331": "Hpa2 acetyltransferase complex",
  "GO:1990332": "Ire1 complex",
  "GO:1990333": "mitotic checkpoint complex, CDC20-MAD2 subcomplex",
  "GO:1990334": "Bfa1-Bub2 complex",
  "GO:1990335": "process resulting in tolerance to alcohol",
  "GO:1990336": "process resulting in tolerance to butan-1-ol",
  "GO:1990337": "process resulting in tolerance to isobutanol",
  "GO:1990338": "laminin-13 complex",
  "GO:1990339": "laminin-14 complex",
  "GO:1990340": "laminin-15 complex",
  "GO:1990341": "thrombospondin complex",
  "GO:1990342": "heterochromatin island",
  "GO:1990343": "heterochromatin domain",
  "GO:1990344": "secondary cell septum biogenesis",
  "GO:1990345": "MTREC complex",
  "GO:1990346": "BID-BCL-xl complex",
  "GO:1990347": "obsolete G*/A mismatch-specific adenine-DNA glycosylase activity",
  "GO:1990348": "obsolete G/A mismatch specific adenine DNA glycosylase activity",
  "GO:1990349": "gap junction-mediated intercellular transport",
  "GO:1990350": "glucose transporter complex",
  "GO:1990351": "transporter complex",
  "GO:1990352": "BRE1 E3 ubiquitin ligase complex",
  "GO:1990353": "Fused-Smurf ubiquitin ligase complex",
  "GO:1990354": "activated SUMO-E1 ligase complex",
  "GO:1990355": "L-methionine biosynthetic process from methionine sulphoxide",
  "GO:1990356": "sumoylated E2 ligase complex",
  "GO:1990357": "terminal web",
  "GO:1990358": "xylanosome",
  "GO:1990359": "stress response to zinc ion",
  "GO:1990360": "PKM2 protein kinase complex",
  "GO:1990361": "PKM2 pyruvate kinase complex",
  "GO:1990362": "butanol dehydrogenase activity",
  "GO:1990363": "obsolete response to hydrolysate",
  "GO:1990364": "obsolete response to aldehyde",
  "GO:1990365": "obsolete response to phenol",
  "GO:1990366": "obsolete response to organic acid",
  "GO:1990367": "process resulting in tolerance to organic substance",
  "GO:1990368": "obsolete process resulting in tolerance to hydrolysate",
  "GO:1990369": "process resulting in tolerance to ketone",
  "GO:1990370": "process resulting in tolerance to aldehyde",
  "GO:1990371": "process resulting in tolerance to phenol",
  "GO:1990372": "process resulting in tolerance to organic acid",
  "GO:1990373": "process resulting in tolerance to alkane",
  "GO:1990374": "Kir2 inward rectifier potassium channel complex",
  "GO:1990375": "baculum development",
  "GO:1990376": "negative regulation of G1/S transition of mitotic cell cycle by positive regulation of transcription from RNA polymerase II promoter in response to nitrogen starvation",
  "GO:1990377": "organomineral extracellular matrix",
  "GO:1990378": "upstream stimulatory factor complex",
  "GO:1990379": "lipid transport across blood brain barrier",
  "GO:1990380": "Lys48-specific deubiquitinase activity",
  "GO:1990381": "ubiquitin-specific protease binding",
  "GO:1990382": "obsolete melanosome assembly",
  "GO:1990383": "cellular response to biotin starvation",
  "GO:1990384": "hyaloid vascular plexus regression",
  "GO:1990385": "meiotic spindle midzone",
  "GO:1990386": "mitotic cleavage furrow ingression",
  "GO:1990387": "isogloboside biosynthetic process",
  "GO:1990388": "xylem-to-phloem iron transport",
  "GO:1990389": "CUE1-UBC7 ubiquitin-conjugating enzyme complex",
  "GO:1990390": "protein K33-linked ubiquitination",
  "GO:1990391": "DNA repair complex",
  "GO:1990392": "EFF-1 complex",
  "GO:1990393": "3M complex",
  "GO:1990394": "cellular response to cell wall damage",
  "GO:1990395": "meiotic spindle pole body organization",
  "GO:1990396": "single-strand break repair via homologous recombination",
  "GO:1990397": "queuosine salvage",
  "GO:1990398": "Cus cation efflux complex",
  "GO:1990399": "epithelium regeneration",
  "GO:1990400": "mitochondrial ribosomal large subunit rRNA binding",
  "GO:1990401": "embryonic lung development",
  "GO:1990402": "embryonic liver development",
  "GO:1990403": "embryonic brain development",
  "GO:1990404": "protein ADP-ribosylase activity",
  "GO:1990405": "protein antigen binding",
  "GO:1990406": "CGRP receptor complex",
  "GO:1990407": "calcitonin gene-related peptide binding",
  "GO:1990408": "calcitonin gene-related peptide receptor signaling pathway",
  "GO:1990409": "adrenomedullin binding",
  "GO:1990410": "adrenomedullin receptor signaling pathway",
  "GO:1990411": "hercynylcysteine sulfoxide lyase activity (ergothioneine-forming)",
  "GO:1990412": "hercynylselenocysteine lyase activity (selenoneine-forming)",
  "GO:1990413": "eyespot apparatus",
  "GO:1990414": "replication-born double-strand break repair via sister chromatid exchange",
  "GO:1990415": "Pex17p-Pex14p docking complex",
  "GO:1990416": "cellular response to brain-derived neurotrophic factor stimulus",
  "GO:1990417": "snoRNA release from pre-rRNA",
  "GO:1990418": "response to insulin-like growth factor stimulus",
  "GO:1990419": "obsolete response to elemental metal",
  "GO:1990420": "establishment of septation initiation network asymmetry",
  "GO:1990421": "subtelomeric heterochromatin",
  "GO:1990422": "glyoxalase (glycolic acid-forming) activity",
  "GO:1990423": "RZZ complex",
  "GO:1990424": "protein arginine kinase activity",
  "GO:1990425": "ryanodine receptor complex",
  "GO:1990426": "homologous recombination-dependent replication fork processing",
  "GO:1990427": "stereocilia tip-link density",
  "GO:1990428": "miRNA transport",
  "GO:1990429": "peroxisomal importomer complex",
  "GO:1990430": "extracellular matrix protein binding",
  "GO:1990431": "priRNA 3'-end processing",
  "GO:1990432": "siRNA 3'-end processing",
  "GO:1990433": "CSL-Notch-Mastermind transcription factor complex",
  "GO:1990434": "lower tip-link density",
  "GO:1990435": "upper tip-link density",
  "GO:1990436": "obsolete MAPK cascade involved in oxidative stress signaling pathway",
  "GO:1990437": "snRNA 2'-O-methylation",
  "GO:1990438": "U6 2'-O-snRNA methylation",
  "GO:1990439": "MAP kinase threonine phosphatase activity",
  "GO:1990440": "positive regulation of transcription from RNA polymerase II promoter in response to endoplasmic reticulum stress",
  "GO:1990441": "negative regulation of transcription from RNA polymerase II promoter in response to endoplasmic reticulum stress",
  "GO:1990442": "intrinsic apoptotic signaling pathway in response to nitrosative stress",
  "GO:1990443": "peptidyl-threonine autophosphorylation",
  "GO:1990444": "F-box domain binding",
  "GO:1990445": "obsolete Multiciliate cell differentiation",
  "GO:1990446": "U1 snRNP binding",
  "GO:1990447": "U2 snRNP binding",
  "GO:1990448": "exon-exon junction complex binding",
  "GO:1990449": "obsolete amylin receptor",
  "GO:1990450": "linear polyubiquitin binding",
  "GO:1990451": "cellular stress response to acidic pH",
  "GO:1990452": "Parkin-FBXW7-Cul1 ubiquitin ligase complex",
  "GO:1990453": "nucleosome disassembly/reassembly complex",
  "GO:1990454": "L-type voltage-gated calcium channel complex",
  "GO:1990455": "PTEN phosphatase complex",
  "GO:1990456": "mitochondrion-ER tethering",
  "GO:1990457": "pexophagosome",
  "GO:1990458": "lipooligosaccharide binding",
  "GO:1990459": "transferrin receptor binding",
  "GO:1990460": "leptin receptor binding",
  "GO:1990461": "detoxification of iron ion",
  "GO:1990462": "omegasome",
  "GO:1990463": "lateral cortical node",
  "GO:1990464": "D-2-hydroxyacid dehydrogenase (quinone) activity",
  "GO:1990465": "aldehyde oxygenase (deformylating) activity",
  "GO:1990466": "protein autosumoylation",
  "GO:1990467": "NuA3a histone acetyltransferase complex",
  "GO:1990468": "NuA3b histone acetyltransferase complex",
  "GO:1990469": "Rhino-Deadlock-Cutoff Complex",
  "GO:1990470": "piRNA cluster binding",
  "GO:1990471": "piRNA uni-strand cluster binding",
  "GO:1990472": "piRNA dual-strand cluster binding",
  "GO:1990473": "ciliary targeting signal binding",
  "GO:1990474": "synaptic vesicle, readily releasable pool",
  "GO:1990475": "synaptic vesicle, recycling pool",
  "GO:1990476": "synaptic vesicle, resting pool",
  "GO:1990477": "NURS complex",
  "GO:1990478": "response to ultrasound",
  "GO:1990479": "obsolete response to lipoic acid",
  "GO:1990480": "obsolete geranyl diphosphate synthase",
  "GO:1990481": "mRNA pseudouridine synthesis",
  "GO:1990482": "sphingolipid alpha-glucuronosyltransferase activity",
  "GO:1990483": "Clr6 histone deacetylase complex I''",
  "GO:1990484": "aerobic lactate catabolic process",
  "GO:1990485": "anaerobic lactate catabolic process",
  "GO:1990486": "anaerobic fatty acid catabolic process",
  "GO:1990487": "anaerobic lignin catabolic process",
  "GO:1990488": "anaerobic cellulose catabolic process",
  "GO:1990489": "anaerobic pectin catabolic process",
  "GO:1990490": "archaeal proton-transporting A-type ATPase complex",
  "GO:1990491": "methane biosynthetic process from methanol and hydrogen",
  "GO:1990492": "mitotic cell cycle checkpoint inhibiting CAR assembly",
  "GO:1990493": "obsolete cyclin H-CDK7 complex",
  "GO:1990494": "obsolete regulation of mitotic cytokinesis, actomyosin contractile ring assembly",
  "GO:1990495": "obsolete actin filament organization involved in mitotic cytokinetic actomyosin contractile ring assembly",
  "GO:1990496": "obsolete regulation of actin filament organization involved in mitotic cytokinetic actomyosin contractile ring assembly",
  "GO:1990497": "regulation of cytoplasmic translation in response to stress",
  "GO:1990498": "mitotic spindle microtubule",
  "GO:1990499": "raps-insc complex",
  "GO:1990500": "eif4e-cup complex",
  "GO:1990501": "exon-exon junction subcomplex mago-y14",
  "GO:1990502": "dense core granule maturation",
  "GO:1990503": "dendritic lamellar body",
  "GO:1990504": "dense core granule exocytosis",
  "GO:1990505": "mitotic DNA replication maintenance of fidelity",
  "GO:1990506": "mitotic DNA-dependent DNA replication",
  "GO:1990507": "ATP-independent chaperone mediated protein folding",
  "GO:1990508": "CKM complex",
  "GO:1990509": "PYM-mago-Y14 complex",
  "GO:1990511": "piRNA biosynthetic process",
  "GO:1990512": "Cry-Per complex",
  "GO:1990513": "CLOCK-BMAL transcription complex",
  "GO:1990514": "5' transitive RNA interference",
  "GO:1990515": "3' transitive RNA interference",
  "GO:1990516": "ribonucleotide excision repair",
  "GO:1990517": "obsolete protein localization to photoreceptor outer segment",
  "GO:1990518": "single-stranded DNA-dependent ATP-dependent 3'-5' DNA helicase activity",
  "GO:1990519": "mitochondrial pyrimidine nucleotide import",
  "GO:1990520": "separase-securin complex",
  "GO:1990521": "m7G(5')pppN diphosphatase activator activity",
  "GO:1990522": "tail spike morphogenesis",
  "GO:1990523": "bone regeneration",
  "GO:1990524": "INA complex",
  "GO:1990525": "BIR domain binding",
  "GO:1990526": "Ste12p-Dig1p-Dig2p complex",
  "GO:1990527": "Tec1p-Ste12p-Dig1p complex",
  "GO:1990528": "Rvs161p-Rvs167p complex",
  "GO:1990529": "glycosylphosphatidylinositol-mannosyltransferase I complex",
  "GO:1990530": "Cdc50p-Drs2p complex",
  "GO:1990531": "Lem3p-Dnf1p complex",
  "GO:1990532": "stress response to nickel ion",
  "GO:1990533": "Dom34-Hbs1 complex",
  "GO:1990534": "thermospermine oxidase activity",
  "GO:1990535": "neuron projection maintenance",
  "GO:1990536": "phosphoenolpyruvate transmembrane import into Golgi lumen",
  "GO:1990537": "mitotic spindle polar microtubule",
  "GO:1990538": "xylan O-acetyltransferase activity",
  "GO:1990539": "fructose import across plasma membrane",
  "GO:1990540": "mitochondrial manganese ion transmembrane transport",
  "GO:1990541": "mitochondrial citrate transmembrane transport",
  "GO:1990542": "mitochondrial transmembrane transport",
  "GO:1990543": "mitochondrial S-adenosyl-L-methionine transmembrane transport",
  "GO:1990544": "mitochondrial ATP transmembrane transport",
  "GO:1990545": "mitochondrial thiamine pyrophosphate transmembrane transport",
  "GO:1990546": "mitochondrial tricarboxylic acid transmembrane transport",
  "GO:1990547": "mitochondrial phosphate ion transmembrane transport",
  "GO:1990548": "mitochondrial FAD transmembrane transport",
  "GO:1990549": "mitochondrial NAD transmembrane transport",
  "GO:1990550": "mitochondrial alpha-ketoglutarate transmembrane transport",
  "GO:1990551": "mitochondrial 2-oxoadipate transmembrane transport",
  "GO:1990553": "mitochondrial 5'-adenylyl sulfate transmembrane transport",
  "GO:1990554": "mitochondrial 3'-phospho-5'-adenylyl sulfate transmembrane transport",
  "GO:1990555": "mitochondrial oxaloacetate transmembrane transport",
  "GO:1990556": "mitochondrial isopropylmalate transmembrane transport",
  "GO:1990557": "mitochondrial sulfate transmembrane transport",
  "GO:1990558": "mitochondrial malonate(1-) transmembrane transport",
  "GO:1990559": "mitochondrial coenzyme A transmembrane transport",
  "GO:1990560": "obsolete DNA methyltransferase binding",
  "GO:1990561": "regulation of transcription from RNA polymerase II promoter in response to copper ion starvation",
  "GO:1990562": "syndecan-syntenin-ALIX complex",
  "GO:1990563": "extracellular exosome complex",
  "GO:1990564": "protein polyufmylation",
  "GO:1990565": "HSP90-CDC37 chaperone complex",
  "GO:1990566": "I(KACh) inward rectifier potassium channel complex",
  "GO:1990567": "DPS complex",
  "GO:1990568": "obsolete MIS18 complex",
  "GO:1990569": "UDP-N-acetylglucosamine transmembrane transport",
  "GO:1990570": "GDP-mannose transmembrane transport",
  "GO:1990571": "meiotic centromere clustering",
  "GO:1990572": "TERT-RMRP complex",
  "GO:1990573": "potassium ion import across plasma membrane",
  "GO:1990574": "meiotic spindle astral microtubule",
  "GO:1990575": "mitochondrial L-ornithine transmembrane transport",
  "GO:1990576": "G-protein coupled glucose receptor activity",
  "GO:1990577": "C-terminal protein demethylation",
  "GO:1990578": "perinuclear endoplasmic reticulum membrane",
  "GO:1990579": "peptidyl-serine trans-autophosphorylation",
  "GO:1990580": "regulation of cytoplasmic translational termination",
  "GO:1990581": "obsolete lysosome lysis",
  "GO:1990582": "obsolete intracellular membrane-bounded organelle binding",
  "GO:1990583": "phospholipase D activator activity",
  "GO:1990584": "cardiac Troponin complex",
  "GO:1990585": "hydroxyproline O-arabinosyltransferase activity",
  "GO:1990586": "divisome complex",
  "GO:1990587": "FtsQBL complex",
  "GO:1990588": "FtsBL complex",
  "GO:1990589": "ATF4-CREB1 transcription factor complex",
  "GO:1990590": "ATF1-ATF4 transcription factor complex",
  "GO:1990591": "asparagine transmembrane import into vacuole",
  "GO:1990592": "protein K69-linked ufmylation",
  "GO:1990593": "nascent polypeptide-associated complex binding",
  "GO:1990594": "L-altrarate dehydratase activity",
  "GO:1990595": "mast cell secretagogue receptor activity",
  "GO:1990596": "histone H3-K4 deacetylation",
  "GO:1990597": "AIP1-IRE1 complex",
  "GO:1990598": "repair of mitotic mono-orientation defects",
  "GO:1990599": "3' overhang single-stranded DNA endodeoxyribonuclease activity",
  "GO:1990600": "single-stranded DNA endodeoxyribonuclease activator activity",
  "GO:1990601": "5' overhang single-stranded DNA endodeoxyribonuclease activity",
  "GO:1990602": "importin alpha-subunit nuclear import complex",
  "GO:1990603": "dark adaptation",
  "GO:1990604": "IRE1-TRAF2-ASK1 complex",
  "GO:1990605": "GU repeat RNA binding",
  "GO:1990606": "membrane scission GTPase motor activity",
  "GO:1990607": "obsolete detection of stimulus involved in cytokinesis after mitosis checkpoint",
  "GO:1990608": "mitotic spindle pole body localization to nuclear envelope",
  "GO:1990609": "glutamate-cysteine ligase regulator activity",
  "GO:1990610": "acetolactate synthase regulator activity",
  "GO:1990611": "regulation of cytoplasmic translational initiation in response to stress",
  "GO:1990612": "Sad1-Kms2 LINC complex",
  "GO:1990613": "mitochondrial membrane fusion",
  "GO:1990614": "mitochondrial magnesium ion transmembrane transport",
  "GO:1990615": "Kelch-containing formin regulatory complex",
  "GO:1990616": "magnesium ion export from mitochondrion",
  "GO:1990617": "CHOP-ATF4 complex",
  "GO:1990618": "obsolete ANPR-A:ANP complex",
  "GO:1990619": "histone H3-K9 deacetylation",
  "GO:1990620": "ANPR-A receptor complex",
  "GO:1990621": "Vps4-Vta1 complex",
  "GO:1990622": "CHOP-ATF3 complex",
  "GO:1990623": "Herring body",
  "GO:1990624": "guanyl nucleotide exchange factor inhibitor activity",
  "GO:1990625": "negative regulation of cytoplasmic translational initiation in response to stress",
  "GO:1990626": "mitochondrial outer membrane fusion",
  "GO:1990627": "mitochondrial inner membrane fusion",
  "GO:1990628": "obsolete Sigma-E factor negative regulation complex",
  "GO:1990629": "phospholamban complex",
  "GO:1990630": "IRE1-RACK1-PP2A complex",
  "GO:1990631": "ErbB-4 class receptor binding",
  "GO:1990632": "branching involved in submandibular gland morphogenesis",
  "GO:1990633": "mutator focus",
  "GO:1990634": "protein phosphatase 5 binding",
  "GO:1990635": "proximal dendrite",
  "GO:1990636": "reproductive senescence",
  "GO:1990637": "response to prolactin",
  "GO:1990638": "response to granulocyte colony-stimulating factor",
  "GO:1990639": "obsolete inositol-3,4,5-trisphosphate 5-phosphatase activity",
  "GO:1990640": "inositol-2,4,5-triphosphate 5-phosphatase activity",
  "GO:1990641": "response to iron ion starvation",
  "GO:1990642": "obsolete response to castration",
  "GO:1990643": "cellular response to granulocyte colony-stimulating factor",
  "GO:1990644": "microtubule site clamp",
  "GO:1990645": "obsolete phosphorylase dephosphorylation",
  "GO:1990646": "cellular response to prolactin",
  "GO:1990647": "C/EBP complex",
  "GO:1990648": "inositol-4,5,6-triphosphate 5-phosphatase activity",
  "GO:1990649": "inositol-1,2,4,5-tetrakisphosphate 5-phosphatase activity",
  "GO:1990650": "inositol-2,4,5,6-tetrakisphosphate 5-phosphatase activity",
  "GO:1990651": "inositol-1,2,4,5,6-pentakisphosphate 5-phosphatase activity",
  "GO:1990652": "obsolete positive regulation of pyrimidine-containing compound salvage by positive regulation of transcription from RNA polymerase II promoter",
  "GO:1990653": "obsolete monounsaturated fatty acid biosynthetic process",
  "GO:1990654": "sebum secreting cell proliferation",
  "GO:1990655": "4 iron, 3 sulfur cluster binding",
  "GO:1990656": "t-SNARE clustering",
  "GO:1990657": "iNOS-S100A8/A9 complex",
  "GO:1990658": "transnitrosylase complex",
  "GO:1990659": "sequestering of manganese ion",
  "GO:1990660": "calprotectin complex",
  "GO:1990661": "S100A8 complex",
  "GO:1990662": "S100A9 complex",
  "GO:1990663": "dihydroorotate dehydrogenase (fumarate) activity",
  "GO:1990664": "Nkx-2.5 complex",
  "GO:1990665": "AnxA2-p11 complex",
  "GO:1990666": "PCSK9-LDLR complex",
  "GO:1990667": "PCSK9-AnxA2 complex",
  "GO:1990668": "vesicle fusion with endoplasmic reticulum-Golgi intermediate compartment (ERGIC) membrane",
  "GO:1990669": "endoplasmic reticulum-Golgi intermediate compartment (ERGIC) derived vesicle fusion with endoplasmic reticulum membrane",
  "GO:1990670": "vesicle fusion with Golgi cis cisterna membrane",
  "GO:1990671": "vesicle fusion with Golgi medial cisterna membrane",
  "GO:1990672": "medial-Golgi-derived vesicle fusion with Golgi trans cisterna membrane",
  "GO:1990673": "intrinsic component of endoplasmic reticulum-Golgi intermediate compartment (ERGIC) membrane",
  "GO:1990674": "Golgi cis cisterna membrane",
  "GO:1990675": "Golgi medial cisterna membrane",
  "GO:1990676": "Golgi trans cisterna membrane",
  "GO:1990677": "mitochondrial inner membrane assembly complex",
  "GO:1990678": "histone H4-K16 deacetylation",
  "GO:1990679": "histone H4-K12 deacetylation",
  "GO:1990680": "response to melanocyte-stimulating hormone",
  "GO:1990681": "protein phosphatase type 2A inhibitor activity",
  "GO:1990682": "CSF1-CSF1R complex",
  "GO:1990683": "DNA double-strand break attachment to nuclear envelope",
  "GO:1990684": "protein-lipid-RNA complex",
  "GO:1990685": "HDL-containing protein-lipid-RNA complex",
  "GO:1990686": "LDL-containing protein-lipid-RNA complex",
  "GO:1990687": "endoplasmic reticulum-derived vesicle fusion with endoplasmic reticulum-Golgi intermediate compartment (ERGIC) membrane",
  "GO:1990688": "Golgi vesicle fusion with endoplasmic reticulum-Golgi intermediate compartment (ERGIC) membrane",
  "GO:1990689": "endoplasmic reticulum-Golgi intermediate compartment (ERGIC) derived vesicle fusion with Golgi cis cisterna membrane",
  "GO:1990690": "Golgi medial cisterna-derived vesicle fusion with Golgi cis cisterna membrane",
  "GO:1990691": "cis-Golgi-derived vesicle fusion with Golgi medial cisterna membrane",
  "GO:1990692": "trans-Golgi-derived vesicle fusion with Golgi medial cisterna membrane",
  "GO:1990693": "intrinsic component of Golgi cis cisterna membrane",
  "GO:1990694": "intrinsic component of Golgi medial cisterna membrane",
  "GO:1990695": "intrinsic component of Golgi trans cisterna membrane",
  "GO:1990696": "USH2 complex",
  "GO:1990697": "protein depalmitoleylation",
  "GO:1990698": "palmitoleoyltransferase activity",
  "GO:1990699": "palmitoleyl hydrolase activity",
  "GO:1990700": "nucleolar chromatin organization",
  "GO:1990701": "integral component of endoplasmic reticulum-Golgi intermediate compartment (ERGIC) membrane",
  "GO:1990702": "integral component of Golgi cis cisterna membrane",
  "GO:1990703": "integral component of Golgi medial cisterna membrane",
  "GO:1990704": "integral component of Golgi trans cisterna membrane",
  "GO:1990705": "cholangiocyte proliferation",
  "GO:1990706": "MAD1 complex",
  "GO:1990707": "nuclear subtelomeric heterochromatin",
  "GO:1990708": "conditioned place preference",
  "GO:1990709": "presynaptic active zone organization",
  "GO:1990710": "MutS complex",
  "GO:1990711": "Beta-catenin-ICAT complex",
  "GO:1990712": "HFE-transferrin receptor complex",
  "GO:1990713": "survivin complex",
  "GO:1990714": "hydroxyproline O-galactosyltransferase activity",
  "GO:1990715": "mRNA CDS binding",
  "GO:1990716": "axonemal central apparatus",
  "GO:1990717": "axonemal central bridge",
  "GO:1990718": "axonemal central pair projection",
  "GO:1990719": "C1 axonemal microtubule",
  "GO:1990720": "C2 axonemal microtubule",
  "GO:1990721": "obsolete prostatic acid phosphatase complex",
  "GO:1990722": "DAPK1-calmodulin complex",
  "GO:1990723": "cytoplasmic periphery of the nuclear pore complex",
  "GO:1990724": "galectin complex",
  "GO:1990725": "cord factor receptor activity",
  "GO:1990726": "Lsm1-7-Pat1 complex",
  "GO:1990727": "tubulin folding cofactor complex",
  "GO:1990728": "mitotic spindle assembly checkpoint MAD1-MAD2 complex",
  "GO:1990729": "primary miRNA modification",
  "GO:1990730": "VCP-NSFL1C complex",
  "GO:1990731": "UV-damage excision repair, DNA incision",
  "GO:1990732": "pyrenoid",
  "GO:1990733": "titin-telethonin complex",
  "GO:1990734": "astral microtubule anchoring at mitotic spindle pole body",
  "GO:1990735": "gamma-tubulin complex localization to mitotic spindle pole body",
  "GO:1990736": "regulation of vascular smooth muscle cell membrane depolarization",
  "GO:1990737": "response to manganese-induced endoplasmic reticulum stress",
  "GO:1990738": "pseudouridine 5'-phosphatase activity",
  "GO:1990739": "granulosa cell proliferation",
  "GO:1990740": "obsolete non-selective anion channel activity",
  "GO:1990741": "obsolete non-selective cation channel activity",
  "GO:1990742": "microvesicle",
  "GO:1990743": "protein sialylation",
  "GO:1990744": "primary miRNA methylation",
  "GO:1990745": "EARP complex",
  "GO:1990746": "HCN4 channel complex",
  "GO:1990747": "pancreatic trypsinogen secretion",
  "GO:1990748": "cellular detoxification",
  "GO:1990749": "polynucleotide adenylyltransferase activator activity",
  "GO:1990750": "obsolete axon shaft",
  "GO:1990751": "Schwann cell chemotaxis",
  "GO:1990752": "microtubule end",
  "GO:1990753": "equatorial cell cortex",
  "GO:1990754": "obsolete GABAergic neuronal action potential",
  "GO:1990755": "mitotic spindle microtubule depolymerization",
  "GO:1990756": "protein binding, bridging involved in substrate recognition for ubiquitination",
  "GO:1990757": "ubiquitin ligase activator activity",
  "GO:1990758": "mitotic sister chromatid biorientation",
  "GO:1990759": "HCN2 channel complex",
  "GO:1990760": "osmolarity-sensing cation channel activity",
  "GO:1990761": "growth cone lamellipodium",
  "GO:1990762": "cytoplasmic alanyl-tRNA aminoacylation",
  "GO:1990763": "arrestin family protein binding",
  "GO:1990764": "myofibroblast contraction",
  "GO:1990765": "colon smooth muscle contraction",
  "GO:1990767": "prostaglandin receptor internalization",
  "GO:1990768": "gastric mucosal blood circulation",
  "GO:1990769": "proximal neuron projection",
  "GO:1990770": "small intestine smooth muscle contraction",
  "GO:1990771": "clathrin-mediated extracellular exosome endocytosis",
  "GO:1990772": "substance P secretion",
  "GO:1990773": "matrix metallopeptidase secretion",
  "GO:1990774": "tumor necrosis factor secretion",
  "GO:1990775": "endothelin secretion",
  "GO:1990776": "response to angiotensin",
  "GO:1990777": "lipoprotein particle",
  "GO:1990778": "protein localization to cell periphery",
  "GO:1990779": "glycoprotein Ib-IX-V complex",
  "GO:1990780": "cytoplasmic side of dendritic spine plasma membrane",
  "GO:1990781": "response to immobilization stress combined with electrical stimulus",
  "GO:1990782": "protein tyrosine kinase binding",
  "GO:1990783": "periphagosomal region of cytoplasm",
  "GO:1990784": "response to dsDNA",
  "GO:1990785": "response to water-immersion restraint stress",
  "GO:1990786": "cellular response to dsDNA",
  "GO:1990787": "negative regulation of hh target transcription factor activity",
  "GO:1990788": "GLI-SUFU complex",
  "GO:1990789": "thyroid gland epithelial cell proliferation",
  "GO:1990790": "response to glial cell derived neurotrophic factor",
  "GO:1990791": "dorsal root ganglion development",
  "GO:1990792": "cellular response to glial cell derived neurotrophic factor",
  "GO:1990793": "substance P secretion, neurotransmission",
  "GO:1990794": "basolateral part of cell",
  "GO:1990795": "rod bipolar cell terminal bouton",
  "GO:1990796": "photoreceptor cell terminal bouton",
  "GO:1990797": "obsolete cholecystokinin secretion",
  "GO:1990798": "pancreas regeneration",
  "GO:1990799": "mitochondrial tRNA wobble position uridine thiolation",
  "GO:1990801": "protein phosphorylation involved in mitotic spindle assembly",
  "GO:1990802": "protein phosphorylation involved in DNA double-strand break processing",
  "GO:1990803": "protein phosphorylation involved in protein localization to spindle microtubule",
  "GO:1990804": "protein phosphorylation involved in double-strand break repair via nonhomologous end joining",
  "GO:1990805": "central cylinder",
  "GO:1990806": "obsolete ligand-gated ion channel signaling pathway",
  "GO:1990807": "obsolete protein N-acetyltransferase activity",
  "GO:1990808": "F-bar domain binding",
  "GO:1990809": "endoplasmic reticulum tubular network membrane organization",
  "GO:1990810": "microtubule anchoring at mitotic spindle pole body",
  "GO:1990811": "Msd1-Wdr8-Pkl1 complex",
  "GO:1990812": "growth cone filopodium",
  "GO:1990813": "meiotic centromeric cohesion protection",
  "GO:1990814": "DNA/DNA annealing activity",
  "GO:1990815": "obsolete regulation of protein localization to cell division site after cytokinesis",
  "GO:1990816": "vacuole-mitochondrion membrane contact site",
  "GO:1990817": "RNA adenylyltransferase activity",
  "GO:1990818": "L-arginine transmembrane export from vacuole",
  "GO:1990819": "actin fusion focus",
  "GO:1990820": "response to mitotic DNA integrity checkpoint signaling",
  "GO:1990821": "high affinity glucose import",
  "GO:1990822": "basic amino acid transmembrane transport",
  "GO:1990823": "response to leukemia inhibitory factor",
  "GO:1990824": "obsolete magnesium-dependent protein complex",
  "GO:1990825": "sequence-specific mRNA binding",
  "GO:1990826": "nucleoplasmic periphery of the nuclear pore complex",
  "GO:1990827": "deaminase binding",
  "GO:1990828": "hepatocyte dedifferentiation",
  "GO:1990829": "C-rich single-stranded DNA binding",
  "GO:1990830": "cellular response to leukemia inhibitory factor",
  "GO:1990831": "cellular response to carcinoembryonic antigen",
  "GO:1990832": "slow axonal transport",
  "GO:1990833": "clathrin-uncoating ATPase activity",
  "GO:1990834": "response to odorant",
  "GO:1990835": "obsolete insulin-like growth factor production",
  "GO:1990836": "lysosomal matrix",
  "GO:1990837": "sequence-specific double-stranded DNA binding",
  "GO:1990838": "poly(U)-specific exoribonuclease activity, producing 3' uridine cyclic phosphate ends",
  "GO:1990839": "response to endothelin",
  "GO:1990840": "response to lectin",
  "GO:1990841": "promoter-specific chromatin binding",
  "GO:1990842": "obsolete response to prenatal stress",
  "GO:1990843": "subsarcolemmal mitochondrion",
  "GO:1990844": "interfibrillar mitochondrion",
  "GO:1990845": "adaptive thermogenesis",
  "GO:1990846": "ribonucleoside-diphosphate reductase inhibitor activity",
  "GO:1990847": "peptide pheromone transmembrane export involved in conjugation with cellular fusion",
  "GO:1990848": "obsolete Positive regulation of removal of reactive oxygen species",
  "GO:1990849": "maintenance of vacuolar location",
  "GO:1990850": "H-gal-GP complex",
  "GO:1990851": "Wnt-Frizzled-LRP5/6 complex",
  "GO:1990852": "protein transport along microtubule to spindle pole body",
  "GO:1990853": "histone H2A SQE motif phosphorylation",
  "GO:1990854": "vacuole-ER tethering",
  "GO:1990855": "obsolete myo-inositol import across plasma membrane",
  "GO:1990856": "methionyl-initiator methionine tRNA binding",
  "GO:1990857": "APC-Fzr1/Mfr1 complex",
  "GO:1990858": "cellular response to lectin",
  "GO:1990859": "cellular response to endothelin",
  "GO:1990860": "Pho85-Pho80 CDK-cyclin complex",
  "GO:1990861": "Ubp3-Bre5 deubiquitination complex",
  "GO:1990862": "nuclear membrane complex Bqt3-Bqt4",
  "GO:1990863": "acinar cell proliferation",
  "GO:1990864": "response to growth hormone-releasing hormone",
  "GO:1990865": "obsolete response to intermittent hypoxia",
  "GO:1990866": "obsolete response to sustained hypoxia",
  "GO:1990867": "response to gastrin",
  "GO:1990868": "response to chemokine",
  "GO:1990869": "cellular response to chemokine",
  "GO:1990870": "obsolete protein fibril",
  "GO:1990871": "Vma12-Vma22 assembly complex",
  "GO:1990872": "negative regulation of sterol import by negative regulation of transcription from RNA polymerase II promoter",
  "GO:1990873": "intrinsic component of plasma membrane of cell tip",
  "GO:1990874": "vascular smooth muscle cell proliferation",
  "GO:1990875": "nucleoplasmic side of nuclear pore",
  "GO:1990876": "cytoplasmic side of nuclear pore",
  "GO:1990877": "Lst4-Lst7 complex",
  "GO:1990878": "cellular response to gastrin",
  "GO:1990879": "CST complex",
  "GO:1990880": "cellular detoxification of copper ion",
  "GO:1990881": "obsolete negative regulation of transcription from RNA polymerase II promoter in response to DNA damage",
  "GO:1990882": "rRNA acetylation",
  "GO:1990883": "rRNA cytidine N-acetyltransferase activity",
  "GO:1990884": "RNA acetylation",
  "GO:1990885": "obsolete protein serine/threonine kinase binding",
  "GO:1990886": "3,4-dihydroxy-5-polyprenylbenzoic acid O-methyltransferase activity",
  "GO:1990887": "2-polyprenyl-3-methyl-5-hydroxy-6-methoxy-1,4-benzoquinol O-methyltransferase activity",
  "GO:1990888": "2-polyprenyl-6-hydroxyphenol O-methyltransferase activity",
  "GO:1990889": "H4K20me3 modified histone binding",
  "GO:1990890": "netrin receptor binding",
  "GO:1990891": "mitotic sister chromatid arm separation",
  "GO:1990892": "mitotic chromosome arm chromatin condensation",
  "GO:1990893": "mitotic chromosome centromere condensation",
  "GO:1990894": "obsolete positive regulation of induction of conjugation with cellular fusion by regulation of transcription from RNA polymerase II promoter",
  "GO:1990895": "regulation of protein localization to cell cortex of cell tip",
  "GO:1990896": "protein localization to cell cortex of cell tip",
  "GO:1990897": "obsolete CTDK-1 complex",
  "GO:1990898": "meiotic DNA double-strand break clipping",
  "GO:1990899": "meiotic DNA double-strand break resectioning",
  "GO:1990900": "ciliary pocket collar",
  "GO:1990901": "old cell pole",
  "GO:1990902": "new cell pole",
  "GO:1990903": "extracellular ribonucleoprotein complex",
  "GO:1990904": "ribonucleoprotein complex",
  "GO:1990905": "dinoflagellate peduncle",
  "GO:1990906": "accessory outer segment",
  "GO:1990907": "beta-catenin-TCF complex",
  "GO:1990908": "obsolete Lys63-specific zinc metallopeptidase deubiquitinase activity",
  "GO:1990909": "Wnt signalosome",
  "GO:1990910": "response to hypobaric hypoxia",
  "GO:1990911": "response to psychosocial stress",
  "GO:1990912": "obsolete response to microwave radiation",
  "GO:1990913": "sperm head plasma membrane",
  "GO:1990914": "integral component of periplasmic side of plasma membrane",
  "GO:1990915": "structural constituent of ascospore wall",
  "GO:1990916": "Isp3 layer of spore wall",
  "GO:1990917": "ooplasm",
  "GO:1990918": "double-strand break repair involved in meiotic recombination",
  "GO:1990919": "nuclear membrane proteasome anchor",
  "GO:1990920": "proteasome localization to nuclear periphery",
  "GO:1990921": "obsolete proteasome localization to nuclear periphery",
  "GO:1990922": "hepatic stellate cell proliferation",
  "GO:1990923": "PET complex",
  "GO:1990924": "obsolete amphisome membrane",
  "GO:1990925": "mitochondrial iron ion transmembrane transport",
  "GO:1990927": "calcium ion regulated lysosome exocytosis",
  "GO:1990928": "response to amino acid starvation",
  "GO:1990929": "sulfoquinovosidase activity",
  "GO:1990930": "RNA N1-methyladenosine dioxygenase activity",
  "GO:1990931": "RNA N6-methyladenosine dioxygenase activity",
  "GO:1990932": "5.8S rRNA binding",
  "GO:1990933": "microtubule cytoskeleton attachment to nuclear envelope",
  "GO:1990934": "nucleolus-like body",
  "GO:1990935": "splicing factor binding",
  "GO:1990936": "vascular smooth muscle cell dedifferentiation",
  "GO:1990937": "xylan acetylation",
  "GO:1990938": "peptidyl-aspartic acid autophosphorylation",
  "GO:1990939": "ATP-dependent microtubule motor activity",
  "GO:1990940": "obsolete microtubule sliding involved in mitotic spindle elongation",
  "GO:1990941": "mitotic spindle kinetochore microtubule",
  "GO:1990942": "mitotic metaphase chromosome recapture",
  "GO:1990943": "mating type region replication fork barrier binding",
  "GO:1990944": "maintenance of spindle pole body localization",
  "GO:1990945": "protein location to meiotic spindle pole body",
  "GO:2000001": "regulation of DNA damage checkpoint",
  "GO:2000002": "negative regulation of DNA damage checkpoint",
  "GO:2000003": "positive regulation of DNA damage checkpoint",
  "GO:2000004": "regulation of metanephric S-shaped body morphogenesis",
  "GO:2000005": "negative regulation of metanephric S-shaped body morphogenesis",
  "GO:2000006": "regulation of metanephric comma-shaped body morphogenesis",
  "GO:2000007": "negative regulation of metanephric comma-shaped body morphogenesis",
  "GO:2000008": "regulation of protein localization to cell surface",
  "GO:2000009": "negative regulation of protein localization to cell surface",
  "GO:2000010": "positive regulation of protein localization to cell surface",
  "GO:2000011": "regulation of adaxial/abaxial pattern formation",
  "GO:2000012": "regulation of auxin polar transport",
  "GO:2000013": "regulation of arginine biosynthetic process via ornithine",
  "GO:2000014": "regulation of endosperm development",
  "GO:2000015": "regulation of determination of dorsal identity",
  "GO:2000016": "negative regulation of determination of dorsal identity",
  "GO:2000017": "positive regulation of determination of dorsal identity",
  "GO:2000018": "regulation of male gonad development",
  "GO:2000019": "negative regulation of male gonad development",
  "GO:2000020": "positive regulation of male gonad development",
  "GO:2000021": "regulation of ion homeostasis",
  "GO:2000022": "regulation of jasmonic acid mediated signaling pathway",
  "GO:2000023": "regulation of lateral root development",
  "GO:2000024": "regulation of leaf development",
  "GO:2000025": "regulation of leaf formation",
  "GO:2000026": "regulation of multicellular organismal development",
  "GO:2000027": "regulation of organ morphogenesis",
  "GO:2000028": "regulation of photoperiodism, flowering",
  "GO:2000029": "regulation of proanthocyanidin biosynthetic process",
  "GO:2000030": "regulation of response to red or far red light",
  "GO:2000031": "regulation of salicylic acid mediated signaling pathway",
  "GO:2000032": "regulation of secondary shoot formation",
  "GO:2000033": "regulation of seed dormancy process",
  "GO:2000034": "regulation of seed maturation",
  "GO:2000035": "regulation of stem cell division",
  "GO:2000036": "regulation of stem cell population maintenance",
  "GO:2000037": "regulation of stomatal complex patterning",
  "GO:2000038": "regulation of stomatal complex development",
  "GO:2000039": "regulation of trichome morphogenesis",
  "GO:2000040": "regulation of planar cell polarity pathway involved in axis elongation",
  "GO:2000041": "negative regulation of planar cell polarity pathway involved in axis elongation",
  "GO:2000042": "negative regulation of double-strand break repair via homologous recombination",
  "GO:2000043": "regulation of cardiac cell fate specification",
  "GO:2000044": "negative regulation of cardiac cell fate specification",
  "GO:2000045": "regulation of G1/S transition of mitotic cell cycle",
  "GO:2000046": "obsolete regulation of G2 phase of mitotic cell cycle",
  "GO:2000047": "regulation of cell-cell adhesion mediated by cadherin",
  "GO:2000048": "negative regulation of cell-cell adhesion mediated by cadherin",
  "GO:2000049": "positive regulation of cell-cell adhesion mediated by cadherin",
  "GO:2000050": "regulation of non-canonical Wnt signaling pathway",
  "GO:2000051": "negative regulation of non-canonical Wnt signaling pathway",
  "GO:2000052": "positive regulation of non-canonical Wnt signaling pathway",
  "GO:2000053": "regulation of Wnt signaling pathway involved in dorsal/ventral axis specification",
  "GO:2000054": "negative regulation of Wnt signaling pathway involved in dorsal/ventral axis specification",
  "GO:2000055": "positive regulation of Wnt signaling pathway involved in dorsal/ventral axis specification",
  "GO:2000056": "regulation of Wnt signaling pathway involved in digestive tract morphogenesis",
  "GO:2000057": "negative regulation of Wnt signaling pathway involved in digestive tract morphogenesis",
  "GO:2000058": "regulation of protein ubiquitination involved in ubiquitin-dependent protein catabolic process",
  "GO:2000059": "negative regulation of protein ubiquitination involved in ubiquitin-dependent protein catabolic process",
  "GO:2000060": "positive regulation of protein ubiquitination involved in ubiquitin-dependent protein catabolic process",
  "GO:2000061": "regulation of ureter smooth muscle cell differentiation",
  "GO:2000062": "negative regulation of ureter smooth muscle cell differentiation",
  "GO:2000063": "positive regulation of ureter smooth muscle cell differentiation",
  "GO:2000064": "regulation of cortisol biosynthetic process",
  "GO:2000065": "negative regulation of cortisol biosynthetic process",
  "GO:2000066": "positive regulation of cortisol biosynthetic process",
  "GO:2000067": "regulation of root morphogenesis",
  "GO:2000068": "regulation of defense response to insect",
  "GO:2000069": "regulation of post-embryonic root development",
  "GO:2000070": "regulation of response to water deprivation",
  "GO:2000071": "regulation of defense response by callose deposition",
  "GO:2000072": "regulation of defense response to fungus, incompatible interaction",
  "GO:2000073": "regulation of cytokinesis, site selection",
  "GO:2000074": "regulation of type B pancreatic cell development",
  "GO:2000075": "negative regulation of cytokinesis, site selection",
  "GO:2000076": "positive regulation cytokinesis, site selection",
  "GO:2000077": "negative regulation of type B pancreatic cell development",
  "GO:2000078": "positive regulation of type B pancreatic cell development",
  "GO:2000079": "regulation of canonical Wnt signaling pathway involved in controlling type B pancreatic cell proliferation",
  "GO:2000080": "negative regulation of canonical Wnt signaling pathway involved in controlling type B pancreatic cell proliferation",
  "GO:2000081": "positive regulation of canonical Wnt signaling pathway involved in controlling type B pancreatic cell proliferation",
  "GO:2000082": "regulation of L-ascorbic acid biosynthetic process",
  "GO:2000083": "negative regulation of L-ascorbic acid biosynthetic process",
  "GO:2000084": "regulation of mesenchymal to epithelial transition involved in mesonephros morphogenesis",
  "GO:2000085": "negative regulation of mesenchymal to epithelial transition involved in mesonephros morphogenesis",
  "GO:2000086": "positive regulation of mesenchymal to epithelial transition involved in mesonephros morphogenesis",
  "GO:2000087": "regulation of mesonephric glomerulus development",
  "GO:2000088": "negative regulation of mesonephric glomerulus development",
  "GO:2000089": "positive regulation of mesonephric glomerulus development",
  "GO:2000090": "regulation of mesonephric glomerular mesangial cell proliferation",
  "GO:2000091": "negative regulation of mesonephric glomerular mesangial cell proliferation",
  "GO:2000092": "positive regulation of mesonephric glomerular mesangial cell proliferation",
  "GO:2000093": "regulation of mesonephric nephron tubule epithelial cell differentiation",
  "GO:2000094": "negative regulation of mesonephric nephron tubule epithelial cell differentiation",
  "GO:2000095": "regulation of Wnt signaling pathway, planar cell polarity pathway",
  "GO:2000096": "positive regulation of Wnt signaling pathway, planar cell polarity pathway",
  "GO:2000097": "regulation of smooth muscle cell-matrix adhesion",
  "GO:2000098": "negative regulation of smooth muscle cell-matrix adhesion",
  "GO:2000099": "regulation of establishment or maintenance of bipolar cell polarity",
  "GO:2000100": "regulation of establishment or maintenance of bipolar cell polarity regulating cell shape",
  "GO:2000101": "regulation of mammary stem cell proliferation",
  "GO:2000102": "negative regulation of mammary stem cell proliferation",
  "GO:2000103": "positive regulation of mammary stem cell proliferation",
  "GO:2000104": "negative regulation of DNA-dependent DNA replication",
  "GO:2000105": "positive regulation of DNA-dependent DNA replication",
  "GO:2000106": "regulation of leukocyte apoptotic process",
  "GO:2000107": "negative regulation of leukocyte apoptotic process",
  "GO:2000108": "positive regulation of leukocyte apoptotic process",
  "GO:2000109": "regulation of macrophage apoptotic process",
  "GO:2000110": "negative regulation of macrophage apoptotic process",
  "GO:2000111": "positive regulation of macrophage apoptotic process",
  "GO:2000112": "regulation of cellular macromolecule biosynthetic process",
  "GO:2000113": "negative regulation of cellular macromolecule biosynthetic process",
  "GO:2000114": "regulation of establishment of cell polarity",
  "GO:2000115": "regulation of maintenance of bipolar cell polarity regulating cell shape",
  "GO:2000116": "regulation of cysteine-type endopeptidase activity",
  "GO:2000117": "negative regulation of cysteine-type endopeptidase activity",
  "GO:2000118": "regulation of sodium-dependent phosphate transport",
  "GO:2000119": "negative regulation of sodium-dependent phosphate transport",
  "GO:2000120": "positive regulation of sodium-dependent phosphate transport",
  "GO:2000121": "regulation of removal of superoxide radicals",
  "GO:2000122": "negative regulation of stomatal complex development",
  "GO:2000123": "positive regulation of stomatal complex development",
  "GO:2000124": "regulation of endocannabinoid signaling pathway",
  "GO:2000125": "regulation of octopamine or tyramine signaling pathway",
  "GO:2000126": "negative regulation of octopamine or tyramine signaling pathway",
  "GO:2000127": "positive regulation of octopamine or tyramine signaling pathway",
  "GO:2000128": "regulation of octopamine signaling pathway",
  "GO:2000129": "negative regulation of octopamine signaling pathway",
  "GO:2000130": "positive regulation of octopamine signaling pathway",
  "GO:2000131": "regulation of tyramine signaling pathway",
  "GO:2000132": "negative regulation of tyramine signaling pathway",
  "GO:2000133": "positive regulation of tyramine signaling pathway",
  "GO:2000134": "negative regulation of G1/S transition of mitotic cell cycle",
  "GO:2000135": "obsolete positive regulation of regulation of secondary heart field cardioblast proliferation",
  "GO:2000136": "regulation of cell proliferation involved in heart morphogenesis",
  "GO:2000137": "negative regulation of cell proliferation involved in heart morphogenesis",
  "GO:2000138": "positive regulation of cell proliferation involved in heart morphogenesis",
  "GO:2000139": "regulation of octopamine signaling pathway involved in response to food",
  "GO:2000140": "negative regulation of octopamine signaling pathway involved in response to food",
  "GO:2000141": "positive regulation of octopamine signaling pathway involved in response to food",
  "GO:2000142": "regulation of DNA-templated transcription, initiation",
  "GO:2000143": "negative regulation of DNA-templated transcription, initiation",
  "GO:2000144": "positive regulation of DNA-templated transcription, initiation",
  "GO:2000145": "regulation of cell motility",
  "GO:2000146": "negative regulation of cell motility",
  "GO:2000147": "positive regulation of cell motility",
  "GO:2000148": "regulation of planar cell polarity pathway involved in ventricular septum morphogenesis",
  "GO:2000149": "negative regulation of planar cell polarity pathway involved in ventricular septum morphogenesis",
  "GO:2000150": "regulation of planar cell polarity pathway involved in cardiac muscle tissue morphogenesis",
  "GO:2000151": "negative regulation of planar cell polarity pathway involved in cardiac muscle tissue morphogenesis",
  "GO:2000152": "regulation of ubiquitin-specific protease activity",
  "GO:2000153": "obsolete regulation of flagellar cell motility",
  "GO:2000154": "obsolete negative regulation of flagellar cell motility",
  "GO:2000155": "positive regulation of cilium-dependent cell motility",
  "GO:2000156": "regulation of retrograde vesicle-mediated transport, Golgi to ER",
  "GO:2000157": "negative regulation of ubiquitin-specific protease activity",
  "GO:2000158": "positive regulation of ubiquitin-specific protease activity",
  "GO:2000159": "regulation of planar cell polarity pathway involved in heart morphogenesis",
  "GO:2000160": "negative regulation of planar cell polarity pathway involved in heart morphogenesis",
  "GO:2000161": "regulation of planar cell polarity pathway involved in cardiac right atrium morphogenesis",
  "GO:2000162": "negative regulation of planar cell polarity pathway involved in cardiac right atrium morphogenesis",
  "GO:2000163": "regulation of planar cell polarity pathway involved in outflow tract morphogenesis",
  "GO:2000164": "negative regulation of planar cell polarity pathway involved in outflow tract morphogenesis",
  "GO:2000165": "regulation of planar cell polarity pathway involved in pericardium morphogenesis",
  "GO:2000166": "negative regulation of planar cell polarity pathway involved in pericardium morphogenesis",
  "GO:2000167": "regulation of planar cell polarity pathway involved in neural tube closure",
  "GO:2000168": "negative regulation of planar cell polarity pathway involved in neural tube closure",
  "GO:2000169": "regulation of peptidyl-cysteine S-nitrosylation",
  "GO:2000170": "positive regulation of peptidyl-cysteine S-nitrosylation",
  "GO:2000171": "negative regulation of dendrite development",
  "GO:2000172": "regulation of branching morphogenesis of a nerve",
  "GO:2000173": "negative regulation of branching morphogenesis of a nerve",
  "GO:2000174": "regulation of pro-T cell differentiation",
  "GO:2000175": "negative regulation of pro-T cell differentiation",
  "GO:2000176": "positive regulation of pro-T cell differentiation",
  "GO:2000177": "regulation of neural precursor cell proliferation",
  "GO:2000178": "negative regulation of neural precursor cell proliferation",
  "GO:2000179": "positive regulation of neural precursor cell proliferation",
  "GO:2000180": "negative regulation of androgen biosynthetic process",
  "GO:2000181": "negative regulation of blood vessel morphogenesis",
  "GO:2000182": "regulation of progesterone biosynthetic process",
  "GO:2000183": "negative regulation of progesterone biosynthetic process",
  "GO:2000184": "positive regulation of progesterone biosynthetic process",
  "GO:2000185": "regulation of phosphate transmembrane transport",
  "GO:2000186": "negative regulation of phosphate transmembrane transport",
  "GO:2000187": "positive regulation of phosphate transmembrane transport",
  "GO:2000188": "regulation of cholesterol homeostasis",
  "GO:2000189": "positive regulation of cholesterol homeostasis",
  "GO:2000190": "obsolete negative regulation of regulation of transcription from RNA polymerase II promoter by nuclear hormone receptor",
  "GO:2000191": "regulation of fatty acid transport",
  "GO:2000192": "negative regulation of fatty acid transport",
  "GO:2000193": "positive regulation of fatty acid transport",
  "GO:2000194": "regulation of female gonad development",
  "GO:2000195": "negative regulation of female gonad development",
  "GO:2000196": "positive regulation of female gonad development",
  "GO:2000197": "regulation of ribonucleoprotein complex localization",
  "GO:2000198": "negative regulation of ribonucleoprotein complex localization",
  "GO:2000199": "positive regulation of ribonucleoprotein complex localization",
  "GO:2000200": "regulation of ribosomal subunit export from nucleus",
  "GO:2000201": "negative regulation of ribosomal subunit export from nucleus",
  "GO:2000202": "positive regulation of ribosomal subunit export from nucleus",
  "GO:2000203": "regulation of ribosomal large subunit export from nucleus",
  "GO:2000204": "negative regulation of ribosomal large subunit export from nucleus",
  "GO:2000205": "positive regulation of ribosomal large subunit export from nucleus",
  "GO:2000206": "regulation of ribosomal small subunit export from nucleus",
  "GO:2000207": "negative regulation of ribosomal small subunit export from nucleus",
  "GO:2000208": "positive regulation of ribosomal small subunit export from nucleus",
  "GO:2000209": "regulation of anoikis",
  "GO:2000210": "positive regulation of anoikis",
  "GO:2000211": "regulation of glutamate metabolic process",
  "GO:2000212": "negative regulation of glutamate metabolic process",
  "GO:2000213": "positive regulation of glutamate metabolic process",
  "GO:2000214": "regulation of proline metabolic process",
  "GO:2000215": "negative regulation of proline metabolic process",
  "GO:2000216": "positive regulation of proline metabolic process",
  "GO:2000217": "regulation of invasive growth in response to glucose limitation",
  "GO:2000218": "negative regulation of invasive growth in response to glucose limitation",
  "GO:2000219": "positive regulation of invasive growth in response to glucose limitation",
  "GO:2000220": "regulation of pseudohyphal growth",
  "GO:2000221": "negative regulation of pseudohyphal growth",
  "GO:2000222": "positive regulation of pseudohyphal growth",
  "GO:2000223": "regulation of BMP signaling pathway involved in heart jogging",
  "GO:2000224": "regulation of testosterone biosynthetic process",
  "GO:2000225": "negative regulation of testosterone biosynthetic process",
  "GO:2000226": "regulation of pancreatic A cell differentiation",
  "GO:2000227": "negative regulation of pancreatic A cell differentiation",
  "GO:2000228": "positive regulation of pancreatic A cell differentiation",
  "GO:2000229": "regulation of pancreatic stellate cell proliferation",
  "GO:2000230": "negative regulation of pancreatic stellate cell proliferation",
  "GO:2000231": "positive regulation of pancreatic stellate cell proliferation",
  "GO:2000232": "regulation of rRNA processing",
  "GO:2000233": "negative regulation of rRNA processing",
  "GO:2000234": "positive regulation of rRNA processing",
  "GO:2000235": "regulation of tRNA processing",
  "GO:2000236": "negative regulation of tRNA processing",
  "GO:2000237": "positive regulation of tRNA processing",
  "GO:2000238": "regulation of tRNA export from nucleus",
  "GO:2000239": "negative regulation of tRNA export from nucleus",
  "GO:2000240": "positive regulation of tRNA export from nucleus",
  "GO:2000241": "regulation of reproductive process",
  "GO:2000242": "negative regulation of reproductive process",
  "GO:2000243": "positive regulation of reproductive process",
  "GO:2000244": "regulation of FtsZ-dependent cytokinesis",
  "GO:2000245": "negative regulation of FtsZ-dependent cytokinesis",
  "GO:2000246": "positive regulation of FtsZ-dependent cytokinesis",
  "GO:2000247": "positive regulation of establishment or maintenance of bipolar cell polarity regulating cell shape",
  "GO:2000248": "negative regulation of establishment or maintenance of neuroblast polarity",
  "GO:2000249": "regulation of actin cytoskeleton reorganization",
  "GO:2000250": "negative regulation of actin cytoskeleton reorganization",
  "GO:2000251": "positive regulation of actin cytoskeleton reorganization",
  "GO:2000252": "negative regulation of feeding behavior",
  "GO:2000253": "positive regulation of feeding behavior",
  "GO:2000254": "regulation of male germ cell proliferation",
  "GO:2000255": "negative regulation of male germ cell proliferation",
  "GO:2000256": "positive regulation of male germ cell proliferation",
  "GO:2000257": "regulation of protein activation cascade",
  "GO:2000258": "negative regulation of protein activation cascade",
  "GO:2000259": "positive regulation of protein activation cascade",
  "GO:2000260": "regulation of blood coagulation, common pathway",
  "GO:2000261": "negative regulation of blood coagulation, common pathway",
  "GO:2000262": "positive regulation of blood coagulation, common pathway",
  "GO:2000263": "regulation of blood coagulation, extrinsic pathway",
  "GO:2000264": "negative regulation of blood coagulation, extrinsic pathway",
  "GO:2000265": "positive regulation of blood coagulation, extrinsic pathway",
  "GO:2000266": "regulation of blood coagulation, intrinsic pathway",
  "GO:2000267": "negative regulation of blood coagulation, intrinsic pathway",
  "GO:2000268": "positive regulation of blood coagulation, intrinsic pathway",
  "GO:2000269": "regulation of fibroblast apoptotic process",
  "GO:2000270": "negative regulation of fibroblast apoptotic process",
  "GO:2000271": "positive regulation of fibroblast apoptotic process",
  "GO:2000272": "negative regulation of receptor activity",
  "GO:2000273": "positive regulation of receptor activity",
  "GO:2000274": "regulation of epithelial cell migration, open tracheal system",
  "GO:2000275": "regulation of oxidative phosphorylation uncoupler activity",
  "GO:2000276": "negative regulation of oxidative phosphorylation uncoupler activity",
  "GO:2000277": "positive regulation of oxidative phosphorylation uncoupler activity",
  "GO:2000278": "regulation of DNA biosynthetic process",
  "GO:2000279": "negative regulation of DNA biosynthetic process",
  "GO:2000280": "regulation of root development",
  "GO:2000281": "regulation of histone H3-T3 phosphorylation",
  "GO:2000282": "regulation of cellular amino acid biosynthetic process",
  "GO:2000283": "negative regulation of cellular amino acid biosynthetic process",
  "GO:2000284": "positive regulation of cellular amino acid biosynthetic process",
  "GO:2000285": "obsolete negative regulation of regulation of excitatory postsynaptic membrane potential",
  "GO:2000286": "receptor internalization involved in canonical Wnt signaling pathway",
  "GO:2000287": "positive regulation of myotome development",
  "GO:2000288": "positive regulation of myoblast proliferation",
  "GO:2000289": "regulation of photoreceptor cell axon guidance",
  "GO:2000290": "regulation of myotome development",
  "GO:2000291": "regulation of myoblast proliferation",
  "GO:2000292": "regulation of defecation",
  "GO:2000293": "negative regulation of defecation",
  "GO:2000294": "positive regulation of defecation",
  "GO:2000295": "regulation of hydrogen peroxide catabolic process",
  "GO:2000296": "negative regulation of hydrogen peroxide catabolic process",
  "GO:2000297": "negative regulation of synapse maturation",
  "GO:2000298": "regulation of Rho-dependent protein serine/threonine kinase activity",
  "GO:2000299": "negative regulation of Rho-dependent protein serine/threonine kinase activity",
  "GO:2000300": "regulation of synaptic vesicle exocytosis",
  "GO:2000301": "negative regulation of synaptic vesicle exocytosis",
  "GO:2000302": "positive regulation of synaptic vesicle exocytosis",
  "GO:2000303": "regulation of ceramide biosynthetic process",
  "GO:2000304": "positive regulation of ceramide biosynthetic process",
  "GO:2000305": "semaphorin-plexin signaling pathway involved in regulation of photoreceptor cell axon guidance",
  "GO:2000306": "positive regulation of photomorphogenesis",
  "GO:2000307": "regulation of tumor necrosis factor (ligand) superfamily member 11 production",
  "GO:2000308": "negative regulation of tumor necrosis factor (ligand) superfamily member 11 production",
  "GO:2000309": "positive regulation of tumor necrosis factor (ligand) superfamily member 11 production",
  "GO:2000310": "regulation of N-methyl-D-aspartate selective glutamate receptor activity",
  "GO:2000311": "regulation of alpha-amino-3-hydroxy-5-methyl-4-isoxazole propionate selective glutamate receptor activity",
  "GO:2000312": "regulation of kainate selective glutamate receptor activity",
  "GO:2000313": "regulation of fibroblast growth factor receptor signaling pathway involved in neural plate anterior/posterior pattern formation",
  "GO:2000314": "negative regulation of fibroblast growth factor receptor signaling pathway involved in neural plate anterior/posterior pattern formation",
  "GO:2000315": "positive regulation of fibroblast growth factor receptor signaling pathway involved in neural plate anterior/posterior pattern formation",
  "GO:2000316": "regulation of T-helper 17 type immune response",
  "GO:2000317": "negative regulation of T-helper 17 type immune response",
  "GO:2000318": "positive regulation of T-helper 17 type immune response",
  "GO:2000319": "regulation of T-helper 17 cell differentiation",
  "GO:2000320": "negative regulation of T-helper 17 cell differentiation",
  "GO:2000321": "positive regulation of T-helper 17 cell differentiation",
  "GO:2000322": "regulation of glucocorticoid receptor signaling pathway",
  "GO:2000323": "negative regulation of glucocorticoid receptor signaling pathway",
  "GO:2000324": "positive regulation of glucocorticoid receptor signaling pathway",
  "GO:2000325": "regulation of ligand-dependent nuclear receptor transcription coactivator activity",
  "GO:2000326": "negative regulation of ligand-dependent nuclear receptor transcription coactivator activity",
  "GO:2000327": "positive regulation of ligand-dependent nuclear receptor transcription coactivator activity",
  "GO:2000328": "regulation of T-helper 17 cell lineage commitment",
  "GO:2000329": "negative regulation of T-helper 17 cell lineage commitment",
  "GO:2000330": "positive regulation of T-helper 17 cell lineage commitment",
  "GO:2000331": "regulation of terminal button organization",
  "GO:2000332": "regulation of blood microparticle formation",
  "GO:2000333": "negative regulation of blood microparticle formation",
  "GO:2000334": "positive regulation of blood microparticle formation",
  "GO:2000335": "regulation of endothelial microparticle formation",
  "GO:2000336": "negative regulation of endothelial microparticle formation",
  "GO:2000337": "positive regulation of endothelial microparticle formation",
  "GO:2000338": "regulation of chemokine (C-X-C motif) ligand 1 production",
  "GO:2000339": "negative regulation of chemokine (C-X-C motif) ligand 1 production",
  "GO:2000340": "positive regulation of chemokine (C-X-C motif) ligand 1 production",
  "GO:2000341": "regulation of chemokine (C-X-C motif) ligand 2 production",
  "GO:2000342": "negative regulation of chemokine (C-X-C motif) ligand 2 production",
  "GO:2000343": "positive regulation of chemokine (C-X-C motif) ligand 2 production",
  "GO:2000344": "positive regulation of acrosome reaction",
  "GO:2000345": "regulation of hepatocyte proliferation",
  "GO:2000346": "negative regulation of hepatocyte proliferation",
  "GO:2000347": "positive regulation of hepatocyte proliferation",
  "GO:2000348": "regulation of CD40 signaling pathway",
  "GO:2000349": "negative regulation of CD40 signaling pathway",
  "GO:2000350": "positive regulation of CD40 signaling pathway",
  "GO:2000351": "regulation of endothelial cell apoptotic process",
  "GO:2000352": "negative regulation of endothelial cell apoptotic process",
  "GO:2000353": "positive regulation of endothelial cell apoptotic process",
  "GO:2000354": "regulation of ovarian follicle development",
  "GO:2000355": "negative regulation of ovarian follicle development",
  "GO:2000356": "regulation of kidney smooth muscle cell differentiation",
  "GO:2000357": "negative regulation of kidney smooth muscle cell differentiation",
  "GO:2000358": "positive regulation of kidney smooth muscle cell differentiation",
  "GO:2000359": "regulation of binding of sperm to zona pellucida",
  "GO:2000360": "negative regulation of binding of sperm to zona pellucida",
  "GO:2000361": "regulation of prostaglandin-E synthase activity",
  "GO:2000362": "negative regulation of prostaglandin-E synthase activity",
  "GO:2000363": "positive regulation of prostaglandin-E synthase activity",
  "GO:2000364": "regulation of STAT protein import into nucleus",
  "GO:2000365": "negative regulation of STAT protein import into nucleus",
  "GO:2000366": "positive regulation of STAT protein import into nucleus",
  "GO:2000367": "regulation of acrosomal vesicle exocytosis",
  "GO:2000368": "positive regulation of acrosomal vesicle exocytosis",
  "GO:2000369": "regulation of clathrin-mediated endocytosis",
  "GO:2000370": "positive regulation of clathrin-mediated endocytosis",
  "GO:2000371": "regulation of DNA topoisomerase (ATP-hydrolyzing) activity",
  "GO:2000372": "negative regulation of DNA topoisomerase (ATP-hydrolyzing) activity",
  "GO:2000373": "positive regulation of DNA topoisomerase (ATP-hydrolyzing) activity",
  "GO:2000374": "regulation of oxygen metabolic process",
  "GO:2000375": "negative regulation of oxygen metabolic process",
  "GO:2000376": "positive regulation of oxygen metabolic process",
  "GO:2000377": "regulation of reactive oxygen species metabolic process",
  "GO:2000378": "negative regulation of reactive oxygen species metabolic process",
  "GO:2000379": "positive regulation of reactive oxygen species metabolic process",
  "GO:2000380": "regulation of mesoderm development",
  "GO:2000381": "negative regulation of mesoderm development",
  "GO:2000382": "positive regulation of mesoderm development",
  "GO:2000383": "regulation of ectoderm development",
  "GO:2000384": "negative regulation of ectoderm development",
  "GO:2000385": "positive regulation of ectoderm development",
  "GO:2000386": "positive regulation of ovarian follicle development",
  "GO:2000387": "regulation of antral ovarian follicle growth",
  "GO:2000388": "positive regulation of antral ovarian follicle growth",
  "GO:2000389": "regulation of neutrophil extravasation",
  "GO:2000390": "negative regulation of neutrophil extravasation",
  "GO:2000391": "positive regulation of neutrophil extravasation",
  "GO:2000392": "regulation of lamellipodium morphogenesis",
  "GO:2000393": "negative regulation of lamellipodium morphogenesis",
  "GO:2000394": "positive regulation of lamellipodium morphogenesis",
  "GO:2000395": "regulation of ubiquitin-dependent endocytosis",
  "GO:2000396": "negative regulation of ubiquitin-dependent endocytosis",
  "GO:2000397": "positive regulation of ubiquitin-dependent endocytosis",
  "GO:2000398": "regulation of thymocyte aggregation",
  "GO:2000399": "negative regulation of thymocyte aggregation",
  "GO:2000400": "positive regulation of thymocyte aggregation",
  "GO:2000401": "regulation of lymphocyte migration",
  "GO:2000402": "negative regulation of lymphocyte migration",
  "GO:2000403": "positive regulation of lymphocyte migration",
  "GO:2000404": "regulation of T cell migration",
  "GO:2000405": "negative regulation of T cell migration",
  "GO:2000406": "positive regulation of T cell migration",
  "GO:2000407": "regulation of T cell extravasation",
  "GO:2000408": "negative regulation of T cell extravasation",
  "GO:2000409": "positive regulation of T cell extravasation",
  "GO:2000410": "regulation of thymocyte migration",
  "GO:2000411": "negative regulation of thymocyte migration",
  "GO:2000412": "positive regulation of thymocyte migration",
  "GO:2000413": "regulation of fibronectin-dependent thymocyte migration",
  "GO:2000414": "negative regulation of fibronectin-dependent thymocyte migration",
  "GO:2000415": "positive regulation of fibronectin-dependent thymocyte migration",
  "GO:2000416": "regulation of eosinophil migration",
  "GO:2000417": "negative regulation of eosinophil migration",
  "GO:2000418": "positive regulation of eosinophil migration",
  "GO:2000419": "regulation of eosinophil extravasation",
  "GO:2000420": "negative regulation of eosinophil extravasation",
  "GO:2000421": "positive regulation of eosinophil extravasation",
  "GO:2000422": "regulation of eosinophil chemotaxis",
  "GO:2000423": "negative regulation of eosinophil chemotaxis",
  "GO:2000424": "positive regulation of eosinophil chemotaxis",
  "GO:2000425": "regulation of apoptotic cell clearance",
  "GO:2000426": "negative regulation of apoptotic cell clearance",
  "GO:2000427": "positive regulation of apoptotic cell clearance",
  "GO:2000428": "regulation of neutrophil aggregation",
  "GO:2000429": "negative regulation of neutrophil aggregation",
  "GO:2000430": "positive regulation of neutrophil aggregation",
  "GO:2000431": "regulation of cytokinesis, actomyosin contractile ring assembly",
  "GO:2000432": "negative regulation of cytokinesis, actomyosin contractile ring assembly",
  "GO:2000433": "positive regulation of cytokinesis, actomyosin contractile ring assembly",
  "GO:2000434": "regulation of protein neddylation",
  "GO:2000435": "negative regulation of protein neddylation",
  "GO:2000436": "positive regulation of protein neddylation",
  "GO:2000437": "regulation of monocyte extravasation",
  "GO:2000438": "negative regulation of monocyte extravasation",
  "GO:2000439": "positive regulation of monocyte extravasation",
  "GO:2000440": "regulation of toll-like receptor 15 signaling pathway",
  "GO:2000441": "negative regulation of toll-like receptor 15 signaling pathway",
  "GO:2000442": "positive regulation of toll-like receptor 15 signaling pathway",
  "GO:2000443": "regulation of toll-like receptor 21 signaling pathway",
  "GO:2000444": "negative regulation of toll-like receptor 21 signaling pathway",
  "GO:2000445": "positive regulation of toll-like receptor 21 signaling pathway",
  "GO:2000446": "regulation of macrophage migration inhibitory factor signaling pathway",
  "GO:2000447": "negative regulation of macrophage migration inhibitory factor signaling pathway",
  "GO:2000448": "positive regulation of macrophage migration inhibitory factor signaling pathway",
  "GO:2000449": "regulation of CD8-positive, alpha-beta T cell extravasation",
  "GO:2000450": "negative regulation of CD8-positive, alpha-beta T cell extravasation",
  "GO:2000451": "positive regulation of CD8-positive, alpha-beta T cell extravasation",
  "GO:2000452": "regulation of CD8-positive, alpha-beta cytotoxic T cell extravasation",
  "GO:2000453": "negative regulation of CD8-positive, alpha-beta cytotoxic T cell extravasation",
  "GO:2000454": "positive regulation of CD8-positive, alpha-beta cytotoxic T cell extravasation",
  "GO:2000455": "regulation of T-helper 17 cell extravasation",
  "GO:2000456": "negative regulation of T-helper 17 cell extravasation",
  "GO:2000457": "positive regulation of T-helper 17 cell extravasation",
  "GO:2000458": "regulation of astrocyte chemotaxis",
  "GO:2000459": "negative regulation of astrocyte chemotaxis",
  "GO:2000460": "obsolete regulation of eukaryotic cell surface binding",
  "GO:2000461": "obsolete negative regulation of eukaryotic cell surface binding",
  "GO:2000462": "obsolete positive regulation of eukaryotic cell surface binding",
  "GO:2000463": "positive regulation of excitatory postsynaptic potential",
  "GO:2000464": "positive regulation of astrocyte chemotaxis",
  "GO:2000465": "regulation of glycogen (starch) synthase activity",
  "GO:2000466": "negative regulation of glycogen (starch) synthase activity",
  "GO:2000467": "positive regulation of glycogen (starch) synthase activity",
  "GO:2000468": "regulation of peroxidase activity",
  "GO:2000469": "negative regulation of peroxidase activity",
  "GO:2000470": "positive regulation of peroxidase activity",
  "GO:2000471": "regulation of hematopoietic stem cell migration",
  "GO:2000472": "negative regulation of hematopoietic stem cell migration",
  "GO:2000473": "positive regulation of hematopoietic stem cell migration",
  "GO:2000474": "regulation of opioid receptor signaling pathway",
  "GO:2000475": "negative regulation of opioid receptor signaling pathway",
  "GO:2000476": "positive regulation of opioid receptor signaling pathway",
  "GO:2000477": "regulation of metanephric glomerular visceral epithelial cell development",
  "GO:2000478": "positive regulation of metanephric glomerular visceral epithelial cell development",
  "GO:2000479": "regulation of cAMP-dependent protein kinase activity",
  "GO:2000480": "negative regulation of cAMP-dependent protein kinase activity",
  "GO:2000481": "positive regulation of cAMP-dependent protein kinase activity",
  "GO:2000482": "regulation of interleukin-8 secretion",
  "GO:2000483": "negative regulation of interleukin-8 secretion",
  "GO:2000484": "positive regulation of interleukin-8 secretion",
  "GO:2000485": "regulation of glutamine transport",
  "GO:2000486": "negative regulation of glutamine transport",
  "GO:2000487": "positive regulation of glutamine transport",
  "GO:2000488": "positive regulation of brassinosteroid biosynthetic process",
  "GO:2000489": "regulation of hepatic stellate cell activation",
  "GO:2000490": "negative regulation of hepatic stellate cell activation",
  "GO:2000491": "positive regulation of hepatic stellate cell activation",
  "GO:2000492": "regulation of interleukin-18-mediated signaling pathway",
  "GO:2000493": "negative regulation of interleukin-18-mediated signaling pathway",
  "GO:2000494": "positive regulation of interleukin-18-mediated signaling pathway",
  "GO:2000495": "regulation of cell proliferation involved in compound eye morphogenesis",
  "GO:2000496": "negative regulation of cell proliferation involved in compound eye morphogenesis",
  "GO:2000497": "positive regulation of cell proliferation involved in compound eye morphogenesis",
  "GO:2000498": "obsolete regulation of induction of apoptosis in response to chemical stimulus",
  "GO:2000499": "obsolete negative regulation of induction of apoptosis in response to chemical stimulus",
  "GO:2000500": "obsolete positive regulation of induction of apoptosis in response to chemical stimulus",
  "GO:2000501": "regulation of natural killer cell chemotaxis",
  "GO:2000502": "negative regulation of natural killer cell chemotaxis",
  "GO:2000503": "positive regulation of natural killer cell chemotaxis",
  "GO:2000504": "positive regulation of blood vessel remodeling",
  "GO:2000505": "regulation of energy homeostasis",
  "GO:2000506": "negative regulation of energy homeostasis",
  "GO:2000507": "positive regulation of energy homeostasis",
  "GO:2000508": "regulation of dendritic cell chemotaxis",
  "GO:2000509": "negative regulation of dendritic cell chemotaxis",
  "GO:2000510": "positive regulation of dendritic cell chemotaxis",
  "GO:2000511": "regulation of granzyme A production",
  "GO:2000512": "negative regulation of granzyme A production",
  "GO:2000513": "positive regulation of granzyme A production",
  "GO:2000514": "regulation of CD4-positive, alpha-beta T cell activation",
  "GO:2000515": "negative regulation of CD4-positive, alpha-beta T cell activation",
  "GO:2000516": "positive regulation of CD4-positive, alpha-beta T cell activation",
  "GO:2000517": "regulation of T-helper 1 cell activation",
  "GO:2000518": "negative regulation of T-helper 1 cell activation",
  "GO:2000519": "positive regulation of T-helper 1 cell activation",
  "GO:2000520": "regulation of immunological synapse formation",
  "GO:2000521": "negative regulation of immunological synapse formation",
  "GO:2000522": "positive regulation of immunological synapse formation",
  "GO:2000523": "regulation of T cell costimulation",
  "GO:2000524": "negative regulation of T cell costimulation",
  "GO:2000525": "positive regulation of T cell costimulation",
  "GO:2000526": "positive regulation of glycoprotein biosynthetic process involved in immunological synapse formation",
  "GO:2000527": "regulation of myeloid dendritic cell chemotaxis",
  "GO:2000528": "negative regulation of myeloid dendritic cell chemotaxis",
  "GO:2000529": "positive regulation of myeloid dendritic cell chemotaxis",
  "GO:2000530": "obsolete positive regulation of regulation of insulin secretion involved in cellular response to glucose stimulus",
  "GO:2000531": "regulation of fatty acid biosynthetic process by regulation of transcription from RNA polymerase II promoter",
  "GO:2000532": "regulation of renal albumin absorption",
  "GO:2000533": "negative regulation of renal albumin absorption",
  "GO:2000534": "positive regulation of renal albumin absorption",
  "GO:2000535": "regulation of entry of bacterium into host cell",
  "GO:2000536": "negative regulation of entry of bacterium into host cell",
  "GO:2000537": "regulation of B cell chemotaxis",
  "GO:2000538": "positive regulation of B cell chemotaxis",
  "GO:2000539": "regulation of protein geranylgeranylation",
  "GO:2000540": "negative regulation of protein geranylgeranylation",
  "GO:2000541": "positive regulation of protein geranylgeranylation",
  "GO:2000542": "negative regulation of gastrulation",
  "GO:2000543": "positive regulation of gastrulation",
  "GO:2000544": "regulation of endothelial cell chemotaxis to fibroblast growth factor",
  "GO:2000545": "negative regulation of endothelial cell chemotaxis to fibroblast growth factor",
  "GO:2000546": "positive regulation of endothelial cell chemotaxis to fibroblast growth factor",
  "GO:2000547": "regulation of dendritic cell dendrite assembly",
  "GO:2000548": "negative regulation of dendritic cell dendrite assembly",
  "GO:2000549": "positive regulation of dendritic cell dendrite assembly",
  "GO:2000550": "negative regulation of B cell chemotaxis",
  "GO:2000551": "regulation of T-helper 2 cell cytokine production",
  "GO:2000552": "negative regulation of T-helper 2 cell cytokine production",
  "GO:2000553": "positive regulation of T-helper 2 cell cytokine production",
  "GO:2000554": "regulation of T-helper 1 cell cytokine production",
  "GO:2000555": "negative regulation of T-helper 1 cell cytokine production",
  "GO:2000556": "positive regulation of T-helper 1 cell cytokine production",
  "GO:2000557": "regulation of immunoglobulin production in mucosal tissue",
  "GO:2000558": "positive regulation of immunoglobulin production in mucosal tissue",
  "GO:2000559": "regulation of CD24 biosynthetic process",
  "GO:2000560": "positive regulation of CD24 biosynthetic process",
  "GO:2000561": "regulation of CD4-positive, alpha-beta T cell proliferation",
  "GO:2000562": "negative regulation of CD4-positive, alpha-beta T cell proliferation",
  "GO:2000563": "positive regulation of CD4-positive, alpha-beta T cell proliferation",
  "GO:2000564": "regulation of CD8-positive, alpha-beta T cell proliferation",
  "GO:2000565": "negative regulation of CD8-positive, alpha-beta T cell proliferation",
  "GO:2000566": "positive regulation of CD8-positive, alpha-beta T cell proliferation",
  "GO:2000567": "regulation of memory T cell activation",
  "GO:2000568": "positive regulation of memory T cell activation",
  "GO:2000569": "regulation of T-helper 2 cell activation",
  "GO:2000570": "positive regulation of T-helper 2 cell activation",
  "GO:2000571": "regulation of interleukin-4-dependent isotype switching to IgE isotypes",
  "GO:2000572": "positive regulation of interleukin-4-dependent isotype switching to IgE isotypes",
  "GO:2000573": "positive regulation of DNA biosynthetic process",
  "GO:2000574": "regulation of microtubule motor activity",
  "GO:2000575": "negative regulation of microtubule motor activity",
  "GO:2000576": "positive regulation of microtubule motor activity",
  "GO:2000577": "regulation of ATP-dependent microtubule motor activity, minus-end-directed",
  "GO:2000578": "negative regulation of ATP-dependent microtubule motor activity, minus-end-directed",
  "GO:2000579": "positive regulation of ATP-dependent microtubule motor activity, minus-end-directed",
  "GO:2000580": "regulation of ATP-dependent microtubule motor activity, plus-end-directed",
  "GO:2000581": "negative regulation of ATP-dependent microtubule motor activity, plus-end-directed",
  "GO:2000582": "positive regulation of ATP-dependent microtubule motor activity, plus-end-directed",
  "GO:2000583": "regulation of platelet-derived growth factor receptor-alpha signaling pathway",
  "GO:2000584": "negative regulation of platelet-derived growth factor receptor-alpha signaling pathway",
  "GO:2000585": "positive regulation of platelet-derived growth factor receptor-alpha signaling pathway",
  "GO:2000586": "regulation of platelet-derived growth factor receptor-beta signaling pathway",
  "GO:2000587": "negative regulation of platelet-derived growth factor receptor-beta signaling pathway",
  "GO:2000588": "positive regulation of platelet-derived growth factor receptor-beta signaling pathway",
  "GO:2000589": "regulation of metanephric mesenchymal cell migration",
  "GO:2000590": "negative regulation of metanephric mesenchymal cell migration",
  "GO:2000591": "positive regulation of metanephric mesenchymal cell migration",
  "GO:2000592": "regulation of metanephric DCT cell differentiation",
  "GO:2000593": "negative regulation of metanephric DCT cell differentiation",
  "GO:2000594": "positive regulation of metanephric DCT cell differentiation",
  "GO:2000595": "regulation of optic nerve formation",
  "GO:2000596": "negative regulation of optic nerve formation",
  "GO:2000597": "positive regulation of optic nerve formation",
  "GO:2000598": "regulation of cyclin catabolic process",
  "GO:2000599": "negative regulation of cyclin catabolic process",
  "GO:2000600": "positive regulation of cyclin catabolic process",
  "GO:2000601": "positive regulation of Arp2/3 complex-mediated actin nucleation",
  "GO:2000602": "obsolete regulation of interphase of mitotic cell cycle",
  "GO:2000603": "regulation of secondary growth",
  "GO:2000604": "negative regulation of secondary growth",
  "GO:2000605": "positive regulation of secondary growth",
  "GO:2000606": "regulation of cell proliferation involved in mesonephros development",
  "GO:2000607": "negative regulation of cell proliferation involved in mesonephros development",
  "GO:2000608": "positive regulation of cell proliferation involved in mesonephros development",
  "GO:2000609": "regulation of thyroid hormone generation",
  "GO:2000610": "negative regulation of thyroid hormone generation",
  "GO:2000611": "positive regulation of thyroid hormone generation",
  "GO:2000612": "regulation of thyroid-stimulating hormone secretion",
  "GO:2000613": "negative regulation of thyroid-stimulating hormone secretion",
  "GO:2000614": "positive regulation of thyroid-stimulating hormone secretion",
  "GO:2000615": "regulation of histone H3-K9 acetylation",
  "GO:2000616": "negative regulation of histone H3-K9 acetylation",
  "GO:2000617": "positive regulation of histone H3-K9 acetylation",
  "GO:2000618": "regulation of histone H4-K16 acetylation",
  "GO:2000619": "negative regulation of histone H4-K16 acetylation",
  "GO:2000620": "positive regulation of histone H4-K16 acetylation",
  "GO:2000621": "regulation of DNA replication termination",
  "GO:2000622": "regulation of nuclear-transcribed mRNA catabolic process, nonsense-mediated decay",
  "GO:2000623": "negative regulation of nuclear-transcribed mRNA catabolic process, nonsense-mediated decay",
  "GO:2000624": "positive regulation of nuclear-transcribed mRNA catabolic process, nonsense-mediated decay",
  "GO:2000625": "regulation of miRNA catabolic process",
  "GO:2000626": "negative regulation of miRNA catabolic process",
  "GO:2000627": "positive regulation of miRNA catabolic process",
  "GO:2000628": "regulation of miRNA metabolic process",
  "GO:2000629": "negative regulation of miRNA metabolic process",
  "GO:2000630": "positive regulation of miRNA metabolic process",
  "GO:2000631": "regulation of pre-miRNA processing",
  "GO:2000632": "negative regulation of pre-miRNA processing",
  "GO:2000633": "positive regulation of pre-miRNA processing",
  "GO:2000634": "regulation of primary miRNA processing",
  "GO:2000635": "negative regulation of primary miRNA processing",
  "GO:2000636": "positive regulation of primary miRNA processing",
  "GO:2000637": "positive regulation of gene silencing by miRNA",
  "GO:2000638": "regulation of SREBP signaling pathway",
  "GO:2000639": "negative regulation of SREBP signaling pathway",
  "GO:2000640": "positive regulation of SREBP signaling pathway",
  "GO:2000641": "regulation of early endosome to late endosome transport",
  "GO:2000642": "negative regulation of early endosome to late endosome transport",
  "GO:2000643": "positive regulation of early endosome to late endosome transport",
  "GO:2000644": "regulation of receptor catabolic process",
  "GO:2000645": "negative regulation of receptor catabolic process",
  "GO:2000646": "positive regulation of receptor catabolic process",
  "GO:2000647": "negative regulation of stem cell proliferation",
  "GO:2000648": "positive regulation of stem cell proliferation",
  "GO:2000649": "regulation of sodium ion transmembrane transporter activity",
  "GO:2000650": "negative regulation of sodium ion transmembrane transporter activity",
  "GO:2000651": "positive regulation of sodium ion transmembrane transporter activity",
  "GO:2000652": "regulation of secondary cell wall biogenesis",
  "GO:2000653": "regulation of genetic imprinting",
  "GO:2000654": "regulation of cellular response to testosterone stimulus",
  "GO:2000655": "negative regulation of cellular response to testosterone stimulus",
  "GO:2000656": "regulation of apolipoprotein binding",
  "GO:2000657": "negative regulation of apolipoprotein binding",
  "GO:2000658": "positive regulation of apolipoprotein binding",
  "GO:2000659": "regulation of interleukin-1-mediated signaling pathway",
  "GO:2000660": "negative regulation of interleukin-1-mediated signaling pathway",
  "GO:2000661": "positive regulation of interleukin-1-mediated signaling pathway",
  "GO:2000662": "regulation of interleukin-5 secretion",
  "GO:2000663": "negative regulation of interleukin-5 secretion",
  "GO:2000664": "positive regulation of interleukin-5 secretion",
  "GO:2000665": "regulation of interleukin-13 secretion",
  "GO:2000666": "negative regulation of interleukin-13 secretion",
  "GO:2000667": "positive regulation of interleukin-13 secretion",
  "GO:2000668": "regulation of dendritic cell apoptotic process",
  "GO:2000669": "negative regulation of dendritic cell apoptotic process",
  "GO:2000670": "positive regulation of dendritic cell apoptotic process",
  "GO:2000671": "regulation of motor neuron apoptotic process",
  "GO:2000672": "negative regulation of motor neuron apoptotic process",
  "GO:2000673": "positive regulation of motor neuron apoptotic process",
  "GO:2000674": "regulation of type B pancreatic cell apoptotic process",
  "GO:2000675": "negative regulation of type B pancreatic cell apoptotic process",
  "GO:2000676": "positive regulation of type B pancreatic cell apoptotic process",
  "GO:2000677": "regulation of transcription regulatory region DNA binding",
  "GO:2000678": "negative regulation of transcription regulatory region DNA binding",
  "GO:2000679": "positive regulation of transcription regulatory region DNA binding",
  "GO:2000680": "regulation of rubidium ion transport",
  "GO:2000681": "negative regulation of rubidium ion transport",
  "GO:2000682": "positive regulation of rubidium ion transport",
  "GO:2000683": "regulation of cellular response to X-ray",
  "GO:2000684": "negative regulation of cellular response to X-ray",
  "GO:2000685": "positive regulation of cellular response to X-ray",
  "GO:2000686": "regulation of rubidium ion transmembrane transporter activity",
  "GO:2000687": "negative regulation of rubidium ion transmembrane transporter activity",
  "GO:2000688": "positive regulation of rubidium ion transmembrane transporter activity",
  "GO:2000689": "actomyosin contractile ring assembly actin filament organization",
  "GO:2000690": "regulation of cardiac muscle cell myoblast differentiation",
  "GO:2000691": "negative regulation of cardiac muscle cell myoblast differentiation",
  "GO:2000692": "negative regulation of seed maturation",
  "GO:2000693": "positive regulation of seed maturation",
  "GO:2000694": "regulation of phragmoplast microtubule organization",
  "GO:2000696": "regulation of epithelial cell differentiation involved in kidney development",
  "GO:2000697": "negative regulation of epithelial cell differentiation involved in kidney development",
  "GO:2000698": "positive regulation of epithelial cell differentiation involved in kidney development",
  "GO:2000699": "fibroblast growth factor receptor signaling pathway involved in ureteric bud formation",
  "GO:2000700": "positive regulation of cardiac muscle cell myoblast differentiation",
  "GO:2000701": "glial cell-derived neurotrophic factor receptor signaling pathway involved in ureteric bud formation",
  "GO:2000702": "regulation of fibroblast growth factor receptor signaling pathway involved in ureteric bud formation",
  "GO:2000703": "negative regulation of fibroblast growth factor receptor signaling pathway involved in ureteric bud formation",
  "GO:2000704": "positive regulation of fibroblast growth factor receptor signaling pathway involved in ureteric bud formation",
  "GO:2000705": "regulation of dense core granule biogenesis",
  "GO:2000706": "negative regulation of dense core granule biogenesis",
  "GO:2000707": "positive regulation of dense core granule biogenesis",
  "GO:2000708": "myosin filament organization involved in cytokinetic actomyosin contractile ring assembly",
  "GO:2000709": "regulation of maintenance of meiotic sister chromatid cohesion, centromeric",
  "GO:2000710": "negative regulation of maintenance of meiotic sister chromatid cohesion, centromeric",
  "GO:2000711": "positive regulation of maintenance of meiotic sister chromatid cohesion, centromeric",
  "GO:2000712": "regulation of maintenance of meiotic sister chromatid cohesion, arms",
  "GO:2000713": "negative regulation of maintenance of meiotic sister chromatid cohesion, arms",
  "GO:2000714": "positive regulation of maintenance of meiotic sister chromatid cohesion, arms",
  "GO:2000715": "regulation of maintenance of mitotic sister chromatid cohesion, arms",
  "GO:2000716": "negative regulation of maintenance of mitotic sister chromatid cohesion, arms",
  "GO:2000717": "positive regulation of maintenance of mitotic sister chromatid cohesion, arms",
  "GO:2000718": "regulation of maintenance of mitotic sister chromatid cohesion, centromeric",
  "GO:2000719": "negative regulation of maintenance of mitotic sister chromatid cohesion, centromeric",
  "GO:2000720": "positive regulation of maintenance of mitotic sister chromatid cohesion, centromeric",
  "GO:2000721": "positive regulation of transcription from RNA polymerase II promoter involved in smooth muscle cell differentiation",
  "GO:2000722": "regulation of cardiac vascular smooth muscle cell differentiation",
  "GO:2000723": "negative regulation of cardiac vascular smooth muscle cell differentiation",
  "GO:2000724": "positive regulation of cardiac vascular smooth muscle cell differentiation",
  "GO:2000725": "regulation of cardiac muscle cell differentiation",
  "GO:2000726": "negative regulation of cardiac muscle cell differentiation",
  "GO:2000727": "positive regulation of cardiac muscle cell differentiation",
  "GO:2000728": "regulation of mRNA export from nucleus in response to heat stress",
  "GO:2000729": "positive regulation of mesenchymal cell proliferation involved in ureter development",
  "GO:2000730": "regulation of termination of RNA polymerase I transcription",
  "GO:2000731": "negative regulation of termination of RNA polymerase I transcription",
  "GO:2000732": "positive regulation of termination of RNA polymerase I transcription",
  "GO:2000733": "regulation of glial cell-derived neurotrophic factor receptor signaling pathway involved in ureteric bud formation",
  "GO:2000734": "negative regulation of glial cell-derived neurotrophic factor receptor signaling pathway involved in ureteric bud formation",
  "GO:2000735": "positive regulation of glial cell-derived neurotrophic factor receptor signaling pathway involved in ureteric bud formation",
  "GO:2000736": "regulation of stem cell differentiation",
  "GO:2000737": "negative regulation of stem cell differentiation",
  "GO:2000738": "positive regulation of stem cell differentiation",
  "GO:2000739": "regulation of mesenchymal stem cell differentiation",
  "GO:2000740": "negative regulation of mesenchymal stem cell differentiation",
  "GO:2000741": "positive regulation of mesenchymal stem cell differentiation",
  "GO:2000742": "regulation of anterior head development",
  "GO:2000743": "negative regulation of anterior head development",
  "GO:2000744": "positive regulation of anterior head development",
  "GO:2000745": "obsolete positive regulation of transcription from RNA polymerase III promoter involved in smooth muscle cell differentiation",
  "GO:2000746": "regulation of defecation rhythm",
  "GO:2000747": "negative regulation of defecation rhythm",
  "GO:2000748": "positive regulation of defecation rhythm",
  "GO:2000749": "positive regulation of chromatin silencing at rDNA",
  "GO:2000750": "negative regulation of establishment or maintenance of bipolar cell polarity regulating cell shape",
  "GO:2000751": "histone H3-T3 phosphorylation involved in chromosome passenger complex localization to kinetochore",
  "GO:2000752": "regulation of glucosylceramide catabolic process",
  "GO:2000753": "positive regulation of glucosylceramide catabolic process",
  "GO:2000754": "regulation of sphingomyelin catabolic process",
  "GO:2000755": "positive regulation of sphingomyelin catabolic process",
  "GO:2000756": "regulation of peptidyl-lysine acetylation",
  "GO:2000757": "negative regulation of peptidyl-lysine acetylation",
  "GO:2000758": "positive regulation of peptidyl-lysine acetylation",
  "GO:2000759": "regulation of N-terminal peptidyl-lysine acetylation",
  "GO:2000760": "negative regulation of N-terminal peptidyl-lysine acetylation",
  "GO:2000761": "positive regulation of N-terminal peptidyl-lysine acetylation",
  "GO:2000762": "regulation of phenylpropanoid metabolic process",
  "GO:2000763": "positive regulation of transcription from RNA polymerase II promoter involved in norepinephrine biosynthetic process",
  "GO:2000764": "positive regulation of semaphorin-plexin signaling pathway involved in outflow tract morphogenesis",
  "GO:2000765": "regulation of cytoplasmic translation",
  "GO:2000766": "negative regulation of cytoplasmic translation",
  "GO:2000767": "positive regulation of cytoplasmic translation",
  "GO:2000768": "positive regulation of nephron tubule epithelial cell differentiation",
  "GO:2000769": "regulation of establishment or maintenance of cell polarity regulating cell shape",
  "GO:2000770": "negative regulation of establishment or maintenance of cell polarity regulating cell shape",
  "GO:2000771": "positive regulation of establishment or maintenance of cell polarity regulating cell shape",
  "GO:2000772": "regulation of cellular senescence",
  "GO:2000773": "negative regulation of cellular senescence",
  "GO:2000774": "positive regulation of cellular senescence",
  "GO:2000775": "histone H3-S10 phosphorylation involved in chromosome condensation",
  "GO:2000776": "histone H4 acetylation involved in response to DNA damage stimulus",
  "GO:2000777": "positive regulation of proteasomal ubiquitin-dependent protein catabolic process involved in cellular response to hypoxia",
  "GO:2000778": "positive regulation of interleukin-6 secretion",
  "GO:2000779": "regulation of double-strand break repair",
  "GO:2000780": "negative regulation of double-strand break repair",
  "GO:2000781": "positive regulation of double-strand break repair",
  "GO:2000782": "regulation of establishment of cell polarity regulating cell shape",
  "GO:2000783": "negative regulation of establishment of cell polarity regulating cell shape",
  "GO:2000784": "positive regulation of establishment of cell polarity regulating cell shape",
  "GO:2000785": "regulation of autophagosome assembly",
  "GO:2000786": "positive regulation of autophagosome assembly",
  "GO:2000787": "regulation of venous endothelial cell fate commitment",
  "GO:2000788": "negative regulation of venous endothelial cell fate commitment",
  "GO:2000789": "positive regulation of venous endothelial cell fate commitment",
  "GO:2000790": "regulation of mesenchymal cell proliferation involved in lung development",
  "GO:2000791": "negative regulation of mesenchymal cell proliferation involved in lung development",
  "GO:2000792": "positive regulation of mesenchymal cell proliferation involved in lung development",
  "GO:2000793": "cell proliferation involved in heart valve development",
  "GO:2000794": "regulation of epithelial cell proliferation involved in lung morphogenesis",
  "GO:2000795": "negative regulation of epithelial cell proliferation involved in lung morphogenesis",
  "GO:2000796": "Notch signaling pathway involved in negative regulation of venous endothelial cell fate commitment",
  "GO:2000797": "regulation of amniotic stem cell differentiation",
  "GO:2000798": "negative regulation of amniotic stem cell differentiation",
  "GO:2000799": "positive regulation of amniotic stem cell differentiation",
  "GO:2000800": "regulation of endocardial cushion to mesenchymal transition involved in heart valve formation",
  "GO:2000801": "negative regulation of endocardial cushion to mesenchymal transition involved in heart valve formation",
  "GO:2000802": "positive regulation of endocardial cushion to mesenchymal transition involved in heart valve formation",
  "GO:2000803": "endosomal signal transduction",
  "GO:2000804": "regulation of termination of RNA polymerase II transcription, poly(A)-coupled",
  "GO:2000805": "negative regulation of termination of RNA polymerase II transcription, poly(A)-coupled",
  "GO:2000806": "positive regulation of termination of RNA polymerase II transcription, poly(A)-coupled",
  "GO:2000807": "regulation of synaptic vesicle clustering",
  "GO:2000808": "negative regulation of synaptic vesicle clustering",
  "GO:2000809": "positive regulation of synaptic vesicle clustering",
  "GO:2000810": "regulation of bicellular tight junction assembly",
  "GO:2000811": "negative regulation of anoikis",
  "GO:2000812": "regulation of barbed-end actin filament capping",
  "GO:2000813": "negative regulation of barbed-end actin filament capping",
  "GO:2000814": "positive regulation of barbed-end actin filament capping",
  "GO:2000815": "regulation of mRNA stability involved in response to oxidative stress",
  "GO:2000816": "negative regulation of mitotic sister chromatid separation",
  "GO:2000817": "regulation of histone H3-T3 phosphorylation involved in chromosome passenger complex localization to kinetochore",
  "GO:2000818": "negative regulation of myoblast proliferation",
  "GO:2000819": "regulation of nucleotide-excision repair",
  "GO:2000820": "negative regulation of transcription from RNA polymerase II promoter involved in smooth muscle cell differentiation",
  "GO:2000821": "regulation of grooming behavior",
  "GO:2000822": "regulation of behavioral fear response",
  "GO:2000823": "regulation of androgen receptor activity",
  "GO:2000824": "negative regulation of androgen receptor activity",
  "GO:2000825": "positive regulation of androgen receptor activity",
  "GO:2000826": "regulation of heart morphogenesis",
  "GO:2000827": "mitochondrial RNA surveillance",
  "GO:2000828": "regulation of parathyroid hormone secretion",
  "GO:2000829": "negative regulation of parathyroid hormone secretion",
  "GO:2000830": "positive regulation of parathyroid hormone secretion",
  "GO:2000831": "regulation of steroid hormone secretion",
  "GO:2000832": "negative regulation of steroid hormone secretion",
  "GO:2000833": "positive regulation of steroid hormone secretion",
  "GO:2000834": "regulation of androgen secretion",
  "GO:2000835": "negative regulation of androgen secretion",
  "GO:2000836": "positive regulation of androgen secretion",
  "GO:2000837": "regulation of androstenedione secretion",
  "GO:2000838": "negative regulation of androstenedione secretion",
  "GO:2000839": "positive regulation of androstenedione secretion",
  "GO:2000840": "regulation of dehydroepiandrosterone secretion",
  "GO:2000841": "negative regulation of dehydroepiandrosterone secretion",
  "GO:2000842": "positive regulation of dehydroepiandrosterone secretion",
  "GO:2000843": "regulation of testosterone secretion",
  "GO:2000844": "negative regulation of testosterone secretion",
  "GO:2000845": "positive regulation of testosterone secretion",
  "GO:2000846": "regulation of corticosteroid hormone secretion",
  "GO:2000847": "negative regulation of corticosteroid hormone secretion",
  "GO:2000848": "positive regulation of corticosteroid hormone secretion",
  "GO:2000849": "regulation of glucocorticoid secretion",
  "GO:2000850": "negative regulation of glucocorticoid secretion",
  "GO:2000851": "positive regulation of glucocorticoid secretion",
  "GO:2000852": "regulation of corticosterone secretion",
  "GO:2000853": "negative regulation of corticosterone secretion",
  "GO:2000854": "positive regulation of corticosterone secretion",
  "GO:2000855": "regulation of mineralocorticoid secretion",
  "GO:2000856": "negative regulation of mineralocorticoid secretion",
  "GO:2000857": "positive regulation of mineralocorticoid secretion",
  "GO:2000858": "regulation of aldosterone secretion",
  "GO:2000859": "negative regulation of aldosterone secretion",
  "GO:2000860": "positive regulation of aldosterone secretion",
  "GO:2000861": "regulation of estrogen secretion",
  "GO:2000862": "negative regulation of estrogen secretion",
  "GO:2000863": "positive regulation of estrogen secretion",
  "GO:2000864": "regulation of estradiol secretion",
  "GO:2000865": "negative regulation of estradiol secretion",
  "GO:2000866": "positive regulation of estradiol secretion",
  "GO:2000867": "regulation of estrone secretion",
  "GO:2000868": "negative regulation of estrone secretion",
  "GO:2000869": "positive regulation of estrone secretion",
  "GO:2000870": "regulation of progesterone secretion",
  "GO:2000871": "negative regulation of progesterone secretion",
  "GO:2000872": "positive regulation of progesterone secretion",
  "GO:2000873": "regulation of histone H4 acetylation involved in response to DNA damage stimulus",
  "GO:2000874": "regulation of glyoxylate cycle",
  "GO:2000875": "negative regulation of glyoxylate cycle",
  "GO:2000876": "positive regulation of glyoxylate cycle",
  "GO:2000877": "negative regulation of oligopeptide transport",
  "GO:2000878": "positive regulation of oligopeptide transport",
  "GO:2000879": "negative regulation of dipeptide transport",
  "GO:2000880": "positive regulation of dipeptide transport",
  "GO:2000881": "regulation of starch catabolic process",
  "GO:2000882": "negative regulation of starch catabolic process",
  "GO:2000883": "positive regulation of starch catabolic process",
  "GO:2000884": "glucomannan catabolic process",
  "GO:2000885": "galactoglucomannan catabolic process",
  "GO:2000886": "glucuronoxylan catabolic process",
  "GO:2000887": "glucuronoarabinoxylan catabolic process",
  "GO:2000888": "arabinoxylan-containing compound catabolic process",
  "GO:2000889": "cellodextrin metabolic process",
  "GO:2000890": "cellodextrin catabolic process",
  "GO:2000891": "cellobiose metabolic process",
  "GO:2000892": "cellobiose catabolic process",
  "GO:2000893": "cellotriose metabolic process",
  "GO:2000894": "cellotriose catabolic process",
  "GO:2000895": "hemicellulose catabolic process",
  "GO:2000896": "amylopectin metabolic process",
  "GO:2000897": "amylopectin catabolic process",
  "GO:2000898": "regulation of glucomannan catabolic process",
  "GO:2000899": "xyloglucan catabolic process",
  "GO:2000900": "cyclodextrin metabolic process",
  "GO:2000901": "cyclodextrin catabolic process",
  "GO:2000902": "cellooligosaccharide metabolic process",
  "GO:2000903": "cellooligosaccharide catabolic process",
  "GO:2000904": "regulation of starch metabolic process",
  "GO:2000905": "negative regulation of starch metabolic process",
  "GO:2000906": "positive regulation of starch metabolic process",
  "GO:2000907": "negative regulation of glucomannan catabolic process",
  "GO:2000908": "positive regulation of glucomannan catabolic process",
  "GO:2000909": "regulation of sterol import",
  "GO:2000910": "negative regulation of sterol import",
  "GO:2000911": "positive regulation of sterol import",
  "GO:2000912": "regulation of galactoglucomannan catabolic process",
  "GO:2000913": "negative regulation of galactoglucomannan catabolic process",
  "GO:2000914": "positive regulation of galactoglucomannan catabolic process",
  "GO:2000915": "regulation of glucuronoxylan catabolic process",
  "GO:2000916": "negative regulation of glucuronoxylan catabolic process",
  "GO:2000917": "positive regulation of glucuronoxylan catabolic process",
  "GO:2000918": "regulation of glucuronoarabinoxylan catabolic process",
  "GO:2000919": "negative regulation of glucuronoarabinoxylan catabolic process",
  "GO:2000920": "positive regulation of glucuronoarabinoxylan catabolic process",
  "GO:2000921": "regulation of arabinoxylan-containing compound catabolic process",
  "GO:2000922": "negative regulation of arabinoxylan-containing compound catabolic process",
  "GO:2000923": "positive regulation of arabinoxylan-containing compound catabolic process",
  "GO:2000924": "regulation of cellodextrin metabolic process",
  "GO:2000925": "negative regulation of cellodextrin metabolic process",
  "GO:2000926": "positive regulation of cellodextrin metabolic process",
  "GO:2000927": "regulation of cellodextrin catabolic process",
  "GO:2000928": "negative regulation of cellodextrin catabolic process",
  "GO:2000929": "positive regulation of cellodextrin catabolic process",
  "GO:2000930": "regulation of cellobiose metabolic process",
  "GO:2000931": "negative regulation of cellobiose metabolic process",
  "GO:2000932": "positive regulation of cellobiose metabolic process",
  "GO:2000933": "regulation of cellotriose metabolic process",
  "GO:2000934": "negative regulation of cellotriose metabolic process",
  "GO:2000935": "positive regulation of cellotriose metabolic process",
  "GO:2000936": "regulation of cellotriose catabolic process",
  "GO:2000937": "negative regulation of cellotriose catabolic process",
  "GO:2000938": "positive regulation of cellotriose catabolic process",
  "GO:2000939": "regulation of plant-type cell wall cellulose catabolic process",
  "GO:2000940": "negative regulation of plant-type cell wall cellulose catabolic process",
  "GO:2000941": "positive regulation of plant-type cell wall cellulose catabolic process",
  "GO:2000942": "regulation of amylopectin metabolic process",
  "GO:2000943": "negative regulation of amylopectin metabolic process",
  "GO:2000944": "positive regulation of amylopectin metabolic process",
  "GO:2000945": "regulation of amylopectin catabolic process",
  "GO:2000946": "negative regulation of amylopectin catabolic process",
  "GO:2000947": "positive regulation of amylopectin catabolic process",
  "GO:2000948": "regulation of xyloglucan metabolic process",
  "GO:2000949": "negative regulation of xyloglucan metabolic process",
  "GO:2000950": "positive regulation of xyloglucan metabolic process",
  "GO:2000951": "regulation of xyloglucan catabolic process",
  "GO:2000952": "negative regulation of xyloglucan catabolic process",
  "GO:2000953": "positive regulation of xyloglucan catabolic process",
  "GO:2000954": "regulation of cyclodextrin metabolic process",
  "GO:2000955": "negative regulation of cyclodextrin metabolic process",
  "GO:2000956": "positive regulation of cyclodextrin metabolic process",
  "GO:2000957": "regulation of cyclodextrin catabolic process",
  "GO:2000958": "negative regulation of cyclodextrin catabolic process",
  "GO:2000959": "positive regulation of cyclodextrin catabolic process",
  "GO:2000960": "regulation of cellooligosaccharide metabolic process",
  "GO:2000961": "negative regulation of cellooligosaccharide metabolic process",
  "GO:2000962": "positive regulation of cellooligosaccharide metabolic process",
  "GO:2000963": "regulation of cellooligosaccharide catabolic process",
  "GO:2000964": "negative regulation of cellooligosaccharide catabolic process",
  "GO:2000965": "positive regulation of cellooligosaccharide catabolic process",
  "GO:2000966": "regulation of cell wall polysaccharide catabolic process",
  "GO:2000967": "negative regulation of cell wall polysaccharide catabolic process",
  "GO:2000968": "positive regulation of cell wall polysaccharide catabolic process",
  "GO:2000969": "positive regulation of alpha-amino-3-hydroxy-5-methyl-4-isoxazole propionate selective glutamate receptor activity",
  "GO:2000970": "regulation of detection of glucose",
  "GO:2000971": "negative regulation of detection of glucose",
  "GO:2000972": "positive regulation of detection of glucose",
  "GO:2000973": "regulation of pro-B cell differentiation",
  "GO:2000974": "negative regulation of pro-B cell differentiation",
  "GO:2000975": "positive regulation of pro-B cell differentiation",
  "GO:2000976": "obsolete regulation of transcription from RNA polymerase II promoter involved in detection of glucose",
  "GO:2000977": "regulation of forebrain neuron differentiation",
  "GO:2000978": "negative regulation of forebrain neuron differentiation",
  "GO:2000979": "positive regulation of forebrain neuron differentiation",
  "GO:2000980": "regulation of inner ear receptor cell differentiation",
  "GO:2000981": "negative regulation of inner ear receptor cell differentiation",
  "GO:2000982": "positive regulation of inner ear receptor cell differentiation",
  "GO:2000983": "regulation of ATP citrate synthase activity",
  "GO:2000984": "negative regulation of ATP citrate synthase activity",
  "GO:2000985": "positive regulation of ATP citrate synthase activity",
  "GO:2000986": "negative regulation of behavioral fear response",
  "GO:2000987": "positive regulation of behavioral fear response",
  "GO:2000988": "regulation of hemicellulose catabolic process",
  "GO:2000989": "negative regulation of hemicellulose catabolic process",
  "GO:2000990": "positive regulation of hemicellulose catabolic process",
  "GO:2000991": "regulation of galactomannan catabolic process",
  "GO:2000992": "negative regulation of galactomannan catabolic process",
  "GO:2000993": "positive regulation of galactomannan catabolic process",
  "GO:2000994": "regulation of mannan catabolic process",
  "GO:2000995": "negative regulation of mannan catabolic process",
  "GO:2000996": "positive regulation of mannan catabolic process",
  "GO:2000997": "regulation of cellulose catabolic process",
  "GO:2000998": "negative regulation of cellulose catabolic process",
  "GO:2000999": "positive regulation of cellulose catabolic process",
  "GO:2001000": "regulation of xylan catabolic process",
  "GO:2001001": "negative regulation of xylan catabolic process",
  "GO:2001002": "positive regulation of xylan catabolic process",
  "GO:2001003": "regulation of pectin catabolic process",
  "GO:2001004": "negative regulation of pectin catabolic process",
  "GO:2001005": "positive regulation of pectin catabolic process",
  "GO:2001006": "regulation of cellulose biosynthetic process",
  "GO:2001007": "negative regulation of cellulose biosynthetic process",
  "GO:2001008": "positive regulation of cellulose biosynthetic process",
  "GO:2001009": "regulation of plant-type cell wall cellulose biosynthetic process",
  "GO:2001010": "negative regulation of plant-type cell wall cellulose biosynthetic process",
  "GO:2001011": "positive regulation of plant-type cell wall cellulose biosynthetic process",
  "GO:2001012": "mesenchymal cell differentiation involved in renal system development",
  "GO:2001013": "epithelial cell proliferation involved in renal tubule morphogenesis",
  "GO:2001014": "regulation of skeletal muscle cell differentiation",
  "GO:2001015": "negative regulation of skeletal muscle cell differentiation",
  "GO:2001016": "positive regulation of skeletal muscle cell differentiation",
  "GO:2001017": "regulation of retrograde axon cargo transport",
  "GO:2001018": "negative regulation of retrograde axon cargo transport",
  "GO:2001019": "positive regulation of retrograde axon cargo transport",
  "GO:2001020": "regulation of response to DNA damage stimulus",
  "GO:2001021": "negative regulation of response to DNA damage stimulus",
  "GO:2001022": "positive regulation of response to DNA damage stimulus",
  "GO:2001023": "regulation of response to drug",
  "GO:2001024": "negative regulation of response to drug",
  "GO:2001025": "positive regulation of response to drug",
  "GO:2001026": "regulation of endothelial cell chemotaxis",
  "GO:2001027": "negative regulation of endothelial cell chemotaxis",
  "GO:2001028": "positive regulation of endothelial cell chemotaxis",
  "GO:2001029": "regulation of cellular glucuronidation",
  "GO:2001030": "negative regulation of cellular glucuronidation",
  "GO:2001031": "positive regulation of cellular glucuronidation",
  "GO:2001032": "regulation of double-strand break repair via nonhomologous end joining",
  "GO:2001033": "negative regulation of double-strand break repair via nonhomologous end joining",
  "GO:2001034": "positive regulation of double-strand break repair via nonhomologous end joining",
  "GO:2001035": "regulation of tongue muscle cell differentiation",
  "GO:2001036": "negative regulation of tongue muscle cell differentiation",
  "GO:2001037": "positive regulation of tongue muscle cell differentiation",
  "GO:2001038": "regulation of cellular response to drug",
  "GO:2001039": "negative regulation of cellular response to drug",
  "GO:2001040": "positive regulation of cellular response to drug",
  "GO:2001042": "negative regulation of cell separation after cytokinesis",
  "GO:2001043": "positive regulation of cell separation after cytokinesis",
  "GO:2001044": "regulation of integrin-mediated signaling pathway",
  "GO:2001045": "negative regulation of integrin-mediated signaling pathway",
  "GO:2001046": "positive regulation of integrin-mediated signaling pathway",
  "GO:2001049": "regulation of tendon cell differentiation",
  "GO:2001050": "negative regulation of tendon cell differentiation",
  "GO:2001051": "positive regulation of tendon cell differentiation",
  "GO:2001053": "regulation of mesenchymal cell apoptotic process",
  "GO:2001054": "negative regulation of mesenchymal cell apoptotic process",
  "GO:2001055": "positive regulation of mesenchymal cell apoptotic process",
  "GO:2001056": "positive regulation of cysteine-type endopeptidase activity",
  "GO:2001057": "reactive nitrogen species metabolic process",
  "GO:2001058": "D-tagatose 6-phosphate metabolic process",
  "GO:2001059": "D-tagatose 6-phosphate catabolic process",
  "GO:2001060": "D-glycero-D-manno-heptose 7-phosphate metabolic process",
  "GO:2001061": "D-glycero-D-manno-heptose 7-phosphate biosynthetic process",
  "GO:2001062": "xylan binding",
  "GO:2001063": "glucomannan binding",
  "GO:2001064": "cellooligosaccharide binding",
  "GO:2001065": "mannan binding",
  "GO:2001066": "amylopectin binding",
  "GO:2001067": "pullulan binding",
  "GO:2001068": "arabinoxylan binding",
  "GO:2001069": "glycogen binding",
  "GO:2001070": "starch binding",
  "GO:2001071": "maltoheptaose binding",
  "GO:2001072": "galactomannan binding",
  "GO:2001073": "cyclodextrin binding",
  "GO:2001074": "regulation of metanephric ureteric bud development",
  "GO:2001075": "negative regulation of metanephric ureteric bud development",
  "GO:2001076": "positive regulation of metanephric ureteric bud development",
  "GO:2001077": "(1->3),(1->4)-beta-glucan binding",
  "GO:2001078": "(1->6)-beta-D-glucan binding",
  "GO:2001079": "beta-D-Gal-(1->4)-beta-D-GlcNAc-(1->3)-beta-D-Gal-(1->4)-D-Glc binding",
  "GO:2001080": "chitosan binding",
  "GO:2001081": "(1->4)-beta-D-galactan binding",
  "GO:2001082": "inulin binding",
  "GO:2001083": "alpha-D-glucan binding",
  "GO:2001084": "L-arabinofuranose binding",
  "GO:2001085": "arabinogalactan binding",
  "GO:2001086": "laminarabiose transport",
  "GO:2001087": "sophorose transport",
  "GO:2001088": "trisaccharide transport",
  "GO:2001089": "maltotriose transport",
  "GO:2001090": "maltotriulose transport",
  "GO:2001091": "nigerotriose transport",
  "GO:2001092": "arabinotriose transport",
  "GO:2001093": "galactotriose transport",
  "GO:2001094": "xylotriose transport",
  "GO:2001095": "mannotriose transport",
  "GO:2001096": "cellotriose transport",
  "GO:2001097": "laminaritriose transport",
  "GO:2001098": "tetrasaccharide transport",
  "GO:2001099": "maltotetraose transport",
  "GO:2001100": "pentasaccharide transport",
  "GO:2001101": "maltopentaose transport",
  "GO:2001102": "hexasaccharide transport",
  "GO:2001103": "maltohexaose transport",
  "GO:2001104": "heptasaccharide transport",
  "GO:2001105": "maltoheptaose transport",
  "GO:2001106": "regulation of Rho guanyl-nucleotide exchange factor activity",
  "GO:2001107": "negative regulation of Rho guanyl-nucleotide exchange factor activity",
  "GO:2001108": "positive regulation of Rho guanyl-nucleotide exchange factor activity",
  "GO:2001109": "regulation of lens epithelial cell proliferation",
  "GO:2001110": "negative regulation of lens epithelial cell proliferation",
  "GO:2001111": "positive regulation of lens epithelial cell proliferation",
  "GO:2001112": "regulation of cellular response to hepatocyte growth factor stimulus",
  "GO:2001113": "negative regulation of cellular response to hepatocyte growth factor stimulus",
  "GO:2001114": "positive regulation of cellular response to hepatocyte growth factor stimulus",
  "GO:2001115": "methanopterin-containing compound metabolic process",
  "GO:2001116": "methanopterin-containing compound biosynthetic process",
  "GO:2001117": "tetrahydromethanopterin metabolic process",
  "GO:2001118": "tetrahydromethanopterin biosynthetic process",
  "GO:2001119": "methanofuran metabolic process",
  "GO:2001120": "methanofuran biosynthetic process",
  "GO:2001121": "coenzyme gamma-F420-2 biosynthetic process",
  "GO:2001122": "maltoheptaose metabolic process",
  "GO:2001123": "maltoheptaose catabolic process",
  "GO:2001124": "regulation of translational frameshifting",
  "GO:2001125": "negative regulation of translational frameshifting",
  "GO:2001126": "positive regulation of translational frameshifting",
  "GO:2001127": "methane biosynthetic process from formic acid",
  "GO:2001128": "methane biosynthetic process from methylamine",
  "GO:2001129": "methane biosynthetic process from dimethylamine",
  "GO:2001130": "methane biosynthetic process from trimethylamine",
  "GO:2001131": "methane biosynthetic process from dimethyl sulfide",
  "GO:2001132": "methane biosynthetic process from 3-(methylthio)propionic acid",
  "GO:2001133": "methane biosynthetic process from methanethiol",
  "GO:2001134": "methane biosynthetic process from carbon monoxide",
  "GO:2001135": "regulation of endocytic recycling",
  "GO:2001136": "negative regulation of endocytic recycling",
  "GO:2001137": "positive regulation of endocytic recycling",
  "GO:2001138": "regulation of phospholipid transport",
  "GO:2001139": "negative regulation of phospholipid transport",
  "GO:2001140": "positive regulation of phospholipid transport",
  "GO:2001141": "regulation of RNA biosynthetic process",
  "GO:2001142": "nicotinate transport",
  "GO:2001143": "N-methylnicotinate transport",
  "GO:2001144": "regulation of phosphatidylinositol-3,4,5-trisphosphate 5-phosphatase activity",
  "GO:2001145": "negative regulation of phosphatidylinositol-3,4,5-trisphosphate 5-phosphatase activity",
  "GO:2001146": "positive regulation of phosphatidylinositol-3,4,5-trisphosphate 5-phosphatase activity",
  "GO:2001147": "camalexin binding",
  "GO:2001148": "regulation of dipeptide transmembrane transport",
  "GO:2001149": "negative regulation of dipeptide transmembrane transport",
  "GO:2001150": "positive regulation of dipeptide transmembrane transport",
  "GO:2001151": "regulation of renal water transport",
  "GO:2001152": "negative regulation of renal water transport",
  "GO:2001153": "positive regulation of renal water transport",
  "GO:2001154": "regulation of glycolytic fermentation to ethanol",
  "GO:2001155": "negative regulation of glycolytic fermentation to ethanol",
  "GO:2001156": "regulation of proline catabolic process to glutamate",
  "GO:2001157": "negative regulation of proline catabolic process to glutamate",
  "GO:2001158": "positive regulation of proline catabolic process to glutamate",
  "GO:2001159": "regulation of CVT pathway",
  "GO:2001160": "regulation of histone H3-K79 methylation",
  "GO:2001161": "negative regulation of histone H3-K79 methylation",
  "GO:2001162": "positive regulation of histone H3-K79 methylation",
  "GO:2001163": "regulation of phosphorylation of RNA polymerase II C-terminal domain serine 2 residues",
  "GO:2001164": "negative regulation of phosphorylation of RNA polymerase II C-terminal domain serine 2 residues",
  "GO:2001165": "positive regulation of phosphorylation of RNA polymerase II C-terminal domain serine 2 residues",
  "GO:2001166": "regulation of histone H2B ubiquitination",
  "GO:2001167": "negative regulation of histone H2B ubiquitination",
  "GO:2001168": "positive regulation of histone H2B ubiquitination",
  "GO:2001169": "regulation of ATP biosynthetic process",
  "GO:2001170": "negative regulation of ATP biosynthetic process",
  "GO:2001171": "positive regulation of ATP biosynthetic process",
  "GO:2001172": "positive regulation of glycolytic fermentation to ethanol",
  "GO:2001173": "regulation of histone H2B conserved C-terminal lysine ubiquitination",
  "GO:2001174": "negative regulation of histone H2B conserved C-terminal lysine ubiquitination",
  "GO:2001175": "positive regulation of histone H2B conserved C-terminal lysine ubiquitination",
  "GO:2001176": "regulation of mediator complex assembly",
  "GO:2001177": "negative regulation of mediator complex assembly",
  "GO:2001178": "positive regulation of mediator complex assembly",
  "GO:2001179": "regulation of interleukin-10 secretion",
  "GO:2001180": "negative regulation of interleukin-10 secretion",
  "GO:2001181": "positive regulation of interleukin-10 secretion",
  "GO:2001182": "regulation of interleukin-12 secretion",
  "GO:2001183": "negative regulation of interleukin-12 secretion",
  "GO:2001184": "positive regulation of interleukin-12 secretion",
  "GO:2001185": "regulation of CD8-positive, alpha-beta T cell activation",
  "GO:2001186": "negative regulation of CD8-positive, alpha-beta T cell activation",
  "GO:2001187": "positive regulation of CD8-positive, alpha-beta T cell activation",
  "GO:2001188": "regulation of T cell activation via T cell receptor contact with antigen bound to MHC molecule on antigen presenting cell",
  "GO:2001189": "negative regulation of T cell activation via T cell receptor contact with antigen bound to MHC molecule on antigen presenting cell",
  "GO:2001190": "positive regulation of T cell activation via T cell receptor contact with antigen bound to MHC molecule on antigen presenting cell",
  "GO:2001191": "regulation of gamma-delta T cell activation involved in immune response",
  "GO:2001192": "negative regulation of gamma-delta T cell activation involved in immune response",
  "GO:2001193": "positive regulation of gamma-delta T cell activation involved in immune response",
  "GO:2001194": "regulation of lysine biosynthetic process via alpha-aminoadipate and saccharopine",
  "GO:2001195": "negative regulation of lysine biosynthetic process via alpha-aminoadipate and saccharopine",
  "GO:2001196": "positive regulation of lysine biosynthetic process via alpha-aminoadipate and saccharopine",
  "GO:2001197": "basement membrane assembly involved in embryonic body morphogenesis",
  "GO:2001198": "regulation of dendritic cell differentiation",
  "GO:2001199": "negative regulation of dendritic cell differentiation",
  "GO:2001200": "positive regulation of dendritic cell differentiation",
  "GO:2001201": "regulation of transforming growth factor-beta secretion",
  "GO:2001202": "negative regulation of transforming growth factor-beta secretion",
  "GO:2001203": "positive regulation of transforming growth factor-beta secretion",
  "GO:2001204": "regulation of osteoclast development",
  "GO:2001205": "negative regulation of osteoclast development",
  "GO:2001206": "positive regulation of osteoclast development",
  "GO:2001207": "regulation of transcription elongation from RNA polymerase I promoter",
  "GO:2001208": "negative regulation of transcription elongation from RNA polymerase I promoter",
  "GO:2001209": "positive regulation of transcription elongation from RNA polymerase I promoter",
  "GO:2001210": "regulation of isopentenyl diphosphate biosynthetic process, mevalonate pathway",
  "GO:2001211": "negative regulation of isopentenyl diphosphate biosynthetic process, mevalonate pathway",
  "GO:2001212": "regulation of vasculogenesis",
  "GO:2001213": "negative regulation of vasculogenesis",
  "GO:2001214": "positive regulation of vasculogenesis",
  "GO:2001215": "regulation of hydroxymethylglutaryl-CoA reductase (NADPH) activity",
  "GO:2001216": "negative regulation of hydroxymethylglutaryl-CoA reductase (NADPH) activity",
  "GO:2001217": "obsolete regulation of S/G2 transition of mitotic cell cycle",
  "GO:2001218": "obsolete negative regulation of S/G2 transition of mitotic cell cycle",
  "GO:2001219": "obsolete positive regulation of S/G2 transition of mitotic cell cycle",
  "GO:2001220": "obsolete negative regulation of G2 phase of mitotic cell cycle",
  "GO:2001221": "obsolete positive regulation of G2 phase of mitotic cell cycle",
  "GO:2001222": "regulation of neuron migration",
  "GO:2001223": "negative regulation of neuron migration",
  "GO:2001224": "positive regulation of neuron migration",
  "GO:2001225": "regulation of chloride transport",
  "GO:2001226": "negative regulation of chloride transport",
  "GO:2001227": "quercitrin binding",
  "GO:2001228": "regulation of response to gamma radiation",
  "GO:2001229": "negative regulation of response to gamma radiation",
  "GO:2001230": "positive regulation of response to gamma radiation",
  "GO:2001231": "regulation of protein targeting to prospore membrane",
  "GO:2001232": "positive regulation of protein targeting to prospore membrane",
  "GO:2001233": "regulation of apoptotic signaling pathway",
  "GO:2001234": "negative regulation of apoptotic signaling pathway",
  "GO:2001235": "positive regulation of apoptotic signaling pathway",
  "GO:2001236": "regulation of extrinsic apoptotic signaling pathway",
  "GO:2001237": "negative regulation of extrinsic apoptotic signaling pathway",
  "GO:2001238": "positive regulation of extrinsic apoptotic signaling pathway",
  "GO:2001239": "regulation of extrinsic apoptotic signaling pathway in absence of ligand",
  "GO:2001240": "negative regulation of extrinsic apoptotic signaling pathway in absence of ligand",
  "GO:2001241": "positive regulation of extrinsic apoptotic signaling pathway in absence of ligand",
  "GO:2001242": "regulation of intrinsic apoptotic signaling pathway",
  "GO:2001243": "negative regulation of intrinsic apoptotic signaling pathway",
  "GO:2001244": "positive regulation of intrinsic apoptotic signaling pathway",
  "GO:2001245": "regulation of phosphatidylcholine biosynthetic process",
  "GO:2001246": "negative regulation of phosphatidylcholine biosynthetic process",
  "GO:2001247": "positive regulation of phosphatidylcholine biosynthetic process",
  "GO:2001248": "regulation of ammonia assimilation cycle",
  "GO:2001249": "negative regulation of ammonia assimilation cycle",
  "GO:2001250": "positive regulation of ammonia assimilation cycle",
  "GO:2001251": "negative regulation of chromosome organization",
  "GO:2001252": "positive regulation of chromosome organization",
  "GO:2001253": "regulation of histone H3-K36 trimethylation",
  "GO:2001254": "negative regulation of histone H3-K36 trimethylation",
  "GO:2001255": "positive regulation of histone H3-K36 trimethylation",
  "GO:2001256": "regulation of store-operated calcium entry",
  "GO:2001257": "regulation of cation channel activity",
  "GO:2001258": "negative regulation of cation channel activity",
  "GO:2001259": "positive regulation of cation channel activity",
  "GO:2001260": "regulation of semaphorin-plexin signaling pathway",
  "GO:2001261": "negative regulation of semaphorin-plexin signaling pathway",
  "GO:2001262": "positive regulation of semaphorin-plexin signaling pathway",
  "GO:2001263": "regulation of C-C chemokine binding",
  "GO:2001264": "negative regulation of C-C chemokine binding",
  "GO:2001265": "positive regulation of C-C chemokine binding",
  "GO:2001266": "Roundabout signaling pathway involved in axon guidance",
  "GO:2001267": "regulation of cysteine-type endopeptidase activity involved in apoptotic signaling pathway",
  "GO:2001268": "negative regulation of cysteine-type endopeptidase activity involved in apoptotic signaling pathway",
  "GO:2001269": "positive regulation of cysteine-type endopeptidase activity involved in apoptotic signaling pathway",
  "GO:2001270": "regulation of cysteine-type endopeptidase activity involved in execution phase of apoptosis",
  "GO:2001271": "negative regulation of cysteine-type endopeptidase activity involved in execution phase of apoptosis",
  "GO:2001272": "positive regulation of cysteine-type endopeptidase activity involved in execution phase of apoptosis",
  "GO:2001273": "regulation of glucose import in response to insulin stimulus",
  "GO:2001274": "negative regulation of glucose import in response to insulin stimulus",
  "GO:2001275": "positive regulation of glucose import in response to insulin stimulus",
  "GO:2001276": "regulation of leucine biosynthetic process",
  "GO:2001277": "negative regulation of leucine biosynthetic process",
  "GO:2001278": "positive regulation of leucine biosynthetic process",
  "GO:2001279": "regulation of unsaturated fatty acid biosynthetic process",
  "GO:2001280": "positive regulation of unsaturated fatty acid biosynthetic process",
  "GO:2001281": "regulation of muscle cell chemotaxis toward tendon cell",
  "GO:2001282": "negative regulation of muscle cell chemotaxis toward tendon cell",
  "GO:2001283": "Roundabout signaling pathway involved in muscle cell chemotaxis toward tendon cell",
  "GO:2001284": "regulation of BMP secretion",
  "GO:2001285": "negative regulation of BMP secretion",
  "GO:2001286": "regulation of caveolin-mediated endocytosis",
  "GO:2001287": "negative regulation of caveolin-mediated endocytosis",
  "GO:2001288": "positive regulation of caveolin-mediated endocytosis",
  "GO:2001289": "lipid X metabolic process",
  "GO:2001290": "hydroperoxide metabolic process",
  "GO:2001291": "codeine metabolic process",
  "GO:2001292": "codeine catabolic process",
  "GO:2001293": "malonyl-CoA metabolic process",
  "GO:2001294": "malonyl-CoA catabolic process",
  "GO:2001295": "malonyl-CoA biosynthetic process",
  "GO:2001296": "N(omega)-methyl-L-arginine metabolic process",
  "GO:2001297": "N(omega)-methyl-L-arginine catabolic process",
  "GO:2001298": "N(omega),N(omega)-dimethyl-L-arginine metabolic process",
  "GO:2001299": "N(omega),N(omega)-dimethyl-L-arginine catabolic process",
  "GO:2001300": "lipoxin metabolic process",
  "GO:2001301": "lipoxin biosynthetic process",
  "GO:2001302": "lipoxin A4 metabolic process",
  "GO:2001303": "lipoxin A4 biosynthetic process",
  "GO:2001304": "lipoxin B4 metabolic process",
  "GO:2001305": "xanthone-containing compound metabolic process",
  "GO:2001306": "lipoxin B4 biosynthetic process",
  "GO:2001307": "xanthone-containing compound biosynthetic process",
  "GO:2001308": "gliotoxin metabolic process",
  "GO:2001309": "gliotoxin catabolic process",
  "GO:2001310": "gliotoxin biosynthetic process",
  "GO:2001311": "lysobisphosphatidic acid metabolic process",
  "GO:2001312": "lysobisphosphatidic acid biosynthetic process",
  "GO:2001313": "UDP-4-deoxy-4-formamido-beta-L-arabinopyranose metabolic process",
  "GO:2001314": "UDP-4-deoxy-4-formamido-beta-L-arabinopyranose catabolic process",
  "GO:2001315": "UDP-4-deoxy-4-formamido-beta-L-arabinopyranose biosynthetic process",
  "GO:2001316": "kojic acid metabolic process",
  "GO:2001317": "kojic acid biosynthetic process"
}
